var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var mathjax = {};

var version = {};

Object.defineProperty(version, "__esModule", {
  value: true
});
version.VERSION = void 0;
version.VERSION = '3.2.2';

var HandlerList$1 = {};

var PrioritizedList$1 = {};

Object.defineProperty(PrioritizedList$1, "__esModule", {
  value: true
});
PrioritizedList$1.PrioritizedList = void 0;
var PrioritizedList = (function () {
  function PrioritizedList() {
    this.items = [];
    this.items = [];
  }
  PrioritizedList.prototype[Symbol.iterator] = function () {
    var i = 0;
    var items = this.items;
    return {
      next: function () {
        return {
          value: items[i++],
          done: i > items.length
        };
      }
    };
  };
  PrioritizedList.prototype.add = function (item, priority) {
    if (priority === void 0) {
      priority = PrioritizedList.DEFAULTPRIORITY;
    }
    var i = this.items.length;
    do {
      i--;
    } while (i >= 0 && priority < this.items[i].priority);
    this.items.splice(i + 1, 0, {
      item: item,
      priority: priority
    });
    return item;
  };
  PrioritizedList.prototype.remove = function (item) {
    var i = this.items.length;
    do {
      i--;
    } while (i >= 0 && this.items[i].item !== item);
    if (i >= 0) {
      this.items.splice(i, 1);
    }
  };
  PrioritizedList.DEFAULTPRIORITY = 5;
  return PrioritizedList;
})();
PrioritizedList$1.PrioritizedList = PrioritizedList;

var __extends$2i = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$Z = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(HandlerList$1, "__esModule", {
  value: true
});
HandlerList$1.HandlerList = void 0;
var PrioritizedList_js_1$1 = PrioritizedList$1;
var HandlerList = (function (_super) {
  __extends$2i(HandlerList, _super);
  function HandlerList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  HandlerList.prototype.register = function (handler) {
    return this.add(handler, handler.priority);
  };
  HandlerList.prototype.unregister = function (handler) {
    this.remove(handler);
  };
  HandlerList.prototype.handlesDocument = function (document) {
    var e_1, _a;
    try {
      for (var _b = __values$Z(this), _c = _b.next(); !_c.done; _c = _b.next()) {
        var item = _c.value;
        var handler = item.item;
        if (handler.handlesDocument(document)) {
          return handler;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    throw new Error("Can't find handler for document");
  };
  HandlerList.prototype.document = function (document, options) {
    if (options === void 0) {
      options = null;
    }
    return this.handlesDocument(document).create(document, options);
  };
  return HandlerList;
})(PrioritizedList_js_1$1.PrioritizedList);
HandlerList$1.HandlerList = HandlerList;

var Retries = {};

Object.defineProperty(Retries, "__esModule", {
  value: true
});
Retries.retryAfter = Retries.handleRetriesFor = void 0;
function handleRetriesFor(code) {
  return new Promise(function run(ok, fail) {
    try {
      ok(code());
    } catch (err) {
      if (err.retry && err.retry instanceof Promise) {
        err.retry.then(function () {
          return run(ok, fail);
        }).catch(function (perr) {
          return fail(perr);
        });
      } else if (err.restart && err.restart.isCallback) {
        MathJax.Callback.After(function () {
          return run(ok, fail);
        }, err.restart);
      } else {
        fail(err);
      }
    }
  });
}
Retries.handleRetriesFor = handleRetriesFor;
function retryAfter(promise) {
  var err = new Error('MathJax retry');
  err.retry = promise;
  throw err;
}
Retries.retryAfter = retryAfter;

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mathjax = void 0;
  var version_js_1 = version;
  var HandlerList_js_1 = HandlerList$1;
  var Retries_js_1 = Retries;
  exports.mathjax = {
    version: version_js_1.VERSION,
    handlers: new HandlerList_js_1.HandlerList(),
    document: function (document, options) {
      return exports.mathjax.handlers.document(document, options);
    },
    handleRetriesFor: Retries_js_1.handleRetriesFor,
    retryAfter: Retries_js_1.retryAfter,
    asyncLoad: null
  };
})(mathjax);
getDefaultExportFromCjs(mathjax);

var global$1 = {};

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MathJax = exports.combineWithMathJax = exports.combineDefaults = exports.combineConfig = exports.isObject = void 0;
  var version_js_1 = version;
  function isObject(x) {
    return typeof x === 'object' && x !== null;
  }
  exports.isObject = isObject;
  function combineConfig(dst, src) {
    var e_1, _a;
    try {
      for (var _b = __values(Object.keys(src)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        if (id === '__esModule') continue;
        if (isObject(dst[id]) && isObject(src[id]) && !(src[id] instanceof Promise)) {
          combineConfig(dst[id], src[id]);
        } else if (src[id] !== null && src[id] !== undefined) {
          dst[id] = src[id];
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return dst;
  }
  exports.combineConfig = combineConfig;
  function combineDefaults(dst, name, src) {
    var e_2, _a;
    if (!dst[name]) {
      dst[name] = {};
    }
    dst = dst[name];
    try {
      for (var _b = __values(Object.keys(src)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        if (isObject(dst[id]) && isObject(src[id])) {
          combineDefaults(dst, id, src[id]);
        } else if (dst[id] == null && src[id] != null) {
          dst[id] = src[id];
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return dst;
  }
  exports.combineDefaults = combineDefaults;
  function combineWithMathJax(config) {
    return combineConfig(exports.MathJax, config);
  }
  exports.combineWithMathJax = combineWithMathJax;
  if (typeof commonjsGlobal.MathJax === 'undefined') {
    commonjsGlobal.MathJax = {};
  }
  if (!commonjsGlobal.MathJax.version) {
    commonjsGlobal.MathJax = {
      version: version_js_1.VERSION,
      _: {},
      config: commonjsGlobal.MathJax
    };
  }
  exports.MathJax = commonjsGlobal.MathJax;
})(global$1);
getDefaultExportFromCjs(global$1);

var assistiveMml = {};

var MathItem = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.newState = exports.STATE = exports.AbstractMathItem = exports.protoItem = void 0;
  function protoItem(open, math, close, n, start, end, display) {
    if (display === void 0) {
      display = null;
    }
    var item = {
      open: open,
      math: math,
      close: close,
      n: n,
      start: {
        n: start
      },
      end: {
        n: end
      },
      display: display
    };
    return item;
  }
  exports.protoItem = protoItem;
  var AbstractMathItem = (function () {
    function AbstractMathItem(math, jax, display, start, end) {
      if (display === void 0) {
        display = true;
      }
      if (start === void 0) {
        start = {
          i: 0,
          n: 0,
          delim: ''
        };
      }
      if (end === void 0) {
        end = {
          i: 0,
          n: 0,
          delim: ''
        };
      }
      this.root = null;
      this.typesetRoot = null;
      this.metrics = {};
      this.inputData = {};
      this.outputData = {};
      this._state = exports.STATE.UNPROCESSED;
      this.math = math;
      this.inputJax = jax;
      this.display = display;
      this.start = start;
      this.end = end;
      this.root = null;
      this.typesetRoot = null;
      this.metrics = {};
      this.inputData = {};
      this.outputData = {};
    }
    Object.defineProperty(AbstractMathItem.prototype, "isEscaped", {
      get: function () {
        return this.display === null;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMathItem.prototype.render = function (document) {
      document.renderActions.renderMath(this, document);
    };
    AbstractMathItem.prototype.rerender = function (document, start) {
      if (start === void 0) {
        start = exports.STATE.RERENDER;
      }
      if (this.state() >= start) {
        this.state(start - 1);
      }
      document.renderActions.renderMath(this, document, start);
    };
    AbstractMathItem.prototype.convert = function (document, end) {
      if (end === void 0) {
        end = exports.STATE.LAST;
      }
      document.renderActions.renderConvert(this, document, end);
    };
    AbstractMathItem.prototype.compile = function (document) {
      if (this.state() < exports.STATE.COMPILED) {
        this.root = this.inputJax.compile(this, document);
        this.state(exports.STATE.COMPILED);
      }
    };
    AbstractMathItem.prototype.typeset = function (document) {
      if (this.state() < exports.STATE.TYPESET) {
        this.typesetRoot = document.outputJax[this.isEscaped ? 'escaped' : 'typeset'](this, document);
        this.state(exports.STATE.TYPESET);
      }
    };
    AbstractMathItem.prototype.updateDocument = function (_document) {};
    AbstractMathItem.prototype.removeFromDocument = function (_restore) {
    };
    AbstractMathItem.prototype.setMetrics = function (em, ex, cwidth, lwidth, scale) {
      this.metrics = {
        em: em,
        ex: ex,
        containerWidth: cwidth,
        lineWidth: lwidth,
        scale: scale
      };
    };
    AbstractMathItem.prototype.state = function (state, restore) {
      if (state === void 0) {
        state = null;
      }
      if (restore === void 0) {
        restore = false;
      }
      if (state != null) {
        if (state < exports.STATE.INSERTED && this._state >= exports.STATE.INSERTED) {
          this.removeFromDocument(restore);
        }
        if (state < exports.STATE.TYPESET && this._state >= exports.STATE.TYPESET) {
          this.outputData = {};
        }
        if (state < exports.STATE.COMPILED && this._state >= exports.STATE.COMPILED) {
          this.inputData = {};
        }
        this._state = state;
      }
      return this._state;
    };
    AbstractMathItem.prototype.reset = function (restore) {
      if (restore === void 0) {
        restore = false;
      }
      this.state(exports.STATE.UNPROCESSED, restore);
    };
    return AbstractMathItem;
  })();
  exports.AbstractMathItem = AbstractMathItem;
  exports.STATE = {
    UNPROCESSED: 0,
    FINDMATH: 10,
    COMPILED: 20,
    CONVERT: 100,
    METRICS: 110,
    RERENDER: 125,
    TYPESET: 150,
    INSERTED: 200,
    LAST: 10000
  };
  function newState(name, state) {
    if ((name in exports.STATE)) {
      throw Error('State ' + name + ' already exists');
    }
    exports.STATE[name] = state;
  }
  exports.newState = newState;
})(MathItem);
getDefaultExportFromCjs(MathItem);

var SerializedMmlVisitor = {};

var MmlVisitor$3 = {};

var MmlFactory$1 = {};

var NodeFactory$2 = {};

var Factory = {};

var __values$Y = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$_ = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$y = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(Factory, "__esModule", {
  value: true
});
Factory.AbstractFactory = void 0;
var AbstractFactory = (function () {
  function AbstractFactory(nodes) {
    var e_1, _a;
    if (nodes === void 0) {
      nodes = null;
    }
    this.defaultKind = 'unknown';
    this.nodeMap = new Map();
    this.node = {};
    if (nodes === null) {
      nodes = this.constructor.defaultNodes;
    }
    try {
      for (var _b = __values$Y(Object.keys(nodes)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var kind = _c.value;
        this.setNodeClass(kind, nodes[kind]);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  AbstractFactory.prototype.create = function (kind) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    return (this.node[kind] || this.node[this.defaultKind]).apply(void 0, __spreadArray$y([], __read$_(args), false));
  };
  AbstractFactory.prototype.setNodeClass = function (kind, nodeClass) {
    this.nodeMap.set(kind, nodeClass);
    var THIS = this;
    var KIND = this.nodeMap.get(kind);
    this.node[kind] = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return new (KIND.bind.apply(KIND, __spreadArray$y([void 0, THIS], __read$_(args), false)))();
    };
  };
  AbstractFactory.prototype.getNodeClass = function (kind) {
    return this.nodeMap.get(kind);
  };
  AbstractFactory.prototype.deleteNodeClass = function (kind) {
    this.nodeMap.delete(kind);
    delete this.node[kind];
  };
  AbstractFactory.prototype.nodeIsKind = function (node, kind) {
    return node instanceof this.getNodeClass(kind);
  };
  AbstractFactory.prototype.getKinds = function () {
    return Array.from(this.nodeMap.keys());
  };
  AbstractFactory.defaultNodes = {};
  return AbstractFactory;
})();
Factory.AbstractFactory = AbstractFactory;

var __extends$2h = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(NodeFactory$2, "__esModule", {
  value: true
});
NodeFactory$2.AbstractNodeFactory = void 0;
var Factory_js_1$2 = Factory;
var AbstractNodeFactory = (function (_super) {
  __extends$2h(AbstractNodeFactory, _super);
  function AbstractNodeFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AbstractNodeFactory.prototype.create = function (kind, properties, children) {
    if (properties === void 0) {
      properties = {};
    }
    if (children === void 0) {
      children = [];
    }
    return this.node[kind](properties, children);
  };
  return AbstractNodeFactory;
})(Factory_js_1$2.AbstractFactory);
NodeFactory$2.AbstractNodeFactory = AbstractNodeFactory;

var MML = {};

var MmlNode = {};

var Attributes = {};

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Attributes = exports.INHERIT = void 0;
  exports.INHERIT = '_inherit_';
  var Attributes = (function () {
    function Attributes(defaults, global) {
      this.global = global;
      this.defaults = Object.create(global);
      this.inherited = Object.create(this.defaults);
      this.attributes = Object.create(this.inherited);
      Object.assign(this.defaults, defaults);
    }
    Attributes.prototype.set = function (name, value) {
      this.attributes[name] = value;
    };
    Attributes.prototype.setList = function (list) {
      Object.assign(this.attributes, list);
    };
    Attributes.prototype.get = function (name) {
      var value = this.attributes[name];
      if (value === exports.INHERIT) {
        value = this.global[name];
      }
      return value;
    };
    Attributes.prototype.getExplicit = function (name) {
      if (!this.attributes.hasOwnProperty(name)) {
        return undefined;
      }
      return this.attributes[name];
    };
    Attributes.prototype.getList = function () {
      var e_1, _a;
      var names = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
      }
      var values = {};
      try {
        for (var names_1 = __values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
          var name_1 = names_1_1.value;
          values[name_1] = this.get(name_1);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return values;
    };
    Attributes.prototype.setInherited = function (name, value) {
      this.inherited[name] = value;
    };
    Attributes.prototype.getInherited = function (name) {
      return this.inherited[name];
    };
    Attributes.prototype.getDefault = function (name) {
      return this.defaults[name];
    };
    Attributes.prototype.isSet = function (name) {
      return this.attributes.hasOwnProperty(name) || this.inherited.hasOwnProperty(name);
    };
    Attributes.prototype.hasDefault = function (name) {
      return (name in this.defaults);
    };
    Attributes.prototype.getExplicitNames = function () {
      return Object.keys(this.attributes);
    };
    Attributes.prototype.getInheritedNames = function () {
      return Object.keys(this.inherited);
    };
    Attributes.prototype.getDefaultNames = function () {
      return Object.keys(this.defaults);
    };
    Attributes.prototype.getGlobalNames = function () {
      return Object.keys(this.global);
    };
    Attributes.prototype.getAllAttributes = function () {
      return this.attributes;
    };
    Attributes.prototype.getAllInherited = function () {
      return this.inherited;
    };
    Attributes.prototype.getAllDefaults = function () {
      return this.defaults;
    };
    Attributes.prototype.getAllGlobals = function () {
      return this.global;
    };
    return Attributes;
  })();
  exports.Attributes = Attributes;
})(Attributes);
getDefaultExportFromCjs(Attributes);

var Node = {};

var __extends$2g = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$J = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$J = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$J.apply(this, arguments);
});
var __values$X = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(Node, "__esModule", {
  value: true
});
Node.AbstractEmptyNode = Node.AbstractNode = void 0;
var AbstractNode = (function () {
  function AbstractNode(factory, properties, children) {
    var e_1, _a;
    if (properties === void 0) {
      properties = {};
    }
    if (children === void 0) {
      children = [];
    }
    this.factory = factory;
    this.parent = null;
    this.properties = {};
    this.childNodes = [];
    try {
      for (var _b = __values$X(Object.keys(properties)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_1 = _c.value;
        this.setProperty(name_1, properties[name_1]);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    if (children.length) {
      this.setChildren(children);
    }
  }
  Object.defineProperty(AbstractNode.prototype, "kind", {
    get: function () {
      return 'unknown';
    },
    enumerable: false,
    configurable: true
  });
  AbstractNode.prototype.setProperty = function (name, value) {
    this.properties[name] = value;
  };
  AbstractNode.prototype.getProperty = function (name) {
    return this.properties[name];
  };
  AbstractNode.prototype.getPropertyNames = function () {
    return Object.keys(this.properties);
  };
  AbstractNode.prototype.getAllProperties = function () {
    return this.properties;
  };
  AbstractNode.prototype.removeProperty = function () {
    var e_2, _a;
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      names[_i] = arguments[_i];
    }
    try {
      for (var names_1 = __values$X(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
        var name_2 = names_1_1.value;
        delete this.properties[name_2];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  AbstractNode.prototype.isKind = function (kind) {
    return this.factory.nodeIsKind(this, kind);
  };
  AbstractNode.prototype.setChildren = function (children) {
    var e_3, _a;
    this.childNodes = [];
    try {
      for (var children_1 = __values$X(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
        var child = children_1_1.value;
        this.appendChild(child);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
  };
  AbstractNode.prototype.appendChild = function (child) {
    this.childNodes.push(child);
    child.parent = this;
    return child;
  };
  AbstractNode.prototype.replaceChild = function (newChild, oldChild) {
    var i = this.childIndex(oldChild);
    if (i !== null) {
      this.childNodes[i] = newChild;
      newChild.parent = this;
      oldChild.parent = null;
    }
    return newChild;
  };
  AbstractNode.prototype.removeChild = function (child) {
    var i = this.childIndex(child);
    if (i !== null) {
      this.childNodes.splice(i, 1);
      child.parent = null;
    }
    return child;
  };
  AbstractNode.prototype.childIndex = function (node) {
    var i = this.childNodes.indexOf(node);
    return i === -1 ? null : i;
  };
  AbstractNode.prototype.copy = function () {
    var e_4, _a;
    var node = this.factory.create(this.kind);
    node.properties = __assign$J({}, this.properties);
    try {
      for (var _b = __values$X(this.childNodes || []), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        if (child) {
          node.appendChild(child.copy());
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    return node;
  };
  AbstractNode.prototype.findNodes = function (kind) {
    var nodes = [];
    this.walkTree(function (node) {
      if (node.isKind(kind)) {
        nodes.push(node);
      }
    });
    return nodes;
  };
  AbstractNode.prototype.walkTree = function (func, data) {
    var e_5, _a;
    func(this, data);
    try {
      for (var _b = __values$X(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        if (child) {
          child.walkTree(func, data);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_5) throw e_5.error;
      }
    }
    return data;
  };
  AbstractNode.prototype.toString = function () {
    return this.kind + '(' + this.childNodes.join(',') + ')';
  };
  return AbstractNode;
})();
Node.AbstractNode = AbstractNode;
var AbstractEmptyNode = (function (_super) {
  __extends$2g(AbstractEmptyNode, _super);
  function AbstractEmptyNode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AbstractEmptyNode.prototype.setChildren = function (_children) {};
  AbstractEmptyNode.prototype.appendChild = function (child) {
    return child;
  };
  AbstractEmptyNode.prototype.replaceChild = function (_newChild, oldChild) {
    return oldChild;
  };
  AbstractEmptyNode.prototype.childIndex = function (_node) {
    return null;
  };
  AbstractEmptyNode.prototype.walkTree = function (func, data) {
    func(this, data);
    return data;
  };
  AbstractEmptyNode.prototype.toString = function () {
    return this.kind;
  };
  return AbstractEmptyNode;
})(AbstractNode);
Node.AbstractEmptyNode = AbstractEmptyNode;

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __assign = commonjsGlobal && commonjsGlobal.__assign || (function () {
    __assign = Object.assign || (function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    });
    return __assign.apply(this, arguments);
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.XMLNode = exports.TextNode = exports.AbstractMmlEmptyNode = exports.AbstractMmlBaseNode = exports.AbstractMmlLayoutNode = exports.AbstractMmlTokenNode = exports.AbstractMmlNode = exports.indentAttributes = exports.TEXCLASSNAMES = exports.TEXCLASS = void 0;
  var Attributes_js_1 = Attributes;
  var Node_js_1 = Node;
  exports.TEXCLASS = {
    ORD: 0,
    OP: 1,
    BIN: 2,
    REL: 3,
    OPEN: 4,
    CLOSE: 5,
    PUNCT: 6,
    INNER: 7,
    VCENTER: 8,
    NONE: -1
  };
  exports.TEXCLASSNAMES = ['ORD', 'OP', 'BIN', 'REL', 'OPEN', 'CLOSE', 'PUNCT', 'INNER', 'VCENTER'];
  var TEXSPACELENGTH = ['', 'thinmathspace', 'mediummathspace', 'thickmathspace'];
  var TEXSPACE = [[0, -1, 2, 3, 0, 0, 0, 1], [-1, -1, 0, 3, 0, 0, 0, 1], [2, 2, 0, 0, 2, 0, 0, 2], [3, 3, 0, 0, 3, 0, 0, 3], [0, 0, 0, 0, 0, 0, 0, 0], [0, -1, 2, 3, 0, 0, 0, 1], [1, 1, 0, 1, 1, 1, 1, 1], [1, -1, 2, 3, 1, 0, 1, 1]];
  exports.indentAttributes = ['indentalign', 'indentalignfirst', 'indentshift', 'indentshiftfirst'];
  var AbstractMmlNode = (function (_super) {
    __extends(AbstractMmlNode, _super);
    function AbstractMmlNode(factory, attributes, children) {
      if (attributes === void 0) {
        attributes = {};
      }
      if (children === void 0) {
        children = [];
      }
      var _this = _super.call(this, factory) || this;
      _this.prevClass = null;
      _this.prevLevel = null;
      _this.texclass = null;
      if (_this.arity < 0) {
        _this.childNodes = [factory.create('inferredMrow')];
        _this.childNodes[0].parent = _this;
      }
      _this.setChildren(children);
      _this.attributes = new Attributes_js_1.Attributes(factory.getNodeClass(_this.kind).defaults, factory.getNodeClass('math').defaults);
      _this.attributes.setList(attributes);
      return _this;
    }
    AbstractMmlNode.prototype.copy = function (keepIds) {
      var e_1, _a, e_2, _b;
      if (keepIds === void 0) {
        keepIds = false;
      }
      var node = this.factory.create(this.kind);
      node.properties = __assign({}, this.properties);
      if (this.attributes) {
        var attributes = this.attributes.getAllAttributes();
        try {
          for (var _c = __values(Object.keys(attributes)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var name_1 = _d.value;
            if (name_1 !== 'id' || keepIds) {
              node.attributes.set(name_1, attributes[name_1]);
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
      if (this.childNodes && this.childNodes.length) {
        var children = this.childNodes;
        if (children.length === 1 && children[0].isInferred) {
          children = children[0].childNodes;
        }
        try {
          for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var child = children_1_1.value;
            if (child) {
              node.appendChild(child.copy());
            } else {
              node.childNodes.push(null);
            }
          }
        } catch (e_2_1) {
          e_2 = {
            error: e_2_1
          };
        } finally {
          try {
            if (children_1_1 && !children_1_1.done && (_b = children_1.return)) _b.call(children_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
      }
      return node;
    };
    Object.defineProperty(AbstractMmlNode.prototype, "texClass", {
      get: function () {
        return this.texclass;
      },
      set: function (texClass) {
        this.texclass = texClass;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "isToken", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "isEmbellished", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "isSpacelike", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "linebreakContainer", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "hasNewLine", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "arity", {
      get: function () {
        return Infinity;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "isInferred", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "Parent", {
      get: function () {
        var parent = this.parent;
        while (parent && parent.notParent) {
          parent = parent.Parent;
        }
        return parent;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlNode.prototype, "notParent", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMmlNode.prototype.setChildren = function (children) {
      if (this.arity < 0) {
        return this.childNodes[0].setChildren(children);
      }
      return _super.prototype.setChildren.call(this, children);
    };
    AbstractMmlNode.prototype.appendChild = function (child) {
      var e_3, _a;
      var _this = this;
      if (this.arity < 0) {
        this.childNodes[0].appendChild(child);
        return child;
      }
      if (child.isInferred) {
        if (this.arity === Infinity) {
          child.childNodes.forEach(function (node) {
            return _super.prototype.appendChild.call(_this, node);
          });
          return child;
        }
        var original = child;
        child = this.factory.create('mrow');
        child.setChildren(original.childNodes);
        child.attributes = original.attributes;
        try {
          for (var _b = __values(original.getPropertyNames()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var name_2 = _c.value;
            child.setProperty(name_2, original.getProperty(name_2));
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
      }
      return _super.prototype.appendChild.call(this, child);
    };
    AbstractMmlNode.prototype.replaceChild = function (newChild, oldChild) {
      if (this.arity < 0) {
        this.childNodes[0].replaceChild(newChild, oldChild);
        return newChild;
      }
      return _super.prototype.replaceChild.call(this, newChild, oldChild);
    };
    AbstractMmlNode.prototype.core = function () {
      return this;
    };
    AbstractMmlNode.prototype.coreMO = function () {
      return this;
    };
    AbstractMmlNode.prototype.coreIndex = function () {
      return 0;
    };
    AbstractMmlNode.prototype.childPosition = function () {
      var e_4, _a;
      var child = this;
      var parent = child.parent;
      while (parent && parent.notParent) {
        child = parent;
        parent = parent.parent;
      }
      if (parent) {
        var i = 0;
        try {
          for (var _b = __values(parent.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
            var node = _c.value;
            if (node === child) {
              return i;
            }
            i++;
          }
        } catch (e_4_1) {
          e_4 = {
            error: e_4_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_4) throw e_4.error;
          }
        }
      }
      return null;
    };
    AbstractMmlNode.prototype.setTeXclass = function (prev) {
      this.getPrevClass(prev);
      return this.texClass != null ? this : prev;
    };
    AbstractMmlNode.prototype.updateTeXclass = function (core) {
      if (core) {
        this.prevClass = core.prevClass;
        this.prevLevel = core.prevLevel;
        core.prevClass = core.prevLevel = null;
        this.texClass = core.texClass;
      }
    };
    AbstractMmlNode.prototype.getPrevClass = function (prev) {
      if (prev) {
        this.prevClass = prev.texClass;
        this.prevLevel = prev.attributes.get('scriptlevel');
      }
    };
    AbstractMmlNode.prototype.texSpacing = function () {
      var prevClass = this.prevClass != null ? this.prevClass : exports.TEXCLASS.NONE;
      var texClass = this.texClass || exports.TEXCLASS.ORD;
      if (prevClass === exports.TEXCLASS.NONE || texClass === exports.TEXCLASS.NONE) {
        return '';
      }
      if (prevClass === exports.TEXCLASS.VCENTER) {
        prevClass = exports.TEXCLASS.ORD;
      }
      if (texClass === exports.TEXCLASS.VCENTER) {
        texClass = exports.TEXCLASS.ORD;
      }
      var space = TEXSPACE[prevClass][texClass];
      if ((this.prevLevel > 0 || this.attributes.get('scriptlevel') > 0) && space >= 0) {
        return '';
      }
      return TEXSPACELENGTH[Math.abs(space)];
    };
    AbstractMmlNode.prototype.hasSpacingAttributes = function () {
      return this.isEmbellished && this.coreMO().hasSpacingAttributes();
    };
    AbstractMmlNode.prototype.setInheritedAttributes = function (attributes, display, level, prime) {
      var e_5, _a;
      if (attributes === void 0) {
        attributes = {};
      }
      if (display === void 0) {
        display = false;
      }
      if (level === void 0) {
        level = 0;
      }
      if (prime === void 0) {
        prime = false;
      }
      var defaults = this.attributes.getAllDefaults();
      try {
        for (var _b = __values(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          if (defaults.hasOwnProperty(key) || AbstractMmlNode.alwaysInherit.hasOwnProperty(key)) {
            var _d = __read(attributes[key], 2), node = _d[0], value = _d[1];
            var noinherit = (AbstractMmlNode.noInherit[node] || ({}))[this.kind] || ({});
            if (!noinherit[key]) {
              this.attributes.setInherited(key, value);
            }
          }
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      var displaystyle = this.attributes.getExplicit('displaystyle');
      if (displaystyle === undefined) {
        this.attributes.setInherited('displaystyle', display);
      }
      var scriptlevel = this.attributes.getExplicit('scriptlevel');
      if (scriptlevel === undefined) {
        this.attributes.setInherited('scriptlevel', level);
      }
      if (prime) {
        this.setProperty('texprimestyle', prime);
      }
      var arity = this.arity;
      if (arity >= 0 && arity !== Infinity && (arity === 1 && this.childNodes.length === 0 || arity !== 1 && this.childNodes.length !== arity)) {
        if (arity < this.childNodes.length) {
          this.childNodes = this.childNodes.slice(0, arity);
        } else {
          while (this.childNodes.length < arity) {
            this.appendChild(this.factory.create('mrow'));
          }
        }
      }
      this.setChildInheritedAttributes(attributes, display, level, prime);
    };
    AbstractMmlNode.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
      var e_6, _a;
      try {
        for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          child.setInheritedAttributes(attributes, display, level, prime);
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_6) throw e_6.error;
        }
      }
    };
    AbstractMmlNode.prototype.addInheritedAttributes = function (current, attributes) {
      var e_7, _a;
      var updated = __assign({}, current);
      try {
        for (var _b = __values(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var name_3 = _c.value;
          if (name_3 !== 'displaystyle' && name_3 !== 'scriptlevel' && name_3 !== 'style') {
            updated[name_3] = [this.kind, attributes[name_3]];
          }
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
      return updated;
    };
    AbstractMmlNode.prototype.inheritAttributesFrom = function (node) {
      var attributes = node.attributes;
      var display = attributes.get('displaystyle');
      var scriptlevel = attributes.get('scriptlevel');
      var defaults = !attributes.isSet('mathsize') ? {} : {
        mathsize: ['math', attributes.get('mathsize')]
      };
      var prime = node.getProperty('texprimestyle') || false;
      this.setInheritedAttributes(defaults, display, scriptlevel, prime);
    };
    AbstractMmlNode.prototype.verifyTree = function (options) {
      if (options === void 0) {
        options = null;
      }
      if (options === null) {
        return;
      }
      this.verifyAttributes(options);
      var arity = this.arity;
      if (options['checkArity']) {
        if (arity >= 0 && arity !== Infinity && (arity === 1 && this.childNodes.length === 0 || arity !== 1 && this.childNodes.length !== arity)) {
          this.mError('Wrong number of children for "' + this.kind + '" node', options, true);
        }
      }
      this.verifyChildren(options);
    };
    AbstractMmlNode.prototype.verifyAttributes = function (options) {
      var e_8, _a;
      if (options['checkAttributes']) {
        var attributes = this.attributes;
        var bad = [];
        try {
          for (var _b = __values(attributes.getExplicitNames()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var name_4 = _c.value;
            if (name_4.substr(0, 5) !== 'data-' && attributes.getDefault(name_4) === undefined && !name_4.match(/^(?:class|style|id|(?:xlink:)?href)$/)) {
              bad.push(name_4);
            }
          }
        } catch (e_8_1) {
          e_8 = {
            error: e_8_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_8) throw e_8.error;
          }
        }
        if (bad.length) {
          this.mError('Unknown attributes for ' + this.kind + ' node: ' + bad.join(', '), options);
        }
      }
    };
    AbstractMmlNode.prototype.verifyChildren = function (options) {
      var e_9, _a;
      try {
        for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          child.verifyTree(options);
        }
      } catch (e_9_1) {
        e_9 = {
          error: e_9_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_9) throw e_9.error;
        }
      }
    };
    AbstractMmlNode.prototype.mError = function (message, options, short) {
      if (short === void 0) {
        short = false;
      }
      if (this.parent && this.parent.isKind('merror')) {
        return null;
      }
      var merror = this.factory.create('merror');
      merror.attributes.set('data-mjx-message', message);
      if (options['fullErrors'] || short) {
        var mtext = this.factory.create('mtext');
        var text = this.factory.create('text');
        text.setText(options['fullErrors'] ? message : this.kind);
        mtext.appendChild(text);
        merror.appendChild(mtext);
        this.parent.replaceChild(merror, this);
      } else {
        this.parent.replaceChild(merror, this);
        merror.appendChild(this);
      }
      return merror;
    };
    AbstractMmlNode.defaults = {
      mathbackground: Attributes_js_1.INHERIT,
      mathcolor: Attributes_js_1.INHERIT,
      mathsize: Attributes_js_1.INHERIT,
      dir: Attributes_js_1.INHERIT
    };
    AbstractMmlNode.noInherit = {
      mstyle: {
        mpadded: {
          width: true,
          height: true,
          depth: true,
          lspace: true,
          voffset: true
        },
        mtable: {
          width: true,
          height: true,
          depth: true,
          align: true
        }
      },
      maligngroup: {
        mrow: {
          groupalign: true
        },
        mtable: {
          groupalign: true
        }
      }
    };
    AbstractMmlNode.alwaysInherit = {
      scriptminsize: true,
      scriptsizemultiplier: true
    };
    AbstractMmlNode.verifyDefaults = {
      checkArity: true,
      checkAttributes: false,
      fullErrors: false,
      fixMmultiscripts: true,
      fixMtables: true
    };
    return AbstractMmlNode;
  })(Node_js_1.AbstractNode);
  exports.AbstractMmlNode = AbstractMmlNode;
  var AbstractMmlTokenNode = (function (_super) {
    __extends(AbstractMmlTokenNode, _super);
    function AbstractMmlTokenNode() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AbstractMmlTokenNode.prototype, "isToken", {
      get: function () {
        return true;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMmlTokenNode.prototype.getText = function () {
      var e_10, _a;
      var text = '';
      try {
        for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (child instanceof TextNode) {
            text += child.getText();
          }
        }
      } catch (e_10_1) {
        e_10 = {
          error: e_10_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_10) throw e_10.error;
        }
      }
      return text;
    };
    AbstractMmlTokenNode.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
      var e_11, _a;
      try {
        for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (child instanceof AbstractMmlNode) {
            child.setInheritedAttributes(attributes, display, level, prime);
          }
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_11) throw e_11.error;
        }
      }
    };
    AbstractMmlTokenNode.prototype.walkTree = function (func, data) {
      var e_12, _a;
      func(this, data);
      try {
        for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (child instanceof AbstractMmlNode) {
            child.walkTree(func, data);
          }
        }
      } catch (e_12_1) {
        e_12 = {
          error: e_12_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_12) throw e_12.error;
        }
      }
      return data;
    };
    AbstractMmlTokenNode.defaults = __assign(__assign({}, AbstractMmlNode.defaults), {
      mathvariant: 'normal',
      mathsize: Attributes_js_1.INHERIT
    });
    return AbstractMmlTokenNode;
  })(AbstractMmlNode);
  exports.AbstractMmlTokenNode = AbstractMmlTokenNode;
  var AbstractMmlLayoutNode = (function (_super) {
    __extends(AbstractMmlLayoutNode, _super);
    function AbstractMmlLayoutNode() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AbstractMmlLayoutNode.prototype, "isSpacelike", {
      get: function () {
        return this.childNodes[0].isSpacelike;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlLayoutNode.prototype, "isEmbellished", {
      get: function () {
        return this.childNodes[0].isEmbellished;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlLayoutNode.prototype, "arity", {
      get: function () {
        return -1;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMmlLayoutNode.prototype.core = function () {
      return this.childNodes[0];
    };
    AbstractMmlLayoutNode.prototype.coreMO = function () {
      return this.childNodes[0].coreMO();
    };
    AbstractMmlLayoutNode.prototype.setTeXclass = function (prev) {
      prev = this.childNodes[0].setTeXclass(prev);
      this.updateTeXclass(this.childNodes[0]);
      return prev;
    };
    AbstractMmlLayoutNode.defaults = AbstractMmlNode.defaults;
    return AbstractMmlLayoutNode;
  })(AbstractMmlNode);
  exports.AbstractMmlLayoutNode = AbstractMmlLayoutNode;
  var AbstractMmlBaseNode = (function (_super) {
    __extends(AbstractMmlBaseNode, _super);
    function AbstractMmlBaseNode() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AbstractMmlBaseNode.prototype, "isEmbellished", {
      get: function () {
        return this.childNodes[0].isEmbellished;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMmlBaseNode.prototype.core = function () {
      return this.childNodes[0];
    };
    AbstractMmlBaseNode.prototype.coreMO = function () {
      return this.childNodes[0].coreMO();
    };
    AbstractMmlBaseNode.prototype.setTeXclass = function (prev) {
      var e_13, _a;
      this.getPrevClass(prev);
      this.texClass = exports.TEXCLASS.ORD;
      var base = this.childNodes[0];
      if (base) {
        if (this.isEmbellished || base.isKind('mi')) {
          prev = base.setTeXclass(prev);
          this.updateTeXclass(this.core());
        } else {
          base.setTeXclass(null);
          prev = this;
        }
      } else {
        prev = this;
      }
      try {
        for (var _b = __values(this.childNodes.slice(1)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (child) {
            child.setTeXclass(null);
          }
        }
      } catch (e_13_1) {
        e_13 = {
          error: e_13_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_13) throw e_13.error;
        }
      }
      return prev;
    };
    AbstractMmlBaseNode.defaults = AbstractMmlNode.defaults;
    return AbstractMmlBaseNode;
  })(AbstractMmlNode);
  exports.AbstractMmlBaseNode = AbstractMmlBaseNode;
  var AbstractMmlEmptyNode = (function (_super) {
    __extends(AbstractMmlEmptyNode, _super);
    function AbstractMmlEmptyNode() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "isToken", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "isEmbellished", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "isSpacelike", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "linebreakContainer", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "hasNewLine", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "arity", {
      get: function () {
        return 0;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "isInferred", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "notParent", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "Parent", {
      get: function () {
        return this.parent;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "texClass", {
      get: function () {
        return exports.TEXCLASS.NONE;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "prevClass", {
      get: function () {
        return exports.TEXCLASS.NONE;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "prevLevel", {
      get: function () {
        return 0;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMmlEmptyNode.prototype.hasSpacingAttributes = function () {
      return false;
    };
    Object.defineProperty(AbstractMmlEmptyNode.prototype, "attributes", {
      get: function () {
        return null;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMmlEmptyNode.prototype.core = function () {
      return this;
    };
    AbstractMmlEmptyNode.prototype.coreMO = function () {
      return this;
    };
    AbstractMmlEmptyNode.prototype.coreIndex = function () {
      return 0;
    };
    AbstractMmlEmptyNode.prototype.childPosition = function () {
      return 0;
    };
    AbstractMmlEmptyNode.prototype.setTeXclass = function (prev) {
      return prev;
    };
    AbstractMmlEmptyNode.prototype.texSpacing = function () {
      return '';
    };
    AbstractMmlEmptyNode.prototype.setInheritedAttributes = function (_attributes, _display, _level, _prime) {};
    AbstractMmlEmptyNode.prototype.inheritAttributesFrom = function (_node) {};
    AbstractMmlEmptyNode.prototype.verifyTree = function (_options) {};
    AbstractMmlEmptyNode.prototype.mError = function (_message, _options, _short) {
      return null;
    };
    return AbstractMmlEmptyNode;
  })(Node_js_1.AbstractEmptyNode);
  exports.AbstractMmlEmptyNode = AbstractMmlEmptyNode;
  var TextNode = (function (_super) {
    __extends(TextNode, _super);
    function TextNode() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.text = '';
      return _this;
    }
    Object.defineProperty(TextNode.prototype, "kind", {
      get: function () {
        return 'text';
      },
      enumerable: false,
      configurable: true
    });
    TextNode.prototype.getText = function () {
      return this.text;
    };
    TextNode.prototype.setText = function (text) {
      this.text = text;
      return this;
    };
    TextNode.prototype.copy = function () {
      return this.factory.create(this.kind).setText(this.getText());
    };
    TextNode.prototype.toString = function () {
      return this.text;
    };
    return TextNode;
  })(AbstractMmlEmptyNode);
  exports.TextNode = TextNode;
  var XMLNode = (function (_super) {
    __extends(XMLNode, _super);
    function XMLNode() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.xml = null;
      _this.adaptor = null;
      return _this;
    }
    Object.defineProperty(XMLNode.prototype, "kind", {
      get: function () {
        return 'XML';
      },
      enumerable: false,
      configurable: true
    });
    XMLNode.prototype.getXML = function () {
      return this.xml;
    };
    XMLNode.prototype.setXML = function (xml, adaptor) {
      if (adaptor === void 0) {
        adaptor = null;
      }
      this.xml = xml;
      this.adaptor = adaptor;
      return this;
    };
    XMLNode.prototype.getSerializedXML = function () {
      return this.adaptor.serializeXML(this.xml);
    };
    XMLNode.prototype.copy = function () {
      return this.factory.create(this.kind).setXML(this.adaptor.clone(this.xml));
    };
    XMLNode.prototype.toString = function () {
      return 'XML data';
    };
    return XMLNode;
  })(AbstractMmlEmptyNode);
  exports.XMLNode = XMLNode;
})(MmlNode);
getDefaultExportFromCjs(MmlNode);

var math$2 = {};

var __extends$2f = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$I = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$I = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$I.apply(this, arguments);
});
Object.defineProperty(math$2, "__esModule", {
  value: true
});
math$2.MmlMath = void 0;
var MmlNode_js_1$P = MmlNode;
var MmlMath = (function (_super) {
  __extends$2f(MmlMath, _super);
  function MmlMath() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMath.prototype, "kind", {
    get: function () {
      return 'math';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMath.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMath.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    if (this.attributes.get('mode') === 'display') {
      this.attributes.setInherited('display', 'block');
    }
    attributes = this.addInheritedAttributes(attributes, this.attributes.getAllAttributes());
    display = !!this.attributes.get('displaystyle') || !this.attributes.get('displaystyle') && this.attributes.get('display') === 'block';
    this.attributes.setInherited('displaystyle', display);
    level = this.attributes.get('scriptlevel') || this.constructor.defaults['scriptlevel'];
    _super.prototype.setChildInheritedAttributes.call(this, attributes, display, level, prime);
  };
  MmlMath.defaults = __assign$I(__assign$I({}, MmlNode_js_1$P.AbstractMmlLayoutNode.defaults), {
    mathvariant: 'normal',
    mathsize: 'normal',
    mathcolor: '',
    mathbackground: 'transparent',
    dir: 'ltr',
    scriptlevel: 0,
    displaystyle: false,
    display: 'inline',
    maxwidth: '',
    overflow: 'linebreak',
    altimg: '',
    'altimg-width': '',
    'altimg-height': '',
    'altimg-valign': '',
    alttext: '',
    cdgroup: '',
    scriptsizemultiplier: 1 / Math.sqrt(2),
    scriptminsize: '8px',
    infixlinebreakstyle: 'before',
    lineleading: '1ex',
    linebreakmultchar: '\u2062',
    indentshift: 'auto',
    indentalign: 'auto',
    indenttarget: '',
    indentalignfirst: 'indentalign',
    indentshiftfirst: 'indentshift',
    indentalignlast: 'indentalign',
    indentshiftlast: 'indentshift'
  });
  return MmlMath;
})(MmlNode_js_1$P.AbstractMmlLayoutNode);
math$2.MmlMath = MmlMath;

var mi$2 = {};

var __extends$2e = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$H = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$H = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$H.apply(this, arguments);
});
Object.defineProperty(mi$2, "__esModule", {
  value: true
});
mi$2.MmlMi = void 0;
var MmlNode_js_1$O = MmlNode;
var MmlMi = (function (_super) {
  __extends$2e(MmlMi, _super);
  function MmlMi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$O.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMi.prototype, "kind", {
    get: function () {
      return 'mi';
    },
    enumerable: false,
    configurable: true
  });
  MmlMi.prototype.setInheritedAttributes = function (attributes, display, level, prime) {
    if (attributes === void 0) {
      attributes = {};
    }
    if (display === void 0) {
      display = false;
    }
    if (level === void 0) {
      level = 0;
    }
    if (prime === void 0) {
      prime = false;
    }
    _super.prototype.setInheritedAttributes.call(this, attributes, display, level, prime);
    var text = this.getText();
    if (text.match(MmlMi.singleCharacter) && !attributes.mathvariant) {
      this.attributes.setInherited('mathvariant', 'italic');
    }
  };
  MmlMi.prototype.setTeXclass = function (prev) {
    this.getPrevClass(prev);
    var name = this.getText();
    if (name.length > 1 && name.match(MmlMi.operatorName) && this.attributes.get('mathvariant') === 'normal' && this.getProperty('autoOP') === undefined && this.getProperty('texClass') === undefined) {
      this.texClass = MmlNode_js_1$O.TEXCLASS.OP;
      this.setProperty('autoOP', true);
    }
    return this;
  };
  MmlMi.defaults = __assign$H({}, MmlNode_js_1$O.AbstractMmlTokenNode.defaults);
  MmlMi.operatorName = /^[a-z][a-z0-9]*$/i;
  MmlMi.singleCharacter = /^[\uD800-\uDBFF]?.[\u0300-\u036F\u1AB0-\u1ABE\u1DC0-\u1DFF\u20D0-\u20EF]*$/;
  return MmlMi;
})(MmlNode_js_1$O.AbstractMmlTokenNode);
mi$2.MmlMi = MmlMi;

var mn$2 = {};

var __extends$2d = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$G = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$G = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$G.apply(this, arguments);
});
Object.defineProperty(mn$2, "__esModule", {
  value: true
});
mn$2.MmlMn = void 0;
var MmlNode_js_1$N = MmlNode;
var MmlMn = (function (_super) {
  __extends$2d(MmlMn, _super);
  function MmlMn() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$N.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMn.prototype, "kind", {
    get: function () {
      return 'mn';
    },
    enumerable: false,
    configurable: true
  });
  MmlMn.defaults = __assign$G({}, MmlNode_js_1$N.AbstractMmlTokenNode.defaults);
  return MmlMn;
})(MmlNode_js_1$N.AbstractMmlTokenNode);
mn$2.MmlMn = MmlMn;

var mo$2 = {};

var OperatorDictionary = {};

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.OPTABLE = exports.MMLSPACING = exports.getRange = exports.RANGES = exports.MO = exports.OPDEF = void 0;
  var MmlNode_js_1 = MmlNode;
  function OPDEF(lspace, rspace, texClass, properties) {
    if (texClass === void 0) {
      texClass = MmlNode_js_1.TEXCLASS.BIN;
    }
    if (properties === void 0) {
      properties = null;
    }
    return [lspace, rspace, texClass, properties];
  }
  exports.OPDEF = OPDEF;
  exports.MO = {
    ORD: OPDEF(0, 0, MmlNode_js_1.TEXCLASS.ORD),
    ORD11: OPDEF(1, 1, MmlNode_js_1.TEXCLASS.ORD),
    ORD21: OPDEF(2, 1, MmlNode_js_1.TEXCLASS.ORD),
    ORD02: OPDEF(0, 2, MmlNode_js_1.TEXCLASS.ORD),
    ORD55: OPDEF(5, 5, MmlNode_js_1.TEXCLASS.ORD),
    NONE: OPDEF(0, 0, MmlNode_js_1.TEXCLASS.NONE),
    OP: OPDEF(1, 2, MmlNode_js_1.TEXCLASS.OP, {
      largeop: true,
      movablelimits: true,
      symmetric: true
    }),
    OPFIXED: OPDEF(1, 2, MmlNode_js_1.TEXCLASS.OP, {
      largeop: true,
      movablelimits: true
    }),
    INTEGRAL: OPDEF(0, 1, MmlNode_js_1.TEXCLASS.OP, {
      largeop: true,
      symmetric: true
    }),
    INTEGRAL2: OPDEF(1, 2, MmlNode_js_1.TEXCLASS.OP, {
      largeop: true,
      symmetric: true
    }),
    BIN3: OPDEF(3, 3, MmlNode_js_1.TEXCLASS.BIN),
    BIN4: OPDEF(4, 4, MmlNode_js_1.TEXCLASS.BIN),
    BIN01: OPDEF(0, 1, MmlNode_js_1.TEXCLASS.BIN),
    BIN5: OPDEF(5, 5, MmlNode_js_1.TEXCLASS.BIN),
    TALLBIN: OPDEF(4, 4, MmlNode_js_1.TEXCLASS.BIN, {
      stretchy: true
    }),
    BINOP: OPDEF(4, 4, MmlNode_js_1.TEXCLASS.BIN, {
      largeop: true,
      movablelimits: true
    }),
    REL: OPDEF(5, 5, MmlNode_js_1.TEXCLASS.REL),
    REL1: OPDEF(1, 1, MmlNode_js_1.TEXCLASS.REL, {
      stretchy: true
    }),
    REL4: OPDEF(4, 4, MmlNode_js_1.TEXCLASS.REL),
    RELSTRETCH: OPDEF(5, 5, MmlNode_js_1.TEXCLASS.REL, {
      stretchy: true
    }),
    RELACCENT: OPDEF(5, 5, MmlNode_js_1.TEXCLASS.REL, {
      accent: true
    }),
    WIDEREL: OPDEF(5, 5, MmlNode_js_1.TEXCLASS.REL, {
      accent: true,
      stretchy: true
    }),
    OPEN: OPDEF(0, 0, MmlNode_js_1.TEXCLASS.OPEN, {
      fence: true,
      stretchy: true,
      symmetric: true
    }),
    CLOSE: OPDEF(0, 0, MmlNode_js_1.TEXCLASS.CLOSE, {
      fence: true,
      stretchy: true,
      symmetric: true
    }),
    INNER: OPDEF(0, 0, MmlNode_js_1.TEXCLASS.INNER),
    PUNCT: OPDEF(0, 3, MmlNode_js_1.TEXCLASS.PUNCT),
    ACCENT: OPDEF(0, 0, MmlNode_js_1.TEXCLASS.ORD, {
      accent: true
    }),
    WIDEACCENT: OPDEF(0, 0, MmlNode_js_1.TEXCLASS.ORD, {
      accent: true,
      stretchy: true
    })
  };
  exports.RANGES = [[0x0020, 0x007F, MmlNode_js_1.TEXCLASS.REL, 'mo'], [0x00A0, 0x00BF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x00C0, 0x024F, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x02B0, 0x036F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x0370, 0x1A20, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x1AB0, 0x1AFF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x1B00, 0x1DBF, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x1DC0, 0x1DFF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x1E00, 0x1FFF, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x2000, 0x206F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x2070, 0x209F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x2100, 0x214F, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x2150, 0x218F, MmlNode_js_1.TEXCLASS.ORD, 'mn'], [0x2190, 0x21FF, MmlNode_js_1.TEXCLASS.REL, 'mo'], [0x2200, 0x22FF, MmlNode_js_1.TEXCLASS.BIN, 'mo'], [0x2300, 0x23FF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x2460, 0x24FF, MmlNode_js_1.TEXCLASS.ORD, 'mn'], [0x2500, 0x27EF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x27F0, 0x27FF, MmlNode_js_1.TEXCLASS.REL, 'mo'], [0x2800, 0x28FF, MmlNode_js_1.TEXCLASS.ORD, 'mtext'], [0x2900, 0x297F, MmlNode_js_1.TEXCLASS.REL, 'mo'], [0x2980, 0x29FF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x2A00, 0x2AFF, MmlNode_js_1.TEXCLASS.BIN, 'mo'], [0x2B00, 0x2B2F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x2B30, 0x2B4F, MmlNode_js_1.TEXCLASS.REL, 'mo'], [0x2B50, 0x2BFF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x2C00, 0x2DE0, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x2E00, 0x2E7F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x2E80, 0x2FDF, MmlNode_js_1.TEXCLASS.ORD, 'mi', 'normal'], [0x2FF0, 0x303F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x3040, 0xA49F, MmlNode_js_1.TEXCLASS.ORD, 'mi', 'normal'], [0xA4D0, 0xA82F, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0xA830, 0xA83F, MmlNode_js_1.TEXCLASS.ORD, 'mn'], [0xA840, 0xD7FF, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0xF900, 0xFAFF, MmlNode_js_1.TEXCLASS.ORD, 'mi', 'normal'], [0xFB00, 0xFDFF, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0xFE00, 0xFE6F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0xFE70, 0x100FF, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x10100, 0x1018F, MmlNode_js_1.TEXCLASS.ORD, 'mn'], [0x10190, 0x123FF, MmlNode_js_1.TEXCLASS.ORD, 'mi', 'normal'], [0x12400, 0x1247F, MmlNode_js_1.TEXCLASS.ORD, 'mn'], [0x12480, 0x1BC9F, MmlNode_js_1.TEXCLASS.ORD, 'mi', 'normal'], [0x1BCA0, 0x1D25F, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x1D360, 0x1D37F, MmlNode_js_1.TEXCLASS.ORD, 'mn'], [0x1D400, 0x1D7CD, MmlNode_js_1.TEXCLASS.ORD, 'mi'], [0x1D7CE, 0x1D7FF, MmlNode_js_1.TEXCLASS.ORD, 'mn'], [0x1DF00, 0x1F7FF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x1F800, 0x1F8FF, MmlNode_js_1.TEXCLASS.REL, 'mo'], [0x1F900, 0x1F9FF, MmlNode_js_1.TEXCLASS.ORD, 'mo'], [0x20000, 0x2FA1F, MmlNode_js_1.TEXCLASS.ORD, 'mi', 'normnal']];
  function getRange(text) {
    var e_1, _a;
    var n = text.codePointAt(0);
    try {
      for (var RANGES_1 = __values(exports.RANGES), RANGES_1_1 = RANGES_1.next(); !RANGES_1_1.done; RANGES_1_1 = RANGES_1.next()) {
        var range = RANGES_1_1.value;
        if (n <= range[1]) {
          if (n >= range[0]) {
            return range;
          }
          break;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (RANGES_1_1 && !RANGES_1_1.done && (_a = RANGES_1.return)) _a.call(RANGES_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return null;
  }
  exports.getRange = getRange;
  exports.MMLSPACING = [[0, 0], [1, 2], [3, 3], [4, 4], [0, 0], [0, 0], [0, 3]];
  exports.OPTABLE = {
    prefix: {
      '(': exports.MO.OPEN,
      '+': exports.MO.BIN01,
      '-': exports.MO.BIN01,
      '[': exports.MO.OPEN,
      '{': exports.MO.OPEN,
      '|': exports.MO.OPEN,
      '||': [0, 0, MmlNode_js_1.TEXCLASS.BIN, {
        fence: true,
        stretchy: true,
        symmetric: true
      }],
      '|||': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true,
        symmetric: true
      }],
      '\u00AC': exports.MO.ORD21,
      '\u00B1': exports.MO.BIN01,
      '\u2016': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true
      }],
      '\u2018': [0, 0, MmlNode_js_1.TEXCLASS.OPEN, {
        fence: true
      }],
      '\u201C': [0, 0, MmlNode_js_1.TEXCLASS.OPEN, {
        fence: true
      }],
      '\u2145': exports.MO.ORD21,
      '\u2146': OPDEF(2, 0, MmlNode_js_1.TEXCLASS.ORD),
      '\u2200': exports.MO.ORD21,
      '\u2202': exports.MO.ORD21,
      '\u2203': exports.MO.ORD21,
      '\u2204': exports.MO.ORD21,
      '\u2207': exports.MO.ORD21,
      '\u220F': exports.MO.OP,
      '\u2210': exports.MO.OP,
      '\u2211': exports.MO.OP,
      '\u2212': exports.MO.BIN01,
      '\u2213': exports.MO.BIN01,
      '\u221A': [1, 1, MmlNode_js_1.TEXCLASS.ORD, {
        stretchy: true
      }],
      '\u221B': exports.MO.ORD11,
      '\u221C': exports.MO.ORD11,
      '\u2220': exports.MO.ORD,
      '\u2221': exports.MO.ORD,
      '\u2222': exports.MO.ORD,
      '\u222B': exports.MO.INTEGRAL,
      '\u222C': exports.MO.INTEGRAL,
      '\u222D': exports.MO.INTEGRAL,
      '\u222E': exports.MO.INTEGRAL,
      '\u222F': exports.MO.INTEGRAL,
      '\u2230': exports.MO.INTEGRAL,
      '\u2231': exports.MO.INTEGRAL,
      '\u2232': exports.MO.INTEGRAL,
      '\u2233': exports.MO.INTEGRAL,
      '\u22C0': exports.MO.OP,
      '\u22C1': exports.MO.OP,
      '\u22C2': exports.MO.OP,
      '\u22C3': exports.MO.OP,
      '\u2308': exports.MO.OPEN,
      '\u230A': exports.MO.OPEN,
      '\u2329': exports.MO.OPEN,
      '\u2772': exports.MO.OPEN,
      '\u27E6': exports.MO.OPEN,
      '\u27E8': exports.MO.OPEN,
      '\u27EA': exports.MO.OPEN,
      '\u27EC': exports.MO.OPEN,
      '\u27EE': exports.MO.OPEN,
      '\u2980': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true
      }],
      '\u2983': exports.MO.OPEN,
      '\u2985': exports.MO.OPEN,
      '\u2987': exports.MO.OPEN,
      '\u2989': exports.MO.OPEN,
      '\u298B': exports.MO.OPEN,
      '\u298D': exports.MO.OPEN,
      '\u298F': exports.MO.OPEN,
      '\u2991': exports.MO.OPEN,
      '\u2993': exports.MO.OPEN,
      '\u2995': exports.MO.OPEN,
      '\u2997': exports.MO.OPEN,
      '\u29FC': exports.MO.OPEN,
      '\u2A00': exports.MO.OP,
      '\u2A01': exports.MO.OP,
      '\u2A02': exports.MO.OP,
      '\u2A03': exports.MO.OP,
      '\u2A04': exports.MO.OP,
      '\u2A05': exports.MO.OP,
      '\u2A06': exports.MO.OP,
      '\u2A07': exports.MO.OP,
      '\u2A08': exports.MO.OP,
      '\u2A09': exports.MO.OP,
      '\u2A0A': exports.MO.OP,
      '\u2A0B': exports.MO.INTEGRAL2,
      '\u2A0C': exports.MO.INTEGRAL,
      '\u2A0D': exports.MO.INTEGRAL2,
      '\u2A0E': exports.MO.INTEGRAL2,
      '\u2A0F': exports.MO.INTEGRAL2,
      '\u2A10': exports.MO.OP,
      '\u2A11': exports.MO.OP,
      '\u2A12': exports.MO.OP,
      '\u2A13': exports.MO.OP,
      '\u2A14': exports.MO.OP,
      '\u2A15': exports.MO.INTEGRAL2,
      '\u2A16': exports.MO.INTEGRAL2,
      '\u2A17': exports.MO.INTEGRAL2,
      '\u2A18': exports.MO.INTEGRAL2,
      '\u2A19': exports.MO.INTEGRAL2,
      '\u2A1A': exports.MO.INTEGRAL2,
      '\u2A1B': exports.MO.INTEGRAL2,
      '\u2A1C': exports.MO.INTEGRAL2,
      '\u2AFC': exports.MO.OP,
      '\u2AFF': exports.MO.OP
    },
    postfix: {
      '!!': OPDEF(1, 0),
      '!': [1, 0, MmlNode_js_1.TEXCLASS.CLOSE, null],
      '"': exports.MO.ACCENT,
      '&': exports.MO.ORD,
      ')': exports.MO.CLOSE,
      '++': OPDEF(0, 0),
      '--': OPDEF(0, 0),
      '..': OPDEF(0, 0),
      '...': exports.MO.ORD,
      '\'': exports.MO.ACCENT,
      ']': exports.MO.CLOSE,
      '^': exports.MO.WIDEACCENT,
      '_': exports.MO.WIDEACCENT,
      '`': exports.MO.ACCENT,
      '|': exports.MO.CLOSE,
      '}': exports.MO.CLOSE,
      '~': exports.MO.WIDEACCENT,
      '||': [0, 0, MmlNode_js_1.TEXCLASS.BIN, {
        fence: true,
        stretchy: true,
        symmetric: true
      }],
      '|||': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true,
        symmetric: true
      }],
      '\u00A8': exports.MO.ACCENT,
      '\u00AA': exports.MO.ACCENT,
      '\u00AF': exports.MO.WIDEACCENT,
      '\u00B0': exports.MO.ORD,
      '\u00B2': exports.MO.ACCENT,
      '\u00B3': exports.MO.ACCENT,
      '\u00B4': exports.MO.ACCENT,
      '\u00B8': exports.MO.ACCENT,
      '\u00B9': exports.MO.ACCENT,
      '\u00BA': exports.MO.ACCENT,
      '\u02C6': exports.MO.WIDEACCENT,
      '\u02C7': exports.MO.WIDEACCENT,
      '\u02C9': exports.MO.WIDEACCENT,
      '\u02CA': exports.MO.ACCENT,
      '\u02CB': exports.MO.ACCENT,
      '\u02CD': exports.MO.WIDEACCENT,
      '\u02D8': exports.MO.ACCENT,
      '\u02D9': exports.MO.ACCENT,
      '\u02DA': exports.MO.ACCENT,
      '\u02DC': exports.MO.WIDEACCENT,
      '\u02DD': exports.MO.ACCENT,
      '\u02F7': exports.MO.WIDEACCENT,
      '\u0302': exports.MO.WIDEACCENT,
      '\u0311': exports.MO.ACCENT,
      '\u03F6': exports.MO.REL,
      '\u2016': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true
      }],
      '\u2019': [0, 0, MmlNode_js_1.TEXCLASS.CLOSE, {
        fence: true
      }],
      '\u201A': exports.MO.ACCENT,
      '\u201B': exports.MO.ACCENT,
      '\u201D': [0, 0, MmlNode_js_1.TEXCLASS.CLOSE, {
        fence: true
      }],
      '\u201E': exports.MO.ACCENT,
      '\u201F': exports.MO.ACCENT,
      '\u2032': exports.MO.ORD,
      '\u2033': exports.MO.ACCENT,
      '\u2034': exports.MO.ACCENT,
      '\u2035': exports.MO.ACCENT,
      '\u2036': exports.MO.ACCENT,
      '\u2037': exports.MO.ACCENT,
      '\u203E': exports.MO.WIDEACCENT,
      '\u2057': exports.MO.ACCENT,
      '\u20DB': exports.MO.ACCENT,
      '\u20DC': exports.MO.ACCENT,
      '\u2309': exports.MO.CLOSE,
      '\u230B': exports.MO.CLOSE,
      '\u232A': exports.MO.CLOSE,
      '\u23B4': exports.MO.WIDEACCENT,
      '\u23B5': exports.MO.WIDEACCENT,
      '\u23DC': exports.MO.WIDEACCENT,
      '\u23DD': exports.MO.WIDEACCENT,
      '\u23DE': exports.MO.WIDEACCENT,
      '\u23DF': exports.MO.WIDEACCENT,
      '\u23E0': exports.MO.WIDEACCENT,
      '\u23E1': exports.MO.WIDEACCENT,
      '\u25A0': exports.MO.BIN3,
      '\u25A1': exports.MO.BIN3,
      '\u25AA': exports.MO.BIN3,
      '\u25AB': exports.MO.BIN3,
      '\u25AD': exports.MO.BIN3,
      '\u25AE': exports.MO.BIN3,
      '\u25AF': exports.MO.BIN3,
      '\u25B0': exports.MO.BIN3,
      '\u25B1': exports.MO.BIN3,
      '\u25B2': exports.MO.BIN4,
      '\u25B4': exports.MO.BIN4,
      '\u25B6': exports.MO.BIN4,
      '\u25B7': exports.MO.BIN4,
      '\u25B8': exports.MO.BIN4,
      '\u25BC': exports.MO.BIN4,
      '\u25BE': exports.MO.BIN4,
      '\u25C0': exports.MO.BIN4,
      '\u25C1': exports.MO.BIN4,
      '\u25C2': exports.MO.BIN4,
      '\u25C4': exports.MO.BIN4,
      '\u25C5': exports.MO.BIN4,
      '\u25C6': exports.MO.BIN4,
      '\u25C7': exports.MO.BIN4,
      '\u25C8': exports.MO.BIN4,
      '\u25C9': exports.MO.BIN4,
      '\u25CC': exports.MO.BIN4,
      '\u25CD': exports.MO.BIN4,
      '\u25CE': exports.MO.BIN4,
      '\u25CF': exports.MO.BIN4,
      '\u25D6': exports.MO.BIN4,
      '\u25D7': exports.MO.BIN4,
      '\u25E6': exports.MO.BIN4,
      '\u266D': exports.MO.ORD02,
      '\u266E': exports.MO.ORD02,
      '\u266F': exports.MO.ORD02,
      '\u2773': exports.MO.CLOSE,
      '\u27E7': exports.MO.CLOSE,
      '\u27E9': exports.MO.CLOSE,
      '\u27EB': exports.MO.CLOSE,
      '\u27ED': exports.MO.CLOSE,
      '\u27EF': exports.MO.CLOSE,
      '\u2980': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true
      }],
      '\u2984': exports.MO.CLOSE,
      '\u2986': exports.MO.CLOSE,
      '\u2988': exports.MO.CLOSE,
      '\u298A': exports.MO.CLOSE,
      '\u298C': exports.MO.CLOSE,
      '\u298E': exports.MO.CLOSE,
      '\u2990': exports.MO.CLOSE,
      '\u2992': exports.MO.CLOSE,
      '\u2994': exports.MO.CLOSE,
      '\u2996': exports.MO.CLOSE,
      '\u2998': exports.MO.CLOSE,
      '\u29FD': exports.MO.CLOSE
    },
    infix: {
      '!=': exports.MO.BIN4,
      '#': exports.MO.ORD,
      '$': exports.MO.ORD,
      '%': [3, 3, MmlNode_js_1.TEXCLASS.ORD, null],
      '&&': exports.MO.BIN4,
      '': exports.MO.ORD,
      '*': exports.MO.BIN3,
      '**': OPDEF(1, 1),
      '*=': exports.MO.BIN4,
      '+': exports.MO.BIN4,
      '+=': exports.MO.BIN4,
      ',': [0, 3, MmlNode_js_1.TEXCLASS.PUNCT, {
        linebreakstyle: 'after',
        separator: true
      }],
      '-': exports.MO.BIN4,
      '-=': exports.MO.BIN4,
      '->': exports.MO.BIN5,
      '.': [0, 3, MmlNode_js_1.TEXCLASS.PUNCT, {
        separator: true
      }],
      '/': exports.MO.ORD11,
      '//': OPDEF(1, 1),
      '/=': exports.MO.BIN4,
      ':': [1, 2, MmlNode_js_1.TEXCLASS.REL, null],
      ':=': exports.MO.BIN4,
      ';': [0, 3, MmlNode_js_1.TEXCLASS.PUNCT, {
        linebreakstyle: 'after',
        separator: true
      }],
      '<': exports.MO.REL,
      '<=': exports.MO.BIN5,
      '<>': OPDEF(1, 1),
      '=': exports.MO.REL,
      '==': exports.MO.BIN4,
      '>': exports.MO.REL,
      '>=': exports.MO.BIN5,
      '?': [1, 1, MmlNode_js_1.TEXCLASS.CLOSE, null],
      '@': exports.MO.ORD11,
      '\\': exports.MO.ORD,
      '^': exports.MO.ORD11,
      '_': exports.MO.ORD11,
      '|': [2, 2, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true,
        symmetric: true
      }],
      '||': [2, 2, MmlNode_js_1.TEXCLASS.BIN, {
        fence: true,
        stretchy: true,
        symmetric: true
      }],
      '|||': [2, 2, MmlNode_js_1.TEXCLASS.ORD, {
        fence: true,
        stretchy: true,
        symmetric: true
      }],
      '\u00B1': exports.MO.BIN4,
      '\u00B7': exports.MO.BIN4,
      '\u00D7': exports.MO.BIN4,
      '\u00F7': exports.MO.BIN4,
      '\u02B9': exports.MO.ORD,
      '\u0300': exports.MO.ACCENT,
      '\u0301': exports.MO.ACCENT,
      '\u0303': exports.MO.WIDEACCENT,
      '\u0304': exports.MO.ACCENT,
      '\u0306': exports.MO.ACCENT,
      '\u0307': exports.MO.ACCENT,
      '\u0308': exports.MO.ACCENT,
      '\u030C': exports.MO.ACCENT,
      '\u0332': exports.MO.WIDEACCENT,
      '\u0338': exports.MO.REL4,
      '\u2015': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        stretchy: true
      }],
      '\u2017': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        stretchy: true
      }],
      '\u2020': exports.MO.BIN3,
      '\u2021': exports.MO.BIN3,
      '\u2022': exports.MO.BIN4,
      '\u2026': exports.MO.INNER,
      '\u2043': exports.MO.BIN4,
      '\u2044': exports.MO.TALLBIN,
      '\u2061': exports.MO.NONE,
      '\u2062': exports.MO.NONE,
      '\u2063': [0, 0, MmlNode_js_1.TEXCLASS.NONE, {
        linebreakstyle: 'after',
        separator: true
      }],
      '\u2064': exports.MO.NONE,
      '\u20D7': exports.MO.ACCENT,
      '\u2111': exports.MO.ORD,
      '\u2113': exports.MO.ORD,
      '\u2118': exports.MO.ORD,
      '\u211C': exports.MO.ORD,
      '\u2190': exports.MO.WIDEREL,
      '\u2191': exports.MO.RELSTRETCH,
      '\u2192': exports.MO.WIDEREL,
      '\u2193': exports.MO.RELSTRETCH,
      '\u2194': exports.MO.WIDEREL,
      '\u2195': exports.MO.RELSTRETCH,
      '\u2196': exports.MO.RELSTRETCH,
      '\u2197': exports.MO.RELSTRETCH,
      '\u2198': exports.MO.RELSTRETCH,
      '\u2199': exports.MO.RELSTRETCH,
      '\u219A': exports.MO.RELACCENT,
      '\u219B': exports.MO.RELACCENT,
      '\u219C': exports.MO.WIDEREL,
      '\u219D': exports.MO.WIDEREL,
      '\u219E': exports.MO.WIDEREL,
      '\u219F': exports.MO.WIDEREL,
      '\u21A0': exports.MO.WIDEREL,
      '\u21A1': exports.MO.RELSTRETCH,
      '\u21A2': exports.MO.WIDEREL,
      '\u21A3': exports.MO.WIDEREL,
      '\u21A4': exports.MO.WIDEREL,
      '\u21A5': exports.MO.RELSTRETCH,
      '\u21A6': exports.MO.WIDEREL,
      '\u21A7': exports.MO.RELSTRETCH,
      '\u21A8': exports.MO.RELSTRETCH,
      '\u21A9': exports.MO.WIDEREL,
      '\u21AA': exports.MO.WIDEREL,
      '\u21AB': exports.MO.WIDEREL,
      '\u21AC': exports.MO.WIDEREL,
      '\u21AD': exports.MO.WIDEREL,
      '\u21AE': exports.MO.RELACCENT,
      '\u21AF': exports.MO.RELSTRETCH,
      '\u21B0': exports.MO.RELSTRETCH,
      '\u21B1': exports.MO.RELSTRETCH,
      '\u21B2': exports.MO.RELSTRETCH,
      '\u21B3': exports.MO.RELSTRETCH,
      '\u21B4': exports.MO.RELSTRETCH,
      '\u21B5': exports.MO.RELSTRETCH,
      '\u21B6': exports.MO.RELACCENT,
      '\u21B7': exports.MO.RELACCENT,
      '\u21B8': exports.MO.REL,
      '\u21B9': exports.MO.WIDEREL,
      '\u21BA': exports.MO.REL,
      '\u21BB': exports.MO.REL,
      '\u21BC': exports.MO.WIDEREL,
      '\u21BD': exports.MO.WIDEREL,
      '\u21BE': exports.MO.RELSTRETCH,
      '\u21BF': exports.MO.RELSTRETCH,
      '\u21C0': exports.MO.WIDEREL,
      '\u21C1': exports.MO.WIDEREL,
      '\u21C2': exports.MO.RELSTRETCH,
      '\u21C3': exports.MO.RELSTRETCH,
      '\u21C4': exports.MO.WIDEREL,
      '\u21C5': exports.MO.RELSTRETCH,
      '\u21C6': exports.MO.WIDEREL,
      '\u21C7': exports.MO.WIDEREL,
      '\u21C8': exports.MO.RELSTRETCH,
      '\u21C9': exports.MO.WIDEREL,
      '\u21CA': exports.MO.RELSTRETCH,
      '\u21CB': exports.MO.WIDEREL,
      '\u21CC': exports.MO.WIDEREL,
      '\u21CD': exports.MO.RELACCENT,
      '\u21CE': exports.MO.RELACCENT,
      '\u21CF': exports.MO.RELACCENT,
      '\u21D0': exports.MO.WIDEREL,
      '\u21D1': exports.MO.RELSTRETCH,
      '\u21D2': exports.MO.WIDEREL,
      '\u21D3': exports.MO.RELSTRETCH,
      '\u21D4': exports.MO.WIDEREL,
      '\u21D5': exports.MO.RELSTRETCH,
      '\u21D6': exports.MO.RELSTRETCH,
      '\u21D7': exports.MO.RELSTRETCH,
      '\u21D8': exports.MO.RELSTRETCH,
      '\u21D9': exports.MO.RELSTRETCH,
      '\u21DA': exports.MO.WIDEREL,
      '\u21DB': exports.MO.WIDEREL,
      '\u21DC': exports.MO.WIDEREL,
      '\u21DD': exports.MO.WIDEREL,
      '\u21DE': exports.MO.REL,
      '\u21DF': exports.MO.REL,
      '\u21E0': exports.MO.WIDEREL,
      '\u21E1': exports.MO.RELSTRETCH,
      '\u21E2': exports.MO.WIDEREL,
      '\u21E3': exports.MO.RELSTRETCH,
      '\u21E4': exports.MO.WIDEREL,
      '\u21E5': exports.MO.WIDEREL,
      '\u21E6': exports.MO.WIDEREL,
      '\u21E7': exports.MO.RELSTRETCH,
      '\u21E8': exports.MO.WIDEREL,
      '\u21E9': exports.MO.RELSTRETCH,
      '\u21EA': exports.MO.RELSTRETCH,
      '\u21EB': exports.MO.RELSTRETCH,
      '\u21EC': exports.MO.RELSTRETCH,
      '\u21ED': exports.MO.RELSTRETCH,
      '\u21EE': exports.MO.RELSTRETCH,
      '\u21EF': exports.MO.RELSTRETCH,
      '\u21F0': exports.MO.WIDEREL,
      '\u21F1': exports.MO.REL,
      '\u21F2': exports.MO.REL,
      '\u21F3': exports.MO.RELSTRETCH,
      '\u21F4': exports.MO.RELACCENT,
      '\u21F5': exports.MO.RELSTRETCH,
      '\u21F6': exports.MO.WIDEREL,
      '\u21F7': exports.MO.RELACCENT,
      '\u21F8': exports.MO.RELACCENT,
      '\u21F9': exports.MO.RELACCENT,
      '\u21FA': exports.MO.RELACCENT,
      '\u21FB': exports.MO.RELACCENT,
      '\u21FC': exports.MO.RELACCENT,
      '\u21FD': exports.MO.WIDEREL,
      '\u21FE': exports.MO.WIDEREL,
      '\u21FF': exports.MO.WIDEREL,
      '\u2201': OPDEF(1, 2, MmlNode_js_1.TEXCLASS.ORD),
      '\u2205': exports.MO.ORD,
      '\u2206': exports.MO.BIN3,
      '\u2208': exports.MO.REL,
      '\u2209': exports.MO.REL,
      '\u220A': exports.MO.REL,
      '\u220B': exports.MO.REL,
      '\u220C': exports.MO.REL,
      '\u220D': exports.MO.REL,
      '\u220E': exports.MO.BIN3,
      '\u2212': exports.MO.BIN4,
      '\u2213': exports.MO.BIN4,
      '\u2214': exports.MO.BIN4,
      '\u2215': exports.MO.TALLBIN,
      '\u2216': exports.MO.BIN4,
      '\u2217': exports.MO.BIN4,
      '\u2218': exports.MO.BIN4,
      '\u2219': exports.MO.BIN4,
      '\u221D': exports.MO.REL,
      '\u221E': exports.MO.ORD,
      '\u221F': exports.MO.REL,
      '\u2223': exports.MO.REL,
      '\u2224': exports.MO.REL,
      '\u2225': exports.MO.REL,
      '\u2226': exports.MO.REL,
      '\u2227': exports.MO.BIN4,
      '\u2228': exports.MO.BIN4,
      '\u2229': exports.MO.BIN4,
      '\u222A': exports.MO.BIN4,
      '\u2234': exports.MO.REL,
      '\u2235': exports.MO.REL,
      '\u2236': exports.MO.REL,
      '\u2237': exports.MO.REL,
      '\u2238': exports.MO.BIN4,
      '\u2239': exports.MO.REL,
      '\u223A': exports.MO.BIN4,
      '\u223B': exports.MO.REL,
      '\u223C': exports.MO.REL,
      '\u223D': exports.MO.REL,
      '\u223D\u0331': exports.MO.BIN3,
      '\u223E': exports.MO.REL,
      '\u223F': exports.MO.BIN3,
      '\u2240': exports.MO.BIN4,
      '\u2241': exports.MO.REL,
      '\u2242': exports.MO.REL,
      '\u2242\u0338': exports.MO.REL,
      '\u2243': exports.MO.REL,
      '\u2244': exports.MO.REL,
      '\u2245': exports.MO.REL,
      '\u2246': exports.MO.REL,
      '\u2247': exports.MO.REL,
      '\u2248': exports.MO.REL,
      '\u2249': exports.MO.REL,
      '\u224A': exports.MO.REL,
      '\u224B': exports.MO.REL,
      '\u224C': exports.MO.REL,
      '\u224D': exports.MO.REL,
      '\u224E': exports.MO.REL,
      '\u224E\u0338': exports.MO.REL,
      '\u224F': exports.MO.REL,
      '\u224F\u0338': exports.MO.REL,
      '\u2250': exports.MO.REL,
      '\u2251': exports.MO.REL,
      '\u2252': exports.MO.REL,
      '\u2253': exports.MO.REL,
      '\u2254': exports.MO.REL,
      '\u2255': exports.MO.REL,
      '\u2256': exports.MO.REL,
      '\u2257': exports.MO.REL,
      '\u2258': exports.MO.REL,
      '\u2259': exports.MO.REL,
      '\u225A': exports.MO.REL,
      '\u225B': exports.MO.REL,
      '\u225C': exports.MO.REL,
      '\u225D': exports.MO.REL,
      '\u225E': exports.MO.REL,
      '\u225F': exports.MO.REL,
      '\u2260': exports.MO.REL,
      '\u2261': exports.MO.REL,
      '\u2262': exports.MO.REL,
      '\u2263': exports.MO.REL,
      '\u2264': exports.MO.REL,
      '\u2265': exports.MO.REL,
      '\u2266': exports.MO.REL,
      '\u2266\u0338': exports.MO.REL,
      '\u2267': exports.MO.REL,
      '\u2268': exports.MO.REL,
      '\u2269': exports.MO.REL,
      '\u226A': exports.MO.REL,
      '\u226A\u0338': exports.MO.REL,
      '\u226B': exports.MO.REL,
      '\u226B\u0338': exports.MO.REL,
      '\u226C': exports.MO.REL,
      '\u226D': exports.MO.REL,
      '\u226E': exports.MO.REL,
      '\u226F': exports.MO.REL,
      '\u2270': exports.MO.REL,
      '\u2271': exports.MO.REL,
      '\u2272': exports.MO.REL,
      '\u2273': exports.MO.REL,
      '\u2274': exports.MO.REL,
      '\u2275': exports.MO.REL,
      '\u2276': exports.MO.REL,
      '\u2277': exports.MO.REL,
      '\u2278': exports.MO.REL,
      '\u2279': exports.MO.REL,
      '\u227A': exports.MO.REL,
      '\u227B': exports.MO.REL,
      '\u227C': exports.MO.REL,
      '\u227D': exports.MO.REL,
      '\u227E': exports.MO.REL,
      '\u227F': exports.MO.REL,
      '\u227F\u0338': exports.MO.REL,
      '\u2280': exports.MO.REL,
      '\u2281': exports.MO.REL,
      '\u2282': exports.MO.REL,
      '\u2282\u20D2': exports.MO.REL,
      '\u2283': exports.MO.REL,
      '\u2283\u20D2': exports.MO.REL,
      '\u2284': exports.MO.REL,
      '\u2285': exports.MO.REL,
      '\u2286': exports.MO.REL,
      '\u2287': exports.MO.REL,
      '\u2288': exports.MO.REL,
      '\u2289': exports.MO.REL,
      '\u228A': exports.MO.REL,
      '\u228B': exports.MO.REL,
      '\u228C': exports.MO.BIN4,
      '\u228D': exports.MO.BIN4,
      '\u228E': exports.MO.BIN4,
      '\u228F': exports.MO.REL,
      '\u228F\u0338': exports.MO.REL,
      '\u2290': exports.MO.REL,
      '\u2290\u0338': exports.MO.REL,
      '\u2291': exports.MO.REL,
      '\u2292': exports.MO.REL,
      '\u2293': exports.MO.BIN4,
      '\u2294': exports.MO.BIN4,
      '\u2295': exports.MO.BIN4,
      '\u2296': exports.MO.BIN4,
      '\u2297': exports.MO.BIN4,
      '\u2298': exports.MO.BIN4,
      '\u2299': exports.MO.BIN4,
      '\u229A': exports.MO.BIN4,
      '\u229B': exports.MO.BIN4,
      '\u229C': exports.MO.BIN4,
      '\u229D': exports.MO.BIN4,
      '\u229E': exports.MO.BIN4,
      '\u229F': exports.MO.BIN4,
      '\u22A0': exports.MO.BIN4,
      '\u22A1': exports.MO.BIN4,
      '\u22A2': exports.MO.REL,
      '\u22A3': exports.MO.REL,
      '\u22A4': exports.MO.ORD55,
      '\u22A5': exports.MO.REL,
      '\u22A6': exports.MO.REL,
      '\u22A7': exports.MO.REL,
      '\u22A8': exports.MO.REL,
      '\u22A9': exports.MO.REL,
      '\u22AA': exports.MO.REL,
      '\u22AB': exports.MO.REL,
      '\u22AC': exports.MO.REL,
      '\u22AD': exports.MO.REL,
      '\u22AE': exports.MO.REL,
      '\u22AF': exports.MO.REL,
      '\u22B0': exports.MO.REL,
      '\u22B1': exports.MO.REL,
      '\u22B2': exports.MO.REL,
      '\u22B3': exports.MO.REL,
      '\u22B4': exports.MO.REL,
      '\u22B5': exports.MO.REL,
      '\u22B6': exports.MO.REL,
      '\u22B7': exports.MO.REL,
      '\u22B8': exports.MO.REL,
      '\u22B9': exports.MO.REL,
      '\u22BA': exports.MO.BIN4,
      '\u22BB': exports.MO.BIN4,
      '\u22BC': exports.MO.BIN4,
      '\u22BD': exports.MO.BIN4,
      '\u22BE': exports.MO.BIN3,
      '\u22BF': exports.MO.BIN3,
      '\u22C4': exports.MO.BIN4,
      '\u22C5': exports.MO.BIN4,
      '\u22C6': exports.MO.BIN4,
      '\u22C7': exports.MO.BIN4,
      '\u22C8': exports.MO.REL,
      '\u22C9': exports.MO.BIN4,
      '\u22CA': exports.MO.BIN4,
      '\u22CB': exports.MO.BIN4,
      '\u22CC': exports.MO.BIN4,
      '\u22CD': exports.MO.REL,
      '\u22CE': exports.MO.BIN4,
      '\u22CF': exports.MO.BIN4,
      '\u22D0': exports.MO.REL,
      '\u22D1': exports.MO.REL,
      '\u22D2': exports.MO.BIN4,
      '\u22D3': exports.MO.BIN4,
      '\u22D4': exports.MO.REL,
      '\u22D5': exports.MO.REL,
      '\u22D6': exports.MO.REL,
      '\u22D7': exports.MO.REL,
      '\u22D8': exports.MO.REL,
      '\u22D9': exports.MO.REL,
      '\u22DA': exports.MO.REL,
      '\u22DB': exports.MO.REL,
      '\u22DC': exports.MO.REL,
      '\u22DD': exports.MO.REL,
      '\u22DE': exports.MO.REL,
      '\u22DF': exports.MO.REL,
      '\u22E0': exports.MO.REL,
      '\u22E1': exports.MO.REL,
      '\u22E2': exports.MO.REL,
      '\u22E3': exports.MO.REL,
      '\u22E4': exports.MO.REL,
      '\u22E5': exports.MO.REL,
      '\u22E6': exports.MO.REL,
      '\u22E7': exports.MO.REL,
      '\u22E8': exports.MO.REL,
      '\u22E9': exports.MO.REL,
      '\u22EA': exports.MO.REL,
      '\u22EB': exports.MO.REL,
      '\u22EC': exports.MO.REL,
      '\u22ED': exports.MO.REL,
      '\u22EE': exports.MO.ORD55,
      '\u22EF': exports.MO.INNER,
      '\u22F0': exports.MO.REL,
      '\u22F1': [5, 5, MmlNode_js_1.TEXCLASS.INNER, null],
      '\u22F2': exports.MO.REL,
      '\u22F3': exports.MO.REL,
      '\u22F4': exports.MO.REL,
      '\u22F5': exports.MO.REL,
      '\u22F6': exports.MO.REL,
      '\u22F7': exports.MO.REL,
      '\u22F8': exports.MO.REL,
      '\u22F9': exports.MO.REL,
      '\u22FA': exports.MO.REL,
      '\u22FB': exports.MO.REL,
      '\u22FC': exports.MO.REL,
      '\u22FD': exports.MO.REL,
      '\u22FE': exports.MO.REL,
      '\u22FF': exports.MO.REL,
      '\u2305': exports.MO.BIN3,
      '\u2306': exports.MO.BIN3,
      '\u2322': exports.MO.REL4,
      '\u2323': exports.MO.REL4,
      '\u2329': exports.MO.OPEN,
      '\u232A': exports.MO.CLOSE,
      '\u23AA': exports.MO.ORD,
      '\u23AF': [0, 0, MmlNode_js_1.TEXCLASS.ORD, {
        stretchy: true
      }],
      '\u23B0': exports.MO.OPEN,
      '\u23B1': exports.MO.CLOSE,
      '\u2500': exports.MO.ORD,
      '\u25B3': exports.MO.BIN4,
      '\u25B5': exports.MO.BIN4,
      '\u25B9': exports.MO.BIN4,
      '\u25BD': exports.MO.BIN4,
      '\u25BF': exports.MO.BIN4,
      '\u25C3': exports.MO.BIN4,
      '\u25EF': exports.MO.BIN3,
      '\u2660': exports.MO.ORD,
      '\u2661': exports.MO.ORD,
      '\u2662': exports.MO.ORD,
      '\u2663': exports.MO.ORD,
      '\u2758': exports.MO.REL,
      '\u27F0': exports.MO.RELSTRETCH,
      '\u27F1': exports.MO.RELSTRETCH,
      '\u27F5': exports.MO.WIDEREL,
      '\u27F6': exports.MO.WIDEREL,
      '\u27F7': exports.MO.WIDEREL,
      '\u27F8': exports.MO.WIDEREL,
      '\u27F9': exports.MO.WIDEREL,
      '\u27FA': exports.MO.WIDEREL,
      '\u27FB': exports.MO.WIDEREL,
      '\u27FC': exports.MO.WIDEREL,
      '\u27FD': exports.MO.WIDEREL,
      '\u27FE': exports.MO.WIDEREL,
      '\u27FF': exports.MO.WIDEREL,
      '\u2900': exports.MO.RELACCENT,
      '\u2901': exports.MO.RELACCENT,
      '\u2902': exports.MO.RELACCENT,
      '\u2903': exports.MO.RELACCENT,
      '\u2904': exports.MO.RELACCENT,
      '\u2905': exports.MO.RELACCENT,
      '\u2906': exports.MO.RELACCENT,
      '\u2907': exports.MO.RELACCENT,
      '\u2908': exports.MO.REL,
      '\u2909': exports.MO.REL,
      '\u290A': exports.MO.RELSTRETCH,
      '\u290B': exports.MO.RELSTRETCH,
      '\u290C': exports.MO.WIDEREL,
      '\u290D': exports.MO.WIDEREL,
      '\u290E': exports.MO.WIDEREL,
      '\u290F': exports.MO.WIDEREL,
      '\u2910': exports.MO.WIDEREL,
      '\u2911': exports.MO.RELACCENT,
      '\u2912': exports.MO.RELSTRETCH,
      '\u2913': exports.MO.RELSTRETCH,
      '\u2914': exports.MO.RELACCENT,
      '\u2915': exports.MO.RELACCENT,
      '\u2916': exports.MO.RELACCENT,
      '\u2917': exports.MO.RELACCENT,
      '\u2918': exports.MO.RELACCENT,
      '\u2919': exports.MO.RELACCENT,
      '\u291A': exports.MO.RELACCENT,
      '\u291B': exports.MO.RELACCENT,
      '\u291C': exports.MO.RELACCENT,
      '\u291D': exports.MO.RELACCENT,
      '\u291E': exports.MO.RELACCENT,
      '\u291F': exports.MO.RELACCENT,
      '\u2920': exports.MO.RELACCENT,
      '\u2921': exports.MO.RELSTRETCH,
      '\u2922': exports.MO.RELSTRETCH,
      '\u2923': exports.MO.REL,
      '\u2924': exports.MO.REL,
      '\u2925': exports.MO.REL,
      '\u2926': exports.MO.REL,
      '\u2927': exports.MO.REL,
      '\u2928': exports.MO.REL,
      '\u2929': exports.MO.REL,
      '\u292A': exports.MO.REL,
      '\u292B': exports.MO.REL,
      '\u292C': exports.MO.REL,
      '\u292D': exports.MO.REL,
      '\u292E': exports.MO.REL,
      '\u292F': exports.MO.REL,
      '\u2930': exports.MO.REL,
      '\u2931': exports.MO.REL,
      '\u2932': exports.MO.REL,
      '\u2933': exports.MO.RELACCENT,
      '\u2934': exports.MO.REL,
      '\u2935': exports.MO.REL,
      '\u2936': exports.MO.REL,
      '\u2937': exports.MO.REL,
      '\u2938': exports.MO.REL,
      '\u2939': exports.MO.REL,
      '\u293A': exports.MO.RELACCENT,
      '\u293B': exports.MO.RELACCENT,
      '\u293C': exports.MO.RELACCENT,
      '\u293D': exports.MO.RELACCENT,
      '\u293E': exports.MO.REL,
      '\u293F': exports.MO.REL,
      '\u2940': exports.MO.REL,
      '\u2941': exports.MO.REL,
      '\u2942': exports.MO.RELACCENT,
      '\u2943': exports.MO.RELACCENT,
      '\u2944': exports.MO.RELACCENT,
      '\u2945': exports.MO.RELACCENT,
      '\u2946': exports.MO.RELACCENT,
      '\u2947': exports.MO.RELACCENT,
      '\u2948': exports.MO.RELACCENT,
      '\u2949': exports.MO.REL,
      '\u294A': exports.MO.RELACCENT,
      '\u294B': exports.MO.RELACCENT,
      '\u294C': exports.MO.REL,
      '\u294D': exports.MO.REL,
      '\u294E': exports.MO.WIDEREL,
      '\u294F': exports.MO.RELSTRETCH,
      '\u2950': exports.MO.WIDEREL,
      '\u2951': exports.MO.RELSTRETCH,
      '\u2952': exports.MO.WIDEREL,
      '\u2953': exports.MO.WIDEREL,
      '\u2954': exports.MO.RELSTRETCH,
      '\u2955': exports.MO.RELSTRETCH,
      '\u2956': exports.MO.RELSTRETCH,
      '\u2957': exports.MO.RELSTRETCH,
      '\u2958': exports.MO.RELSTRETCH,
      '\u2959': exports.MO.RELSTRETCH,
      '\u295A': exports.MO.WIDEREL,
      '\u295B': exports.MO.WIDEREL,
      '\u295C': exports.MO.RELSTRETCH,
      '\u295D': exports.MO.RELSTRETCH,
      '\u295E': exports.MO.WIDEREL,
      '\u295F': exports.MO.WIDEREL,
      '\u2960': exports.MO.RELSTRETCH,
      '\u2961': exports.MO.RELSTRETCH,
      '\u2962': exports.MO.RELACCENT,
      '\u2963': exports.MO.REL,
      '\u2964': exports.MO.RELACCENT,
      '\u2965': exports.MO.REL,
      '\u2966': exports.MO.RELACCENT,
      '\u2967': exports.MO.RELACCENT,
      '\u2968': exports.MO.RELACCENT,
      '\u2969': exports.MO.RELACCENT,
      '\u296A': exports.MO.RELACCENT,
      '\u296B': exports.MO.RELACCENT,
      '\u296C': exports.MO.RELACCENT,
      '\u296D': exports.MO.RELACCENT,
      '\u296E': exports.MO.RELSTRETCH,
      '\u296F': exports.MO.RELSTRETCH,
      '\u2970': exports.MO.RELACCENT,
      '\u2971': exports.MO.RELACCENT,
      '\u2972': exports.MO.RELACCENT,
      '\u2973': exports.MO.RELACCENT,
      '\u2974': exports.MO.RELACCENT,
      '\u2975': exports.MO.RELACCENT,
      '\u2976': exports.MO.RELACCENT,
      '\u2977': exports.MO.RELACCENT,
      '\u2978': exports.MO.RELACCENT,
      '\u2979': exports.MO.RELACCENT,
      '\u297A': exports.MO.RELACCENT,
      '\u297B': exports.MO.RELACCENT,
      '\u297C': exports.MO.RELACCENT,
      '\u297D': exports.MO.RELACCENT,
      '\u297E': exports.MO.REL,
      '\u297F': exports.MO.REL,
      '\u2981': exports.MO.BIN3,
      '\u2982': exports.MO.BIN3,
      '\u2999': exports.MO.BIN3,
      '\u299A': exports.MO.BIN3,
      '\u299B': exports.MO.BIN3,
      '\u299C': exports.MO.BIN3,
      '\u299D': exports.MO.BIN3,
      '\u299E': exports.MO.BIN3,
      '\u299F': exports.MO.BIN3,
      '\u29A0': exports.MO.BIN3,
      '\u29A1': exports.MO.BIN3,
      '\u29A2': exports.MO.BIN3,
      '\u29A3': exports.MO.BIN3,
      '\u29A4': exports.MO.BIN3,
      '\u29A5': exports.MO.BIN3,
      '\u29A6': exports.MO.BIN3,
      '\u29A7': exports.MO.BIN3,
      '\u29A8': exports.MO.BIN3,
      '\u29A9': exports.MO.BIN3,
      '\u29AA': exports.MO.BIN3,
      '\u29AB': exports.MO.BIN3,
      '\u29AC': exports.MO.BIN3,
      '\u29AD': exports.MO.BIN3,
      '\u29AE': exports.MO.BIN3,
      '\u29AF': exports.MO.BIN3,
      '\u29B0': exports.MO.BIN3,
      '\u29B1': exports.MO.BIN3,
      '\u29B2': exports.MO.BIN3,
      '\u29B3': exports.MO.BIN3,
      '\u29B4': exports.MO.BIN3,
      '\u29B5': exports.MO.BIN3,
      '\u29B6': exports.MO.BIN4,
      '\u29B7': exports.MO.BIN4,
      '\u29B8': exports.MO.BIN4,
      '\u29B9': exports.MO.BIN4,
      '\u29BA': exports.MO.BIN4,
      '\u29BB': exports.MO.BIN4,
      '\u29BC': exports.MO.BIN4,
      '\u29BD': exports.MO.BIN4,
      '\u29BE': exports.MO.BIN4,
      '\u29BF': exports.MO.BIN4,
      '\u29C0': exports.MO.REL,
      '\u29C1': exports.MO.REL,
      '\u29C2': exports.MO.BIN3,
      '\u29C3': exports.MO.BIN3,
      '\u29C4': exports.MO.BIN4,
      '\u29C5': exports.MO.BIN4,
      '\u29C6': exports.MO.BIN4,
      '\u29C7': exports.MO.BIN4,
      '\u29C8': exports.MO.BIN4,
      '\u29C9': exports.MO.BIN3,
      '\u29CA': exports.MO.BIN3,
      '\u29CB': exports.MO.BIN3,
      '\u29CC': exports.MO.BIN3,
      '\u29CD': exports.MO.BIN3,
      '\u29CE': exports.MO.REL,
      '\u29CF': exports.MO.REL,
      '\u29CF\u0338': exports.MO.REL,
      '\u29D0': exports.MO.REL,
      '\u29D0\u0338': exports.MO.REL,
      '\u29D1': exports.MO.REL,
      '\u29D2': exports.MO.REL,
      '\u29D3': exports.MO.REL,
      '\u29D4': exports.MO.REL,
      '\u29D5': exports.MO.REL,
      '\u29D6': exports.MO.BIN4,
      '\u29D7': exports.MO.BIN4,
      '\u29D8': exports.MO.BIN3,
      '\u29D9': exports.MO.BIN3,
      '\u29DB': exports.MO.BIN3,
      '\u29DC': exports.MO.BIN3,
      '\u29DD': exports.MO.BIN3,
      '\u29DE': exports.MO.REL,
      '\u29DF': exports.MO.BIN3,
      '\u29E0': exports.MO.BIN3,
      '\u29E1': exports.MO.REL,
      '\u29E2': exports.MO.BIN4,
      '\u29E3': exports.MO.REL,
      '\u29E4': exports.MO.REL,
      '\u29E5': exports.MO.REL,
      '\u29E6': exports.MO.REL,
      '\u29E7': exports.MO.BIN3,
      '\u29E8': exports.MO.BIN3,
      '\u29E9': exports.MO.BIN3,
      '\u29EA': exports.MO.BIN3,
      '\u29EB': exports.MO.BIN3,
      '\u29EC': exports.MO.BIN3,
      '\u29ED': exports.MO.BIN3,
      '\u29EE': exports.MO.BIN3,
      '\u29EF': exports.MO.BIN3,
      '\u29F0': exports.MO.BIN3,
      '\u29F1': exports.MO.BIN3,
      '\u29F2': exports.MO.BIN3,
      '\u29F3': exports.MO.BIN3,
      '\u29F4': exports.MO.REL,
      '\u29F5': exports.MO.BIN4,
      '\u29F6': exports.MO.BIN4,
      '\u29F7': exports.MO.BIN4,
      '\u29F8': exports.MO.BIN3,
      '\u29F9': exports.MO.BIN3,
      '\u29FA': exports.MO.BIN3,
      '\u29FB': exports.MO.BIN3,
      '\u29FE': exports.MO.BIN4,
      '\u29FF': exports.MO.BIN4,
      '\u2A1D': exports.MO.BIN3,
      '\u2A1E': exports.MO.BIN3,
      '\u2A1F': exports.MO.BIN3,
      '\u2A20': exports.MO.BIN3,
      '\u2A21': exports.MO.BIN3,
      '\u2A22': exports.MO.BIN4,
      '\u2A23': exports.MO.BIN4,
      '\u2A24': exports.MO.BIN4,
      '\u2A25': exports.MO.BIN4,
      '\u2A26': exports.MO.BIN4,
      '\u2A27': exports.MO.BIN4,
      '\u2A28': exports.MO.BIN4,
      '\u2A29': exports.MO.BIN4,
      '\u2A2A': exports.MO.BIN4,
      '\u2A2B': exports.MO.BIN4,
      '\u2A2C': exports.MO.BIN4,
      '\u2A2D': exports.MO.BIN4,
      '\u2A2E': exports.MO.BIN4,
      '\u2A2F': exports.MO.BIN4,
      '\u2A30': exports.MO.BIN4,
      '\u2A31': exports.MO.BIN4,
      '\u2A32': exports.MO.BIN4,
      '\u2A33': exports.MO.BIN4,
      '\u2A34': exports.MO.BIN4,
      '\u2A35': exports.MO.BIN4,
      '\u2A36': exports.MO.BIN4,
      '\u2A37': exports.MO.BIN4,
      '\u2A38': exports.MO.BIN4,
      '\u2A39': exports.MO.BIN4,
      '\u2A3A': exports.MO.BIN4,
      '\u2A3B': exports.MO.BIN4,
      '\u2A3C': exports.MO.BIN4,
      '\u2A3D': exports.MO.BIN4,
      '\u2A3E': exports.MO.BIN4,
      '\u2A3F': exports.MO.BIN4,
      '\u2A40': exports.MO.BIN4,
      '\u2A41': exports.MO.BIN4,
      '\u2A42': exports.MO.BIN4,
      '\u2A43': exports.MO.BIN4,
      '\u2A44': exports.MO.BIN4,
      '\u2A45': exports.MO.BIN4,
      '\u2A46': exports.MO.BIN4,
      '\u2A47': exports.MO.BIN4,
      '\u2A48': exports.MO.BIN4,
      '\u2A49': exports.MO.BIN4,
      '\u2A4A': exports.MO.BIN4,
      '\u2A4B': exports.MO.BIN4,
      '\u2A4C': exports.MO.BIN4,
      '\u2A4D': exports.MO.BIN4,
      '\u2A4E': exports.MO.BIN4,
      '\u2A4F': exports.MO.BIN4,
      '\u2A50': exports.MO.BIN4,
      '\u2A51': exports.MO.BIN4,
      '\u2A52': exports.MO.BIN4,
      '\u2A53': exports.MO.BIN4,
      '\u2A54': exports.MO.BIN4,
      '\u2A55': exports.MO.BIN4,
      '\u2A56': exports.MO.BIN4,
      '\u2A57': exports.MO.BIN4,
      '\u2A58': exports.MO.BIN4,
      '\u2A59': exports.MO.REL,
      '\u2A5A': exports.MO.BIN4,
      '\u2A5B': exports.MO.BIN4,
      '\u2A5C': exports.MO.BIN4,
      '\u2A5D': exports.MO.BIN4,
      '\u2A5E': exports.MO.BIN4,
      '\u2A5F': exports.MO.BIN4,
      '\u2A60': exports.MO.BIN4,
      '\u2A61': exports.MO.BIN4,
      '\u2A62': exports.MO.BIN4,
      '\u2A63': exports.MO.BIN4,
      '\u2A64': exports.MO.BIN4,
      '\u2A65': exports.MO.BIN4,
      '\u2A66': exports.MO.REL,
      '\u2A67': exports.MO.REL,
      '\u2A68': exports.MO.REL,
      '\u2A69': exports.MO.REL,
      '\u2A6A': exports.MO.REL,
      '\u2A6B': exports.MO.REL,
      '\u2A6C': exports.MO.REL,
      '\u2A6D': exports.MO.REL,
      '\u2A6E': exports.MO.REL,
      '\u2A6F': exports.MO.REL,
      '\u2A70': exports.MO.REL,
      '\u2A71': exports.MO.BIN4,
      '\u2A72': exports.MO.BIN4,
      '\u2A73': exports.MO.REL,
      '\u2A74': exports.MO.REL,
      '\u2A75': exports.MO.REL,
      '\u2A76': exports.MO.REL,
      '\u2A77': exports.MO.REL,
      '\u2A78': exports.MO.REL,
      '\u2A79': exports.MO.REL,
      '\u2A7A': exports.MO.REL,
      '\u2A7B': exports.MO.REL,
      '\u2A7C': exports.MO.REL,
      '\u2A7D': exports.MO.REL,
      '\u2A7D\u0338': exports.MO.REL,
      '\u2A7E': exports.MO.REL,
      '\u2A7E\u0338': exports.MO.REL,
      '\u2A7F': exports.MO.REL,
      '\u2A80': exports.MO.REL,
      '\u2A81': exports.MO.REL,
      '\u2A82': exports.MO.REL,
      '\u2A83': exports.MO.REL,
      '\u2A84': exports.MO.REL,
      '\u2A85': exports.MO.REL,
      '\u2A86': exports.MO.REL,
      '\u2A87': exports.MO.REL,
      '\u2A88': exports.MO.REL,
      '\u2A89': exports.MO.REL,
      '\u2A8A': exports.MO.REL,
      '\u2A8B': exports.MO.REL,
      '\u2A8C': exports.MO.REL,
      '\u2A8D': exports.MO.REL,
      '\u2A8E': exports.MO.REL,
      '\u2A8F': exports.MO.REL,
      '\u2A90': exports.MO.REL,
      '\u2A91': exports.MO.REL,
      '\u2A92': exports.MO.REL,
      '\u2A93': exports.MO.REL,
      '\u2A94': exports.MO.REL,
      '\u2A95': exports.MO.REL,
      '\u2A96': exports.MO.REL,
      '\u2A97': exports.MO.REL,
      '\u2A98': exports.MO.REL,
      '\u2A99': exports.MO.REL,
      '\u2A9A': exports.MO.REL,
      '\u2A9B': exports.MO.REL,
      '\u2A9C': exports.MO.REL,
      '\u2A9D': exports.MO.REL,
      '\u2A9E': exports.MO.REL,
      '\u2A9F': exports.MO.REL,
      '\u2AA0': exports.MO.REL,
      '\u2AA1': exports.MO.REL,
      '\u2AA1\u0338': exports.MO.REL,
      '\u2AA2': exports.MO.REL,
      '\u2AA2\u0338': exports.MO.REL,
      '\u2AA3': exports.MO.REL,
      '\u2AA4': exports.MO.REL,
      '\u2AA5': exports.MO.REL,
      '\u2AA6': exports.MO.REL,
      '\u2AA7': exports.MO.REL,
      '\u2AA8': exports.MO.REL,
      '\u2AA9': exports.MO.REL,
      '\u2AAA': exports.MO.REL,
      '\u2AAB': exports.MO.REL,
      '\u2AAC': exports.MO.REL,
      '\u2AAD': exports.MO.REL,
      '\u2AAE': exports.MO.REL,
      '\u2AAF': exports.MO.REL,
      '\u2AAF\u0338': exports.MO.REL,
      '\u2AB0': exports.MO.REL,
      '\u2AB0\u0338': exports.MO.REL,
      '\u2AB1': exports.MO.REL,
      '\u2AB2': exports.MO.REL,
      '\u2AB3': exports.MO.REL,
      '\u2AB4': exports.MO.REL,
      '\u2AB5': exports.MO.REL,
      '\u2AB6': exports.MO.REL,
      '\u2AB7': exports.MO.REL,
      '\u2AB8': exports.MO.REL,
      '\u2AB9': exports.MO.REL,
      '\u2ABA': exports.MO.REL,
      '\u2ABB': exports.MO.REL,
      '\u2ABC': exports.MO.REL,
      '\u2ABD': exports.MO.REL,
      '\u2ABE': exports.MO.REL,
      '\u2ABF': exports.MO.REL,
      '\u2AC0': exports.MO.REL,
      '\u2AC1': exports.MO.REL,
      '\u2AC2': exports.MO.REL,
      '\u2AC3': exports.MO.REL,
      '\u2AC4': exports.MO.REL,
      '\u2AC5': exports.MO.REL,
      '\u2AC6': exports.MO.REL,
      '\u2AC7': exports.MO.REL,
      '\u2AC8': exports.MO.REL,
      '\u2AC9': exports.MO.REL,
      '\u2ACA': exports.MO.REL,
      '\u2ACB': exports.MO.REL,
      '\u2ACC': exports.MO.REL,
      '\u2ACD': exports.MO.REL,
      '\u2ACE': exports.MO.REL,
      '\u2ACF': exports.MO.REL,
      '\u2AD0': exports.MO.REL,
      '\u2AD1': exports.MO.REL,
      '\u2AD2': exports.MO.REL,
      '\u2AD3': exports.MO.REL,
      '\u2AD4': exports.MO.REL,
      '\u2AD5': exports.MO.REL,
      '\u2AD6': exports.MO.REL,
      '\u2AD7': exports.MO.REL,
      '\u2AD8': exports.MO.REL,
      '\u2AD9': exports.MO.REL,
      '\u2ADA': exports.MO.REL,
      '\u2ADB': exports.MO.REL,
      '\u2ADD': exports.MO.REL,
      '\u2ADD\u0338': exports.MO.REL,
      '\u2ADE': exports.MO.REL,
      '\u2ADF': exports.MO.REL,
      '\u2AE0': exports.MO.REL,
      '\u2AE1': exports.MO.REL,
      '\u2AE2': exports.MO.REL,
      '\u2AE3': exports.MO.REL,
      '\u2AE4': exports.MO.REL,
      '\u2AE5': exports.MO.REL,
      '\u2AE6': exports.MO.REL,
      '\u2AE7': exports.MO.REL,
      '\u2AE8': exports.MO.REL,
      '\u2AE9': exports.MO.REL,
      '\u2AEA': exports.MO.REL,
      '\u2AEB': exports.MO.REL,
      '\u2AEC': exports.MO.REL,
      '\u2AED': exports.MO.REL,
      '\u2AEE': exports.MO.REL,
      '\u2AEF': exports.MO.REL,
      '\u2AF0': exports.MO.REL,
      '\u2AF1': exports.MO.REL,
      '\u2AF2': exports.MO.REL,
      '\u2AF3': exports.MO.REL,
      '\u2AF4': exports.MO.BIN4,
      '\u2AF5': exports.MO.BIN4,
      '\u2AF6': exports.MO.BIN4,
      '\u2AF7': exports.MO.REL,
      '\u2AF8': exports.MO.REL,
      '\u2AF9': exports.MO.REL,
      '\u2AFA': exports.MO.REL,
      '\u2AFB': exports.MO.BIN4,
      '\u2AFD': exports.MO.BIN4,
      '\u2AFE': exports.MO.BIN3,
      '\u2B45': exports.MO.RELSTRETCH,
      '\u2B46': exports.MO.RELSTRETCH,
      '\u3008': exports.MO.OPEN,
      '\u3009': exports.MO.CLOSE,
      '\uFE37': exports.MO.WIDEACCENT,
      '\uFE38': exports.MO.WIDEACCENT
    }
  };
  exports.OPTABLE.infix['^'] = exports.MO.WIDEREL;
  exports.OPTABLE.infix['_'] = exports.MO.WIDEREL;
  exports.OPTABLE.infix['\u2ADC'] = exports.MO.REL;
})(OperatorDictionary);
getDefaultExportFromCjs(OperatorDictionary);

var string = {};

var __read$Z = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$x = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(string, "__esModule", {
  value: true
});
string.split = string.isPercent = string.unicodeString = string.unicodeChars = string.quotePattern = string.sortLength = void 0;
function sortLength(a, b) {
  return a.length !== b.length ? b.length - a.length : a === b ? 0 : a < b ? -1 : 1;
}
string.sortLength = sortLength;
function quotePattern(text) {
  return text.replace(/([\^$(){}+*?\-|\[\]\:\\])/g, '\\$1');
}
string.quotePattern = quotePattern;
function unicodeChars(text) {
  return Array.from(text).map(function (c) {
    return c.codePointAt(0);
  });
}
string.unicodeChars = unicodeChars;
function unicodeString(data) {
  return String.fromCodePoint.apply(String, __spreadArray$x([], __read$Z(data), false));
}
string.unicodeString = unicodeString;
function isPercent(x) {
  return !!x.match(/%\s*$/);
}
string.isPercent = isPercent;
function split(x) {
  return x.trim().split(/\s+/);
}
string.split = split;

var __extends$2c = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$F = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$F = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$F.apply(this, arguments);
});
var __read$Y = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$W = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mo$2, "__esModule", {
  value: true
});
mo$2.MmlMo = void 0;
var MmlNode_js_1$M = MmlNode;
var OperatorDictionary_js_1$1 = OperatorDictionary;
var string_js_1$a = string;
var MmlMo = (function (_super) {
  __extends$2c(MmlMo, _super);
  function MmlMo() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._texClass = null;
    _this.lspace = 5 / 18;
    _this.rspace = 5 / 18;
    return _this;
  }
  Object.defineProperty(MmlMo.prototype, "texClass", {
    get: function () {
      if (this._texClass === null) {
        var mo = this.getText();
        var _a = __read$Y(this.handleExplicitForm(this.getForms()), 3), form1 = _a[0], form2 = _a[1], form3 = _a[2];
        var OPTABLE_1 = this.constructor.OPTABLE;
        var def = OPTABLE_1[form1][mo] || OPTABLE_1[form2][mo] || OPTABLE_1[form3][mo];
        return def ? def[2] : MmlNode_js_1$M.TEXCLASS.REL;
      }
      return this._texClass;
    },
    set: function (value) {
      this._texClass = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMo.prototype, "kind", {
    get: function () {
      return 'mo';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMo.prototype, "isEmbellished", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMo.prototype, "hasNewLine", {
    get: function () {
      return this.attributes.get('linebreak') === 'newline';
    },
    enumerable: false,
    configurable: true
  });
  MmlMo.prototype.coreParent = function () {
    var embellished = this;
    var parent = this;
    var math = this.factory.getNodeClass('math');
    while (parent && parent.isEmbellished && parent.coreMO() === this && !(parent instanceof math)) {
      embellished = parent;
      parent = parent.parent;
    }
    return embellished;
  };
  MmlMo.prototype.coreText = function (parent) {
    if (!parent) {
      return '';
    }
    if (parent.isEmbellished) {
      return parent.coreMO().getText();
    }
    while (((parent.isKind('mrow') || parent.isKind('TeXAtom') && parent.texClass !== MmlNode_js_1$M.TEXCLASS.VCENTER || parent.isKind('mstyle') || parent.isKind('mphantom')) && parent.childNodes.length === 1 || parent.isKind('munderover')) && parent.childNodes[0]) {
      parent = parent.childNodes[0];
    }
    return parent.isToken ? parent.getText() : '';
  };
  MmlMo.prototype.hasSpacingAttributes = function () {
    return this.attributes.isSet('lspace') || this.attributes.isSet('rspace');
  };
  Object.defineProperty(MmlMo.prototype, "isAccent", {
    get: function () {
      var accent = false;
      var node = this.coreParent().parent;
      if (node) {
        var key = node.isKind('mover') ? node.childNodes[node.over].coreMO() ? 'accent' : '' : node.isKind('munder') ? node.childNodes[node.under].coreMO() ? 'accentunder' : '' : node.isKind('munderover') ? this === node.childNodes[node.over].coreMO() ? 'accent' : this === node.childNodes[node.under].coreMO() ? 'accentunder' : '' : '';
        if (key) {
          var value = node.attributes.getExplicit(key);
          accent = value !== undefined ? accent : this.attributes.get('accent');
        }
      }
      return accent;
    },
    enumerable: false,
    configurable: true
  });
  MmlMo.prototype.setTeXclass = function (prev) {
    var _a = this.attributes.getList('form', 'fence'), form = _a.form, fence = _a.fence;
    if (this.getProperty('texClass') === undefined && (this.attributes.isSet('lspace') || this.attributes.isSet('rspace'))) {
      return null;
    }
    if (fence && this.texClass === MmlNode_js_1$M.TEXCLASS.REL) {
      if (form === 'prefix') {
        this.texClass = MmlNode_js_1$M.TEXCLASS.OPEN;
      }
      if (form === 'postfix') {
        this.texClass = MmlNode_js_1$M.TEXCLASS.CLOSE;
      }
    }
    return this.adjustTeXclass(prev);
  };
  MmlMo.prototype.adjustTeXclass = function (prev) {
    var texClass = this.texClass;
    var prevClass = this.prevClass;
    if (texClass === MmlNode_js_1$M.TEXCLASS.NONE) {
      return prev;
    }
    if (prev) {
      if (prev.getProperty('autoOP') && (texClass === MmlNode_js_1$M.TEXCLASS.BIN || texClass === MmlNode_js_1$M.TEXCLASS.REL)) {
        prevClass = prev.texClass = MmlNode_js_1$M.TEXCLASS.ORD;
      }
      prevClass = this.prevClass = prev.texClass || MmlNode_js_1$M.TEXCLASS.ORD;
      this.prevLevel = this.attributes.getInherited('scriptlevel');
    } else {
      prevClass = this.prevClass = MmlNode_js_1$M.TEXCLASS.NONE;
    }
    if (texClass === MmlNode_js_1$M.TEXCLASS.BIN && (prevClass === MmlNode_js_1$M.TEXCLASS.NONE || prevClass === MmlNode_js_1$M.TEXCLASS.BIN || prevClass === MmlNode_js_1$M.TEXCLASS.OP || prevClass === MmlNode_js_1$M.TEXCLASS.REL || prevClass === MmlNode_js_1$M.TEXCLASS.OPEN || prevClass === MmlNode_js_1$M.TEXCLASS.PUNCT)) {
      this.texClass = MmlNode_js_1$M.TEXCLASS.ORD;
    } else if (prevClass === MmlNode_js_1$M.TEXCLASS.BIN && (texClass === MmlNode_js_1$M.TEXCLASS.REL || texClass === MmlNode_js_1$M.TEXCLASS.CLOSE || texClass === MmlNode_js_1$M.TEXCLASS.PUNCT)) {
      prev.texClass = this.prevClass = MmlNode_js_1$M.TEXCLASS.ORD;
    } else if (texClass === MmlNode_js_1$M.TEXCLASS.BIN) {
      var child = this;
      var parent_1 = this.parent;
      while (parent_1 && parent_1.parent && parent_1.isEmbellished && (parent_1.childNodes.length === 1 || !parent_1.isKind('mrow') && parent_1.core() === child)) {
        child = parent_1;
        parent_1 = parent_1.parent;
      }
      if (parent_1.childNodes[parent_1.childNodes.length - 1] === child) {
        this.texClass = MmlNode_js_1$M.TEXCLASS.ORD;
      }
    }
    return this;
  };
  MmlMo.prototype.setInheritedAttributes = function (attributes, display, level, prime) {
    if (attributes === void 0) {
      attributes = {};
    }
    if (display === void 0) {
      display = false;
    }
    if (level === void 0) {
      level = 0;
    }
    if (prime === void 0) {
      prime = false;
    }
    _super.prototype.setInheritedAttributes.call(this, attributes, display, level, prime);
    var mo = this.getText();
    this.checkOperatorTable(mo);
    this.checkPseudoScripts(mo);
    this.checkPrimes(mo);
    this.checkMathAccent(mo);
  };
  MmlMo.prototype.checkOperatorTable = function (mo) {
    var e_1, _a;
    var _b = __read$Y(this.handleExplicitForm(this.getForms()), 3), form1 = _b[0], form2 = _b[1], form3 = _b[2];
    this.attributes.setInherited('form', form1);
    var OPTABLE = this.constructor.OPTABLE;
    var def = OPTABLE[form1][mo] || OPTABLE[form2][mo] || OPTABLE[form3][mo];
    if (def) {
      if (this.getProperty('texClass') === undefined) {
        this.texClass = def[2];
      }
      try {
        for (var _c = __values$W(Object.keys(def[3] || ({}))), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_1 = _d.value;
          this.attributes.setInherited(name_1, def[3][name_1]);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      this.lspace = (def[0] + 1) / 18;
      this.rspace = (def[1] + 1) / 18;
    } else {
      var range = (0, OperatorDictionary_js_1$1.getRange)(mo);
      if (range) {
        if (this.getProperty('texClass') === undefined) {
          this.texClass = range[2];
        }
        var spacing = this.constructor.MMLSPACING[range[2]];
        this.lspace = (spacing[0] + 1) / 18;
        this.rspace = (spacing[1] + 1) / 18;
      }
    }
  };
  MmlMo.prototype.getForms = function () {
    var core = this;
    var parent = this.parent;
    var Parent = this.Parent;
    while (Parent && Parent.isEmbellished) {
      core = parent;
      parent = Parent.parent;
      Parent = Parent.Parent;
    }
    if (parent && parent.isKind('mrow') && parent.nonSpaceLength() !== 1) {
      if (parent.firstNonSpace() === core) {
        return ['prefix', 'infix', 'postfix'];
      }
      if (parent.lastNonSpace() === core) {
        return ['postfix', 'infix', 'prefix'];
      }
    }
    return ['infix', 'prefix', 'postfix'];
  };
  MmlMo.prototype.handleExplicitForm = function (forms) {
    if (this.attributes.isSet('form')) {
      var form_1 = this.attributes.get('form');
      forms = [form_1].concat(forms.filter(function (name) {
        return name !== form_1;
      }));
    }
    return forms;
  };
  MmlMo.prototype.checkPseudoScripts = function (mo) {
    var PSEUDOSCRIPTS = this.constructor.pseudoScripts;
    if (!mo.match(PSEUDOSCRIPTS)) return;
    var parent = this.coreParent().Parent;
    var isPseudo = !parent || !(parent.isKind('msubsup') && !parent.isKind('msub'));
    this.setProperty('pseudoscript', isPseudo);
    if (isPseudo) {
      this.attributes.setInherited('lspace', 0);
      this.attributes.setInherited('rspace', 0);
    }
  };
  MmlMo.prototype.checkPrimes = function (mo) {
    var PRIMES = this.constructor.primes;
    if (!mo.match(PRIMES)) return;
    var REMAP = this.constructor.remapPrimes;
    var primes = (0, string_js_1$a.unicodeString)((0, string_js_1$a.unicodeChars)(mo).map(function (c) {
      return REMAP[c];
    }));
    this.setProperty('primes', primes);
  };
  MmlMo.prototype.checkMathAccent = function (mo) {
    var parent = this.Parent;
    if (this.getProperty('mathaccent') !== undefined || !parent || !parent.isKind('munderover')) return;
    var base = parent.childNodes[0];
    if (base.isEmbellished && base.coreMO() === this) return;
    var MATHACCENT = this.constructor.mathaccents;
    if (mo.match(MATHACCENT)) {
      this.setProperty('mathaccent', true);
    }
  };
  MmlMo.defaults = __assign$F(__assign$F({}, MmlNode_js_1$M.AbstractMmlTokenNode.defaults), {
    form: 'infix',
    fence: false,
    separator: false,
    lspace: 'thickmathspace',
    rspace: 'thickmathspace',
    stretchy: false,
    symmetric: false,
    maxsize: 'infinity',
    minsize: '0em',
    largeop: false,
    movablelimits: false,
    accent: false,
    linebreak: 'auto',
    lineleading: '1ex',
    linebreakstyle: 'before',
    indentalign: 'auto',
    indentshift: '0',
    indenttarget: '',
    indentalignfirst: 'indentalign',
    indentshiftfirst: 'indentshift',
    indentalignlast: 'indentalign',
    indentshiftlast: 'indentshift'
  });
  MmlMo.MMLSPACING = OperatorDictionary_js_1$1.MMLSPACING;
  MmlMo.OPTABLE = OperatorDictionary_js_1$1.OPTABLE;
  MmlMo.pseudoScripts = new RegExp(['^["\'*`', '\u00AA', '\u00B0', '\u00B2-\u00B4', '\u00B9', '\u00BA', '\u2018-\u201F', '\u2032-\u2037\u2057', '\u2070\u2071', '\u2074-\u207F', '\u2080-\u208E', ']+$'].join(''));
  MmlMo.primes = new RegExp(['^["\'`', '\u2018-\u201F', ']+$'].join(''));
  MmlMo.remapPrimes = {
    0x0022: 0x2033,
    0x0027: 0x2032,
    0x0060: 0x2035,
    0x2018: 0x2035,
    0x2019: 0x2032,
    0x201A: 0x2032,
    0x201B: 0x2035,
    0x201C: 0x2036,
    0x201D: 0x2033,
    0x201E: 0x2033,
    0x201F: 0x2036
  };
  MmlMo.mathaccents = new RegExp(['^[', '\u00B4\u0301\u02CA', '\u0060\u0300\u02CB', '\u00A8\u0308', '\u007E\u0303\u02DC', '\u00AF\u0304\u02C9', '\u02D8\u0306', '\u02C7\u030C', '\u005E\u0302\u02C6', '\u2192\u20D7', '\u02D9\u0307', '\u02DA\u030A', '\u20DB', '\u20DC', ']$'].join(''));
  return MmlMo;
})(MmlNode_js_1$M.AbstractMmlTokenNode);
mo$2.MmlMo = MmlMo;

var mtext$2 = {};

var __extends$2b = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$E = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$E = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$E.apply(this, arguments);
});
Object.defineProperty(mtext$2, "__esModule", {
  value: true
});
mtext$2.MmlMtext = void 0;
var MmlNode_js_1$L = MmlNode;
var MmlMtext = (function (_super) {
  __extends$2b(MmlMtext, _super);
  function MmlMtext() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$L.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMtext.prototype, "kind", {
    get: function () {
      return 'mtext';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMtext.prototype, "isSpacelike", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMtext.defaults = __assign$E({}, MmlNode_js_1$L.AbstractMmlTokenNode.defaults);
  return MmlMtext;
})(MmlNode_js_1$L.AbstractMmlTokenNode);
mtext$2.MmlMtext = MmlMtext;

var mspace$2 = {};

var __extends$2a = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$D = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$D = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$D.apply(this, arguments);
});
Object.defineProperty(mspace$2, "__esModule", {
  value: true
});
mspace$2.MmlMspace = void 0;
var MmlNode_js_1$K = MmlNode;
var MmlMspace = (function (_super) {
  __extends$2a(MmlMspace, _super);
  function MmlMspace() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$K.TEXCLASS.NONE;
    return _this;
  }
  MmlMspace.prototype.setTeXclass = function (prev) {
    return prev;
  };
  Object.defineProperty(MmlMspace.prototype, "kind", {
    get: function () {
      return 'mspace';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMspace.prototype, "arity", {
    get: function () {
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMspace.prototype, "isSpacelike", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMspace.prototype, "hasNewline", {
    get: function () {
      var attributes = this.attributes;
      return attributes.getExplicit('width') == null && attributes.getExplicit('height') == null && attributes.getExplicit('depth') == null && attributes.get('linebreak') === 'newline';
    },
    enumerable: false,
    configurable: true
  });
  MmlMspace.defaults = __assign$D(__assign$D({}, MmlNode_js_1$K.AbstractMmlTokenNode.defaults), {
    width: '0em',
    height: '0ex',
    depth: '0ex',
    linebreak: 'auto'
  });
  return MmlMspace;
})(MmlNode_js_1$K.AbstractMmlTokenNode);
mspace$2.MmlMspace = MmlMspace;

var ms$3 = {};

var __extends$29 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$C = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$C = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$C.apply(this, arguments);
});
Object.defineProperty(ms$3, "__esModule", {
  value: true
});
ms$3.MmlMs = void 0;
var MmlNode_js_1$J = MmlNode;
var MmlMs = (function (_super) {
  __extends$29(MmlMs, _super);
  function MmlMs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$J.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMs.prototype, "kind", {
    get: function () {
      return 'ms';
    },
    enumerable: false,
    configurable: true
  });
  MmlMs.defaults = __assign$C(__assign$C({}, MmlNode_js_1$J.AbstractMmlTokenNode.defaults), {
    lquote: '"',
    rquote: '"'
  });
  return MmlMs;
})(MmlNode_js_1$J.AbstractMmlTokenNode);
ms$3.MmlMs = MmlMs;

var mrow$2 = {};

var __extends$28 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$B = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$B = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$B.apply(this, arguments);
});
var __values$V = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mrow$2, "__esModule", {
  value: true
});
mrow$2.MmlInferredMrow = mrow$2.MmlMrow = void 0;
var MmlNode_js_1$I = MmlNode;
var MmlMrow = (function (_super) {
  __extends$28(MmlMrow, _super);
  function MmlMrow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._core = null;
    return _this;
  }
  Object.defineProperty(MmlMrow.prototype, "kind", {
    get: function () {
      return 'mrow';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMrow.prototype, "isSpacelike", {
    get: function () {
      var e_1, _a;
      try {
        for (var _b = __values$V(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (!child.isSpacelike) {
            return false;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMrow.prototype, "isEmbellished", {
    get: function () {
      var e_2, _a;
      var embellished = false;
      var i = 0;
      try {
        for (var _b = __values$V(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (child) {
            if (child.isEmbellished) {
              if (embellished) {
                return false;
              }
              embellished = true;
              this._core = i;
            } else if (!child.isSpacelike) {
              return false;
            }
          }
          i++;
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      return embellished;
    },
    enumerable: false,
    configurable: true
  });
  MmlMrow.prototype.core = function () {
    if (!this.isEmbellished || this._core == null) {
      return this;
    }
    return this.childNodes[this._core];
  };
  MmlMrow.prototype.coreMO = function () {
    if (!this.isEmbellished || this._core == null) {
      return this;
    }
    return this.childNodes[this._core].coreMO();
  };
  MmlMrow.prototype.nonSpaceLength = function () {
    var e_3, _a;
    var n = 0;
    try {
      for (var _b = __values$V(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        if (child && !child.isSpacelike) {
          n++;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return n;
  };
  MmlMrow.prototype.firstNonSpace = function () {
    var e_4, _a;
    try {
      for (var _b = __values$V(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        if (child && !child.isSpacelike) {
          return child;
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    return null;
  };
  MmlMrow.prototype.lastNonSpace = function () {
    var i = this.childNodes.length;
    while (--i >= 0) {
      var child = this.childNodes[i];
      if (child && !child.isSpacelike) {
        return child;
      }
    }
    return null;
  };
  MmlMrow.prototype.setTeXclass = function (prev) {
    var e_5, _a, e_6, _b;
    if (this.getProperty('open') != null || this.getProperty('close') != null) {
      this.getPrevClass(prev);
      prev = null;
      try {
        for (var _c = __values$V(this.childNodes), _d = _c.next(); !_d.done; _d = _c.next()) {
          var child = _d.value;
          prev = child.setTeXclass(prev);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      if (this.texClass == null) {
        this.texClass = MmlNode_js_1$I.TEXCLASS.INNER;
      }
    } else {
      try {
        for (var _e = __values$V(this.childNodes), _f = _e.next(); !_f.done; _f = _e.next()) {
          var child = _f.value;
          prev = child.setTeXclass(prev);
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        } finally {
          if (e_6) throw e_6.error;
        }
      }
      if (this.childNodes[0]) {
        this.updateTeXclass(this.childNodes[0]);
      }
    }
    return prev;
  };
  MmlMrow.defaults = __assign$B({}, MmlNode_js_1$I.AbstractMmlNode.defaults);
  return MmlMrow;
})(MmlNode_js_1$I.AbstractMmlNode);
mrow$2.MmlMrow = MmlMrow;
var MmlInferredMrow = (function (_super) {
  __extends$28(MmlInferredMrow, _super);
  function MmlInferredMrow() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlInferredMrow.prototype, "kind", {
    get: function () {
      return 'inferredMrow';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlInferredMrow.prototype, "isInferred", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlInferredMrow.prototype, "notParent", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlInferredMrow.prototype.toString = function () {
    return '[' + this.childNodes.join(',') + ']';
  };
  MmlInferredMrow.defaults = MmlMrow.defaults;
  return MmlInferredMrow;
})(MmlMrow);
mrow$2.MmlInferredMrow = MmlInferredMrow;

var mfrac$2 = {};

var __extends$27 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$A = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$A = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$A.apply(this, arguments);
});
var __values$U = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mfrac$2, "__esModule", {
  value: true
});
mfrac$2.MmlMfrac = void 0;
var MmlNode_js_1$H = MmlNode;
var MmlMfrac = (function (_super) {
  __extends$27(MmlMfrac, _super);
  function MmlMfrac() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMfrac.prototype, "kind", {
    get: function () {
      return 'mfrac';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMfrac.prototype, "arity", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMfrac.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMfrac.prototype.setTeXclass = function (prev) {
    var e_1, _a;
    this.getPrevClass(prev);
    try {
      for (var _b = __values$U(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        child.setTeXclass(null);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return this;
  };
  MmlMfrac.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    if (!display || level > 0) {
      level++;
    }
    this.childNodes[0].setInheritedAttributes(attributes, false, level, prime);
    this.childNodes[1].setInheritedAttributes(attributes, false, level, true);
  };
  MmlMfrac.defaults = __assign$A(__assign$A({}, MmlNode_js_1$H.AbstractMmlBaseNode.defaults), {
    linethickness: 'medium',
    numalign: 'center',
    denomalign: 'center',
    bevelled: false
  });
  return MmlMfrac;
})(MmlNode_js_1$H.AbstractMmlBaseNode);
mfrac$2.MmlMfrac = MmlMfrac;

var msqrt$2 = {};

var __extends$26 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$z = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$z = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$z.apply(this, arguments);
});
Object.defineProperty(msqrt$2, "__esModule", {
  value: true
});
msqrt$2.MmlMsqrt = void 0;
var MmlNode_js_1$G = MmlNode;
var MmlMsqrt = (function (_super) {
  __extends$26(MmlMsqrt, _super);
  function MmlMsqrt() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$G.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMsqrt.prototype, "kind", {
    get: function () {
      return 'msqrt';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsqrt.prototype, "arity", {
    get: function () {
      return -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsqrt.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMsqrt.prototype.setTeXclass = function (prev) {
    this.getPrevClass(prev);
    this.childNodes[0].setTeXclass(null);
    return this;
  };
  MmlMsqrt.prototype.setChildInheritedAttributes = function (attributes, display, level, _prime) {
    this.childNodes[0].setInheritedAttributes(attributes, display, level, true);
  };
  MmlMsqrt.defaults = __assign$z({}, MmlNode_js_1$G.AbstractMmlNode.defaults);
  return MmlMsqrt;
})(MmlNode_js_1$G.AbstractMmlNode);
msqrt$2.MmlMsqrt = MmlMsqrt;

var mroot$2 = {};

var __extends$25 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$y = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$y = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$y.apply(this, arguments);
});
Object.defineProperty(mroot$2, "__esModule", {
  value: true
});
mroot$2.MmlMroot = void 0;
var MmlNode_js_1$F = MmlNode;
var MmlMroot = (function (_super) {
  __extends$25(MmlMroot, _super);
  function MmlMroot() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$F.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMroot.prototype, "kind", {
    get: function () {
      return 'mroot';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMroot.prototype, "arity", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  MmlMroot.prototype.setTeXclass = function (prev) {
    this.getPrevClass(prev);
    this.childNodes[0].setTeXclass(null);
    this.childNodes[1].setTeXclass(null);
    return this;
  };
  MmlMroot.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    this.childNodes[0].setInheritedAttributes(attributes, display, level, true);
    this.childNodes[1].setInheritedAttributes(attributes, false, level + 2, prime);
  };
  MmlMroot.defaults = __assign$y({}, MmlNode_js_1$F.AbstractMmlNode.defaults);
  return MmlMroot;
})(MmlNode_js_1$F.AbstractMmlNode);
mroot$2.MmlMroot = MmlMroot;

var mstyle = {};

var __extends$24 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$x = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$x = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$x.apply(this, arguments);
});
Object.defineProperty(mstyle, "__esModule", {
  value: true
});
mstyle.MmlMstyle = void 0;
var MmlNode_js_1$E = MmlNode;
var Attributes_js_1$3 = Attributes;
var MmlMstyle = (function (_super) {
  __extends$24(MmlMstyle, _super);
  function MmlMstyle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMstyle.prototype, "kind", {
    get: function () {
      return 'mstyle';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMstyle.prototype, "notParent", {
    get: function () {
      return this.childNodes[0] && this.childNodes[0].childNodes.length === 1;
    },
    enumerable: false,
    configurable: true
  });
  MmlMstyle.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    var scriptlevel = this.attributes.getExplicit('scriptlevel');
    if (scriptlevel != null) {
      scriptlevel = scriptlevel.toString();
      if (scriptlevel.match(/^\s*[-+]/)) {
        level += parseInt(scriptlevel);
      } else {
        level = parseInt(scriptlevel);
      }
      prime = false;
    }
    var displaystyle = this.attributes.getExplicit('displaystyle');
    if (displaystyle != null) {
      display = displaystyle === true;
      prime = false;
    }
    var cramped = this.attributes.getExplicit('data-cramped');
    if (cramped != null) {
      prime = cramped;
    }
    attributes = this.addInheritedAttributes(attributes, this.attributes.getAllAttributes());
    this.childNodes[0].setInheritedAttributes(attributes, display, level, prime);
  };
  MmlMstyle.defaults = __assign$x(__assign$x({}, MmlNode_js_1$E.AbstractMmlLayoutNode.defaults), {
    scriptlevel: Attributes_js_1$3.INHERIT,
    displaystyle: Attributes_js_1$3.INHERIT,
    scriptsizemultiplier: 1 / Math.sqrt(2),
    scriptminsize: '8px',
    mathbackground: Attributes_js_1$3.INHERIT,
    mathcolor: Attributes_js_1$3.INHERIT,
    dir: Attributes_js_1$3.INHERIT,
    infixlinebreakstyle: 'before'
  });
  return MmlMstyle;
})(MmlNode_js_1$E.AbstractMmlLayoutNode);
mstyle.MmlMstyle = MmlMstyle;

var merror = {};

var __extends$23 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$w = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$w = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$w.apply(this, arguments);
});
Object.defineProperty(merror, "__esModule", {
  value: true
});
merror.MmlMerror = void 0;
var MmlNode_js_1$D = MmlNode;
var MmlMerror = (function (_super) {
  __extends$23(MmlMerror, _super);
  function MmlMerror() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$D.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMerror.prototype, "kind", {
    get: function () {
      return 'merror';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMerror.prototype, "arity", {
    get: function () {
      return -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMerror.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMerror.defaults = __assign$w({}, MmlNode_js_1$D.AbstractMmlNode.defaults);
  return MmlMerror;
})(MmlNode_js_1$D.AbstractMmlNode);
merror.MmlMerror = MmlMerror;

var mpadded$2 = {};

var __extends$22 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$v = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$v = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$v.apply(this, arguments);
});
Object.defineProperty(mpadded$2, "__esModule", {
  value: true
});
mpadded$2.MmlMpadded = void 0;
var MmlNode_js_1$C = MmlNode;
var MmlMpadded = (function (_super) {
  __extends$22(MmlMpadded, _super);
  function MmlMpadded() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMpadded.prototype, "kind", {
    get: function () {
      return 'mpadded';
    },
    enumerable: false,
    configurable: true
  });
  MmlMpadded.defaults = __assign$v(__assign$v({}, MmlNode_js_1$C.AbstractMmlLayoutNode.defaults), {
    width: '',
    height: '',
    depth: '',
    lspace: 0,
    voffset: 0
  });
  return MmlMpadded;
})(MmlNode_js_1$C.AbstractMmlLayoutNode);
mpadded$2.MmlMpadded = MmlMpadded;

var mphantom = {};

var __extends$21 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$u = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$u = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$u.apply(this, arguments);
});
Object.defineProperty(mphantom, "__esModule", {
  value: true
});
mphantom.MmlMphantom = void 0;
var MmlNode_js_1$B = MmlNode;
var MmlMphantom = (function (_super) {
  __extends$21(MmlMphantom, _super);
  function MmlMphantom() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$B.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMphantom.prototype, "kind", {
    get: function () {
      return 'mphantom';
    },
    enumerable: false,
    configurable: true
  });
  MmlMphantom.defaults = __assign$u({}, MmlNode_js_1$B.AbstractMmlLayoutNode.defaults);
  return MmlMphantom;
})(MmlNode_js_1$B.AbstractMmlLayoutNode);
mphantom.MmlMphantom = MmlMphantom;

var mfenced$2 = {};

var __extends$20 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$t = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$t = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$t.apply(this, arguments);
});
var __values$T = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mfenced$2, "__esModule", {
  value: true
});
mfenced$2.MmlMfenced = void 0;
var MmlNode_js_1$A = MmlNode;
var MmlMfenced = (function (_super) {
  __extends$20(MmlMfenced, _super);
  function MmlMfenced() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$A.TEXCLASS.INNER;
    _this.separators = [];
    _this.open = null;
    _this.close = null;
    return _this;
  }
  Object.defineProperty(MmlMfenced.prototype, "kind", {
    get: function () {
      return 'mfenced';
    },
    enumerable: false,
    configurable: true
  });
  MmlMfenced.prototype.setTeXclass = function (prev) {
    this.getPrevClass(prev);
    if (this.open) {
      prev = this.open.setTeXclass(prev);
    }
    if (this.childNodes[0]) {
      prev = this.childNodes[0].setTeXclass(prev);
    }
    for (var i = 1, m = this.childNodes.length; i < m; i++) {
      if (this.separators[i - 1]) {
        prev = this.separators[i - 1].setTeXclass(prev);
      }
      if (this.childNodes[i]) {
        prev = this.childNodes[i].setTeXclass(prev);
      }
    }
    if (this.close) {
      prev = this.close.setTeXclass(prev);
    }
    this.updateTeXclass(this.open);
    return prev;
  };
  MmlMfenced.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    var e_1, _a;
    this.addFakeNodes();
    try {
      for (var _b = __values$T([this.open, this.close].concat(this.separators)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        if (child) {
          child.setInheritedAttributes(attributes, display, level, prime);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    _super.prototype.setChildInheritedAttributes.call(this, attributes, display, level, prime);
  };
  MmlMfenced.prototype.addFakeNodes = function () {
    var e_2, _a;
    var _b = this.attributes.getList('open', 'close', 'separators'), open = _b.open, close = _b.close, separators = _b.separators;
    open = open.replace(/[ \t\n\r]/g, '');
    close = close.replace(/[ \t\n\r]/g, '');
    separators = separators.replace(/[ \t\n\r]/g, '');
    if (open) {
      this.open = this.fakeNode(open, {
        fence: true,
        form: 'prefix'
      }, MmlNode_js_1$A.TEXCLASS.OPEN);
    }
    if (separators) {
      while (separators.length < this.childNodes.length - 1) {
        separators += separators.charAt(separators.length - 1);
      }
      var i = 0;
      try {
        for (var _c = __values$T(this.childNodes.slice(1)), _d = _c.next(); !_d.done; _d = _c.next()) {
          var child = _d.value;
          if (child) {
            this.separators.push(this.fakeNode(separators.charAt(i++)));
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
    if (close) {
      this.close = this.fakeNode(close, {
        fence: true,
        form: 'postfix'
      }, MmlNode_js_1$A.TEXCLASS.CLOSE);
    }
  };
  MmlMfenced.prototype.fakeNode = function (c, properties, texClass) {
    if (properties === void 0) {
      properties = {};
    }
    if (texClass === void 0) {
      texClass = null;
    }
    var text = this.factory.create('text').setText(c);
    var node = this.factory.create('mo', properties, [text]);
    node.texClass = texClass;
    node.parent = this;
    return node;
  };
  MmlMfenced.defaults = __assign$t(__assign$t({}, MmlNode_js_1$A.AbstractMmlNode.defaults), {
    open: '(',
    close: ')',
    separators: ','
  });
  return MmlMfenced;
})(MmlNode_js_1$A.AbstractMmlNode);
mfenced$2.MmlMfenced = MmlMfenced;

var menclose$2 = {};

var __extends$1$ = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$s = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$s = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$s.apply(this, arguments);
});
Object.defineProperty(menclose$2, "__esModule", {
  value: true
});
menclose$2.MmlMenclose = void 0;
var MmlNode_js_1$z = MmlNode;
var MmlMenclose = (function (_super) {
  __extends$1$(MmlMenclose, _super);
  function MmlMenclose() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$z.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMenclose.prototype, "kind", {
    get: function () {
      return 'menclose';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMenclose.prototype, "arity", {
    get: function () {
      return -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMenclose.prototype, "linebreakContininer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMenclose.prototype.setTeXclass = function (prev) {
    prev = this.childNodes[0].setTeXclass(prev);
    this.updateTeXclass(this.childNodes[0]);
    return prev;
  };
  MmlMenclose.defaults = __assign$s(__assign$s({}, MmlNode_js_1$z.AbstractMmlNode.defaults), {
    notation: 'longdiv'
  });
  return MmlMenclose;
})(MmlNode_js_1$z.AbstractMmlNode);
menclose$2.MmlMenclose = MmlMenclose;

var maction$2 = {};

var __extends$1_ = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$r = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$r = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$r.apply(this, arguments);
});
Object.defineProperty(maction$2, "__esModule", {
  value: true
});
maction$2.MmlMaction = void 0;
var MmlNode_js_1$y = MmlNode;
var MmlMaction = (function (_super) {
  __extends$1_(MmlMaction, _super);
  function MmlMaction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMaction.prototype, "kind", {
    get: function () {
      return 'maction';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMaction.prototype, "arity", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMaction.prototype, "selected", {
    get: function () {
      var selection = this.attributes.get('selection');
      var i = Math.max(1, Math.min(this.childNodes.length, selection)) - 1;
      return this.childNodes[i] || this.factory.create('mrow');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMaction.prototype, "isEmbellished", {
    get: function () {
      return this.selected.isEmbellished;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMaction.prototype, "isSpacelike", {
    get: function () {
      return this.selected.isSpacelike;
    },
    enumerable: false,
    configurable: true
  });
  MmlMaction.prototype.core = function () {
    return this.selected.core();
  };
  MmlMaction.prototype.coreMO = function () {
    return this.selected.coreMO();
  };
  MmlMaction.prototype.verifyAttributes = function (options) {
    _super.prototype.verifyAttributes.call(this, options);
    if (this.attributes.get('actiontype') !== 'toggle' && this.attributes.getExplicit('selection') !== undefined) {
      var attributes = this.attributes.getAllAttributes();
      delete attributes.selection;
    }
  };
  MmlMaction.prototype.setTeXclass = function (prev) {
    if (this.attributes.get('actiontype') === 'tooltip' && this.childNodes[1]) {
      this.childNodes[1].setTeXclass(null);
    }
    var selected = this.selected;
    prev = selected.setTeXclass(prev);
    this.updateTeXclass(selected);
    return prev;
  };
  MmlMaction.prototype.nextToggleSelection = function () {
    var selection = Math.max(1, this.attributes.get('selection') + 1);
    if (selection > this.childNodes.length) {
      selection = 1;
    }
    this.attributes.set('selection', selection);
  };
  MmlMaction.defaults = __assign$r(__assign$r({}, MmlNode_js_1$y.AbstractMmlNode.defaults), {
    actiontype: 'toggle',
    selection: 1
  });
  return MmlMaction;
})(MmlNode_js_1$y.AbstractMmlNode);
maction$2.MmlMaction = MmlMaction;

var msubsup$2 = {};

var __extends$1Z = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$q = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$q = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$q.apply(this, arguments);
});
Object.defineProperty(msubsup$2, "__esModule", {
  value: true
});
msubsup$2.MmlMsup = msubsup$2.MmlMsub = msubsup$2.MmlMsubsup = void 0;
var MmlNode_js_1$x = MmlNode;
var MmlMsubsup = (function (_super) {
  __extends$1Z(MmlMsubsup, _super);
  function MmlMsubsup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMsubsup.prototype, "kind", {
    get: function () {
      return 'msubsup';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsubsup.prototype, "arity", {
    get: function () {
      return 3;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsubsup.prototype, "base", {
    get: function () {
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsubsup.prototype, "sub", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsubsup.prototype, "sup", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  MmlMsubsup.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    var nodes = this.childNodes;
    nodes[0].setInheritedAttributes(attributes, display, level, prime);
    nodes[1].setInheritedAttributes(attributes, false, level + 1, prime || this.sub === 1);
    if (!nodes[2]) {
      return;
    }
    nodes[2].setInheritedAttributes(attributes, false, level + 1, prime || this.sub === 2);
  };
  MmlMsubsup.defaults = __assign$q(__assign$q({}, MmlNode_js_1$x.AbstractMmlBaseNode.defaults), {
    subscriptshift: '',
    superscriptshift: ''
  });
  return MmlMsubsup;
})(MmlNode_js_1$x.AbstractMmlBaseNode);
msubsup$2.MmlMsubsup = MmlMsubsup;
var MmlMsub = (function (_super) {
  __extends$1Z(MmlMsub, _super);
  function MmlMsub() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMsub.prototype, "kind", {
    get: function () {
      return 'msub';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsub.prototype, "arity", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  MmlMsub.defaults = __assign$q({}, MmlMsubsup.defaults);
  return MmlMsub;
})(MmlMsubsup);
msubsup$2.MmlMsub = MmlMsub;
var MmlMsup = (function (_super) {
  __extends$1Z(MmlMsup, _super);
  function MmlMsup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMsup.prototype, "kind", {
    get: function () {
      return 'msup';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsup.prototype, "arity", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsup.prototype, "sup", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMsup.prototype, "sub", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  MmlMsup.defaults = __assign$q({}, MmlMsubsup.defaults);
  return MmlMsup;
})(MmlMsubsup);
msubsup$2.MmlMsup = MmlMsup;

var munderover$2 = {};

var __extends$1Y = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$p = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$p = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$p.apply(this, arguments);
});
Object.defineProperty(munderover$2, "__esModule", {
  value: true
});
munderover$2.MmlMover = munderover$2.MmlMunder = munderover$2.MmlMunderover = void 0;
var MmlNode_js_1$w = MmlNode;
var MmlMunderover = (function (_super) {
  __extends$1Y(MmlMunderover, _super);
  function MmlMunderover() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMunderover.prototype, "kind", {
    get: function () {
      return 'munderover';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMunderover.prototype, "arity", {
    get: function () {
      return 3;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMunderover.prototype, "base", {
    get: function () {
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMunderover.prototype, "under", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMunderover.prototype, "over", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMunderover.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMunderover.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    var nodes = this.childNodes;
    nodes[0].setInheritedAttributes(attributes, display, level, prime || !!nodes[this.over]);
    var force = !!(!display && nodes[0].coreMO().attributes.get('movablelimits'));
    var ACCENTS = this.constructor.ACCENTS;
    nodes[1].setInheritedAttributes(attributes, false, this.getScriptlevel(ACCENTS[1], force, level), prime || this.under === 1);
    this.setInheritedAccent(1, ACCENTS[1], display, level, prime, force);
    if (!nodes[2]) {
      return;
    }
    nodes[2].setInheritedAttributes(attributes, false, this.getScriptlevel(ACCENTS[2], force, level), prime || this.under === 2);
    this.setInheritedAccent(2, ACCENTS[2], display, level, prime, force);
  };
  MmlMunderover.prototype.getScriptlevel = function (accent, force, level) {
    if (force || !this.attributes.get(accent)) {
      level++;
    }
    return level;
  };
  MmlMunderover.prototype.setInheritedAccent = function (n, accent, display, level, prime, force) {
    var node = this.childNodes[n];
    if (this.attributes.getExplicit(accent) == null && node.isEmbellished) {
      var value = node.coreMO().attributes.get('accent');
      this.attributes.setInherited(accent, value);
      if (value !== this.attributes.getDefault(accent)) {
        node.setInheritedAttributes({}, display, this.getScriptlevel(accent, force, level), prime);
      }
    }
  };
  MmlMunderover.defaults = __assign$p(__assign$p({}, MmlNode_js_1$w.AbstractMmlBaseNode.defaults), {
    accent: false,
    accentunder: false,
    align: 'center'
  });
  MmlMunderover.ACCENTS = ['', 'accentunder', 'accent'];
  return MmlMunderover;
})(MmlNode_js_1$w.AbstractMmlBaseNode);
munderover$2.MmlMunderover = MmlMunderover;
var MmlMunder = (function (_super) {
  __extends$1Y(MmlMunder, _super);
  function MmlMunder() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMunder.prototype, "kind", {
    get: function () {
      return 'munder';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMunder.prototype, "arity", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  MmlMunder.defaults = __assign$p({}, MmlMunderover.defaults);
  return MmlMunder;
})(MmlMunderover);
munderover$2.MmlMunder = MmlMunder;
var MmlMover = (function (_super) {
  __extends$1Y(MmlMover, _super);
  function MmlMover() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMover.prototype, "kind", {
    get: function () {
      return 'mover';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMover.prototype, "arity", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMover.prototype, "over", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMover.prototype, "under", {
    get: function () {
      return 2;
    },
    enumerable: false,
    configurable: true
  });
  MmlMover.defaults = __assign$p({}, MmlMunderover.defaults);
  MmlMover.ACCENTS = ['', 'accent', 'accentunder'];
  return MmlMover;
})(MmlMunderover);
munderover$2.MmlMover = MmlMover;

var mmultiscripts$2 = {};

var __extends$1X = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$o = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$o = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$o.apply(this, arguments);
});
Object.defineProperty(mmultiscripts$2, "__esModule", {
  value: true
});
mmultiscripts$2.MmlNone = mmultiscripts$2.MmlMprescripts = mmultiscripts$2.MmlMmultiscripts = void 0;
var MmlNode_js_1$v = MmlNode;
var msubsup_js_1$5 = msubsup$2;
var MmlMmultiscripts = (function (_super) {
  __extends$1X(MmlMmultiscripts, _super);
  function MmlMmultiscripts() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMmultiscripts.prototype, "kind", {
    get: function () {
      return 'mmultiscripts';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMmultiscripts.prototype, "arity", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  MmlMmultiscripts.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    this.childNodes[0].setInheritedAttributes(attributes, display, level, prime);
    var prescripts = false;
    for (var i = 1, n = 0; i < this.childNodes.length; i++) {
      var child = this.childNodes[i];
      if (child.isKind('mprescripts')) {
        if (!prescripts) {
          prescripts = true;
          if (i % 2 === 0) {
            var mrow = this.factory.create('mrow');
            this.childNodes.splice(i, 0, mrow);
            mrow.parent = this;
            i++;
          }
        }
      } else {
        var primestyle = prime || n % 2 === 0;
        child.setInheritedAttributes(attributes, false, level + 1, primestyle);
        n++;
      }
    }
    if (this.childNodes.length % 2 === (prescripts ? 1 : 0)) {
      this.appendChild(this.factory.create('mrow'));
      this.childNodes[this.childNodes.length - 1].setInheritedAttributes(attributes, false, level + 1, prime);
    }
  };
  MmlMmultiscripts.prototype.verifyChildren = function (options) {
    var prescripts = false;
    var fix = options['fixMmultiscripts'];
    for (var i = 0; i < this.childNodes.length; i++) {
      var child = this.childNodes[i];
      if (child.isKind('mprescripts')) {
        if (prescripts) {
          child.mError(child.kind + ' can only appear once in ' + this.kind, options, true);
        } else {
          prescripts = true;
          if (i % 2 === 0 && !fix) {
            this.mError('There must be an equal number of prescripts of each type', options);
          }
        }
      }
    }
    if (this.childNodes.length % 2 === (prescripts ? 1 : 0) && !fix) {
      this.mError('There must be an equal number of scripts of each type', options);
    }
    _super.prototype.verifyChildren.call(this, options);
  };
  MmlMmultiscripts.defaults = __assign$o({}, msubsup_js_1$5.MmlMsubsup.defaults);
  return MmlMmultiscripts;
})(msubsup_js_1$5.MmlMsubsup);
mmultiscripts$2.MmlMmultiscripts = MmlMmultiscripts;
var MmlMprescripts = (function (_super) {
  __extends$1X(MmlMprescripts, _super);
  function MmlMprescripts() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMprescripts.prototype, "kind", {
    get: function () {
      return 'mprescripts';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMprescripts.prototype, "arity", {
    get: function () {
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  MmlMprescripts.prototype.verifyTree = function (options) {
    _super.prototype.verifyTree.call(this, options);
    if (this.parent && !this.parent.isKind('mmultiscripts')) {
      this.mError(this.kind + ' must be a child of mmultiscripts', options, true);
    }
  };
  MmlMprescripts.defaults = __assign$o({}, MmlNode_js_1$v.AbstractMmlNode.defaults);
  return MmlMprescripts;
})(MmlNode_js_1$v.AbstractMmlNode);
mmultiscripts$2.MmlMprescripts = MmlMprescripts;
var MmlNone$1 = (function (_super) {
  __extends$1X(MmlNone, _super);
  function MmlNone() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlNone.prototype, "kind", {
    get: function () {
      return 'none';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlNone.prototype, "arity", {
    get: function () {
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  MmlNone.prototype.verifyTree = function (options) {
    _super.prototype.verifyTree.call(this, options);
    if (this.parent && !this.parent.isKind('mmultiscripts')) {
      this.mError(this.kind + ' must be a child of mmultiscripts', options, true);
    }
  };
  MmlNone.defaults = __assign$o({}, MmlNode_js_1$v.AbstractMmlNode.defaults);
  return MmlNone;
})(MmlNode_js_1$v.AbstractMmlNode);
mmultiscripts$2.MmlNone = MmlNone$1;

var mtable$2 = {};

var __extends$1W = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$n = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$n = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$n.apply(this, arguments);
});
var __values$S = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mtable$2, "__esModule", {
  value: true
});
mtable$2.MmlMtable = void 0;
var MmlNode_js_1$u = MmlNode;
var string_js_1$9 = string;
var MmlMtable = (function (_super) {
  __extends$1W(MmlMtable, _super);
  function MmlMtable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.properties = {
      useHeight: true
    };
    _this.texclass = MmlNode_js_1$u.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMtable.prototype, "kind", {
    get: function () {
      return 'mtable';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMtable.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMtable.prototype.setInheritedAttributes = function (attributes, display, level, prime) {
    var e_1, _a;
    try {
      for (var indentAttributes_1 = __values$S(MmlNode_js_1$u.indentAttributes), indentAttributes_1_1 = indentAttributes_1.next(); !indentAttributes_1_1.done; indentAttributes_1_1 = indentAttributes_1.next()) {
        var name_1 = indentAttributes_1_1.value;
        if (attributes[name_1]) {
          this.attributes.setInherited(name_1, attributes[name_1][1]);
        }
        if (this.attributes.getExplicit(name_1) !== undefined) {
          delete this.attributes.getAllAttributes()[name_1];
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (indentAttributes_1_1 && !indentAttributes_1_1.done && (_a = indentAttributes_1.return)) _a.call(indentAttributes_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    _super.prototype.setInheritedAttributes.call(this, attributes, display, level, prime);
  };
  MmlMtable.prototype.setChildInheritedAttributes = function (attributes, display, level, _prime) {
    var e_2, _a, e_3, _b;
    try {
      for (var _c = __values$S(this.childNodes), _d = _c.next(); !_d.done; _d = _c.next()) {
        var child = _d.value;
        if (!child.isKind('mtr')) {
          this.replaceChild(this.factory.create('mtr'), child).appendChild(child);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    level = this.getProperty('scriptlevel') || level;
    display = !!(this.attributes.getExplicit('displaystyle') || this.attributes.getDefault('displaystyle'));
    attributes = this.addInheritedAttributes(attributes, {
      columnalign: this.attributes.get('columnalign'),
      rowalign: 'center'
    });
    var cramped = this.attributes.getExplicit('data-cramped');
    var ralign = (0, string_js_1$9.split)(this.attributes.get('rowalign'));
    try {
      for (var _e = __values$S(this.childNodes), _f = _e.next(); !_f.done; _f = _e.next()) {
        var child = _f.value;
        attributes.rowalign[1] = ralign.shift() || attributes.rowalign[1];
        child.setInheritedAttributes(attributes, display, level, !!cramped);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
  };
  MmlMtable.prototype.verifyChildren = function (options) {
    var mtr = null;
    var factory = this.factory;
    for (var i = 0; i < this.childNodes.length; i++) {
      var child = this.childNodes[i];
      if (child.isKind('mtr')) {
        mtr = null;
      } else {
        var isMtd = child.isKind('mtd');
        if (mtr) {
          this.removeChild(child);
          i--;
        } else {
          mtr = this.replaceChild(factory.create('mtr'), child);
        }
        mtr.appendChild(isMtd ? child : factory.create('mtd', {}, [child]));
        if (!options['fixMtables']) {
          child.parent.removeChild(child);
          child.parent = this;
          isMtd && mtr.appendChild(factory.create('mtd'));
          var merror = child.mError('Children of ' + this.kind + ' must be mtr or mlabeledtr', options, isMtd);
          mtr.childNodes[mtr.childNodes.length - 1].appendChild(merror);
        }
      }
    }
    _super.prototype.verifyChildren.call(this, options);
  };
  MmlMtable.prototype.setTeXclass = function (prev) {
    var e_4, _a;
    this.getPrevClass(prev);
    try {
      for (var _b = __values$S(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        child.setTeXclass(null);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    return this;
  };
  MmlMtable.defaults = __assign$n(__assign$n({}, MmlNode_js_1$u.AbstractMmlNode.defaults), {
    align: 'axis',
    rowalign: 'baseline',
    columnalign: 'center',
    groupalign: '{left}',
    alignmentscope: true,
    columnwidth: 'auto',
    width: 'auto',
    rowspacing: '1ex',
    columnspacing: '.8em',
    rowlines: 'none',
    columnlines: 'none',
    frame: 'none',
    framespacing: '0.4em 0.5ex',
    equalrows: false,
    equalcolumns: false,
    displaystyle: false,
    side: 'right',
    minlabelspacing: '0.8em'
  });
  return MmlMtable;
})(MmlNode_js_1$u.AbstractMmlNode);
mtable$2.MmlMtable = MmlMtable;

var mtr$2 = {};

var __extends$1V = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$m = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$m = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$m.apply(this, arguments);
});
var __values$R = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mtr$2, "__esModule", {
  value: true
});
mtr$2.MmlMlabeledtr = mtr$2.MmlMtr = void 0;
var MmlNode_js_1$t = MmlNode;
var Attributes_js_1$2 = Attributes;
var string_js_1$8 = string;
var MmlMtr = (function (_super) {
  __extends$1V(MmlMtr, _super);
  function MmlMtr() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMtr.prototype, "kind", {
    get: function () {
      return 'mtr';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMtr.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMtr.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    var e_1, _a, e_2, _b;
    try {
      for (var _c = __values$R(this.childNodes), _d = _c.next(); !_d.done; _d = _c.next()) {
        var child = _d.value;
        if (!child.isKind('mtd')) {
          this.replaceChild(this.factory.create('mtd'), child).appendChild(child);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    var calign = (0, string_js_1$8.split)(this.attributes.get('columnalign'));
    if (this.arity === 1) {
      calign.unshift(this.parent.attributes.get('side'));
    }
    attributes = this.addInheritedAttributes(attributes, {
      rowalign: this.attributes.get('rowalign'),
      columnalign: 'center'
    });
    try {
      for (var _e = __values$R(this.childNodes), _f = _e.next(); !_f.done; _f = _e.next()) {
        var child = _f.value;
        attributes.columnalign[1] = calign.shift() || attributes.columnalign[1];
        child.setInheritedAttributes(attributes, display, level, prime);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  MmlMtr.prototype.verifyChildren = function (options) {
    var e_3, _a;
    if (this.parent && !this.parent.isKind('mtable')) {
      this.mError(this.kind + ' can only be a child of an mtable', options, true);
      return;
    }
    try {
      for (var _b = __values$R(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        if (!child.isKind('mtd')) {
          var mtd = this.replaceChild(this.factory.create('mtd'), child);
          mtd.appendChild(child);
          if (!options['fixMtables']) {
            child.mError('Children of ' + this.kind + ' must be mtd', options);
          }
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    _super.prototype.verifyChildren.call(this, options);
  };
  MmlMtr.prototype.setTeXclass = function (prev) {
    var e_4, _a;
    this.getPrevClass(prev);
    try {
      for (var _b = __values$R(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        child.setTeXclass(null);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    return this;
  };
  MmlMtr.defaults = __assign$m(__assign$m({}, MmlNode_js_1$t.AbstractMmlNode.defaults), {
    rowalign: Attributes_js_1$2.INHERIT,
    columnalign: Attributes_js_1$2.INHERIT,
    groupalign: Attributes_js_1$2.INHERIT
  });
  return MmlMtr;
})(MmlNode_js_1$t.AbstractMmlNode);
mtr$2.MmlMtr = MmlMtr;
var MmlMlabeledtr = (function (_super) {
  __extends$1V(MmlMlabeledtr, _super);
  function MmlMlabeledtr() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMlabeledtr.prototype, "kind", {
    get: function () {
      return 'mlabeledtr';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMlabeledtr.prototype, "arity", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  return MmlMlabeledtr;
})(MmlMtr);
mtr$2.MmlMlabeledtr = MmlMlabeledtr;

var mtd$2 = {};

var __extends$1U = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$l = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$l = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$l.apply(this, arguments);
});
Object.defineProperty(mtd$2, "__esModule", {
  value: true
});
mtd$2.MmlMtd = void 0;
var MmlNode_js_1$s = MmlNode;
var Attributes_js_1$1 = Attributes;
var MmlMtd = (function (_super) {
  __extends$1U(MmlMtd, _super);
  function MmlMtd() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMtd.prototype, "kind", {
    get: function () {
      return 'mtd';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMtd.prototype, "arity", {
    get: function () {
      return -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMtd.prototype, "linebreakContainer", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMtd.prototype.verifyChildren = function (options) {
    if (this.parent && !this.parent.isKind('mtr')) {
      this.mError(this.kind + ' can only be a child of an mtr or mlabeledtr', options, true);
      return;
    }
    _super.prototype.verifyChildren.call(this, options);
  };
  MmlMtd.prototype.setTeXclass = function (prev) {
    this.getPrevClass(prev);
    this.childNodes[0].setTeXclass(null);
    return this;
  };
  MmlMtd.defaults = __assign$l(__assign$l({}, MmlNode_js_1$s.AbstractMmlBaseNode.defaults), {
    rowspan: 1,
    columnspan: 1,
    rowalign: Attributes_js_1$1.INHERIT,
    columnalign: Attributes_js_1$1.INHERIT,
    groupalign: Attributes_js_1$1.INHERIT
  });
  return MmlMtd;
})(MmlNode_js_1$s.AbstractMmlBaseNode);
mtd$2.MmlMtd = MmlMtd;

var maligngroup = {};

var __extends$1T = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$k = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$k = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$k.apply(this, arguments);
});
Object.defineProperty(maligngroup, "__esModule", {
  value: true
});
maligngroup.MmlMaligngroup = void 0;
var MmlNode_js_1$r = MmlNode;
var Attributes_js_1 = Attributes;
var MmlMaligngroup = (function (_super) {
  __extends$1T(MmlMaligngroup, _super);
  function MmlMaligngroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMaligngroup.prototype, "kind", {
    get: function () {
      return 'maligngroup';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMaligngroup.prototype, "isSpacelike", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMaligngroup.prototype.setChildInheritedAttributes = function (attributes, display, level, prime) {
    attributes = this.addInheritedAttributes(attributes, this.attributes.getAllAttributes());
    _super.prototype.setChildInheritedAttributes.call(this, attributes, display, level, prime);
  };
  MmlMaligngroup.defaults = __assign$k(__assign$k({}, MmlNode_js_1$r.AbstractMmlLayoutNode.defaults), {
    groupalign: Attributes_js_1.INHERIT
  });
  return MmlMaligngroup;
})(MmlNode_js_1$r.AbstractMmlLayoutNode);
maligngroup.MmlMaligngroup = MmlMaligngroup;

var malignmark = {};

var __extends$1S = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$j = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$j = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$j.apply(this, arguments);
});
Object.defineProperty(malignmark, "__esModule", {
  value: true
});
malignmark.MmlMalignmark = void 0;
var MmlNode_js_1$q = MmlNode;
var MmlMalignmark = (function (_super) {
  __extends$1S(MmlMalignmark, _super);
  function MmlMalignmark() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlMalignmark.prototype, "kind", {
    get: function () {
      return 'malignmark';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMalignmark.prototype, "arity", {
    get: function () {
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlMalignmark.prototype, "isSpacelike", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlMalignmark.defaults = __assign$j(__assign$j({}, MmlNode_js_1$q.AbstractMmlNode.defaults), {
    edge: 'left'
  });
  return MmlMalignmark;
})(MmlNode_js_1$q.AbstractMmlNode);
malignmark.MmlMalignmark = MmlMalignmark;

var mglyph$2 = {};

var __extends$1R = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$i = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$i = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$i.apply(this, arguments);
});
Object.defineProperty(mglyph$2, "__esModule", {
  value: true
});
mglyph$2.MmlMglyph = void 0;
var MmlNode_js_1$p = MmlNode;
var MmlMglyph = (function (_super) {
  __extends$1R(MmlMglyph, _super);
  function MmlMglyph() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.texclass = MmlNode_js_1$p.TEXCLASS.ORD;
    return _this;
  }
  Object.defineProperty(MmlMglyph.prototype, "kind", {
    get: function () {
      return 'mglyph';
    },
    enumerable: false,
    configurable: true
  });
  MmlMglyph.prototype.verifyAttributes = function (options) {
    var _a = this.attributes.getList('src', 'fontfamily', 'index'), src = _a.src, fontfamily = _a.fontfamily, index = _a.index;
    if (src === '' && (fontfamily === '' || index === '')) {
      this.mError('mglyph must have either src or fontfamily and index attributes', options, true);
    } else {
      _super.prototype.verifyAttributes.call(this, options);
    }
  };
  MmlMglyph.defaults = __assign$i(__assign$i({}, MmlNode_js_1$p.AbstractMmlTokenNode.defaults), {
    alt: '',
    src: '',
    index: '',
    width: 'auto',
    height: 'auto',
    valign: '0em'
  });
  return MmlMglyph;
})(MmlNode_js_1$p.AbstractMmlTokenNode);
mglyph$2.MmlMglyph = MmlMglyph;

var semantics$2 = {};

var __extends$1Q = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$h = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$h = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$h.apply(this, arguments);
});
Object.defineProperty(semantics$2, "__esModule", {
  value: true
});
semantics$2.MmlAnnotation = semantics$2.MmlAnnotationXML = semantics$2.MmlSemantics = void 0;
var MmlNode_js_1$o = MmlNode;
var MmlSemantics = (function (_super) {
  __extends$1Q(MmlSemantics, _super);
  function MmlSemantics() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlSemantics.prototype, "kind", {
    get: function () {
      return 'semantics';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlSemantics.prototype, "arity", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlSemantics.prototype, "notParent", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MmlSemantics.defaults = __assign$h(__assign$h({}, MmlNode_js_1$o.AbstractMmlBaseNode.defaults), {
    definitionUrl: null,
    encoding: null
  });
  return MmlSemantics;
})(MmlNode_js_1$o.AbstractMmlBaseNode);
semantics$2.MmlSemantics = MmlSemantics;
var MmlAnnotationXML = (function (_super) {
  __extends$1Q(MmlAnnotationXML, _super);
  function MmlAnnotationXML() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlAnnotationXML.prototype, "kind", {
    get: function () {
      return 'annotation-xml';
    },
    enumerable: false,
    configurable: true
  });
  MmlAnnotationXML.prototype.setChildInheritedAttributes = function () {};
  MmlAnnotationXML.defaults = __assign$h(__assign$h({}, MmlNode_js_1$o.AbstractMmlNode.defaults), {
    definitionUrl: null,
    encoding: null,
    cd: 'mathmlkeys',
    name: '',
    src: null
  });
  return MmlAnnotationXML;
})(MmlNode_js_1$o.AbstractMmlNode);
semantics$2.MmlAnnotationXML = MmlAnnotationXML;
var MmlAnnotation = (function (_super) {
  __extends$1Q(MmlAnnotation, _super);
  function MmlAnnotation() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.properties = {
      isChars: true
    };
    return _this;
  }
  Object.defineProperty(MmlAnnotation.prototype, "kind", {
    get: function () {
      return 'annotation';
    },
    enumerable: false,
    configurable: true
  });
  MmlAnnotation.defaults = __assign$h({}, MmlAnnotationXML.defaults);
  return MmlAnnotation;
})(MmlAnnotationXML);
semantics$2.MmlAnnotation = MmlAnnotation;

var TeXAtom$3 = {};

var __extends$1P = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$g = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$g = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$g.apply(this, arguments);
});
Object.defineProperty(TeXAtom$3, "__esModule", {
  value: true
});
TeXAtom$3.TeXAtom = void 0;
var MmlNode_js_1$n = MmlNode;
var mo_js_1$4 = mo$2;
var TeXAtom$2 = (function (_super) {
  __extends$1P(TeXAtom, _super);
  function TeXAtom(factory, attributes, children) {
    var _this = _super.call(this, factory, attributes, children) || this;
    _this.texclass = MmlNode_js_1$n.TEXCLASS.ORD;
    _this.setProperty('texClass', _this.texClass);
    return _this;
  }
  Object.defineProperty(TeXAtom.prototype, "kind", {
    get: function () {
      return 'TeXAtom';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TeXAtom.prototype, "arity", {
    get: function () {
      return -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TeXAtom.prototype, "notParent", {
    get: function () {
      return this.childNodes[0] && this.childNodes[0].childNodes.length === 1;
    },
    enumerable: false,
    configurable: true
  });
  TeXAtom.prototype.setTeXclass = function (prev) {
    this.childNodes[0].setTeXclass(null);
    return this.adjustTeXclass(prev);
  };
  TeXAtom.prototype.adjustTeXclass = function (prev) {
    return prev;
  };
  TeXAtom.defaults = __assign$g({}, MmlNode_js_1$n.AbstractMmlBaseNode.defaults);
  return TeXAtom;
})(MmlNode_js_1$n.AbstractMmlBaseNode);
TeXAtom$3.TeXAtom = TeXAtom$2;
TeXAtom$2.prototype.adjustTeXclass = mo_js_1$4.MmlMo.prototype.adjustTeXclass;

var mathchoice = {};

var __extends$1O = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$f = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$f = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$f.apply(this, arguments);
});
Object.defineProperty(mathchoice, "__esModule", {
  value: true
});
mathchoice.MathChoice = void 0;
var MmlNode_js_1$m = MmlNode;
var MathChoice = (function (_super) {
  __extends$1O(MathChoice, _super);
  function MathChoice() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MathChoice.prototype, "kind", {
    get: function () {
      return 'MathChoice';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MathChoice.prototype, "arity", {
    get: function () {
      return 4;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MathChoice.prototype, "notParent", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  MathChoice.prototype.setInheritedAttributes = function (attributes, display, level, prime) {
    var selection = display ? 0 : Math.max(0, Math.min(level, 2)) + 1;
    var child = this.childNodes[selection] || this.factory.create('mrow');
    this.parent.replaceChild(child, this);
    child.setInheritedAttributes(attributes, display, level, prime);
  };
  MathChoice.defaults = __assign$f({}, MmlNode_js_1$m.AbstractMmlBaseNode.defaults);
  return MathChoice;
})(MmlNode_js_1$m.AbstractMmlBaseNode);
mathchoice.MathChoice = MathChoice;

var _a$b;
Object.defineProperty(MML, "__esModule", {
  value: true
});
MML.MML = void 0;
var MmlNode_js_1$l = MmlNode;
var math_js_1$2 = math$2;
var mi_js_1$2 = mi$2;
var mn_js_1$2 = mn$2;
var mo_js_1$3 = mo$2;
var mtext_js_1$2 = mtext$2;
var mspace_js_1$2 = mspace$2;
var ms_js_1$2 = ms$3;
var mrow_js_1$2 = mrow$2;
var mfrac_js_1$2 = mfrac$2;
var msqrt_js_1$3 = msqrt$2;
var mroot_js_1$2 = mroot$2;
var mstyle_js_1 = mstyle;
var merror_js_1 = merror;
var mpadded_js_1$2 = mpadded$2;
var mphantom_js_1 = mphantom;
var mfenced_js_1$2 = mfenced$2;
var menclose_js_1$2 = menclose$2;
var maction_js_1$2 = maction$2;
var msubsup_js_1$4 = msubsup$2;
var munderover_js_1$2 = munderover$2;
var mmultiscripts_js_1$2 = mmultiscripts$2;
var mtable_js_1$2 = mtable$2;
var mtr_js_1$2 = mtr$2;
var mtd_js_1$2 = mtd$2;
var maligngroup_js_1 = maligngroup;
var malignmark_js_1 = malignmark;
var mglyph_js_1$2 = mglyph$2;
var semantics_js_1$2 = semantics$2;
var TeXAtom_js_1$2 = TeXAtom$3;
var mathchoice_js_1 = mathchoice;
MML.MML = (_a$b = {}, _a$b[math_js_1$2.MmlMath.prototype.kind] = math_js_1$2.MmlMath, _a$b[mi_js_1$2.MmlMi.prototype.kind] = mi_js_1$2.MmlMi, _a$b[mn_js_1$2.MmlMn.prototype.kind] = mn_js_1$2.MmlMn, _a$b[mo_js_1$3.MmlMo.prototype.kind] = mo_js_1$3.MmlMo, _a$b[mtext_js_1$2.MmlMtext.prototype.kind] = mtext_js_1$2.MmlMtext, _a$b[mspace_js_1$2.MmlMspace.prototype.kind] = mspace_js_1$2.MmlMspace, _a$b[ms_js_1$2.MmlMs.prototype.kind] = ms_js_1$2.MmlMs, _a$b[mrow_js_1$2.MmlMrow.prototype.kind] = mrow_js_1$2.MmlMrow, _a$b[mrow_js_1$2.MmlInferredMrow.prototype.kind] = mrow_js_1$2.MmlInferredMrow, _a$b[mfrac_js_1$2.MmlMfrac.prototype.kind] = mfrac_js_1$2.MmlMfrac, _a$b[msqrt_js_1$3.MmlMsqrt.prototype.kind] = msqrt_js_1$3.MmlMsqrt, _a$b[mroot_js_1$2.MmlMroot.prototype.kind] = mroot_js_1$2.MmlMroot, _a$b[mstyle_js_1.MmlMstyle.prototype.kind] = mstyle_js_1.MmlMstyle, _a$b[merror_js_1.MmlMerror.prototype.kind] = merror_js_1.MmlMerror, _a$b[mpadded_js_1$2.MmlMpadded.prototype.kind] = mpadded_js_1$2.MmlMpadded, _a$b[mphantom_js_1.MmlMphantom.prototype.kind] = mphantom_js_1.MmlMphantom, _a$b[mfenced_js_1$2.MmlMfenced.prototype.kind] = mfenced_js_1$2.MmlMfenced, _a$b[menclose_js_1$2.MmlMenclose.prototype.kind] = menclose_js_1$2.MmlMenclose, _a$b[maction_js_1$2.MmlMaction.prototype.kind] = maction_js_1$2.MmlMaction, _a$b[msubsup_js_1$4.MmlMsub.prototype.kind] = msubsup_js_1$4.MmlMsub, _a$b[msubsup_js_1$4.MmlMsup.prototype.kind] = msubsup_js_1$4.MmlMsup, _a$b[msubsup_js_1$4.MmlMsubsup.prototype.kind] = msubsup_js_1$4.MmlMsubsup, _a$b[munderover_js_1$2.MmlMunder.prototype.kind] = munderover_js_1$2.MmlMunder, _a$b[munderover_js_1$2.MmlMover.prototype.kind] = munderover_js_1$2.MmlMover, _a$b[munderover_js_1$2.MmlMunderover.prototype.kind] = munderover_js_1$2.MmlMunderover, _a$b[mmultiscripts_js_1$2.MmlMmultiscripts.prototype.kind] = mmultiscripts_js_1$2.MmlMmultiscripts, _a$b[mmultiscripts_js_1$2.MmlMprescripts.prototype.kind] = mmultiscripts_js_1$2.MmlMprescripts, _a$b[mmultiscripts_js_1$2.MmlNone.prototype.kind] = mmultiscripts_js_1$2.MmlNone, _a$b[mtable_js_1$2.MmlMtable.prototype.kind] = mtable_js_1$2.MmlMtable, _a$b[mtr_js_1$2.MmlMlabeledtr.prototype.kind] = mtr_js_1$2.MmlMlabeledtr, _a$b[mtr_js_1$2.MmlMtr.prototype.kind] = mtr_js_1$2.MmlMtr, _a$b[mtd_js_1$2.MmlMtd.prototype.kind] = mtd_js_1$2.MmlMtd, _a$b[maligngroup_js_1.MmlMaligngroup.prototype.kind] = maligngroup_js_1.MmlMaligngroup, _a$b[malignmark_js_1.MmlMalignmark.prototype.kind] = malignmark_js_1.MmlMalignmark, _a$b[mglyph_js_1$2.MmlMglyph.prototype.kind] = mglyph_js_1$2.MmlMglyph, _a$b[semantics_js_1$2.MmlSemantics.prototype.kind] = semantics_js_1$2.MmlSemantics, _a$b[semantics_js_1$2.MmlAnnotation.prototype.kind] = semantics_js_1$2.MmlAnnotation, _a$b[semantics_js_1$2.MmlAnnotationXML.prototype.kind] = semantics_js_1$2.MmlAnnotationXML, _a$b[TeXAtom_js_1$2.TeXAtom.prototype.kind] = TeXAtom_js_1$2.TeXAtom, _a$b[mathchoice_js_1.MathChoice.prototype.kind] = mathchoice_js_1.MathChoice, _a$b[MmlNode_js_1$l.TextNode.prototype.kind] = MmlNode_js_1$l.TextNode, _a$b[MmlNode_js_1$l.XMLNode.prototype.kind] = MmlNode_js_1$l.XMLNode, _a$b);

var __extends$1N = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(MmlFactory$1, "__esModule", {
  value: true
});
var MmlFactory_2 = MmlFactory$1.MmlFactory = void 0;
var NodeFactory_js_1$2 = NodeFactory$2;
var MML_js_1 = MML;
var MmlFactory = (function (_super) {
  __extends$1N(MmlFactory, _super);
  function MmlFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlFactory.prototype, "MML", {
    get: function () {
      return this.node;
    },
    enumerable: false,
    configurable: true
  });
  MmlFactory.defaultNodes = MML_js_1.MML;
  return MmlFactory;
})(NodeFactory_js_1$2.AbstractNodeFactory);
MmlFactory_2 = MmlFactory$1.MmlFactory = MmlFactory;

var Visitor = {};

var __values$Q = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$X = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$w = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(Visitor, "__esModule", {
  value: true
});
Visitor.AbstractVisitor = void 0;
var Node_js_1 = Node;
var AbstractVisitor = (function () {
  function AbstractVisitor(factory) {
    var e_1, _a;
    this.nodeHandlers = new Map();
    try {
      for (var _b = __values$Q(factory.getKinds()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var kind = _c.value;
        var method = this[AbstractVisitor.methodName(kind)];
        if (method) {
          this.nodeHandlers.set(kind, method);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  AbstractVisitor.methodName = function (kind) {
    return 'visit' + (kind.charAt(0).toUpperCase() + kind.substr(1)).replace(/[^a-z0-9_]/ig, '_') + 'Node';
  };
  AbstractVisitor.prototype.visitTree = function (tree) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    return this.visitNode.apply(this, __spreadArray$w([tree], __read$X(args), false));
  };
  AbstractVisitor.prototype.visitNode = function (node) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var handler = this.nodeHandlers.get(node.kind) || this.visitDefault;
    return handler.call.apply(handler, __spreadArray$w([this, node], __read$X(args), false));
  };
  AbstractVisitor.prototype.visitDefault = function (node) {
    var e_2, _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (node instanceof Node_js_1.AbstractNode) {
      try {
        for (var _b = __values$Q(node.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          this.visitNode.apply(this, __spreadArray$w([child], __read$X(args), false));
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
  };
  AbstractVisitor.prototype.setNodeHandler = function (kind, handler) {
    this.nodeHandlers.set(kind, handler);
  };
  AbstractVisitor.prototype.removeNodeHandler = function (kind) {
    this.nodeHandlers.delete(kind);
  };
  return AbstractVisitor;
})();
Visitor.AbstractVisitor = AbstractVisitor;

var __extends$1M = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(MmlVisitor$3, "__esModule", {
  value: true
});
MmlVisitor$3.MmlVisitor = void 0;
var MmlFactory_js_1 = MmlFactory$1;
var Visitor_js_1 = Visitor;
var MmlVisitor$2 = (function (_super) {
  __extends$1M(MmlVisitor, _super);
  function MmlVisitor(factory) {
    if (factory === void 0) {
      factory = null;
    }
    if (!factory) {
      factory = new MmlFactory_js_1.MmlFactory();
    }
    return _super.call(this, factory) || this;
  }
  MmlVisitor.prototype.visitTextNode = function (_node) {
  };
  MmlVisitor.prototype.visitXMLNode = function (_node) {
  };
  return MmlVisitor;
})(Visitor_js_1.AbstractVisitor);
MmlVisitor$3.MmlVisitor = MmlVisitor$2;

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SerializedMmlVisitor = exports.toEntity = exports.DATAMJX = void 0;
  var MmlVisitor_js_1 = MmlVisitor$3;
  var MmlNode_js_1 = MmlNode;
  var mi_js_1 = mi$2;
  exports.DATAMJX = 'data-mjx-';
  var toEntity = function (c) {
    return '&#x' + c.codePointAt(0).toString(16).toUpperCase() + ';';
  };
  exports.toEntity = toEntity;
  var SerializedMmlVisitor = (function (_super) {
    __extends(SerializedMmlVisitor, _super);
    function SerializedMmlVisitor() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    SerializedMmlVisitor.prototype.visitTree = function (node) {
      return this.visitNode(node, '');
    };
    SerializedMmlVisitor.prototype.visitTextNode = function (node, _space) {
      return this.quoteHTML(node.getText());
    };
    SerializedMmlVisitor.prototype.visitXMLNode = function (node, space) {
      return space + node.getSerializedXML();
    };
    SerializedMmlVisitor.prototype.visitInferredMrowNode = function (node, space) {
      var e_1, _a;
      var mml = [];
      try {
        for (var _b = __values(node.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          mml.push(this.visitNode(child, space));
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return mml.join('\n');
    };
    SerializedMmlVisitor.prototype.visitTeXAtomNode = function (node, space) {
      var children = this.childNodeMml(node, space + '  ', '\n');
      var mml = space + '<mrow' + this.getAttributes(node) + '>' + (children.match(/\S/) ? '\n' + children + space : '') + '</mrow>';
      return mml;
    };
    SerializedMmlVisitor.prototype.visitAnnotationNode = function (node, space) {
      return space + '<annotation' + this.getAttributes(node) + '>' + this.childNodeMml(node, '', '') + '</annotation>';
    };
    SerializedMmlVisitor.prototype.visitDefault = function (node, space) {
      var kind = node.kind;
      var _a = __read(node.isToken || node.childNodes.length === 0 ? ['', ''] : ['\n', space], 2), nl = _a[0], endspace = _a[1];
      var children = this.childNodeMml(node, space + '  ', nl);
      return space + '<' + kind + this.getAttributes(node) + '>' + (children.match(/\S/) ? nl + children + endspace : '') + '</' + kind + '>';
    };
    SerializedMmlVisitor.prototype.childNodeMml = function (node, space, nl) {
      var e_2, _a;
      var mml = '';
      try {
        for (var _b = __values(node.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          mml += this.visitNode(child, space) + nl;
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      return mml;
    };
    SerializedMmlVisitor.prototype.getAttributes = function (node) {
      var e_3, _a;
      var attr = [];
      var defaults = this.constructor.defaultAttributes[node.kind] || ({});
      var attributes = Object.assign({}, defaults, this.getDataAttributes(node), node.attributes.getAllAttributes());
      var variants = this.constructor.variants;
      if (attributes.hasOwnProperty('mathvariant') && variants.hasOwnProperty(attributes.mathvariant)) {
        attributes.mathvariant = variants[attributes.mathvariant];
      }
      try {
        for (var _b = __values(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var name_1 = _c.value;
          var value = String(attributes[name_1]);
          if (value === undefined) continue;
          attr.push(name_1 + '="' + this.quoteHTML(value) + '"');
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
      return attr.length ? ' ' + attr.join(' ') : '';
    };
    SerializedMmlVisitor.prototype.getDataAttributes = function (node) {
      var data = {};
      var variant = node.attributes.getExplicit('mathvariant');
      var variants = this.constructor.variants;
      variant && variants.hasOwnProperty(variant) && this.setDataAttribute(data, 'variant', variant);
      node.getProperty('variantForm') && this.setDataAttribute(data, 'alternate', '1');
      node.getProperty('pseudoscript') && this.setDataAttribute(data, 'pseudoscript', 'true');
      node.getProperty('autoOP') === false && this.setDataAttribute(data, 'auto-op', 'false');
      var scriptalign = node.getProperty('scriptalign');
      scriptalign && this.setDataAttribute(data, 'script-align', scriptalign);
      var texclass = node.getProperty('texClass');
      if (texclass !== undefined) {
        var setclass = true;
        if (texclass === MmlNode_js_1.TEXCLASS.OP && node.isKind('mi')) {
          var name_2 = node.getText();
          setclass = !(name_2.length > 1 && name_2.match(mi_js_1.MmlMi.operatorName));
        }
        setclass && this.setDataAttribute(data, 'texclass', texclass < 0 ? 'NONE' : MmlNode_js_1.TEXCLASSNAMES[texclass]);
      }
      node.getProperty('scriptlevel') && node.getProperty('useHeight') === false && this.setDataAttribute(data, 'smallmatrix', 'true');
      return data;
    };
    SerializedMmlVisitor.prototype.setDataAttribute = function (data, name, value) {
      data[exports.DATAMJX + name] = value;
    };
    SerializedMmlVisitor.prototype.quoteHTML = function (value) {
      return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;').replace(/[\uD800-\uDBFF]./g, exports.toEntity).replace(/[\u0080-\uD7FF\uE000-\uFFFF]/g, exports.toEntity);
    };
    SerializedMmlVisitor.variants = {
      '-tex-calligraphic': 'script',
      '-tex-bold-calligraphic': 'bold-script',
      '-tex-oldstyle': 'normal',
      '-tex-bold-oldstyle': 'bold',
      '-tex-mathit': 'italic'
    };
    SerializedMmlVisitor.defaultAttributes = {
      math: {
        xmlns: 'http://www.w3.org/1998/Math/MathML'
      }
    };
    return SerializedMmlVisitor;
  })(MmlVisitor_js_1.MmlVisitor);
  exports.SerializedMmlVisitor = SerializedMmlVisitor;
})(SerializedMmlVisitor);
getDefaultExportFromCjs(SerializedMmlVisitor);

var Options = {};

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !((i in from))) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.lookup = exports.separateOptions = exports.selectOptionsFromKeys = exports.selectOptions = exports.userOptions = exports.defaultOptions = exports.insert = exports.copy = exports.keys = exports.makeArray = exports.expandable = exports.Expandable = exports.OPTIONS = exports.REMOVE = exports.APPEND = exports.isObject = void 0;
  var OBJECT = ({}).constructor;
  function isObject(obj) {
    return typeof obj === 'object' && obj !== null && (obj.constructor === OBJECT || obj.constructor === Expandable);
  }
  exports.isObject = isObject;
  exports.APPEND = '[+]';
  exports.REMOVE = '[-]';
  exports.OPTIONS = {
    invalidOption: 'warn',
    optionError: function (message, _key) {
      if (exports.OPTIONS.invalidOption === 'fatal') {
        throw new Error(message);
      }
      console.warn('MathJax: ' + message);
    }
  };
  var Expandable = (function () {
    function Expandable() {}
    return Expandable;
  })();
  exports.Expandable = Expandable;
  function expandable(def) {
    return Object.assign(Object.create(Expandable.prototype), def);
  }
  exports.expandable = expandable;
  function makeArray(x) {
    return Array.isArray(x) ? x : [x];
  }
  exports.makeArray = makeArray;
  function keys(def) {
    if (!def) {
      return [];
    }
    return Object.keys(def).concat(Object.getOwnPropertySymbols(def));
  }
  exports.keys = keys;
  function copy(def) {
    var e_1, _a;
    var props = {};
    try {
      for (var _b = __values(keys(def)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;
        var prop = Object.getOwnPropertyDescriptor(def, key);
        var value = prop.value;
        if (Array.isArray(value)) {
          prop.value = insert([], value, false);
        } else if (isObject(value)) {
          prop.value = copy(value);
        }
        if (prop.enumerable) {
          props[key] = prop;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return Object.defineProperties(def.constructor === Expandable ? expandable({}) : {}, props);
  }
  exports.copy = copy;
  function insert(dst, src, warn) {
    var e_2, _a;
    if (warn === void 0) {
      warn = true;
    }
    var _loop_1 = function (key) {
      if (warn && dst[key] === undefined && dst.constructor !== Expandable) {
        if (typeof key === 'symbol') {
          key = key.toString();
        }
        exports.OPTIONS.optionError(("Invalid option \"").concat(key, "\" (no default value)."), key);
        return "continue";
      }
      var sval = src[key], dval = dst[key];
      if (isObject(sval) && dval !== null && (typeof dval === 'object' || typeof dval === 'function')) {
        var ids = keys(sval);
        if (Array.isArray(dval) && (ids.length === 1 && (ids[0] === exports.APPEND || ids[0] === exports.REMOVE) && Array.isArray(sval[ids[0]]) || ids.length === 2 && ids.sort().join(',') === exports.APPEND + ',' + exports.REMOVE && Array.isArray(sval[exports.APPEND]) && Array.isArray(sval[exports.REMOVE]))) {
          if (sval[exports.REMOVE]) {
            dval = dst[key] = dval.filter(function (x) {
              return sval[exports.REMOVE].indexOf(x) < 0;
            });
          }
          if (sval[exports.APPEND]) {
            dst[key] = __spreadArray(__spreadArray([], __read(dval), false), __read(sval[exports.APPEND]), false);
          }
        } else {
          insert(dval, sval, warn);
        }
      } else if (Array.isArray(sval)) {
        dst[key] = [];
        insert(dst[key], sval, false);
      } else if (isObject(sval)) {
        dst[key] = copy(sval);
      } else {
        dst[key] = sval;
      }
    };
    try {
      for (var _b = __values(keys(src)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;
        _loop_1(key);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return dst;
  }
  exports.insert = insert;
  function defaultOptions(options) {
    var defs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      defs[_i - 1] = arguments[_i];
    }
    defs.forEach(function (def) {
      return insert(options, def, false);
    });
    return options;
  }
  exports.defaultOptions = defaultOptions;
  function userOptions(options) {
    var defs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      defs[_i - 1] = arguments[_i];
    }
    defs.forEach(function (def) {
      return insert(options, def, true);
    });
    return options;
  }
  exports.userOptions = userOptions;
  function selectOptions(options) {
    var e_3, _a;
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      keys[_i - 1] = arguments[_i];
    }
    var subset = {};
    try {
      for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
        var key = keys_1_1.value;
        if (options.hasOwnProperty(key)) {
          subset[key] = options[key];
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return subset;
  }
  exports.selectOptions = selectOptions;
  function selectOptionsFromKeys(options, object) {
    return selectOptions.apply(void 0, __spreadArray([options], __read(Object.keys(object)), false));
  }
  exports.selectOptionsFromKeys = selectOptionsFromKeys;
  function separateOptions(options) {
    var e_4, _a, e_5, _b;
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      objects[_i - 1] = arguments[_i];
    }
    var results = [];
    try {
      for (var objects_1 = __values(objects), objects_1_1 = objects_1.next(); !objects_1_1.done; objects_1_1 = objects_1.next()) {
        var object = objects_1_1.value;
        var exists = {}, missing = {};
        try {
          for (var _c = (e_5 = void 0, __values(Object.keys(options || ({})))), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            (object[key] === undefined ? missing : exists)[key] = options[key];
          }
        } catch (e_5_1) {
          e_5 = {
            error: e_5_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
          } finally {
            if (e_5) throw e_5.error;
          }
        }
        results.push(exists);
        options = missing;
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (objects_1_1 && !objects_1_1.done && (_a = objects_1.return)) _a.call(objects_1);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    results.unshift(options);
    return results;
  }
  exports.separateOptions = separateOptions;
  function lookup(name, lookup, def) {
    if (def === void 0) {
      def = null;
    }
    return lookup.hasOwnProperty(name) ? lookup[name] : def;
  }
  exports.lookup = lookup;
})(Options);
getDefaultExportFromCjs(Options);

var __extends$1L = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$e = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$e = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$e.apply(this, arguments);
});
var __read$W = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$v = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$P = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(assistiveMml, "__esModule", {
  value: true
});
var AssistiveMmlHandler_1 = assistiveMml.AssistiveMmlHandler = assistiveMml.AssistiveMmlMathDocumentMixin = assistiveMml.AssistiveMmlMathItemMixin = assistiveMml.LimitedMmlVisitor = void 0;
var MathItem_js_1$7 = MathItem;
var SerializedMmlVisitor_js_1$2 = SerializedMmlVisitor;
var Options_js_1$i = Options;
var LimitedMmlVisitor = (function (_super) {
  __extends$1L(LimitedMmlVisitor, _super);
  function LimitedMmlVisitor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  LimitedMmlVisitor.prototype.getAttributes = function (node) {
    return _super.prototype.getAttributes.call(this, node).replace(/ ?id=".*?"/, '');
  };
  return LimitedMmlVisitor;
})(SerializedMmlVisitor_js_1$2.SerializedMmlVisitor);
assistiveMml.LimitedMmlVisitor = LimitedMmlVisitor;
(0, MathItem_js_1$7.newState)('ASSISTIVEMML', 153);
function AssistiveMmlMathItemMixin(BaseMathItem) {
  return (function (_super) {
    __extends$1L(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.assistiveMml = function (document, force) {
      if (force === void 0) {
        force = false;
      }
      if (this.state() >= MathItem_js_1$7.STATE.ASSISTIVEMML) return;
      if (!this.isEscaped && (document.options.enableAssistiveMml || force)) {
        var adaptor = document.adaptor;
        var mml = document.toMML(this.root).replace(/\n */g, '').replace(/<!--.*?-->/g, '');
        var mmlNodes = adaptor.firstChild(adaptor.body(adaptor.parse(mml, 'text/html')));
        var node = adaptor.node('mjx-assistive-mml', {
          unselectable: 'on',
          display: this.display ? 'block' : 'inline'
        }, [mmlNodes]);
        adaptor.setAttribute(adaptor.firstChild(this.typesetRoot), 'aria-hidden', 'true');
        adaptor.setStyle(this.typesetRoot, 'position', 'relative');
        adaptor.append(this.typesetRoot, node);
      }
      this.state(MathItem_js_1$7.STATE.ASSISTIVEMML);
    };
    return class_1;
  })(BaseMathItem);
}
assistiveMml.AssistiveMmlMathItemMixin = AssistiveMmlMathItemMixin;
function AssistiveMmlMathDocumentMixin(BaseDocument) {
  var _a;
  return (_a = (function (_super) {
    __extends$1L(BaseClass, _super);
    function BaseClass() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$v([], __read$W(args), false)) || this;
      var CLASS = _this.constructor;
      var ProcessBits = CLASS.ProcessBits;
      if (!ProcessBits.has('assistive-mml')) {
        ProcessBits.allocate('assistive-mml');
      }
      _this.visitor = new LimitedMmlVisitor(_this.mmlFactory);
      _this.options.MathItem = AssistiveMmlMathItemMixin(_this.options.MathItem);
      if (('addStyles' in _this)) {
        _this.addStyles(CLASS.assistiveStyles);
      }
      return _this;
    }
    BaseClass.prototype.toMML = function (node) {
      return this.visitor.visitTree(node);
    };
    BaseClass.prototype.assistiveMml = function () {
      var e_1, _a;
      if (!this.processed.isSet('assistive-mml')) {
        try {
          for (var _b = __values$P(this.math), _c = _b.next(); !_c.done; _c = _b.next()) {
            var math = _c.value;
            math.assistiveMml(this);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        this.processed.set('assistive-mml');
      }
      return this;
    };
    BaseClass.prototype.state = function (state, restore) {
      if (restore === void 0) {
        restore = false;
      }
      _super.prototype.state.call(this, state, restore);
      if (state < MathItem_js_1$7.STATE.ASSISTIVEMML) {
        this.processed.clear('assistive-mml');
      }
      return this;
    };
    return BaseClass;
  })(BaseDocument), _a.OPTIONS = __assign$e(__assign$e({}, BaseDocument.OPTIONS), {
    enableAssistiveMml: true,
    renderActions: (0, Options_js_1$i.expandable)(__assign$e(__assign$e({}, BaseDocument.OPTIONS.renderActions), {
      assistiveMml: [MathItem_js_1$7.STATE.ASSISTIVEMML]
    }))
  }), _a.assistiveStyles = {
    'mjx-assistive-mml': {
      position: 'absolute !important',
      top: '0px',
      left: '0px',
      clip: 'rect(1px, 1px, 1px, 1px)',
      padding: '1px 0px 0px 0px !important',
      border: '0px !important',
      display: 'block !important',
      width: 'auto !important',
      overflow: 'hidden !important',
      '-webkit-touch-callout': 'none',
      '-webkit-user-select': 'none',
      '-khtml-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      'user-select': 'none'
    },
    'mjx-assistive-mml[display="block"]': {
      width: '100% !important'
    }
  }, _a);
}
assistiveMml.AssistiveMmlMathDocumentMixin = AssistiveMmlMathDocumentMixin;
function AssistiveMmlHandler(handler) {
  handler.documentClass = AssistiveMmlMathDocumentMixin(handler.documentClass);
  return handler;
}
AssistiveMmlHandler_1 = assistiveMml.AssistiveMmlHandler = AssistiveMmlHandler;

var semanticEnrich = {};

var sre = {};

var system = {};

var engine = {};

var dynamic_cstr = {};

Object.defineProperty(dynamic_cstr, "__esModule", {
  value: true
});
dynamic_cstr.DefaultComparator = dynamic_cstr.DynamicCstrParser = dynamic_cstr.DynamicCstr = dynamic_cstr.DynamicProperties = dynamic_cstr.Axis = void 0;
var Axis;
(function (Axis) {
  Axis["DOMAIN"] = "domain";
  Axis["STYLE"] = "style";
  Axis["LOCALE"] = "locale";
  Axis["TOPIC"] = "topic";
  Axis["MODALITY"] = "modality";
})(Axis || (dynamic_cstr.Axis = Axis = {}));
class DynamicProperties {
  static createProp(...cstrList) {
    const axes = DynamicCstr.DEFAULT_ORDER;
    const dynamicCstr = {};
    for (let i = 0, l = cstrList.length, k = axes.length; i < l && i < k; i++) {
      dynamicCstr[axes[i]] = cstrList[i];
    }
    return new DynamicProperties(dynamicCstr);
  }
  constructor(properties, order = Object.keys(properties)) {
    this.properties = properties;
    this.order = order;
  }
  getProperties() {
    return this.properties;
  }
  getOrder() {
    return this.order;
  }
  getAxes() {
    return this.order;
  }
  getProperty(key) {
    return this.properties[key];
  }
  updateProperties(props) {
    this.properties = props;
  }
  allProperties() {
    const propLists = [];
    this.order.forEach(key => propLists.push(this.getProperty(key).slice()));
    return propLists;
  }
  toString() {
    const cstrStrings = [];
    this.order.forEach(key => cstrStrings.push(key + ': ' + this.getProperty(key).toString()));
    return cstrStrings.join('\n');
  }
}
dynamic_cstr.DynamicProperties = DynamicProperties;
class DynamicCstr extends DynamicProperties {
  static createCstr(...cstrList) {
    const axes = DynamicCstr.DEFAULT_ORDER;
    const dynamicCstr = {};
    for (let i = 0, l = cstrList.length, k = axes.length; i < l && i < k; i++) {
      dynamicCstr[axes[i]] = cstrList[i];
    }
    return new DynamicCstr(dynamicCstr);
  }
  static defaultCstr() {
    return DynamicCstr.createCstr.apply(null, DynamicCstr.DEFAULT_ORDER.map(function (x) {
      return DynamicCstr.DEFAULT_VALUES[x];
    }));
  }
  static validOrder(order) {
    const axes = DynamicCstr.DEFAULT_ORDER.slice();
    return order.every(x => {
      const index = axes.indexOf(x);
      return index !== -1 && axes.splice(index, 1);
    });
  }
  constructor(components_, order) {
    const properties = {};
    for (const [key, value] of Object.entries(components_)) {
      properties[key] = [value];
    }
    super(properties, order);
    this.components = components_;
  }
  getComponents() {
    return this.components;
  }
  getValue(key) {
    return this.components[key];
  }
  getValues() {
    return this.order.map(key => this.getValue(key));
  }
  allProperties() {
    const propLists = super.allProperties();
    for (let i = 0, props, key; (props = propLists[i], key = this.order[i]); i++) {
      const value = this.getValue(key);
      if (props.indexOf(value) === -1) {
        props.unshift(value);
      }
    }
    return propLists;
  }
  toString() {
    return this.getValues().join('.');
  }
  equal(cstr) {
    const keys1 = cstr.getAxes();
    if (this.order.length !== keys1.length) {
      return false;
    }
    for (let j = 0, key; key = keys1[j]; j++) {
      const comp2 = this.getValue(key);
      if (!comp2 || cstr.getValue(key) !== comp2) {
        return false;
      }
    }
    return true;
  }
}
dynamic_cstr.DynamicCstr = DynamicCstr;
DynamicCstr.DEFAULT_ORDER = [Axis.LOCALE, Axis.MODALITY, Axis.DOMAIN, Axis.STYLE, Axis.TOPIC];
DynamicCstr.BASE_LOCALE = 'base';
DynamicCstr.DEFAULT_VALUE = 'default';
DynamicCstr.DEFAULT_VALUES = {
  [Axis.LOCALE]: 'en',
  [Axis.DOMAIN]: DynamicCstr.DEFAULT_VALUE,
  [Axis.STYLE]: DynamicCstr.DEFAULT_VALUE,
  [Axis.TOPIC]: DynamicCstr.DEFAULT_VALUE,
  [Axis.MODALITY]: 'speech'
};
class DynamicCstrParser {
  constructor(order) {
    this.order = order;
  }
  parse(str) {
    const order = str.split('.');
    const cstr = {};
    if (order.length > this.order.length) {
      throw new Error('Invalid dynamic constraint: ' + cstr);
    }
    let j = 0;
    for (let i = 0, key; (key = this.order[i], order.length); (i++, j++)) {
      const value = order.shift();
      cstr[key] = value;
    }
    return new DynamicCstr(cstr, this.order.slice(0, j));
  }
}
dynamic_cstr.DynamicCstrParser = DynamicCstrParser;
class DefaultComparator {
  constructor(reference, fallback = new DynamicProperties(reference.getProperties(), reference.getOrder())) {
    this.reference = reference;
    this.fallback = fallback;
    this.order = this.reference.getOrder();
  }
  getReference() {
    return this.reference;
  }
  setReference(cstr, props) {
    this.reference = cstr;
    this.fallback = props || new DynamicProperties(cstr.getProperties(), cstr.getOrder());
    this.order = this.reference.getOrder();
  }
  match(cstr) {
    const keys1 = cstr.getAxes();
    return keys1.length === this.reference.getAxes().length && keys1.every(key => {
      const value = cstr.getValue(key);
      return value === this.reference.getValue(key) || this.fallback.getProperty(key).indexOf(value) !== -1;
    });
  }
  compare(cstr1, cstr2) {
    let ignore = false;
    for (let i = 0, key; key = this.order[i]; i++) {
      const value1 = cstr1.getValue(key);
      const value2 = cstr2.getValue(key);
      if (!ignore) {
        const ref = this.reference.getValue(key);
        if (ref === value1 && ref !== value2) {
          return -1;
        }
        if (ref === value2 && ref !== value1) {
          return 1;
        }
        if (ref === value1 && ref === value2) {
          continue;
        }
        if (ref !== value1 && ref !== value2) {
          ignore = true;
        }
      }
      const prop = this.fallback.getProperty(key);
      const index1 = prop.indexOf(value1);
      const index2 = prop.indexOf(value2);
      if (index1 < index2) {
        return -1;
      }
      if (index2 < index1) {
        return 1;
      }
    }
    return 0;
  }
  toString() {
    return this.reference.toString() + '\n' + this.fallback.toString();
  }
}
dynamic_cstr.DefaultComparator = DefaultComparator;

var engine_const = {};

Object.defineProperty(engine_const, "__esModule", {
  value: true
});
engine_const.DOMAIN_TO_STYLES = engine_const.Markup = engine_const.Speech = engine_const.personalityPropList = engine_const.personalityProps = engine_const.Mode = void 0;
var Mode;
(function (Mode) {
  Mode["SYNC"] = "sync";
  Mode["ASYNC"] = "async";
  Mode["HTTP"] = "http";
})(Mode || (engine_const.Mode = Mode = {}));
var personalityProps;
(function (personalityProps) {
  personalityProps["PITCH"] = "pitch";
  personalityProps["RATE"] = "rate";
  personalityProps["VOLUME"] = "volume";
  personalityProps["PAUSE"] = "pause";
  personalityProps["JOIN"] = "join";
  personalityProps["LAYOUT"] = "layout";
})(personalityProps || (engine_const.personalityProps = personalityProps = {}));
engine_const.personalityPropList = [personalityProps.PITCH, personalityProps.RATE, personalityProps.VOLUME, personalityProps.PAUSE, personalityProps.JOIN];
var Speech;
(function (Speech) {
  Speech["NONE"] = "none";
  Speech["SHALLOW"] = "shallow";
  Speech["DEEP"] = "deep";
})(Speech || (engine_const.Speech = Speech = {}));
var Markup;
(function (Markup) {
  Markup["NONE"] = "none";
  Markup["LAYOUT"] = "layout";
  Markup["COUNTING"] = "counting";
  Markup["PUNCTUATION"] = "punctuation";
  Markup["SSML"] = "ssml";
  Markup["ACSS"] = "acss";
  Markup["SABLE"] = "sable";
  Markup["VOICEXML"] = "voicexml";
})(Markup || (engine_const.Markup = Markup = {}));
engine_const.DOMAIN_TO_STYLES = {
  mathspeak: 'default',
  clearspeak: 'default'
};

var _debugger = {};

var system_external = {};

var variables = {};

Object.defineProperty(variables, "__esModule", {
  value: true
});
variables.Variables = void 0;
class Variables {
  static ensureLocale(loc, def) {
    if (!Variables.LOCALES.get(loc)) {
      console.error(`Locale ${loc} does not exist! Using` + ` ${Variables.LOCALES.get(def)} instead.`);
      return def;
    }
    return loc;
  }
}
variables.Variables = Variables;
Variables.VERSION = '4.1.2';
Variables.LOCALES = new Map([['af', 'Africaans'], ['ca', 'Catalan'], ['da', 'Danish'], ['de', 'German'], ['en', 'English'], ['es', 'Spanish'], ['euro', 'Euro'], ['fr', 'French'], ['hi', 'Hindi'], ['it', 'Italian'], ['ko', 'Korean'], ['nb', 'Bokmål'], ['nn', 'Nynorsk'], ['sv', 'Swedish'], ['nemeth', 'Nemeth']]);
Variables.mathjaxVersion = '4.0.0-beta.5';
Variables.url = 'https://cdn.jsdelivr.net/npm/speech-rule-engine@' + Variables.VERSION + '/lib/mathmaps';
Variables.WGXpath = 'https://cdn.jsdelivr.net/npm/wicked-good-xpath@1.3.0/dist/wgxpath.install.js';

Object.defineProperty(system_external, "__esModule", {
  value: true
});
system_external.SystemExternal = void 0;
const variables_js_1$1 = variables;
class SystemExternal {
  static nodeRequire() {
    return eval('require');
  }
  static extRequire(library) {
    if (typeof process !== 'undefined' && typeof commonjsRequire !== 'undefined') {
      return SystemExternal.nodeRequire()(library);
    }
    return null;
  }
}
system_external.SystemExternal = SystemExternal;
SystemExternal.windowSupported = (() => !(typeof window === 'undefined'))();
SystemExternal.documentSupported = (() => SystemExternal.windowSupported && !(typeof window.document === 'undefined'))();
SystemExternal.xmldom = SystemExternal.documentSupported ? window : SystemExternal.extRequire('@xmldom/xmldom');
SystemExternal.document = SystemExternal.documentSupported ? window.document : new SystemExternal.xmldom.DOMImplementation().createDocument('', '', 0);
SystemExternal.xpath = SystemExternal.documentSupported ? document : (function () {
  const window = {
    document: {},
    XPathResult: {}
  };
  const wgx = SystemExternal.extRequire('wicked-good-xpath');
  wgx.install(window);
  window.document.XPathResult = window.XPathResult;
  return window.document;
})();
SystemExternal.mathmapsIePath = 'https://cdn.jsdelivr.net/npm/sre-mathmaps-ie@' + variables_js_1$1.Variables.VERSION + 'mathmaps_ie.js';
SystemExternal.fs = SystemExternal.documentSupported ? null : SystemExternal.extRequire('fs');
SystemExternal.url = variables_js_1$1.Variables.url;
SystemExternal.jsonPath = (function () {
  if (SystemExternal.documentSupported) {
    return SystemExternal.url;
  }
  if (process.env.SRE_JSON_PATH || commonjsGlobal.SRE_JSON_PATH) {
    return process.env.SRE_JSON_PATH || commonjsGlobal.SRE_JSON_PATH;
  }
  try {
    const path = SystemExternal.nodeRequire().resolve('speech-rule-engine');
    return path.replace(/sre\.js$/, '') + 'mathmaps';
  } catch (_err) {}
  try {
    const path = SystemExternal.nodeRequire().resolve('.');
    return path.replace(/sre\.js$/, '') + 'mathmaps';
  } catch (_err) {}
  return typeof __dirname !== 'undefined' ? __dirname + (__dirname.match(/lib?$/) ? '/mathmaps' : '/lib/mathmaps') : process.cwd() + '/lib/mathmaps';
})();
SystemExternal.WGXpath = variables_js_1$1.Variables.WGXpath;
SystemExternal.wgxpath = null;
system_external.default = SystemExternal;

Object.defineProperty(_debugger, "__esModule", {
  value: true
});
_debugger.Debugger = void 0;
const system_external_js_1$5 = system_external;
class Debugger {
  static getInstance() {
    Debugger.instance = Debugger.instance || new Debugger();
    return Debugger.instance;
  }
  init(opt_file) {
    if (opt_file) {
      this.startDebugFile_(opt_file);
    }
    this.isActive_ = true;
    return this.fileHandle;
  }
  output(...args) {
    if (this.isActive_) {
      this.output_(args);
    }
  }
  generateOutput(func) {
    if (this.isActive_) {
      this.output_(func.apply(func, []));
    }
  }
  exit(callback = () => {}) {
    this.fileHandle.then(() => {
      if (this.isActive_ && this.stream_) {
        this.stream_.end('', '', callback);
      }
    });
  }
  constructor() {
    this.isActive_ = false;
    this.outputFunction_ = console.info;
    this.fileHandle = Promise.resolve();
    this.stream_ = null;
  }
  startDebugFile_(filename) {
    this.fileHandle = system_external_js_1$5.SystemExternal.fs.promises.open(filename, 'w');
    this.fileHandle = this.fileHandle.then(handle => {
      this.stream_ = handle.createWriteStream(filename);
      this.outputFunction_ = (function (...args) {
        this.stream_.write(args.join(' '));
        this.stream_.write('\n');
      }).bind(this);
      this.stream_.on('error', (function (_error) {
        console.info('Invalid log file. Debug information sent to console.');
        this.outputFunction_ = console.info;
      }).bind(this));
      this.stream_.on('finish', function () {
        console.info('Finalizing debug file.');
      });
    });
  }
  output_(outputList) {
    if (console.info === this.outputFunction_) {
      this.outputFunction_.apply(console, ['Speech Rule Engine Debugger:'].concat(outputList));
      return;
    }
    this.fileHandle.then(() => this.outputFunction_.apply(this.outputFunction_, ['Speech Rule Engine Debugger:'].concat(outputList)));
  }
}
_debugger.Debugger = Debugger;

Object.defineProperty(engine, "__esModule", {
  value: true
});
engine.EnginePromise = engine.Engine = engine.SREError = void 0;
const Dcstr = dynamic_cstr;
const EngineConst$e = engine_const;
const debugger_js_1$7 = _debugger;
const variables_js_1 = variables;
class SREError extends Error {
  constructor(message = '') {
    super();
    this.message = message;
    this.name = 'SRE Error';
  }
}
engine.SREError = SREError;
class Engine {
  set defaultLocale(loc) {
    this._defaultLocale = variables_js_1.Variables.ensureLocale(loc, this._defaultLocale);
  }
  get defaultLocale() {
    return this._defaultLocale;
  }
  static getInstance() {
    Engine.instance = Engine.instance || new Engine();
    return Engine.instance;
  }
  static defaultEvaluator(str, _cstr) {
    return str;
  }
  static evaluateNode(node) {
    return Engine.nodeEvaluator(node);
  }
  getRate() {
    const numeric = parseInt(this.rate, 10);
    return isNaN(numeric) ? 100 : numeric;
  }
  setDynamicCstr(opt_dynamic) {
    if (this.defaultLocale) {
      Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.LOCALE] = this.defaultLocale;
    }
    if (opt_dynamic) {
      const keys = Object.keys(opt_dynamic);
      for (let i = 0; i < keys.length; i++) {
        const feature = keys[i];
        if (Dcstr.DynamicCstr.DEFAULT_ORDER.indexOf(feature) !== -1) {
          const value = opt_dynamic[feature];
          this[feature] = value;
        }
      }
    }
    EngineConst$e.DOMAIN_TO_STYLES[this.domain] = this.style;
    const dynamic = [this.locale, this.modality, this.domain, this.style].join('.');
    const fallback = Dcstr.DynamicProperties.createProp([Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.LOCALE]], [Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.MODALITY]], [Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.DOMAIN]], [Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.STYLE]]);
    const comparator = this.comparators[this.domain];
    const parser = this.parsers[this.domain];
    this.parser = parser ? parser : this.defaultParser;
    this.dynamicCstr = this.parser.parse(dynamic);
    this.dynamicCstr.updateProperties(fallback.getProperties());
    this.comparator = comparator ? comparator() : new Dcstr.DefaultComparator(this.dynamicCstr);
  }
  constructor() {
    this.customLoader = null;
    this.parsers = {};
    this.comparator = null;
    this.mode = EngineConst$e.Mode.SYNC;
    this.init = true;
    this.delay = false;
    this.comparators = {};
    this.domain = 'mathspeak';
    this.style = Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.STYLE];
    this._defaultLocale = Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.LOCALE];
    this.locale = Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.LOCALE];
    this.subiso = '';
    this.modality = Dcstr.DynamicCstr.DEFAULT_VALUES[Dcstr.Axis.MODALITY];
    this.speech = EngineConst$e.Speech.NONE;
    this.markup = EngineConst$e.Markup.NONE;
    this.mark = true;
    this.automark = false;
    this.character = true;
    this.cleanpause = true;
    this.cayleyshort = true;
    this.linebreaks = false;
    this.rate = '100';
    this.walker = 'Table';
    this.structure = false;
    this.aria = false;
    this.ruleSets = [];
    this.strict = false;
    this.isIE = false;
    this.isEdge = false;
    this.pprint = false;
    this.config = false;
    this.rules = '';
    this.prune = '';
    this.locale = this.defaultLocale;
    this.evaluator = Engine.defaultEvaluator;
    this.defaultParser = new Dcstr.DynamicCstrParser(Dcstr.DynamicCstr.DEFAULT_ORDER);
    this.parser = this.defaultParser;
    this.dynamicCstr = Dcstr.DynamicCstr.defaultCstr();
  }
  configurate(feature) {
    if (this.mode === EngineConst$e.Mode.HTTP && !this.config) {
      configBlocks(feature);
      this.config = true;
    }
    configFeature(feature);
  }
  setCustomLoader(fn) {
    if (fn) {
      this.customLoader = fn;
    }
  }
}
engine.Engine = Engine;
Engine.BINARY_FEATURES = ['automark', 'mark', 'character', 'cleanpause', 'strict', 'structure', 'aria', 'pprint', 'cayleyshort', 'linebreaks'];
Engine.STRING_FEATURES = ['markup', 'style', 'domain', 'speech', 'walker', 'defaultLocale', 'locale', 'delay', 'modality', 'rate', 'rules', 'subiso', 'prune'];
Engine.nodeEvaluator = function (_node) {
  return [];
};
engine.default = Engine;
function configFeature(feature) {
  if (typeof SREfeature !== 'undefined') {
    for (const [name, feat] of Object.entries(SREfeature)) {
      feature[name] = feat;
    }
  }
}
function configBlocks(feature) {
  const scripts = document.documentElement.querySelectorAll('script[type="text/x-sre-config"]');
  for (let i = 0, m = scripts.length; i < m; i++) {
    let inner;
    try {
      inner = scripts[i].innerHTML;
      const config = JSON.parse(inner);
      for (const [key, val] of Object.entries(config)) {
        feature[key] = val;
      }
    } catch (_err) {
      debugger_js_1$7.Debugger.getInstance().output('Illegal configuration ', inner);
    }
  }
}
class EnginePromise {
  static get(locale = Engine.getInstance().locale) {
    return EnginePromise.promises[locale] || Promise.resolve('');
  }
  static getall() {
    return Promise.all(Object.values(EnginePromise.promises));
  }
}
engine.EnginePromise = EnginePromise;
EnginePromise.loaded = {};
EnginePromise.promises = {};

var engine_setup = {};

var l10n = {};

var grammar = {};

var dom_util = {};

var xpath_util = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.xpath = void 0;
  exports.resolveNameSpace = resolveNameSpace;
  exports.evalXPath = evalXPath;
  exports.evaluateBoolean = evaluateBoolean;
  exports.evaluateString = evaluateString;
  exports.updateEvaluator = updateEvaluator;
  const engine_js_1 = engine;
  const EngineConst = engine_const;
  const system_external_js_1 = system_external;
  function xpathSupported() {
    if (typeof XPathResult === 'undefined') {
      return false;
    }
    return true;
  }
  exports.xpath = {
    currentDocument: null,
    evaluate: xpathSupported() ? document.evaluate : system_external_js_1.SystemExternal.xpath.evaluate,
    result: xpathSupported() ? XPathResult : system_external_js_1.SystemExternal.xpath.XPathResult,
    createNSResolver: xpathSupported() ? document.createNSResolver : system_external_js_1.SystemExternal.xpath.createNSResolver
  };
  const nameSpaces = {
    xhtml: 'http://www.w3.org/1999/xhtml',
    mathml: 'http://www.w3.org/1998/Math/MathML',
    mml: 'http://www.w3.org/1998/Math/MathML',
    svg: 'http://www.w3.org/2000/svg'
  };
  function resolveNameSpace(prefix) {
    return nameSpaces[prefix] || null;
  }
  class Resolver {
    constructor() {
      this.lookupNamespaceURI = resolveNameSpace;
    }
  }
  function evaluateXpath(expression, rootNode, type) {
    return engine_js_1.Engine.getInstance().mode === EngineConst.Mode.HTTP && !engine_js_1.Engine.getInstance().isIE && !engine_js_1.Engine.getInstance().isEdge ? exports.xpath.currentDocument.evaluate(expression, rootNode, resolveNameSpace, type, null) : exports.xpath.evaluate(expression, rootNode, new Resolver(), type, null);
  }
  function evalXPath(expression, rootNode) {
    let iterator;
    try {
      iterator = evaluateXpath(expression, rootNode, exports.xpath.result.ORDERED_NODE_ITERATOR_TYPE);
    } catch (_err) {
      return [];
    }
    const results = [];
    for (let xpathNode = iterator.iterateNext(); xpathNode; xpathNode = iterator.iterateNext()) {
      results.push(xpathNode);
    }
    return results;
  }
  function evaluateBoolean(expression, rootNode) {
    let result;
    try {
      result = evaluateXpath(expression, rootNode, exports.xpath.result.BOOLEAN_TYPE);
    } catch (_err) {
      return false;
    }
    return result.booleanValue;
  }
  function evaluateString(expression, rootNode) {
    let result;
    try {
      result = evaluateXpath(expression, rootNode, exports.xpath.result.STRING_TYPE);
    } catch (_err) {
      return '';
    }
    return result.stringValue;
  }
  function updateEvaluator(node) {
    if (engine_js_1.Engine.getInstance().mode !== EngineConst.Mode.HTTP) return;
    let parent = node;
    while (parent && !parent.evaluate) {
      parent = parent.parentNode;
    }
    if (parent && parent.evaluate) {
      exports.xpath.currentDocument = parent;
    } else if (node.ownerDocument) {
      exports.xpath.currentDocument = node.ownerDocument;
    }
  }
})(xpath_util);
getDefaultExportFromCjs(xpath_util);

Object.defineProperty(dom_util, "__esModule", {
  value: true
});
dom_util.NodeType = void 0;
dom_util.toArray = toArray;
dom_util.parseInput = parseInput;
dom_util.replaceNode = replaceNode;
dom_util.createElement = createElement;
dom_util.createElementNS = createElementNS;
dom_util.createTextNode = createTextNode;
dom_util.formatXml = formatXml;
dom_util.querySelectorAllByAttr = querySelectorAllByAttr;
dom_util.querySelectorAllByAttrValue = querySelectorAllByAttrValue;
dom_util.querySelectorAll = querySelectorAll;
dom_util.tagName = tagName;
dom_util.cloneNode = cloneNode;
dom_util.serializeXml = serializeXml;
const engine_js_1$m = engine;
const EngineConst$d = engine_const;
const system_external_js_1$4 = system_external;
const XpathUtil$e = xpath_util;
function toArray(nodeList) {
  const nodeArray = [];
  for (let i = 0, m = nodeList.length; i < m; i++) {
    nodeArray.push(nodeList[i]);
  }
  return nodeArray;
}
function trimInput(input) {
  input = input.replace(/&nbsp;/g, ' ');
  return input.replace(/>[ \f\n\r\t\v\u200b]+</g, '><').trim();
}
function parseInput(input) {
  const dp = new system_external_js_1$4.SystemExternal.xmldom.DOMParser();
  const clean_input = trimInput(input);
  const allValues = clean_input.match(/&(?!lt|gt|amp|quot|apos)\w+;/g);
  const html = !!allValues;
  if (!clean_input) {
    throw new Error('Empty input!');
  }
  try {
    const doc = dp.parseFromString(clean_input, html ? 'text/html' : 'text/xml');
    if (engine_js_1$m.Engine.getInstance().mode === EngineConst$d.Mode.HTTP) {
      XpathUtil$e.xpath.currentDocument = doc;
      return html ? doc.body.childNodes[0] : doc.documentElement;
    }
    return doc.documentElement;
  } catch (err) {
    throw new engine_js_1$m.SREError('Illegal input: ' + err.message);
  }
}
var NodeType;
(function (NodeType) {
  NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
  NodeType[NodeType["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
  NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
  NodeType[NodeType["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
  NodeType[NodeType["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
  NodeType[NodeType["ENTITY_NODE"] = 6] = "ENTITY_NODE";
  NodeType[NodeType["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
  NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
  NodeType[NodeType["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
  NodeType[NodeType["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
  NodeType[NodeType["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
  NodeType[NodeType["NOTATION_NODE"] = 12] = "NOTATION_NODE";
})(NodeType || (dom_util.NodeType = NodeType = {}));
function replaceNode(oldNode, newNode) {
  if (!oldNode.parentNode) {
    return;
  }
  oldNode.parentNode.insertBefore(newNode, oldNode);
  oldNode.parentNode.removeChild(oldNode);
}
function createElement(tag) {
  return system_external_js_1$4.SystemExternal.document.createElement(tag);
}
function createElementNS(url, tag) {
  return system_external_js_1$4.SystemExternal.document.createElementNS(url, tag);
}
function createTextNode(content) {
  return system_external_js_1$4.SystemExternal.document.createTextNode(content);
}
function formatXml(xml) {
  let formatted = '';
  let reg = /(>)(<)(\/*)/g;
  xml = xml.replace(reg, '$1\r\n$2$3');
  let pad = 0;
  let split = xml.split('\r\n');
  reg = /(\.)*(<)(\/*)/g;
  split = split.map(x => x.replace(reg, '$1\r\n$2$3').split('\r\n')).reduce((x, y) => x.concat(y), []);
  while (split.length) {
    let node = split.shift();
    if (!node) {
      continue;
    }
    let indent = 0;
    if (node.match(/^<\w[^>/]*>[^>]+$/)) {
      const match = matchingStartEnd(node, split[0]);
      if (match[0]) {
        if (match[1]) {
          node = node + split.shift().slice(0, -match[1].length);
          if (match[1].trim()) {
            split.unshift(match[1]);
          }
        } else {
          node = node + split.shift();
        }
      } else {
        indent = 1;
      }
    } else if (node.match(/^<\/\w/)) {
      if (pad !== 0) {
        pad -= 1;
      }
    } else if (node.match(/^<\w[^>]*[^/]>.*$/)) {
      indent = 1;
    } else if (node.match(/^<\w[^>]*\/>.+$/)) {
      const position = node.indexOf('>') + 1;
      const rest = node.slice(position);
      if (rest.trim()) {
        split.unshift();
      }
      node = node.slice(0, position) + rest;
    } else {
      indent = 0;
    }
    formatted += new Array(pad + 1).join('  ') + node + '\r\n';
    pad += indent;
  }
  return formatted;
}
function matchingStartEnd(start, end) {
  if (!end) {
    return [false, ''];
  }
  const tag1 = start.match(/^<([^> ]+).*>/);
  const tag2 = end.match(/^<\/([^>]+)>(.*)/);
  return tag1 && tag2 && tag1[1] === tag2[1] ? [true, tag2[2]] : [false, ''];
}
function querySelectorAllByAttr(node, attr) {
  return node.querySelectorAll ? toArray(node.querySelectorAll(`[${attr}]`)) : XpathUtil$e.evalXPath(`.//*[@${attr}]`, node);
}
function querySelectorAllByAttrValue(node, attr, value) {
  return node.querySelectorAll ? toArray(node.querySelectorAll(`[${attr}="${value}"]`)) : XpathUtil$e.evalXPath(`.//*[@${attr}="${value}"]`, node);
}
function querySelectorAll(node, tag) {
  return node.querySelectorAll ? toArray(node.querySelectorAll(tag)) : XpathUtil$e.evalXPath(`.//${tag}`, node);
}
function tagName(node) {
  return node.tagName.toUpperCase();
}
function cloneNode(node) {
  return node.cloneNode(true);
}
function serializeXml(node) {
  const xmls = new system_external_js_1$4.SystemExternal.xmldom.XMLSerializer();
  return xmls.serializeToString(node);
}

var locale_util = {};

var locale$f = {};

var messages = {};

var transformers = {};

var semantic_meaning = {};

var alphabet = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.INTERVALS = exports.Base = exports.Embellish = exports.Font = void 0;
  exports.makeInterval = makeInterval;
  exports.makeMultiInterval = makeMultiInterval;
  exports.makeCodeInterval = makeCodeInterval;
  exports.alphabetName = alphabetName;
  var Font;
  (function (Font) {
    Font["BOLD"] = "bold";
    Font["BOLDFRAKTUR"] = "bold-fraktur";
    Font["BOLDITALIC"] = "bold-italic";
    Font["BOLDSCRIPT"] = "bold-script";
    Font["DOUBLESTRUCK"] = "double-struck";
    Font["DOUBLESTRUCKITALIC"] = "double-struck-italic";
    Font["FULLWIDTH"] = "fullwidth";
    Font["FRAKTUR"] = "fraktur";
    Font["ITALIC"] = "italic";
    Font["MONOSPACE"] = "monospace";
    Font["NORMAL"] = "normal";
    Font["SCRIPT"] = "script";
    Font["SANSSERIF"] = "sans-serif";
    Font["SANSSERIFITALIC"] = "sans-serif-italic";
    Font["SANSSERIFBOLD"] = "sans-serif-bold";
    Font["SANSSERIFBOLDITALIC"] = "sans-serif-bold-italic";
  })(Font || (exports.Font = Font = {}));
  var Embellish;
  (function (Embellish) {
    Embellish["SUPER"] = "super";
    Embellish["SUB"] = "sub";
    Embellish["CIRCLED"] = "circled";
    Embellish["PARENTHESIZED"] = "parenthesized";
    Embellish["PERIOD"] = "period";
    Embellish["NEGATIVECIRCLED"] = "negative-circled";
    Embellish["DOUBLECIRCLED"] = "double-circled";
    Embellish["CIRCLEDSANSSERIF"] = "circled-sans-serif";
    Embellish["NEGATIVECIRCLEDSANSSERIF"] = "negative-circled-sans-serif";
    Embellish["COMMA"] = "comma";
    Embellish["SQUARED"] = "squared";
    Embellish["NEGATIVESQUARED"] = "negative-squared";
  })(Embellish || (exports.Embellish = Embellish = {}));
  var Base;
  (function (Base) {
    Base["LATINCAP"] = "latinCap";
    Base["LATINSMALL"] = "latinSmall";
    Base["GREEKCAP"] = "greekCap";
    Base["GREEKSMALL"] = "greekSmall";
    Base["DIGIT"] = "digit";
  })(Base || (exports.Base = Base = {}));
  function num2str(num) {
    const str = num.toString(16).toUpperCase();
    return str.length > 3 ? str : ('000' + str).slice(-4);
  }
  function makeInterval([a, b], subst) {
    const start = parseInt(a, 16);
    const end = parseInt(b, 16);
    const result = [];
    for (let i = start; i <= end; i++) {
      let key = num2str(i);
      const sub = subst[key];
      if (sub === false) {
        continue;
      }
      key = subst[key] || key;
      result.push(key);
    }
    return result;
  }
  function makeCharInterval(int, subst = {}) {
    return makeInterval(int, subst).map(x => String.fromCodePoint(parseInt(x, 16)));
  }
  function makeMultiInterval(ints) {
    let result = [];
    for (const int of ints) {
      if (Array.isArray(int)) {
        result = result.concat(makeCharInterval(int));
        continue;
      }
      result.push(String.fromCodePoint(parseInt(int, 16)));
    }
    return result;
  }
  function makeCodeInterval(ints) {
    let result = [];
    for (const int of ints) {
      if (Array.isArray(int)) {
        result = result.concat(makeInterval(int, {}).map(x => parseInt(x, 16)));
        continue;
      }
      result.push(parseInt(int, 16));
    }
    return result;
  }
  const PROTO_INTERVALS = [{
    interval: ['1D400', '1D419'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.BOLD
  }, {
    interval: ['1D41A', '1D433'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.BOLD
  }, {
    interval: ['1D56C', '1D585'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.BOLDFRAKTUR
  }, {
    interval: ['1D586', '1D59F'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.BOLDFRAKTUR
  }, {
    interval: ['1D468', '1D481'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.BOLDITALIC
  }, {
    interval: ['1D482', '1D49B'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.BOLDITALIC
  }, {
    interval: ['1D4D0', '1D4E9'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.BOLDSCRIPT
  }, {
    interval: ['1D4EA', '1D503'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.BOLDSCRIPT
  }, {
    interval: ['1D538', '1D551'],
    base: Base.LATINCAP,
    subst: {
      '1D53A': '2102',
      '1D53F': '210D',
      '1D545': '2115',
      '1D547': '2119',
      '1D548': '211A',
      '1D549': '211D',
      '1D551': '2124'
    },
    capital: true,
    category: 'Lu',
    font: Font.DOUBLESTRUCK
  }, {
    interval: ['1D552', '1D56B'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.DOUBLESTRUCK
  }, {
    interval: ['1D504', '1D51D'],
    base: Base.LATINCAP,
    subst: {
      '1D506': '212D',
      '1D50B': '210C',
      '1D50C': '2111',
      '1D515': '211C',
      '1D51D': '2128'
    },
    capital: true,
    category: 'Lu',
    font: Font.FRAKTUR
  }, {
    interval: ['1D51E', '1D537'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.FRAKTUR
  }, {
    interval: ['FF21', 'FF3A'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.FULLWIDTH
  }, {
    interval: ['FF41', 'FF5A'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.FULLWIDTH
  }, {
    interval: ['1D434', '1D44D'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.ITALIC
  }, {
    interval: ['1D44E', '1D467'],
    base: Base.LATINSMALL,
    subst: {
      '1D455': '210E'
    },
    capital: false,
    category: 'Ll',
    font: Font.ITALIC
  }, {
    interval: ['1D670', '1D689'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.MONOSPACE
  }, {
    interval: ['1D68A', '1D6A3'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.MONOSPACE
  }, {
    interval: ['0041', '005A'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.NORMAL
  }, {
    interval: ['0061', '007A'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.NORMAL
  }, {
    interval: ['1D49C', '1D4B5'],
    base: Base.LATINCAP,
    subst: {
      '1D49D': '212C',
      '1D4A0': '2130',
      '1D4A1': '2131',
      '1D4A3': '210B',
      '1D4A4': '2110',
      '1D4A7': '2112',
      '1D4A8': '2133',
      '1D4AD': '211B'
    },
    capital: true,
    category: 'Lu',
    font: Font.SCRIPT
  }, {
    interval: ['1D4B6', '1D4CF'],
    base: Base.LATINSMALL,
    subst: {
      '1D4BA': '212F',
      '1D4BC': '210A',
      '1D4C4': '2134'
    },
    capital: false,
    category: 'Ll',
    font: Font.SCRIPT
  }, {
    interval: ['1D5A0', '1D5B9'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.SANSSERIF
  }, {
    interval: ['1D5BA', '1D5D3'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.SANSSERIF
  }, {
    interval: ['1D608', '1D621'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.SANSSERIFITALIC
  }, {
    interval: ['1D622', '1D63B'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.SANSSERIFITALIC
  }, {
    interval: ['1D5D4', '1D5ED'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.SANSSERIFBOLD
  }, {
    interval: ['1D5EE', '1D607'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.SANSSERIFBOLD
  }, {
    interval: ['1D63C', '1D655'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.SANSSERIFBOLDITALIC
  }, {
    interval: ['1D656', '1D66F'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.SANSSERIFBOLDITALIC
  }, {
    interval: ['0391', '03A9'],
    base: Base.GREEKCAP,
    subst: {
      '03A2': '03F4'
    },
    capital: true,
    category: 'Lu',
    font: Font.NORMAL
  }, {
    interval: ['03B0', '03D0'],
    base: Base.GREEKSMALL,
    subst: {
      '03B0': '2207',
      '03CA': '2202',
      '03CB': '03F5',
      '03CC': '03D1',
      '03CD': '03F0',
      '03CE': '03D5',
      '03CF': '03F1',
      '03D0': '03D6'
    },
    capital: false,
    category: 'Ll',
    font: Font.NORMAL
  }, {
    interval: ['1D6A8', '1D6C0'],
    base: Base.GREEKCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.BOLD
  }, {
    interval: ['1D6C1', '1D6E1'],
    base: Base.GREEKSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.BOLD
  }, {
    interval: ['1D6E2', '1D6FA'],
    base: Base.GREEKCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.ITALIC
  }, {
    interval: ['1D6FB', '1D71B'],
    base: Base.GREEKSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.ITALIC
  }, {
    interval: ['1D71C', '1D734'],
    base: Base.GREEKCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.BOLDITALIC
  }, {
    interval: ['1D735', '1D755'],
    base: Base.GREEKSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.BOLDITALIC
  }, {
    interval: ['1D756', '1D76E'],
    base: Base.GREEKCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.SANSSERIFBOLD
  }, {
    interval: ['1D76F', '1D78F'],
    base: Base.GREEKSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.SANSSERIFBOLD
  }, {
    interval: ['1D790', '1D7A8'],
    base: Base.GREEKCAP,
    subst: {},
    capital: true,
    category: 'Lu',
    font: Font.SANSSERIFBOLDITALIC
  }, {
    interval: ['1D7A9', '1D7C9'],
    base: Base.GREEKSMALL,
    subst: {},
    capital: false,
    category: 'Ll',
    font: Font.SANSSERIFBOLDITALIC
  }, {
    interval: ['0030', '0039'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'Nd',
    font: Font.NORMAL
  }, {
    interval: ['2070', '2079'],
    base: Base.DIGIT,
    subst: {
      2071: '00B9',
      2072: '00B2',
      2073: '00B3'
    },
    offset: 0,
    category: 'No',
    font: Embellish.SUPER
  }, {
    interval: ['2080', '2089'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'No',
    font: Embellish.SUB
  }, {
    interval: ['245F', '2473'],
    base: Base.DIGIT,
    subst: {
      '245F': '24EA'
    },
    offset: 0,
    category: 'No',
    font: Embellish.CIRCLED
  }, {
    interval: ['3251', '325F'],
    base: Base.DIGIT,
    subst: {},
    offset: 21,
    category: 'No',
    font: Embellish.CIRCLED
  }, {
    interval: ['32B1', '32BF'],
    base: Base.DIGIT,
    subst: {},
    offset: 36,
    category: 'No',
    font: Embellish.CIRCLED
  }, {
    interval: ['2474', '2487'],
    base: Base.DIGIT,
    subst: {},
    offset: 1,
    category: 'No',
    font: Embellish.PARENTHESIZED
  }, {
    interval: ['2487', '249B'],
    base: Base.DIGIT,
    subst: {
      2487: '1F100'
    },
    offset: 0,
    category: 'No',
    font: Embellish.PERIOD
  }, {
    interval: ['2775', '277F'],
    base: Base.DIGIT,
    subst: {
      2775: '24FF'
    },
    offset: 0,
    category: 'No',
    font: Embellish.NEGATIVECIRCLED
  }, {
    interval: ['24EB', '24F4'],
    base: Base.DIGIT,
    subst: {},
    offset: 11,
    category: 'No',
    font: Embellish.NEGATIVECIRCLED
  }, {
    interval: ['24F5', '24FE'],
    base: Base.DIGIT,
    subst: {},
    offset: 1,
    category: 'No',
    font: Embellish.DOUBLECIRCLED
  }, {
    interval: ['277F', '2789'],
    base: Base.DIGIT,
    subst: {
      '277F': '1F10B'
    },
    offset: 0,
    category: 'No',
    font: Embellish.CIRCLEDSANSSERIF
  }, {
    interval: ['2789', '2793'],
    base: Base.DIGIT,
    subst: {
      2789: '1F10C'
    },
    offset: 0,
    category: 'No',
    font: Embellish.NEGATIVECIRCLEDSANSSERIF
  }, {
    interval: ['FF10', 'FF19'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'Nd',
    font: Font.FULLWIDTH
  }, {
    interval: ['1D7CE', '1D7D7'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'Nd',
    font: Font.BOLD
  }, {
    interval: ['1D7D8', '1D7E1'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'Nd',
    font: Font.DOUBLESTRUCK
  }, {
    interval: ['1D7E2', '1D7EB'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'Nd',
    font: Font.SANSSERIF
  }, {
    interval: ['1D7EC', '1D7F5'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'Nd',
    font: Font.SANSSERIFBOLD
  }, {
    interval: ['1D7F6', '1D7FF'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'Nd',
    font: Font.MONOSPACE
  }, {
    interval: ['1F101', '1F10A'],
    base: Base.DIGIT,
    subst: {},
    offset: 0,
    category: 'No',
    font: Embellish.COMMA
  }, {
    interval: ['24B6', '24CF'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'So',
    font: Embellish.CIRCLED
  }, {
    interval: ['24D0', '24E9'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'So',
    font: Embellish.CIRCLED
  }, {
    interval: ['1F110', '1F129'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'So',
    font: Embellish.PARENTHESIZED
  }, {
    interval: ['249C', '24B5'],
    base: Base.LATINSMALL,
    subst: {},
    capital: false,
    category: 'So',
    font: Embellish.PARENTHESIZED
  }, {
    interval: ['1F130', '1F149'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'So',
    font: Embellish.SQUARED
  }, {
    interval: ['1F170', '1F189'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'So',
    font: Embellish.NEGATIVESQUARED
  }, {
    interval: ['1F150', '1F169'],
    base: Base.LATINCAP,
    subst: {},
    capital: true,
    category: 'So',
    font: Embellish.NEGATIVECIRCLED
  }];
  exports.INTERVALS = new Map();
  function alphabetName(base, font) {
    const capFont = font.split('-').map(x => x[0].toUpperCase() + x.slice(1)).join('');
    return base + capFont;
  }
  for (const proto of PROTO_INTERVALS) {
    const key = alphabetName(proto.base, proto.font);
    const interval = makeCharInterval(proto.interval, proto.subst);
    let alphabet = exports.INTERVALS.get(key);
    if (alphabet) {
      alphabet.unicode = alphabet.unicode.concat(interval);
      continue;
    }
    alphabet = proto;
    alphabet.unicode = interval;
    exports.INTERVALS.set(key, alphabet);
  }
})(alphabet);
getDefaultExportFromCjs(alphabet);

Object.defineProperty(semantic_meaning, "__esModule", {
  value: true
});
semantic_meaning.SemanticSecondary = semantic_meaning.SemanticFont = semantic_meaning.SemanticRole = semantic_meaning.SemanticType = void 0;
const Alphabet$1 = alphabet;
var Types;
(function (Types) {
  Types["PUNCTUATION"] = "punctuation";
  Types["FENCE"] = "fence";
  Types["NUMBER"] = "number";
  Types["IDENTIFIER"] = "identifier";
  Types["TEXT"] = "text";
  Types["OPERATOR"] = "operator";
  Types["RELATION"] = "relation";
  Types["LARGEOP"] = "largeop";
  Types["FUNCTION"] = "function";
  Types["ACCENT"] = "accent";
  Types["FENCED"] = "fenced";
  Types["FRACTION"] = "fraction";
  Types["PUNCTUATED"] = "punctuated";
  Types["RELSEQ"] = "relseq";
  Types["MULTIREL"] = "multirel";
  Types["INFIXOP"] = "infixop";
  Types["PREFIXOP"] = "prefixop";
  Types["POSTFIXOP"] = "postfixop";
  Types["APPL"] = "appl";
  Types["INTEGRAL"] = "integral";
  Types["BIGOP"] = "bigop";
  Types["SQRT"] = "sqrt";
  Types["ROOT"] = "root";
  Types["LIMUPPER"] = "limupper";
  Types["LIMLOWER"] = "limlower";
  Types["LIMBOTH"] = "limboth";
  Types["SUBSCRIPT"] = "subscript";
  Types["SUPERSCRIPT"] = "superscript";
  Types["UNDERSCORE"] = "underscore";
  Types["OVERSCORE"] = "overscore";
  Types["TENSOR"] = "tensor";
  Types["TABLE"] = "table";
  Types["MULTILINE"] = "multiline";
  Types["MATRIX"] = "matrix";
  Types["VECTOR"] = "vector";
  Types["CASES"] = "cases";
  Types["ROW"] = "row";
  Types["LINE"] = "line";
  Types["CELL"] = "cell";
  Types["ENCLOSE"] = "enclose";
  Types["INFERENCE"] = "inference";
  Types["RULELABEL"] = "rulelabel";
  Types["CONCLUSION"] = "conclusion";
  Types["PREMISES"] = "premises";
  Types["UNKNOWN"] = "unknown";
  Types["EMPTY"] = "empty";
})(Types || (Types = {}));
semantic_meaning.SemanticType = Object.assign({}, Types);
var Roles;
(function (Roles) {
  Roles["COMMA"] = "comma";
  Roles["SEMICOLON"] = "semicolon";
  Roles["ELLIPSIS"] = "ellipsis";
  Roles["FULLSTOP"] = "fullstop";
  Roles["QUESTION"] = "question";
  Roles["EXCLAMATION"] = "exclamation";
  Roles["QUOTES"] = "quotes";
  Roles["DASH"] = "dash";
  Roles["TILDE"] = "tilde";
  Roles["PRIME"] = "prime";
  Roles["DEGREE"] = "degree";
  Roles["VBAR"] = "vbar";
  Roles["COLON"] = "colon";
  Roles["OPENFENCE"] = "openfence";
  Roles["CLOSEFENCE"] = "closefence";
  Roles["APPLICATION"] = "application";
  Roles["DUMMY"] = "dummy";
  Roles["UNIT"] = "unit";
  Roles["LABEL"] = "label";
  Roles["OPEN"] = "open";
  Roles["CLOSE"] = "close";
  Roles["TOP"] = "top";
  Roles["BOTTOM"] = "bottom";
  Roles["NEUTRAL"] = "neutral";
  Roles["METRIC"] = "metric";
  Roles["LATINLETTER"] = "latinletter";
  Roles["GREEKLETTER"] = "greekletter";
  Roles["OTHERLETTER"] = "otherletter";
  Roles["NUMBERSET"] = "numbersetletter";
  Roles["INTEGER"] = "integer";
  Roles["FLOAT"] = "float";
  Roles["OTHERNUMBER"] = "othernumber";
  Roles["INFTY"] = "infty";
  Roles["MIXED"] = "mixed";
  Roles["MULTIACCENT"] = "multiaccent";
  Roles["OVERACCENT"] = "overaccent";
  Roles["UNDERACCENT"] = "underaccent";
  Roles["UNDEROVER"] = "underover";
  Roles["SUBSUP"] = "subsup";
  Roles["LEFTSUB"] = "leftsub";
  Roles["LEFTSUPER"] = "leftsuper";
  Roles["RIGHTSUB"] = "rightsub";
  Roles["RIGHTSUPER"] = "rightsuper";
  Roles["LEFTRIGHT"] = "leftright";
  Roles["ABOVEBELOW"] = "abovebelow";
  Roles["SETEMPTY"] = "set empty";
  Roles["SETEXT"] = "set extended";
  Roles["SETSINGLE"] = "set singleton";
  Roles["SETCOLLECT"] = "set collection";
  Roles["STRING"] = "string";
  Roles["SPACE"] = "space";
  Roles["ANNOTATION"] = "annotation";
  Roles["TEXT"] = "text";
  Roles["SEQUENCE"] = "sequence";
  Roles["ENDPUNCT"] = "endpunct";
  Roles["STARTPUNCT"] = "startpunct";
  Roles["NEGATIVE"] = "negative";
  Roles["POSITIVE"] = "positive";
  Roles["NEGATION"] = "negation";
  Roles["MULTIOP"] = "multiop";
  Roles["PREFIXOP"] = "prefix operator";
  Roles["POSTFIXOP"] = "postfix operator";
  Roles["LIMFUNC"] = "limit function";
  Roles["INFIXFUNC"] = "infix function";
  Roles["PREFIXFUNC"] = "prefix function";
  Roles["POSTFIXFUNC"] = "postfix function";
  Roles["SIMPLEFUNC"] = "simple function";
  Roles["COMPFUNC"] = "composed function";
  Roles["SUM"] = "sum";
  Roles["INTEGRAL"] = "integral";
  Roles["GEOMETRY"] = "geometry";
  Roles["BOX"] = "box";
  Roles["BLOCK"] = "block";
  Roles["ADDITION"] = "addition";
  Roles["MULTIPLICATION"] = "multiplication";
  Roles["SUBTRACTION"] = "subtraction";
  Roles["IMPLICIT"] = "implicit";
  Roles["DIVISION"] = "division";
  Roles["VULGAR"] = "vulgar";
  Roles["EQUALITY"] = "equality";
  Roles["INEQUALITY"] = "inequality";
  Roles["ARROW"] = "arrow";
  Roles["ELEMENT"] = "element";
  Roles["NONELEMENT"] = "nonelement";
  Roles["REELEMENT"] = "reelement";
  Roles["RENONELEMENT"] = "renonelement";
  Roles["SET"] = "set";
  Roles["DETERMINANT"] = "determinant";
  Roles["ROWVECTOR"] = "rowvector";
  Roles["BINOMIAL"] = "binomial";
  Roles["SQUAREMATRIX"] = "squarematrix";
  Roles["CYCLE"] = "cycle";
  Roles["MULTILINE"] = "multiline";
  Roles["MATRIX"] = "matrix";
  Roles["VECTOR"] = "vector";
  Roles["CASES"] = "cases";
  Roles["TABLE"] = "table";
  Roles["CAYLEY"] = "cayley";
  Roles["PROOF"] = "proof";
  Roles["LEFT"] = "left";
  Roles["RIGHT"] = "right";
  Roles["UP"] = "up";
  Roles["DOWN"] = "down";
  Roles["FINAL"] = "final";
  Roles["SINGLE"] = "single";
  Roles["HYP"] = "hyp";
  Roles["AXIOM"] = "axiom";
  Roles["LOGIC"] = "logic";
  Roles["UNKNOWN"] = "unknown";
  Roles["MGLYPH"] = "mglyph";
})(Roles || (Roles = {}));
semantic_meaning.SemanticRole = Object.assign({}, Roles);
var ExtraFont;
(function (ExtraFont) {
  ExtraFont["CALIGRAPHIC"] = "caligraphic";
  ExtraFont["CALIGRAPHICBOLD"] = "caligraphic-bold";
  ExtraFont["OLDSTYLE"] = "oldstyle";
  ExtraFont["OLDSTYLEBOLD"] = "oldstyle-bold";
  ExtraFont["UNKNOWN"] = "unknown";
})(ExtraFont || (ExtraFont = {}));
semantic_meaning.SemanticFont = Object.assign(Object.assign(Object.assign({}, Alphabet$1.Font), ExtraFont), Alphabet$1.Embellish);
var SecondaryEnum;
(function (SecondaryEnum) {
  SecondaryEnum["ALLLETTERS"] = "allLetters";
  SecondaryEnum["D"] = "d";
  SecondaryEnum["BAR"] = "bar";
  SecondaryEnum["TILDE"] = "tilde";
})(SecondaryEnum || (SecondaryEnum = {}));
semantic_meaning.SemanticSecondary = Object.assign(Object.assign({}, Alphabet$1.Base), SecondaryEnum);

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Combiners = void 0;
  exports.pluralCase = pluralCase;
  exports.identityTransformer = identityTransformer;
  exports.siCombiner = siCombiner;
  exports.convertVulgarFraction = convertVulgarFraction;
  exports.vulgarFractionSmall = vulgarFractionSmall;
  const semantic_meaning_js_1 = semantic_meaning;
  function pluralCase(num, _plural) {
    return num.toString();
  }
  function identityTransformer(input) {
    return input.toString();
  }
  function siCombiner(prefix, unit) {
    return prefix + unit.toLowerCase();
  }
  exports.Combiners = {};
  exports.Combiners.identityCombiner = function (a, b, c) {
    return a + b + c;
  };
  exports.Combiners.prefixCombiner = function (letter, font, cap) {
    letter = cap ? cap + ' ' + letter : letter;
    return font ? font + ' ' + letter : letter;
  };
  exports.Combiners.postfixCombiner = function (letter, font, cap) {
    letter = cap ? cap + ' ' + letter : letter;
    return font ? letter + ' ' + font : letter;
  };
  exports.Combiners.romanceCombiner = function (letter, font, cap) {
    letter = cap ? letter + ' ' + cap : letter;
    return font ? letter + ' ' + font : letter;
  };
  function convertVulgarFraction(node, over = '') {
    if (!node.childNodes || !node.childNodes[0] || !node.childNodes[0].childNodes || node.childNodes[0].childNodes.length < 2 || node.childNodes[0].childNodes[0].tagName !== semantic_meaning_js_1.SemanticType.NUMBER || node.childNodes[0].childNodes[0].getAttribute('role') !== semantic_meaning_js_1.SemanticRole.INTEGER || node.childNodes[0].childNodes[1].tagName !== semantic_meaning_js_1.SemanticType.NUMBER || node.childNodes[0].childNodes[1].getAttribute('role') !== semantic_meaning_js_1.SemanticRole.INTEGER) {
      return {
        convertible: false,
        content: node.textContent
      };
    }
    const denStr = node.childNodes[0].childNodes[1].textContent;
    const enumStr = node.childNodes[0].childNodes[0].textContent;
    const denominator = Number(denStr);
    const enumerator = Number(enumStr);
    if (isNaN(denominator) || isNaN(enumerator)) {
      return {
        convertible: false,
        content: `${enumStr} ${over} ${denStr}`
      };
    }
    return {
      convertible: true,
      enumerator: enumerator,
      denominator: denominator
    };
  }
  function vulgarFractionSmall(node, enumer, denom) {
    const conversion = convertVulgarFraction(node);
    if (conversion.convertible) {
      const enumerator = conversion.enumerator;
      const denominator = conversion.denominator;
      return enumerator > 0 && enumerator < enumer && denominator > 0 && denominator < denom;
    }
    return false;
  }
})(transformers);
getDefaultExportFromCjs(transformers);

Object.defineProperty(messages, "__esModule", {
  value: true
});
messages.MESSAGES = MESSAGES;
messages.NUMBERS = NUMBERS;
messages.ALPHABETS = ALPHABETS;
messages.FUNCTIONS = FUNCTIONS;
messages.SUBISO = SUBISO;
const tr$7 = transformers;
function MESSAGES() {
  return {
    MS: {},
    MSroots: {},
    font: {},
    embellish: {},
    role: {},
    enclose: {},
    navigate: {},
    regexp: {},
    unitTimes: ''
  };
}
function NUMBERS(numbers = {}) {
  return Object.assign({
    zero: 'zero',
    ones: [],
    tens: [],
    large: [],
    special: {},
    wordOrdinal: tr$7.identityTransformer,
    numericOrdinal: tr$7.identityTransformer,
    numberToWords: tr$7.identityTransformer,
    numberToOrdinal: tr$7.pluralCase,
    vulgarSep: ' ',
    numSep: ' '
  }, numbers);
}
function ALPHABETS() {
  return {
    latinSmall: [],
    latinCap: [],
    greekSmall: [],
    greekCap: [],
    capPrefix: {
      default: ''
    },
    smallPrefix: {
      default: ''
    },
    digitPrefix: {
      default: ''
    },
    languagePrefix: {},
    digitTrans: {
      default: tr$7.identityTransformer,
      mathspeak: tr$7.identityTransformer,
      clearspeak: tr$7.identityTransformer
    },
    letterTrans: {
      default: tr$7.identityTransformer
    },
    combiner: (letter, _font, _cap) => {
      return letter;
    }
  };
}
function FUNCTIONS() {
  return {
    fracNestDepth: n => tr$7.vulgarFractionSmall(n, 10, 100),
    radicalNestDepth: _count => '',
    combineRootIndex: function (postfix, _index) {
      return postfix;
    },
    combineNestedFraction: tr$7.Combiners.identityCombiner,
    combineNestedRadical: tr$7.Combiners.identityCombiner,
    fontRegexp: function (font) {
      return new RegExp('^' + font.split(/ |-/).join('( |-)') + '( |-)');
    },
    si: tr$7.siCombiner,
    plural: tr$7.identityTransformer
  };
}
function SUBISO() {
  return {
    default: '',
    current: '',
    all: []
  };
}

Object.defineProperty(locale$f, "__esModule", {
  value: true
});
locale$f.LOCALE = void 0;
locale$f.createLocale = createLocale;
const messages_js_1 = messages;
locale$f.LOCALE = createLocale();
function createLocale() {
  return {
    FUNCTIONS: (0, messages_js_1.FUNCTIONS)(),
    MESSAGES: (0, messages_js_1.MESSAGES)(),
    ALPHABETS: (0, messages_js_1.ALPHABETS)(),
    NUMBERS: (0, messages_js_1.NUMBERS)(),
    COMBINERS: {},
    CORRECTIONS: {},
    SUBISO: (0, messages_js_1.SUBISO)()
  };
}

Object.defineProperty(locale_util, "__esModule", {
  value: true
});
locale_util.nestingToString = nestingToString;
locale_util.combinePostfixIndex = combinePostfixIndex;
locale_util.localFont = localFont;
locale_util.localRole = localRole;
locale_util.localEnclose = localEnclose;
locale_util.localeFontCombiner = localeFontCombiner;
const locale_js_1$q = locale$f;
const transformers_js_1$8 = transformers;
function nestingToString(count) {
  switch (count) {
    case 1:
      return locale_js_1$q.LOCALE.MESSAGES.MS.ONCE || '';
    case 2:
      return locale_js_1$q.LOCALE.MESSAGES.MS.TWICE;
    default:
      return count.toString();
  }
}
function combinePostfixIndex(postfix, index) {
  return postfix === locale_js_1$q.LOCALE.MESSAGES.MS.ROOTINDEX || postfix === locale_js_1$q.LOCALE.MESSAGES.MS.INDEX ? postfix : postfix + ' ' + index;
}
function localFont(font) {
  return extractString(locale_js_1$q.LOCALE.MESSAGES.font[font], font);
}
function localRole(role) {
  return extractString(locale_js_1$q.LOCALE.MESSAGES.role[role], role);
}
function localEnclose(enclose) {
  return extractString(locale_js_1$q.LOCALE.MESSAGES.enclose[enclose], enclose);
}
function extractString(combiner, fallback) {
  if (combiner === undefined) {
    return fallback;
  }
  return typeof combiner === 'string' ? combiner : combiner[0];
}
function localeFontCombiner(font) {
  return typeof font === 'string' ? {
    font: font,
    combiner: locale_js_1$q.LOCALE.ALPHABETS.combiner
  } : {
    font: font[0],
    combiner: locale_js_1$q.LOCALE.COMBINERS[font[1]] || transformers_js_1$8.Combiners[font[1]] || locale_js_1$q.LOCALE.ALPHABETS.combiner
  };
}

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Grammar = exports.ATTRIBUTE = void 0;
  exports.correctFont = correctFont;
  const DomUtil = dom_util;
  const engine_js_1 = engine;
  const LocaleUtil = locale_util;
  const locale_js_1 = locale$f;
  exports.ATTRIBUTE = 'grammar';
  class Grammar {
    static getInstance() {
      Grammar.instance = Grammar.instance || new Grammar();
      return Grammar.instance;
    }
    static parseInput(grammar) {
      const attributes = {};
      const components = grammar.split(':');
      for (const component of components) {
        const comp = component.split('=');
        const key = comp[0].trim();
        if (comp[1]) {
          attributes[key] = comp[1].trim();
          continue;
        }
        key.match(/^!/) ? attributes[key.slice(1)] = false : attributes[key] = true;
      }
      return attributes;
    }
    static parseState(stateStr) {
      const state = {};
      const corrections = stateStr.split(' ');
      for (const correction of corrections) {
        const corr = correction.split(':');
        const key = corr[0];
        const value = corr[1];
        state[key] = value ? value : true;
      }
      return state;
    }
    static translateString(text) {
      if (text.match(/:unit$/)) {
        return Grammar.translateUnit(text);
      }
      const engine = engine_js_1.Engine.getInstance();
      let result = engine.evaluator(text, engine.dynamicCstr);
      result = result === null ? text : result;
      if (Grammar.getInstance().getParameter('plural')) {
        result = locale_js_1.LOCALE.FUNCTIONS.plural(result);
      }
      return result;
    }
    static translateUnit(text) {
      text = Grammar.prepareUnit(text);
      const engine = engine_js_1.Engine.getInstance();
      const plural = Grammar.getInstance().getParameter('plural');
      const strict = engine.strict;
      const baseCstr = `${engine.locale}.${engine.modality}.default`;
      engine.strict = true;
      let cstr;
      let result;
      if (plural) {
        cstr = engine.defaultParser.parse(baseCstr + '.plural');
        result = engine.evaluator(text, cstr);
      }
      if (result) {
        engine.strict = strict;
        return result;
      }
      cstr = engine.defaultParser.parse(baseCstr + '.default');
      result = engine.evaluator(text, cstr);
      engine.strict = strict;
      if (!result) {
        return Grammar.cleanUnit(text);
      }
      if (plural) {
        result = locale_js_1.LOCALE.FUNCTIONS.plural(result);
      }
      return result;
    }
    static prepareUnit(text) {
      const match = text.match(/:unit$/);
      return match ? text.slice(0, match.index).replace(/\s+/g, ' ') + text.slice(match.index) : text;
    }
    static cleanUnit(text) {
      if (text.match(/:unit$/)) {
        return text.replace(/:unit$/, '');
      }
      return text;
    }
    clear() {
      this.parameters_ = {};
      this.stateStack_ = [];
    }
    setParameter(parameter, value) {
      const oldValue = this.parameters_[parameter];
      value ? this.parameters_[parameter] = value : delete this.parameters_[parameter];
      return oldValue;
    }
    getParameter(parameter) {
      return this.parameters_[parameter];
    }
    setCorrection(correction, func) {
      this.corrections_[correction] = func;
    }
    setPreprocessor(preprocessor, func) {
      this.preprocessors_[preprocessor] = func;
    }
    getCorrection(correction) {
      return this.corrections_[correction];
    }
    getState() {
      const pairs = [];
      for (const [key, val] of Object.entries(this.parameters_)) {
        pairs.push(typeof val === 'string' ? key + ':' + val : key);
      }
      return pairs.join(' ');
    }
    processSingles() {
      const assignment = {};
      for (const single of this.singles) {
        assignment[single] = false;
      }
      this.singles = [];
      this.pushState(assignment);
    }
    pushState(assignment) {
      for (let [key, value] of Object.entries(assignment)) {
        if (key.match(/^\?/)) {
          delete assignment[key];
          key = key.slice(1);
          this.singles.push(key);
        }
        assignment[key] = this.setParameter(key, value);
      }
      this.stateStack_.push(assignment);
    }
    popState() {
      const assignment = this.stateStack_.pop();
      for (const [key, val] of Object.entries(assignment)) {
        this.setParameter(key, val);
      }
    }
    setAttribute(node) {
      if (node && node.nodeType === DomUtil.NodeType.ELEMENT_NODE) {
        const state = this.getState();
        if (state) {
          node.setAttribute(exports.ATTRIBUTE, state);
        }
      }
    }
    preprocess(text) {
      return this.runProcessors(text, this.preprocessors_);
    }
    correct(text) {
      return this.runProcessors(text, this.corrections_);
    }
    apply(text, opt_flags) {
      this.currentFlags = opt_flags || ({});
      text = this.currentFlags.adjust || this.currentFlags.preprocess ? Grammar.getInstance().preprocess(text) : text;
      if (this.parameters_['translate'] || this.currentFlags.translate) {
        text = Grammar.translateString(text);
      }
      text = this.currentFlags.adjust || this.currentFlags.correct ? Grammar.getInstance().correct(text) : text;
      this.currentFlags = {};
      return text;
    }
    runProcessors(text, funcs) {
      for (const [key, val] of Object.entries(this.parameters_)) {
        const func = funcs[key];
        if (!func) {
          continue;
        }
        text = val === true ? func(text) : func(text, val);
      }
      return text;
    }
    constructor() {
      this.currentFlags = {};
      this.parameters_ = {};
      this.corrections_ = {};
      this.preprocessors_ = {};
      this.stateStack_ = [];
      this.singles = [];
    }
  }
  exports.Grammar = Grammar;
  function correctFont(text, correction) {
    if (!correction || !text) {
      return text;
    }
    const regexp = locale_js_1.LOCALE.FUNCTIONS.fontRegexp(LocaleUtil.localFont(correction));
    return text.replace(regexp, '');
  }
  function correctCaps(text) {
    let cap = locale_js_1.LOCALE.ALPHABETS.capPrefix[engine_js_1.Engine.getInstance().domain];
    if (typeof cap === 'undefined') {
      cap = locale_js_1.LOCALE.ALPHABETS.capPrefix['default'];
    }
    return correctFont(text, cap);
  }
  function addAnnotation(text, annotation) {
    return text + ':' + annotation;
  }
  function numbersToAlpha(text) {
    return text.match(/\d+/) ? locale_js_1.LOCALE.NUMBERS.numberToWords(parseInt(text, 10)) : text;
  }
  function noTranslateText(text) {
    if (text.match(new RegExp('^[' + locale_js_1.LOCALE.MESSAGES.regexp.TEXT + ']+$'))) {
      Grammar.getInstance().currentFlags['translate'] = false;
    }
    return text;
  }
  Grammar.getInstance().setCorrection('localFont', LocaleUtil.localFont);
  Grammar.getInstance().setCorrection('localRole', LocaleUtil.localRole);
  Grammar.getInstance().setCorrection('localEnclose', LocaleUtil.localEnclose);
  Grammar.getInstance().setCorrection('ignoreFont', correctFont);
  Grammar.getInstance().setPreprocessor('annotation', addAnnotation);
  Grammar.getInstance().setPreprocessor('noTranslateText', noTranslateText);
  Grammar.getInstance().setCorrection('ignoreCaps', correctCaps);
  Grammar.getInstance().setPreprocessor('numbers2alpha', numbersToAlpha);
})(grammar);
getDefaultExportFromCjs(grammar);

var locale_af = {};

var numbers_af = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const messages_js_1 = messages;
  function hundredsToWords_(num) {
    let n = num % 1000;
    let str = '';
    let ones = exports.NUMBERS.ones[Math.floor(n / 100)];
    str += ones ? ones + exports.NUMBERS.numSep + 'honderd' : '';
    n = n % 100;
    if (n) {
      str += str ? exports.NUMBERS.numSep : '';
      ones = exports.NUMBERS.ones[n];
      if (ones) {
        str += ones;
      } else {
        const tens = exports.NUMBERS.tens[Math.floor(n / 10)];
        ones = exports.NUMBERS.ones[n % 10];
        str += ones ? ones + '-en-' + tens : tens;
      }
    }
    return str;
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        const hund = hundredsToWords_(num % 1000);
        if (pos) {
          const large = exports.NUMBERS.large[pos];
          str = hund + exports.NUMBERS.numSep + large + (str ? exports.NUMBERS.numSep + str : '');
        } else {
          str = hund + (str ? exports.NUMBERS.numSep + str : '');
        }
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str;
  }
  function numberToOrdinal(num, plural) {
    if (num === 1) {
      return 'enkel';
    }
    if (num === 2) {
      return plural ? 'helftes' : 'helfte';
    }
    if (num === 4) {
      return plural ? 'kwarte' : 'kwart';
    }
    return wordOrdinal(num) + (plural ? 's' : '');
  }
  function wordOrdinal(num) {
    if (num === 1) {
      return 'eerste';
    }
    if (num === 3) {
      return 'derde';
    }
    if (num === 8) {
      return 'agste';
    }
    if (num === 9) {
      return 'negende';
    }
    const ordinal = numberToWords(num);
    return ordinal + (num < 19 ? 'de' : 'ste');
  }
  function numericOrdinal(num) {
    return num.toString() + '.';
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_af);
getDefaultExportFromCjs(numbers_af);

Object.defineProperty(locale_af, "__esModule", {
  value: true
});
locale_af.af = af;
const grammar_js_1$a = grammar;
const locale_util_js_1$d = locale_util;
const locale_js_1$p = locale$f;
const numbers_af_js_1 = numbers_af;
const tr$6 = transformers;
const germanPostfixCombiner$1 = function (letter, font, cap) {
  letter = !cap ? letter : cap + ' ' + letter;
  return font ? letter + ' ' + font : letter;
};
let locale$e = null;
function af() {
  if (!locale$e) {
    locale$e = create$d();
  }
  return locale$e;
}
function create$d() {
  const loc = (0, locale_js_1$p.createLocale)();
  loc.NUMBERS = numbers_af_js_1.NUMBERS;
  loc.COMBINERS['germanPostfix'] = germanPostfixCombiner$1;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$d.nestingToString;
  loc.FUNCTIONS.plural = unit => {
    return (/.*s$/).test(unit) ? unit : unit + 's';
  };
  loc.FUNCTIONS.fontRegexp = function (font) {
    return new RegExp('((^' + font + ' )|( ' + font + '$))');
  };
  loc.ALPHABETS.combiner = tr$6.Combiners.prefixCombiner;
  loc.ALPHABETS.digitTrans.default = numbers_af_js_1.NUMBERS.numberToWords;
  loc.CORRECTIONS.article = name => {
    return grammar_js_1$a.Grammar.getInstance().getParameter('noArticle') ? '' : name;
  };
  return loc;
}

var locale_ca = {};

var numbers_ca = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const grammar_js_1 = grammar;
  const messages_js_1 = messages;
  function tensToWords_(num) {
    const n = num % 100;
    if (n < 20) {
      return exports.NUMBERS.ones[n];
    }
    const ten = Math.floor(n / 10);
    const tens = exports.NUMBERS.tens[ten];
    const ones = exports.NUMBERS.ones[n % 10];
    return tens && ones ? tens + (ten === 2 ? '-i-' : '-') + ones : tens || ones;
  }
  function hundredsToWords_(num) {
    const n = num % 1000;
    const hundred = Math.floor(n / 100);
    const hundreds = hundred ? hundred === 1 ? 'cent' : exports.NUMBERS.ones[hundred] + '-cents' : '';
    const tens = tensToWords_(n % 100);
    return hundreds && tens ? hundreds + exports.NUMBERS.numSep + tens : hundreds || tens;
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % (pos > 1 ? 1000000 : 1000);
      if (hundreds) {
        let large = exports.NUMBERS.large[pos];
        if (!pos) {
          str = hundredsToWords_(hundreds);
        } else if (pos === 1) {
          str = (hundreds === 1 ? '' : hundredsToWords_(hundreds) + exports.NUMBERS.numSep) + large + (str ? exports.NUMBERS.numSep + str : '');
        } else {
          const thousands = numberToWords(hundreds);
          large = hundreds === 1 ? large : large.replace(/\u00f3$/, 'ons');
          str = thousands + exports.NUMBERS.numSep + large + (str ? exports.NUMBERS.numSep + str : '');
        }
      }
      num = Math.floor(num / (pos > 1 ? 1000000 : 1000));
      pos++;
    }
    return str;
  }
  function numberToOrdinal(num, _plural) {
    if (num > 1999) {
      return numericOrdinal(num);
    }
    if (num <= 10) {
      return exports.NUMBERS.special.onesOrdinals[num - 1];
    }
    const result = numberToWords(num);
    if (result.match(/mil$/)) {
      return result.replace(/mil$/, 'mil·lèsima');
    }
    if (result.match(/u$/)) {
      return result.replace(/u$/, 'vena');
    }
    if (result.match(/a$/)) {
      return result.replace(/a$/, 'ena');
    }
    return result + (result.match(/e$/) ? 'na' : 'ena');
  }
  function numericOrdinal(num) {
    const gender = grammar_js_1.Grammar.getInstance().getParameter('gender');
    return num.toString() + (gender === 'f' ? 'a' : 'n');
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_ca);
getDefaultExportFromCjs(numbers_ca);

Object.defineProperty(locale_ca, "__esModule", {
  value: true
});
locale_ca.ca = ca;
const locale_js_1$o = locale$f;
const locale_util_js_1$c = locale_util;
const numbers_ca_js_1 = numbers_ca;
const transformers_js_1$7 = transformers;
const sansserifCombiner$1 = function (letter, font, cap) {
  letter = 'sans serif ' + (cap ? cap + ' ' + letter : letter);
  return font ? letter + ' ' + font : letter;
};
let locale$d = null;
function ca() {
  if (!locale$d) {
    locale$d = create$c();
  }
  return locale$d;
}
function create$c() {
  const loc = (0, locale_js_1$o.createLocale)();
  loc.NUMBERS = numbers_ca_js_1.NUMBERS;
  loc.COMBINERS['sansserif'] = sansserifCombiner$1;
  loc.FUNCTIONS.fracNestDepth = _node => false;
  loc.FUNCTIONS.combineRootIndex = locale_util_js_1$c.combinePostfixIndex;
  loc.FUNCTIONS.combineNestedRadical = (a, _b, c) => a + c;
  loc.FUNCTIONS.fontRegexp = font => RegExp('^' + font + ' ');
  loc.FUNCTIONS.plural = unit => {
    if ((/.*os$/).test(unit)) {
      return unit + 'sos';
    }
    if ((/.*s$/).test(unit)) {
      return unit + 'os';
    }
    if ((/.*ga$/).test(unit)) {
      return unit.slice(0, -2) + 'gues';
    }
    if ((/.*ça$/).test(unit)) {
      return unit.slice(0, -2) + 'ces';
    }
    if ((/.*ca$/).test(unit)) {
      return unit.slice(0, -2) + 'ques';
    }
    if ((/.*ja$/).test(unit)) {
      return unit.slice(0, -2) + 'ges';
    }
    if ((/.*qua$/).test(unit)) {
      return unit.slice(0, -3) + 'qües';
    }
    if ((/.*a$/).test(unit)) {
      return unit.slice(0, -1) + 'es';
    }
    if ((/.*(e|i)$/).test(unit)) {
      return unit + 'ns';
    }
    if ((/.*í$/).test(unit)) {
      return unit.slice(0, -1) + 'ins';
    }
    return unit + 's';
  };
  loc.FUNCTIONS.si = (prefix, unit) => {
    if (unit.match(/^metre/)) {
      prefix = prefix.replace(/a$/, 'à').replace(/o$/, 'ò').replace(/i$/, 'í');
    }
    return prefix + unit;
  };
  loc.ALPHABETS.combiner = transformers_js_1$7.Combiners.prefixCombiner;
  return loc;
}

var locale_da = {};

var numbers_da = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const messages_js_1 = messages;
  function onePrefix_(num, mill = false) {
    return num === exports.NUMBERS.ones[1] ? mill ? 'et' : 'en' : num;
  }
  function hundredsToWords_(num, ordinal = false) {
    let n = num % 1000;
    let str = '';
    let ones = exports.NUMBERS.ones[Math.floor(n / 100)];
    str += ones ? onePrefix_(ones, true) + ' hundrede' : '';
    n = n % 100;
    if (n) {
      str += str ? ' og ' : '';
      ones = ordinal ? exports.NUMBERS.special.smallOrdinals[n] : exports.NUMBERS.ones[n];
      if (ones) {
        str += ones;
      } else {
        const tens = ordinal ? exports.NUMBERS.special.tensOrdinals[Math.floor(n / 10)] : exports.NUMBERS.tens[Math.floor(n / 10)];
        ones = exports.NUMBERS.ones[n % 10];
        str += ones ? onePrefix_(ones) + 'og' + tens : tens;
      }
    }
    return str;
  }
  function numberToWords(num, ordinal = false) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        const hund = hundredsToWords_(hundreds, ordinal && !pos);
        if (pos) {
          const large = exports.NUMBERS.large[pos];
          const plural = hundreds > 1 ? 'er' : '';
          str = onePrefix_(hund, pos <= 1) + ' ' + large + plural + (str ? ' og ' : '') + str;
        } else {
          str = onePrefix_(hund) + str;
        }
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str;
  }
  function numberToOrdinal(num, plural) {
    if (num === 1) {
      return plural ? 'hel' : 'hele';
    }
    if (num === 2) {
      return plural ? 'halv' : 'halve';
    }
    return wordOrdinal(num) + (plural ? 'dele' : 'del');
  }
  function wordOrdinal(num) {
    if (num % 100) {
      return numberToWords(num, true);
    }
    const ordinal = numberToWords(num);
    return ordinal.match(/e$/) ? ordinal : ordinal + 'e';
  }
  function numericOrdinal(num) {
    return num.toString() + '.';
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_da);
getDefaultExportFromCjs(numbers_da);

Object.defineProperty(locale_da, "__esModule", {
  value: true
});
locale_da.da = da;
const locale_js_1$n = locale$f;
const locale_util_js_1$b = locale_util;
const numbers_da_js_1 = numbers_da;
const tr$5 = transformers;
let locale$c = null;
function da() {
  if (!locale$c) {
    locale$c = create$b();
  }
  return locale$c;
}
function create$b() {
  const loc = (0, locale_js_1$n.createLocale)();
  loc.NUMBERS = numbers_da_js_1.NUMBERS;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$b.nestingToString;
  loc.FUNCTIONS.fontRegexp = font => {
    return font === loc.ALPHABETS.capPrefix['default'] ? RegExp('^' + font + ' ') : RegExp(' ' + font + '$');
  };
  loc.ALPHABETS.combiner = tr$5.Combiners.postfixCombiner;
  loc.ALPHABETS.digitTrans.default = numbers_da_js_1.NUMBERS.numberToWords;
  return loc;
}

var locale_de = {};

var numbers_de = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const messages_js_1 = messages;
  function onePrefix_(num, mill = false) {
    return num === exports.NUMBERS.ones[1] ? mill ? 'eine' : 'ein' : num;
  }
  function hundredsToWords_(num) {
    let n = num % 1000;
    let str = '';
    let ones = exports.NUMBERS.ones[Math.floor(n / 100)];
    str += ones ? onePrefix_(ones) + 'hundert' : '';
    n = n % 100;
    if (n) {
      str += str ? exports.NUMBERS.numSep : '';
      ones = exports.NUMBERS.ones[n];
      if (ones) {
        str += ones;
      } else {
        const tens = exports.NUMBERS.tens[Math.floor(n / 10)];
        ones = exports.NUMBERS.ones[n % 10];
        str += ones ? onePrefix_(ones) + 'und' + tens : tens;
      }
    }
    return str;
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        const hund = hundredsToWords_(num % 1000);
        if (pos) {
          const large = exports.NUMBERS.large[pos];
          const plural = pos > 1 && hundreds > 1 ? large.match(/e$/) ? 'n' : 'en' : '';
          str = onePrefix_(hund, pos > 1) + large + plural + str;
        } else {
          str = onePrefix_(hund, pos > 1) + str;
        }
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str.replace(/ein$/, 'eins');
  }
  function numberToOrdinal(num, plural) {
    if (num === 1) {
      return 'eintel';
    }
    if (num === 2) {
      return plural ? 'halbe' : 'halb';
    }
    return wordOrdinal(num) + 'l';
  }
  function wordOrdinal(num) {
    if (num === 1) {
      return 'erste';
    }
    if (num === 3) {
      return 'dritte';
    }
    if (num === 7) {
      return 'siebte';
    }
    if (num === 8) {
      return 'achte';
    }
    const ordinal = numberToWords(num);
    return ordinal + (num < 19 ? 'te' : 'ste');
  }
  function numericOrdinal(num) {
    return num.toString() + '.';
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_de);
getDefaultExportFromCjs(numbers_de);

Object.defineProperty(locale_de, "__esModule", {
  value: true
});
locale_de.de = de;
const grammar_js_1$9 = grammar;
const locale_util_js_1$a = locale_util;
const locale_js_1$m = locale$f;
const numbers_de_js_1 = numbers_de;
const germanPrefixCombiner = function (letter, font, cap) {
  if (cap === 's') {
    font = font.split(' ').map(function (x) {
      return x.replace(/s$/, '');
    }).join(' ');
    cap = '';
  }
  letter = cap ? cap + ' ' + letter : letter;
  return font ? font + ' ' + letter : letter;
};
const germanPostfixCombiner = function (letter, font, cap) {
  letter = !cap || cap === 's' ? letter : cap + ' ' + letter;
  return font ? letter + ' ' + font : letter;
};
let locale$b = null;
function de() {
  if (!locale$b) {
    locale$b = create$a();
  }
  return locale$b;
}
function create$a() {
  const loc = (0, locale_js_1$m.createLocale)();
  loc.NUMBERS = numbers_de_js_1.NUMBERS;
  loc.COMBINERS['germanPostfix'] = germanPostfixCombiner;
  loc.ALPHABETS.combiner = germanPrefixCombiner;
  loc.FUNCTIONS.radicalNestDepth = x => {
    return x > 1 ? loc.NUMBERS.numberToWords(x) + 'fach' : '';
  };
  loc.FUNCTIONS.combineRootIndex = (postfix, index) => {
    const root = index ? index + 'wurzel' : '';
    return postfix.replace('Wurzel', root);
  };
  loc.FUNCTIONS.combineNestedRadical = (a, b, c) => {
    a = c.match(/exponent$/) ? a + 'r' : a;
    const count = (b ? b + ' ' : '') + a;
    return c.match(/ /) ? c.replace(/ /, ' ' + count + ' ') : count + ' ' + c;
  };
  loc.FUNCTIONS.fontRegexp = function (font) {
    font = font.split(' ').map(function (x) {
      return x.replace(/s$/, '(|s)');
    }).join(' ');
    return new RegExp('((^' + font + ' )|( ' + font + '$))');
  };
  loc.CORRECTIONS.correctOne = num => num.replace(/^eins$/, 'ein');
  loc.CORRECTIONS.localFontNumber = font => {
    const realFont = (0, locale_util_js_1$a.localFont)(font);
    return realFont.split(' ').map(function (x) {
      return x.replace(/s$/, '');
    }).join(' ');
  };
  loc.CORRECTIONS.lowercase = name => name.toLowerCase();
  loc.CORRECTIONS.article = name => {
    const decl = grammar_js_1$9.Grammar.getInstance().getParameter('case');
    const plural = grammar_js_1$9.Grammar.getInstance().getParameter('plural');
    if (decl === 'dative') {
      return ({
        der: 'dem',
        die: plural ? 'den' : 'der',
        das: 'dem'
      })[name];
    }
    return name;
  };
  loc.CORRECTIONS.masculine = name => {
    const decl = grammar_js_1$9.Grammar.getInstance().getParameter('case');
    if (decl === 'dative') {
      return name + 'n';
    }
    return name;
  };
  return loc;
}

var locale_en = {};

var numbers_en = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const messages_js_1 = messages;
  function hundredsToWords_(num) {
    let n = num % 1000;
    let str = '';
    str += exports.NUMBERS.ones[Math.floor(n / 100)] ? exports.NUMBERS.ones[Math.floor(n / 100)] + exports.NUMBERS.numSep + 'hundred' : '';
    n = n % 100;
    if (n) {
      str += str ? exports.NUMBERS.numSep : '';
      str += exports.NUMBERS.ones[n] || exports.NUMBERS.tens[Math.floor(n / 10)] + (n % 10 ? exports.NUMBERS.numSep + exports.NUMBERS.ones[n % 10] : '');
    }
    return str;
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        str = hundredsToWords_(num % 1000) + (pos ? '-' + exports.NUMBERS.large[pos] + '-' : '') + str;
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str.replace(/-$/, '');
  }
  function numberToOrdinal(num, plural) {
    if (num === 1) {
      return plural ? 'oneths' : 'oneth';
    }
    if (num === 2) {
      return plural ? 'halves' : 'half';
    }
    const ordinal = wordOrdinal(num);
    return plural ? ordinal + 's' : ordinal;
  }
  function wordOrdinal(num) {
    let ordinal = numberToWords(num);
    if (ordinal.match(/one$/)) {
      ordinal = ordinal.slice(0, -3) + 'first';
    } else if (ordinal.match(/two$/)) {
      ordinal = ordinal.slice(0, -3) + 'second';
    } else if (ordinal.match(/three$/)) {
      ordinal = ordinal.slice(0, -5) + 'third';
    } else if (ordinal.match(/five$/)) {
      ordinal = ordinal.slice(0, -4) + 'fifth';
    } else if (ordinal.match(/eight$/)) {
      ordinal = ordinal.slice(0, -5) + 'eighth';
    } else if (ordinal.match(/nine$/)) {
      ordinal = ordinal.slice(0, -4) + 'ninth';
    } else if (ordinal.match(/twelve$/)) {
      ordinal = ordinal.slice(0, -6) + 'twelfth';
    } else if (ordinal.match(/ty$/)) {
      ordinal = ordinal.slice(0, -2) + 'tieth';
    } else {
      ordinal = ordinal + 'th';
    }
    return ordinal;
  }
  function numericOrdinal(num) {
    const tens = num % 100;
    const numStr = num.toString();
    if (tens > 10 && tens < 20) {
      return numStr + 'th';
    }
    switch (num % 10) {
      case 1:
        return numStr + 'st';
      case 2:
        return numStr + 'nd';
      case 3:
        return numStr + 'rd';
      default:
        return numStr + 'th';
    }
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_en);
getDefaultExportFromCjs(numbers_en);

Object.defineProperty(locale_en, "__esModule", {
  value: true
});
locale_en.en = en;
const grammar_js_1$8 = grammar;
const locale_js_1$l = locale$f;
const locale_util_js_1$9 = locale_util;
const numbers_en_js_1 = numbers_en;
const tr$4 = transformers;
let locale$a = null;
function en() {
  if (!locale$a) {
    locale$a = create$9();
  }
  return locale$a;
}
function create$9() {
  const loc = (0, locale_js_1$l.createLocale)();
  loc.NUMBERS = numbers_en_js_1.NUMBERS;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$9.nestingToString;
  loc.FUNCTIONS.plural = unit => {
    return (/.*s$/).test(unit) ? unit : unit + 's';
  };
  loc.ALPHABETS.combiner = tr$4.Combiners.prefixCombiner;
  loc.ALPHABETS.digitTrans.default = numbers_en_js_1.NUMBERS.numberToWords;
  loc.CORRECTIONS.article = name => {
    return grammar_js_1$8.Grammar.getInstance().getParameter('noArticle') ? '' : name;
  };
  return loc;
}

var locale_es = {};

var numbers_es = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const grammar_js_1 = grammar;
  const messages_js_1 = messages;
  function tensToWords_(num) {
    const n = num % 100;
    if (n < 30) {
      return exports.NUMBERS.ones[n];
    }
    const tens = exports.NUMBERS.tens[Math.floor(n / 10)];
    const ones = exports.NUMBERS.ones[n % 10];
    return tens && ones ? tens + ' y ' + ones : tens || ones;
  }
  function hundredsToWords_(num) {
    const n = num % 1000;
    const hundred = Math.floor(n / 100);
    const hundreds = exports.NUMBERS.special.hundreds[hundred];
    const tens = tensToWords_(n % 100);
    if (hundred === 1) {
      if (!tens) {
        return hundreds;
      }
      return hundreds + 'to' + ' ' + tens;
    }
    return hundreds && tens ? hundreds + ' ' + tens : hundreds || tens;
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        let large = exports.NUMBERS.large[pos];
        const huns = hundredsToWords_(hundreds);
        if (!pos) {
          str = huns;
        } else if (hundreds === 1) {
          large = large.match('/^mil( |$)/') ? large : 'un ' + large;
          str = large + (str ? ' ' + str : '');
        } else {
          large = large.replace(/\u00f3n$/, 'ones');
          str = hundredsToWords_(hundreds) + ' ' + large + (str ? ' ' + str : '');
        }
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str;
  }
  function numberToOrdinal(num, _plural) {
    if (num > 1999) {
      return num.toString() + 'a';
    }
    if (num <= 12) {
      return exports.NUMBERS.special.onesOrdinals[num - 1];
    }
    const result = [];
    if (num >= 1000) {
      num = num - 1000;
      result.push('milésima');
    }
    if (!num) {
      return result.join(' ');
    }
    let pos = 0;
    pos = Math.floor(num / 100);
    if (pos > 0) {
      result.push(exports.NUMBERS.special.hundredsOrdinals[pos - 1]);
      num = num % 100;
    }
    if (num <= 12) {
      result.push(exports.NUMBERS.special.onesOrdinals[num - 1]);
    } else {
      pos = Math.floor(num / 10);
      if (pos > 0) {
        result.push(exports.NUMBERS.special.tensOrdinals[pos - 1]);
        num = num % 10;
      }
      if (num > 0) {
        result.push(exports.NUMBERS.special.onesOrdinals[num - 1]);
      }
    }
    return result.join(' ');
  }
  function numericOrdinal(num) {
    const gender = grammar_js_1.Grammar.getInstance().getParameter('gender');
    return num.toString() + (gender === 'f' ? 'a' : 'o');
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_es);
getDefaultExportFromCjs(numbers_es);

Object.defineProperty(locale_es, "__esModule", {
  value: true
});
locale_es.es = es;
const locale_js_1$k = locale$f;
const locale_util_js_1$8 = locale_util;
const numbers_es_js_1 = numbers_es;
const transformers_js_1$6 = transformers;
const sansserifCombiner = function (letter, font, cap) {
  letter = 'sans serif ' + (cap ? cap + ' ' + letter : letter);
  return font ? letter + ' ' + font : letter;
};
let locale$9 = null;
function es() {
  if (!locale$9) {
    locale$9 = create$8();
  }
  return locale$9;
}
function create$8() {
  const loc = (0, locale_js_1$k.createLocale)();
  loc.NUMBERS = numbers_es_js_1.NUMBERS;
  loc.COMBINERS['sansserif'] = sansserifCombiner;
  loc.FUNCTIONS.fracNestDepth = _node => false;
  loc.FUNCTIONS.combineRootIndex = locale_util_js_1$8.combinePostfixIndex;
  loc.FUNCTIONS.combineNestedRadical = (a, _b, c) => a + c;
  loc.FUNCTIONS.fontRegexp = font => RegExp('^' + font + ' ');
  loc.FUNCTIONS.plural = unit => {
    if ((/.*(a|e|i|o|u)$/).test(unit)) {
      return unit + 's';
    }
    if ((/.*z$/).test(unit)) {
      return unit.slice(0, -1) + 'ces';
    }
    if ((/.*c$/).test(unit)) {
      return unit.slice(0, -1) + 'ques';
    }
    if ((/.*g$/).test(unit)) {
      return unit + 'ues';
    }
    if ((/.*\u00f3n$/).test(unit)) {
      return unit.slice(0, -2) + 'ones';
    }
    return unit + 'es';
  };
  loc.FUNCTIONS.si = (prefix, unit) => {
    if (unit.match(/^metro/)) {
      prefix = prefix.replace(/a$/, 'á').replace(/o$/, 'ó').replace(/i$/, 'í');
    }
    return prefix + unit;
  };
  loc.ALPHABETS.combiner = transformers_js_1$6.Combiners.prefixCombiner;
  return loc;
}

var locale_euro = {};

Object.defineProperty(locale_euro, "__esModule", {
  value: true
});
locale_euro.euro = euro;
const locale_js_1$j = locale$f;
let locale$8 = null;
function euro() {
  if (!locale$8) {
    locale$8 = (0, locale_js_1$j.createLocale)();
  }
  return locale$8;
}

var locale_fr = {};

var numbers_fr = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const engine_js_1 = engine;
  const grammar_js_1 = grammar;
  const messages_js_1 = messages;
  function hundredsToWords_(num) {
    let n = num % 1000;
    let str = '';
    str += exports.NUMBERS.ones[Math.floor(n / 100)] ? exports.NUMBERS.ones[Math.floor(n / 100)] + '-cent' : '';
    n = n % 100;
    if (n) {
      str += str ? '-' : '';
      let ones = exports.NUMBERS.ones[n];
      if (ones) {
        str += ones;
      } else {
        const tens = exports.NUMBERS.tens[Math.floor(n / 10)];
        if (tens.match(/-dix$/)) {
          ones = exports.NUMBERS.ones[n % 10 + 10];
          str += tens.replace(/-dix$/, '') + '-' + ones;
        } else {
          str += tens + (n % 10 ? '-' + exports.NUMBERS.ones[n % 10] : '');
        }
      }
    }
    const match = str.match(/s-\w+$/);
    return match ? str.replace(/s-\w+$/, match[0].slice(1)) : str.replace(/-un$/, '-et-un');
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    if (exports.NUMBERS.special['tens-' + engine_js_1.Engine.getInstance().subiso]) {
      exports.NUMBERS.tens = exports.NUMBERS.special['tens-' + engine_js_1.Engine.getInstance().subiso];
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        let large = exports.NUMBERS.large[pos];
        const huns = hundredsToWords_(hundreds);
        if (large && large.match(/^mille /)) {
          const rest = large.replace(/^mille /, '');
          if (str.match(RegExp(rest))) {
            str = huns + (pos ? '-mille-' : '') + str;
          } else if (str.match(RegExp(rest.replace(/s$/, '')))) {
            str = huns + (pos ? '-mille-' : '') + str.replace(rest.replace(/s$/, ''), rest);
          } else {
            str = huns + (pos ? '-' + large + '-' : '') + str;
          }
        } else {
          large = hundreds === 1 && large ? large.replace(/s$/, '') : large;
          str = huns + (pos ? '-' + large + '-' : '') + str;
        }
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str.replace(/-$/, '');
  }
  const SMALL_ORDINAL = {
    1: 'unième',
    2: 'demi',
    3: 'tiers',
    4: 'quart'
  };
  function numberToOrdinal(num, plural) {
    const ordinal = SMALL_ORDINAL[num] || wordOrdinal(num);
    return num === 3 ? ordinal : plural ? ordinal + 's' : ordinal;
  }
  function wordOrdinal(num) {
    if (num === 1) {
      return 'première';
    }
    let ordinal = numberToWords(num);
    if (ordinal.match(/^neuf$/)) {
      ordinal = ordinal.slice(0, -1) + 'v';
    } else if (ordinal.match(/cinq$/)) {
      ordinal = ordinal + 'u';
    } else if (ordinal.match(/trois$/)) {
      ordinal = ordinal + '';
    } else if (ordinal.match(/e$/) || ordinal.match(/s$/)) {
      ordinal = ordinal.slice(0, -1);
    }
    ordinal = ordinal + 'ième';
    return ordinal;
  }
  function numericOrdinal(num) {
    const gender = grammar_js_1.Grammar.getInstance().getParameter('gender');
    return num === 1 ? num.toString() + (gender === 'm' ? 'er' : 're') : num.toString() + 'e';
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_fr);
getDefaultExportFromCjs(numbers_fr);

Object.defineProperty(locale_fr, "__esModule", {
  value: true
});
locale_fr.fr = fr;
const grammar_js_1$7 = grammar;
const locale_js_1$i = locale$f;
const locale_util_js_1$7 = locale_util;
const numbers_fr_js_1 = numbers_fr;
const transformers_js_1$5 = transformers;
let locale$7 = null;
function fr() {
  if (!locale$7) {
    locale$7 = create$7();
  }
  return locale$7;
}
function create$7() {
  const loc = (0, locale_js_1$i.createLocale)();
  loc.NUMBERS = numbers_fr_js_1.NUMBERS;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$7.nestingToString;
  loc.FUNCTIONS.combineRootIndex = locale_util_js_1$7.combinePostfixIndex;
  loc.FUNCTIONS.combineNestedFraction = (a, b, c) => c.replace(/ $/g, '') + b + a;
  loc.FUNCTIONS.combineNestedRadical = (a, _b, c) => c + ' ' + a;
  loc.FUNCTIONS.fontRegexp = font => RegExp(' (en |)' + font + '$');
  loc.FUNCTIONS.plural = unit => {
    return (/.*s$/).test(unit) ? unit : unit + 's';
  };
  loc.CORRECTIONS.article = name => {
    return grammar_js_1$7.Grammar.getInstance().getParameter('noArticle') ? '' : name;
  };
  loc.ALPHABETS.combiner = transformers_js_1$5.Combiners.romanceCombiner;
  loc.SUBISO = {
    default: 'fr',
    current: 'fr',
    all: ['fr', 'be', 'ch']
  };
  return loc;
}

var locale_hi = {};

var numbers_hi = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const grammar_js_1 = grammar;
  const messages_js_1 = messages;
  function hundredsToWords_(num) {
    let n = num % 1000;
    let str = '';
    str += exports.NUMBERS.ones[Math.floor(n / 100)] ? exports.NUMBERS.ones[Math.floor(n / 100)] + exports.NUMBERS.numSep + exports.NUMBERS.special.hundred : '';
    n = n % 100;
    if (n) {
      str += str ? exports.NUMBERS.numSep : '';
      str += exports.NUMBERS.ones[n];
    }
    return str;
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 32)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    const hundreds = num % 1000;
    const hundredsWords = hundredsToWords_(hundreds);
    num = Math.floor(num / 1000);
    if (!num) {
      return hundredsWords;
    }
    while (num > 0) {
      const thousands = num % 100;
      if (thousands) {
        str = exports.NUMBERS.ones[thousands] + exports.NUMBERS.numSep + exports.NUMBERS.large[pos] + (str ? exports.NUMBERS.numSep + str : '');
      }
      num = Math.floor(num / 100);
      pos++;
    }
    return hundredsWords ? str + exports.NUMBERS.numSep + hundredsWords : str;
  }
  function numberToOrdinal(num, _plural) {
    if (num <= 10) {
      return exports.NUMBERS.special.smallDenominators[num];
    }
    return wordOrdinal(num) + ' अंश';
  }
  function wordOrdinal(num) {
    const gender = grammar_js_1.Grammar.getInstance().getParameter('gender');
    if (num <= 0) {
      return num.toString();
    }
    if (num < 10) {
      return gender === 'f' ? exports.NUMBERS.special.ordinalsFeminine[num] : exports.NUMBERS.special.ordinalsMasculine[num];
    }
    const ordinal = numberToWords(num);
    return ordinal + (gender === 'f' ? 'वीं' : 'वाँ');
  }
  function numericOrdinal(num) {
    const gender = grammar_js_1.Grammar.getInstance().getParameter('gender');
    if (num > 0 && num < 10) {
      return gender === 'f' ? exports.NUMBERS.special.simpleSmallOrdinalsFeminine[num] : exports.NUMBERS.special.simpleSmallOrdinalsMasculine[num];
    }
    const ordinal = num.toString().split('').map(function (x) {
      const num = parseInt(x, 10);
      return isNaN(num) ? '' : exports.NUMBERS.special.simpleNumbers[num];
    }).join('');
    return ordinal + (gender === 'f' ? 'वीं' : 'वाँ');
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_hi);
getDefaultExportFromCjs(numbers_hi);

Object.defineProperty(locale_hi, "__esModule", {
  value: true
});
locale_hi.hi = hi;
const locale_js_1$h = locale$f;
const numbers_hi_js_1 = numbers_hi;
const transformers_js_1$4 = transformers;
const locale_util_js_1$6 = locale_util;
let locale$6 = null;
function hi() {
  if (!locale$6) {
    locale$6 = create$6();
  }
  return locale$6;
}
function create$6() {
  const loc = (0, locale_js_1$h.createLocale)();
  loc.NUMBERS = numbers_hi_js_1.NUMBERS;
  loc.ALPHABETS.combiner = transformers_js_1$4.Combiners.prefixCombiner;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$6.nestingToString;
  return loc;
}

var locale_ko = {};

var numbers_ko = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const messages_js_1 = messages;
  function thousandsToWords_(num) {
    let n = num % 10000;
    let str = '';
    str += exports.NUMBERS.ones[Math.floor(n / 1000)] ? Math.floor(n / 1000) === 1 ? '천' : exports.NUMBERS.ones[Math.floor(n / 1000)] + '천' : '';
    n = n % 1000;
    if (n) {
      str += exports.NUMBERS.ones[Math.floor(n / 100)] ? Math.floor(n / 100) === 1 ? '백' : exports.NUMBERS.ones[Math.floor(n / 100)] + '백' : '';
      n = n % 100;
      str += exports.NUMBERS.tens[Math.floor(n / 10)] + (n % 10 ? exports.NUMBERS.ones[n % 10] : '');
    }
    return str;
  }
  function numberToWords(num) {
    if (num === 0) return exports.NUMBERS.zero;
    if (num >= Math.pow(10, 36)) return num.toString();
    let pos = 0;
    let str = '';
    while (num > 0) {
      const thousands = num % 10000;
      if (thousands) {
        str = thousandsToWords_(num % 10000) + (pos ? exports.NUMBERS.large[pos] + exports.NUMBERS.numSep : '') + str;
      }
      num = Math.floor(num / 10000);
      pos++;
    }
    return str.replace(/ $/, '');
  }
  function numberToOrdinal(num, _plural) {
    if (num === 1) return '첫번째';
    return wordOrdinal(num) + '번째';
  }
  function wordOrdinal(num) {
    const ordinal = numberToWords(num);
    num %= 100;
    const label = numberToWords(num);
    if (!label || !num) return ordinal;
    const tens = num === 20 ? '스무' : exports.NUMBERS.tens[10 + Math.floor(num / 10)];
    const ones = exports.NUMBERS.ones[10 + Math.floor(num % 10)];
    return ordinal.slice(0, -label.length) + tens + ones;
  }
  function numericOrdinal(num) {
    return numberToOrdinal(num);
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_ko);
getDefaultExportFromCjs(numbers_ko);

Object.defineProperty(locale_ko, "__esModule", {
  value: true
});
locale_ko.ko = ko;
const grammar_js_1$6 = grammar;
const locale_js_1$g = locale$f;
const locale_util_js_1$5 = locale_util;
const numbers_ko_js_1 = numbers_ko;
const tr$3 = transformers;
let locale$5 = null;
function ko() {
  if (!locale$5) {
    locale$5 = create$5();
  }
  return locale$5;
}
function create$5() {
  const loc = (0, locale_js_1$g.createLocale)();
  loc.NUMBERS = numbers_ko_js_1.NUMBERS;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$5.nestingToString;
  loc.FUNCTIONS.plural = function (unit) {
    return unit;
  };
  loc.FUNCTIONS.si = (prefix, unit) => {
    return prefix + unit;
  };
  loc.FUNCTIONS.combineRootIndex = function (index, postfix) {
    return index + postfix;
  };
  loc.ALPHABETS.combiner = tr$3.Combiners.prefixCombiner;
  loc.ALPHABETS.digitTrans.default = numbers_ko_js_1.NUMBERS.numberToWords;
  loc.CORRECTIONS.postposition = name => {
    if (['같다', '는', '와', '를', '로'].includes(name)) return name;
    const char = name.slice(-1);
    const value = (char.charCodeAt(0) - 44032) % 28;
    let final = value > 0 ? true : false;
    if (char.match(/[r,l,n,m,1,3,6,7,8,0]/i)) final = true;
    grammar_js_1$6.Grammar.getInstance().setParameter('final', final);
    return name;
  };
  loc.CORRECTIONS.article = name => {
    const final = grammar_js_1$6.Grammar.getInstance().getParameter('final');
    if (final) grammar_js_1$6.Grammar.getInstance().setParameter('final', false);
    if (name === '같다') name = '는';
    const temp = ({
      는: '은',
      와: '과',
      를: '을',
      로: '으로'
    })[name];
    return temp !== undefined && final ? temp : name;
  };
  return loc;
}

var locale_it = {};

var numbers_it = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const grammar_js_1 = grammar;
  const messages_js_1 = messages;
  function hundredsToWords_(num) {
    let n = num % 1000;
    let str = '';
    str += exports.NUMBERS.ones[Math.floor(n / 100)] ? exports.NUMBERS.ones[Math.floor(n / 100)] + exports.NUMBERS.numSep + 'cento' : '';
    n = n % 100;
    if (n) {
      str += str ? exports.NUMBERS.numSep : '';
      const ones = exports.NUMBERS.ones[n];
      if (ones) {
        str += ones;
      } else {
        let tens = exports.NUMBERS.tens[Math.floor(n / 10)];
        const rest = n % 10;
        if (rest === 1 || rest === 8) {
          tens = tens.slice(0, -1);
        }
        str += tens;
        str += rest ? exports.NUMBERS.numSep + exports.NUMBERS.ones[n % 10] : '';
      }
    }
    return str;
  }
  function numberToWords(num) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    if (num === 1 && grammar_js_1.Grammar.getInstance().getParameter('fraction')) {
      return 'un';
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        str = hundredsToWords_(num % 1000) + (pos ? '-' + exports.NUMBERS.large[pos] + '-' : '') + str;
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str.replace(/-$/, '');
  }
  function numberToOrdinal(num, plural) {
    if (num === 2) {
      return plural ? 'mezzi' : 'mezzo';
    }
    const ordinal = wordOrdinal(num);
    if (!plural) {
      return ordinal;
    }
    const gender = ordinal.match(/o$/) ? 'i' : 'e';
    return ordinal.slice(0, -1) + gender;
  }
  function wordOrdinal(num) {
    const gender = grammar_js_1.Grammar.getInstance().getParameter('gender');
    const postfix = gender === 'm' ? 'o' : 'a';
    let ordinal = exports.NUMBERS.special.onesOrdinals[num];
    if (ordinal) {
      return ordinal.slice(0, -1) + postfix;
    }
    ordinal = numberToWords(num);
    return ordinal.slice(0, -1) + 'esim' + postfix;
  }
  function numericOrdinal(num) {
    const gender = grammar_js_1.Grammar.getInstance().getParameter('gender');
    return num.toString() + (gender === 'm' ? 'o' : 'a');
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_it);
getDefaultExportFromCjs(numbers_it);

Object.defineProperty(locale_it, "__esModule", {
  value: true
});
locale_it.it = it;
const locale_util_js_1$4 = locale_util;
const locale_js_1$f = locale$f;
const numbers_it_js_1 = numbers_it;
const transformers_js_1$3 = transformers;
const italianPostfixCombiner = function (letter, font, cap) {
  if (letter.match(/^[a-zA-Z]$/)) {
    font = font.replace('cerchiato', 'cerchiata');
  }
  letter = cap ? letter + ' ' + cap : letter;
  return font ? letter + ' ' + font : letter;
};
let locale$4 = null;
function it() {
  if (!locale$4) {
    locale$4 = create$4();
  }
  return locale$4;
}
function create$4() {
  const loc = (0, locale_js_1$f.createLocale)();
  loc.NUMBERS = numbers_it_js_1.NUMBERS;
  loc.COMBINERS['italianPostfix'] = italianPostfixCombiner;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$4.nestingToString;
  loc.FUNCTIONS.combineRootIndex = locale_util_js_1$4.combinePostfixIndex;
  loc.FUNCTIONS.combineNestedFraction = (a, b, c) => c.replace(/ $/g, '') + b + a;
  loc.FUNCTIONS.combineNestedRadical = (a, _b, c) => c + ' ' + a;
  loc.FUNCTIONS.fontRegexp = font => RegExp(' (en |)' + font + '$');
  loc.ALPHABETS.combiner = transformers_js_1$3.Combiners.romanceCombiner;
  return loc;
}

var locale_nb = {};

var numbers_nn = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const engine_js_1 = engine;
  const messages_js_1 = messages;
  function hundredsToWordsRo_(num, ordinal = false) {
    let n = num % 1000;
    let str = '';
    const count = Math.floor(n / 100);
    const ones = exports.NUMBERS.ones[count];
    str += ones ? (count === 1 ? '' : ones) + 'hundre' : '';
    n = n % 100;
    if (n) {
      str += str ? 'og' : '';
      if (ordinal) {
        const ord = exports.NUMBERS.special.smallOrdinals[n];
        if (ord) {
          return str + ord;
        }
        if (n % 10) {
          return str + exports.NUMBERS.tens[Math.floor(n / 10)] + exports.NUMBERS.special.smallOrdinals[n % 10];
        }
      }
      str += exports.NUMBERS.ones[n] || exports.NUMBERS.tens[Math.floor(n / 10)] + (n % 10 ? exports.NUMBERS.ones[n % 10] : '');
    }
    return ordinal ? replaceOrdinal(str) : str;
  }
  function numberToWordsRo(num, ordinal = false) {
    if (num === 0) {
      return ordinal ? exports.NUMBERS.special.smallOrdinals[0] : exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        const hund = hundredsToWordsRo_(num % 1000, pos ? false : ordinal);
        if (!pos && ordinal) {
          ordinal = !ordinal;
        }
        str = hund + (pos ? ' ' + (exports.NUMBERS.large[pos] + (pos > 1 && hundreds > 1 ? 'er' : '')) + (str ? ' ' : '') : '') + str;
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return ordinal ? str + (str.match(/tusen$/) ? 'de' : 'te') : str;
  }
  function numberToOrdinal(num, _plural) {
    return wordOrdinal(num);
  }
  function replaceOrdinal(str) {
    const letOne = exports.NUMBERS.special.endOrdinal[0];
    if (letOne === 'a' && str.match(/en$/)) {
      return str.slice(0, -2) + exports.NUMBERS.special.endOrdinal;
    }
    if (str.match(/(d|n)$/) || str.match(/hundre$/)) {
      return str + 'de';
    }
    if (str.match(/i$/)) {
      return str + exports.NUMBERS.special.endOrdinal;
    }
    if (letOne === 'a' && str.match(/e$/)) {
      return str.slice(0, -1) + exports.NUMBERS.special.endOrdinal;
    }
    if (str.match(/e$/)) {
      return str + 'nde';
    }
    return str + 'nde';
  }
  function wordOrdinal(num) {
    const ordinal = numberToWords(num, true);
    return ordinal;
  }
  function numericOrdinal(num) {
    return num.toString() + '.';
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
  function onePrefix_(num, thd = false) {
    const numOne = exports.NUMBERS.ones[1];
    return num === numOne ? num === 'ein' ? 'eitt ' : thd ? 'et' : 'ett' : num;
  }
  function hundredsToWordsGe_(num, ordinal = false) {
    let n = num % 1000;
    let str = '';
    let ones = exports.NUMBERS.ones[Math.floor(n / 100)];
    str += ones ? onePrefix_(ones) + 'hundre' : '';
    n = n % 100;
    if (n) {
      str += str ? 'og' : '';
      if (ordinal) {
        const ord = exports.NUMBERS.special.smallOrdinals[n];
        if (ord) {
          return str += ord;
        }
      }
      ones = exports.NUMBERS.ones[n];
      if (ones) {
        str += ones;
      } else {
        const tens = exports.NUMBERS.tens[Math.floor(n / 10)];
        ones = exports.NUMBERS.ones[n % 10];
        str += ones ? ones + 'og' + tens : tens;
      }
    }
    return ordinal ? replaceOrdinal(str) : str;
  }
  function numberToWordsGe(num, ordinal = false) {
    if (num === 0) {
      return ordinal ? exports.NUMBERS.special.smallOrdinals[0] : exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        const hund = hundredsToWordsGe_(num % 1000, pos ? false : ordinal);
        if (!pos && ordinal) {
          ordinal = !ordinal;
        }
        str = (pos === 1 ? onePrefix_(hund, true) : hund) + (pos > 1 ? exports.NUMBERS.numSep : '') + (pos ? exports.NUMBERS.large[pos] + (pos > 1 && hundreds > 1 ? 'er' : '') : '') + (pos > 1 && str ? exports.NUMBERS.numSep : '') + str;
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return ordinal ? str + (str.match(/tusen$/) ? 'de' : 'te') : str;
  }
  function numberToWords(num, ordinal = false) {
    const word = engine_js_1.Engine.getInstance().subiso === 'alt' ? numberToWordsGe(num, ordinal) : numberToWordsRo(num, ordinal);
    return word;
  }
})(numbers_nn);
getDefaultExportFromCjs(numbers_nn);

Object.defineProperty(locale_nb, "__esModule", {
  value: true
});
locale_nb.nb = nb;
const locale_js_1$e = locale$f;
const locale_util_js_1$3 = locale_util;
const numbers_nn_js_1$1 = numbers_nn;
const tr$2 = transformers;
let locale$3 = null;
function nb() {
  if (!locale$3) {
    locale$3 = create$3();
  }
  return locale$3;
}
function create$3() {
  const loc = (0, locale_js_1$e.createLocale)();
  loc.NUMBERS = numbers_nn_js_1$1.NUMBERS;
  loc.ALPHABETS.combiner = tr$2.Combiners.prefixCombiner;
  loc.ALPHABETS.digitTrans.default = numbers_nn_js_1$1.NUMBERS.numberToWords;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$3.nestingToString;
  return loc;
}

var locale_nemeth = {};

var numbers_nemeth = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const messages_js_1 = messages;
  function numberToWords(num) {
    const digits = num.toString().split('');
    return digits.map(function (digit) {
      return exports.NUMBERS.ones[parseInt(digit, 10)];
    }).join('');
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    numberToWords: numberToWords,
    numberToOrdinal: numberToWords
  });
})(numbers_nemeth);
getDefaultExportFromCjs(numbers_nemeth);

Object.defineProperty(locale_nemeth, "__esModule", {
  value: true
});
locale_nemeth.nemeth = nemeth;
const locale_js_1$d = locale$f;
const numbers_nemeth_js_1 = numbers_nemeth;
const transformers_js_1$2 = transformers;
const simpleEnglish = function (letter) {
  return letter.match(RegExp('^' + locale$2.ALPHABETS.languagePrefix.english)) ? letter.slice(1) : letter;
};
const postfixCombiner = function (letter, font, _number) {
  letter = simpleEnglish(letter);
  return font ? letter + font : letter;
};
const germanCombiner = function (letter, font, _cap) {
  return font + simpleEnglish(letter);
};
const embellishCombiner = function (letter, font, num) {
  letter = simpleEnglish(letter);
  return font + (num ? num : '') + letter + '⠻';
};
const doubleEmbellishCombiner = function (letter, font, num) {
  letter = simpleEnglish(letter);
  return font + (num ? num : '') + letter + '⠻⠻';
};
const parensCombiner = function (letter, font, _number) {
  letter = simpleEnglish(letter);
  return font + letter + '⠾';
};
let locale$2 = null;
function nemeth() {
  if (!locale$2) {
    locale$2 = create$2();
  }
  return locale$2;
}
function create$2() {
  const loc = (0, locale_js_1$d.createLocale)();
  loc.NUMBERS = numbers_nemeth_js_1.NUMBERS;
  loc.COMBINERS = {
    postfixCombiner: postfixCombiner,
    germanCombiner: germanCombiner,
    embellishCombiner: embellishCombiner,
    doubleEmbellishCombiner: doubleEmbellishCombiner,
    parensCombiner: parensCombiner
  };
  loc.FUNCTIONS.fracNestDepth = _node => false;
  loc.FUNCTIONS.fontRegexp = font => RegExp('^' + font);
  loc.FUNCTIONS.si = transformers_js_1$2.identityTransformer;
  loc.ALPHABETS.combiner = (letter, font, num) => {
    return font ? font + num + letter : simpleEnglish(letter);
  };
  loc.ALPHABETS.digitTrans = {
    default: numbers_nemeth_js_1.NUMBERS.numberToWords
  };
  return loc;
}

var locale_nn = {};

Object.defineProperty(locale_nn, "__esModule", {
  value: true
});
locale_nn.nn = nn;
const locale_js_1$c = locale$f;
const locale_util_js_1$2 = locale_util;
const numbers_nn_js_1 = numbers_nn;
const tr$1 = transformers;
let locale$1 = null;
function nn() {
  if (!locale$1) {
    locale$1 = create$1();
  }
  return locale$1;
}
function create$1() {
  const loc = (0, locale_js_1$c.createLocale)();
  loc.NUMBERS = numbers_nn_js_1.NUMBERS;
  loc.ALPHABETS.combiner = tr$1.Combiners.prefixCombiner;
  loc.ALPHABETS.digitTrans.default = numbers_nn_js_1.NUMBERS.numberToWords;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$2.nestingToString;
  loc.SUBISO = {
    default: '',
    current: '',
    all: ['', 'alt']
  };
  return loc;
}

var locale_sv = {};

var numbers_sv = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NUMBERS = void 0;
  const messages_js_1 = messages;
  function hundredsToWords_(num) {
    let n = num % 1000;
    let str = '';
    const hundreds = Math.floor(n / 100);
    str += exports.NUMBERS.ones[hundreds] ? (hundreds === 1 ? '' : exports.NUMBERS.ones[hundreds] + exports.NUMBERS.numSep) + 'hundra' : '';
    n = n % 100;
    if (n) {
      str += str ? exports.NUMBERS.numSep : '';
      str += exports.NUMBERS.ones[n] || exports.NUMBERS.tens[Math.floor(n / 10)] + (n % 10 ? exports.NUMBERS.numSep + exports.NUMBERS.ones[n % 10] : '');
    }
    return str;
  }
  function numberToWords(num, ordinal = false) {
    if (num === 0) {
      return exports.NUMBERS.zero;
    }
    if (num >= Math.pow(10, 36)) {
      return num.toString();
    }
    let pos = 0;
    let str = '';
    while (num > 0) {
      const hundreds = num % 1000;
      if (hundreds) {
        const large = exports.NUMBERS.large[pos];
        const plural = hundreds > 1 && pos > 1 && !ordinal ? 'er' : '';
        str = (pos === 1 && hundreds === 1 ? '' : (pos > 1 && hundreds === 1 ? 'en' : hundredsToWords_(num % 1000)) + (pos > 1 ? ' ' : '')) + (pos ? large + plural + (pos > 1 ? ' ' : '') : '') + str;
      }
      num = Math.floor(num / 1000);
      pos++;
    }
    return str.replace(/ $/, '');
  }
  function numberToOrdinal(num, plural) {
    if (num === 1) {
      return plural ? 'hel' : 'hel';
    }
    if (num === 2) {
      return plural ? 'halva' : 'halv';
    }
    let ordinal = wordOrdinal(num);
    ordinal = ordinal.match(/de$/) ? ordinal.replace(/de$/, '') : ordinal;
    return ordinal + (plural ? 'delar' : 'del');
  }
  function wordOrdinal(num) {
    let ordinal = numberToWords(num, true);
    if (ordinal.match(/^noll$/)) {
      ordinal = 'nollte';
    } else if (ordinal.match(/ett$/)) {
      ordinal = ordinal.replace(/ett$/, 'första');
    } else if (ordinal.match(/två$/)) {
      ordinal = ordinal.replace(/två$/, 'andra');
    } else if (ordinal.match(/tre$/)) {
      ordinal = ordinal.replace(/tre$/, 'tredje');
    } else if (ordinal.match(/fyra$/)) {
      ordinal = ordinal.replace(/fyra$/, 'fjärde');
    } else if (ordinal.match(/fem$/)) {
      ordinal = ordinal.replace(/fem$/, 'femte');
    } else if (ordinal.match(/sex$/)) {
      ordinal = ordinal.replace(/sex$/, 'sjätte');
    } else if (ordinal.match(/sju$/)) {
      ordinal = ordinal.replace(/sju$/, 'sjunde');
    } else if (ordinal.match(/åtta$/)) {
      ordinal = ordinal.replace(/åtta$/, 'åttonde');
    } else if (ordinal.match(/nio$/)) {
      ordinal = ordinal.replace(/nio$/, 'nionde');
    } else if (ordinal.match(/tio$/)) {
      ordinal = ordinal.replace(/tio$/, 'tionde');
    } else if (ordinal.match(/elva$/)) {
      ordinal = ordinal.replace(/elva$/, 'elfte');
    } else if (ordinal.match(/tolv$/)) {
      ordinal = ordinal.replace(/tolv$/, 'tolfte');
    } else if (ordinal.match(/tusen$/)) {
      ordinal = ordinal.replace(/tusen$/, 'tusonde');
    } else if (ordinal.match(/jard$/) || ordinal.match(/jon$/)) {
      ordinal = ordinal + 'te';
    } else {
      ordinal = ordinal + 'de';
    }
    return ordinal;
  }
  function numericOrdinal(num) {
    const str = num.toString();
    if (str.match(/11$|12$/)) {
      return str + ':e';
    }
    return str + (str.match(/1$|2$/) ? ':a' : ':e');
  }
  exports.NUMBERS = (0, messages_js_1.NUMBERS)({
    wordOrdinal: wordOrdinal,
    numericOrdinal: numericOrdinal,
    numberToWords: numberToWords,
    numberToOrdinal: numberToOrdinal
  });
})(numbers_sv);
getDefaultExportFromCjs(numbers_sv);

Object.defineProperty(locale_sv, "__esModule", {
  value: true
});
locale_sv.sv = sv;
const locale_js_1$b = locale$f;
const locale_util_js_1$1 = locale_util;
const numbers_sv_js_1 = numbers_sv;
const tr = transformers;
let locale = null;
function sv() {
  if (!locale) {
    locale = create();
  }
  return locale;
}
function create() {
  const loc = (0, locale_js_1$b.createLocale)();
  loc.NUMBERS = numbers_sv_js_1.NUMBERS;
  loc.FUNCTIONS.radicalNestDepth = locale_util_js_1$1.nestingToString;
  loc.FUNCTIONS.fontRegexp = function (font) {
    return new RegExp('((^' + font + ' )|( ' + font + '$))');
  };
  loc.ALPHABETS.combiner = tr.Combiners.prefixCombiner;
  loc.ALPHABETS.digitTrans.default = numbers_sv_js_1.NUMBERS.numberToWords;
  loc.CORRECTIONS.correctOne = num => num.replace(/^ett$/, 'en');
  return loc;
}

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.locales = void 0;
  exports.setLocale = setLocale;
  exports.completeLocale = completeLocale;
  const engine_js_1 = engine;
  const variables_js_1 = variables;
  const grammar_js_1 = grammar;
  const locale_af_js_1 = locale_af;
  const locale_ca_js_1 = locale_ca;
  const locale_da_js_1 = locale_da;
  const locale_de_js_1 = locale_de;
  const locale_en_js_1 = locale_en;
  const locale_es_js_1 = locale_es;
  const locale_euro_js_1 = locale_euro;
  const locale_fr_js_1 = locale_fr;
  const locale_hi_js_1 = locale_hi;
  const locale_ko_js_1 = locale_ko;
  const locale_it_js_1 = locale_it;
  const locale_nb_js_1 = locale_nb;
  const locale_nemeth_js_1 = locale_nemeth;
  const locale_nn_js_1 = locale_nn;
  const locale_sv_js_1 = locale_sv;
  const locale_js_1 = locale$f;
  exports.locales = {
    af: locale_af_js_1.af,
    ca: locale_ca_js_1.ca,
    da: locale_da_js_1.da,
    de: locale_de_js_1.de,
    en: locale_en_js_1.en,
    es: locale_es_js_1.es,
    euro: locale_euro_js_1.euro,
    fr: locale_fr_js_1.fr,
    hi: locale_hi_js_1.hi,
    it: locale_it_js_1.it,
    ko: locale_ko_js_1.ko,
    nb: locale_nb_js_1.nb,
    nn: locale_nn_js_1.nn,
    sv: locale_sv_js_1.sv,
    nemeth: locale_nemeth_js_1.nemeth
  };
  function setLocale() {
    const msgs = getLocale();
    setSubiso(msgs);
    if (msgs) {
      for (const key of Object.getOwnPropertyNames(msgs)) {
        locale_js_1.LOCALE[key] = msgs[key];
      }
      for (const [key, func] of Object.entries(msgs.CORRECTIONS)) {
        grammar_js_1.Grammar.getInstance().setCorrection(key, func);
      }
    }
  }
  function setSubiso(msg) {
    const subiso = engine_js_1.Engine.getInstance().subiso;
    if (msg.SUBISO.all.indexOf(subiso) === -1) {
      engine_js_1.Engine.getInstance().subiso = msg.SUBISO.default;
    }
    msg.SUBISO.current = engine_js_1.Engine.getInstance().subiso;
  }
  function getLocale() {
    const locale = variables_js_1.Variables.ensureLocale(engine_js_1.Engine.getInstance().locale, engine_js_1.Engine.getInstance().defaultLocale);
    engine_js_1.Engine.getInstance().locale = locale;
    return exports.locales[locale]();
  }
  function completeLocale(json) {
    const locale = exports.locales[json.locale];
    if (!locale) {
      console.error('Locale ' + json.locale + ' does not exist!');
      return;
    }
    const kind = json.kind.toUpperCase();
    const messages = json.messages;
    if (!messages) return;
    const loc = locale();
    for (const [key, value] of Object.entries(messages)) {
      loc[kind][key] = value;
    }
  }
})(l10n);
getDefaultExportFromCjs(l10n);

var math_map = {};

var browser_util = {};

Object.defineProperty(browser_util, "__esModule", {
  value: true
});
browser_util.mapsForIE = void 0;
browser_util.detectIE = detectIE;
browser_util.detectEdge = detectEdge;
const system_external_js_1$3 = system_external;
const xpath_util_js_1$1 = xpath_util;
function detectIE() {
  const isIE = typeof window !== 'undefined' && ('ActiveXObject' in window) && ('clipboardData' in window);
  if (!isIE) {
    return false;
  }
  loadMapsForIE();
  loadWGXpath();
  return true;
}
function detectEdge() {
  var _a;
  const isEdge = typeof window !== 'undefined' && ('MSGestureEvent' in window) && ((_a = window.chrome) === null || _a === void 0 ? void 0 : _a.loadTimes) === null;
  if (!isEdge) {
    return false;
  }
  document.evaluate = null;
  loadWGXpath(true);
  return true;
}
browser_util.mapsForIE = null;
function loadWGXpath(opt_isEdge) {
  loadScript(system_external_js_1$3.SystemExternal.WGXpath);
  installWGXpath(opt_isEdge);
}
function installWGXpath(opt_isEdge, opt_count) {
  let count = opt_count || 1;
  if (typeof wgxpath === 'undefined' && count < 10) {
    setTimeout(function () {
      installWGXpath(opt_isEdge, count++);
    }, 200);
    return;
  }
  if (count >= 10) {
    return;
  }
  system_external_js_1$3.SystemExternal.wgxpath = wgxpath;
  opt_isEdge ? system_external_js_1$3.SystemExternal.wgxpath.install({
    document: document
  }) : system_external_js_1$3.SystemExternal.wgxpath.install();
  xpath_util_js_1$1.xpath.evaluate = document.evaluate;
  xpath_util_js_1$1.xpath.result = XPathResult;
  xpath_util_js_1$1.xpath.createNSResolver = document.createNSResolver;
}
function loadMapsForIE() {
  loadScript(system_external_js_1$3.SystemExternal.mathmapsIePath);
}
function loadScript(src) {
  const scr = system_external_js_1$3.SystemExternal.document.createElement('script');
  scr.type = 'text/javascript';
  scr.src = src;
  system_external_js_1$3.SystemExternal.document.head ? system_external_js_1$3.SystemExternal.document.head.appendChild(scr) : system_external_js_1$3.SystemExternal.document.body.appendChild(scr);
}

var file_util = {};

Object.defineProperty(file_util, "__esModule", {
  value: true
});
file_util.makePath = makePath;
file_util.localePath = localePath;
const system_external_js_1$2 = system_external;
function makePath(path) {
  return path.match('/$') ? path : path + '/';
}
function localePath(locale, ext = 'json') {
  return makePath(system_external_js_1$2.SystemExternal.jsonPath) + locale + (ext.match(/^\./) ? ext : '.' + ext);
}

var math_compound_store = {};

var semantic_attr = {};

(function (exports) {
  var __rest = commonjsGlobal && commonjsGlobal.__rest || (function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SemanticMap = exports.NamedSymbol = void 0;
  exports.addFunctionSemantic = addFunctionSemantic;
  exports.equal = equal;
  exports.isMatchingFence = isMatchingFence;
  const semantic_meaning_js_1 = semantic_meaning;
  const Alphabet = alphabet;
  exports.NamedSymbol = {
    functionApplication: String.fromCodePoint(0x2061),
    invisibleTimes: String.fromCodePoint(0x2062),
    invisibleComma: String.fromCodePoint(0x2063),
    invisiblePlus: String.fromCodePoint(0x2064)
  };
  class meaningMap extends Map {
    get(symbol) {
      return super.get(symbol) || ({
        role: semantic_meaning_js_1.SemanticRole.UNKNOWN,
        type: semantic_meaning_js_1.SemanticType.UNKNOWN,
        font: semantic_meaning_js_1.SemanticFont.UNKNOWN
      });
    }
  }
  class secondaryMap extends Map {
    set(char, kind, annotation = '') {
      super.set(this.secKey(kind, char), annotation || kind);
      return this;
    }
    has(char, kind) {
      return super.has(this.secKey(kind, char));
    }
    get(char, kind) {
      return super.get(this.secKey(kind, char));
    }
    secKey(kind, char) {
      return char ? `${kind} ${char}` : `${kind}`;
    }
  }
  exports.SemanticMap = {
    Meaning: new meaningMap(),
    Secondary: new secondaryMap(),
    FencesHoriz: new Map(),
    FencesVert: new Map(),
    LatexCommands: new Map()
  };
  function addMeaning(symbols, meaning) {
    for (const symbol of symbols) {
      exports.SemanticMap.Meaning.set(symbol, {
        role: meaning.role || semantic_meaning_js_1.SemanticRole.UNKNOWN,
        type: meaning.type || semantic_meaning_js_1.SemanticType.UNKNOWN,
        font: meaning.font || semantic_meaning_js_1.SemanticFont.UNKNOWN
      });
      if (meaning.secondary) {
        exports.SemanticMap.Secondary.set(symbol, meaning.secondary);
      }
    }
  }
  function initMeaning() {
    const sets = [{
      set: ['23', '26', '40', '5c', 'a1', 'a7', 'b6', 'bf', '2017', ['2022', '2025'], '2027', '203b', '203c', ['2041', '2043'], ['2047', '2049'], ['204b', '204d'], '2050', '2055', '2056', ['2058', '205e'], '2234', '2235', 'fe45', 'fe46', 'fe5f', 'fe60', 'fe68', 'fe6b', 'ff03', 'ff06', 'ff0f', 'ff20', 'ff3c'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.UNKNOWN
    }, {
      set: ['22', 'ab', 'bb', '2dd', ['2018', '201f'], '2039', '203a', ['301d', '301f'], 'fe10', 'ff02', 'ff07'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.QUOTES
    }, {
      set: ['3b', '204f', '2a1f', '2a3e', 'fe14', 'fe54', 'ff1b'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.SEMICOLON
    }, {
      set: ['3f', '203d', 'fe16', 'fe56', 'ff1f'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.QUESTION
    }, {
      set: ['21', 'fe15', 'fe57', 'ff01'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.EXCLAMATION
    }, {
      set: ['5e', '60', 'a8', 'aa', 'b4', 'ba', '2c7', ['2d8', '2da'], '2040', '207a', '207d', '207e', 'ff3e', 'ff40'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.OVERACCENT
    }, {
      set: ['b8', '2db', '2038', '203f', '2054', '208a', '208d', '208e'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.UNDERACCENT
    }, {
      set: ['3a', '2982', 'fe13', 'fe30', 'fe55', 'ff1a'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.COLON
    }, {
      set: ['2c', '2063', 'fe50', 'ff0c'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.COMMA
    }, {
      set: ['2026', ['22ee', '22f1'], 'fe19'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.ELLIPSIS
    }, {
      set: ['2e', 'fe52', 'ff0e'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.FULLSTOP
    }, {
      set: ['2d', '207b', '208b', '2212', '2796', 'fe63', 'ff0d'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.DASH,
      secondary: semantic_meaning_js_1.SemanticSecondary.BAR
    }, {
      set: ['5f', 'af', ['2010', '2015'], '203e', '208b', ['fe49', 'fe4f'], 'fe58', 'ff3f', 'ffe3'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.DASH,
      secondary: semantic_meaning_js_1.SemanticSecondary.BAR
    }, {
      set: ['7e', '2dc', '2f7', '303', '330', '334', '2053', '223c', '223d', '301c', 'ff5e'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.TILDE,
      secondary: semantic_meaning_js_1.SemanticSecondary.TILDE
    }, {
      set: ['27', '2b9', '2ba', ['2032', '2037'], '2057'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.PRIME
    }, {
      set: ['b0'],
      type: semantic_meaning_js_1.SemanticType.PUNCTUATION,
      role: semantic_meaning_js_1.SemanticRole.DEGREE
    }, {
      set: ['2b', 'b1', '2064', '2213', '2214', '2228', '222a', ['228c', '228e'], '2294', '2295', '229d', '229e', '22bb', '22bd', '22c4', '22ce', '22d3', '2304', '271b', '271c', '2795', '27cf', '29fa', '29fb', '29fe', ['2a22', '2a28'], '2a2d', '2a2e', '2a39', '2a42', '2a45', '2a46', '2a48', '2a4a', '2a4c', '2a4f', '2a50', '2a52', '2a54', '2a56', '2a57', '2a59', '2a5b', '2a5d', ['2a61', '2a63'], '2adc', '2add', 'fe62', 'ff0b'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.ADDITION
    }, {
      set: ['2a', 'b7', 'd7', '2020', '2021', '204e', '2051', '2062', ['2217', '2219'], '2227', '2229', '2240', '2293', '2297', ['2299', '229b'], '22a0', '22a1', '22b9', '22bc', ['22c5', '22cc'], '22cf', '22d2', '22d4', '2303', '2305', '2306', '25cb', '2715', '2716', '27ce', '27d1', ['29d1', '29d7'], '29e2', '2a1d', ['2a2f', '2a37'], ['2a3b', '2a3d'], '2a40', '2a43', '2a44', '2a47', '2a49', '2a4b', '2a4d', '2a4e', '2a51', '2a53', '2a55', '2a58', '2a5a', '2a5c', ['2a5e', '2a60'], '2ada', '2adb', 'fe61', 'ff0a'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.MULTIPLICATION
    }, {
      set: ['2d', 'af', '2010', '2011', '2052', '207b', '208b', '2212', '2216', '2238', '2242', '2296', '229f', '2796', '29ff', ['2a29', '2a2c'], '2a3a', '2a41', 'fe63', 'ff0d'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.SUBTRACTION
    }, {
      set: ['2f', 'f7', '2044', '2215', '2298', '2797', '27cc', '29bc', ['29f5', '29f9'], '2a38'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.DIVISION
    }, {
      set: ['25', '2030', '2031', 'ff05', 'fe6a'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.POSTFIXOP
    }, {
      set: ['ac', '2200', '2201', '2203', '2204', '2206', ['221a', '221c'], '2310', 'ffe2'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.PREFIXOP
    }, {
      set: ['2320', '2321', '23aa', '23ae', '23af', '23b2', '23b3', '23b6', '23b7'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.PREFIXOP
    }, {
      set: ['1d7ca', '1d7cb'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.PREFIXOP,
      font: semantic_meaning_js_1.SemanticFont.BOLD
    }, {
      set: ['3d', '7e', '207c', '208c', '221d', '2237', ['223a', '223f'], '2243', '2245', '2248', ['224a', '224e'], ['2251', '225f'], '2261', '2263', '229c', '22cd', '22d5', '29e4', '29e6', '2a66', '2a67', ['2a6a', '2a6c'], ['2a6c', '2a78'], 'fe66', 'ff1d'],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.EQUALITY
    }, {
      set: ['3c', '3e', '2241', '2242', '2244', '2246', '2247', '2249', '224f', '2250', '2260', '2262', ['2264', '2281'], '22b0', '22b1', ['22d6', '22e1'], ['22e6', '22e9'], ['2976', '2978'], '29c0', '29c1', '29e1', '29e3', '29e5', ['2a79', '2abc'], ['2af7', '2afa'], 'fe64', 'fe65', 'ff1c', 'ff1e'],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.INEQUALITY
    }, {
      set: [['2282', '228b'], ['228f', '2292'], ['22b2', '22b8'], '22d0', '22d1', ['22e2', '22e5'], ['22ea', '22ed'], '27c3', '27c4', ['27c7', '27c9'], ['27d5', '27d7'], '27dc', ['2979', '297b'], '29df', ['2abd', '2ad8']],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.SET
    }, {
      set: ['2236', ['27e0', '27e5'], '292b', '292c', ['29b5', '29bb'], '29be', '29bf', ['29c2', '29d0']],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.UNKNOWN
    }, {
      set: ['2205', ['29b0', '29b4']],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.SETEMPTY
    }, {
      set: ['1ab2', '221e', ['29dc', '29de']],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.INFTY
    }, {
      set: ['22a2', '22a3', ['22a6', '22af'], '27da', '27db', '27dd', '27de', '2ade', ['2ae2', '2ae6'], '2aec', '2aed'],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.LOGIC
    }, {
      set: ['22a4', '22a5', '22ba', '27d8', '27d9', '27df', '2adf', '2ae0', ['2ae7', '2aeb'], '2af1'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.LOGIC
    }, {
      set: [['2190', '21ff'], '2301', '2324', '238b', '2794', ['2798', '27af'], ['27b1', '27be'], ['27f0', '27ff'], ['2900', '292a'], ['292d', '2975'], ['297c', '297f'], ['2b00', '2b11'], ['2b30', '2b4c'], ['ffe9', 'ffec']],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.ARROW
    }, {
      set: ['2208', '220a', ['22f2', '22f9'], '22ff', '27d2', '2ad9'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.ELEMENT
    }, {
      set: ['2209'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.NONELEMENT
    }, {
      set: ['220b', '220d', ['22fa', '22fe']],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.REELEMENT
    }, {
      set: ['220c'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.RENONELEMENT
    }, {
      set: [['220f', '2211'], ['22c0', '22c3'], ['2a00', '2a0b'], '2a3f', '2afc', '2aff'],
      type: semantic_meaning_js_1.SemanticType.LARGEOP,
      role: semantic_meaning_js_1.SemanticRole.SUM
    }, {
      set: ['2140'],
      type: semantic_meaning_js_1.SemanticType.LARGEOP,
      role: semantic_meaning_js_1.SemanticRole.SUM,
      font: semantic_meaning_js_1.SemanticFont.DOUBLESTRUCK
    }, {
      set: [['222b', '2233'], ['2a0c', '2a17'], ['2a17', '2a1c']],
      type: semantic_meaning_js_1.SemanticType.LARGEOP,
      role: semantic_meaning_js_1.SemanticRole.INTEGRAL
    }, {
      set: [['2500', '257F']],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.BOX
    }, {
      set: [['2580', '259F']],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.BLOCK
    }, {
      set: [['25A0', '25FF'], ['2B12', '2B2F'], ['2B50', '2B59']],
      type: semantic_meaning_js_1.SemanticType.RELATION,
      role: semantic_meaning_js_1.SemanticRole.GEOMETRY
    }, {
      set: ['220e', '2300', '2302', '2311', '29bd', '29e0', ['29e8', '29f3'], '2a1e', '2afe', 'ffed', 'ffee'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.GEOMETRY
    }, {
      set: [['221f', '2222'], '22be', '22bf', ['2312', '2314'], '237c', '27c0', ['299b', '29af']],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.GEOMETRY
    }, {
      set: ['24', ['a2', 'a5'], 'b5', '2123', ['2125', '2127'], '212a', '212b', 'fe69', 'ff04', 'ffe0', 'ffe1', 'ffe5', 'ffe6'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.UNKNOWN
    }, {
      set: ['a9', 'ae', '210f', '2114', '2116', '2117', ['211e', '2122'], '212e', '2132', ['2139', '213b'], ['2141', '2144'], '214d', '214e', ['1f12a', '1f12c'], '1f18a'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.OTHERLETTER
    }, {
      set: ['2224', '2226', '2239', '2307', '27b0', '27bf', '27c1', '27c2', '27ca', '27cb', '27cd', '27d0', '27d3', '27d4', '2981', '2999', '299a', '29e7', '29f4', '2a20', '2a21', '2a64', '2a65', '2a68', '2a69', '2ae1', ['2aee', '2af0'], '2af2', '2af3', '2af5', '2af6', '2afb', '2afd'],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.UNKNOWN
    }, {
      set: ['2605', '2606', '26aa', '26ab', ['2720', '274d']],
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.UNKNOWN
    }, {
      set: [['2145', '2149']],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.LATINLETTER,
      font: semantic_meaning_js_1.SemanticFont.DOUBLESTRUCKITALIC,
      secondary: semantic_meaning_js_1.SemanticSecondary.ALLLETTERS
    }, {
      set: [['213c', '213f']],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.GREEKLETTER,
      font: semantic_meaning_js_1.SemanticFont.DOUBLESTRUCK,
      secondary: semantic_meaning_js_1.SemanticSecondary.ALLLETTERS
    }, {
      set: ['3d0', '3d7', '3f6', ['1d26', '1d2a'], '1d5e', '1d60', ['1d66', '1d6a']],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.GREEKLETTER,
      font: semantic_meaning_js_1.SemanticFont.NORMAL,
      secondary: semantic_meaning_js_1.SemanticSecondary.ALLLETTERS
    }, {
      set: [['2135', '2138']],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.OTHERLETTER,
      font: semantic_meaning_js_1.SemanticFont.NORMAL,
      secondary: semantic_meaning_js_1.SemanticSecondary.ALLLETTERS
    }, {
      set: ['131', '237'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.LATINLETTER,
      font: semantic_meaning_js_1.SemanticFont.NORMAL
    }, {
      set: ['1d6a4', '1d6a5'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.LATINLETTER,
      font: semantic_meaning_js_1.SemanticFont.ITALIC
    }, {
      set: ['2113', '2118'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.LATINLETTER,
      font: semantic_meaning_js_1.SemanticFont.SCRIPT
    }, {
      set: [['c0', 'd6'], ['d8', 'f6'], ['f8', '1bf'], ['1c4', '2af'], ['1d00', '1d25'], ['1d6b', '1d9a'], ['1e00', '1ef9'], ['363', '36f'], ['1dd3', '1de6'], ['1d62', '1d65'], '1dca', '2071', '207f', ['2090', '209c'], '2c7c'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.LATINLETTER,
      font: semantic_meaning_js_1.SemanticFont.NORMAL
    }, {
      set: [['00bc', '00be'], ['2150', '215f'], '2189'],
      type: semantic_meaning_js_1.SemanticType.NUMBER,
      role: semantic_meaning_js_1.SemanticRole.FLOAT
    }, {
      set: ['23E8', ['3248', '324f']],
      type: semantic_meaning_js_1.SemanticType.NUMBER,
      role: semantic_meaning_js_1.SemanticRole.INTEGER
    }, {
      set: [['214A', '214C'], '2705', '2713', '2714', '2717', '2718'],
      type: semantic_meaning_js_1.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1.SemanticRole.UNKNOWN
    }, {
      set: ['20', 'a0', 'ad', ['2000', '200f'], ['2028', '202f'], ['205f', '2060'], '206a', '206b', '206e', '206f', 'feff', ['fff9', 'fffb']],
      type: semantic_meaning_js_1.SemanticType.TEXT,
      role: semantic_meaning_js_1.SemanticRole.SPACE
    }, {
      set: ['7c', 'a6', '2223', '23b8', '23b9', '23d0', '2758', ['fe31', 'fe34'], 'ff5c', 'ffe4', 'ffe8'],
      type: semantic_meaning_js_1.SemanticType.FENCE,
      role: semantic_meaning_js_1.SemanticRole.NEUTRAL
    }, {
      set: ['2016', '2225', '2980', '2af4'],
      type: semantic_meaning_js_1.SemanticType.FENCE,
      role: semantic_meaning_js_1.SemanticRole.METRIC
    }];
    sets.forEach(_a => {
      var {set: s} = _a, m = __rest(_a, ["set"]);
      return addMeaning(Alphabet.makeMultiInterval(s), m);
    });
  }
  function addFences(map, ints, sep = 1) {
    const used = {};
    const codes = Alphabet.makeCodeInterval(ints);
    for (const code of codes) {
      if (used[code]) continue;
      map.set(String.fromCodePoint(code), String.fromCodePoint(code + sep));
      used[code] = true;
      used[code + sep] = true;
    }
  }
  function initFences() {
    addFences(exports.SemanticMap.FencesVert, ['23b4', ['23dc', '23e1'], ['fe35', 'fe44'], 'fe47']);
    addFences(exports.SemanticMap.FencesHoriz, ['28', '2045', ['2308', '230f'], ['231c', '231f'], '2329', '23b0', ['2768', '2775'], '27c5', ['27e6', '27ef'], ['2983', '2998'], ['29d8', '29db'], '29fc', ['2e22', '2e29'], ['3008', '3011'], ['3014', '301b'], 'fd3e', 'fe17', ['fe59', 'fe5e'], 'ff08', 'ff5f', 'ff62']);
    addFences(exports.SemanticMap.FencesHoriz, ['5b', '7b', 'ff3b', 'ff5b'], 2);
    addFences(exports.SemanticMap.FencesHoriz, [['239b', '23a6']], 3);
    addFences(exports.SemanticMap.FencesHoriz, [['23a7', '23a9']], 4);
    addMeaning([...exports.SemanticMap.FencesHoriz.keys()], {
      type: semantic_meaning_js_1.SemanticType.FENCE,
      role: semantic_meaning_js_1.SemanticRole.OPEN
    });
    addMeaning([...exports.SemanticMap.FencesHoriz.values()], {
      type: semantic_meaning_js_1.SemanticType.FENCE,
      role: semantic_meaning_js_1.SemanticRole.CLOSE
    });
    addMeaning([...exports.SemanticMap.FencesVert.keys()], {
      type: semantic_meaning_js_1.SemanticType.FENCE,
      role: semantic_meaning_js_1.SemanticRole.TOP
    });
    addMeaning([...exports.SemanticMap.FencesVert.values()], {
      type: semantic_meaning_js_1.SemanticType.FENCE,
      role: semantic_meaning_js_1.SemanticRole.BOTTOM
    });
  }
  const trigonometricFunctions = ['cos', 'cot', 'csc', 'sec', 'sin', 'tan', 'arccos', 'arccot', 'arccsc', 'arcsec', 'arcsin', 'arctan'];
  const hyperbolicFunctions = ['cosh', 'coth', 'csch', 'sech', 'sinh', 'tanh', 'arcosh', 'arcoth', 'arcsch', 'arsech', 'arsinh', 'artanh'];
  const algebraicFunctions = ['deg', 'det', 'dim', 'hom', 'ker', 'Tr'];
  const elementaryFunctions = ['log', 'ln', 'lg', 'exp', 'gcd', 'lcm', 'arg', 'im', 're', 'Pr'];
  const prefixFunctions = trigonometricFunctions.concat(hyperbolicFunctions, algebraicFunctions, elementaryFunctions);
  function initFunctions() {
    addMeaning(['inf', 'lim', 'liminf', 'limsup', 'max', 'min', 'sup', 'injlim', 'projlim'], {
      type: semantic_meaning_js_1.SemanticType.FUNCTION,
      role: semantic_meaning_js_1.SemanticRole.LIMFUNC
    });
    addMeaning(prefixFunctions, {
      type: semantic_meaning_js_1.SemanticType.FUNCTION,
      role: semantic_meaning_js_1.SemanticRole.PREFIXFUNC
    });
    addMeaning(['mod', 'rem'], {
      type: semantic_meaning_js_1.SemanticType.OPERATOR,
      role: semantic_meaning_js_1.SemanticRole.PREFIXFUNC
    });
  }
  function addFunctionSemantic(base, names) {
    const meaning = exports.SemanticMap.Meaning.get(base) || ({
      type: semantic_meaning_js_1.SemanticType.FUNCTION,
      role: semantic_meaning_js_1.SemanticRole.PREFIXFUNC
    });
    addMeaning(names, meaning);
  }
  function equal(meaning1, meaning2) {
    return meaning1.type === meaning2.type && meaning1.role === meaning2.role && meaning1.font === meaning2.font;
  }
  function isMatchingFence(open, close) {
    const meaning = exports.SemanticMap.Meaning.get(open);
    if (meaning.type !== semantic_meaning_js_1.SemanticType.FENCE) {
      return false;
    }
    if (meaning.role === semantic_meaning_js_1.SemanticRole.NEUTRAL || meaning.role === semantic_meaning_js_1.SemanticRole.METRIC) {
      return open === close;
    }
    return exports.SemanticMap.FencesHoriz.get(open) === close || exports.SemanticMap.FencesVert.get(open) === close;
  }
  function changeSemantics(alphabet, change) {
    for (const [pos, meaning] of Object.entries(change)) {
      const character = alphabet[pos];
      if (character !== undefined) {
        exports.SemanticMap.Meaning.set(character, meaning);
      }
    }
  }
  function addSecondaries(alphabet, change) {
    for (const [pos, meaning] of Object.entries(change)) {
      const character = alphabet[pos];
      if (character !== undefined) {
        exports.SemanticMap.Secondary.set(character, meaning);
      }
    }
  }
  function singleAlphabet(alphabet, type, role, font, semfont, secondaries = [], change = {}, secondary = {}) {
    const interval = Alphabet.INTERVALS.get(Alphabet.alphabetName(alphabet, font));
    if (interval) {
      interval.unicode.forEach(x => {
        exports.SemanticMap.Meaning.set(x, {
          type: type,
          role: role,
          font: semfont
        });
        secondaries.forEach(sec => exports.SemanticMap.Secondary.set(x, sec));
      });
      changeSemantics(interval.unicode, change);
      addSecondaries(interval.unicode, secondary);
    }
  }
  function initAlphabets() {
    for (const [name, font] of Object.entries(semantic_meaning_js_1.SemanticFont)) {
      const emb = !!Alphabet.Embellish[name];
      const semfont = emb ? semantic_meaning_js_1.SemanticFont.UNKNOWN : font === semantic_meaning_js_1.SemanticFont.FULLWIDTH ? semantic_meaning_js_1.SemanticFont.NORMAL : font;
      singleAlphabet(Alphabet.Base.LATINCAP, semantic_meaning_js_1.SemanticType.IDENTIFIER, semantic_meaning_js_1.SemanticRole.LATINLETTER, font, semfont, [semantic_meaning_js_1.SemanticSecondary.ALLLETTERS]);
      singleAlphabet(Alphabet.Base.LATINSMALL, semantic_meaning_js_1.SemanticType.IDENTIFIER, semantic_meaning_js_1.SemanticRole.LATINLETTER, font, semfont, [semantic_meaning_js_1.SemanticSecondary.ALLLETTERS], {}, {
        3: semantic_meaning_js_1.SemanticSecondary.D
      });
      singleAlphabet(Alphabet.Base.GREEKCAP, semantic_meaning_js_1.SemanticType.IDENTIFIER, semantic_meaning_js_1.SemanticRole.GREEKLETTER, font, semfont, [semantic_meaning_js_1.SemanticSecondary.ALLLETTERS]);
      singleAlphabet(Alphabet.Base.GREEKSMALL, semantic_meaning_js_1.SemanticType.IDENTIFIER, semantic_meaning_js_1.SemanticRole.GREEKLETTER, font, semfont, [semantic_meaning_js_1.SemanticSecondary.ALLLETTERS], {
        0: {
          type: semantic_meaning_js_1.SemanticType.OPERATOR,
          role: semantic_meaning_js_1.SemanticRole.PREFIXOP,
          font: semfont
        },
        26: {
          type: semantic_meaning_js_1.SemanticType.OPERATOR,
          role: semantic_meaning_js_1.SemanticRole.PREFIXOP,
          font: semfont
        }
      });
      singleAlphabet(Alphabet.Base.DIGIT, semantic_meaning_js_1.SemanticType.NUMBER, semantic_meaning_js_1.SemanticRole.INTEGER, font, semfont);
    }
  }
  initMeaning();
  initFences();
  initAlphabets();
  initFunctions();
})(semantic_attr);
getDefaultExportFromCjs(semantic_attr);

var math_simple_store = {};

Object.defineProperty(math_simple_store, "__esModule", {
  value: true
});
math_simple_store.MathSimpleStore = void 0;
const engine_js_1$l = engine;
const dynamic_cstr_js_1$8 = dynamic_cstr;
class MathSimpleStore {
  constructor() {
    this.rules = new Map();
  }
  static parseUnicode(num) {
    const keyValue = parseInt(num, 16);
    return String.fromCodePoint(keyValue);
  }
  static testDynamicConstraints_(dynamic, rule) {
    if (engine_js_1$l.Engine.getInstance().strict) {
      return rule.cstr.equal(dynamic);
    }
    return engine_js_1$l.Engine.getInstance().comparator.match(rule.cstr);
  }
  defineRulesFromMappings(locale, modality, mapping) {
    for (const [domain, styles] of Object.entries(mapping)) {
      for (const [style, content] of Object.entries(styles)) {
        this.defineRuleFromStrings(locale, modality, domain, style, content);
      }
    }
  }
  getRules(key) {
    let store = this.rules.get(key);
    if (!store) {
      store = [];
      this.rules.set(key, store);
    }
    return store;
  }
  defineRuleFromStrings(locale, modality, domain, style, content) {
    let store = this.getRules(locale);
    const parser = engine_js_1$l.Engine.getInstance().parsers[domain] || engine_js_1$l.Engine.getInstance().defaultParser;
    const comp = engine_js_1$l.Engine.getInstance().comparators[domain];
    const cstr = `${locale}.${modality}.${domain}.${style}`;
    const dynamic = parser.parse(cstr);
    const comparator = comp ? comp() : engine_js_1$l.Engine.getInstance().comparator;
    const oldCstr = comparator.getReference();
    comparator.setReference(dynamic);
    const rule = {
      cstr: dynamic,
      action: content
    };
    store = store.filter(r => !dynamic.equal(r.cstr));
    store.push(rule);
    this.rules.set(locale, store);
    comparator.setReference(oldCstr);
  }
  lookupRule(_node, dynamic) {
    let rules = this.getRules(dynamic.getValue(dynamic_cstr_js_1$8.Axis.LOCALE));
    rules = rules.filter(function (rule) {
      return MathSimpleStore.testDynamicConstraints_(dynamic, rule);
    });
    if (rules.length === 1) {
      return rules[0];
    }
    return rules.length ? rules.sort((r1, r2) => engine_js_1$l.Engine.getInstance().comparator.compare(r1.cstr, r2.cstr))[0] : null;
  }
}
math_simple_store.MathSimpleStore = MathSimpleStore;

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.addCharacterRules = exports.baseStores = exports.subStores = void 0;
  exports.changeLocale = changeLocale;
  exports.setSiPrefixes = setSiPrefixes;
  exports.defineRules = defineRules;
  exports.defineRule = defineRule;
  exports.addSymbolRules = addSymbolRules;
  exports.addFunctionRules = addFunctionRules;
  exports.addUnitRules = addUnitRules;
  exports.lookupRule = lookupRule;
  exports.lookupCategory = lookupCategory;
  exports.lookupString = lookupString;
  exports.enumerate = enumerate;
  exports.reset = reset;
  const engine_js_1 = engine;
  const l10n_js_1 = l10n;
  const semantic_attr_js_1 = semantic_attr;
  const math_simple_store_js_1 = math_simple_store;
  const dynamic_cstr_js_1 = dynamic_cstr;
  let locale = dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1.Axis.LOCALE];
  let modality = dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1.Axis.MODALITY];
  function changeLocale(json) {
    if (!json['locale'] && !json['modality']) {
      return false;
    }
    locale = json['locale'] || locale;
    modality = json['modality'] || modality;
    return true;
  }
  let siPrefixes = {};
  function setSiPrefixes(prefixes) {
    siPrefixes = prefixes;
  }
  exports.subStores = new Map();
  exports.baseStores = new Map();
  function getSubStore(base, key) {
    let store = exports.subStores.get(key);
    if (store) {
      return store;
    }
    store = new math_simple_store_js_1.MathSimpleStore();
    store.base = exports.baseStores.get(base);
    exports.subStores.set(key, store);
    return store;
  }
  function completeWithBase(json) {
    const base = exports.baseStores.get(json.key);
    if (!base) {
      return;
    }
    const names = json.names;
    Object.assign(json, base);
    if (names && base.names) {
      json.names = json.names.concat(names);
    }
  }
  function defineRules(base, str, mappings) {
    const store = getSubStore(base, str);
    store.defineRulesFromMappings(locale, modality, mappings);
  }
  function defineRule(domain, style, str, content) {
    const store = getSubStore(str, str);
    store.defineRuleFromStrings(locale, modality, domain, style, content);
  }
  function addSymbolRules(json) {
    for (const rule of json) {
      if (changeLocale(rule)) {
        continue;
      }
      const key = math_simple_store_js_1.MathSimpleStore.parseUnicode(rule['key']);
      if (locale === 'base') {
        exports.baseStores.set(key, rule);
        continue;
      }
      defineRules(key, key, rule['mappings']);
    }
  }
  function addCharacterRule(json) {
    if (changeLocale(json)) {
      return;
    }
    for (const [key, value] of Object.entries(json)) {
      defineRule('default', 'default', key, value);
    }
  }
  const addCharacterRules = json => json.forEach(addCharacterRule);
  exports.addCharacterRules = addCharacterRules;
  function addFunctionRule(json) {
    for (let j = 0, name; name = json.names[j]; j++) {
      defineRules(json.key, name, json.mappings);
    }
  }
  function addFunctionRules(json) {
    for (const rule of json) {
      if (changeLocale(rule)) {
        continue;
      }
      (0, semantic_attr_js_1.addFunctionSemantic)(rule.key, rule.names || []);
      if (locale === 'base') {
        exports.baseStores.set(rule.key, rule);
        continue;
      }
      completeWithBase(rule);
      addFunctionRule(rule);
    }
  }
  function addUnitRules(json) {
    for (const rule of json) {
      if (changeLocale(rule)) {
        continue;
      }
      rule.key += ':unit';
      if (locale === 'base') {
        exports.baseStores.set(rule.key, rule);
        continue;
      }
      completeWithBase(rule);
      if (rule.names) {
        rule.names = rule.names.map(function (name) {
          return name + ':unit';
        });
      }
      if (rule.si) {
        addSiUnitRule(rule);
      }
      addFunctionRule(rule);
    }
  }
  function addSiUnitRule(json) {
    for (const key of Object.keys(siPrefixes)) {
      const newJson = Object.assign({}, json);
      newJson.mappings = {};
      const prefix = siPrefixes[key];
      newJson['names'] = newJson['names'].map(function (name) {
        return key + name;
      });
      for (const domain of Object.keys(json['mappings'])) {
        newJson.mappings[domain] = {};
        for (const style of Object.keys(json['mappings'][domain])) {
          newJson['mappings'][domain][style] = l10n_js_1.locales[locale]().FUNCTIONS.si(prefix, json['mappings'][domain][style]);
        }
      }
      addFunctionRule(newJson);
    }
  }
  function lookupRule(node, dynamic) {
    const store = exports.subStores.get(node);
    return store ? store.lookupRule(null, dynamic) : null;
  }
  function lookupCategory(character) {
    const store = exports.subStores.get(character);
    return (store === null || store === void 0 ? void 0 : store.base) ? store.base.category : '';
  }
  function lookupString(text, dynamic) {
    const rule = lookupRule(text, dynamic);
    if (!rule) {
      return null;
    }
    return rule.action;
  }
  engine_js_1.Engine.getInstance().evaluator = lookupString;
  function enumerate(info = {}) {
    for (const store of exports.subStores.values()) {
      for (const [, rules] of store.rules.entries()) {
        for (const {cstr: dynamic} of rules) {
          info = enumerate_(dynamic.getValues(), info);
        }
      }
    }
    return info;
  }
  function enumerate_(dynamic, info) {
    info = info || ({});
    if (!dynamic.length) {
      return info;
    }
    info[dynamic[0]] = enumerate_(dynamic.slice(1), info[dynamic[0]]);
    return info;
  }
  function reset() {
    locale = dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1.Axis.LOCALE];
    modality = dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1.Axis.MODALITY];
  }
})(math_compound_store);
getDefaultExportFromCjs(math_compound_store);

var speech_rule_engine = {};

var auditory_description = {};

var span = {};

Object.defineProperty(span, "__esModule", {
  value: true
});
span.Span = void 0;
class Span {
  constructor(speech, attributes) {
    this.speech = speech;
    this.attributes = attributes;
  }
  static empty() {
    return new Span('', {});
  }
  static stringEmpty(str) {
    return new Span(str, {});
  }
  static stringAttr(str, attr) {
    return new Span(str, attr);
  }
  static singleton(str, def = {}) {
    return [Span.stringAttr(str, def)];
  }
  static node(str, node, def = {}) {
    const attr = Span.getAttributes(node);
    Object.assign(attr, def);
    return new Span(str, attr);
  }
  static getAttributes(node) {
    const attrs = {};
    for (const attr of Span.attributeList) {
      if (node.hasAttribute(attr)) {
        attrs[attr] = node.getAttribute(attr);
      }
    }
    return attrs;
  }
}
span.Span = Span;
Span.attributeList = ['id', 'extid'];

Object.defineProperty(auditory_description, "__esModule", {
  value: true
});
auditory_description.AuditoryDescription = auditory_description.AuditoryList = auditory_description.AuditoryItem = void 0;
const grammar_js_1$5 = grammar;
const span_js_1$9 = span;
class AuditoryItem {
  constructor(data = null) {
    this.data = data;
    this.prev = null;
    this.next = null;
  }
}
auditory_description.AuditoryItem = AuditoryItem;
class AuditoryList extends Set {
  constructor(descrs) {
    super();
    this.annotations = [];
    this.anchor = new AuditoryItem();
    this.anchor.next = this.anchor;
    this.anchor.prev = this.anchor;
    descrs.forEach(d => {
      const item = new AuditoryItem(d);
      if (d.annotation) {
        this.annotations.push(item);
      }
      this.push(item);
    });
  }
  first() {
    return this.empty ? null : this.anchor.next;
  }
  last() {
    return this.empty ? null : this.anchor.prev;
  }
  push(item) {
    item.next = this.anchor;
    item.prev = this.anchor.prev;
    item.prev.next = item;
    this.anchor.prev = item;
    super.add(item);
  }
  pop() {
    const item = this.last();
    if (!item) {
      return null;
    }
    this.delete(item);
    return item;
  }
  delete(item) {
    if (!this.has(item)) {
      return false;
    }
    super.delete(item);
    item.prev.next = item.next;
    item.next = item.prev;
    return true;
  }
  insertAfter(descr, item) {
    this.insertBefore(descr, item.next);
  }
  insertBefore(descr, item) {
    const nitem = new AuditoryItem(descr);
    if (!item || !this.has(item)) {
      this.push(nitem);
      return;
    }
    item.prev.next = nitem;
    nitem.prev = item.prev;
    nitem.next = item;
    item.prev = nitem;
  }
  prevText(item) {
    do {
      item = item.prev;
    } while (item !== this.anchor && !item.data.text);
    return item === this.anchor ? null : item;
  }
  *[Symbol.iterator]() {
    let current = this.anchor.next;
    while (current !== this.anchor) {
      yield current;
      current = current.next;
    }
  }
  nextText(item) {
    while (item !== this.anchor && !item.data.text) {
      item = item.next;
    }
    return item;
  }
  clear() {
    this.anchor.next = this.anchor;
    this.anchor.prev = this.anchor;
    super.clear();
  }
  empty() {
    return this.anchor.prev === this.anchor && this.anchor === this.anchor.next;
  }
  toList() {
    const result = [];
    let item = this.anchor.next;
    while (item !== this.anchor) {
      result.push(item.data);
      item = item.next;
    }
    return result;
  }
}
auditory_description.AuditoryList = AuditoryList;
class AuditoryDescription {
  static create(args, flags = {}) {
    args.text = grammar_js_1$5.Grammar.getInstance().apply(args.text, flags);
    return new AuditoryDescription(args);
  }
  constructor({context, text, userValue, annotation, attributes, personality, layout}) {
    this.context = context || '';
    this.text = text || '';
    this.userValue = userValue || '';
    this.annotation = annotation || '';
    this.attributes = attributes || ({});
    this.personality = personality || ({});
    this.layout = layout || '';
  }
  isEmpty() {
    return this.context.length === 0 && this.text.length === 0 && this.userValue.length === 0 && this.annotation.length === 0;
  }
  clone() {
    let personality;
    if (this.personality) {
      personality = {};
      for (const [key, val] of Object.entries(this.personality)) {
        personality[key] = val;
      }
    }
    let attributes;
    if (this.attributes) {
      attributes = {};
      for (const [key, val] of Object.entries(this.attributes)) {
        attributes[key] = val;
      }
    }
    return new AuditoryDescription({
      context: this.context,
      text: this.text,
      userValue: this.userValue,
      annotation: this.annotation,
      personality: personality,
      attributes: attributes,
      layout: this.layout
    });
  }
  toString() {
    return 'AuditoryDescription(context="' + this.context + '" ' + ' text="' + this.text + '" ' + ' userValue="' + this.userValue + '" ' + ' annotation="' + this.annotation + '")';
  }
  descriptionString() {
    return this.context && this.text ? this.context + ' ' + this.text : this.context || this.text;
  }
  descriptionSpan() {
    return span_js_1$9.Span.stringAttr(this.descriptionString(), this.attributes);
  }
  equals(that) {
    return this.context === that.context && this.text === that.text && this.userValue === that.userValue && this.annotation === that.annotation;
  }
}
auditory_description.AuditoryDescription = AuditoryDescription;

var speech_rules = {};

Object.defineProperty(speech_rules, "__esModule", {
  value: true
});
speech_rules.addStore = addStore;
speech_rules.getStore = getStore$1;
const dynamic_cstr_js_1$7 = dynamic_cstr;
const funcStore = new Map();
function addStore(constr, inherit, store) {
  const values = {};
  if (inherit) {
    const inherits = funcStore.get(inherit) || ({});
    Object.assign(values, inherits);
  }
  funcStore.set(constr, Object.assign(values, store));
}
function getStore$1(locale, modality, domain) {
  return funcStore.get([locale, modality, domain].join('.')) || funcStore.get([dynamic_cstr_js_1$7.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$7.Axis.LOCALE], modality, domain].join('.')) || funcStore.get([dynamic_cstr_js_1$7.DynamicCstr.BASE_LOCALE, modality, domain].join('.')) || ({});
}

var speech_rule_stores = {};

var clearspeak_rules = {};

var store_util = {};

Object.defineProperty(store_util, "__esModule", {
  value: true
});
store_util.nodeCounter = nodeCounter$1;
store_util.pauseSeparator = pauseSeparator;
store_util.contentIterator = contentIterator$1;
const auditory_description_js_1$5 = auditory_description;
const XpathUtil$d = xpath_util;
const engine_js_1$k = engine;
function nodeCounter$1(nodes, context) {
  const localLength = nodes.length;
  let localCounter = 0;
  let localContext = context;
  if (!context) {
    localContext = '';
  }
  return function () {
    if (localCounter < localLength) {
      localCounter += 1;
    }
    return localContext + ' ' + localCounter;
  };
}
function pauseSeparator(_nodes, context) {
  const numeral = parseFloat(context);
  const value = isNaN(numeral) ? context : numeral;
  return function () {
    return [auditory_description_js_1$5.AuditoryDescription.create({
      text: '',
      personality: {
        pause: value
      }
    })];
  };
}
function contentIterator$1(nodes, context) {
  let contentNodes;
  if (nodes.length > 0) {
    contentNodes = XpathUtil$d.evalXPath('../../content/*', nodes[0]);
  } else {
    contentNodes = [];
  }
  return function () {
    const content = contentNodes.shift();
    const contextDescr = context ? [auditory_description_js_1$5.AuditoryDescription.create({
      text: context
    }, {
      translate: true
    })] : [];
    if (!content) {
      return contextDescr;
    }
    const descrs = engine_js_1$k.Engine.evaluateNode(content);
    return contextDescr.concat(descrs);
  };
}

var clearspeak_util = {};

var semantic_annotations = {};

var semantic_annotator = {};

Object.defineProperty(semantic_annotator, "__esModule", {
  value: true
});
semantic_annotator.SemanticVisitor = semantic_annotator.SemanticAnnotator = void 0;
class SemanticAnnotator {
  constructor(domain, name, func) {
    this.domain = domain;
    this.name = name;
    this.func = func;
    this.active = false;
  }
  annotate(node) {
    node.childNodes.forEach(this.annotate.bind(this));
    node.contentNodes.forEach(this.annotate.bind(this));
    node.addAnnotation(this.domain, this.func(node));
  }
}
semantic_annotator.SemanticAnnotator = SemanticAnnotator;
class SemanticVisitor {
  constructor(domain, name, func, def = {}) {
    this.domain = domain;
    this.name = name;
    this.func = func;
    this.def = def;
    this.active = false;
  }
  visit(node, info) {
    let result = this.func(node, info);
    node.addAnnotation(this.domain, result[0]);
    for (let i = 0, child; child = node.childNodes[i]; i++) {
      result = this.visit(child, result[1]);
    }
    for (let i = 0, content; content = node.contentNodes[i]; i++) {
      result = this.visit(content, result[1]);
    }
    return result;
  }
}
semantic_annotator.SemanticVisitor = SemanticVisitor;

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.visitors = exports.annotators = void 0;
  exports.register = register;
  exports.activate = activate;
  exports.deactivate = deactivate;
  exports.annotate = annotate;
  const semantic_annotator_js_1 = semantic_annotator;
  exports.annotators = new Map();
  exports.visitors = new Map();
  function register(annotator) {
    const name = annotator.domain + ':' + annotator.name;
    annotator instanceof semantic_annotator_js_1.SemanticAnnotator ? exports.annotators.set(name, annotator) : exports.visitors.set(name, annotator);
  }
  function activate(domain, name) {
    const key = domain + ':' + name;
    const annotator = exports.annotators.get(key) || exports.visitors.get(key);
    if (annotator) {
      annotator.active = true;
    }
  }
  function deactivate(domain, name) {
    const key = domain + ':' + name;
    const annotator = exports.annotators.get(key) || exports.visitors.get(key);
    if (annotator) {
      annotator.active = false;
    }
  }
  function annotate(node) {
    for (const annotator of exports.annotators.values()) {
      if (annotator.active) {
        annotator.annotate(node);
      }
    }
    for (const visitor of exports.visitors.values()) {
      if (visitor.active) {
        visitor.visit(node, Object.assign({}, visitor.def));
      }
    }
  }
})(semantic_annotations);
getDefaultExportFromCjs(semantic_annotations);

Object.defineProperty(clearspeak_util, "__esModule", {
  value: true
});
clearspeak_util.nodeCounter = nodeCounter;
clearspeak_util.allCellsSimple = allCellsSimple;
clearspeak_util.isSmallVulgarFraction = isSmallVulgarFraction$1;
clearspeak_util.ordinalExponent = ordinalExponent;
clearspeak_util.nestingDepth = nestingDepth$1;
clearspeak_util.matchingFences = matchingFences;
clearspeak_util.fencedArguments = fencedArguments;
clearspeak_util.simpleArguments = simpleArguments;
clearspeak_util.wordOrdinal = wordOrdinal;
const span_js_1$8 = span;
const DomUtil$x = dom_util;
const engine_js_1$j = engine;
const XpathUtil$c = xpath_util;
const locale_js_1$a = locale$f;
const transformers_js_1$1 = transformers;
const grammar_js_1$4 = grammar;
const StoreUtil$3 = store_util;
const semantic_annotations_js_1$4 = semantic_annotations;
const semantic_annotator_js_1$2 = semantic_annotator;
const semantic_attr_js_1$8 = semantic_attr;
const semantic_meaning_js_1$v = semantic_meaning;
function nodeCounter(nodes, context) {
  const split = context.split('-');
  const func = StoreUtil$3.nodeCounter(nodes, split[0] || '');
  const sep = split[1] || '';
  const init = split[2] || '';
  let first = true;
  return function () {
    const result = func();
    if (first) {
      first = false;
      return init + result + sep;
    } else {
      return result + sep;
    }
  };
}
function isSimpleExpression(node) {
  return isSimpleNumber_(node) || isSimpleLetters_(node) || isSimpleDegree_(node) || isSimpleNegative_(node) || isSimpleFunction_(node);
}
function isSimpleFunction_(node) {
  return node.type === semantic_meaning_js_1$v.SemanticType.APPL && (node.childNodes[0].role === semantic_meaning_js_1$v.SemanticRole.PREFIXFUNC || node.childNodes[0].role === semantic_meaning_js_1$v.SemanticRole.SIMPLEFUNC) && (isSimple_(node.childNodes[1]) || node.childNodes[1].type === semantic_meaning_js_1$v.SemanticType.FENCED && isSimple_(node.childNodes[1].childNodes[0]));
}
function isSimpleNegative_(node) {
  return node.type === semantic_meaning_js_1$v.SemanticType.PREFIXOP && node.role === semantic_meaning_js_1$v.SemanticRole.NEGATIVE && isSimple_(node.childNodes[0]) && node.childNodes[0].type !== semantic_meaning_js_1$v.SemanticType.PREFIXOP && node.childNodes[0].type !== semantic_meaning_js_1$v.SemanticType.APPL && node.childNodes[0].type !== semantic_meaning_js_1$v.SemanticType.PUNCTUATED;
}
function isSimpleDegree_(node) {
  return node.type === semantic_meaning_js_1$v.SemanticType.PUNCTUATED && node.role === semantic_meaning_js_1$v.SemanticRole.ENDPUNCT && node.childNodes.length === 2 && node.childNodes[1].role === semantic_meaning_js_1$v.SemanticRole.DEGREE && (isLetter_(node.childNodes[0]) || isNumber_(node.childNodes[0]) || node.childNodes[0].type === semantic_meaning_js_1$v.SemanticType.PREFIXOP && node.childNodes[0].role === semantic_meaning_js_1$v.SemanticRole.NEGATIVE && (isLetter_(node.childNodes[0].childNodes[0]) || isNumber_(node.childNodes[0].childNodes[0])));
}
function isSimpleLetters_(node) {
  return isLetter_(node) || node.type === semantic_meaning_js_1$v.SemanticType.INFIXOP && node.role === semantic_meaning_js_1$v.SemanticRole.IMPLICIT && (node.childNodes.length === 2 && (isLetter_(node.childNodes[0]) || isSimpleNumber_(node.childNodes[0])) && isLetter_(node.childNodes[1]) || node.childNodes.length === 3 && isSimpleNumber_(node.childNodes[0]) && isLetter_(node.childNodes[1]) && isLetter_(node.childNodes[2]));
}
function isSimple_(node) {
  return node.hasAnnotation('clearspeak', 'simple');
}
function isLetter_(node) {
  return node.type === semantic_meaning_js_1$v.SemanticType.IDENTIFIER && (node.role === semantic_meaning_js_1$v.SemanticRole.LATINLETTER || node.role === semantic_meaning_js_1$v.SemanticRole.GREEKLETTER || node.role === semantic_meaning_js_1$v.SemanticRole.OTHERLETTER || node.role === semantic_meaning_js_1$v.SemanticRole.SIMPLEFUNC);
}
function isNumber_(node) {
  return node.type === semantic_meaning_js_1$v.SemanticType.NUMBER && (node.role === semantic_meaning_js_1$v.SemanticRole.INTEGER || node.role === semantic_meaning_js_1$v.SemanticRole.FLOAT);
}
function isSimpleNumber_(node) {
  return isNumber_(node) || isSimpleFraction_(node);
}
function isSimpleFraction_(node) {
  if (hasPreference('Fraction_Over') || hasPreference('Fraction_FracOver')) {
    return false;
  }
  if (node.type !== semantic_meaning_js_1$v.SemanticType.FRACTION || node.role !== semantic_meaning_js_1$v.SemanticRole.VULGAR) {
    return false;
  }
  if (hasPreference('Fraction_Ordinal')) {
    return true;
  }
  const enumerator = parseInt(node.childNodes[0].textContent, 10);
  const denominator = parseInt(node.childNodes[1].textContent, 10);
  return enumerator > 0 && enumerator < 20 && denominator > 0 && denominator < 11;
}
function hasPreference(pref) {
  return engine_js_1$j.Engine.getInstance().style === pref;
}
(0, semantic_annotations_js_1$4.register)(new semantic_annotator_js_1$2.SemanticAnnotator('clearspeak', 'simple', function (node) {
  return isSimpleExpression(node) ? 'simple' : '';
}));
function simpleNode(node) {
  if (!node.hasAttribute('annotation')) {
    return false;
  }
  const annotation = node.getAttribute('annotation');
  return !!(/clearspeak:simple$|clearspeak:simple;/).exec(annotation);
}
function simpleCell_(node) {
  if (simpleNode(node)) {
    return true;
  }
  if (node.tagName !== semantic_meaning_js_1$v.SemanticType.SUBSCRIPT) {
    return false;
  }
  const children = node.childNodes[0].childNodes;
  const index = children[1];
  return children[0].tagName === semantic_meaning_js_1$v.SemanticType.IDENTIFIER && (isInteger_(index) || index.tagName === semantic_meaning_js_1$v.SemanticType.INFIXOP && index.hasAttribute('role') && index.getAttribute('role') === semantic_meaning_js_1$v.SemanticRole.IMPLICIT && allIndices_(index));
}
function isInteger_(node) {
  return node.tagName === semantic_meaning_js_1$v.SemanticType.NUMBER && node.hasAttribute('role') && node.getAttribute('role') === semantic_meaning_js_1$v.SemanticRole.INTEGER;
}
function allIndices_(node) {
  const nodes = XpathUtil$c.evalXPath('children/*', node);
  return nodes.every(x => isInteger_(x) || x.tagName === semantic_meaning_js_1$v.SemanticType.IDENTIFIER);
}
function allCellsSimple(node) {
  const xpath = node.tagName === semantic_meaning_js_1$v.SemanticType.MATRIX ? 'children/row/children/cell/children/*' : 'children/line/children/*';
  const nodes = XpathUtil$c.evalXPath(xpath, node);
  const result = nodes.every(simpleCell_);
  return result ? [node] : [];
}
function isSmallVulgarFraction$1(node) {
  return (0, transformers_js_1$1.vulgarFractionSmall)(node, 20, 11) ? [node] : [];
}
function isUnitExpression(node) {
  return node.type === semantic_meaning_js_1$v.SemanticType.TEXT && node.role !== semantic_meaning_js_1$v.SemanticRole.LABEL || node.type === semantic_meaning_js_1$v.SemanticType.PUNCTUATED && node.role === semantic_meaning_js_1$v.SemanticRole.TEXT && isNumber_(node.childNodes[0]) && allTextLastContent_(node.childNodes.slice(1)) || node.type === semantic_meaning_js_1$v.SemanticType.IDENTIFIER && node.role === semantic_meaning_js_1$v.SemanticRole.UNIT || node.type === semantic_meaning_js_1$v.SemanticType.INFIXOP && (node.role === semantic_meaning_js_1$v.SemanticRole.IMPLICIT || node.role === semantic_meaning_js_1$v.SemanticRole.UNIT);
}
function allTextLastContent_(nodes) {
  for (let i = 0; i < nodes.length - 1; i++) {
    if (!(nodes[i].type === semantic_meaning_js_1$v.SemanticType.TEXT && nodes[i].textContent === '')) {
      return false;
    }
  }
  return nodes[nodes.length - 1].type === semantic_meaning_js_1$v.SemanticType.TEXT;
}
(0, semantic_annotations_js_1$4.register)(new semantic_annotator_js_1$2.SemanticAnnotator('clearspeak', 'unit', function (node) {
  return isUnitExpression(node) ? 'unit' : '';
}));
function ordinalExponent(node) {
  const num = parseInt(node.textContent, 10);
  return [span_js_1$8.Span.stringEmpty(isNaN(num) ? node.textContent : num > 10 ? locale_js_1$a.LOCALE.NUMBERS.numericOrdinal(num) : locale_js_1$a.LOCALE.NUMBERS.wordOrdinal(num))];
}
let NESTING_DEPTH = null;
function nestingDepth$1(node) {
  let count = 0;
  const fence = node.textContent;
  const index = node.getAttribute('role') === 'open' ? 0 : 1;
  let parent = node.parentNode;
  while (parent) {
    if (parent.tagName === semantic_meaning_js_1$v.SemanticType.FENCED && parent.childNodes[0].childNodes[index].textContent === fence) {
      count++;
    }
    parent = parent.parentNode;
  }
  NESTING_DEPTH = count > 1 ? locale_js_1$a.LOCALE.NUMBERS.wordOrdinal(count) : '';
  return [span_js_1$8.Span.stringEmpty(NESTING_DEPTH)];
}
function matchingFences(node) {
  const sibling = node.previousSibling;
  let left, right;
  if (sibling) {
    left = sibling;
    right = node;
  } else {
    left = node;
    right = node.nextSibling;
  }
  if (!right) {
    return [];
  }
  return (0, semantic_attr_js_1$8.isMatchingFence)(left.textContent, right.textContent) ? [node] : [];
}
function insertNesting(text, correction) {
  if (!correction || !text) {
    return text;
  }
  const start = text.match(/^(open|close) /);
  if (!start) {
    return correction + ' ' + text;
  }
  return start[0] + correction + ' ' + text.substring(start[0].length);
}
grammar_js_1$4.Grammar.getInstance().setCorrection('insertNesting', insertNesting);
function fencedArguments(node) {
  const content = DomUtil$x.toArray(node.parentNode.childNodes);
  const children = XpathUtil$c.evalXPath('../../children/*', node);
  const index = content.indexOf(node);
  return fencedFactor_(children[index]) || fencedFactor_(children[index + 1]) ? [node] : [];
}
function simpleArguments(node) {
  const content = DomUtil$x.toArray(node.parentNode.childNodes);
  const children = XpathUtil$c.evalXPath('../../children/*', node);
  const index = content.indexOf(node);
  return simpleFactor_(children[index]) && children[index + 1] && (simpleFactor_(children[index + 1]) || children[index + 1].tagName === semantic_meaning_js_1$v.SemanticType.ROOT || children[index + 1].tagName === semantic_meaning_js_1$v.SemanticType.SQRT || children[index + 1].tagName === semantic_meaning_js_1$v.SemanticType.SUPERSCRIPT && children[index + 1].childNodes[0].childNodes[0] && (children[index + 1].childNodes[0].childNodes[0].tagName === semantic_meaning_js_1$v.SemanticType.NUMBER || children[index + 1].childNodes[0].childNodes[0].tagName === semantic_meaning_js_1$v.SemanticType.IDENTIFIER) && (children[index + 1].childNodes[0].childNodes[1].textContent === '2' || children[index + 1].childNodes[0].childNodes[1].textContent === '3')) ? [node] : [];
}
function simpleFactor_(node) {
  return !!node && (node.tagName === semantic_meaning_js_1$v.SemanticType.NUMBER || node.tagName === semantic_meaning_js_1$v.SemanticType.IDENTIFIER || node.tagName === semantic_meaning_js_1$v.SemanticType.FUNCTION || node.tagName === semantic_meaning_js_1$v.SemanticType.APPL || node.tagName === semantic_meaning_js_1$v.SemanticType.FRACTION);
}
function fencedFactor_(node) {
  return node && (node.tagName === semantic_meaning_js_1$v.SemanticType.FENCED || node.hasAttribute('role') && node.getAttribute('role') === semantic_meaning_js_1$v.SemanticRole.LEFTRIGHT || layoutFactor_(node));
}
function layoutFactor_(node) {
  return !!node && (node.tagName === semantic_meaning_js_1$v.SemanticType.MATRIX || node.tagName === semantic_meaning_js_1$v.SemanticType.VECTOR);
}
function wordOrdinal(node) {
  return [span_js_1$8.Span.stringEmpty(locale_js_1$a.LOCALE.NUMBERS.wordOrdinal(parseInt(node.textContent, 10)))];
}

var mathspeak_util = {};

var base_util = {};

Object.defineProperty(base_util, "__esModule", {
  value: true
});
base_util.removeEmpty = removeEmpty;
base_util.interleaveLists = interleaveLists;
base_util.setdifference = setdifference;
function removeEmpty(strs) {
  return strs.filter(str => str);
}
function interleaveLists(list1, list2) {
  const result = [];
  while (list1.length || list2.length) {
    if (list1.length) {
      result.push(list1.shift());
    }
    if (list2.length) {
      result.push(list2.shift());
    }
  }
  return result;
}
function setdifference(a, b) {
  if (!a) {
    return [];
  }
  if (!b) {
    return a;
  }
  return a.filter(x => b.indexOf(x) < 0);
}

var semantic_processor = {};

var semantic_heuristic_factory = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SemanticHeuristics = void 0;
  exports.SemanticHeuristics = {
    factory: null,
    updateFactory: function (nodeFactory) {
      exports.SemanticHeuristics.factory = nodeFactory;
    },
    heuristics: new Map(),
    flags: {
      combine_juxtaposition: true,
      convert_juxtaposition: true,
      multioperator: true
    },
    blacklist: {},
    add: function (heuristic) {
      const name = heuristic.name;
      exports.SemanticHeuristics.heuristics.set(name, heuristic);
      if (!exports.SemanticHeuristics.flags[name]) {
        exports.SemanticHeuristics.flags[name] = false;
      }
    },
    run: function (name, root, opt_alternative) {
      const heuristic = exports.SemanticHeuristics.heuristics.get(name);
      return heuristic && !exports.SemanticHeuristics.blacklist[name] && (exports.SemanticHeuristics.flags[name] || heuristic.applicable(root)) ? heuristic.apply(root) : opt_alternative ? opt_alternative(root) : root;
    }
  };
})(semantic_heuristic_factory);
getDefaultExportFromCjs(semantic_heuristic_factory);

var semantic_node_factory = {};

var semantic_default = {};

var semantic_ordering = {};

Object.defineProperty(semantic_ordering, "__esModule", {
  value: true
});
semantic_ordering.reduce = reduce;
const semantic_meaning_js_1$u = semantic_meaning;
const comparators = [];
function add(comparator) {
  comparators.push(comparator);
}
function apply(meaning1, meaning2) {
  for (let i = 0, comparator; comparator = comparators[i]; i++) {
    const result = comparator.compare(meaning1, meaning2);
    if (result !== 0) {
      return result;
    }
  }
  return 0;
}
function sort(meanings) {
  meanings.sort(apply);
}
function reduce(meanings) {
  if (meanings.length <= 1) {
    return meanings;
  }
  const copy = meanings.slice();
  sort(copy);
  const result = [];
  let last;
  do {
    last = copy.pop();
    result.push(last);
  } while (last && copy.length && apply(copy[copy.length - 1], last) === 0);
  return result;
}
class SemanticComparator {
  constructor(comparator, type = null) {
    this.comparator = comparator;
    this.type = type;
    add(this);
  }
  compare(meaning1, meaning2) {
    return this.type && this.type === meaning1.type && this.type === meaning2.type ? this.comparator(meaning1, meaning2) : 0;
  }
}
function simpleFunction(meaning1, meaning2) {
  if (meaning1.role === semantic_meaning_js_1$u.SemanticRole.SIMPLEFUNC) {
    return 1;
  }
  if (meaning2.role === semantic_meaning_js_1$u.SemanticRole.SIMPLEFUNC) {
    return -1;
  }
  return 0;
}
new SemanticComparator(simpleFunction, semantic_meaning_js_1$u.SemanticType.IDENTIFIER);

Object.defineProperty(semantic_default, "__esModule", {
  value: true
});
semantic_default.SemanticMeaningCollator = semantic_default.SemanticNodeCollator = semantic_default.SemanticDefault = void 0;
const SemanticAttr = semantic_attr;
const semantic_ordering_js_1 = semantic_ordering;
function key(symbol, font) {
  return symbol.match(/^.+:.+$/) || !font ? symbol : symbol + ':' + font;
}
class SemanticDefault extends Map {
  set(symbol, meaning) {
    super.set(key(symbol, meaning.font), meaning);
    return this;
  }
  setNode(node) {
    this.set(node.textContent, node.meaning());
  }
  get(symbol, font = null) {
    return super.get(key(symbol, font));
  }
  getNode(node) {
    return this.get(node.textContent, node.font);
  }
}
semantic_default.SemanticDefault = SemanticDefault;
class SemanticCollator extends Map {
  add(symbol, entry) {
    const list = this.get(symbol);
    if (list) {
      list.push(entry);
    } else {
      super.set(symbol, [entry]);
    }
  }
  get(symbol, font = null) {
    return super.get(key(symbol, font));
  }
  getNode(node) {
    return this.get(node.textContent, node.font);
  }
  minimize() {
    for (const [key, entry] of this) {
      if (entry.length === 1) {
        this.delete(key);
      }
    }
  }
  isMultiValued() {
    for (const value of this.values()) {
      if (value.length > 1) {
        return true;
      }
    }
    return false;
  }
}
class SemanticNodeCollator extends SemanticCollator {
  add(symbol, entry) {
    super.add(key(symbol, entry.font), entry);
  }
  addNode(node) {
    this.add(node.textContent, node);
  }
  toString() {
    const outer = [];
    for (const [key, nodes] of this) {
      const length = Array(key.length + 3).join(' ');
      const inner = nodes.map(node => node.toString()).join('\n' + length);
      outer.push(key + ': ' + inner);
    }
    return outer.join('\n');
  }
  collateMeaning() {
    const collator = new SemanticMeaningCollator();
    for (const [key, val] of this) {
      collator.set(key, val.map(node => node.meaning()));
    }
    return collator;
  }
}
semantic_default.SemanticNodeCollator = SemanticNodeCollator;
class SemanticMeaningCollator extends SemanticCollator {
  add(symbol, entry) {
    const list = this.get(symbol, entry.font);
    if (!list || !list.find(function (x) {
      return SemanticAttr.equal(x, entry);
    })) {
      super.add(key(symbol, entry.font), entry);
    }
  }
  addNode(node) {
    this.add(node.textContent, node.meaning());
  }
  toString() {
    const outer = [];
    for (const [key, nodes] of this) {
      const length = Array(key.length + 3).join(' ');
      const inner = nodes.map(node => `{type: ${node.type}, role: ${node.role}, font: ${node.font}}`).join('\n' + length);
      outer.push(key + ': ' + inner);
    }
    return outer.join('\n');
  }
  reduce() {
    for (const [key, val] of this) {
      if (val.length !== 1) {
        this.set(key, (0, semantic_ordering_js_1.reduce)(val));
      }
    }
  }
  default() {
    const def = new SemanticDefault();
    for (const [key, val] of this) {
      if (val.length === 1) {
        def.set(key, val[0]);
      }
    }
    return def;
  }
  newDefault() {
    const oldDefault = this.default();
    this.reduce();
    const newDefault = this.default();
    return oldDefault.size !== newDefault.size ? newDefault : null;
  }
}
semantic_default.SemanticMeaningCollator = SemanticMeaningCollator;

var semantic_node = {};

var semantic_util = {};

Object.defineProperty(semantic_util, "__esModule", {
  value: true
});
semantic_util.MMLTAGS = void 0;
semantic_util.hasMathTag = hasMathTag;
semantic_util.hasIgnoreTag = hasIgnoreTag;
semantic_util.hasEmptyTag = hasEmptyTag;
semantic_util.hasDisplayTag = hasDisplayTag;
semantic_util.isOrphanedGlyph = isOrphanedGlyph;
semantic_util.purgeNodes = purgeNodes;
semantic_util.isZeroLength = isZeroLength;
semantic_util.addAttributes = addAttributes;
semantic_util.getEmbellishedInner = getEmbellishedInner;
semantic_util.sliceNodes = sliceNodes;
semantic_util.partitionNodes = partitionNodes;
const DomUtil$w = dom_util;
var MMLTAGS;
(function (MMLTAGS) {
  MMLTAGS["ANNOTATION"] = "ANNOTATION";
  MMLTAGS["ANNOTATIONXML"] = "ANNOTATION-XML";
  MMLTAGS["MACTION"] = "MACTION";
  MMLTAGS["MALIGNGROUP"] = "MALIGNGROUP";
  MMLTAGS["MALIGNMARK"] = "MALIGNMARK";
  MMLTAGS["MATH"] = "MATH";
  MMLTAGS["MENCLOSE"] = "MENCLOSE";
  MMLTAGS["MERROR"] = "MERROR";
  MMLTAGS["MFENCED"] = "MFENCED";
  MMLTAGS["MFRAC"] = "MFRAC";
  MMLTAGS["MGLYPH"] = "MGLYPH";
  MMLTAGS["MI"] = "MI";
  MMLTAGS["MLABELEDTR"] = "MLABELEDTR";
  MMLTAGS["MMULTISCRIPTS"] = "MMULTISCRIPTS";
  MMLTAGS["MN"] = "MN";
  MMLTAGS["MO"] = "MO";
  MMLTAGS["MOVER"] = "MOVER";
  MMLTAGS["MPADDED"] = "MPADDED";
  MMLTAGS["MPHANTOM"] = "MPHANTOM";
  MMLTAGS["MPRESCRIPTS"] = "MPRESCRIPTS";
  MMLTAGS["MROOT"] = "MROOT";
  MMLTAGS["MROW"] = "MROW";
  MMLTAGS["MS"] = "MS";
  MMLTAGS["MSPACE"] = "MSPACE";
  MMLTAGS["MSQRT"] = "MSQRT";
  MMLTAGS["MSTYLE"] = "MSTYLE";
  MMLTAGS["MSUB"] = "MSUB";
  MMLTAGS["MSUBSUP"] = "MSUBSUP";
  MMLTAGS["MSUP"] = "MSUP";
  MMLTAGS["MTABLE"] = "MTABLE";
  MMLTAGS["MTD"] = "MTD";
  MMLTAGS["MTEXT"] = "MTEXT";
  MMLTAGS["MTR"] = "MTR";
  MMLTAGS["MUNDER"] = "MUNDER";
  MMLTAGS["MUNDEROVER"] = "MUNDEROVER";
  MMLTAGS["NONE"] = "NONE";
  MMLTAGS["SEMANTICS"] = "SEMANTICS";
})(MMLTAGS || (semantic_util.MMLTAGS = MMLTAGS = {}));
const ALLTAGS = Object.values(MMLTAGS);
const LEAFTAGS = [MMLTAGS.MO, MMLTAGS.MI, MMLTAGS.MN, MMLTAGS.MTEXT, MMLTAGS.MS, MMLTAGS.MSPACE];
const IGNORETAGS = [MMLTAGS.MERROR, MMLTAGS.MPHANTOM, MMLTAGS.MALIGNGROUP, MMLTAGS.MALIGNMARK, MMLTAGS.MPRESCRIPTS, MMLTAGS.ANNOTATION, MMLTAGS.ANNOTATIONXML];
const EMPTYTAGS = [MMLTAGS.MATH, MMLTAGS.MROW, MMLTAGS.MPADDED, MMLTAGS.MACTION, MMLTAGS.NONE, MMLTAGS.MSTYLE, MMLTAGS.SEMANTICS];
const DISPLAYTAGS = [MMLTAGS.MROOT, MMLTAGS.MSQRT];
const directSpeechKeys = ['aria-label', 'exact-speech', 'alt'];
function hasMathTag(node) {
  return !!node && DomUtil$w.tagName(node) === MMLTAGS.MATH;
}
function hasLeafTag(node) {
  return !!node && LEAFTAGS.includes(DomUtil$w.tagName(node));
}
function hasIgnoreTag(node) {
  return !!node && (IGNORETAGS.includes(DomUtil$w.tagName(node)) || !ALLTAGS.includes(DomUtil$w.tagName(node)));
}
function hasEmptyTag(node) {
  return !!node && EMPTYTAGS.includes(DomUtil$w.tagName(node));
}
function hasDisplayTag(node) {
  return !!node && DISPLAYTAGS.includes(DomUtil$w.tagName(node));
}
function isOrphanedGlyph(node) {
  return !!node && DomUtil$w.tagName(node) === MMLTAGS.MGLYPH && !hasLeafTag(node.parentNode);
}
function purgeNodes(nodes) {
  const nodeArray = [];
  for (let i = 0, node; node = nodes[i]; i++) {
    if (node.nodeType !== DomUtil$w.NodeType.ELEMENT_NODE) {
      continue;
    }
    const tagName = DomUtil$w.tagName(node);
    if (IGNORETAGS.includes(tagName)) {
      continue;
    }
    if (EMPTYTAGS.includes(tagName) && node.childNodes.length === 0) {
      continue;
    }
    nodeArray.push(node);
  }
  return nodeArray;
}
function isZeroLength(length) {
  if (!length) {
    return false;
  }
  const negativeNamedSpaces = ['negativeveryverythinmathspace', 'negativeverythinmathspace', 'negativethinmathspace', 'negativemediummathspace', 'negativethickmathspace', 'negativeverythickmathspace', 'negativeveryverythickmathspace'];
  if (negativeNamedSpaces.includes(length)) {
    return true;
  }
  const value = length.match(/[0-9.]+/);
  if (!value) {
    return false;
  }
  return parseFloat(value[0]) === 0;
}
function addAttributes(to, from) {
  if (from.hasAttributes()) {
    const attrs = from.attributes;
    for (let i = attrs.length - 1; i >= 0; i--) {
      const key = attrs[i].name;
      if (key.match(/^ext/)) {
        to.attributes[key] = attrs[i].value;
        to.nobreaking = true;
      }
      if (directSpeechKeys.includes(key)) {
        to.attributes['ext-speech'] = attrs[i].value;
        to.nobreaking = true;
      }
      if (key.match(/texclass$/)) {
        to.attributes['texclass'] = attrs[i].value;
      }
      if (key.toLowerCase() === 'data-latex') {
        to.attributes['latex'] = attrs[i].value;
      }
      if (key === 'href') {
        to.attributes['href'] = attrs[i].value;
        to.nobreaking = true;
      }
    }
  }
}
function getEmbellishedInner(node) {
  if (node && node.embellished && node.childNodes.length > 0) {
    return getEmbellishedInner(node.childNodes[0]);
  }
  return node;
}
function sliceNodes(nodes, pred, opt_reverse) {
  if (opt_reverse) {
    nodes.reverse();
  }
  const head = [];
  for (let i = 0, node; node = nodes[i]; i++) {
    if (pred(node)) {
      if (opt_reverse) {
        return {
          head: nodes.slice(i + 1).reverse(),
          div: node,
          tail: head.reverse()
        };
      }
      return {
        head: head,
        div: node,
        tail: nodes.slice(i + 1)
      };
    }
    head.push(node);
  }
  if (opt_reverse) {
    return {
      head: [],
      div: null,
      tail: head.reverse()
    };
  }
  return {
    head: head,
    div: null,
    tail: []
  };
}
function partitionNodes(nodes, pred) {
  let restNodes = nodes;
  const rel = [];
  const comp = [];
  let result = null;
  do {
    result = sliceNodes(restNodes, pred);
    comp.push(result.head);
    rel.push(result.div);
    restNodes = result.tail;
  } while (result.div);
  rel.pop();
  return {
    rel: rel,
    comp: comp
  };
}

Object.defineProperty(semantic_node, "__esModule", {
  value: true
});
semantic_node.SemanticNode = void 0;
const DomUtil$v = dom_util;
const semantic_attr_js_1$7 = semantic_attr;
const semantic_meaning_js_1$t = semantic_meaning;
const SemanticUtil$4 = semantic_util;
class SemanticNode {
  static fromXml(xml) {
    const id = parseInt(xml.getAttribute('id'), 10);
    const node = new SemanticNode(id);
    node.type = xml.tagName;
    SemanticNode.setAttribute(node, xml, 'role');
    SemanticNode.setAttribute(node, xml, 'font');
    SemanticNode.setAttribute(node, xml, 'embellished');
    SemanticNode.setAttribute(node, xml, 'fencepointer', 'fencePointer');
    if (xml.getAttribute('annotation')) {
      node.parseAnnotation(xml.getAttribute('annotation'));
    }
    SemanticUtil$4.addAttributes(node, xml);
    SemanticNode.processChildren(node, xml);
    return node;
  }
  static setAttribute(node, xml, attribute, opt_name) {
    opt_name = opt_name || attribute;
    const value = xml.getAttribute(attribute);
    if (value) {
      node[opt_name] = value;
    }
  }
  static processChildren(node, xml) {
    for (const child of DomUtil$v.toArray(xml.childNodes)) {
      if (child.nodeType === DomUtil$v.NodeType.TEXT_NODE) {
        node.textContent = child.textContent;
        continue;
      }
      const children = DomUtil$v.toArray(child.childNodes).map(SemanticNode.fromXml);
      children.forEach(x => x.parent = node);
      if (DomUtil$v.tagName(child) === 'CONTENT') {
        node.contentNodes = children;
      } else {
        node.childNodes = children;
      }
    }
  }
  constructor(id) {
    this.id = id;
    this.mathml = [];
    this.parent = null;
    this.type = semantic_meaning_js_1$t.SemanticType.UNKNOWN;
    this.role = semantic_meaning_js_1$t.SemanticRole.UNKNOWN;
    this.font = semantic_meaning_js_1$t.SemanticFont.UNKNOWN;
    this.embellished = null;
    this.fencePointer = '';
    this.childNodes = [];
    this.textContent = '';
    this.mathmlTree = null;
    this.contentNodes = [];
    this.annotation = {};
    this.attributes = {};
    this.nobreaking = false;
  }
  querySelectorAll(pred) {
    let result = [];
    for (let i = 0, child; child = this.childNodes[i]; i++) {
      result = result.concat(child.querySelectorAll(pred));
    }
    for (let i = 0, content; content = this.contentNodes[i]; i++) {
      result = result.concat(content.querySelectorAll(pred));
    }
    if (pred(this)) {
      result.unshift(this);
    }
    return result;
  }
  xml(xml, brief) {
    const xmlNodeList = function (tag, nodes) {
      const xmlNodes = nodes.map(function (x) {
        return x.xml(xml, brief);
      });
      const tagNode = xml.createElementNS('', tag);
      for (let i = 0, child; child = xmlNodes[i]; i++) {
        tagNode.appendChild(child);
      }
      return tagNode;
    };
    const node = xml.createElementNS('', this.type);
    if (!brief) {
      this.xmlAttributes(node);
    }
    node.textContent = this.textContent;
    if (this.contentNodes.length > 0) {
      node.appendChild(xmlNodeList("content", this.contentNodes));
    }
    if (this.childNodes.length > 0) {
      node.appendChild(xmlNodeList("children", this.childNodes));
    }
    return node;
  }
  toString(brief = false) {
    const xml = DomUtil$v.parseInput('<snode/>');
    return DomUtil$v.serializeXml(this.xml(xml.ownerDocument, brief));
  }
  allAttributes() {
    const attributes = [];
    attributes.push(["role", this.role]);
    if (this.font !== semantic_meaning_js_1$t.SemanticFont.UNKNOWN) {
      attributes.push(["font", this.font]);
    }
    if (Object.keys(this.annotation).length) {
      attributes.push(["annotation", this.annotationXml()]);
    }
    if (this.embellished) {
      attributes.push(["embellished", this.embellished]);
    }
    if (this.fencePointer) {
      attributes.push(["fencepointer", this.fencePointer]);
    }
    attributes.push(["id", this.id.toString()]);
    return attributes;
  }
  annotationXml() {
    const result = [];
    for (const [key, val] of Object.entries(this.annotation)) {
      val.forEach(mean => result.push(key + ':' + mean));
    }
    return result.join(';');
  }
  attributesXml() {
    const result = [];
    for (const [key, value] of Object.entries(this.attributes)) {
      result.push(key + ':' + SemanticNode.escapeValue(value));
    }
    return result.join(';');
  }
  toJson() {
    const json = {};
    json["type"] = this.type;
    const attributes = this.allAttributes();
    for (let i = 0, attr; attr = attributes[i]; i++) {
      json[attr[0]] = attr[1].toString();
    }
    if (this.textContent) {
      json["$t"] = this.textContent;
    }
    if (this.childNodes.length) {
      json["children"] = this.childNodes.map(function (child) {
        return child.toJson();
      });
    }
    if (this.contentNodes.length) {
      json["content"] = this.contentNodes.map(function (child) {
        return child.toJson();
      });
    }
    return json;
  }
  updateContent(content, text) {
    const newContent = text ? content.replace(/^[ \f\n\r\t\v\u200b]*/, '').replace(/[ \f\n\r\t\v\u200b]*$/, '') : content.trim();
    content = content && !newContent ? content : newContent;
    if (this.textContent === content) {
      return;
    }
    const meaning = semantic_attr_js_1$7.SemanticMap.Meaning.get(content.replace(/\s/g, ' '));
    this.textContent = content;
    this.role = meaning.role;
    this.type = meaning.type;
    this.font = meaning.font;
  }
  addMathmlNodes(mmlNodes) {
    for (let i = 0, mml; mml = mmlNodes[i]; i++) {
      if (this.mathml.indexOf(mml) === -1) {
        this.mathml.push(mml);
      }
    }
  }
  appendChild(child) {
    this.childNodes.push(child);
    this.addMathmlNodes(child.mathml);
    child.parent = this;
  }
  replaceChild(oldNode, newNode) {
    const index = this.childNodes.indexOf(oldNode);
    if (index === -1) {
      return;
    }
    oldNode.parent = null;
    newNode.parent = this;
    this.childNodes[index] = newNode;
    const removeMathml = oldNode.mathml.filter(function (x) {
      return newNode.mathml.indexOf(x) === -1;
    });
    const addMathml = newNode.mathml.filter(function (x) {
      return oldNode.mathml.indexOf(x) === -1;
    });
    this.removeMathmlNodes(removeMathml);
    this.addMathmlNodes(addMathml);
  }
  appendContentNode(node) {
    if (node) {
      this.contentNodes.push(node);
      this.addMathmlNodes(node.mathml);
      node.parent = this;
    }
  }
  removeContentNode(node) {
    if (node) {
      const index = this.contentNodes.indexOf(node);
      if (index !== -1) {
        this.contentNodes.slice(index, 1);
      }
    }
  }
  equals(node) {
    if (!node) {
      return false;
    }
    if (this.type !== node.type || this.role !== node.role || this.textContent !== node.textContent || this.childNodes.length !== node.childNodes.length || this.contentNodes.length !== node.contentNodes.length) {
      return false;
    }
    for (let i = 0, node1, node2; (node1 = this.childNodes[i], node2 = node.childNodes[i]); i++) {
      if (!node1.equals(node2)) {
        return false;
      }
    }
    for (let i = 0, node1, node2; (node1 = this.contentNodes[i], node2 = node.contentNodes[i]); i++) {
      if (!node1.equals(node2)) {
        return false;
      }
    }
    return true;
  }
  displayTree() {
    console.info(this.displayTree_(0));
  }
  addAnnotation(domain, annotation) {
    if (annotation) {
      this.addAnnotation_(domain, annotation);
    }
  }
  getAnnotation(domain) {
    const content = this.annotation[domain];
    return content ? content : [];
  }
  hasAnnotation(domain, annotation) {
    const content = this.annotation[domain];
    if (!content) {
      return false;
    }
    return content.indexOf(annotation) !== -1;
  }
  parseAnnotation(stateStr) {
    const annotations = stateStr.split(';');
    for (let i = 0, l = annotations.length; i < l; i++) {
      const annotation = annotations[i].split(':');
      this.addAnnotation(annotation[0], annotation[1]);
    }
  }
  meaning() {
    return {
      type: this.type,
      role: this.role,
      font: this.font
    };
  }
  xmlAttributes(node) {
    const attributes = this.allAttributes();
    for (let i = 0, attr; attr = attributes[i]; i++) {
      node.setAttribute(attr[0], attr[1]);
    }
    this.addExternalAttributes(node);
  }
  addExternalAttributes(node) {
    for (const [attr, val] of Object.entries(this.attributes)) {
      node.setAttribute(attr, val);
    }
  }
  static escapeValue(value) {
    return value.replace(/;/g, '\\0003B');
  }
  parseAttributes(stateStr) {
    if (!stateStr) return;
    const attributes = stateStr.split(';');
    for (let i = 0, l = attributes.length; i < l; i++) {
      const [key, ...values] = attributes[i].split(':');
      if (key) {
        this.attributes[key] = values.join('').replace(/\\0003B/g, ';');
      }
    }
  }
  removeMathmlNodes(mmlNodes) {
    const mmlList = this.mathml;
    for (let i = 0, mml; mml = mmlNodes[i]; i++) {
      const index = mmlList.indexOf(mml);
      if (index !== -1) {
        mmlList.splice(index, 1);
      }
    }
    this.mathml = mmlList;
  }
  displayTree_(depth) {
    depth++;
    const depthString = Array(depth).join('  ');
    let result = '';
    result += '\n' + depthString + this.toString();
    result += '\n' + depthString + 'MathmlTree:';
    result += '\n' + depthString + this.mathmlTreeString();
    result += '\n' + depthString + 'MathML:';
    for (let i = 0, mml; mml = this.mathml[i]; i++) {
      result += '\n' + depthString + mml.toString();
    }
    result += '\n' + depthString + 'Begin Content';
    this.contentNodes.forEach(function (x) {
      result += x.displayTree_(depth);
    });
    result += '\n' + depthString + 'End Content';
    result += '\n' + depthString + 'Begin Children';
    this.childNodes.forEach(function (x) {
      result += x.displayTree_(depth);
    });
    result += '\n' + depthString + 'End Children';
    return result;
  }
  mathmlTreeString() {
    return this.mathmlTree ? this.mathmlTree.toString() : 'EMPTY';
  }
  addAnnotation_(domain, annotation) {
    const content = this.annotation[domain];
    if (content && !content.includes(annotation)) {
      content.push(annotation);
    } else {
      this.annotation[domain] = [annotation];
    }
  }
}
semantic_node.SemanticNode = SemanticNode;

Object.defineProperty(semantic_node_factory, "__esModule", {
  value: true
});
semantic_node_factory.SemanticNodeFactory = void 0;
const semantic_meaning_js_1$s = semantic_meaning;
const semantic_default_js_1 = semantic_default;
const semantic_default_js_2 = semantic_default;
const semantic_node_js_1$2 = semantic_node;
class SemanticNodeFactory {
  constructor() {
    this.leafMap = new semantic_default_js_2.SemanticNodeCollator();
    this.defaultMap = new semantic_default_js_1.SemanticDefault();
    this.idCounter_ = -1;
  }
  makeNode(id) {
    return this.createNode_(id);
  }
  makeUnprocessed(mml) {
    const node = this.createNode_();
    node.mathml = [mml];
    node.mathmlTree = mml;
    return node;
  }
  makeEmptyNode() {
    const node = this.createNode_();
    node.type = semantic_meaning_js_1$s.SemanticType.EMPTY;
    return node;
  }
  makeContentNode(content) {
    const node = this.createNode_();
    node.updateContent(content);
    return node;
  }
  makeMultipleContentNodes(num, content) {
    const nodes = [];
    for (let i = 0; i < num; i++) {
      nodes.push(this.makeContentNode(content));
    }
    return nodes;
  }
  makeLeafNode(content, font) {
    if (!content) {
      return this.makeEmptyNode();
    }
    const node = this.makeContentNode(content);
    node.font = font || node.font;
    const meaning = this.defaultMap.getNode(node);
    if (meaning) {
      node.type = meaning.type;
      node.role = meaning.role;
      node.font = meaning.font;
    }
    this.leafMap.addNode(node);
    return node;
  }
  makeBranchNode(type, children, contentNodes, opt_content) {
    const node = this.createNode_();
    if (opt_content) {
      node.updateContent(opt_content);
    }
    node.type = type;
    node.childNodes = children;
    node.contentNodes = contentNodes;
    children.concat(contentNodes).forEach(function (x) {
      x.parent = node;
      node.addMathmlNodes(x.mathml);
    });
    return node;
  }
  createNode_(id) {
    if (typeof id !== 'undefined') {
      this.idCounter_ = Math.max(this.idCounter_, id);
    } else {
      id = ++this.idCounter_;
    }
    return new semantic_node_js_1$2.SemanticNode(id);
  }
}
semantic_node_factory.SemanticNodeFactory = SemanticNodeFactory;

var semantic_pred = {};

Object.defineProperty(semantic_pred, "__esModule", {
  value: true
});
semantic_pred.isType = isType;
semantic_pred.isRole = isRole;
semantic_pred.isAccent = isAccent;
semantic_pred.isSimpleFunctionScope = isSimpleFunctionScope;
semantic_pred.isPrefixFunctionBoundary = isPrefixFunctionBoundary;
semantic_pred.isBigOpBoundary = isBigOpBoundary;
semantic_pred.isIntegralDxBoundary = isIntegralDxBoundary;
semantic_pred.isIntegralDxBoundarySingle = isIntegralDxBoundarySingle;
semantic_pred.isGeneralFunctionBoundary = isGeneralFunctionBoundary;
semantic_pred.isEmbellished = isEmbellished;
semantic_pred.isOperator = isOperator;
semantic_pred.isRelation = isRelation;
semantic_pred.isPunctuation = isPunctuation;
semantic_pred.isFence = isFence;
semantic_pred.isElligibleEmbellishedFence = isElligibleEmbellishedFence;
semantic_pred.isTableOrMultiline = isTableOrMultiline;
semantic_pred.tableIsMatrixOrVector = tableIsMatrixOrVector;
semantic_pred.isFencedElement = isFencedElement;
semantic_pred.tableIsCases = tableIsCases;
semantic_pred.tableIsMultiline = tableIsMultiline;
semantic_pred.lineIsLabelled = lineIsLabelled;
semantic_pred.isBinomial = isBinomial;
semantic_pred.isLimitBase = isLimitBase;
semantic_pred.isSimpleFunctionHead = isSimpleFunctionHead;
semantic_pred.singlePunctAtPosition = singlePunctAtPosition;
semantic_pred.isSimpleFunction = isSimpleFunction;
semantic_pred.isSetNode = isSetNode;
semantic_pred.isSingletonSetContent = isSingletonSetContent;
semantic_pred.isUnitCounter = isUnitCounter;
semantic_pred.isPureUnit = isPureUnit;
semantic_pred.isUnitProduct = isUnitProduct;
semantic_pred.isImplicit = isImplicit;
semantic_pred.isImplicitOp = isImplicitOp;
semantic_pred.isNeutralFence = isNeutralFence;
semantic_pred.compareNeutralFences = compareNeutralFences;
semantic_pred.elligibleLeftNeutral = elligibleLeftNeutral;
semantic_pred.elligibleRightNeutral = elligibleRightNeutral;
semantic_pred.isMembership = isMembership;
const semantic_attr_js_1$6 = semantic_attr;
const semantic_meaning_js_1$r = semantic_meaning;
const semantic_util_js_1$b = semantic_util;
function isType(node, attr) {
  return node.type === attr;
}
function embellishedType(node, attr) {
  return node.embellished === attr;
}
function isRole(node, attr) {
  return node.role === attr;
}
function isAccent(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.FENCE) || isType(node, semantic_meaning_js_1$r.SemanticType.PUNCTUATION) || isType(node, semantic_meaning_js_1$r.SemanticType.OPERATOR) || isType(node, semantic_meaning_js_1$r.SemanticType.RELATION);
}
function isSimpleFunctionScope(node) {
  const children = node.childNodes;
  if (children.length === 0) {
    return true;
  }
  if (children.length > 1) {
    return false;
  }
  const child = children[0];
  if (child.type === semantic_meaning_js_1$r.SemanticType.INFIXOP) {
    if (child.role !== semantic_meaning_js_1$r.SemanticRole.IMPLICIT) {
      return false;
    }
    if (child.childNodes.some(x => isType(x, semantic_meaning_js_1$r.SemanticType.INFIXOP))) {
      return false;
    }
  }
  return true;
}
function isPrefixFunctionBoundary(node) {
  return isOperator(node) && !isRole(node, semantic_meaning_js_1$r.SemanticRole.DIVISION) || isType(node, semantic_meaning_js_1$r.SemanticType.APPL) || isGeneralFunctionBoundary(node);
}
function isBigOpBoundary(node) {
  return isOperator(node) || isGeneralFunctionBoundary(node);
}
function isIntegralDxBoundary(firstNode, secondNode) {
  return !!secondNode && isType(secondNode, semantic_meaning_js_1$r.SemanticType.IDENTIFIER) && semantic_attr_js_1$6.SemanticMap.Secondary.has(firstNode.textContent, semantic_meaning_js_1$r.SemanticSecondary.D);
}
function isIntegralDxBoundarySingle(node) {
  if (isType(node, semantic_meaning_js_1$r.SemanticType.IDENTIFIER)) {
    const firstChar = node.textContent[0];
    return firstChar && node.textContent[1] && semantic_attr_js_1$6.SemanticMap.Secondary.has(firstChar, semantic_meaning_js_1$r.SemanticSecondary.D);
  }
  return false;
}
function isGeneralFunctionBoundary(node) {
  return isRelation(node) || isPunctuation(node);
}
function isEmbellished(node) {
  if (node.embellished) {
    return node.embellished;
  }
  if (isEmbellishedType(node.type)) {
    return node.type;
  }
  return null;
}
function isEmbellishedType(type) {
  return type === semantic_meaning_js_1$r.SemanticType.OPERATOR || type === semantic_meaning_js_1$r.SemanticType.RELATION || type === semantic_meaning_js_1$r.SemanticType.FENCE || type === semantic_meaning_js_1$r.SemanticType.PUNCTUATION;
}
function isOperator(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.OPERATOR) || embellishedType(node, semantic_meaning_js_1$r.SemanticType.OPERATOR);
}
function isRelation(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.RELATION) || embellishedType(node, semantic_meaning_js_1$r.SemanticType.RELATION);
}
function isPunctuation(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.PUNCTUATION) || embellishedType(node, semantic_meaning_js_1$r.SemanticType.PUNCTUATION);
}
function isFence(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.FENCE) || embellishedType(node, semantic_meaning_js_1$r.SemanticType.FENCE);
}
function isElligibleEmbellishedFence(node) {
  if (!node || !isFence(node)) {
    return false;
  }
  if (!node.embellished) {
    return true;
  }
  return recurseBaseNode(node);
}
function bothSide(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.TENSOR) && (!isType(node.childNodes[1], semantic_meaning_js_1$r.SemanticType.EMPTY) || !isType(node.childNodes[2], semantic_meaning_js_1$r.SemanticType.EMPTY)) && (!isType(node.childNodes[3], semantic_meaning_js_1$r.SemanticType.EMPTY) || !isType(node.childNodes[4], semantic_meaning_js_1$r.SemanticType.EMPTY));
}
function recurseBaseNode(node) {
  if (!node.embellished) {
    return true;
  }
  if (bothSide(node)) {
    return false;
  }
  if (isRole(node, semantic_meaning_js_1$r.SemanticRole.CLOSE) && isType(node, semantic_meaning_js_1$r.SemanticType.TENSOR)) {
    return false;
  }
  if (isRole(node, semantic_meaning_js_1$r.SemanticRole.OPEN) && (isType(node, semantic_meaning_js_1$r.SemanticType.SUBSCRIPT) || isType(node, semantic_meaning_js_1$r.SemanticType.SUPERSCRIPT))) {
    return false;
  }
  return recurseBaseNode(node.childNodes[0]);
}
function isTableOrMultiline(node) {
  return !!node && (isType(node, semantic_meaning_js_1$r.SemanticType.TABLE) || isType(node, semantic_meaning_js_1$r.SemanticType.MULTILINE));
}
function tableIsMatrixOrVector(node) {
  return !!node && isFencedElement(node) && isTableOrMultiline(node.childNodes[0]);
}
function isFencedElement(node) {
  return !!node && isType(node, semantic_meaning_js_1$r.SemanticType.FENCED) && (isRole(node, semantic_meaning_js_1$r.SemanticRole.LEFTRIGHT) || isNeutralFence(node)) && node.childNodes.length === 1;
}
function tableIsCases(_table, prevNodes) {
  return prevNodes.length > 0 && isRole(prevNodes[prevNodes.length - 1], semantic_meaning_js_1$r.SemanticRole.OPENFENCE);
}
function tableIsMultiline(table) {
  return table.childNodes.every(function (row) {
    const length = row.childNodes.length;
    return length <= 1;
  });
}
function lineIsLabelled(line) {
  return isType(line, semantic_meaning_js_1$r.SemanticType.LINE) && line.contentNodes.length && isRole(line.contentNodes[0], semantic_meaning_js_1$r.SemanticRole.LABEL);
}
function isBinomial(table) {
  return table.childNodes.length === 2;
}
function isLimitBase(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.LARGEOP) || isType(node, semantic_meaning_js_1$r.SemanticType.LIMBOTH) || isType(node, semantic_meaning_js_1$r.SemanticType.LIMLOWER) || isType(node, semantic_meaning_js_1$r.SemanticType.LIMUPPER) || isType(node, semantic_meaning_js_1$r.SemanticType.FUNCTION) && isRole(node, semantic_meaning_js_1$r.SemanticRole.LIMFUNC) || (isType(node, semantic_meaning_js_1$r.SemanticType.OVERSCORE) || isType(node, semantic_meaning_js_1$r.SemanticType.UNDERSCORE)) && isLimitBase(node.childNodes[0]);
}
function isSimpleFunctionHead(node) {
  return node.type === semantic_meaning_js_1$r.SemanticType.IDENTIFIER || node.role === semantic_meaning_js_1$r.SemanticRole.LATINLETTER || node.role === semantic_meaning_js_1$r.SemanticRole.GREEKLETTER || node.role === semantic_meaning_js_1$r.SemanticRole.OTHERLETTER;
}
function singlePunctAtPosition(nodes, puncts, position) {
  return puncts.length === 1 && (nodes[position].type === semantic_meaning_js_1$r.SemanticType.PUNCTUATION || nodes[position].embellished === semantic_meaning_js_1$r.SemanticType.PUNCTUATION) && nodes[position] === puncts[0];
}
function isSimpleFunction(node) {
  return isType(node, semantic_meaning_js_1$r.SemanticType.IDENTIFIER) && isRole(node, semantic_meaning_js_1$r.SemanticRole.SIMPLEFUNC);
}
function isLeftBrace(node) {
  const leftBrace = ['{', '﹛', '｛'];
  return !!node && leftBrace.indexOf(node.textContent) !== -1;
}
function isRightBrace(node) {
  const rightBrace = ['}', '﹜', '｝'];
  return !!node && rightBrace.indexOf(node.textContent) !== -1;
}
function isSetNode(node) {
  return isLeftBrace(node.contentNodes[0]) && isRightBrace(node.contentNodes[1]);
}
const illegalSingleton = [semantic_meaning_js_1$r.SemanticType.PUNCTUATION, semantic_meaning_js_1$r.SemanticType.PUNCTUATED, semantic_meaning_js_1$r.SemanticType.RELSEQ, semantic_meaning_js_1$r.SemanticType.MULTIREL, semantic_meaning_js_1$r.SemanticType.TABLE, semantic_meaning_js_1$r.SemanticType.MULTILINE, semantic_meaning_js_1$r.SemanticType.CASES, semantic_meaning_js_1$r.SemanticType.INFERENCE];
const scriptedElement = [semantic_meaning_js_1$r.SemanticType.LIMUPPER, semantic_meaning_js_1$r.SemanticType.LIMLOWER, semantic_meaning_js_1$r.SemanticType.LIMBOTH, semantic_meaning_js_1$r.SemanticType.SUBSCRIPT, semantic_meaning_js_1$r.SemanticType.SUPERSCRIPT, semantic_meaning_js_1$r.SemanticType.UNDERSCORE, semantic_meaning_js_1$r.SemanticType.OVERSCORE, semantic_meaning_js_1$r.SemanticType.TENSOR];
function isSingletonSetContent(node) {
  const type = node.type;
  if (illegalSingleton.indexOf(type) !== -1 || type === semantic_meaning_js_1$r.SemanticType.INFIXOP && node.role !== semantic_meaning_js_1$r.SemanticRole.IMPLICIT) {
    return false;
  }
  if (type === semantic_meaning_js_1$r.SemanticType.FENCED) {
    return node.role === semantic_meaning_js_1$r.SemanticRole.LEFTRIGHT ? isSingletonSetContent(node.childNodes[0]) : true;
  }
  if (scriptedElement.indexOf(type) !== -1) {
    return isSingletonSetContent(node.childNodes[0]);
  }
  return true;
}
function isNumber(node) {
  return node.type === semantic_meaning_js_1$r.SemanticType.NUMBER && (node.role === semantic_meaning_js_1$r.SemanticRole.INTEGER || node.role === semantic_meaning_js_1$r.SemanticRole.FLOAT);
}
function isUnitCounter(node) {
  return isNumber(node) || node.role === semantic_meaning_js_1$r.SemanticRole.VULGAR || node.role === semantic_meaning_js_1$r.SemanticRole.MIXED;
}
function isPureUnit(node) {
  const children = node.childNodes;
  return node.role === semantic_meaning_js_1$r.SemanticRole.UNIT && (!children.length || children[0].role === semantic_meaning_js_1$r.SemanticRole.UNIT);
}
function isUnitProduct(node) {
  const children = node.childNodes;
  return node.type === semantic_meaning_js_1$r.SemanticType.INFIXOP && (node.role === semantic_meaning_js_1$r.SemanticRole.MULTIPLICATION || node.role === semantic_meaning_js_1$r.SemanticRole.IMPLICIT) && children.length && (isPureUnit(children[0]) || isUnitCounter(children[0])) && node.childNodes.slice(1).every(isPureUnit);
}
function isImplicit(node) {
  return node.type === semantic_meaning_js_1$r.SemanticType.INFIXOP && (node.role === semantic_meaning_js_1$r.SemanticRole.IMPLICIT || node.role === semantic_meaning_js_1$r.SemanticRole.UNIT && !!node.contentNodes.length && node.contentNodes[0].textContent === semantic_attr_js_1$6.NamedSymbol.invisibleTimes);
}
function isImplicitOp(node) {
  return node.type === semantic_meaning_js_1$r.SemanticType.INFIXOP && node.role === semantic_meaning_js_1$r.SemanticRole.IMPLICIT;
}
function isNeutralFence(fence) {
  return fence.role === semantic_meaning_js_1$r.SemanticRole.NEUTRAL || fence.role === semantic_meaning_js_1$r.SemanticRole.METRIC;
}
function compareNeutralFences(fence1, fence2) {
  return isNeutralFence(fence1) && isNeutralFence(fence2) && (0, semantic_util_js_1$b.getEmbellishedInner)(fence1).textContent === (0, semantic_util_js_1$b.getEmbellishedInner)(fence2).textContent;
}
function elligibleLeftNeutral(fence) {
  if (!isNeutralFence(fence)) {
    return false;
  }
  if (!fence.embellished) {
    return true;
  }
  if (fence.type === semantic_meaning_js_1$r.SemanticType.SUPERSCRIPT || fence.type === semantic_meaning_js_1$r.SemanticType.SUBSCRIPT) {
    return false;
  }
  if (fence.type === semantic_meaning_js_1$r.SemanticType.TENSOR && (fence.childNodes[3].type !== semantic_meaning_js_1$r.SemanticType.EMPTY || fence.childNodes[4].type !== semantic_meaning_js_1$r.SemanticType.EMPTY)) {
    return false;
  }
  return true;
}
function elligibleRightNeutral(fence) {
  if (!isNeutralFence(fence)) {
    return false;
  }
  if (!fence.embellished) {
    return true;
  }
  if (fence.type === semantic_meaning_js_1$r.SemanticType.TENSOR && (fence.childNodes[1].type !== semantic_meaning_js_1$r.SemanticType.EMPTY || fence.childNodes[2].type !== semantic_meaning_js_1$r.SemanticType.EMPTY)) {
    return false;
  }
  return true;
}
function isMembership(element) {
  return [semantic_meaning_js_1$r.SemanticRole.ELEMENT, semantic_meaning_js_1$r.SemanticRole.NONELEMENT, semantic_meaning_js_1$r.SemanticRole.REELEMENT, semantic_meaning_js_1$r.SemanticRole.RENONELEMENT].includes(element.role);
}

Object.defineProperty(semantic_processor, "__esModule", {
  value: true
});
semantic_processor.SemanticProcessor = void 0;
const DomUtil$u = dom_util;
const semantic_attr_js_1$5 = semantic_attr;
const semantic_meaning_js_1$q = semantic_meaning;
const semantic_heuristic_factory_js_1$3 = semantic_heuristic_factory;
const semantic_node_factory_js_1$2 = semantic_node_factory;
const SemanticPred$3 = semantic_pred;
const SemanticUtil$3 = semantic_util;
const semantic_util_js_1$a = semantic_util;
class SemanticProcessor {
  static getInstance() {
    SemanticProcessor.instance = SemanticProcessor.instance || new SemanticProcessor();
    return SemanticProcessor.instance;
  }
  static tableToMultiline(table) {
    if (!SemanticPred$3.tableIsMultiline(table)) {
      return semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('rewrite_subcases', table, SemanticProcessor.classifyTable);
    }
    table.type = semantic_meaning_js_1$q.SemanticType.MULTILINE;
    for (let i = 0, row; row = table.childNodes[i]; i++) {
      SemanticProcessor.rowToLine_(row, semantic_meaning_js_1$q.SemanticRole.MULTILINE);
    }
    if (table.childNodes.length === 1 && !SemanticPred$3.lineIsLabelled(table.childNodes[0]) && SemanticPred$3.isFencedElement(table.childNodes[0].childNodes[0])) {
      SemanticProcessor.tableToMatrixOrVector_(SemanticProcessor.rewriteFencedLine_(table));
    }
    SemanticProcessor.binomialForm_(table);
    SemanticProcessor.classifyMultiline(table);
    return table;
  }
  static number(node) {
    if (node.type === semantic_meaning_js_1$q.SemanticType.UNKNOWN || node.type === semantic_meaning_js_1$q.SemanticType.IDENTIFIER) {
      node.type = semantic_meaning_js_1$q.SemanticType.NUMBER;
    }
    SemanticProcessor.meaningFromContent(node, SemanticProcessor.numberRole_);
    SemanticProcessor.exprFont_(node);
  }
  static classifyMultiline(multiline) {
    let index = 0;
    const length = multiline.childNodes.length;
    let line;
    while (index < length && (!(line = multiline.childNodes[index]) || !line.childNodes.length)) {
      index++;
    }
    if (index >= length) {
      return;
    }
    const firstRole = line.childNodes[0].role;
    if (firstRole !== semantic_meaning_js_1$q.SemanticRole.UNKNOWN && multiline.childNodes.every(function (x) {
      const cell = x.childNodes[0];
      return !cell || cell.role === firstRole && (SemanticPred$3.isType(cell, semantic_meaning_js_1$q.SemanticType.RELATION) || SemanticPred$3.isType(cell, semantic_meaning_js_1$q.SemanticType.RELSEQ));
    })) {
      multiline.role = firstRole;
    }
  }
  static classifyTable(table) {
    const columns = SemanticProcessor.computeColumns_(table);
    SemanticProcessor.classifyByColumns_(table, columns, semantic_meaning_js_1$q.SemanticRole.EQUALITY) || SemanticProcessor.classifyByColumns_(table, columns, semantic_meaning_js_1$q.SemanticRole.INEQUALITY, [semantic_meaning_js_1$q.SemanticRole.EQUALITY]) || SemanticProcessor.classifyByColumns_(table, columns, semantic_meaning_js_1$q.SemanticRole.ARROW) || SemanticProcessor.detectCaleyTable(table);
    return table;
  }
  static detectCaleyTable(table) {
    if (!table.mathmlTree) {
      return false;
    }
    const tree = table.mathmlTree;
    const cl = tree.getAttribute('columnlines');
    const rl = tree.getAttribute('rowlines');
    if (!cl || !rl) {
      return false;
    }
    if (SemanticProcessor.cayleySpacing(cl) && SemanticProcessor.cayleySpacing(rl)) {
      table.role = semantic_meaning_js_1$q.SemanticRole.CAYLEY;
      return true;
    }
    return false;
  }
  static cayleySpacing(lines) {
    const list = lines.split(' ');
    return (list[0] === 'solid' || list[0] === 'dashed') && list.slice(1).every(x => x === 'none');
  }
  static proof(node, semantics, parse) {
    const attrs = SemanticProcessor.separateSemantics(semantics);
    return SemanticProcessor.getInstance().proof(node, attrs, parse);
  }
  static findSemantics(node, attr, opt_value) {
    const value = opt_value == null ? null : opt_value;
    const semantics = SemanticProcessor.getSemantics(node);
    if (!semantics) {
      return false;
    }
    if (!semantics[attr]) {
      return false;
    }
    return value == null ? true : semantics[attr] === value;
  }
  static getSemantics(node) {
    const semantics = node.getAttribute('semantics');
    if (!semantics) {
      return null;
    }
    return SemanticProcessor.separateSemantics(semantics);
  }
  static removePrefix(name) {
    const [, ...rest] = name.split('_');
    return rest.join('_');
  }
  static separateSemantics(attr) {
    const result = {};
    attr.split(';').forEach(function (x) {
      const [name, value] = x.split(':');
      result[SemanticProcessor.removePrefix(name)] = value;
    });
    return result;
  }
  static matchSpaces_(nodes, ops) {
    for (let i = 0, op; op = ops[i]; i++) {
      const node = nodes[i];
      const mt1 = node.mathmlTree;
      const mt2 = nodes[i + 1].mathmlTree;
      if (!mt1 || !mt2) {
        continue;
      }
      const sibling = mt1.nextSibling;
      if (!sibling || sibling === mt2) {
        continue;
      }
      const spacer = SemanticProcessor.getSpacer_(sibling);
      if (spacer) {
        op.mathml.push(spacer);
        op.mathmlTree = spacer;
        op.role = semantic_meaning_js_1$q.SemanticRole.SPACE;
      }
    }
  }
  static getSpacer_(node) {
    if (DomUtil$u.tagName(node) === semantic_util_js_1$a.MMLTAGS.MSPACE) {
      return node;
    }
    while (SemanticUtil$3.hasEmptyTag(node) && node.childNodes.length === 1) {
      node = node.childNodes[0];
      if (DomUtil$u.tagName(node) === semantic_util_js_1$a.MMLTAGS.MSPACE) {
        return node;
      }
    }
    return null;
  }
  static fenceToPunct_(fence) {
    const newRole = SemanticProcessor.FENCE_TO_PUNCT_[fence.role];
    if (!newRole) {
      return;
    }
    while (fence.embellished) {
      fence.embellished = semantic_meaning_js_1$q.SemanticType.PUNCTUATION;
      if (!(SemanticPred$3.isRole(fence, semantic_meaning_js_1$q.SemanticRole.SUBSUP) || SemanticPred$3.isRole(fence, semantic_meaning_js_1$q.SemanticRole.UNDEROVER))) {
        fence.role = newRole;
      }
      fence = fence.childNodes[0];
    }
    fence.type = semantic_meaning_js_1$q.SemanticType.PUNCTUATION;
    fence.role = newRole;
  }
  static classifyFunction_(funcNode, restNodes) {
    if (funcNode.type === semantic_meaning_js_1$q.SemanticType.APPL || funcNode.type === semantic_meaning_js_1$q.SemanticType.BIGOP || funcNode.type === semantic_meaning_js_1$q.SemanticType.INTEGRAL) {
      return '';
    }
    if (restNodes[0] && restNodes[0].textContent === semantic_attr_js_1$5.NamedSymbol.functionApplication) {
      SemanticProcessor.getInstance().funcAppls[funcNode.id] = restNodes.shift();
      let role = semantic_meaning_js_1$q.SemanticRole.SIMPLEFUNC;
      semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('simple2prefix', funcNode);
      if (funcNode.role === semantic_meaning_js_1$q.SemanticRole.PREFIXFUNC || funcNode.role === semantic_meaning_js_1$q.SemanticRole.LIMFUNC) {
        role = funcNode.role;
      }
      SemanticProcessor.propagateFunctionRole_(funcNode, role);
      return 'prefix';
    }
    const kind = SemanticProcessor.CLASSIFY_FUNCTION_[funcNode.role];
    return kind ? kind : SemanticPred$3.isSimpleFunctionHead(funcNode) ? 'simple' : '';
  }
  static propagateFunctionRole_(funcNode, tag) {
    if (funcNode) {
      if (funcNode.type === semantic_meaning_js_1$q.SemanticType.INFIXOP) {
        return;
      }
      if (!(SemanticPred$3.isRole(funcNode, semantic_meaning_js_1$q.SemanticRole.SUBSUP) || SemanticPred$3.isRole(funcNode, semantic_meaning_js_1$q.SemanticRole.UNDEROVER))) {
        funcNode.role = tag;
      }
      SemanticProcessor.propagateFunctionRole_(funcNode.childNodes[0], tag);
    }
  }
  static getFunctionOp_(tree, pred) {
    if (pred(tree)) {
      return tree;
    }
    for (let i = 0, child; child = tree.childNodes[i]; i++) {
      const op = SemanticProcessor.getFunctionOp_(child, pred);
      if (op) {
        return op;
      }
    }
    return null;
  }
  static tableToMatrixOrVector_(node) {
    const matrix = node.childNodes[0];
    SemanticPred$3.isType(matrix, semantic_meaning_js_1$q.SemanticType.MULTILINE) ? SemanticProcessor.tableToVector_(node) : SemanticProcessor.tableToMatrix_(node);
    node.contentNodes.forEach(matrix.appendContentNode.bind(matrix));
    for (let i = 0, row; row = matrix.childNodes[i]; i++) {
      SemanticProcessor.assignRoleToRow_(row, SemanticProcessor.getComponentRoles_(matrix));
    }
    matrix.parent = null;
    return matrix;
  }
  static tableToVector_(node) {
    const vector = node.childNodes[0];
    vector.type = semantic_meaning_js_1$q.SemanticType.VECTOR;
    if (vector.childNodes.length === 1) {
      SemanticProcessor.tableToSquare_(node);
      return;
    }
    SemanticProcessor.binomialForm_(vector);
  }
  static binomialForm_(node) {
    if (!SemanticPred$3.isRole(node, semantic_meaning_js_1$q.SemanticRole.UNKNOWN)) {
      return;
    }
    if (SemanticPred$3.isBinomial(node)) {
      node.role = semantic_meaning_js_1$q.SemanticRole.BINOMIAL;
      node.childNodes[0].role = semantic_meaning_js_1$q.SemanticRole.BINOMIAL;
      node.childNodes[1].role = semantic_meaning_js_1$q.SemanticRole.BINOMIAL;
    }
  }
  static tableToMatrix_(node) {
    const matrix = node.childNodes[0];
    matrix.type = semantic_meaning_js_1$q.SemanticType.MATRIX;
    if (matrix.childNodes && matrix.childNodes.length > 0 && matrix.childNodes[0].childNodes && matrix.childNodes.length === matrix.childNodes[0].childNodes.length) {
      SemanticProcessor.tableToSquare_(node);
      return;
    }
    if (matrix.childNodes && matrix.childNodes.length === 1) {
      matrix.role = semantic_meaning_js_1$q.SemanticRole.ROWVECTOR;
    }
  }
  static tableToSquare_(node) {
    const matrix = node.childNodes[0];
    if (!SemanticPred$3.isRole(matrix, semantic_meaning_js_1$q.SemanticRole.UNKNOWN)) {
      return;
    }
    if (SemanticPred$3.isNeutralFence(node)) {
      matrix.role = semantic_meaning_js_1$q.SemanticRole.DETERMINANT;
      return;
    }
    matrix.role = semantic_meaning_js_1$q.SemanticRole.SQUAREMATRIX;
  }
  static getComponentRoles_(node) {
    const role = node.role;
    if (role && role !== semantic_meaning_js_1$q.SemanticRole.UNKNOWN) {
      return role;
    }
    return node.type.toLowerCase() || semantic_meaning_js_1$q.SemanticRole.UNKNOWN;
  }
  static tableToCases_(table, openFence) {
    for (let i = 0, row; row = table.childNodes[i]; i++) {
      SemanticProcessor.assignRoleToRow_(row, semantic_meaning_js_1$q.SemanticRole.CASES);
    }
    table.type = semantic_meaning_js_1$q.SemanticType.CASES;
    table.appendContentNode(openFence);
    if (SemanticPred$3.tableIsMultiline(table)) {
      SemanticProcessor.binomialForm_(table);
    }
    return table;
  }
  static rewriteFencedLine_(table) {
    const line = table.childNodes[0];
    const fenced = table.childNodes[0].childNodes[0];
    const element = table.childNodes[0].childNodes[0].childNodes[0];
    fenced.parent = table.parent;
    table.parent = fenced;
    element.parent = line;
    fenced.childNodes = [table];
    line.childNodes = [element];
    return fenced;
  }
  static rowToLine_(row, opt_role) {
    const role = opt_role || semantic_meaning_js_1$q.SemanticRole.UNKNOWN;
    if (SemanticPred$3.isType(row, semantic_meaning_js_1$q.SemanticType.ROW)) {
      row.type = semantic_meaning_js_1$q.SemanticType.LINE;
      row.role = role;
      if (row.childNodes.length === 1 && SemanticPred$3.isType(row.childNodes[0], semantic_meaning_js_1$q.SemanticType.CELL)) {
        row.childNodes = row.childNodes[0].childNodes;
        row.childNodes.forEach(function (x) {
          x.parent = row;
        });
      }
    }
  }
  static assignRoleToRow_(row, role) {
    if (SemanticPred$3.isType(row, semantic_meaning_js_1$q.SemanticType.LINE)) {
      row.role = role;
      return;
    }
    if (SemanticPred$3.isType(row, semantic_meaning_js_1$q.SemanticType.ROW)) {
      row.role = role;
      row.childNodes.forEach(function (cell) {
        if (SemanticPred$3.isType(cell, semantic_meaning_js_1$q.SemanticType.CELL)) {
          cell.role = role;
        }
      });
    }
  }
  static nextSeparatorFunction_(separators) {
    let sepList;
    if (separators) {
      if (separators.match(/^\s+$/)) {
        return null;
      } else {
        sepList = separators.replace(/\s/g, '').split('').filter(function (x) {
          return x;
        });
      }
    } else {
      sepList = [','];
    }
    return function () {
      if (sepList.length > 1) {
        return sepList.shift();
      }
      return sepList[0];
    };
  }
  static meaningFromContent(node, func) {
    const content = [...node.textContent].filter(x => x.match(/[^\s]/));
    const meaning = content.map(x => semantic_attr_js_1$5.SemanticMap.Meaning.get(x));
    func(node, content, meaning);
  }
  static numberRole_(node, content, meaning) {
    if (node.role !== semantic_meaning_js_1$q.SemanticRole.UNKNOWN) {
      return;
    }
    if (meaning.every(function (x) {
      return x.type === semantic_meaning_js_1$q.SemanticType.NUMBER && x.role === semantic_meaning_js_1$q.SemanticRole.INTEGER || x.type === semantic_meaning_js_1$q.SemanticType.PUNCTUATION && x.role === semantic_meaning_js_1$q.SemanticRole.COMMA;
    })) {
      node.role = semantic_meaning_js_1$q.SemanticRole.INTEGER;
      if (content[0] === '0') {
        node.addAnnotation('general', 'basenumber');
      }
      return;
    }
    if (meaning.every(function (x) {
      return x.type === semantic_meaning_js_1$q.SemanticType.NUMBER && x.role === semantic_meaning_js_1$q.SemanticRole.INTEGER || x.type === semantic_meaning_js_1$q.SemanticType.PUNCTUATION;
    })) {
      node.role = semantic_meaning_js_1$q.SemanticRole.FLOAT;
      return;
    }
    node.role = semantic_meaning_js_1$q.SemanticRole.OTHERNUMBER;
  }
  static exprFont_(node) {
    if (node.font !== semantic_meaning_js_1$q.SemanticFont.UNKNOWN) {
      return;
    }
    SemanticProcessor.compSemantics(node, 'font', semantic_meaning_js_1$q.SemanticFont);
  }
  static compSemantics(node, field, sem) {
    const content = [...node.textContent];
    const meaning = content.map(x => semantic_attr_js_1$5.SemanticMap.Meaning.get(x));
    const single = meaning.reduce(function (prev, curr) {
      if (!prev || !curr[field] || curr[field] === sem.UNKNOWN || curr[field] === prev) {
        return prev;
      }
      if (prev === sem.UNKNOWN) {
        return curr[field];
      }
      return null;
    }, sem.UNKNOWN);
    if (single) {
      node[field] = single;
    }
  }
  static purgeFences_(partition) {
    const rel = partition.rel;
    const comp = partition.comp;
    const newRel = [];
    const newComp = [];
    while (rel.length > 0) {
      const currentRel = rel.shift();
      let currentComp = comp.shift();
      if (SemanticPred$3.isElligibleEmbellishedFence(currentRel)) {
        newRel.push(currentRel);
        newComp.push(currentComp);
        continue;
      }
      SemanticProcessor.fenceToPunct_(currentRel);
      currentComp.push(currentRel);
      currentComp = currentComp.concat(comp.shift());
      comp.unshift(currentComp);
    }
    newComp.push(comp.shift());
    return {
      rel: newRel,
      comp: newComp
    };
  }
  static rewriteFencedNode_(fenced) {
    const ofence = fenced.contentNodes[0];
    const cfence = fenced.contentNodes[1];
    let rewritten = SemanticProcessor.rewriteFence_(fenced, ofence);
    fenced.contentNodes[0] = rewritten.fence;
    rewritten = SemanticProcessor.rewriteFence_(rewritten.node, cfence);
    fenced.contentNodes[1] = rewritten.fence;
    fenced.contentNodes[0].parent = fenced;
    fenced.contentNodes[1].parent = fenced;
    rewritten.node.parent = null;
    return rewritten.node;
  }
  static rewriteFence_(node, fence) {
    if (!fence.embellished) {
      return {
        node: node,
        fence: fence
      };
    }
    const newFence = fence.childNodes[0];
    const rewritten = SemanticProcessor.rewriteFence_(node, newFence);
    if (SemanticPred$3.isType(fence, semantic_meaning_js_1$q.SemanticType.SUPERSCRIPT) || SemanticPred$3.isType(fence, semantic_meaning_js_1$q.SemanticType.SUBSCRIPT) || SemanticPred$3.isType(fence, semantic_meaning_js_1$q.SemanticType.TENSOR)) {
      if (!SemanticPred$3.isRole(fence, semantic_meaning_js_1$q.SemanticRole.SUBSUP)) {
        fence.role = node.role;
      }
      if (newFence !== rewritten.node) {
        fence.replaceChild(newFence, rewritten.node);
        newFence.parent = node;
      }
      SemanticProcessor.propagateFencePointer_(fence, newFence);
      return {
        node: fence,
        fence: rewritten.fence
      };
    }
    fence.replaceChild(newFence, rewritten.fence);
    if (fence.mathmlTree && fence.mathml.indexOf(fence.mathmlTree) === -1) {
      fence.mathml.push(fence.mathmlTree);
    }
    return {
      node: rewritten.node,
      fence: fence
    };
  }
  static propagateFencePointer_(oldNode, newNode) {
    oldNode.fencePointer = newNode.fencePointer || newNode.id.toString();
    oldNode.embellished = null;
  }
  static classifyByColumns_(table, columns, relation, alternatives = []) {
    const relations = [relation].concat(alternatives);
    const test1 = x => SemanticProcessor.isPureRelation_(x, relations);
    const test2 = x => SemanticProcessor.isEndRelation_(x, relations) || SemanticProcessor.isPureRelation_(x, relations);
    const test3 = x => SemanticProcessor.isEndRelation_(x, relations, true) || SemanticProcessor.isPureRelation_(x, relations);
    if (columns.length === 3 && SemanticProcessor.testColumns_(columns, 1, test1) || columns.length === 2 && (SemanticProcessor.testColumns_(columns, 1, test2) || SemanticProcessor.testColumns_(columns, 0, test3))) {
      table.role = relation;
      return true;
    }
    return false;
  }
  static isEndRelation_(node, relations, opt_right) {
    const position = opt_right ? node.childNodes.length - 1 : 0;
    return SemanticPred$3.isType(node, semantic_meaning_js_1$q.SemanticType.RELSEQ) && relations.some(relation => SemanticPred$3.isRole(node, relation)) && SemanticPred$3.isType(node.childNodes[position], semantic_meaning_js_1$q.SemanticType.EMPTY);
  }
  static isPureRelation_(node, relations) {
    return SemanticPred$3.isType(node, semantic_meaning_js_1$q.SemanticType.RELATION) && relations.some(relation => SemanticPred$3.isRole(node, relation));
  }
  static computeColumns_(table) {
    const columns = [];
    for (let i = 0, row; row = table.childNodes[i]; i++) {
      for (let j = 0, cell; cell = row.childNodes[j]; j++) {
        const column = columns[j];
        column ? columns[j].push(cell) : columns[j] = [cell];
      }
    }
    return columns;
  }
  static testColumns_(columns, index, pred) {
    const column = columns[index];
    return column ? column.some(function (cell) {
      return cell.childNodes.length && pred(cell.childNodes[0]);
    }) && column.every(function (cell) {
      return !cell.childNodes.length || pred(cell.childNodes[0]);
    }) : false;
  }
  setNodeFactory(factory) {
    SemanticProcessor.getInstance().factory_ = factory;
    semantic_heuristic_factory_js_1$3.SemanticHeuristics.updateFactory(SemanticProcessor.getInstance().factory_);
  }
  getNodeFactory() {
    return SemanticProcessor.getInstance().factory_;
  }
  identifierNode(leaf, font, unit) {
    if (unit === 'MathML-Unit') {
      leaf.type = semantic_meaning_js_1$q.SemanticType.IDENTIFIER;
      leaf.role = semantic_meaning_js_1$q.SemanticRole.UNIT;
    } else if (!font && leaf.textContent.length === 1 && (leaf.role === semantic_meaning_js_1$q.SemanticRole.INTEGER || leaf.role === semantic_meaning_js_1$q.SemanticRole.LATINLETTER || leaf.role === semantic_meaning_js_1$q.SemanticRole.GREEKLETTER) && leaf.font === semantic_meaning_js_1$q.SemanticFont.NORMAL) {
      leaf.font = semantic_meaning_js_1$q.SemanticFont.ITALIC;
      return semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('simpleNamedFunction', leaf);
    }
    if (leaf.type === semantic_meaning_js_1$q.SemanticType.UNKNOWN) {
      leaf.type = semantic_meaning_js_1$q.SemanticType.IDENTIFIER;
    }
    SemanticProcessor.exprFont_(leaf);
    return semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('simpleNamedFunction', leaf);
  }
  implicitNode(nodes) {
    nodes = SemanticProcessor.getInstance().getMixedNumbers_(nodes);
    nodes = SemanticProcessor.getInstance().combineUnits_(nodes);
    if (nodes.length === 1) {
      return nodes[0];
    }
    const node = SemanticProcessor.getInstance().implicitNode_(nodes);
    return semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('combine_juxtaposition', node);
  }
  text(leaf, type) {
    SemanticProcessor.exprFont_(leaf);
    leaf.type = semantic_meaning_js_1$q.SemanticType.TEXT;
    if (type === semantic_util_js_1$a.MMLTAGS.ANNOTATIONXML) {
      leaf.role = semantic_meaning_js_1$q.SemanticRole.ANNOTATION;
      return leaf;
    }
    if (type === semantic_util_js_1$a.MMLTAGS.MS) {
      leaf.role = semantic_meaning_js_1$q.SemanticRole.STRING;
      return leaf;
    }
    if (type === semantic_util_js_1$a.MMLTAGS.MSPACE || leaf.textContent.match(/^\s*$/)) {
      leaf.role = semantic_meaning_js_1$q.SemanticRole.SPACE;
      return leaf;
    }
    if ((/\s/).exec(leaf.textContent)) {
      leaf.role = semantic_meaning_js_1$q.SemanticRole.TEXT;
      return leaf;
    }
    leaf.role = semantic_meaning_js_1$q.SemanticRole.UNKNOWN;
    return leaf;
  }
  row(nodes) {
    nodes = nodes.filter(function (x) {
      return !SemanticPred$3.isType(x, semantic_meaning_js_1$q.SemanticType.EMPTY);
    });
    if (nodes.length === 0) {
      return SemanticProcessor.getInstance().factory_.makeEmptyNode();
    }
    nodes = SemanticProcessor.getInstance().getFencesInRow_(nodes);
    nodes = SemanticProcessor.getInstance().tablesInRow(nodes);
    nodes = SemanticProcessor.getInstance().getPunctuationInRow_(nodes);
    nodes = SemanticProcessor.getInstance().getTextInRow_(nodes);
    nodes = SemanticProcessor.getInstance().getFunctionsInRow_(nodes);
    return SemanticProcessor.getInstance().relationsInRow_(nodes);
  }
  limitNode(mmlTag, children) {
    if (!children.length) {
      return SemanticProcessor.getInstance().factory_.makeEmptyNode();
    }
    let center = children[0];
    let type = semantic_meaning_js_1$q.SemanticType.UNKNOWN;
    if (!children[1]) {
      return center;
    }
    let result;
    semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('op_with_limits', children);
    if (SemanticPred$3.isLimitBase(center)) {
      result = SemanticProcessor.MML_TO_LIMIT_[mmlTag];
      const length = result.length;
      type = result.type;
      children = children.slice(0, result.length + 1);
      if (length === 1 && SemanticPred$3.isAccent(children[1]) || length === 2 && SemanticPred$3.isAccent(children[1]) && SemanticPred$3.isAccent(children[2])) {
        result = SemanticProcessor.MML_TO_BOUNDS_[mmlTag];
        return SemanticProcessor.getInstance().accentNode_(center, children, result.type, result.length, result.accent);
      }
      if (length === 2) {
        if (SemanticPred$3.isAccent(children[1])) {
          center = SemanticProcessor.getInstance().accentNode_(center, [center, children[1]], ({
            MSUBSUP: semantic_meaning_js_1$q.SemanticType.SUBSCRIPT,
            MUNDEROVER: semantic_meaning_js_1$q.SemanticType.UNDERSCORE
          })[mmlTag], 1, true);
          return !children[2] ? center : SemanticProcessor.getInstance().makeLimitNode_(center, [center, children[2]], null, semantic_meaning_js_1$q.SemanticType.LIMUPPER);
        }
        if (children[2] && SemanticPred$3.isAccent(children[2])) {
          center = SemanticProcessor.getInstance().accentNode_(center, [center, children[2]], ({
            MSUBSUP: semantic_meaning_js_1$q.SemanticType.SUPERSCRIPT,
            MUNDEROVER: semantic_meaning_js_1$q.SemanticType.OVERSCORE
          })[mmlTag], 1, true);
          return SemanticProcessor.getInstance().makeLimitNode_(center, [center, children[1]], null, semantic_meaning_js_1$q.SemanticType.LIMLOWER);
        }
        if (!children[length]) {
          type = semantic_meaning_js_1$q.SemanticType.LIMLOWER;
        }
      }
      return SemanticProcessor.getInstance().makeLimitNode_(center, children, null, type);
    }
    result = SemanticProcessor.MML_TO_BOUNDS_[mmlTag];
    return SemanticProcessor.getInstance().accentNode_(center, children, result.type, result.length, result.accent);
  }
  tablesInRow(nodes) {
    let partition = SemanticUtil$3.partitionNodes(nodes, SemanticPred$3.tableIsMatrixOrVector);
    let result = [];
    for (let i = 0, matrix; matrix = partition.rel[i]; i++) {
      result = result.concat(partition.comp.shift());
      result.push(SemanticProcessor.tableToMatrixOrVector_(matrix));
    }
    result = result.concat(partition.comp.shift());
    partition = SemanticUtil$3.partitionNodes(result, SemanticPred$3.isTableOrMultiline);
    result = [];
    for (let i = 0, table; table = partition.rel[i]; i++) {
      const prevNodes = partition.comp.shift();
      if (SemanticPred$3.tableIsCases(table, prevNodes)) {
        SemanticProcessor.tableToCases_(table, prevNodes.pop());
      }
      result = result.concat(prevNodes);
      result.push(table);
    }
    return result.concat(partition.comp.shift());
  }
  mfenced(open, close, sepValue, children) {
    if (sepValue && children.length > 0) {
      const separators = SemanticProcessor.nextSeparatorFunction_(sepValue);
      const newChildren = [children.shift()];
      children.forEach(child => {
        newChildren.push(SemanticProcessor.getInstance().factory_.makeContentNode(separators()));
        newChildren.push(child);
      });
      children = newChildren;
    }
    if (open && close) {
      return SemanticProcessor.getInstance().horizontalFencedNode_(SemanticProcessor.getInstance().factory_.makeContentNode(open), SemanticProcessor.getInstance().factory_.makeContentNode(close), children);
    }
    if (open) {
      children.unshift(SemanticProcessor.getInstance().factory_.makeContentNode(open));
    }
    if (close) {
      children.push(SemanticProcessor.getInstance().factory_.makeContentNode(close));
    }
    return SemanticProcessor.getInstance().row(children);
  }
  fractionLikeNode(denom, enume, linethickness, bevelled) {
    let node;
    if (!bevelled && SemanticUtil$3.isZeroLength(linethickness)) {
      const child0 = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.LINE, [denom], []);
      const child1 = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.LINE, [enume], []);
      node = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.MULTILINE, [child0, child1], []);
      SemanticProcessor.binomialForm_(node);
      SemanticProcessor.classifyMultiline(node);
      return node;
    } else {
      node = SemanticProcessor.getInstance().fractionNode_(denom, enume);
      if (bevelled) {
        node.addAnnotation('general', 'bevelled');
      }
      return node;
    }
  }
  tensor(base, lsub, lsup, rsub, rsup) {
    const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.TENSOR, [base, SemanticProcessor.getInstance().scriptNode_(lsub, semantic_meaning_js_1$q.SemanticRole.LEFTSUB), SemanticProcessor.getInstance().scriptNode_(lsup, semantic_meaning_js_1$q.SemanticRole.LEFTSUPER), SemanticProcessor.getInstance().scriptNode_(rsub, semantic_meaning_js_1$q.SemanticRole.RIGHTSUB), SemanticProcessor.getInstance().scriptNode_(rsup, semantic_meaning_js_1$q.SemanticRole.RIGHTSUPER)], []);
    newNode.role = base.role;
    newNode.embellished = SemanticPred$3.isEmbellished(base);
    return newNode;
  }
  pseudoTensor(base, sub, sup) {
    const isEmpty = x => !SemanticPred$3.isType(x, semantic_meaning_js_1$q.SemanticType.EMPTY);
    const nonEmptySub = sub.filter(isEmpty).length;
    const nonEmptySup = sup.filter(isEmpty).length;
    if (!nonEmptySub && !nonEmptySup) {
      return base;
    }
    const mmlTag = nonEmptySub ? nonEmptySup ? semantic_util_js_1$a.MMLTAGS.MSUBSUP : semantic_util_js_1$a.MMLTAGS.MSUB : semantic_util_js_1$a.MMLTAGS.MSUP;
    const mmlchild = [base];
    if (nonEmptySub) {
      mmlchild.push(SemanticProcessor.getInstance().scriptNode_(sub, semantic_meaning_js_1$q.SemanticRole.RIGHTSUB, true));
    }
    if (nonEmptySup) {
      mmlchild.push(SemanticProcessor.getInstance().scriptNode_(sup, semantic_meaning_js_1$q.SemanticRole.RIGHTSUPER, true));
    }
    return SemanticProcessor.getInstance().limitNode(mmlTag, mmlchild);
  }
  font(font) {
    const mathjaxFont = SemanticProcessor.MATHJAX_FONTS[font];
    return mathjaxFont ? mathjaxFont : font;
  }
  proof(node, semantics, parse) {
    if (!semantics['inference'] && !semantics['axiom']) {
      console.log('Noise');
    }
    if (semantics['axiom']) {
      const cleaned = SemanticProcessor.getInstance().cleanInference(node.childNodes);
      const axiom = cleaned.length ? SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.INFERENCE, parse(cleaned), []) : SemanticProcessor.getInstance().factory_.makeEmptyNode();
      axiom.role = semantic_meaning_js_1$q.SemanticRole.AXIOM;
      axiom.mathmlTree = node;
      return axiom;
    }
    const inference = SemanticProcessor.getInstance().inference(node, semantics, parse);
    if (semantics['proof']) {
      inference.role = semantic_meaning_js_1$q.SemanticRole.PROOF;
      inference.childNodes[0].role = semantic_meaning_js_1$q.SemanticRole.FINAL;
    }
    return inference;
  }
  inference(node, semantics, parse) {
    if (semantics['inferenceRule']) {
      const formulas = SemanticProcessor.getInstance().getFormulas(node, [], parse);
      const inference = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.INFERENCE, [formulas.conclusion, formulas.premises], []);
      return inference;
    }
    const label = semantics['labelledRule'];
    const children = DomUtil$u.toArray(node.childNodes);
    const content = [];
    if (label === 'left' || label === 'both') {
      content.push(SemanticProcessor.getInstance().getLabel(node, children, parse, semantic_meaning_js_1$q.SemanticRole.LEFT));
    }
    if (label === 'right' || label === 'both') {
      content.push(SemanticProcessor.getInstance().getLabel(node, children, parse, semantic_meaning_js_1$q.SemanticRole.RIGHT));
    }
    const formulas = SemanticProcessor.getInstance().getFormulas(node, children, parse);
    const inference = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.INFERENCE, [formulas.conclusion, formulas.premises], content);
    inference.mathmlTree = node;
    return inference;
  }
  getLabel(_node, children, parse, side) {
    const label = SemanticProcessor.getInstance().findNestedRow(children, 'prooflabel', side);
    const sem = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.RULELABEL, parse(DomUtil$u.toArray(label.childNodes)), []);
    sem.role = side;
    sem.mathmlTree = label;
    return sem;
  }
  getFormulas(node, children, parse) {
    const inf = children.length ? SemanticProcessor.getInstance().findNestedRow(children, 'inferenceRule') : node;
    const up = SemanticProcessor.getSemantics(inf)['inferenceRule'] === 'up';
    const premRow = up ? inf.childNodes[1] : inf.childNodes[0];
    const concRow = up ? inf.childNodes[0] : inf.childNodes[1];
    const premTable = premRow.childNodes[0].childNodes[0];
    const topRow = DomUtil$u.toArray(premTable.childNodes[0].childNodes);
    const premNodes = [];
    let i = 1;
    for (const cell of topRow) {
      if (i % 2) {
        premNodes.push(cell.childNodes[0]);
      }
      i++;
    }
    const premises = parse(premNodes);
    const conclusion = parse(DomUtil$u.toArray(concRow.childNodes[0].childNodes))[0];
    const prem = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.PREMISES, premises, []);
    prem.mathmlTree = premTable;
    const conc = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.CONCLUSION, [conclusion], []);
    conc.mathmlTree = concRow.childNodes[0].childNodes[0];
    return {
      conclusion: conc,
      premises: prem
    };
  }
  findNestedRow(nodes, semantic, opt_value) {
    return SemanticProcessor.getInstance().findNestedRow_(nodes, semantic, 0, opt_value);
  }
  cleanInference(nodes) {
    return DomUtil$u.toArray(nodes).filter(function (x) {
      return DomUtil$u.tagName(x) !== 'MSPACE';
    });
  }
  operatorNode(node) {
    if (node.type === semantic_meaning_js_1$q.SemanticType.UNKNOWN) {
      node.type = semantic_meaning_js_1$q.SemanticType.OPERATOR;
    }
    return semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('multioperator', node);
  }
  constructor() {
    this.funcAppls = {};
    this.splitRoles = new Map([[semantic_meaning_js_1$q.SemanticRole.SUBTRACTION, semantic_meaning_js_1$q.SemanticRole.NEGATIVE], [semantic_meaning_js_1$q.SemanticRole.ADDITION, semantic_meaning_js_1$q.SemanticRole.POSITIVE]]);
    this.splitOps = ['−', '-', '‐', '‑', '+'];
    this.factory_ = new semantic_node_factory_js_1$2.SemanticNodeFactory();
    semantic_heuristic_factory_js_1$3.SemanticHeuristics.updateFactory(this.factory_);
  }
  implicitNode_(nodes) {
    const operators = SemanticProcessor.getInstance().factory_.makeMultipleContentNodes(nodes.length - 1, semantic_attr_js_1$5.NamedSymbol.invisibleTimes);
    SemanticProcessor.matchSpaces_(nodes, operators);
    const newNode = SemanticProcessor.getInstance().infixNode_(nodes, operators[0]);
    newNode.role = semantic_meaning_js_1$q.SemanticRole.IMPLICIT;
    operators.forEach(function (op) {
      op.parent = newNode;
    });
    newNode.contentNodes = operators;
    return newNode;
  }
  infixNode_(children, opNode) {
    const node = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.INFIXOP, children, [opNode], SemanticUtil$3.getEmbellishedInner(opNode).textContent);
    node.role = opNode.role;
    return semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('propagateSimpleFunction', node);
  }
  explicitMixed_(nodes) {
    const partition = SemanticUtil$3.partitionNodes(nodes, function (x) {
      return x.textContent === semantic_attr_js_1$5.NamedSymbol.invisiblePlus;
    });
    if (!partition.rel.length) {
      return nodes;
    }
    let result = [];
    for (let i = 0, rel; rel = partition.rel[i]; i++) {
      const prev = partition.comp[i];
      const next = partition.comp[i + 1];
      const last = prev.length - 1;
      if (prev[last] && next[0] && SemanticPred$3.isType(prev[last], semantic_meaning_js_1$q.SemanticType.NUMBER) && !SemanticPred$3.isRole(prev[last], semantic_meaning_js_1$q.SemanticRole.MIXED) && SemanticPred$3.isType(next[0], semantic_meaning_js_1$q.SemanticType.FRACTION)) {
        const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.NUMBER, [prev[last], next[0]], []);
        newNode.role = semantic_meaning_js_1$q.SemanticRole.MIXED;
        result = result.concat(prev.slice(0, last));
        result.push(newNode);
        next.shift();
      } else {
        result = result.concat(prev);
        result.push(rel);
      }
    }
    return result.concat(partition.comp[partition.comp.length - 1]);
  }
  concatNode_(inner, nodeList, type) {
    if (nodeList.length === 0) {
      return inner;
    }
    const content = nodeList.map(function (x) {
      return SemanticUtil$3.getEmbellishedInner(x).textContent;
    }).join(' ');
    const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(type, [inner], nodeList, content);
    if (nodeList.length > 1) {
      newNode.role = semantic_meaning_js_1$q.SemanticRole.MULTIOP;
    }
    return newNode;
  }
  prefixNode_(node, prefixes) {
    const newPrefixes = this.splitSingles(prefixes);
    let newNode = node;
    while (newPrefixes.length > 0) {
      const op = newPrefixes.pop();
      newNode = SemanticProcessor.getInstance().concatNode_(newNode, op, semantic_meaning_js_1$q.SemanticType.PREFIXOP);
      if (op.length === 1 && this.splitOps.indexOf(op[0].textContent) !== -1) {
        newNode.role = this.splitRoles.get(op[0].role);
      }
    }
    return newNode;
  }
  splitSingles(prefixes) {
    let lastOp = 0;
    const result = [];
    let i = 0;
    while (i < prefixes.length) {
      const op = prefixes[i];
      if (this.splitRoles.has(op.role) && (!prefixes[i - 1] || prefixes[i - 1].role !== op.role) && (!prefixes[i + 1] || prefixes[i + 1].role !== op.role) && this.splitOps.indexOf(op.textContent) !== -1) {
        result.push(prefixes.slice(lastOp, i));
        result.push(prefixes.slice(i, i + 1));
        lastOp = i + 1;
      }
      i++;
    }
    if (lastOp < i) {
      result.push(prefixes.slice(lastOp, i));
    }
    return result;
  }
  postfixNode_(node, postfixes) {
    if (!postfixes.length) {
      return node;
    }
    return SemanticProcessor.getInstance().concatNode_(node, postfixes, semantic_meaning_js_1$q.SemanticType.POSTFIXOP);
  }
  combineUnits_(nodes) {
    const partition = SemanticUtil$3.partitionNodes(nodes, function (x) {
      return !SemanticPred$3.isRole(x, semantic_meaning_js_1$q.SemanticRole.UNIT);
    });
    if (nodes.length === partition.rel.length) {
      return partition.rel;
    }
    const result = [];
    let rel;
    let last;
    do {
      const comp = partition.comp.shift();
      rel = partition.rel.shift();
      let unitNode = null;
      last = result.pop();
      if (last) {
        if (!comp.length || !SemanticPred$3.isUnitCounter(last)) {
          result.push(last);
        } else {
          comp.unshift(last);
        }
      }
      if (comp.length === 1) {
        unitNode = comp.pop();
      }
      if (comp.length > 1) {
        unitNode = SemanticProcessor.getInstance().implicitNode_(comp);
        unitNode.role = semantic_meaning_js_1$q.SemanticRole.UNIT;
      }
      if (unitNode) {
        result.push(unitNode);
      }
      if (rel) {
        result.push(rel);
      }
    } while (rel);
    return result;
  }
  getMixedNumbers_(nodes) {
    const partition = SemanticUtil$3.partitionNodes(nodes, function (x) {
      return SemanticPred$3.isType(x, semantic_meaning_js_1$q.SemanticType.FRACTION) && SemanticPred$3.isRole(x, semantic_meaning_js_1$q.SemanticRole.VULGAR);
    });
    if (!partition.rel.length) {
      return nodes;
    }
    let result = [];
    for (let i = 0, rel; rel = partition.rel[i]; i++) {
      const comp = partition.comp[i];
      const last = comp.length - 1;
      if (comp[last] && SemanticPred$3.isType(comp[last], semantic_meaning_js_1$q.SemanticType.NUMBER) && (SemanticPred$3.isRole(comp[last], semantic_meaning_js_1$q.SemanticRole.INTEGER) || SemanticPred$3.isRole(comp[last], semantic_meaning_js_1$q.SemanticRole.FLOAT))) {
        const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.NUMBER, [comp[last], rel], []);
        newNode.role = semantic_meaning_js_1$q.SemanticRole.MIXED;
        result = result.concat(comp.slice(0, last));
        result.push(newNode);
      } else {
        result = result.concat(comp);
        result.push(rel);
      }
    }
    return result.concat(partition.comp[partition.comp.length - 1]);
  }
  getTextInRow_(nodes) {
    if (nodes.length === 0) {
      return nodes;
    }
    if (nodes.length === 1) {
      if (nodes[0].type === semantic_meaning_js_1$q.SemanticType.TEXT && nodes[0].role === semantic_meaning_js_1$q.SemanticRole.UNKNOWN) {
        nodes[0].role = semantic_meaning_js_1$q.SemanticRole.ANNOTATION;
      }
      return nodes;
    }
    const {rel: rel, comp: comp} = SemanticUtil$3.partitionNodes(nodes, x => SemanticPred$3.isType(x, semantic_meaning_js_1$q.SemanticType.TEXT));
    if (rel.length === 0) {
      return nodes;
    }
    const result = [];
    let prevComp = comp.shift();
    while (rel.length > 0) {
      let currentRel = rel.shift();
      let nextComp = comp.shift();
      const text = [];
      while (!nextComp.length && rel.length && currentRel.role !== semantic_meaning_js_1$q.SemanticRole.SPACE && rel[0].role !== semantic_meaning_js_1$q.SemanticRole.SPACE) {
        text.push(currentRel);
        currentRel = rel.shift();
        nextComp = comp.shift();
      }
      if (text.length) {
        if (prevComp.length) {
          result.push(SemanticProcessor.getInstance().row(prevComp));
        }
        text.push(currentRel);
        const dummy = SemanticProcessor.getInstance().dummyNode_(text);
        result.push(dummy);
        prevComp = nextComp;
        continue;
      }
      if (currentRel.role !== semantic_meaning_js_1$q.SemanticRole.UNKNOWN) {
        if (prevComp.length) {
          result.push(SemanticProcessor.getInstance().row(prevComp));
        }
        result.push(currentRel);
        prevComp = nextComp;
        continue;
      }
      const meaning = semantic_attr_js_1$5.SemanticMap.Meaning.get(currentRel.textContent);
      if (meaning.type === semantic_meaning_js_1$q.SemanticType.PUNCTUATION) {
        currentRel.role = meaning.role;
        currentRel.font = meaning.font;
        if (prevComp.length) {
          result.push(SemanticProcessor.getInstance().row(prevComp));
        }
        result.push(currentRel);
        prevComp = nextComp;
        continue;
      }
      if (meaning.type !== semantic_meaning_js_1$q.SemanticType.UNKNOWN) {
        currentRel.type = meaning.type;
        currentRel.role = meaning.role;
        currentRel.font = meaning.font;
        currentRel.addAnnotation('general', 'text');
        prevComp.push(currentRel);
        prevComp = prevComp.concat(nextComp);
        continue;
      }
      SemanticProcessor.meaningFromContent(currentRel, (n, c, m) => {
        if (n.role !== semantic_meaning_js_1$q.SemanticRole.UNKNOWN) {
          return;
        }
        SemanticProcessor.numberRole_(n, c, m);
        if (n.role !== semantic_meaning_js_1$q.SemanticRole.OTHERNUMBER) {
          n.type = semantic_meaning_js_1$q.SemanticType.NUMBER;
          return;
        }
        if (m.some(x => x.type !== semantic_meaning_js_1$q.SemanticType.NUMBER && x.type !== semantic_meaning_js_1$q.SemanticType.IDENTIFIER)) {
          n.type = semantic_meaning_js_1$q.SemanticType.TEXT;
          n.role = semantic_meaning_js_1$q.SemanticRole.ANNOTATION;
          return;
        }
        n.role = semantic_meaning_js_1$q.SemanticRole.UNKNOWN;
      });
      if (currentRel.type === semantic_meaning_js_1$q.SemanticType.TEXT && currentRel.role !== semantic_meaning_js_1$q.SemanticRole.UNKNOWN) {
        if (prevComp.length) {
          result.push(SemanticProcessor.getInstance().row(prevComp));
        }
        result.push(currentRel);
        prevComp = nextComp;
        continue;
      }
      if (currentRel.role === semantic_meaning_js_1$q.SemanticRole.UNKNOWN) {
        if (rel.length || nextComp.length) {
          if (nextComp.length && nextComp[0].type === semantic_meaning_js_1$q.SemanticType.FENCED) {
            currentRel.type = semantic_meaning_js_1$q.SemanticType.FUNCTION;
            currentRel.role = semantic_meaning_js_1$q.SemanticRole.PREFIXFUNC;
          } else {
            currentRel.role = semantic_meaning_js_1$q.SemanticRole.TEXT;
          }
        } else {
          currentRel.type = semantic_meaning_js_1$q.SemanticType.IDENTIFIER;
          currentRel.role = semantic_meaning_js_1$q.SemanticRole.UNIT;
        }
      }
      prevComp.push(currentRel);
      prevComp = prevComp.concat(nextComp);
    }
    if (prevComp.length > 0) {
      result.push(SemanticProcessor.getInstance().row(prevComp));
    }
    return result.length > 1 ? [SemanticProcessor.getInstance().dummyNode_(result)] : result;
  }
  relationsInRow_(nodes) {
    const partition = SemanticUtil$3.partitionNodes(nodes, SemanticPred$3.isRelation);
    const firstRel = partition.rel[0];
    if (!firstRel) {
      return SemanticProcessor.getInstance().operationsInRow_(nodes);
    }
    if (nodes.length === 1) {
      return nodes[0];
    }
    const children = partition.comp.map(SemanticProcessor.getInstance().operationsInRow_);
    let node;
    if (partition.rel.some(function (x) {
      return !x.equals(firstRel);
    })) {
      node = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.MULTIREL, children, partition.rel);
      if (partition.rel.every(function (x) {
        return x.role === firstRel.role;
      })) {
        node.role = firstRel.role;
      }
      return node;
    }
    node = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.RELSEQ, children, partition.rel, SemanticUtil$3.getEmbellishedInner(firstRel).textContent);
    node.role = firstRel.role;
    return node;
  }
  operationsInRow_(nodes) {
    if (nodes.length === 0) {
      return SemanticProcessor.getInstance().factory_.makeEmptyNode();
    }
    nodes = SemanticProcessor.getInstance().explicitMixed_(nodes);
    if (nodes.length === 1) {
      return nodes[0];
    }
    const prefix = [];
    while (nodes.length > 0 && SemanticPred$3.isOperator(nodes[0])) {
      prefix.push(nodes.shift());
    }
    if (nodes.length === 0) {
      return SemanticProcessor.getInstance().prefixNode_(prefix.pop(), prefix);
    }
    if (nodes.length === 1) {
      return SemanticProcessor.getInstance().prefixNode_(nodes[0], prefix);
    }
    nodes = semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('convert_juxtaposition', nodes);
    const split = SemanticUtil$3.sliceNodes(nodes, SemanticPred$3.isOperator);
    const node = SemanticProcessor.getInstance().wrapFactor(prefix, split);
    return SemanticProcessor.getInstance().addFactor(node, split);
  }
  wrapPostfix(split) {
    var _a;
    if (((_a = split.div) === null || _a === void 0 ? void 0 : _a.role) === semantic_meaning_js_1$q.SemanticRole.POSTFIXOP) {
      if (!split.tail.length || split.tail[0].type === semantic_meaning_js_1$q.SemanticType.OPERATOR) {
        split.head = [SemanticProcessor.getInstance().postfixNode_(SemanticProcessor.getInstance().implicitNode(split.head), [split.div])];
        split.div = split.tail.shift();
        SemanticProcessor.getInstance().wrapPostfix(split);
      } else {
        split.div.role = semantic_meaning_js_1$q.SemanticRole.DIVISION;
      }
    }
  }
  wrapFactor(prefix, split) {
    SemanticProcessor.getInstance().wrapPostfix(split);
    return SemanticProcessor.getInstance().prefixNode_(SemanticProcessor.getInstance().implicitNode(split.head), prefix);
  }
  addFactor(node, split) {
    if (!split.div) {
      if (SemanticPred$3.isUnitProduct(node)) {
        node.role = semantic_meaning_js_1$q.SemanticRole.UNIT;
      }
      return node;
    }
    return SemanticProcessor.getInstance().operationsTree_(split.tail, node, split.div);
  }
  operationsTree_(nodes, root, lastop, prefix = []) {
    if (nodes.length === 0) {
      prefix.unshift(lastop);
      if (root.type === semantic_meaning_js_1$q.SemanticType.INFIXOP) {
        const node = SemanticProcessor.getInstance().postfixNode_(root.childNodes.pop(), prefix);
        root.appendChild(node);
        return root;
      }
      return SemanticProcessor.getInstance().postfixNode_(root, prefix);
    }
    const split = SemanticUtil$3.sliceNodes(nodes, SemanticPred$3.isOperator);
    if (split.head.length === 0) {
      prefix.push(split.div);
      return SemanticProcessor.getInstance().operationsTree_(split.tail, root, lastop, prefix);
    }
    const node = SemanticProcessor.getInstance().wrapFactor(prefix, split);
    const newNode = SemanticProcessor.getInstance().appendOperand_(root, lastop, node);
    return SemanticProcessor.getInstance().addFactor(newNode, split);
  }
  appendOperand_(root, op, node) {
    if (root.type !== semantic_meaning_js_1$q.SemanticType.INFIXOP) {
      return SemanticProcessor.getInstance().infixNode_([root, node], op);
    }
    const division = SemanticProcessor.getInstance().appendDivisionOp_(root, op, node);
    if (division) {
      return division;
    }
    if (SemanticProcessor.getInstance().appendExistingOperator_(root, op, node)) {
      return root;
    }
    return op.role === semantic_meaning_js_1$q.SemanticRole.MULTIPLICATION ? SemanticProcessor.getInstance().appendMultiplicativeOp_(root, op, node) : SemanticProcessor.getInstance().appendAdditiveOp_(root, op, node);
  }
  appendDivisionOp_(root, op, node) {
    if (op.role === semantic_meaning_js_1$q.SemanticRole.DIVISION) {
      if (SemanticPred$3.isImplicit(root)) {
        return SemanticProcessor.getInstance().infixNode_([root, node], op);
      }
      return SemanticProcessor.getInstance().appendLastOperand_(root, op, node);
    }
    return root.role === semantic_meaning_js_1$q.SemanticRole.DIVISION ? SemanticProcessor.getInstance().infixNode_([root, node], op) : null;
  }
  appendLastOperand_(root, op, node) {
    let lastRoot = root;
    let lastChild = root.childNodes[root.childNodes.length - 1];
    while (lastChild && lastChild.type === semantic_meaning_js_1$q.SemanticType.INFIXOP && !SemanticPred$3.isImplicit(lastChild)) {
      lastRoot = lastChild;
      lastChild = lastRoot.childNodes[root.childNodes.length - 1];
    }
    const newNode = SemanticProcessor.getInstance().infixNode_([lastRoot.childNodes.pop(), node], op);
    lastRoot.appendChild(newNode);
    return root;
  }
  appendMultiplicativeOp_(root, op, node) {
    if (SemanticPred$3.isImplicit(root)) {
      return SemanticProcessor.getInstance().infixNode_([root, node], op);
    }
    let lastRoot = root;
    let lastChild = root.childNodes[root.childNodes.length - 1];
    while (lastChild && lastChild.type === semantic_meaning_js_1$q.SemanticType.INFIXOP && !SemanticPred$3.isImplicit(lastChild)) {
      lastRoot = lastChild;
      lastChild = lastRoot.childNodes[root.childNodes.length - 1];
    }
    const newNode = SemanticProcessor.getInstance().infixNode_([lastRoot.childNodes.pop(), node], op);
    lastRoot.appendChild(newNode);
    return root;
  }
  appendAdditiveOp_(root, op, node) {
    return SemanticProcessor.getInstance().infixNode_([root, node], op);
  }
  appendExistingOperator_(root, op, node) {
    if (!root || root.type !== semantic_meaning_js_1$q.SemanticType.INFIXOP || SemanticPred$3.isImplicit(root)) {
      return false;
    }
    if (root.contentNodes[0].equals(op)) {
      root.appendContentNode(op);
      root.appendChild(node);
      return true;
    }
    return SemanticProcessor.getInstance().appendExistingOperator_(root.childNodes[root.childNodes.length - 1], op, node);
  }
  getFencesInRow_(nodes) {
    let partition = SemanticUtil$3.partitionNodes(nodes, SemanticPred$3.isFence);
    partition = SemanticProcessor.purgeFences_(partition);
    const felem = partition.comp.shift();
    return SemanticProcessor.getInstance().fences_(partition.rel, partition.comp, [], [felem]);
  }
  fences_(fences, content, openStack, contentStack) {
    if (fences.length === 0 && openStack.length === 0) {
      return contentStack[0];
    }
    const interval = semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('bracketed_interval', [fences[0], fences[1], ...content[0] || []], () => null);
    if (interval) {
      fences.shift();
      fences.shift();
      content.shift();
      const stack = contentStack.pop() || [];
      contentStack.push([...stack, interval, ...content.shift()]);
      return SemanticProcessor.getInstance().fences_(fences, content, openStack, contentStack);
    }
    const openPred = x => SemanticPred$3.isRole(x, semantic_meaning_js_1$q.SemanticRole.OPEN);
    if (fences.length === 0) {
      const result = contentStack.shift();
      while (openStack.length > 0) {
        if (openPred(openStack[0])) {
          const firstOpen = openStack.shift();
          SemanticProcessor.fenceToPunct_(firstOpen);
          result.push(firstOpen);
        } else {
          const split = SemanticUtil$3.sliceNodes(openStack, openPred);
          const cutLength = split.head.length - 1;
          const innerNodes = SemanticProcessor.getInstance().neutralFences_(split.head, contentStack.slice(0, cutLength));
          contentStack = contentStack.slice(cutLength);
          result.push(...innerNodes);
          if (split.div) {
            split.tail.unshift(split.div);
          }
          openStack = split.tail;
        }
        result.push(...contentStack.shift());
      }
      return result;
    }
    const lastOpen = openStack[openStack.length - 1];
    const firstRole = fences[0].role;
    if (firstRole === semantic_meaning_js_1$q.SemanticRole.OPEN || SemanticPred$3.isNeutralFence(fences[0]) && !(lastOpen && SemanticPred$3.compareNeutralFences(fences[0], lastOpen))) {
      openStack.push(fences.shift());
      const cont = content.shift();
      if (cont) {
        contentStack.push(cont);
      }
      return SemanticProcessor.getInstance().fences_(fences, content, openStack, contentStack);
    }
    if (lastOpen && firstRole === semantic_meaning_js_1$q.SemanticRole.CLOSE && lastOpen.role === semantic_meaning_js_1$q.SemanticRole.OPEN) {
      const fenced = SemanticProcessor.getInstance().horizontalFencedNode_(openStack.pop(), fences.shift(), contentStack.pop());
      contentStack.push(contentStack.pop().concat([fenced], content.shift()));
      return SemanticProcessor.getInstance().fences_(fences, content, openStack, contentStack);
    }
    if (lastOpen && SemanticPred$3.compareNeutralFences(fences[0], lastOpen)) {
      if (!SemanticPred$3.elligibleLeftNeutral(lastOpen) || !SemanticPred$3.elligibleRightNeutral(fences[0])) {
        openStack.push(fences.shift());
        const cont = content.shift();
        if (cont) {
          contentStack.push(cont);
        }
        return SemanticProcessor.getInstance().fences_(fences, content, openStack, contentStack);
      }
      const fenced = SemanticProcessor.getInstance().horizontalFencedNode_(openStack.pop(), fences.shift(), contentStack.pop());
      contentStack.push(contentStack.pop().concat([fenced], content.shift()));
      return SemanticProcessor.getInstance().fences_(fences, content, openStack, contentStack);
    }
    if (lastOpen && firstRole === semantic_meaning_js_1$q.SemanticRole.CLOSE && SemanticPred$3.isNeutralFence(lastOpen) && openStack.some(openPred)) {
      const split = SemanticUtil$3.sliceNodes(openStack, openPred, true);
      const rightContent = contentStack.pop();
      const cutLength = contentStack.length - split.tail.length + 1;
      const innerNodes = SemanticProcessor.getInstance().neutralFences_(split.tail, contentStack.slice(cutLength));
      contentStack = contentStack.slice(0, cutLength);
      const fenced = SemanticProcessor.getInstance().horizontalFencedNode_(split.div, fences.shift(), contentStack.pop().concat(innerNodes, rightContent));
      contentStack.push(contentStack.pop().concat([fenced], content.shift()));
      return SemanticProcessor.getInstance().fences_(fences, content, split.head, contentStack);
    }
    const fenced = fences.shift();
    SemanticProcessor.fenceToPunct_(fenced);
    contentStack.push(contentStack.pop().concat([fenced], content.shift()));
    return SemanticProcessor.getInstance().fences_(fences, content, openStack, contentStack);
  }
  neutralFences_(fences, content) {
    if (fences.length === 0) {
      return fences;
    }
    if (fences.length === 1) {
      SemanticProcessor.fenceToPunct_(fences[0]);
      return fences;
    }
    const firstFence = fences.shift();
    if (!SemanticPred$3.elligibleLeftNeutral(firstFence)) {
      SemanticProcessor.fenceToPunct_(firstFence);
      const restContent = content.shift();
      restContent.unshift(firstFence);
      return restContent.concat(SemanticProcessor.getInstance().neutralFences_(fences, content));
    }
    const split = SemanticUtil$3.sliceNodes(fences, function (x) {
      return SemanticPred$3.compareNeutralFences(x, firstFence);
    });
    if (!split.div) {
      SemanticProcessor.fenceToPunct_(firstFence);
      const restContent = content.shift();
      restContent.unshift(firstFence);
      return restContent.concat(SemanticProcessor.getInstance().neutralFences_(fences, content));
    }
    if (!SemanticPred$3.elligibleRightNeutral(split.div)) {
      SemanticProcessor.fenceToPunct_(split.div);
      fences.unshift(firstFence);
      return SemanticProcessor.getInstance().neutralFences_(fences, content);
    }
    const newContent = SemanticProcessor.getInstance().combineFencedContent_(firstFence, split.div, split.head, content);
    if (split.tail.length > 0) {
      const leftContent = newContent.shift();
      const result = SemanticProcessor.getInstance().neutralFences_(split.tail, newContent);
      return leftContent.concat(result);
    }
    return newContent[0];
  }
  combineFencedContent_(leftFence, rightFence, midFences, content) {
    if (midFences.length === 0) {
      const fenced = SemanticProcessor.getInstance().horizontalFencedNode_(leftFence, rightFence, content.shift());
      if (content.length > 0) {
        content[0].unshift(fenced);
      } else {
        content = [[fenced]];
      }
      return content;
    }
    const leftContent = content.shift();
    const cutLength = midFences.length - 1;
    const midContent = content.slice(0, cutLength);
    content = content.slice(cutLength);
    const rightContent = content.shift();
    const innerNodes = SemanticProcessor.getInstance().neutralFences_(midFences, midContent);
    leftContent.push(...innerNodes);
    leftContent.push(...rightContent);
    const fenced = SemanticProcessor.getInstance().horizontalFencedNode_(leftFence, rightFence, leftContent);
    if (content.length > 0) {
      content[0].unshift(fenced);
    } else {
      content = [[fenced]];
    }
    return content;
  }
  horizontalFencedNode_(ofence, cfence, content) {
    const childNode = SemanticProcessor.getInstance().row(content);
    let newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.FENCED, [childNode], [ofence, cfence]);
    if (ofence.role === semantic_meaning_js_1$q.SemanticRole.OPEN) {
      SemanticProcessor.getInstance().classifyHorizontalFence_(newNode);
      newNode = semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('propagateComposedFunction', newNode);
    } else {
      newNode.role = ofence.role;
    }
    newNode = semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('detect_cycle', newNode);
    return SemanticProcessor.rewriteFencedNode_(newNode);
  }
  classifyHorizontalFence_(node) {
    node.role = semantic_meaning_js_1$q.SemanticRole.LEFTRIGHT;
    const children = node.childNodes;
    if (!SemanticPred$3.isSetNode(node) || children.length > 1) {
      return;
    }
    if (children.length === 0 || children[0].type === semantic_meaning_js_1$q.SemanticType.EMPTY) {
      node.role = semantic_meaning_js_1$q.SemanticRole.SETEMPTY;
      return;
    }
    const type = children[0].type;
    if (children.length === 1 && SemanticPred$3.isSingletonSetContent(children[0])) {
      node.role = semantic_meaning_js_1$q.SemanticRole.SETSINGLE;
      return;
    }
    const role = children[0].role;
    if (type !== semantic_meaning_js_1$q.SemanticType.PUNCTUATED || role !== semantic_meaning_js_1$q.SemanticRole.SEQUENCE) {
      return;
    }
    if (children[0].contentNodes[0].role === semantic_meaning_js_1$q.SemanticRole.COMMA) {
      node.role = semantic_meaning_js_1$q.SemanticRole.SETCOLLECT;
      return;
    }
    if (children[0].contentNodes.length === 1 && (children[0].contentNodes[0].role === semantic_meaning_js_1$q.SemanticRole.VBAR || children[0].contentNodes[0].role === semantic_meaning_js_1$q.SemanticRole.COLON)) {
      node.role = semantic_meaning_js_1$q.SemanticRole.SETEXT;
      SemanticProcessor.getInstance().setExtension_(node);
      return;
    }
  }
  setExtension_(set) {
    const extender = set.childNodes[0].childNodes[0];
    if (extender && extender.type === semantic_meaning_js_1$q.SemanticType.INFIXOP && extender.contentNodes.length === 1 && SemanticPred$3.isMembership(extender.contentNodes[0])) {
      extender.addAnnotation('set', 'intensional');
      extender.contentNodes[0].addAnnotation('set', 'intensional');
    }
  }
  getPunctuationInRow_(nodes) {
    if (nodes.length <= 1) {
      return nodes;
    }
    const allowedType = x => {
      const type = x.type;
      return type === 'punctuation' || type === 'text' || type === 'operator' || type === 'relation';
    };
    const partition = SemanticUtil$3.partitionNodes(nodes, function (x) {
      if (!SemanticPred$3.isPunctuation(x)) {
        return false;
      }
      if (SemanticPred$3.isPunctuation(x) && !SemanticPred$3.isRole(x, semantic_meaning_js_1$q.SemanticRole.ELLIPSIS)) {
        return true;
      }
      const index = nodes.indexOf(x);
      if (index === 0) {
        if (nodes[1] && allowedType(nodes[1])) {
          return false;
        }
        return true;
      }
      const prev = nodes[index - 1];
      if (index === nodes.length - 1) {
        if (allowedType(prev)) {
          return false;
        }
        return true;
      }
      const next = nodes[index + 1];
      if (allowedType(prev) && allowedType(next)) {
        return false;
      }
      return true;
    });
    if (partition.rel.length === 0) {
      return nodes;
    }
    let newNodes = [];
    let firstComp = partition.comp.shift();
    if (firstComp.length > 0) {
      newNodes.push(SemanticProcessor.getInstance().row(firstComp));
    }
    let relCounter = 0;
    while (partition.comp.length > 0) {
      let puncts = [];
      const saveCount = relCounter;
      do {
        puncts.push(partition.rel[relCounter++]);
        firstComp = partition.comp.shift();
      } while (partition.rel[relCounter] && firstComp && firstComp.length === 0);
      puncts = semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('ellipses', puncts);
      partition.rel.splice(saveCount, relCounter - saveCount, ...puncts);
      relCounter = saveCount + puncts.length;
      newNodes = newNodes.concat(puncts);
      if (firstComp && firstComp.length > 0) {
        newNodes.push(SemanticProcessor.getInstance().row(firstComp));
      }
    }
    return newNodes.length === 1 && partition.rel.length === 1 ? newNodes : [SemanticProcessor.getInstance().punctuatedNode_(newNodes, partition.rel)];
  }
  punctuatedNode_(nodes, punctuations) {
    const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.PUNCTUATED, nodes, punctuations);
    if (punctuations.length === nodes.length) {
      const firstRole = punctuations[0].role;
      if (firstRole !== semantic_meaning_js_1$q.SemanticRole.UNKNOWN && punctuations.every(function (punct) {
        return punct.role === firstRole;
      })) {
        newNode.role = firstRole;
        return newNode;
      }
    }
    const fpunct = punctuations[0];
    if (SemanticPred$3.singlePunctAtPosition(nodes, punctuations, 0)) {
      newNode.role = fpunct.childNodes.length && !fpunct.embellished ? fpunct.role : semantic_meaning_js_1$q.SemanticRole.STARTPUNCT;
    } else if (SemanticPred$3.singlePunctAtPosition(nodes, punctuations, nodes.length - 1)) {
      newNode.role = fpunct.childNodes.length && !fpunct.embellished ? fpunct.role : semantic_meaning_js_1$q.SemanticRole.ENDPUNCT;
    } else if (punctuations.every(x => SemanticPred$3.isRole(x, semantic_meaning_js_1$q.SemanticRole.DUMMY))) {
      newNode.role = semantic_meaning_js_1$q.SemanticRole.TEXT;
    } else if (punctuations.every(x => SemanticPred$3.isRole(x, semantic_meaning_js_1$q.SemanticRole.SPACE))) {
      newNode.role = semantic_meaning_js_1$q.SemanticRole.SPACE;
    } else {
      newNode.role = semantic_meaning_js_1$q.SemanticRole.SEQUENCE;
    }
    return newNode;
  }
  dummyNode_(children) {
    const commata = SemanticProcessor.getInstance().factory_.makeMultipleContentNodes(children.length - 1, semantic_attr_js_1$5.NamedSymbol.invisibleComma);
    commata.forEach(function (comma) {
      comma.role = semantic_meaning_js_1$q.SemanticRole.DUMMY;
    });
    return SemanticProcessor.getInstance().punctuatedNode_(children, commata);
  }
  accentRole_(node, type) {
    if (!SemanticPred$3.isAccent(node)) {
      return false;
    }
    const content = node.textContent;
    const role = semantic_attr_js_1$5.SemanticMap.Secondary.get(content, semantic_meaning_js_1$q.SemanticSecondary.BAR) || semantic_attr_js_1$5.SemanticMap.Secondary.get(content, semantic_meaning_js_1$q.SemanticSecondary.TILDE) || node.role;
    node.role = type === semantic_meaning_js_1$q.SemanticType.UNDERSCORE ? semantic_meaning_js_1$q.SemanticRole.UNDERACCENT : semantic_meaning_js_1$q.SemanticRole.OVERACCENT;
    node.addAnnotation('accent', role);
    return true;
  }
  accentNode_(center, children, type, length, accent) {
    children = children.slice(0, length + 1);
    const child1 = children[1];
    const child2 = children[2];
    let innerNode;
    if (!accent && child2) {
      innerNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.SUBSCRIPT, [center, child1], []);
      innerNode.role = semantic_meaning_js_1$q.SemanticRole.SUBSUP;
      children = [innerNode, child2];
      type = semantic_meaning_js_1$q.SemanticType.SUPERSCRIPT;
    }
    if (accent) {
      const underAccent = SemanticProcessor.getInstance().accentRole_(child1, type);
      if (child2) {
        const overAccent = SemanticProcessor.getInstance().accentRole_(child2, semantic_meaning_js_1$q.SemanticType.OVERSCORE);
        if (overAccent && !underAccent) {
          innerNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.OVERSCORE, [center, child2], []);
          children = [innerNode, child1];
          type = semantic_meaning_js_1$q.SemanticType.UNDERSCORE;
        } else {
          innerNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.UNDERSCORE, [center, child1], []);
          children = [innerNode, child2];
          type = semantic_meaning_js_1$q.SemanticType.OVERSCORE;
        }
        innerNode.role = semantic_meaning_js_1$q.SemanticRole.UNDEROVER;
      }
    }
    return SemanticProcessor.getInstance().makeLimitNode_(center, children, innerNode, type);
  }
  makeLimitNode_(center, children, innerNode, type) {
    if (type === semantic_meaning_js_1$q.SemanticType.LIMUPPER && center.type === semantic_meaning_js_1$q.SemanticType.LIMLOWER) {
      center.childNodes.push(children[1]);
      children[1].parent = center;
      center.type = semantic_meaning_js_1$q.SemanticType.LIMBOTH;
      return center;
    }
    if (type === semantic_meaning_js_1$q.SemanticType.LIMLOWER && center.type === semantic_meaning_js_1$q.SemanticType.LIMUPPER) {
      center.childNodes.splice(1, -1, children[1]);
      children[1].parent = center;
      center.type = semantic_meaning_js_1$q.SemanticType.LIMBOTH;
      return center;
    }
    const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(type, children, []);
    const embellished = SemanticPred$3.isEmbellished(center);
    if (innerNode) {
      innerNode.embellished = embellished;
    }
    newNode.embellished = embellished;
    newNode.role = center.role;
    return newNode;
  }
  getFunctionsInRow_(restNodes, opt_result) {
    const result = opt_result || [];
    if (restNodes.length === 0) {
      return result;
    }
    const firstNode = restNodes.shift();
    const heuristic = SemanticProcessor.classifyFunction_(firstNode, restNodes);
    if (!heuristic) {
      result.push(firstNode);
      return SemanticProcessor.getInstance().getFunctionsInRow_(restNodes, result);
    }
    const processedRest = SemanticProcessor.getInstance().getFunctionsInRow_(restNodes, []);
    const newRest = SemanticProcessor.getInstance().getFunctionArgs_(firstNode, processedRest, heuristic);
    return result.concat(newRest);
  }
  getFunctionArgs_(func, rest, heuristic) {
    let partition, arg, funcNode;
    switch (heuristic) {
      case 'integral':
        {
          const components = SemanticProcessor.getInstance().getIntegralArgs_(rest);
          if (!components.intvar && !components.integrand.length) {
            components.rest.unshift(func);
            return components.rest;
          }
          const integrand = SemanticProcessor.getInstance().row(components.integrand);
          funcNode = SemanticProcessor.getInstance().integralNode_(func, integrand, components.intvar);
          semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('intvar_from_fraction', funcNode);
          components.rest.unshift(funcNode);
          return components.rest;
        }
      case 'prefix':
        {
          if (rest[0] && rest[0].type === semantic_meaning_js_1$q.SemanticType.FENCED) {
            const arg = rest.shift();
            if (!SemanticPred$3.isNeutralFence(arg)) {
              arg.role = semantic_meaning_js_1$q.SemanticRole.LEFTRIGHT;
            }
            funcNode = SemanticProcessor.getInstance().functionNode_(func, arg);
            rest.unshift(funcNode);
            return rest;
          }
          partition = SemanticUtil$3.sliceNodes(rest, SemanticPred$3.isPrefixFunctionBoundary);
          if (!partition.head.length) {
            if (!partition.div || !SemanticPred$3.isType(partition.div, semantic_meaning_js_1$q.SemanticType.APPL)) {
              rest.unshift(func);
              return rest;
            }
            arg = partition.div;
          } else {
            arg = SemanticProcessor.getInstance().row(partition.head);
            if (partition.div) {
              partition.tail.unshift(partition.div);
            }
          }
          funcNode = SemanticProcessor.getInstance().functionNode_(func, arg);
          partition.tail.unshift(funcNode);
          return partition.tail;
        }
      case 'bigop':
        {
          partition = SemanticUtil$3.sliceNodes(rest, SemanticPred$3.isBigOpBoundary);
          if (!partition.head.length) {
            rest.unshift(func);
            return rest;
          }
          arg = SemanticProcessor.getInstance().row(partition.head);
          funcNode = SemanticProcessor.getInstance().bigOpNode_(func, arg);
          if (partition.div) {
            partition.tail.unshift(partition.div);
          }
          partition.tail.unshift(funcNode);
          return partition.tail;
        }
      case 'simple':
      default:
        {
          if (rest.length === 0) {
            return [func];
          }
          const firstArg = rest[0];
          if (firstArg.type === semantic_meaning_js_1$q.SemanticType.FENCED && !SemanticPred$3.isNeutralFence(firstArg) && SemanticPred$3.isSimpleFunctionScope(firstArg)) {
            firstArg.role = semantic_meaning_js_1$q.SemanticRole.LEFTRIGHT;
            SemanticProcessor.propagateFunctionRole_(func, semantic_meaning_js_1$q.SemanticRole.SIMPLEFUNC);
            funcNode = SemanticProcessor.getInstance().functionNode_(func, rest.shift());
            rest.unshift(funcNode);
            return rest;
          }
          rest.unshift(func);
          return rest;
        }
    }
  }
  getIntegralArgs_(nodes, args = []) {
    if (nodes.length === 0) {
      const partition = SemanticUtil$3.sliceNodes(args, SemanticPred$3.isBigOpBoundary);
      if (partition.div) {
        partition.tail.unshift(partition.div);
      }
      return {
        integrand: partition.head,
        intvar: null,
        rest: partition.tail
      };
    }
    semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('intvar_from_implicit', nodes);
    const firstNode = nodes[0];
    if (SemanticPred$3.isGeneralFunctionBoundary(firstNode)) {
      const {integrand: args2, rest: rest2} = SemanticProcessor.getInstance().getIntegralArgs_(args);
      return {
        integrand: args2,
        intvar: null,
        rest: rest2.concat(nodes)
      };
    }
    if (SemanticPred$3.isIntegralDxBoundarySingle(firstNode)) {
      firstNode.role = semantic_meaning_js_1$q.SemanticRole.INTEGRAL;
      return {
        integrand: args,
        intvar: firstNode,
        rest: nodes.slice(1)
      };
    }
    if (nodes[1] && SemanticPred$3.isIntegralDxBoundary(firstNode, nodes[1])) {
      const intvar = SemanticProcessor.getInstance().prefixNode_(nodes[1], [firstNode]);
      intvar.role = semantic_meaning_js_1$q.SemanticRole.INTEGRAL;
      return {
        integrand: args,
        intvar: intvar,
        rest: nodes.slice(2)
      };
    }
    args.push(nodes.shift());
    return SemanticProcessor.getInstance().getIntegralArgs_(nodes, args);
  }
  functionNode_(func, arg) {
    const applNode = SemanticProcessor.getInstance().factory_.makeContentNode(semantic_attr_js_1$5.NamedSymbol.functionApplication);
    const appl = SemanticProcessor.getInstance().funcAppls[func.id];
    if (appl) {
      applNode.mathmlTree = appl.mathmlTree;
      applNode.mathml = appl.mathml;
      applNode.annotation = appl.annotation;
      applNode.attributes = appl.attributes;
      delete SemanticProcessor.getInstance().funcAppls[func.id];
    }
    applNode.type = semantic_meaning_js_1$q.SemanticType.PUNCTUATION;
    applNode.role = semantic_meaning_js_1$q.SemanticRole.APPLICATION;
    const funcop = SemanticProcessor.getFunctionOp_(func, function (node) {
      return SemanticPred$3.isType(node, semantic_meaning_js_1$q.SemanticType.FUNCTION) || SemanticPred$3.isType(node, semantic_meaning_js_1$q.SemanticType.IDENTIFIER) && SemanticPred$3.isRole(node, semantic_meaning_js_1$q.SemanticRole.SIMPLEFUNC);
    });
    return SemanticProcessor.getInstance().functionalNode_(semantic_meaning_js_1$q.SemanticType.APPL, [func, arg], funcop, [applNode]);
  }
  bigOpNode_(bigOp, arg) {
    const largeop = SemanticProcessor.getFunctionOp_(bigOp, x => SemanticPred$3.isType(x, semantic_meaning_js_1$q.SemanticType.LARGEOP));
    return SemanticProcessor.getInstance().functionalNode_(semantic_meaning_js_1$q.SemanticType.BIGOP, [bigOp, arg], largeop, []);
  }
  integralNode_(integral, integrand, intvar) {
    integrand = integrand || SemanticProcessor.getInstance().factory_.makeEmptyNode();
    intvar = intvar || SemanticProcessor.getInstance().factory_.makeEmptyNode();
    const largeop = SemanticProcessor.getFunctionOp_(integral, x => SemanticPred$3.isType(x, semantic_meaning_js_1$q.SemanticType.LARGEOP));
    return SemanticProcessor.getInstance().functionalNode_(semantic_meaning_js_1$q.SemanticType.INTEGRAL, [integral, integrand, intvar], largeop, []);
  }
  functionalNode_(type, children, operator, content) {
    const funcop = children[0];
    let oldParent;
    if (operator) {
      oldParent = operator.parent;
      content.push(operator);
    }
    const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(type, children, content);
    newNode.role = funcop.role;
    if (oldParent) {
      operator.parent = oldParent;
    }
    return newNode;
  }
  fractionNode_(denom, enume) {
    const newNode = SemanticProcessor.getInstance().factory_.makeBranchNode(semantic_meaning_js_1$q.SemanticType.FRACTION, [denom, enume], []);
    newNode.role = newNode.childNodes.every(function (x) {
      return SemanticPred$3.isType(x, semantic_meaning_js_1$q.SemanticType.NUMBER) && SemanticPred$3.isRole(x, semantic_meaning_js_1$q.SemanticRole.INTEGER);
    }) ? semantic_meaning_js_1$q.SemanticRole.VULGAR : newNode.childNodes.every(SemanticPred$3.isPureUnit) ? semantic_meaning_js_1$q.SemanticRole.UNIT : semantic_meaning_js_1$q.SemanticRole.DIVISION;
    return semantic_heuristic_factory_js_1$3.SemanticHeuristics.run('propagateSimpleFunction', newNode);
  }
  scriptNode_(nodes, role, opt_noSingle) {
    let newNode;
    switch (nodes.length) {
      case 0:
        newNode = SemanticProcessor.getInstance().factory_.makeEmptyNode();
        break;
      case 1:
        newNode = nodes[0];
        if (opt_noSingle) {
          return newNode;
        }
        break;
      default:
        newNode = SemanticProcessor.getInstance().dummyNode_(nodes);
    }
    newNode.role = role;
    return newNode;
  }
  findNestedRow_(nodes, semantic, level, value) {
    if (level > 3) {
      return null;
    }
    for (let i = 0, node; node = nodes[i]; i++) {
      const tag = DomUtil$u.tagName(node);
      if (tag !== semantic_util_js_1$a.MMLTAGS.MSPACE) {
        if (tag === semantic_util_js_1$a.MMLTAGS.MROW) {
          return SemanticProcessor.getInstance().findNestedRow_(DomUtil$u.toArray(node.childNodes), semantic, level + 1, value);
        }
        if (SemanticProcessor.findSemantics(node, semantic, value)) {
          return node;
        }
      }
    }
    return null;
  }
}
semantic_processor.SemanticProcessor = SemanticProcessor;
SemanticProcessor.FENCE_TO_PUNCT_ = {
  [semantic_meaning_js_1$q.SemanticRole.METRIC]: semantic_meaning_js_1$q.SemanticRole.METRIC,
  [semantic_meaning_js_1$q.SemanticRole.NEUTRAL]: semantic_meaning_js_1$q.SemanticRole.VBAR,
  [semantic_meaning_js_1$q.SemanticRole.OPEN]: semantic_meaning_js_1$q.SemanticRole.OPENFENCE,
  [semantic_meaning_js_1$q.SemanticRole.CLOSE]: semantic_meaning_js_1$q.SemanticRole.CLOSEFENCE
};
SemanticProcessor.MML_TO_LIMIT_ = {
  [semantic_util_js_1$a.MMLTAGS.MSUB]: {
    type: semantic_meaning_js_1$q.SemanticType.LIMLOWER,
    length: 1
  },
  [semantic_util_js_1$a.MMLTAGS.MUNDER]: {
    type: semantic_meaning_js_1$q.SemanticType.LIMLOWER,
    length: 1
  },
  [semantic_util_js_1$a.MMLTAGS.MSUP]: {
    type: semantic_meaning_js_1$q.SemanticType.LIMUPPER,
    length: 1
  },
  [semantic_util_js_1$a.MMLTAGS.MOVER]: {
    type: semantic_meaning_js_1$q.SemanticType.LIMUPPER,
    length: 1
  },
  [semantic_util_js_1$a.MMLTAGS.MSUBSUP]: {
    type: semantic_meaning_js_1$q.SemanticType.LIMBOTH,
    length: 2
  },
  [semantic_util_js_1$a.MMLTAGS.MUNDEROVER]: {
    type: semantic_meaning_js_1$q.SemanticType.LIMBOTH,
    length: 2
  }
};
SemanticProcessor.MML_TO_BOUNDS_ = {
  [semantic_util_js_1$a.MMLTAGS.MSUB]: {
    type: semantic_meaning_js_1$q.SemanticType.SUBSCRIPT,
    length: 1,
    accent: false
  },
  [semantic_util_js_1$a.MMLTAGS.MSUP]: {
    type: semantic_meaning_js_1$q.SemanticType.SUPERSCRIPT,
    length: 1,
    accent: false
  },
  [semantic_util_js_1$a.MMLTAGS.MSUBSUP]: {
    type: semantic_meaning_js_1$q.SemanticType.SUBSCRIPT,
    length: 2,
    accent: false
  },
  [semantic_util_js_1$a.MMLTAGS.MUNDER]: {
    type: semantic_meaning_js_1$q.SemanticType.UNDERSCORE,
    length: 1,
    accent: true
  },
  [semantic_util_js_1$a.MMLTAGS.MOVER]: {
    type: semantic_meaning_js_1$q.SemanticType.OVERSCORE,
    length: 1,
    accent: true
  },
  [semantic_util_js_1$a.MMLTAGS.MUNDEROVER]: {
    type: semantic_meaning_js_1$q.SemanticType.UNDERSCORE,
    length: 2,
    accent: true
  }
};
SemanticProcessor.CLASSIFY_FUNCTION_ = {
  [semantic_meaning_js_1$q.SemanticRole.INTEGRAL]: 'integral',
  [semantic_meaning_js_1$q.SemanticRole.SUM]: 'bigop',
  [semantic_meaning_js_1$q.SemanticRole.PREFIXFUNC]: 'prefix',
  [semantic_meaning_js_1$q.SemanticRole.LIMFUNC]: 'prefix',
  [semantic_meaning_js_1$q.SemanticRole.SIMPLEFUNC]: 'prefix',
  [semantic_meaning_js_1$q.SemanticRole.COMPFUNC]: 'prefix'
};
SemanticProcessor.MATHJAX_FONTS = {
  '-tex-caligraphic': semantic_meaning_js_1$q.SemanticFont.CALIGRAPHIC,
  '-tex-caligraphic-bold': semantic_meaning_js_1$q.SemanticFont.CALIGRAPHICBOLD,
  '-tex-calligraphic': semantic_meaning_js_1$q.SemanticFont.CALIGRAPHIC,
  '-tex-calligraphic-bold': semantic_meaning_js_1$q.SemanticFont.CALIGRAPHICBOLD,
  '-tex-oldstyle': semantic_meaning_js_1$q.SemanticFont.OLDSTYLE,
  '-tex-oldstyle-bold': semantic_meaning_js_1$q.SemanticFont.OLDSTYLEBOLD,
  '-tex-mathit': semantic_meaning_js_1$q.SemanticFont.ITALIC
};

Object.defineProperty(mathspeak_util, "__esModule", {
  value: true
});
mathspeak_util.spaceoutText = spaceoutText;
mathspeak_util.spaceoutNumber = spaceoutNumber;
mathspeak_util.spaceoutIdentifier = spaceoutIdentifier;
mathspeak_util.resetNestingDepth = resetNestingDepth;
mathspeak_util.fractionNestingDepth = fractionNestingDepth;
mathspeak_util.openingFractionVerbose = openingFractionVerbose$1;
mathspeak_util.closingFractionVerbose = closingFractionVerbose$1;
mathspeak_util.overFractionVerbose = overFractionVerbose;
mathspeak_util.openingFractionBrief = openingFractionBrief$1;
mathspeak_util.closingFractionBrief = closingFractionBrief$1;
mathspeak_util.openingFractionSbrief = openingFractionSbrief$1;
mathspeak_util.closingFractionSbrief = closingFractionSbrief$1;
mathspeak_util.overFractionSbrief = overFractionSbrief$1;
mathspeak_util.isSmallVulgarFraction = isSmallVulgarFraction;
mathspeak_util.nestedSubSuper = nestedSubSuper;
mathspeak_util.subscriptVerbose = subscriptVerbose;
mathspeak_util.subscriptBrief = subscriptBrief;
mathspeak_util.superscriptVerbose = superscriptVerbose;
mathspeak_util.superscriptBrief = superscriptBrief;
mathspeak_util.baselineVerbose = baselineVerbose$1;
mathspeak_util.baselineBrief = baselineBrief$1;
mathspeak_util.radicalNestingDepth = radicalNestingDepth$1;
mathspeak_util.openingRadicalVerbose = openingRadicalVerbose$1;
mathspeak_util.closingRadicalVerbose = closingRadicalVerbose$1;
mathspeak_util.indexRadicalVerbose = indexRadicalVerbose$1;
mathspeak_util.openingRadicalBrief = openingRadicalBrief$1;
mathspeak_util.closingRadicalBrief = closingRadicalBrief$1;
mathspeak_util.indexRadicalBrief = indexRadicalBrief$1;
mathspeak_util.openingRadicalSbrief = openingRadicalSbrief$1;
mathspeak_util.indexRadicalSbrief = indexRadicalSbrief$1;
mathspeak_util.nestedUnderscript = nestedUnderscript;
mathspeak_util.endscripts = endscripts;
mathspeak_util.nestedOverscript = nestedOverscript;
mathspeak_util.determinantIsSimple = determinantIsSimple;
mathspeak_util.generateBaselineConstraint = generateBaselineConstraint;
mathspeak_util.removeParens = removeParens;
mathspeak_util.generateTensorRules = generateTensorRules;
mathspeak_util.smallRoot = smallRoot;
const span_js_1$7 = span;
const BaseUtil$2 = base_util;
const DomUtil$t = dom_util;
const XpathUtil$b = xpath_util;
const locale_js_1$9 = locale$f;
const semantic_meaning_js_1$p = semantic_meaning;
const semantic_processor_js_1$2 = semantic_processor;
let nestingDepth = {};
function spaceoutText(node) {
  return Array.from(node.textContent).map(span_js_1$7.Span.stringEmpty);
}
function spaceoutNodes(node, correction) {
  const content = Array.from(node.textContent);
  const result = [];
  const processor = semantic_processor_js_1$2.SemanticProcessor.getInstance();
  const doc = node.ownerDocument;
  for (let i = 0, chr; chr = content[i]; i++) {
    const leaf = processor.getNodeFactory().makeLeafNode(chr, semantic_meaning_js_1$p.SemanticFont.UNKNOWN);
    const sn = processor.identifierNode(leaf, semantic_meaning_js_1$p.SemanticFont.UNKNOWN, '');
    correction(sn);
    result.push(sn.xml(doc));
  }
  return result;
}
function spaceoutNumber(node) {
  return spaceoutNodes(node, function (sn) {
    if (!sn.textContent.match(/\W/)) {
      sn.type = semantic_meaning_js_1$p.SemanticType.NUMBER;
    }
  });
}
function spaceoutIdentifier(node) {
  return spaceoutNodes(node, function (sn) {
    sn.font = semantic_meaning_js_1$p.SemanticFont.UNKNOWN;
    sn.type = semantic_meaning_js_1$p.SemanticType.IDENTIFIER;
  });
}
const nestingBarriers = [semantic_meaning_js_1$p.SemanticType.CASES, semantic_meaning_js_1$p.SemanticType.CELL, semantic_meaning_js_1$p.SemanticType.INTEGRAL, semantic_meaning_js_1$p.SemanticType.LINE, semantic_meaning_js_1$p.SemanticType.MATRIX, semantic_meaning_js_1$p.SemanticType.MULTILINE, semantic_meaning_js_1$p.SemanticType.OVERSCORE, semantic_meaning_js_1$p.SemanticType.ROOT, semantic_meaning_js_1$p.SemanticType.ROW, semantic_meaning_js_1$p.SemanticType.SQRT, semantic_meaning_js_1$p.SemanticType.SUBSCRIPT, semantic_meaning_js_1$p.SemanticType.SUPERSCRIPT, semantic_meaning_js_1$p.SemanticType.TABLE, semantic_meaning_js_1$p.SemanticType.UNDERSCORE, semantic_meaning_js_1$p.SemanticType.VECTOR];
function resetNestingDepth(node) {
  nestingDepth = {};
  return [node];
}
function getNestingDepth(type, node, tags, opt_barrierTags, opt_barrierAttrs, opt_func) {
  opt_barrierTags = opt_barrierTags || nestingBarriers;
  opt_barrierAttrs = opt_barrierAttrs || ({});
  opt_func = opt_func || (function (_node) {
    return false;
  });
  const xmlText = DomUtil$t.serializeXml(node);
  if (!nestingDepth[type]) {
    nestingDepth[type] = {};
  }
  if (nestingDepth[type][xmlText]) {
    return nestingDepth[type][xmlText];
  }
  if (opt_func(node) || tags.indexOf(node.tagName) < 0) {
    return 0;
  }
  const depth = computeNestingDepth_(node, tags, BaseUtil$2.setdifference(opt_barrierTags, tags), opt_barrierAttrs, opt_func, 0);
  nestingDepth[type][xmlText] = depth;
  return depth;
}
function containsAttr(node, attrs) {
  if (!node.attributes) {
    return false;
  }
  const attributes = DomUtil$t.toArray(node.attributes);
  for (let i = 0, attr; attr = attributes[i]; i++) {
    if (attrs[attr.nodeName] === attr.nodeValue) {
      return true;
    }
  }
  return false;
}
function computeNestingDepth_(node, tags, barriers, attrs, func, depth) {
  if (func(node) || barriers.indexOf(node.tagName) > -1 || containsAttr(node, attrs)) {
    return depth;
  }
  if (tags.indexOf(node.tagName) > -1) {
    depth++;
  }
  if (!node.childNodes || node.childNodes.length === 0) {
    return depth;
  }
  const children = DomUtil$t.toArray(node.childNodes);
  return Math.max.apply(null, children.map(function (subNode) {
    return computeNestingDepth_(subNode, tags, barriers, attrs, func, depth);
  }));
}
function fractionNestingDepth(node) {
  return getNestingDepth('fraction', node, ['fraction'], nestingBarriers, {}, locale_js_1$9.LOCALE.FUNCTIONS.fracNestDepth);
}
function nestedFraction$1(node, expr, opt_end) {
  const depth = fractionNestingDepth(node);
  const annotation = Array(depth).fill(expr);
  if (opt_end) {
    annotation.push(opt_end);
  }
  return annotation.join(locale_js_1$9.LOCALE.MESSAGES.regexp.JOINER_FRAC);
}
function openingFractionVerbose$1(node) {
  return span_js_1$7.Span.singleton(nestedFraction$1(node, locale_js_1$9.LOCALE.MESSAGES.MS.START, locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_V));
}
function closingFractionVerbose$1(node) {
  return span_js_1$7.Span.singleton(nestedFraction$1(node, locale_js_1$9.LOCALE.MESSAGES.MS.END, locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_V), {
    kind: 'LAST'
  });
}
function overFractionVerbose(node) {
  return span_js_1$7.Span.singleton(nestedFraction$1(node, locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_OVER), {});
}
function openingFractionBrief$1(node) {
  return span_js_1$7.Span.singleton(nestedFraction$1(node, locale_js_1$9.LOCALE.MESSAGES.MS.START, locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_B));
}
function closingFractionBrief$1(node) {
  return span_js_1$7.Span.singleton(nestedFraction$1(node, locale_js_1$9.LOCALE.MESSAGES.MS.END, locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_B), {
    kind: 'LAST'
  });
}
function openingFractionSbrief$1(node) {
  const depth = fractionNestingDepth(node);
  return span_js_1$7.Span.singleton(depth === 1 ? locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_S : locale_js_1$9.LOCALE.FUNCTIONS.combineNestedFraction(locale_js_1$9.LOCALE.MESSAGES.MS.NEST_FRAC, locale_js_1$9.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_S));
}
function closingFractionSbrief$1(node) {
  const depth = fractionNestingDepth(node);
  return span_js_1$7.Span.singleton(depth === 1 ? locale_js_1$9.LOCALE.MESSAGES.MS.ENDFRAC : locale_js_1$9.LOCALE.FUNCTIONS.combineNestedFraction(locale_js_1$9.LOCALE.MESSAGES.MS.NEST_FRAC, locale_js_1$9.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), locale_js_1$9.LOCALE.MESSAGES.MS.ENDFRAC), {
    kind: 'LAST'
  });
}
function overFractionSbrief$1(node) {
  const depth = fractionNestingDepth(node);
  return span_js_1$7.Span.singleton(depth === 1 ? locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_OVER : locale_js_1$9.LOCALE.FUNCTIONS.combineNestedFraction(locale_js_1$9.LOCALE.MESSAGES.MS.NEST_FRAC, locale_js_1$9.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), locale_js_1$9.LOCALE.MESSAGES.MS.FRAC_OVER));
}
function isSmallVulgarFraction(node) {
  return locale_js_1$9.LOCALE.FUNCTIONS.fracNestDepth(node) ? [node] : [];
}
function nestedSubSuper(node, init, replace) {
  while (node.parentNode) {
    const children = node.parentNode;
    const parent = children.parentNode;
    if (!parent) {
      break;
    }
    const nodeRole = node.getAttribute && node.getAttribute('role');
    if (parent.tagName === semantic_meaning_js_1$p.SemanticType.SUBSCRIPT && node === children.childNodes[1] || parent.tagName === semantic_meaning_js_1$p.SemanticType.TENSOR && nodeRole && (nodeRole === semantic_meaning_js_1$p.SemanticRole.LEFTSUB || nodeRole === semantic_meaning_js_1$p.SemanticRole.RIGHTSUB)) {
      init = replace.sub + locale_js_1$9.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + init;
    }
    if (parent.tagName === semantic_meaning_js_1$p.SemanticType.SUPERSCRIPT && node === children.childNodes[1] || parent.tagName === semantic_meaning_js_1$p.SemanticType.TENSOR && nodeRole && (nodeRole === semantic_meaning_js_1$p.SemanticRole.LEFTSUPER || nodeRole === semantic_meaning_js_1$p.SemanticRole.RIGHTSUPER)) {
      init = replace.sup + locale_js_1$9.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + init;
    }
    node = parent;
  }
  return init.trim();
}
function subscriptVerbose(node) {
  return span_js_1$7.Span.singleton(nestedSubSuper(node, locale_js_1$9.LOCALE.MESSAGES.MS.SUBSCRIPT, {
    sup: locale_js_1$9.LOCALE.MESSAGES.MS.SUPER,
    sub: locale_js_1$9.LOCALE.MESSAGES.MS.SUB
  }));
}
function subscriptBrief(node) {
  return span_js_1$7.Span.singleton(nestedSubSuper(node, locale_js_1$9.LOCALE.MESSAGES.MS.SUB, {
    sup: locale_js_1$9.LOCALE.MESSAGES.MS.SUP,
    sub: locale_js_1$9.LOCALE.MESSAGES.MS.SUB
  }));
}
function superscriptVerbose(node) {
  return span_js_1$7.Span.singleton(nestedSubSuper(node, locale_js_1$9.LOCALE.MESSAGES.MS.SUPERSCRIPT, {
    sup: locale_js_1$9.LOCALE.MESSAGES.MS.SUPER,
    sub: locale_js_1$9.LOCALE.MESSAGES.MS.SUB
  }));
}
function superscriptBrief(node) {
  return span_js_1$7.Span.singleton(nestedSubSuper(node, locale_js_1$9.LOCALE.MESSAGES.MS.SUP, {
    sup: locale_js_1$9.LOCALE.MESSAGES.MS.SUP,
    sub: locale_js_1$9.LOCALE.MESSAGES.MS.SUB
  }));
}
function baselineVerbose$1(node) {
  const baseline = nestedSubSuper(node, '', {
    sup: locale_js_1$9.LOCALE.MESSAGES.MS.SUPER,
    sub: locale_js_1$9.LOCALE.MESSAGES.MS.SUB
  });
  return span_js_1$7.Span.singleton(!baseline ? locale_js_1$9.LOCALE.MESSAGES.MS.BASELINE : baseline.replace(new RegExp(locale_js_1$9.LOCALE.MESSAGES.MS.SUB + '$'), locale_js_1$9.LOCALE.MESSAGES.MS.SUBSCRIPT).replace(new RegExp(locale_js_1$9.LOCALE.MESSAGES.MS.SUPER + '$'), locale_js_1$9.LOCALE.MESSAGES.MS.SUPERSCRIPT));
}
function baselineBrief$1(node) {
  const baseline = nestedSubSuper(node, '', {
    sup: locale_js_1$9.LOCALE.MESSAGES.MS.SUP,
    sub: locale_js_1$9.LOCALE.MESSAGES.MS.SUB
  });
  return span_js_1$7.Span.singleton(baseline || locale_js_1$9.LOCALE.MESSAGES.MS.BASE);
}
function radicalNestingDepth$1(node) {
  return getNestingDepth('radical', node, ['sqrt', 'root'], nestingBarriers, {});
}
function nestedRadical$2(node, prefix, postfix) {
  const depth = radicalNestingDepth$1(node);
  const index = getRootIndex$1(node);
  postfix = index ? locale_js_1$9.LOCALE.FUNCTIONS.combineRootIndex(postfix, index) : postfix;
  return depth === 1 ? postfix : locale_js_1$9.LOCALE.FUNCTIONS.combineNestedRadical(prefix, locale_js_1$9.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), postfix);
}
function getRootIndex$1(node) {
  const content = node.tagName === 'sqrt' ? '2' : XpathUtil$b.evalXPath('children/*[1]', node)[0].textContent.trim();
  return locale_js_1$9.LOCALE.MESSAGES.MSroots[content] || '';
}
function openingRadicalVerbose$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NESTED, locale_js_1$9.LOCALE.MESSAGES.MS.STARTROOT));
}
function closingRadicalVerbose$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NESTED, locale_js_1$9.LOCALE.MESSAGES.MS.ENDROOT));
}
function indexRadicalVerbose$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NESTED, locale_js_1$9.LOCALE.MESSAGES.MS.ROOTINDEX));
}
function openingRadicalBrief$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$9.LOCALE.MESSAGES.MS.STARTROOT));
}
function closingRadicalBrief$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$9.LOCALE.MESSAGES.MS.ENDROOT));
}
function indexRadicalBrief$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$9.LOCALE.MESSAGES.MS.ROOTINDEX));
}
function openingRadicalSbrief$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$9.LOCALE.MESSAGES.MS.ROOT));
}
function indexRadicalSbrief$1(node) {
  return span_js_1$7.Span.singleton(nestedRadical$2(node, locale_js_1$9.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$9.LOCALE.MESSAGES.MS.INDEX));
}
function underscoreNestingDepth(node) {
  return getNestingDepth('underscore', node, ['underscore'], nestingBarriers, {}, function (node) {
    return node.tagName && node.tagName === semantic_meaning_js_1$p.SemanticType.UNDERSCORE && node.childNodes[0].childNodes[1].getAttribute('role') === semantic_meaning_js_1$p.SemanticRole.UNDERACCENT;
  });
}
function nestedUnderscript(node) {
  const depth = underscoreNestingDepth(node);
  return span_js_1$7.Span.singleton(Array(depth).join(locale_js_1$9.LOCALE.MESSAGES.MS.UNDER) + locale_js_1$9.LOCALE.MESSAGES.MS.UNDERSCRIPT);
}
function overscoreNestingDepth(node) {
  return getNestingDepth('overscore', node, ['overscore'], nestingBarriers, {}, function (node) {
    return node.tagName && node.tagName === semantic_meaning_js_1$p.SemanticType.OVERSCORE && node.childNodes[0].childNodes[1].getAttribute('role') === semantic_meaning_js_1$p.SemanticRole.OVERACCENT;
  });
}
function endscripts(_node) {
  return span_js_1$7.Span.singleton(locale_js_1$9.LOCALE.MESSAGES.MS.ENDSCRIPTS);
}
function nestedOverscript(node) {
  const depth = overscoreNestingDepth(node);
  return span_js_1$7.Span.singleton(Array(depth).join(locale_js_1$9.LOCALE.MESSAGES.MS.OVER) + locale_js_1$9.LOCALE.MESSAGES.MS.OVERSCRIPT);
}
function determinantIsSimple(node) {
  if (node.tagName !== semantic_meaning_js_1$p.SemanticType.MATRIX || node.getAttribute('role') !== semantic_meaning_js_1$p.SemanticRole.DETERMINANT) {
    return [];
  }
  const cells = XpathUtil$b.evalXPath('children/row/children/cell/children/*', node);
  for (let i = 0, cell; cell = cells[i]; i++) {
    if (cell.tagName === semantic_meaning_js_1$p.SemanticType.NUMBER) {
      continue;
    }
    if (cell.tagName === semantic_meaning_js_1$p.SemanticType.IDENTIFIER) {
      const role = cell.getAttribute('role');
      if (role === semantic_meaning_js_1$p.SemanticRole.LATINLETTER || role === semantic_meaning_js_1$p.SemanticRole.GREEKLETTER || role === semantic_meaning_js_1$p.SemanticRole.OTHERLETTER) {
        continue;
      }
    }
    return [];
  }
  return [node];
}
function generateBaselineConstraint() {
  const ignoreElems = ['subscript', 'superscript', 'tensor'];
  const mainElems = ['relseq', 'multrel'];
  const breakElems = ['fraction', 'punctuation', 'fenced', 'sqrt', 'root'];
  const ancestrify = elemList => elemList.map(elem => 'ancestor::' + elem);
  const notify = elem => 'not(' + elem + ')';
  const prefix = 'ancestor::*/following-sibling::*';
  const middle = notify(ancestrify(ignoreElems).join(' or '));
  const mainList = ancestrify(mainElems);
  const breakList = ancestrify(breakElems);
  let breakCstrs = [];
  for (let i = 0, brk; brk = breakList[i]; i++) {
    breakCstrs = breakCstrs.concat(mainList.map(function (elem) {
      return brk + '/' + elem;
    }));
  }
  const postfix = notify(breakCstrs.join(' | '));
  return [[prefix, middle, postfix].join(' and ')];
}
function removeParens(node) {
  if (!node.childNodes.length || !node.childNodes[0].childNodes.length || !node.childNodes[0].childNodes[0].childNodes.length) {
    return span_js_1$7.Span.singleton('');
  }
  const content = node.childNodes[0].childNodes[0].childNodes[0].textContent;
  return span_js_1$7.Span.singleton(content.match(/^\(.+\)$/) ? content.slice(1, -1) : content);
}
const componentString = new Map([[3, 'CSFleftsuperscript'], [4, 'CSFleftsubscript'], [2, 'CSFbaseline'], [1, 'CSFrightsubscript'], [0, 'CSFrightsuperscript']]);
const childNumber = new Map([[4, 2], [3, 3], [2, 1], [1, 4], [0, 5]]);
function generateTensorRuleStrings_(constellation) {
  const constraints = [];
  let verbString = '';
  let briefString = '';
  let constel = parseInt(constellation, 2);
  for (let i = 0; i < 5; i++) {
    const childString = 'children/*[' + childNumber.get(i) + ']';
    if (constel & 1) {
      const compString = componentString.get(i % 5);
      verbString = '[t] ' + compString + 'Verbose; [n] ' + childString + ';' + verbString;
      briefString = '[t] ' + compString + 'Brief; [n] ' + childString + ';' + briefString;
    } else {
      constraints.unshift('name(' + childString + ')="empty"');
    }
    constel >>= 1;
  }
  return [constraints, verbString, briefString];
}
function generateTensorRules(store, brief = true) {
  const constellations = ['11111', '11110', '11101', '11100', '10111', '10110', '10101', '10100', '01111', '01110', '01101', '01100'];
  for (const constel of constellations) {
    let name = 'tensor' + constel;
    let [components, verbStr, briefStr] = generateTensorRuleStrings_(constel);
    store.defineRule(name, 'default', verbStr, 'self::tensor', ...components);
    if (brief) {
      store.defineRule(name, 'brief', briefStr, 'self::tensor', ...components);
      store.defineRule(name, 'sbrief', briefStr, 'self::tensor', ...components);
    }
    if (!(parseInt(constel, 2) & 3)) {
      continue;
    }
    const baselineStr = componentString.get(2);
    verbStr += '; [t]' + baselineStr + 'Verbose';
    briefStr += '; [t]' + baselineStr + 'Brief';
    name = name + '-baseline';
    const cstr = '((.//*[not(*)])[last()]/@id)!=(((.//ancestor::fraction|' + 'ancestor::root|ancestor::sqrt|ancestor::cell|ancestor::line|' + 'ancestor::stree)[1]//*[not(*)])[last()]/@id)';
    store.defineRule(name, 'default', verbStr, 'self::tensor', cstr, ...components);
    if (brief) {
      store.defineRule(name, 'brief', briefStr, 'self::tensor', cstr, ...components);
      store.defineRule(name, 'sbrief', briefStr, 'self::tensor', cstr, ...components);
    }
  }
}
function smallRoot(node) {
  let max = Object.keys(locale_js_1$9.LOCALE.MESSAGES.MSroots).length;
  if (!max) {
    return [];
  } else {
    max++;
  }
  if (!node.childNodes || node.childNodes.length === 0 || !node.childNodes[0].childNodes) {
    return [];
  }
  const index = node.childNodes[0].childNodes[0].textContent;
  if (!(/^\d+$/).test(index)) {
    return [];
  }
  const num = parseInt(index, 10);
  return num > 1 && num <= max ? [node] : [];
}

var numbers_util = {};

Object.defineProperty(numbers_util, "__esModule", {
  value: true
});
numbers_util.ordinalCounter = ordinalCounter;
numbers_util.wordCounter = wordCounter;
numbers_util.vulgarFraction = vulgarFraction;
numbers_util.ordinalPosition = ordinalPosition;
const span_js_1$6 = span;
const DomUtil$s = dom_util;
const locale_js_1$8 = locale$f;
const transformers_js_1 = transformers;
function ordinalCounter(_node, context) {
  let counter = 0;
  return function () {
    return locale_js_1$8.LOCALE.NUMBERS.numericOrdinal(++counter) + ' ' + context;
  };
}
function wordCounter(_node, context) {
  let counter = 0;
  return function () {
    return locale_js_1$8.LOCALE.NUMBERS.numberToOrdinal(++counter, false) + ' ' + context;
  };
}
function vulgarFraction(node) {
  const conversion = (0, transformers_js_1.convertVulgarFraction)(node, locale_js_1$8.LOCALE.MESSAGES.MS.FRAC_OVER);
  if (conversion.convertible && conversion.enumerator && conversion.denominator) {
    return [span_js_1$6.Span.node(locale_js_1$8.LOCALE.NUMBERS.numberToWords(conversion.enumerator), node.childNodes[0].childNodes[0], {
      separator: ''
    }), span_js_1$6.Span.stringAttr(locale_js_1$8.LOCALE.NUMBERS.vulgarSep, {
      separator: ''
    }), span_js_1$6.Span.node(locale_js_1$8.LOCALE.NUMBERS.numberToOrdinal(conversion.denominator, conversion.enumerator !== 1), node.childNodes[0].childNodes[1])];
  }
  return [span_js_1$6.Span.node(conversion.content || '', node)];
}
function ordinalPosition(node) {
  const children = DomUtil$s.toArray(node.parentNode.childNodes);
  return span_js_1$6.Span.singleton(locale_js_1$8.LOCALE.NUMBERS.numericOrdinal(children.indexOf(node) + 1).toString());
}

Object.defineProperty(clearspeak_rules, "__esModule", {
  value: true
});
clearspeak_rules.ClearspeakRules = ClearspeakRules;
const dynamic_cstr_js_1$6 = dynamic_cstr;
const StoreUtil$2 = store_util;
const ClearspeakUtil = clearspeak_util;
const MathspeakUtil$5 = mathspeak_util;
const NumbersUtil$2 = numbers_util;
const SpeechRules$3 = speech_rules;
function ClearspeakRules() {
  SpeechRules$3.addStore(dynamic_cstr_js_1$6.DynamicCstr.BASE_LOCALE + '.speech.clearspeak', '', {
    CTFpauseSeparator: StoreUtil$2.pauseSeparator,
    CTFnodeCounter: ClearspeakUtil.nodeCounter,
    CTFcontentIterator: StoreUtil$2.contentIterator,
    CSFvulgarFraction: NumbersUtil$2.vulgarFraction,
    CQFvulgarFractionSmall: ClearspeakUtil.isSmallVulgarFraction,
    CQFcellsSimple: ClearspeakUtil.allCellsSimple,
    CSFordinalExponent: ClearspeakUtil.ordinalExponent,
    CSFwordOrdinal: ClearspeakUtil.wordOrdinal,
    CQFmatchingFences: ClearspeakUtil.matchingFences,
    CSFnestingDepth: ClearspeakUtil.nestingDepth,
    CQFfencedArguments: ClearspeakUtil.fencedArguments,
    CQFsimpleArguments: ClearspeakUtil.simpleArguments,
    CQFspaceoutNumber: MathspeakUtil$5.spaceoutNumber
  });
}

var mathspeak_rules = {};

var mathspeak_french_util = {};

Object.defineProperty(mathspeak_french_util, "__esModule", {
  value: true
});
mathspeak_french_util.baselineVerbose = baselineVerbose;
mathspeak_french_util.baselineBrief = baselineBrief;
mathspeak_french_util.leftSuperscriptVerbose = leftSuperscriptVerbose;
mathspeak_french_util.leftSubscriptVerbose = leftSubscriptVerbose;
mathspeak_french_util.leftSuperscriptBrief = leftSuperscriptBrief;
mathspeak_french_util.leftSubscriptBrief = leftSubscriptBrief;
const MathspeakUtil$4 = mathspeak_util;
function baselineVerbose(node) {
  const baseline = MathspeakUtil$4.baselineVerbose(node);
  baseline[0].speech = baseline[0].speech.replace(/-$/, '');
  return baseline;
}
function baselineBrief(node) {
  const baseline = MathspeakUtil$4.baselineBrief(node);
  baseline[0].speech = baseline[0].speech.replace(/-$/, '');
  return baseline;
}
function leftSuperscriptVerbose(node) {
  const leftIndex = MathspeakUtil$4.superscriptVerbose(node);
  leftIndex[0].speech = leftIndex[0].speech.replace(/^exposant/, 'exposant gauche');
  return leftIndex;
}
function leftSubscriptVerbose(node) {
  const leftIndex = MathspeakUtil$4.subscriptVerbose(node);
  leftIndex[0].speech = leftIndex[0].speech.replace(/^indice/, 'indice gauche');
  return leftIndex;
}
function leftSuperscriptBrief(node) {
  const leftIndex = MathspeakUtil$4.superscriptBrief(node);
  leftIndex[0].speech = leftIndex[0].speech.replace(/^sup/, 'sup gauche');
  return leftIndex;
}
function leftSubscriptBrief(node) {
  const leftIndex = MathspeakUtil$4.subscriptBrief(node);
  leftIndex[0].speech = leftIndex[0].speech.replace(/^sub/, 'sub gauche');
  return leftIndex;
}

var mathspeak_korean_util = {};

Object.defineProperty(mathspeak_korean_util, "__esModule", {
  value: true
});
mathspeak_korean_util.nestedFraction = nestedFraction;
mathspeak_korean_util.openingFractionVerbose = openingFractionVerbose;
mathspeak_korean_util.closingFractionVerbose = closingFractionVerbose;
mathspeak_korean_util.openingFractionBrief = openingFractionBrief;
mathspeak_korean_util.closingFractionBrief = closingFractionBrief;
mathspeak_korean_util.openingFractionSbrief = openingFractionSbrief;
mathspeak_korean_util.closingFractionSbrief = closingFractionSbrief;
mathspeak_korean_util.overFractionSbrief = overFractionSbrief;
mathspeak_korean_util.isSimpleIndex = isSimpleIndex;
mathspeak_korean_util.nestedRadical = nestedRadical$1;
mathspeak_korean_util.openingRadicalVerbose = openingRadicalVerbose;
mathspeak_korean_util.closingRadicalVerbose = closingRadicalVerbose;
mathspeak_korean_util.openingRadicalBrief = openingRadicalBrief;
mathspeak_korean_util.closingRadicalBrief = closingRadicalBrief;
mathspeak_korean_util.openingRadicalSbrief = openingRadicalSbrief;
mathspeak_korean_util.getRootIndex = getRootIndex;
mathspeak_korean_util.indexRadical = indexRadical$1;
mathspeak_korean_util.indexRadicalVerbose = indexRadicalVerbose;
mathspeak_korean_util.indexRadicalBrief = indexRadicalBrief;
mathspeak_korean_util.indexRadicalSbrief = indexRadicalSbrief;
mathspeak_korean_util.ordinalConversion = ordinalConversion;
mathspeak_korean_util.decreasedOrdinalConversion = decreasedOrdinalConversion;
mathspeak_korean_util.listOrdinalConversion = listOrdinalConversion;
mathspeak_korean_util.checkDepth = checkDepth;
mathspeak_korean_util.getDepthValue = getDepthValue;
const span_js_1$5 = span;
const MathspeakUtil$3 = mathspeak_util;
const locale_js_1$7 = locale$f;
const XpathUtil$a = xpath_util;
function nestedFraction(node, expr, opt_end) {
  const depth = MathspeakUtil$3.fractionNestingDepth(node);
  const annotation = [...Array(depth)].map(_x => expr);
  if (opt_end) {
    annotation.unshift(opt_end);
  }
  return annotation.join(locale_js_1$7.LOCALE.MESSAGES.regexp.JOINER_FRAC);
}
function openingFractionVerbose(node) {
  return span_js_1$5.Span.singleton(nestedFraction(node, locale_js_1$7.LOCALE.MESSAGES.MS.START, locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_V));
}
function closingFractionVerbose(node) {
  return span_js_1$5.Span.singleton(nestedFraction(node, locale_js_1$7.LOCALE.MESSAGES.MS.END, locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_V));
}
function openingFractionBrief(node) {
  return span_js_1$5.Span.singleton(nestedFraction(node, locale_js_1$7.LOCALE.MESSAGES.MS.START, locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_B));
}
function closingFractionBrief(node) {
  return span_js_1$5.Span.singleton(nestedFraction(node, locale_js_1$7.LOCALE.MESSAGES.MS.END, locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_B));
}
function openingFractionSbrief(node) {
  const depth = MathspeakUtil$3.fractionNestingDepth(node);
  if (depth === 1) {
    return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_S);
  }
  return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.FUNCTIONS.combineNestedFraction(locale_js_1$7.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), locale_js_1$7.LOCALE.MESSAGES.MS.NEST_FRAC, locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_S));
}
function closingFractionSbrief(node) {
  const depth = MathspeakUtil$3.fractionNestingDepth(node);
  if (depth === 1) {
    return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.MESSAGES.MS.ENDFRAC);
  }
  return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.FUNCTIONS.combineNestedFraction(locale_js_1$7.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), locale_js_1$7.LOCALE.MESSAGES.MS.NEST_FRAC, locale_js_1$7.LOCALE.MESSAGES.MS.ENDFRAC));
}
function overFractionSbrief(node) {
  const depth = MathspeakUtil$3.fractionNestingDepth(node);
  if (depth === 1) {
    return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_OVER);
  }
  return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.FUNCTIONS.combineNestedFraction(locale_js_1$7.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), locale_js_1$7.LOCALE.MESSAGES.MS.NEST_FRAC, locale_js_1$7.LOCALE.MESSAGES.MS.FRAC_OVER));
}
function isSimpleIndex(node) {
  const index = XpathUtil$a.evalXPath('children/*[1]', node)[0].toString().match(/[^>⁢>]+<\/[^>]*>/g);
  return index.length === 1 ? [node] : [];
}
function nestedRadical$1(node, prefix, postfix) {
  const depth = MathspeakUtil$3.radicalNestingDepth(node);
  if (depth === 1) return postfix;
  return locale_js_1$7.LOCALE.FUNCTIONS.combineNestedRadical(locale_js_1$7.LOCALE.FUNCTIONS.radicalNestDepth(depth - 1), prefix, postfix);
}
function openingRadicalVerbose(node) {
  return span_js_1$5.Span.singleton(nestedRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.NESTED, locale_js_1$7.LOCALE.MESSAGES.MS.STARTROOT));
}
function closingRadicalVerbose(node) {
  return span_js_1$5.Span.singleton(nestedRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.NESTED, locale_js_1$7.LOCALE.MESSAGES.MS.ENDROOT));
}
function openingRadicalBrief(node) {
  return span_js_1$5.Span.singleton(nestedRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$7.LOCALE.MESSAGES.MS.STARTROOT));
}
function closingRadicalBrief(node) {
  return span_js_1$5.Span.singleton(nestedRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$7.LOCALE.MESSAGES.MS.ENDROOT));
}
function openingRadicalSbrief(node) {
  return span_js_1$5.Span.singleton(nestedRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.NEST_ROOT, locale_js_1$7.LOCALE.MESSAGES.MS.ROOT));
}
function getRootIndex(node) {
  const content = XpathUtil$a.evalXPath('children/*[1]', node)[0].textContent.trim();
  return locale_js_1$7.LOCALE.MESSAGES.MSroots[content] || content + '제곱근';
}
function indexRadical$1(node, postfix) {
  const index = getRootIndex(node);
  return index ? index : postfix;
}
function indexRadicalVerbose(node) {
  return span_js_1$5.Span.singleton(indexRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.ROOTINDEX));
}
function indexRadicalBrief(node) {
  return span_js_1$5.Span.singleton(indexRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.ROOTINDEX));
}
function indexRadicalSbrief(node) {
  return span_js_1$5.Span.singleton(indexRadical$1(node, locale_js_1$7.LOCALE.MESSAGES.MS.INDEX));
}
function ordinalConversion(node) {
  const children = XpathUtil$a.evalXPath('children/*', node);
  return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.NUMBERS.wordOrdinal(children.length));
}
function decreasedOrdinalConversion(node) {
  const children = XpathUtil$a.evalXPath('children/*', node);
  return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.NUMBERS.wordOrdinal(children.length - 1));
}
function listOrdinalConversion(node) {
  const children = XpathUtil$a.evalXPath('children/*', node);
  const content = XpathUtil$a.evalXPath('content/*', node);
  return span_js_1$5.Span.singleton(locale_js_1$7.LOCALE.NUMBERS.wordOrdinal(children.length - content.length));
}
function checkDepth(node) {
  const roleList = [];
  const depth = getDepthValue(node, roleList);
  return depth > 3 ? [] : [node];
}
function getDepthValue(node, roleList) {
  const role = node.getAttribute('role');
  const index = roleList.indexOf(role) > -1;
  if (!index) {
    roleList.push(role);
  }
  const children = XpathUtil$a.evalXPath('children/*', node);
  let max = 0, cur = 0;
  if (children.length) {
    children.forEach(child => {
      cur = getDepthValue(child, roleList);
      max = cur > max ? cur : max;
    });
    return max + 1;
  }
  return 0;
}

var unit_util = {};

Object.defineProperty(unit_util, "__esModule", {
  value: true
});
unit_util.unitMultipliers = unitMultipliers;
unit_util.oneLeft = oneLeft;
const auditory_description_js_1$4 = auditory_description;
const XpathUtil$9 = xpath_util;
const locale_js_1$6 = locale$f;
const semantic_meaning_js_1$o = semantic_meaning;
function unitMultipliers(nodes, _context) {
  const children = nodes;
  let counter = 0;
  return function () {
    const descr = auditory_description_js_1$4.AuditoryDescription.create({
      text: rightMostUnit(children[counter]) && leftMostUnit(children[counter + 1]) ? locale_js_1$6.LOCALE.MESSAGES.unitTimes : ''
    }, {});
    counter++;
    return [descr];
  };
}
const SCRIPT_ELEMENTS = [semantic_meaning_js_1$o.SemanticType.SUPERSCRIPT, semantic_meaning_js_1$o.SemanticType.SUBSCRIPT, semantic_meaning_js_1$o.SemanticType.OVERSCORE, semantic_meaning_js_1$o.SemanticType.UNDERSCORE];
function rightMostUnit(node) {
  while (node) {
    if (node.getAttribute('role') === 'unit') {
      return true;
    }
    const tag = node.tagName;
    const children = XpathUtil$9.evalXPath('children/*', node);
    node = SCRIPT_ELEMENTS.indexOf(tag) !== -1 ? children[0] : children[children.length - 1];
  }
  return false;
}
function leftMostUnit(node) {
  while (node) {
    if (node.getAttribute('role') === 'unit') {
      return true;
    }
    const children = XpathUtil$9.evalXPath('children/*', node);
    node = children[0];
  }
  return false;
}
function oneLeft(node) {
  while (node) {
    if (node.tagName === 'number' && node.textContent === '1') {
      return [node];
    }
    if (node.tagName !== 'infixop' || node.getAttribute('role') !== 'multiplication' && node.getAttribute('role') !== 'implicit') {
      return [];
    }
    node = XpathUtil$9.evalXPath('children/*', node)[0];
  }
  return [];
}

Object.defineProperty(mathspeak_rules, "__esModule", {
  value: true
});
mathspeak_rules.MathspeakRules = MathspeakRules;
const dynamic_cstr_js_1$5 = dynamic_cstr;
const StoreUtil$1 = store_util;
const MathspeakFrenchUtil = mathspeak_french_util;
const MathspeakKoreanUtil$1 = mathspeak_korean_util;
const MathspeakUtil$2 = mathspeak_util;
const NumbersUtil$1 = numbers_util;
const SpeechRules$2 = speech_rules;
const UnitUtil = unit_util;
function MathspeakRules() {
  SpeechRules$2.addStore(dynamic_cstr_js_1$5.DynamicCstr.BASE_LOCALE + '.speech.mathspeak', '', {
    CQFspaceoutNumber: MathspeakUtil$2.spaceoutNumber,
    CQFspaceoutIdentifier: MathspeakUtil$2.spaceoutIdentifier,
    CSFspaceoutText: MathspeakUtil$2.spaceoutText,
    CSFopenFracVerbose: MathspeakUtil$2.openingFractionVerbose,
    CSFcloseFracVerbose: MathspeakUtil$2.closingFractionVerbose,
    CSFoverFracVerbose: MathspeakUtil$2.overFractionVerbose,
    CSFopenFracBrief: MathspeakUtil$2.openingFractionBrief,
    CSFcloseFracBrief: MathspeakUtil$2.closingFractionBrief,
    CSFopenFracSbrief: MathspeakUtil$2.openingFractionSbrief,
    CSFcloseFracSbrief: MathspeakUtil$2.closingFractionSbrief,
    CSFoverFracSbrief: MathspeakUtil$2.overFractionSbrief,
    CSFvulgarFraction: NumbersUtil$1.vulgarFraction,
    CQFvulgarFractionSmall: MathspeakUtil$2.isSmallVulgarFraction,
    CSFopenRadicalVerbose: MathspeakUtil$2.openingRadicalVerbose,
    CSFcloseRadicalVerbose: MathspeakUtil$2.closingRadicalVerbose,
    CSFindexRadicalVerbose: MathspeakUtil$2.indexRadicalVerbose,
    CSFopenRadicalBrief: MathspeakUtil$2.openingRadicalBrief,
    CSFcloseRadicalBrief: MathspeakUtil$2.closingRadicalBrief,
    CSFindexRadicalBrief: MathspeakUtil$2.indexRadicalBrief,
    CSFopenRadicalSbrief: MathspeakUtil$2.openingRadicalSbrief,
    CSFindexRadicalSbrief: MathspeakUtil$2.indexRadicalSbrief,
    CQFisSmallRoot: MathspeakUtil$2.smallRoot,
    CSFsuperscriptVerbose: MathspeakUtil$2.superscriptVerbose,
    CSFsuperscriptBrief: MathspeakUtil$2.superscriptBrief,
    CSFsubscriptVerbose: MathspeakUtil$2.subscriptVerbose,
    CSFsubscriptBrief: MathspeakUtil$2.subscriptBrief,
    CSFbaselineVerbose: MathspeakUtil$2.baselineVerbose,
    CSFbaselineBrief: MathspeakUtil$2.baselineBrief,
    CSFleftsuperscriptVerbose: MathspeakUtil$2.superscriptVerbose,
    CSFleftsubscriptVerbose: MathspeakUtil$2.subscriptVerbose,
    CSFrightsuperscriptVerbose: MathspeakUtil$2.superscriptVerbose,
    CSFrightsubscriptVerbose: MathspeakUtil$2.subscriptVerbose,
    CSFleftsuperscriptBrief: MathspeakUtil$2.superscriptBrief,
    CSFleftsubscriptBrief: MathspeakUtil$2.subscriptBrief,
    CSFrightsuperscriptBrief: MathspeakUtil$2.superscriptBrief,
    CSFrightsubscriptBrief: MathspeakUtil$2.subscriptBrief,
    CSFunderscript: MathspeakUtil$2.nestedUnderscript,
    CSFoverscript: MathspeakUtil$2.nestedOverscript,
    CSFendscripts: MathspeakUtil$2.endscripts,
    CTFordinalCounter: NumbersUtil$1.ordinalCounter,
    CTFwordCounter: NumbersUtil$1.wordCounter,
    CTFcontentIterator: StoreUtil$1.contentIterator,
    CQFdetIsSimple: MathspeakUtil$2.determinantIsSimple,
    CSFRemoveParens: MathspeakUtil$2.removeParens,
    CQFresetNesting: MathspeakUtil$2.resetNestingDepth,
    CGFbaselineConstraint: MathspeakUtil$2.generateBaselineConstraint,
    CGFtensorRules: MathspeakUtil$2.generateTensorRules
  });
  SpeechRules$2.addStore('es.speech.mathspeak', dynamic_cstr_js_1$5.DynamicCstr.BASE_LOCALE + '.speech.mathspeak', {
    CTFunitMultipliers: UnitUtil.unitMultipliers,
    CQFoneLeft: UnitUtil.oneLeft
  });
  SpeechRules$2.addStore('fr.speech.mathspeak', dynamic_cstr_js_1$5.DynamicCstr.BASE_LOCALE + '.speech.mathspeak', {
    CSFbaselineVerbose: MathspeakFrenchUtil.baselineVerbose,
    CSFbaselineBrief: MathspeakFrenchUtil.baselineBrief,
    CSFleftsuperscriptVerbose: MathspeakFrenchUtil.leftSuperscriptVerbose,
    CSFleftsubscriptVerbose: MathspeakFrenchUtil.leftSubscriptVerbose,
    CSFleftsuperscriptBrief: MathspeakFrenchUtil.leftSuperscriptBrief,
    CSFleftsubscriptBrief: MathspeakFrenchUtil.leftSubscriptBrief
  });
  SpeechRules$2.addStore('ko.speech.mathspeak', dynamic_cstr_js_1$5.DynamicCstr.BASE_LOCALE + '.speech.mathspeak', {
    CSFopenFracVerbose: MathspeakKoreanUtil$1.openingFractionVerbose,
    CSFcloseFracVerbose: MathspeakKoreanUtil$1.closingFractionVerbose,
    CSFopenFracBrief: MathspeakKoreanUtil$1.openingFractionBrief,
    CSFcloseFracBrief: MathspeakKoreanUtil$1.closingFractionBrief,
    CSFopenFracSbrief: MathspeakKoreanUtil$1.openingFractionSbrief,
    CSFoverFracSbrief: MathspeakKoreanUtil$1.overFractionSbrief,
    CSFcloseFracSbrief: MathspeakKoreanUtil$1.closingFractionSbrief,
    CQFisSimpleIndex: MathspeakKoreanUtil$1.isSimpleIndex,
    CSFindexRadicalVerbose: MathspeakKoreanUtil$1.indexRadicalVerbose,
    CSFindexRadicalBrief: MathspeakKoreanUtil$1.indexRadicalBrief,
    CSFindexRadicalSbrief: MathspeakKoreanUtil$1.indexRadicalSbrief,
    CSFopenRadicalVerbose: MathspeakKoreanUtil$1.openingRadicalVerbose,
    CSFcloseRadicalVerbose: MathspeakKoreanUtil$1.closingRadicalVerbose,
    CSFopenRadicalBrief: MathspeakKoreanUtil$1.openingRadicalBrief,
    CSFcloseRadicalBrief: MathspeakKoreanUtil$1.closingRadicalBrief,
    CSFopenRadicalSbrief: MathspeakKoreanUtil$1.openingRadicalSbrief
  });
}

var other_rules = {};

var nemeth_util = {};

Object.defineProperty(nemeth_util, "__esModule", {
  value: true
});
nemeth_util.openingFraction = openingFraction;
nemeth_util.closingFraction = closingFraction;
nemeth_util.overFraction = overFraction;
nemeth_util.overBevelledFraction = overBevelledFraction;
nemeth_util.hyperFractionBoundary = hyperFractionBoundary;
nemeth_util.openingRadical = openingRadical;
nemeth_util.closingRadical = closingRadical;
nemeth_util.indexRadical = indexRadical;
nemeth_util.relationIterator = relationIterator;
nemeth_util.implicitIterator = implicitIterator;
nemeth_util.contentIterator = contentIterator;
const auditory_description_js_1$3 = auditory_description;
const span_js_1$4 = span;
const DomUtil$r = dom_util;
const XpathUtil$8 = xpath_util;
const grammar_js_1$3 = grammar;
const engine_js_1$i = engine;
const semantic_annotations_js_1$3 = semantic_annotations;
const semantic_annotator_js_1$1 = semantic_annotator;
const semantic_meaning_js_1$n = semantic_meaning;
const locale_js_1$5 = locale$f;
const MathspeakUtil$1 = mathspeak_util;
const store_util_js_1 = store_util;
function openingFraction(node) {
  const depth = MathspeakUtil$1.fractionNestingDepth(node);
  return span_js_1$4.Span.singleton(new Array(depth).join(locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_START);
}
function closingFraction(node) {
  const depth = MathspeakUtil$1.fractionNestingDepth(node);
  return span_js_1$4.Span.singleton(new Array(depth).join(locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_END);
}
function overFraction(node) {
  const depth = MathspeakUtil$1.fractionNestingDepth(node);
  return span_js_1$4.Span.singleton(new Array(depth).join(locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_OVER);
}
function overBevelledFraction(node) {
  const depth = MathspeakUtil$1.fractionNestingDepth(node);
  return span_js_1$4.Span.singleton(new Array(depth).join(locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + '⠸' + locale_js_1$5.LOCALE.MESSAGES.MS.FRACTION_OVER);
}
function hyperFractionBoundary(node) {
  return locale_js_1$5.LOCALE.MESSAGES.regexp.HYPER === MathspeakUtil$1.fractionNestingDepth(node).toString() ? [node] : [];
}
function nestedRadical(node, postfix) {
  const depth = radicalNestingDepth(node);
  return span_js_1$4.Span.singleton(depth === 1 ? postfix : new Array(depth).join(locale_js_1$5.LOCALE.MESSAGES.MS.NESTED) + postfix);
}
function radicalNestingDepth(node, opt_depth) {
  const depth = opt_depth || 0;
  if (!node.parentNode) {
    return depth;
  }
  return radicalNestingDepth(node.parentNode, node.tagName === 'root' || node.tagName === 'sqrt' ? depth + 1 : depth);
}
function openingRadical(node) {
  return nestedRadical(node, locale_js_1$5.LOCALE.MESSAGES.MS.STARTROOT);
}
function closingRadical(node) {
  return nestedRadical(node, locale_js_1$5.LOCALE.MESSAGES.MS.ENDROOT);
}
function indexRadical(node) {
  return nestedRadical(node, locale_js_1$5.LOCALE.MESSAGES.MS.ROOTINDEX);
}
function enlargeFence(text) {
  const start = '⠠';
  if (text.length === 1) {
    return start + text;
  }
  const neut = '⠳';
  const split = text.split('');
  if (split.every(function (x) {
    return x === neut;
  })) {
    return start + split.join(start);
  }
  return text.slice(0, -1) + start + text.slice(-1);
}
grammar_js_1$3.Grammar.getInstance().setCorrection('enlargeFence', enlargeFence);
const NUMBER_PROPAGATORS = [semantic_meaning_js_1$n.SemanticType.MULTIREL, semantic_meaning_js_1$n.SemanticType.RELSEQ, semantic_meaning_js_1$n.SemanticType.APPL, semantic_meaning_js_1$n.SemanticType.ROW, semantic_meaning_js_1$n.SemanticType.LINE];
const NUMBER_INHIBITORS = [semantic_meaning_js_1$n.SemanticType.SUBSCRIPT, semantic_meaning_js_1$n.SemanticType.SUPERSCRIPT, semantic_meaning_js_1$n.SemanticType.OVERSCORE, semantic_meaning_js_1$n.SemanticType.UNDERSCORE];
function checkParent(node, info) {
  const parent = node.parent;
  if (!parent) {
    return false;
  }
  const type = parent.type;
  if (NUMBER_PROPAGATORS.indexOf(type) !== -1 || type === semantic_meaning_js_1$n.SemanticType.PREFIXOP && parent.role === semantic_meaning_js_1$n.SemanticRole.NEGATIVE && !info.script && !info.enclosed || type === semantic_meaning_js_1$n.SemanticType.PREFIXOP && parent.role === semantic_meaning_js_1$n.SemanticRole.GEOMETRY) {
    return true;
  }
  if (type === semantic_meaning_js_1$n.SemanticType.PUNCTUATED) {
    if (!info.enclosed || parent.role === semantic_meaning_js_1$n.SemanticRole.TEXT) {
      return true;
    }
  }
  return false;
}
function propagateNumber(node, info) {
  if (!node.childNodes.length) {
    if (checkParent(node, info)) {
      info.number = true;
      info.script = false;
      info.enclosed = false;
    }
    return [info['number'] ? 'number' : '', {
      number: false,
      enclosed: info.enclosed,
      script: info.script
    }];
  }
  if (NUMBER_INHIBITORS.indexOf(node.type) !== -1) {
    info.script = true;
  }
  if (node.type === semantic_meaning_js_1$n.SemanticType.FENCED) {
    info.number = false;
    info.enclosed = true;
    return ['', info];
  }
  if (node.type === semantic_meaning_js_1$n.SemanticType.PREFIXOP && node.role !== semantic_meaning_js_1$n.SemanticRole.GEOMETRY && node.role !== semantic_meaning_js_1$n.SemanticRole.NEGATIVE) {
    info.number = false;
    return ['', info];
  }
  if (checkParent(node, info)) {
    info.number = true;
    info.enclosed = false;
  }
  return ['', info];
}
(0, semantic_annotations_js_1$3.register)(new semantic_annotator_js_1$1.SemanticVisitor('nemeth', 'number', propagateNumber, {
  number: true
}));
function annotateDepth(node) {
  if (!node.parent) {
    return [1];
  }
  const depth = parseInt(node.parent.annotation['depth'][0]);
  return [depth + 1];
}
(0, semantic_annotations_js_1$3.register)(new semantic_annotator_js_1$1.SemanticVisitor('depth', 'depth', annotateDepth));
(0, semantic_annotations_js_1$3.activate)('depth', 'depth');
function relationIterator(nodes, context) {
  var _a;
  const childNodes = nodes.slice(0);
  let first = true;
  const parentNode = nodes[0].parentNode.parentNode;
  const match = (_a = parentNode.getAttribute('annotation')) === null || _a === void 0 ? void 0 : _a.match(/depth:(\d+)/);
  const depth = match ? match[1] : '';
  let contentNodes;
  if (nodes.length > 0) {
    contentNodes = XpathUtil$8.evalXPath('./content/*', parentNode);
  } else {
    contentNodes = [];
  }
  return function () {
    const content = contentNodes.shift();
    const leftChild = childNodes.shift();
    const rightChild = childNodes[0];
    const contextDescr = context ? [auditory_description_js_1$3.AuditoryDescription.create({
      text: context
    }, {
      translate: true
    })] : [];
    if (!content) {
      return contextDescr;
    }
    const base = leftChild ? MathspeakUtil$1.nestedSubSuper(leftChild, '', {
      sup: locale_js_1$5.LOCALE.MESSAGES.MS.SUPER,
      sub: locale_js_1$5.LOCALE.MESSAGES.MS.SUB
    }) : '';
    const left = leftChild && DomUtil$r.tagName(leftChild) !== 'EMPTY' || first && parentNode && parentNode.previousSibling ? [auditory_description_js_1$3.AuditoryDescription.create({
      text: locale_js_1$5.LOCALE.MESSAGES.regexp.SPACE + base
    }, {})] : [];
    const right = rightChild && DomUtil$r.tagName(rightChild) !== 'EMPTY' || !contentNodes.length && parentNode && parentNode.nextSibling ? [auditory_description_js_1$3.AuditoryDescription.create({
      text: locale_js_1$5.LOCALE.MESSAGES.regexp.SPACE
    }, {})] : [];
    const descrs = engine_js_1$i.Engine.evaluateNode(content);
    descrs.unshift(new auditory_description_js_1$3.AuditoryDescription({
      text: '',
      layout: `beginrel${depth}`
    }));
    descrs.push(new auditory_description_js_1$3.AuditoryDescription({
      text: '',
      layout: `endrel${depth}`
    }));
    first = false;
    return contextDescr.concat(left, descrs, right);
  };
}
function implicitIterator(nodes, context) {
  const childNodes = nodes.slice(0);
  let contentNodes;
  if (nodes.length > 0) {
    contentNodes = XpathUtil$8.evalXPath('../../content/*', nodes[0]);
  } else {
    contentNodes = [];
  }
  return function () {
    const leftChild = childNodes.shift();
    const rightChild = childNodes[0];
    const content = contentNodes.shift();
    const contextDescr = context ? [auditory_description_js_1$3.AuditoryDescription.create({
      text: context
    }, {
      translate: true
    })] : [];
    if (!content) {
      return contextDescr;
    }
    const left = leftChild && DomUtil$r.tagName(leftChild) === 'NUMBER';
    const right = rightChild && DomUtil$r.tagName(rightChild) === 'NUMBER';
    return contextDescr.concat(left && right && content.getAttribute('role') === semantic_meaning_js_1$n.SemanticRole.SPACE ? [auditory_description_js_1$3.AuditoryDescription.create({
      text: locale_js_1$5.LOCALE.MESSAGES.regexp.SPACE
    }, {})] : []);
  };
}
function ignoreEnglish(text) {
  return (0, grammar_js_1$3.correctFont)(text, locale_js_1$5.LOCALE.ALPHABETS.languagePrefix.english);
}
grammar_js_1$3.Grammar.getInstance().setCorrection('ignoreEnglish', ignoreEnglish);
function contentIterator(nodes, context) {
  var _a;
  const func = (0, store_util_js_1.contentIterator)(nodes, context);
  const parentNode = nodes[0].parentNode.parentNode;
  const match = (_a = parentNode.getAttribute('annotation')) === null || _a === void 0 ? void 0 : _a.match(/depth:(\d+)/);
  const depth = match ? match[1] : '';
  return function () {
    const descrs = func();
    descrs.unshift(new auditory_description_js_1$3.AuditoryDescription({
      text: '',
      layout: `beginrel${depth}`
    }));
    descrs.push(new auditory_description_js_1$3.AuditoryDescription({
      text: '',
      layout: `endrel${depth}`
    }));
    return descrs;
  };
}
function literal(text) {
  const evalStr = e => engine_js_1$i.Engine.getInstance().evaluator(e, engine_js_1$i.Engine.getInstance().dynamicCstr);
  return Array.from(text).map(evalStr).join('');
}
grammar_js_1$3.Grammar.getInstance().setCorrection('literal', literal);

Object.defineProperty(other_rules, "__esModule", {
  value: true
});
other_rules.PrefixRules = PrefixRules;
other_rules.OtherRules = OtherRules;
other_rules.BrailleRules = BrailleRules;
const dynamic_cstr_js_1$4 = dynamic_cstr;
const StoreUtil = store_util;
const MathspeakKoreanUtil = mathspeak_korean_util;
const MathspeakUtil = mathspeak_util;
const NemethUtil = nemeth_util;
const NumbersUtil = numbers_util;
const SpeechRules$1 = speech_rules;
function PrefixRules() {
  SpeechRules$1.addStore('en.prefix.default', '', {
    CSFordinalPosition: NumbersUtil.ordinalPosition
  });
}
function OtherRules() {
  SpeechRules$1.addStore('en.speech.chromevox', '', {
    CTFnodeCounter: StoreUtil.nodeCounter,
    CTFcontentIterator: StoreUtil.contentIterator
  });
  SpeechRules$1.addStore('en.speech.emacspeak', 'en.speech.chromevox', {
    CQFvulgarFractionSmall: MathspeakUtil.isSmallVulgarFraction,
    CSFvulgarFraction: NumbersUtil.vulgarFraction
  });
  SpeechRules$1.addStore('ko.summary.', 'ko.speech.mathspeak', {
    CSFordinalConversion: MathspeakKoreanUtil.ordinalConversion,
    CSFdecreasedOrdinalConversion: MathspeakKoreanUtil.decreasedOrdinalConversion,
    CSFlistOrdinalConversion: MathspeakKoreanUtil.listOrdinalConversion
  });
}
function BrailleRules() {
  SpeechRules$1.addStore('nemeth.braille.default', dynamic_cstr_js_1$4.DynamicCstr.BASE_LOCALE + '.speech.mathspeak', {
    CSFopenFraction: NemethUtil.openingFraction,
    CSFcloseFraction: NemethUtil.closingFraction,
    CSFoverFraction: NemethUtil.overFraction,
    CSFoverBevFraction: NemethUtil.overBevelledFraction,
    CQFhyperFraction: NemethUtil.hyperFractionBoundary,
    CSFopenRadical: NemethUtil.openingRadical,
    CSFcloseRadical: NemethUtil.closingRadical,
    CSFindexRadical: NemethUtil.indexRadical,
    CSFsubscript: MathspeakUtil.subscriptVerbose,
    CSFsuperscript: MathspeakUtil.superscriptVerbose,
    CSFbaseline: MathspeakUtil.baselineVerbose,
    CGFtensorRules: st => MathspeakUtil.generateTensorRules(st, false),
    CTFcontentIterator: NemethUtil.contentIterator,
    CTFrelationIterator: NemethUtil.relationIterator,
    CTFimplicitIterator: NemethUtil.implicitIterator
  });
  SpeechRules$1.addStore('euro.braille.default', 'nemeth.braille.default', {});
}

Object.defineProperty(speech_rule_stores, "__esModule", {
  value: true
});
speech_rule_stores.init = init$2;
const clearspeak_rules_js_1 = clearspeak_rules;
const mathspeak_rules_js_1 = mathspeak_rules;
const other_rules_js_1 = other_rules;
let INIT = false;
function init$2() {
  if (INIT) {
    return;
  }
  (0, mathspeak_rules_js_1.MathspeakRules)();
  (0, clearspeak_rules_js_1.ClearspeakRules)();
  (0, other_rules_js_1.PrefixRules)();
  (0, other_rules_js_1.OtherRules)();
  (0, other_rules_js_1.BrailleRules)();
  INIT = true;
}

var braille_store = {};

var math_store = {};

var base_rule_store = {};

var speech_rule = {};

Object.defineProperty(speech_rule, "__esModule", {
  value: true
});
speech_rule.OutputError = speech_rule.Precondition = speech_rule.Action = speech_rule.Component = speech_rule.ActionType = speech_rule.SpeechRule = void 0;
const engine_js_1$h = engine;
const Grammar = grammar;
class SpeechRule {
  constructor(name, dynamicCstr, precondition, action) {
    this.name = name;
    this.dynamicCstr = dynamicCstr;
    this.precondition = precondition;
    this.action = action;
    this.context = null;
  }
  toString() {
    return this.name + ' | ' + this.dynamicCstr.toString() + ' | ' + this.precondition.toString() + ' ==> ' + this.action.toString();
  }
}
speech_rule.SpeechRule = SpeechRule;
var ActionType;
(function (ActionType) {
  ActionType["NODE"] = "NODE";
  ActionType["MULTI"] = "MULTI";
  ActionType["TEXT"] = "TEXT";
  ActionType["PERSONALITY"] = "PERSONALITY";
})(ActionType || (speech_rule.ActionType = ActionType = {}));
function actionFromString(str) {
  switch (str) {
    case '[n]':
      return ActionType.NODE;
    case '[m]':
      return ActionType.MULTI;
    case '[t]':
      return ActionType.TEXT;
    case '[p]':
      return ActionType.PERSONALITY;
    default:
      throw 'Parse error: ' + str;
  }
}
function actionToString(speechType) {
  switch (speechType) {
    case ActionType.NODE:
      return '[n]';
    case ActionType.MULTI:
      return '[m]';
    case ActionType.TEXT:
      return '[t]';
    case ActionType.PERSONALITY:
      return '[p]';
    default:
      throw 'Unknown type error: ' + speechType;
  }
}
class Component {
  static grammarFromString(grammar) {
    return Grammar.Grammar.parseInput(grammar);
  }
  static fromString(input) {
    const output = {
      type: actionFromString(input.substring(0, 3))
    };
    let rest = input.slice(3).trim();
    if (!rest) {
      throw new OutputError('Missing content.');
    }
    switch (output.type) {
      case ActionType.TEXT:
        if (rest[0] === '"') {
          const quotedString = splitString(rest, '\\(')[0].trim();
          if (quotedString.slice(-1) !== '"') {
            throw new OutputError('Invalid string syntax.');
          }
          output.content = quotedString;
          rest = rest.slice(quotedString.length).trim();
          if (rest.indexOf('(') === -1) {
            rest = '';
          }
          break;
        }
      case ActionType.NODE:
      case ActionType.MULTI:
        {
          const bracket = rest.indexOf(' (');
          if (bracket === -1) {
            output.content = rest.trim();
            rest = '';
            break;
          }
          output.content = rest.substring(0, bracket).trim();
          rest = rest.slice(bracket).trim();
        }
        break;
    }
    if (rest) {
      const attributes = Component.attributesFromString(rest);
      if (attributes.grammar) {
        output.grammar = attributes.grammar;
        delete attributes.grammar;
      }
      if (Object.keys(attributes).length) {
        output.attributes = attributes;
      }
    }
    return new Component(output);
  }
  static attributesFromString(attrs) {
    if (attrs[0] !== '(' || attrs.slice(-1) !== ')') {
      throw new OutputError('Invalid attribute expression: ' + attrs);
    }
    const attributes = {};
    const attribs = splitString(attrs.slice(1, -1), ',');
    for (const attr of attribs) {
      const colon = attr.indexOf(':');
      if (colon === -1) {
        attributes[attr.trim()] = 'true';
      } else {
        const key = attr.substring(0, colon).trim();
        const value = attr.slice(colon + 1).trim();
        attributes[key] = key === Grammar.ATTRIBUTE ? Component.grammarFromString(value) : value;
      }
    }
    return attributes;
  }
  constructor({type, content, attributes, grammar}) {
    this.type = type;
    this.content = content;
    this.attributes = attributes;
    this.grammar = grammar;
  }
  toString() {
    let strs = '';
    strs += actionToString(this.type);
    strs += this.content ? ' ' + this.content : '';
    const attrs = this.attributesToString();
    strs += attrs ? ' ' + attrs : '';
    return strs;
  }
  grammarToString() {
    return this.getGrammar().join(':');
  }
  getGrammar() {
    if (!this.grammar) {
      return [];
    }
    const attribs = [];
    for (const [key, val] of Object.entries(this.grammar)) {
      attribs.push(val === true ? key : val === false ? `!${key}` : `${key}=${val}`);
    }
    return attribs;
  }
  attributesToString() {
    const attribs = this.getAttributes();
    const grammar = this.grammarToString();
    if (grammar) {
      attribs.push('grammar:' + grammar);
    }
    return attribs.length > 0 ? '(' + attribs.join(', ') + ')' : '';
  }
  getAttributes() {
    if (!this.attributes) {
      return [];
    }
    const attribs = [];
    for (const [key, val] of Object.entries(this.attributes)) {
      attribs.push(val === 'true' ? key : `${key}:${val}`);
    }
    return attribs;
  }
}
speech_rule.Component = Component;
class Action {
  static fromString(input) {
    const comps = splitString(input, ';').filter(function (x) {
      return x.match(/\S/);
    }).map(function (x) {
      return x.trim();
    });
    const newComps = [];
    for (let i = 0, m = comps.length; i < m; i++) {
      const comp = Component.fromString(comps[i]);
      if (comp) {
        newComps.push(comp);
      }
    }
    Action.naiveSpan(newComps);
    return new Action(newComps);
  }
  static naiveSpan(comps) {
    var _a;
    let first = false;
    for (let i = 0, comp; comp = comps[i]; i++) {
      if (first && (comp.type !== ActionType.TEXT || comp.content[0] !== '"' && !comp.content.match(/^CSF/))) continue;
      if (!first && comp.type === ActionType.PERSONALITY) continue;
      if (!first) {
        first = true;
        continue;
      }
      if ((_a = comp.attributes) === null || _a === void 0 ? void 0 : _a.span) continue;
      const next = comps[i + 1];
      if (next && next.type !== ActionType.NODE) continue;
      Action.addNaiveSpan(comp, next ? next.content : 'LAST');
    }
  }
  static addNaiveSpan(comp, span) {
    if (!comp.attributes) {
      comp.attributes = {};
    }
    comp.attributes['span'] = span;
  }
  constructor(components) {
    this.components = components;
  }
  toString() {
    const comps = this.components.map(function (c) {
      return c.toString();
    });
    return comps.join('; ');
  }
}
speech_rule.Action = Action;
class Precondition {
  static constraintValue(constr, priorities) {
    for (let i = 0, regexp; regexp = priorities[i]; i++) {
      if (constr.match(regexp)) {
        return ++i;
      }
    }
    return 0;
  }
  toString() {
    const constrs = this.constraints.join(', ');
    return `${this.query}, ${constrs} (${this.priority}, ${this.rank})`;
  }
  constructor(query, ...cstr) {
    this.query = query;
    this.constraints = cstr;
    const [exists, user] = this.presetPriority();
    this.priority = exists ? user : this.calculatePriority();
  }
  calculatePriority() {
    const query = Precondition.constraintValue(this.query, Precondition.queryPriorities);
    if (!query) {
      return 0;
    }
    const match = this.query.match(/^self::.+\[(.+)\]/);
    let attr = 0;
    if ((match === null || match === void 0 ? void 0 : match.length) && match[1]) {
      const inner = match[1];
      attr = Precondition.constraintValue(inner, Precondition.attributePriorities);
    }
    return query * 100 + attr * 10;
  }
  presetPriority() {
    if (!this.constraints.length) {
      return [false, 0];
    }
    const last = this.constraints[this.constraints.length - 1].match(/^priority=(.*$)/);
    if (!last) {
      return [false, 0];
    }
    this.constraints.pop();
    const numb = parseFloat(last[1]);
    return [true, isNaN(numb) ? 0 : numb];
  }
}
speech_rule.Precondition = Precondition;
Precondition.queryPriorities = [/^self::\*$/, /^self::[\w-]+$/, /^self::\*\[.+\]$/, /^self::[\w-]+\[.+\]$/];
Precondition.attributePriorities = [/^@[\w-]+$/, /^@[\w-]+!=".+"$/, /^not\(contains\(@[\w-]+,\s*".+"\)\)$/, /^contains\(@[\w-]+,".+"\)$/, /^@[\w-]+=".+"$/];
class OutputError extends engine_js_1$h.SREError {
  constructor(msg) {
    super(msg);
    this.name = 'RuleError';
  }
}
speech_rule.OutputError = OutputError;
function splitString(str, sep) {
  const strList = [];
  let prefix = '';
  while (str !== '') {
    const sepPos = str.search(sep);
    if (sepPos === -1) {
      if ((str.match(/"/g) || []).length % 2 !== 0) {
        throw new OutputError('Invalid string in expression: ' + str);
      }
      strList.push(prefix + str);
      prefix = '';
      str = '';
    } else if ((str.substring(0, sepPos).match(/"/g) || []).length % 2 === 0) {
      strList.push(prefix + str.substring(0, sepPos));
      prefix = '';
      str = str.substring(sepPos + 1);
    } else {
      const nextQuot = str.substring(sepPos).search('"');
      if (nextQuot === -1) {
        throw new OutputError('Invalid string in expression: ' + str);
      } else {
        prefix = prefix + str.substring(0, sepPos + nextQuot + 1);
        str = str.substring(sepPos + nextQuot + 1);
      }
    }
  }
  if (prefix) {
    strList.push(prefix);
  }
  return strList;
}

var speech_rule_context = {};

var speech_rule_functions = {};

Object.defineProperty(speech_rule_functions, "__esModule", {
  value: true
});
speech_rule_functions.CustomGenerators = speech_rule_functions.ContextFunctions = speech_rule_functions.CustomStrings = speech_rule_functions.CustomQueries = void 0;
class FunctionsStore {
  constructor(prefix, store) {
    this.prefix = prefix;
    this.store = store;
  }
  add(name, func) {
    if (this.checkCustomFunctionSyntax_(name)) {
      this.store[name] = func;
    }
  }
  addStore(store) {
    const keys = Object.keys(store.store);
    for (let i = 0, key; key = keys[i]; i++) {
      this.add(key, store.store[key]);
    }
  }
  lookup(name) {
    return this.store[name];
  }
  checkCustomFunctionSyntax_(name) {
    const reg = new RegExp('^' + this.prefix);
    if (!name.match(reg)) {
      console.error('FunctionError: Invalid function name. Expected prefix ' + this.prefix);
      return false;
    }
    return true;
  }
}
class CustomQueries extends FunctionsStore {
  constructor() {
    const store = {};
    super('CQF', store);
  }
}
speech_rule_functions.CustomQueries = CustomQueries;
class CustomStrings extends FunctionsStore {
  constructor() {
    const store = {};
    super('CSF', store);
  }
}
speech_rule_functions.CustomStrings = CustomStrings;
class ContextFunctions extends FunctionsStore {
  constructor() {
    const store = {};
    super('CTF', store);
  }
}
speech_rule_functions.ContextFunctions = ContextFunctions;
class CustomGenerators extends FunctionsStore {
  constructor() {
    const store = {};
    super('CGF', store);
  }
}
speech_rule_functions.CustomGenerators = CustomGenerators;

Object.defineProperty(speech_rule_context, "__esModule", {
  value: true
});
speech_rule_context.SpeechRuleContext = void 0;
const span_js_1$3 = span;
const XpathUtil$7 = xpath_util;
const srf = speech_rule_functions;
class SpeechRuleContext {
  constructor() {
    this.customQueries = new srf.CustomQueries();
    this.customStrings = new srf.CustomStrings();
    this.contextFunctions = new srf.ContextFunctions();
    this.customGenerators = new srf.CustomGenerators();
  }
  applyCustomQuery(node, funcName) {
    const func = this.customQueries.lookup(funcName);
    return func ? func(node) : null;
  }
  applySelector(node, expr) {
    const result = this.applyCustomQuery(node, expr);
    return result || XpathUtil$7.evalXPath(expr, node);
  }
  applyQuery(node, expr) {
    const results = this.applySelector(node, expr);
    if (results.length > 0) {
      return results[0];
    }
    return null;
  }
  applyConstraint(node, expr) {
    const result = this.applyQuery(node, expr);
    return !!result || XpathUtil$7.evaluateBoolean(expr, node);
  }
  constructString(node, expr) {
    const result = this.constructString_(node, expr);
    return Array.isArray(result) ? result.map(x => x.speech).join('') : result;
  }
  constructSpan(node, expr, def) {
    const result = this.constructString_(node, expr);
    if (Array.isArray(result)) {
      const last = result[result.length - 1];
      last.attributes = Object.assign({}, def, last.attributes);
      return result;
    } else {
      return [span_js_1$3.Span.node(result, node, def)];
    }
  }
  constructString_(node, expr) {
    if (!expr) {
      return '';
    }
    if (expr.charAt(0) === '"') {
      return expr.slice(1, -1);
    }
    const func = this.customStrings.lookup(expr);
    if (func) {
      return func(node);
    }
    return XpathUtil$7.evaluateString(expr, node);
  }
  parse(functions) {
    const functs = Array.isArray(functions) ? functions : Object.entries(functions);
    for (const func of functs) {
      const kind = func[0].slice(0, 3);
      switch (kind) {
        case 'CQF':
          this.customQueries.add(func[0], func[1]);
          break;
        case 'CSF':
          this.customStrings.add(func[0], func[1]);
          break;
        case 'CTF':
          this.contextFunctions.add(func[0], func[1]);
          break;
        case 'CGF':
          this.customGenerators.add(func[0], func[1]);
          break;
        default:
          console.error('FunctionError: Invalid function name ' + func[0]);
      }
    }
  }
}
speech_rule_context.SpeechRuleContext = SpeechRuleContext;

Object.defineProperty(base_rule_store, "__esModule", {
  value: true
});
base_rule_store.BaseRuleStore = void 0;
const auditory_description_js_1$2 = auditory_description;
const dynamic_cstr_js_1$3 = dynamic_cstr;
const speech_rule_js_1$2 = speech_rule;
const speech_rule_context_js_1 = speech_rule_context;
class BaseRuleStore {
  static compareStaticConstraints_(cstr1, cstr2) {
    if (cstr1.length !== cstr2.length) {
      return false;
    }
    for (let i = 0, cstr; cstr = cstr1[i]; i++) {
      if (cstr2.indexOf(cstr) === -1) {
        return false;
      }
    }
    return true;
  }
  static comparePreconditions_(rule1, rule2) {
    const prec1 = rule1.precondition;
    const prec2 = rule2.precondition;
    if (prec1.query !== prec2.query) {
      return false;
    }
    return BaseRuleStore.compareStaticConstraints_(prec1.constraints, prec2.constraints);
  }
  constructor() {
    this.context = new speech_rule_context_js_1.SpeechRuleContext();
    this.parseOrder = dynamic_cstr_js_1$3.DynamicCstr.DEFAULT_ORDER;
    this.parser = new dynamic_cstr_js_1$3.DynamicCstrParser(this.parseOrder);
    this.locale = dynamic_cstr_js_1$3.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$3.Axis.LOCALE];
    this.modality = dynamic_cstr_js_1$3.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$3.Axis.MODALITY];
    this.domain = '';
    this.initialized = false;
    this.inherits = null;
    this.kind = 'standard';
    this.customTranscriptions = {};
    this.preconditions = new Map();
    this.speechRules_ = [];
    this.rank = 0;
    this.parseMethods = {
      Rule: this.defineRule,
      Generator: this.generateRules,
      Action: this.defineAction,
      Precondition: this.definePrecondition,
      Ignore: this.ignoreRules
    };
  }
  defineRule(name, dynamic, action, prec, ...args) {
    const postc = this.parseAction(action);
    const fullPrec = this.parsePrecondition(prec, args);
    const dynamicCstr = this.parseCstr(dynamic);
    if (!(postc && fullPrec && dynamicCstr)) {
      console.error(`Rule Error: ${prec}, (${dynamic}): ${action}`);
      return null;
    }
    const rule = new speech_rule_js_1$2.SpeechRule(name, dynamicCstr, fullPrec, postc);
    rule.precondition.rank = this.rank++;
    this.addRule(rule);
    return rule;
  }
  addRule(rule) {
    rule.context = this.context;
    this.speechRules_.unshift(rule);
  }
  deleteRule(rule) {
    const index = this.speechRules_.indexOf(rule);
    if (index !== -1) {
      this.speechRules_.splice(index, 1);
    }
  }
  findRule(pred) {
    for (let i = 0, rule; rule = this.speechRules_[i]; i++) {
      if (pred(rule)) {
        return rule;
      }
    }
    return null;
  }
  findAllRules(pred) {
    return this.speechRules_.filter(pred);
  }
  evaluateDefault(node) {
    const rest = node.textContent.slice(0);
    if (rest.match(/^\s+$/)) {
      return this.evaluateWhitespace(rest);
    }
    return this.evaluateString(rest);
  }
  evaluateWhitespace(_str) {
    return [];
  }
  evaluateCustom(str) {
    const trans = this.customTranscriptions[str];
    return trans !== undefined ? auditory_description_js_1$2.AuditoryDescription.create({
      text: trans
    }, {
      adjust: true,
      translate: false
    }) : null;
  }
  evaluateCharacter(str) {
    return this.evaluateCustom(str) || auditory_description_js_1$2.AuditoryDescription.create({
      text: str
    }, {
      adjust: true,
      translate: true
    });
  }
  removeDuplicates(rule) {
    for (let i = this.speechRules_.length - 1, oldRule; oldRule = this.speechRules_[i]; i--) {
      if (oldRule !== rule && rule.dynamicCstr.equal(oldRule.dynamicCstr) && BaseRuleStore.comparePreconditions_(oldRule, rule)) {
        this.speechRules_.splice(i, 1);
      }
    }
  }
  getSpeechRules() {
    return this.speechRules_;
  }
  setSpeechRules(rules) {
    this.speechRules_ = rules;
  }
  getPreconditions() {
    return this.preconditions;
  }
  parseCstr(cstr) {
    try {
      return this.parser.parse(this.locale + '.' + this.modality + (this.domain ? '.' + this.domain : '') + '.' + cstr);
    } catch (err) {
      if (err.name === 'RuleError') {
        console.error('Rule Error ', `Illegal Dynamic Constraint: ${cstr}.`, err.message);
        return null;
      } else {
        throw err;
      }
    }
  }
  parsePrecondition(query, rest) {
    try {
      const queryCstr = this.parsePrecondition_(query);
      query = queryCstr[0];
      let restCstr = queryCstr.slice(1);
      for (const cstr of rest) {
        restCstr = restCstr.concat(this.parsePrecondition_(cstr));
      }
      return new speech_rule_js_1$2.Precondition(query, ...restCstr);
    } catch (err) {
      if (err.name === 'RuleError') {
        console.error('Rule Error ', `Illegal preconditions: ${query}, ${rest}.`, err.message);
        return null;
      } else {
        throw err;
      }
    }
  }
  parseAction(action) {
    try {
      return speech_rule_js_1$2.Action.fromString(action);
    } catch (err) {
      if (err.name === 'RuleError') {
        console.error('Rule Error ', `Illegal action: ${action}.`, err.message);
        return null;
      } else {
        throw err;
      }
    }
  }
  parse(ruleSet) {
    this.modality = ruleSet.modality || this.modality;
    this.locale = ruleSet.locale || this.locale;
    this.domain = ruleSet.domain || this.domain;
    this.context.parse(ruleSet.functions || []);
    if (ruleSet.kind !== 'actions') {
      this.kind = ruleSet.kind || this.kind;
      this.inheritRules();
    }
    this.parseRules(ruleSet.rules || []);
  }
  parseRules(rules) {
    for (let i = 0, rule; rule = rules[i]; i++) {
      const type = rule[0];
      const method = this.parseMethods[type];
      if (type && method) {
        method.apply(this, rule.slice(1));
      }
    }
  }
  generateRules(generator) {
    const method = this.context.customGenerators.lookup(generator);
    if (method) {
      method(this);
    }
  }
  defineAction(name, action) {
    let postc;
    try {
      postc = speech_rule_js_1$2.Action.fromString(action);
    } catch (err) {
      if (err.name === 'RuleError') {
        console.error('Action Error ', action, err.message);
        return;
      } else {
        throw err;
      }
    }
    const prec = this.getFullPreconditions(name);
    if (!prec) {
      console.error(`Action Error: No precondition for action ${name}`);
      return;
    }
    this.ignoreRules(name);
    const regexp = new RegExp('^\\w+\\.\\w+\\.' + (this.domain ? '\\w+\\.' : ''));
    prec.conditions.forEach(([dynamic, prec]) => {
      const newDynamic = this.parseCstr(dynamic.toString().replace(regexp, ''));
      this.addRule(new speech_rule_js_1$2.SpeechRule(name, newDynamic, prec, postc));
    });
  }
  getFullPreconditions(name) {
    const prec = this.preconditions.get(name);
    if (prec || !this.inherits) {
      return prec;
    }
    return this.inherits.getFullPreconditions(name);
  }
  definePrecondition(name, dynamic, prec, ...args) {
    const fullPrec = this.parsePrecondition(prec, args);
    const dynamicCstr = this.parseCstr(dynamic);
    if (!(fullPrec && dynamicCstr)) {
      console.error(`Precondition Error: ${prec}, (${dynamic})`);
      return;
    }
    fullPrec.rank = this.rank++;
    this.preconditions.set(name, new Condition(dynamicCstr, fullPrec));
  }
  inheritRules() {
    if (!this.inherits || !this.inherits.getSpeechRules().length) {
      return;
    }
    const regexp = new RegExp('^\\w+\\.\\w+\\.' + (this.domain ? '\\w+\\.' : ''));
    this.inherits.getSpeechRules().forEach(rule => {
      const newDynamic = this.parseCstr(rule.dynamicCstr.toString().replace(regexp, ''));
      this.addRule(new speech_rule_js_1$2.SpeechRule(rule.name, newDynamic, rule.precondition, rule.action));
    });
  }
  ignoreRules(name, ...cstrs) {
    let rules = this.findAllRules(r => r.name === name);
    if (!cstrs.length) {
      rules.forEach(this.deleteRule.bind(this));
      return;
    }
    let rest = [];
    for (const cstr of cstrs) {
      const dynamic = this.parseCstr(cstr);
      for (const rule of rules) {
        if (dynamic.equal(rule.dynamicCstr)) {
          this.deleteRule(rule);
        } else {
          rest.push(rule);
        }
      }
      rules = rest;
      rest = [];
    }
  }
  parsePrecondition_(cstr) {
    const generator = this.context.customGenerators.lookup(cstr);
    return generator ? generator() : [cstr];
  }
}
base_rule_store.BaseRuleStore = BaseRuleStore;
class Condition {
  constructor(base, condition) {
    this.base = base;
    this._conditions = [];
    this.constraints = [];
    this.allCstr = {};
    this.constraints.push(base);
    this.addCondition(base, condition);
  }
  get conditions() {
    return this._conditions;
  }
  addConstraint(dynamic) {
    if (this.constraints.filter(cstr => cstr.equal(dynamic)).length) {
      return;
    }
    this.constraints.push(dynamic);
    const newConds = [];
    for (const [dyn, pre] of this.conditions) {
      if (this.base.equal(dyn)) {
        newConds.push([dynamic, pre]);
      }
    }
    this._conditions = this._conditions.concat(newConds);
  }
  addBaseCondition(cond) {
    this.addCondition(this.base, cond);
  }
  addFullCondition(cond) {
    this.constraints.forEach(cstr => this.addCondition(cstr, cond));
  }
  addCondition(dynamic, cond) {
    const condStr = dynamic.toString() + ' ' + cond.toString();
    if (this.allCstr.condStr) {
      return;
    }
    this.allCstr[condStr] = true;
    this._conditions.push([dynamic, cond]);
  }
}

Object.defineProperty(math_store, "__esModule", {
  value: true
});
math_store.MathStore = void 0;
const BaseUtil$1 = base_util;
const locale_js_1$4 = locale$f;
const semantic_annotations_js_1$2 = semantic_annotations;
const base_rule_store_js_1 = base_rule_store;
const speech_rule_js_1$1 = speech_rule;
class MathStore extends base_rule_store_js_1.BaseRuleStore {
  constructor() {
    super();
    this.annotators = [];
    this.parseMethods['Alias'] = this.defineAlias;
    this.parseMethods['SpecializedRule'] = this.defineSpecializedRule;
    this.parseMethods['Specialized'] = this.defineSpecialized;
  }
  initialize() {
    if (this.initialized) {
      return;
    }
    this.annotations();
    this.initialized = true;
  }
  annotations() {
    for (let i = 0, annotator; annotator = this.annotators[i]; i++) {
      (0, semantic_annotations_js_1$2.activate)(this.domain, annotator);
    }
  }
  defineAlias(name, prec, ...args) {
    const fullPrec = this.parsePrecondition(prec, args);
    if (!fullPrec) {
      console.error(`Precondition Error: ${prec} ${args}`);
      return;
    }
    const condition = this.preconditions.get(name);
    if (!condition) {
      console.error(`Alias Error: No precondition by the name of ${name}`);
      return;
    }
    condition.addFullCondition(fullPrec);
  }
  defineRulesAlias(name, query, ...args) {
    const rules = this.findAllRules(function (rule) {
      return rule.name === name;
    });
    if (rules.length === 0) {
      throw new speech_rule_js_1$1.OutputError('Rule with name ' + name + ' does not exist.');
    }
    const keep = [];
    const findKeep = rule => {
      const cstr = rule.dynamicCstr.toString();
      const action = rule.action.toString();
      for (let i = 0, k; k = keep[i]; i++) {
        if (k.action === action && k.cstr === cstr) {
          return false;
        }
      }
      keep.push({
        cstr: cstr,
        action: action
      });
      return true;
    };
    rules.forEach(rule => {
      if (findKeep(rule)) {
        this.addAlias_(rule, query, args);
      }
    });
  }
  defineSpecializedRule(name, oldDynamic, newDynamic, opt_action) {
    const dynamicCstr = this.parseCstr(oldDynamic);
    const rule = this.findRule(rule => rule.name === name && dynamicCstr.equal(rule.dynamicCstr));
    const newCstr = this.parseCstr(newDynamic);
    if (!rule && opt_action) {
      throw new speech_rule_js_1$1.OutputError('Rule named ' + name + ' with style ' + oldDynamic + ' does not exist.');
    }
    const action = opt_action ? speech_rule_js_1$1.Action.fromString(opt_action) : rule.action;
    const newRule = new speech_rule_js_1$1.SpeechRule(rule.name, newCstr, rule.precondition, action);
    this.addRule(newRule);
  }
  defineSpecialized(name, _old, dynamic) {
    const cstr = this.parseCstr(dynamic);
    if (!cstr) {
      console.error(`Dynamic Constraint Error: ${dynamic}`);
      return;
    }
    const condition = this.preconditions.get(name);
    if (!condition) {
      console.error(`Alias Error: No precondition by the name of ${name}`);
      return;
    }
    condition.addConstraint(cstr);
  }
  evaluateString(str) {
    const descs = [];
    if (str.match(/^\s+$/)) {
      return descs;
    }
    let num = this.matchNumber(str);
    if (num && num.length === str.length) {
      descs.push(this.evaluateCharacter(num.number));
      return descs;
    }
    const split = BaseUtil$1.removeEmpty(str.replace(/\s/g, ' ').split(' '));
    for (let i = 0, s; s = split[i]; i++) {
      if (s.length === 1) {
        descs.push(this.evaluateCharacter(s));
      } else if (s.match(new RegExp('^[' + locale_js_1$4.LOCALE.MESSAGES.regexp.TEXT + ']+$'))) {
        descs.push(this.evaluateCharacter(s));
      } else {
        let rest = s;
        while (rest) {
          num = this.matchNumber(rest);
          const alpha = rest.match(new RegExp('^[' + locale_js_1$4.LOCALE.MESSAGES.regexp.TEXT + ']+'));
          if (num) {
            descs.push(this.evaluateCharacter(num.number));
            rest = rest.substring(num.length);
          } else if (alpha) {
            descs.push(this.evaluateCharacter(alpha[0]));
            rest = rest.substring(alpha[0].length);
          } else {
            const chars = Array.from(rest);
            const chr = chars[0];
            descs.push(this.evaluateCharacter(chr));
            rest = chars.slice(1).join('');
          }
        }
      }
    }
    return descs;
  }
  parse(ruleSet) {
    super.parse(ruleSet);
    this.annotators = ruleSet['annotators'] || [];
  }
  addAlias_(rule, query, cstrList) {
    const prec = this.parsePrecondition(query, cstrList);
    const newRule = new speech_rule_js_1$1.SpeechRule(rule.name, rule.dynamicCstr, prec, rule.action);
    newRule.name = rule.name;
    this.addRule(newRule);
  }
  matchNumber(str) {
    const locNum = str.match(new RegExp('^' + locale_js_1$4.LOCALE.MESSAGES.regexp.NUMBER));
    const enNum = str.match(new RegExp('^' + MathStore.regexp.NUMBER));
    if (!locNum && !enNum) {
      return null;
    }
    const isEn = enNum && enNum[0] === str;
    const isLoc = locNum && locNum[0] === str || !isEn;
    if (isLoc) {
      return locNum ? {
        number: locNum[0],
        length: locNum[0].length
      } : null;
    }
    const num = enNum[0].replace(new RegExp(MathStore.regexp.DIGIT_GROUP, 'g'), 'X').replace(new RegExp(MathStore.regexp.DECIMAL_MARK, 'g'), locale_js_1$4.LOCALE.MESSAGES.regexp.DECIMAL_MARK).replace(/X/g, locale_js_1$4.LOCALE.MESSAGES.regexp.DIGIT_GROUP.replace(/\\/g, ''));
    return {
      number: num,
      length: enNum[0].length
    };
  }
}
math_store.MathStore = MathStore;
MathStore.regexp = {
  NUMBER: '((\\d{1,3})(?=(,| ))((,| )\\d{3})*(\\.\\d+)?)|^\\d*\\.\\d+|^\\d+',
  DECIMAL_MARK: '\\.',
  DIGIT_GROUP: ','
};

Object.defineProperty(braille_store, "__esModule", {
  value: true
});
braille_store.EuroStore = braille_store.BrailleStore = void 0;
const math_store_js_1$1 = math_store;
const semantic_annotations_js_1$1 = semantic_annotations;
const semantic_attr_js_1$4 = semantic_attr;
const semantic_meaning_js_1$m = semantic_meaning;
class BrailleStore extends math_store_js_1$1.MathStore {
  constructor() {
    super(...arguments);
    this.modality = 'braille';
    this.customTranscriptions = {
      '\u22ca': '⠈⠡⠳'
    };
  }
  evaluateString(str) {
    const descs = [];
    const text = Array.from(str);
    for (let i = 0; i < text.length; i++) {
      descs.push(this.evaluateCharacter(text[i]));
    }
    return descs;
  }
  annotations() {
    for (let i = 0, annotator; annotator = this.annotators[i]; i++) {
      (0, semantic_annotations_js_1$1.activate)(this.locale, annotator);
    }
  }
}
braille_store.BrailleStore = BrailleStore;
class EuroStore extends BrailleStore {
  constructor() {
    super(...arguments);
    this.locale = 'euro';
    this.customTranscriptions = {};
    this.customCommands = {
      '\\cdot': '*',
      '\\lt': '<',
      '\\gt': '>'
    };
    this.lastSpecial = false;
    this.specialChars = ['^', '_', '{', '}'];
  }
  evaluateString(str) {
    const regexp = /(\\[a-z]+|\\{|\\}|\\\\)/i;
    const split = str.split(regexp);
    const cleaned = this.cleanup(split);
    return super.evaluateString(cleaned);
  }
  cleanup(commands) {
    const cleaned = [];
    let intext = false;
    let lastcom = null;
    for (let command of commands) {
      if (command.match(/^\\/)) {
        if (command === '\\text') {
          intext = true;
        }
        if (this.addSpace(semantic_attr_js_1$4.SemanticMap.LatexCommands.get(command))) {
          cleaned.push(' ');
        }
        command = this.customCommands[command] || command;
        const newcom = command.match(/^\\/);
        if (newcom && command.match(/^\\[a-zA-Z]+$/) && lastcom) {
          cleaned.push(' ');
        }
        lastcom = newcom ? command : null;
        cleaned.push(command);
        continue;
      }
      const rest = command.split('');
      for (const char of rest) {
        if (intext) {
          cleaned.push(char);
          intext = char !== '}';
          lastcom = null;
          continue;
        }
        if (char.match(/[a-z]/i) && lastcom) {
          lastcom = null;
          cleaned.push(' ');
          cleaned.push(char);
          continue;
        }
        if (char.match(/\s/)) continue;
        if (this.addSpace(char)) {
          cleaned.push(' ');
        }
        cleaned.push(char);
        lastcom = null;
      }
    }
    return cleaned.join('');
  }
  addSpace(char) {
    if (!char) return false;
    if (this.specialChars.indexOf(char) !== -1) {
      this.lastSpecial = true;
      return false;
    }
    if (this.lastSpecial) {
      this.lastSpecial = false;
      return false;
    }
    const meaning = semantic_attr_js_1$4.SemanticMap.Meaning.get(char);
    return meaning.type === semantic_meaning_js_1$m.SemanticType.OPERATOR || meaning.type === semantic_meaning_js_1$m.SemanticType.RELATION || meaning.type === semantic_meaning_js_1$m.SemanticType.PUNCTUATION && meaning.role === semantic_meaning_js_1$m.SemanticRole.COLON;
  }
}
braille_store.EuroStore = EuroStore;

var trie = {};

var trie_node = {};

Object.defineProperty(trie_node, "__esModule", {
  value: true
});
trie_node.TrieNodeKind = void 0;
var TrieNodeKind;
(function (TrieNodeKind) {
  TrieNodeKind["ROOT"] = "root";
  TrieNodeKind["DYNAMIC"] = "dynamic";
  TrieNodeKind["QUERY"] = "query";
  TrieNodeKind["BOOLEAN"] = "boolean";
  TrieNodeKind["STATIC"] = "static";
})(TrieNodeKind || (trie_node.TrieNodeKind = TrieNodeKind = {}));

var trie_node_factory = {};

var abstract_trie_node = {};

Object.defineProperty(abstract_trie_node, "__esModule", {
  value: true
});
abstract_trie_node.StaticTrieNode = abstract_trie_node.AbstractTrieNode = void 0;
const debugger_js_1$6 = _debugger;
const trie_node_js_1$2 = trie_node;
class AbstractTrieNode {
  constructor(constraint, test) {
    this.constraint = constraint;
    this.test = test;
    this.children_ = {};
    this.kind = trie_node_js_1$2.TrieNodeKind.ROOT;
  }
  getConstraint() {
    return this.constraint;
  }
  getKind() {
    return this.kind;
  }
  applyTest(object) {
    return this.test(object);
  }
  addChild(node) {
    const constraint = node.getConstraint();
    const child = this.children_[constraint];
    this.children_[constraint] = node;
    return child;
  }
  getChild(constraint) {
    return this.children_[constraint];
  }
  getChildren() {
    const children = [];
    for (const val of Object.values(this.children_)) {
      children.push(val);
    }
    return children;
  }
  findChildren(object) {
    const children = [];
    for (const val of Object.values(this.children_)) {
      if (val.applyTest(object)) {
        children.push(val);
      }
    }
    return children;
  }
  removeChild(constraint) {
    delete this.children_[constraint];
  }
  toString() {
    return this.constraint;
  }
}
abstract_trie_node.AbstractTrieNode = AbstractTrieNode;
class StaticTrieNode extends AbstractTrieNode {
  constructor(constraint, test) {
    super(constraint, test);
    this.rule_ = null;
    this.kind = trie_node_js_1$2.TrieNodeKind.STATIC;
  }
  getRule() {
    return this.rule_;
  }
  setRule(rule) {
    if (this.rule_) {
      debugger_js_1$6.Debugger.getInstance().output('Replacing rule ' + this.rule_ + ' with ' + rule);
    }
    this.rule_ = rule;
  }
  toString() {
    const rule = this.getRule();
    return rule ? this.constraint + '\n' + '==> ' + this.getRule().action : this.constraint;
  }
}
abstract_trie_node.StaticTrieNode = StaticTrieNode;

Object.defineProperty(trie_node_factory, "__esModule", {
  value: true
});
trie_node_factory.getNode = getNode;
const DomUtil$q = dom_util;
const XpathUtil$6 = xpath_util;
const grammar_js_1$2 = grammar;
const MathCompoundStore$3 = math_compound_store;
const abstract_trie_node_js_1 = abstract_trie_node;
const abstract_trie_node_js_2 = abstract_trie_node;
const trie_node_js_1$1 = trie_node;
function getNode(kind, constraint, context) {
  switch (kind) {
    case trie_node_js_1$1.TrieNodeKind.ROOT:
      return new RootTrieNode();
    case trie_node_js_1$1.TrieNodeKind.DYNAMIC:
      return new DynamicTrieNode(constraint);
    case trie_node_js_1$1.TrieNodeKind.QUERY:
      return new QueryTrieNode(constraint, context);
    case trie_node_js_1$1.TrieNodeKind.BOOLEAN:
      return new BooleanTrieNode(constraint, context);
    default:
      return null;
  }
}
class RootTrieNode extends abstract_trie_node_js_1.AbstractTrieNode {
  constructor() {
    super('', () => true);
    this.kind = trie_node_js_1$1.TrieNodeKind.ROOT;
  }
}
class DynamicTrieNode extends abstract_trie_node_js_1.AbstractTrieNode {
  constructor(constraint) {
    super(constraint, axis => axis === constraint);
    this.kind = trie_node_js_1$1.TrieNodeKind.DYNAMIC;
  }
}
const comparator = {
  '=': (x, y) => x === y,
  '!=': (x, y) => x !== y,
  '<': (x, y) => x < y,
  '>': (x, y) => x > y,
  '<=': (x, y) => x <= y,
  '>=': (x, y) => x >= y
};
function constraintTest(constraint) {
  if (constraint.match(/^self::\*$/)) {
    return _node => true;
  }
  if (constraint.match(/^self::\w+$/)) {
    const tag = constraint.slice(6).toUpperCase();
    return node => node.tagName && DomUtil$q.tagName(node) === tag;
  }
  if (constraint.match(/^self::\w+:\w+$/)) {
    const inter = constraint.split(':');
    const namespace = XpathUtil$6.resolveNameSpace(inter[2]);
    if (!namespace) {
      return null;
    }
    const tag = inter[3].toUpperCase();
    return node => node.localName && node.localName.toUpperCase() === tag && node.namespaceURI === namespace;
  }
  if (constraint.match(/^@\w+$/)) {
    const attr = constraint.slice(1);
    return node => node.hasAttribute && node.hasAttribute(attr);
  }
  if (constraint.match(/^@\w+="[\w\d ]+"$/)) {
    const split = constraint.split('=');
    const attr = split[0].slice(1);
    const value = split[1].slice(1, -1);
    return node => node.hasAttribute && node.hasAttribute(attr) && node.getAttribute(attr) === value;
  }
  if (constraint.match(/^@\w+!="[\w\d ]+"$/)) {
    const split = constraint.split('!=');
    const attr = split[0].slice(1);
    const value = split[1].slice(1, -1);
    return node => !node.hasAttribute || !node.hasAttribute(attr) || node.getAttribute(attr) !== value;
  }
  if (constraint.match(/^contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)$/)) {
    const split = constraint.split('"');
    const value = split[1];
    return _node => !!grammar_js_1$2.Grammar.getInstance().getParameter(value);
  }
  if (constraint.match(/^not\(\s*contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)\s*\)$/)) {
    const split = constraint.split('"');
    const value = split[1];
    return _node => !grammar_js_1$2.Grammar.getInstance().getParameter(value);
  }
  if (constraint.match(/^name\(\.\.\/\.\.\)="\w+"$/)) {
    const split = constraint.split('"');
    const tag = split[1].toUpperCase();
    return node => {
      var _a, _b;
      return ((_b = (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.tagName) && DomUtil$q.tagName(node.parentNode.parentNode) === tag;
    };
  }
  if (constraint.match(/^count\(preceding-sibling::\*\)=\d+$/)) {
    const split = constraint.split('=');
    const num = parseInt(split[1], 10);
    return node => {
      var _a;
      return ((_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.childNodes[num]) === node;
    };
  }
  if (constraint.match(/^.+\[@category!?=".+"\]$/)) {
    let [, query, equality, category] = constraint.match(/^(.+)\[@category(!?=)"(.+)"\]$/);
    const unit = category.match(/^unit:(.+)$/);
    let add = '';
    if (unit) {
      category = unit[1];
      add = ':unit';
    }
    return node => {
      const xpath = XpathUtil$6.evalXPath(query, node)[0];
      if (xpath) {
        const result = MathCompoundStore$3.lookupCategory(xpath.textContent + add);
        return equality === '=' ? result === category : result !== category;
      }
      return false;
    };
  }
  if (constraint.match(/^string-length\(.+\)\W+\d+/)) {
    const [, select, comp, count] = constraint.match(/^string-length\((.+)\)(\W+)(\d+)/);
    const func = comparator[comp] || comparator['='];
    const numb = parseInt(count, 10);
    return node => {
      const xpath = XpathUtil$6.evalXPath(select, node)[0];
      if (!xpath) {
        return false;
      }
      return func(Array.from(xpath.textContent).length, numb);
    };
  }
  return null;
}
class QueryTrieNode extends abstract_trie_node_js_2.StaticTrieNode {
  constructor(constraint, context) {
    super(constraint, constraintTest(constraint));
    this.context = context;
    this.kind = trie_node_js_1$1.TrieNodeKind.QUERY;
  }
  applyTest(object) {
    return this.test ? this.test(object) : this.context.applyQuery(object, this.constraint) === object;
  }
}
class BooleanTrieNode extends abstract_trie_node_js_2.StaticTrieNode {
  constructor(constraint, context) {
    super(constraint, constraintTest(constraint));
    this.context = context;
    this.kind = trie_node_js_1$1.TrieNodeKind.BOOLEAN;
  }
  applyTest(object) {
    return this.test ? this.test(object) : this.context.applyConstraint(object, this.constraint);
  }
}

Object.defineProperty(trie, "__esModule", {
  value: true
});
trie.Trie = void 0;
const trie_node_js_1 = trie_node;
const trie_node_factory_js_1 = trie_node_factory;
class Trie {
  static collectRules_(root) {
    const rules = [];
    let explore = [root];
    while (explore.length) {
      const node = explore.shift();
      if (node.getKind() === trie_node_js_1.TrieNodeKind.QUERY || node.getKind() === trie_node_js_1.TrieNodeKind.BOOLEAN) {
        const rule = node.getRule();
        if (rule) {
          rules.unshift(rule);
        }
      }
      explore = explore.concat(node.getChildren());
    }
    return rules;
  }
  static printWithDepth_(node, depth, str) {
    const prefix = new Array(depth + 2).join(depth.toString()) + ': ';
    str += prefix + node.toString() + '\n';
    const children = node.getChildren();
    for (let i = 0, child; child = children[i]; i++) {
      str = Trie.printWithDepth_(child, depth + 1, str);
    }
    return str;
  }
  static order_(node) {
    const children = node.getChildren();
    if (!children.length) {
      return 0;
    }
    const max = Math.max.apply(null, children.map(Trie.order_));
    return Math.max(children.length, max);
  }
  constructor() {
    this.root = (0, trie_node_factory_js_1.getNode)(trie_node_js_1.TrieNodeKind.ROOT, '', null);
  }
  addRule(rule) {
    let node = this.root;
    const context = rule.context;
    const dynamicCstr = rule.dynamicCstr.getValues();
    for (let i = 0, l = dynamicCstr.length; i < l; i++) {
      node = this.addNode_(node, dynamicCstr[i], trie_node_js_1.TrieNodeKind.DYNAMIC, context);
    }
    node = this.addNode_(node, rule.precondition.query, trie_node_js_1.TrieNodeKind.QUERY, context);
    const booleans = rule.precondition.constraints;
    for (let i = 0, l = booleans.length; i < l; i++) {
      node = this.addNode_(node, booleans[i], trie_node_js_1.TrieNodeKind.BOOLEAN, context);
    }
    node.setRule(rule);
  }
  lookupRules(xml, dynamic) {
    let nodes = [this.root];
    const rules = [];
    while (dynamic.length) {
      const dynamicSet = dynamic.shift();
      const newNodes = [];
      while (nodes.length) {
        const node = nodes.shift();
        const children = node.getChildren();
        children.forEach(child => {
          if (child.getKind() !== trie_node_js_1.TrieNodeKind.DYNAMIC || dynamicSet.indexOf(child.getConstraint()) !== -1) {
            newNodes.push(child);
          }
        });
      }
      nodes = newNodes.slice();
    }
    while (nodes.length) {
      const node = nodes.shift();
      if (node.getRule) {
        const rule = node.getRule();
        if (rule) {
          rules.push(rule);
        }
      }
      const children = node.findChildren(xml);
      nodes = nodes.concat(children);
    }
    return rules;
  }
  hasSubtrie(cstrs) {
    let subtrie = this.root;
    for (let i = 0, l = cstrs.length; i < l; i++) {
      const cstr = cstrs[i];
      subtrie = subtrie.getChild(cstr);
      if (!subtrie) {
        return false;
      }
    }
    return true;
  }
  toString() {
    return Trie.printWithDepth_(this.root, 0, '');
  }
  collectRules(root = this.root) {
    return Trie.collectRules_(root);
  }
  order() {
    return Trie.order_(this.root);
  }
  enumerate(opt_info) {
    return this.enumerate_(this.root, opt_info);
  }
  byConstraint(constraint) {
    let node = this.root;
    while (constraint.length && node) {
      const cstr = constraint.shift();
      node = node.getChild(cstr);
    }
    return node || null;
  }
  enumerate_(node, info) {
    info = info || ({});
    const children = node.getChildren();
    for (let i = 0, child; child = children[i]; i++) {
      if (child.kind !== trie_node_js_1.TrieNodeKind.DYNAMIC) {
        continue;
      }
      info[child.getConstraint()] = this.enumerate_(child, info[child.getConstraint()]);
    }
    return info;
  }
  addNode_(node, constraint, kind, context) {
    let nextNode = node.getChild(constraint);
    if (!nextNode) {
      nextNode = (0, trie_node_factory_js_1.getNode)(kind, constraint, context);
      node.addChild(nextNode);
    }
    return nextNode;
  }
}
trie.Trie = Trie;

Object.defineProperty(speech_rule_engine, "__esModule", {
  value: true
});
speech_rule_engine.SpeechRuleEngine = void 0;
const auditory_description_js_1$1 = auditory_description;
const span_js_1$2 = span;
const debugger_js_1$5 = _debugger;
const DomUtil$p = dom_util;
const engine_js_1$g = engine;
const EngineConst$c = engine_const;
const xpath_util_js_1 = xpath_util;
const SpeechRules = speech_rules;
const SpeechRuleStores = speech_rule_stores;
const braille_store_js_1 = braille_store;
const dynamic_cstr_js_1$2 = dynamic_cstr;
const grammar_js_1$1 = grammar;
const math_store_js_1 = math_store;
const speech_rule_js_1 = speech_rule;
const trie_js_1 = trie;
class SpeechRuleEngine {
  static getInstance() {
    SpeechRuleEngine.instance = SpeechRuleEngine.instance || new SpeechRuleEngine();
    return SpeechRuleEngine.instance;
  }
  static debugSpeechRule(rule, node) {
    const prec = rule.precondition;
    const queryResult = rule.context.applyQuery(node, prec.query);
    debugger_js_1$5.Debugger.getInstance().output(prec.query, queryResult ? queryResult.toString() : queryResult);
    prec.constraints.forEach(cstr => debugger_js_1$5.Debugger.getInstance().output(cstr, rule.context.applyConstraint(node, cstr)));
  }
  static debugNamedSpeechRule(name, node) {
    const rules = SpeechRuleEngine.getInstance().trie.collectRules();
    const allRules = rules.filter(rule => rule.name == name);
    for (let i = 0, rule; rule = allRules[i]; i++) {
      debugger_js_1$5.Debugger.getInstance().output('Rule', name, 'DynamicCstr:', rule.dynamicCstr.toString(), 'number', i);
      SpeechRuleEngine.debugSpeechRule(rule, node);
    }
  }
  evaluateNode(node) {
    (0, xpath_util_js_1.updateEvaluator)(node);
    const timeIn = new Date().getTime();
    let result = [];
    try {
      result = this.evaluateNode_(node);
    } catch (err) {
      console.log(err);
      console.error('Something went wrong computing speech.');
      debugger_js_1$5.Debugger.getInstance().output(err);
    }
    const timeOut = new Date().getTime();
    debugger_js_1$5.Debugger.getInstance().output('Time:', timeOut - timeIn);
    return result;
  }
  toString() {
    const allRules = this.trie.collectRules();
    return allRules.map(rule => rule.toString()).join('\n');
  }
  runInSetting(settings, callback) {
    const engine = engine_js_1$g.Engine.getInstance();
    const save = {};
    for (const [key, val] of Object.entries(settings)) {
      save[key] = engine[key];
      engine[key] = val;
    }
    engine.setDynamicCstr();
    const result = callback();
    for (const [key, val] of Object.entries(save)) {
      engine[key] = val;
    }
    engine.setDynamicCstr();
    return result;
  }
  static addStore(set) {
    const store = storeFactory(set);
    if (store.kind !== 'abstract') {
      store.getSpeechRules().forEach(x => SpeechRuleEngine.getInstance().trie.addRule(x));
    }
    SpeechRuleEngine.getInstance().addEvaluator(store);
  }
  processGrammar(context, node, grammar) {
    const assignment = {};
    for (const [key, val] of Object.entries(grammar)) {
      assignment[key] = typeof val === 'string' ? context.constructString(node, val) : val;
    }
    grammar_js_1$1.Grammar.getInstance().pushState(assignment);
  }
  addEvaluator(store) {
    const fun = store.evaluateDefault.bind(store);
    const loc = this.evaluators_[store.locale];
    if (loc) {
      loc[store.modality] = fun;
      return;
    }
    const mod = {};
    mod[store.modality] = fun;
    this.evaluators_[store.locale] = mod;
  }
  getEvaluator(locale, modality) {
    const loc = this.evaluators_[locale] || this.evaluators_[dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$2.Axis.LOCALE]];
    return loc[modality] || loc[dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$2.Axis.MODALITY]];
  }
  enumerate(opt_info) {
    return this.trie.enumerate(opt_info);
  }
  constructor() {
    this.trie = null;
    this.evaluators_ = {};
    this.trie = new trie_js_1.Trie();
  }
  evaluateNode_(node) {
    if (!node) {
      return [];
    }
    this.updateConstraint_();
    let result = this.evaluateTree_(node);
    result = processAnnotations(result);
    return result;
  }
  evaluateTree_(node) {
    const engine = engine_js_1$g.Engine.getInstance();
    let result;
    debugger_js_1$5.Debugger.getInstance().output(engine.mode !== EngineConst$c.Mode.HTTP ? node.toString() : node);
    grammar_js_1$1.Grammar.getInstance().setAttribute(node);
    const rule = this.lookupRule(node, engine.dynamicCstr);
    if (!rule) {
      if (engine.strict) {
        return [];
      }
      result = this.getEvaluator(engine.locale, engine.modality)(node);
      if (node.attributes) {
        this.addPersonality_(result, {}, false, node);
      }
      return result;
    }
    debugger_js_1$5.Debugger.getInstance().generateOutput(() => ['Apply Rule:', rule.name, rule.dynamicCstr.toString(), engine.mode === EngineConst$c.Mode.HTTP ? DomUtil$p.serializeXml(node) : node.toString()]);
    grammar_js_1$1.Grammar.getInstance().processSingles();
    const context = rule.context;
    const components = rule.action.components;
    result = [];
    for (let i = 0, component; component = components[i]; i++) {
      let descrs = [];
      const content = component.content || '';
      const attributes = component.attributes || ({});
      let multi = false;
      if (component.grammar) {
        this.processGrammar(context, node, component.grammar);
      }
      let saveEngine = null;
      if (attributes.engine) {
        saveEngine = engine_js_1$g.Engine.getInstance().dynamicCstr.getComponents();
        const features = Object.assign({}, saveEngine, grammar_js_1$1.Grammar.parseInput(attributes.engine));
        engine_js_1$g.Engine.getInstance().setDynamicCstr(features);
        this.updateConstraint_();
      }
      switch (component.type) {
        case speech_rule_js_1.ActionType.NODE:
          {
            const selected = context.applyQuery(node, content);
            if (selected) {
              descrs = this.evaluateTree_(selected);
            }
          }
          break;
        case speech_rule_js_1.ActionType.MULTI:
          {
            multi = true;
            const selects = context.applySelector(node, content);
            if (selects.length > 0) {
              descrs = this.evaluateNodeList_(context, selects, attributes['sepFunc'], context.constructString(node, attributes['separator']), attributes['ctxtFunc'], context.constructString(node, attributes['context']));
            }
          }
          break;
        case speech_rule_js_1.ActionType.TEXT:
          {
            const xpath = attributes['span'];
            let attrs = {};
            if (xpath) {
              const nodes = (0, xpath_util_js_1.evalXPath)(xpath, node);
              attrs = nodes.length ? span_js_1$2.Span.getAttributes(nodes[0]) : {
                kind: xpath
              };
            }
            const str = context.constructSpan(node, content, attrs);
            descrs = str.map(function (span) {
              return auditory_description_js_1$1.AuditoryDescription.create({
                text: span.speech,
                attributes: span.attributes
              }, {
                adjust: true
              });
            });
          }
          break;
        case speech_rule_js_1.ActionType.PERSONALITY:
        default:
          descrs = [auditory_description_js_1$1.AuditoryDescription.create({
            text: content
          })];
      }
      if (descrs[0] && !multi) {
        if (attributes['context']) {
          descrs[0]['context'] = context.constructString(node, attributes['context']) + (descrs[0]['context'] || '');
        }
        if (attributes['annotation']) {
          descrs[0]['annotation'] = attributes['annotation'];
        }
      }
      this.addLayout(descrs, attributes, multi);
      if (component.grammar) {
        grammar_js_1$1.Grammar.getInstance().popState();
      }
      result = result.concat(this.addPersonality_(descrs, attributes, multi, node));
      if (saveEngine) {
        engine_js_1$g.Engine.getInstance().setDynamicCstr(saveEngine);
        this.updateConstraint_();
      }
    }
    grammar_js_1$1.Grammar.getInstance().popState();
    return result;
  }
  evaluateNodeList_(context, nodes, sepFunc, sepStr, ctxtFunc, ctxtStr) {
    if (!nodes.length) {
      return [];
    }
    const sep = sepStr || '';
    const cont = ctxtStr || '';
    const cFunc = context.contextFunctions.lookup(ctxtFunc);
    const ctxtClosure = cFunc ? cFunc(nodes, cont) : function () {
      return cont;
    };
    const sFunc = context.contextFunctions.lookup(sepFunc);
    const sepClosure = sFunc ? sFunc(nodes, sep) : function () {
      return [auditory_description_js_1$1.AuditoryDescription.create({
        text: sep
      }, {
        translate: true
      })];
    };
    let result = [];
    for (let i = 0, node; node = nodes[i]; i++) {
      const descrs = this.evaluateTree_(node);
      if (descrs.length > 0) {
        descrs[0]['context'] = ctxtClosure() + (descrs[0]['context'] || '');
        result = result.concat(descrs);
        if (i < nodes.length - 1) {
          const text = sepClosure();
          result = result.concat(text);
        }
      }
    }
    return result;
  }
  addLayout(descrs, props, _multi) {
    const layout = props.layout;
    if (!layout) {
      return;
    }
    if (layout.match(/^begin/)) {
      descrs.unshift(new auditory_description_js_1$1.AuditoryDescription({
        text: '',
        layout: layout
      }));
      return;
    }
    if (layout.match(/^end/)) {
      descrs.push(new auditory_description_js_1$1.AuditoryDescription({
        text: '',
        layout: layout
      }));
      return;
    }
    descrs.unshift(new auditory_description_js_1$1.AuditoryDescription({
      text: '',
      layout: `begin${layout}`
    }));
    descrs.push(new auditory_description_js_1$1.AuditoryDescription({
      text: '',
      layout: `end${layout}`
    }));
  }
  addPersonality_(descrs, props, multi, node) {
    const personality = {};
    let pause = null;
    for (const key of EngineConst$c.personalityPropList) {
      const value = props[key];
      if (typeof value === 'undefined') {
        continue;
      }
      const numeral = parseFloat(value);
      const realValue = isNaN(numeral) ? value.charAt(0) === '"' ? value.slice(1, -1) : value : numeral;
      if (key === EngineConst$c.personalityProps.PAUSE) {
        pause = realValue;
      } else {
        personality[key] = realValue;
      }
    }
    for (let i = 0, descr; descr = descrs[i]; i++) {
      this.addRelativePersonality_(descr, personality);
      this.addExternalAttributes_(descr, node);
    }
    if (multi && descrs.length) {
      delete descrs[descrs.length - 1].personality[EngineConst$c.personalityProps.JOIN];
    }
    if (pause && descrs.length) {
      const last = descrs[descrs.length - 1];
      if (last.text || Object.keys(last.personality).length) {
        descrs.push(auditory_description_js_1$1.AuditoryDescription.create({
          text: '',
          personality: {
            pause: pause
          }
        }));
      } else {
        last.personality[EngineConst$c.personalityProps.PAUSE] = pause;
      }
    }
    return descrs;
  }
  addExternalAttributes_(descr, node) {
    if (descr.attributes['id'] === undefined) {
      descr.attributes['id'] = node.getAttribute('id');
    }
    if (node.hasAttributes()) {
      const attrs = node.attributes;
      for (let i = attrs.length - 1; i >= 0; i--) {
        const key = attrs[i].name;
        if (!descr.attributes[key] && key.match(/^ext/)) {
          descr.attributes[key] = attrs[i].value;
        }
      }
    }
  }
  addRelativePersonality_(descr, personality) {
    if (!descr['personality']) {
      descr['personality'] = personality;
      return descr;
    }
    const descrPersonality = descr['personality'];
    for (const [key, val] of Object.entries(personality)) {
      if (descrPersonality[key] && typeof descrPersonality[key] == 'number' && typeof val == 'number') {
        descrPersonality[key] = (descrPersonality[key] + val).toString();
      } else if (!descrPersonality[key]) {
        descrPersonality[key] = val;
      }
    }
    return descr;
  }
  updateConstraint_() {
    const dynamic = engine_js_1$g.Engine.getInstance().dynamicCstr;
    const strict = engine_js_1$g.Engine.getInstance().strict;
    const trie = this.trie;
    const props = {};
    let locale = dynamic.getValue(dynamic_cstr_js_1$2.Axis.LOCALE);
    let modality = dynamic.getValue(dynamic_cstr_js_1$2.Axis.MODALITY);
    let domain = dynamic.getValue(dynamic_cstr_js_1$2.Axis.DOMAIN);
    if (!trie.hasSubtrie([locale, modality, domain])) {
      domain = dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$2.Axis.DOMAIN];
      if (!trie.hasSubtrie([locale, modality, domain])) {
        modality = dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$2.Axis.MODALITY];
        if (!trie.hasSubtrie([locale, modality, domain])) {
          locale = dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$2.Axis.LOCALE];
        }
      }
    }
    props[dynamic_cstr_js_1$2.Axis.LOCALE] = [locale];
    props[dynamic_cstr_js_1$2.Axis.MODALITY] = [modality !== 'summary' ? modality : dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$2.Axis.MODALITY]];
    props[dynamic_cstr_js_1$2.Axis.DOMAIN] = [modality !== 'speech' ? dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_1$2.Axis.DOMAIN] : domain];
    const order = dynamic.getOrder();
    for (let i = 0, axis; axis = order[i]; i++) {
      if (!props[axis]) {
        const value = dynamic.getValue(axis);
        const valueSet = this.makeSet_(value, dynamic.preference);
        const def = dynamic_cstr_js_1$2.DynamicCstr.DEFAULT_VALUES[axis];
        if (!strict && value !== def) {
          valueSet.push(def);
        }
        props[axis] = valueSet;
      }
    }
    dynamic.updateProperties(props);
  }
  makeSet_(value, preferences) {
    if (!preferences || !Object.keys(preferences).length) {
      return [value];
    }
    return value.split(':');
  }
  lookupRule(node, dynamic) {
    if (!node || node.nodeType !== DomUtil$p.NodeType.ELEMENT_NODE && node.nodeType !== DomUtil$p.NodeType.TEXT_NODE) {
      return null;
    }
    const matchingRules = this.lookupRules(node, dynamic);
    return matchingRules.length > 0 ? this.pickMostConstraint_(dynamic, matchingRules) : null;
  }
  lookupRules(node, dynamic) {
    return this.trie.lookupRules(node, dynamic.allProperties());
  }
  pickMostConstraint_(_dynamic, rules) {
    const comparator = engine_js_1$g.Engine.getInstance().comparator;
    rules.sort(function (r1, r2) {
      return comparator.compare(r1.dynamicCstr, r2.dynamicCstr) || r2.precondition.priority - r1.precondition.priority || r2.precondition.constraints.length - r1.precondition.constraints.length || r2.precondition.rank - r1.precondition.rank;
    });
    debugger_js_1$5.Debugger.getInstance().generateOutput((() => {
      return rules.map(x => x.name + '(' + x.dynamicCstr.toString() + ')');
    }).bind(this));
    return rules[0];
  }
}
speech_rule_engine.SpeechRuleEngine = SpeechRuleEngine;
const stores = new Map();
function getStore(locale, modality) {
  if (modality === 'braille' && locale === 'euro') {
    return new braille_store_js_1.EuroStore();
  }
  if (modality === 'braille') {
    return new braille_store_js_1.BrailleStore();
  }
  return new math_store_js_1.MathStore();
}
function storeFactory(set) {
  const name = `${set.locale}.${set.modality}.${set.domain}`;
  if (set.kind === 'actions') {
    const store = stores.get(name);
    store.parse(set);
    return store;
  }
  SpeechRuleStores.init();
  if (set && !set.functions) {
    set.functions = SpeechRules.getStore(set.locale, set.modality, set.domain);
  }
  const store = getStore(set.locale, set.modality);
  stores.set(name, store);
  if (set.inherits) {
    store.inherits = stores.get(`${set.inherits}.${set.modality}.${set.domain}`);
  }
  store.parse(set);
  store.initialize();
  return store;
}
engine_js_1$g.Engine.nodeEvaluator = SpeechRuleEngine.getInstance().evaluateNode.bind(SpeechRuleEngine.getInstance());
const punctuationMarks = ['⠆', '⠒', '⠲', '⠦', '⠴', '⠄'];
function processAnnotations(descrs) {
  const alist = new auditory_description_js_1$1.AuditoryList(descrs);
  for (const item of alist.annotations) {
    const descr = item.data;
    if (descr.annotation === 'punctuation') {
      const prev = alist.prevText(item);
      if (!prev) continue;
      const last = prev.data;
      if (last.annotation !== 'punctuation' && last.text !== '⠀' && descr.text.length === 1 && punctuationMarks.indexOf(descr.text) !== -1) {
        descr.text = '⠸' + descr.text;
      }
    }
  }
  return alist.toList();
}

var alphabet_generator = {};

Object.defineProperty(alphabet_generator, "__esModule", {
  value: true
});
alphabet_generator.generateBase = generateBase;
alphabet_generator.generate = generate;
const Alphabet = alphabet;
const engine_js_1$f = engine;
const L10n$1 = l10n;
const locale_js_1$3 = locale$f;
const locale_util_js_1 = locale_util;
const MathCompoundStore$2 = math_compound_store;
const Domains = {
  small: ['default'],
  capital: ['default'],
  digit: ['default']
};
function makeDomains() {
  const alph = locale_js_1$3.LOCALE.ALPHABETS;
  const combineKeys = (obj1, obj2) => {
    const result = {};
    Object.keys(obj1).forEach(k => result[k] = true);
    Object.keys(obj2).forEach(k => result[k] = true);
    return Object.keys(result);
  };
  Domains.small = combineKeys(alph.smallPrefix, alph.letterTrans);
  Domains.capital = combineKeys(alph.capPrefix, alph.letterTrans);
  Domains.digit = combineKeys(alph.digitPrefix, alph.digitTrans);
}
function generateBase() {
  for (const int of Alphabet.INTERVALS.values()) {
    const letters = int.unicode;
    for (const letter of letters) {
      MathCompoundStore$2.baseStores.set(letter, {
        key: letter,
        category: int.category
      });
    }
  }
}
function generate(locale) {
  const oldLocale = engine_js_1$f.Engine.getInstance().locale;
  engine_js_1$f.Engine.getInstance().locale = locale;
  L10n$1.setLocale();
  MathCompoundStore$2.changeLocale({
    locale: locale
  });
  makeDomains();
  for (const int of Alphabet.INTERVALS.values()) {
    const letters = int.unicode;
    if (('offset' in int)) {
      numberRules(letters, int.font, int.offset || 0);
    } else {
      const alphabet = locale_js_1$3.LOCALE.ALPHABETS[int.base];
      alphabetRules(letters, alphabet, int.font, !!int.capital);
    }
  }
  engine_js_1$f.Engine.getInstance().locale = oldLocale;
  L10n$1.setLocale();
}
function getFont(font) {
  const realFont = font === 'normal' || font === 'fullwidth' ? '' : locale_js_1$3.LOCALE.MESSAGES.font[font] || locale_js_1$3.LOCALE.MESSAGES.embellish[font] || '';
  return (0, locale_util_js_1.localeFontCombiner)(realFont);
}
function alphabetRules(unicodes, letters, font, cap) {
  const realFont = getFont(font);
  for (let i = 0, unicode, letter; (unicode = unicodes[i], letter = letters[i]); i++) {
    const prefixes = cap ? locale_js_1$3.LOCALE.ALPHABETS.capPrefix : locale_js_1$3.LOCALE.ALPHABETS.smallPrefix;
    const domains = cap ? Domains.capital : Domains.small;
    makeLetter(realFont.combiner, unicode, letter, realFont.font, prefixes, locale_js_1$3.LOCALE.ALPHABETS.letterTrans, domains);
  }
}
function numberRules(unicodes, font, offset) {
  const realFont = getFont(font);
  for (let i = 0, unicode; unicode = unicodes[i]; i++) {
    const prefixes = locale_js_1$3.LOCALE.ALPHABETS.digitPrefix;
    const num = i + offset;
    makeLetter(realFont.combiner, unicode, num, realFont.font, prefixes, locale_js_1$3.LOCALE.ALPHABETS.digitTrans, Domains.digit);
  }
}
function makeLetter(combiner, unicode, letter, font, prefixes, transformers, domains) {
  for (let i = 0, domain; domain = domains[i]; i++) {
    const transformer = (domain in transformers) ? transformers[domain] : transformers['default'];
    const prefix = (domain in prefixes) ? prefixes[domain] : prefixes['default'];
    MathCompoundStore$2.defineRule(domain, 'default', unicode, combiner(transformer(letter), font, prefix));
  }
}

var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || (function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
});
Object.defineProperty(math_map, "__esModule", {
  value: true
});
math_map.loadLocale = loadLocale;
math_map.standardLoader = standardLoader;
const BrowserUtil$1 = browser_util;
const engine_js_1$e = engine;
const EngineConst$b = engine_const;
const FileUtil$1 = file_util;
const system_external_js_1$1 = system_external;
const dynamic_cstr_js_1$1 = dynamic_cstr;
const MathCompoundStore$1 = math_compound_store;
const speech_rule_engine_js_1$2 = speech_rule_engine;
const l10n_js_1 = l10n;
const AlphabetGenerator = alphabet_generator;
const addSymbols = {
  functions: MathCompoundStore$1.addFunctionRules,
  symbols: MathCompoundStore$1.addSymbolRules,
  units: MathCompoundStore$1.addUnitRules,
  si: x => x.forEach(MathCompoundStore$1.setSiPrefixes),
  messages: l10n_js_1.completeLocale,
  rules: speech_rule_engine_js_1$2.SpeechRuleEngine.addStore,
  characters: MathCompoundStore$1.addCharacterRules
};
let _init = false;
function loadLocale() {
  return __awaiter$1(this, arguments, void 0, function* (locale = engine_js_1$e.Engine.getInstance().locale) {
    if (!_init) {
      AlphabetGenerator.generateBase();
      _loadLocale(dynamic_cstr_js_1$1.DynamicCstr.BASE_LOCALE);
      _init = true;
    }
    return engine_js_1$e.EnginePromise.promises[dynamic_cstr_js_1$1.DynamicCstr.BASE_LOCALE].then(() => __awaiter$1(this, void 0, void 0, function* () {
      const defLoc = engine_js_1$e.Engine.getInstance().defaultLocale;
      if (defLoc) {
        _loadLocale(defLoc);
        return engine_js_1$e.EnginePromise.promises[defLoc].then(() => __awaiter$1(this, void 0, void 0, function* () {
          _loadLocale(locale);
          return engine_js_1$e.EnginePromise.promises[locale];
        }));
      }
      _loadLocale(locale);
      return engine_js_1$e.EnginePromise.promises[locale];
    }));
  });
}
function _loadLocale(locale = engine_js_1$e.Engine.getInstance().locale) {
  if (!engine_js_1$e.EnginePromise.loaded[locale]) {
    engine_js_1$e.EnginePromise.loaded[locale] = [false, false];
    MathCompoundStore$1.reset();
    retrieveMaps(locale);
  }
}
function loadMethod() {
  if (engine_js_1$e.Engine.getInstance().customLoader) {
    return engine_js_1$e.Engine.getInstance().customLoader;
  }
  return standardLoader();
}
function standardLoader() {
  switch (engine_js_1$e.Engine.getInstance().mode) {
    case EngineConst$b.Mode.ASYNC:
      return loadFile;
    case EngineConst$b.Mode.HTTP:
      return loadAjax;
    case EngineConst$b.Mode.SYNC:
    default:
      return loadFileSync;
  }
}
function retrieveFiles(locale) {
  const loader = loadMethod();
  const promise = new Promise(res => {
    const inner = loader(locale);
    inner.then(str => {
      parseMaps(str);
      engine_js_1$e.EnginePromise.loaded[locale] = [true, true];
      res(locale);
    }, _err => {
      engine_js_1$e.EnginePromise.loaded[locale] = [true, false];
      console.error(`Unable to load locale: ${locale}`);
      engine_js_1$e.Engine.getInstance().locale = engine_js_1$e.Engine.getInstance().defaultLocale;
      res(locale);
    });
  });
  engine_js_1$e.EnginePromise.promises[locale] = promise;
}
function parseMaps(json) {
  const js = typeof json === 'string' ? JSON.parse(json) : json;
  addMaps(js);
}
function addMaps(json, opt_locale) {
  let generate = true;
  for (let i = 0, key; key = Object.keys(json)[i]; i++) {
    const info = key.split('/');
    if (opt_locale && opt_locale !== info[0]) {
      continue;
    }
    if (generate && info[1] === 'symbols' && info[0] !== 'base') {
      AlphabetGenerator.generate(info[0]);
      generate = false;
    }
    addSymbols[info[1]](json[key]);
  }
}
function retrieveMaps(locale) {
  if (engine_js_1$e.Engine.getInstance().isIE && engine_js_1$e.Engine.getInstance().mode === EngineConst$b.Mode.HTTP) {
    getJsonIE_(locale);
    return;
  }
  retrieveFiles(locale);
}
function getJsonIE_(locale, opt_count) {
  let count = opt_count || 1;
  if (!BrowserUtil$1.mapsForIE) {
    if (count <= 5) {
      setTimeout((() => getJsonIE_(locale, count++)).bind(this), 300);
    }
    return;
  }
  addMaps(BrowserUtil$1.mapsForIE, locale);
}
function loadFile(locale) {
  const file = FileUtil$1.localePath(locale);
  return new Promise((res, rej) => {
    system_external_js_1$1.SystemExternal.fs.readFile(file, 'utf8', (err, json) => {
      if (err) {
        return rej(err);
      }
      res(json);
    });
  });
}
function loadFileSync(locale) {
  const file = FileUtil$1.localePath(locale);
  return new Promise((res, rej) => {
    let str = '{}';
    try {
      str = system_external_js_1$1.SystemExternal.fs.readFileSync(file, 'utf8');
    } catch (err) {
      return rej(err);
    }
    res(str);
  });
}
function loadAjax(locale) {
  const file = FileUtil$1.localePath(locale);
  const httpRequest = new XMLHttpRequest();
  return new Promise((res, rej) => {
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4) {
        const status = httpRequest.status;
        if (status === 0 || status >= 200 && status < 400) {
          res(httpRequest.responseText);
        } else {
          rej(status);
        }
      }
    };
    httpRequest.open('GET', file, true);
    httpRequest.send();
  });
}

var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || (function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
});
Object.defineProperty(engine_setup, "__esModule", {
  value: true
});
engine_setup.setup = setup$1;
const L10n = l10n;
const MathMap = math_map;
const BrowserUtil = browser_util;
const debugger_js_1$4 = _debugger;
const engine_js_1$d = engine;
const FileUtil = file_util;
const system_external_js_1 = system_external;
const MATHSPEAK_ONLY = ['ca', 'da', 'es'];
const EN_RULES = ['chromevox', 'clearspeak', 'mathspeak', 'emacspeak', 'html'];
function ensureDomain(feature) {
  if (feature.modality && feature.modality !== 'speech' || !feature.modality && engine_js_1$d.Engine.getInstance().modality !== 'speech') {
    return;
  }
  if (!feature.domain) {
    return;
  }
  if (feature.domain === 'default') {
    feature.domain = 'mathspeak';
    return;
  }
  const locale = feature.locale || engine_js_1$d.Engine.getInstance().locale;
  const domain = feature.domain;
  if (MATHSPEAK_ONLY.indexOf(locale) !== -1) {
    if (domain !== 'mathspeak') {
      feature.domain = 'mathspeak';
    }
    return;
  }
  if (locale === 'en') {
    if (EN_RULES.indexOf(domain) === -1) {
      feature.domain = 'mathspeak';
    }
    return;
  }
  if (domain !== 'mathspeak' && domain !== 'clearspeak') {
    feature.domain = 'mathspeak';
  }
}
function setup$1(feature) {
  return __awaiter(this, void 0, void 0, function* () {
    ensureDomain(feature);
    const engine = engine_js_1$d.Engine.getInstance();
    const setIf = feat => {
      if (typeof feature[feat] !== 'undefined') {
        engine[feat] = !!feature[feat];
      }
    };
    const setMulti = feat => {
      if (typeof feature[feat] !== 'undefined') {
        engine[feat] = feature[feat];
      }
    };
    setMulti('mode');
    engine.configurate(feature);
    engine_js_1$d.Engine.BINARY_FEATURES.forEach(setIf);
    engine_js_1$d.Engine.STRING_FEATURES.forEach(setMulti);
    if (feature.debug) {
      debugger_js_1$4.Debugger.getInstance().init();
    }
    if (feature.json) {
      system_external_js_1.SystemExternal.jsonPath = FileUtil.makePath(feature.json);
    }
    if (feature.xpath) {
      system_external_js_1.SystemExternal.WGXpath = feature.xpath;
    }
    engine.setCustomLoader(feature.custom);
    setupBrowsers(engine);
    L10n.setLocale();
    engine.setDynamicCstr();
    if (engine.init) {
      engine_js_1$d.EnginePromise.promises['init'] = new Promise((res, _rej) => {
        setTimeout(() => {
          res('init');
        }, 10);
      });
      engine.init = false;
      return engine_js_1$d.EnginePromise.get();
    }
    if (engine.delay) {
      engine.delay = false;
      return engine_js_1$d.EnginePromise.get();
    }
    return MathMap.loadLocale();
  });
}
function setupBrowsers(engine) {
  engine.isIE = BrowserUtil.detectIE();
  engine.isEdge = BrowserUtil.detectEdge();
}

var processor_factory = {};

var aural_rendering = {};

var acss_renderer = {};

var event_util = {};

Object.defineProperty(event_util, "__esModule", {
  value: true
});
event_util.Event = event_util.Move = event_util.KeyCode = void 0;
var KeyCode;
(function (KeyCode) {
  KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
  KeyCode[KeyCode["ESC"] = 27] = "ESC";
  KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
  KeyCode[KeyCode["PAGE_UP"] = 33] = "PAGE_UP";
  KeyCode[KeyCode["PAGE_DOWN"] = 34] = "PAGE_DOWN";
  KeyCode[KeyCode["END"] = 35] = "END";
  KeyCode[KeyCode["HOME"] = 36] = "HOME";
  KeyCode[KeyCode["LEFT"] = 37] = "LEFT";
  KeyCode[KeyCode["UP"] = 38] = "UP";
  KeyCode[KeyCode["RIGHT"] = 39] = "RIGHT";
  KeyCode[KeyCode["DOWN"] = 40] = "DOWN";
  KeyCode[KeyCode["TAB"] = 9] = "TAB";
  KeyCode[KeyCode["LESS"] = 188] = "LESS";
  KeyCode[KeyCode["GREATER"] = 190] = "GREATER";
  KeyCode[KeyCode["DASH"] = 189] = "DASH";
  KeyCode[KeyCode["ZERO"] = 48] = "ZERO";
  KeyCode[KeyCode["ONE"] = 49] = "ONE";
  KeyCode[KeyCode["TWO"] = 50] = "TWO";
  KeyCode[KeyCode["THREE"] = 51] = "THREE";
  KeyCode[KeyCode["FOUR"] = 52] = "FOUR";
  KeyCode[KeyCode["FIVE"] = 53] = "FIVE";
  KeyCode[KeyCode["SIX"] = 54] = "SIX";
  KeyCode[KeyCode["SEVEN"] = 55] = "SEVEN";
  KeyCode[KeyCode["EIGHT"] = 56] = "EIGHT";
  KeyCode[KeyCode["NINE"] = 57] = "NINE";
  KeyCode[KeyCode["A"] = 65] = "A";
  KeyCode[KeyCode["B"] = 66] = "B";
  KeyCode[KeyCode["C"] = 67] = "C";
  KeyCode[KeyCode["D"] = 68] = "D";
  KeyCode[KeyCode["E"] = 69] = "E";
  KeyCode[KeyCode["F"] = 70] = "F";
  KeyCode[KeyCode["G"] = 71] = "G";
  KeyCode[KeyCode["H"] = 72] = "H";
  KeyCode[KeyCode["I"] = 73] = "I";
  KeyCode[KeyCode["J"] = 74] = "J";
  KeyCode[KeyCode["K"] = 75] = "K";
  KeyCode[KeyCode["L"] = 76] = "L";
  KeyCode[KeyCode["M"] = 77] = "M";
  KeyCode[KeyCode["N"] = 78] = "N";
  KeyCode[KeyCode["O"] = 79] = "O";
  KeyCode[KeyCode["P"] = 80] = "P";
  KeyCode[KeyCode["Q"] = 81] = "Q";
  KeyCode[KeyCode["R"] = 82] = "R";
  KeyCode[KeyCode["S"] = 83] = "S";
  KeyCode[KeyCode["T"] = 84] = "T";
  KeyCode[KeyCode["U"] = 85] = "U";
  KeyCode[KeyCode["V"] = 86] = "V";
  KeyCode[KeyCode["W"] = 87] = "W";
  KeyCode[KeyCode["X"] = 88] = "X";
  KeyCode[KeyCode["Y"] = 89] = "Y";
  KeyCode[KeyCode["Z"] = 90] = "Z";
})(KeyCode || (event_util.KeyCode = KeyCode = {}));
event_util.Move = new Map([[13, 'ENTER'], [27, 'ESC'], [32, 'SPACE'], [33, 'PAGE_UP'], [34, 'PAGE_DOWN'], [35, 'END'], [36, 'HOME'], [37, 'LEFT'], [38, 'UP'], [39, 'RIGHT'], [40, 'DOWN'], [9, 'TAB'], [188, 'LESS'], [190, 'GREATER'], [189, 'DASH'], [48, 'ZERO'], [49, 'ONE'], [50, 'TWO'], [51, 'THREE'], [52, 'FOUR'], [53, 'FIVE'], [54, 'SIX'], [55, 'SEVEN'], [56, 'EIGHT'], [57, 'NINE'], [65, 'A'], [66, 'B'], [67, 'C'], [68, 'D'], [69, 'E'], [70, 'F'], [71, 'G'], [72, 'H'], [73, 'I'], [74, 'J'], [75, 'K'], [76, 'L'], [77, 'M'], [78, 'N'], [79, 'O'], [80, 'P'], [81, 'Q'], [82, 'R'], [83, 'S'], [84, 'T'], [85, 'U'], [86, 'V'], [87, 'W'], [88, 'X'], [89, 'Y'], [90, 'Z']]);
var EventType;
(function (EventType) {
  EventType["CLICK"] = "click";
  EventType["DBLCLICK"] = "dblclick";
  EventType["MOUSEDOWN"] = "mousedown";
  EventType["MOUSEUP"] = "mouseup";
  EventType["MOUSEOVER"] = "mouseover";
  EventType["MOUSEOUT"] = "mouseout";
  EventType["MOUSEMOVE"] = "mousemove";
  EventType["SELECTSTART"] = "selectstart";
  EventType["KEYPRESS"] = "keypress";
  EventType["KEYDOWN"] = "keydown";
  EventType["KEYUP"] = "keyup";
  EventType["TOUCHSTART"] = "touchstart";
  EventType["TOUCHMOVE"] = "touchmove";
  EventType["TOUCHEND"] = "touchend";
  EventType["TOUCHCANCEL"] = "touchcancel";
})(EventType || (EventType = {}));
class Event$1 {
  constructor(src, type, callback) {
    this.src = src;
    this.type = type;
    this.callback = callback;
  }
  add() {
    this.src.addEventListener(this.type, this.callback);
  }
  remove() {
    this.src.removeEventListener(this.type, this.callback);
  }
}
event_util.Event = Event$1;

var audio_util = {};

Object.defineProperty(audio_util, "__esModule", {
  value: true
});
audio_util.mergePause = mergePause;
audio_util.mergeMarkup = mergeMarkup;
audio_util.sortClose = sortClose;
audio_util.personalityMarkup = personalityMarkup;
audio_util.isMarkupElement = isMarkupElement;
audio_util.isPauseElement = isPauseElement;
const base_util_js_1$1 = base_util;
const EngineConst$a = engine_const;
const engine_js_1$c = engine;
const span_js_1$1 = span;
function mergePause(oldPause, newPause, opt_merge) {
  if (!oldPause) {
    return newPause;
  }
  return {
    pause: mergePause_(oldPause.pause, newPause.pause, opt_merge)
  };
}
function mergePause_(oldPause, newPause, opt_merge) {
  const merge = opt_merge || (function (x, y) {
    if (typeof x === 'number' && typeof y === 'number') {
      return x + y;
    }
    if (typeof x === 'number') {
      return y;
    }
    if (typeof y === 'number') {
      return x;
    }
    return [oldPause, newPause].sort()[0];
  });
  return merge.call(null, oldPause, newPause);
}
function mergeMarkup(oldPers, newPers) {
  delete oldPers.open;
  newPers.close.forEach(x => delete oldPers[x]);
  newPers.open.forEach(x => oldPers[x] = newPers[x]);
  const keys = Object.keys(oldPers);
  oldPers.open = keys;
}
function sortClose(open, descrs) {
  if (open.length <= 1) {
    return open;
  }
  const result = [];
  for (let i = 0, descr; (descr = descrs[i], open.length); i++) {
    if (!descr.close || !descr.close.length) {
      continue;
    }
    descr.close.forEach(function (x) {
      const index = open.indexOf(x);
      if (index !== -1) {
        result.unshift(x);
        open.splice(index, 1);
      }
    });
  }
  return result;
}
let PersonalityRanges_ = {};
let LastOpen_ = [];
function personalityMarkup(descrs) {
  PersonalityRanges_ = {};
  LastOpen_ = [];
  let result = [];
  const currentPers = {};
  for (let i = 0, descr; descr = descrs[i]; i++) {
    let pause = null;
    const span = descr.descriptionSpan();
    const pers = descr.personality;
    const join = pers[EngineConst$a.personalityProps.JOIN];
    delete pers[EngineConst$a.personalityProps.JOIN];
    if (typeof pers[EngineConst$a.personalityProps.PAUSE] !== 'undefined') {
      pause = {
        [EngineConst$a.personalityProps.PAUSE]: pers[EngineConst$a.personalityProps.PAUSE]
      };
      delete pers[EngineConst$a.personalityProps.PAUSE];
    }
    const diff = personalityDiff_(pers, currentPers);
    appendMarkup_(result, span, diff, join, pause, true);
  }
  result = result.concat(finaliseMarkup_());
  result = simplifyMarkup_(result);
  result = engine_js_1$c.Engine.getInstance().cleanpause ? cleanPause(result) : result;
  return result;
}
function cleanPause(markup) {
  while (isPauseElement(markup[0])) {
    markup.shift();
  }
  while (isPauseElement(markup[markup.length - 1])) {
    markup.pop();
  }
  return markup;
}
function appendElement_(markup, element) {
  const last = markup[markup.length - 1];
  if (!last) {
    markup.push(element);
    return;
  }
  if (isSpanElement(element) && isSpanElement(last)) {
    if (typeof last.join === 'undefined') {
      last.span = last.span.concat(element.span);
      return;
    }
    const lstr = last['span'].pop();
    const fstr = element['span'].shift();
    last['span'].push(lstr + last.join + fstr);
    last['span'] = last['span'].concat(element.span);
    last.join = element.join;
    return;
  }
  if (isPauseElement(element) && isPauseElement(last)) {
    last.pause = mergePause_(last.pause, element.pause);
    return;
  }
  markup.push(element);
}
function simplifyMarkup_(markup) {
  const lastPers = {};
  const result = [];
  for (let i = 0, element; element = markup[i]; i++) {
    if (!isMarkupElement(element)) {
      appendElement_(result, element);
      continue;
    }
    if (!element.close || element.close.length !== 1 || element.open.length) {
      copyValues_(element, lastPers);
      result.push(element);
      continue;
    }
    let nextElement = markup[i + 1];
    if (!nextElement || isSpanElement(nextElement)) {
      copyValues_(element, lastPers);
      result.push(element);
      continue;
    }
    const pauseElement = isPauseElement(nextElement) ? nextElement : null;
    if (pauseElement) {
      nextElement = markup[i + 2];
    }
    if (nextElement && isMarkupElement(nextElement) && nextElement.open[0] === element.close[0] && !nextElement.close.length && nextElement[nextElement.open[0]] === lastPers[nextElement.open[0]]) {
      if (pauseElement) {
        appendElement_(result, pauseElement);
        i = i + 2;
      } else {
        i = i + 1;
      }
    } else {
      copyValues_(element, lastPers);
      result.push(element);
    }
  }
  return result;
}
function copyValues_(from, to) {
  if (from['rate']) {
    to['rate'] = from['rate'];
  }
  if (from['pitch']) {
    to['pitch'] = from['pitch'];
  }
  if (from['volume']) {
    to['volume'] = from['volume'];
  }
}
function finaliseMarkup_() {
  const final = [];
  for (let i = LastOpen_.length - 1; i >= 0; i--) {
    const pers = LastOpen_[i];
    if (pers.length) {
      const markup = {
        open: [],
        close: []
      };
      for (let j = 0; j < pers.length; j++) {
        const per = pers[j];
        markup.close.push(per);
        markup[per] = 0;
      }
      final.push(markup);
    }
  }
  return final;
}
function isMarkupElement(element) {
  return typeof element === 'object' && element.open;
}
function isPauseElement(element) {
  return typeof element === 'object' && Object.keys(element).length === 1 && Object.keys(element)[0] === EngineConst$a.personalityProps.PAUSE;
}
function isSpanElement(element) {
  const keys = Object.keys(element);
  return typeof element === 'object' && (keys.length === 1 && keys[0] === 'span' || keys.length === 2 && (keys[0] === 'span' && keys[1] === 'join' || keys[1] === 'span' && keys[0] === 'join'));
}
function appendMarkup_(markup, span, pers, join, pause, merge = false) {
  if (merge) {
    const last = markup[markup.length - 1];
    let oldJoin;
    if (last) {
      oldJoin = last[EngineConst$a.personalityProps.JOIN];
    }
    if (last && !span.speech && pause && isPauseElement(last)) {
      const pauseProp = EngineConst$a.personalityProps.PAUSE;
      last[pauseProp] = mergePause_(last[pauseProp], pause[pauseProp]);
      pause = null;
    }
    if (last && span.speech && Object.keys(pers).length === 0 && isSpanElement(last)) {
      if (typeof oldJoin !== 'undefined') {
        const lastSpan = last['span'].pop();
        span = span_js_1$1.Span.stringAttr(lastSpan.speech + oldJoin + span.speech, lastSpan.attributes);
      }
      last['span'].push(span);
      span = span_js_1$1.Span.empty();
      last[EngineConst$a.personalityProps.JOIN] = join;
    }
  }
  if (Object.keys(pers).length !== 0) {
    markup.push(pers);
  }
  if (span.speech) {
    markup.push({
      span: [span],
      join: join
    });
  }
  if (pause) {
    markup.push(pause);
  }
}
function personalityDiff_(current, old) {
  if (!old) {
    return current;
  }
  const result = {};
  for (const prop of EngineConst$a.personalityPropList) {
    const currentValue = current[prop];
    const oldValue = old[prop];
    if (!currentValue && !oldValue || currentValue && oldValue && currentValue === oldValue) {
      continue;
    }
    const value = currentValue || 0;
    if (!isMarkupElement(result)) {
      result.open = [];
      result.close = [];
    }
    if (!currentValue) {
      result.close.push(prop);
    }
    if (!oldValue) {
      result.open.push(prop);
    }
    if (oldValue && currentValue) {
      result.close.push(prop);
      result.open.push(prop);
    }
    old[prop] = value;
    result[prop] = value;
    PersonalityRanges_[prop] ? PersonalityRanges_[prop].push(value) : PersonalityRanges_[prop] = [value];
  }
  if (isMarkupElement(result)) {
    let c = result.close.slice();
    while (c.length > 0) {
      let lo = LastOpen_.pop();
      const loNew = (0, base_util_js_1$1.setdifference)(lo, c);
      c = (0, base_util_js_1$1.setdifference)(c, lo);
      lo = loNew;
      if (c.length === 0) {
        if (lo.length !== 0) {
          LastOpen_.push(lo);
        }
        continue;
      }
      if (lo.length === 0) {
        continue;
      }
      result.close = result.close.concat(lo);
      result.open = result.open.concat(lo);
      for (let i = 0, open; open = lo[i]; i++) {
        result[open] = old[open];
      }
    }
    LastOpen_.push(result.open);
  }
  return result;
}

var markup_renderer = {};

var abstract_audio_renderer = {};

Object.defineProperty(abstract_audio_renderer, "__esModule", {
  value: true
});
abstract_audio_renderer.AbstractAudioRenderer = void 0;
const engine_js_1$b = engine;
class AbstractAudioRenderer {
  constructor() {
    this.separator_ = ' ';
  }
  set separator(sep) {
    this.separator_ = sep;
  }
  get separator() {
    return engine_js_1$b.Engine.getInstance().modality === 'braille' ? '' : this.separator_;
  }
  error(_key) {
    return null;
  }
  merge(spans) {
    let str = '';
    const len = spans.length - 1;
    for (let i = 0, span; span = spans[i]; i++) {
      str += span.speech;
      if (i < len) {
        const sep = span.attributes['separator'];
        str += sep !== undefined ? sep : this.separator;
      }
    }
    return str;
  }
  finalize(str) {
    return str;
  }
  pauseValue(value) {
    let numeric;
    switch (value) {
      case 'long':
        numeric = 750;
        break;
      case 'medium':
        numeric = 500;
        break;
      case 'short':
        numeric = 250;
        break;
      default:
        numeric = parseInt(value, 10);
    }
    return Math.floor(numeric * engine_js_1$b.Engine.getInstance().getRate() / 100);
  }
}
abstract_audio_renderer.AbstractAudioRenderer = AbstractAudioRenderer;

Object.defineProperty(markup_renderer, "__esModule", {
  value: true
});
markup_renderer.MarkupRenderer = void 0;
const EngineConst$9 = engine_const;
const abstract_audio_renderer_js_1$2 = abstract_audio_renderer;
class MarkupRenderer extends abstract_audio_renderer_js_1$2.AbstractAudioRenderer {
  constructor() {
    super(...arguments);
    this.ignoreElements = [EngineConst$9.personalityProps.LAYOUT];
    this.scaleFunction = null;
  }
  setScaleFunction(a, b, c, d, decimals = 0) {
    this.scaleFunction = x => {
      const delta = (x - a) / (b - a);
      const num = c * (1 - delta) + d * delta;
      return +(Math.round(num + 'e+' + decimals) + 'e-' + decimals);
    };
  }
  applyScaleFunction(value) {
    return this.scaleFunction ? this.scaleFunction(value) : value;
  }
  ignoreElement(key) {
    return this.ignoreElements.indexOf(key) !== -1;
  }
}
markup_renderer.MarkupRenderer = MarkupRenderer;

Object.defineProperty(acss_renderer, "__esModule", {
  value: true
});
acss_renderer.AcssRenderer = void 0;
const EngineConst$8 = engine_const;
const EventUtil = event_util;
const AudioUtil$3 = audio_util;
const markup_renderer_js_1$1 = markup_renderer;
class AcssRenderer extends markup_renderer_js_1$1.MarkupRenderer {
  markup(descrs) {
    this.setScaleFunction(-2, 2, 0, 10, 0);
    const markup = AudioUtil$3.personalityMarkup(descrs);
    const result = [];
    const currentPers = {
      open: []
    };
    let pause = null;
    let isString = false;
    for (let i = 0, descr; descr = markup[i]; i++) {
      if (AudioUtil$3.isMarkupElement(descr)) {
        AudioUtil$3.mergeMarkup(currentPers, descr);
        continue;
      }
      if (AudioUtil$3.isPauseElement(descr)) {
        if (isString) {
          pause = AudioUtil$3.mergePause(pause, descr, Math.max);
        }
        continue;
      }
      const str = '"' + this.merge(descr.span) + '"';
      isString = true;
      if (pause) {
        result.push(this.pause(pause));
        pause = null;
      }
      const prosody = this.prosody_(currentPers);
      result.push(prosody ? '(text (' + prosody + ') ' + str + ')' : str);
    }
    return '(exp ' + result.join(' ') + ')';
  }
  error(key) {
    return '(error "' + EventUtil.Move.get(key) + '")';
  }
  prosodyElement(key, value) {
    value = this.applyScaleFunction(value);
    switch (key) {
      case EngineConst$8.personalityProps.RATE:
        return '(richness . ' + value + ')';
      case EngineConst$8.personalityProps.PITCH:
        return '(average-pitch . ' + value + ')';
      case EngineConst$8.personalityProps.VOLUME:
        return '(stress . ' + value + ')';
    }
    return '(value . ' + value + ')';
  }
  pause(pause) {
    return '(pause . ' + this.pauseValue(pause[EngineConst$8.personalityProps.PAUSE]) + ')';
  }
  prosody_(pros) {
    const keys = pros.open;
    const result = [];
    for (let i = 0, key; key = keys[i]; i++) {
      result.push(this.prosodyElement(key, pros[key]));
    }
    return result.join(' ');
  }
}
acss_renderer.AcssRenderer = AcssRenderer;

var layout_renderer = {};

var xml_renderer = {};

Object.defineProperty(xml_renderer, "__esModule", {
  value: true
});
xml_renderer.XmlRenderer = void 0;
const engine_js_1$a = engine;
const AudioUtil$2 = audio_util;
const markup_renderer_js_1 = markup_renderer;
class XmlRenderer extends markup_renderer_js_1.MarkupRenderer {
  markup(descrs) {
    this.setScaleFunction(-2, 2, -100, 100, 2);
    const markup = AudioUtil$2.personalityMarkup(descrs);
    const result = [];
    const currentOpen = [];
    for (let i = 0, descr; descr = markup[i]; i++) {
      if (descr.span) {
        result.push(this.merge(descr.span));
        continue;
      }
      if (AudioUtil$2.isPauseElement(descr)) {
        result.push(this.pause(descr));
        continue;
      }
      if (descr.close.length) {
        for (let j = 0; j < descr.close.length; j++) {
          const last = currentOpen.pop();
          if (descr.close.indexOf(last) === -1) {
            throw new engine_js_1$a.SREError('Unknown closing markup element: ' + last);
          }
          result.push(this.closeTag(last));
        }
      }
      if (descr.open.length) {
        const open = AudioUtil$2.sortClose(descr.open.slice(), markup.slice(i + 1));
        open.forEach(o => {
          result.push(this.prosodyElement(o, descr[o]));
          currentOpen.push(o);
        });
      }
    }
    return result.join(' ');
  }
}
xml_renderer.XmlRenderer = XmlRenderer;

Object.defineProperty(layout_renderer, "__esModule", {
  value: true
});
layout_renderer.LayoutRenderer = void 0;
const debugger_js_1$3 = _debugger;
const DomUtil$o = dom_util;
const EngineConst$7 = engine_const;
const engine_js_1$9 = engine;
const AudioUtil$1 = audio_util;
const xml_renderer_js_1$3 = xml_renderer;
class LayoutRenderer extends xml_renderer_js_1$3.XmlRenderer {
  constructor() {
    super(...arguments);
    this.values = new Map();
  }
  finalize(str) {
    setRelValues(this.values.get('rel'));
    return setTwoDim(str);
  }
  pause(_pause) {
    return '';
  }
  prosodyElement(attr, value) {
    return attr === EngineConst$7.personalityProps.LAYOUT ? `<${value}>` : '';
  }
  closeTag(tag) {
    return `</${tag}>`;
  }
  markup(descrs) {
    this.values.clear();
    const result = [];
    let content = [];
    for (const descr of descrs) {
      if (!descr.layout) {
        content.push(descr);
        continue;
      }
      result.push(this.processContent(content));
      content = [];
      const [pref, layout, value] = this.layoutValue(descr.layout);
      if (pref === 'begin') {
        result.push('<' + layout + (value ? ` value="${value}"` : '') + '>');
        continue;
      }
      if (pref === 'end') {
        result.push('</' + layout + '>');
        continue;
      }
      console.warn('Something went wrong with layout markup: ' + layout);
    }
    result.push(this.processContent(content));
    return result.join('');
  }
  processContent(content) {
    const result = [];
    const markup = AudioUtil$1.personalityMarkup(content);
    for (let i = 0, descr; descr = markup[i]; i++) {
      if (descr.span) {
        result.push(this.merge(descr.span));
        continue;
      }
      if (AudioUtil$1.isPauseElement(descr)) {
        continue;
      }
    }
    return result.join('');
  }
  layoutValue(layout) {
    const match = layout.match(/^(begin|end|)(.*\D)(\d*)$/);
    const value = match[3];
    if (!value) {
      return [match[1], match[2], ''];
    }
    layout = match[2];
    if (!this.values.has(layout)) {
      this.values.set(layout, {});
    }
    this.values.get(layout)[value] = true;
    return [match[1], layout, value];
  }
}
layout_renderer.LayoutRenderer = LayoutRenderer;
LayoutRenderer.options = {
  cayleyshort: engine_js_1$9.Engine.getInstance().cayleyshort,
  linebreaks: engine_js_1$9.Engine.getInstance().linebreaks
};
let twodExpr = '';
const handlers = {
  TABLE: handleTable,
  CASES: handleCases,
  CAYLEY: handleCayley,
  MATRIX: handleMatrix,
  CELL: recurseTree,
  FENCE: recurseTree,
  ROW: recurseTree,
  FRACTION: handleFraction,
  NUMERATOR: handleFractionPart,
  DENOMINATOR: handleFractionPart,
  REL: handleRelation,
  OP: handleRelation
};
function applyHandler(element) {
  const tag = DomUtil$o.tagName(element);
  const handler = handlers[tag];
  return handler ? handler(element) : element.textContent;
}
const relValues = new Map();
function setRelValues(values) {
  relValues.clear();
  if (!values) return;
  const keys = Object.keys(values).map(x => parseInt(x)).sort();
  for (let i = 0, key; key = keys[i]; i++) {
    relValues.set(key, i + 1);
  }
}
function setTwoDim(str) {
  twodExpr = '';
  const dom = DomUtil$o.parseInput(`<all>${str}</all>`);
  debugger_js_1$3.Debugger.getInstance().output(DomUtil$o.formatXml(dom.toString()));
  twodExpr = recurseTree(dom);
  return twodExpr;
}
function combineContent(str1, str2) {
  if (!str1 || !str2) {
    return str1 + str2;
  }
  const height1 = strHeight(str1);
  const height2 = strHeight(str2);
  const diff = height1 - height2;
  str1 = diff < 0 ? padCell(str1, height2, strWidth(str1)) : str1;
  str2 = diff > 0 ? padCell(str2, height1, strWidth(str2)) : str2;
  const lines1 = str1.split(/\r\n|\r|\n/);
  const lines2 = str2.split(/\r\n|\r|\n/);
  const result = [];
  for (let i = 0; i < lines1.length; i++) {
    result.push(lines1[i] + lines2[i]);
  }
  return result.join('\n');
}
function recurseTree(dom) {
  let result = '';
  for (const child of Array.from(dom.childNodes)) {
    if (child.nodeType === DomUtil$o.NodeType.TEXT_NODE) {
      result = combineContent(result, child.textContent);
      continue;
    }
    result = combineContent(result, applyHandler(child));
  }
  return result;
}
function strHeight(str) {
  return str.split(/\r\n|\r|\n/).length;
}
function strWidth(str) {
  return str.split(/\r\n|\r|\n/).reduce((max, x) => Math.max(x.length, max), 0);
}
function padHeight(str, height) {
  const padding = height - strHeight(str);
  return str + (padding > 0 ? new Array(padding + 1).join('\n') : '');
}
function padWidth(str, width) {
  const lines = str.split(/\r\n|\r|\n/);
  const result = [];
  for (const line of lines) {
    const padding = width - line.length;
    result.push(line + (padding > 0 ? new Array(padding + 1).join('⠀') : ''));
  }
  return result.join('\n');
}
function padCell(str, height, width) {
  str = padHeight(str, height);
  return padWidth(str, width);
}
function assembleRows(matrix) {
  const children = Array.from(matrix.childNodes);
  const mat = [];
  for (const row of children) {
    if (row.nodeType !== DomUtil$o.NodeType.ELEMENT_NODE) {
      continue;
    }
    mat.push(handleRow(row));
  }
  return mat;
}
function getMaxParameters(mat) {
  const maxHeight = mat.reduce((max, x) => Math.max(x.height, max), 0);
  const maxWidth = [];
  for (let i = 0; i < mat[0].width.length; i++) {
    maxWidth.push(mat.map(x => x.width[i]).reduce((max, x) => Math.max(max, x), 0));
  }
  return [maxHeight, maxWidth];
}
function combineCells(mat, maxWidth) {
  const newMat = [];
  for (const row of mat) {
    if (row.height === 0) {
      continue;
    }
    const newCells = [];
    for (let i = 0; i < row.cells.length; i++) {
      newCells.push(padCell(row.cells[i], row.height, maxWidth[i]));
    }
    row.cells = newCells;
    newMat.push(row);
  }
  return newMat;
}
function combineRows(mat, maxHeight) {
  if (maxHeight === 1) {
    return mat.map(row => row.lfence + row.cells.join(row.sep) + row.rfence).join('\n');
  }
  const result = [];
  for (const row of mat) {
    const sep = verticalArrange(row.sep, row.height);
    let str = row.cells.shift();
    while (row.cells.length) {
      str = combineContent(str, sep);
      str = combineContent(str, row.cells.shift());
    }
    str = combineContent(verticalArrange(row.lfence, row.height), str);
    str = combineContent(str, verticalArrange(row.rfence, row.height));
    result.push(str);
    result.push(row.lfence + new Array(strWidth(str) - 3).join(row.sep) + row.rfence);
  }
  return result.slice(0, -1).join('\n');
}
function verticalArrange(char, height) {
  let str = '';
  while (height) {
    str += char + '\n';
    height--;
  }
  return str.slice(0, -1);
}
function getFence(node) {
  if (node.nodeType === DomUtil$o.NodeType.ELEMENT_NODE && DomUtil$o.tagName(node) === 'FENCE') {
    return applyHandler(node);
  }
  return '';
}
function handleMatrix(matrix) {
  let mat = assembleRows(matrix);
  const [maxHeight, maxWidth] = getMaxParameters(mat);
  mat = combineCells(mat, maxWidth);
  return combineRows(mat, maxHeight);
}
function handleTable(table) {
  let mat = assembleRows(table);
  mat.forEach(row => {
    row.cells = row.cells.slice(1).slice(0, -1);
    row.width = row.width.slice(1).slice(0, -1);
  });
  const [maxHeight, maxWidth] = getMaxParameters(mat);
  mat = combineCells(mat, maxWidth);
  return combineRows(mat, maxHeight);
}
function handleCases(cases) {
  let mat = assembleRows(cases);
  mat.forEach(row => {
    row.cells = row.cells.slice(0, -1);
    row.width = row.width.slice(0, -1);
  });
  const [maxHeight, maxWidth] = getMaxParameters(mat);
  mat = combineCells(mat, maxWidth);
  return combineRows(mat, maxHeight);
}
function handleCayley(cayley) {
  let mat = assembleRows(cayley);
  mat.forEach(row => {
    row.cells = row.cells.slice(1).slice(0, -1);
    row.width = row.width.slice(1).slice(0, -1);
    row.sep = row.sep + row.sep;
  });
  const [maxHeight, maxWidth] = getMaxParameters(mat);
  const bar = {
    lfence: '',
    rfence: '',
    cells: maxWidth.map(x => '⠐' + new Array(x).join('⠒')),
    width: maxWidth,
    height: 1,
    sep: mat[0].sep
  };
  if (engine_js_1$9.Engine.getInstance().cayleyshort && mat[0].cells[0] === '⠀') {
    bar.cells[0] = '⠀';
  }
  mat.splice(1, 0, bar);
  mat = combineCells(mat, maxWidth);
  return combineRows(mat, maxHeight);
}
function handleRow(row) {
  const children = Array.from(row.childNodes);
  const lfence = getFence(children[0]);
  const rfence = getFence(children[children.length - 1]);
  if (lfence) {
    children.shift();
  }
  if (rfence) {
    children.pop();
  }
  let sep = '';
  const cells = [];
  for (const child of children) {
    if (child.nodeType === DomUtil$o.NodeType.TEXT_NODE) {
      sep = child.textContent;
      continue;
    }
    const result = applyHandler(child);
    cells.push(result);
  }
  return {
    lfence: lfence,
    rfence: rfence,
    sep: sep,
    cells: cells,
    height: cells.reduce((max, x) => Math.max(strHeight(x), max), 0),
    width: cells.map(strWidth)
  };
}
function centerCell(cell, width) {
  const cw = strWidth(cell);
  const center = (width - cw) / 2;
  const [lpad, rpad] = Math.floor(center) === center ? [center, center] : [Math.floor(center), Math.ceil(center)];
  const lines = cell.split(/\r\n|\r|\n/);
  const result = [];
  const [lstr, rstr] = [new Array(lpad + 1).join('⠀'), new Array(rpad + 1).join('⠀')];
  for (const line of lines) {
    result.push(lstr + line + rstr);
  }
  return result.join('\n');
}
function handleFraction(frac) {
  const [open, num, , den, close] = Array.from(frac.childNodes);
  const numerator = applyHandler(num);
  const denominator = applyHandler(den);
  const nwidth = strWidth(numerator);
  const dwidth = strWidth(denominator);
  let maxWidth = Math.max(nwidth, dwidth);
  const bar = open + new Array(maxWidth + 1).join('⠒') + close;
  maxWidth = bar.length;
  return `${centerCell(numerator, maxWidth)}\n${bar}\n` + `${centerCell(denominator, maxWidth)}`;
}
function handleFractionPart(prt) {
  const fchild = prt.firstChild;
  const content = recurseTree(prt);
  if (fchild && fchild.nodeType === DomUtil$o.NodeType.ELEMENT_NODE) {
    if (DomUtil$o.tagName(fchild) === 'ENGLISH') {
      return '⠰' + content;
    }
    if (DomUtil$o.tagName(fchild) === 'NUMBER') {
      return '⠼' + content;
    }
  }
  return content;
}
function handleRelation(rel) {
  if (!engine_js_1$9.Engine.getInstance().linebreaks) {
    return recurseTree(rel);
  }
  const value = relValues.get(parseInt(rel.getAttribute('value')));
  return (value ? `<br value="${value}"/>` : '') + recurseTree(rel);
}

var punctuation_renderer = {};

Object.defineProperty(punctuation_renderer, "__esModule", {
  value: true
});
punctuation_renderer.PunctuationRenderer = void 0;
const EngineConst$6 = engine_const;
const abstract_audio_renderer_js_1$1 = abstract_audio_renderer;
const AudioUtil = audio_util;
class PunctuationRenderer extends abstract_audio_renderer_js_1$1.AbstractAudioRenderer {
  markup(descrs) {
    const markup = AudioUtil.personalityMarkup(descrs);
    let str = '';
    let pause = null;
    let span = false;
    for (let i = 0, descr; descr = markup[i]; i++) {
      if (AudioUtil.isMarkupElement(descr)) {
        continue;
      }
      if (AudioUtil.isPauseElement(descr)) {
        pause = descr;
        continue;
      }
      if (pause) {
        str += this.pause(pause[EngineConst$6.personalityProps.PAUSE]);
        pause = null;
      }
      str += (span ? this.separator : '') + this.merge(descr.span);
      span = true;
    }
    return str;
  }
  pause(pause) {
    let newPause;
    if (typeof pause === 'number') {
      if (pause <= 250) {
        newPause = 'short';
      } else if (pause <= 500) {
        newPause = 'medium';
      } else {
        newPause = 'long';
      }
    } else {
      newPause = pause;
    }
    return PunctuationRenderer.PAUSE_PUNCTUATION.get(newPause) || '';
  }
}
punctuation_renderer.PunctuationRenderer = PunctuationRenderer;
PunctuationRenderer.PAUSE_PUNCTUATION = new Map([['short', ','], ['medium', ';'], ['long', '.']]);

var sable_renderer = {};

Object.defineProperty(sable_renderer, "__esModule", {
  value: true
});
sable_renderer.SableRenderer = void 0;
const EngineConst$5 = engine_const;
const xml_renderer_js_1$2 = xml_renderer;
class SableRenderer extends xml_renderer_js_1$2.XmlRenderer {
  finalize(str) {
    return '<?xml version="1.0"?>' + '<!DOCTYPE SABLE PUBLIC "-//SABLE//DTD SABLE speech mark up//EN"' + ' "Sable.v0_2.dtd" []><SABLE>' + this.separator + str + this.separator + '</SABLE>';
  }
  pause(pause) {
    return '<BREAK ' + 'MSEC="' + this.pauseValue(pause[EngineConst$5.personalityProps.PAUSE]) + '"/>';
  }
  prosodyElement(tag, value) {
    value = this.applyScaleFunction(value);
    switch (tag) {
      case EngineConst$5.personalityProps.PITCH:
        return '<PITCH RANGE="' + value + '%">';
      case EngineConst$5.personalityProps.RATE:
        return '<RATE SPEED="' + value + '%">';
      case EngineConst$5.personalityProps.VOLUME:
        return '<VOLUME LEVEL="' + value + '%">';
      default:
        return '<' + tag.toUpperCase() + ' VALUE="' + value + '">';
    }
  }
  closeTag(tag) {
    return '</' + tag.toUpperCase() + '>';
  }
}
sable_renderer.SableRenderer = SableRenderer;

var ssml_renderer = {};

Object.defineProperty(ssml_renderer, "__esModule", {
  value: true
});
ssml_renderer.SsmlRenderer = void 0;
const engine_js_1$8 = engine;
const EngineConst$4 = engine_const;
const xml_renderer_js_1$1 = xml_renderer;
class SsmlRenderer extends xml_renderer_js_1$1.XmlRenderer {
  finalize(str) {
    return '<?xml version="1.0"?><speak version="1.1"' + ' xmlns="http://www.w3.org/2001/10/synthesis"' + ` xml:lang="${engine_js_1$8.Engine.getInstance().locale}">` + '<prosody rate="' + engine_js_1$8.Engine.getInstance().getRate() + '%">' + this.separator + str + this.separator + '</prosody></speak>';
  }
  pause(pause) {
    return '<break ' + 'time="' + this.pauseValue(pause[EngineConst$4.personalityProps.PAUSE]) + 'ms"/>';
  }
  prosodyElement(attr, value) {
    value = Math.floor(this.applyScaleFunction(value));
    const valueStr = value < 0 ? value.toString() : '+' + value.toString();
    return '<prosody ' + attr.toLowerCase() + '="' + valueStr + (attr === EngineConst$4.personalityProps.VOLUME ? '>' : '%">');
  }
  closeTag(_tag) {
    return '</prosody>';
  }
  markup(descrs) {
    SsmlRenderer.MARKS = {};
    return super.markup(descrs);
  }
  merge(spans) {
    const result = [];
    let lastMark = '';
    for (let i = 0; i < spans.length; i++) {
      const span = spans[i];
      if (this.isEmptySpan(span)) continue;
      const kind = SsmlRenderer.MARK_KIND ? span.attributes['kind'] : '';
      const id = engine_js_1$8.Engine.getInstance().automark ? span.attributes['id'] : engine_js_1$8.Engine.getInstance().mark ? span.attributes['extid'] : '';
      if (id && id !== lastMark && !(SsmlRenderer.MARK_ONCE && SsmlRenderer.MARKS[id])) {
        result.push(kind ? `<mark name="${id}" kind="${kind}"/>` : `<mark name="${id}"/>`);
        lastMark = id;
        SsmlRenderer.MARKS[id] = true;
      }
      if (engine_js_1$8.Engine.getInstance().character && span.speech.length === 1 && span.speech.match(/[a-zA-Z]/)) {
        result.push('<say-as interpret-as="' + SsmlRenderer.CHARACTER_ATTR + '">' + span.speech + '</say-as>');
      } else {
        result.push(span.speech);
      }
    }
    return result.join(this.separator);
  }
  isEmptySpan(span) {
    const sep = span.attributes['separator'];
    return span.speech.match(/^\s*$/) && (!sep || sep.match(/^\s*$/));
  }
}
ssml_renderer.SsmlRenderer = SsmlRenderer;
SsmlRenderer.MARK_ONCE = false;
SsmlRenderer.MARK_KIND = true;
SsmlRenderer.CHARACTER_ATTR = 'character';
SsmlRenderer.MARKS = {};

var string_renderer = {};

Object.defineProperty(string_renderer, "__esModule", {
  value: true
});
string_renderer.CountingRenderer = string_renderer.StringRenderer = void 0;
const engine_js_1$7 = engine;
const abstract_audio_renderer_js_1 = abstract_audio_renderer;
const audio_util_js_1 = audio_util;
class StringRenderer extends abstract_audio_renderer_js_1.AbstractAudioRenderer {
  markup(descrs) {
    let str = '';
    const markup = (0, audio_util_js_1.personalityMarkup)(descrs);
    const clean = markup.filter(x => x.span);
    if (!clean.length) {
      return str;
    }
    const len = clean.length - 1;
    for (let i = 0, descr; descr = clean[i]; i++) {
      if (descr.span) {
        str += this.merge(descr.span);
      }
      if (i >= len) {
        continue;
      }
      const join = descr.join;
      str += typeof join === 'undefined' ? this.separator : join;
    }
    return str;
  }
}
string_renderer.StringRenderer = StringRenderer;
class CountingRenderer extends StringRenderer {
  finalize(str) {
    const output = super.finalize(str);
    const count = engine_js_1$7.Engine.getInstance().modality === 'braille' ? '⣿⠀⣿⠀⣿⠀⣿⠀⣿⠀' : '0123456789';
    let second = new Array(Math.trunc(output.length / 10) + 1).join(count);
    second += count.slice(0, output.length % 10);
    return output + '\n' + second;
  }
}
string_renderer.CountingRenderer = CountingRenderer;

Object.defineProperty(aural_rendering, "__esModule", {
  value: true
});
aural_rendering.setSeparator = setSeparator;
aural_rendering.getSeparator = getSeparator;
aural_rendering.markup = markup;
aural_rendering.merge = merge;
aural_rendering.finalize = finalize;
aural_rendering.error = error;
aural_rendering.registerRenderer = registerRenderer;
aural_rendering.isXml = isXml;
const engine_js_1$6 = engine;
const EngineConst$3 = engine_const;
const acss_renderer_js_1 = acss_renderer;
const layout_renderer_js_1 = layout_renderer;
const punctuation_renderer_js_1 = punctuation_renderer;
const sable_renderer_js_1 = sable_renderer;
const span_js_1 = span;
const ssml_renderer_js_1 = ssml_renderer;
const string_renderer_js_1 = string_renderer;
const xml_renderer_js_1 = xml_renderer;
const xmlInstance = new ssml_renderer_js_1.SsmlRenderer();
const renderers = new Map([[EngineConst$3.Markup.NONE, new string_renderer_js_1.StringRenderer()], [EngineConst$3.Markup.COUNTING, new string_renderer_js_1.CountingRenderer()], [EngineConst$3.Markup.PUNCTUATION, new punctuation_renderer_js_1.PunctuationRenderer()], [EngineConst$3.Markup.LAYOUT, new layout_renderer_js_1.LayoutRenderer()], [EngineConst$3.Markup.ACSS, new acss_renderer_js_1.AcssRenderer()], [EngineConst$3.Markup.SABLE, new sable_renderer_js_1.SableRenderer()], [EngineConst$3.Markup.VOICEXML, xmlInstance], [EngineConst$3.Markup.SSML, xmlInstance]]);
function setSeparator(sep) {
  const renderer = renderers.get(engine_js_1$6.Engine.getInstance().markup);
  if (renderer) {
    renderer.separator = sep;
  }
}
function getSeparator() {
  const renderer = renderers.get(engine_js_1$6.Engine.getInstance().markup);
  return renderer ? renderer.separator : '';
}
function markup(descrs) {
  const renderer = renderers.get(engine_js_1$6.Engine.getInstance().markup);
  if (!renderer) {
    return '';
  }
  return renderer.markup(descrs);
}
function merge(strs) {
  const span = strs.map(s => {
    return typeof s === 'string' ? span_js_1.Span.stringEmpty(s) : s;
  });
  const renderer = renderers.get(engine_js_1$6.Engine.getInstance().markup);
  if (!renderer) {
    return strs.join();
  }
  return renderer.merge(span);
}
function finalize(str) {
  const renderer = renderers.get(engine_js_1$6.Engine.getInstance().markup);
  if (!renderer) {
    return str;
  }
  return renderer.finalize(str);
}
function error(key) {
  const renderer = renderers.get(engine_js_1$6.Engine.getInstance().markup);
  if (!renderer) {
    return '';
  }
  return renderer.error(key);
}
function registerRenderer(type, renderer) {
  renderers.set(type, renderer);
}
function isXml() {
  return renderers.get(engine_js_1$6.Engine.getInstance().markup) instanceof xml_renderer_js_1.XmlRenderer;
}

var enrich$1 = {};

var semantic = {};

var semantic_tree = {};

var semantic_mathml = {};

var semantic_parser = {};

Object.defineProperty(semantic_parser, "__esModule", {
  value: true
});
semantic_parser.SemanticAbstractParser = void 0;
const semantic_node_factory_js_1$1 = semantic_node_factory;
class SemanticAbstractParser {
  constructor(type) {
    this.type = type;
    this.factory_ = new semantic_node_factory_js_1$1.SemanticNodeFactory();
  }
  getFactory() {
    return this.factory_;
  }
  setFactory(factory) {
    this.factory_ = factory;
  }
  getType() {
    return this.type;
  }
  parseList(list) {
    const result = [];
    for (let i = 0, element; element = list[i]; i++) {
      result.push(this.parse(element));
    }
    return result;
  }
}
semantic_parser.SemanticAbstractParser = SemanticAbstractParser;

Object.defineProperty(semantic_mathml, "__esModule", {
  value: true
});
semantic_mathml.SemanticMathml = void 0;
const DomUtil$n = dom_util;
const semantic_meaning_js_1$l = semantic_meaning;
const semantic_attr_js_1$3 = semantic_attr;
const semantic_parser_js_1 = semantic_parser;
const SemanticPred$2 = semantic_pred;
const semantic_processor_js_1$1 = semantic_processor;
const SemanticUtil$2 = semantic_util;
const semantic_util_js_1$9 = semantic_util;
const semantic_heuristic_factory_js_1$2 = semantic_heuristic_factory;
class SemanticMathml extends semantic_parser_js_1.SemanticAbstractParser {
  static getAttribute_(node, attr, def) {
    if (!node.hasAttribute(attr)) {
      return def;
    }
    const value = node.getAttribute(attr);
    if (value.match(/^\s*$/)) {
      return null;
    }
    return value;
  }
  constructor() {
    super('MathML');
    this.parseMap_ = new Map([[semantic_util_js_1$9.MMLTAGS.SEMANTICS, this.semantics_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MATH, this.rows_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MROW, this.rows_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MPADDED, this.rows_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MSTYLE, this.rows_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MFRAC, this.fraction_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MSUB, this.limits_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MSUP, this.limits_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MSUBSUP, this.limits_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MOVER, this.limits_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MUNDER, this.limits_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MUNDEROVER, this.limits_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MROOT, this.root_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MSQRT, this.sqrt_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MTABLE, this.table_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MLABELEDTR, this.tableLabeledRow_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MTR, this.tableRow_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MTD, this.tableCell_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MS, this.text_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MTEXT, this.text_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MSPACE, this.space_.bind(this)], [semantic_util_js_1$9.MMLTAGS.ANNOTATIONXML, this.text_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MI, this.identifier_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MN, this.number_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MO, this.operator_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MFENCED, this.fenced_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MENCLOSE, this.enclosed_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MMULTISCRIPTS, this.multiscripts_.bind(this)], [semantic_util_js_1$9.MMLTAGS.ANNOTATION, this.empty_.bind(this)], [semantic_util_js_1$9.MMLTAGS.NONE, this.empty_.bind(this)], [semantic_util_js_1$9.MMLTAGS.MACTION, this.action_.bind(this)]]);
    const meaning = {
      type: semantic_meaning_js_1$l.SemanticType.IDENTIFIER,
      role: semantic_meaning_js_1$l.SemanticRole.NUMBERSET,
      font: semantic_meaning_js_1$l.SemanticFont.DOUBLESTRUCK
    };
    ['C', 'H', 'N', 'P', 'Q', 'R', 'Z', 'ℂ', 'ℍ', 'ℕ', 'ℙ', 'ℚ', 'ℝ', 'ℤ'].forEach((x => this.getFactory().defaultMap.set(x, meaning)).bind(this));
  }
  parse(mml) {
    semantic_processor_js_1$1.SemanticProcessor.getInstance().setNodeFactory(this.getFactory());
    const children = DomUtil$n.toArray(mml.childNodes);
    const tag = DomUtil$n.tagName(mml);
    const func = this.parseMap_.get(tag);
    const newNode = (func ? func : this.dummy_.bind(this))(mml, children);
    SemanticUtil$2.addAttributes(newNode, mml);
    if ([semantic_util_js_1$9.MMLTAGS.MATH, semantic_util_js_1$9.MMLTAGS.MROW, semantic_util_js_1$9.MMLTAGS.MPADDED, semantic_util_js_1$9.MMLTAGS.MSTYLE, semantic_util_js_1$9.MMLTAGS.SEMANTICS, semantic_util_js_1$9.MMLTAGS.MACTION].indexOf(tag) !== -1) {
      return newNode;
    }
    newNode.mathml.unshift(mml);
    newNode.mathmlTree = mml;
    return newNode;
  }
  semantics_(_node, children) {
    return children.length ? this.parse(children[0]) : this.getFactory().makeEmptyNode();
  }
  rows_(node, children) {
    const semantics = node.getAttribute('semantics');
    if (semantics && semantics.match('bspr_')) {
      return semantic_processor_js_1$1.SemanticProcessor.proof(node, semantics, this.parseList.bind(this));
    }
    children = SemanticUtil$2.purgeNodes(children);
    let newNode;
    if (children.length === 1) {
      newNode = this.parse(children[0]);
      if (newNode.type === semantic_meaning_js_1$l.SemanticType.EMPTY && !newNode.mathmlTree) {
        newNode.mathmlTree = node;
      }
    } else {
      const snode = semantic_heuristic_factory_js_1$2.SemanticHeuristics.run('function_from_identifiers', node);
      newNode = snode && snode !== node ? snode : semantic_processor_js_1$1.SemanticProcessor.getInstance().row(this.parseList(children));
    }
    newNode.mathml.unshift(node);
    return newNode;
  }
  fraction_(node, children) {
    if (!children.length) {
      return this.getFactory().makeEmptyNode();
    }
    const upper = this.parse(children[0]);
    const lower = children[1] ? this.parse(children[1]) : this.getFactory().makeEmptyNode();
    const sem = semantic_processor_js_1$1.SemanticProcessor.getInstance().fractionLikeNode(upper, lower, node.getAttribute('linethickness'), node.getAttribute('bevelled') === 'true');
    return sem;
  }
  limits_(node, children) {
    return semantic_processor_js_1$1.SemanticProcessor.getInstance().limitNode(DomUtil$n.tagName(node), this.parseList(children));
  }
  root_(node, children) {
    if (!children[1]) {
      return this.sqrt_(node, children);
    }
    return this.getFactory().makeBranchNode(semantic_meaning_js_1$l.SemanticType.ROOT, [this.parse(children[1]), this.parse(children[0])], []);
  }
  sqrt_(_node, children) {
    const semNodes = this.parseList(SemanticUtil$2.purgeNodes(children));
    return this.getFactory().makeBranchNode(semantic_meaning_js_1$l.SemanticType.SQRT, [semantic_processor_js_1$1.SemanticProcessor.getInstance().row(semNodes)], []);
  }
  table_(node, children) {
    const semantics = node.getAttribute('semantics');
    if (semantics && semantics.match('bspr_')) {
      return semantic_processor_js_1$1.SemanticProcessor.proof(node, semantics, this.parseList.bind(this));
    }
    const newNode = this.getFactory().makeBranchNode(semantic_meaning_js_1$l.SemanticType.TABLE, this.parseList(children), []);
    newNode.mathmlTree = node;
    return semantic_processor_js_1$1.SemanticProcessor.tableToMultiline(newNode);
  }
  tableRow_(_node, children) {
    const newNode = this.getFactory().makeBranchNode(semantic_meaning_js_1$l.SemanticType.ROW, this.parseList(children), []);
    newNode.role = semantic_meaning_js_1$l.SemanticRole.TABLE;
    return newNode;
  }
  tableLabeledRow_(node, children) {
    var _a;
    if (!children.length) {
      return this.tableRow_(node, children);
    }
    const label = this.parse(children[0]);
    label.role = semantic_meaning_js_1$l.SemanticRole.LABEL;
    if (((_a = label.childNodes[0]) === null || _a === void 0 ? void 0 : _a.type) === semantic_meaning_js_1$l.SemanticType.TEXT) {
      label.childNodes[0].role = semantic_meaning_js_1$l.SemanticRole.LABEL;
    }
    const newNode = this.getFactory().makeBranchNode(semantic_meaning_js_1$l.SemanticType.ROW, this.parseList(children.slice(1)), [label]);
    newNode.role = semantic_meaning_js_1$l.SemanticRole.TABLE;
    return newNode;
  }
  tableCell_(_node, children) {
    const semNodes = this.parseList(SemanticUtil$2.purgeNodes(children));
    let childNodes;
    if (!semNodes.length) {
      childNodes = [];
    } else if (semNodes.length === 1 && SemanticPred$2.isType(semNodes[0], semantic_meaning_js_1$l.SemanticType.EMPTY)) {
      childNodes = semNodes;
    } else {
      childNodes = [semantic_processor_js_1$1.SemanticProcessor.getInstance().row(semNodes)];
    }
    const newNode = this.getFactory().makeBranchNode(semantic_meaning_js_1$l.SemanticType.CELL, childNodes, []);
    newNode.role = semantic_meaning_js_1$l.SemanticRole.TABLE;
    return newNode;
  }
  space_(node, children) {
    const width = node.getAttribute('width');
    const match = width && width.match(/[a-z]*$/);
    if (!match) {
      return this.empty_(node, children);
    }
    const sizes = {
      cm: 0.4,
      pc: 0.5,
      em: 0.5,
      ex: 1,
      in: 0.15,
      pt: 5,
      mm: 5
    };
    const unit = match[0];
    const measure = parseFloat(width.slice(0, match.index));
    const size = sizes[unit];
    if (!size || isNaN(measure) || measure < size) {
      return this.empty_(node, children);
    }
    const newNode = this.getFactory().makeUnprocessed(node);
    return semantic_processor_js_1$1.SemanticProcessor.getInstance().text(newNode, DomUtil$n.tagName(node));
  }
  text_(node, children) {
    const newNode = this.leaf_(node, children);
    if (!node.textContent) {
      return newNode;
    }
    newNode.updateContent(node.textContent, true);
    return semantic_processor_js_1$1.SemanticProcessor.getInstance().text(newNode, DomUtil$n.tagName(node));
  }
  identifier_(node, children) {
    const newNode = this.leaf_(node, children);
    return semantic_processor_js_1$1.SemanticProcessor.getInstance().identifierNode(newNode, semantic_processor_js_1$1.SemanticProcessor.getInstance().font(node.getAttribute('mathvariant')), node.getAttribute('class'));
  }
  number_(node, children) {
    const newNode = this.leaf_(node, children);
    semantic_processor_js_1$1.SemanticProcessor.number(newNode);
    return newNode;
  }
  operator_(node, children) {
    const newNode = this.leaf_(node, children);
    semantic_processor_js_1$1.SemanticProcessor.getInstance().operatorNode(newNode);
    return newNode;
  }
  fenced_(node, children) {
    const semNodes = this.parseList(SemanticUtil$2.purgeNodes(children));
    const sepValue = SemanticMathml.getAttribute_(node, 'separators', ',');
    const open = SemanticMathml.getAttribute_(node, 'open', '(');
    const close = SemanticMathml.getAttribute_(node, 'close', ')');
    const newNode = semantic_processor_js_1$1.SemanticProcessor.getInstance().mfenced(open, close, sepValue, semNodes);
    const nodes = semantic_processor_js_1$1.SemanticProcessor.getInstance().tablesInRow([newNode]);
    return nodes[0];
  }
  enclosed_(node, children) {
    const semNodes = this.parseList(SemanticUtil$2.purgeNodes(children));
    const newNode = this.getFactory().makeBranchNode(semantic_meaning_js_1$l.SemanticType.ENCLOSE, [semantic_processor_js_1$1.SemanticProcessor.getInstance().row(semNodes)], []);
    newNode.role = node.getAttribute('notation') || semantic_meaning_js_1$l.SemanticRole.UNKNOWN;
    return newNode;
  }
  multiscripts_(_node, children) {
    if (!children.length) {
      return this.getFactory().makeEmptyNode();
    }
    const base = this.parse(children.shift());
    if (!children.length) {
      return base;
    }
    const lsup = [];
    const lsub = [];
    const rsup = [];
    const rsub = [];
    let prescripts = false;
    let scriptcount = 0;
    for (let i = 0, child; child = children[i]; i++) {
      if (DomUtil$n.tagName(child) === semantic_util_js_1$9.MMLTAGS.MPRESCRIPTS) {
        prescripts = true;
        scriptcount = 0;
        continue;
      }
      prescripts ? scriptcount & 1 ? lsup.push(child) : lsub.push(child) : scriptcount & 1 ? rsup.push(child) : rsub.push(child);
      scriptcount++;
    }
    if (!SemanticUtil$2.purgeNodes(lsup).length && !SemanticUtil$2.purgeNodes(lsub).length) {
      return semantic_processor_js_1$1.SemanticProcessor.getInstance().pseudoTensor(base, this.parseList(rsub), this.parseList(rsup));
    }
    return semantic_processor_js_1$1.SemanticProcessor.getInstance().tensor(base, this.parseList(lsub), this.parseList(lsup), this.parseList(rsub), this.parseList(rsup));
  }
  empty_(_node, _children) {
    return this.getFactory().makeEmptyNode();
  }
  action_(node, children) {
    const selection = children[node.hasAttribute('selection') ? parseInt(node.getAttribute('selection'), 10) - 1 : 0];
    const stree = this.parse(selection);
    stree.mathmlTree = selection;
    return stree;
  }
  dummy_(node, _children) {
    const unknown = this.getFactory().makeUnprocessed(node);
    unknown.role = node.tagName;
    unknown.textContent = node.textContent;
    return unknown;
  }
  leaf_(mml, children) {
    if (children.length === 1 && children[0].nodeType !== DomUtil$n.NodeType.TEXT_NODE) {
      const node = this.getFactory().makeUnprocessed(mml);
      node.role = children[0].tagName;
      SemanticUtil$2.addAttributes(node, children[0]);
      return node;
    }
    const node = this.getFactory().makeLeafNode(mml.textContent, semantic_processor_js_1$1.SemanticProcessor.getInstance().font(mml.getAttribute('mathvariant')));
    if (mml.hasAttribute('data-latex')) {
      semantic_attr_js_1$3.SemanticMap.LatexCommands.set(mml.getAttribute('data-latex'), mml.textContent);
    }
    return node;
  }
}
semantic_mathml.SemanticMathml = SemanticMathml;

var semantic_heuristic = {};

Object.defineProperty(semantic_heuristic, "__esModule", {
  value: true
});
semantic_heuristic.SemanticMmlHeuristic = semantic_heuristic.SemanticMultiHeuristic = semantic_heuristic.SemanticTreeHeuristic = void 0;
class SemanticAbstractHeuristic {
  constructor(name, method, predicate = _x => false) {
    this.name = name;
    this.apply = method;
    this.applicable = predicate;
  }
}
class SemanticTreeHeuristic extends SemanticAbstractHeuristic {}
semantic_heuristic.SemanticTreeHeuristic = SemanticTreeHeuristic;
class SemanticMultiHeuristic extends SemanticAbstractHeuristic {}
semantic_heuristic.SemanticMultiHeuristic = SemanticMultiHeuristic;
class SemanticMmlHeuristic extends SemanticAbstractHeuristic {}
semantic_heuristic.SemanticMmlHeuristic = SemanticMmlHeuristic;

var semantic_skeleton = {};

var enrich_attr = {};

Object.defineProperty(enrich_attr, "__esModule", {
  value: true
});
enrich_attr.EnrichAttributes = enrich_attr.Attribute = void 0;
enrich_attr.makeIdList = makeIdList;
enrich_attr.setAttributes = setAttributes;
enrich_attr.removeAttributePrefix = removeAttributePrefix;
enrich_attr.addPrefix = addPrefix$1;
enrich_attr.addMrow = addMrow;
const DomUtil$m = dom_util;
const semantic_meaning_js_1$k = semantic_meaning;
const Prefix = 'data-semantic-';
var Attribute;
(function (Attribute) {
  Attribute["ADDED"] = "data-semantic-added";
  Attribute["ALTERNATIVE"] = "data-semantic-alternative";
  Attribute["CHILDREN"] = "data-semantic-children";
  Attribute["COLLAPSED"] = "data-semantic-collapsed";
  Attribute["CONTENT"] = "data-semantic-content";
  Attribute["EMBELLISHED"] = "data-semantic-embellished";
  Attribute["FENCEPOINTER"] = "data-semantic-fencepointer";
  Attribute["FONT"] = "data-semantic-font";
  Attribute["ID"] = "data-semantic-id";
  Attribute["ANNOTATION"] = "data-semantic-annotation";
  Attribute["ATTRIBUTES"] = "data-semantic-attributes";
  Attribute["OPERATOR"] = "data-semantic-operator";
  Attribute["OWNS"] = "data-semantic-owns";
  Attribute["PARENT"] = "data-semantic-parent";
  Attribute["POSTFIX"] = "data-semantic-postfix";
  Attribute["PREFIX"] = "data-semantic-prefix";
  Attribute["ROLE"] = "data-semantic-role";
  Attribute["SPEECH"] = "data-semantic-speech";
  Attribute["STRUCTURE"] = "data-semantic-structure";
  Attribute["SUMMARY"] = "data-semantic-summary";
  Attribute["TYPE"] = "data-semantic-type";
})(Attribute || (enrich_attr.Attribute = Attribute = {}));
enrich_attr.EnrichAttributes = [Attribute.ADDED, Attribute.ALTERNATIVE, Attribute.CHILDREN, Attribute.COLLAPSED, Attribute.CONTENT, Attribute.EMBELLISHED, Attribute.FENCEPOINTER, Attribute.FONT, Attribute.ID, Attribute.ANNOTATION, Attribute.ATTRIBUTES, Attribute.OPERATOR, Attribute.OWNS, Attribute.PARENT, Attribute.POSTFIX, Attribute.PREFIX, Attribute.ROLE, Attribute.SPEECH, Attribute.STRUCTURE, Attribute.SUMMARY, Attribute.TYPE];
function makeIdList(nodes) {
  return nodes.map(function (node) {
    return node.id;
  }).join(',');
}
function setAttributes(mml, semantic) {
  mml.setAttribute(Attribute.TYPE, semantic.type);
  const attributes = semantic.allAttributes();
  for (let i = 0, attr; attr = attributes[i]; i++) {
    mml.setAttribute(Prefix + attr[0].toLowerCase(), attr[1]);
  }
  if (semantic.childNodes.length) {
    mml.setAttribute(Attribute.CHILDREN, makeIdList(semantic.childNodes));
  }
  if (semantic.contentNodes.length) {
    mml.setAttribute(Attribute.CONTENT, makeIdList(semantic.contentNodes));
  }
  if (semantic.parent) {
    mml.setAttribute(Attribute.PARENT, semantic.parent.id.toString());
  }
  const external = semantic.attributesXml();
  if (external) {
    mml.setAttribute(Attribute.ATTRIBUTES, external);
  }
  setPostfix(mml, semantic);
}
function setPostfix(mml, semantic) {
  const postfix = [];
  if (semantic.role === semantic_meaning_js_1$k.SemanticRole.MGLYPH) {
    postfix.push('image');
  }
  if (semantic.attributes['href']) {
    postfix.push('link');
  }
  if (postfix.length) {
    mml.setAttribute(Attribute.POSTFIX, postfix.join(' '));
  }
}
function removeAttributePrefix(mml) {
  return mml.toString().replace(new RegExp(Prefix, 'g'), '');
}
function addPrefix$1(attr) {
  return Prefix + attr;
}
function addMrow() {
  const mrow = DomUtil$m.createElement('mrow');
  mrow.setAttribute(Attribute.ADDED, 'true');
  return mrow;
}

Object.defineProperty(semantic_skeleton, "__esModule", {
  value: true
});
semantic_skeleton.SemanticSkeleton = void 0;
const BaseUtil = base_util;
const engine_js_1$5 = engine;
const XpathUtil$5 = xpath_util;
const enrich_attr_js_1$k = enrich_attr;
const semantic_meaning_js_1$j = semantic_meaning;
class SemanticSkeleton {
  static fromTree(tree) {
    return SemanticSkeleton.fromNode(tree.root);
  }
  static fromNode(node) {
    return new SemanticSkeleton(SemanticSkeleton.fromNode_(node));
  }
  static fromString(skel) {
    return new SemanticSkeleton(SemanticSkeleton.fromString_(skel));
  }
  static simpleCollapseStructure(strct) {
    return typeof strct === 'number';
  }
  static contentCollapseStructure(strct) {
    return !!strct && !SemanticSkeleton.simpleCollapseStructure(strct) && strct[0] === 'c';
  }
  static interleaveIds(first, second) {
    return BaseUtil.interleaveLists(SemanticSkeleton.collapsedLeafs(first), SemanticSkeleton.collapsedLeafs(second));
  }
  static collapsedLeafs(...args) {
    const collapseStructure = coll => {
      if (SemanticSkeleton.simpleCollapseStructure(coll)) {
        return [coll];
      }
      coll = coll;
      return SemanticSkeleton.contentCollapseStructure(coll[1]) ? coll.slice(2) : coll.slice(1);
    };
    return args.reduce((x, y) => x.concat(collapseStructure(y)), []);
  }
  static fromStructure(mml, tree) {
    return new SemanticSkeleton(SemanticSkeleton.tree_(mml, tree.root));
  }
  static combineContentChildren(type, _role, content, children) {
    switch (type) {
      case semantic_meaning_js_1$j.SemanticType.RELSEQ:
      case semantic_meaning_js_1$j.SemanticType.INFIXOP:
      case semantic_meaning_js_1$j.SemanticType.MULTIREL:
        return BaseUtil.interleaveLists(children, content);
      case semantic_meaning_js_1$j.SemanticType.PREFIXOP:
        return content.concat(children);
      case semantic_meaning_js_1$j.SemanticType.POSTFIXOP:
        return children.concat(content);
      case semantic_meaning_js_1$j.SemanticType.MATRIX:
      case semantic_meaning_js_1$j.SemanticType.VECTOR:
      case semantic_meaning_js_1$j.SemanticType.FENCED:
        children.unshift(content[0]);
        children.push(content[1]);
        return children;
      case semantic_meaning_js_1$j.SemanticType.CASES:
        children.unshift(content[0]);
        return children;
      case semantic_meaning_js_1$j.SemanticType.APPL:
        return [children[0], content[0], children[1]];
      case semantic_meaning_js_1$j.SemanticType.ROOT:
        return [children[0], children[1]];
      case semantic_meaning_js_1$j.SemanticType.ROW:
      case semantic_meaning_js_1$j.SemanticType.LINE:
        if (content.length) {
          children.unshift(content[0]);
        }
        return children;
      default:
        return children;
    }
  }
  static makeSexp_(struct) {
    if (SemanticSkeleton.simpleCollapseStructure(struct)) {
      return struct.toString();
    }
    if (SemanticSkeleton.contentCollapseStructure(struct)) {
      return '(' + 'c ' + struct.slice(1).map(SemanticSkeleton.makeSexp_).join(' ') + ')';
    }
    return '(' + struct.map(SemanticSkeleton.makeSexp_).join(' ') + ')';
  }
  static fromString_(skeleton) {
    let str = skeleton.replace(/\(/g, '[');
    str = str.replace(/\)/g, ']');
    str = str.replace(/ /g, ',');
    str = str.replace(/c/g, '"c"');
    return JSON.parse(str);
  }
  static fromNode_(node) {
    if (!node) {
      return [];
    }
    const content = node.contentNodes;
    let contentStructure;
    if (content.length) {
      contentStructure = content.map(SemanticSkeleton.fromNode_);
      contentStructure.unshift('c');
    }
    const children = node.childNodes;
    if (!children.length) {
      return content.length ? [node.id, contentStructure] : node.id;
    }
    const structure = children.map(SemanticSkeleton.fromNode_);
    if (content.length) {
      structure.unshift(contentStructure);
    }
    structure.unshift(node.id);
    return structure;
  }
  static tree_(mml, node, level = 0, posinset = 1, setsize = 1) {
    if (!node) {
      return [];
    }
    const id = node.id;
    const skeleton = [id];
    XpathUtil$5.updateEvaluator(mml);
    const mmlChild = XpathUtil$5.evalXPath(`.//self::*[@${enrich_attr_js_1$k.Attribute.ID}=${id}]`, mml)[0];
    if (!node.childNodes.length) {
      SemanticSkeleton.addAria(mmlChild, level, posinset, setsize);
      return node.id;
    }
    const children = SemanticSkeleton.combineContentChildren(node.type, node.role, node.contentNodes.map(function (x) {
      return x;
    }), node.childNodes.map(function (x) {
      return x;
    }));
    if (mmlChild) {
      SemanticSkeleton.addOwns_(mmlChild, children);
    }
    for (let i = 0, l = children.length, child; child = children[i]; i++) {
      skeleton.push(SemanticSkeleton.tree_(mml, child, level + 1, i + 1, l));
    }
    SemanticSkeleton.addAria(mmlChild, level, posinset, setsize, 'treeitem' );
    return skeleton;
  }
  static addAria(node, level, posinset, setsize, role = 'treeitem' ) {
    if (!engine_js_1$5.Engine.getInstance().aria || !node) {
      return;
    }
    node.setAttribute('aria-level', level.toString());
    node.setAttribute('aria-posinset', posinset.toString());
    node.setAttribute('aria-setsize', setsize.toString());
    node.setAttribute('role', role);
    if (node.hasAttribute(enrich_attr_js_1$k.Attribute.OWNS)) {
      node.setAttribute('aria-owns', node.getAttribute(enrich_attr_js_1$k.Attribute.OWNS));
    }
  }
  static addOwns_(node, children) {
    const collapsed = node.getAttribute(enrich_attr_js_1$k.Attribute.COLLAPSED);
    const leafs = collapsed ? SemanticSkeleton.realLeafs_(SemanticSkeleton.fromString(collapsed).array) : children.map(x => x.id);
    node.setAttribute(enrich_attr_js_1$k.Attribute.OWNS, leafs.join(' '));
  }
  static realLeafs_(sexp) {
    if (SemanticSkeleton.simpleCollapseStructure(sexp)) {
      return [sexp];
    }
    if (SemanticSkeleton.contentCollapseStructure(sexp)) {
      return [];
    }
    sexp = sexp;
    let result = [];
    for (let i = 1; i < sexp.length; i++) {
      result = result.concat(SemanticSkeleton.realLeafs_(sexp[i]));
    }
    return result;
  }
  constructor(skeleton) {
    this.parents = null;
    this.levelsMap = null;
    skeleton = skeleton === 0 ? skeleton : skeleton || [];
    this.array = skeleton;
  }
  populate() {
    if (this.parents && this.levelsMap) {
      return;
    }
    this.parents = {};
    this.levelsMap = {};
    this.populate_(this.array, this.array, []);
  }
  toString() {
    return SemanticSkeleton.makeSexp_(this.array);
  }
  populate_(element, layer, parents) {
    if (SemanticSkeleton.simpleCollapseStructure(element)) {
      element = element;
      this.levelsMap[element] = layer;
      this.parents[element] = element === parents[0] ? parents.slice(1) : parents;
      return;
    }
    const newElement = SemanticSkeleton.contentCollapseStructure(element) ? element.slice(1) : element;
    const newParents = [newElement[0]].concat(parents);
    for (let i = 0, l = newElement.length; i < l; i++) {
      const current = newElement[i];
      this.populate_(current, element, newParents);
    }
  }
  isRoot(id) {
    const level = this.levelsMap[id];
    return id === level[0];
  }
  directChildren(id) {
    if (!this.isRoot(id)) {
      return [];
    }
    const level = this.levelsMap[id];
    return level.slice(1).map(child => {
      if (SemanticSkeleton.simpleCollapseStructure(child)) {
        return child;
      }
      if (SemanticSkeleton.contentCollapseStructure(child)) {
        return child[1];
      }
      return child[0];
    });
  }
  subtreeNodes(id) {
    if (!this.isRoot(id)) {
      return [];
    }
    const subtreeNodes_ = (tree, nodes) => {
      if (SemanticSkeleton.simpleCollapseStructure(tree)) {
        nodes.push(tree);
        return;
      }
      tree = tree;
      if (SemanticSkeleton.contentCollapseStructure(tree)) {
        tree = tree.slice(1);
      }
      tree.forEach(x => subtreeNodes_(x, nodes));
    };
    const level = this.levelsMap[id];
    const subtree = [];
    subtreeNodes_(level.slice(1), subtree);
    return subtree;
  }
}
semantic_skeleton.SemanticSkeleton = SemanticSkeleton;

const debugger_js_1$2 = _debugger;
const engine_js_1$4 = engine;
const semantic_attr_js_1$2 = semantic_attr;
const semantic_heuristic_factory_js_1$1 = semantic_heuristic_factory;
const semantic_heuristic_js_1 = semantic_heuristic;
const semantic_meaning_js_1$i = semantic_meaning;
const SemanticPred$1 = semantic_pred;
const semantic_processor_js_1 = semantic_processor;
const SemanticUtil$1 = semantic_util;
const semantic_skeleton_js_1$5 = semantic_skeleton;
const semantic_util_js_1$8 = semantic_util;
const DomUtil$l = dom_util;
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('combine_juxtaposition', combineJuxtaposition));
function combineJuxtaposition(root) {
  for (let i = root.childNodes.length - 1, child; child = root.childNodes[i]; i--) {
    if (!SemanticPred$1.isImplicitOp(child) || child.nobreaking) {
      continue;
    }
    root.childNodes.splice(i, 1, ...child.childNodes);
    root.contentNodes.splice(i, 0, ...child.contentNodes);
    child.childNodes.concat(child.contentNodes).forEach(function (x) {
      x.parent = root;
    });
    root.addMathmlNodes(child.mathml);
  }
  return root;
}
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('propagateSimpleFunction', node => {
  if ((node.type === semantic_meaning_js_1$i.SemanticType.INFIXOP || node.type === semantic_meaning_js_1$i.SemanticType.FRACTION) && node.childNodes.every(SemanticPred$1.isSimpleFunction)) {
    node.role = semantic_meaning_js_1$i.SemanticRole.COMPFUNC;
  }
  return node;
}, _node => engine_js_1$4.Engine.getInstance().domain === 'clearspeak'));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('simpleNamedFunction', node => {
  const specialFunctions = ['f', 'g', 'h', 'F', 'G', 'H'];
  if (node.role !== semantic_meaning_js_1$i.SemanticRole.UNIT && specialFunctions.indexOf(node.textContent) !== -1) {
    node.role = semantic_meaning_js_1$i.SemanticRole.SIMPLEFUNC;
  }
  return node;
}, _node => engine_js_1$4.Engine.getInstance().domain === 'clearspeak'));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('propagateComposedFunction', node => {
  if (node.type === semantic_meaning_js_1$i.SemanticType.FENCED && node.childNodes[0].role === semantic_meaning_js_1$i.SemanticRole.COMPFUNC) {
    node.role = semantic_meaning_js_1$i.SemanticRole.COMPFUNC;
  }
  return node;
}, _node => engine_js_1$4.Engine.getInstance().domain === 'clearspeak'));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('multioperator', node => {
  if (node.role !== semantic_meaning_js_1$i.SemanticRole.UNKNOWN || node.textContent.length <= 1) {
    return;
  }
  semantic_processor_js_1.SemanticProcessor.compSemantics(node, 'role', semantic_meaning_js_1$i.SemanticRole);
  semantic_processor_js_1.SemanticProcessor.compSemantics(node, 'type', semantic_meaning_js_1$i.SemanticType);
}));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticMultiHeuristic('convert_juxtaposition', nodes => {
  let partition = SemanticUtil$1.partitionNodes(nodes, function (x) {
    return x.textContent === semantic_attr_js_1$2.NamedSymbol.invisibleTimes && x.type === semantic_meaning_js_1$i.SemanticType.OPERATOR;
  });
  partition = partition.rel.length ? juxtapositionPrePost(partition) : partition;
  nodes = partition.comp[0];
  for (let i = 1, c, r; (c = partition.comp[i], r = partition.rel[i - 1]); i++) {
    nodes.push(r);
    nodes = nodes.concat(c);
  }
  partition = SemanticUtil$1.partitionNodes(nodes, function (x) {
    return x.textContent === semantic_attr_js_1$2.NamedSymbol.invisibleTimes && (x.type === semantic_meaning_js_1$i.SemanticType.OPERATOR || x.type === semantic_meaning_js_1$i.SemanticType.INFIXOP);
  });
  if (!partition.rel.length) {
    return nodes;
  }
  return recurseJuxtaposition(partition.comp.shift(), partition.rel, partition.comp);
}));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('simple2prefix', node => {
  if (node.textContent.length > 1 && !node.textContent[0].match(/[A-Z]/)) {
    node.role = semantic_meaning_js_1$i.SemanticRole.PREFIXFUNC;
  }
  return node;
}, node => engine_js_1$4.Engine.getInstance().modality === 'braille' && node.type === semantic_meaning_js_1$i.SemanticType.IDENTIFIER));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('detect_cycle', node => {
  node.type = semantic_meaning_js_1$i.SemanticType.MATRIX;
  node.role = semantic_meaning_js_1$i.SemanticRole.CYCLE;
  const row = node.childNodes[0];
  row.type = semantic_meaning_js_1$i.SemanticType.ROW;
  row.role = semantic_meaning_js_1$i.SemanticRole.CYCLE;
  row.textContent = '';
  row.contentNodes = [];
  return node;
}, node => node.type === semantic_meaning_js_1$i.SemanticType.FENCED && node.childNodes[0].type === semantic_meaning_js_1$i.SemanticType.INFIXOP && node.childNodes[0].role === semantic_meaning_js_1$i.SemanticRole.IMPLICIT && node.childNodes[0].childNodes.every(function (x) {
  return x.type === semantic_meaning_js_1$i.SemanticType.NUMBER;
}) && node.childNodes[0].contentNodes.every(function (x) {
  return x.role === semantic_meaning_js_1$i.SemanticRole.SPACE;
})));
function juxtapositionPrePost(partition) {
  const rels = [];
  const comps = [];
  let next = partition.comp.shift();
  let rel = null;
  let collect = [];
  while (partition.comp.length) {
    collect = [];
    if (next.length) {
      if (rel) {
        rels.push(rel);
      }
      comps.push(next);
      rel = partition.rel.shift();
      next = partition.comp.shift();
      continue;
    }
    if (rel) {
      collect.push(rel);
    }
    while (!next.length && partition.comp.length) {
      next = partition.comp.shift();
      collect.push(partition.rel.shift());
    }
    rel = convertPrePost(collect, next, comps);
  }
  if (!collect.length && !next.length) {
    collect.push(rel);
    convertPrePost(collect, next, comps);
  } else {
    rels.push(rel);
    comps.push(next);
  }
  return {
    rel: rels,
    comp: comps
  };
}
function convertPrePost(collect, next, comps) {
  let rel = null;
  if (!collect.length) {
    return rel;
  }
  const prev = comps[comps.length - 1];
  const prevExists = prev && prev.length;
  const nextExists = next && next.length;
  const processor = semantic_processor_js_1.SemanticProcessor.getInstance();
  if (prevExists && nextExists) {
    if (next[0].type === semantic_meaning_js_1$i.SemanticType.INFIXOP && next[0].role === semantic_meaning_js_1$i.SemanticRole.IMPLICIT) {
      rel = collect.pop();
      prev.push(processor['postfixNode_'](prev.pop(), collect));
      return rel;
    }
    rel = collect.shift();
    const result = processor['prefixNode_'](next.shift(), collect);
    next.unshift(result);
    return rel;
  }
  if (prevExists) {
    prev.push(processor['postfixNode_'](prev.pop(), collect));
    return rel;
  }
  if (nextExists) {
    next.unshift(processor['prefixNode_'](next.shift(), collect));
  }
  return rel;
}
function recurseJuxtaposition(acc, ops, elements) {
  if (!ops.length) {
    return acc;
  }
  const left = acc.pop();
  const op = ops.shift();
  const first = elements.shift();
  if (op.type === semantic_meaning_js_1$i.SemanticType.INFIXOP && (op.role === semantic_meaning_js_1$i.SemanticRole.IMPLICIT || op.role === semantic_meaning_js_1$i.SemanticRole.UNIT)) {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 2');
    const right = (left ? [left, op] : [op]).concat(first);
    return recurseJuxtaposition(acc.concat(right), ops, elements);
  }
  if (!left) {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 3');
    return recurseJuxtaposition([op].concat(first), ops, elements);
  }
  const right = first.shift();
  if (!right) {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 9');
    const newOp = semantic_heuristic_factory_js_1$1.SemanticHeuristics.factory.makeBranchNode(semantic_meaning_js_1$i.SemanticType.INFIXOP, [left, ops.shift()], [op], op.textContent);
    newOp.role = semantic_meaning_js_1$i.SemanticRole.IMPLICIT;
    semantic_heuristic_factory_js_1$1.SemanticHeuristics.run('combine_juxtaposition', newOp);
    ops.unshift(newOp);
    return recurseJuxtaposition(acc, ops, elements);
  }
  if (SemanticPred$1.isOperator(left) || SemanticPred$1.isOperator(right)) {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 4');
    return recurseJuxtaposition(acc.concat([left, op, right]).concat(first), ops, elements);
  }
  let result = null;
  if (SemanticPred$1.isImplicitOp(left) && SemanticPred$1.isImplicitOp(right)) {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 5');
    left.contentNodes.push(op);
    left.contentNodes = left.contentNodes.concat(right.contentNodes);
    left.childNodes.push(right);
    left.childNodes = left.childNodes.concat(right.childNodes);
    right.childNodes.forEach(x => x.parent = left);
    op.parent = left;
    left.addMathmlNodes(op.mathml);
    left.addMathmlNodes(right.mathml);
    result = left;
  } else if (SemanticPred$1.isImplicitOp(left)) {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 6');
    left.contentNodes.push(op);
    left.childNodes.push(right);
    right.parent = left;
    op.parent = left;
    left.addMathmlNodes(op.mathml);
    left.addMathmlNodes(right.mathml);
    result = left;
  } else if (SemanticPred$1.isImplicitOp(right)) {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 7');
    right.contentNodes.unshift(op);
    right.childNodes.unshift(left);
    left.parent = right;
    op.parent = right;
    right.addMathmlNodes(op.mathml);
    right.addMathmlNodes(left.mathml);
    result = right;
  } else {
    debugger_js_1$2.Debugger.getInstance().output('Juxta Heuristic Case 8');
    result = semantic_heuristic_factory_js_1$1.SemanticHeuristics.factory.makeBranchNode(semantic_meaning_js_1$i.SemanticType.INFIXOP, [left, right], [op], op.textContent);
    result.role = semantic_meaning_js_1$i.SemanticRole.IMPLICIT;
  }
  acc.push(result);
  return recurseJuxtaposition(acc.concat(first), ops, elements);
}
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticMultiHeuristic('intvar_from_implicit', implicitUnpack, nodes => nodes[0] && SemanticPred$1.isImplicit(nodes[0])));
function implicitUnpack(nodes) {
  const children = nodes[0].childNodes;
  nodes.splice(0, 1, ...children);
}
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('intvar_from_fraction', integralFractionArg, node => {
  if (node.type !== semantic_meaning_js_1$i.SemanticType.INTEGRAL) return false;
  const [, integrand, intvar] = node.childNodes;
  return intvar.type === semantic_meaning_js_1$i.SemanticType.EMPTY && integrand.type === semantic_meaning_js_1$i.SemanticType.FRACTION;
}));
function integralFractionArg(node) {
  const integrand = node.childNodes[1];
  const enumerator = integrand.childNodes[0];
  if (SemanticPred$1.isIntegralDxBoundarySingle(enumerator)) {
    enumerator.role = semantic_meaning_js_1$i.SemanticRole.INTEGRAL;
    return;
  }
  if (!SemanticPred$1.isImplicit(enumerator)) return;
  const length = enumerator.childNodes.length;
  const first = enumerator.childNodes[length - 2];
  const second = enumerator.childNodes[length - 1];
  if (SemanticPred$1.isIntegralDxBoundarySingle(second)) {
    second.role = semantic_meaning_js_1$i.SemanticRole.INTEGRAL;
    return;
  }
  if (SemanticPred$1.isIntegralDxBoundary(first, second)) {
    const prefix = semantic_processor_js_1.SemanticProcessor.getInstance()['prefixNode_'](second, [first]);
    prefix.role = semantic_meaning_js_1$i.SemanticRole.INTEGRAL;
    if (length === 2) {
      integrand.childNodes[0] = prefix;
    } else {
      enumerator.childNodes.pop();
      enumerator.contentNodes.pop();
      enumerator.childNodes[length - 2] = prefix;
      prefix.parent = enumerator;
    }
  }
}
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticTreeHeuristic('rewrite_subcases', rewriteSubcasesTable, table => {
  let left = true;
  let right = true;
  const topLeft = table.childNodes[0].childNodes[0];
  if (!eligibleNode(topLeft.mathmlTree)) {
    left = false;
  } else {
    for (let i = 1, row; row = table.childNodes[i]; i++) {
      if (row.childNodes[0].childNodes.length) {
        left = false;
        break;
      }
    }
  }
  if (left) {
    table.addAnnotation('Emph', 'left');
  }
  const topRight = table.childNodes[0].childNodes[table.childNodes[0].childNodes.length - 1];
  if (!eligibleNode(topRight.mathmlTree)) {
    right = false;
  } else {
    const firstRow = table.childNodes[0].childNodes.length;
    for (let i = 1, row; row = table.childNodes[i]; i++) {
      if (row.childNodes.length >= firstRow) {
        right = false;
        break;
      }
    }
  }
  if (right) {
    table.addAnnotation('Emph', 'right');
  }
  return left || right;
}));
function eligibleNode(node) {
  return node.childNodes[0] && node.childNodes[0].childNodes[0] && DomUtil$l.tagName(node.childNodes[0]) === semantic_util_js_1$8.MMLTAGS.MPADDED && DomUtil$l.tagName(node.childNodes[0].childNodes[0]) === semantic_util_js_1$8.MMLTAGS.MPADDED && DomUtil$l.tagName(node.childNodes[0].childNodes[node.childNodes[0].childNodes.length - 1]) === semantic_util_js_1$8.MMLTAGS.MPHANTOM;
}
const rewritable = [semantic_meaning_js_1$i.SemanticType.PUNCTUATED, semantic_meaning_js_1$i.SemanticType.RELSEQ, semantic_meaning_js_1$i.SemanticType.MULTIREL, semantic_meaning_js_1$i.SemanticType.INFIXOP, semantic_meaning_js_1$i.SemanticType.PREFIXOP, semantic_meaning_js_1$i.SemanticType.POSTFIXOP];
function rewriteSubcasesTable(table) {
  table.addAnnotation('Emph', 'top');
  let row = [];
  if (table.hasAnnotation('Emph', 'left')) {
    const topLeft = table.childNodes[0].childNodes[0].childNodes[0];
    const cells = rewriteCell(topLeft, true);
    cells.forEach(x => x.addAnnotation('Emph', 'left'));
    row = row.concat(cells);
    for (let i = 0, line; line = table.childNodes[i]; i++) {
      line.childNodes.shift();
    }
  }
  row.push(table);
  if (table.hasAnnotation('Emph', 'right')) {
    const topRight = table.childNodes[0].childNodes[table.childNodes[0].childNodes.length - 1].childNodes[0];
    const cells = rewriteCell(topRight);
    cells.forEach(x => x.addAnnotation('Emph', 'left'));
    row = row.concat(cells);
    table.childNodes[0].childNodes.pop();
  }
  semantic_processor_js_1.SemanticProcessor.tableToMultiline(table);
  const newNode = semantic_processor_js_1.SemanticProcessor.getInstance().row(row);
  const annotation = table.annotation['Emph'];
  table.annotation['Emph'] = ['table'];
  annotation.forEach(x => newNode.addAnnotation('Emph', x));
  return newNode;
}
function rewriteCell(cell, left) {
  if (!cell.childNodes.length) {
    rewriteFence(cell);
    return [cell];
  }
  let fence = null;
  if (cell.type === semantic_meaning_js_1$i.SemanticType.PUNCTUATED && (left ? cell.role === semantic_meaning_js_1$i.SemanticRole.ENDPUNCT : cell.role === semantic_meaning_js_1$i.SemanticRole.STARTPUNCT)) {
    const children = cell.childNodes;
    if (rewriteFence(children[left ? children.length - 1 : 0])) {
      cell = children[left ? 0 : children.length - 1];
      fence = children[left ? children.length - 1 : 0];
    }
  }
  if (rewritable.indexOf(cell.type) !== -1) {
    const children = cell.childNodes;
    rewriteFence(children[left ? children.length - 1 : 0]);
    const newNodes = semantic_skeleton_js_1$5.SemanticSkeleton.combineContentChildren(cell.type, cell.role, cell.contentNodes, cell.childNodes);
    if (fence) {
      if (left) {
        newNodes.push(fence);
      } else {
        newNodes.unshift(fence);
      }
    }
    return newNodes;
  }
  return fence ? left ? [cell, fence] : [fence, cell] : [cell];
}
const PUNCT_TO_FENCE_ = {
  [semantic_meaning_js_1$i.SemanticRole.METRIC]: semantic_meaning_js_1$i.SemanticRole.METRIC,
  [semantic_meaning_js_1$i.SemanticRole.VBAR]: semantic_meaning_js_1$i.SemanticRole.NEUTRAL,
  [semantic_meaning_js_1$i.SemanticRole.OPENFENCE]: semantic_meaning_js_1$i.SemanticRole.OPEN,
  [semantic_meaning_js_1$i.SemanticRole.CLOSEFENCE]: semantic_meaning_js_1$i.SemanticRole.CLOSE
};
function rewriteFence(fence) {
  if (fence.type !== semantic_meaning_js_1$i.SemanticType.PUNCTUATION) {
    return false;
  }
  const role = PUNCT_TO_FENCE_[fence.role];
  if (!role) {
    return false;
  }
  fence.role = role;
  fence.type = semantic_meaning_js_1$i.SemanticType.FENCE;
  fence.addAnnotation('Emph', 'fence');
  return true;
}
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticMultiHeuristic('ellipses', nodes => {
  const newNodes = [];
  let current = nodes.shift();
  while (current) {
    [current, nodes] = combineNodes(current, nodes, semantic_meaning_js_1$i.SemanticRole.FULLSTOP, semantic_meaning_js_1$i.SemanticRole.ELLIPSIS);
    [current, nodes] = combineNodes(current, nodes, semantic_meaning_js_1$i.SemanticRole.DASH);
    newNodes.push(current);
    current = nodes.shift();
  }
  return newNodes;
}, nodes => nodes.length > 1));
function combineNodes(current, nodes, src, target = src) {
  const collect = [];
  while (current && current.role === src) {
    collect.push(current);
    current = nodes.shift();
  }
  if (!collect.length) {
    return [current, nodes];
  }
  if (current) {
    nodes.unshift(current);
  }
  return [collect.length === 1 ? collect[0] : combinedNodes(collect, target), nodes];
}
function combinedNodes(nodes, role) {
  const node = semantic_heuristic_factory_js_1$1.SemanticHeuristics.factory.makeBranchNode(semantic_meaning_js_1$i.SemanticType.PUNCTUATION, nodes, []);
  node.role = role;
  return node;
}
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticMultiHeuristic('op_with_limits', nodes => {
  const center = nodes[0];
  center.type = semantic_meaning_js_1$i.SemanticType.LARGEOP;
  center.role = semantic_meaning_js_1$i.SemanticRole.SUM;
  return nodes;
}, nodes => {
  return nodes[0].type === semantic_meaning_js_1$i.SemanticType.OPERATOR && nodes.slice(1).some(node => node.type === semantic_meaning_js_1$i.SemanticType.RELSEQ || node.type === semantic_meaning_js_1$i.SemanticType.MULTIREL || node.type === semantic_meaning_js_1$i.SemanticType.INFIXOP && node.role === semantic_meaning_js_1$i.SemanticRole.ELEMENT || node.type === semantic_meaning_js_1$i.SemanticType.PUNCTUATED && node.role === semantic_meaning_js_1$i.SemanticRole.SEQUENCE);
}));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticMultiHeuristic('bracketed_interval', nodes => {
  const leftFence = nodes[0];
  const rightFence = nodes[1];
  const content = nodes.slice(2);
  const childNode = semantic_processor_js_1.SemanticProcessor.getInstance().row(content);
  const fenced = semantic_heuristic_factory_js_1$1.SemanticHeuristics.factory.makeBranchNode(semantic_meaning_js_1$i.SemanticType.FENCED, [childNode], [leftFence, rightFence]);
  fenced.role = semantic_meaning_js_1$i.SemanticRole.LEFTRIGHT;
  return fenced;
}, nodes => {
  const leftFence = nodes[0];
  const rightFence = nodes[1];
  const content = nodes.slice(2);
  if (!(leftFence && (leftFence.textContent === ']' || leftFence.textContent === '[') && rightFence && (rightFence.textContent === ']' || rightFence.textContent === '['))) {
    return false;
  }
  const partition = SemanticUtil$1.partitionNodes(content, SemanticPred$1.isPunctuation);
  return !!(partition.rel.length === 1 && partition.comp[0].length && partition.comp[1].length);
}));
semantic_heuristic_factory_js_1$1.SemanticHeuristics.add(new semantic_heuristic_js_1.SemanticMmlHeuristic('function_from_identifiers', node => {
  const expr = DomUtil$l.toArray(node.childNodes).map(x => x.textContent.trim()).join('');
  const meaning = semantic_attr_js_1$2.SemanticMap.Meaning.get(expr);
  if (meaning.type === semantic_meaning_js_1$i.SemanticType.UNKNOWN) {
    return node;
  }
  const snode = semantic_heuristic_factory_js_1$1.SemanticHeuristics.factory.makeLeafNode(expr, semantic_processor_js_1.SemanticProcessor.getInstance().font(node.getAttribute('mathvariant')));
  snode.mathmlTree = node;
  return snode;
}, node => {
  const children = DomUtil$l.toArray(node.childNodes);
  if (children.length < 2) {
    return false;
  }
  return children.every(child => DomUtil$l.tagName(child) === semantic_util_js_1$8.MMLTAGS.MI && semantic_attr_js_1$2.SemanticMap.Meaning.get(child.textContent.trim()).role === semantic_meaning_js_1$i.SemanticRole.LATINLETTER);
}));

Object.defineProperty(semantic_tree, "__esModule", {
  value: true
});
semantic_tree.SemanticTree = void 0;
const DomUtil$k = dom_util;
const semantic_annotations_js_1 = semantic_annotations;
const semantic_annotator_js_1 = semantic_annotator;
const semantic_meaning_js_1$h = semantic_meaning;
const semantic_mathml_js_1 = semantic_mathml;
const semantic_node_js_1$1 = semantic_node;
const SemanticPred = semantic_pred;
class SemanticTree {
  static empty() {
    const empty = DomUtil$k.parseInput('<math/>');
    const stree = new SemanticTree(empty);
    stree.mathml = empty;
    return stree;
  }
  static fromNode(semantic, opt_mathml) {
    const stree = SemanticTree.empty();
    stree.root = semantic;
    if (opt_mathml) {
      stree.mathml = opt_mathml;
    }
    return stree;
  }
  static fromRoot(semantic, opt_mathml) {
    let root = semantic;
    while (root.parent) {
      root = root.parent;
    }
    const stree = SemanticTree.fromNode(root);
    if (opt_mathml) {
      stree.mathml = opt_mathml;
    }
    return stree;
  }
  static fromXml(xml) {
    const stree = SemanticTree.empty();
    if (xml.childNodes[0]) {
      stree.root = semantic_node_js_1$1.SemanticNode.fromXml(xml.childNodes[0]);
    }
    return stree;
  }
  constructor(mathml) {
    this.mathml = mathml;
    this.parser = new semantic_mathml_js_1.SemanticMathml();
    this.root = this.parser.parse(mathml);
    this.collator = this.parser.getFactory().leafMap.collateMeaning();
    const newDefault = this.collator.newDefault();
    if (newDefault) {
      this.parser = new semantic_mathml_js_1.SemanticMathml();
      this.parser.getFactory().defaultMap = newDefault;
      this.root = this.parser.parse(mathml);
    }
    unitVisitor.visit(this.root, {});
    (0, semantic_annotations_js_1.annotate)(this.root);
  }
  xml(opt_brief) {
    const xml = DomUtil$k.parseInput('<stree></stree>');
    const xmlRoot = this.root.xml(xml.ownerDocument, opt_brief);
    xml.appendChild(xmlRoot);
    return xml;
  }
  toString(opt_brief) {
    return DomUtil$k.serializeXml(this.xml(opt_brief));
  }
  formatXml(opt_brief) {
    const xml = this.toString(opt_brief);
    return DomUtil$k.formatXml(xml);
  }
  displayTree() {
    this.root.displayTree();
  }
  replaceNode(oldNode, newNode) {
    const parent = oldNode.parent;
    if (!parent) {
      this.root = newNode;
      return;
    }
    parent.replaceChild(oldNode, newNode);
  }
  toJson() {
    const json = {};
    json['stree'] = this.root.toJson();
    return json;
  }
}
semantic_tree.SemanticTree = SemanticTree;
const unitVisitor = new semantic_annotator_js_1.SemanticVisitor('general', 'unit', (node, _info) => {
  if (SemanticPred.isUnitProduct(node)) {
    node.role = semantic_meaning_js_1$h.SemanticRole.UNIT;
  }
  return false;
});

Object.defineProperty(semantic, "__esModule", {
  value: true
});
semantic.xmlTree = xmlTree;
semantic.getTree = getTree;
semantic.getTreeFromString = getTreeFromString;
const DomUtil$j = dom_util;
const semantic_tree_js_1$2 = semantic_tree;
function xmlTree(mml) {
  return getTree(mml).xml();
}
function getTree(mml) {
  return new semantic_tree_js_1$2.SemanticTree(mml);
}
function getTreeFromString(expr) {
  const mml = DomUtil$j.parseInput(expr);
  return getTree(mml);
}

var enrich_mathml = {};

var enrich_case = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.factory = void 0;
  exports.getCase = getCase;
  function getCase(node) {
    for (let i = 0, enrich; enrich = exports.factory[i]; i++) {
      if (enrich.test(node)) {
        return enrich.constr(node);
      }
    }
    return null;
  }
  exports.factory = [];
})(enrich_case);
getDefaultExportFromCjs(enrich_case);

Object.defineProperty(enrich_mathml, "__esModule", {
  value: true
});
enrich_mathml.enrich = enrich;
enrich_mathml.walkTree = walkTree;
enrich_mathml.introduceNewLayer = introduceNewLayer;
enrich_mathml.ascendNewNode = ascendNewNode;
enrich_mathml.addCollapsedAttribute = addCollapsedAttribute;
enrich_mathml.cloneContentNode = cloneContentNode;
enrich_mathml.rewriteMfenced = rewriteMfenced;
enrich_mathml.setOperatorAttribute = setOperatorAttribute;
enrich_mathml.getInnerNode = getInnerNode;
enrich_mathml.collapsePunctuated = collapsePunctuated;
const debugger_js_1$1 = _debugger;
const DomUtil$i = dom_util;
const engine_js_1$3 = engine;
const semantic_attr_js_1$1 = semantic_attr;
const semantic_meaning_js_1$g = semantic_meaning;
const semantic_heuristic_factory_js_1 = semantic_heuristic_factory;
const semantic_skeleton_js_1$4 = semantic_skeleton;
const SemanticUtil = semantic_util;
const semantic_util_js_1$7 = semantic_util;
const EnrichAttr$1 = enrich_attr;
const enrich_case_js_1$1 = enrich_case;
const SETTINGS = {
  collapsed: true,
  implicit: true,
  wiki: true
};
const IDS = new Map();
function enrich(mml, semantic) {
  IDS.clear();
  const oldMml = DomUtil$i.cloneNode(mml);
  walkTree(semantic.root);
  if (engine_js_1$3.Engine.getInstance().structure) {
    mml.setAttribute(EnrichAttr$1.Attribute.STRUCTURE, semantic_skeleton_js_1$4.SemanticSkeleton.fromStructure(mml, semantic).toString());
  }
  debugger_js_1$1.Debugger.getInstance().generateOutput(() => [formattedOutput(oldMml, 'Original MathML', SETTINGS.wiki), formattedOutput(semantic, 'Semantic Tree', SETTINGS.wiki), formattedOutput(mml, 'Semantically enriched MathML', SETTINGS.wiki)]);
  return mml;
}
function walkTree(semantic) {
  debugger_js_1$1.Debugger.getInstance().output('WALKING START: ' + semantic.toString());
  const specialCase = (0, enrich_case_js_1$1.getCase)(semantic);
  let newNode;
  if (specialCase) {
    newNode = specialCase.getMathml();
    debugger_js_1$1.Debugger.getInstance().output('WALKING END: ' + semantic.toString());
    return ascendNewNode(newNode);
  }
  if (semantic.mathml.length === 1) {
    debugger_js_1$1.Debugger.getInstance().output('Walktree Case 0');
    if (!semantic.childNodes.length) {
      debugger_js_1$1.Debugger.getInstance().output('Walktree Case 0.1');
      newNode = semantic.mathml[0];
      EnrichAttr$1.setAttributes(newNode, semantic);
      debugger_js_1$1.Debugger.getInstance().output('WALKING END: ' + semantic.toString());
      return ascendNewNode(newNode);
    }
    const fchild = semantic.childNodes[0];
    if (semantic.childNodes.length === 1 && fchild.type === semantic_meaning_js_1$g.SemanticType.EMPTY) {
      debugger_js_1$1.Debugger.getInstance().output('Walktree Case 0.2');
      newNode = semantic.mathml[0];
      EnrichAttr$1.setAttributes(newNode, semantic);
      newNode.appendChild(walkTree(fchild));
      debugger_js_1$1.Debugger.getInstance().output('WALKING END: ' + semantic.toString());
      return ascendNewNode(newNode);
    }
    semantic.childNodes.forEach(child => {
      if (!child.mathml.length) {
        child.mathml = [createInvisibleOperator(child)];
      }
    });
  }
  const newContent = semantic.contentNodes.map(cloneContentNode);
  setOperatorAttribute(semantic, newContent);
  const newChildren = semantic.childNodes.map(walkTree);
  const childrenList = semantic_skeleton_js_1$4.SemanticSkeleton.combineContentChildren(semantic.type, semantic.role, newContent, newChildren);
  newNode = semantic.mathmlTree;
  if (newNode === null) {
    debugger_js_1$1.Debugger.getInstance().output('Walktree Case 1');
    newNode = introduceNewLayer(childrenList, semantic);
  } else {
    const attached = attachedElement(childrenList);
    debugger_js_1$1.Debugger.getInstance().output('Walktree Case 2');
    if (attached) {
      debugger_js_1$1.Debugger.getInstance().output('Walktree Case 2.1');
      newNode = parentNode(attached);
    } else {
      debugger_js_1$1.Debugger.getInstance().output('Walktree Case 2.2');
      newNode = getInnerNode(newNode);
    }
  }
  newNode = rewriteMfenced(newNode);
  mergeChildren(newNode, childrenList, semantic);
  if (!IDS.has(semantic.id)) {
    IDS.set(semantic.id, true);
    EnrichAttr$1.setAttributes(newNode, semantic);
  }
  debugger_js_1$1.Debugger.getInstance().output('WALKING END: ' + semantic.toString());
  return ascendNewNode(newNode);
}
function introduceNewLayer(children, semantic) {
  const lca = mathmlLca(children);
  let newNode = lca.node;
  const info = lca.type;
  if (info !== lcaType.VALID || !SemanticUtil.hasEmptyTag(newNode) || !newNode.parentNode && semantic.parent) {
    debugger_js_1$1.Debugger.getInstance().output('Walktree Case 1.1');
    newNode = EnrichAttr$1.addMrow();
    if (info === lcaType.PRUNED) {
      debugger_js_1$1.Debugger.getInstance().output('Walktree Case 1.1.0');
      newNode = introduceLayerAboveLca(newNode, lca.node, children);
    } else if (children[0]) {
      debugger_js_1$1.Debugger.getInstance().output('Walktree Case 1.1.1');
      const node = attachedElement(children);
      if (node) {
        const oldChildren = childrenSubset(parentNode(node), children);
        DomUtil$i.replaceNode(node, newNode);
        oldChildren.forEach(function (x) {
          newNode.appendChild(x);
        });
      } else {
        moveSemanticAttributes(newNode, children[0]);
        newNode = children[0];
      }
    }
  }
  if (!semantic.mathmlTree) {
    semantic.mathmlTree = newNode;
  }
  return newNode;
}
function introduceLayerAboveLca(mrow, lca, children) {
  let innerNode = descendNode(lca);
  if (SemanticUtil.hasMathTag(innerNode)) {
    debugger_js_1$1.Debugger.getInstance().output('Walktree Case 1.1.0.0');
    moveSemanticAttributes(innerNode, mrow);
    DomUtil$i.toArray(innerNode.childNodes).forEach(function (x) {
      mrow.appendChild(x);
    });
    const auxNode = mrow;
    mrow = innerNode;
    innerNode = auxNode;
  }
  const index = children.indexOf(lca);
  children[index] = innerNode;
  DomUtil$i.replaceNode(innerNode, mrow);
  mrow.appendChild(innerNode);
  children.forEach(function (x) {
    mrow.appendChild(x);
  });
  return mrow;
}
function moveSemanticAttributes(oldNode, newNode) {
  for (const attr of EnrichAttr$1.EnrichAttributes) {
    if (oldNode.hasAttribute(attr)) {
      newNode.setAttribute(attr, oldNode.getAttribute(attr));
      oldNode.removeAttribute(attr);
    }
  }
}
function childrenSubset(node, newChildren) {
  const oldChildren = DomUtil$i.toArray(node.childNodes);
  let leftIndex = +Infinity;
  let rightIndex = -Infinity;
  newChildren.forEach(function (child) {
    const index = oldChildren.indexOf(child);
    if (index !== -1) {
      leftIndex = Math.min(leftIndex, index);
      rightIndex = Math.max(rightIndex, index);
    }
  });
  return oldChildren.slice(leftIndex, rightIndex + 1);
}
function collateChildNodes(node, children, semantic) {
  const oldChildren = [];
  let newChildren = DomUtil$i.toArray(node.childNodes);
  let notFirst = false;
  while (newChildren.length) {
    const child = newChildren.shift();
    if (child.hasAttribute(EnrichAttr$1.Attribute.TYPE)) {
      oldChildren.push(child);
      continue;
    }
    const collect = collectChildNodes(child, children);
    if (collect.length === 0) {
      continue;
    }
    if (collect.length === 1) {
      oldChildren.push(child);
      continue;
    }
    if (notFirst) {
      child.setAttribute('AuxiliaryImplicit', true);
    } else {
      notFirst = true;
    }
    newChildren = collect.concat(newChildren);
  }
  const rear = [];
  const semChildren = semantic.childNodes.map(function (x) {
    return x.mathmlTree;
  });
  while (semChildren.length) {
    const schild = semChildren.pop();
    if (!schild) {
      continue;
    }
    if (oldChildren.indexOf(schild) !== -1) {
      break;
    }
    if (children.indexOf(schild) !== -1) {
      rear.unshift(schild);
    }
  }
  return oldChildren.concat(rear);
}
function collectChildNodes(node, children) {
  const collect = [];
  let newChildren = DomUtil$i.toArray(node.childNodes);
  while (newChildren.length) {
    const child = newChildren.shift();
    if (child.nodeType !== DomUtil$i.NodeType.ELEMENT_NODE) {
      continue;
    }
    if (child.hasAttribute(EnrichAttr$1.Attribute.TYPE) || children.indexOf(child) !== -1) {
      collect.push(child);
      continue;
    }
    newChildren = DomUtil$i.toArray(child.childNodes).concat(newChildren);
  }
  return collect;
}
function mergeChildren(node, newChildren, semantic) {
  if (!newChildren.length) return;
  if (newChildren.length === 1 && node === newChildren[0]) return;
  const oldChildren = semantic.role === semantic_meaning_js_1$g.SemanticRole.IMPLICIT && semantic_heuristic_factory_js_1.SemanticHeuristics.flags.combine_juxtaposition ? collateChildNodes(node, newChildren, semantic) : DomUtil$i.toArray(node.childNodes);
  if (!oldChildren.length) {
    newChildren.forEach(function (x) {
      node.appendChild(x);
    });
    return;
  }
  let oldCounter = 0;
  while (newChildren.length) {
    const newChild = newChildren[0];
    if (oldChildren[oldCounter] === newChild || functionApplication(oldChildren[oldCounter], newChild)) {
      newChildren.shift();
      oldCounter++;
      continue;
    }
    if (oldChildren[oldCounter] && newChildren.indexOf(oldChildren[oldCounter]) === -1) {
      oldCounter++;
      continue;
    }
    if (isDescendant(newChild, node)) {
      newChildren.shift();
      continue;
    }
    const oldChild = oldChildren[oldCounter];
    if (!oldChild) {
      if (newChild.parentNode) {
        node = parentNode(newChild);
        newChildren.shift();
        continue;
      }
      const nextChild = newChildren[1];
      if (nextChild && nextChild.parentNode) {
        node = parentNode(nextChild);
        node.insertBefore(newChild, nextChild);
        newChildren.shift();
        newChildren.shift();
        continue;
      }
      node.insertBefore(newChild, null);
      newChildren.shift();
      continue;
    }
    insertNewChild(node, oldChild, newChild);
    newChildren.shift();
  }
}
function insertNewChild(node, oldChild, newChild) {
  let parent = oldChild;
  let next = parentNode(parent);
  while (next && next.firstChild === parent && !parent.hasAttribute('AuxiliaryImplicit') && next !== node) {
    parent = next;
    next = parentNode(parent);
  }
  if (next) {
    next.insertBefore(newChild, parent);
    parent.removeAttribute('AuxiliaryImplicit');
  }
}
function isDescendant(child, node) {
  if (!child) {
    return false;
  }
  do {
    child = parentNode(child);
    if (child === node) {
      return true;
    }
  } while (child);
  return false;
}
function functionApplication(oldNode, newNode) {
  const appl = semantic_attr_js_1$1.NamedSymbol.functionApplication;
  if (oldNode && newNode && oldNode.textContent && newNode.textContent && oldNode.textContent === appl && newNode.textContent === appl && newNode.getAttribute(EnrichAttr$1.Attribute.ADDED) === 'true') {
    for (let i = 0, attr; attr = oldNode.attributes[i]; i++) {
      if (!newNode.hasAttribute(attr.nodeName)) {
        newNode.setAttribute(attr.nodeName, attr.nodeValue);
      }
    }
    DomUtil$i.replaceNode(oldNode, newNode);
    return true;
  }
  return false;
}
var lcaType;
(function (lcaType) {
  lcaType["VALID"] = "valid";
  lcaType["INVALID"] = "invalid";
  lcaType["PRUNED"] = "pruned";
})(lcaType || (lcaType = {}));
function mathmlLca(children) {
  const leftMost = attachedElement(children);
  if (!leftMost) {
    return {
      type: lcaType.INVALID,
      node: null
    };
  }
  const rightMost = attachedElement(children.slice().reverse());
  if (leftMost === rightMost) {
    return {
      type: lcaType.VALID,
      node: leftMost
    };
  }
  const leftPath = pathToRoot(leftMost);
  const newLeftPath = prunePath(leftPath, children);
  const rightPath = pathToRoot(rightMost, function (x) {
    return newLeftPath.indexOf(x) !== -1;
  });
  const lca = rightPath[0];
  const lIndex = newLeftPath.indexOf(lca);
  if (lIndex === -1) {
    return {
      type: lcaType.INVALID,
      node: null
    };
  }
  return {
    type: newLeftPath.length !== leftPath.length ? lcaType.PRUNED : validLca(newLeftPath[lIndex + 1], rightPath[1]) ? lcaType.VALID : lcaType.INVALID,
    node: lca
  };
}
function prunePath(path, children) {
  let i = 0;
  while (path[i] && children.indexOf(path[i]) === -1) {
    i++;
  }
  return path.slice(0, i + 1);
}
function attachedElement(nodes) {
  let count = 0;
  let attached = null;
  while (!attached && count < nodes.length) {
    if (nodes[count].parentNode) {
      attached = nodes[count];
    }
    count++;
  }
  return attached;
}
function pathToRoot(node, opt_test) {
  const test = opt_test || (_x => false);
  const path = [node];
  while (!test(node) && !SemanticUtil.hasMathTag(node) && node.parentNode) {
    node = parentNode(node);
    path.unshift(node);
  }
  return path;
}
function validLca(left, right) {
  return !!(left && right && !left.previousSibling && !right.nextSibling);
}
function ascendNewNode(newNode) {
  while (!SemanticUtil.hasMathTag(newNode) && unitChild(newNode)) {
    newNode = parentNode(newNode);
  }
  return newNode;
}
function descendNode(node) {
  const children = DomUtil$i.toArray(node.childNodes);
  if (!children) {
    return node;
  }
  const remainder = children.filter(function (child) {
    return child.nodeType === DomUtil$i.NodeType.ELEMENT_NODE && !SemanticUtil.hasIgnoreTag(child);
  });
  if (remainder.length === 1 && SemanticUtil.hasEmptyTag(remainder[0]) && !remainder[0].hasAttribute(EnrichAttr$1.Attribute.TYPE)) {
    return descendNode(remainder[0]);
  }
  return node;
}
function unitChild(node) {
  const parent = parentNode(node);
  if (!parent || !SemanticUtil.hasEmptyTag(parent)) {
    return false;
  }
  return DomUtil$i.toArray(parent.childNodes).every(function (child) {
    return child === node || isIgnorable(child);
  });
}
function isIgnorable(node) {
  if (node.nodeType !== DomUtil$i.NodeType.ELEMENT_NODE) {
    return true;
  }
  if (!node || SemanticUtil.hasIgnoreTag(node)) {
    return true;
  }
  const children = DomUtil$i.toArray(node.childNodes);
  if (!SemanticUtil.hasEmptyTag(node) && children.length || SemanticUtil.hasDisplayTag(node) || node.hasAttribute(EnrichAttr$1.Attribute.TYPE) || SemanticUtil.isOrphanedGlyph(node)) {
    return false;
  }
  return DomUtil$i.toArray(node.childNodes).every(isIgnorable);
}
function parentNode(element) {
  return element.parentNode;
}
function addCollapsedAttribute(node, collapsed) {
  const skeleton = new semantic_skeleton_js_1$4.SemanticSkeleton(collapsed);
  node.setAttribute(EnrichAttr$1.Attribute.COLLAPSED, skeleton.toString());
}
function cloneContentNode(content) {
  if (content.mathml.length) {
    return walkTree(content);
  }
  const clone = SETTINGS.implicit ? createInvisibleOperator(content) : EnrichAttr$1.addMrow();
  content.mathml = [clone];
  return clone;
}
function rewriteMfenced(mml) {
  if (DomUtil$i.tagName(mml) !== semantic_util_js_1$7.MMLTAGS.MFENCED) {
    return mml;
  }
  const newNode = EnrichAttr$1.addMrow();
  for (let i = 0, attr; attr = mml.attributes[i]; i++) {
    if (['open', 'close', 'separators'].indexOf(attr.name) === -1) {
      newNode.setAttribute(attr.name, attr.value);
    }
  }
  DomUtil$i.toArray(mml.childNodes).forEach(function (x) {
    newNode.appendChild(x);
  });
  DomUtil$i.replaceNode(mml, newNode);
  return newNode;
}
function createInvisibleOperator(operator) {
  const moNode = DomUtil$i.createElement('mo');
  const text = DomUtil$i.createTextNode(operator.textContent);
  moNode.appendChild(text);
  EnrichAttr$1.setAttributes(moNode, operator);
  moNode.setAttribute(EnrichAttr$1.Attribute.ADDED, 'true');
  return moNode;
}
function setOperatorAttribute(semantic, content) {
  const operator = semantic.type + (semantic.textContent ? ',' + semantic.textContent : '');
  content.forEach(function (c) {
    getInnerNode(c).setAttribute(EnrichAttr$1.Attribute.OPERATOR, operator);
  });
}
function getInnerNode(node) {
  const children = DomUtil$i.toArray(node.childNodes);
  if (!children) {
    return node;
  }
  const remainder = children.filter(function (child) {
    return !isIgnorable(child);
  });
  const result = [];
  for (let i = 0, remain; remain = remainder[i]; i++) {
    if (SemanticUtil.hasEmptyTag(remain) && remain.getAttribute(EnrichAttr$1.Attribute.TYPE) !== semantic_meaning_js_1$g.SemanticType.PUNCTUATION) {
      const nextInner = getInnerNode(remain);
      if (nextInner && nextInner !== remain) {
        result.push(nextInner);
      }
    } else {
      result.push(remain);
    }
  }
  if (result.length === 1) {
    return result[0];
  }
  return node;
}
function formattedOutput(element, name, wiki = false) {
  const output = EnrichAttr$1.removeAttributePrefix(DomUtil$i.formatXml(element.toString()));
  return wiki ? name + ':\n```html\n' + output + '\n```\n' : output;
}
function collapsePunctuated(semantic, opt_children) {
  const optional = !!opt_children;
  const children = opt_children || [];
  const parent = semantic.parent;
  const contentIds = semantic.contentNodes.map(function (x) {
    return x.id;
  });
  contentIds.unshift('c');
  const childIds = [semantic.id, contentIds];
  for (let i = 0, child; child = semantic.childNodes[i]; i++) {
    const mmlChild = walkTree(child);
    children.push(mmlChild);
    const innerNode = getInnerNode(mmlChild);
    if (parent && !optional) {
      innerNode.setAttribute(EnrichAttr$1.Attribute.PARENT, parent.id.toString());
    }
    childIds.push(child.id);
  }
  return childIds;
}

var case_binomial = {};

var abstract_enrich_case = {};

Object.defineProperty(abstract_enrich_case, "__esModule", {
  value: true
});
abstract_enrich_case.AbstractEnrichCase = void 0;
class AbstractEnrichCase {
  constructor(semantic) {
    this.semantic = semantic;
  }
}
abstract_enrich_case.AbstractEnrichCase = AbstractEnrichCase;

Object.defineProperty(case_binomial, "__esModule", {
  value: true
});
case_binomial.CaseBinomial = void 0;
const DomUtil$h = dom_util;
const semantic_meaning_js_1$f = semantic_meaning;
const abstract_enrich_case_js_1$9 = abstract_enrich_case;
const enrich_mathml_js_1 = enrich_mathml;
const enrich_attr_js_1$j = enrich_attr;
class CaseBinomial extends abstract_enrich_case_js_1$9.AbstractEnrichCase {
  static test(semantic) {
    return !semantic.mathmlTree && semantic.type === semantic_meaning_js_1$f.SemanticType.LINE && semantic.role === semantic_meaning_js_1$f.SemanticRole.BINOMIAL;
  }
  constructor(semantic) {
    super(semantic);
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    if (!this.semantic.childNodes.length) {
      return this.mml;
    }
    const child = this.semantic.childNodes[0];
    this.mml = (0, enrich_mathml_js_1.walkTree)(child);
    if (this.mml.hasAttribute(enrich_attr_js_1$j.Attribute.TYPE)) {
      const mrow = (0, enrich_attr_js_1$j.addMrow)();
      DomUtil$h.replaceNode(this.mml, mrow);
      mrow.appendChild(this.mml);
      this.mml = mrow;
    }
    (0, enrich_attr_js_1$j.setAttributes)(this.mml, this.semantic);
    return this.mml;
  }
}
case_binomial.CaseBinomial = CaseBinomial;

var case_double_script = {};

Object.defineProperty(case_double_script, "__esModule", {
  value: true
});
case_double_script.CaseDoubleScript = void 0;
const DomUtil$g = dom_util;
const semantic_meaning_js_1$e = semantic_meaning;
const semantic_util_js_1$6 = semantic_util;
const abstract_enrich_case_js_1$8 = abstract_enrich_case;
const EnrichMathml$b = enrich_mathml;
const enrich_attr_js_1$i = enrich_attr;
class CaseDoubleScript extends abstract_enrich_case_js_1$8.AbstractEnrichCase {
  static test(semantic) {
    if (!semantic.mathmlTree || !semantic.childNodes.length) {
      return false;
    }
    const mmlTag = DomUtil$g.tagName(semantic.mathmlTree);
    const role = semantic.childNodes[0].role;
    return mmlTag === semantic_util_js_1$6.MMLTAGS.MSUBSUP && role === semantic_meaning_js_1$e.SemanticRole.SUBSUP || mmlTag === semantic_util_js_1$6.MMLTAGS.MUNDEROVER && role === semantic_meaning_js_1$e.SemanticRole.UNDEROVER;
  }
  constructor(semantic) {
    super(semantic);
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    const ignore = this.semantic.childNodes[0];
    const baseSem = ignore.childNodes[0];
    const supSem = this.semantic.childNodes[1];
    const subSem = ignore.childNodes[1];
    const supMml = EnrichMathml$b.walkTree(supSem);
    const baseMml = EnrichMathml$b.walkTree(baseSem);
    const subMml = EnrichMathml$b.walkTree(subSem);
    (0, enrich_attr_js_1$i.setAttributes)(this.mml, this.semantic);
    this.mml.setAttribute(enrich_attr_js_1$i.Attribute.CHILDREN, (0, enrich_attr_js_1$i.makeIdList)([baseSem, subSem, supSem]));
    [baseMml, subMml, supMml].forEach(child => EnrichMathml$b.getInnerNode(child).setAttribute(enrich_attr_js_1$i.Attribute.PARENT, this.mml.getAttribute(enrich_attr_js_1$i.Attribute.ID)));
    this.mml.setAttribute(enrich_attr_js_1$i.Attribute.TYPE, ignore.role);
    EnrichMathml$b.addCollapsedAttribute(this.mml, [this.semantic.id, [ignore.id, baseSem.id, subSem.id], supSem.id]);
    return this.mml;
  }
}
case_double_script.CaseDoubleScript = CaseDoubleScript;

var case_embellished = {};

var case_multiscripts = {};

var case_multiindex = {};

Object.defineProperty(case_multiindex, "__esModule", {
  value: true
});
case_multiindex.CaseMultiindex = void 0;
const DomUtil$f = dom_util;
const semantic_meaning_js_1$d = semantic_meaning;
const semantic_util_js_1$5 = semantic_util;
const abstract_enrich_case_js_1$7 = abstract_enrich_case;
const EnrichMathml$a = enrich_mathml;
const enrich_attr_js_1$h = enrich_attr;
class CaseMultiindex extends abstract_enrich_case_js_1$7.AbstractEnrichCase {
  static multiscriptIndex(index) {
    if (index.type === semantic_meaning_js_1$d.SemanticType.PUNCTUATED && index.contentNodes[0].role === semantic_meaning_js_1$d.SemanticRole.DUMMY) {
      return EnrichMathml$a.collapsePunctuated(index);
    }
    EnrichMathml$a.walkTree(index);
    return index.id;
  }
  static createNone_(semantic) {
    const newNode = DomUtil$f.createElement('none');
    if (semantic) {
      (0, enrich_attr_js_1$h.setAttributes)(newNode, semantic);
    }
    newNode.setAttribute(enrich_attr_js_1$h.Attribute.ADDED, 'true');
    return newNode;
  }
  constructor(semantic) {
    super(semantic);
    this.mml = semantic.mathmlTree;
  }
  completeMultiscript(rightIndices, leftIndices) {
    const children = DomUtil$f.toArray(this.mml.childNodes).slice(1);
    let childCounter = 0;
    const completeIndices = indices => {
      for (const index of indices) {
        const child = children[childCounter];
        if (child && index === parseInt(child.getAttribute(enrich_attr_js_1$h.Attribute.ID))) {
          child.setAttribute(enrich_attr_js_1$h.Attribute.PARENT, this.semantic.id.toString());
          childCounter++;
        } else if (!child || index !== parseInt(EnrichMathml$a.getInnerNode(child).getAttribute(enrich_attr_js_1$h.Attribute.ID))) {
          const query = this.semantic.querySelectorAll(x => x.id === index);
          this.mml.insertBefore(CaseMultiindex.createNone_(query[0]), child || null);
        } else {
          EnrichMathml$a.getInnerNode(child).setAttribute(enrich_attr_js_1$h.Attribute.PARENT, this.semantic.id.toString());
          childCounter++;
        }
      }
    };
    completeIndices(rightIndices);
    if (children[childCounter] && DomUtil$f.tagName(children[childCounter]) !== semantic_util_js_1$5.MMLTAGS.MPRESCRIPTS) {
      this.mml.insertBefore(children[childCounter], DomUtil$f.createElement('mprescripts'));
    } else {
      childCounter++;
    }
    completeIndices(leftIndices);
  }
}
case_multiindex.CaseMultiindex = CaseMultiindex;

Object.defineProperty(case_multiscripts, "__esModule", {
  value: true
});
case_multiscripts.CaseMultiscripts = void 0;
const DomUtil$e = dom_util;
const semantic_meaning_js_1$c = semantic_meaning;
const semantic_skeleton_js_1$3 = semantic_skeleton;
const semantic_util_js_1$4 = semantic_util;
const case_multiindex_js_1$1 = case_multiindex;
const EnrichMathml$9 = enrich_mathml;
const enrich_attr_js_1$g = enrich_attr;
class CaseMultiscripts extends case_multiindex_js_1$1.CaseMultiindex {
  static test(semantic) {
    if (!semantic.mathmlTree) {
      return false;
    }
    const mmlTag = DomUtil$e.tagName(semantic.mathmlTree);
    return mmlTag === semantic_util_js_1$4.MMLTAGS.MMULTISCRIPTS && (semantic.type === semantic_meaning_js_1$c.SemanticType.SUPERSCRIPT || semantic.type === semantic_meaning_js_1$c.SemanticType.SUBSCRIPT);
  }
  constructor(semantic) {
    super(semantic);
  }
  getMathml() {
    (0, enrich_attr_js_1$g.setAttributes)(this.mml, this.semantic);
    let baseSem, rsup, rsub;
    if (this.semantic.childNodes[0] && this.semantic.childNodes[0].role === semantic_meaning_js_1$c.SemanticRole.SUBSUP) {
      const ignore = this.semantic.childNodes[0];
      baseSem = ignore.childNodes[0];
      rsup = case_multiindex_js_1$1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]);
      rsub = case_multiindex_js_1$1.CaseMultiindex.multiscriptIndex(ignore.childNodes[1]);
      const collapsed = [this.semantic.id, [ignore.id, baseSem.id, rsub], rsup];
      EnrichMathml$9.addCollapsedAttribute(this.mml, collapsed);
      this.mml.setAttribute(enrich_attr_js_1$g.Attribute.TYPE, ignore.role);
      this.completeMultiscript(semantic_skeleton_js_1$3.SemanticSkeleton.interleaveIds(rsub, rsup), []);
    } else {
      baseSem = this.semantic.childNodes[0];
      rsup = case_multiindex_js_1$1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]);
      const collapsed = [this.semantic.id, baseSem.id, rsup];
      EnrichMathml$9.addCollapsedAttribute(this.mml, collapsed);
    }
    const childIds = semantic_skeleton_js_1$3.SemanticSkeleton.collapsedLeafs(rsub || [], rsup);
    const base = EnrichMathml$9.walkTree(baseSem);
    EnrichMathml$9.getInnerNode(base).setAttribute(enrich_attr_js_1$g.Attribute.PARENT, this.semantic.id.toString());
    childIds.unshift(baseSem.id);
    this.mml.setAttribute(enrich_attr_js_1$g.Attribute.CHILDREN, childIds.join(','));
    return this.mml;
  }
}
case_multiscripts.CaseMultiscripts = CaseMultiscripts;

var case_tensor = {};

Object.defineProperty(case_tensor, "__esModule", {
  value: true
});
case_tensor.CaseTensor = void 0;
const semantic_meaning_js_1$b = semantic_meaning;
const semantic_skeleton_js_1$2 = semantic_skeleton;
const case_multiindex_js_1 = case_multiindex;
const EnrichMathml$8 = enrich_mathml;
const enrich_attr_js_1$f = enrich_attr;
class CaseTensor extends case_multiindex_js_1.CaseMultiindex {
  static test(semantic) {
    return !!semantic.mathmlTree && semantic.type === semantic_meaning_js_1$b.SemanticType.TENSOR;
  }
  constructor(semantic) {
    super(semantic);
  }
  getMathml() {
    EnrichMathml$8.walkTree(this.semantic.childNodes[0]);
    const lsub = case_multiindex_js_1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]);
    const lsup = case_multiindex_js_1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[2]);
    const rsub = case_multiindex_js_1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[3]);
    const rsup = case_multiindex_js_1.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[4]);
    (0, enrich_attr_js_1$f.setAttributes)(this.mml, this.semantic);
    const collapsed = [this.semantic.id, this.semantic.childNodes[0].id, lsub, lsup, rsub, rsup];
    EnrichMathml$8.addCollapsedAttribute(this.mml, collapsed);
    const childIds = semantic_skeleton_js_1$2.SemanticSkeleton.collapsedLeafs(lsub, lsup, rsub, rsup);
    childIds.unshift(this.semantic.childNodes[0].id);
    this.mml.setAttribute(enrich_attr_js_1$f.Attribute.CHILDREN, childIds.join(','));
    this.completeMultiscript(semantic_skeleton_js_1$2.SemanticSkeleton.interleaveIds(rsub, rsup), semantic_skeleton_js_1$2.SemanticSkeleton.interleaveIds(lsub, lsup));
    return this.mml;
  }
}
case_tensor.CaseTensor = CaseTensor;

Object.defineProperty(case_embellished, "__esModule", {
  value: true
});
case_embellished.CaseEmbellished = void 0;
const DomUtil$d = dom_util;
const semantic_meaning_js_1$a = semantic_meaning;
const semantic_node_js_1 = semantic_node;
const semantic_util_js_1$3 = semantic_util;
const abstract_enrich_case_js_1$6 = abstract_enrich_case;
const case_double_script_js_1$1 = case_double_script;
const case_multiscripts_js_1$1 = case_multiscripts;
const case_tensor_js_1$1 = case_tensor;
const EnrichMathml$7 = enrich_mathml;
const enrich_attr_js_1$e = enrich_attr;
class CaseEmbellished extends abstract_enrich_case_js_1$6.AbstractEnrichCase {
  static test(semantic) {
    return !!(semantic.mathmlTree && semantic.fencePointer && !semantic.mathmlTree.getAttribute('data-semantic-type'));
  }
  static makeEmptyNode_(id) {
    const mrow = (0, enrich_attr_js_1$e.addMrow)();
    const empty = new semantic_node_js_1.SemanticNode(id);
    empty.type = semantic_meaning_js_1$a.SemanticType.EMPTY;
    empty.mathmlTree = mrow;
    return empty;
  }
  static fencedMap_(fence, ids) {
    ids[fence.id] = fence.mathmlTree;
    if (!fence.embellished) {
      return;
    }
    CaseEmbellished.fencedMap_(fence.childNodes[0], ids);
  }
  constructor(semantic) {
    super(semantic);
    this.fenced = null;
    this.fencedMml = null;
    this.fencedMmlNodes = [];
    this.ofence = null;
    this.ofenceMml = null;
    this.ofenceMap = {};
    this.cfence = null;
    this.cfenceMml = null;
    this.cfenceMap = {};
    this.parentCleanup = [];
  }
  getMathml() {
    this.getFenced_();
    this.fencedMml = EnrichMathml$7.walkTree(this.fenced);
    this.getFencesMml_();
    if (this.fenced.type === semantic_meaning_js_1$a.SemanticType.EMPTY && !this.fencedMml.parentNode) {
      this.fencedMml.setAttribute(enrich_attr_js_1$e.Attribute.ADDED, 'true');
      this.cfenceMml.parentNode.insertBefore(this.fencedMml, this.cfenceMml);
    }
    this.getFencedMml_();
    const rewrite = this.rewrite_();
    return rewrite;
  }
  fencedElement(node) {
    return node.type === semantic_meaning_js_1$a.SemanticType.FENCED || node.type === semantic_meaning_js_1$a.SemanticType.MATRIX || node.type === semantic_meaning_js_1$a.SemanticType.VECTOR;
  }
  getFenced_() {
    let currentNode = this.semantic;
    while (!this.fencedElement(currentNode)) {
      currentNode = currentNode.childNodes[0];
    }
    this.fenced = currentNode.childNodes[0];
    this.ofence = currentNode.contentNodes[0];
    this.cfence = currentNode.contentNodes[1];
    CaseEmbellished.fencedMap_(this.ofence, this.ofenceMap);
    CaseEmbellished.fencedMap_(this.cfence, this.cfenceMap);
  }
  getFencedMml_() {
    let sibling = this.ofenceMml.nextSibling;
    sibling = sibling === this.fencedMml ? sibling : this.fencedMml;
    while (sibling && sibling !== this.cfenceMml) {
      this.fencedMmlNodes.push(sibling);
      sibling = sibling.nextSibling;
    }
  }
  getFencesMml_() {
    let currentNode = this.semantic;
    const ofenceIds = Object.keys(this.ofenceMap);
    const cfenceIds = Object.keys(this.cfenceMap);
    while ((!this.ofenceMml || !this.cfenceMml) && currentNode !== this.fenced) {
      if (ofenceIds.indexOf(currentNode.fencePointer) !== -1 && !this.ofenceMml) {
        this.ofenceMml = currentNode.mathmlTree;
      }
      if (cfenceIds.indexOf(currentNode.fencePointer) !== -1 && !this.cfenceMml) {
        this.cfenceMml = currentNode.mathmlTree;
      }
      currentNode = currentNode.childNodes[0];
    }
    if (!this.ofenceMml) {
      this.ofenceMml = this.ofence.mathmlTree;
    }
    if (!this.cfenceMml) {
      this.cfenceMml = this.cfence.mathmlTree;
    }
    if (this.ofenceMml) {
      this.ofenceMml = EnrichMathml$7.ascendNewNode(this.ofenceMml);
    }
    if (this.cfenceMml) {
      this.cfenceMml = EnrichMathml$7.ascendNewNode(this.cfenceMml);
    }
  }
  rewrite_() {
    let currentNode = this.semantic;
    let result = null;
    const newNode = this.introduceNewLayer_();
    (0, enrich_attr_js_1$e.setAttributes)(newNode, this.fenced.parent);
    while (!this.fencedElement(currentNode)) {
      const mml = currentNode.mathmlTree;
      const specialCase = this.specialCase_(currentNode, mml);
      if (specialCase) {
        currentNode = specialCase;
      } else {
        (0, enrich_attr_js_1$e.setAttributes)(mml, currentNode);
        const mmlChildren = [];
        for (let i = 1, child; child = currentNode.childNodes[i]; i++) {
          mmlChildren.push(EnrichMathml$7.walkTree(child));
        }
        currentNode = currentNode.childNodes[0];
      }
      const dummy = DomUtil$d.createElement('dummy');
      const saveChild = mml.childNodes[0];
      DomUtil$d.replaceNode(mml, dummy);
      DomUtil$d.replaceNode(newNode, mml);
      DomUtil$d.replaceNode(mml.childNodes[0], newNode);
      DomUtil$d.replaceNode(dummy, saveChild);
      if (!result) {
        result = mml;
      }
    }
    EnrichMathml$7.walkTree(this.ofence);
    EnrichMathml$7.walkTree(this.cfence);
    this.cleanupParents_();
    return result || newNode;
  }
  specialCase_(semantic, mml) {
    const mmlTag = DomUtil$d.tagName(mml);
    let parent = null;
    let caller;
    if (mmlTag === semantic_util_js_1$3.MMLTAGS.MSUBSUP) {
      parent = semantic.childNodes[0];
      caller = case_double_script_js_1$1.CaseDoubleScript;
    } else if (mmlTag === semantic_util_js_1$3.MMLTAGS.MMULTISCRIPTS) {
      if (semantic.type === semantic_meaning_js_1$a.SemanticType.SUPERSCRIPT || semantic.type === semantic_meaning_js_1$a.SemanticType.SUBSCRIPT) {
        caller = case_multiscripts_js_1$1.CaseMultiscripts;
      } else if (semantic.type === semantic_meaning_js_1$a.SemanticType.TENSOR) {
        caller = case_tensor_js_1$1.CaseTensor;
      }
      if (caller && semantic.childNodes[0] && semantic.childNodes[0].role === semantic_meaning_js_1$a.SemanticRole.SUBSUP) {
        parent = semantic.childNodes[0];
      } else {
        parent = semantic;
      }
    }
    if (!parent) {
      return null;
    }
    const base = parent.childNodes[0];
    const empty = CaseEmbellished.makeEmptyNode_(base.id);
    parent.childNodes[0] = empty;
    mml = new caller(semantic).getMathml();
    parent.childNodes[0] = base;
    this.parentCleanup.push(mml);
    return parent.childNodes[0];
  }
  introduceNewLayer_() {
    const fullOfence = this.fullFence(this.ofenceMml);
    const fullCfence = this.fullFence(this.cfenceMml);
    let newNode = (0, enrich_attr_js_1$e.addMrow)();
    DomUtil$d.replaceNode(this.fencedMml, newNode);
    this.fencedMmlNodes.forEach(node => newNode.appendChild(node));
    newNode.insertBefore(fullOfence, this.fencedMml);
    newNode.appendChild(fullCfence);
    if (!newNode.parentNode) {
      const mrow = (0, enrich_attr_js_1$e.addMrow)();
      while (newNode.childNodes.length > 0) {
        mrow.appendChild(newNode.childNodes[0]);
      }
      newNode.appendChild(mrow);
      newNode = mrow;
    }
    return newNode;
  }
  fullFence(fence) {
    const parent = this.fencedMml.parentNode;
    let currentFence = fence;
    while (currentFence.parentNode && currentFence.parentNode !== parent) {
      currentFence = currentFence.parentNode;
    }
    return currentFence;
  }
  cleanupParents_() {
    this.parentCleanup.forEach(function (x) {
      const parent = x.childNodes[1].getAttribute(enrich_attr_js_1$e.Attribute.PARENT);
      x.childNodes[0].setAttribute(enrich_attr_js_1$e.Attribute.PARENT, parent);
    });
  }
}
case_embellished.CaseEmbellished = CaseEmbellished;

var case_empheq = {};

Object.defineProperty(case_empheq, "__esModule", {
  value: true
});
case_empheq.CaseEmpheq = void 0;
const semantic_util_js_1$2 = semantic_util;
const abstract_enrich_case_js_1$5 = abstract_enrich_case;
const EnrichMathml$6 = enrich_mathml;
const enrich_attr_js_1$d = enrich_attr;
const DomUtil$c = dom_util;
class CaseEmpheq extends abstract_enrich_case_js_1$5.AbstractEnrichCase {
  static test(semantic) {
    return !!semantic.mathmlTree && semantic.hasAnnotation('Emph', 'top');
  }
  constructor(semantic) {
    super(semantic);
    this.mrows = [];
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    this.recurseToTable(this.semantic);
    if (this.mrows.length) {
      const newRow = (0, enrich_attr_js_1$d.addMrow)();
      const parent = this.mml.parentNode;
      parent.insertBefore(newRow, this.mml);
      for (const mrow of this.mrows) {
        newRow.appendChild(mrow);
      }
      newRow.appendChild(this.mml);
    }
    return this.mml;
  }
  recurseToTable(node) {
    var _a, _b;
    if (!(node.hasAnnotation('Emph', 'top') || node.hasAnnotation('Emph', 'fence')) && (node.hasAnnotation('Emph', 'left') || node.hasAnnotation('Emph', 'right'))) {
      EnrichMathml$6.walkTree(node);
      return;
    }
    if (!node.mathmlTree || DomUtil$c.tagName(node.mathmlTree) === semantic_util_js_1$2.MMLTAGS.MTABLE && ((_a = node.annotation['Emph']) === null || _a === void 0 ? void 0 : _a.length) && node.annotation['Emph'][0] !== 'table') {
      const newNode = (0, enrich_attr_js_1$d.addMrow)();
      (0, enrich_attr_js_1$d.setAttributes)(newNode, node);
      this.mrows.unshift(newNode);
    } else {
      if (DomUtil$c.tagName(node.mathmlTree) === semantic_util_js_1$2.MMLTAGS.MTABLE && ((_b = node.annotation['Emph']) === null || _b === void 0 ? void 0 : _b.length) && node.annotation['Emph'][0] === 'table') {
        this.finalizeTable(node);
        return;
      }
      (0, enrich_attr_js_1$d.setAttributes)(node.mathmlTree, node);
    }
    node.childNodes.forEach(this.recurseToTable.bind(this));
    if (node.textContent || node.type === 'punctuated') {
      const newContent = node.contentNodes.map(x => {
        const newNode = EnrichMathml$6.cloneContentNode(x);
        if (newNode.hasAttribute('data-semantic-added')) {
          this.mrows.unshift(newNode);
        } else {
          this.recurseToTable(x);
        }
        return newNode;
      });
      EnrichMathml$6.setOperatorAttribute(node, newContent);
      return;
    }
    node.contentNodes.forEach(this.recurseToTable.bind(this));
  }
  finalizeTable(node) {
    (0, enrich_attr_js_1$d.setAttributes)(node.mathmlTree, node);
    node.contentNodes.forEach(x => {
      EnrichMathml$6.walkTree(x);
    });
    node.childNodes.forEach(x => {
      EnrichMathml$6.walkTree(x);
    });
  }
}
case_empheq.CaseEmpheq = CaseEmpheq;

var case_limit = {};

Object.defineProperty(case_limit, "__esModule", {
  value: true
});
case_limit.CaseLimit = void 0;
const DomUtil$b = dom_util;
const semantic_meaning_js_1$9 = semantic_meaning;
const semantic_util_js_1$1 = semantic_util;
const abstract_enrich_case_js_1$4 = abstract_enrich_case;
const EnrichMathml$5 = enrich_mathml;
const enrich_attr_js_1$c = enrich_attr;
class CaseLimit extends abstract_enrich_case_js_1$4.AbstractEnrichCase {
  static test(semantic) {
    if (!semantic.mathmlTree || !semantic.childNodes.length) {
      return false;
    }
    const mmlTag = DomUtil$b.tagName(semantic.mathmlTree);
    const type = semantic.type;
    return (type === semantic_meaning_js_1$9.SemanticType.LIMUPPER || type === semantic_meaning_js_1$9.SemanticType.LIMLOWER) && (mmlTag === semantic_util_js_1$1.MMLTAGS.MSUBSUP || mmlTag === semantic_util_js_1$1.MMLTAGS.MUNDEROVER) || type === semantic_meaning_js_1$9.SemanticType.LIMBOTH && (mmlTag === semantic_util_js_1$1.MMLTAGS.MSUB || mmlTag === semantic_util_js_1$1.MMLTAGS.MUNDER || mmlTag === semantic_util_js_1$1.MMLTAGS.MSUP || mmlTag === semantic_util_js_1$1.MMLTAGS.MOVER);
  }
  static walkTree_(node) {
    if (node) {
      EnrichMathml$5.walkTree(node);
    }
  }
  constructor(semantic) {
    super(semantic);
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    const children = this.semantic.childNodes;
    if (this.semantic.type !== semantic_meaning_js_1$9.SemanticType.LIMBOTH && this.mml.childNodes.length >= 3) {
      this.mml = EnrichMathml$5.introduceNewLayer([this.mml], this.semantic);
    }
    (0, enrich_attr_js_1$c.setAttributes)(this.mml, this.semantic);
    if (!children[0].mathmlTree) {
      children[0].mathmlTree = this.semantic.mathmlTree;
    }
    children.forEach(CaseLimit.walkTree_);
    return this.mml;
  }
}
case_limit.CaseLimit = CaseLimit;

var case_line = {};

Object.defineProperty(case_line, "__esModule", {
  value: true
});
case_line.CaseLine = void 0;
const semantic_meaning_js_1$8 = semantic_meaning;
const abstract_enrich_case_js_1$3 = abstract_enrich_case;
const EnrichMathml$4 = enrich_mathml;
const enrich_attr_js_1$b = enrich_attr;
class CaseLine extends abstract_enrich_case_js_1$3.AbstractEnrichCase {
  static test(semantic) {
    return !!semantic.mathmlTree && semantic.type === semantic_meaning_js_1$8.SemanticType.LINE;
  }
  constructor(semantic) {
    super(semantic);
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    if (this.semantic.contentNodes.length) {
      EnrichMathml$4.walkTree(this.semantic.contentNodes[0]);
    }
    if (this.semantic.childNodes.length) {
      EnrichMathml$4.walkTree(this.semantic.childNodes[0]);
    }
    (0, enrich_attr_js_1$b.setAttributes)(this.mml, this.semantic);
    return this.mml;
  }
}
case_line.CaseLine = CaseLine;

var case_proof = {};

Object.defineProperty(case_proof, "__esModule", {
  value: true
});
case_proof.CaseProof = void 0;
const semantic_meaning_js_1$7 = semantic_meaning;
const abstract_enrich_case_js_1$2 = abstract_enrich_case;
const EnrichMathml$3 = enrich_mathml;
const enrich_attr_js_1$a = enrich_attr;
class CaseProof extends abstract_enrich_case_js_1$2.AbstractEnrichCase {
  static test(semantic) {
    return !!semantic.mathmlTree && (semantic.type === semantic_meaning_js_1$7.SemanticType.INFERENCE || semantic.type === semantic_meaning_js_1$7.SemanticType.PREMISES);
  }
  constructor(semantic) {
    super(semantic);
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    if (!this.semantic.childNodes.length) {
      return this.mml;
    }
    this.semantic.contentNodes.forEach(function (x) {
      EnrichMathml$3.walkTree(x);
      (0, enrich_attr_js_1$a.setAttributes)(x.mathmlTree, x);
    });
    this.semantic.childNodes.forEach(function (x) {
      EnrichMathml$3.walkTree(x);
    });
    (0, enrich_attr_js_1$a.setAttributes)(this.mml, this.semantic);
    if (this.mml.getAttribute('data-semantic-id') === this.mml.getAttribute('data-semantic-parent')) {
      this.mml.removeAttribute('data-semantic-parent');
    }
    return this.mml;
  }
}
case_proof.CaseProof = CaseProof;

var case_table = {};

Object.defineProperty(case_table, "__esModule", {
  value: true
});
case_table.CaseTable = void 0;
const DomUtil$a = dom_util;
const semantic_meaning_js_1$6 = semantic_meaning;
const semantic_util_js_1 = semantic_util;
const abstract_enrich_case_js_1$1 = abstract_enrich_case;
const EnrichMathml$2 = enrich_mathml;
const enrich_attr_js_1$9 = enrich_attr;
class CaseTable extends abstract_enrich_case_js_1$1.AbstractEnrichCase {
  static test(semantic) {
    return semantic.type === semantic_meaning_js_1$6.SemanticType.MATRIX || semantic.type === semantic_meaning_js_1$6.SemanticType.VECTOR || semantic.type === semantic_meaning_js_1$6.SemanticType.CASES;
  }
  constructor(semantic) {
    super(semantic);
    this.inner = [];
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    const lfence = EnrichMathml$2.cloneContentNode(this.semantic.contentNodes[0]);
    const rfence = this.semantic.contentNodes[1] ? EnrichMathml$2.cloneContentNode(this.semantic.contentNodes[1]) : null;
    this.inner = this.semantic.childNodes.map(EnrichMathml$2.walkTree);
    if (!this.mml) {
      this.mml = EnrichMathml$2.introduceNewLayer([lfence].concat(this.inner, [rfence]), this.semantic);
    } else if (DomUtil$a.tagName(this.mml) === semantic_util_js_1.MMLTAGS.MFENCED) {
      const children = this.mml.childNodes;
      this.mml.insertBefore(lfence, children[0] || null);
      if (rfence) {
        this.mml.appendChild(rfence);
      }
      this.mml = EnrichMathml$2.rewriteMfenced(this.mml);
    } else {
      const newChildren = [lfence, this.mml];
      if (rfence) {
        newChildren.push(rfence);
      }
      this.mml = EnrichMathml$2.introduceNewLayer(newChildren, this.semantic);
    }
    (0, enrich_attr_js_1$9.setAttributes)(this.mml, this.semantic);
    return this.mml;
  }
}
case_table.CaseTable = CaseTable;

var case_text = {};

Object.defineProperty(case_text, "__esModule", {
  value: true
});
case_text.CaseText = void 0;
const semantic_meaning_js_1$5 = semantic_meaning;
const abstract_enrich_case_js_1 = abstract_enrich_case;
const EnrichMathml$1 = enrich_mathml;
const enrich_attr_js_1$8 = enrich_attr;
class CaseText extends abstract_enrich_case_js_1.AbstractEnrichCase {
  static test(semantic) {
    return semantic.type === semantic_meaning_js_1$5.SemanticType.PUNCTUATED && (semantic.role === semantic_meaning_js_1$5.SemanticRole.TEXT || semantic.contentNodes.every(x => x.role === semantic_meaning_js_1$5.SemanticRole.DUMMY));
  }
  constructor(semantic) {
    super(semantic);
    this.mml = semantic.mathmlTree;
  }
  getMathml() {
    const children = [];
    const collapsed = EnrichMathml$1.collapsePunctuated(this.semantic, children);
    this.mml = EnrichMathml$1.introduceNewLayer(children, this.semantic);
    (0, enrich_attr_js_1$8.setAttributes)(this.mml, this.semantic);
    this.mml.removeAttribute(enrich_attr_js_1$8.Attribute.CONTENT);
    EnrichMathml$1.addCollapsedAttribute(this.mml, collapsed);
    return this.mml;
  }
}
case_text.CaseText = CaseText;

const case_binomial_js_1 = case_binomial;
const case_double_script_js_1 = case_double_script;
const case_embellished_js_1 = case_embellished;
const case_empheq_js_1 = case_empheq;
const case_limit_js_1 = case_limit;
const case_line_js_1 = case_line;
const case_multiscripts_js_1 = case_multiscripts;
const case_proof_js_1 = case_proof;
const case_table_js_1 = case_table;
const case_tensor_js_1 = case_tensor;
const case_text_js_1 = case_text;
const enrich_case_js_1 = enrich_case;
enrich_case_js_1.factory.push(...[{
  test: case_limit_js_1.CaseLimit.test,
  constr: node => new case_limit_js_1.CaseLimit(node)
}, {
  test: case_embellished_js_1.CaseEmbellished.test,
  constr: node => new case_embellished_js_1.CaseEmbellished(node)
}, {
  test: case_double_script_js_1.CaseDoubleScript.test,
  constr: node => new case_double_script_js_1.CaseDoubleScript(node)
}, {
  test: case_tensor_js_1.CaseTensor.test,
  constr: node => new case_tensor_js_1.CaseTensor(node)
}, {
  test: case_multiscripts_js_1.CaseMultiscripts.test,
  constr: node => new case_multiscripts_js_1.CaseMultiscripts(node)
}, {
  test: case_line_js_1.CaseLine.test,
  constr: node => new case_line_js_1.CaseLine(node)
}, {
  test: case_binomial_js_1.CaseBinomial.test,
  constr: node => new case_binomial_js_1.CaseBinomial(node)
}, {
  test: case_proof_js_1.CaseProof.test,
  constr: node => new case_proof_js_1.CaseProof(node)
}, {
  test: case_empheq_js_1.CaseEmpheq.test,
  constr: node => new case_empheq_js_1.CaseEmpheq(node)
}, {
  test: case_table_js_1.CaseTable.test,
  constr: node => new case_table_js_1.CaseTable(node)
}, {
  test: case_text_js_1.CaseText.test,
  constr: node => new case_text_js_1.CaseText(node)
}]);

Object.defineProperty(enrich$1, "__esModule", {
  value: true
});
enrich$1.semanticMathmlNode = semanticMathmlNode;
enrich$1.semanticMathmlSync = semanticMathmlSync;
enrich$1.semanticMathml = semanticMathml;
enrich$1.testTranslation = testTranslation;
enrich$1.prepareMmlString = prepareMmlString;
const debugger_js_1 = _debugger;
const DomUtil$9 = dom_util;
const engine_js_1$2 = engine;
const Semantic$1 = semantic;
const EnrichMathml = enrich_mathml;
function semanticMathmlNode(mml) {
  const clone = DomUtil$9.cloneNode(mml);
  const tree = Semantic$1.getTree(clone);
  return EnrichMathml.enrich(clone, tree);
}
function semanticMathmlSync(expr) {
  const mml = DomUtil$9.parseInput(expr);
  return semanticMathmlNode(mml);
}
function semanticMathml(expr, callback) {
  engine_js_1$2.EnginePromise.getall().then(() => {
    const mml = DomUtil$9.parseInput(expr);
    callback(semanticMathmlNode(mml));
  });
}
function testTranslation(expr) {
  debugger_js_1.Debugger.getInstance().init();
  const mml = semanticMathmlSync(prepareMmlString(expr));
  debugger_js_1.Debugger.getInstance().exit();
  return mml;
}
function prepareMmlString(expr) {
  if (!expr.match(/^<math/)) {
    expr = '<math>' + expr;
  }
  if (!expr.match(/\/math>$/)) {
    expr += '</math>';
  }
  return expr;
}

var highlighter_factory = {};

var chtml_highlighter = {};

var css_highlighter = {};

var abstract_highlighter = {};

Object.defineProperty(abstract_highlighter, "__esModule", {
  value: true
});
abstract_highlighter.AbstractHighlighter = void 0;
const XpathUtil$4 = xpath_util;
const enrich_attr_js_1$7 = enrich_attr;
let counter = 0;
class AbstractHighlighter {
  constructor() {
    this.counter = counter++;
    this.ATTR = 'sre-highlight-' + this.counter.toString();
    this.color = null;
    this.mactionName = '';
    this.currentHighlights = [];
  }
  highlight(nodes) {
    this.currentHighlights.push(nodes.map(node => {
      const info = this.highlightNode(node);
      this.setHighlighted(node);
      return info;
    }));
  }
  highlightAll(node) {
    const mactions = this.getMactionNodes(node);
    for (let i = 0, maction; maction = mactions[i]; i++) {
      this.highlight([maction]);
    }
  }
  unhighlight() {
    const nodes = this.currentHighlights.pop();
    if (!nodes) {
      return;
    }
    nodes.forEach(highlight => {
      if (this.isHighlighted(highlight.node)) {
        this.unhighlightNode(highlight);
        this.unsetHighlighted(highlight.node);
      }
    });
  }
  unhighlightAll() {
    while (this.currentHighlights.length > 0) {
      this.unhighlight();
    }
  }
  setColor(color) {
    this.color = color;
  }
  colorString() {
    return this.color.rgba();
  }
  addEvents(node, events) {
    const mactions = this.getMactionNodes(node);
    for (let i = 0, maction; maction = mactions[i]; i++) {
      for (const [key, event] of Object.entries(events)) {
        maction.addEventListener(key, event);
      }
    }
  }
  getMactionNodes(node) {
    return Array.from(node.getElementsByClassName(this.mactionName));
  }
  isMactionNode(node) {
    const className = node.className || node.getAttribute('class');
    return className ? !!className.match(new RegExp(this.mactionName)) : false;
  }
  isHighlighted(node) {
    return node.hasAttribute(this.ATTR);
  }
  setHighlighted(node) {
    node.setAttribute(this.ATTR, 'true');
  }
  unsetHighlighted(node) {
    node.removeAttribute(this.ATTR);
  }
  colorizeAll(node) {
    XpathUtil$4.updateEvaluator(node);
    const allNodes = XpathUtil$4.evalXPath(`.//*[@${enrich_attr_js_1$7.Attribute.ID}]`, node);
    allNodes.forEach(x => this.colorize(x));
  }
  uncolorizeAll(node) {
    const allNodes = XpathUtil$4.evalXPath(`.//*[@${enrich_attr_js_1$7.Attribute.ID}]`, node);
    allNodes.forEach(x => this.uncolorize(x));
  }
  colorize(node) {
    const fore = (0, enrich_attr_js_1$7.addPrefix)('foreground');
    if (node.hasAttribute(fore)) {
      node.setAttribute(fore + '-old', node.style.color);
      node.style.color = node.getAttribute(fore);
    }
  }
  uncolorize(node) {
    const fore = (0, enrich_attr_js_1$7.addPrefix)('foreground') + '-old';
    if (node.hasAttribute(fore)) {
      node.style.color = node.getAttribute(fore);
    }
  }
}
abstract_highlighter.AbstractHighlighter = AbstractHighlighter;

Object.defineProperty(css_highlighter, "__esModule", {
  value: true
});
css_highlighter.CssHighlighter = void 0;
const abstract_highlighter_js_1$3 = abstract_highlighter;
class CssHighlighter extends abstract_highlighter_js_1$3.AbstractHighlighter {
  constructor() {
    super();
    this.mactionName = 'mjx-maction';
  }
  highlightNode(node) {
    const info = {
      node: node,
      background: node.style.backgroundColor,
      foreground: node.style.color
    };
    if (!this.isHighlighted(node)) {
      const color = this.colorString();
      node.style.backgroundColor = color.background;
      node.style.color = color.foreground;
    }
    return info;
  }
  unhighlightNode(info) {
    info.node.style.backgroundColor = info.background;
    info.node.style.color = info.foreground;
  }
}
css_highlighter.CssHighlighter = CssHighlighter;

Object.defineProperty(chtml_highlighter, "__esModule", {
  value: true
});
chtml_highlighter.ChtmlHighlighter = void 0;
const css_highlighter_js_1$2 = css_highlighter;
class ChtmlHighlighter extends css_highlighter_js_1$2.CssHighlighter {
  constructor() {
    super();
  }
  isMactionNode(node) {
    var _a;
    return ((_a = node.tagName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === this.mactionName.toUpperCase();
  }
  getMactionNodes(node) {
    return Array.from(node.getElementsByTagName(this.mactionName));
  }
}
chtml_highlighter.ChtmlHighlighter = ChtmlHighlighter;

var color_picker = {};

Object.defineProperty(color_picker, "__esModule", {
  value: true
});
color_picker.ContrastPicker = color_picker.ColorPicker = void 0;
const namedColors = {
  red: {
    red: 255,
    green: 0,
    blue: 0
  },
  green: {
    red: 0,
    green: 255,
    blue: 0
  },
  blue: {
    red: 0,
    green: 0,
    blue: 255
  },
  yellow: {
    red: 255,
    green: 255,
    blue: 0
  },
  cyan: {
    red: 0,
    green: 255,
    blue: 255
  },
  magenta: {
    red: 255,
    green: 0,
    blue: 255
  },
  white: {
    red: 255,
    green: 255,
    blue: 255
  },
  black: {
    red: 0,
    green: 0,
    blue: 0
  }
};
function getChannelColor(color, deflt) {
  const col = color || ({
    color: deflt
  });
  let channel = Object.prototype.hasOwnProperty.call(col, 'color') ? namedColors[col.color] : col;
  if (!channel) {
    channel = namedColors[deflt];
  }
  channel.alpha = Object.prototype.hasOwnProperty.call(col, 'alpha') ? col.alpha : 1;
  return normalizeColor(channel);
}
function normalizeColor(color) {
  const normalizeCol = col => {
    col = Math.max(col, 0);
    col = Math.min(255, col);
    return Math.round(col);
  };
  color.red = normalizeCol(color.red);
  color.green = normalizeCol(color.green);
  color.blue = normalizeCol(color.blue);
  color.alpha = Math.max(color.alpha, 0);
  color.alpha = Math.min(1, color.alpha);
  return color;
}
class ColorPicker {
  static toHex(num) {
    const hex = num.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }
  constructor(background, foreground) {
    this.foreground = getChannelColor(foreground, ColorPicker.DEFAULT_FOREGROUND_);
    this.background = getChannelColor(background, ColorPicker.DEFAULT_BACKGROUND_);
  }
  rgba() {
    const rgba = function (col) {
      return 'rgba(' + col.red + ',' + col.green + ',' + col.blue + ',' + col.alpha + ')';
    };
    return {
      background: rgba(this.background),
      foreground: rgba(this.foreground)
    };
  }
  rgb() {
    const rgb = function (col) {
      return 'rgb(' + col.red + ',' + col.green + ',' + col.blue + ')';
    };
    return {
      background: rgb(this.background),
      alphaback: this.background.alpha.toString(),
      foreground: rgb(this.foreground),
      alphafore: this.foreground.alpha.toString()
    };
  }
  hex() {
    const hex = function (col) {
      return '#' + ColorPicker.toHex(col.red) + ColorPicker.toHex(col.green) + ColorPicker.toHex(col.blue);
    };
    return {
      background: hex(this.background),
      alphaback: this.background.alpha.toString(),
      foreground: hex(this.foreground),
      alphafore: this.foreground.alpha.toString()
    };
  }
}
color_picker.ColorPicker = ColorPicker;
ColorPicker.DEFAULT_BACKGROUND_ = 'blue';
ColorPicker.DEFAULT_FOREGROUND_ = 'black';
function hsl2rgb(h, s, l) {
  s = s > 1 ? s / 100 : s;
  l = l > 1 ? l / 100 : l;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(h / 60 % 2 - 1));
  const m = l - c / 2;
  let r = 0, g = 0, b = 0;
  if (0 <= h && h < 60) {
    [r, g, b] = [c, x, 0];
  } else if (60 <= h && h < 120) {
    [r, g, b] = [x, c, 0];
  } else if (120 <= h && h < 180) {
    [r, g, b] = [0, c, x];
  } else if (180 <= h && h < 240) {
    [r, g, b] = [0, x, c];
  } else if (240 <= h && h < 300) {
    [r, g, b] = [x, 0, c];
  } else if (300 <= h && h < 360) {
    [r, g, b] = [c, 0, x];
  }
  return {
    red: r + m,
    green: g + m,
    blue: b + m
  };
}
function rgb2RGB(rgb) {
  return {
    red: Math.round(255 * rgb.red),
    green: Math.round(255 * rgb.green),
    blue: Math.round(255 * rgb.blue)
  };
}
function RGB2hex(col) {
  return 'rgb(' + col.red + ',' + col.green + ',' + col.blue + ')';
}
class ContrastPicker {
  constructor() {
    this.hue = 10;
    this.sat = 100;
    this.light = 50;
    this.incr = 50;
  }
  generate() {
    return RGB2hex(rgb2RGB(hsl2rgb(this.hue, this.sat, this.light)));
  }
  increment() {
    this.hue = (this.hue + this.incr) % 360;
  }
}
color_picker.ContrastPicker = ContrastPicker;

var html_highlighter = {};

Object.defineProperty(html_highlighter, "__esModule", {
  value: true
});
html_highlighter.HtmlHighlighter = void 0;
const DomUtil$8 = dom_util;
const abstract_highlighter_js_1$2 = abstract_highlighter;
class HtmlHighlighter extends abstract_highlighter_js_1$2.AbstractHighlighter {
  constructor() {
    super();
    this.mactionName = 'maction';
  }
  highlightNode(node) {
    const info = {
      node: node,
      foreground: node.style.color,
      position: node.style.position
    };
    const color = this.color.rgb();
    node.style.color = color.foreground;
    node.style.position = 'relative';
    const bbox = node.bbox;
    if (bbox && bbox.w) {
      const vpad = 0.05;
      const hpad = 0;
      const span = DomUtil$8.createElement('span');
      const left = parseFloat(node.style.paddingLeft || '0');
      span.style.backgroundColor = color.background;
      span.style.opacity = color.alphaback.toString();
      span.style.display = 'inline-block';
      span.style.height = bbox.h + bbox.d + 2 * vpad + 'em';
      span.style.verticalAlign = -bbox.d + 'em';
      span.style.marginTop = span.style.marginBottom = -vpad + 'em';
      span.style.width = bbox.w + 2 * hpad + 'em';
      span.style.marginLeft = left - hpad + 'em';
      span.style.marginRight = -bbox.w - hpad - left + 'em';
      node.parentNode.insertBefore(span, node);
      info.box = span;
    }
    return info;
  }
  unhighlightNode(info) {
    const node = info.node;
    node.style.color = info.foreground;
    node.style.position = info.position;
    if (info.box) {
      info.box.parentNode.removeChild(info.box);
    }
  }
}
html_highlighter.HtmlHighlighter = HtmlHighlighter;

var mml_css_highlighter = {};

Object.defineProperty(mml_css_highlighter, "__esModule", {
  value: true
});
mml_css_highlighter.MmlCssHighlighter = void 0;
const css_highlighter_js_1$1 = css_highlighter;
class MmlCssHighlighter extends css_highlighter_js_1$1.CssHighlighter {
  constructor() {
    super();
    this.mactionName = 'maction';
  }
  getMactionNodes(node) {
    return Array.from(node.getElementsByTagName(this.mactionName));
  }
  isMactionNode(node) {
    return node.tagName === this.mactionName;
  }
}
mml_css_highlighter.MmlCssHighlighter = MmlCssHighlighter;

var mml_highlighter = {};

Object.defineProperty(mml_highlighter, "__esModule", {
  value: true
});
mml_highlighter.MmlHighlighter = void 0;
const abstract_highlighter_js_1$1 = abstract_highlighter;
class MmlHighlighter extends abstract_highlighter_js_1$1.AbstractHighlighter {
  constructor() {
    super();
    this.mactionName = 'maction';
  }
  highlightNode(node) {
    let style = node.getAttribute('style');
    style += ';background-color: ' + this.colorString().background;
    style += ';color: ' + this.colorString().foreground;
    node.setAttribute('style', style);
    return {
      node: node
    };
  }
  unhighlightNode(info) {
    let style = info.node.getAttribute('style');
    style = style.replace(';background-color: ' + this.colorString().background, '');
    style = style.replace(';color: ' + this.colorString().foreground, '');
    info.node.setAttribute('style', style);
  }
  colorString() {
    return this.color.rgba();
  }
  getMactionNodes(node) {
    return Array.from(node.getElementsByTagName(this.mactionName));
  }
  isMactionNode(node) {
    return node.tagName === this.mactionName;
  }
}
mml_highlighter.MmlHighlighter = MmlHighlighter;

var svg_highlighter = {};

Object.defineProperty(svg_highlighter, "__esModule", {
  value: true
});
svg_highlighter.SvgHighlighter = void 0;
const DomUtil$7 = dom_util;
const abstract_highlighter_js_1 = abstract_highlighter;
class SvgHighlighter extends abstract_highlighter_js_1.AbstractHighlighter {
  constructor() {
    super();
    this.mactionName = 'mjx-svg-maction';
  }
  highlightNode(node) {
    let info;
    if (this.isHighlighted(node)) {
      info = {
        node: node.previousSibling || node,
        background: node.style.backgroundColor,
        foreground: node.style.color
      };
      return info;
    }
    if (node.tagName === 'svg') {
      const info = {
        node: node,
        background: node.style.backgroundColor,
        foreground: node.style.color
      };
      node.style.backgroundColor = this.colorString().background;
      node.style.color = this.colorString().foreground;
      return info;
    }
    const rect = DomUtil$7.createElementNS('http://www.w3.org/2000/svg', 'rect');
    const padding = 40;
    let bbox;
    if (node.nodeName === 'use') {
      const g = DomUtil$7.createElementNS('http://www.w3.org/2000/svg', 'g');
      node.parentNode.insertBefore(g, node);
      g.appendChild(node);
      bbox = g.getBBox();
      g.parentNode.replaceChild(node, g);
    } else {
      bbox = node.getBBox();
    }
    rect.setAttribute('x', (bbox.x - padding).toString());
    rect.setAttribute('y', (bbox.y - padding).toString());
    rect.setAttribute('width', (bbox.width + 2 * padding).toString());
    rect.setAttribute('height', (bbox.height + 2 * padding).toString());
    const transform = node.getAttribute('transform');
    if (transform) {
      rect.setAttribute('transform', transform);
    }
    rect.setAttribute('fill', this.colorString().background);
    rect.setAttribute(this.ATTR, 'true');
    node.parentNode.insertBefore(rect, node);
    info = {
      node: rect,
      foreground: node.getAttribute('fill')
    };
    node.setAttribute('fill', this.colorString().foreground);
    return info;
  }
  setHighlighted(node) {
    if (node.tagName === 'svg') {
      super.setHighlighted(node);
    }
  }
  unhighlightNode(info) {
    if (('background' in info)) {
      info.node.style.backgroundColor = info.background;
      info.node.style.color = info.foreground;
      return;
    }
    info.foreground ? info.node.nextSibling.setAttribute('fill', info.foreground) : info.node.nextSibling.removeAttribute('fill');
    info.node.parentNode.removeChild(info.node);
  }
  isMactionNode(node) {
    let className = node.className || node.getAttribute('class');
    if (!className) {
      return false;
    }
    className = className.baseVal !== undefined ? className.baseVal : className;
    return className ? !!className.match(new RegExp(this.mactionName)) : false;
  }
}
svg_highlighter.SvgHighlighter = SvgHighlighter;

var svg_v3_highlighter = {};

Object.defineProperty(svg_v3_highlighter, "__esModule", {
  value: true
});
svg_v3_highlighter.SvgV3Highlighter = void 0;
const DomUtil$6 = dom_util;
const XpathUtil$3 = xpath_util;
const color_picker_js_1$2 = color_picker;
const svg_highlighter_js_1$1 = svg_highlighter;
class SvgV3Highlighter extends svg_highlighter_js_1$1.SvgHighlighter {
  constructor() {
    super();
    this.mactionName = 'maction';
  }
  highlightNode(node) {
    let info;
    if (this.isHighlighted(node)) {
      info = {
        node: node,
        background: this.colorString().background,
        foreground: this.colorString().foreground
      };
      return info;
    }
    if (node.tagName === 'svg' || node.tagName === 'MJX-CONTAINER') {
      info = {
        node: node,
        background: node.style.backgroundColor,
        foreground: node.style.color
      };
      node.style.backgroundColor = this.colorString().background;
      node.style.color = this.colorString().foreground;
      return info;
    }
    const rect = DomUtil$6.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('sre-highlighter-added', 'true');
    const padding = 40;
    const bbox = node.getBBox();
    rect.setAttribute('x', (bbox.x - padding).toString());
    rect.setAttribute('y', (bbox.y - padding).toString());
    rect.setAttribute('width', (bbox.width + 2 * padding).toString());
    rect.setAttribute('height', (bbox.height + 2 * padding).toString());
    const transform = node.getAttribute('transform');
    if (transform) {
      rect.setAttribute('transform', transform);
    }
    rect.setAttribute('fill', this.colorString().background);
    node.setAttribute(this.ATTR, 'true');
    node.parentNode.insertBefore(rect, node);
    info = {
      node: node,
      foreground: node.getAttribute('fill')
    };
    if (node.nodeName === 'rect') {
      const picker = new color_picker_js_1$2.ColorPicker({
        alpha: 0,
        color: 'black'
      });
      node.setAttribute('fill', picker.rgba().foreground);
    } else {
      node.setAttribute('fill', this.colorString().foreground);
    }
    return info;
  }
  unhighlightNode(info) {
    const previous = info.node.previousSibling;
    if (previous && previous.hasAttribute('sre-highlighter-added')) {
      info.foreground ? info.node.setAttribute('fill', info.foreground) : info.node.removeAttribute('fill');
      info.node.parentNode.removeChild(previous);
      return;
    }
    info.node.style.backgroundColor = info.background;
    info.node.style.color = info.foreground;
  }
  isMactionNode(node) {
    return node.getAttribute('data-mml-node') === this.mactionName;
  }
  getMactionNodes(node) {
    return Array.from(XpathUtil$3.evalXPath(`.//*[@data-mml-node="${this.mactionName}"]`, node));
  }
}
svg_v3_highlighter.SvgV3Highlighter = SvgV3Highlighter;

Object.defineProperty(highlighter_factory, "__esModule", {
  value: true
});
highlighter_factory.highlighter = highlighter;
highlighter_factory.update = update;
highlighter_factory.addEvents = addEvents;
const chtml_highlighter_js_1 = chtml_highlighter;
const color_picker_js_1$1 = color_picker;
const css_highlighter_js_1 = css_highlighter;
const html_highlighter_js_1 = html_highlighter;
const mml_css_highlighter_js_1 = mml_css_highlighter;
const mml_highlighter_js_1 = mml_highlighter;
const svg_highlighter_js_1 = svg_highlighter;
const svg_v3_highlighter_js_1 = svg_v3_highlighter;
function highlighter(back, fore, rendererInfo) {
  const colorPicker = new color_picker_js_1$1.ColorPicker(back, fore);
  const renderer = rendererInfo.renderer === 'NativeMML' && rendererInfo.browser === 'Safari' ? 'MML-CSS' : rendererInfo.renderer === 'SVG' && rendererInfo.browser === 'v3' ? 'SVG-V3' : rendererInfo.renderer;
  const highlighter = new (highlighterMapping[renderer] || highlighterMapping['NativeMML'])();
  highlighter.setColor(colorPicker);
  return highlighter;
}
function update(back, fore, highlighter) {
  const colorPicker = new color_picker_js_1$1.ColorPicker(back, fore);
  highlighter.setColor(colorPicker);
}
function addEvents(node, events, rendererInfo) {
  const highlight = highlighterMapping[rendererInfo.renderer];
  if (highlight) {
    new highlight().addEvents(node, events);
  }
}
const highlighterMapping = {
  SVG: svg_highlighter_js_1.SvgHighlighter,
  'SVG-V3': svg_v3_highlighter_js_1.SvgV3Highlighter,
  NativeMML: mml_highlighter_js_1.MmlHighlighter,
  'HTML-CSS': html_highlighter_js_1.HtmlHighlighter,
  'MML-CSS': mml_css_highlighter_js_1.MmlCssHighlighter,
  CommonHTML: css_highlighter_js_1.CssHighlighter,
  CHTML: chtml_highlighter_js_1.ChtmlHighlighter
};

var speech_generator_factory = {};

var adhoc_speech_generator = {};

var abstract_speech_generator = {};

var rebuild_stree = {};

var walker_util = {};

Object.defineProperty(walker_util, "__esModule", {
  value: true
});
walker_util.splitAttribute = splitAttribute;
walker_util.getAttribute = getAttribute;
walker_util.getSemanticRoot = getSemanticRoot;
walker_util.getBySemanticId = getBySemanticId;
walker_util.getAllBySemanticId = getAllBySemanticId;
const DomUtil$5 = dom_util;
const enrich_attr_js_1$6 = enrich_attr;
function splitAttribute(attr) {
  return !attr ? [] : attr.split(/,/);
}
function getAttribute(node, attr) {
  return node.getAttribute(attr);
}
function getSemanticRoot(node) {
  if (node.hasAttribute(enrich_attr_js_1$6.Attribute.TYPE) && !node.hasAttribute(enrich_attr_js_1$6.Attribute.PARENT)) {
    return node;
  }
  const semanticNodes = DomUtil$5.querySelectorAllByAttr(node, enrich_attr_js_1$6.Attribute.TYPE);
  for (let i = 0, semanticNode; semanticNode = semanticNodes[i]; i++) {
    if (!semanticNode.hasAttribute(enrich_attr_js_1$6.Attribute.PARENT)) {
      return semanticNode;
    }
  }
  return node;
}
function getBySemanticId(root, id) {
  if (root.getAttribute(enrich_attr_js_1$6.Attribute.ID) === id) {
    return root;
  }
  return DomUtil$5.querySelectorAllByAttrValue(root, enrich_attr_js_1$6.Attribute.ID, id)[0];
}
function getAllBySemanticId(root, id) {
  if (root.getAttribute(enrich_attr_js_1$6.Attribute.ID) === id) {
    return [root];
  }
  return DomUtil$5.querySelectorAllByAttrValue(root, enrich_attr_js_1$6.Attribute.ID, id);
}

Object.defineProperty(rebuild_stree, "__esModule", {
  value: true
});
rebuild_stree.RebuildStree = void 0;
const enrich_attr_js_1$5 = enrich_attr;
const semantic_attr_js_1 = semantic_attr;
const semantic_meaning_js_1$4 = semantic_meaning;
const semantic_node_factory_js_1 = semantic_node_factory;
const semantic_skeleton_js_1$1 = semantic_skeleton;
const semantic_tree_js_1$1 = semantic_tree;
const WalkerUtil$8 = walker_util;
class RebuildStree {
  static textContent(snode, node, ignore) {
    if (!ignore && node.textContent) {
      snode.textContent = node.textContent;
      return;
    }
    const operator = WalkerUtil$8.splitAttribute(WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.OPERATOR));
    if (operator.length > 1) {
      snode.textContent = operator[1];
    }
  }
  static isPunctuated(collapsed) {
    return !semantic_skeleton_js_1$1.SemanticSkeleton.simpleCollapseStructure(collapsed) && collapsed[1] && semantic_skeleton_js_1$1.SemanticSkeleton.contentCollapseStructure(collapsed[1]);
  }
  constructor(mathml) {
    this.mathml = mathml;
    this.factory = new semantic_node_factory_js_1.SemanticNodeFactory();
    this.nodeDict = {};
    this.mmlRoot = WalkerUtil$8.getSemanticRoot(mathml);
    this.streeRoot = this.assembleTree(this.mmlRoot);
    this.stree = semantic_tree_js_1$1.SemanticTree.fromNode(this.streeRoot, this.mathml);
    this.xml = this.stree.xml();
  }
  getTree() {
    return this.stree;
  }
  assembleTree(node) {
    const snode = this.makeNode(node);
    const children = WalkerUtil$8.splitAttribute(WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.CHILDREN));
    const content = WalkerUtil$8.splitAttribute(WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.CONTENT));
    if (content.length === 0 && children.length === 0) {
      RebuildStree.textContent(snode, node);
      return snode;
    }
    if (content.length > 0) {
      const fcontent = WalkerUtil$8.getBySemanticId(this.mathml, content[0]);
      if (fcontent) {
        RebuildStree.textContent(snode, fcontent, true);
      }
    }
    snode.contentNodes = content.map(id => this.setParent(id, snode));
    snode.childNodes = children.map(id => this.setParent(id, snode));
    const collapsed = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.COLLAPSED);
    return collapsed ? this.postProcess(snode, collapsed) : snode;
  }
  makeNode(node) {
    const type = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.TYPE);
    const role = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.ROLE);
    const font = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.FONT);
    const annotation = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.ANNOTATION) || '';
    const attributes = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.ATTRIBUTES) || '';
    const id = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.ID);
    const embellished = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.EMBELLISHED);
    const fencepointer = WalkerUtil$8.getAttribute(node, enrich_attr_js_1$5.Attribute.FENCEPOINTER);
    const snode = this.createNode(parseInt(id, 10));
    snode.type = type;
    snode.role = role;
    snode.font = font ? font : semantic_meaning_js_1$4.SemanticFont.UNKNOWN;
    snode.parseAnnotation(annotation);
    snode.parseAttributes(attributes);
    if (fencepointer) {
      snode.fencePointer = fencepointer;
    }
    if (embellished) {
      snode.embellished = embellished;
    }
    return snode;
  }
  makePunctuation(id) {
    const node = this.createNode(id);
    node.updateContent(semantic_attr_js_1.NamedSymbol.invisibleComma);
    node.role = semantic_meaning_js_1$4.SemanticRole.DUMMY;
    return node;
  }
  makePunctuated(snode, collapsed, role) {
    const punctuated = this.createNode(collapsed[0]);
    punctuated.type = semantic_meaning_js_1$4.SemanticType.PUNCTUATED;
    punctuated.embellished = snode.embellished;
    punctuated.fencePointer = snode.fencePointer;
    punctuated.role = role;
    const cont = collapsed.splice(1, 1)[0].slice(1);
    punctuated.contentNodes = cont.map(this.makePunctuation.bind(this));
    this.collapsedChildren_(collapsed);
  }
  makeEmpty(snode, collapsed, role) {
    const empty = this.createNode(collapsed);
    empty.type = semantic_meaning_js_1$4.SemanticType.EMPTY;
    empty.embellished = snode.embellished;
    empty.fencePointer = snode.fencePointer;
    empty.role = role;
  }
  makeIndex(snode, collapsed, role) {
    if (RebuildStree.isPunctuated(collapsed)) {
      this.makePunctuated(snode, collapsed, role);
      collapsed = collapsed[0];
      return;
    }
    if (semantic_skeleton_js_1$1.SemanticSkeleton.simpleCollapseStructure(collapsed) && !this.nodeDict[collapsed.toString()]) {
      this.makeEmpty(snode, collapsed, role);
    }
  }
  postProcess(snode, collapsed) {
    const array = semantic_skeleton_js_1$1.SemanticSkeleton.fromString(collapsed).array;
    if (snode.type === semantic_meaning_js_1$4.SemanticRole.SUBSUP) {
      const subscript = this.createNode(array[1][0]);
      subscript.type = semantic_meaning_js_1$4.SemanticType.SUBSCRIPT;
      subscript.role = semantic_meaning_js_1$4.SemanticRole.SUBSUP;
      snode.type = semantic_meaning_js_1$4.SemanticType.SUPERSCRIPT;
      subscript.embellished = snode.embellished;
      subscript.fencePointer = snode.fencePointer;
      this.makeIndex(snode, array[1][2], semantic_meaning_js_1$4.SemanticRole.RIGHTSUB);
      this.makeIndex(snode, array[2], semantic_meaning_js_1$4.SemanticRole.RIGHTSUPER);
      this.collapsedChildren_(array);
      return snode;
    }
    if (snode.type === semantic_meaning_js_1$4.SemanticType.SUBSCRIPT) {
      this.makeIndex(snode, array[2], semantic_meaning_js_1$4.SemanticRole.RIGHTSUB);
      this.collapsedChildren_(array);
      return snode;
    }
    if (snode.type === semantic_meaning_js_1$4.SemanticType.SUPERSCRIPT) {
      this.makeIndex(snode, array[2], semantic_meaning_js_1$4.SemanticRole.RIGHTSUPER);
      this.collapsedChildren_(array);
      return snode;
    }
    if (snode.type === semantic_meaning_js_1$4.SemanticType.TENSOR) {
      this.makeIndex(snode, array[2], semantic_meaning_js_1$4.SemanticRole.LEFTSUB);
      this.makeIndex(snode, array[3], semantic_meaning_js_1$4.SemanticRole.LEFTSUPER);
      this.makeIndex(snode, array[4], semantic_meaning_js_1$4.SemanticRole.RIGHTSUB);
      this.makeIndex(snode, array[5], semantic_meaning_js_1$4.SemanticRole.RIGHTSUPER);
      this.collapsedChildren_(array);
      return snode;
    }
    if (snode.type === semantic_meaning_js_1$4.SemanticType.PUNCTUATED) {
      if (RebuildStree.isPunctuated(array)) {
        const cont = array.splice(1, 1)[0].slice(1);
        snode.contentNodes = cont.map(this.makePunctuation.bind(this));
      }
      return snode;
    }
    if (snode.type === semantic_meaning_js_1$4.SemanticRole.UNDEROVER) {
      const score = this.createNode(array[1][0]);
      if (snode.childNodes[1].role === semantic_meaning_js_1$4.SemanticRole.OVERACCENT) {
        score.type = semantic_meaning_js_1$4.SemanticType.OVERSCORE;
        snode.type = semantic_meaning_js_1$4.SemanticType.UNDERSCORE;
      } else {
        score.type = semantic_meaning_js_1$4.SemanticType.UNDERSCORE;
        snode.type = semantic_meaning_js_1$4.SemanticType.OVERSCORE;
      }
      score.role = semantic_meaning_js_1$4.SemanticRole.UNDEROVER;
      score.embellished = snode.embellished;
      score.fencePointer = snode.fencePointer;
      this.collapsedChildren_(array);
      return snode;
    }
    return snode;
  }
  createNode(id) {
    const node = this.factory.makeNode(id);
    this.nodeDict[id.toString()] = node;
    return node;
  }
  collapsedChildren_(collapsed) {
    const recurseCollapsed = coll => {
      const parent = this.nodeDict[coll[0]];
      parent.childNodes = [];
      for (let j = 1, l = coll.length; j < l; j++) {
        const id = coll[j];
        parent.childNodes.push(semantic_skeleton_js_1$1.SemanticSkeleton.simpleCollapseStructure(id) ? this.nodeDict[id] : recurseCollapsed(id));
      }
      return parent;
    };
    recurseCollapsed(collapsed);
  }
  setParent(id, snode) {
    const mml = WalkerUtil$8.getBySemanticId(this.mathml, id);
    const sn = this.assembleTree(mml);
    sn.parent = snode;
    return sn;
  }
}
rebuild_stree.RebuildStree = RebuildStree;

var speech_generator_util = {};

Object.defineProperty(speech_generator_util, "__esModule", {
  value: true
});
speech_generator_util.computeSpeech = computeSpeech;
speech_generator_util.computeMarkup = computeMarkup;
speech_generator_util.recomputeMarkup = recomputeMarkup;
speech_generator_util.addSpeech = addSpeech;
speech_generator_util.addModality = addModality;
speech_generator_util.addPrefix = addPrefix;
speech_generator_util.retrievePrefix = retrievePrefix;
speech_generator_util.connectMactions = connectMactions;
speech_generator_util.connectAllMactions = connectAllMactions;
speech_generator_util.retrieveSummary = retrieveSummary;
const AuralRendering$2 = aural_rendering;
const DomUtil$4 = dom_util;
const XpathUtil$2 = xpath_util;
const enrich_attr_js_1$4 = enrich_attr;
const speech_rule_engine_js_1$1 = speech_rule_engine;
const semantic_tree_js_1 = semantic_tree;
const WalkerUtil$7 = walker_util;
function computeSpeech(xml) {
  return speech_rule_engine_js_1$1.SpeechRuleEngine.getInstance().evaluateNode(xml);
}
function recomputeSpeech(semantic) {
  const tree = semantic_tree_js_1.SemanticTree.fromNode(semantic);
  return computeSpeech(tree.xml());
}
function computeMarkup(tree) {
  const descrs = computeSpeech(tree);
  return AuralRendering$2.markup(descrs);
}
function recomputeMarkup(semantic) {
  const descrs = recomputeSpeech(semantic);
  return AuralRendering$2.markup(descrs);
}
function addSpeech(mml, semantic, snode) {
  const sxml = DomUtil$4.querySelectorAllByAttrValue(snode, 'id', semantic.id.toString())[0];
  const speech = sxml ? AuralRendering$2.markup(computeSpeech(sxml)) : recomputeMarkup(semantic);
  mml.setAttribute(enrich_attr_js_1$4.Attribute.SPEECH, speech);
}
function addModality(mml, semantic, modality) {
  const markup = recomputeMarkup(semantic);
  mml.setAttribute(modality, markup);
}
function addPrefix(mml, semantic) {
  const speech = retrievePrefix(semantic);
  if (speech) {
    mml.setAttribute(enrich_attr_js_1$4.Attribute.PREFIX, speech);
  }
}
function retrievePrefix(semantic) {
  const descrs = computePrefix(semantic);
  return AuralRendering$2.markup(descrs);
}
function computePrefix(semantic) {
  const tree = semantic_tree_js_1.SemanticTree.fromRoot(semantic);
  const nodes = XpathUtil$2.evalXPath('.//*[@id="' + semantic.id + '"]', tree.xml());
  let node = nodes[0];
  if (nodes.length > 1) {
    node = nodeAtPosition(semantic, nodes) || node;
  }
  return node ? speech_rule_engine_js_1$1.SpeechRuleEngine.getInstance().runInSetting({
    modality: 'prefix',
    domain: 'default',
    style: 'default',
    strict: true,
    speech: true
  }, function () {
    return speech_rule_engine_js_1$1.SpeechRuleEngine.getInstance().evaluateNode(node);
  }) : [];
}
function nodeAtPosition(semantic, nodes) {
  const node = nodes[0];
  if (!semantic.parent) {
    return node;
  }
  const path = [];
  while (semantic) {
    path.push(semantic.id);
    semantic = semantic.parent;
  }
  const pathEquals = function (xml, path) {
    while (path.length && path.shift().toString() === xml.getAttribute('id') && xml.parentNode && xml.parentNode.parentNode) {
      xml = xml.parentNode.parentNode;
    }
    return !path.length;
  };
  for (let i = 0, xml; xml = nodes[i]; i++) {
    if (pathEquals(xml, path.slice())) {
      return xml;
    }
  }
  return node;
}
function connectMactions(node, mml, stree) {
  const mactions = DomUtil$4.querySelectorAll(mml, 'maction');
  for (let i = 0, maction; maction = mactions[i]; i++) {
    const aid = maction.getAttribute('id');
    const span = DomUtil$4.querySelectorAllByAttrValue(node, 'id', aid)[0];
    if (!span) {
      continue;
    }
    const lchild = maction.childNodes[1];
    const mid = lchild.getAttribute(enrich_attr_js_1$4.Attribute.ID);
    let cspan = WalkerUtil$7.getBySemanticId(node, mid);
    if (cspan && cspan.getAttribute(enrich_attr_js_1$4.Attribute.TYPE) !== 'dummy') {
      continue;
    }
    cspan = span.childNodes[0];
    if (cspan.getAttribute('sre-highlighter-added')) {
      continue;
    }
    const pid = lchild.getAttribute(enrich_attr_js_1$4.Attribute.PARENT);
    if (pid) {
      cspan.setAttribute(enrich_attr_js_1$4.Attribute.PARENT, pid);
    }
    cspan.setAttribute(enrich_attr_js_1$4.Attribute.TYPE, 'dummy');
    cspan.setAttribute(enrich_attr_js_1$4.Attribute.ID, mid);
    cspan.setAttribute('role', 'treeitem');
    cspan.setAttribute('aria-level', lchild.getAttribute('aria-level'));
    const cst = DomUtil$4.querySelectorAllByAttrValue(stree, 'id', mid)[0];
    cst.setAttribute('alternative', mid);
  }
}
function connectAllMactions(mml, stree) {
  const mactions = DomUtil$4.querySelectorAll(mml, 'maction');
  for (let i = 0, maction; maction = mactions[i]; i++) {
    const lchild = maction.childNodes[1];
    const mid = lchild.getAttribute(enrich_attr_js_1$4.Attribute.ID);
    const cst = DomUtil$4.querySelectorAllByAttrValue(stree, 'id', mid)[0];
    cst.setAttribute('alternative', mid);
  }
}
function retrieveSummary(node, options = {}) {
  const descrs = computeSummary(node, options);
  return AuralRendering$2.markup(descrs);
}
function computeSummary(node, options = {}) {
  const preOption = options.locale ? {
    locale: options.locale
  } : {};
  return node ? speech_rule_engine_js_1$1.SpeechRuleEngine.getInstance().runInSetting(Object.assign(preOption, {
    modality: 'summary',
    strict: false,
    speech: true
  }), function () {
    return speech_rule_engine_js_1$1.SpeechRuleEngine.getInstance().evaluateNode(node);
  }) : [];
}

var clearspeak_preferences = {};

Object.defineProperty(clearspeak_preferences, "__esModule", {
  value: true
});
clearspeak_preferences.ClearspeakPreferences = void 0;
const engine_js_1$1 = engine;
const EngineConst$2 = engine_const;
const dynamic_cstr_js_1 = dynamic_cstr;
const dynamic_cstr_js_2 = dynamic_cstr;
const MathCompoundStore = math_compound_store;
const speech_rule_engine_js_1 = speech_rule_engine;
const semantic_meaning_js_1$3 = semantic_meaning;
class ClearspeakPreferences extends dynamic_cstr_js_1.DynamicCstr {
  static comparator() {
    return new Comparator(engine_js_1$1.Engine.getInstance().dynamicCstr, dynamic_cstr_js_2.DynamicProperties.createProp([dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_2.Axis.LOCALE]], [dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_2.Axis.MODALITY]], [dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_2.Axis.DOMAIN]], [dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUES[dynamic_cstr_js_2.Axis.STYLE]]));
  }
  static fromPreference(pref) {
    const pairs = pref.split(':');
    const preferences = {};
    const properties = PREFERENCES.getProperties();
    const validKeys = Object.keys(properties);
    for (let i = 0, key; key = pairs[i]; i++) {
      const pair = key.split('_');
      if (validKeys.indexOf(pair[0]) === -1) {
        continue;
      }
      const value = pair[1];
      if (value && value !== ClearspeakPreferences.AUTO && properties[pair[0]].indexOf(value) !== -1) {
        preferences[pair[0]] = pair[1];
      }
    }
    return preferences;
  }
  static toPreference(pref) {
    const keys = Object.keys(pref);
    const str = [];
    for (let i = 0; i < keys.length; i++) {
      str.push(keys[i] + '_' + pref[keys[i]]);
    }
    return str.length ? str.join(':') : dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUE;
  }
  static getLocalePreferences(opt_dynamic) {
    const dynamic = opt_dynamic || MathCompoundStore.enumerate(speech_rule_engine_js_1.SpeechRuleEngine.getInstance().enumerate());
    return ClearspeakPreferences.getLocalePreferences_(dynamic);
  }
  static currentPreference() {
    return EngineConst$2.DOMAIN_TO_STYLES['clearspeak'];
  }
  static relevantPreferences(node) {
    const roles = SEMANTIC_MAPPING_[node.type];
    if (!roles) {
      return 'ImpliedTimes';
    }
    return roles[node.role] || roles[''] || 'ImpliedTimes';
  }
  static findPreference(prefs, kind) {
    if (prefs === 'default') {
      return ClearspeakPreferences.AUTO;
    }
    const parsed = ClearspeakPreferences.fromPreference(prefs);
    return parsed[kind] || ClearspeakPreferences.AUTO;
  }
  static addPreference(prefs, kind, value) {
    if (prefs === 'default') {
      return kind + '_' + value;
    }
    const parsed = ClearspeakPreferences.fromPreference(prefs);
    parsed[kind] = value;
    return ClearspeakPreferences.toPreference(parsed);
  }
  static getLocalePreferences_(dynamic) {
    const result = {};
    for (const locale of Object.keys(dynamic)) {
      if (!dynamic[locale]['speech'] || !dynamic[locale]['speech']['clearspeak']) {
        continue;
      }
      const locPrefs = Object.keys(dynamic[locale]['speech']['clearspeak']);
      if (locPrefs.length < 3) continue;
      const prefs = result[locale] = {};
      for (const axis in PREFERENCES.getProperties()) {
        const allSty = PREFERENCES.getProperties()[axis];
        const values = [axis + '_Auto'];
        if (allSty) {
          for (const sty of allSty) {
            if (locPrefs.indexOf(axis + '_' + sty) !== -1) {
              values.push(axis + '_' + sty);
            }
          }
        }
        prefs[axis] = values;
      }
    }
    return result;
  }
  constructor(cstr, preference) {
    super(cstr);
    this.preference = preference;
  }
  equal(cstr) {
    const top = super.equal(cstr);
    if (!top) {
      return false;
    }
    const keys = Object.keys(this.preference);
    const preference = cstr.preference;
    if (keys.length !== Object.keys(preference).length) {
      return false;
    }
    for (let i = 0, key; key = keys[i]; i++) {
      if (this.preference[key] !== preference[key]) {
        return false;
      }
    }
    return true;
  }
}
clearspeak_preferences.ClearspeakPreferences = ClearspeakPreferences;
ClearspeakPreferences.AUTO = 'Auto';
const PREFERENCES = new dynamic_cstr_js_2.DynamicProperties({
  AbsoluteValue: ['Auto', 'AbsEnd', 'Cardinality', 'Determinant'],
  Bar: ['Auto', 'Conjugate'],
  Caps: ['Auto', 'SayCaps'],
  CombinationPermutation: ['Auto', 'ChoosePermute'],
  Currency: ['Auto', 'Position', 'Prefix'],
  Ellipses: ['Auto', 'AndSoOn'],
  Enclosed: ['Auto', 'EndEnclose'],
  Exponent: ['Auto', 'AfterPower', 'Ordinal', 'OrdinalPower', 'Exponent'],
  Fraction: ['Auto', 'EndFrac', 'FracOver', 'General', 'GeneralEndFrac', 'Ordinal', 'Over', 'OverEndFrac', 'Per'],
  Functions: ['Auto', 'None', 'Reciprocal'],
  ImpliedTimes: ['Auto', 'MoreImpliedTimes', 'None'],
  Log: ['Auto', 'LnAsNaturalLog'],
  Matrix: ['Auto', 'Combinatoric', 'EndMatrix', 'EndVector', 'SilentColNum', 'SpeakColNum', 'Vector'],
  MultiLineLabel: ['Auto', 'Case', 'Constraint', 'Equation', 'Line', 'None', 'Row', 'Step'],
  MultiLineOverview: ['Auto', 'None'],
  MultiLinePausesBetweenColumns: ['Auto', 'Long', 'Short'],
  MultsymbolDot: ['Auto', 'Dot'],
  MultsymbolX: ['Auto', 'By', 'Cross'],
  Paren: ['Auto', 'CoordPoint', 'Interval', 'Silent', 'Speak', 'SpeakNestingLevel'],
  Prime: ['Auto', 'Angle', 'Length'],
  Roots: ['Auto', 'PosNegSqRoot', 'PosNegSqRootEnd', 'RootEnd'],
  SetMemberSymbol: ['Auto', 'Belongs', 'Element', 'Member', 'In'],
  Sets: ['Auto', 'SilentBracket', 'woAll'],
  TriangleSymbol: ['Auto', 'Delta'],
  Trig: ['Auto', 'ArcTrig', 'TrigInverse', 'Reciprocal'],
  VerticalLine: ['Auto', 'Divides', 'Given', 'SuchThat']
});
class Comparator extends dynamic_cstr_js_2.DefaultComparator {
  constructor(cstr, props) {
    super(cstr, props);
    this.preference = cstr instanceof ClearspeakPreferences ? cstr.preference : {};
  }
  match(cstr) {
    if (!(cstr instanceof ClearspeakPreferences)) {
      return super.match(cstr);
    }
    if (cstr.getComponents()[dynamic_cstr_js_2.Axis.STYLE] === 'default') {
      return true;
    }
    const keys = Object.keys(cstr.preference);
    for (let i = 0, key; key = keys[i]; i++) {
      if (this.preference[key] !== cstr.preference[key]) {
        return false;
      }
    }
    return true;
  }
  compare(cstr1, cstr2) {
    const top = super.compare(cstr1, cstr2);
    if (top !== 0) {
      return top;
    }
    const pref1 = cstr1 instanceof ClearspeakPreferences;
    const pref2 = cstr2 instanceof ClearspeakPreferences;
    if (!pref1 && pref2) {
      return 1;
    }
    if (pref1 && !pref2) {
      return -1;
    }
    if (!pref1 && !pref2) {
      return 0;
    }
    const length1 = Object.keys(cstr1.preference).length;
    const length2 = Object.keys(cstr2.preference).length;
    return length1 > length2 ? -1 : length1 < length2 ? 1 : 0;
  }
}
class Parser$1 extends dynamic_cstr_js_2.DynamicCstrParser {
  constructor() {
    super([dynamic_cstr_js_2.Axis.LOCALE, dynamic_cstr_js_2.Axis.MODALITY, dynamic_cstr_js_2.Axis.DOMAIN, dynamic_cstr_js_2.Axis.STYLE]);
  }
  parse(str) {
    const initial = super.parse(str);
    let style = initial.getValue(dynamic_cstr_js_2.Axis.STYLE);
    const locale = initial.getValue(dynamic_cstr_js_2.Axis.LOCALE);
    const modality = initial.getValue(dynamic_cstr_js_2.Axis.MODALITY);
    let pref = {};
    if (style !== dynamic_cstr_js_1.DynamicCstr.DEFAULT_VALUE) {
      pref = this.fromPreference(style);
      style = this.toPreference(pref);
    }
    return new ClearspeakPreferences({
      locale: locale,
      modality: modality,
      domain: 'clearspeak',
      style: style
    }, pref);
  }
  fromPreference(pref) {
    return ClearspeakPreferences.fromPreference(pref);
  }
  toPreference(pref) {
    return ClearspeakPreferences.toPreference(pref);
  }
}
const REVERSE_MAPPING = [['AbsoluteValue', semantic_meaning_js_1$3.SemanticType.FENCED, semantic_meaning_js_1$3.SemanticRole.NEUTRAL, semantic_meaning_js_1$3.SemanticRole.METRIC], ['Bar', semantic_meaning_js_1$3.SemanticType.OVERSCORE, semantic_meaning_js_1$3.SemanticRole.OVERACCENT], ['Caps', semantic_meaning_js_1$3.SemanticType.IDENTIFIER, semantic_meaning_js_1$3.SemanticRole.LATINLETTER], ['CombinationPermutation', semantic_meaning_js_1$3.SemanticType.APPL, semantic_meaning_js_1$3.SemanticRole.UNKNOWN], ['Ellipses', semantic_meaning_js_1$3.SemanticType.PUNCTUATION, semantic_meaning_js_1$3.SemanticRole.ELLIPSIS], ['Exponent', semantic_meaning_js_1$3.SemanticType.SUPERSCRIPT, ''], ['Fraction', semantic_meaning_js_1$3.SemanticType.FRACTION, ''], ['Functions', semantic_meaning_js_1$3.SemanticType.APPL, semantic_meaning_js_1$3.SemanticRole.SIMPLEFUNC], ['ImpliedTimes', semantic_meaning_js_1$3.SemanticType.OPERATOR, semantic_meaning_js_1$3.SemanticRole.IMPLICIT], ['Log', semantic_meaning_js_1$3.SemanticType.APPL, semantic_meaning_js_1$3.SemanticRole.PREFIXFUNC], ['Matrix', semantic_meaning_js_1$3.SemanticType.MATRIX, ''], ['Matrix', semantic_meaning_js_1$3.SemanticType.VECTOR, ''], ['MultiLineLabel', semantic_meaning_js_1$3.SemanticType.MULTILINE, semantic_meaning_js_1$3.SemanticRole.LABEL], ['MultiLineOverview', semantic_meaning_js_1$3.SemanticType.MULTILINE, semantic_meaning_js_1$3.SemanticRole.TABLE], ['MultiLinePausesBetweenColumns', semantic_meaning_js_1$3.SemanticType.MULTILINE, semantic_meaning_js_1$3.SemanticRole.TABLE], ['MultiLineLabel', semantic_meaning_js_1$3.SemanticType.TABLE, semantic_meaning_js_1$3.SemanticRole.LABEL], ['MultiLineOverview', semantic_meaning_js_1$3.SemanticType.TABLE, semantic_meaning_js_1$3.SemanticRole.TABLE], ['MultiLinePausesBetweenColumns', semantic_meaning_js_1$3.SemanticType.TABLE, semantic_meaning_js_1$3.SemanticRole.TABLE], ['MultiLineLabel', semantic_meaning_js_1$3.SemanticType.CASES, semantic_meaning_js_1$3.SemanticRole.LABEL], ['MultiLineOverview', semantic_meaning_js_1$3.SemanticType.CASES, semantic_meaning_js_1$3.SemanticRole.TABLE], ['MultiLinePausesBetweenColumns', semantic_meaning_js_1$3.SemanticType.CASES, semantic_meaning_js_1$3.SemanticRole.TABLE], ['MultsymbolDot', semantic_meaning_js_1$3.SemanticType.OPERATOR, semantic_meaning_js_1$3.SemanticRole.MULTIPLICATION], ['MultsymbolX', semantic_meaning_js_1$3.SemanticType.OPERATOR, semantic_meaning_js_1$3.SemanticRole.MULTIPLICATION], ['Paren', semantic_meaning_js_1$3.SemanticType.FENCED, semantic_meaning_js_1$3.SemanticRole.LEFTRIGHT], ['Prime', semantic_meaning_js_1$3.SemanticType.SUPERSCRIPT, semantic_meaning_js_1$3.SemanticRole.PRIME], ['Roots', semantic_meaning_js_1$3.SemanticType.ROOT, ''], ['Roots', semantic_meaning_js_1$3.SemanticType.SQRT, ''], ['SetMemberSymbol', semantic_meaning_js_1$3.SemanticType.RELATION, semantic_meaning_js_1$3.SemanticRole.ELEMENT], ['Sets', semantic_meaning_js_1$3.SemanticType.FENCED, semantic_meaning_js_1$3.SemanticRole.SETEXT], ['TriangleSymbol', semantic_meaning_js_1$3.SemanticType.IDENTIFIER, semantic_meaning_js_1$3.SemanticRole.GREEKLETTER], ['Trig', semantic_meaning_js_1$3.SemanticType.APPL, semantic_meaning_js_1$3.SemanticRole.PREFIXFUNC], ['VerticalLine', semantic_meaning_js_1$3.SemanticType.PUNCTUATED, semantic_meaning_js_1$3.SemanticRole.VBAR]];
const SEMANTIC_MAPPING_ = (function () {
  const result = {};
  for (let i = 0, triple; triple = REVERSE_MAPPING[i]; i++) {
    const pref = triple[0];
    let role = result[triple[1]];
    if (!role) {
      role = {};
      result[triple[1]] = role;
    }
    role[triple[2]] = pref;
  }
  return result;
})();
engine_js_1$1.Engine.getInstance().comparators['clearspeak'] = ClearspeakPreferences.comparator;
engine_js_1$1.Engine.getInstance().parsers['clearspeak'] = new Parser$1();

Object.defineProperty(abstract_speech_generator, "__esModule", {
  value: true
});
abstract_speech_generator.AbstractSpeechGenerator = void 0;
const engine_setup_js_1$2 = engine_setup;
const EnrichAttr = enrich_attr;
const rebuild_stree_js_1$3 = rebuild_stree;
const SpeechGeneratorUtil$4 = speech_generator_util;
const EngineConst$1 = engine_const;
const locale_js_1$2 = locale$f;
const clearspeak_preferences_js_1 = clearspeak_preferences;
class AbstractSpeechGenerator {
  constructor() {
    this.modality = EnrichAttr.addPrefix('speech');
    this.rebuilt_ = null;
    this.options_ = {};
  }
  getRebuilt() {
    return this.rebuilt_;
  }
  setRebuilt(rebuilt) {
    this.rebuilt_ = rebuilt;
  }
  computeRebuilt(xml, force = false) {
    if (!this.rebuilt_ || force) {
      this.rebuilt_ = new rebuild_stree_js_1$3.RebuildStree(xml);
    }
    return this.rebuilt_;
  }
  setOptions(options) {
    this.options_ = options || ({});
    this.modality = EnrichAttr.addPrefix(this.options_.modality || 'speech');
  }
  setOption(key, value) {
    const options = this.getOptions();
    options[key] = value;
    this.setOptions(options);
  }
  getOptions() {
    return this.options_;
  }
  generateSpeech(_node, xml) {
    if (!this.rebuilt_) {
      this.rebuilt_ = new rebuild_stree_js_1$3.RebuildStree(xml);
    }
    (0, engine_setup_js_1$2.setup)(this.options_);
    return SpeechGeneratorUtil$4.computeMarkup(this.getRebuilt().xml);
  }
  nextRules() {
    const options = this.getOptions();
    if (options.modality !== 'speech') {
      return;
    }
    const prefs = clearspeak_preferences_js_1.ClearspeakPreferences.getLocalePreferences();
    if (!prefs[options.locale]) {
      return;
    }
    EngineConst$1.DOMAIN_TO_STYLES[options.domain] = options.style;
    options.domain = options.domain === 'mathspeak' ? 'clearspeak' : 'mathspeak';
    options.style = EngineConst$1.DOMAIN_TO_STYLES[options.domain];
    this.setOptions(options);
  }
  nextStyle(id) {
    this.setOption('style', this.nextStyle_(this.getRebuilt().nodeDict[id]));
  }
  nextStyle_(node) {
    const {modality: modality, domain: domain, style: style} = this.getOptions();
    if (modality !== 'speech') {
      return style;
    }
    if (domain === 'mathspeak') {
      const styles = ['default', 'brief', 'sbrief'];
      const index = styles.indexOf(style);
      if (index === -1) {
        return style;
      }
      return index >= styles.length - 1 ? styles[0] : styles[index + 1];
    }
    if (domain === 'clearspeak') {
      const prefs = clearspeak_preferences_js_1.ClearspeakPreferences.getLocalePreferences();
      const loc = prefs['en'];
      if (!loc) {
        return 'default';
      }
      const smart = clearspeak_preferences_js_1.ClearspeakPreferences.relevantPreferences(node);
      const current = clearspeak_preferences_js_1.ClearspeakPreferences.findPreference(style, smart);
      const options = loc[smart].map(function (x) {
        return x.split('_')[1];
      });
      const index = options.indexOf(current);
      if (index === -1) {
        return style;
      }
      const next = index >= options.length - 1 ? options[0] : options[index + 1];
      const result = clearspeak_preferences_js_1.ClearspeakPreferences.addPreference(style, smart, next);
      return result;
    }
    return style;
  }
  getLevel(depth) {
    return locale_js_1$2.LOCALE.MESSAGES.navigate.LEVEL + ' ' + depth;
  }
  getActionable(actionable) {
    return actionable ? actionable < 0 ? locale_js_1$2.LOCALE.MESSAGES.navigate.EXPANDABLE : locale_js_1$2.LOCALE.MESSAGES.navigate.COLLAPSIBLE : '';
  }
}
abstract_speech_generator.AbstractSpeechGenerator = AbstractSpeechGenerator;

Object.defineProperty(adhoc_speech_generator, "__esModule", {
  value: true
});
adhoc_speech_generator.AdhocSpeechGenerator = void 0;
const abstract_speech_generator_js_1$5 = abstract_speech_generator;
class AdhocSpeechGenerator extends abstract_speech_generator_js_1$5.AbstractSpeechGenerator {
  getSpeech(node, xml) {
    const speech = this.generateSpeech(node, xml);
    node.setAttribute(this.modality, speech);
    return speech;
  }
}
adhoc_speech_generator.AdhocSpeechGenerator = AdhocSpeechGenerator;

var color_generator = {};

Object.defineProperty(color_generator, "__esModule", {
  value: true
});
color_generator.ColorGenerator = void 0;
const DomUtil$3 = dom_util;
const enrich_attr_js_1$3 = enrich_attr;
const color_picker_js_1 = color_picker;
const rebuild_stree_js_1$2 = rebuild_stree;
const WalkerUtil$6 = walker_util;
const abstract_speech_generator_js_1$4 = abstract_speech_generator;
class ColorGenerator extends abstract_speech_generator_js_1$4.AbstractSpeechGenerator {
  constructor() {
    super(...arguments);
    this.modality = (0, enrich_attr_js_1$3.addPrefix)('foreground');
    this.contrast = new color_picker_js_1.ContrastPicker();
  }
  static visitStree_(tree, leaves, ignore) {
    if (!tree.childNodes.length) {
      if (!ignore[tree.id]) {
        leaves.push(tree.id);
      }
      return;
    }
    if (tree.contentNodes.length) {
      if (tree.type === 'punctuated') {
        tree.contentNodes.forEach(x => ignore[x.id] = true);
      }
      if (tree.role !== 'implicit') {
        leaves.push(tree.contentNodes.map(x => x.id));
      }
    }
    if (tree.childNodes.length) {
      if (tree.role === 'implicit') {
        const factors = [];
        let rest = [];
        for (const child of tree.childNodes) {
          const tt = [];
          ColorGenerator.visitStree_(child, tt, ignore);
          if (tt.length <= 2) {
            factors.push(tt.shift());
          }
          rest = rest.concat(tt);
        }
        leaves.push(factors);
        rest.forEach(x => leaves.push(x));
        return;
      }
      tree.childNodes.forEach(x => ColorGenerator.visitStree_(x, leaves, ignore));
    }
  }
  getSpeech(node, _xml) {
    return WalkerUtil$6.getAttribute(node, this.modality);
  }
  generateSpeech(node, xml) {
    if (!this.getRebuilt()) {
      this.setRebuilt(new rebuild_stree_js_1$2.RebuildStree(DomUtil$3.parseInput(xml)));
    }
    this.colorLeaves_(node);
    return WalkerUtil$6.getAttribute(node, this.modality);
  }
  colorLeaves_(node) {
    const leaves = [];
    ColorGenerator.visitStree_(this.getRebuilt().streeRoot, leaves, {});
    for (const id of leaves) {
      const color = this.contrast.generate();
      let success = false;
      if (Array.isArray(id)) {
        success = id.map(x => this.colorLeave_(node, x, color)).reduce((x, y) => x || y, false);
      } else {
        success = this.colorLeave_(node, id.toString(), color);
      }
      if (success) {
        this.contrast.increment();
      }
    }
  }
  colorLeave_(node, id, color) {
    const aux = WalkerUtil$6.getBySemanticId(node, id);
    if (aux) {
      aux.setAttribute(this.modality, color);
      return true;
    }
    return false;
  }
}
color_generator.ColorGenerator = ColorGenerator;

var direct_speech_generator = {};

Object.defineProperty(direct_speech_generator, "__esModule", {
  value: true
});
direct_speech_generator.DirectSpeechGenerator = void 0;
const WalkerUtil$5 = walker_util;
const abstract_speech_generator_js_1$3 = abstract_speech_generator;
class DirectSpeechGenerator extends abstract_speech_generator_js_1$3.AbstractSpeechGenerator {
  getSpeech(node, _xml) {
    return WalkerUtil$5.getAttribute(node, this.modality);
  }
}
direct_speech_generator.DirectSpeechGenerator = DirectSpeechGenerator;

var dummy_speech_generator = {};

Object.defineProperty(dummy_speech_generator, "__esModule", {
  value: true
});
dummy_speech_generator.DummySpeechGenerator = void 0;
const abstract_speech_generator_js_1$2 = abstract_speech_generator;
class DummySpeechGenerator extends abstract_speech_generator_js_1$2.AbstractSpeechGenerator {
  getSpeech(_node, _xml) {
    return '';
  }
}
dummy_speech_generator.DummySpeechGenerator = DummySpeechGenerator;

var node_speech_generator = {};

var tree_speech_generator = {};

Object.defineProperty(tree_speech_generator, "__esModule", {
  value: true
});
tree_speech_generator.TreeSpeechGenerator = void 0;
const enrich_attr_js_1$2 = enrich_attr;
const WalkerUtil$4 = walker_util;
const abstract_speech_generator_js_1$1 = abstract_speech_generator;
const SpeechGeneratorUtil$3 = speech_generator_util;
class TreeSpeechGenerator extends abstract_speech_generator_js_1$1.AbstractSpeechGenerator {
  getSpeech(node, xml, root = null) {
    if (this.getRebuilt()) {
      SpeechGeneratorUtil$3.connectMactions(node, xml, this.getRebuilt().xml);
    }
    const speech = this.generateSpeech(node, xml);
    const nodes = this.getRebuilt().nodeDict;
    for (const [key, snode] of Object.entries(nodes)) {
      const innerMml = WalkerUtil$4.getBySemanticId(xml, key);
      const innerNode = WalkerUtil$4.getBySemanticId(node, key) || root && WalkerUtil$4.getBySemanticId(root, key);
      if (!innerMml || !innerNode) {
        continue;
      }
      if (!this.modality || this.modality === enrich_attr_js_1$2.Attribute.SPEECH) {
        SpeechGeneratorUtil$3.addSpeech(innerNode, snode, this.getRebuilt().xml);
      } else {
        SpeechGeneratorUtil$3.addModality(innerNode, snode, this.modality);
      }
      if (this.modality === enrich_attr_js_1$2.Attribute.SPEECH) {
        SpeechGeneratorUtil$3.addPrefix(innerNode, snode);
      }
    }
    return speech;
  }
}
tree_speech_generator.TreeSpeechGenerator = TreeSpeechGenerator;

Object.defineProperty(node_speech_generator, "__esModule", {
  value: true
});
node_speech_generator.NodeSpeechGenerator = void 0;
const WalkerUtil$3 = walker_util;
const tree_speech_generator_js_1$1 = tree_speech_generator;
class NodeSpeechGenerator extends tree_speech_generator_js_1$1.TreeSpeechGenerator {
  getSpeech(node, _xml) {
    super.getSpeech(node, _xml);
    return WalkerUtil$3.getAttribute(node, this.modality);
  }
}
node_speech_generator.NodeSpeechGenerator = NodeSpeechGenerator;

var summary_speech_generator = {};

Object.defineProperty(summary_speech_generator, "__esModule", {
  value: true
});
summary_speech_generator.SummarySpeechGenerator = void 0;
const abstract_speech_generator_js_1 = abstract_speech_generator;
const SpeechGeneratorUtil$2 = speech_generator_util;
const engine_setup_js_1$1 = engine_setup;
const enrich_attr_js_1$1 = enrich_attr;
class SummarySpeechGenerator extends abstract_speech_generator_js_1.AbstractSpeechGenerator {
  getSpeech(node, _xml) {
    (0, engine_setup_js_1$1.setup)(this.getOptions());
    const id = node.getAttribute(enrich_attr_js_1$1.Attribute.ID);
    const snode = this.getRebuilt().streeRoot.querySelectorAll(x => x.id.toString() === id)[0];
    SpeechGeneratorUtil$2.addModality(node, snode, this.modality);
    const speech = node.getAttribute(enrich_attr_js_1$1.Attribute.SUMMARY);
    return speech;
  }
}
summary_speech_generator.SummarySpeechGenerator = SummarySpeechGenerator;

Object.defineProperty(speech_generator_factory, "__esModule", {
  value: true
});
speech_generator_factory.generator = generator;
const adhoc_speech_generator_js_1 = adhoc_speech_generator;
const color_generator_js_1 = color_generator;
const direct_speech_generator_js_1 = direct_speech_generator;
const dummy_speech_generator_js_1 = dummy_speech_generator;
const node_speech_generator_js_1 = node_speech_generator;
const summary_speech_generator_js_1 = summary_speech_generator;
const tree_speech_generator_js_1 = tree_speech_generator;
function generator(type) {
  const constructor = generatorMapping[type] || generatorMapping.Direct;
  return constructor();
}
const generatorMapping = {
  Adhoc: () => new adhoc_speech_generator_js_1.AdhocSpeechGenerator(),
  Color: () => new color_generator_js_1.ColorGenerator(),
  Direct: () => new direct_speech_generator_js_1.DirectSpeechGenerator(),
  Dummy: () => new dummy_speech_generator_js_1.DummySpeechGenerator(),
  Node: () => new node_speech_generator_js_1.NodeSpeechGenerator(),
  Summary: () => new summary_speech_generator_js_1.SummarySpeechGenerator(),
  Tree: () => new tree_speech_generator_js_1.TreeSpeechGenerator()
};

var walker_factory = {};

var dummy_walker = {};

var abstract_walker = {};

var focus = {};

Object.defineProperty(focus, "__esModule", {
  value: true
});
focus.Focus = void 0;
const WalkerUtil$2 = walker_util;
class Focus {
  static factory(primaryId, nodeIds, rebuilt, dom) {
    const idFunc = id => WalkerUtil$2.getBySemanticId(dom, id);
    const dict = rebuilt.nodeDict;
    const node = idFunc(primaryId);
    const nodes = nodeIds.map(idFunc);
    const snodes = nodeIds.map(function (primaryId) {
      return dict[primaryId];
    });
    const focus = new Focus(snodes, dict[primaryId]);
    focus.domNodes = nodes;
    focus.domPrimary_ = node;
    focus.allNodes = Focus.generateAllVisibleNodes_(nodeIds, nodes, dict, dom);
    return focus;
  }
  static generateAllVisibleNodes_(ids, nodes, dict, domNode) {
    let result = [];
    for (let i = 0, l = ids.length; i < l; i++) {
      if (nodes[i]) {
        const allNodes = Focus.getAllVisibleNodes([ids[i]], domNode);
        if (allNodes.length) {
          result = result.concat(allNodes);
        } else {
          result.push(nodes[i]);
        }
        continue;
      }
      const virtual = dict[ids[i]];
      if (!virtual) {
        continue;
      }
      const childIds = virtual.childNodes.map(x => x.id.toString());
      const children = Focus.getAllVisibleNodes(childIds, domNode);
      result = result.concat(Focus.generateAllVisibleNodes_(childIds, children, dict, domNode));
    }
    return result;
  }
  static getAllVisibleNodes(ids, domNode) {
    let result = [];
    for (const id of ids) {
      result = result.concat(WalkerUtil$2.getAllBySemanticId(domNode, id));
    }
    return result;
  }
  constructor(nodes, primary) {
    this.nodes = nodes;
    this.primary = primary;
    this.domNodes = [];
    this.domPrimary_ = null;
    this.allNodes = [];
  }
  getSemanticPrimary() {
    return this.primary;
  }
  getSemanticNodes() {
    return this.nodes;
  }
  getNodes() {
    return this.allNodes;
  }
  getDomNodes() {
    return this.domNodes;
  }
  getDomPrimary() {
    return this.domPrimary_;
  }
  toString() {
    return 'Primary:' + this.domPrimary_ + ' Nodes:' + this.domNodes;
  }
  clone() {
    const focus = new Focus(this.nodes, this.primary);
    focus.domNodes = this.domNodes;
    focus.domPrimary_ = this.domPrimary_;
    focus.allNodes = this.allNodes;
    return focus;
  }
}
focus.Focus = Focus;

var walker$1 = {};

Object.defineProperty(walker$1, "__esModule", {
  value: true
});
walker$1.WalkerState = walker$1.WalkerMoves = void 0;
var WalkerMoves;
(function (WalkerMoves) {
  WalkerMoves["UP"] = "up";
  WalkerMoves["DOWN"] = "down";
  WalkerMoves["LEFT"] = "left";
  WalkerMoves["RIGHT"] = "right";
  WalkerMoves["REPEAT"] = "repeat";
  WalkerMoves["DEPTH"] = "depth";
  WalkerMoves["ENTER"] = "enter";
  WalkerMoves["EXPAND"] = "expand";
  WalkerMoves["HOME"] = "home";
  WalkerMoves["SUMMARY"] = "summary";
  WalkerMoves["DETAIL"] = "detail";
  WalkerMoves["ROW"] = "row";
  WalkerMoves["CELL"] = "cell";
})(WalkerMoves || (walker$1.WalkerMoves = WalkerMoves = {}));
class WalkerState {
  static resetState(id) {
    delete WalkerState.STATE[id];
  }
  static setState(id, value) {
    WalkerState.STATE[id] = value;
  }
  static getState(id) {
    return WalkerState.STATE[id];
  }
}
walker$1.WalkerState = WalkerState;
WalkerState.STATE = {};

Object.defineProperty(abstract_walker, "__esModule", {
  value: true
});
abstract_walker.AbstractWalker = void 0;
const auditory_description_js_1 = auditory_description;
const AuralRendering$1 = aural_rendering;
const DomUtil$2 = dom_util;
const engine_setup_js_1 = engine_setup;
const event_util_js_1$2 = event_util;
const enrich_attr_js_1 = enrich_attr;
const locale_js_1$1 = locale$f;
const grammar_js_1 = grammar;
const semantic_skeleton_js_1 = semantic_skeleton;
const SpeechGeneratorFactory$1 = speech_generator_factory;
const SpeechGeneratorUtil$1 = speech_generator_util;
const focus_js_1 = focus;
const rebuild_stree_js_1$1 = rebuild_stree;
const walker_js_1$1 = walker$1;
const WalkerUtil$1 = walker_util;
const XpathUtil$1 = xpath_util;
class AbstractWalker {
  constructor(node, generator, highlighter, xml) {
    this.node = node;
    this.generator = generator;
    this.highlighter = highlighter;
    this.modifier = false;
    this.keyMapping = new Map([[event_util_js_1$2.KeyCode.UP, this.up.bind(this)], [event_util_js_1$2.KeyCode.DOWN, this.down.bind(this)], [event_util_js_1$2.KeyCode.RIGHT, this.right.bind(this)], [event_util_js_1$2.KeyCode.LEFT, this.left.bind(this)], [event_util_js_1$2.KeyCode.TAB, this.repeat.bind(this)], [event_util_js_1$2.KeyCode.DASH, this.expand.bind(this)], [event_util_js_1$2.KeyCode.SPACE, this.depth.bind(this)], [event_util_js_1$2.KeyCode.HOME, this.home.bind(this)], [event_util_js_1$2.KeyCode.X, this.summary.bind(this)], [event_util_js_1$2.KeyCode.Z, this.detail.bind(this)], [event_util_js_1$2.KeyCode.V, this.virtualize.bind(this)], [event_util_js_1$2.KeyCode.P, this.previous.bind(this)], [event_util_js_1$2.KeyCode.U, this.undo.bind(this)], [event_util_js_1$2.KeyCode.LESS, this.previousRules.bind(this)], [event_util_js_1$2.KeyCode.GREATER, this.nextRules.bind(this)]]);
    this.cursors = [];
    this.xml_ = null;
    this.rebuilt_ = null;
    this.focus_ = null;
    this.active_ = false;
    if (this.node.id) {
      this.id = this.node.id;
    } else if (this.node.hasAttribute(AbstractWalker.SRE_ID_ATTR)) {
      this.id = this.node.getAttribute(AbstractWalker.SRE_ID_ATTR);
    } else {
      this.node.setAttribute(AbstractWalker.SRE_ID_ATTR, AbstractWalker.ID_COUNTER.toString());
      this.id = AbstractWalker.ID_COUNTER++;
    }
    this.rootNode = WalkerUtil$1.getSemanticRoot(node);
    this.rootId = this.rootNode.getAttribute(enrich_attr_js_1.Attribute.ID);
    this.xmlString_ = xml;
    this.moved = walker_js_1$1.WalkerMoves.ENTER;
  }
  getXml() {
    if (!this.xml_) {
      this.xml_ = DomUtil$2.parseInput(this.xmlString_);
    }
    return this.xml_;
  }
  getRebuilt() {
    if (!this.rebuilt_) {
      this.rebuildStree();
    }
    return this.rebuilt_;
  }
  isActive() {
    return this.active_;
  }
  activate() {
    if (this.isActive()) {
      return;
    }
    this.toggleActive_();
  }
  deactivate() {
    if (!this.isActive()) {
      return;
    }
    walker_js_1$1.WalkerState.setState(this.id, this.primaryId());
    this.toggleActive_();
  }
  getFocus(update = false) {
    if (this.rootId === null) {
      this.getRebuilt();
    }
    if (!this.focus_) {
      this.focus_ = this.singletonFocus(this.rootId);
    }
    if (update) {
      this.updateFocus();
    }
    return this.focus_;
  }
  setFocus(focus) {
    this.focus_ = focus;
  }
  getDepth() {
    return this.levels.depth() - 1;
  }
  isSpeech() {
    return this.generator.modality === enrich_attr_js_1.Attribute.SPEECH;
  }
  focusDomNodes() {
    return this.getFocus().getDomNodes();
  }
  focusSemanticNodes() {
    return this.getFocus().getSemanticNodes();
  }
  speech() {
    const nodes = this.focusDomNodes();
    if (!nodes.length) {
      return '';
    }
    const special = this.specialMove();
    if (special !== null) {
      return special;
    }
    switch (this.moved) {
      case walker_js_1$1.WalkerMoves.DEPTH:
        return this.depth_();
      case walker_js_1$1.WalkerMoves.SUMMARY:
        return this.summary_();
      case walker_js_1$1.WalkerMoves.DETAIL:
        return this.detail_();
      default:
        {
          const speech = [];
          const snodes = this.focusSemanticNodes();
          for (let i = 0, l = nodes.length; i < l; i++) {
            const node = nodes[i];
            const snode = snodes[i];
            speech.push(node ? this.generator.getSpeech(node, this.getXml(), this.node) : SpeechGeneratorUtil$1.recomputeMarkup(snode));
          }
          return this.mergePrefix_(speech);
        }
    }
  }
  move(key) {
    const direction = this.keyMapping.get(key);
    if (!direction) {
      return null;
    }
    const focus = direction();
    if (!focus || focus === this.getFocus()) {
      return false;
    }
    this.setFocus(focus);
    if (this.moved === walker_js_1$1.WalkerMoves.HOME) {
      this.levels = this.initLevels();
    }
    return true;
  }
  up() {
    this.moved = walker_js_1$1.WalkerMoves.UP;
    return this.getFocus();
  }
  down() {
    this.moved = walker_js_1$1.WalkerMoves.DOWN;
    return this.getFocus();
  }
  left() {
    this.moved = walker_js_1$1.WalkerMoves.LEFT;
    return this.getFocus();
  }
  right() {
    this.moved = walker_js_1$1.WalkerMoves.RIGHT;
    return this.getFocus();
  }
  repeat() {
    this.moved = walker_js_1$1.WalkerMoves.REPEAT;
    return this.getFocus().clone();
  }
  depth() {
    this.moved = this.isSpeech() ? walker_js_1$1.WalkerMoves.DEPTH : walker_js_1$1.WalkerMoves.REPEAT;
    return this.getFocus().clone();
  }
  home() {
    this.moved = walker_js_1$1.WalkerMoves.HOME;
    const focus = this.singletonFocus(this.rootId);
    return focus;
  }
  getBySemanticId(id) {
    return WalkerUtil$1.getBySemanticId(this.node, id);
  }
  primaryId() {
    return this.getFocus().getSemanticPrimary().id.toString();
  }
  expand() {
    const primary = this.getFocus().getDomPrimary();
    const expandable = this.actionable_(primary);
    if (!expandable) {
      return this.getFocus();
    }
    this.moved = walker_js_1$1.WalkerMoves.EXPAND;
    expandable.dispatchEvent(new Event('click'));
    return this.getFocus().clone();
  }
  expandable(node) {
    const parent = !!this.actionable_(node);
    return parent && node.childNodes.length === 0;
  }
  collapsible(node) {
    const parent = !!this.actionable_(node);
    return parent && node.childNodes.length > 0;
  }
  restoreState() {
    if (!this.highlighter) {
      return;
    }
    const state = walker_js_1$1.WalkerState.getState(this.id);
    if (!state) {
      return;
    }
    let node = this.getRebuilt().nodeDict[state];
    const path = [];
    while (node) {
      path.push(node.id);
      node = node.parent;
    }
    path.pop();
    while (path.length > 0) {
      this.down();
      const id = path.pop();
      const focus = this.findFocusOnLevel(id);
      if (!focus) {
        break;
      }
      this.setFocus(focus);
    }
    this.moved = walker_js_1$1.WalkerMoves.ENTER;
  }
  updateFocus() {
    this.setFocus(focus_js_1.Focus.factory(this.getFocus().getSemanticPrimary().id.toString(), this.getFocus().getSemanticNodes().map(x => x.id.toString()), this.getRebuilt(), this.node));
  }
  rebuildStree() {
    this.rebuilt_ = new rebuild_stree_js_1$1.RebuildStree(this.getXml());
    this.rootId = this.rebuilt_.stree.root.id.toString();
    this.generator.setRebuilt(this.rebuilt_);
    this.skeleton = semantic_skeleton_js_1.SemanticSkeleton.fromTree(this.rebuilt_.stree);
    this.skeleton.populate();
    this.focus_ = this.singletonFocus(this.rootId);
    this.levels = this.initLevels();
    SpeechGeneratorUtil$1.connectMactions(this.node, this.getXml(), this.rebuilt_.xml);
  }
  previousLevel() {
    const dnode = this.getFocus().getDomPrimary();
    return dnode ? WalkerUtil$1.getAttribute(dnode, enrich_attr_js_1.Attribute.PARENT) : this.getFocus().getSemanticPrimary().parent.id.toString();
  }
  nextLevel() {
    const dnode = this.getFocus().getDomPrimary();
    let children;
    let content;
    if (dnode) {
      children = WalkerUtil$1.splitAttribute(WalkerUtil$1.getAttribute(dnode, enrich_attr_js_1.Attribute.CHILDREN));
      content = WalkerUtil$1.splitAttribute(WalkerUtil$1.getAttribute(dnode, enrich_attr_js_1.Attribute.CONTENT));
      const type = WalkerUtil$1.getAttribute(dnode, enrich_attr_js_1.Attribute.TYPE);
      const role = WalkerUtil$1.getAttribute(dnode, enrich_attr_js_1.Attribute.ROLE);
      return this.combineContentChildren(type, role, content, children);
    }
    const toIds = x => x.id.toString();
    const snode = this.getRebuilt().nodeDict[this.primaryId()];
    children = snode.childNodes.map(toIds);
    content = snode.contentNodes.map(toIds);
    if (children.length === 0) {
      return [];
    }
    return this.combineContentChildren(snode.type, snode.role, content, children);
  }
  singletonFocus(id) {
    this.getRebuilt();
    const ids = this.retrieveVisuals(id);
    return this.focusFromId(id, ids);
  }
  retrieveVisuals(id) {
    if (!this.skeleton) {
      return [id];
    }
    const num = parseInt(id, 10);
    const semStree = this.skeleton.subtreeNodes(num);
    if (!semStree.length) {
      return [id];
    }
    semStree.unshift(num);
    const mmlStree = {};
    const result = [];
    XpathUtil$1.updateEvaluator(this.getXml());
    for (const child of semStree) {
      if (mmlStree[child]) {
        continue;
      }
      result.push(child.toString());
      mmlStree[child] = true;
      this.subtreeIds(child, mmlStree);
    }
    return result;
  }
  subtreeIds(id, nodes) {
    const xmlRoot = XpathUtil$1.evalXPath(`//*[@data-semantic-id="${id}"]`, this.getXml());
    const xpath = XpathUtil$1.evalXPath('*//@data-semantic-id', xmlRoot[0]);
    xpath.forEach(x => nodes[parseInt(x.textContent, 10)] = true);
  }
  focusFromId(id, ids) {
    return focus_js_1.Focus.factory(id, ids, this.getRebuilt(), this.node);
  }
  summary() {
    this.moved = this.isSpeech() ? walker_js_1$1.WalkerMoves.SUMMARY : walker_js_1$1.WalkerMoves.REPEAT;
    return this.getFocus().clone();
  }
  detail() {
    this.moved = this.isSpeech() ? walker_js_1$1.WalkerMoves.DETAIL : walker_js_1$1.WalkerMoves.REPEAT;
    return this.getFocus().clone();
  }
  specialMove() {
    return null;
  }
  virtualize(opt_undo) {
    this.cursors.push({
      focus: this.getFocus(),
      levels: this.levels,
      undo: opt_undo || !this.cursors.length
    });
    this.levels = this.levels.clone();
    return this.getFocus().clone();
  }
  previous() {
    const previous = this.cursors.pop();
    if (!previous) {
      return this.getFocus();
    }
    this.levels = previous.levels;
    return previous.focus;
  }
  undo() {
    let previous;
    do {
      previous = this.cursors.pop();
    } while (previous && !previous.undo);
    if (!previous) {
      return this.getFocus();
    }
    this.levels = previous.levels;
    return previous.focus;
  }
  update(options) {
    (0, engine_setup_js_1.setup)(options).then(() => SpeechGeneratorFactory$1.generator('Tree').getSpeech(this.node, this.getXml()));
  }
  nextRules() {
    this.generator.nextRules();
    const options = this.generator.getOptions();
    if (options.modality !== 'speech') {
      return this.getFocus();
    }
    this.update(options);
    this.moved = walker_js_1$1.WalkerMoves.REPEAT;
    return this.getFocus().clone();
  }
  previousRules() {
    var _a;
    this.generator.nextStyle((_a = this.getFocus().getSemanticPrimary()) === null || _a === void 0 ? void 0 : _a.id.toString());
    const options = this.generator.getOptions();
    if (options.modality !== 'speech') {
      return this.getFocus();
    }
    this.update(options);
    this.moved = walker_js_1$1.WalkerMoves.REPEAT;
    return this.getFocus().clone();
  }
  refocus() {
    let focus = this.getFocus();
    let last;
    while (!focus.getNodes().length) {
      last = this.levels.peek();
      const up = this.up();
      if (!up) {
        break;
      }
      this.setFocus(up);
      focus = this.getFocus(true);
    }
    this.levels.push(last);
    this.setFocus(focus);
  }
  toggleActive_() {
    this.active_ = !this.active_;
  }
  mergePrefix_(speech, pre = []) {
    const prefix = this.isSpeech() ? this.prefix_() : '';
    if (prefix) {
      speech.unshift(prefix);
    }
    const postfix = this.isSpeech() ? this.postfix_() : '';
    if (postfix) {
      speech.push(postfix);
    }
    return AuralRendering$1.finalize(AuralRendering$1.merge(pre.concat(speech)));
  }
  prefix_() {
    const nodes = this.getFocus().getDomNodes();
    const snodes = this.getFocus().getSemanticNodes();
    return nodes[0] ? WalkerUtil$1.getAttribute(nodes[0], enrich_attr_js_1.Attribute.PREFIX) : SpeechGeneratorUtil$1.retrievePrefix(snodes[0]);
  }
  postfix_() {
    const nodes = this.getFocus().getDomNodes();
    return nodes[0] ? WalkerUtil$1.getAttribute(nodes[0], enrich_attr_js_1.Attribute.POSTFIX) : '';
  }
  depth_() {
    const oldDepth = grammar_js_1.Grammar.getInstance().getParameter('depth');
    grammar_js_1.Grammar.getInstance().setParameter('depth', true);
    const primary = this.getFocus().getDomPrimary();
    const expand = this.expandable(primary) ? locale_js_1$1.LOCALE.MESSAGES.navigate.EXPANDABLE : this.collapsible(primary) ? locale_js_1$1.LOCALE.MESSAGES.navigate.COLLAPSIBLE : '';
    const level = locale_js_1$1.LOCALE.MESSAGES.navigate.LEVEL + ' ' + this.getDepth();
    const snodes = this.getFocus().getSemanticNodes();
    const prefix = SpeechGeneratorUtil$1.retrievePrefix(snodes[0]);
    const audio = [new auditory_description_js_1.AuditoryDescription({
      text: level,
      personality: {}
    }), new auditory_description_js_1.AuditoryDescription({
      text: prefix,
      personality: {}
    }), new auditory_description_js_1.AuditoryDescription({
      text: expand,
      personality: {}
    })];
    grammar_js_1.Grammar.getInstance().setParameter('depth', oldDepth);
    return AuralRendering$1.finalize(AuralRendering$1.markup(audio));
  }
  actionable_(node) {
    const parent = node === null || node === void 0 ? void 0 : node.parentNode;
    return parent && this.highlighter.isMactionNode(parent) ? parent : null;
  }
  summary_() {
    const sprimary = this.getFocus().getSemanticPrimary();
    const sid = sprimary.id.toString();
    const snode = this.getRebuilt().xml.getAttribute('id') === sid ? this.getRebuilt().xml : DomUtil$2.querySelectorAllByAttrValue(this.getRebuilt().xml, 'id', sid)[0];
    const summary = SpeechGeneratorUtil$1.retrieveSummary(snode);
    const speech = this.mergePrefix_([summary]);
    return speech;
  }
  detail_() {
    const sprimary = this.getFocus().getSemanticPrimary();
    const sid = sprimary.id.toString();
    const snode = this.getRebuilt().xml.getAttribute('id') === sid ? this.getRebuilt().xml : DomUtil$2.querySelectorAllByAttrValue(this.getRebuilt().xml, 'id', sid)[0];
    const oldAlt = snode.getAttribute('alternative');
    snode.removeAttribute('alternative');
    const detail = SpeechGeneratorUtil$1.computeMarkup(snode);
    const speech = this.mergePrefix_([detail]);
    snode.setAttribute('alternative', oldAlt);
    return speech;
  }
}
abstract_walker.AbstractWalker = AbstractWalker;
AbstractWalker.ID_COUNTER = 0;
AbstractWalker.SRE_ID_ATTR = 'sre-explorer-id';

Object.defineProperty(dummy_walker, "__esModule", {
  value: true
});
dummy_walker.DummyWalker = void 0;
const abstract_walker_js_1$2 = abstract_walker;
class DummyWalker extends abstract_walker_js_1$2.AbstractWalker {
  up() {
    return null;
  }
  down() {
    return null;
  }
  left() {
    return null;
  }
  right() {
    return null;
  }
  repeat() {
    return null;
  }
  depth() {
    return null;
  }
  home() {
    return null;
  }
  getDepth() {
    return 0;
  }
  initLevels() {
    return null;
  }
  combineContentChildren(_type, _role, _content, _children) {
    return [];
  }
  findFocusOnLevel(_id) {
    return null;
  }
}
dummy_walker.DummyWalker = DummyWalker;

var semantic_walker = {};

var levels = {};

Object.defineProperty(levels, "__esModule", {
  value: true
});
levels.Levels = void 0;
class Levels {
  constructor() {
    this.level_ = [];
  }
  push(level) {
    this.level_.push(level);
  }
  pop() {
    return this.level_.pop();
  }
  peek() {
    return this.level_[this.level_.length - 1] || null;
  }
  indexOf(element) {
    const last = this.peek();
    return !last ? null : last.indexOf(element);
  }
  find(pred) {
    const last = this.peek();
    if (!last) {
      return null;
    }
    for (let i = 0, l = last.length; i < l; i++) {
      if (pred(last[i])) {
        return last[i];
      }
    }
    return null;
  }
  get(index) {
    const last = this.peek();
    return !last || index < 0 || index >= last.length ? null : last[index];
  }
  depth() {
    return this.level_.length;
  }
  clone() {
    const levels = new Levels();
    levels.level_ = this.level_.slice(0);
    return levels;
  }
  toString() {
    let str = '';
    for (let i = 0, level; level = this.level_[i]; i++) {
      str += '\n' + level.map(function (x) {
        return x.toString();
      });
    }
    return str;
  }
}
levels.Levels = Levels;

Object.defineProperty(semantic_walker, "__esModule", {
  value: true
});
semantic_walker.SemanticWalker = void 0;
const semantic_meaning_js_1$2 = semantic_meaning;
const abstract_walker_js_1$1 = abstract_walker;
const levels_js_1$1 = levels;
class SemanticWalker extends abstract_walker_js_1$1.AbstractWalker {
  constructor(node, generator, highlighter, xml) {
    super(node, generator, highlighter, xml);
    this.node = node;
    this.generator = generator;
    this.highlighter = highlighter;
    this.levels = null;
    this.restoreState();
  }
  initLevels() {
    const levels = new levels_js_1$1.Levels();
    levels.push([this.getFocus()]);
    return levels;
  }
  up() {
    super.up();
    const parent = this.previousLevel();
    if (!parent) {
      return null;
    }
    this.levels.pop();
    const found = this.levels.find(function (focus) {
      return focus.getSemanticNodes().some(function (node) {
        return node.id.toString() === parent;
      });
    });
    return found;
  }
  down() {
    super.down();
    const children = this.nextLevel();
    if (children.length === 0) {
      return null;
    }
    this.levels.push(children);
    return children[0];
  }
  combineContentChildren(type, role, content, children) {
    switch (type) {
      case semantic_meaning_js_1$2.SemanticType.RELSEQ:
      case semantic_meaning_js_1$2.SemanticType.INFIXOP:
      case semantic_meaning_js_1$2.SemanticType.MULTIREL:
        return this.makePairList(children, content);
      case semantic_meaning_js_1$2.SemanticType.PREFIXOP:
        return [this.focusFromId(children[0], content.concat(children))];
      case semantic_meaning_js_1$2.SemanticType.POSTFIXOP:
        return [this.focusFromId(children[0], children.concat(content))];
      case semantic_meaning_js_1$2.SemanticType.MATRIX:
      case semantic_meaning_js_1$2.SemanticType.VECTOR:
      case semantic_meaning_js_1$2.SemanticType.FENCED:
        return [this.focusFromId(children[0], [content[0], children[0], content[1]])];
      case semantic_meaning_js_1$2.SemanticType.CASES:
        return [this.focusFromId(children[0], [content[0], children[0]])];
      case semantic_meaning_js_1$2.SemanticType.PUNCTUATED:
        if (role === semantic_meaning_js_1$2.SemanticRole.TEXT) {
          return children.map(this.singletonFocus.bind(this));
        }
        if (children.length === content.length) {
          return content.map(this.singletonFocus.bind(this));
        }
        return this.combinePunctuations(children, content, [], []);
      case semantic_meaning_js_1$2.SemanticType.APPL:
        return [this.focusFromId(children[0], [children[0], content[0]]), this.singletonFocus(children[1])];
      case semantic_meaning_js_1$2.SemanticType.ROOT:
        return [this.singletonFocus(children[0]), this.singletonFocus(children[1])];
      default:
        return children.map(this.singletonFocus.bind(this));
    }
  }
  combinePunctuations(children, content, prepunct, acc) {
    if (children.length === 0) {
      return acc;
    }
    const child = children.shift();
    const cont = content.shift();
    if (child === cont) {
      prepunct.push(cont);
      return this.combinePunctuations(children, content, prepunct, acc);
    } else {
      content.unshift(cont);
      prepunct.push(child);
      if (children.length === content.length) {
        acc.push(this.focusFromId(child, prepunct.concat(content)));
        return acc;
      } else {
        acc.push(this.focusFromId(child, prepunct));
        return this.combinePunctuations(children, content, [], acc);
      }
    }
  }
  makePairList(children, content) {
    if (children.length === 0) {
      return [];
    }
    if (children.length === 1) {
      return [this.singletonFocus(children[0])];
    }
    const result = [this.singletonFocus(children.shift())];
    for (let i = 0, l = children.length; i < l; i++) {
      result.push(this.focusFromId(children[i], [content[i], children[i]]));
    }
    return result;
  }
  left() {
    super.left();
    const index = this.levels.indexOf(this.getFocus());
    if (index === null) {
      return null;
    }
    const ids = this.levels.get(index - 1);
    return ids ? ids : null;
  }
  right() {
    super.right();
    const index = this.levels.indexOf(this.getFocus());
    if (index === null) {
      return null;
    }
    const ids = this.levels.get(index + 1);
    return ids ? ids : null;
  }
  findFocusOnLevel(id) {
    const focus = this.levels.find(x => {
      const pid = x.getSemanticPrimary().id;
      return pid === id;
    });
    return focus;
  }
}
semantic_walker.SemanticWalker = SemanticWalker;

var syntax_walker = {};

Object.defineProperty(syntax_walker, "__esModule", {
  value: true
});
syntax_walker.SyntaxWalker = void 0;
const base_util_js_1 = base_util;
const semantic_meaning_js_1$1 = semantic_meaning;
const abstract_walker_js_1 = abstract_walker;
const levels_js_1 = levels;
class SyntaxWalker extends abstract_walker_js_1.AbstractWalker {
  constructor(node, generator, highlighter, xml) {
    super(node, generator, highlighter, xml);
    this.node = node;
    this.generator = generator;
    this.highlighter = highlighter;
    this.levels = null;
    this.restoreState();
  }
  initLevels() {
    const levels = new levels_js_1.Levels();
    levels.push([this.primaryId()]);
    return levels;
  }
  up() {
    super.up();
    const parent = this.previousLevel();
    if (!parent) {
      return null;
    }
    this.levels.pop();
    return this.singletonFocus(parent);
  }
  down() {
    super.down();
    const children = this.nextLevel();
    if (children.length === 0) {
      return null;
    }
    const focus = this.singletonFocus(children[0]);
    if (focus) {
      this.levels.push(children);
    }
    return focus;
  }
  combineContentChildren(type, role, content, children) {
    switch (type) {
      case semantic_meaning_js_1$1.SemanticType.RELSEQ:
      case semantic_meaning_js_1$1.SemanticType.INFIXOP:
      case semantic_meaning_js_1$1.SemanticType.MULTIREL:
        return (0, base_util_js_1.interleaveLists)(children, content);
      case semantic_meaning_js_1$1.SemanticType.PREFIXOP:
        return content.concat(children);
      case semantic_meaning_js_1$1.SemanticType.POSTFIXOP:
        return children.concat(content);
      case semantic_meaning_js_1$1.SemanticType.MATRIX:
      case semantic_meaning_js_1$1.SemanticType.VECTOR:
      case semantic_meaning_js_1$1.SemanticType.FENCED:
        children.unshift(content[0]);
        children.push(content[1]);
        return children;
      case semantic_meaning_js_1$1.SemanticType.CASES:
        children.unshift(content[0]);
        return children;
      case semantic_meaning_js_1$1.SemanticType.PUNCTUATED:
        if (role === semantic_meaning_js_1$1.SemanticRole.TEXT) {
          return (0, base_util_js_1.interleaveLists)(children, content);
        }
        return children;
      case semantic_meaning_js_1$1.SemanticType.APPL:
        return [children[0], content[0], children[1]];
      case semantic_meaning_js_1$1.SemanticType.ROOT:
        return [children[0], children[1]];
      default:
        return children;
    }
  }
  left() {
    super.left();
    const index = this.levels.indexOf(this.primaryId());
    if (index === null) {
      return null;
    }
    const id = this.levels.get(index - 1);
    return id ? this.singletonFocus(id) : null;
  }
  right() {
    super.right();
    const index = this.levels.indexOf(this.primaryId());
    if (index === null) {
      return null;
    }
    const id = this.levels.get(index + 1);
    return id ? this.singletonFocus(id) : null;
  }
  findFocusOnLevel(id) {
    return this.singletonFocus(id.toString());
  }
  focusDomNodes() {
    return [this.getFocus().getDomPrimary()];
  }
  focusSemanticNodes() {
    return [this.getFocus().getSemanticPrimary()];
  }
}
syntax_walker.SyntaxWalker = SyntaxWalker;

var table_walker = {};

Object.defineProperty(table_walker, "__esModule", {
  value: true
});
table_walker.TableWalker = void 0;
const DomUtil$1 = dom_util;
const event_util_js_1$1 = event_util;
const semantic_meaning_js_1 = semantic_meaning;
const syntax_walker_js_1$1 = syntax_walker;
const walker_js_1 = walker$1;
class TableWalker extends syntax_walker_js_1$1.SyntaxWalker {
  constructor(node, generator, highlighter, xml) {
    super(node, generator, highlighter, xml);
    this.node = node;
    this.generator = generator;
    this.highlighter = highlighter;
    this.firstJump = null;
    this.key_ = null;
    this.row_ = 0;
    this.currentTable_ = null;
    this.keyMapping.set(event_util_js_1$1.KeyCode.ZERO, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.ONE, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.TWO, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.THREE, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.FOUR, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.FIVE, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.SIX, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.SEVEN, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.EIGHT, this.jumpCell.bind(this));
    this.keyMapping.set(event_util_js_1$1.KeyCode.NINE, this.jumpCell.bind(this));
  }
  move(key) {
    this.key_ = key;
    const result = super.move(key);
    this.modifier = false;
    return result;
  }
  up() {
    this.moved = walker_js_1.WalkerMoves.UP;
    return this.eligibleCell_() ? this.verticalMove_(false) : super.up();
  }
  down() {
    this.moved = walker_js_1.WalkerMoves.DOWN;
    return this.eligibleCell_() ? this.verticalMove_(true) : super.down();
  }
  jumpCell() {
    if (!this.isInTable_() || this.key_ === null) {
      return this.getFocus();
    }
    if (this.moved === walker_js_1.WalkerMoves.ROW) {
      this.moved = walker_js_1.WalkerMoves.CELL;
      const column = this.key_ - event_util_js_1$1.KeyCode.ZERO;
      if (!this.isLegalJump_(this.row_, column)) {
        return this.getFocus();
      }
      return this.jumpCell_(this.row_, column);
    }
    const row = this.key_ - event_util_js_1$1.KeyCode.ZERO;
    if (row > this.currentTable_.childNodes.length) {
      return this.getFocus();
    }
    this.row_ = row;
    this.moved = walker_js_1.WalkerMoves.ROW;
    return this.getFocus().clone();
  }
  undo() {
    const focus = super.undo();
    if (focus === this.firstJump) {
      this.firstJump = null;
    }
    return focus;
  }
  eligibleCell_() {
    const primary = this.getFocus().getSemanticPrimary();
    return this.modifier && primary.type === semantic_meaning_js_1.SemanticType.CELL && TableWalker.ELIGIBLE_CELL_ROLES.indexOf(primary.role) !== -1;
  }
  verticalMove_(direction) {
    const parent = this.previousLevel();
    if (!parent) {
      return null;
    }
    const origFocus = this.getFocus();
    const origIndex = this.levels.indexOf(this.primaryId());
    const origLevel = this.levels.pop();
    const parentIndex = this.levels.indexOf(parent);
    const row = this.levels.get(direction ? parentIndex + 1 : parentIndex - 1);
    if (!row) {
      this.levels.push(origLevel);
      return null;
    }
    this.setFocus(this.singletonFocus(row));
    const children = this.nextLevel();
    const newNode = children[origIndex];
    if (!newNode) {
      this.setFocus(origFocus);
      this.levels.push(origLevel);
      return null;
    }
    this.levels.push(children);
    return this.singletonFocus(children[origIndex]);
  }
  jumpCell_(row, column) {
    if (!this.firstJump) {
      this.firstJump = this.getFocus();
      this.virtualize(true);
    } else {
      this.virtualize(false);
    }
    const id = this.currentTable_.id.toString();
    let level;
    do {
      level = this.levels.pop();
    } while (level.indexOf(id) === -1);
    this.levels.push(level);
    this.setFocus(this.singletonFocus(id));
    this.levels.push(this.nextLevel());
    const semRow = this.currentTable_.childNodes[row - 1];
    this.setFocus(this.singletonFocus(semRow.id.toString()));
    this.levels.push(this.nextLevel());
    return this.singletonFocus(semRow.childNodes[column - 1].id.toString());
  }
  isLegalJump_(row, column) {
    const xmlTable = DomUtil$1.querySelectorAllByAttrValue(this.getRebuilt().xml, 'id', this.currentTable_.id.toString())[0];
    if (!xmlTable || xmlTable.hasAttribute('alternative')) {
      return false;
    }
    const rowNode = this.currentTable_.childNodes[row - 1];
    if (!rowNode) {
      return false;
    }
    const xmlRow = DomUtil$1.querySelectorAllByAttrValue(xmlTable, 'id', rowNode.id.toString())[0];
    if (!xmlRow || xmlRow.hasAttribute('alternative')) {
      return false;
    }
    return !!(rowNode && rowNode.childNodes[column - 1]);
  }
  isInTable_() {
    let snode = this.getFocus().getSemanticPrimary();
    while (snode) {
      if (TableWalker.ELIGIBLE_TABLE_TYPES.indexOf(snode.type) !== -1) {
        this.currentTable_ = snode;
        return true;
      }
      snode = snode.parent;
    }
    return false;
  }
}
table_walker.TableWalker = TableWalker;
TableWalker.ELIGIBLE_CELL_ROLES = [semantic_meaning_js_1.SemanticRole.DETERMINANT, semantic_meaning_js_1.SemanticRole.ROWVECTOR, semantic_meaning_js_1.SemanticRole.BINOMIAL, semantic_meaning_js_1.SemanticRole.SQUAREMATRIX, semantic_meaning_js_1.SemanticRole.MULTILINE, semantic_meaning_js_1.SemanticRole.MATRIX, semantic_meaning_js_1.SemanticRole.VECTOR, semantic_meaning_js_1.SemanticRole.CASES, semantic_meaning_js_1.SemanticRole.TABLE];
TableWalker.ELIGIBLE_TABLE_TYPES = [semantic_meaning_js_1.SemanticType.MULTILINE, semantic_meaning_js_1.SemanticType.MATRIX, semantic_meaning_js_1.SemanticType.VECTOR, semantic_meaning_js_1.SemanticType.CASES, semantic_meaning_js_1.SemanticType.TABLE];

Object.defineProperty(walker_factory, "__esModule", {
  value: true
});
walker_factory.walker = walker;
const dummy_walker_js_1 = dummy_walker;
const semantic_walker_js_1 = semantic_walker;
const syntax_walker_js_1 = syntax_walker;
const table_walker_js_1 = table_walker;
function walker(type, node, generator, highlighter, xml) {
  const constructor = walkerMapping[type.toLowerCase()] || walkerMapping['dummy'];
  return constructor(node, generator, highlighter, xml);
}
const walkerMapping = {
  dummy: (p1, p2, p3, p4) => new dummy_walker_js_1.DummyWalker(p1, p2, p3, p4),
  semantic: (p1, p2, p3, p4) => new semantic_walker_js_1.SemanticWalker(p1, p2, p3, p4),
  syntax: (p1, p2, p3, p4) => new syntax_walker_js_1.SyntaxWalker(p1, p2, p3, p4),
  table: (p1, p2, p3, p4) => new table_walker_js_1.TableWalker(p1, p2, p3, p4)
};

var processor = {};

Object.defineProperty(processor, "__esModule", {
  value: true
});
processor.KeyProcessor = processor.Processor = void 0;
const event_util_js_1 = event_util;
class Processor {
  static stringify_(x) {
    return x ? x.toString() : x;
  }
  constructor(name, methods) {
    this.name = name;
    this.process = methods.processor;
    this.postprocess = methods.postprocessor || ((x, _y) => x);
    this.processor = this.postprocess ? function (x) {
      return this.postprocess(this.process(x), x);
    } : this.process;
    this.print = methods.print || Processor.stringify_;
    this.pprint = methods.pprint || this.print;
  }
}
processor.Processor = Processor;
Processor.LocalState = {
  walker: null,
  speechGenerator: null,
  highlighter: null
};
class KeyProcessor extends Processor {
  static getKey_(key) {
    return typeof key === 'string' ? event_util_js_1.KeyCode[key.toUpperCase()] : key;
  }
  constructor(name, methods) {
    super(name, methods);
    this.key = methods.key || KeyProcessor.getKey_;
  }
}
processor.KeyProcessor = KeyProcessor;

Object.defineProperty(processor_factory, "__esModule", {
  value: true
});
processor_factory.process = process$1;
processor_factory.output = output;
processor_factory.keypress = keypress;
const AuralRendering = aural_rendering;
const Enrich = enrich$1;
const HighlighterFactory = highlighter_factory;
const locale_js_1 = locale$f;
const Semantic = semantic;
const SpeechGeneratorFactory = speech_generator_factory;
const SpeechGeneratorUtil = speech_generator_util;
const WalkerFactory = walker_factory;
const WalkerUtil = walker_util;
const rebuild_stree_js_1 = rebuild_stree;
const DomUtil = dom_util;
const engine_js_1 = engine;
const EngineConst = engine_const;
const processor_js_1 = processor;
const XpathUtil = xpath_util;
const PROCESSORS = new Map();
function set(processor) {
  PROCESSORS.set(processor.name, processor);
}
function get(name) {
  const processor = PROCESSORS.get(name);
  if (!processor) {
    throw new engine_js_1.SREError('Unknown processor ' + name);
  }
  return processor;
}
function process$1(name, expr) {
  const processor = get(name);
  try {
    return processor.processor(expr);
  } catch (_e) {
    throw new engine_js_1.SREError('Processing error for expression ' + expr);
  }
}
function print(name, data) {
  const processor = get(name);
  return engine_js_1.Engine.getInstance().pprint ? processor.pprint(data) : processor.print(data);
}
function output(name, expr) {
  const processor = get(name);
  try {
    const data = processor.processor(expr);
    return engine_js_1.Engine.getInstance().pprint ? processor.pprint(data) : processor.print(data);
  } catch (_e) {
    console.log(_e);
    throw new engine_js_1.SREError('Processing error for expression ' + expr);
  }
}
function keypress(name, expr) {
  const processor = get(name);
  const key = processor instanceof processor_js_1.KeyProcessor ? processor.key(expr) : expr;
  const data = processor.processor(key);
  return engine_js_1.Engine.getInstance().pprint ? processor.pprint(data) : processor.print(data);
}
set(new processor_js_1.Processor('semantic', {
  processor: function (expr) {
    const mml = DomUtil.parseInput(expr);
    return Semantic.xmlTree(mml);
  },
  postprocessor: function (xml, _expr) {
    const setting = engine_js_1.Engine.getInstance().speech;
    if (setting === EngineConst.Speech.NONE) {
      return xml;
    }
    const clone = DomUtil.cloneNode(xml);
    let speech = SpeechGeneratorUtil.computeMarkup(clone);
    if (setting === EngineConst.Speech.SHALLOW) {
      xml.setAttribute('speech', AuralRendering.finalize(speech));
      return xml;
    }
    const nodesXml = XpathUtil.evalXPath('.//*[@id]', xml);
    const nodesClone = XpathUtil.evalXPath('.//*[@id]', clone);
    for (let i = 0, orig, node; (orig = nodesXml[i], node = nodesClone[i]); i++) {
      speech = SpeechGeneratorUtil.computeMarkup(node);
      orig.setAttribute('speech', AuralRendering.finalize(speech));
    }
    return xml;
  },
  pprint: function (tree) {
    return DomUtil.formatXml(tree.toString());
  }
}));
set(new processor_js_1.Processor('speech', {
  processor: function (expr) {
    const mml = DomUtil.parseInput(expr);
    const xml = Semantic.xmlTree(mml);
    const descrs = SpeechGeneratorUtil.computeSpeech(xml);
    return AuralRendering.finalize(AuralRendering.markup(descrs));
  },
  pprint: function (speech) {
    const str = speech.toString();
    return AuralRendering.isXml() ? DomUtil.formatXml(str) : str;
  }
}));
set(new processor_js_1.Processor('json', {
  processor: function (expr) {
    const mml = DomUtil.parseInput(expr);
    const stree = Semantic.getTree(mml);
    return stree.toJson();
  },
  postprocessor: function (json, expr) {
    const setting = engine_js_1.Engine.getInstance().speech;
    if (setting === EngineConst.Speech.NONE) {
      return json;
    }
    const mml = DomUtil.parseInput(expr);
    const xml = Semantic.xmlTree(mml);
    const speech = SpeechGeneratorUtil.computeMarkup(xml);
    if (setting === EngineConst.Speech.SHALLOW) {
      json.stree.speech = AuralRendering.finalize(speech);
      return json;
    }
    const addRec = json => {
      const node = XpathUtil.evalXPath(`.//*[@id=${json.id}]`, xml)[0];
      const speech = SpeechGeneratorUtil.computeMarkup(node);
      json.speech = AuralRendering.finalize(speech);
      if (json.children) {
        json.children.forEach(addRec);
      }
    };
    addRec(json.stree);
    return json;
  },
  print: function (json) {
    return JSON.stringify(json);
  },
  pprint: function (json) {
    return JSON.stringify(json, null, 2);
  }
}));
set(new processor_js_1.Processor('description', {
  processor: function (expr) {
    const mml = DomUtil.parseInput(expr);
    const xml = Semantic.xmlTree(mml);
    const descrs = SpeechGeneratorUtil.computeSpeech(xml);
    return descrs;
  },
  print: function (descrs) {
    return JSON.stringify(descrs);
  },
  pprint: function (descrs) {
    return JSON.stringify(descrs, null, 2);
  }
}));
set(new processor_js_1.Processor('enriched', {
  processor: function (expr) {
    return Enrich.semanticMathmlSync(expr);
  },
  postprocessor: function (enr, _expr) {
    const root = WalkerUtil.getSemanticRoot(enr);
    let generator;
    switch (engine_js_1.Engine.getInstance().speech) {
      case EngineConst.Speech.NONE:
        break;
      case EngineConst.Speech.SHALLOW:
        generator = SpeechGeneratorFactory.generator('Adhoc');
        generator.getSpeech(root, enr);
        break;
      case EngineConst.Speech.DEEP:
        generator = SpeechGeneratorFactory.generator('Tree');
        generator.getSpeech(enr, enr);
        break;
    }
    return enr;
  },
  pprint: function (tree) {
    return DomUtil.formatXml(tree.toString());
  }
}));
set(new processor_js_1.Processor('rebuild', {
  processor: function (expr) {
    const rebuilt = new rebuild_stree_js_1.RebuildStree(DomUtil.parseInput(expr));
    return rebuilt.stree.xml();
  },
  pprint: function (tree) {
    return DomUtil.formatXml(tree.toString());
  }
}));
set(new processor_js_1.Processor('walker', {
  processor: function (expr) {
    const generator = SpeechGeneratorFactory.generator('Node');
    processor_js_1.Processor.LocalState.speechGenerator = generator;
    generator.setOptions({
      modality: engine_js_1.Engine.getInstance().modality,
      locale: engine_js_1.Engine.getInstance().locale,
      domain: engine_js_1.Engine.getInstance().domain,
      style: engine_js_1.Engine.getInstance().style
    });
    processor_js_1.Processor.LocalState.highlighter = HighlighterFactory.highlighter({
      color: 'black'
    }, {
      color: 'white'
    }, {
      renderer: 'NativeMML'
    });
    const node = process$1('enriched', expr);
    const eml = print('enriched', node);
    processor_js_1.Processor.LocalState.walker = WalkerFactory.walker(engine_js_1.Engine.getInstance().walker, node, generator, processor_js_1.Processor.LocalState.highlighter, eml);
    return processor_js_1.Processor.LocalState.walker;
  },
  print: function (_walker) {
    return processor_js_1.Processor.LocalState.walker.speech();
  }
}));
set(new processor_js_1.KeyProcessor('move', {
  processor: function (direction) {
    if (!processor_js_1.Processor.LocalState.walker) {
      return null;
    }
    const move = processor_js_1.Processor.LocalState.walker.move(direction);
    return move === false ? AuralRendering.error(direction) : processor_js_1.Processor.LocalState.walker.speech();
  }
}));
set(new processor_js_1.Processor('number', {
  processor: function (numb) {
    const num = parseInt(numb, 10);
    return isNaN(num) ? '' : locale_js_1.LOCALE.NUMBERS.numberToWords(num);
  }
}));
set(new processor_js_1.Processor('ordinal', {
  processor: function (numb) {
    const num = parseInt(numb, 10);
    return isNaN(num) ? '' : locale_js_1.LOCALE.NUMBERS.wordOrdinal(num);
  }
}));
set(new processor_js_1.Processor('numericOrdinal', {
  processor: function (numb) {
    const num = parseInt(numb, 10);
    return isNaN(num) ? '' : locale_js_1.LOCALE.NUMBERS.numericOrdinal(num);
  }
}));
set(new processor_js_1.Processor('vulgar', {
  processor: function (numb) {
    const [en, den] = numb.split('/').map(x => parseInt(x, 10));
    return isNaN(en) || isNaN(den) ? '' : process$1('speech', `<mfrac><mn>${en}</mn><mn>${den}</mn></mfrac>`);
  }
}));
set(new processor_js_1.Processor('latex', {
  processor: function (ltx) {
    if (engine_js_1.Engine.getInstance().modality !== 'braille' || engine_js_1.Engine.getInstance().locale !== 'euro') {
      console.info('LaTeX input currently only works for Euro Braille output.' + ' Please use the latex-to-speech package from npm for general' + ' LaTeX input to SRE.');
    }
    return process$1('speech', `<math data-latex="${ltx}"></math>`);
  }
}));

(function (exports) {
  var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || (function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.localePath = exports.file = exports.localeLoader = exports.version = void 0;
  exports.setupEngine = setupEngine;
  exports.engineSetup = engineSetup;
  exports.engineReady = engineReady;
  exports.toSpeech = toSpeech;
  exports.toSemantic = toSemantic;
  exports.toJson = toJson;
  exports.toDescription = toDescription;
  exports.toEnriched = toEnriched;
  exports.number = number;
  exports.ordinal = ordinal;
  exports.numericOrdinal = numericOrdinal;
  exports.vulgar = vulgar;
  exports.processFile = processFile;
  exports.walk = walk;
  exports.move = move;
  exports.exit = exit;
  const engine_js_1 = engine;
  const engine_setup_js_1 = engine_setup;
  const EngineConst = engine_const;
  const FileUtil = file_util;
  const ProcessorFactory = processor_factory;
  const system_external_js_1 = system_external;
  const variables_js_1 = variables;
  const math_map_js_1 = math_map;
  exports.version = variables_js_1.Variables.VERSION;
  function setupEngine(feature) {
    return __awaiter(this, void 0, void 0, function* () {
      return (0, engine_setup_js_1.setup)(feature);
    });
  }
  function engineSetup() {
    const engineFeatures = ['mode'].concat(engine_js_1.Engine.STRING_FEATURES, engine_js_1.Engine.BINARY_FEATURES);
    const engine = engine_js_1.Engine.getInstance();
    const features = {};
    engineFeatures.forEach(function (x) {
      features[x] = engine[x];
    });
    features.json = system_external_js_1.SystemExternal.jsonPath;
    features.xpath = system_external_js_1.SystemExternal.WGXpath;
    features.rules = engine.ruleSets.slice();
    return features;
  }
  function engineReady() {
    return __awaiter(this, void 0, void 0, function* () {
      return setupEngine({}).then(() => engine_js_1.EnginePromise.getall());
    });
  }
  exports.localeLoader = math_map_js_1.standardLoader;
  function toSpeech(expr) {
    return processString('speech', expr);
  }
  function toSemantic(expr) {
    return processString('semantic', expr);
  }
  function toJson(expr) {
    return processString('json', expr);
  }
  function toDescription(expr) {
    return processString('description', expr);
  }
  function toEnriched(expr) {
    return processString('enriched', expr);
  }
  function number(expr) {
    return processString('number', expr);
  }
  function ordinal(expr) {
    return processString('ordinal', expr);
  }
  function numericOrdinal(expr) {
    return processString('numericOrdinal', expr);
  }
  function vulgar(expr) {
    return processString('vulgar', expr);
  }
  function processString(processor, input) {
    return ProcessorFactory.process(processor, input);
  }
  exports.file = {};
  exports.file.toSpeech = function (input, opt_output) {
    return processFile('speech', input, opt_output);
  };
  exports.file.toSemantic = function (input, opt_output) {
    return processFile('semantic', input, opt_output);
  };
  exports.file.toJson = function (input, opt_output) {
    return processFile('json', input, opt_output);
  };
  exports.file.toDescription = function (input, opt_output) {
    return processFile('description', input, opt_output);
  };
  exports.file.toEnriched = function (input, opt_output) {
    return processFile('enriched', input, opt_output);
  };
  function processFile(processor, input, opt_output) {
    switch (engine_js_1.Engine.getInstance().mode) {
      case EngineConst.Mode.ASYNC:
        return processFileAsync(processor, input, opt_output);
      case EngineConst.Mode.SYNC:
        return processFileSync(processor, input, opt_output);
      default:
        throw new engine_js_1.SREError(`Can process files in ${engine_js_1.Engine.getInstance().mode} mode`);
    }
  }
  function processFileSync(processor, input, opt_output) {
    const expr = inputFileSync_(input);
    const result = ProcessorFactory.output(processor, expr);
    if (opt_output) {
      try {
        system_external_js_1.SystemExternal.fs.writeFileSync(opt_output, result);
      } catch (_err) {
        throw new engine_js_1.SREError('Can not write to file: ' + opt_output);
      }
    }
    return result;
  }
  function inputFileSync_(file) {
    let expr;
    try {
      expr = system_external_js_1.SystemExternal.fs.readFileSync(file, {
        encoding: 'utf8'
      });
    } catch (_err) {
      throw new engine_js_1.SREError('Can not open file: ' + file);
    }
    return expr;
  }
  function processFileAsync(processor, file, output) {
    return __awaiter(this, void 0, void 0, function* () {
      const expr = yield system_external_js_1.SystemExternal.fs.promises.readFile(file, {
        encoding: 'utf8'
      });
      const result = ProcessorFactory.output(processor, expr);
      if (output) {
        try {
          system_external_js_1.SystemExternal.fs.promises.writeFile(output, result);
        } catch (_err) {
          throw new engine_js_1.SREError('Can not write to file: ' + output);
        }
      }
      return result;
    });
  }
  function walk(expr) {
    return ProcessorFactory.output('walker', expr);
  }
  function move(direction) {
    return ProcessorFactory.keypress('move', direction);
  }
  function exit(opt_value) {
    const value = opt_value || 0;
    engine_js_1.EnginePromise.getall().then(() => process.exit(value));
  }
  exports.localePath = FileUtil.localePath;
  if (system_external_js_1.SystemExternal.documentSupported) {
    setupEngine({
      mode: EngineConst.Mode.HTTP
    }).then(() => setupEngine({}));
  } else {
    setupEngine({
      mode: EngineConst.Mode.SYNC
    }).then(() => setupEngine({
      mode: EngineConst.Mode.ASYNC
    }));
  }
})(system);
getDefaultExportFromCjs(system);

var mathmaps = {};

Object.defineProperty(mathmaps, "__esModule", {
  value: true
});
var MathMaps = new Map();
mathmaps.default = MathMaps;

(function (exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  });
  var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || (function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  });
  var __generator = commonjsGlobal && commonjsGlobal.__generator || (function (thisArg, body) {
    var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    }, f, y, t, g;
    return (g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g);
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_) try {
        if ((f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)) return t;
        if ((y = 0, t)) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.sreReady = exports.Sre = void 0;
  var Api = __importStar(system);
  var WalkerFactory = __importStar(walker_factory);
  var SpeechGeneratorFactory = __importStar(speech_generator_factory);
  var EngineConst = __importStar(engine_const);
  var engine_js_1 = __importDefault(engine);
  var clearspeak_preferences_js_1 = clearspeak_preferences;
  var HighlighterFactory = __importStar(highlighter_factory);
  var variables_js_1 = variables;
  var mathmaps_js_1 = __importDefault(mathmaps);
  var Sre;
  (function (Sre) {
    Sre.locales = variables_js_1.Variables.LOCALES;
    Sre.sreReady = Api.engineReady;
    Sre.setupEngine = Api.setupEngine;
    Sre.engineSetup = Api.engineSetup;
    Sre.toEnriched = Api.toEnriched;
    Sre.toSpeech = Api.toSpeech;
    Sre.clearspeakPreferences = clearspeak_preferences_js_1.ClearspeakPreferences;
    Sre.getHighlighter = HighlighterFactory.highlighter;
    Sre.getSpeechGenerator = SpeechGeneratorFactory.generator;
    Sre.getWalker = WalkerFactory.walker;
    Sre.clearspeakStyle = function () {
      return EngineConst.DOMAIN_TO_STYLES['clearspeak'];
    };
    Sre.preloadLocales = function (locale) {
      return __awaiter(this, void 0, void 0, function () {
        var json;
        return __generator(this, function (_a) {
          json = mathmaps_js_1.default.get(locale);
          return [2, json ? new Promise(function (res, _rej) {
            return res(JSON.stringify(json));
          }) : Api.localeLoader()(locale)];
        });
      });
    };
  })(Sre = exports.Sre || (exports.Sre = {}));
  exports.sreReady = Sre.sreReady;
  engine_js_1.default.getInstance().delay = true;
  exports.default = Sre;
})(sre);
getDefaultExportFromCjs(sre);

var __extends$1K = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$d = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$d = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$d.apply(this, arguments);
});
var __values$O = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$V = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$u = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$L = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(semanticEnrich, "__esModule", {
  value: true
});
var EnrichHandler_1 = semanticEnrich.EnrichHandler = semanticEnrich.EnrichedMathDocumentMixin = semanticEnrich.EnrichedMathItemMixin = void 0;
var mathjax_js_1$4 = mathjax;
var MathItem_js_1$6 = MathItem;
var SerializedMmlVisitor_js_1$1 = SerializedMmlVisitor;
var Options_js_1$h = Options;
var sre_js_1$1 = __importDefault$L(sre);
var currentSpeech = 'none';
(0, MathItem_js_1$6.newState)('ENRICHED', 30);
(0, MathItem_js_1$6.newState)('ATTACHSPEECH', 155);
function EnrichedMathItemMixin(BaseMathItem, MmlJax, toMathML) {
  return (function (_super) {
    __extends$1K(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.serializeMml = function (node) {
      if (('outerHTML' in node)) {
        return node.outerHTML;
      }
      if (typeof Element !== 'undefined' && typeof window !== 'undefined' && node instanceof Element) {
        var div = window.document.createElement('div');
        div.appendChild(node);
        return div.innerHTML;
      }
      return node.toString();
    };
    class_1.prototype.enrich = function (document, force) {
      if (force === void 0) {
        force = false;
      }
      if (this.state() >= MathItem_js_1$6.STATE.ENRICHED) return;
      if (!this.isEscaped && (document.options.enableEnrichment || force)) {
        if (document.options.sre.speech !== currentSpeech) {
          currentSpeech = document.options.sre.speech;
          mathjax_js_1$4.mathjax.retryAfter(sre_js_1$1.default.setupEngine(document.options.sre).then(function () {
            return sre_js_1$1.default.sreReady();
          }));
        }
        var math = new document.options.MathItem('', MmlJax);
        try {
          var mml = this.inputData.originalMml = toMathML(this.root);
          math.math = this.serializeMml(sre_js_1$1.default.toEnriched(mml));
          math.display = this.display;
          math.compile(document);
          this.root = math.root;
          this.inputData.enrichedMml = math.math;
        } catch (err) {
          document.options.enrichError(document, this, err);
        }
      }
      this.state(MathItem_js_1$6.STATE.ENRICHED);
    };
    class_1.prototype.attachSpeech = function (document) {
      var e_1, _a;
      if (this.state() >= MathItem_js_1$6.STATE.ATTACHSPEECH) return;
      var attributes = this.root.attributes;
      var speech = attributes.get('aria-label') || this.getSpeech(this.root);
      if (speech) {
        var adaptor = document.adaptor;
        var node = this.typesetRoot;
        adaptor.setAttribute(node, 'aria-label', speech);
        try {
          for (var _b = __values$O(adaptor.childNodes(node)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            adaptor.setAttribute(child, 'aria-hidden', 'true');
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
      this.state(MathItem_js_1$6.STATE.ATTACHSPEECH);
    };
    class_1.prototype.getSpeech = function (node) {
      var e_2, _a;
      var attributes = node.attributes;
      if (!attributes) return '';
      var speech = attributes.getExplicit('data-semantic-speech');
      if (!attributes.getExplicit('data-semantic-parent') && speech) {
        return speech;
      }
      try {
        for (var _b = __values$O(node.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          var value = this.getSpeech(child);
          if (value != null) {
            return value;
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      return '';
    };
    return class_1;
  })(BaseMathItem);
}
semanticEnrich.EnrichedMathItemMixin = EnrichedMathItemMixin;
function EnrichedMathDocumentMixin(BaseDocument, MmlJax) {
  var _a;
  return (_a = (function (_super) {
    __extends$1K(class_2, _super);
    function class_2() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$u([], __read$V(args), false)) || this;
      MmlJax.setMmlFactory(_this.mmlFactory);
      var ProcessBits = _this.constructor.ProcessBits;
      if (!ProcessBits.has('enriched')) {
        ProcessBits.allocate('enriched');
        ProcessBits.allocate('attach-speech');
      }
      var visitor = new SerializedMmlVisitor_js_1$1.SerializedMmlVisitor(_this.mmlFactory);
      var toMathML = function (node) {
        return visitor.visitTree(node);
      };
      _this.options.MathItem = EnrichedMathItemMixin(_this.options.MathItem, MmlJax, toMathML);
      return _this;
    }
    class_2.prototype.attachSpeech = function () {
      var e_3, _a;
      if (!this.processed.isSet('attach-speech')) {
        try {
          for (var _b = __values$O(this.math), _c = _b.next(); !_c.done; _c = _b.next()) {
            var math = _c.value;
            math.attachSpeech(this);
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
        this.processed.set('attach-speech');
      }
      return this;
    };
    class_2.prototype.enrich = function () {
      var e_4, _a;
      if (!this.processed.isSet('enriched')) {
        if (this.options.enableEnrichment) {
          try {
            for (var _b = __values$O(this.math), _c = _b.next(); !_c.done; _c = _b.next()) {
              var math = _c.value;
              math.enrich(this);
            }
          } catch (e_4_1) {
            e_4 = {
              error: e_4_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_4) throw e_4.error;
            }
          }
        }
        this.processed.set('enriched');
      }
      return this;
    };
    class_2.prototype.enrichError = function (_doc, _math, err) {
      console.warn('Enrichment error:', err);
    };
    class_2.prototype.state = function (state, restore) {
      if (restore === void 0) {
        restore = false;
      }
      _super.prototype.state.call(this, state, restore);
      if (state < MathItem_js_1$6.STATE.ENRICHED) {
        this.processed.clear('enriched');
      }
      return this;
    };
    return class_2;
  })(BaseDocument), _a.OPTIONS = __assign$d(__assign$d({}, BaseDocument.OPTIONS), {
    enableEnrichment: true,
    enrichError: function (doc, math, err) {
      return doc.enrichError(doc, math, err);
    },
    renderActions: (0, Options_js_1$h.expandable)(__assign$d(__assign$d({}, BaseDocument.OPTIONS.renderActions), {
      enrich: [MathItem_js_1$6.STATE.ENRICHED],
      attachSpeech: [MathItem_js_1$6.STATE.ATTACHSPEECH]
    })),
    sre: (0, Options_js_1$h.expandable)({
      speech: 'none',
      domain: 'mathspeak',
      style: 'default',
      locale: 'en'
    })
  }), _a);
}
semanticEnrich.EnrichedMathDocumentMixin = EnrichedMathDocumentMixin;
function EnrichHandler(handler, MmlJax) {
  MmlJax.setAdaptor(handler.adaptor);
  handler.documentClass = EnrichedMathDocumentMixin(handler.documentClass, MmlJax);
  return handler;
}
EnrichHandler_1 = semanticEnrich.EnrichHandler = EnrichHandler;

var MenuHandler$1 = {};

var Menu$1 = {};

var MJContextMenu$1 = {};

var context_menu = {};

var abstract_menu = {};

var abstract_postable = {};

var menu_element = {};

var abstract_navigatable = {};

var key_navigatable = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.KEY = void 0;
  (function (KEY) {
    KEY[KEY["RETURN"] = 13] = "RETURN";
    KEY[KEY["ESCAPE"] = 27] = "ESCAPE";
    KEY[KEY["SPACE"] = 32] = "SPACE";
    KEY[KEY["LEFT"] = 37] = "LEFT";
    KEY[KEY["UP"] = 38] = "UP";
    KEY[KEY["RIGHT"] = 39] = "RIGHT";
    KEY[KEY["DOWN"] = 40] = "DOWN";
  })(exports.KEY || (exports.KEY = {}));
})(key_navigatable);
getDefaultExportFromCjs(key_navigatable);

var mouse_navigatable = {};

Object.defineProperty(mouse_navigatable, "__esModule", {
  value: true
});
mouse_navigatable.MOUSE = void 0;
mouse_navigatable.MOUSE = {
  CLICK: 'click',
  DBLCLICK: 'dblclick',
  DOWN: 'mousedown',
  UP: 'mouseup',
  OVER: 'mouseover',
  OUT: 'mouseout',
  MOVE: 'mousemove',
  SELECTEND: 'selectend',
  SELECTSTART: 'selectstart'
};

Object.defineProperty(abstract_navigatable, "__esModule", {
  value: true
});
abstract_navigatable.AbstractNavigatable = void 0;
var key_navigatable_js_1$3 = key_navigatable;
var mouse_navigatable_js_1 = mouse_navigatable;
var AbstractNavigatable = (function () {
  function AbstractNavigatable() {
    this.bubble = false;
  }
  AbstractNavigatable.prototype.bubbleKey = function () {
    this.bubble = true;
  };
  AbstractNavigatable.prototype.keydown = function (event) {
    switch (event.keyCode) {
      case key_navigatable_js_1$3.KEY.ESCAPE:
        this.escape(event);
        break;
      case key_navigatable_js_1$3.KEY.RIGHT:
        this.right(event);
        break;
      case key_navigatable_js_1$3.KEY.LEFT:
        this.left(event);
        break;
      case key_navigatable_js_1$3.KEY.UP:
        this.up(event);
        break;
      case key_navigatable_js_1$3.KEY.DOWN:
        this.down(event);
        break;
      case key_navigatable_js_1$3.KEY.RETURN:
      case key_navigatable_js_1$3.KEY.SPACE:
        this.space(event);
        break;
      default:
        return;
    }
    this.bubble ? this.bubble = false : this.stop(event);
  };
  AbstractNavigatable.prototype.escape = function (_event) {};
  AbstractNavigatable.prototype.space = function (_event) {};
  AbstractNavigatable.prototype.left = function (_event) {};
  AbstractNavigatable.prototype.right = function (_event) {};
  AbstractNavigatable.prototype.up = function (_event) {};
  AbstractNavigatable.prototype.down = function (_event) {};
  AbstractNavigatable.prototype.stop = function (event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
      event.cancelBubble = true;
    }
  };
  AbstractNavigatable.prototype.mousedown = function (event) {
    return this.stop(event);
  };
  AbstractNavigatable.prototype.mouseup = function (event) {
    return this.stop(event);
  };
  AbstractNavigatable.prototype.mouseover = function (event) {
    return this.stop(event);
  };
  AbstractNavigatable.prototype.mouseout = function (event) {
    return this.stop(event);
  };
  AbstractNavigatable.prototype.click = function (event) {
    return this.stop(event);
  };
  AbstractNavigatable.prototype.addEvents = function (element) {
    element.addEventListener(mouse_navigatable_js_1.MOUSE.DOWN, this.mousedown.bind(this));
    element.addEventListener(mouse_navigatable_js_1.MOUSE.UP, this.mouseup.bind(this));
    element.addEventListener(mouse_navigatable_js_1.MOUSE.OVER, this.mouseover.bind(this));
    element.addEventListener(mouse_navigatable_js_1.MOUSE.OUT, this.mouseout.bind(this));
    element.addEventListener(mouse_navigatable_js_1.MOUSE.CLICK, this.click.bind(this));
    element.addEventListener('keydown', this.keydown.bind(this));
    element.addEventListener('dragstart', this.stop.bind(this));
    element.addEventListener(mouse_navigatable_js_1.MOUSE.SELECTSTART, this.stop.bind(this));
    element.addEventListener('contextmenu', this.stop.bind(this));
    element.addEventListener(mouse_navigatable_js_1.MOUSE.DBLCLICK, this.stop.bind(this));
  };
  return AbstractNavigatable;
})();
abstract_navigatable.AbstractNavigatable = AbstractNavigatable;

var __extends$1J = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(menu_element, "__esModule", {
  value: true
});
menu_element.MenuElement = void 0;
var abstract_navigatable_js_1 = abstract_navigatable;
var MenuElement = (function (_super) {
  __extends$1J(MenuElement, _super);
  function MenuElement() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MenuElement.prototype.addAttributes = function (attributes) {
    for (var attr in attributes) {
      this.html.setAttribute(attr, attributes[attr]);
    }
  };
  Object.defineProperty(MenuElement.prototype, "html", {
    get: function () {
      if (!this._html) {
        this.generateHtml();
      }
      return this._html;
    },
    set: function (html) {
      this._html = html;
      this.addEvents(html);
    },
    enumerable: false,
    configurable: true
  });
  MenuElement.prototype.generateHtml = function () {
    var html = document.createElement('div');
    html.classList.add(this.className);
    html.setAttribute('role', this.role);
    this.html = html;
  };
  MenuElement.prototype.focus = function () {
    var html = this.html;
    html.setAttribute('tabindex', '0');
    html.focus();
  };
  MenuElement.prototype.unfocus = function () {
    var html = this.html;
    if (html.hasAttribute('tabindex')) {
      html.setAttribute('tabindex', '-1');
    }
    try {
      html.blur();
    } catch (e) {}
    html.blur();
  };
  return MenuElement;
})(abstract_navigatable_js_1.AbstractNavigatable);
menu_element.MenuElement = MenuElement;

var __extends$1I = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(abstract_postable, "__esModule", {
  value: true
});
abstract_postable.AbstractPostable = void 0;
var menu_element_js_1$1 = menu_element;
var AbstractPostable = (function (_super) {
  __extends$1I(AbstractPostable, _super);
  function AbstractPostable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.posted = false;
    return _this;
  }
  AbstractPostable.prototype.isPosted = function () {
    return this.posted;
  };
  AbstractPostable.prototype.post = function (x, y) {
    if (this.posted) {
      return;
    }
    if (typeof x !== 'undefined' && typeof y !== 'undefined') {
      this.html.setAttribute('style', 'left: ' + x + 'px; top: ' + y + 'px;');
    }
    this.display();
    this.posted = true;
  };
  AbstractPostable.prototype.unpost = function () {
    if (!this.posted) {
      return;
    }
    var html = this.html;
    if (html.parentNode) {
      html.parentNode.removeChild(html);
    }
    this.posted = false;
  };
  return AbstractPostable;
})(menu_element_js_1$1.MenuElement);
abstract_postable.AbstractPostable = AbstractPostable;

var abstract_item = {};

var abstract_entry = {};

var html_classes = {};

Object.defineProperty(html_classes, "__esModule", {
  value: true
});
html_classes.HtmlAttrs = html_classes.HtmlClasses = void 0;
var PREFIX = 'CtxtMenu';
function prefix_(name) {
  return PREFIX + '_' + name;
}
function prefixClass_(name) {
  return prefix_(name);
}
function prefixAttr_(name) {
  return prefix_(name);
}
html_classes.HtmlClasses = {
  ATTACHED: prefixClass_('Attached'),
  CONTEXTMENU: prefixClass_('ContextMenu'),
  MENU: prefixClass_('Menu'),
  MENUARROW: prefixClass_('MenuArrow'),
  MENUACTIVE: prefixClass_('MenuActive'),
  MENUCHECK: prefixClass_('MenuCheck'),
  MENUCLOSE: prefixClass_('MenuClose'),
  MENUCOMBOBOX: prefixClass_('MenuComboBox'),
  MENUDISABLED: prefixClass_('MenuDisabled'),
  MENUFRAME: prefixClass_('MenuFrame'),
  MENUITEM: prefixClass_('MenuItem'),
  MENULABEL: prefixClass_('MenuLabel'),
  MENURADIOCHECK: prefixClass_('MenuRadioCheck'),
  MENUINPUTBOX: prefixClass_('MenuInputBox'),
  MENURULE: prefixClass_('MenuRule'),
  MENUSLIDER: prefixClass_('MenuSlider'),
  MOUSEPOST: prefixClass_('MousePost'),
  RTL: prefixClass_('RTL'),
  INFO: prefixClass_('Info'),
  INFOCLOSE: prefixClass_('InfoClose'),
  INFOCONTENT: prefixClass_('InfoContent'),
  INFOSIGNATURE: prefixClass_('InfoSignature'),
  INFOTITLE: prefixClass_('InfoTitle'),
  SLIDERVALUE: prefixClass_('SliderValue'),
  SLIDERBAR: prefixClass_('SliderBar'),
  SELECTION: prefixClass_('Selection'),
  SELECTIONBOX: prefixClass_('SelectionBox'),
  SELECTIONMENU: prefixClass_('SelectionMenu'),
  SELECTIONDIVIDER: prefixClass_('SelectionDivider'),
  SELECTIONITEM: prefixClass_('SelectionItem')
};
html_classes.HtmlAttrs = {
  COUNTER: prefixAttr_('Counter'),
  KEYDOWNFUNC: prefixAttr_('keydownFunc'),
  CONTEXTMENUFUNC: prefixAttr_('contextmenuFunc'),
  OLDTAB: prefixAttr_('Oldtabindex'),
  TOUCHFUNC: prefixAttr_('TouchFunc')
};

var __extends$1H = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(abstract_entry, "__esModule", {
  value: true
});
abstract_entry.AbstractEntry = void 0;
var menu_element_js_1 = menu_element;
var html_classes_js_1$f = html_classes;
var AbstractEntry = (function (_super) {
  __extends$1H(AbstractEntry, _super);
  function AbstractEntry(_menu, _type) {
    var _this = _super.call(this) || this;
    _this._menu = _menu;
    _this._type = _type;
    _this.className = html_classes_js_1$f.HtmlClasses['MENUITEM'];
    _this.role = 'menuitem';
    _this.hidden = false;
    return _this;
  }
  Object.defineProperty(AbstractEntry.prototype, "menu", {
    get: function () {
      return this._menu;
    },
    set: function (menu) {
      this._menu = menu;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AbstractEntry.prototype, "type", {
    get: function () {
      return this._type;
    },
    enumerable: false,
    configurable: true
  });
  AbstractEntry.prototype.hide = function () {
    this.hidden = true;
    this.menu.generateMenu();
  };
  AbstractEntry.prototype.show = function () {
    this.hidden = false;
    this.menu.generateMenu();
  };
  AbstractEntry.prototype.isHidden = function () {
    return this.hidden;
  };
  return AbstractEntry;
})(menu_element_js_1.MenuElement);
abstract_entry.AbstractEntry = AbstractEntry;

var menu_util = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MenuUtil = void 0;
  (function (MenuUtil) {
    function close(item) {
      var menu = item.menu;
      if (menu.baseMenu) {
        menu.baseMenu.unpost();
      } else {
        menu.unpost();
      }
    }
    MenuUtil.close = close;
    function getActiveElement(item) {
      var menu = item.menu;
      var baseMenu = menu.baseMenu ? menu.baseMenu : menu;
      return baseMenu.store.active;
    }
    MenuUtil.getActiveElement = getActiveElement;
    function error(_error, msg) {
      console.error('ContextMenu Error: ' + msg);
    }
    MenuUtil.error = error;
    function counter() {
      return count++;
    }
    MenuUtil.counter = counter;
    var count = 0;
  })(exports.MenuUtil || (exports.MenuUtil = {}));
})(menu_util);
getDefaultExportFromCjs(menu_util);

var __extends$1G = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$N = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(abstract_item, "__esModule", {
  value: true
});
abstract_item.AbstractItem = void 0;
var abstract_entry_js_1$1 = abstract_entry;
var menu_util_js_1$8 = menu_util;
var html_classes_js_1$e = html_classes;
var AbstractItem = (function (_super) {
  __extends$1G(AbstractItem, _super);
  function AbstractItem(menu, type, _content, id) {
    var _this = _super.call(this, menu, type) || this;
    _this._content = _content;
    _this.disabled = false;
    _this.callbacks = [];
    _this._id = id ? id : _content;
    return _this;
  }
  Object.defineProperty(AbstractItem.prototype, "content", {
    get: function () {
      return this._content;
    },
    set: function (content) {
      this._content = content;
      this.generateHtml();
      if (this.menu) {
        this.menu.generateHtml();
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AbstractItem.prototype, "id", {
    get: function () {
      return this._id;
    },
    enumerable: false,
    configurable: true
  });
  AbstractItem.prototype.press = function () {
    if (!this.disabled) {
      this.executeAction();
      this.executeCallbacks_();
    }
  };
  AbstractItem.prototype.executeAction = function () {};
  AbstractItem.prototype.registerCallback = function (func) {
    if (this.callbacks.indexOf(func) === -1) {
      this.callbacks.push(func);
    }
  };
  AbstractItem.prototype.unregisterCallback = function (func) {
    var index = this.callbacks.indexOf(func);
    if (index !== -1) {
      this.callbacks.splice(index, 1);
    }
  };
  AbstractItem.prototype.mousedown = function (event) {
    this.press();
    this.stop(event);
  };
  AbstractItem.prototype.mouseover = function (event) {
    this.focus();
    this.stop(event);
  };
  AbstractItem.prototype.mouseout = function (event) {
    this.deactivate();
    this.stop(event);
  };
  AbstractItem.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    html.setAttribute('aria-disabled', 'false');
    html.textContent = this.content;
  };
  AbstractItem.prototype.activate = function () {
    if (!this.disabled) {
      this.html.classList.add(html_classes_js_1$e.HtmlClasses['MENUACTIVE']);
    }
  };
  AbstractItem.prototype.deactivate = function () {
    this.html.classList.remove(html_classes_js_1$e.HtmlClasses['MENUACTIVE']);
  };
  AbstractItem.prototype.focus = function () {
    this.menu.focused = this;
    _super.prototype.focus.call(this);
    this.activate();
  };
  AbstractItem.prototype.unfocus = function () {
    this.deactivate();
    _super.prototype.unfocus.call(this);
  };
  AbstractItem.prototype.escape = function (_event) {
    menu_util_js_1$8.MenuUtil.close(this);
  };
  AbstractItem.prototype.up = function (event) {
    this.menu.up(event);
  };
  AbstractItem.prototype.down = function (event) {
    this.menu.down(event);
  };
  AbstractItem.prototype.left = function (event) {
    this.menu.left(event);
  };
  AbstractItem.prototype.right = function (event) {
    this.menu.right(event);
  };
  AbstractItem.prototype.space = function (_event) {
    this.press();
  };
  AbstractItem.prototype.disable = function () {
    this.disabled = true;
    var html = this.html;
    html.classList.add(html_classes_js_1$e.HtmlClasses['MENUDISABLED']);
    html.setAttribute('aria-disabled', 'true');
  };
  AbstractItem.prototype.enable = function () {
    this.disabled = false;
    var html = this.html;
    html.classList.remove(html_classes_js_1$e.HtmlClasses['MENUDISABLED']);
    html.removeAttribute('aria-disabled');
  };
  AbstractItem.prototype.executeCallbacks_ = function () {
    var e_1, _a;
    try {
      for (var _b = __values$N(this.callbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
        var func = _c.value;
        try {
          func(this);
        } catch (e) {
          menu_util_js_1$8.MenuUtil.error(e, 'Callback for menu entry ' + this.id + ' failed.');
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  return AbstractItem;
})(abstract_entry_js_1$1.AbstractEntry);
abstract_item.AbstractItem = AbstractItem;

var item_submenu = {};

var __extends$1F = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_submenu, "__esModule", {
  value: true
});
item_submenu.Submenu = void 0;
var abstract_item_js_1$4 = abstract_item;
var html_classes_js_1$d = html_classes;
var Submenu = (function (_super) {
  __extends$1F(Submenu, _super);
  function Submenu(menu, content, id) {
    var _this = _super.call(this, menu, 'submenu', content, id) || this;
    _this._submenu = null;
    return _this;
  }
  Submenu.fromJson = function (factory, _a, menu) {
    var content = _a.content, submenu = _a.menu, id = _a.id;
    var item = new this(menu, content, id);
    var sm = factory.get('subMenu')(factory, submenu, item);
    item.submenu = sm;
    return item;
  };
  Object.defineProperty(Submenu.prototype, "submenu", {
    get: function () {
      return this._submenu;
    },
    set: function (menu) {
      this._submenu = menu;
    },
    enumerable: false,
    configurable: true
  });
  Submenu.prototype.mouseover = function (event) {
    this.focus();
    this.stop(event);
  };
  Submenu.prototype.mouseout = function (event) {
    this.stop(event);
  };
  Submenu.prototype.unfocus = function () {
    if (!this.submenu.isPosted()) {
      _super.prototype.unfocus.call(this);
      return;
    }
    if (this.menu.focused !== this) {
      _super.prototype.unfocus.call(this);
      this.menu.unpostSubmenus();
      return;
    }
    this.html.setAttribute('tabindex', '-1');
    this.html.blur();
  };
  Submenu.prototype.focus = function () {
    _super.prototype.focus.call(this);
    if (!this.submenu.isPosted() && !this.disabled) {
      this.submenu.post();
    }
  };
  Submenu.prototype.executeAction = function () {
    this.submenu.isPosted() ? this.submenu.unpost() : this.submenu.post();
  };
  Submenu.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    this.span = document.createElement('span');
    this.span.textContent = '\u25BA';
    this.span.classList.add(html_classes_js_1$d.HtmlClasses['MENUARROW']);
    html.appendChild(this.span);
    html.setAttribute('aria-haspopup', 'true');
  };
  Submenu.prototype.left = function (event) {
    if (this.submenu.isPosted()) {
      this.submenu.unpost();
    } else {
      _super.prototype.left.call(this, event);
    }
  };
  Submenu.prototype.right = function (event) {
    if (!this.submenu.isPosted()) {
      this.submenu.post();
    } else {
      this.submenu.down(event);
    }
  };
  Submenu.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Submenu;
})(abstract_item_js_1$4.AbstractItem);
item_submenu.Submenu = Submenu;

var __extends$1E = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$M = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(abstract_menu, "__esModule", {
  value: true
});
abstract_menu.AbstractMenu = void 0;
var abstract_postable_js_1$2 = abstract_postable;
var abstract_item_js_1$3 = abstract_item;
var html_classes_js_1$c = html_classes;
var item_submenu_js_1$2 = item_submenu;
var AbstractMenu = (function (_super) {
  __extends$1E(AbstractMenu, _super);
  function AbstractMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.className = html_classes_js_1$c.HtmlClasses['CONTEXTMENU'];
    _this.role = 'menu';
    _this._items = [];
    _this._baseMenu = null;
    return _this;
  }
  Object.defineProperty(AbstractMenu.prototype, "baseMenu", {
    get: function () {
      return this._baseMenu;
    },
    set: function (menu) {
      this._baseMenu = menu;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AbstractMenu.prototype, "items", {
    get: function () {
      return this._items;
    },
    set: function (items) {
      this._items = items;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AbstractMenu.prototype, "pool", {
    get: function () {
      return this.variablePool;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AbstractMenu.prototype, "focused", {
    get: function () {
      return this._focused;
    },
    set: function (item) {
      if (this._focused === item) {
        return;
      }
      if (!this._focused) {
        this.unfocus();
      }
      var old = this._focused;
      this._focused = item;
      if (old) {
        old.unfocus();
      }
    },
    enumerable: false,
    configurable: true
  });
  AbstractMenu.prototype.up = function (_event) {
    var items = this.items.filter(function (x) {
      return x instanceof abstract_item_js_1$3.AbstractItem && !x.isHidden();
    });
    if (items.length === 0) {
      return;
    }
    if (!this.focused) {
      items[items.length - 1].focus();
      return;
    }
    var index = items.indexOf(this.focused);
    if (index === -1) {
      return;
    }
    index = index ? --index : items.length - 1;
    items[index].focus();
  };
  AbstractMenu.prototype.down = function (_event) {
    var items = this.items.filter(function (x) {
      return x instanceof abstract_item_js_1$3.AbstractItem && !x.isHidden();
    });
    if (items.length === 0) {
      return;
    }
    if (!this.focused) {
      items[0].focus();
      return;
    }
    var index = items.indexOf(this.focused);
    if (index === -1) {
      return;
    }
    index++;
    index = index === items.length ? 0 : index;
    items[index].focus();
  };
  AbstractMenu.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    this.generateMenu();
  };
  AbstractMenu.prototype.generateMenu = function () {
    var e_1, _a;
    var html = this.html;
    html.classList.add(html_classes_js_1$c.HtmlClasses['MENU']);
    try {
      for (var _b = __values$M(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
        var item = _c.value;
        if (!item.isHidden()) {
          html.appendChild(item.html);
          continue;
        }
        var itemHtml = item.html;
        if (itemHtml.parentNode) {
          itemHtml.parentNode.removeChild(itemHtml);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  AbstractMenu.prototype.post = function (x, y) {
    this.variablePool.update();
    _super.prototype.post.call(this, x, y);
  };
  AbstractMenu.prototype.unpostSubmenus = function () {
    var e_2, _a;
    var submenus = this.items.filter(function (x) {
      return x instanceof item_submenu_js_1$2.Submenu;
    });
    try {
      for (var submenus_1 = __values$M(submenus), submenus_1_1 = submenus_1.next(); !submenus_1_1.done; submenus_1_1 = submenus_1.next()) {
        var submenu = submenus_1_1.value;
        submenu.submenu.unpost();
        if (submenu !== this.focused) {
          submenu.unfocus();
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (submenus_1_1 && !submenus_1_1.done && (_a = submenus_1.return)) _a.call(submenus_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  AbstractMenu.prototype.unpost = function () {
    _super.prototype.unpost.call(this);
    this.unpostSubmenus();
    this.focused = null;
  };
  AbstractMenu.prototype.find = function (id) {
    var e_3, _a;
    try {
      for (var _b = __values$M(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
        var item = _c.value;
        if (item.type === 'rule') {
          continue;
        }
        if (item.id === id) {
          return item;
        }
        if (item.type === 'submenu') {
          var result = item.submenu.find(id);
          if (result) {
            return result;
          }
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return null;
  };
  return AbstractMenu;
})(abstract_postable_js_1$2.AbstractPostable);
abstract_menu.AbstractMenu = AbstractMenu;

var menu_store = {};

var __values$L = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(menu_store, "__esModule", {
  value: true
});
menu_store.MenuStore = void 0;
var menu_util_js_1$7 = menu_util;
var html_classes_js_1$b = html_classes;
var key_navigatable_js_1$2 = key_navigatable;
var MenuStore = (function () {
  function MenuStore(menu) {
    this.menu = menu;
    this.store = [];
    this._active = null;
    this.counter = 0;
    this.attachedClass = html_classes_js_1$b.HtmlClasses['ATTACHED'] + '_' + menu_util_js_1$7.MenuUtil.counter();
    this.taborder = true;
    this.attrMap = {};
  }
  Object.defineProperty(MenuStore.prototype, "active", {
    get: function () {
      return this._active;
    },
    set: function (element) {
      do {
        if (this.store.indexOf(element) !== -1) {
          this._active = element;
          break;
        }
        element = element.parentNode;
      } while (element);
    },
    enumerable: false,
    configurable: true
  });
  MenuStore.prototype.next = function () {
    var length = this.store.length;
    if (length === 0) {
      this.active = null;
      return null;
    }
    var index = this.store.indexOf(this.active);
    index = index === -1 ? 0 : index < length - 1 ? index + 1 : 0;
    this.active = this.store[index];
    return this.active;
  };
  MenuStore.prototype.previous = function () {
    var length = this.store.length;
    if (length === 0) {
      this.active = null;
      return null;
    }
    var last = length - 1;
    var index = this.store.indexOf(this.active);
    index = index === -1 ? last : index === 0 ? last : index - 1;
    this.active = this.store[index];
    return this.active;
  };
  MenuStore.prototype.clear = function () {
    this.remove(this.store);
  };
  MenuStore.prototype.insert = function (elementOrList) {
    var e_1, _a;
    var elements = elementOrList instanceof HTMLElement ? [elementOrList] : elementOrList;
    try {
      for (var elements_1 = __values$L(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
        var element = elements_1_1.value;
        this.insertElement(element);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    this.sort();
  };
  MenuStore.prototype.remove = function (elementOrList) {
    var e_2, _a;
    var elements = elementOrList instanceof HTMLElement ? [elementOrList] : elementOrList;
    try {
      for (var elements_2 = __values$L(elements), elements_2_1 = elements_2.next(); !elements_2_1.done; elements_2_1 = elements_2.next()) {
        var element = elements_2_1.value;
        this.removeElement(element);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (elements_2_1 && !elements_2_1.done && (_a = elements_2.return)) _a.call(elements_2);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    this.sort();
  };
  MenuStore.prototype.inTaborder = function (flag) {
    if (this.taborder && !flag) {
      this.removeTaborder();
    }
    if (!this.taborder && flag) {
      this.insertTaborder();
    }
    this.taborder = flag;
  };
  MenuStore.prototype.insertTaborder = function () {
    if (this.taborder) {
      this.insertTaborder_();
    }
  };
  MenuStore.prototype.removeTaborder = function () {
    if (this.taborder) {
      this.removeTaborder_();
    }
  };
  MenuStore.prototype.insertElement = function (element) {
    if (element.classList.contains(this.attachedClass)) {
      return;
    }
    element.classList.add(this.attachedClass);
    if (this.taborder) {
      this.addTabindex(element);
    }
    this.addEvents(element);
  };
  MenuStore.prototype.removeElement = function (element) {
    if (!element.classList.contains(this.attachedClass)) {
      return;
    }
    element.classList.remove(this.attachedClass);
    if (this.taborder) {
      this.removeTabindex(element);
    }
    this.removeEvents(element);
  };
  MenuStore.prototype.sort = function () {
    var nodes = document.getElementsByClassName(this.attachedClass);
    this.store = [].slice.call(nodes);
  };
  MenuStore.prototype.insertTaborder_ = function () {
    this.store.forEach(function (x) {
      return x.setAttribute('tabindex', '0');
    });
  };
  MenuStore.prototype.removeTaborder_ = function () {
    this.store.forEach(function (x) {
      return x.setAttribute('tabindex', '-1');
    });
  };
  MenuStore.prototype.addTabindex = function (element) {
    if (element.hasAttribute('tabindex')) {
      element.setAttribute(html_classes_js_1$b.HtmlAttrs['OLDTAB'], element.getAttribute('tabindex'));
    }
    element.setAttribute('tabindex', '0');
  };
  MenuStore.prototype.removeTabindex = function (element) {
    if (element.hasAttribute(html_classes_js_1$b.HtmlAttrs['OLDTAB'])) {
      element.setAttribute('tabindex', element.getAttribute(html_classes_js_1$b.HtmlAttrs['OLDTAB']));
      element.removeAttribute(html_classes_js_1$b.HtmlAttrs['OLDTAB']);
    } else {
      element.removeAttribute('tabindex');
    }
  };
  MenuStore.prototype.addEvents = function (element) {
    if (element.hasAttribute(html_classes_js_1$b.HtmlAttrs['COUNTER'])) {
      return;
    }
    this.addEvent(element, 'contextmenu', this.menu.post.bind(this.menu));
    this.addEvent(element, 'keydown', this.keydown.bind(this));
    element.setAttribute(html_classes_js_1$b.HtmlAttrs['COUNTER'], this.counter.toString());
    this.counter++;
  };
  MenuStore.prototype.addEvent = function (element, name, func) {
    var attrName = html_classes_js_1$b.HtmlAttrs[name.toUpperCase() + 'FUNC'];
    this.attrMap[attrName + this.counter] = func;
    element.addEventListener(name, func);
  };
  MenuStore.prototype.removeEvents = function (element) {
    if (!element.hasAttribute(html_classes_js_1$b.HtmlAttrs['COUNTER'])) {
      return;
    }
    var counter = element.getAttribute(html_classes_js_1$b.HtmlAttrs['COUNTER']);
    this.removeEvent(element, 'contextmenu', counter);
    this.removeEvent(element, 'keydown', counter);
    element.removeAttribute(html_classes_js_1$b.HtmlAttrs['COUNTER']);
  };
  MenuStore.prototype.removeEvent = function (element, name, counter) {
    var attrName = html_classes_js_1$b.HtmlAttrs[name.toUpperCase() + 'FUNC'];
    var menuFunc = this.attrMap[attrName + counter];
    element.removeEventListener(name, menuFunc);
  };
  MenuStore.prototype.keydown = function (event) {
    if (event.keyCode === key_navigatable_js_1$2.KEY.SPACE) {
      this.menu.post(event);
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  return MenuStore;
})();
menu_store.MenuStore = MenuStore;

var variable_pool = {};

Object.defineProperty(variable_pool, "__esModule", {
  value: true
});
variable_pool.VariablePool = void 0;
var VariablePool = (function () {
  function VariablePool() {
    this.pool = {};
  }
  VariablePool.prototype.insert = function (variable) {
    this.pool[variable.name] = variable;
  };
  VariablePool.prototype.lookup = function (name) {
    return this.pool[name];
  };
  VariablePool.prototype.remove = function (name) {
    delete this.pool[name];
  };
  VariablePool.prototype.update = function () {
    for (var variable in this.pool) {
      this.pool[variable].update();
    }
  };
  return VariablePool;
})();
variable_pool.VariablePool = VariablePool;

var __extends$1D = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(context_menu, "__esModule", {
  value: true
});
context_menu.ContextMenu = void 0;
var abstract_menu_js_1$2 = abstract_menu;
var html_classes_js_1$a = html_classes;
var menu_store_js_1 = menu_store;
var variable_pool_js_1 = variable_pool;
var ContextMenu = (function (_super) {
  __extends$1D(ContextMenu, _super);
  function ContextMenu(factory) {
    var _this = _super.call(this) || this;
    _this.factory = factory;
    _this.id = '';
    _this.moving = false;
    _this._store = new menu_store_js_1.MenuStore(_this);
    _this.widgets = [];
    _this.variablePool = new variable_pool_js_1.VariablePool();
    return _this;
  }
  ContextMenu.fromJson = function (factory, _a) {
    var pool = _a.pool, items = _a.items, _b = _a.id, id = _b === void 0 ? '' : _b;
    var ctxtMenu = new this(factory);
    ctxtMenu.id = id;
    var varParser = factory.get('variable');
    pool.forEach(function (x) {
      return varParser(factory, x, ctxtMenu.pool);
    });
    var itemList = factory.get('items')(factory, items, ctxtMenu);
    ctxtMenu.items = itemList;
    return ctxtMenu;
  };
  ContextMenu.prototype.generateHtml = function () {
    if (this.isPosted()) {
      this.unpost();
    }
    _super.prototype.generateHtml.call(this);
    this._frame = document.createElement('div');
    this._frame.classList.add(html_classes_js_1$a.HtmlClasses['MENUFRAME']);
    var styleString = 'left: 0px; top: 0px; z-index: 200; width: 100%; ' + 'height: 100%; border: 0px; padding: 0px; margin: 0px;';
    this._frame.setAttribute('style', 'position: absolute; ' + styleString);
    var innerDiv = document.createElement('div');
    innerDiv.setAttribute('style', 'position: fixed; ' + styleString);
    this._frame.appendChild(innerDiv);
    innerDiv.addEventListener('mousedown', (function (event) {
      this.unpost();
      this.unpostWidgets();
      this.stop(event);
    }).bind(this));
  };
  ContextMenu.prototype.display = function () {
    document.body.appendChild(this.frame);
    this.frame.appendChild(this.html);
    this.focus();
  };
  ContextMenu.prototype.escape = function (_event) {
    this.unpost();
    this.unpostWidgets();
  };
  ContextMenu.prototype.unpost = function () {
    _super.prototype.unpost.call(this);
    if (this.widgets.length > 0) {
      return;
    }
    this.frame.parentNode.removeChild(this.frame);
    var store = this.store;
    if (!this.moving) {
      store.insertTaborder();
    }
    store.active.focus();
  };
  ContextMenu.prototype.left = function (_event) {
    this.move_(this.store.previous());
  };
  ContextMenu.prototype.right = function (_event) {
    this.move_(this.store.next());
  };
  Object.defineProperty(ContextMenu.prototype, "frame", {
    get: function () {
      return this._frame;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ContextMenu.prototype, "store", {
    get: function () {
      return this._store;
    },
    enumerable: false,
    configurable: true
  });
  ContextMenu.prototype.post = function (numberOrEvent, isY) {
    if (typeof isY !== 'undefined') {
      if (!this.moving) {
        this.store.removeTaborder();
      }
      _super.prototype.post.call(this, numberOrEvent, isY);
      return;
    }
    var event = numberOrEvent;
    var node;
    if (event instanceof Event) {
      node = event.target;
      this.stop(event);
    } else {
      node = event;
    }
    var x;
    var y;
    if (event instanceof MouseEvent) {
      (x = event.pageX, y = event.pageY);
      if (!x && !y && event.clientX) {
        x = event.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        y = event.clientY + document.body.scrollTop + document.documentElement.scrollTop;
      }
    }
    if (!x && !y && node) {
      var offsetX = window.pageXOffset || document.documentElement.scrollLeft;
      var offsetY = window.pageYOffset || document.documentElement.scrollTop;
      var rect = node.getBoundingClientRect();
      x = (rect.right + rect.left) / 2 + offsetX;
      y = (rect.bottom + rect.top) / 2 + offsetY;
    }
    this.store.active = node;
    this.anchor = this.store.active;
    var menu = this.html;
    var margin = 5;
    if (x + menu.offsetWidth > document.body.offsetWidth - margin) {
      x = document.body.offsetWidth - menu.offsetWidth - margin;
    }
    this.post(x, y);
  };
  ContextMenu.prototype.registerWidget = function (widget) {
    this.widgets.push(widget);
  };
  ContextMenu.prototype.unregisterWidget = function (widget) {
    var index = this.widgets.indexOf(widget);
    if (index > -1) {
      this.widgets.splice(index, 1);
    }
    if (this.widgets.length === 0) {
      this.unpost();
    }
  };
  ContextMenu.prototype.unpostWidgets = function () {
    this.widgets.forEach(function (x) {
      return x.unpost();
    });
  };
  ContextMenu.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  ContextMenu.prototype.move_ = function (next) {
    if (this.anchor && next !== this.anchor) {
      this.moving = true;
      this.unpost();
      this.post(next);
      this.moving = false;
    }
  };
  return ContextMenu;
})(abstract_menu_js_1$2.AbstractMenu);
context_menu.ContextMenu = ContextMenu;

var __extends$1C = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$K = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$U = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(MJContextMenu$1, "__esModule", {
  value: true
});
MJContextMenu$1.MJContextMenu = void 0;
var context_menu_js_1$1 = context_menu;
var item_submenu_js_1$1 = item_submenu;
var MJContextMenu = (function (_super) {
  __extends$1C(MJContextMenu, _super);
  function MJContextMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.mathItem = null;
    _this.annotation = '';
    _this.annotationTypes = {};
    return _this;
  }
  MJContextMenu.prototype.post = function (x, y) {
    if (this.mathItem) {
      if (y !== undefined) {
        var input = this.mathItem.inputJax.name;
        var original = this.findID('Show', 'Original');
        original.content = input === 'MathML' ? 'Original MathML' : input + ' Commands';
        var clipboard = this.findID('Copy', 'Original');
        clipboard.content = original.content;
        var semantics = this.findID('Settings', 'semantics');
        input === 'MathML' ? semantics.disable() : semantics.enable();
        this.getAnnotationMenu();
        this.dynamicSubmenus();
      }
      _super.prototype.post.call(this, x, y);
    }
  };
  MJContextMenu.prototype.unpost = function () {
    _super.prototype.unpost.call(this);
    this.mathItem = null;
  };
  MJContextMenu.prototype.findID = function () {
    var e_1, _a;
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      names[_i] = arguments[_i];
    }
    var menu = this;
    var item = null;
    try {
      for (var names_1 = __values$K(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
        var name_1 = names_1_1.value;
        if (menu) {
          item = menu.find(name_1);
          menu = item instanceof item_submenu_js_1$1.Submenu ? item.submenu : null;
        } else {
          item = null;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return item;
  };
  MJContextMenu.prototype.getAnnotationMenu = function () {
    var _this = this;
    var annotations = this.getAnnotations(this.getSemanticNode());
    this.createAnnotationMenu('Show', annotations, function () {
      return _this.showAnnotation.post();
    });
    this.createAnnotationMenu('Copy', annotations, function () {
      return _this.copyAnnotation();
    });
  };
  MJContextMenu.prototype.getSemanticNode = function () {
    var node = this.mathItem.root;
    while (node && !node.isKind('semantics')) {
      if (node.isToken || node.childNodes.length !== 1) return null;
      node = node.childNodes[0];
    }
    return node;
  };
  MJContextMenu.prototype.getAnnotations = function (node) {
    var e_2, _a;
    var annotations = [];
    if (!node) return annotations;
    try {
      for (var _b = __values$K(node.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        if (child.isKind('annotation')) {
          var match = this.annotationMatch(child);
          if (match) {
            var value = child.childNodes.reduce(function (text, chars) {
              return text + chars.toString();
            }, '');
            annotations.push([match, value]);
          }
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return annotations;
  };
  MJContextMenu.prototype.annotationMatch = function (child) {
    var e_3, _a;
    var encoding = child.attributes.get('encoding');
    try {
      for (var _b = __values$K(Object.keys(this.annotationTypes)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var type = _c.value;
        if (this.annotationTypes[type].indexOf(encoding) >= 0) {
          return type;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return null;
  };
  MJContextMenu.prototype.createAnnotationMenu = function (id, annotations, action) {
    var _this = this;
    var menu = this.findID(id, 'Annotation');
    menu.submenu = this.factory.get('subMenu')(this.factory, {
      items: annotations.map(function (_a) {
        var _b = __read$U(_a, 2), type = _b[0], value = _b[1];
        return {
          type: 'command',
          id: type,
          content: type,
          action: function () {
            _this.annotation = value;
            action();
          }
        };
      }),
      id: 'annotations'
    }, menu);
    if (annotations.length) {
      menu.enable();
    } else {
      menu.disable();
    }
  };
  MJContextMenu.prototype.dynamicSubmenus = function () {
    var e_4, _a;
    try {
      for (var _b = __values$K(MJContextMenu.DynamicSubmenus), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = __read$U(_c.value, 2), id = _d[0], method = _d[1];
        var menu = this.find(id);
        if (!menu) continue;
        var sub = method(this, menu);
        menu.submenu = sub;
        if (sub.items.length) {
          menu.enable();
        } else {
          menu.disable();
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
  };
  MJContextMenu.DynamicSubmenus = new Map();
  return MJContextMenu;
})(context_menu_js_1$1.ContextMenu);
MJContextMenu$1.MJContextMenu = MJContextMenu;

var MmlVisitor$1 = {};

var __extends$1B = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(MmlVisitor$1, "__esModule", {
  value: true
});
MmlVisitor$1.MmlVisitor = void 0;
var SerializedMmlVisitor_js_1 = SerializedMmlVisitor;
var Options_js_1$g = Options;
var MmlVisitor = (function (_super) {
  __extends$1B(MmlVisitor, _super);
  function MmlVisitor() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.options = {
      texHints: true,
      semantics: false
    };
    _this.mathItem = null;
    return _this;
  }
  MmlVisitor.prototype.visitTree = function (node, math, options) {
    if (math === void 0) {
      math = null;
    }
    if (options === void 0) {
      options = {};
    }
    this.mathItem = math;
    (0, Options_js_1$g.userOptions)(this.options, options);
    return this.visitNode(node, '');
  };
  MmlVisitor.prototype.visitTeXAtomNode = function (node, space) {
    if (this.options.texHints) {
      return _super.prototype.visitTeXAtomNode.call(this, node, space);
    }
    if (node.childNodes[0] && node.childNodes[0].childNodes.length === 1) {
      return this.visitNode(node.childNodes[0], space);
    }
    return space + '<mrow' + this.getAttributes(node) + '>\n' + this.childNodeMml(node, space + '  ', '\n') + space + '</mrow>';
  };
  MmlVisitor.prototype.visitMathNode = function (node, space) {
    if (!this.options.semantics || this.mathItem.inputJax.name !== 'TeX') {
      return _super.prototype.visitDefault.call(this, node, space);
    }
    var addRow = node.childNodes.length && node.childNodes[0].childNodes.length > 1;
    return space + '<math' + this.getAttributes(node) + '>\n' + space + '  <semantics>\n' + (addRow ? space + '    <mrow>\n' : '') + this.childNodeMml(node, space + (addRow ? '      ' : '    '), '\n') + (addRow ? space + '    </mrow>\n' : '') + space + '    <annotation encoding="application/x-tex">' + this.mathItem.math + '</annotation>\n' + space + '  </semantics>\n' + space + '</math>';
  };
  return MmlVisitor;
})(SerializedMmlVisitor_js_1.SerializedMmlVisitor);
MmlVisitor$1.MmlVisitor = MmlVisitor;

var SelectableInfo$1 = {};

var info = {};

var close_button = {};

var __extends$1A = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(close_button, "__esModule", {
  value: true
});
close_button.CloseButton = void 0;
var abstract_postable_js_1$1 = abstract_postable;
var html_classes_js_1$9 = html_classes;
var CloseButton = (function (_super) {
  __extends$1A(CloseButton, _super);
  function CloseButton(element) {
    var _this = _super.call(this) || this;
    _this.element = element;
    _this.className = html_classes_js_1$9.HtmlClasses['MENUCLOSE'];
    _this.role = 'button';
    return _this;
  }
  CloseButton.prototype.generateHtml = function () {
    var html = document.createElement('span');
    html.classList.add(this.className);
    html.setAttribute('role', this.role);
    html.setAttribute('tabindex', '0');
    var content = document.createElement('span');
    content.textContent = '\u00D7';
    html.appendChild(content);
    this.html = html;
  };
  CloseButton.prototype.display = function () {};
  CloseButton.prototype.unpost = function () {
    _super.prototype.unpost.call(this);
    this.element.unpost();
  };
  CloseButton.prototype.keydown = function (event) {
    this.bubbleKey();
    _super.prototype.keydown.call(this, event);
  };
  CloseButton.prototype.space = function (event) {
    this.unpost();
    this.stop(event);
  };
  CloseButton.prototype.mousedown = function (event) {
    this.unpost();
    this.stop(event);
  };
  return CloseButton;
})(abstract_postable_js_1$1.AbstractPostable);
close_button.CloseButton = CloseButton;

var __extends$1z = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(info, "__esModule", {
  value: true
});
info.Info = void 0;
var close_button_js_1 = close_button;
var html_classes_js_1$8 = html_classes;
var abstract_postable_js_1 = abstract_postable;
var Info = (function (_super) {
  __extends$1z(Info, _super);
  function Info(title, content, signature) {
    var _this = _super.call(this) || this;
    _this.title = title;
    _this.signature = signature;
    _this.className = html_classes_js_1$8.HtmlClasses['INFO'];
    _this.role = 'dialog';
    _this.contentDiv = _this.generateContent();
    _this.close = _this.generateClose();
    _this.content = content || (function () {
      return '';
    });
    return _this;
  }
  Info.prototype.attachMenu = function (menu) {
    this.menu = menu;
  };
  Info.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    html.appendChild(this.generateTitle());
    html.appendChild(this.contentDiv);
    html.appendChild(this.generateSignature());
    html.appendChild(this.close.html);
    html.setAttribute('tabindex', '0');
  };
  Info.prototype.post = function () {
    _super.prototype.post.call(this);
    var doc = document.documentElement;
    var html = this.html;
    var H = window.innerHeight || doc.clientHeight || doc.scrollHeight || 0;
    var x = Math.floor(-html.offsetWidth / 2);
    var y = Math.floor((H - html.offsetHeight) / 3);
    html.setAttribute('style', 'margin-left: ' + x + 'px; top: ' + y + 'px;');
    if (window.event instanceof MouseEvent) {
      html.classList.add(html_classes_js_1$8.HtmlClasses['MOUSEPOST']);
    }
    html.focus();
  };
  Info.prototype.display = function () {
    this.menu.registerWidget(this);
    this.contentDiv.innerHTML = this.content();
    var html = this.menu.html;
    if (html.parentNode) {
      html.parentNode.removeChild(html);
    }
    this.menu.frame.appendChild(this.html);
  };
  Info.prototype.click = function (_event) {};
  Info.prototype.keydown = function (event) {
    this.bubbleKey();
    _super.prototype.keydown.call(this, event);
  };
  Info.prototype.escape = function (_event) {
    this.unpost();
  };
  Info.prototype.unpost = function () {
    _super.prototype.unpost.call(this);
    this.html.classList.remove(html_classes_js_1$8.HtmlClasses['MOUSEPOST']);
    this.menu.unregisterWidget(this);
  };
  Info.prototype.generateClose = function () {
    var close = new close_button_js_1.CloseButton(this);
    var html = close.html;
    html.classList.add(html_classes_js_1$8.HtmlClasses['INFOCLOSE']);
    html.setAttribute('aria-label', 'Close Dialog Box');
    return close;
  };
  Info.prototype.generateTitle = function () {
    var span = document.createElement('span');
    span.innerHTML = this.title;
    span.classList.add(html_classes_js_1$8.HtmlClasses['INFOTITLE']);
    return span;
  };
  Info.prototype.generateContent = function () {
    var div = document.createElement('div');
    div.classList.add(html_classes_js_1$8.HtmlClasses['INFOCONTENT']);
    div.setAttribute('tabindex', '0');
    return div;
  };
  Info.prototype.generateSignature = function () {
    var span = document.createElement('span');
    span.innerHTML = this.signature;
    span.classList.add(html_classes_js_1$8.HtmlClasses['INFOSIGNATURE']);
    return span;
  };
  Info.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Info;
})(abstract_postable_js_1.AbstractPostable);
info.Info = Info;

var __extends$1y = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(SelectableInfo$1, "__esModule", {
  value: true
});
SelectableInfo$1.SelectableInfo = void 0;
var info_js_1$2 = info;
var html_classes_js_1$7 = html_classes;
var SelectableInfo = (function (_super) {
  __extends$1y(SelectableInfo, _super);
  function SelectableInfo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SelectableInfo.prototype.addEvents = function (element) {
    var _this = this;
    element.addEventListener('keypress', function (event) {
      if (event.key === 'a' && (event.ctrlKey || event.metaKey)) {
        _this.selectAll();
        _this.stop(event);
      }
    });
  };
  SelectableInfo.prototype.selectAll = function () {
    var selection = document.getSelection();
    selection.selectAllChildren(this.html.querySelector('pre'));
  };
  SelectableInfo.prototype.copyToClipboard = function () {
    this.selectAll();
    try {
      document.execCommand('copy');
    } catch (err) {
      alert('Can\'t copy to clipboard: ' + err.message);
    }
    document.getSelection().removeAllRanges();
  };
  SelectableInfo.prototype.generateHtml = function () {
    var _this = this;
    _super.prototype.generateHtml.call(this);
    var footer = this.html.querySelector('span.' + html_classes_js_1$7.HtmlClasses['INFOSIGNATURE']);
    var button = footer.appendChild(document.createElement('input'));
    button.type = 'button';
    button.value = 'Copy to Clipboard';
    button.addEventListener('click', function (_event) {
      return _this.copyToClipboard();
    });
  };
  return SelectableInfo;
})(info_js_1$2.Info);
SelectableInfo$1.SelectableInfo = SelectableInfo;

var parse$1 = {};

var item_command = {};

var __extends$1x = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_command, "__esModule", {
  value: true
});
item_command.Command = void 0;
var abstract_item_js_1$2 = abstract_item;
var menu_util_js_1$6 = menu_util;
var Command = (function (_super) {
  __extends$1x(Command, _super);
  function Command(menu, content, command, id) {
    var _this = _super.call(this, menu, 'command', content, id) || this;
    _this.command = command;
    return _this;
  }
  Command.fromJson = function (_factory, _a, menu) {
    var content = _a.content, action = _a.action, id = _a.id;
    return new this(menu, content, action, id);
  };
  Command.prototype.executeAction = function () {
    try {
      this.command(menu_util_js_1$6.MenuUtil.getActiveElement(this));
    } catch (e) {
      menu_util_js_1$6.MenuUtil.error(e, 'Illegal command callback.');
    }
    menu_util_js_1$6.MenuUtil.close(this);
  };
  Command.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Command;
})(abstract_item_js_1$2.AbstractItem);
item_command.Command = Command;

var variable = {};

Object.defineProperty(variable, "__esModule", {
  value: true
});
variable.Variable = void 0;
var menu_util_js_1$5 = menu_util;
var Variable = (function () {
  function Variable(_name, getter, setter) {
    this._name = _name;
    this.getter = getter;
    this.setter = setter;
    this.items = [];
  }
  Variable.fromJson = function (_factory, _a, pool) {
    var name = _a.name, getter = _a.getter, setter = _a.setter;
    var variable = new this(name, getter, setter);
    pool.insert(variable);
  };
  Object.defineProperty(Variable.prototype, "name", {
    get: function () {
      return this._name;
    },
    enumerable: false,
    configurable: true
  });
  Variable.prototype.getValue = function (node) {
    try {
      return this.getter(node);
    } catch (e) {
      menu_util_js_1$5.MenuUtil.error(e, 'Command of variable ' + this.name + ' failed.');
      return null;
    }
  };
  Variable.prototype.setValue = function (value, node) {
    try {
      this.setter(value, node);
    } catch (e) {
      menu_util_js_1$5.MenuUtil.error(e, 'Command of variable ' + this.name + ' failed.');
    }
    this.update();
  };
  Variable.prototype.register = function (item) {
    if (this.items.indexOf(item) === -1) {
      this.items.push(item);
    }
  };
  Variable.prototype.unregister = function (item) {
    var index = this.items.indexOf(item);
    if (index !== -1) {
      this.items.splice(index, 1);
    }
  };
  Variable.prototype.update = function () {
    this.items.forEach(function (x) {
      return x.update();
    });
  };
  Variable.prototype.registerCallback = function (func) {
    this.items.forEach(function (x) {
      return x.registerCallback(func);
    });
  };
  Variable.prototype.unregisterCallback = function (func) {
    this.items.forEach(function (x) {
      return x.unregisterCallback(func);
    });
  };
  Variable.prototype.toJson = function () {
    return {
      type: 'variable',
      name: this.name,
      getter: this.getter.toString(),
      setter: this.setter.toString()
    };
  };
  return Variable;
})();
variable.Variable = Variable;

var item_checkbox = {};

var abstract_variable_item = {};

var __extends$1w = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(abstract_variable_item, "__esModule", {
  value: true
});
abstract_variable_item.AbstractVariableItem = void 0;
var abstract_item_js_1$1 = abstract_item;
var AbstractVariableItem = (function (_super) {
  __extends$1w(AbstractVariableItem, _super);
  function AbstractVariableItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AbstractVariableItem.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    if (!this.span) {
      this.generateSpan();
    }
    html.appendChild(this.span);
    this.update();
  };
  AbstractVariableItem.prototype.register = function () {
    this.variable.register(this);
  };
  AbstractVariableItem.prototype.unregister = function () {
    this.variable.unregister(this);
  };
  AbstractVariableItem.prototype.update = function () {
    this.updateAria();
    if (this.span) {
      this.updateSpan();
    }
  };
  return AbstractVariableItem;
})(abstract_item_js_1$1.AbstractItem);
abstract_variable_item.AbstractVariableItem = AbstractVariableItem;

var __extends$1v = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_checkbox, "__esModule", {
  value: true
});
item_checkbox.Checkbox = void 0;
var abstract_variable_item_js_1$3 = abstract_variable_item;
var menu_util_js_1$4 = menu_util;
var html_classes_js_1$6 = html_classes;
var Checkbox = (function (_super) {
  __extends$1v(Checkbox, _super);
  function Checkbox(menu, content, variable, id) {
    var _this = _super.call(this, menu, 'checkbox', content, id) || this;
    _this.role = 'menuitemcheckbox';
    _this.variable = menu.pool.lookup(variable);
    _this.register();
    return _this;
  }
  Checkbox.fromJson = function (_factory, _a, menu) {
    var content = _a.content, variable = _a.variable, id = _a.id;
    return new this(menu, content, variable, id);
  };
  Checkbox.prototype.executeAction = function () {
    this.variable.setValue(!this.variable.getValue());
    menu_util_js_1$4.MenuUtil.close(this);
  };
  Checkbox.prototype.generateSpan = function () {
    this.span = document.createElement('span');
    this.span.textContent = '\u2713';
    this.span.classList.add(html_classes_js_1$6.HtmlClasses['MENUCHECK']);
  };
  Checkbox.prototype.updateAria = function () {
    this.html.setAttribute('aria-checked', this.variable.getValue() ? 'true' : 'false');
  };
  Checkbox.prototype.updateSpan = function () {
    this.span.style.display = this.variable.getValue() ? '' : 'none';
  };
  Checkbox.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Checkbox;
})(abstract_variable_item_js_1$3.AbstractVariableItem);
item_checkbox.Checkbox = Checkbox;

var item_combo = {};

var __extends$1u = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_combo, "__esModule", {
  value: true
});
item_combo.Combo = void 0;
var abstract_variable_item_js_1$2 = abstract_variable_item;
var menu_util_js_1$3 = menu_util;
var html_classes_js_1$5 = html_classes;
var key_navigatable_js_1$1 = key_navigatable;
var Combo = (function (_super) {
  __extends$1u(Combo, _super);
  function Combo(menu, content, variable, id) {
    var _this = _super.call(this, menu, 'combobox', content, id) || this;
    _this.role = 'combobox';
    _this.inputEvent = false;
    _this.variable = menu.pool.lookup(variable);
    _this.register();
    return _this;
  }
  Combo.fromJson = function (_factory, _a, menu) {
    var content = _a.content, variable = _a.variable, id = _a.id;
    return new this(menu, content, variable, id);
  };
  Combo.prototype.executeAction = function () {
    this.variable.setValue(this.input.value, menu_util_js_1$3.MenuUtil.getActiveElement(this));
  };
  Combo.prototype.space = function (event) {
    _super.prototype.space.call(this, event);
    menu_util_js_1$3.MenuUtil.close(this);
  };
  Combo.prototype.focus = function () {
    _super.prototype.focus.call(this);
    this.input.focus();
  };
  Combo.prototype.unfocus = function () {
    _super.prototype.unfocus.call(this);
    this.updateSpan();
  };
  Combo.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    html.classList.add(html_classes_js_1$5.HtmlClasses['MENUCOMBOBOX']);
  };
  Combo.prototype.generateSpan = function () {
    this.span = document.createElement('span');
    this.span.classList.add(html_classes_js_1$5.HtmlClasses['MENUINPUTBOX']);
    this.input = document.createElement('input');
    this.input.addEventListener('keydown', this.inputKey.bind(this));
    this.input.setAttribute('size', '10em');
    this.input.setAttribute('type', 'text');
    this.input.setAttribute('tabindex', '-1');
    this.span.appendChild(this.input);
  };
  Combo.prototype.inputKey = function (_event) {
    this.bubbleKey();
    this.inputEvent = true;
  };
  Combo.prototype.keydown = function (event) {
    if (this.inputEvent && event.keyCode !== key_navigatable_js_1$1.KEY.ESCAPE && event.keyCode !== key_navigatable_js_1$1.KEY.RETURN) {
      this.inputEvent = false;
      event.stopPropagation();
      return;
    }
    _super.prototype.keydown.call(this, event);
    event.stopPropagation();
  };
  Combo.prototype.updateAria = function () {};
  Combo.prototype.updateSpan = function () {
    var initValue;
    try {
      initValue = this.variable.getValue(menu_util_js_1$3.MenuUtil.getActiveElement(this));
    } catch (e) {
      initValue = '';
    }
    this.input.value = initValue;
  };
  Combo.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Combo;
})(abstract_variable_item_js_1$2.AbstractVariableItem);
item_combo.Combo = Combo;

var item_label = {};

var __extends$1t = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_label, "__esModule", {
  value: true
});
item_label.Label = void 0;
var abstract_item_js_1 = abstract_item;
var html_classes_js_1$4 = html_classes;
var Label = (function (_super) {
  __extends$1t(Label, _super);
  function Label(menu, content, id) {
    return _super.call(this, menu, 'label', content, id) || this;
  }
  Label.fromJson = function (_factory, _a, menu) {
    var content = _a.content, id = _a.id;
    return new this(menu, content, id);
  };
  Label.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    html.classList.add(html_classes_js_1$4.HtmlClasses['MENULABEL']);
  };
  Label.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Label;
})(abstract_item_js_1.AbstractItem);
item_label.Label = Label;

var item_radio = {};

var __extends$1s = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_radio, "__esModule", {
  value: true
});
item_radio.Radio = void 0;
var abstract_variable_item_js_1$1 = abstract_variable_item;
var menu_util_js_1$2 = menu_util;
var html_classes_js_1$3 = html_classes;
var Radio = (function (_super) {
  __extends$1s(Radio, _super);
  function Radio(menu, content, variable, id) {
    var _this = _super.call(this, menu, 'radio', content, id) || this;
    _this.role = 'menuitemradio';
    _this.variable = menu.pool.lookup(variable);
    _this.register();
    return _this;
  }
  Radio.fromJson = function (_factory, _a, menu) {
    var content = _a.content, variable = _a.variable, id = _a.id;
    return new this(menu, content, variable, id);
  };
  Radio.prototype.executeAction = function () {
    this.variable.setValue(this.id);
    menu_util_js_1$2.MenuUtil.close(this);
  };
  Radio.prototype.generateSpan = function () {
    this.span = document.createElement('span');
    this.span.textContent = '\u2713';
    this.span.classList.add(html_classes_js_1$3.HtmlClasses['MENURADIOCHECK']);
  };
  Radio.prototype.updateAria = function () {
    this.html.setAttribute('aria-checked', this.variable.getValue() === this.id ? 'true' : 'false');
  };
  Radio.prototype.updateSpan = function () {
    this.span.style.display = this.variable.getValue() === this.id ? '' : 'none';
  };
  Radio.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Radio;
})(abstract_variable_item_js_1$1.AbstractVariableItem);
item_radio.Radio = Radio;

var item_rule = {};

var __extends$1r = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_rule, "__esModule", {
  value: true
});
item_rule.Rule = void 0;
var abstract_entry_js_1 = abstract_entry;
var html_classes_js_1$2 = html_classes;
var Rule = (function (_super) {
  __extends$1r(Rule, _super);
  function Rule(menu) {
    var _this = _super.call(this, menu, 'rule') || this;
    _this.className = html_classes_js_1$2.HtmlClasses['MENUITEM'];
    _this.role = 'separator';
    return _this;
  }
  Rule.fromJson = function (_factory, _a, menu) {
    return new this(menu);
  };
  Rule.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    html.classList.add(html_classes_js_1$2.HtmlClasses['MENURULE']);
    html.setAttribute('aria-orientation', 'vertical');
  };
  Rule.prototype.addEvents = function (_element) {};
  Rule.prototype.toJson = function () {
    return {
      type: 'rule'
    };
  };
  return Rule;
})(abstract_entry_js_1.AbstractEntry);
item_rule.Rule = Rule;

var item_slider = {};

var __extends$1q = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(item_slider, "__esModule", {
  value: true
});
item_slider.Slider = void 0;
var abstract_variable_item_js_1 = abstract_variable_item;
var menu_util_js_1$1 = menu_util;
var html_classes_js_1$1 = html_classes;
var key_navigatable_js_1 = key_navigatable;
var Slider = (function (_super) {
  __extends$1q(Slider, _super);
  function Slider(menu, content, variable, id) {
    var _this = _super.call(this, menu, 'slider', content, id) || this;
    _this.role = 'slider';
    _this.labelId = 'ctx_slideLabel' + menu_util_js_1$1.MenuUtil.counter();
    _this.valueId = 'ctx_slideValue' + menu_util_js_1$1.MenuUtil.counter();
    _this.inputEvent = false;
    _this.variable = menu.pool.lookup(variable);
    _this.register();
    return _this;
  }
  Slider.fromJson = function (_factory, _a, menu) {
    var content = _a.content, variable = _a.variable, id = _a.id;
    return new this(menu, content, variable, id);
  };
  Slider.prototype.executeAction = function () {
    this.variable.setValue(this.input.value, menu_util_js_1$1.MenuUtil.getActiveElement(this));
    this.update();
  };
  Slider.prototype.space = function (event) {
    _super.prototype.space.call(this, event);
    menu_util_js_1$1.MenuUtil.close(this);
  };
  Slider.prototype.focus = function () {
    _super.prototype.focus.call(this);
    this.input.focus();
  };
  Slider.prototype.unfocus = function () {
    _super.prototype.unfocus.call(this);
    this.updateSpan();
  };
  Slider.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    var html = this.html;
    html.classList.add(html_classes_js_1$1.HtmlClasses['MENUSLIDER']);
    this.valueSpan = document.createElement('span');
    this.valueSpan.setAttribute('id', this.valueId);
    this.valueSpan.classList.add(html_classes_js_1$1.HtmlClasses['SLIDERVALUE']);
    this.html.appendChild(this.valueSpan);
  };
  Slider.prototype.generateSpan = function () {
    this.span = document.createElement('span');
    this.labelSpan = document.createElement('span');
    this.labelSpan.setAttribute('id', this.labelId);
    this.labelSpan.appendChild(this.html.childNodes[0]);
    this.html.appendChild(this.labelSpan);
    this.input = document.createElement('input');
    this.input.setAttribute('type', 'range');
    this.input.setAttribute('min', '0');
    this.input.setAttribute('max', '100');
    this.input.setAttribute('aria-valuemin', '0');
    this.input.setAttribute('aria-valuemax', '100');
    this.input.setAttribute('aria-labelledby', this.labelId);
    this.input.addEventListener('keydown', this.inputKey.bind(this));
    this.input.addEventListener('input', this.executeAction.bind(this));
    this.input.classList.add(html_classes_js_1$1.HtmlClasses['SLIDERBAR']);
    this.span.appendChild(this.input);
  };
  Slider.prototype.inputKey = function (_event) {
    this.inputEvent = true;
  };
  Slider.prototype.mousedown = function (event) {
    event.stopPropagation();
  };
  Slider.prototype.mouseup = function (_event) {
    event.stopPropagation();
  };
  Slider.prototype.keydown = function (event) {
    var code = event.keyCode;
    if (code === key_navigatable_js_1.KEY.UP || code === key_navigatable_js_1.KEY.DOWN) {
      event.preventDefault();
      _super.prototype.keydown.call(this, event);
      return;
    }
    if (this.inputEvent && code !== key_navigatable_js_1.KEY.ESCAPE && code !== key_navigatable_js_1.KEY.RETURN) {
      this.inputEvent = false;
      event.stopPropagation();
      return;
    }
    _super.prototype.keydown.call(this, event);
    event.stopPropagation();
  };
  Slider.prototype.updateAria = function () {
    var value = this.variable.getValue();
    if (value && this.input) {
      this.input.setAttribute('aria-valuenow', value);
      this.input.setAttribute('aria-valuetext', value + '%');
    }
  };
  Slider.prototype.updateSpan = function () {
    var initValue;
    try {
      initValue = this.variable.getValue(menu_util_js_1$1.MenuUtil.getActiveElement(this));
      this.valueSpan.innerHTML = initValue + '%';
    } catch (e) {
      initValue = '';
    }
    this.input.value = initValue;
  };
  Slider.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return Slider;
})(abstract_variable_item_js_1.AbstractVariableItem);
item_slider.Slider = Slider;

var sub_menu = {};

var __extends$1p = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(sub_menu, "__esModule", {
  value: true
});
sub_menu.SubMenu = void 0;
var abstract_menu_js_1$1 = abstract_menu;
var SubMenu = (function (_super) {
  __extends$1p(SubMenu, _super);
  function SubMenu(_anchor) {
    var _this = _super.call(this) || this;
    _this._anchor = _anchor;
    _this.variablePool = _this.anchor.menu.pool;
    _this.setBaseMenu();
    return _this;
  }
  SubMenu.fromJson = function (factory, _a, anchor) {
    var its = _a.items;
    var submenu = new this(anchor);
    var itemList = factory.get('items')(factory, its, submenu);
    submenu.items = itemList;
    return submenu;
  };
  Object.defineProperty(SubMenu.prototype, "anchor", {
    get: function () {
      return this._anchor;
    },
    enumerable: false,
    configurable: true
  });
  SubMenu.prototype.post = function () {
    if (!this.anchor.menu.isPosted()) {
      return;
    }
    var margin = 5;
    var parent = this.anchor.html;
    var menu = this.html;
    var base = this.baseMenu.frame;
    var mw = parent.offsetWidth;
    var x = mw - 2;
    var y = 0;
    while (parent && parent !== base) {
      x += parent.offsetLeft;
      y += parent.offsetTop;
      parent = parent.parentNode;
    }
    {
      if (x + menu.offsetWidth > document.body.offsetWidth - margin) {
        x = Math.max(margin, x - mw - menu.offsetWidth + 6);
      }
    }
    _super.prototype.post.call(this, x, y);
  };
  SubMenu.prototype.display = function () {
    this.baseMenu.frame.appendChild(this.html);
  };
  SubMenu.prototype.setBaseMenu = function () {
    var menu = this;
    do {
      menu = menu.anchor.menu;
    } while (menu instanceof SubMenu);
    this.baseMenu = menu;
  };
  SubMenu.prototype.left = function (_event) {
    this.focused = null;
    this.anchor.focus();
  };
  SubMenu.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  return SubMenu;
})(abstract_menu_js_1$1.AbstractMenu);
sub_menu.SubMenu = SubMenu;

var selection_box = {};

var __extends$1o = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$T = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(selection_box, "__esModule", {
  value: true
});
selection_box.SelectionBox = selection_box.SelectionMenu = void 0;
var menu_util_js_1 = menu_util;
var html_classes_js_1 = html_classes;
var abstract_menu_js_1 = abstract_menu;
var info_js_1$1 = info;
var SelectionMenu = (function (_super) {
  __extends$1o(SelectionMenu, _super);
  function SelectionMenu(anchor) {
    var _this = _super.call(this) || this;
    _this.anchor = anchor;
    _this.className = html_classes_js_1.HtmlClasses['SELECTIONMENU'];
    _this.variablePool = _this.anchor.menu.pool;
    _this.baseMenu = _this.anchor.menu;
    return _this;
  }
  SelectionMenu.fromJson = function (factory, _a, sb) {
    var title = _a.title, values = _a.values, variable = _a.variable;
    var selection = new this(sb);
    var tit = factory.get('label')(factory, {
      content: title || '',
      id: title || 'id'
    }, selection);
    var rul = factory.get('rule')(factory, {}, selection);
    var radios = values.map(function (x) {
      return factory.get('radio')(factory, {
        content: x,
        variable: variable,
        id: x
      }, selection);
    });
    var items = [tit, rul].concat(radios);
    selection.items = items;
    return selection;
  };
  SelectionMenu.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    this.items.forEach(function (item) {
      return item.html.classList.add(html_classes_js_1.HtmlClasses['SELECTIONITEM']);
    });
  };
  SelectionMenu.prototype.display = function () {};
  SelectionMenu.prototype.right = function (event) {
    this.anchor.right(event);
  };
  SelectionMenu.prototype.left = function (event) {
    this.anchor.left(event);
  };
  return SelectionMenu;
})(abstract_menu_js_1.AbstractMenu);
selection_box.SelectionMenu = SelectionMenu;
var SelectionBox = (function (_super) {
  __extends$1o(SelectionBox, _super);
  function SelectionBox(title, signature, style, grid) {
    if (style === void 0) {
      style = "none";
    }
    if (grid === void 0) {
      grid = "vertical";
    }
    var _this = _super.call(this, title, null, signature) || this;
    _this.style = style;
    _this.grid = grid;
    _this._selections = [];
    _this.prefix = 'ctxt-selection';
    _this._balanced = true;
    return _this;
  }
  SelectionBox.fromJson = function (factory, _a, ctxt) {
    var title = _a.title, signature = _a.signature, selections = _a.selections, order = _a.order, grid = _a.grid;
    var sb = new this(title, signature, order, grid);
    sb.attachMenu(ctxt);
    var sels = selections.map(function (x) {
      return factory.get('selectionMenu')(factory, x, sb);
    });
    sb.selections = sels;
    return sb;
  };
  SelectionBox.prototype.attachMenu = function (menu) {
    this.menu = menu;
  };
  Object.defineProperty(SelectionBox.prototype, "selections", {
    get: function () {
      return this._selections;
    },
    set: function (selections) {
      var _this = this;
      this._selections = [];
      selections.forEach(function (x) {
        return _this.addSelection(x);
      });
    },
    enumerable: false,
    configurable: true
  });
  SelectionBox.prototype.addSelection = function (selection) {
    selection.anchor = this;
    this._selections.push(selection);
  };
  SelectionBox.prototype.rowDiv = function (sels) {
    var _this = this;
    var div = document.createElement('div');
    this.contentDiv.appendChild(div);
    var rects = sels.map(function (sel) {
      div.appendChild(sel.html);
      if (!sel.html.id) {
        sel.html.id = _this.prefix + menu_util_js_1.MenuUtil.counter();
      }
      return sel.html.getBoundingClientRect();
    });
    var column = rects.map(function (x) {
      return x.width;
    });
    var width = column.reduce(function (x, y) {
      return x + y;
    }, 0);
    var height = rects.reduce(function (x, y) {
      return Math.max(x, y.height);
    }, 0);
    div.classList.add(html_classes_js_1.HtmlClasses['SELECTIONDIVIDER']);
    div.setAttribute('style', 'height: ' + height + 'px;');
    return [div, width, height, column];
  };
  SelectionBox.prototype.display = function () {
    _super.prototype.display.call(this);
    this.order();
    if (!this.selections.length) {
      return;
    }
    var outerDivs = [];
    var maxWidth = 0;
    var balancedColumn = [];
    var chunks = this.getChunkSize(this.selections.length);
    var _loop_1 = function (i) {
      var sels = this_1.selections.slice(i, i + chunks);
      var _a = __read$T(this_1.rowDiv(sels), 4), div = _a[0], width = _a[1], height = _a[2], column = _a[3];
      outerDivs.push(div);
      maxWidth = Math.max(maxWidth, width);
      sels.forEach(function (sel) {
        return sel.html.style.height = height + 'px';
      });
      balancedColumn = this_1.combineColumn(balancedColumn, column);
    };
    var this_1 = this;
    for (var i = 0; i < this.selections.length; i += chunks) {
      _loop_1(i);
    }
    if (this._balanced) {
      this.balanceColumn(outerDivs, balancedColumn);
      maxWidth = balancedColumn.reduce(function (x, y) {
        return x + y;
      }, 20);
    }
    outerDivs.forEach(function (div) {
      return div.style.width = maxWidth + 'px';
    });
  };
  SelectionBox.prototype.getChunkSize = function (size) {
    switch (this.grid) {
      case "square":
        return Math.floor(Math.sqrt(size));
      case "horizontal":
        return Math.floor(size / SelectionBox.chunkSize);
      case "vertical":
      default:
        return SelectionBox.chunkSize;
    }
  };
  SelectionBox.prototype.balanceColumn = function (divs, column) {
    divs.forEach(function (div) {
      var children = Array.from(div.children);
      for (var i = 0, child = void 0; child = children[i]; i++) {
        child.style.width = column[i] + 'px';
      }
    });
  };
  SelectionBox.prototype.combineColumn = function (col1, col2) {
    var result = [];
    var i = 0;
    while (col1[i] || col2[i]) {
      if (!col1[i]) {
        result = result.concat(col2.slice(i));
        break;
      }
      if (!col2[i]) {
        result = result.concat(col1.slice(i));
        break;
      }
      result.push(Math.max(col1[i], col2[i]));
      i++;
    }
    return result;
  };
  SelectionBox.prototype.left = function (event) {
    var _this = this;
    this.move(event, function (index) {
      return (index === 0 ? _this.selections.length : index) - 1;
    });
  };
  SelectionBox.prototype.right = function (event) {
    var _this = this;
    this.move(event, function (index) {
      return index === _this.selections.length - 1 ? 0 : index + 1;
    });
  };
  SelectionBox.prototype.generateHtml = function () {
    _super.prototype.generateHtml.call(this);
    this.html.classList.add(html_classes_js_1.HtmlClasses['SELECTION']);
  };
  SelectionBox.prototype.generateContent = function () {
    var div = _super.prototype.generateContent.call(this);
    div.classList.add(html_classes_js_1.HtmlClasses['SELECTIONBOX']);
    div.removeAttribute('tabindex');
    return div;
  };
  SelectionBox.prototype.findSelection = function (event) {
    var target = event.target;
    var selection = null;
    if (target.id) {
      selection = this.selections.find(function (x) {
        return x.html.id === target.id;
      });
    }
    if (!selection) {
      var id_1 = target.parentElement.id;
      selection = this.selections.find(function (x) {
        return x.html.id === id_1;
      });
    }
    return selection;
  };
  SelectionBox.prototype.move = function (event, isNext) {
    var selection = this.findSelection(event);
    if (selection.focused) {
      selection.focused.unfocus();
    }
    var index = this.selections.indexOf(selection);
    var next = isNext(index);
    this.selections[next].focus();
  };
  SelectionBox.prototype.order = function () {
    this.selections.sort(SelectionBox.orderMethod.get(this.style));
  };
  SelectionBox.prototype.toJson = function () {
    return {
      type: ''
    };
  };
  SelectionBox.chunkSize = 4;
  SelectionBox.orderMethod = new Map([["alphabetical", function (x, y) {
    return x.items[0].content.localeCompare(y.items[0].content);
  }], ["none", function (_x, _y) {
    return 1;
  }], ["decreasing", function (x, y) {
    var xl = x.items.length;
    var yl = y.items.length;
    return xl < yl ? 1 : yl < xl ? -1 : 0;
  }], ["increasing", function (x, y) {
    var xl = x.items.length;
    var yl = y.items.length;
    return xl < yl ? -1 : yl < xl ? 1 : 0;
  }]]);
  return SelectionBox;
})(info_js_1$1.Info);
selection_box.SelectionBox = SelectionBox;

var parser_factory = {};

Object.defineProperty(parser_factory, "__esModule", {
  value: true
});
parser_factory.ParserFactory = void 0;
var ParserFactory = (function () {
  function ParserFactory(init) {
    this._parser = new Map(init);
  }
  ParserFactory.prototype.get = function (name) {
    return this._parser.get(name);
  };
  ParserFactory.prototype.add = function (name, method) {
    this._parser.set(name, method);
  };
  return ParserFactory;
})();
parser_factory.ParserFactory = ParserFactory;

var __rest = commonjsGlobal && commonjsGlobal.__rest || (function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
});
var __read$S = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$J = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __spread = commonjsGlobal && commonjsGlobal.__spread || (function () {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read$S(arguments[i]));
  return ar;
});
Object.defineProperty(parse$1, "__esModule", {
  value: true
});
parse$1.Parser = void 0;
var item_command_js_1 = item_command;
var context_menu_js_1 = context_menu;
var variable_js_1 = variable;
var item_checkbox_js_1 = item_checkbox;
var item_combo_js_1 = item_combo;
var item_label_js_1 = item_label;
var item_radio_js_1 = item_radio;
var item_submenu_js_1 = item_submenu;
var item_rule_js_1$1 = item_rule;
var item_slider_js_1 = item_slider;
var sub_menu_js_1 = sub_menu;
var selection_box_js_1 = selection_box;
var parser_factory_js_1 = parser_factory;
var Parser = (function () {
  function Parser(init) {
    var _this = this;
    if (init === void 0) {
      init = [];
    }
    this._initList = [['command', item_command_js_1.Command.fromJson.bind(item_command_js_1.Command)], ['checkbox', item_checkbox_js_1.Checkbox.fromJson.bind(item_checkbox_js_1.Checkbox)], ['combo', item_combo_js_1.Combo.fromJson.bind(item_combo_js_1.Combo)], ['slider', item_slider_js_1.Slider.fromJson.bind(item_slider_js_1.Slider)], ['label', item_label_js_1.Label.fromJson.bind(item_label_js_1.Label)], ['radio', item_radio_js_1.Radio.fromJson.bind(item_radio_js_1.Radio)], ['rule', item_rule_js_1$1.Rule.fromJson.bind(item_rule_js_1$1.Rule)], ['submenu', item_submenu_js_1.Submenu.fromJson.bind(item_submenu_js_1.Submenu)], ['contextMenu', context_menu_js_1.ContextMenu.fromJson.bind(context_menu_js_1.ContextMenu)], ['subMenu', sub_menu_js_1.SubMenu.fromJson.bind(sub_menu_js_1.SubMenu)], ['variable', variable_js_1.Variable.fromJson.bind(variable_js_1.Variable)], ['items', this.items.bind(this)], ['selectionMenu', selection_box_js_1.SelectionMenu.fromJson.bind(selection_box_js_1.SelectionMenu)], ['selectionBox', selection_box_js_1.SelectionBox.fromJson.bind(selection_box_js_1.SelectionBox)]];
    this._factory = new parser_factory_js_1.ParserFactory(this._initList);
    init.forEach(function (_a) {
      var _b = __read$S(_a, 2), x = _b[0], y = _b[1];
      return _this.factory.add(x, y);
    });
  }
  Object.defineProperty(Parser.prototype, "factory", {
    get: function () {
      return this._factory;
    },
    enumerable: false,
    configurable: true
  });
  Parser.prototype.items = function (_factory, its, ctxt) {
    var e_1, _a;
    var hidden = [];
    try {
      for (var its_1 = __values$J(its), its_1_1 = its_1.next(); !its_1_1.done; its_1_1 = its_1.next()) {
        var item = its_1_1.value;
        var entry = this.parse(item, ctxt);
        if (!entry) {
          continue;
        }
        ctxt.items.push(entry);
        if (item.disabled) {
          entry.disable();
        }
        if (item.hidden) {
          hidden.push(entry);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (its_1_1 && !its_1_1.done && (_a = its_1.return)) _a.call(its_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    hidden.forEach(function (x) {
      return x.hide();
    });
    return ctxt.items;
  };
  Parser.prototype.parse = function (_a) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    }
    var kind = _a.type, json = __rest(_a, ["type"]);
    var func = this.factory.get(kind);
    return func ? func.apply(void 0, __spread([this.factory, json], rest)) : null;
  };
  return Parser;
})();
parse$1.Parser = Parser;

var css_util = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CssStyles = void 0;
  var html_classes_js_1 = html_classes;
  (function (CssStyles) {
    function makeClass_(name) {
      return '.' + (html_classes_js_1.HtmlClasses[name] || name);
    }
    var INFO_STYLES = {};
    (INFO_STYLES[makeClass_('INFOCLOSE')] = '{' + '  top:.2em; right:.2em;' + '}', INFO_STYLES[makeClass_('INFOCONTENT')] = '{' + '  overflow:auto; text-align:left; font-size:80%;' + '  padding:.4em .6em; border:1px inset; margin:1em 0px;' + '  max-height:20em; max-width:30em; background-color:#EEEEEE;' + '  white-space:normal;' + '}', INFO_STYLES[makeClass_('INFO') + makeClass_('MOUSEPOST')] = '{' + 'outline:none;' + '}', INFO_STYLES[makeClass_('INFO')] = '{' + '  position:fixed; left:50%; width:auto; text-align:center;' + '  border:3px outset; padding:1em 2em; background-color:#DDDDDD;' + '  color:black;' + '  cursor:default; font-family:message-box; font-size:120%;' + '  font-style:normal; text-indent:0; text-transform:none;' + '  line-height:normal; letter-spacing:normal; word-spacing:normal;' + '  word-wrap:normal; white-space:nowrap; float:none; z-index:201;' + '  border-radius: 15px;                     /* Opera 10.5 and IE9 */' + '  -webkit-border-radius:15px;               /* Safari and Chrome */' + '  -moz-border-radius:15px;                  /* Firefox */' + '  -khtml-border-radius:15px;                /* Konqueror */' + '  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */' + '  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */' + '  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */' + '  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */' + '  filter:progid:DXImageTransform.Microsoft.dropshadow(OffX=2,' + ' OffY=2, Color="gray", Positive="true"); /* IE */' + '}');
    var MENU_STYLES = {};
    (MENU_STYLES[makeClass_('MENU')] = '{' + '  position:absolute;' + '  background-color:white;' + '  color:black;' + '  width:auto; padding:5px 0px;' + '  border:1px solid #CCCCCC; margin:0; cursor:default;' + '  font: menu; text-align:left; text-indent:0; text-transform:none;' + '  line-height:normal; letter-spacing:normal; word-spacing:normal;' + '  word-wrap:normal; white-space:nowrap; float:none; z-index:201;' + '  border-radius: 5px;                     /* Opera 10.5 and IE9 */' + '  -webkit-border-radius: 5px;             /* Safari and Chrome */' + '  -moz-border-radius: 5px;                /* Firefox */' + '  -khtml-border-radius: 5px;              /* Konqueror */' + '  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */' + '  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */' + '  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */' + '  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */' + '}', MENU_STYLES[makeClass_('MENUITEM')] = '{' + '  padding: 1px 2em;' + '  background:transparent;' + '}', MENU_STYLES[makeClass_('MENUARROW')] = '{' + '  position:absolute; right:.5em; padding-top:.25em; color:#666666;' + '  font-family: null; font-size: .75em' + '}', MENU_STYLES[makeClass_('MENUACTIVE') + ' ' + makeClass_('MENUARROW')] = '{color:white}', MENU_STYLES[makeClass_('MENUARROW') + makeClass_('RTL')] = '{left:.5em; right:auto}', MENU_STYLES[makeClass_('MENUCHECK')] = '{' + '  position:absolute; left:.7em;' + '  font-family: null' + '}', MENU_STYLES[makeClass_('MENUCHECK') + makeClass_('RTL')] = '{ right:.7em; left:auto }', MENU_STYLES[makeClass_('MENURADIOCHECK')] = '{' + '  position:absolute; left: .7em;' + '}', MENU_STYLES[makeClass_('MENURADIOCHECK') + makeClass_('RTL')] = '{' + '  right: .7em; left:auto' + '}', MENU_STYLES[makeClass_('MENUINPUTBOX')] = '{' + '  padding-left: 1em; right:.5em; color:#666666;' + '  font-family: null;' + '}', MENU_STYLES[makeClass_('MENUINPUTBOX') + makeClass_('RTL')] = '{' + '  left: .1em;' + '}', MENU_STYLES[makeClass_('MENUCOMBOBOX')] = '{' + '  left:.1em; padding-bottom:.5em;' + '}', MENU_STYLES[makeClass_('MENUSLIDER')] = '{' + '  left: .1em;' + '}', MENU_STYLES[makeClass_('SLIDERVALUE')] = '{' + '  position:absolute; right:.1em; padding-top:.25em; color:#333333;' + '  font-size: .75em' + '}', MENU_STYLES[makeClass_('SLIDERBAR')] = '{' + '  outline: none; background: #d3d3d3' + '}', MENU_STYLES[makeClass_('MENULABEL')] = '{' + '  padding: 1px 2em 3px 1.33em;' + '  font-style:italic' + '}', MENU_STYLES[makeClass_('MENURULE')] = '{' + '  border-top: 1px solid #DDDDDD;' + '  margin: 4px 3px;' + '}', MENU_STYLES[makeClass_('MENUDISABLED')] = '{' + '  color:GrayText' + '}', MENU_STYLES[makeClass_('MENUACTIVE')] = '{' + '  background-color: #606872;' + '  color: white;' + '}', MENU_STYLES[makeClass_('MENUDISABLED') + ':focus'] = '{' + '  background-color: #E8E8E8' + '}', MENU_STYLES[makeClass_('MENULABEL') + ':focus'] = '{' + '  background-color: #E8E8E8' + '}', MENU_STYLES[makeClass_('CONTEXTMENU') + ':focus'] = '{' + '  outline:none' + '}', MENU_STYLES[makeClass_('CONTEXTMENU') + ' ' + makeClass_('MENUITEM') + ':focus'] = '{' + '  outline:none' + '}', MENU_STYLES[makeClass_('SELECTIONMENU')] = '{' + '  position:relative; float:left;' + '  border-bottom: none;' + ' -webkit-box-shadow:none;' + ' -webkit-border-radius:0px; ' + '}', MENU_STYLES[makeClass_('SELECTIONITEM')] = '{' + '  padding-right: 1em;' + '}', MENU_STYLES[makeClass_('SELECTION')] = '{' + '  right: 40%; width:50%; ' + '}', MENU_STYLES[makeClass_('SELECTIONBOX')] = '{' + '  padding: 0em; max-height:20em; max-width: none;' + '  background-color:#FFFFFF;' + '}', MENU_STYLES[makeClass_('SELECTIONDIVIDER')] = '{' + '  clear: both; border-top: 2px solid #000000;' + '}', MENU_STYLES[makeClass_('MENU') + ' ' + makeClass_('MENUCLOSE')] = '{' + '  top:-10px; left:-10px' + '}');
    var CLOSE_ICON_STYLES = {};
    (CLOSE_ICON_STYLES[makeClass_('MENUCLOSE')] = '{' + '  position:absolute;' + '  cursor:pointer;' + '  display:inline-block;' + '  border:2px solid #AAA;' + '  border-radius:18px;' + '  -webkit-border-radius: 18px;             /* Safari and Chrome */' + '  -moz-border-radius: 18px;                /* Firefox */' + '  -khtml-border-radius: 18px;              /* Konqueror */' + '  font-family: "Courier New", Courier;' + '  font-size:24px;' + '  color:#F0F0F0' + '}', CLOSE_ICON_STYLES[makeClass_('MENUCLOSE') + ' span'] = '{' + '  display:block; background-color:#AAA; border:1.5px solid;' + '  border-radius:18px;' + '  -webkit-border-radius: 18px;             /* Safari and Chrome */' + '  -moz-border-radius: 18px;                /* Firefox */' + '  -khtml-border-radius: 18px;              /* Konqueror */' + '  line-height:0;' + '  padding:8px 0 6px     /* may need to be browser-specific */' + '}', CLOSE_ICON_STYLES[makeClass_('MENUCLOSE') + ':hover'] = '{' + '  color:white!important;' + '  border:2px solid #CCC!important' + '}', CLOSE_ICON_STYLES[makeClass_('MENUCLOSE') + ':hover span'] = '{' + '  background-color:#CCC!important' + '}', CLOSE_ICON_STYLES[makeClass_('MENUCLOSE') + ':hover:focus'] = '{' + '  outline:none' + '}');
    var INFO_ADDED = false;
    var MENU_ADDED = false;
    var CLOSE_ICON_ADDED = false;
    function addMenuStyles(opt_document) {
      if (MENU_ADDED) {
        return;
      }
      addStyles_(MENU_STYLES, opt_document);
      MENU_ADDED = true;
      addCloseIconStyles_(opt_document);
    }
    CssStyles.addMenuStyles = addMenuStyles;
    function addInfoStyles(opt_document) {
      if (INFO_ADDED) {
        return;
      }
      addStyles_(INFO_STYLES, opt_document);
      INFO_ADDED = true;
      addCloseIconStyles_(opt_document);
    }
    CssStyles.addInfoStyles = addInfoStyles;
    function addCloseIconStyles_(opt_document) {
      if (CLOSE_ICON_ADDED) {
        return;
      }
      addStyles_(CLOSE_ICON_STYLES, opt_document);
      CLOSE_ICON_ADDED = true;
    }
    function addStyles_(styles, opt_document) {
      var doc = opt_document || document;
      var element = doc.createElement('style');
      element.type = 'text/css';
      var inner = '';
      for (var style in styles) {
        inner += style;
        inner += ' ';
        inner += styles[style];
        inner += '\n';
      }
      element.innerHTML = inner;
      doc.head.appendChild(element);
    }
  })(exports.CssStyles || (exports.CssStyles = {}));
})(css_util);
getDefaultExportFromCjs(css_util);

var __read$R = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$I = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$K = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(Menu$1, "__esModule", {
  value: true
});
Menu$1.Menu = void 0;
var mathjax_js_1$3 = mathjax;
var MathItem_js_1$5 = MathItem;
var global_js_1 = global$1;
var Options_js_1$f = Options;
var MJContextMenu_js_1 = MJContextMenu$1;
var MmlVisitor_js_1 = MmlVisitor$1;
var SelectableInfo_js_1 = SelectableInfo$1;
var info_js_1 = info;
var parse_js_1 = parse$1;
var item_rule_js_1 = item_rule;
var css_util_js_1 = css_util;
var sre_js_1 = __importDefault$K(sre);
var MathJax$1 = global_js_1.MathJax;
var isMac = typeof window !== 'undefined' && window.navigator && window.navigator.platform.substr(0, 3) === 'Mac';
var Menu = (function () {
  function Menu(document, options) {
    if (options === void 0) {
      options = {};
    }
    var _this = this;
    this.settings = null;
    this.defaultSettings = null;
    this.menu = null;
    this.MmlVisitor = new MmlVisitor_js_1.MmlVisitor();
    this.jax = {
      CHTML: null,
      SVG: null
    };
    this.rerenderStart = MathItem_js_1$5.STATE.LAST;
    this.about = new info_js_1.Info('<b style="font-size:120%;">MathJax</b> v' + mathjax_js_1$3.mathjax.version, function () {
      var lines = [];
      lines.push('Input Jax: ' + _this.document.inputJax.map(function (jax) {
        return jax.name;
      }).join(', '));
      lines.push('Output Jax: ' + _this.document.outputJax.name);
      lines.push('Document Type: ' + _this.document.kind);
      return lines.join('<br/>');
    }, '<a href="https://www.mathjax.org">www.mathjax.org</a>');
    this.help = new info_js_1.Info('<b>MathJax Help</b>', function () {
      return ['<p><b>MathJax</b> is a JavaScript library that allows page', ' authors to include mathematics within their web pages.', ' As a reader, you don\'t need to do anything to make that happen.</p>', '<p><b>Browsers</b>: MathJax works with all modern browsers including', ' Edge, Firefox, Chrome, Safari, Opera, and most mobile browsers.</p>', '<p><b>Math Menu</b>: MathJax adds a contextual menu to equations.', ' Right-click or CTRL-click on any mathematics to access the menu.</p>', '<div style="margin-left: 1em;">', '<p><b>Show Math As:</b> These options allow you to view the formula\'s', ' source markup (as MathML or in its original format).</p>', '<p><b>Copy to Clipboard:</b> These options copy the formula\'s source markup,', ' as MathML or in its original format, to the clipboard', ' (in browsers that support that).</p>', '<p><b>Math Settings:</b> These give you control over features of MathJax,', ' such the size of the mathematics, and the mechanism used', ' to display equations.</p>', '<p><b>Accessibility</b>: MathJax can work with screen', ' readers to make mathematics accessible to the visually impaired.', ' Turn on the explorer to enable generation of speech strings', ' and the ability to investigate expressions interactively.</p>', '<p><b>Language</b>: This menu lets you select the language used by MathJax', ' for its menus and warning messages. (Not yet implemented in version 3.)</p>', '</div>', '<p><b>Math Zoom</b>: If you are having difficulty reading an', ' equation, MathJax can enlarge it to help you see it better, or', ' you can scall all the math on the page to make it larger.', ' Turn these features on in the <b>Math Settings</b> menu.</p>', '<p><b>Preferences</b>: MathJax uses your browser\'s localStorage database', ' to save the preferences set via this menu locally in your browser.  These', ' are not used to track you, and are not transferred or used remotely by', ' MathJax in any way.</p>'].join('\n');
    }, '<a href="https://www.mathjax.org">www.mathjax.org</a>');
    this.mathmlCode = new SelectableInfo_js_1.SelectableInfo('MathJax MathML Expression', function () {
      if (!_this.menu.mathItem) return '';
      var text = _this.toMML(_this.menu.mathItem);
      return '<pre>' + _this.formatSource(text) + '</pre>';
    }, '');
    this.originalText = new SelectableInfo_js_1.SelectableInfo('MathJax Original Source', function () {
      if (!_this.menu.mathItem) return '';
      var text = _this.menu.mathItem.math;
      return '<pre style="font-size:125%; margin:0">' + _this.formatSource(text) + '</pre>';
    }, '');
    this.annotationText = new SelectableInfo_js_1.SelectableInfo('MathJax Annotation Text', function () {
      if (!_this.menu.mathItem) return '';
      var text = _this.menu.annotation;
      return '<pre style="font-size:125%; margin:0">' + _this.formatSource(text) + '</pre>';
    }, '');
    this.zoomBox = new info_js_1.Info('MathJax Zoomed Expression', function () {
      if (!_this.menu.mathItem) return '';
      var element = _this.menu.mathItem.typesetRoot.cloneNode(true);
      element.style.margin = '0';
      var scale = 1.25 * parseFloat(_this.settings.zscale);
      return '<div style="font-size: ' + scale + '%">' + element.outerHTML + '</div>';
    }, '');
    this.document = document;
    this.options = (0, Options_js_1$f.userOptions)((0, Options_js_1$f.defaultOptions)({}, this.constructor.OPTIONS), options);
    this.initSettings();
    this.mergeUserSettings();
    this.initMenu();
    this.applySettings();
  }
  Object.defineProperty(Menu.prototype, "isLoading", {
    get: function () {
      return Menu.loading > 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Menu.prototype, "loadingPromise", {
    get: function () {
      if (!this.isLoading) {
        return Promise.resolve();
      }
      if (!Menu._loadingPromise) {
        Menu._loadingPromise = new Promise(function (ok, failed) {
          Menu._loadingOK = ok;
          Menu._loadingFailed = failed;
        });
      }
      return Menu._loadingPromise;
    },
    enumerable: false,
    configurable: true
  });
  Menu.prototype.initSettings = function () {
    this.settings = this.options.settings;
    this.jax = this.options.jax;
    var jax = this.document.outputJax;
    this.jax[jax.name] = jax;
    this.settings.renderer = jax.name;
    if (MathJax$1._.a11y && MathJax$1._.a11y.explorer) {
      Object.assign(this.settings, this.document.options.a11y);
    }
    this.settings.scale = jax.options.scale;
    this.defaultSettings = Object.assign({}, this.settings);
  };
  Menu.prototype.initMenu = function () {
    var _this = this;
    var parser = new parse_js_1.Parser([['contextMenu', MJContextMenu_js_1.MJContextMenu.fromJson.bind(MJContextMenu_js_1.MJContextMenu)]]);
    this.menu = parser.parse({
      type: 'contextMenu',
      id: 'MathJax_Menu',
      pool: [this.variable('texHints'), this.variable('semantics'), this.variable('zoom'), this.variable('zscale'), this.variable('renderer', function (jax) {
        return _this.setRenderer(jax);
      }), this.variable('alt'), this.variable('cmd'), this.variable('ctrl'), this.variable('shift'), this.variable('scale', function (scale) {
        return _this.setScale(scale);
      }), this.variable('explorer', function (explore) {
        return _this.setExplorer(explore);
      }), this.a11yVar('highlight'), this.a11yVar('backgroundColor'), this.a11yVar('backgroundOpacity'), this.a11yVar('foregroundColor'), this.a11yVar('foregroundOpacity'), this.a11yVar('speech'), this.a11yVar('subtitles'), this.a11yVar('braille'), this.a11yVar('viewBraille'), this.a11yVar('locale', function (value) {
        return sre_js_1.default.setupEngine({
          locale: value
        });
      }), this.a11yVar('speechRules', function (value) {
        var _a = __read$R(value.split('-'), 2), domain = _a[0], style = _a[1];
        _this.document.options.sre.domain = domain;
        _this.document.options.sre.style = style;
      }), this.a11yVar('magnification'), this.a11yVar('magnify'), this.a11yVar('treeColoring'), this.a11yVar('infoType'), this.a11yVar('infoRole'), this.a11yVar('infoPrefix'), this.variable('autocollapse'), this.variable('collapsible', function (collapse) {
        return _this.setCollapsible(collapse);
      }), this.variable('inTabOrder', function (tab) {
        return _this.setTabOrder(tab);
      }), this.variable('assistiveMml', function (mml) {
        return _this.setAssistiveMml(mml);
      })],
      items: [this.submenu('Show', 'Show Math As', [this.command('MathMLcode', 'MathML Code', function () {
        return _this.mathmlCode.post();
      }), this.command('Original', 'Original Form', function () {
        return _this.originalText.post();
      }), this.submenu('Annotation', 'Annotation')]), this.submenu('Copy', 'Copy to Clipboard', [this.command('MathMLcode', 'MathML Code', function () {
        return _this.copyMathML();
      }), this.command('Original', 'Original Form', function () {
        return _this.copyOriginal();
      }), this.submenu('Annotation', 'Annotation')]), this.rule(), this.submenu('Settings', 'Math Settings', [this.submenu('Renderer', 'Math Renderer', this.radioGroup('renderer', [['CHTML'], ['SVG']])), this.rule(), this.submenu('ZoomTrigger', 'Zoom Trigger', [this.command('ZoomNow', 'Zoom Once Now', function () {
        return _this.zoom(null, '', _this.menu.mathItem);
      }), this.rule(), this.radioGroup('zoom', [['Click'], ['DoubleClick', 'Double-Click'], ['NoZoom', 'No Zoom']]), this.rule(), this.label('TriggerRequires', 'Trigger Requires:'), this.checkbox(isMac ? 'Option' : 'Alt', isMac ? 'Option' : 'Alt', 'alt'), this.checkbox('Command', 'Command', 'cmd', {
        hidden: !isMac
      }), this.checkbox('Control', 'Control', 'ctrl', {
        hiddne: isMac
      }), this.checkbox('Shift', 'Shift', 'shift')]), this.submenu('ZoomFactor', 'Zoom Factor', this.radioGroup('zscale', [['150%'], ['175%'], ['200%'], ['250%'], ['300%'], ['400%']])), this.rule(), this.command('Scale', 'Scale All Math...', function () {
        return _this.scaleAllMath();
      }), this.rule(), this.checkbox('texHints', 'Add TeX hints to MathML', 'texHints'), this.checkbox('semantics', 'Add original as annotation', 'semantics'), this.rule(), this.command('Reset', 'Reset to defaults', function () {
        return _this.resetDefaults();
      })]), this.submenu('Accessibility', 'Accessibility', [this.checkbox('Activate', 'Activate', 'explorer'), this.submenu('Speech', 'Speech', [this.checkbox('Speech', 'Speech Output', 'speech'), this.checkbox('Subtitles', 'Speech Subtitles', 'subtitles'), this.checkbox('Braille', 'Braille Output', 'braille'), this.checkbox('View Braille', 'Braille Subtitles', 'viewBraille'), this.rule(), this.submenu('A11yLanguage', 'Language'), this.rule(), this.submenu('Mathspeak', 'Mathspeak Rules', this.radioGroup('speechRules', [['mathspeak-default', 'Verbose'], ['mathspeak-brief', 'Brief'], ['mathspeak-sbrief', 'Superbrief']])), this.submenu('Clearspeak', 'Clearspeak Rules', this.radioGroup('speechRules', [['clearspeak-default', 'Auto']])), this.submenu('ChromeVox', 'ChromeVox Rules', this.radioGroup('speechRules', [['chromevox-default', 'Standard'], ['chromevox-alternative', 'Alternative']]))]), this.submenu('Highlight', 'Highlight', [this.submenu('Background', 'Background', this.radioGroup('backgroundColor', [['Blue'], ['Red'], ['Green'], ['Yellow'], ['Cyan'], ['Magenta'], ['White'], ['Black']])), {
        'type': 'slider',
        'variable': 'backgroundOpacity',
        'content': ' '
      }, this.submenu('Foreground', 'Foreground', this.radioGroup('foregroundColor', [['Black'], ['White'], ['Magenta'], ['Cyan'], ['Yellow'], ['Green'], ['Red'], ['Blue']])), {
        'type': 'slider',
        'variable': 'foregroundOpacity',
        'content': ' '
      }, this.rule(), this.radioGroup('highlight', [['None'], ['Hover'], ['Flame']]), this.rule(), this.checkbox('TreeColoring', 'Tree Coloring', 'treeColoring')]), this.submenu('Magnification', 'Magnification', [this.radioGroup('magnification', [['None'], ['Keyboard'], ['Mouse']]), this.rule(), this.radioGroup('magnify', [['200%'], ['300%'], ['400%'], ['500%']])]), this.submenu('Semantic Info', 'Semantic Info', [this.checkbox('Type', 'Type', 'infoType'), this.checkbox('Role', 'Role', 'infoRole'), this.checkbox('Prefix', 'Prefix', 'infoPrefix')], true), this.rule(), this.checkbox('Collapsible', 'Collapsible Math', 'collapsible'), this.checkbox('AutoCollapse', 'Auto Collapse', 'autocollapse', {
        disabled: true
      }), this.rule(), this.checkbox('InTabOrder', 'Include in Tab Order', 'inTabOrder'), this.checkbox('AssistiveMml', 'Include Hidden MathML', 'assistiveMml')]), this.submenu('Language', 'Language'), this.rule(), this.command('About', 'About MathJax', function () {
        return _this.about.post();
      }), this.command('Help', 'MathJax Help', function () {
        return _this.help.post();
      })]
    });
    var menu = this.menu;
    this.about.attachMenu(menu);
    this.help.attachMenu(menu);
    this.originalText.attachMenu(menu);
    this.annotationText.attachMenu(menu);
    this.mathmlCode.attachMenu(menu);
    this.zoomBox.attachMenu(menu);
    this.checkLoadableItems();
    this.enableExplorerItems(this.settings.explorer);
    menu.showAnnotation = this.annotationText;
    menu.copyAnnotation = this.copyAnnotation.bind(this);
    menu.annotationTypes = this.options.annotationTypes;
    css_util_js_1.CssStyles.addInfoStyles(this.document.document);
    css_util_js_1.CssStyles.addMenuStyles(this.document.document);
  };
  Menu.prototype.checkLoadableItems = function () {
    var e_1, _a;
    if (MathJax$1 && MathJax$1._ && MathJax$1.loader && MathJax$1.startup) {
      if (this.settings.collapsible && (!MathJax$1._.a11y || !MathJax$1._.a11y.complexity)) {
        this.loadA11y('complexity');
      }
      if (this.settings.explorer && (!MathJax$1._.a11y || !MathJax$1._.a11y.explorer)) {
        this.loadA11y('explorer');
      }
      if (this.settings.assistiveMml && (!MathJax$1._.a11y || !MathJax$1._.a11y['assistive-mml'])) {
        this.loadA11y('assistive-mml');
      }
    } else {
      var menu = this.menu;
      try {
        for (var _b = __values$I(Object.keys(this.jax)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var name_1 = _c.value;
          if (!this.jax[name_1]) {
            menu.findID('Settings', 'Renderer', name_1).disable();
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      menu.findID('Accessibility', 'Activate').disable();
      menu.findID('Accessibility', 'AutoCollapse').disable();
      menu.findID('Accessibility', 'Collapsible').disable();
    }
  };
  Menu.prototype.enableExplorerItems = function (enable) {
    var e_2, _a;
    var menu = this.menu.findID('Accessibility', 'Activate').menu;
    try {
      for (var _b = __values$I(menu.items.slice(1)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var item = _c.value;
        if (item instanceof item_rule_js_1.Rule) break;
        enable ? item.enable() : item.disable();
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  Menu.prototype.mergeUserSettings = function () {
    try {
      var settings = localStorage.getItem(Menu.MENU_STORAGE);
      if (!settings) return;
      Object.assign(this.settings, JSON.parse(settings));
      this.setA11y(this.settings);
    } catch (err) {
      console.log('MathJax localStorage error: ' + err.message);
    }
  };
  Menu.prototype.saveUserSettings = function () {
    var e_3, _a;
    var settings = {};
    try {
      for (var _b = __values$I(Object.keys(this.settings)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_2 = _c.value;
        if (this.settings[name_2] !== this.defaultSettings[name_2]) {
          settings[name_2] = this.settings[name_2];
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    try {
      if (Object.keys(settings).length) {
        localStorage.setItem(Menu.MENU_STORAGE, JSON.stringify(settings));
      } else {
        localStorage.removeItem(Menu.MENU_STORAGE);
      }
    } catch (err) {
      console.log('MathJax localStorage error: ' + err.message);
    }
  };
  Menu.prototype.setA11y = function (options) {
    if (MathJax$1._.a11y && MathJax$1._.a11y.explorer) {
      MathJax$1._.a11y.explorer_ts.setA11yOptions(this.document, options);
    }
  };
  Menu.prototype.getA11y = function (option) {
    if (MathJax$1._.a11y && MathJax$1._.a11y.explorer) {
      if (this.document.options.a11y[option] !== undefined) {
        return this.document.options.a11y[option];
      }
      return this.document.options.sre[option];
    }
  };
  Menu.prototype.applySettings = function () {
    this.setTabOrder(this.settings.inTabOrder);
    this.document.options.enableAssistiveMml = this.settings.assistiveMml;
    this.document.outputJax.options.scale = parseFloat(this.settings.scale);
    if (this.settings.renderer !== this.defaultSettings.renderer) {
      this.setRenderer(this.settings.renderer);
    }
  };
  Menu.prototype.setScale = function (scale) {
    this.document.outputJax.options.scale = parseFloat(scale);
    this.document.rerender();
  };
  Menu.prototype.setRenderer = function (jax) {
    var _this = this;
    if (this.jax[jax]) {
      this.setOutputJax(jax);
    } else {
      var name_3 = jax.toLowerCase();
      this.loadComponent('output/' + name_3, function () {
        var startup = MathJax$1.startup;
        if ((name_3 in startup.constructors)) {
          startup.useOutput(name_3, true);
          startup.output = startup.getOutputJax();
          _this.jax[jax] = startup.output;
          _this.setOutputJax(jax);
        }
      });
    }
  };
  Menu.prototype.setOutputJax = function (jax) {
    this.jax[jax].setAdaptor(this.document.adaptor);
    this.document.outputJax = this.jax[jax];
    this.rerender();
  };
  Menu.prototype.setTabOrder = function (tab) {
    this.menu.store.inTaborder(tab);
  };
  Menu.prototype.setAssistiveMml = function (mml) {
    this.document.options.enableAssistiveMml = mml;
    if (!mml || MathJax$1._.a11y && MathJax$1._.a11y['assistive-mml']) {
      this.rerender();
    } else {
      this.loadA11y('assistive-mml');
    }
  };
  Menu.prototype.setExplorer = function (explore) {
    this.enableExplorerItems(explore);
    this.document.options.enableExplorer = explore;
    if (!explore || MathJax$1._.a11y && MathJax$1._.a11y.explorer) {
      this.rerender(this.settings.collapsible ? MathItem_js_1$5.STATE.RERENDER : MathItem_js_1$5.STATE.COMPILED);
    } else {
      this.loadA11y('explorer');
    }
  };
  Menu.prototype.setCollapsible = function (collapse) {
    this.document.options.enableComplexity = collapse;
    if (!collapse || MathJax$1._.a11y && MathJax$1._.a11y.complexity) {
      this.rerender(MathItem_js_1$5.STATE.COMPILED);
    } else {
      this.loadA11y('complexity');
    }
  };
  Menu.prototype.scaleAllMath = function () {
    var scale = (parseFloat(this.settings.scale) * 100).toFixed(1).replace(/.0$/, '');
    var percent = prompt('Scale all mathematics (compared to surrounding text) by', scale + '%');
    if (percent) {
      if (percent.match(/^\s*\d+(\.\d*)?\s*%?\s*$/)) {
        var scale_1 = parseFloat(percent) / 100;
        if (scale_1) {
          this.menu.pool.lookup('scale').setValue(String(scale_1));
        } else {
          alert('The scale should not be zero');
        }
      } else {
        alert('The scale should be a percentage (e.g., 120%)');
      }
    }
  };
  Menu.prototype.resetDefaults = function () {
    var e_4, _a;
    Menu.loading++;
    var pool = this.menu.pool;
    var settings = this.defaultSettings;
    try {
      for (var _b = __values$I(Object.keys(this.settings)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_4 = _c.value;
        var variable = pool.lookup(name_4);
        if (variable) {
          variable.setValue(settings[name_4]);
          var item = variable.items[0];
          if (item) {
            item.executeCallbacks_();
          }
        } else {
          this.settings[name_4] = settings[name_4];
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    Menu.loading--;
    this.rerender(MathItem_js_1$5.STATE.COMPILED);
  };
  Menu.prototype.checkComponent = function (name) {
    var promise = Menu.loadingPromises.get(name);
    if (promise) {
      mathjax_js_1$3.mathjax.retryAfter(promise);
    }
  };
  Menu.prototype.loadComponent = function (name, callback) {
    if (Menu.loadingPromises.has(name)) return;
    var loader = MathJax$1.loader;
    if (!loader) return;
    Menu.loading++;
    var promise = loader.load(name).then(function () {
      Menu.loading--;
      Menu.loadingPromises.delete(name);
      callback();
      if (Menu.loading === 0 && Menu._loadingPromise) {
        Menu._loadingPromise = null;
        Menu._loadingOK();
      }
    }).catch(function (err) {
      if (Menu._loadingPromise) {
        Menu._loadingPromise = null;
        Menu._loadingFailed(err);
      } else {
        console.log(err);
      }
    });
    Menu.loadingPromises.set(name, promise);
  };
  Menu.prototype.loadA11y = function (component) {
    var _this = this;
    var noEnrich = !MathItem_js_1$5.STATE.ENRICHED;
    this.loadComponent('a11y/' + component, function () {
      var startup = MathJax$1.startup;
      mathjax_js_1$3.mathjax.handlers.unregister(startup.handler);
      startup.handler = startup.getHandler();
      mathjax_js_1$3.mathjax.handlers.register(startup.handler);
      var document = _this.document;
      _this.document = startup.document = startup.getDocument();
      _this.document.menu = _this;
      _this.document.outputJax.reset();
      _this.transferMathList(document);
      _this.document.processed = document.processed;
      if (!Menu._loadingPromise) {
        _this.document.outputJax.reset();
        _this.rerender(component === 'complexity' || noEnrich ? MathItem_js_1$5.STATE.COMPILED : MathItem_js_1$5.STATE.TYPESET);
      }
    });
  };
  Menu.prototype.transferMathList = function (document) {
    var e_5, _a;
    var MathItem = this.document.options.MathItem;
    try {
      for (var _b = __values$I(document.math), _c = _b.next(); !_c.done; _c = _b.next()) {
        var item = _c.value;
        var math = new MathItem();
        Object.assign(math, item);
        this.document.math.push(math);
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_5) throw e_5.error;
      }
    }
  };
  Menu.prototype.formatSource = function (text) {
    return text.trim().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };
  Menu.prototype.toMML = function (math) {
    return this.MmlVisitor.visitTree(math.root, math, {
      texHints: this.settings.texHints,
      semantics: this.settings.semantics && math.inputJax.name !== 'MathML'
    });
  };
  Menu.prototype.zoom = function (event, type, math) {
    if (!event || this.isZoomEvent(event, type)) {
      this.menu.mathItem = math;
      if (event) {
        this.menu.post(event);
      }
      this.zoomBox.post();
    }
  };
  Menu.prototype.isZoomEvent = function (event, zoom) {
    return this.settings.zoom === zoom && (!this.settings.alt || event.altKey) && (!this.settings.ctrl || event.ctrlKey) && (!this.settings.cmd || event.metaKey) && (!this.settings.shift || event.shiftKey);
  };
  Menu.prototype.rerender = function (start) {
    if (start === void 0) {
      start = MathItem_js_1$5.STATE.TYPESET;
    }
    this.rerenderStart = Math.min(start, this.rerenderStart);
    if (!Menu.loading) {
      if (this.rerenderStart <= MathItem_js_1$5.STATE.COMPILED) {
        this.document.reset({
          inputJax: []
        });
      }
      this.document.rerender(this.rerenderStart);
      this.rerenderStart = MathItem_js_1$5.STATE.LAST;
    }
  };
  Menu.prototype.copyMathML = function () {
    this.copyToClipboard(this.toMML(this.menu.mathItem));
  };
  Menu.prototype.copyOriginal = function () {
    this.copyToClipboard(this.menu.mathItem.math.trim());
  };
  Menu.prototype.copyAnnotation = function () {
    this.copyToClipboard(this.menu.annotation.trim());
  };
  Menu.prototype.copyToClipboard = function (text) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.cssText = 'height: 1px; width: 1px; padding: 1px; position: absolute; left: -10px';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
    } catch (error) {
      alert('Can\'t copy to clipboard: ' + error.message);
    }
    document.body.removeChild(input);
  };
  Menu.prototype.addMenu = function (math) {
    var _this = this;
    var element = math.typesetRoot;
    element.addEventListener('contextmenu', function () {
      return _this.menu.mathItem = math;
    }, true);
    element.addEventListener('keydown', function () {
      return _this.menu.mathItem = math;
    }, true);
    element.addEventListener('click', function (event) {
      return _this.zoom(event, 'Click', math);
    }, true);
    element.addEventListener('dblclick', function (event) {
      return _this.zoom(event, 'DoubleClick', math);
    }, true);
    this.menu.store.insert(element);
  };
  Menu.prototype.clear = function () {
    this.menu.store.clear();
  };
  Menu.prototype.variable = function (name, action) {
    var _this = this;
    return {
      name: name,
      getter: function () {
        return _this.settings[name];
      },
      setter: function (value) {
        _this.settings[name] = value;
        action && action(value);
        _this.saveUserSettings();
      }
    };
  };
  Menu.prototype.a11yVar = function (name, action) {
    var _this = this;
    return {
      name: name,
      getter: function () {
        return _this.getA11y(name);
      },
      setter: function (value) {
        _this.settings[name] = value;
        var options = {};
        options[name] = value;
        _this.setA11y(options);
        action && action(value);
        _this.saveUserSettings();
      }
    };
  };
  Menu.prototype.submenu = function (id, content, entries, disabled) {
    var e_6, _a;
    if (entries === void 0) {
      entries = [];
    }
    if (disabled === void 0) {
      disabled = false;
    }
    var items = [];
    try {
      for (var entries_1 = __values$I(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
        var entry = entries_1_1.value;
        if (Array.isArray(entry)) {
          items = items.concat(entry);
        } else {
          items.push(entry);
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
      } finally {
        if (e_6) throw e_6.error;
      }
    }
    return {
      type: 'submenu',
      id: id,
      content: content,
      menu: {
        items: items
      },
      disabled: items.length === 0 || disabled
    };
  };
  Menu.prototype.command = function (id, content, action, other) {
    if (other === void 0) {
      other = {};
    }
    return Object.assign({
      type: 'command',
      id: id,
      content: content,
      action: action
    }, other);
  };
  Menu.prototype.checkbox = function (id, content, variable, other) {
    if (other === void 0) {
      other = {};
    }
    return Object.assign({
      type: 'checkbox',
      id: id,
      content: content,
      variable: variable
    }, other);
  };
  Menu.prototype.radioGroup = function (variable, radios) {
    var _this = this;
    return radios.map(function (def) {
      return _this.radio(def[0], def[1] || def[0], variable);
    });
  };
  Menu.prototype.radio = function (id, content, variable, other) {
    if (other === void 0) {
      other = {};
    }
    return Object.assign({
      type: 'radio',
      id: id,
      content: content,
      variable: variable
    }, other);
  };
  Menu.prototype.label = function (id, content) {
    return {
      type: 'label',
      id: id,
      content: content
    };
  };
  Menu.prototype.rule = function () {
    return {
      type: 'rule'
    };
  };
  Menu.MENU_STORAGE = 'MathJax-Menu-Settings';
  Menu.OPTIONS = {
    settings: {
      texHints: true,
      semantics: false,
      zoom: 'NoZoom',
      zscale: '200%',
      renderer: 'CHTML',
      alt: false,
      cmd: false,
      ctrl: false,
      shift: false,
      scale: 1,
      autocollapse: false,
      collapsible: false,
      inTabOrder: true,
      assistiveMml: true,
      explorer: false
    },
    jax: {
      CHTML: null,
      SVG: null
    },
    annotationTypes: (0, Options_js_1$f.expandable)({
      TeX: ['TeX', 'LaTeX', 'application/x-tex'],
      StarMath: ['StarMath 5.0'],
      Maple: ['Maple'],
      ContentMathML: ['MathML-Content', 'application/mathml-content+xml'],
      OpenMath: ['OpenMath']
    })
  };
  Menu.loading = 0;
  Menu.loadingPromises = new Map();
  Menu._loadingPromise = null;
  Menu._loadingOK = null;
  Menu._loadingFailed = null;
  return Menu;
})();
Menu$1.Menu = Menu;

var __extends$1n = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$c = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$c = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$c.apply(this, arguments);
});
var __read$Q = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$t = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$H = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(MenuHandler$1, "__esModule", {
  value: true
});
var MenuHandler_2 = MenuHandler$1.MenuHandler = MenuHandler$1.MenuMathDocumentMixin = MenuHandler$1.MenuMathItemMixin = void 0;
var mathjax_js_1$2 = mathjax;
var MathItem_js_1$4 = MathItem;
var Options_js_1$e = Options;
var Menu_js_1 = Menu$1;
(0, MathItem_js_1$4.newState)('CONTEXT_MENU', 170);
function MenuMathItemMixin(BaseMathItem) {
  return (function (_super) {
    __extends$1n(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.addMenu = function (document, force) {
      if (force === void 0) {
        force = false;
      }
      if (this.state() >= MathItem_js_1$4.STATE.CONTEXT_MENU) return;
      if (!this.isEscaped && (document.options.enableMenu || force)) {
        document.menu.addMenu(this);
      }
      this.state(MathItem_js_1$4.STATE.CONTEXT_MENU);
    };
    class_1.prototype.checkLoading = function (document) {
      document.checkLoading();
    };
    return class_1;
  })(BaseMathItem);
}
MenuHandler$1.MenuMathItemMixin = MenuMathItemMixin;
function MenuMathDocumentMixin(BaseDocument) {
  var _a;
  return (_a = (function (_super) {
    __extends$1n(class_2, _super);
    function class_2() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$t([], __read$Q(args), false)) || this;
      _this.menu = new _this.options.MenuClass(_this, _this.options.menuOptions);
      var ProcessBits = _this.constructor.ProcessBits;
      if (!ProcessBits.has('context-menu')) {
        ProcessBits.allocate('context-menu');
      }
      _this.options.MathItem = MenuMathItemMixin(_this.options.MathItem);
      return _this;
    }
    class_2.prototype.addMenu = function () {
      var e_1, _a;
      if (!this.processed.isSet('context-menu')) {
        try {
          for (var _b = __values$H(this.math), _c = _b.next(); !_c.done; _c = _b.next()) {
            var math = _c.value;
            math.addMenu(this);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        this.processed.set('context-menu');
      }
      return this;
    };
    class_2.prototype.checkLoading = function () {
      if (this.menu.isLoading) {
        mathjax_js_1$2.mathjax.retryAfter(this.menu.loadingPromise.catch(function (err) {
          return console.log(err);
        }));
      }
      var settings = this.menu.settings;
      if (settings.collapsible) {
        this.options.enableComplexity = true;
        this.menu.checkComponent('a11y/complexity');
      }
      if (settings.explorer) {
        this.options.enableEnrichment = true;
        this.options.enableExplorer = true;
        this.menu.checkComponent('a11y/explorer');
      }
      return this;
    };
    class_2.prototype.state = function (state, restore) {
      if (restore === void 0) {
        restore = false;
      }
      _super.prototype.state.call(this, state, restore);
      if (state < MathItem_js_1$4.STATE.CONTEXT_MENU) {
        this.processed.clear('context-menu');
      }
      return this;
    };
    class_2.prototype.updateDocument = function () {
      _super.prototype.updateDocument.call(this);
      this.menu.menu.store.sort();
      return this;
    };
    return class_2;
  })(BaseDocument), _a.OPTIONS = __assign$c(__assign$c({
    enableEnrichment: true,
    enableComplexity: true,
    enableExplorer: true,
    enrichSpeech: 'none',
    enrichError: function (_doc, _math, err) {
      return console.warn('Enrichment Error:', err);
    }
  }, BaseDocument.OPTIONS), {
    MenuClass: Menu_js_1.Menu,
    menuOptions: Menu_js_1.Menu.OPTIONS,
    enableMenu: true,
    sre: BaseDocument.OPTIONS.sre || (0, Options_js_1$e.expandable)({}),
    a11y: BaseDocument.OPTIONS.a11y || (0, Options_js_1$e.expandable)({}),
    renderActions: (0, Options_js_1$e.expandable)(__assign$c(__assign$c({}, BaseDocument.OPTIONS.renderActions), {
      addMenu: [MathItem_js_1$4.STATE.CONTEXT_MENU],
      checkLoading: [MathItem_js_1$4.STATE.UNPROCESSED + 1]
    }))
  }), _a);
}
MenuHandler$1.MenuMathDocumentMixin = MenuMathDocumentMixin;
function MenuHandler(handler) {
  handler.documentClass = MenuMathDocumentMixin(handler.documentClass);
  return handler;
}
MenuHandler_2 = MenuHandler$1.MenuHandler = MenuHandler;

var FindMathML$1 = {};

var FindMath = {};

Object.defineProperty(FindMath, "__esModule", {
  value: true
});
FindMath.AbstractFindMath = void 0;
var Options_js_1$d = Options;
var AbstractFindMath = (function () {
  function AbstractFindMath(options) {
    var CLASS = this.constructor;
    this.options = (0, Options_js_1$d.userOptions)((0, Options_js_1$d.defaultOptions)({}, CLASS.OPTIONS), options);
  }
  AbstractFindMath.OPTIONS = {};
  return AbstractFindMath;
})();
FindMath.AbstractFindMath = AbstractFindMath;

var __extends$1m = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$G = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(FindMathML$1, "__esModule", {
  value: true
});
var FindMathML_2 = FindMathML$1.FindMathML = void 0;
var FindMath_js_1$1 = FindMath;
var NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
var FindMathML = (function (_super) {
  __extends$1m(FindMathML, _super);
  function FindMathML() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FindMathML.prototype.findMath = function (node) {
    var set = new Set();
    this.findMathNodes(node, set);
    this.findMathPrefixed(node, set);
    var html = this.adaptor.root(this.adaptor.document);
    if (this.adaptor.kind(html) === 'html' && set.size === 0) {
      this.findMathNS(node, set);
    }
    return this.processMath(set);
  };
  FindMathML.prototype.findMathNodes = function (node, set) {
    var e_1, _a;
    try {
      for (var _b = __values$G(this.adaptor.tags(node, 'math')), _c = _b.next(); !_c.done; _c = _b.next()) {
        var math = _c.value;
        set.add(math);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  FindMathML.prototype.findMathPrefixed = function (node, set) {
    var e_2, _a, e_3, _b;
    var html = this.adaptor.root(this.adaptor.document);
    try {
      for (var _c = __values$G(this.adaptor.allAttributes(html)), _d = _c.next(); !_d.done; _d = _c.next()) {
        var attr = _d.value;
        if (attr.name.substr(0, 6) === 'xmlns:' && attr.value === NAMESPACE) {
          var prefix = attr.name.substr(6);
          try {
            for (var _e = (e_3 = void 0, __values$G(this.adaptor.tags(node, prefix + ':math'))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var math = _f.value;
              set.add(math);
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  FindMathML.prototype.findMathNS = function (node, set) {
    var e_4, _a;
    try {
      for (var _b = __values$G(this.adaptor.tags(node, 'math', NAMESPACE)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var math = _c.value;
        set.add(math);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
  };
  FindMathML.prototype.processMath = function (set) {
    var e_5, _a;
    var math = [];
    try {
      for (var _b = __values$G(Array.from(set)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var mml = _c.value;
        var display = this.adaptor.getAttribute(mml, 'display') === 'block' || this.adaptor.getAttribute(mml, 'mode') === 'display';
        var start = {
          node: mml,
          n: 0,
          delim: ''
        };
        var end = {
          node: mml,
          n: 0,
          delim: ''
        };
        math.push({
          math: this.adaptor.outerHTML(mml),
          start: start,
          end: end,
          display: display
        });
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_5) throw e_5.error;
      }
    }
    return math;
  };
  FindMathML.OPTIONS = {};
  return FindMathML;
})(FindMath_js_1$1.AbstractFindMath);
FindMathML_2 = FindMathML$1.FindMathML = FindMathML;

var mathml = {};

var InputJax = {};

var FunctionList$1 = {};

var __extends$1l = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$F = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$P = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$s = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(FunctionList$1, "__esModule", {
  value: true
});
FunctionList$1.FunctionList = void 0;
var PrioritizedList_js_1 = PrioritizedList$1;
var FunctionList = (function (_super) {
  __extends$1l(FunctionList, _super);
  function FunctionList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FunctionList.prototype.execute = function () {
    var e_1, _a;
    var data = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      data[_i] = arguments[_i];
    }
    try {
      for (var _b = __values$F(this), _c = _b.next(); !_c.done; _c = _b.next()) {
        var item = _c.value;
        var result = item.item.apply(item, __spreadArray$s([], __read$P(data), false));
        if (result === false) {
          return false;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return true;
  };
  FunctionList.prototype.asyncExecute = function () {
    var data = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      data[_i] = arguments[_i];
    }
    var i = -1;
    var items = this.items;
    return new Promise(function (ok, fail) {
      (function execute() {
        var _a;
        while (++i < items.length) {
          var result = (_a = items[i]).item.apply(_a, __spreadArray$s([], __read$P(data), false));
          if (result instanceof Promise) {
            result.then(execute).catch(function (err) {
              return fail(err);
            });
            return;
          }
          if (result === false) {
            ok(false);
            return;
          }
        }
        ok(true);
      })();
    });
  };
  return FunctionList;
})(PrioritizedList_js_1.PrioritizedList);
FunctionList$1.FunctionList = FunctionList;

Object.defineProperty(InputJax, "__esModule", {
  value: true
});
InputJax.AbstractInputJax = void 0;
var Options_js_1$c = Options;
var FunctionList_js_1$2 = FunctionList$1;
var AbstractInputJax = (function () {
  function AbstractInputJax(options) {
    if (options === void 0) {
      options = {};
    }
    this.adaptor = null;
    this.mmlFactory = null;
    var CLASS = this.constructor;
    this.options = (0, Options_js_1$c.userOptions)((0, Options_js_1$c.defaultOptions)({}, CLASS.OPTIONS), options);
    this.preFilters = new FunctionList_js_1$2.FunctionList();
    this.postFilters = new FunctionList_js_1$2.FunctionList();
  }
  Object.defineProperty(AbstractInputJax.prototype, "name", {
    get: function () {
      return this.constructor.NAME;
    },
    enumerable: false,
    configurable: true
  });
  AbstractInputJax.prototype.setAdaptor = function (adaptor) {
    this.adaptor = adaptor;
  };
  AbstractInputJax.prototype.setMmlFactory = function (mmlFactory) {
    this.mmlFactory = mmlFactory;
  };
  AbstractInputJax.prototype.initialize = function () {};
  AbstractInputJax.prototype.reset = function () {
  };
  Object.defineProperty(AbstractInputJax.prototype, "processStrings", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  AbstractInputJax.prototype.findMath = function (_node, _options) {
    return [];
  };
  AbstractInputJax.prototype.executeFilters = function (filters, math, document, data) {
    var args = {
      math: math,
      document: document,
      data: data
    };
    filters.execute(args);
    return args.data;
  };
  AbstractInputJax.NAME = 'generic';
  AbstractInputJax.OPTIONS = {};
  return AbstractInputJax;
})();
InputJax.AbstractInputJax = AbstractInputJax;

var MathMLCompile$1 = {};

var Entities$1 = {};

var AsyncLoad = {};

Object.defineProperty(AsyncLoad, "__esModule", {
  value: true
});
AsyncLoad.asyncLoad = void 0;
var mathjax_js_1$1 = mathjax;
function asyncLoad(name) {
  if (!mathjax_js_1$1.mathjax.asyncLoad) {
    return Promise.reject(("Can't load '").concat(name, "': No asyncLoad method specified"));
  }
  return new Promise(function (ok, fail) {
    var result = mathjax_js_1$1.mathjax.asyncLoad(name);
    if (result instanceof Promise) {
      result.then(function (value) {
        return ok(value);
      }).catch(function (err) {
        return fail(err);
      });
    } else {
      ok(result);
    }
  });
}
AsyncLoad.asyncLoad = asyncLoad;

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.numeric = exports.translate = exports.remove = exports.add = exports.entities = exports.options = void 0;
  var Retries_js_1 = Retries;
  var AsyncLoad_js_1 = AsyncLoad;
  exports.options = {
    loadMissingEntities: true
  };
  exports.entities = {
    ApplyFunction: '\u2061',
    Backslash: '\u2216',
    Because: '\u2235',
    Breve: '\u02D8',
    Cap: '\u22D2',
    CenterDot: '\u00B7',
    CircleDot: '\u2299',
    CircleMinus: '\u2296',
    CirclePlus: '\u2295',
    CircleTimes: '\u2297',
    Congruent: '\u2261',
    ContourIntegral: '\u222E',
    Coproduct: '\u2210',
    Cross: '\u2A2F',
    Cup: '\u22D3',
    CupCap: '\u224D',
    Dagger: '\u2021',
    Del: '\u2207',
    Delta: '\u0394',
    Diamond: '\u22C4',
    DifferentialD: '\u2146',
    DotEqual: '\u2250',
    DoubleDot: '\u00A8',
    DoubleRightTee: '\u22A8',
    DoubleVerticalBar: '\u2225',
    DownArrow: '\u2193',
    DownLeftVector: '\u21BD',
    DownRightVector: '\u21C1',
    DownTee: '\u22A4',
    Downarrow: '\u21D3',
    Element: '\u2208',
    EqualTilde: '\u2242',
    Equilibrium: '\u21CC',
    Exists: '\u2203',
    ExponentialE: '\u2147',
    FilledVerySmallSquare: '\u25AA',
    ForAll: '\u2200',
    Gamma: '\u0393',
    Gg: '\u22D9',
    GreaterEqual: '\u2265',
    GreaterEqualLess: '\u22DB',
    GreaterFullEqual: '\u2267',
    GreaterLess: '\u2277',
    GreaterSlantEqual: '\u2A7E',
    GreaterTilde: '\u2273',
    Hacek: '\u02C7',
    Hat: '\u005E',
    HumpDownHump: '\u224E',
    HumpEqual: '\u224F',
    Im: '\u2111',
    ImaginaryI: '\u2148',
    Integral: '\u222B',
    Intersection: '\u22C2',
    InvisibleComma: '\u2063',
    InvisibleTimes: '\u2062',
    Lambda: '\u039B',
    Larr: '\u219E',
    LeftAngleBracket: '\u27E8',
    LeftArrow: '\u2190',
    LeftArrowRightArrow: '\u21C6',
    LeftCeiling: '\u2308',
    LeftDownVector: '\u21C3',
    LeftFloor: '\u230A',
    LeftRightArrow: '\u2194',
    LeftTee: '\u22A3',
    LeftTriangle: '\u22B2',
    LeftTriangleEqual: '\u22B4',
    LeftUpVector: '\u21BF',
    LeftVector: '\u21BC',
    Leftarrow: '\u21D0',
    Leftrightarrow: '\u21D4',
    LessEqualGreater: '\u22DA',
    LessFullEqual: '\u2266',
    LessGreater: '\u2276',
    LessSlantEqual: '\u2A7D',
    LessTilde: '\u2272',
    Ll: '\u22D8',
    Lleftarrow: '\u21DA',
    LongLeftArrow: '\u27F5',
    LongLeftRightArrow: '\u27F7',
    LongRightArrow: '\u27F6',
    Longleftarrow: '\u27F8',
    Longleftrightarrow: '\u27FA',
    Longrightarrow: '\u27F9',
    Lsh: '\u21B0',
    MinusPlus: '\u2213',
    NestedGreaterGreater: '\u226B',
    NestedLessLess: '\u226A',
    NotDoubleVerticalBar: '\u2226',
    NotElement: '\u2209',
    NotEqual: '\u2260',
    NotExists: '\u2204',
    NotGreater: '\u226F',
    NotGreaterEqual: '\u2271',
    NotLeftTriangle: '\u22EA',
    NotLeftTriangleEqual: '\u22EC',
    NotLess: '\u226E',
    NotLessEqual: '\u2270',
    NotPrecedes: '\u2280',
    NotPrecedesSlantEqual: '\u22E0',
    NotRightTriangle: '\u22EB',
    NotRightTriangleEqual: '\u22ED',
    NotSubsetEqual: '\u2288',
    NotSucceeds: '\u2281',
    NotSucceedsSlantEqual: '\u22E1',
    NotSupersetEqual: '\u2289',
    NotTilde: '\u2241',
    NotVerticalBar: '\u2224',
    Omega: '\u03A9',
    OverBar: '\u203E',
    OverBrace: '\u23DE',
    PartialD: '\u2202',
    Phi: '\u03A6',
    Pi: '\u03A0',
    PlusMinus: '\u00B1',
    Precedes: '\u227A',
    PrecedesEqual: '\u2AAF',
    PrecedesSlantEqual: '\u227C',
    PrecedesTilde: '\u227E',
    Product: '\u220F',
    Proportional: '\u221D',
    Psi: '\u03A8',
    Rarr: '\u21A0',
    Re: '\u211C',
    ReverseEquilibrium: '\u21CB',
    RightAngleBracket: '\u27E9',
    RightArrow: '\u2192',
    RightArrowLeftArrow: '\u21C4',
    RightCeiling: '\u2309',
    RightDownVector: '\u21C2',
    RightFloor: '\u230B',
    RightTee: '\u22A2',
    RightTeeArrow: '\u21A6',
    RightTriangle: '\u22B3',
    RightTriangleEqual: '\u22B5',
    RightUpVector: '\u21BE',
    RightVector: '\u21C0',
    Rightarrow: '\u21D2',
    Rrightarrow: '\u21DB',
    Rsh: '\u21B1',
    Sigma: '\u03A3',
    SmallCircle: '\u2218',
    Sqrt: '\u221A',
    Square: '\u25A1',
    SquareIntersection: '\u2293',
    SquareSubset: '\u228F',
    SquareSubsetEqual: '\u2291',
    SquareSuperset: '\u2290',
    SquareSupersetEqual: '\u2292',
    SquareUnion: '\u2294',
    Star: '\u22C6',
    Subset: '\u22D0',
    SubsetEqual: '\u2286',
    Succeeds: '\u227B',
    SucceedsEqual: '\u2AB0',
    SucceedsSlantEqual: '\u227D',
    SucceedsTilde: '\u227F',
    SuchThat: '\u220B',
    Sum: '\u2211',
    Superset: '\u2283',
    SupersetEqual: '\u2287',
    Supset: '\u22D1',
    Therefore: '\u2234',
    Theta: '\u0398',
    Tilde: '\u223C',
    TildeEqual: '\u2243',
    TildeFullEqual: '\u2245',
    TildeTilde: '\u2248',
    UnderBar: '\u005F',
    UnderBrace: '\u23DF',
    Union: '\u22C3',
    UnionPlus: '\u228E',
    UpArrow: '\u2191',
    UpDownArrow: '\u2195',
    UpTee: '\u22A5',
    Uparrow: '\u21D1',
    Updownarrow: '\u21D5',
    Upsilon: '\u03A5',
    Vdash: '\u22A9',
    Vee: '\u22C1',
    VerticalBar: '\u2223',
    VerticalTilde: '\u2240',
    Vvdash: '\u22AA',
    Wedge: '\u22C0',
    Xi: '\u039E',
    amp: '\u0026',
    acute: '\u00B4',
    aleph: '\u2135',
    alpha: '\u03B1',
    amalg: '\u2A3F',
    and: '\u2227',
    ang: '\u2220',
    angmsd: '\u2221',
    angsph: '\u2222',
    ape: '\u224A',
    backprime: '\u2035',
    backsim: '\u223D',
    backsimeq: '\u22CD',
    beta: '\u03B2',
    beth: '\u2136',
    between: '\u226C',
    bigcirc: '\u25EF',
    bigodot: '\u2A00',
    bigoplus: '\u2A01',
    bigotimes: '\u2A02',
    bigsqcup: '\u2A06',
    bigstar: '\u2605',
    bigtriangledown: '\u25BD',
    bigtriangleup: '\u25B3',
    biguplus: '\u2A04',
    blacklozenge: '\u29EB',
    blacktriangle: '\u25B4',
    blacktriangledown: '\u25BE',
    blacktriangleleft: '\u25C2',
    bowtie: '\u22C8',
    boxdl: '\u2510',
    boxdr: '\u250C',
    boxminus: '\u229F',
    boxplus: '\u229E',
    boxtimes: '\u22A0',
    boxul: '\u2518',
    boxur: '\u2514',
    bsol: '\u005C',
    bull: '\u2022',
    cap: '\u2229',
    check: '\u2713',
    chi: '\u03C7',
    circ: '\u02C6',
    circeq: '\u2257',
    circlearrowleft: '\u21BA',
    circlearrowright: '\u21BB',
    circledR: '\u00AE',
    circledS: '\u24C8',
    circledast: '\u229B',
    circledcirc: '\u229A',
    circleddash: '\u229D',
    clubs: '\u2663',
    colon: '\u003A',
    comp: '\u2201',
    ctdot: '\u22EF',
    cuepr: '\u22DE',
    cuesc: '\u22DF',
    cularr: '\u21B6',
    cup: '\u222A',
    curarr: '\u21B7',
    curlyvee: '\u22CE',
    curlywedge: '\u22CF',
    dagger: '\u2020',
    daleth: '\u2138',
    ddarr: '\u21CA',
    deg: '\u00B0',
    delta: '\u03B4',
    digamma: '\u03DD',
    div: '\u00F7',
    divideontimes: '\u22C7',
    dot: '\u02D9',
    doteqdot: '\u2251',
    dotplus: '\u2214',
    dotsquare: '\u22A1',
    dtdot: '\u22F1',
    ecir: '\u2256',
    efDot: '\u2252',
    egs: '\u2A96',
    ell: '\u2113',
    els: '\u2A95',
    empty: '\u2205',
    epsi: '\u03B5',
    epsiv: '\u03F5',
    erDot: '\u2253',
    eta: '\u03B7',
    eth: '\u00F0',
    flat: '\u266D',
    fork: '\u22D4',
    frown: '\u2322',
    gEl: '\u2A8C',
    gamma: '\u03B3',
    gap: '\u2A86',
    gimel: '\u2137',
    gnE: '\u2269',
    gnap: '\u2A8A',
    gne: '\u2A88',
    gnsim: '\u22E7',
    gt: '\u003E',
    gtdot: '\u22D7',
    harrw: '\u21AD',
    hbar: '\u210F',
    hellip: '\u2026',
    hookleftarrow: '\u21A9',
    hookrightarrow: '\u21AA',
    imath: '\u0131',
    infin: '\u221E',
    intcal: '\u22BA',
    iota: '\u03B9',
    jmath: '\u0237',
    kappa: '\u03BA',
    kappav: '\u03F0',
    lEg: '\u2A8B',
    lambda: '\u03BB',
    lap: '\u2A85',
    larrlp: '\u21AB',
    larrtl: '\u21A2',
    lbrace: '\u007B',
    lbrack: '\u005B',
    le: '\u2264',
    leftleftarrows: '\u21C7',
    leftthreetimes: '\u22CB',
    lessdot: '\u22D6',
    lmoust: '\u23B0',
    lnE: '\u2268',
    lnap: '\u2A89',
    lne: '\u2A87',
    lnsim: '\u22E6',
    longmapsto: '\u27FC',
    looparrowright: '\u21AC',
    lowast: '\u2217',
    loz: '\u25CA',
    lt: '\u003C',
    ltimes: '\u22C9',
    ltri: '\u25C3',
    macr: '\u00AF',
    malt: '\u2720',
    mho: '\u2127',
    mu: '\u03BC',
    multimap: '\u22B8',
    nLeftarrow: '\u21CD',
    nLeftrightarrow: '\u21CE',
    nRightarrow: '\u21CF',
    nVDash: '\u22AF',
    nVdash: '\u22AE',
    natur: '\u266E',
    nearr: '\u2197',
    nharr: '\u21AE',
    nlarr: '\u219A',
    not: '\u00AC',
    nrarr: '\u219B',
    nu: '\u03BD',
    nvDash: '\u22AD',
    nvdash: '\u22AC',
    nwarr: '\u2196',
    omega: '\u03C9',
    omicron: '\u03BF',
    or: '\u2228',
    osol: '\u2298',
    period: '\u002E',
    phi: '\u03C6',
    phiv: '\u03D5',
    pi: '\u03C0',
    piv: '\u03D6',
    prap: '\u2AB7',
    precnapprox: '\u2AB9',
    precneqq: '\u2AB5',
    precnsim: '\u22E8',
    prime: '\u2032',
    psi: '\u03C8',
    quot: '\u0022',
    rarrtl: '\u21A3',
    rbrace: '\u007D',
    rbrack: '\u005D',
    rho: '\u03C1',
    rhov: '\u03F1',
    rightrightarrows: '\u21C9',
    rightthreetimes: '\u22CC',
    ring: '\u02DA',
    rmoust: '\u23B1',
    rtimes: '\u22CA',
    rtri: '\u25B9',
    scap: '\u2AB8',
    scnE: '\u2AB6',
    scnap: '\u2ABA',
    scnsim: '\u22E9',
    sdot: '\u22C5',
    searr: '\u2198',
    sect: '\u00A7',
    sharp: '\u266F',
    sigma: '\u03C3',
    sigmav: '\u03C2',
    simne: '\u2246',
    smile: '\u2323',
    spades: '\u2660',
    sub: '\u2282',
    subE: '\u2AC5',
    subnE: '\u2ACB',
    subne: '\u228A',
    supE: '\u2AC6',
    supnE: '\u2ACC',
    supne: '\u228B',
    swarr: '\u2199',
    tau: '\u03C4',
    theta: '\u03B8',
    thetav: '\u03D1',
    tilde: '\u02DC',
    times: '\u00D7',
    triangle: '\u25B5',
    triangleq: '\u225C',
    upsi: '\u03C5',
    upuparrows: '\u21C8',
    veebar: '\u22BB',
    vellip: '\u22EE',
    weierp: '\u2118',
    xi: '\u03BE',
    yen: '\u00A5',
    zeta: '\u03B6',
    zigrarr: '\u21DD',
    nbsp: '\u00A0',
    rsquo: '\u2019',
    lsquo: '\u2018'
  };
  var loaded = {};
  function add(additions, file) {
    Object.assign(exports.entities, additions);
    loaded[file] = true;
  }
  exports.add = add;
  function remove(entity) {
    delete exports.entities[entity];
  }
  exports.remove = remove;
  function translate(text) {
    return text.replace(/&([a-z][a-z0-9]*|#(?:[0-9]+|x[0-9a-f]+));/ig, replace);
  }
  exports.translate = translate;
  function replace(match, entity) {
    if (entity.charAt(0) === '#') {
      return numeric(entity.slice(1));
    }
    if (exports.entities[entity]) {
      return exports.entities[entity];
    }
    if (exports.options['loadMissingEntities']) {
      var file = entity.match(/^[a-zA-Z](fr|scr|opf)$/) ? RegExp.$1 : entity.charAt(0).toLowerCase();
      if (!loaded[file]) {
        loaded[file] = true;
        (0, Retries_js_1.retryAfter)((0, AsyncLoad_js_1.asyncLoad)('./util/entities/' + file + '.js'));
      }
    }
    return match;
  }
  function numeric(entity) {
    var n = entity.charAt(0) === 'x' ? parseInt(entity.slice(1), 16) : parseInt(entity);
    return String.fromCodePoint(n);
  }
  exports.numeric = numeric;
})(Entities$1);
getDefaultExportFromCjs(Entities$1);

var __assign$b = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$b = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$b.apply(this, arguments);
});
var __createBinding$d = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$d = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$d = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$d(result, mod, k);
  __setModuleDefault$d(result, mod);
  return result;
});
var __values$E = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(MathMLCompile$1, "__esModule", {
  value: true
});
MathMLCompile$1.MathMLCompile = void 0;
var MmlNode_js_1$k = MmlNode;
var Options_js_1$b = Options;
var Entities = __importStar$d(Entities$1);
var MathMLCompile = (function () {
  function MathMLCompile(options) {
    if (options === void 0) {
      options = {};
    }
    var Class = this.constructor;
    this.options = (0, Options_js_1$b.userOptions)((0, Options_js_1$b.defaultOptions)({}, Class.OPTIONS), options);
  }
  MathMLCompile.prototype.setMmlFactory = function (mmlFactory) {
    this.factory = mmlFactory;
  };
  MathMLCompile.prototype.compile = function (node) {
    var mml = this.makeNode(node);
    mml.verifyTree(this.options['verify']);
    mml.setInheritedAttributes({}, false, 0, false);
    mml.walkTree(this.markMrows);
    return mml;
  };
  MathMLCompile.prototype.makeNode = function (node) {
    var e_1, _a;
    var adaptor = this.adaptor;
    var limits = false;
    var kind = adaptor.kind(node).replace(/^.*:/, '');
    var texClass = adaptor.getAttribute(node, 'data-mjx-texclass') || '';
    if (texClass) {
      texClass = this.filterAttribute('data-mjx-texclass', texClass) || '';
    }
    var type = texClass && kind === 'mrow' ? 'TeXAtom' : kind;
    try {
      for (var _b = __values$E(this.filterClassList(adaptor.allClasses(node))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_1 = _c.value;
        if (name_1.match(/^MJX-TeXAtom-/) && kind === 'mrow') {
          texClass = name_1.substr(12);
          type = 'TeXAtom';
        } else if (name_1 === 'MJX-fixedlimits') {
          limits = true;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    this.factory.getNodeClass(type) || this.error('Unknown node type "' + type + '"');
    var mml = this.factory.create(type);
    if (type === 'TeXAtom' && texClass === 'OP' && !limits) {
      mml.setProperty('movesupsub', true);
      mml.attributes.setInherited('movablelimits', true);
    }
    if (texClass) {
      mml.texClass = MmlNode_js_1$k.TEXCLASS[texClass];
      mml.setProperty('texClass', mml.texClass);
    }
    this.addAttributes(mml, node);
    this.checkClass(mml, node);
    this.addChildren(mml, node);
    return mml;
  };
  MathMLCompile.prototype.addAttributes = function (mml, node) {
    var e_2, _a;
    var ignoreVariant = false;
    try {
      for (var _b = __values$E(this.adaptor.allAttributes(node)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var attr = _c.value;
        var name_2 = attr.name;
        var value = this.filterAttribute(name_2, attr.value);
        if (value === null || name_2 === 'xmlns') {
          continue;
        }
        if (name_2.substr(0, 9) === 'data-mjx-') {
          switch (name_2.substr(9)) {
            case 'alternate':
              mml.setProperty('variantForm', true);
              break;
            case 'variant':
              mml.attributes.set('mathvariant', value);
              ignoreVariant = true;
              break;
            case 'smallmatrix':
              mml.setProperty('scriptlevel', 1);
              mml.setProperty('useHeight', false);
              break;
            case 'accent':
              mml.setProperty('mathaccent', value === 'true');
              break;
            case 'auto-op':
              mml.setProperty('autoOP', value === 'true');
              break;
            case 'script-align':
              mml.setProperty('scriptalign', value);
              break;
          }
        } else if (name_2 !== 'class') {
          var val = value.toLowerCase();
          if (val === 'true' || val === 'false') {
            mml.attributes.set(name_2, val === 'true');
          } else if (!ignoreVariant || name_2 !== 'mathvariant') {
            mml.attributes.set(name_2, value);
          }
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  MathMLCompile.prototype.filterAttribute = function (_name, value) {
    return value;
  };
  MathMLCompile.prototype.filterClassList = function (list) {
    return list;
  };
  MathMLCompile.prototype.addChildren = function (mml, node) {
    var e_3, _a;
    if (mml.arity === 0) {
      return;
    }
    var adaptor = this.adaptor;
    try {
      for (var _b = __values$E(adaptor.childNodes(node)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        var name_3 = adaptor.kind(child);
        if (name_3 === '#comment') {
          continue;
        }
        if (name_3 === '#text') {
          this.addText(mml, child);
        } else if (mml.isKind('annotation-xml')) {
          mml.appendChild(this.factory.create('XML').setXML(child, adaptor));
        } else {
          var childMml = mml.appendChild(this.makeNode(child));
          if (childMml.arity === 0 && adaptor.childNodes(child).length) {
            if (this.options['fixMisplacedChildren']) {
              this.addChildren(mml, child);
            } else {
              childMml.mError('There should not be children for ' + childMml.kind + ' nodes', this.options['verify'], true);
            }
          }
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
  };
  MathMLCompile.prototype.addText = function (mml, child) {
    var text = this.adaptor.value(child);
    if ((mml.isToken || mml.getProperty('isChars')) && mml.arity) {
      if (mml.isToken) {
        text = Entities.translate(text);
        text = this.trimSpace(text);
      }
      mml.appendChild(this.factory.create('text').setText(text));
    } else if (text.match(/\S/)) {
      this.error('Unexpected text node "' + text + '"');
    }
  };
  MathMLCompile.prototype.checkClass = function (mml, node) {
    var e_4, _a;
    var classList = [];
    try {
      for (var _b = __values$E(this.filterClassList(this.adaptor.allClasses(node))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_4 = _c.value;
        if (name_4.substr(0, 4) === 'MJX-') {
          if (name_4 === 'MJX-variant') {
            mml.setProperty('variantForm', true);
          } else if (name_4.substr(0, 11) !== 'MJX-TeXAtom') {
            mml.attributes.set('mathvariant', this.fixCalligraphic(name_4.substr(3)));
          }
        } else {
          classList.push(name_4);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    if (classList.length) {
      mml.attributes.set('class', classList.join(' '));
    }
  };
  MathMLCompile.prototype.fixCalligraphic = function (variant) {
    return variant.replace(/caligraphic/, 'calligraphic');
  };
  MathMLCompile.prototype.markMrows = function (mml) {
    if (mml.isKind('mrow') && !mml.isInferred && mml.childNodes.length >= 2) {
      var first = mml.childNodes[0];
      var last = mml.childNodes[mml.childNodes.length - 1];
      if (first.isKind('mo') && first.attributes.get('fence') && first.attributes.get('stretchy') && last.isKind('mo') && last.attributes.get('fence') && last.attributes.get('stretchy')) {
        if (first.childNodes.length) {
          mml.setProperty('open', first.getText());
        }
        if (last.childNodes.length) {
          mml.setProperty('close', last.getText());
        }
      }
    }
  };
  MathMLCompile.prototype.trimSpace = function (text) {
    return text.replace(/[\t\n\r]/g, ' ').replace(/^ +/, '').replace(/ +$/, '').replace(/  +/g, ' ');
  };
  MathMLCompile.prototype.error = function (message) {
    throw new Error(message);
  };
  MathMLCompile.OPTIONS = {
    MmlFactory: null,
    fixMisplacedChildren: true,
    verify: __assign$b({}, MmlNode_js_1$k.AbstractMmlNode.verifyDefaults),
    translateEntities: true
  };
  return MathMLCompile;
})();
MathMLCompile$1.MathMLCompile = MathMLCompile;

var __extends$1k = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$O = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(mathml, "__esModule", {
  value: true
});
var MathML_1 = mathml.MathML = void 0;
var InputJax_js_1$1 = InputJax;
var Options_js_1$a = Options;
var FunctionList_js_1$1 = FunctionList$1;
var FindMathML_js_1 = FindMathML$1;
var MathMLCompile_js_1 = MathMLCompile$1;
var MathML = (function (_super) {
  __extends$1k(MathML, _super);
  function MathML(options) {
    if (options === void 0) {
      options = {};
    }
    var _this = this;
    var _a = __read$O((0, Options_js_1$a.separateOptions)(options, FindMathML_js_1.FindMathML.OPTIONS, MathMLCompile_js_1.MathMLCompile.OPTIONS), 3), mml = _a[0], find = _a[1], compile = _a[2];
    _this = _super.call(this, mml) || this;
    _this.findMathML = _this.options['FindMathML'] || new FindMathML_js_1.FindMathML(find);
    _this.mathml = _this.options['MathMLCompile'] || new MathMLCompile_js_1.MathMLCompile(compile);
    _this.mmlFilters = new FunctionList_js_1$1.FunctionList();
    return _this;
  }
  MathML.prototype.setAdaptor = function (adaptor) {
    _super.prototype.setAdaptor.call(this, adaptor);
    this.findMathML.adaptor = adaptor;
    this.mathml.adaptor = adaptor;
  };
  MathML.prototype.setMmlFactory = function (mmlFactory) {
    _super.prototype.setMmlFactory.call(this, mmlFactory);
    this.mathml.setMmlFactory(mmlFactory);
  };
  Object.defineProperty(MathML.prototype, "processStrings", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  MathML.prototype.compile = function (math, document) {
    var mml = math.start.node;
    if (!mml || !math.end.node || this.options['forceReparse'] || this.adaptor.kind(mml) === '#text') {
      var mathml = this.executeFilters(this.preFilters, math, document, (math.math || '<math></math>').trim());
      var doc = this.checkForErrors(this.adaptor.parse(mathml, 'text/' + this.options['parseAs']));
      var body = this.adaptor.body(doc);
      if (this.adaptor.childNodes(body).length !== 1) {
        this.error('MathML must consist of a single element');
      }
      mml = this.adaptor.remove(this.adaptor.firstChild(body));
      if (this.adaptor.kind(mml).replace(/^[a-z]+:/, '') !== 'math') {
        this.error('MathML must be formed by a <math> element, not <' + this.adaptor.kind(mml) + '>');
      }
    }
    mml = this.executeFilters(this.mmlFilters, math, document, mml);
    return this.executeFilters(this.postFilters, math, document, this.mathml.compile(mml));
  };
  MathML.prototype.checkForErrors = function (doc) {
    var err = this.adaptor.tags(this.adaptor.body(doc), 'parsererror')[0];
    if (err) {
      if (this.adaptor.textContent(err) === '') {
        this.error('Error processing MathML');
      }
      this.options['parseError'].call(this, err);
    }
    return doc;
  };
  MathML.prototype.error = function (message) {
    throw new Error(message);
  };
  MathML.prototype.findMath = function (node) {
    return this.findMathML.findMath(node);
  };
  MathML.NAME = 'MathML';
  MathML.OPTIONS = (0, Options_js_1$a.defaultOptions)({
    parseAs: 'html',
    forceReparse: false,
    FindMathML: null,
    MathMLCompile: null,
    parseError: function (node) {
      this.error(this.adaptor.textContent(node).replace(/\n.*/g, ''));
    }
  }, InputJax_js_1$1.AbstractInputJax.OPTIONS);
  return MathML;
})(InputJax_js_1$1.AbstractInputJax);
MathML_1 = mathml.MathML = MathML;

var tex$2 = {};

var FindTeX$1 = {};

var __extends$1j = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$N = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(FindTeX$1, "__esModule", {
  value: true
});
FindTeX$1.FindTeX = void 0;
var FindMath_js_1 = FindMath;
var string_js_1$7 = string;
var MathItem_js_1$3 = MathItem;
var FindTeX = (function (_super) {
  __extends$1j(FindTeX, _super);
  function FindTeX(options) {
    var _this = _super.call(this, options) || this;
    _this.getPatterns();
    return _this;
  }
  FindTeX.prototype.getPatterns = function () {
    var _this = this;
    var options = this.options;
    var starts = [], parts = [], subparts = [];
    this.end = {};
    this.env = this.sub = 0;
    var i = 1;
    options['inlineMath'].forEach(function (delims) {
      return _this.addPattern(starts, delims, false);
    });
    options['displayMath'].forEach(function (delims) {
      return _this.addPattern(starts, delims, true);
    });
    if (starts.length) {
      parts.push(starts.sort(string_js_1$7.sortLength).join('|'));
    }
    if (options['processEnvironments']) {
      parts.push('\\\\begin\\s*\\{([^}]*)\\}');
      this.env = i;
      i++;
    }
    if (options['processEscapes']) {
      subparts.push('\\\\([\\\\$])');
    }
    if (options['processRefs']) {
      subparts.push('(\\\\(?:eq)?ref\\s*\\{[^}]*\\})');
    }
    if (subparts.length) {
      parts.push('(' + subparts.join('|') + ')');
      this.sub = i;
    }
    this.start = new RegExp(parts.join('|'), 'g');
    this.hasPatterns = parts.length > 0;
  };
  FindTeX.prototype.addPattern = function (starts, delims, display) {
    var _a = __read$N(delims, 2), open = _a[0], close = _a[1];
    starts.push((0, string_js_1$7.quotePattern)(open));
    this.end[open] = [close, display, this.endPattern(close)];
  };
  FindTeX.prototype.endPattern = function (end, endp) {
    return new RegExp((endp || (0, string_js_1$7.quotePattern)(end)) + '|\\\\(?:[a-zA-Z]|.)|[{}]', 'g');
  };
  FindTeX.prototype.findEnd = function (text, n, start, end) {
    var _a = __read$N(end, 3), close = _a[0], display = _a[1], pattern = _a[2];
    var i = pattern.lastIndex = start.index + start[0].length;
    var match, braces = 0;
    while (match = pattern.exec(text)) {
      if ((match[1] || match[0]) === close && braces === 0) {
        return (0, MathItem_js_1$3.protoItem)(start[0], text.substr(i, match.index - i), match[0], n, start.index, match.index + match[0].length, display);
      } else if (match[0] === '{') {
        braces++;
      } else if (match[0] === '}' && braces) {
        braces--;
      }
    }
    return null;
  };
  FindTeX.prototype.findMathInString = function (math, n, text) {
    var start, match;
    this.start.lastIndex = 0;
    while (start = this.start.exec(text)) {
      if (start[this.env] !== undefined && this.env) {
        var end = '\\\\end\\s*(\\{' + (0, string_js_1$7.quotePattern)(start[this.env]) + '\\})';
        match = this.findEnd(text, n, start, ['{' + start[this.env] + '}', true, this.endPattern(null, end)]);
        if (match) {
          match.math = match.open + match.math + match.close;
          match.open = match.close = '';
        }
      } else if (start[this.sub] !== undefined && this.sub) {
        var math_1 = start[this.sub];
        var end = start.index + start[this.sub].length;
        if (math_1.length === 2) {
          match = (0, MathItem_js_1$3.protoItem)('', math_1.substr(1), '', n, start.index, end);
        } else {
          match = (0, MathItem_js_1$3.protoItem)('', math_1, '', n, start.index, end, false);
        }
      } else {
        match = this.findEnd(text, n, start, this.end[start[0]]);
      }
      if (match) {
        math.push(match);
        this.start.lastIndex = match.end.n;
      }
    }
  };
  FindTeX.prototype.findMath = function (strings) {
    var math = [];
    if (this.hasPatterns) {
      for (var i = 0, m = strings.length; i < m; i++) {
        this.findMathInString(math, i, strings[i]);
      }
    }
    return math;
  };
  FindTeX.OPTIONS = {
    inlineMath: [['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']],
    processEscapes: true,
    processEnvironments: true,
    processRefs: true
  };
  return FindTeX;
})(FindMath_js_1.AbstractFindMath);
FindTeX$1.FindTeX = FindTeX;

var FilterUtil$1 = {};

var NodeUtil$1 = {};

var __values$D = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$M = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$r = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(NodeUtil$1, "__esModule", {
  value: true
});
var MmlNode_js_1$j = MmlNode;
var mo_js_1$2 = mo$2;
var NodeUtil;
(function (NodeUtil) {
  var attrs = new Map([['autoOP', true], ['fnOP', true], ['movesupsub', true], ['subsupOK', true], ['texprimestyle', true], ['useHeight', true], ['variantForm', true], ['withDelims', true], ['mathaccent', true], ['open', true], ['close', true]]);
  function createEntity(code) {
    return String.fromCodePoint(parseInt(code, 16));
  }
  NodeUtil.createEntity = createEntity;
  function getChildren(node) {
    return node.childNodes;
  }
  NodeUtil.getChildren = getChildren;
  function getText(node) {
    return node.getText();
  }
  NodeUtil.getText = getText;
  function appendChildren(node, children) {
    var e_1, _a;
    try {
      for (var children_1 = __values$D(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
        var child = children_1_1.value;
        node.appendChild(child);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  NodeUtil.appendChildren = appendChildren;
  function setAttribute(node, attribute, value) {
    node.attributes.set(attribute, value);
  }
  NodeUtil.setAttribute = setAttribute;
  function setProperty(node, property, value) {
    node.setProperty(property, value);
  }
  NodeUtil.setProperty = setProperty;
  function setProperties(node, properties) {
    var e_2, _a;
    try {
      for (var _b = __values$D(Object.keys(properties)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_1 = _c.value;
        var value = properties[name_1];
        if (name_1 === 'texClass') {
          node.texClass = value;
          node.setProperty(name_1, value);
        } else if (name_1 === 'movablelimits') {
          node.setProperty('movablelimits', value);
          if (node.isKind('mo') || node.isKind('mstyle')) {
            node.attributes.set('movablelimits', value);
          }
        } else if (name_1 === 'inferred') {} else if (attrs.has(name_1)) {
          node.setProperty(name_1, value);
        } else {
          node.attributes.set(name_1, value);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  }
  NodeUtil.setProperties = setProperties;
  function getProperty(node, property) {
    return node.getProperty(property);
  }
  NodeUtil.getProperty = getProperty;
  function getAttribute(node, attr) {
    return node.attributes.get(attr);
  }
  NodeUtil.getAttribute = getAttribute;
  function removeProperties(node) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      properties[_i - 1] = arguments[_i];
    }
    node.removeProperty.apply(node, __spreadArray$r([], __read$M(properties), false));
  }
  NodeUtil.removeProperties = removeProperties;
  function getChildAt(node, position) {
    return node.childNodes[position];
  }
  NodeUtil.getChildAt = getChildAt;
  function setChild(node, position, child) {
    var children = node.childNodes;
    children[position] = child;
    if (child) {
      child.parent = node;
    }
  }
  NodeUtil.setChild = setChild;
  function copyChildren(oldNode, newNode) {
    var children = oldNode.childNodes;
    for (var i = 0; i < children.length; i++) {
      setChild(newNode, i, children[i]);
    }
  }
  NodeUtil.copyChildren = copyChildren;
  function copyAttributes(oldNode, newNode) {
    newNode.attributes = oldNode.attributes;
    setProperties(newNode, oldNode.getAllProperties());
  }
  NodeUtil.copyAttributes = copyAttributes;
  function isType(node, kind) {
    return node.isKind(kind);
  }
  NodeUtil.isType = isType;
  function isEmbellished(node) {
    return node.isEmbellished;
  }
  NodeUtil.isEmbellished = isEmbellished;
  function getTexClass(node) {
    return node.texClass;
  }
  NodeUtil.getTexClass = getTexClass;
  function getCoreMO(node) {
    return node.coreMO();
  }
  NodeUtil.getCoreMO = getCoreMO;
  function isNode(item) {
    return item instanceof MmlNode_js_1$j.AbstractMmlNode || item instanceof MmlNode_js_1$j.AbstractMmlEmptyNode;
  }
  NodeUtil.isNode = isNode;
  function isInferred(node) {
    return node.isInferred;
  }
  NodeUtil.isInferred = isInferred;
  function getForm(node) {
    var e_3, _a;
    if (!isType(node, 'mo')) {
      return null;
    }
    var mo = node;
    var forms = mo.getForms();
    try {
      for (var forms_1 = __values$D(forms), forms_1_1 = forms_1.next(); !forms_1_1.done; forms_1_1 = forms_1.next()) {
        var form = forms_1_1.value;
        var symbol = mo_js_1$2.MmlMo.OPTABLE[form][mo.getText()];
        if (symbol) {
          return symbol;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (forms_1_1 && !forms_1_1.done && (_a = forms_1.return)) _a.call(forms_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return null;
  }
  NodeUtil.getForm = getForm;
})(NodeUtil || (NodeUtil = {}));
NodeUtil$1.default = NodeUtil;

var __values$C = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$J = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(FilterUtil$1, "__esModule", {
  value: true
});
var MmlNode_js_1$i = MmlNode;
var NodeUtil_js_1$h = __importDefault$J(NodeUtil$1);
var FilterUtil;
(function (FilterUtil) {
  FilterUtil.cleanStretchy = function (arg) {
    var e_1, _a;
    var options = arg.data;
    try {
      for (var _b = __values$C(options.getList('fixStretchy')), _c = _b.next(); !_c.done; _c = _b.next()) {
        var mo = _c.value;
        if (NodeUtil_js_1$h.default.getProperty(mo, 'fixStretchy')) {
          var symbol = NodeUtil_js_1$h.default.getForm(mo);
          if (symbol && symbol[3] && symbol[3]['stretchy']) {
            NodeUtil_js_1$h.default.setAttribute(mo, 'stretchy', false);
          }
          var parent_1 = mo.parent;
          if (!NodeUtil_js_1$h.default.getTexClass(mo) && (!symbol || !symbol[2])) {
            var texAtom = options.nodeFactory.create('node', 'TeXAtom', [mo]);
            parent_1.replaceChild(texAtom, mo);
            texAtom.inheritAttributesFrom(mo);
          }
          NodeUtil_js_1$h.default.removeProperties(mo, 'fixStretchy');
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  FilterUtil.cleanAttributes = function (arg) {
    var node = arg.data.root;
    node.walkTree(function (mml, _d) {
      var e_2, _a;
      var attribs = mml.attributes;
      if (!attribs) {
        return;
      }
      var keep = new Set((attribs.get('mjx-keep-attrs') || '').split(/ /));
      delete attribs.getAllAttributes()['mjx-keep-attrs'];
      try {
        for (var _b = __values$C(attribs.getExplicitNames()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          if (!keep.has(key) && attribs.attributes[key] === mml.attributes.getInherited(key)) {
            delete attribs.attributes[key];
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }, {});
  };
  FilterUtil.combineRelations = function (arg) {
    var e_3, _a, e_4, _b;
    var remove = [];
    try {
      for (var _c = __values$C(arg.data.getList('mo')), _e = _c.next(); !_e.done; _e = _c.next()) {
        var mo = _e.value;
        if (mo.getProperty('relationsCombined') || !mo.parent || mo.parent && !NodeUtil_js_1$h.default.isType(mo.parent, 'mrow') || NodeUtil_js_1$h.default.getTexClass(mo) !== MmlNode_js_1$i.TEXCLASS.REL) {
          continue;
        }
        var mml = mo.parent;
        var m2 = void 0;
        var children = mml.childNodes;
        var next = children.indexOf(mo) + 1;
        var variantForm = NodeUtil_js_1$h.default.getProperty(mo, 'variantForm');
        while (next < children.length && (m2 = children[next]) && NodeUtil_js_1$h.default.isType(m2, 'mo') && NodeUtil_js_1$h.default.getTexClass(m2) === MmlNode_js_1$i.TEXCLASS.REL) {
          if (variantForm === NodeUtil_js_1$h.default.getProperty(m2, 'variantForm') && _compareExplicit(mo, m2)) {
            NodeUtil_js_1$h.default.appendChildren(mo, NodeUtil_js_1$h.default.getChildren(m2));
            _copyExplicit(['stretchy', 'rspace'], mo, m2);
            try {
              for (var _f = (e_4 = void 0, __values$C(m2.getPropertyNames())), _g = _f.next(); !_g.done; _g = _f.next()) {
                var name_1 = _g.value;
                mo.setProperty(name_1, m2.getProperty(name_1));
              }
            } catch (e_4_1) {
              e_4 = {
                error: e_4_1
              };
            } finally {
              try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
              } finally {
                if (e_4) throw e_4.error;
              }
            }
            children.splice(next, 1);
            remove.push(m2);
            m2.parent = null;
            m2.setProperty('relationsCombined', true);
          } else {
            if (mo.attributes.getExplicit('rspace') == null) {
              NodeUtil_js_1$h.default.setAttribute(mo, 'rspace', '0pt');
            }
            if (m2.attributes.getExplicit('lspace') == null) {
              NodeUtil_js_1$h.default.setAttribute(m2, 'lspace', '0pt');
            }
            break;
          }
        }
        mo.attributes.setInherited('form', mo.getForms()[0]);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_e && !_e.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    arg.data.removeFromList('mo', remove);
  };
  var _copyExplicit = function (attrs, node1, node2) {
    var attr1 = node1.attributes;
    var attr2 = node2.attributes;
    attrs.forEach(function (x) {
      var attr = attr2.getExplicit(x);
      if (attr != null) {
        attr1.set(x, attr);
      }
    });
  };
  var _compareExplicit = function (node1, node2) {
    var e_5, _a;
    var filter = function (attr, space) {
      var exp = attr.getExplicitNames();
      return exp.filter(function (x) {
        return x !== space && (x !== 'stretchy' || attr.getExplicit('stretchy'));
      });
    };
    var attr1 = node1.attributes;
    var attr2 = node2.attributes;
    var exp1 = filter(attr1, 'lspace');
    var exp2 = filter(attr2, 'rspace');
    if (exp1.length !== exp2.length) {
      return false;
    }
    try {
      for (var exp1_1 = __values$C(exp1), exp1_1_1 = exp1_1.next(); !exp1_1_1.done; exp1_1_1 = exp1_1.next()) {
        var name_2 = exp1_1_1.value;
        if (attr1.getExplicit(name_2) !== attr2.getExplicit(name_2)) {
          return false;
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (exp1_1_1 && !exp1_1_1.done && (_a = exp1_1.return)) _a.call(exp1_1);
      } finally {
        if (e_5) throw e_5.error;
      }
    }
    return true;
  };
  var _cleanSubSup = function (options, low, up) {
    var e_6, _a;
    var remove = [];
    try {
      for (var _b = __values$C(options.getList('m' + low + up)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var mml = _c.value;
        var children = mml.childNodes;
        if (children[mml[low]] && children[mml[up]]) {
          continue;
        }
        var parent_2 = mml.parent;
        var newNode = children[mml[low]] ? options.nodeFactory.create('node', 'm' + low, [children[mml.base], children[mml[low]]]) : options.nodeFactory.create('node', 'm' + up, [children[mml.base], children[mml[up]]]);
        NodeUtil_js_1$h.default.copyAttributes(mml, newNode);
        if (parent_2) {
          parent_2.replaceChild(newNode, mml);
        } else {
          options.root = newNode;
        }
        remove.push(mml);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_6) throw e_6.error;
      }
    }
    options.removeFromList('m' + low + up, remove);
  };
  FilterUtil.cleanSubSup = function (arg) {
    var options = arg.data;
    if (options.error) {
      return;
    }
    _cleanSubSup(options, 'sub', 'sup');
    _cleanSubSup(options, 'under', 'over');
  };
  var _moveLimits = function (options, underover, subsup) {
    var e_7, _a;
    var remove = [];
    try {
      for (var _b = __values$C(options.getList(underover)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var mml = _c.value;
        if (mml.attributes.get('displaystyle')) {
          continue;
        }
        var base = mml.childNodes[mml.base];
        var mo = base.coreMO();
        if (base.getProperty('movablelimits') && !mo.attributes.getExplicit('movablelimits')) {
          var node = options.nodeFactory.create('node', subsup, mml.childNodes);
          NodeUtil_js_1$h.default.copyAttributes(mml, node);
          if (mml.parent) {
            mml.parent.replaceChild(node, mml);
          } else {
            options.root = node;
          }
          remove.push(mml);
        }
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_7) throw e_7.error;
      }
    }
    options.removeFromList(underover, remove);
  };
  FilterUtil.moveLimits = function (arg) {
    var options = arg.data;
    _moveLimits(options, 'munderover', 'msubsup');
    _moveLimits(options, 'munder', 'msub');
    _moveLimits(options, 'mover', 'msup');
  };
  FilterUtil.setInherited = function (arg) {
    arg.data.root.setInheritedAttributes({}, arg.math['display'], 0, false);
  };
})(FilterUtil || (FilterUtil = {}));
FilterUtil$1.default = FilterUtil;

var TexParser$1 = {};

var ParseUtil$1 = {};

var TexError$1 = {};

Object.defineProperty(TexError$1, "__esModule", {
  value: true
});
var TexError = (function () {
  function TexError(id, message) {
    var rest = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      rest[_i - 2] = arguments[_i];
    }
    this.id = id;
    this.message = TexError.processString(message, rest);
  }
  TexError.processString = function (str, args) {
    var parts = str.split(TexError.pattern);
    for (var i = 1, m = parts.length; i < m; i += 2) {
      var c = parts[i].charAt(0);
      if (c >= '0' && c <= '9') {
        parts[i] = args[parseInt(parts[i], 10) - 1];
        if (typeof parts[i] === 'number') {
          parts[i] = parts[i].toString();
        }
      } else if (c === '{') {
        c = parts[i].substr(1);
        if (c >= '0' && c <= '9') {
          parts[i] = args[parseInt(parts[i].substr(1, parts[i].length - 2), 10) - 1];
          if (typeof parts[i] === 'number') {
            parts[i] = parts[i].toString();
          }
        } else {
          var match = parts[i].match(/^\{([a-z]+):%(\d+)\|(.*)\}$/);
          if (match) {
            parts[i] = '%' + parts[i];
          }
        }
      }
      if (parts[i] == null) {
        parts[i] = '???';
      }
    }
    return parts.join('');
  };
  TexError.pattern = /%(\d+|\{\d+\}|\{[a-z]+:\%\d+(?:\|(?:%\{\d+\}|%.|[^\}])*)+\}|.)/g;
  return TexError;
})();
TexError$1.default = TexError;

var __read$L = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$B = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$I = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(ParseUtil$1, "__esModule", {
  value: true
});
var MmlNode_js_1$h = MmlNode;
var NodeUtil_js_1$g = __importDefault$I(NodeUtil$1);
var TexParser_js_1$a = __importDefault$I(TexParser$1);
var TexError_js_1$k = __importDefault$I(TexError$1);
var Entities_js_1$2 = Entities$1;
var ParseUtil;
(function (ParseUtil) {
  var emPerInch = 7.2;
  var pxPerInch = 72;
  var UNIT_CASES = {
    'em': function (m) {
      return m;
    },
    'ex': function (m) {
      return m * .43;
    },
    'pt': function (m) {
      return m / 10;
    },
    'pc': function (m) {
      return m * 1.2;
    },
    'px': function (m) {
      return m * emPerInch / pxPerInch;
    },
    'in': function (m) {
      return m * emPerInch;
    },
    'cm': function (m) {
      return m * emPerInch / 2.54;
    },
    'mm': function (m) {
      return m * emPerInch / 25.4;
    },
    'mu': function (m) {
      return m / 18;
    }
  };
  var num = '([-+]?([.,]\\d+|\\d+([.,]\\d*)?))';
  var unit = '(pt|em|ex|mu|px|mm|cm|in|pc)';
  var dimenEnd = RegExp('^\\s*' + num + '\\s*' + unit + '\\s*$');
  var dimenRest = RegExp('^\\s*' + num + '\\s*' + unit + ' ?');
  function matchDimen(dim, rest) {
    if (rest === void 0) {
      rest = false;
    }
    var match = dim.match(rest ? dimenRest : dimenEnd);
    return match ? muReplace([match[1].replace(/,/, '.'), match[4], match[0].length]) : [null, null, 0];
  }
  ParseUtil.matchDimen = matchDimen;
  function muReplace(_a) {
    var _b = __read$L(_a, 3), value = _b[0], unit = _b[1], length = _b[2];
    if (unit !== 'mu') {
      return [value, unit, length];
    }
    var em = Em(UNIT_CASES[unit](parseFloat(value || '1')));
    return [em.slice(0, -2), 'em', length];
  }
  function dimen2em(dim) {
    var _a = __read$L(matchDimen(dim), 2), value = _a[0], unit = _a[1];
    var m = parseFloat(value || '1');
    var func = UNIT_CASES[unit];
    return func ? func(m) : 0;
  }
  ParseUtil.dimen2em = dimen2em;
  function Em(m) {
    if (Math.abs(m) < .0006) {
      return '0em';
    }
    return m.toFixed(3).replace(/\.?0+$/, '') + 'em';
  }
  ParseUtil.Em = Em;
  function cols() {
    var W = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      W[_i] = arguments[_i];
    }
    return W.map(function (n) {
      return Em(n);
    }).join(' ');
  }
  ParseUtil.cols = cols;
  function fenced(configuration, open, mml, close, big, color) {
    if (big === void 0) {
      big = '';
    }
    if (color === void 0) {
      color = '';
    }
    var nf = configuration.nodeFactory;
    var mrow = nf.create('node', 'mrow', [], {
      open: open,
      close: close,
      texClass: MmlNode_js_1$h.TEXCLASS.INNER
    });
    var mo;
    if (big) {
      mo = new TexParser_js_1$a.default('\\' + big + 'l' + open, configuration.parser.stack.env, configuration).mml();
    } else {
      var openNode = nf.create('text', open);
      mo = nf.create('node', 'mo', [], {
        fence: true,
        stretchy: true,
        symmetric: true,
        texClass: MmlNode_js_1$h.TEXCLASS.OPEN
      }, openNode);
    }
    NodeUtil_js_1$g.default.appendChildren(mrow, [mo, mml]);
    if (big) {
      mo = new TexParser_js_1$a.default('\\' + big + 'r' + close, configuration.parser.stack.env, configuration).mml();
    } else {
      var closeNode = nf.create('text', close);
      mo = nf.create('node', 'mo', [], {
        fence: true,
        stretchy: true,
        symmetric: true,
        texClass: MmlNode_js_1$h.TEXCLASS.CLOSE
      }, closeNode);
    }
    color && mo.attributes.set('mathcolor', color);
    NodeUtil_js_1$g.default.appendChildren(mrow, [mo]);
    return mrow;
  }
  ParseUtil.fenced = fenced;
  function fixedFence(configuration, open, mml, close) {
    var mrow = configuration.nodeFactory.create('node', 'mrow', [], {
      open: open,
      close: close,
      texClass: MmlNode_js_1$h.TEXCLASS.ORD
    });
    if (open) {
      NodeUtil_js_1$g.default.appendChildren(mrow, [mathPalette(configuration, open, 'l')]);
    }
    if (NodeUtil_js_1$g.default.isType(mml, 'mrow')) {
      NodeUtil_js_1$g.default.appendChildren(mrow, NodeUtil_js_1$g.default.getChildren(mml));
    } else {
      NodeUtil_js_1$g.default.appendChildren(mrow, [mml]);
    }
    if (close) {
      NodeUtil_js_1$g.default.appendChildren(mrow, [mathPalette(configuration, close, 'r')]);
    }
    return mrow;
  }
  ParseUtil.fixedFence = fixedFence;
  function mathPalette(configuration, fence, side) {
    if (fence === '{' || fence === '}') {
      fence = '\\' + fence;
    }
    var D = '{\\bigg' + side + ' ' + fence + '}';
    var T = '{\\big' + side + ' ' + fence + '}';
    return new TexParser_js_1$a.default('\\mathchoice' + D + T + T + T, {}, configuration).mml();
  }
  ParseUtil.mathPalette = mathPalette;
  function fixInitialMO(configuration, nodes) {
    for (var i = 0, m = nodes.length; i < m; i++) {
      var child = nodes[i];
      if (child && (!NodeUtil_js_1$g.default.isType(child, 'mspace') && (!NodeUtil_js_1$g.default.isType(child, 'TeXAtom') || NodeUtil_js_1$g.default.getChildren(child)[0] && NodeUtil_js_1$g.default.getChildren(NodeUtil_js_1$g.default.getChildren(child)[0]).length))) {
        if (NodeUtil_js_1$g.default.isEmbellished(child) || NodeUtil_js_1$g.default.isType(child, 'TeXAtom') && NodeUtil_js_1$g.default.getTexClass(child) === MmlNode_js_1$h.TEXCLASS.REL) {
          var mi = configuration.nodeFactory.create('node', 'mi');
          nodes.unshift(mi);
        }
        break;
      }
    }
  }
  ParseUtil.fixInitialMO = fixInitialMO;
  function internalMath(parser, text, level, font) {
    if (parser.configuration.options.internalMath) {
      return parser.configuration.options.internalMath(parser, text, level, font);
    }
    var mathvariant = font || parser.stack.env.font;
    var def = mathvariant ? {
      mathvariant: mathvariant
    } : {};
    var mml = [], i = 0, k = 0, c, node, match = '', braces = 0;
    if (text.match(/\\?[${}\\]|\\\(|\\(eq)?ref\s*\{/)) {
      while (i < text.length) {
        c = text.charAt(i++);
        if (c === '$') {
          if (match === '$' && braces === 0) {
            node = parser.create('node', 'TeXAtom', [new TexParser_js_1$a.default(text.slice(k, i - 1), {}, parser.configuration).mml()]);
            mml.push(node);
            match = '';
            k = i;
          } else if (match === '') {
            if (k < i - 1) {
              mml.push(internalText(parser, text.slice(k, i - 1), def));
            }
            match = '$';
            k = i;
          }
        } else if (c === '{' && match !== '') {
          braces++;
        } else if (c === '}') {
          if (match === '}' && braces === 0) {
            var atom = new TexParser_js_1$a.default(text.slice(k, i), {}, parser.configuration).mml();
            node = parser.create('node', 'TeXAtom', [atom], def);
            mml.push(node);
            match = '';
            k = i;
          } else if (match !== '') {
            if (braces) {
              braces--;
            }
          }
        } else if (c === '\\') {
          if (match === '' && text.substr(i).match(/^(eq)?ref\s*\{/)) {
            var len = RegExp['$&'].length;
            if (k < i - 1) {
              mml.push(internalText(parser, text.slice(k, i - 1), def));
            }
            match = '}';
            k = i - 1;
            i += len;
          } else {
            c = text.charAt(i++);
            if (c === '(' && match === '') {
              if (k < i - 2) {
                mml.push(internalText(parser, text.slice(k, i - 2), def));
              }
              match = ')';
              k = i;
            } else if (c === ')' && match === ')' && braces === 0) {
              node = parser.create('node', 'TeXAtom', [new TexParser_js_1$a.default(text.slice(k, i - 2), {}, parser.configuration).mml()]);
              mml.push(node);
              match = '';
              k = i;
            } else if (c.match(/[${}\\]/) && match === '') {
              i--;
              text = text.substr(0, i - 1) + text.substr(i);
            }
          }
        }
      }
      if (match !== '') {
        throw new TexError_js_1$k.default('MathNotTerminated', 'Math not terminated in text box');
      }
    }
    if (k < text.length) {
      mml.push(internalText(parser, text.slice(k), def));
    }
    if (level != null) {
      mml = [parser.create('node', 'mstyle', mml, {
        displaystyle: false,
        scriptlevel: level
      })];
    } else if (mml.length > 1) {
      mml = [parser.create('node', 'mrow', mml)];
    }
    return mml;
  }
  ParseUtil.internalMath = internalMath;
  function internalText(parser, text, def) {
    text = text.replace(/^\s+/, Entities_js_1$2.entities.nbsp).replace(/\s+$/, Entities_js_1$2.entities.nbsp);
    var textNode = parser.create('text', text);
    return parser.create('node', 'mtext', [], def, textNode);
  }
  ParseUtil.internalText = internalText;
  function underOver(parser, base, script, pos, stack) {
    ParseUtil.checkMovableLimits(base);
    if (NodeUtil_js_1$g.default.isType(base, 'munderover') && NodeUtil_js_1$g.default.isEmbellished(base)) {
      NodeUtil_js_1$g.default.setProperties(NodeUtil_js_1$g.default.getCoreMO(base), {
        lspace: 0,
        rspace: 0
      });
      var mo = parser.create('node', 'mo', [], {
        rspace: 0
      });
      base = parser.create('node', 'mrow', [mo, base]);
    }
    var mml = parser.create('node', 'munderover', [base]);
    NodeUtil_js_1$g.default.setChild(mml, pos === 'over' ? mml.over : mml.under, script);
    var node = mml;
    if (stack) {
      node = parser.create('node', 'TeXAtom', [mml], {
        texClass: MmlNode_js_1$h.TEXCLASS.OP,
        movesupsub: true
      });
    }
    NodeUtil_js_1$g.default.setProperty(node, 'subsupOK', true);
    return node;
  }
  ParseUtil.underOver = underOver;
  function checkMovableLimits(base) {
    var symbol = NodeUtil_js_1$g.default.isType(base, 'mo') ? NodeUtil_js_1$g.default.getForm(base) : null;
    if (NodeUtil_js_1$g.default.getProperty(base, 'movablelimits') || symbol && symbol[3] && symbol[3].movablelimits) {
      NodeUtil_js_1$g.default.setProperties(base, {
        movablelimits: false
      });
    }
  }
  ParseUtil.checkMovableLimits = checkMovableLimits;
  function trimSpaces(text) {
    if (typeof text !== 'string') {
      return text;
    }
    var TEXT = text.trim();
    if (TEXT.match(/\\$/) && text.match(/ $/)) {
      TEXT += ' ';
    }
    return TEXT;
  }
  ParseUtil.trimSpaces = trimSpaces;
  function setArrayAlign(array, align) {
    align = ParseUtil.trimSpaces(align || '');
    if (align === 't') {
      array.arraydef.align = 'baseline 1';
    } else if (align === 'b') {
      array.arraydef.align = 'baseline -1';
    } else if (align === 'c') {
      array.arraydef.align = 'axis';
    } else if (align) {
      array.arraydef.align = align;
    }
    return array;
  }
  ParseUtil.setArrayAlign = setArrayAlign;
  function substituteArgs(parser, args, str) {
    var text = '';
    var newstring = '';
    var i = 0;
    while (i < str.length) {
      var c = str.charAt(i++);
      if (c === '\\') {
        text += c + str.charAt(i++);
      } else if (c === '#') {
        c = str.charAt(i++);
        if (c === '#') {
          text += c;
        } else {
          if (!c.match(/[1-9]/) || parseInt(c, 10) > args.length) {
            throw new TexError_js_1$k.default('IllegalMacroParam', 'Illegal macro parameter reference');
          }
          newstring = addArgs(parser, addArgs(parser, newstring, text), args[parseInt(c, 10) - 1]);
          text = '';
        }
      } else {
        text += c;
      }
    }
    return addArgs(parser, newstring, text);
  }
  ParseUtil.substituteArgs = substituteArgs;
  function addArgs(parser, s1, s2) {
    if (s2.match(/^[a-z]/i) && s1.match(/(^|[^\\])(\\\\)*\\[a-z]+$/i)) {
      s1 += ' ';
    }
    if (s1.length + s2.length > parser.configuration.options['maxBuffer']) {
      throw new TexError_js_1$k.default('MaxBufferSize', 'MathJax internal buffer size exceeded; is there a' + ' recursive macro call?');
    }
    return s1 + s2;
  }
  ParseUtil.addArgs = addArgs;
  function checkMaxMacros(parser, isMacro) {
    if (isMacro === void 0) {
      isMacro = true;
    }
    if (++parser.macroCount <= parser.configuration.options['maxMacros']) {
      return;
    }
    if (isMacro) {
      throw new TexError_js_1$k.default('MaxMacroSub1', 'MathJax maximum macro substitution count exceeded; ' + 'is here a recursive macro call?');
    } else {
      throw new TexError_js_1$k.default('MaxMacroSub2', 'MathJax maximum substitution count exceeded; ' + 'is there a recursive latex environment?');
    }
  }
  ParseUtil.checkMaxMacros = checkMaxMacros;
  function checkEqnEnv(parser) {
    if (parser.stack.global.eqnenv) {
      throw new TexError_js_1$k.default('ErroneousNestingEq', 'Erroneous nesting of equation structures');
    }
    parser.stack.global.eqnenv = true;
  }
  ParseUtil.checkEqnEnv = checkEqnEnv;
  function copyNode(node, parser) {
    var tree = node.copy();
    var options = parser.configuration;
    tree.walkTree(function (n) {
      var e_1, _a;
      options.addNode(n.kind, n);
      var lists = (n.getProperty('in-lists') || '').split(/,/);
      try {
        for (var lists_1 = __values$B(lists), lists_1_1 = lists_1.next(); !lists_1_1.done; lists_1_1 = lists_1.next()) {
          var list = lists_1_1.value;
          list && options.addNode(list, n);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (lists_1_1 && !lists_1_1.done && (_a = lists_1.return)) _a.call(lists_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    });
    return tree;
  }
  ParseUtil.copyNode = copyNode;
  function MmlFilterAttribute(_parser, _name, value) {
    return value;
  }
  ParseUtil.MmlFilterAttribute = MmlFilterAttribute;
  function getFontDef(parser) {
    var font = parser.stack.env['font'];
    return font ? {
      mathvariant: font
    } : {};
  }
  ParseUtil.getFontDef = getFontDef;
  function keyvalOptions(attrib, allowed, error) {
    var e_2, _a;
    if (allowed === void 0) {
      allowed = null;
    }
    if (error === void 0) {
      error = false;
    }
    var def = readKeyval(attrib);
    if (allowed) {
      try {
        for (var _b = __values$B(Object.keys(def)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          if (!allowed.hasOwnProperty(key)) {
            if (error) {
              throw new TexError_js_1$k.default('InvalidOption', 'Invalid option: %1', key);
            }
            delete def[key];
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
    return def;
  }
  ParseUtil.keyvalOptions = keyvalOptions;
  function readKeyval(text) {
    var _a, _b;
    var options = {};
    var rest = text;
    var end, key, val;
    while (rest) {
      (_a = __read$L(readValue(rest, ['=', ',']), 3), key = _a[0], end = _a[1], rest = _a[2]);
      if (end === '=') {
        (_b = __read$L(readValue(rest, [',']), 3), val = _b[0], end = _b[1], rest = _b[2]);
        val = val === 'false' || val === 'true' ? JSON.parse(val) : val;
        options[key] = val;
      } else if (key) {
        options[key] = true;
      }
    }
    return options;
  }
  function removeBraces(text, count) {
    while (count > 0) {
      text = text.trim().slice(1, -1);
      count--;
    }
    return text.trim();
  }
  function readValue(text, end) {
    var length = text.length;
    var braces = 0;
    var value = '';
    var index = 0;
    var start = 0;
    var startCount = true;
    var stopCount = false;
    while (index < length) {
      var c = text[index++];
      switch (c) {
        case ' ':
          break;
        case '{':
          if (startCount) {
            start++;
          } else {
            stopCount = false;
            if (start > braces) {
              start = braces;
            }
          }
          braces++;
          break;
        case '}':
          if (braces) {
            braces--;
          }
          if (startCount || stopCount) {
            start--;
            stopCount = true;
          }
          startCount = false;
          break;
        default:
          if (!braces && end.indexOf(c) !== -1) {
            return [stopCount ? 'true' : removeBraces(value, start), c, text.slice(index)];
          }
          startCount = false;
          stopCount = false;
      }
      value += c;
    }
    if (braces) {
      throw new TexError_js_1$k.default('ExtraOpenMissingClose', 'Extra open brace or missing close brace');
    }
    return [stopCount ? 'true' : removeBraces(value, start), '', text.slice(index)];
  }
})(ParseUtil || (ParseUtil = {}));
ParseUtil$1.default = ParseUtil;

var Stack$1 = {};

var __values$A = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$K = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$q = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$H = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(Stack$1, "__esModule", {
  value: true
});
var NodeUtil_js_1$f = __importDefault$H(NodeUtil$1);
var Stack = (function () {
  function Stack(_factory, _env, inner) {
    this._factory = _factory;
    this._env = _env;
    this.global = {};
    this.stack = [];
    this.global = {
      isInner: inner
    };
    this.stack = [this._factory.create('start', this.global)];
    if (_env) {
      this.stack[0].env = _env;
    }
    this.env = this.stack[0].env;
  }
  Object.defineProperty(Stack.prototype, "env", {
    get: function () {
      return this._env;
    },
    set: function (env) {
      this._env = env;
    },
    enumerable: false,
    configurable: true
  });
  Stack.prototype.Push = function () {
    var e_1, _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    try {
      for (var args_1 = __values$A(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
        var node = args_1_1.value;
        if (!node) {
          continue;
        }
        var item = NodeUtil_js_1$f.default.isNode(node) ? this._factory.create('mml', node) : node;
        item.global = this.global;
        var _b = __read$K(this.stack.length ? this.Top().checkItem(item) : [null, true], 2), top_1 = _b[0], success = _b[1];
        if (!success) {
          continue;
        }
        if (top_1) {
          this.Pop();
          this.Push.apply(this, __spreadArray$q([], __read$K(top_1), false));
          continue;
        }
        this.stack.push(item);
        if (item.env) {
          if (item.copyEnv) {
            Object.assign(item.env, this.env);
          }
          this.env = item.env;
        } else {
          item.env = this.env;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  Stack.prototype.Pop = function () {
    var item = this.stack.pop();
    if (!item.isOpen) {
      delete item.env;
    }
    this.env = this.stack.length ? this.Top().env : {};
    return item;
  };
  Stack.prototype.Top = function (n) {
    if (n === void 0) {
      n = 1;
    }
    return this.stack.length < n ? null : this.stack[this.stack.length - n];
  };
  Stack.prototype.Prev = function (noPop) {
    var top = this.Top();
    return noPop ? top.First : top.Pop();
  };
  Stack.prototype.toString = function () {
    return 'stack[\n  ' + this.stack.join('\n  ') + '\n]';
  };
  return Stack;
})();
Stack$1.default = Stack;

var __values$z = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$J = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$p = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$G = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(TexParser$1, "__esModule", {
  value: true
});
var ParseUtil_js_1$f = __importDefault$G(ParseUtil$1);
var Stack_js_1$1 = __importDefault$G(Stack$1);
var TexError_js_1$j = __importDefault$G(TexError$1);
var MmlNode_js_1$g = MmlNode;
var TexParser = (function () {
  function TexParser(_string, env, configuration) {
    var e_1, _a;
    this._string = _string;
    this.configuration = configuration;
    this.macroCount = 0;
    this.i = 0;
    this.currentCS = '';
    var inner = env.hasOwnProperty('isInner');
    var isInner = env['isInner'];
    delete env['isInner'];
    var ENV;
    if (env) {
      ENV = {};
      try {
        for (var _b = __values$z(Object.keys(env)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var id = _c.value;
          ENV[id] = env[id];
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
    this.configuration.pushParser(this);
    this.stack = new Stack_js_1$1.default(this.itemFactory, ENV, inner ? isInner : true);
    this.Parse();
    this.Push(this.itemFactory.create('stop'));
  }
  Object.defineProperty(TexParser.prototype, "options", {
    get: function () {
      return this.configuration.options;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TexParser.prototype, "itemFactory", {
    get: function () {
      return this.configuration.itemFactory;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TexParser.prototype, "tags", {
    get: function () {
      return this.configuration.tags;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TexParser.prototype, "string", {
    get: function () {
      return this._string;
    },
    set: function (str) {
      this._string = str;
    },
    enumerable: false,
    configurable: true
  });
  TexParser.prototype.parse = function (kind, input) {
    return this.configuration.handlers.get(kind).parse(input);
  };
  TexParser.prototype.lookup = function (kind, symbol) {
    return this.configuration.handlers.get(kind).lookup(symbol);
  };
  TexParser.prototype.contains = function (kind, symbol) {
    return this.configuration.handlers.get(kind).contains(symbol);
  };
  TexParser.prototype.toString = function () {
    var e_2, _a;
    var str = '';
    try {
      for (var _b = __values$z(Array.from(this.configuration.handlers.keys())), _c = _b.next(); !_c.done; _c = _b.next()) {
        var config = _c.value;
        str += config + ': ' + this.configuration.handlers.get(config) + '\n';
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return str;
  };
  TexParser.prototype.Parse = function () {
    var c;
    while (this.i < this.string.length) {
      c = this.getCodePoint();
      this.i += c.length;
      this.parse('character', [this, c]);
    }
  };
  TexParser.prototype.Push = function (arg) {
    if (arg instanceof MmlNode_js_1$g.AbstractMmlNode && arg.isInferred) {
      this.PushAll(arg.childNodes);
    } else {
      this.stack.Push(arg);
    }
  };
  TexParser.prototype.PushAll = function (args) {
    var e_3, _a;
    try {
      for (var args_1 = __values$z(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
        var arg = args_1_1.value;
        this.stack.Push(arg);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
  };
  TexParser.prototype.mml = function () {
    if (!this.stack.Top().isKind('mml')) {
      return null;
    }
    var node = this.stack.Top().First;
    this.configuration.popParser();
    return node;
  };
  TexParser.prototype.convertDelimiter = function (c) {
    var symbol = this.lookup('delimiter', c);
    return symbol ? symbol.char : null;
  };
  TexParser.prototype.getCodePoint = function () {
    var code = this.string.codePointAt(this.i);
    return code === undefined ? '' : String.fromCodePoint(code);
  };
  TexParser.prototype.nextIsSpace = function () {
    return !!this.string.charAt(this.i).match(/\s/);
  };
  TexParser.prototype.GetNext = function () {
    while (this.nextIsSpace()) {
      this.i++;
    }
    return this.getCodePoint();
  };
  TexParser.prototype.GetCS = function () {
    var CS = this.string.slice(this.i).match(/^(([a-z]+) ?|[\uD800-\uDBFF].|.)/i);
    if (CS) {
      this.i += CS[0].length;
      return CS[2] || CS[1];
    } else {
      this.i++;
      return ' ';
    }
  };
  TexParser.prototype.GetArgument = function (_name, noneOK) {
    switch (this.GetNext()) {
      case '':
        if (!noneOK) {
          throw new TexError_js_1$j.default('MissingArgFor', 'Missing argument for %1', this.currentCS);
        }
        return null;
      case '}':
        if (!noneOK) {
          throw new TexError_js_1$j.default('ExtraCloseMissingOpen', 'Extra close brace or missing open brace');
        }
        return null;
      case '\\':
        this.i++;
        return '\\' + this.GetCS();
      case '{':
        var j = ++this.i, parens = 1;
        while (this.i < this.string.length) {
          switch (this.string.charAt(this.i++)) {
            case '\\':
              this.i++;
              break;
            case '{':
              parens++;
              break;
            case '}':
              if (--parens === 0) {
                return this.string.slice(j, this.i - 1);
              }
              break;
          }
        }
        throw new TexError_js_1$j.default('MissingCloseBrace', 'Missing close brace');
    }
    var c = this.getCodePoint();
    this.i += c.length;
    return c;
  };
  TexParser.prototype.GetBrackets = function (_name, def) {
    if (this.GetNext() !== '[') {
      return def;
    }
    var j = ++this.i, parens = 0;
    while (this.i < this.string.length) {
      switch (this.string.charAt(this.i++)) {
        case '{':
          parens++;
          break;
        case '\\':
          this.i++;
          break;
        case '}':
          if (parens-- <= 0) {
            throw new TexError_js_1$j.default('ExtraCloseLooking', 'Extra close brace while looking for %1', '\']\'');
          }
          break;
        case ']':
          if (parens === 0) {
            return this.string.slice(j, this.i - 1);
          }
          break;
      }
    }
    throw new TexError_js_1$j.default('MissingCloseBracket', 'Could not find closing \']\' for argument to %1', this.currentCS);
  };
  TexParser.prototype.GetDelimiter = function (name, braceOK) {
    var c = this.GetNext();
    this.i += c.length;
    if (this.i <= this.string.length) {
      if (c === '\\') {
        c += this.GetCS();
      } else if (c === '{' && braceOK) {
        this.i--;
        c = this.GetArgument(name).trim();
      }
      if (this.contains('delimiter', c)) {
        return this.convertDelimiter(c);
      }
    }
    throw new TexError_js_1$j.default('MissingOrUnrecognizedDelim', 'Missing or unrecognized delimiter for %1', this.currentCS);
  };
  TexParser.prototype.GetDimen = function (name) {
    if (this.GetNext() === '{') {
      var dimen = this.GetArgument(name);
      var _a = __read$J(ParseUtil_js_1$f.default.matchDimen(dimen), 2), value = _a[0], unit = _a[1];
      if (value) {
        return value + unit;
      }
    } else {
      var dimen = this.string.slice(this.i);
      var _b = __read$J(ParseUtil_js_1$f.default.matchDimen(dimen, true), 3), value = _b[0], unit = _b[1], length_1 = _b[2];
      if (value) {
        this.i += length_1;
        return value + unit;
      }
    }
    throw new TexError_js_1$j.default('MissingDimOrUnits', 'Missing dimension or its units for %1', this.currentCS);
  };
  TexParser.prototype.GetUpTo = function (_name, token) {
    while (this.nextIsSpace()) {
      this.i++;
    }
    var j = this.i;
    var parens = 0;
    while (this.i < this.string.length) {
      var k = this.i;
      var c = this.GetNext();
      this.i += c.length;
      switch (c) {
        case '\\':
          c += this.GetCS();
          break;
        case '{':
          parens++;
          break;
        case '}':
          if (parens === 0) {
            throw new TexError_js_1$j.default('ExtraCloseLooking', 'Extra close brace while looking for %1', token);
          }
          parens--;
          break;
      }
      if (parens === 0 && c === token) {
        return this.string.slice(j, k);
      }
    }
    throw new TexError_js_1$j.default('TokenNotFoundForCommand', 'Could not find %1 for %2', token, this.currentCS);
  };
  TexParser.prototype.ParseArg = function (name) {
    return new TexParser(this.GetArgument(name), this.stack.env, this.configuration).mml();
  };
  TexParser.prototype.ParseUpTo = function (name, token) {
    return new TexParser(this.GetUpTo(name, token), this.stack.env, this.configuration).mml();
  };
  TexParser.prototype.GetDelimiterArg = function (name) {
    var c = ParseUtil_js_1$f.default.trimSpaces(this.GetArgument(name));
    if (c === '') {
      return null;
    }
    if (this.contains('delimiter', c)) {
      return c;
    }
    throw new TexError_js_1$j.default('MissingOrUnrecognizedDelim', 'Missing or unrecognized delimiter for %1', this.currentCS);
  };
  TexParser.prototype.GetStar = function () {
    var star = this.GetNext() === '*';
    if (star) {
      this.i++;
    }
    return star;
  };
  TexParser.prototype.create = function (kind) {
    var _a;
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    }
    return (_a = this.configuration.nodeFactory).create.apply(_a, __spreadArray$p([kind], __read$J(rest), false));
  };
  return TexParser;
})();
TexParser$1.default = TexParser;

var ParseOptions$1 = {};

var StackItemFactory$1 = {};

var StackItem = {};

var __extends$1i = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$I = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$o = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$y = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$F = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(StackItem, "__esModule", {
  value: true
});
StackItem.BaseItem = StackItem.MmlStack = void 0;
var TexError_js_1$i = __importDefault$F(TexError$1);
var MmlStack = (function () {
  function MmlStack(_nodes) {
    this._nodes = _nodes;
  }
  Object.defineProperty(MmlStack.prototype, "nodes", {
    get: function () {
      return this._nodes;
    },
    enumerable: false,
    configurable: true
  });
  MmlStack.prototype.Push = function () {
    var _a;
    var nodes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      nodes[_i] = arguments[_i];
    }
    (_a = this._nodes).push.apply(_a, __spreadArray$o([], __read$I(nodes), false));
  };
  MmlStack.prototype.Pop = function () {
    return this._nodes.pop();
  };
  Object.defineProperty(MmlStack.prototype, "First", {
    get: function () {
      return this._nodes[this.Size() - 1];
    },
    set: function (node) {
      this._nodes[this.Size() - 1] = node;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlStack.prototype, "Last", {
    get: function () {
      return this._nodes[0];
    },
    set: function (node) {
      this._nodes[0] = node;
    },
    enumerable: false,
    configurable: true
  });
  MmlStack.prototype.Peek = function (n) {
    if (n == null) {
      n = 1;
    }
    return this._nodes.slice(this.Size() - n);
  };
  MmlStack.prototype.Size = function () {
    return this._nodes.length;
  };
  MmlStack.prototype.Clear = function () {
    this._nodes = [];
  };
  MmlStack.prototype.toMml = function (inferred, forceRow) {
    if (inferred === void 0) {
      inferred = true;
    }
    if (this._nodes.length === 1 && !forceRow) {
      return this.First;
    }
    return this.create('node', inferred ? 'inferredMrow' : 'mrow', this._nodes, {});
  };
  MmlStack.prototype.create = function (kind) {
    var _a;
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    }
    return (_a = this.factory.configuration.nodeFactory).create.apply(_a, __spreadArray$o([kind], __read$I(rest), false));
  };
  return MmlStack;
})();
StackItem.MmlStack = MmlStack;
var BaseItem = (function (_super) {
  __extends$1i(BaseItem, _super);
  function BaseItem(factory) {
    var nodes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      nodes[_i - 1] = arguments[_i];
    }
    var _this = _super.call(this, nodes) || this;
    _this.factory = factory;
    _this.global = {};
    _this._properties = {};
    if (_this.isOpen) {
      _this._env = {};
    }
    return _this;
  }
  Object.defineProperty(BaseItem.prototype, "kind", {
    get: function () {
      return 'base';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseItem.prototype, "env", {
    get: function () {
      return this._env;
    },
    set: function (value) {
      this._env = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseItem.prototype, "copyEnv", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  BaseItem.prototype.getProperty = function (key) {
    return this._properties[key];
  };
  BaseItem.prototype.setProperty = function (key, value) {
    this._properties[key] = value;
    return this;
  };
  Object.defineProperty(BaseItem.prototype, "isOpen", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseItem.prototype, "isClose", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseItem.prototype, "isFinal", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  BaseItem.prototype.isKind = function (kind) {
    return kind === this.kind;
  };
  BaseItem.prototype.checkItem = function (item) {
    if (item.isKind('over') && this.isOpen) {
      item.setProperty('num', this.toMml(false));
      this.Clear();
    }
    if (item.isKind('cell') && this.isOpen) {
      if (item.getProperty('linebreak')) {
        return BaseItem.fail;
      }
      throw new TexError_js_1$i.default('Misplaced', 'Misplaced %1', item.getName());
    }
    if (item.isClose && this.getErrors(item.kind)) {
      var _a = __read$I(this.getErrors(item.kind), 2), id = _a[0], message = _a[1];
      throw new TexError_js_1$i.default(id, message, item.getName());
    }
    if (!item.isFinal) {
      return BaseItem.success;
    }
    this.Push(item.First);
    return BaseItem.fail;
  };
  BaseItem.prototype.clearEnv = function () {
    var e_1, _a;
    try {
      for (var _b = __values$y(Object.keys(this.env)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        delete this.env[id];
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  BaseItem.prototype.setProperties = function (def) {
    Object.assign(this._properties, def);
    return this;
  };
  BaseItem.prototype.getName = function () {
    return this.getProperty('name');
  };
  BaseItem.prototype.toString = function () {
    return this.kind + '[' + this.nodes.join('; ') + ']';
  };
  BaseItem.prototype.getErrors = function (kind) {
    var CLASS = this.constructor;
    return (CLASS.errors || ({}))[kind] || BaseItem.errors[kind];
  };
  BaseItem.fail = [null, false];
  BaseItem.success = [null, true];
  BaseItem.errors = {
    end: ['MissingBeginExtraEnd', 'Missing \\begin{%1} or extra \\end{%1}'],
    close: ['ExtraCloseMissingOpen', 'Extra close brace or missing open brace'],
    right: ['MissingLeftExtraRight', 'Missing \\left or extra \\right'],
    middle: ['ExtraMiddle', 'Extra \\middle']
  };
  return BaseItem;
})(MmlStack);
StackItem.BaseItem = BaseItem;

var __extends$1h = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var _a$a;
Object.defineProperty(StackItemFactory$1, "__esModule", {
  value: true
});
var StackItem_js_1$5 = StackItem;
var Factory_js_1$1 = Factory;
var DummyItem = (function (_super) {
  __extends$1h(DummyItem, _super);
  function DummyItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return DummyItem;
})(StackItem_js_1$5.BaseItem);
var StackItemFactory = (function (_super) {
  __extends$1h(StackItemFactory, _super);
  function StackItemFactory() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.defaultKind = 'dummy';
    _this.configuration = null;
    return _this;
  }
  StackItemFactory.DefaultStackItems = (_a$a = {}, _a$a[DummyItem.prototype.kind] = DummyItem, _a$a);
  return StackItemFactory;
})(Factory_js_1$1.AbstractFactory);
StackItemFactory$1.default = StackItemFactory;

var NodeFactory$1 = {};

var __read$H = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$n = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$E = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(NodeFactory$1, "__esModule", {
  value: true
});
NodeFactory$1.NodeFactory = void 0;
var NodeUtil_js_1$e = __importDefault$E(NodeUtil$1);
var NodeFactory = (function () {
  function NodeFactory() {
    this.mmlFactory = null;
    this.factory = {
      'node': NodeFactory.createNode,
      'token': NodeFactory.createToken,
      'text': NodeFactory.createText,
      'error': NodeFactory.createError
    };
  }
  NodeFactory.createNode = function (factory, kind, children, def, text) {
    if (children === void 0) {
      children = [];
    }
    if (def === void 0) {
      def = {};
    }
    var node = factory.mmlFactory.create(kind);
    node.setChildren(children);
    if (text) {
      node.appendChild(text);
    }
    NodeUtil_js_1$e.default.setProperties(node, def);
    return node;
  };
  NodeFactory.createToken = function (factory, kind, def, text) {
    if (def === void 0) {
      def = {};
    }
    if (text === void 0) {
      text = '';
    }
    var textNode = factory.create('text', text);
    return factory.create('node', kind, [], def, textNode);
  };
  NodeFactory.createText = function (factory, text) {
    if (text == null) {
      return null;
    }
    return factory.mmlFactory.create('text').setText(text);
  };
  NodeFactory.createError = function (factory, message) {
    var text = factory.create('text', message);
    var mtext = factory.create('node', 'mtext', [], {}, text);
    var error = factory.create('node', 'merror', [mtext], {
      'data-mjx-error': message
    });
    return error;
  };
  NodeFactory.prototype.setMmlFactory = function (mmlFactory) {
    this.mmlFactory = mmlFactory;
  };
  NodeFactory.prototype.set = function (kind, func) {
    this.factory[kind] = func;
  };
  NodeFactory.prototype.setCreators = function (maps) {
    for (var kind in maps) {
      this.set(kind, maps[kind]);
    }
  };
  NodeFactory.prototype.create = function (kind) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    }
    var func = this.factory[kind] || this.factory['node'];
    var node = func.apply(void 0, __spreadArray$n([this, rest[0]], __read$H(rest.slice(1)), false));
    if (kind === 'node') {
      this.configuration.addNode(rest[0], node);
    }
    return node;
  };
  NodeFactory.prototype.get = function (kind) {
    return this.factory[kind];
  };
  return NodeFactory;
})();
NodeFactory$1.NodeFactory = NodeFactory;

var __read$G = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$m = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$x = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$D = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(ParseOptions$1, "__esModule", {
  value: true
});
var StackItemFactory_js_1 = __importDefault$D(StackItemFactory$1);
var NodeFactory_js_1$1 = NodeFactory$1;
var NodeUtil_js_1$d = __importDefault$D(NodeUtil$1);
var Options_js_1$9 = Options;
var ParseOptions = (function () {
  function ParseOptions(configuration, options) {
    if (options === void 0) {
      options = [];
    }
    this.options = {};
    this.packageData = new Map();
    this.parsers = [];
    this.root = null;
    this.nodeLists = {};
    this.error = false;
    this.handlers = configuration.handlers;
    this.nodeFactory = new NodeFactory_js_1$1.NodeFactory();
    this.nodeFactory.configuration = this;
    this.nodeFactory.setCreators(configuration.nodes);
    this.itemFactory = new StackItemFactory_js_1.default(configuration.items);
    this.itemFactory.configuration = this;
    Options_js_1$9.defaultOptions.apply(void 0, __spreadArray$m([this.options], __read$G(options), false));
    (0, Options_js_1$9.defaultOptions)(this.options, configuration.options);
  }
  ParseOptions.prototype.pushParser = function (parser) {
    this.parsers.unshift(parser);
  };
  ParseOptions.prototype.popParser = function () {
    this.parsers.shift();
  };
  Object.defineProperty(ParseOptions.prototype, "parser", {
    get: function () {
      return this.parsers[0];
    },
    enumerable: false,
    configurable: true
  });
  ParseOptions.prototype.clear = function () {
    this.parsers = [];
    this.root = null;
    this.nodeLists = {};
    this.error = false;
    this.tags.resetTag();
  };
  ParseOptions.prototype.addNode = function (property, node) {
    var list = this.nodeLists[property];
    if (!list) {
      list = this.nodeLists[property] = [];
    }
    list.push(node);
    if (node.kind !== property) {
      var inlists = NodeUtil_js_1$d.default.getProperty(node, 'in-lists') || '';
      var lists = (inlists ? inlists.split(/,/) : []).concat(property).join(',');
      NodeUtil_js_1$d.default.setProperty(node, 'in-lists', lists);
    }
  };
  ParseOptions.prototype.getList = function (property) {
    var e_1, _a;
    var list = this.nodeLists[property] || [];
    var result = [];
    try {
      for (var list_1 = __values$x(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
        var node = list_1_1.value;
        if (this.inTree(node)) {
          result.push(node);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    this.nodeLists[property] = result;
    return result;
  };
  ParseOptions.prototype.removeFromList = function (property, nodes) {
    var e_2, _a;
    var list = this.nodeLists[property] || [];
    try {
      for (var nodes_1 = __values$x(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
        var node = nodes_1_1.value;
        var i = list.indexOf(node);
        if (i >= 0) {
          list.splice(i, 1);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  ParseOptions.prototype.inTree = function (node) {
    while (node && node !== this.root) {
      node = node.parent;
    }
    return !!node;
  };
  return ParseOptions;
})();
ParseOptions$1.default = ParseOptions;

var Tags = {};

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TagsFactory = exports.AllTags = exports.NoTags = exports.AbstractTags = exports.TagInfo = exports.Label = void 0;
  var TexParser_js_1 = __importDefault(TexParser$1);
  var Label = (function () {
    function Label(tag, id) {
      if (tag === void 0) {
        tag = '???';
      }
      if (id === void 0) {
        id = '';
      }
      this.tag = tag;
      this.id = id;
    }
    return Label;
  })();
  exports.Label = Label;
  var TagInfo = (function () {
    function TagInfo(env, taggable, defaultTags, tag, tagId, tagFormat, noTag, labelId) {
      if (env === void 0) {
        env = '';
      }
      if (taggable === void 0) {
        taggable = false;
      }
      if (defaultTags === void 0) {
        defaultTags = false;
      }
      if (tag === void 0) {
        tag = null;
      }
      if (tagId === void 0) {
        tagId = '';
      }
      if (tagFormat === void 0) {
        tagFormat = '';
      }
      if (noTag === void 0) {
        noTag = false;
      }
      if (labelId === void 0) {
        labelId = '';
      }
      this.env = env;
      this.taggable = taggable;
      this.defaultTags = defaultTags;
      this.tag = tag;
      this.tagId = tagId;
      this.tagFormat = tagFormat;
      this.noTag = noTag;
      this.labelId = labelId;
    }
    return TagInfo;
  })();
  exports.TagInfo = TagInfo;
  var AbstractTags = (function () {
    function AbstractTags() {
      this.counter = 0;
      this.allCounter = 0;
      this.configuration = null;
      this.ids = {};
      this.allIds = {};
      this.labels = {};
      this.allLabels = {};
      this.redo = false;
      this.refUpdate = false;
      this.currentTag = new TagInfo();
      this.history = [];
      this.stack = [];
      this.enTag = function (node, tag) {
        var nf = this.configuration.nodeFactory;
        var cell = nf.create('node', 'mtd', [node]);
        var row = nf.create('node', 'mlabeledtr', [tag, cell]);
        var table = nf.create('node', 'mtable', [row], {
          side: this.configuration.options['tagSide'],
          minlabelspacing: this.configuration.options['tagIndent'],
          displaystyle: true
        });
        return table;
      };
    }
    AbstractTags.prototype.start = function (env, taggable, defaultTags) {
      if (this.currentTag) {
        this.stack.push(this.currentTag);
      }
      this.currentTag = new TagInfo(env, taggable, defaultTags);
    };
    Object.defineProperty(AbstractTags.prototype, "env", {
      get: function () {
        return this.currentTag.env;
      },
      enumerable: false,
      configurable: true
    });
    AbstractTags.prototype.end = function () {
      this.history.push(this.currentTag);
      this.currentTag = this.stack.pop();
    };
    AbstractTags.prototype.tag = function (tag, noFormat) {
      this.currentTag.tag = tag;
      this.currentTag.tagFormat = noFormat ? tag : this.formatTag(tag);
      this.currentTag.noTag = false;
    };
    AbstractTags.prototype.notag = function () {
      this.tag('', true);
      this.currentTag.noTag = true;
    };
    Object.defineProperty(AbstractTags.prototype, "noTag", {
      get: function () {
        return this.currentTag.noTag;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(AbstractTags.prototype, "label", {
      get: function () {
        return this.currentTag.labelId;
      },
      set: function (label) {
        this.currentTag.labelId = label;
      },
      enumerable: false,
      configurable: true
    });
    AbstractTags.prototype.formatUrl = function (id, base) {
      return base + '#' + encodeURIComponent(id);
    };
    AbstractTags.prototype.formatTag = function (tag) {
      return '(' + tag + ')';
    };
    AbstractTags.prototype.formatId = function (id) {
      return 'mjx-eqn:' + id.replace(/\s/g, '_');
    };
    AbstractTags.prototype.formatNumber = function (n) {
      return n.toString();
    };
    AbstractTags.prototype.autoTag = function () {
      if (this.currentTag.tag == null) {
        this.counter++;
        this.tag(this.formatNumber(this.counter), false);
      }
    };
    AbstractTags.prototype.clearTag = function () {
      this.label = '';
      this.tag(null, true);
      this.currentTag.tagId = '';
    };
    AbstractTags.prototype.getTag = function (force) {
      if (force === void 0) {
        force = false;
      }
      if (force) {
        this.autoTag();
        return this.makeTag();
      }
      var ct = this.currentTag;
      if (ct.taggable && !ct.noTag) {
        if (ct.defaultTags) {
          this.autoTag();
        }
        if (ct.tag) {
          return this.makeTag();
        }
      }
      return null;
    };
    AbstractTags.prototype.resetTag = function () {
      this.history = [];
      this.redo = false;
      this.refUpdate = false;
      this.clearTag();
    };
    AbstractTags.prototype.reset = function (offset) {
      if (offset === void 0) {
        offset = 0;
      }
      this.resetTag();
      this.counter = this.allCounter = offset;
      this.allLabels = {};
      this.allIds = {};
    };
    AbstractTags.prototype.startEquation = function (math) {
      this.history = [];
      this.stack = [];
      this.clearTag();
      this.currentTag = new TagInfo('', undefined, undefined);
      this.labels = {};
      this.ids = {};
      this.counter = this.allCounter;
      this.redo = false;
      var recompile = math.inputData.recompile;
      if (recompile) {
        this.refUpdate = true;
        this.counter = recompile.counter;
      }
    };
    AbstractTags.prototype.finishEquation = function (math) {
      if (this.redo) {
        math.inputData.recompile = {
          state: math.state(),
          counter: this.allCounter
        };
      }
      if (!this.refUpdate) {
        this.allCounter = this.counter;
      }
      Object.assign(this.allIds, this.ids);
      Object.assign(this.allLabels, this.labels);
    };
    AbstractTags.prototype.finalize = function (node, env) {
      if (!env.display || this.currentTag.env || this.currentTag.tag == null) {
        return node;
      }
      var tag = this.makeTag();
      var table = this.enTag(node, tag);
      return table;
    };
    AbstractTags.prototype.makeId = function () {
      this.currentTag.tagId = this.formatId(this.configuration.options['useLabelIds'] ? this.label || this.currentTag.tag : this.currentTag.tag);
    };
    AbstractTags.prototype.makeTag = function () {
      this.makeId();
      if (this.label) {
        this.labels[this.label] = new Label(this.currentTag.tag, this.currentTag.tagId);
      }
      var mml = new TexParser_js_1.default('\\text{' + this.currentTag.tagFormat + '}', {}, this.configuration).mml();
      return this.configuration.nodeFactory.create('node', 'mtd', [mml], {
        id: this.currentTag.tagId
      });
    };
    return AbstractTags;
  })();
  exports.AbstractTags = AbstractTags;
  var NoTags = (function (_super) {
    __extends(NoTags, _super);
    function NoTags() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    NoTags.prototype.autoTag = function () {};
    NoTags.prototype.getTag = function () {
      return !this.currentTag.tag ? null : _super.prototype.getTag.call(this);
    };
    return NoTags;
  })(AbstractTags);
  exports.NoTags = NoTags;
  var AllTags = (function (_super) {
    __extends(AllTags, _super);
    function AllTags() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    AllTags.prototype.finalize = function (node, env) {
      if (!env.display || this.history.find(function (x) {
        return x.taggable;
      })) {
        return node;
      }
      var tag = this.getTag(true);
      return this.enTag(node, tag);
    };
    return AllTags;
  })(AbstractTags);
  exports.AllTags = AllTags;
  (function (TagsFactory) {
    var tagsMapping = new Map([['none', NoTags], ['all', AllTags]]);
    var defaultTags = 'none';
    TagsFactory.OPTIONS = {
      tags: defaultTags,
      tagSide: 'right',
      tagIndent: '0.8em',
      useLabelIds: true,
      ignoreDuplicateLabels: false
    };
    TagsFactory.add = function (name, constr) {
      tagsMapping.set(name, constr);
    };
    TagsFactory.addTags = function (tags) {
      var e_1, _a;
      try {
        for (var _b = __values(Object.keys(tags)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          TagsFactory.add(key, tags[key]);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    };
    TagsFactory.create = function (name) {
      var constr = tagsMapping.get(name) || tagsMapping.get(defaultTags);
      if (!constr) {
        throw Error('Unknown tags class');
      }
      return new constr();
    };
    TagsFactory.setDefault = function (name) {
      defaultTags = name;
    };
    TagsFactory.getDefault = function () {
      return TagsFactory.create(defaultTags);
    };
  })(exports.TagsFactory || (exports.TagsFactory = {}));
})(Tags);
getDefaultExportFromCjs(Tags);

var Configuration = {};

var MapHandler = {};

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SubHandlers = exports.SubHandler = exports.MapHandler = void 0;
  var PrioritizedList_js_1 = PrioritizedList$1;
  var FunctionList_js_1 = FunctionList$1;
  var MapHandler;
  (function (MapHandler) {
    var maps = new Map();
    MapHandler.register = function (map) {
      maps.set(map.name, map);
    };
    MapHandler.getMap = function (name) {
      return maps.get(name);
    };
  })(MapHandler = exports.MapHandler || (exports.MapHandler = {}));
  var SubHandler = (function () {
    function SubHandler() {
      this._configuration = new PrioritizedList_js_1.PrioritizedList();
      this._fallback = new FunctionList_js_1.FunctionList();
    }
    SubHandler.prototype.add = function (maps, fallback, priority) {
      var e_1, _a;
      if (priority === void 0) {
        priority = PrioritizedList_js_1.PrioritizedList.DEFAULTPRIORITY;
      }
      try {
        for (var _b = __values(maps.slice().reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var name_1 = _c.value;
          var map = MapHandler.getMap(name_1);
          if (!map) {
            this.warn('Configuration ' + name_1 + ' not found! Omitted.');
            return;
          }
          this._configuration.add(map, priority);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      if (fallback) {
        this._fallback.add(fallback, priority);
      }
    };
    SubHandler.prototype.parse = function (input) {
      var e_2, _a;
      try {
        for (var _b = __values(this._configuration), _c = _b.next(); !_c.done; _c = _b.next()) {
          var map = _c.value.item;
          var result = map.parse(input);
          if (result) {
            return result;
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      var _d = __read(input, 2), env = _d[0], symbol = _d[1];
      Array.from(this._fallback)[0].item(env, symbol);
    };
    SubHandler.prototype.lookup = function (symbol) {
      var map = this.applicable(symbol);
      return map ? map.lookup(symbol) : null;
    };
    SubHandler.prototype.contains = function (symbol) {
      return this.applicable(symbol) ? true : false;
    };
    SubHandler.prototype.toString = function () {
      var e_3, _a;
      var names = [];
      try {
        for (var _b = __values(this._configuration), _c = _b.next(); !_c.done; _c = _b.next()) {
          var map = _c.value.item;
          names.push(map.name);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
      return names.join(', ');
    };
    SubHandler.prototype.applicable = function (symbol) {
      var e_4, _a;
      try {
        for (var _b = __values(this._configuration), _c = _b.next(); !_c.done; _c = _b.next()) {
          var map = _c.value.item;
          if (map.contains(symbol)) {
            return map;
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
      return null;
    };
    SubHandler.prototype.retrieve = function (name) {
      var e_5, _a;
      try {
        for (var _b = __values(this._configuration), _c = _b.next(); !_c.done; _c = _b.next()) {
          var map = _c.value.item;
          if (map.name === name) {
            return map;
          }
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      return null;
    };
    SubHandler.prototype.warn = function (message) {
      console.log('TexParser Warning: ' + message);
    };
    return SubHandler;
  })();
  exports.SubHandler = SubHandler;
  var SubHandlers = (function () {
    function SubHandlers() {
      this.map = new Map();
    }
    SubHandlers.prototype.add = function (handlers, fallbacks, priority) {
      var e_6, _a;
      if (priority === void 0) {
        priority = PrioritizedList_js_1.PrioritizedList.DEFAULTPRIORITY;
      }
      try {
        for (var _b = __values(Object.keys(handlers)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var name_2 = key;
          var subHandler = this.get(name_2);
          if (!subHandler) {
            subHandler = new SubHandler();
            this.set(name_2, subHandler);
          }
          subHandler.add(handlers[name_2], fallbacks[name_2], priority);
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_6) throw e_6.error;
        }
      }
    };
    SubHandlers.prototype.set = function (name, subHandler) {
      this.map.set(name, subHandler);
    };
    SubHandlers.prototype.get = function (name) {
      return this.map.get(name);
    };
    SubHandlers.prototype.retrieve = function (name) {
      var e_7, _a;
      try {
        for (var _b = __values(this.map.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var handler = _c.value;
          var map = handler.retrieve(name);
          if (map) {
            return map;
          }
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
      return null;
    };
    SubHandlers.prototype.keys = function () {
      return this.map.keys();
    };
    return SubHandlers;
  })();
  exports.SubHandlers = SubHandlers;
})(MapHandler);
getDefaultExportFromCjs(MapHandler);

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ParserConfiguration = exports.ConfigurationHandler = exports.Configuration = void 0;
  var Options_js_1 = Options;
  var MapHandler_js_1 = MapHandler;
  var FunctionList_js_1 = FunctionList$1;
  var PrioritizedList_js_1 = PrioritizedList$1;
  var Tags_js_1 = Tags;
  var Configuration = (function () {
    function Configuration(name, handler, fallback, items, tags, options, nodes, preprocessors, postprocessors, initMethod, configMethod, priority, parser) {
      if (handler === void 0) {
        handler = {};
      }
      if (fallback === void 0) {
        fallback = {};
      }
      if (items === void 0) {
        items = {};
      }
      if (tags === void 0) {
        tags = {};
      }
      if (options === void 0) {
        options = {};
      }
      if (nodes === void 0) {
        nodes = {};
      }
      if (preprocessors === void 0) {
        preprocessors = [];
      }
      if (postprocessors === void 0) {
        postprocessors = [];
      }
      if (initMethod === void 0) {
        initMethod = null;
      }
      if (configMethod === void 0) {
        configMethod = null;
      }
      this.name = name;
      this.handler = handler;
      this.fallback = fallback;
      this.items = items;
      this.tags = tags;
      this.options = options;
      this.nodes = nodes;
      this.preprocessors = preprocessors;
      this.postprocessors = postprocessors;
      this.initMethod = initMethod;
      this.configMethod = configMethod;
      this.priority = priority;
      this.parser = parser;
      this.handler = Object.assign({
        character: [],
        delimiter: [],
        macro: [],
        environment: []
      }, handler);
    }
    Configuration.makeProcessor = function (func, priority) {
      return Array.isArray(func) ? func : [func, priority];
    };
    Configuration._create = function (name, config) {
      var _this = this;
      if (config === void 0) {
        config = {};
      }
      var priority = config.priority || PrioritizedList_js_1.PrioritizedList.DEFAULTPRIORITY;
      var init = config.init ? this.makeProcessor(config.init, priority) : null;
      var conf = config.config ? this.makeProcessor(config.config, priority) : null;
      var preprocessors = (config.preprocessors || []).map(function (pre) {
        return _this.makeProcessor(pre, priority);
      });
      var postprocessors = (config.postprocessors || []).map(function (post) {
        return _this.makeProcessor(post, priority);
      });
      var parser = config.parser || 'tex';
      return new Configuration(name, config.handler || ({}), config.fallback || ({}), config.items || ({}), config.tags || ({}), config.options || ({}), config.nodes || ({}), preprocessors, postprocessors, init, conf, priority, parser);
    };
    Configuration.create = function (name, config) {
      if (config === void 0) {
        config = {};
      }
      var configuration = Configuration._create(name, config);
      ConfigurationHandler.set(name, configuration);
      return configuration;
    };
    Configuration.local = function (config) {
      if (config === void 0) {
        config = {};
      }
      return Configuration._create('', config);
    };
    Object.defineProperty(Configuration.prototype, "init", {
      get: function () {
        return this.initMethod ? this.initMethod[0] : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Configuration.prototype, "config", {
      get: function () {
        return this.configMethod ? this.configMethod[0] : null;
      },
      enumerable: false,
      configurable: true
    });
    return Configuration;
  })();
  exports.Configuration = Configuration;
  var ConfigurationHandler;
  (function (ConfigurationHandler) {
    var maps = new Map();
    ConfigurationHandler.set = function (name, map) {
      maps.set(name, map);
    };
    ConfigurationHandler.get = function (name) {
      return maps.get(name);
    };
    ConfigurationHandler.keys = function () {
      return maps.keys();
    };
  })(ConfigurationHandler = exports.ConfigurationHandler || (exports.ConfigurationHandler = {}));
  var ParserConfiguration = (function () {
    function ParserConfiguration(packages, parsers) {
      var e_1, _a, e_2, _b;
      if (parsers === void 0) {
        parsers = ['tex'];
      }
      this.initMethod = new FunctionList_js_1.FunctionList();
      this.configMethod = new FunctionList_js_1.FunctionList();
      this.configurations = new PrioritizedList_js_1.PrioritizedList();
      this.parsers = [];
      this.handlers = new MapHandler_js_1.SubHandlers();
      this.items = {};
      this.tags = {};
      this.options = {};
      this.nodes = {};
      this.parsers = parsers;
      try {
        for (var _c = __values(packages.slice().reverse()), _d = _c.next(); !_d.done; _d = _c.next()) {
          var pkg = _d.value;
          this.addPackage(pkg);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      try {
        for (var _e = __values(this.configurations), _f = _e.next(); !_f.done; _f = _e.next()) {
          var _g = _f.value, config = _g.item, priority = _g.priority;
          this.append(config, priority);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
    ParserConfiguration.prototype.init = function () {
      this.initMethod.execute(this);
    };
    ParserConfiguration.prototype.config = function (jax) {
      var e_3, _a;
      this.configMethod.execute(this, jax);
      try {
        for (var _b = __values(this.configurations), _c = _b.next(); !_c.done; _c = _b.next()) {
          var config = _c.value;
          this.addFilters(jax, config.item);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    };
    ParserConfiguration.prototype.addPackage = function (pkg) {
      var name = typeof pkg === 'string' ? pkg : pkg[0];
      var conf = this.getPackage(name);
      conf && this.configurations.add(conf, typeof pkg === 'string' ? conf.priority : pkg[1]);
    };
    ParserConfiguration.prototype.add = function (name, jax, options) {
      var e_4, _a;
      if (options === void 0) {
        options = {};
      }
      var config = this.getPackage(name);
      this.append(config);
      this.configurations.add(config, config.priority);
      this.init();
      var parser = jax.parseOptions;
      parser.nodeFactory.setCreators(config.nodes);
      try {
        for (var _b = __values(Object.keys(config.items)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var kind = _c.value;
          parser.itemFactory.setNodeClass(kind, config.items[kind]);
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
      Tags_js_1.TagsFactory.addTags(config.tags);
      (0, Options_js_1.defaultOptions)(parser.options, config.options);
      (0, Options_js_1.userOptions)(parser.options, options);
      this.addFilters(jax, config);
      if (config.config) {
        config.config(this, jax);
      }
    };
    ParserConfiguration.prototype.getPackage = function (name) {
      var config = ConfigurationHandler.get(name);
      if (config && this.parsers.indexOf(config.parser) < 0) {
        throw Error(("Package ").concat(name, " doesn't target the proper parser"));
      }
      return config;
    };
    ParserConfiguration.prototype.append = function (config, priority) {
      priority = priority || config.priority;
      if (config.initMethod) {
        this.initMethod.add(config.initMethod[0], config.initMethod[1]);
      }
      if (config.configMethod) {
        this.configMethod.add(config.configMethod[0], config.configMethod[1]);
      }
      this.handlers.add(config.handler, config.fallback, priority);
      Object.assign(this.items, config.items);
      Object.assign(this.tags, config.tags);
      (0, Options_js_1.defaultOptions)(this.options, config.options);
      Object.assign(this.nodes, config.nodes);
    };
    ParserConfiguration.prototype.addFilters = function (jax, config) {
      var e_5, _a, e_6, _b;
      try {
        for (var _c = __values(config.preprocessors), _d = _c.next(); !_d.done; _d = _c.next()) {
          var _e = __read(_d.value, 2), pre = _e[0], priority = _e[1];
          jax.preFilters.add(pre, priority);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      try {
        for (var _f = __values(config.postprocessors), _g = _f.next(); !_g.done; _g = _f.next()) {
          var _h = __read(_g.value, 2), post = _h[0], priority = _h[1];
          jax.postFilters.add(post, priority);
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        } finally {
          if (e_6) throw e_6.error;
        }
      }
    };
    return ParserConfiguration;
  })();
  exports.ParserConfiguration = ParserConfiguration;
})(Configuration);
getDefaultExportFromCjs(Configuration);

var BaseConfiguration = {};

var SymbolMap = {};

var _Symbol = {};

Object.defineProperty(_Symbol, "__esModule", {
  value: true
});
_Symbol.Macro = _Symbol.Symbol = void 0;
var Symbol$3 = (function () {
  function Symbol(_symbol, _char, _attributes) {
    this._symbol = _symbol;
    this._char = _char;
    this._attributes = _attributes;
  }
  Object.defineProperty(Symbol.prototype, "symbol", {
    get: function () {
      return this._symbol;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Symbol.prototype, "char", {
    get: function () {
      return this._char;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Symbol.prototype, "attributes", {
    get: function () {
      return this._attributes;
    },
    enumerable: false,
    configurable: true
  });
  return Symbol;
})();
_Symbol.Symbol = Symbol$3;
var Macro = (function () {
  function Macro(_symbol, _func, _args) {
    if (_args === void 0) {
      _args = [];
    }
    this._symbol = _symbol;
    this._func = _func;
    this._args = _args;
  }
  Object.defineProperty(Macro.prototype, "symbol", {
    get: function () {
      return this._symbol;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Macro.prototype, "func", {
    get: function () {
      return this._func;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Macro.prototype, "args", {
    get: function () {
      return this._args;
    },
    enumerable: false,
    configurable: true
  });
  return Macro;
})();
_Symbol.Macro = Macro;

var __extends$1g = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$F = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$w = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __spreadArray$l = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(SymbolMap, "__esModule", {
  value: true
});
SymbolMap.EnvironmentMap = SymbolMap.CommandMap = SymbolMap.MacroMap = SymbolMap.DelimiterMap = SymbolMap.CharacterMap = SymbolMap.AbstractParseMap = SymbolMap.RegExpMap = SymbolMap.AbstractSymbolMap = SymbolMap.parseResult = void 0;
var Symbol_js_1$3 = _Symbol;
var MapHandler_js_1$2 = MapHandler;
function parseResult(result) {
  return result === void 0 ? true : result;
}
SymbolMap.parseResult = parseResult;
var AbstractSymbolMap = (function () {
  function AbstractSymbolMap(_name, _parser) {
    this._name = _name;
    this._parser = _parser;
    MapHandler_js_1$2.MapHandler.register(this);
  }
  Object.defineProperty(AbstractSymbolMap.prototype, "name", {
    get: function () {
      return this._name;
    },
    enumerable: false,
    configurable: true
  });
  AbstractSymbolMap.prototype.parserFor = function (symbol) {
    return this.contains(symbol) ? this.parser : null;
  };
  AbstractSymbolMap.prototype.parse = function (_a) {
    var _b = __read$F(_a, 2), env = _b[0], symbol = _b[1];
    var parser = this.parserFor(symbol);
    var mapped = this.lookup(symbol);
    return parser && mapped ? parseResult(parser(env, mapped)) : null;
  };
  Object.defineProperty(AbstractSymbolMap.prototype, "parser", {
    get: function () {
      return this._parser;
    },
    set: function (parser) {
      this._parser = parser;
    },
    enumerable: false,
    configurable: true
  });
  return AbstractSymbolMap;
})();
SymbolMap.AbstractSymbolMap = AbstractSymbolMap;
var RegExpMap = (function (_super) {
  __extends$1g(RegExpMap, _super);
  function RegExpMap(name, parser, _regExp) {
    var _this = _super.call(this, name, parser) || this;
    _this._regExp = _regExp;
    return _this;
  }
  RegExpMap.prototype.contains = function (symbol) {
    return this._regExp.test(symbol);
  };
  RegExpMap.prototype.lookup = function (symbol) {
    return this.contains(symbol) ? symbol : null;
  };
  return RegExpMap;
})(AbstractSymbolMap);
SymbolMap.RegExpMap = RegExpMap;
var AbstractParseMap = (function (_super) {
  __extends$1g(AbstractParseMap, _super);
  function AbstractParseMap() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.map = new Map();
    return _this;
  }
  AbstractParseMap.prototype.lookup = function (symbol) {
    return this.map.get(symbol);
  };
  AbstractParseMap.prototype.contains = function (symbol) {
    return this.map.has(symbol);
  };
  AbstractParseMap.prototype.add = function (symbol, object) {
    this.map.set(symbol, object);
  };
  AbstractParseMap.prototype.remove = function (symbol) {
    this.map.delete(symbol);
  };
  return AbstractParseMap;
})(AbstractSymbolMap);
SymbolMap.AbstractParseMap = AbstractParseMap;
var CharacterMap = (function (_super) {
  __extends$1g(CharacterMap, _super);
  function CharacterMap(name, parser, json) {
    var e_1, _a;
    var _this = _super.call(this, name, parser) || this;
    try {
      for (var _b = __values$w(Object.keys(json)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;
        var value = json[key];
        var _d = __read$F(typeof value === 'string' ? [value, null] : value, 2), char = _d[0], attrs = _d[1];
        var character = new Symbol_js_1$3.Symbol(key, char, attrs);
        _this.add(key, character);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return _this;
  }
  return CharacterMap;
})(AbstractParseMap);
SymbolMap.CharacterMap = CharacterMap;
var DelimiterMap = (function (_super) {
  __extends$1g(DelimiterMap, _super);
  function DelimiterMap() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DelimiterMap.prototype.parse = function (_a) {
    var _b = __read$F(_a, 2), env = _b[0], symbol = _b[1];
    return _super.prototype.parse.call(this, [env, '\\' + symbol]);
  };
  return DelimiterMap;
})(CharacterMap);
SymbolMap.DelimiterMap = DelimiterMap;
var MacroMap = (function (_super) {
  __extends$1g(MacroMap, _super);
  function MacroMap(name, json, functionMap) {
    var e_2, _a;
    var _this = _super.call(this, name, null) || this;
    try {
      for (var _b = __values$w(Object.keys(json)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;
        var value = json[key];
        var _d = __read$F(typeof value === 'string' ? [value] : value), func = _d[0], attrs = _d.slice(1);
        var character = new Symbol_js_1$3.Macro(key, functionMap[func], attrs);
        _this.add(key, character);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return _this;
  }
  MacroMap.prototype.parserFor = function (symbol) {
    var macro = this.lookup(symbol);
    return macro ? macro.func : null;
  };
  MacroMap.prototype.parse = function (_a) {
    var _b = __read$F(_a, 2), env = _b[0], symbol = _b[1];
    var macro = this.lookup(symbol);
    var parser = this.parserFor(symbol);
    if (!macro || !parser) {
      return null;
    }
    return parseResult(parser.apply(void 0, __spreadArray$l([env, macro.symbol], __read$F(macro.args), false)));
  };
  return MacroMap;
})(AbstractParseMap);
SymbolMap.MacroMap = MacroMap;
var CommandMap = (function (_super) {
  __extends$1g(CommandMap, _super);
  function CommandMap() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CommandMap.prototype.parse = function (_a) {
    var _b = __read$F(_a, 2), env = _b[0], symbol = _b[1];
    var macro = this.lookup(symbol);
    var parser = this.parserFor(symbol);
    if (!macro || !parser) {
      return null;
    }
    var saveCommand = env.currentCS;
    env.currentCS = '\\' + symbol;
    var result = parser.apply(void 0, __spreadArray$l([env, '\\' + macro.symbol], __read$F(macro.args), false));
    env.currentCS = saveCommand;
    return parseResult(result);
  };
  return CommandMap;
})(MacroMap);
SymbolMap.CommandMap = CommandMap;
var EnvironmentMap = (function (_super) {
  __extends$1g(EnvironmentMap, _super);
  function EnvironmentMap(name, parser, json, functionMap) {
    var _this = _super.call(this, name, json, functionMap) || this;
    _this.parser = parser;
    return _this;
  }
  EnvironmentMap.prototype.parse = function (_a) {
    var _b = __read$F(_a, 2), env = _b[0], symbol = _b[1];
    var macro = this.lookup(symbol);
    var envParser = this.parserFor(symbol);
    if (!macro || !envParser) {
      return null;
    }
    return parseResult(this.parser(env, macro.symbol, envParser, macro.args));
  };
  return EnvironmentMap;
})(MacroMap);
SymbolMap.EnvironmentMap = EnvironmentMap;

var BaseItems = {};

var __extends$1f = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$E = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$k = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$C = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(BaseItems, "__esModule", {
  value: true
});
BaseItems.EquationItem = BaseItems.EqnArrayItem = BaseItems.ArrayItem = BaseItems.DotsItem = BaseItems.NonscriptItem = BaseItems.NotItem = BaseItems.FnItem = BaseItems.MmlItem = BaseItems.CellItem = BaseItems.PositionItem = BaseItems.StyleItem = BaseItems.EndItem = BaseItems.BeginItem = BaseItems.RightItem = BaseItems.Middle = BaseItems.LeftItem = BaseItems.OverItem = BaseItems.SubsupItem = BaseItems.PrimeItem = BaseItems.CloseItem = BaseItems.OpenItem = BaseItems.StopItem = BaseItems.StartItem = void 0;
var MapHandler_js_1$1 = MapHandler;
var Entities_js_1$1 = Entities$1;
var MmlNode_js_1$f = MmlNode;
var TexError_js_1$h = __importDefault$C(TexError$1);
var ParseUtil_js_1$e = __importDefault$C(ParseUtil$1);
var NodeUtil_js_1$c = __importDefault$C(NodeUtil$1);
var StackItem_js_1$4 = StackItem;
var StartItem = (function (_super) {
  __extends$1f(StartItem, _super);
  function StartItem(factory, global) {
    var _this = _super.call(this, factory) || this;
    _this.global = global;
    return _this;
  }
  Object.defineProperty(StartItem.prototype, "kind", {
    get: function () {
      return 'start';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StartItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  StartItem.prototype.checkItem = function (item) {
    if (item.isKind('stop')) {
      var node = this.toMml();
      if (!this.global.isInner) {
        node = this.factory.configuration.tags.finalize(node, this.env);
      }
      return [[this.factory.create('mml', node)], true];
    }
    return _super.prototype.checkItem.call(this, item);
  };
  return StartItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.StartItem = StartItem;
var StopItem = (function (_super) {
  __extends$1f(StopItem, _super);
  function StopItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(StopItem.prototype, "kind", {
    get: function () {
      return 'stop';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StopItem.prototype, "isClose", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  return StopItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.StopItem = StopItem;
var OpenItem = (function (_super) {
  __extends$1f(OpenItem, _super);
  function OpenItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(OpenItem.prototype, "kind", {
    get: function () {
      return 'open';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OpenItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  OpenItem.prototype.checkItem = function (item) {
    if (item.isKind('close')) {
      var mml = this.toMml();
      var node = this.create('node', 'TeXAtom', [mml]);
      return [[this.factory.create('mml', node)], true];
    }
    return _super.prototype.checkItem.call(this, item);
  };
  OpenItem.errors = Object.assign(Object.create(StackItem_js_1$4.BaseItem.errors), {
    'stop': ['ExtraOpenMissingClose', 'Extra open brace or missing close brace']
  });
  return OpenItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.OpenItem = OpenItem;
var CloseItem = (function (_super) {
  __extends$1f(CloseItem, _super);
  function CloseItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(CloseItem.prototype, "kind", {
    get: function () {
      return 'close';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CloseItem.prototype, "isClose", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  return CloseItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.CloseItem = CloseItem;
var PrimeItem = (function (_super) {
  __extends$1f(PrimeItem, _super);
  function PrimeItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(PrimeItem.prototype, "kind", {
    get: function () {
      return 'prime';
    },
    enumerable: false,
    configurable: true
  });
  PrimeItem.prototype.checkItem = function (item) {
    var _a = __read$E(this.Peek(2), 2), top0 = _a[0], top1 = _a[1];
    if (!NodeUtil_js_1$c.default.isType(top0, 'msubsup') || NodeUtil_js_1$c.default.isType(top0, 'msup')) {
      var node = this.create('node', 'msup', [top0, top1]);
      return [[node, item], true];
    }
    NodeUtil_js_1$c.default.setChild(top0, top0.sup, top1);
    return [[top0, item], true];
  };
  return PrimeItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.PrimeItem = PrimeItem;
var SubsupItem = (function (_super) {
  __extends$1f(SubsupItem, _super);
  function SubsupItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(SubsupItem.prototype, "kind", {
    get: function () {
      return 'subsup';
    },
    enumerable: false,
    configurable: true
  });
  SubsupItem.prototype.checkItem = function (item) {
    if (item.isKind('open') || item.isKind('left')) {
      return StackItem_js_1$4.BaseItem.success;
    }
    var top = this.First;
    var position = this.getProperty('position');
    if (item.isKind('mml')) {
      if (this.getProperty('primes')) {
        if (position !== 2) {
          NodeUtil_js_1$c.default.setChild(top, 2, this.getProperty('primes'));
        } else {
          NodeUtil_js_1$c.default.setProperty(this.getProperty('primes'), 'variantForm', true);
          var node = this.create('node', 'mrow', [this.getProperty('primes'), item.First]);
          item.First = node;
        }
      }
      NodeUtil_js_1$c.default.setChild(top, position, item.First);
      if (this.getProperty('movesupsub') != null) {
        NodeUtil_js_1$c.default.setProperty(top, 'movesupsub', this.getProperty('movesupsub'));
      }
      var result = this.factory.create('mml', top);
      return [[result], true];
    }
    if (_super.prototype.checkItem.call(this, item)[1]) {
      var error = this.getErrors(['', 'sub', 'sup'][position]);
      throw new (TexError_js_1$h.default.bind.apply(TexError_js_1$h.default, __spreadArray$k([void 0, error[0], error[1]], __read$E(error.splice(2)), false)))();
    }
    return null;
  };
  SubsupItem.errors = Object.assign(Object.create(StackItem_js_1$4.BaseItem.errors), {
    'stop': ['MissingScript', 'Missing superscript or subscript argument'],
    'sup': ['MissingOpenForSup', 'Missing open brace for superscript'],
    'sub': ['MissingOpenForSub', 'Missing open brace for subscript']
  });
  return SubsupItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.SubsupItem = SubsupItem;
var OverItem = (function (_super) {
  __extends$1f(OverItem, _super);
  function OverItem(factory) {
    var _this = _super.call(this, factory) || this;
    _this.setProperty('name', '\\over');
    return _this;
  }
  Object.defineProperty(OverItem.prototype, "kind", {
    get: function () {
      return 'over';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OverItem.prototype, "isClose", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  OverItem.prototype.checkItem = function (item) {
    if (item.isKind('over')) {
      throw new TexError_js_1$h.default('AmbiguousUseOf', 'Ambiguous use of %1', item.getName());
    }
    if (item.isClose) {
      var mml = this.create('node', 'mfrac', [this.getProperty('num'), this.toMml(false)]);
      if (this.getProperty('thickness') != null) {
        NodeUtil_js_1$c.default.setAttribute(mml, 'linethickness', this.getProperty('thickness'));
      }
      if (this.getProperty('open') || this.getProperty('close')) {
        NodeUtil_js_1$c.default.setProperty(mml, 'withDelims', true);
        mml = ParseUtil_js_1$e.default.fixedFence(this.factory.configuration, this.getProperty('open'), mml, this.getProperty('close'));
      }
      return [[this.factory.create('mml', mml), item], true];
    }
    return _super.prototype.checkItem.call(this, item);
  };
  OverItem.prototype.toString = function () {
    return 'over[' + this.getProperty('num') + ' / ' + this.nodes.join('; ') + ']';
  };
  return OverItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.OverItem = OverItem;
var LeftItem = (function (_super) {
  __extends$1f(LeftItem, _super);
  function LeftItem(factory, delim) {
    var _this = _super.call(this, factory) || this;
    _this.setProperty('delim', delim);
    return _this;
  }
  Object.defineProperty(LeftItem.prototype, "kind", {
    get: function () {
      return 'left';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LeftItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  LeftItem.prototype.checkItem = function (item) {
    if (item.isKind('right')) {
      return [[this.factory.create('mml', ParseUtil_js_1$e.default.fenced(this.factory.configuration, this.getProperty('delim'), this.toMml(), item.getProperty('delim'), '', item.getProperty('color')))], true];
    }
    if (item.isKind('middle')) {
      var def = {
        stretchy: true
      };
      if (item.getProperty('color')) {
        def.mathcolor = item.getProperty('color');
      }
      this.Push(this.create('node', 'TeXAtom', [], {
        texClass: MmlNode_js_1$f.TEXCLASS.CLOSE
      }), this.create('token', 'mo', def, item.getProperty('delim')), this.create('node', 'TeXAtom', [], {
        texClass: MmlNode_js_1$f.TEXCLASS.OPEN
      }));
      this.env = {};
      return [[this], true];
    }
    return _super.prototype.checkItem.call(this, item);
  };
  LeftItem.errors = Object.assign(Object.create(StackItem_js_1$4.BaseItem.errors), {
    'stop': ['ExtraLeftMissingRight', 'Extra \\left or missing \\right']
  });
  return LeftItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.LeftItem = LeftItem;
var Middle = (function (_super) {
  __extends$1f(Middle, _super);
  function Middle(factory, delim, color) {
    var _this = _super.call(this, factory) || this;
    _this.setProperty('delim', delim);
    color && _this.setProperty('color', color);
    return _this;
  }
  Object.defineProperty(Middle.prototype, "kind", {
    get: function () {
      return 'middle';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Middle.prototype, "isClose", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  return Middle;
})(StackItem_js_1$4.BaseItem);
BaseItems.Middle = Middle;
var RightItem = (function (_super) {
  __extends$1f(RightItem, _super);
  function RightItem(factory, delim, color) {
    var _this = _super.call(this, factory) || this;
    _this.setProperty('delim', delim);
    color && _this.setProperty('color', color);
    return _this;
  }
  Object.defineProperty(RightItem.prototype, "kind", {
    get: function () {
      return 'right';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(RightItem.prototype, "isClose", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  return RightItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.RightItem = RightItem;
var BeginItem = (function (_super) {
  __extends$1f(BeginItem, _super);
  function BeginItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(BeginItem.prototype, "kind", {
    get: function () {
      return 'begin';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BeginItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  BeginItem.prototype.checkItem = function (item) {
    if (item.isKind('end')) {
      if (item.getName() !== this.getName()) {
        throw new TexError_js_1$h.default('EnvBadEnd', '\\begin{%1} ended with \\end{%2}', this.getName(), item.getName());
      }
      if (!this.getProperty('end')) {
        return [[this.factory.create('mml', this.toMml())], true];
      }
      return StackItem_js_1$4.BaseItem.fail;
    }
    if (item.isKind('stop')) {
      throw new TexError_js_1$h.default('EnvMissingEnd', 'Missing \\end{%1}', this.getName());
    }
    return _super.prototype.checkItem.call(this, item);
  };
  return BeginItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.BeginItem = BeginItem;
var EndItem = (function (_super) {
  __extends$1f(EndItem, _super);
  function EndItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(EndItem.prototype, "kind", {
    get: function () {
      return 'end';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EndItem.prototype, "isClose", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  return EndItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.EndItem = EndItem;
var StyleItem = (function (_super) {
  __extends$1f(StyleItem, _super);
  function StyleItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(StyleItem.prototype, "kind", {
    get: function () {
      return 'style';
    },
    enumerable: false,
    configurable: true
  });
  StyleItem.prototype.checkItem = function (item) {
    if (!item.isClose) {
      return _super.prototype.checkItem.call(this, item);
    }
    var mml = this.create('node', 'mstyle', this.nodes, this.getProperty('styles'));
    return [[this.factory.create('mml', mml), item], true];
  };
  return StyleItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.StyleItem = StyleItem;
var PositionItem = (function (_super) {
  __extends$1f(PositionItem, _super);
  function PositionItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(PositionItem.prototype, "kind", {
    get: function () {
      return 'position';
    },
    enumerable: false,
    configurable: true
  });
  PositionItem.prototype.checkItem = function (item) {
    if (item.isClose) {
      throw new TexError_js_1$h.default('MissingBoxFor', 'Missing box for %1', this.getName());
    }
    if (item.isFinal) {
      var mml = item.toMml();
      switch (this.getProperty('move')) {
        case 'vertical':
          mml = this.create('node', 'mpadded', [mml], {
            height: this.getProperty('dh'),
            depth: this.getProperty('dd'),
            voffset: this.getProperty('dh')
          });
          return [[this.factory.create('mml', mml)], true];
        case 'horizontal':
          return [[this.factory.create('mml', this.getProperty('left')), item, this.factory.create('mml', this.getProperty('right'))], true];
      }
    }
    return _super.prototype.checkItem.call(this, item);
  };
  return PositionItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.PositionItem = PositionItem;
var CellItem = (function (_super) {
  __extends$1f(CellItem, _super);
  function CellItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(CellItem.prototype, "kind", {
    get: function () {
      return 'cell';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CellItem.prototype, "isClose", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  return CellItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.CellItem = CellItem;
var MmlItem = (function (_super) {
  __extends$1f(MmlItem, _super);
  function MmlItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MmlItem.prototype, "isFinal", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MmlItem.prototype, "kind", {
    get: function () {
      return 'mml';
    },
    enumerable: false,
    configurable: true
  });
  return MmlItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.MmlItem = MmlItem;
var FnItem = (function (_super) {
  __extends$1f(FnItem, _super);
  function FnItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(FnItem.prototype, "kind", {
    get: function () {
      return 'fn';
    },
    enumerable: false,
    configurable: true
  });
  FnItem.prototype.checkItem = function (item) {
    var top = this.First;
    if (top) {
      if (item.isOpen) {
        return StackItem_js_1$4.BaseItem.success;
      }
      if (!item.isKind('fn')) {
        var mml = item.First;
        if (!item.isKind('mml') || !mml) {
          return [[top, item], true];
        }
        if (NodeUtil_js_1$c.default.isType(mml, 'mstyle') && mml.childNodes.length && NodeUtil_js_1$c.default.isType(mml.childNodes[0].childNodes[0], 'mspace') || NodeUtil_js_1$c.default.isType(mml, 'mspace')) {
          return [[top, item], true];
        }
        if (NodeUtil_js_1$c.default.isEmbellished(mml)) {
          mml = NodeUtil_js_1$c.default.getCoreMO(mml);
        }
        var form = NodeUtil_js_1$c.default.getForm(mml);
        if (form != null && [0, 0, 1, 1, 0, 1, 1, 0, 0, 0][form[2]]) {
          return [[top, item], true];
        }
      }
      var node = this.create('token', 'mo', {
        texClass: MmlNode_js_1$f.TEXCLASS.NONE
      }, Entities_js_1$1.entities.ApplyFunction);
      return [[top, node, item], true];
    }
    return _super.prototype.checkItem.apply(this, arguments);
  };
  return FnItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.FnItem = FnItem;
var NotItem = (function (_super) {
  __extends$1f(NotItem, _super);
  function NotItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.remap = MapHandler_js_1$1.MapHandler.getMap('not_remap');
    return _this;
  }
  Object.defineProperty(NotItem.prototype, "kind", {
    get: function () {
      return 'not';
    },
    enumerable: false,
    configurable: true
  });
  NotItem.prototype.checkItem = function (item) {
    var mml;
    var c;
    var textNode;
    if (item.isKind('open') || item.isKind('left')) {
      return StackItem_js_1$4.BaseItem.success;
    }
    if (item.isKind('mml') && (NodeUtil_js_1$c.default.isType(item.First, 'mo') || NodeUtil_js_1$c.default.isType(item.First, 'mi') || NodeUtil_js_1$c.default.isType(item.First, 'mtext'))) {
      mml = item.First;
      c = NodeUtil_js_1$c.default.getText(mml);
      if (c.length === 1 && !NodeUtil_js_1$c.default.getProperty(mml, 'movesupsub') && NodeUtil_js_1$c.default.getChildren(mml).length === 1) {
        if (this.remap.contains(c)) {
          textNode = this.create('text', this.remap.lookup(c).char);
          NodeUtil_js_1$c.default.setChild(mml, 0, textNode);
        } else {
          textNode = this.create('text', '\u0338');
          NodeUtil_js_1$c.default.appendChildren(mml, [textNode]);
        }
        return [[item], true];
      }
    }
    textNode = this.create('text', '\u29F8');
    var mtextNode = this.create('node', 'mtext', [], {}, textNode);
    var paddedNode = this.create('node', 'mpadded', [mtextNode], {
      width: 0
    });
    mml = this.create('node', 'TeXAtom', [paddedNode], {
      texClass: MmlNode_js_1$f.TEXCLASS.REL
    });
    return [[mml, item], true];
  };
  return NotItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.NotItem = NotItem;
var NonscriptItem = (function (_super) {
  __extends$1f(NonscriptItem, _super);
  function NonscriptItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(NonscriptItem.prototype, "kind", {
    get: function () {
      return 'nonscript';
    },
    enumerable: false,
    configurable: true
  });
  NonscriptItem.prototype.checkItem = function (item) {
    if (item.isKind('mml') && item.Size() === 1) {
      var mml = item.First;
      if (mml.isKind('mstyle') && mml.notParent) {
        mml = NodeUtil_js_1$c.default.getChildren(NodeUtil_js_1$c.default.getChildren(mml)[0])[0];
      }
      if (mml.isKind('mspace')) {
        if (mml !== item.First) {
          var mrow = this.create('node', 'mrow', [item.Pop()]);
          item.Push(mrow);
        }
        this.factory.configuration.addNode('nonscript', item.First);
      }
    }
    return [[item], true];
  };
  return NonscriptItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.NonscriptItem = NonscriptItem;
var DotsItem = (function (_super) {
  __extends$1f(DotsItem, _super);
  function DotsItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(DotsItem.prototype, "kind", {
    get: function () {
      return 'dots';
    },
    enumerable: false,
    configurable: true
  });
  DotsItem.prototype.checkItem = function (item) {
    if (item.isKind('open') || item.isKind('left')) {
      return StackItem_js_1$4.BaseItem.success;
    }
    var dots = this.getProperty('ldots');
    var top = item.First;
    if (item.isKind('mml') && NodeUtil_js_1$c.default.isEmbellished(top)) {
      var tclass = NodeUtil_js_1$c.default.getTexClass(NodeUtil_js_1$c.default.getCoreMO(top));
      if (tclass === MmlNode_js_1$f.TEXCLASS.BIN || tclass === MmlNode_js_1$f.TEXCLASS.REL) {
        dots = this.getProperty('cdots');
      }
    }
    return [[dots, item], true];
  };
  return DotsItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.DotsItem = DotsItem;
var ArrayItem = (function (_super) {
  __extends$1f(ArrayItem, _super);
  function ArrayItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.table = [];
    _this.row = [];
    _this.frame = [];
    _this.hfill = [];
    _this.arraydef = {};
    _this.dashed = false;
    return _this;
  }
  Object.defineProperty(ArrayItem.prototype, "kind", {
    get: function () {
      return 'array';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ArrayItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ArrayItem.prototype, "copyEnv", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  ArrayItem.prototype.checkItem = function (item) {
    if (item.isClose && !item.isKind('over')) {
      if (item.getProperty('isEntry')) {
        this.EndEntry();
        this.clearEnv();
        return StackItem_js_1$4.BaseItem.fail;
      }
      if (item.getProperty('isCR')) {
        this.EndEntry();
        this.EndRow();
        this.clearEnv();
        return StackItem_js_1$4.BaseItem.fail;
      }
      this.EndTable();
      this.clearEnv();
      var newItem = this.factory.create('mml', this.createMml());
      if (this.getProperty('requireClose')) {
        if (item.isKind('close')) {
          return [[newItem], true];
        }
        throw new TexError_js_1$h.default('MissingCloseBrace', 'Missing close brace');
      }
      return [[newItem, item], true];
    }
    return _super.prototype.checkItem.call(this, item);
  };
  ArrayItem.prototype.createMml = function () {
    var scriptlevel = this.arraydef['scriptlevel'];
    delete this.arraydef['scriptlevel'];
    var mml = this.create('node', 'mtable', this.table, this.arraydef);
    if (scriptlevel) {
      mml.setProperty('scriptlevel', scriptlevel);
    }
    if (this.frame.length === 4) {
      NodeUtil_js_1$c.default.setAttribute(mml, 'frame', this.dashed ? 'dashed' : 'solid');
    } else if (this.frame.length) {
      if (this.arraydef['rowlines']) {
        this.arraydef['rowlines'] = this.arraydef['rowlines'].replace(/none( none)+$/, 'none');
      }
      NodeUtil_js_1$c.default.setAttribute(mml, 'frame', '');
      mml = this.create('node', 'menclose', [mml], {
        notation: this.frame.join(' ')
      });
      if ((this.arraydef['columnlines'] || 'none') !== 'none' || (this.arraydef['rowlines'] || 'none') !== 'none') {
        NodeUtil_js_1$c.default.setAttribute(mml, 'data-padding', 0);
      }
    }
    if (this.getProperty('open') || this.getProperty('close')) {
      mml = ParseUtil_js_1$e.default.fenced(this.factory.configuration, this.getProperty('open'), mml, this.getProperty('close'));
    }
    return mml;
  };
  ArrayItem.prototype.EndEntry = function () {
    var mtd = this.create('node', 'mtd', this.nodes);
    if (this.hfill.length) {
      if (this.hfill[0] === 0) {
        NodeUtil_js_1$c.default.setAttribute(mtd, 'columnalign', 'right');
      }
      if (this.hfill[this.hfill.length - 1] === this.Size()) {
        NodeUtil_js_1$c.default.setAttribute(mtd, 'columnalign', NodeUtil_js_1$c.default.getAttribute(mtd, 'columnalign') ? 'center' : 'left');
      }
    }
    this.row.push(mtd);
    this.Clear();
    this.hfill = [];
  };
  ArrayItem.prototype.EndRow = function () {
    var node;
    if (this.getProperty('isNumbered') && this.row.length === 3) {
      this.row.unshift(this.row.pop());
      node = this.create('node', 'mlabeledtr', this.row);
    } else {
      node = this.create('node', 'mtr', this.row);
    }
    this.table.push(node);
    this.row = [];
  };
  ArrayItem.prototype.EndTable = function () {
    if (this.Size() || this.row.length) {
      this.EndEntry();
      this.EndRow();
    }
    this.checkLines();
  };
  ArrayItem.prototype.checkLines = function () {
    if (this.arraydef['rowlines']) {
      var lines = this.arraydef['rowlines'].split(/ /);
      if (lines.length === this.table.length) {
        this.frame.push('bottom');
        lines.pop();
        this.arraydef['rowlines'] = lines.join(' ');
      } else if (lines.length < this.table.length - 1) {
        this.arraydef['rowlines'] += ' none';
      }
    }
    if (this.getProperty('rowspacing')) {
      var rows = this.arraydef['rowspacing'].split(/ /);
      while (rows.length < this.table.length) {
        rows.push(this.getProperty('rowspacing') + 'em');
      }
      this.arraydef['rowspacing'] = rows.join(' ');
    }
  };
  ArrayItem.prototype.addRowSpacing = function (spacing) {
    if (this.arraydef['rowspacing']) {
      var rows = this.arraydef['rowspacing'].split(/ /);
      if (!this.getProperty('rowspacing')) {
        var dimem = ParseUtil_js_1$e.default.dimen2em(rows[0]);
        this.setProperty('rowspacing', dimem);
      }
      var rowspacing = this.getProperty('rowspacing');
      while (rows.length < this.table.length) {
        rows.push(ParseUtil_js_1$e.default.Em(rowspacing));
      }
      rows[this.table.length - 1] = ParseUtil_js_1$e.default.Em(Math.max(0, rowspacing + ParseUtil_js_1$e.default.dimen2em(spacing)));
      this.arraydef['rowspacing'] = rows.join(' ');
    }
  };
  return ArrayItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.ArrayItem = ArrayItem;
var EqnArrayItem = (function (_super) {
  __extends$1f(EqnArrayItem, _super);
  function EqnArrayItem(factory) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var _this = _super.call(this, factory) || this;
    _this.maxrow = 0;
    _this.factory.configuration.tags.start(args[0], args[2], args[1]);
    return _this;
  }
  Object.defineProperty(EqnArrayItem.prototype, "kind", {
    get: function () {
      return 'eqnarray';
    },
    enumerable: false,
    configurable: true
  });
  EqnArrayItem.prototype.EndEntry = function () {
    if (this.row.length) {
      ParseUtil_js_1$e.default.fixInitialMO(this.factory.configuration, this.nodes);
    }
    var node = this.create('node', 'mtd', this.nodes);
    this.row.push(node);
    this.Clear();
  };
  EqnArrayItem.prototype.EndRow = function () {
    if (this.row.length > this.maxrow) {
      this.maxrow = this.row.length;
    }
    var mtr = 'mtr';
    var tag = this.factory.configuration.tags.getTag();
    if (tag) {
      this.row = [tag].concat(this.row);
      mtr = 'mlabeledtr';
    }
    this.factory.configuration.tags.clearTag();
    var node = this.create('node', mtr, this.row);
    this.table.push(node);
    this.row = [];
  };
  EqnArrayItem.prototype.EndTable = function () {
    _super.prototype.EndTable.call(this);
    this.factory.configuration.tags.end();
    this.extendArray('columnalign', this.maxrow);
    this.extendArray('columnwidth', this.maxrow);
    this.extendArray('columnspacing', this.maxrow - 1);
  };
  EqnArrayItem.prototype.extendArray = function (name, max) {
    if (!this.arraydef[name]) return;
    var repeat = this.arraydef[name].split(/ /);
    var columns = __spreadArray$k([], __read$E(repeat), false);
    if (columns.length > 1) {
      while (columns.length < max) {
        columns.push.apply(columns, __spreadArray$k([], __read$E(repeat), false));
      }
      this.arraydef[name] = columns.slice(0, max).join(' ');
    }
  };
  return EqnArrayItem;
})(ArrayItem);
BaseItems.EqnArrayItem = EqnArrayItem;
var EquationItem = (function (_super) {
  __extends$1f(EquationItem, _super);
  function EquationItem(factory) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var _this = _super.call(this, factory) || this;
    _this.factory.configuration.tags.start('equation', true, args[0]);
    return _this;
  }
  Object.defineProperty(EquationItem.prototype, "kind", {
    get: function () {
      return 'equation';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EquationItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  EquationItem.prototype.checkItem = function (item) {
    if (item.isKind('end')) {
      var mml = this.toMml();
      var tag = this.factory.configuration.tags.getTag();
      this.factory.configuration.tags.end();
      return [[tag ? this.factory.configuration.tags.enTag(mml, tag) : mml, item], true];
    }
    if (item.isKind('stop')) {
      throw new TexError_js_1$h.default('EnvMissingEnd', 'Missing \\end{%1}', this.getName());
    }
    return _super.prototype.checkItem.call(this, item);
  };
  return EquationItem;
})(StackItem_js_1$4.BaseItem);
BaseItems.EquationItem = EquationItem;

var TexConstants = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TexConstant = void 0;
  (function (TexConstant) {
    TexConstant.Variant = {
      NORMAL: 'normal',
      BOLD: 'bold',
      ITALIC: 'italic',
      BOLDITALIC: 'bold-italic',
      DOUBLESTRUCK: 'double-struck',
      FRAKTUR: 'fraktur',
      BOLDFRAKTUR: 'bold-fraktur',
      SCRIPT: 'script',
      BOLDSCRIPT: 'bold-script',
      SANSSERIF: 'sans-serif',
      BOLDSANSSERIF: 'bold-sans-serif',
      SANSSERIFITALIC: 'sans-serif-italic',
      SANSSERIFBOLDITALIC: 'sans-serif-bold-italic',
      MONOSPACE: 'monospace',
      INITIAL: 'inital',
      TAILED: 'tailed',
      LOOPED: 'looped',
      STRETCHED: 'stretched',
      CALLIGRAPHIC: '-tex-calligraphic',
      BOLDCALLIGRAPHIC: '-tex-bold-calligraphic',
      OLDSTYLE: '-tex-oldstyle',
      BOLDOLDSTYLE: '-tex-bold-oldstyle',
      MATHITALIC: '-tex-mathit'
    };
    TexConstant.Form = {
      PREFIX: 'prefix',
      INFIX: 'infix',
      POSTFIX: 'postfix'
    };
    TexConstant.LineBreak = {
      AUTO: 'auto',
      NEWLINE: 'newline',
      NOBREAK: 'nobreak',
      GOODBREAK: 'goodbreak',
      BADBREAK: 'badbreak'
    };
    TexConstant.LineBreakStyle = {
      BEFORE: 'before',
      AFTER: 'after',
      DUPLICATE: 'duplicate',
      INFIXLINBREAKSTYLE: 'infixlinebreakstyle'
    };
    TexConstant.IndentAlign = {
      LEFT: 'left',
      CENTER: 'center',
      RIGHT: 'right',
      AUTO: 'auto',
      ID: 'id',
      INDENTALIGN: 'indentalign'
    };
    TexConstant.IndentShift = {
      INDENTSHIFT: 'indentshift'
    };
    TexConstant.LineThickness = {
      THIN: 'thin',
      MEDIUM: 'medium',
      THICK: 'thick'
    };
    TexConstant.Notation = {
      LONGDIV: 'longdiv',
      ACTUARIAL: 'actuarial',
      PHASORANGLE: 'phasorangle',
      RADICAL: 'radical',
      BOX: 'box',
      ROUNDEDBOX: 'roundedbox',
      CIRCLE: 'circle',
      LEFT: 'left',
      RIGHT: 'right',
      TOP: 'top',
      BOTTOM: 'bottom',
      UPDIAGONALSTRIKE: 'updiagonalstrike',
      DOWNDIAGONALSTRIKE: 'downdiagonalstrike',
      VERTICALSTRIKE: 'verticalstrike',
      HORIZONTALSTRIKE: 'horizontalstrike',
      NORTHEASTARROW: 'northeastarrow',
      MADRUWB: 'madruwb',
      UPDIAGONALARROW: 'updiagonalarrow'
    };
    TexConstant.Align = {
      TOP: 'top',
      BOTTOM: 'bottom',
      CENTER: 'center',
      BASELINE: 'baseline',
      AXIS: 'axis',
      LEFT: 'left',
      RIGHT: 'right'
    };
    TexConstant.Lines = {
      NONE: 'none',
      SOLID: 'solid',
      DASHED: 'dashed'
    };
    TexConstant.Side = {
      LEFT: 'left',
      RIGHT: 'right',
      LEFTOVERLAP: 'leftoverlap',
      RIGHTOVERLAP: 'rightoverlap'
    };
    TexConstant.Width = {
      AUTO: 'auto',
      FIT: 'fit'
    };
    TexConstant.Actiontype = {
      TOGGLE: 'toggle',
      STATUSLINE: 'statusline',
      TOOLTIP: 'tooltip',
      INPUT: 'input'
    };
    TexConstant.Overflow = {
      LINBREAK: 'linebreak',
      SCROLL: 'scroll',
      ELIDE: 'elide',
      TRUNCATE: 'truncate',
      SCALE: 'scale'
    };
    TexConstant.Unit = {
      EM: 'em',
      EX: 'ex',
      PX: 'px',
      IN: 'in',
      CM: 'cm',
      MM: 'mm',
      PT: 'pt',
      PC: 'pc'
    };
  })(exports.TexConstant || (exports.TexConstant = {}));
})(TexConstants);
getDefaultExportFromCjs(TexConstants);

var BaseMethods$1 = {};

var lengths = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.px = exports.emRounded = exports.em = exports.percent = exports.length2em = exports.MATHSPACE = exports.RELUNITS = exports.UNITS = exports.BIGDIMEN = void 0;
  exports.BIGDIMEN = 1000000;
  exports.UNITS = {
    px: 1,
    'in': 96,
    cm: 96 / 2.54,
    mm: 96 / 25.4
  };
  exports.RELUNITS = {
    em: 1,
    ex: .431,
    pt: 1 / 10,
    pc: 12 / 10,
    mu: 1 / 18
  };
  exports.MATHSPACE = {
    veryverythinmathspace: 1 / 18,
    verythinmathspace: 2 / 18,
    thinmathspace: 3 / 18,
    mediummathspace: 4 / 18,
    thickmathspace: 5 / 18,
    verythickmathspace: 6 / 18,
    veryverythickmathspace: 7 / 18,
    negativeveryverythinmathspace: -1 / 18,
    negativeverythinmathspace: -2 / 18,
    negativethinmathspace: -3 / 18,
    negativemediummathspace: -4 / 18,
    negativethickmathspace: -5 / 18,
    negativeverythickmathspace: -6 / 18,
    negativeveryverythickmathspace: -7 / 18,
    thin: .04,
    medium: .06,
    thick: .1,
    normal: 1,
    big: 2,
    small: 1 / Math.sqrt(2),
    infinity: exports.BIGDIMEN
  };
  function length2em(length, size, scale, em) {
    if (size === void 0) {
      size = 0;
    }
    if (scale === void 0) {
      scale = 1;
    }
    if (em === void 0) {
      em = 16;
    }
    if (typeof length !== 'string') {
      length = String(length);
    }
    if (length === '' || length == null) {
      return size;
    }
    if (exports.MATHSPACE[length]) {
      return exports.MATHSPACE[length];
    }
    var match = length.match(/^\s*([-+]?(?:\.\d+|\d+(?:\.\d*)?))?(pt|em|ex|mu|px|pc|in|mm|cm|%)?/);
    if (!match) {
      return size;
    }
    var m = parseFloat(match[1] || '1'), unit = match[2];
    if (exports.UNITS.hasOwnProperty(unit)) {
      return m * exports.UNITS[unit] / em / scale;
    }
    if (exports.RELUNITS.hasOwnProperty(unit)) {
      return m * exports.RELUNITS[unit];
    }
    if (unit === '%') {
      return m / 100 * size;
    }
    return m * size;
  }
  exports.length2em = length2em;
  function percent(m) {
    return (100 * m).toFixed(1).replace(/\.?0+$/, '') + '%';
  }
  exports.percent = percent;
  function em(m) {
    if (Math.abs(m) < .001) return '0';
    return m.toFixed(3).replace(/\.?0+$/, '') + 'em';
  }
  exports.em = em;
  function emRounded(m, em) {
    if (em === void 0) {
      em = 16;
    }
    m = (Math.round(m * em) + .05) / em;
    if (Math.abs(m) < .001) return '0em';
    return m.toFixed(3).replace(/\.?0+$/, '') + 'em';
  }
  exports.emRounded = emRounded;
  function px(m, M, em) {
    if (M === void 0) {
      M = -exports.BIGDIMEN;
    }
    if (em === void 0) {
      em = 16;
    }
    m *= em;
    if (M && m < M) m = M;
    if (Math.abs(m) < .1) return '0';
    return m.toFixed(1).replace(/\.0$/, '') + 'px';
  }
  exports.px = px;
})(lengths);
getDefaultExportFromCjs(lengths);

var __assign$a = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$a = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$a.apply(this, arguments);
});
var __createBinding$c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$c = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$c = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$c(result, mod, k);
  __setModuleDefault$c(result, mod);
  return result;
});
var __read$D = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __importDefault$B = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(BaseMethods$1, "__esModule", {
  value: true
});
var sitem = __importStar$c(BaseItems);
var NodeUtil_js_1$b = __importDefault$B(NodeUtil$1);
var TexError_js_1$g = __importDefault$B(TexError$1);
var TexParser_js_1$9 = __importDefault$B(TexParser$1);
var TexConstants_js_1$b = TexConstants;
var ParseUtil_js_1$d = __importDefault$B(ParseUtil$1);
var MmlNode_js_1$e = MmlNode;
var Tags_js_1$6 = Tags;
var lengths_js_1$6 = lengths;
var Entities_js_1 = Entities$1;
var Options_js_1$8 = Options;
var BaseMethods = {};
var P_HEIGHT = 1.2 / .85;
var MmlTokenAllow = {
  fontfamily: 1,
  fontsize: 1,
  fontweight: 1,
  fontstyle: 1,
  color: 1,
  background: 1,
  id: 1,
  'class': 1,
  href: 1,
  style: 1
};
BaseMethods.Open = function (parser, _c) {
  parser.Push(parser.itemFactory.create('open'));
};
BaseMethods.Close = function (parser, _c) {
  parser.Push(parser.itemFactory.create('close'));
};
BaseMethods.Tilde = function (parser, _c) {
  parser.Push(parser.create('token', 'mtext', {}, Entities_js_1.entities.nbsp));
};
BaseMethods.Space = function (_parser, _c) {};
BaseMethods.Superscript = function (parser, _c) {
  var _a;
  if (parser.GetNext().match(/\d/)) {
    parser.string = parser.string.substr(0, parser.i + 1) + ' ' + parser.string.substr(parser.i + 1);
  }
  var primes;
  var base;
  var top = parser.stack.Top();
  if (top.isKind('prime')) {
    (_a = __read$D(top.Peek(2), 2), base = _a[0], primes = _a[1]);
    parser.stack.Pop();
  } else {
    base = parser.stack.Prev();
    if (!base) {
      base = parser.create('token', 'mi', {}, '');
    }
  }
  var movesupsub = NodeUtil_js_1$b.default.getProperty(base, 'movesupsub');
  var position = NodeUtil_js_1$b.default.isType(base, 'msubsup') ? base.sup : base.over;
  if (NodeUtil_js_1$b.default.isType(base, 'msubsup') && !NodeUtil_js_1$b.default.isType(base, 'msup') && NodeUtil_js_1$b.default.getChildAt(base, base.sup) || NodeUtil_js_1$b.default.isType(base, 'munderover') && !NodeUtil_js_1$b.default.isType(base, 'mover') && NodeUtil_js_1$b.default.getChildAt(base, base.over) && !NodeUtil_js_1$b.default.getProperty(base, 'subsupOK')) {
    throw new TexError_js_1$g.default('DoubleExponent', 'Double exponent: use braces to clarify');
  }
  if (!NodeUtil_js_1$b.default.isType(base, 'msubsup') || NodeUtil_js_1$b.default.isType(base, 'msup')) {
    if (movesupsub) {
      if (!NodeUtil_js_1$b.default.isType(base, 'munderover') || NodeUtil_js_1$b.default.isType(base, 'mover') || NodeUtil_js_1$b.default.getChildAt(base, base.over)) {
        base = parser.create('node', 'munderover', [base], {
          movesupsub: true
        });
      }
      position = base.over;
    } else {
      base = parser.create('node', 'msubsup', [base]);
      position = base.sup;
    }
  }
  parser.Push(parser.itemFactory.create('subsup', base).setProperties({
    position: position,
    primes: primes,
    movesupsub: movesupsub
  }));
};
BaseMethods.Subscript = function (parser, _c) {
  var _a;
  if (parser.GetNext().match(/\d/)) {
    parser.string = parser.string.substr(0, parser.i + 1) + ' ' + parser.string.substr(parser.i + 1);
  }
  var primes, base;
  var top = parser.stack.Top();
  if (top.isKind('prime')) {
    (_a = __read$D(top.Peek(2), 2), base = _a[0], primes = _a[1]);
    parser.stack.Pop();
  } else {
    base = parser.stack.Prev();
    if (!base) {
      base = parser.create('token', 'mi', {}, '');
    }
  }
  var movesupsub = NodeUtil_js_1$b.default.getProperty(base, 'movesupsub');
  var position = NodeUtil_js_1$b.default.isType(base, 'msubsup') ? base.sub : base.under;
  if (NodeUtil_js_1$b.default.isType(base, 'msubsup') && !NodeUtil_js_1$b.default.isType(base, 'msup') && NodeUtil_js_1$b.default.getChildAt(base, base.sub) || NodeUtil_js_1$b.default.isType(base, 'munderover') && !NodeUtil_js_1$b.default.isType(base, 'mover') && NodeUtil_js_1$b.default.getChildAt(base, base.under) && !NodeUtil_js_1$b.default.getProperty(base, 'subsupOK')) {
    throw new TexError_js_1$g.default('DoubleSubscripts', 'Double subscripts: use braces to clarify');
  }
  if (!NodeUtil_js_1$b.default.isType(base, 'msubsup') || NodeUtil_js_1$b.default.isType(base, 'msup')) {
    if (movesupsub) {
      if (!NodeUtil_js_1$b.default.isType(base, 'munderover') || NodeUtil_js_1$b.default.isType(base, 'mover') || NodeUtil_js_1$b.default.getChildAt(base, base.under)) {
        base = parser.create('node', 'munderover', [base], {
          movesupsub: true
        });
      }
      position = base.under;
    } else {
      base = parser.create('node', 'msubsup', [base]);
      position = base.sub;
    }
  }
  parser.Push(parser.itemFactory.create('subsup', base).setProperties({
    position: position,
    primes: primes,
    movesupsub: movesupsub
  }));
};
BaseMethods.Prime = function (parser, c) {
  var base = parser.stack.Prev();
  if (!base) {
    base = parser.create('node', 'mi');
  }
  if (NodeUtil_js_1$b.default.isType(base, 'msubsup') && !NodeUtil_js_1$b.default.isType(base, 'msup') && NodeUtil_js_1$b.default.getChildAt(base, base.sup)) {
    throw new TexError_js_1$g.default('DoubleExponentPrime', 'Prime causes double exponent: use braces to clarify');
  }
  var sup = '';
  parser.i--;
  do {
    sup += Entities_js_1.entities.prime;
    (parser.i++, c = parser.GetNext());
  } while (c === '\'' || c === Entities_js_1.entities.rsquo);
  sup = ['', '\u2032', '\u2033', '\u2034', '\u2057'][sup.length] || sup;
  var node = parser.create('token', 'mo', {
    variantForm: true
  }, sup);
  parser.Push(parser.itemFactory.create('prime', base, node));
};
BaseMethods.Comment = function (parser, _c) {
  while (parser.i < parser.string.length && parser.string.charAt(parser.i) !== '\n') {
    parser.i++;
  }
};
BaseMethods.Hash = function (_parser, _c) {
  throw new TexError_js_1$g.default('CantUseHash1', 'You can\'t use \'macro parameter character #\' in math mode');
};
BaseMethods.MathFont = function (parser, name, variant) {
  var text = parser.GetArgument(name);
  var mml = new TexParser_js_1$9.default(text, __assign$a(__assign$a({}, parser.stack.env), {
    font: variant,
    multiLetterIdentifiers: /^[a-zA-Z]+/,
    noAutoOP: true
  }), parser.configuration).mml();
  parser.Push(parser.create('node', 'TeXAtom', [mml]));
};
BaseMethods.SetFont = function (parser, _name, font) {
  parser.stack.env['font'] = font;
};
BaseMethods.SetStyle = function (parser, _name, texStyle, style, level) {
  parser.stack.env['style'] = texStyle;
  parser.stack.env['level'] = level;
  parser.Push(parser.itemFactory.create('style').setProperty('styles', {
    displaystyle: style,
    scriptlevel: level
  }));
};
BaseMethods.SetSize = function (parser, _name, size) {
  parser.stack.env['size'] = size;
  parser.Push(parser.itemFactory.create('style').setProperty('styles', {
    mathsize: (0, lengths_js_1$6.em)(size)
  }));
};
BaseMethods.Spacer = function (parser, _name, space) {
  var node = parser.create('node', 'mspace', [], {
    width: (0, lengths_js_1$6.em)(space)
  });
  var style = parser.create('node', 'mstyle', [node], {
    scriptlevel: 0
  });
  parser.Push(style);
};
BaseMethods.LeftRight = function (parser, name) {
  var first = name.substr(1);
  parser.Push(parser.itemFactory.create(first, parser.GetDelimiter(name), parser.stack.env.color));
};
BaseMethods.NamedFn = function (parser, name, id) {
  if (!id) {
    id = name.substr(1);
  }
  var mml = parser.create('token', 'mi', {
    texClass: MmlNode_js_1$e.TEXCLASS.OP
  }, id);
  parser.Push(parser.itemFactory.create('fn', mml));
};
BaseMethods.NamedOp = function (parser, name, id) {
  if (!id) {
    id = name.substr(1);
  }
  id = id.replace(/&thinsp;/, '\u2006');
  var mml = parser.create('token', 'mo', {
    movablelimits: true,
    movesupsub: true,
    form: TexConstants_js_1$b.TexConstant.Form.PREFIX,
    texClass: MmlNode_js_1$e.TEXCLASS.OP
  }, id);
  parser.Push(mml);
};
BaseMethods.Limits = function (parser, _name, limits) {
  var op = parser.stack.Prev(true);
  if (!op || NodeUtil_js_1$b.default.getTexClass(NodeUtil_js_1$b.default.getCoreMO(op)) !== MmlNode_js_1$e.TEXCLASS.OP && NodeUtil_js_1$b.default.getProperty(op, 'movesupsub') == null) {
    throw new TexError_js_1$g.default('MisplacedLimits', '%1 is allowed only on operators', parser.currentCS);
  }
  var top = parser.stack.Top();
  var node;
  if (NodeUtil_js_1$b.default.isType(op, 'munderover') && !limits) {
    node = parser.create('node', 'msubsup');
    NodeUtil_js_1$b.default.copyChildren(op, node);
    op = top.Last = node;
  } else if (NodeUtil_js_1$b.default.isType(op, 'msubsup') && limits) {
    node = parser.create('node', 'munderover');
    NodeUtil_js_1$b.default.copyChildren(op, node);
    op = top.Last = node;
  }
  NodeUtil_js_1$b.default.setProperty(op, 'movesupsub', limits ? true : false);
  NodeUtil_js_1$b.default.setProperties(NodeUtil_js_1$b.default.getCoreMO(op), {
    'movablelimits': false
  });
  if (NodeUtil_js_1$b.default.getAttribute(op, 'movablelimits') || NodeUtil_js_1$b.default.getProperty(op, 'movablelimits')) {
    NodeUtil_js_1$b.default.setProperties(op, {
      'movablelimits': false
    });
  }
};
BaseMethods.Over = function (parser, name, open, close) {
  var mml = parser.itemFactory.create('over').setProperty('name', parser.currentCS);
  if (open || close) {
    mml.setProperty('open', open);
    mml.setProperty('close', close);
  } else if (name.match(/withdelims$/)) {
    mml.setProperty('open', parser.GetDelimiter(name));
    mml.setProperty('close', parser.GetDelimiter(name));
  }
  if (name.match(/^\\above/)) {
    mml.setProperty('thickness', parser.GetDimen(name));
  } else if (name.match(/^\\atop/) || open || close) {
    mml.setProperty('thickness', 0);
  }
  parser.Push(mml);
};
BaseMethods.Frac = function (parser, name) {
  var num = parser.ParseArg(name);
  var den = parser.ParseArg(name);
  var node = parser.create('node', 'mfrac', [num, den]);
  parser.Push(node);
};
BaseMethods.Sqrt = function (parser, name) {
  var n = parser.GetBrackets(name);
  var arg = parser.GetArgument(name);
  if (arg === '\\frac') {
    arg += '{' + parser.GetArgument(arg) + '}{' + parser.GetArgument(arg) + '}';
  }
  var mml = new TexParser_js_1$9.default(arg, parser.stack.env, parser.configuration).mml();
  if (!n) {
    mml = parser.create('node', 'msqrt', [mml]);
  } else {
    mml = parser.create('node', 'mroot', [mml, parseRoot(parser, n)]);
  }
  parser.Push(mml);
};
function parseRoot(parser, n) {
  var env = parser.stack.env;
  var inRoot = env['inRoot'];
  env['inRoot'] = true;
  var newParser = new TexParser_js_1$9.default(n, env, parser.configuration);
  var node = newParser.mml();
  var global = newParser.stack.global;
  if (global['leftRoot'] || global['upRoot']) {
    var def = {};
    if (global['leftRoot']) {
      def['width'] = global['leftRoot'];
    }
    if (global['upRoot']) {
      def['voffset'] = global['upRoot'];
      def['height'] = global['upRoot'];
    }
    node = parser.create('node', 'mpadded', [node], def);
  }
  env['inRoot'] = inRoot;
  return node;
}
BaseMethods.Root = function (parser, name) {
  var n = parser.GetUpTo(name, '\\of');
  var arg = parser.ParseArg(name);
  var node = parser.create('node', 'mroot', [arg, parseRoot(parser, n)]);
  parser.Push(node);
};
BaseMethods.MoveRoot = function (parser, name, id) {
  if (!parser.stack.env['inRoot']) {
    throw new TexError_js_1$g.default('MisplacedMoveRoot', '%1 can appear only within a root', parser.currentCS);
  }
  if (parser.stack.global[id]) {
    throw new TexError_js_1$g.default('MultipleMoveRoot', 'Multiple use of %1', parser.currentCS);
  }
  var n = parser.GetArgument(name);
  if (!n.match(/-?[0-9]+/)) {
    throw new TexError_js_1$g.default('IntegerArg', 'The argument to %1 must be an integer', parser.currentCS);
  }
  n = parseInt(n, 10) / 15 + 'em';
  if (n.substr(0, 1) !== '-') {
    n = '+' + n;
  }
  parser.stack.global[id] = n;
};
BaseMethods.Accent = function (parser, name, accent, stretchy) {
  var c = parser.ParseArg(name);
  var def = __assign$a(__assign$a({}, ParseUtil_js_1$d.default.getFontDef(parser)), {
    accent: true,
    mathaccent: true
  });
  var entity = NodeUtil_js_1$b.default.createEntity(accent);
  var moNode = parser.create('token', 'mo', def, entity);
  var mml = moNode;
  NodeUtil_js_1$b.default.setAttribute(mml, 'stretchy', stretchy ? true : false);
  var mo = NodeUtil_js_1$b.default.isEmbellished(c) ? NodeUtil_js_1$b.default.getCoreMO(c) : c;
  if (NodeUtil_js_1$b.default.isType(mo, 'mo') || NodeUtil_js_1$b.default.getProperty(mo, 'movablelimits')) {
    NodeUtil_js_1$b.default.setProperties(mo, {
      'movablelimits': false
    });
  }
  var muoNode = parser.create('node', 'munderover');
  NodeUtil_js_1$b.default.setChild(muoNode, 0, c);
  NodeUtil_js_1$b.default.setChild(muoNode, 1, null);
  NodeUtil_js_1$b.default.setChild(muoNode, 2, mml);
  var texAtom = parser.create('node', 'TeXAtom', [muoNode]);
  parser.Push(texAtom);
};
BaseMethods.UnderOver = function (parser, name, c, stack) {
  var entity = NodeUtil_js_1$b.default.createEntity(c);
  var mo = parser.create('token', 'mo', {
    stretchy: true,
    accent: true
  }, entity);
  var pos = name.charAt(1) === 'o' ? 'over' : 'under';
  var base = parser.ParseArg(name);
  parser.Push(ParseUtil_js_1$d.default.underOver(parser, base, mo, pos, stack));
};
BaseMethods.Overset = function (parser, name) {
  var top = parser.ParseArg(name);
  var base = parser.ParseArg(name);
  ParseUtil_js_1$d.default.checkMovableLimits(base);
  if (top.isKind('mo')) {
    NodeUtil_js_1$b.default.setAttribute(top, 'accent', false);
  }
  var node = parser.create('node', 'mover', [base, top]);
  parser.Push(node);
};
BaseMethods.Underset = function (parser, name) {
  var bot = parser.ParseArg(name);
  var base = parser.ParseArg(name);
  ParseUtil_js_1$d.default.checkMovableLimits(base);
  if (bot.isKind('mo')) {
    NodeUtil_js_1$b.default.setAttribute(bot, 'accent', false);
  }
  var node = parser.create('node', 'munder', [base, bot], {
    accentunder: false
  });
  parser.Push(node);
};
BaseMethods.Overunderset = function (parser, name) {
  var top = parser.ParseArg(name);
  var bot = parser.ParseArg(name);
  var base = parser.ParseArg(name);
  ParseUtil_js_1$d.default.checkMovableLimits(base);
  if (top.isKind('mo')) {
    NodeUtil_js_1$b.default.setAttribute(top, 'accent', false);
  }
  if (bot.isKind('mo')) {
    NodeUtil_js_1$b.default.setAttribute(bot, 'accent', false);
  }
  var node = parser.create('node', 'munderover', [base, bot, top], {
    accent: false,
    accentunder: false
  });
  parser.Push(node);
};
BaseMethods.TeXAtom = function (parser, name, mclass) {
  var def = {
    texClass: mclass
  };
  var mml;
  var node;
  var parsed;
  if (mclass === MmlNode_js_1$e.TEXCLASS.OP) {
    def['movesupsub'] = def['movablelimits'] = true;
    var arg = parser.GetArgument(name);
    var match = arg.match(/^\s*\\rm\s+([a-zA-Z0-9 ]+)$/);
    if (match) {
      def['mathvariant'] = TexConstants_js_1$b.TexConstant.Variant.NORMAL;
      node = parser.create('token', 'mi', def, match[1]);
    } else {
      parsed = new TexParser_js_1$9.default(arg, parser.stack.env, parser.configuration).mml();
      node = parser.create('node', 'TeXAtom', [parsed], def);
    }
    mml = parser.itemFactory.create('fn', node);
  } else {
    parsed = parser.ParseArg(name);
    mml = parser.create('node', 'TeXAtom', [parsed], def);
  }
  parser.Push(mml);
};
BaseMethods.MmlToken = function (parser, name) {
  var kind = parser.GetArgument(name);
  var attr = parser.GetBrackets(name, '').replace(/^\s+/, '');
  var text = parser.GetArgument(name);
  var def = {};
  var keep = [];
  var node;
  try {
    node = parser.create('node', kind);
  } catch (e) {
    node = null;
  }
  if (!node || !node.isToken) {
    throw new TexError_js_1$g.default('NotMathMLToken', '%1 is not a token element', kind);
  }
  while (attr !== '') {
    var match = attr.match(/^([a-z]+)\s*=\s*('[^']*'|"[^"]*"|[^ ,]*)\s*,?\s*/i);
    if (!match) {
      throw new TexError_js_1$g.default('InvalidMathMLAttr', 'Invalid MathML attribute: %1', attr);
    }
    if (!node.attributes.hasDefault(match[1]) && !MmlTokenAllow[match[1]]) {
      throw new TexError_js_1$g.default('UnknownAttrForElement', '%1 is not a recognized attribute for %2', match[1], kind);
    }
    var value = ParseUtil_js_1$d.default.MmlFilterAttribute(parser, match[1], match[2].replace(/^(['"])(.*)\1$/, '$2'));
    if (value) {
      if (value.toLowerCase() === 'true') {
        value = true;
      } else if (value.toLowerCase() === 'false') {
        value = false;
      }
      def[match[1]] = value;
      keep.push(match[1]);
    }
    attr = attr.substr(match[0].length);
  }
  if (keep.length) {
    def['mjx-keep-attrs'] = keep.join(' ');
  }
  var textNode = parser.create('text', text);
  node.appendChild(textNode);
  NodeUtil_js_1$b.default.setProperties(node, def);
  parser.Push(node);
};
BaseMethods.Strut = function (parser, _name) {
  var row = parser.create('node', 'mrow');
  var padded = parser.create('node', 'mpadded', [row], {
    height: '8.6pt',
    depth: '3pt',
    width: 0
  });
  parser.Push(padded);
};
BaseMethods.Phantom = function (parser, name, v, h) {
  var box = parser.create('node', 'mphantom', [parser.ParseArg(name)]);
  if (v || h) {
    box = parser.create('node', 'mpadded', [box]);
    if (h) {
      NodeUtil_js_1$b.default.setAttribute(box, 'height', 0);
      NodeUtil_js_1$b.default.setAttribute(box, 'depth', 0);
    }
    if (v) {
      NodeUtil_js_1$b.default.setAttribute(box, 'width', 0);
    }
  }
  var atom = parser.create('node', 'TeXAtom', [box]);
  parser.Push(atom);
};
BaseMethods.Smash = function (parser, name) {
  var bt = ParseUtil_js_1$d.default.trimSpaces(parser.GetBrackets(name, ''));
  var smash = parser.create('node', 'mpadded', [parser.ParseArg(name)]);
  switch (bt) {
    case 'b':
      NodeUtil_js_1$b.default.setAttribute(smash, 'depth', 0);
      break;
    case 't':
      NodeUtil_js_1$b.default.setAttribute(smash, 'height', 0);
      break;
    default:
      NodeUtil_js_1$b.default.setAttribute(smash, 'height', 0);
      NodeUtil_js_1$b.default.setAttribute(smash, 'depth', 0);
  }
  var atom = parser.create('node', 'TeXAtom', [smash]);
  parser.Push(atom);
};
BaseMethods.Lap = function (parser, name) {
  var mml = parser.create('node', 'mpadded', [parser.ParseArg(name)], {
    width: 0
  });
  if (name === '\\llap') {
    NodeUtil_js_1$b.default.setAttribute(mml, 'lspace', '-1width');
  }
  var atom = parser.create('node', 'TeXAtom', [mml]);
  parser.Push(atom);
};
BaseMethods.RaiseLower = function (parser, name) {
  var h = parser.GetDimen(name);
  var item = parser.itemFactory.create('position').setProperties({
    name: parser.currentCS,
    move: 'vertical'
  });
  if (h.charAt(0) === '-') {
    h = h.slice(1);
    name = name.substr(1) === 'raise' ? '\\lower' : '\\raise';
  }
  if (name === '\\lower') {
    item.setProperty('dh', '-' + h);
    item.setProperty('dd', '+' + h);
  } else {
    item.setProperty('dh', '+' + h);
    item.setProperty('dd', '-' + h);
  }
  parser.Push(item);
};
BaseMethods.MoveLeftRight = function (parser, name) {
  var h = parser.GetDimen(name);
  var nh = h.charAt(0) === '-' ? h.slice(1) : '-' + h;
  if (name === '\\moveleft') {
    var tmp = h;
    h = nh;
    nh = tmp;
  }
  parser.Push(parser.itemFactory.create('position').setProperties({
    name: parser.currentCS,
    move: 'horizontal',
    left: parser.create('node', 'mspace', [], {
      width: h
    }),
    right: parser.create('node', 'mspace', [], {
      width: nh
    })
  }));
};
BaseMethods.Hskip = function (parser, name) {
  var node = parser.create('node', 'mspace', [], {
    width: parser.GetDimen(name)
  });
  parser.Push(node);
};
BaseMethods.Nonscript = function (parser, _name) {
  parser.Push(parser.itemFactory.create('nonscript'));
};
BaseMethods.Rule = function (parser, name, style) {
  var w = parser.GetDimen(name), h = parser.GetDimen(name), d = parser.GetDimen(name);
  var def = {
    width: w,
    height: h,
    depth: d
  };
  if (style !== 'blank') {
    def['mathbackground'] = parser.stack.env['color'] || 'black';
  }
  var node = parser.create('node', 'mspace', [], def);
  parser.Push(node);
};
BaseMethods.rule = function (parser, name) {
  var v = parser.GetBrackets(name), w = parser.GetDimen(name), h = parser.GetDimen(name);
  var mml = parser.create('node', 'mspace', [], {
    width: w,
    height: h,
    mathbackground: parser.stack.env['color'] || 'black'
  });
  if (v) {
    mml = parser.create('node', 'mpadded', [mml], {
      voffset: v
    });
    if (v.match(/^\-/)) {
      NodeUtil_js_1$b.default.setAttribute(mml, 'height', v);
      NodeUtil_js_1$b.default.setAttribute(mml, 'depth', '+' + v.substr(1));
    } else {
      NodeUtil_js_1$b.default.setAttribute(mml, 'height', '+' + v);
    }
  }
  parser.Push(mml);
};
BaseMethods.MakeBig = function (parser, name, mclass, size) {
  size *= P_HEIGHT;
  var sizeStr = String(size).replace(/(\.\d\d\d).+/, '$1') + 'em';
  var delim = parser.GetDelimiter(name, true);
  var mo = parser.create('token', 'mo', {
    minsize: sizeStr,
    maxsize: sizeStr,
    fence: true,
    stretchy: true,
    symmetric: true
  }, delim);
  var node = parser.create('node', 'TeXAtom', [mo], {
    texClass: mclass
  });
  parser.Push(node);
};
BaseMethods.BuildRel = function (parser, name) {
  var top = parser.ParseUpTo(name, '\\over');
  var bot = parser.ParseArg(name);
  var node = parser.create('node', 'munderover');
  NodeUtil_js_1$b.default.setChild(node, 0, bot);
  NodeUtil_js_1$b.default.setChild(node, 1, null);
  NodeUtil_js_1$b.default.setChild(node, 2, top);
  var atom = parser.create('node', 'TeXAtom', [node], {
    texClass: MmlNode_js_1$e.TEXCLASS.REL
  });
  parser.Push(atom);
};
BaseMethods.HBox = function (parser, name, style, font) {
  parser.PushAll(ParseUtil_js_1$d.default.internalMath(parser, parser.GetArgument(name), style, font));
};
BaseMethods.FBox = function (parser, name) {
  var internal = ParseUtil_js_1$d.default.internalMath(parser, parser.GetArgument(name));
  var node = parser.create('node', 'menclose', internal, {
    notation: 'box'
  });
  parser.Push(node);
};
BaseMethods.FrameBox = function (parser, name) {
  var width = parser.GetBrackets(name);
  var pos = parser.GetBrackets(name) || 'c';
  var mml = ParseUtil_js_1$d.default.internalMath(parser, parser.GetArgument(name));
  if (width) {
    mml = [parser.create('node', 'mpadded', mml, {
      width: width,
      'data-align': (0, Options_js_1$8.lookup)(pos, {
        l: 'left',
        r: 'right'
      }, 'center')
    })];
  }
  var node = parser.create('node', 'TeXAtom', [parser.create('node', 'menclose', mml, {
    notation: 'box'
  })], {
    texClass: MmlNode_js_1$e.TEXCLASS.ORD
  });
  parser.Push(node);
};
BaseMethods.Not = function (parser, _name) {
  parser.Push(parser.itemFactory.create('not'));
};
BaseMethods.Dots = function (parser, _name) {
  var ldotsEntity = NodeUtil_js_1$b.default.createEntity('2026');
  var cdotsEntity = NodeUtil_js_1$b.default.createEntity('22EF');
  var ldots = parser.create('token', 'mo', {
    stretchy: false
  }, ldotsEntity);
  var cdots = parser.create('token', 'mo', {
    stretchy: false
  }, cdotsEntity);
  parser.Push(parser.itemFactory.create('dots').setProperties({
    ldots: ldots,
    cdots: cdots
  }));
};
BaseMethods.Matrix = function (parser, _name, open, close, align, spacing, vspacing, style, cases, numbered) {
  var c = parser.GetNext();
  if (c === '') {
    throw new TexError_js_1$g.default('MissingArgFor', 'Missing argument for %1', parser.currentCS);
  }
  if (c === '{') {
    parser.i++;
  } else {
    parser.string = c + '}' + parser.string.slice(parser.i + 1);
    parser.i = 0;
  }
  var array = parser.itemFactory.create('array').setProperty('requireClose', true);
  array.arraydef = {
    rowspacing: vspacing || '4pt',
    columnspacing: spacing || '1em'
  };
  if (cases) {
    array.setProperty('isCases', true);
  }
  if (numbered) {
    array.setProperty('isNumbered', true);
    array.arraydef.side = numbered;
  }
  if (open || close) {
    array.setProperty('open', open);
    array.setProperty('close', close);
  }
  if (style === 'D') {
    array.arraydef.displaystyle = true;
  }
  if (align != null) {
    array.arraydef.columnalign = align;
  }
  parser.Push(array);
};
BaseMethods.Entry = function (parser, name) {
  parser.Push(parser.itemFactory.create('cell').setProperties({
    isEntry: true,
    name: name
  }));
  var top = parser.stack.Top();
  var env = top.getProperty('casesEnv');
  var cases = top.getProperty('isCases');
  if (!cases && !env) return;
  var str = parser.string;
  var braces = 0, close = -1, i = parser.i, m = str.length;
  var end = env ? new RegExp(("^\\\\end\\s*\\{").concat(env.replace(/\*/, '\\*'), "\\}")) : null;
  while (i < m) {
    var c = str.charAt(i);
    if (c === '{') {
      braces++;
      i++;
    } else if (c === '}') {
      if (braces === 0) {
        m = 0;
      } else {
        braces--;
        if (braces === 0 && close < 0) {
          close = i - parser.i;
        }
        i++;
      }
    } else if (c === '&' && braces === 0) {
      throw new TexError_js_1$g.default('ExtraAlignTab', 'Extra alignment tab in \\cases text');
    } else if (c === '\\') {
      var rest = str.substr(i);
      if (rest.match(/^((\\cr)[^a-zA-Z]|\\\\)/) || end && rest.match(end)) {
        m = 0;
      } else {
        i += 2;
      }
    } else {
      i++;
    }
  }
  var text = str.substr(parser.i, i - parser.i);
  if (!text.match(/^\s*\\text[^a-zA-Z]/) || close !== text.replace(/\s+$/, '').length - 1) {
    var internal = ParseUtil_js_1$d.default.internalMath(parser, ParseUtil_js_1$d.default.trimSpaces(text), 0);
    parser.PushAll(internal);
    parser.i = i;
  }
};
BaseMethods.Cr = function (parser, name) {
  parser.Push(parser.itemFactory.create('cell').setProperties({
    isCR: true,
    name: name
  }));
};
BaseMethods.CrLaTeX = function (parser, name, nobrackets) {
  if (nobrackets === void 0) {
    nobrackets = false;
  }
  var n;
  if (!nobrackets) {
    if (parser.string.charAt(parser.i) === '*') {
      parser.i++;
    }
    if (parser.string.charAt(parser.i) === '[') {
      var dim = parser.GetBrackets(name, '');
      var _a = __read$D(ParseUtil_js_1$d.default.matchDimen(dim), 2), value = _a[0], unit = _a[1];
      if (dim && !value) {
        throw new TexError_js_1$g.default('BracketMustBeDimension', 'Bracket argument to %1 must be a dimension', parser.currentCS);
      }
      n = value + unit;
    }
  }
  parser.Push(parser.itemFactory.create('cell').setProperties({
    isCR: true,
    name: name,
    linebreak: true
  }));
  var top = parser.stack.Top();
  var node;
  if (top instanceof sitem.ArrayItem) {
    if (n) {
      top.addRowSpacing(n);
    }
  } else {
    if (n) {
      node = parser.create('node', 'mspace', [], {
        depth: n
      });
      parser.Push(node);
    }
    node = parser.create('node', 'mspace', [], {
      linebreak: TexConstants_js_1$b.TexConstant.LineBreak.NEWLINE
    });
    parser.Push(node);
  }
};
BaseMethods.HLine = function (parser, _name, style) {
  if (style == null) {
    style = 'solid';
  }
  var top = parser.stack.Top();
  if (!(top instanceof sitem.ArrayItem) || top.Size()) {
    throw new TexError_js_1$g.default('Misplaced', 'Misplaced %1', parser.currentCS);
  }
  if (!top.table.length) {
    top.frame.push('top');
  } else {
    var lines = top.arraydef['rowlines'] ? top.arraydef['rowlines'].split(/ /) : [];
    while (lines.length < top.table.length) {
      lines.push('none');
    }
    lines[top.table.length - 1] = style;
    top.arraydef['rowlines'] = lines.join(' ');
  }
};
BaseMethods.HFill = function (parser, _name) {
  var top = parser.stack.Top();
  if (top instanceof sitem.ArrayItem) {
    top.hfill.push(top.Size());
  } else {
    throw new TexError_js_1$g.default('UnsupportedHFill', 'Unsupported use of %1', parser.currentCS);
  }
};
BaseMethods.BeginEnd = function (parser, name) {
  var env = parser.GetArgument(name);
  if (env.match(/\\/i)) {
    throw new TexError_js_1$g.default('InvalidEnv', 'Invalid environment name \'%1\'', env);
  }
  var macro = parser.configuration.handlers.get('environment').lookup(env);
  if (macro && name === '\\end') {
    if (!macro.args[0]) {
      var mml = parser.itemFactory.create('end').setProperty('name', env);
      parser.Push(mml);
      return;
    }
    parser.stack.env['closing'] = env;
  }
  ParseUtil_js_1$d.default.checkMaxMacros(parser, false);
  parser.parse('environment', [parser, env]);
};
BaseMethods.Array = function (parser, begin, open, close, align, spacing, vspacing, style, raggedHeight) {
  if (!align) {
    align = parser.GetArgument('\\begin{' + begin.getName() + '}');
  }
  var lines = ('c' + align).replace(/[^clr|:]/g, '').replace(/[^|:]([|:])+/g, '$1');
  align = align.replace(/[^clr]/g, '').split('').join(' ');
  align = align.replace(/l/g, 'left').replace(/r/g, 'right').replace(/c/g, 'center');
  var array = parser.itemFactory.create('array');
  array.arraydef = {
    columnalign: align,
    columnspacing: spacing || '1em',
    rowspacing: vspacing || '4pt'
  };
  if (lines.match(/[|:]/)) {
    if (lines.charAt(0).match(/[|:]/)) {
      array.frame.push('left');
      array.dashed = lines.charAt(0) === ':';
    }
    if (lines.charAt(lines.length - 1).match(/[|:]/)) {
      array.frame.push('right');
    }
    lines = lines.substr(1, lines.length - 2);
    array.arraydef.columnlines = lines.split('').join(' ').replace(/[^|: ]/g, 'none').replace(/\|/g, 'solid').replace(/:/g, 'dashed');
  }
  if (open) {
    array.setProperty('open', parser.convertDelimiter(open));
  }
  if (close) {
    array.setProperty('close', parser.convertDelimiter(close));
  }
  if ((style || '').charAt(1) === '\'') {
    array.arraydef['data-cramped'] = true;
    style = style.charAt(0);
  }
  if (style === 'D') {
    array.arraydef['displaystyle'] = true;
  } else if (style) {
    array.arraydef['displaystyle'] = false;
  }
  if (style === 'S') {
    array.arraydef['scriptlevel'] = 1;
  }
  if (raggedHeight) {
    array.arraydef['useHeight'] = false;
  }
  parser.Push(begin);
  return array;
};
BaseMethods.AlignedArray = function (parser, begin) {
  var align = parser.GetBrackets('\\begin{' + begin.getName() + '}');
  var item = BaseMethods.Array(parser, begin);
  return ParseUtil_js_1$d.default.setArrayAlign(item, align);
};
BaseMethods.Equation = function (parser, begin, numbered) {
  parser.Push(begin);
  ParseUtil_js_1$d.default.checkEqnEnv(parser);
  return parser.itemFactory.create('equation', numbered).setProperty('name', begin.getName());
};
BaseMethods.EqnArray = function (parser, begin, numbered, taggable, align, spacing) {
  parser.Push(begin);
  if (taggable) {
    ParseUtil_js_1$d.default.checkEqnEnv(parser);
  }
  align = align.replace(/[^clr]/g, '').split('').join(' ');
  align = align.replace(/l/g, 'left').replace(/r/g, 'right').replace(/c/g, 'center');
  var newItem = parser.itemFactory.create('eqnarray', begin.getName(), numbered, taggable, parser.stack.global);
  newItem.arraydef = {
    displaystyle: true,
    columnalign: align,
    columnspacing: spacing || '1em',
    rowspacing: '3pt',
    side: parser.options['tagSide'],
    minlabelspacing: parser.options['tagIndent']
  };
  return newItem;
};
BaseMethods.HandleNoTag = function (parser, _name) {
  parser.tags.notag();
};
BaseMethods.HandleLabel = function (parser, name) {
  var label = parser.GetArgument(name);
  if (label === '') {
    return;
  }
  if (!parser.tags.refUpdate) {
    if (parser.tags.label) {
      throw new TexError_js_1$g.default('MultipleCommand', 'Multiple %1', parser.currentCS);
    }
    parser.tags.label = label;
    if ((parser.tags.allLabels[label] || parser.tags.labels[label]) && !parser.options['ignoreDuplicateLabels']) {
      throw new TexError_js_1$g.default('MultipleLabel', 'Label \'%1\' multiply defined', label);
    }
    parser.tags.labels[label] = new Tags_js_1$6.Label();
  }
};
BaseMethods.HandleRef = function (parser, name, eqref) {
  var label = parser.GetArgument(name);
  var ref = parser.tags.allLabels[label] || parser.tags.labels[label];
  if (!ref) {
    if (!parser.tags.refUpdate) {
      parser.tags.redo = true;
    }
    ref = new Tags_js_1$6.Label();
  }
  var tag = ref.tag;
  if (eqref) {
    tag = parser.tags.formatTag(tag);
  }
  var node = parser.create('node', 'mrow', ParseUtil_js_1$d.default.internalMath(parser, tag), {
    href: parser.tags.formatUrl(ref.id, parser.options.baseURL),
    'class': 'MathJax_ref'
  });
  parser.Push(node);
};
BaseMethods.Macro = function (parser, name, macro, argcount, def) {
  if (argcount) {
    var args = [];
    if (def != null) {
      var optional = parser.GetBrackets(name);
      args.push(optional == null ? def : optional);
    }
    for (var i = args.length; i < argcount; i++) {
      args.push(parser.GetArgument(name));
    }
    macro = ParseUtil_js_1$d.default.substituteArgs(parser, args, macro);
  }
  parser.string = ParseUtil_js_1$d.default.addArgs(parser, macro, parser.string.slice(parser.i));
  parser.i = 0;
  ParseUtil_js_1$d.default.checkMaxMacros(parser);
};
BaseMethods.MathChoice = function (parser, name) {
  var D = parser.ParseArg(name);
  var T = parser.ParseArg(name);
  var S = parser.ParseArg(name);
  var SS = parser.ParseArg(name);
  parser.Push(parser.create('node', 'MathChoice', [D, T, S, SS]));
};
BaseMethods$1.default = BaseMethods;

var ParseMethods$1 = {};

var __read$C = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$j = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$A = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(ParseMethods$1, "__esModule", {
  value: true
});
var NodeUtil_js_1$a = __importDefault$A(NodeUtil$1);
var TexConstants_js_1$a = TexConstants;
var ParseUtil_js_1$c = __importDefault$A(ParseUtil$1);
var ParseMethods;
(function (ParseMethods) {
  function variable(parser, c) {
    var def = ParseUtil_js_1$c.default.getFontDef(parser);
    var env = parser.stack.env;
    if (env.multiLetterIdentifiers && env.font !== '') {
      c = parser.string.substr(parser.i - 1).match(env.multiLetterIdentifiers)[0];
      parser.i += c.length - 1;
      if (def.mathvariant === TexConstants_js_1$a.TexConstant.Variant.NORMAL && env.noAutoOP && c.length > 1) {
        def.autoOP = false;
      }
    }
    var node = parser.create('token', 'mi', def, c);
    parser.Push(node);
  }
  ParseMethods.variable = variable;
  function digit(parser, c) {
    var mml;
    var pattern = parser.configuration.options['digits'];
    var n = parser.string.slice(parser.i - 1).match(pattern);
    var def = ParseUtil_js_1$c.default.getFontDef(parser);
    if (n) {
      mml = parser.create('token', 'mn', def, n[0].replace(/[{}]/g, ''));
      parser.i += n[0].length - 1;
    } else {
      mml = parser.create('token', 'mo', def, c);
    }
    parser.Push(mml);
  }
  ParseMethods.digit = digit;
  function controlSequence(parser, _c) {
    var name = parser.GetCS();
    parser.parse('macro', [parser, name]);
  }
  ParseMethods.controlSequence = controlSequence;
  function mathchar0mi(parser, mchar) {
    var def = mchar.attributes || ({
      mathvariant: TexConstants_js_1$a.TexConstant.Variant.ITALIC
    });
    var node = parser.create('token', 'mi', def, mchar.char);
    parser.Push(node);
  }
  ParseMethods.mathchar0mi = mathchar0mi;
  function mathchar0mo(parser, mchar) {
    var def = mchar.attributes || ({});
    def['stretchy'] = false;
    var node = parser.create('token', 'mo', def, mchar.char);
    NodeUtil_js_1$a.default.setProperty(node, 'fixStretchy', true);
    parser.configuration.addNode('fixStretchy', node);
    parser.Push(node);
  }
  ParseMethods.mathchar0mo = mathchar0mo;
  function mathchar7(parser, mchar) {
    var def = mchar.attributes || ({
      mathvariant: TexConstants_js_1$a.TexConstant.Variant.NORMAL
    });
    if (parser.stack.env['font']) {
      def['mathvariant'] = parser.stack.env['font'];
    }
    var node = parser.create('token', 'mi', def, mchar.char);
    parser.Push(node);
  }
  ParseMethods.mathchar7 = mathchar7;
  function delimiter(parser, delim) {
    var def = delim.attributes || ({});
    def = Object.assign({
      fence: false,
      stretchy: false
    }, def);
    var node = parser.create('token', 'mo', def, delim.char);
    parser.Push(node);
  }
  ParseMethods.delimiter = delimiter;
  function environment(parser, env, func, args) {
    var end = args[0];
    var mml = parser.itemFactory.create('begin').setProperties({
      name: env,
      end: end
    });
    mml = func.apply(void 0, __spreadArray$j([parser, mml], __read$C(args.slice(1)), false));
    parser.Push(mml);
  }
  ParseMethods.environment = environment;
})(ParseMethods || (ParseMethods = {}));
ParseMethods$1.default = ParseMethods;

var __createBinding$b = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$b = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$b = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$b(result, mod, k);
  __setModuleDefault$b(result, mod);
  return result;
});
var __importDefault$z = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var sm$4 = __importStar$b(SymbolMap);
var TexConstants_js_1$9 = TexConstants;
var BaseMethods_js_1$6 = __importDefault$z(BaseMethods$1);
var ParseMethods_js_1$7 = __importDefault$z(ParseMethods$1);
var ParseUtil_js_1$b = __importDefault$z(ParseUtil$1);
var MmlNode_js_1$d = MmlNode;
var lengths_js_1$5 = lengths;
new sm$4.RegExpMap('letter', ParseMethods_js_1$7.default.variable, /[a-z]/i);
new sm$4.RegExpMap('digit', ParseMethods_js_1$7.default.digit, /[0-9.,]/);
new sm$4.RegExpMap('command', ParseMethods_js_1$7.default.controlSequence, /^\\/);
new sm$4.MacroMap('special', {
  '{': 'Open',
  '}': 'Close',
  '~': 'Tilde',
  '^': 'Superscript',
  '_': 'Subscript',
  ' ': 'Space',
  '\t': 'Space',
  '\r': 'Space',
  '\n': 'Space',
  '\'': 'Prime',
  '%': 'Comment',
  '&': 'Entry',
  '#': 'Hash',
  '\u00A0': 'Space',
  '\u2019': 'Prime'
}, BaseMethods_js_1$6.default);
new sm$4.CharacterMap('mathchar0mi', ParseMethods_js_1$7.default.mathchar0mi, {
  alpha: '\u03B1',
  beta: '\u03B2',
  gamma: '\u03B3',
  delta: '\u03B4',
  epsilon: '\u03F5',
  zeta: '\u03B6',
  eta: '\u03B7',
  theta: '\u03B8',
  iota: '\u03B9',
  kappa: '\u03BA',
  lambda: '\u03BB',
  mu: '\u03BC',
  nu: '\u03BD',
  xi: '\u03BE',
  omicron: '\u03BF',
  pi: '\u03C0',
  rho: '\u03C1',
  sigma: '\u03C3',
  tau: '\u03C4',
  upsilon: '\u03C5',
  phi: '\u03D5',
  chi: '\u03C7',
  psi: '\u03C8',
  omega: '\u03C9',
  varepsilon: '\u03B5',
  vartheta: '\u03D1',
  varpi: '\u03D6',
  varrho: '\u03F1',
  varsigma: '\u03C2',
  varphi: '\u03C6',
  S: ['\u00A7', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  aleph: ['\u2135', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  hbar: ['\u210F', {
    variantForm: true
  }],
  imath: '\u0131',
  jmath: '\u0237',
  ell: '\u2113',
  wp: ['\u2118', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  Re: ['\u211C', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  Im: ['\u2111', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  partial: ['\u2202', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.ITALIC
  }],
  infty: ['\u221E', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  prime: ['\u2032', {
    variantForm: true
  }],
  emptyset: ['\u2205', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  nabla: ['\u2207', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  top: ['\u22A4', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  bot: ['\u22A5', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  angle: ['\u2220', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  triangle: ['\u25B3', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  backslash: ['\u2216', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  forall: ['\u2200', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  exists: ['\u2203', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  neg: ['\u00AC', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  lnot: ['\u00AC', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  flat: ['\u266D', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  natural: ['\u266E', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  sharp: ['\u266F', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  clubsuit: ['\u2663', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  diamondsuit: ['\u2662', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  heartsuit: ['\u2661', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }],
  spadesuit: ['\u2660', {
    mathvariant: TexConstants_js_1$9.TexConstant.Variant.NORMAL
  }]
});
new sm$4.CharacterMap('mathchar0mo', ParseMethods_js_1$7.default.mathchar0mo, {
  surd: '\u221A',
  coprod: ['\u2210', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  bigvee: ['\u22C1', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  bigwedge: ['\u22C0', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  biguplus: ['\u2A04', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  bigcap: ['\u22C2', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  bigcup: ['\u22C3', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  'int': ['\u222B', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP
  }],
  intop: ['\u222B', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true,
    movablelimits: true
  }],
  iint: ['\u222C', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP
  }],
  iiint: ['\u222D', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP
  }],
  prod: ['\u220F', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  sum: ['\u2211', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  bigotimes: ['\u2A02', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  bigoplus: ['\u2A01', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  bigodot: ['\u2A00', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  oint: ['\u222E', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP
  }],
  bigsqcup: ['\u2A06', {
    texClass: MmlNode_js_1$d.TEXCLASS.OP,
    movesupsub: true
  }],
  smallint: ['\u222B', {
    largeop: false
  }],
  triangleleft: '\u25C3',
  triangleright: '\u25B9',
  bigtriangleup: '\u25B3',
  bigtriangledown: '\u25BD',
  wedge: '\u2227',
  land: '\u2227',
  vee: '\u2228',
  lor: '\u2228',
  cap: '\u2229',
  cup: '\u222A',
  ddagger: '\u2021',
  dagger: '\u2020',
  sqcap: '\u2293',
  sqcup: '\u2294',
  uplus: '\u228E',
  amalg: '\u2A3F',
  diamond: '\u22C4',
  bullet: '\u2219',
  wr: '\u2240',
  div: '\u00F7',
  divsymbol: '\u00F7',
  odot: ['\u2299', {
    largeop: false
  }],
  oslash: ['\u2298', {
    largeop: false
  }],
  otimes: ['\u2297', {
    largeop: false
  }],
  ominus: ['\u2296', {
    largeop: false
  }],
  oplus: ['\u2295', {
    largeop: false
  }],
  mp: '\u2213',
  pm: '\u00B1',
  circ: '\u2218',
  bigcirc: '\u25EF',
  setminus: '\u2216',
  cdot: '\u22C5',
  ast: '\u2217',
  times: '\u00D7',
  star: '\u22C6',
  propto: '\u221D',
  sqsubseteq: '\u2291',
  sqsupseteq: '\u2292',
  parallel: '\u2225',
  mid: '\u2223',
  dashv: '\u22A3',
  vdash: '\u22A2',
  leq: '\u2264',
  le: '\u2264',
  geq: '\u2265',
  ge: '\u2265',
  lt: '\u003C',
  gt: '\u003E',
  succ: '\u227B',
  prec: '\u227A',
  approx: '\u2248',
  succeq: '\u2AB0',
  preceq: '\u2AAF',
  supset: '\u2283',
  subset: '\u2282',
  supseteq: '\u2287',
  subseteq: '\u2286',
  'in': '\u2208',
  ni: '\u220B',
  notin: '\u2209',
  owns: '\u220B',
  gg: '\u226B',
  ll: '\u226A',
  sim: '\u223C',
  simeq: '\u2243',
  perp: '\u22A5',
  equiv: '\u2261',
  asymp: '\u224D',
  smile: '\u2323',
  frown: '\u2322',
  ne: '\u2260',
  neq: '\u2260',
  cong: '\u2245',
  doteq: '\u2250',
  bowtie: '\u22C8',
  models: '\u22A8',
  notChar: '\u29F8',
  Leftrightarrow: '\u21D4',
  Leftarrow: '\u21D0',
  Rightarrow: '\u21D2',
  leftrightarrow: '\u2194',
  leftarrow: '\u2190',
  gets: '\u2190',
  rightarrow: '\u2192',
  to: ['\u2192', {
    accent: false
  }],
  mapsto: '\u21A6',
  leftharpoonup: '\u21BC',
  leftharpoondown: '\u21BD',
  rightharpoonup: '\u21C0',
  rightharpoondown: '\u21C1',
  nearrow: '\u2197',
  searrow: '\u2198',
  nwarrow: '\u2196',
  swarrow: '\u2199',
  rightleftharpoons: '\u21CC',
  hookrightarrow: '\u21AA',
  hookleftarrow: '\u21A9',
  longleftarrow: '\u27F5',
  Longleftarrow: '\u27F8',
  longrightarrow: '\u27F6',
  Longrightarrow: '\u27F9',
  Longleftrightarrow: '\u27FA',
  longleftrightarrow: '\u27F7',
  longmapsto: '\u27FC',
  ldots: '\u2026',
  cdots: '\u22EF',
  vdots: '\u22EE',
  ddots: '\u22F1',
  dotsc: '\u2026',
  dotsb: '\u22EF',
  dotsm: '\u22EF',
  dotsi: '\u22EF',
  dotso: '\u2026',
  ldotp: ['\u002E', {
    texClass: MmlNode_js_1$d.TEXCLASS.PUNCT
  }],
  cdotp: ['\u22C5', {
    texClass: MmlNode_js_1$d.TEXCLASS.PUNCT
  }],
  colon: ['\u003A', {
    texClass: MmlNode_js_1$d.TEXCLASS.PUNCT
  }]
});
new sm$4.CharacterMap('mathchar7', ParseMethods_js_1$7.default.mathchar7, {
  Gamma: '\u0393',
  Delta: '\u0394',
  Theta: '\u0398',
  Lambda: '\u039B',
  Xi: '\u039E',
  Pi: '\u03A0',
  Sigma: '\u03A3',
  Upsilon: '\u03A5',
  Phi: '\u03A6',
  Psi: '\u03A8',
  Omega: '\u03A9',
  '_': '\u005F',
  '#': '\u0023',
  '$': '\u0024',
  '%': '\u0025',
  '&': '\u0026',
  And: '\u0026'
});
new sm$4.DelimiterMap('delimiter', ParseMethods_js_1$7.default.delimiter, {
  '(': '(',
  ')': ')',
  '[': '[',
  ']': ']',
  '<': '\u27E8',
  '>': '\u27E9',
  '\\lt': '\u27E8',
  '\\gt': '\u27E9',
  '/': '/',
  '|': ['|', {
    texClass: MmlNode_js_1$d.TEXCLASS.ORD
  }],
  '.': '',
  '\\\\': '\\',
  '\\lmoustache': '\u23B0',
  '\\rmoustache': '\u23B1',
  '\\lgroup': '\u27EE',
  '\\rgroup': '\u27EF',
  '\\arrowvert': '\u23D0',
  '\\Arrowvert': '\u2016',
  '\\bracevert': '\u23AA',
  '\\Vert': ['\u2016', {
    texClass: MmlNode_js_1$d.TEXCLASS.ORD
  }],
  '\\|': ['\u2016', {
    texClass: MmlNode_js_1$d.TEXCLASS.ORD
  }],
  '\\vert': ['|', {
    texClass: MmlNode_js_1$d.TEXCLASS.ORD
  }],
  '\\uparrow': '\u2191',
  '\\downarrow': '\u2193',
  '\\updownarrow': '\u2195',
  '\\Uparrow': '\u21D1',
  '\\Downarrow': '\u21D3',
  '\\Updownarrow': '\u21D5',
  '\\backslash': '\\',
  '\\rangle': '\u27E9',
  '\\langle': '\u27E8',
  '\\rbrace': '}',
  '\\lbrace': '{',
  '\\}': '}',
  '\\{': '{',
  '\\rceil': '\u2309',
  '\\lceil': '\u2308',
  '\\rfloor': '\u230B',
  '\\lfloor': '\u230A',
  '\\lbrack': '[',
  '\\rbrack': ']'
});
new sm$4.CommandMap('macros', {
  displaystyle: ['SetStyle', 'D', true, 0],
  textstyle: ['SetStyle', 'T', false, 0],
  scriptstyle: ['SetStyle', 'S', false, 1],
  scriptscriptstyle: ['SetStyle', 'SS', false, 2],
  rm: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.NORMAL],
  mit: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.ITALIC],
  oldstyle: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.OLDSTYLE],
  cal: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.CALLIGRAPHIC],
  it: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.MATHITALIC],
  bf: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.BOLD],
  bbFont: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.DOUBLESTRUCK],
  scr: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.SCRIPT],
  frak: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.FRAKTUR],
  sf: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIF],
  tt: ['SetFont', TexConstants_js_1$9.TexConstant.Variant.MONOSPACE],
  mathrm: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.NORMAL],
  mathup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.NORMAL],
  mathnormal: ['MathFont', ''],
  mathbf: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLD],
  mathbfup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLD],
  mathit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.MATHITALIC],
  mathbfit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDITALIC],
  mathbb: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.DOUBLESTRUCK],
  Bbb: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.DOUBLESTRUCK],
  mathfrak: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.FRAKTUR],
  mathbffrak: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDFRAKTUR],
  mathscr: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SCRIPT],
  mathbfscr: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDSCRIPT],
  mathsf: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIF],
  mathsfup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIF],
  mathbfsf: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDSANSSERIF],
  mathbfsfup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDSANSSERIF],
  mathsfit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIFITALIC],
  mathbfsfit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIFBOLDITALIC],
  mathtt: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.MONOSPACE],
  mathcal: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.CALLIGRAPHIC],
  mathbfcal: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDCALLIGRAPHIC],
  symrm: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.NORMAL],
  symup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.NORMAL],
  symnormal: ['MathFont', ''],
  symbf: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLD],
  symbfup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLD],
  symit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.ITALIC],
  symbfit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDITALIC],
  symbb: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.DOUBLESTRUCK],
  symfrak: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.FRAKTUR],
  symbffrak: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDFRAKTUR],
  symscr: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SCRIPT],
  symbfscr: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDSCRIPT],
  symsf: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIF],
  symsfup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIF],
  symbfsf: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDSANSSERIF],
  symbfsfup: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDSANSSERIF],
  symsfit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIFITALIC],
  symbfsfit: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.SANSSERIFBOLDITALIC],
  symtt: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.MONOSPACE],
  symcal: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.CALLIGRAPHIC],
  symbfcal: ['MathFont', TexConstants_js_1$9.TexConstant.Variant.BOLDCALLIGRAPHIC],
  textrm: ['HBox', null, TexConstants_js_1$9.TexConstant.Variant.NORMAL],
  textup: ['HBox', null, TexConstants_js_1$9.TexConstant.Variant.NORMAL],
  textnormal: ['HBox'],
  textit: ['HBox', null, TexConstants_js_1$9.TexConstant.Variant.ITALIC],
  textbf: ['HBox', null, TexConstants_js_1$9.TexConstant.Variant.BOLD],
  textsf: ['HBox', null, TexConstants_js_1$9.TexConstant.Variant.SANSSERIF],
  texttt: ['HBox', null, TexConstants_js_1$9.TexConstant.Variant.MONOSPACE],
  tiny: ['SetSize', 0.5],
  Tiny: ['SetSize', 0.6],
  scriptsize: ['SetSize', 0.7],
  small: ['SetSize', 0.85],
  normalsize: ['SetSize', 1.0],
  large: ['SetSize', 1.2],
  Large: ['SetSize', 1.44],
  LARGE: ['SetSize', 1.73],
  huge: ['SetSize', 2.07],
  Huge: ['SetSize', 2.49],
  arcsin: 'NamedFn',
  arccos: 'NamedFn',
  arctan: 'NamedFn',
  arg: 'NamedFn',
  cos: 'NamedFn',
  cosh: 'NamedFn',
  cot: 'NamedFn',
  coth: 'NamedFn',
  csc: 'NamedFn',
  deg: 'NamedFn',
  det: 'NamedOp',
  dim: 'NamedFn',
  exp: 'NamedFn',
  gcd: 'NamedOp',
  hom: 'NamedFn',
  inf: 'NamedOp',
  ker: 'NamedFn',
  lg: 'NamedFn',
  lim: 'NamedOp',
  liminf: ['NamedOp', 'lim&thinsp;inf'],
  limsup: ['NamedOp', 'lim&thinsp;sup'],
  ln: 'NamedFn',
  log: 'NamedFn',
  max: 'NamedOp',
  min: 'NamedOp',
  Pr: 'NamedOp',
  sec: 'NamedFn',
  sin: 'NamedFn',
  sinh: 'NamedFn',
  sup: 'NamedOp',
  tan: 'NamedFn',
  tanh: 'NamedFn',
  limits: ['Limits', 1],
  nolimits: ['Limits', 0],
  overline: ['UnderOver', '2015'],
  underline: ['UnderOver', '2015'],
  overbrace: ['UnderOver', '23DE', 1],
  underbrace: ['UnderOver', '23DF', 1],
  overparen: ['UnderOver', '23DC'],
  underparen: ['UnderOver', '23DD'],
  overrightarrow: ['UnderOver', '2192'],
  underrightarrow: ['UnderOver', '2192'],
  overleftarrow: ['UnderOver', '2190'],
  underleftarrow: ['UnderOver', '2190'],
  overleftrightarrow: ['UnderOver', '2194'],
  underleftrightarrow: ['UnderOver', '2194'],
  overset: 'Overset',
  underset: 'Underset',
  overunderset: 'Overunderset',
  stackrel: ['Macro', '\\mathrel{\\mathop{#2}\\limits^{#1}}', 2],
  stackbin: ['Macro', '\\mathbin{\\mathop{#2}\\limits^{#1}}', 2],
  over: 'Over',
  overwithdelims: 'Over',
  atop: 'Over',
  atopwithdelims: 'Over',
  above: 'Over',
  abovewithdelims: 'Over',
  brace: ['Over', '{', '}'],
  brack: ['Over', '[', ']'],
  choose: ['Over', '(', ')'],
  frac: 'Frac',
  sqrt: 'Sqrt',
  root: 'Root',
  uproot: ['MoveRoot', 'upRoot'],
  leftroot: ['MoveRoot', 'leftRoot'],
  left: 'LeftRight',
  right: 'LeftRight',
  middle: 'LeftRight',
  llap: 'Lap',
  rlap: 'Lap',
  raise: 'RaiseLower',
  lower: 'RaiseLower',
  moveleft: 'MoveLeftRight',
  moveright: 'MoveLeftRight',
  ',': ['Spacer', lengths_js_1$5.MATHSPACE.thinmathspace],
  ':': ['Spacer', lengths_js_1$5.MATHSPACE.mediummathspace],
  '>': ['Spacer', lengths_js_1$5.MATHSPACE.mediummathspace],
  ';': ['Spacer', lengths_js_1$5.MATHSPACE.thickmathspace],
  '!': ['Spacer', lengths_js_1$5.MATHSPACE.negativethinmathspace],
  enspace: ['Spacer', .5],
  quad: ['Spacer', 1],
  qquad: ['Spacer', 2],
  thinspace: ['Spacer', lengths_js_1$5.MATHSPACE.thinmathspace],
  negthinspace: ['Spacer', lengths_js_1$5.MATHSPACE.negativethinmathspace],
  hskip: 'Hskip',
  hspace: 'Hskip',
  kern: 'Hskip',
  mskip: 'Hskip',
  mspace: 'Hskip',
  mkern: 'Hskip',
  rule: 'rule',
  Rule: ['Rule'],
  Space: ['Rule', 'blank'],
  nonscript: 'Nonscript',
  big: ['MakeBig', MmlNode_js_1$d.TEXCLASS.ORD, 0.85],
  Big: ['MakeBig', MmlNode_js_1$d.TEXCLASS.ORD, 1.15],
  bigg: ['MakeBig', MmlNode_js_1$d.TEXCLASS.ORD, 1.45],
  Bigg: ['MakeBig', MmlNode_js_1$d.TEXCLASS.ORD, 1.75],
  bigl: ['MakeBig', MmlNode_js_1$d.TEXCLASS.OPEN, 0.85],
  Bigl: ['MakeBig', MmlNode_js_1$d.TEXCLASS.OPEN, 1.15],
  biggl: ['MakeBig', MmlNode_js_1$d.TEXCLASS.OPEN, 1.45],
  Biggl: ['MakeBig', MmlNode_js_1$d.TEXCLASS.OPEN, 1.75],
  bigr: ['MakeBig', MmlNode_js_1$d.TEXCLASS.CLOSE, 0.85],
  Bigr: ['MakeBig', MmlNode_js_1$d.TEXCLASS.CLOSE, 1.15],
  biggr: ['MakeBig', MmlNode_js_1$d.TEXCLASS.CLOSE, 1.45],
  Biggr: ['MakeBig', MmlNode_js_1$d.TEXCLASS.CLOSE, 1.75],
  bigm: ['MakeBig', MmlNode_js_1$d.TEXCLASS.REL, 0.85],
  Bigm: ['MakeBig', MmlNode_js_1$d.TEXCLASS.REL, 1.15],
  biggm: ['MakeBig', MmlNode_js_1$d.TEXCLASS.REL, 1.45],
  Biggm: ['MakeBig', MmlNode_js_1$d.TEXCLASS.REL, 1.75],
  mathord: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.ORD],
  mathop: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.OP],
  mathopen: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.OPEN],
  mathclose: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.CLOSE],
  mathbin: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.BIN],
  mathrel: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.REL],
  mathpunct: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.PUNCT],
  mathinner: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.INNER],
  vcenter: ['TeXAtom', MmlNode_js_1$d.TEXCLASS.VCENTER],
  buildrel: 'BuildRel',
  hbox: ['HBox', 0],
  text: 'HBox',
  mbox: ['HBox', 0],
  fbox: 'FBox',
  boxed: ['Macro', '\\fbox{$\\displaystyle{#1}$}', 1],
  framebox: 'FrameBox',
  strut: 'Strut',
  mathstrut: ['Macro', '\\vphantom{(}'],
  phantom: 'Phantom',
  vphantom: ['Phantom', 1, 0],
  hphantom: ['Phantom', 0, 1],
  smash: 'Smash',
  acute: ['Accent', '00B4'],
  grave: ['Accent', '0060'],
  ddot: ['Accent', '00A8'],
  tilde: ['Accent', '007E'],
  bar: ['Accent', '00AF'],
  breve: ['Accent', '02D8'],
  check: ['Accent', '02C7'],
  hat: ['Accent', '005E'],
  vec: ['Accent', '2192'],
  dot: ['Accent', '02D9'],
  widetilde: ['Accent', '007E', 1],
  widehat: ['Accent', '005E', 1],
  matrix: 'Matrix',
  array: 'Matrix',
  pmatrix: ['Matrix', '(', ')'],
  cases: ['Matrix', '{', '', 'left left', null, '.1em', null, true],
  eqalign: ['Matrix', null, null, 'right left', (0, lengths_js_1$5.em)(lengths_js_1$5.MATHSPACE.thickmathspace), '.5em', 'D'],
  displaylines: ['Matrix', null, null, 'center', null, '.5em', 'D'],
  cr: 'Cr',
  '\\': 'CrLaTeX',
  newline: ['CrLaTeX', true],
  hline: ['HLine', 'solid'],
  hdashline: ['HLine', 'dashed'],
  eqalignno: ['Matrix', null, null, 'right left', (0, lengths_js_1$5.em)(lengths_js_1$5.MATHSPACE.thickmathspace), '.5em', 'D', null, 'right'],
  leqalignno: ['Matrix', null, null, 'right left', (0, lengths_js_1$5.em)(lengths_js_1$5.MATHSPACE.thickmathspace), '.5em', 'D', null, 'left'],
  hfill: 'HFill',
  hfil: 'HFill',
  hfilll: 'HFill',
  bmod: ['Macro', '\\mmlToken{mo}[lspace="thickmathspace"' + ' rspace="thickmathspace"]{mod}'],
  pmod: ['Macro', '\\pod{\\mmlToken{mi}{mod}\\kern 6mu #1}', 1],
  mod: ['Macro', '\\mathchoice{\\kern18mu}{\\kern12mu}' + '{\\kern12mu}{\\kern12mu}\\mmlToken{mi}{mod}\\,\\,#1', 1],
  pod: ['Macro', '\\mathchoice{\\kern18mu}{\\kern8mu}' + '{\\kern8mu}{\\kern8mu}(#1)', 1],
  iff: ['Macro', '\\;\\Longleftrightarrow\\;'],
  skew: ['Macro', '{{#2{#3\\mkern#1mu}\\mkern-#1mu}{}}', 3],
  pmb: ['Macro', '\\rlap{#1}\\kern1px{#1}', 1],
  TeX: ['Macro', 'T\\kern-.14em\\lower.5ex{E}\\kern-.115em X'],
  LaTeX: ['Macro', 'L\\kern-.325em\\raise.21em' + '{\\scriptstyle{A}}\\kern-.17em\\TeX'],
  ' ': ['Macro', '\\text{ }'],
  not: 'Not',
  dots: 'Dots',
  space: 'Tilde',
  '\u00A0': 'Tilde',
  begin: 'BeginEnd',
  end: 'BeginEnd',
  label: 'HandleLabel',
  ref: 'HandleRef',
  nonumber: 'HandleNoTag',
  mathchoice: 'MathChoice',
  mmlToken: 'MmlToken'
}, BaseMethods_js_1$6.default);
new sm$4.EnvironmentMap('environment', ParseMethods_js_1$7.default.environment, {
  array: ['AlignedArray'],
  equation: ['Equation', null, true],
  eqnarray: ['EqnArray', null, true, true, 'rcl', ParseUtil_js_1$b.default.cols(0, lengths_js_1$5.MATHSPACE.thickmathspace), '.5em']
}, BaseMethods_js_1$6.default);
new sm$4.CharacterMap('not_remap', null, {
  '\u2190': '\u219A',
  '\u2192': '\u219B',
  '\u2194': '\u21AE',
  '\u21D0': '\u21CD',
  '\u21D2': '\u21CF',
  '\u21D4': '\u21CE',
  '\u2208': '\u2209',
  '\u220B': '\u220C',
  '\u2223': '\u2224',
  '\u2225': '\u2226',
  '\u223C': '\u2241',
  '\u007E': '\u2241',
  '\u2243': '\u2244',
  '\u2245': '\u2247',
  '\u2248': '\u2249',
  '\u224D': '\u226D',
  '\u003D': '\u2260',
  '\u2261': '\u2262',
  '\u003C': '\u226E',
  '\u003E': '\u226F',
  '\u2264': '\u2270',
  '\u2265': '\u2271',
  '\u2272': '\u2274',
  '\u2273': '\u2275',
  '\u2276': '\u2278',
  '\u2277': '\u2279',
  '\u227A': '\u2280',
  '\u227B': '\u2281',
  '\u2282': '\u2284',
  '\u2283': '\u2285',
  '\u2286': '\u2288',
  '\u2287': '\u2289',
  '\u22A2': '\u22AC',
  '\u22A8': '\u22AD',
  '\u22A9': '\u22AE',
  '\u22AB': '\u22AF',
  '\u227C': '\u22E0',
  '\u227D': '\u22E1',
  '\u2291': '\u22E2',
  '\u2292': '\u22E3',
  '\u22B2': '\u22EA',
  '\u22B3': '\u22EB',
  '\u22B4': '\u22EC',
  '\u22B5': '\u22ED',
  '\u2203': '\u2204'
});

var __extends$1e = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __createBinding$a = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$a = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$a = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$a(result, mod, k);
  __setModuleDefault$a(result, mod);
  return result;
});
var __values$v = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$y = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var _a$9;
Object.defineProperty(BaseConfiguration, "__esModule", {
  value: true
});
BaseConfiguration.BaseConfiguration = BaseConfiguration.BaseTags = BaseConfiguration.Other = void 0;
var Configuration_js_1$k = Configuration;
var MapHandler_js_1 = MapHandler;
var TexError_js_1$f = __importDefault$y(TexError$1);
var NodeUtil_js_1$9 = __importDefault$y(NodeUtil$1);
var SymbolMap_js_1$g = SymbolMap;
var bitem = __importStar$a(BaseItems);
var Tags_js_1$5 = Tags;
var OperatorDictionary_js_1 = OperatorDictionary;
new SymbolMap_js_1$g.CharacterMap('remap', null, {
  '-': '\u2212',
  '*': '\u2217',
  '`': '\u2018'
});
function Other(parser, char) {
  var font = parser.stack.env['font'];
  var def = font ? {
    mathvariant: parser.stack.env['font']
  } : {};
  var remap = MapHandler_js_1.MapHandler.getMap('remap').lookup(char);
  var range = (0, OperatorDictionary_js_1.getRange)(char);
  var type = range ? range[3] : 'mo';
  var mo = parser.create('token', type, def, remap ? remap.char : char);
  range[4] && mo.attributes.set('mathvariant', range[4]);
  if (type === 'mo') {
    NodeUtil_js_1$9.default.setProperty(mo, 'fixStretchy', true);
    parser.configuration.addNode('fixStretchy', mo);
  }
  parser.Push(mo);
}
BaseConfiguration.Other = Other;
function csUndefined(_parser, name) {
  throw new TexError_js_1$f.default('UndefinedControlSequence', 'Undefined control sequence %1', '\\' + name);
}
function envUndefined(_parser, env) {
  throw new TexError_js_1$f.default('UnknownEnv', 'Unknown environment \'%1\'', env);
}
function filterNonscript(_a) {
  var e_1, _b;
  var data = _a.data;
  try {
    for (var _c = __values$v(data.getList('nonscript')), _d = _c.next(); !_d.done; _d = _c.next()) {
      var mml = _d.value;
      if (mml.attributes.get('scriptlevel') > 0) {
        var parent_1 = mml.parent;
        parent_1.childNodes.splice(parent_1.childIndex(mml), 1);
        data.removeFromList(mml.kind, [mml]);
        if (mml.isKind('mrow')) {
          var mstyle = mml.childNodes[0];
          data.removeFromList('mstyle', [mstyle]);
          data.removeFromList('mspace', mstyle.childNodes[0].childNodes);
        }
      } else if (mml.isKind('mrow')) {
        mml.parent.replaceChild(mml.childNodes[0], mml);
        data.removeFromList('mrow', [mml]);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}
var BaseTags = (function (_super) {
  __extends$1e(BaseTags, _super);
  function BaseTags() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return BaseTags;
})(Tags_js_1$5.AbstractTags);
BaseConfiguration.BaseTags = BaseTags;
BaseConfiguration.BaseConfiguration = Configuration_js_1$k.Configuration.create('base', {
  handler: {
    character: ['command', 'special', 'letter', 'digit'],
    delimiter: ['delimiter'],
    macro: ['delimiter', 'macros', 'mathchar0mi', 'mathchar0mo', 'mathchar7'],
    environment: ['environment']
  },
  fallback: {
    character: Other,
    macro: csUndefined,
    environment: envUndefined
  },
  items: (_a$9 = {}, _a$9[bitem.StartItem.prototype.kind] = bitem.StartItem, _a$9[bitem.StopItem.prototype.kind] = bitem.StopItem, _a$9[bitem.OpenItem.prototype.kind] = bitem.OpenItem, _a$9[bitem.CloseItem.prototype.kind] = bitem.CloseItem, _a$9[bitem.PrimeItem.prototype.kind] = bitem.PrimeItem, _a$9[bitem.SubsupItem.prototype.kind] = bitem.SubsupItem, _a$9[bitem.OverItem.prototype.kind] = bitem.OverItem, _a$9[bitem.LeftItem.prototype.kind] = bitem.LeftItem, _a$9[bitem.Middle.prototype.kind] = bitem.Middle, _a$9[bitem.RightItem.prototype.kind] = bitem.RightItem, _a$9[bitem.BeginItem.prototype.kind] = bitem.BeginItem, _a$9[bitem.EndItem.prototype.kind] = bitem.EndItem, _a$9[bitem.StyleItem.prototype.kind] = bitem.StyleItem, _a$9[bitem.PositionItem.prototype.kind] = bitem.PositionItem, _a$9[bitem.CellItem.prototype.kind] = bitem.CellItem, _a$9[bitem.MmlItem.prototype.kind] = bitem.MmlItem, _a$9[bitem.FnItem.prototype.kind] = bitem.FnItem, _a$9[bitem.NotItem.prototype.kind] = bitem.NotItem, _a$9[bitem.NonscriptItem.prototype.kind] = bitem.NonscriptItem, _a$9[bitem.DotsItem.prototype.kind] = bitem.DotsItem, _a$9[bitem.ArrayItem.prototype.kind] = bitem.ArrayItem, _a$9[bitem.EqnArrayItem.prototype.kind] = bitem.EqnArrayItem, _a$9[bitem.EquationItem.prototype.kind] = bitem.EquationItem, _a$9),
  options: {
    maxMacros: 1000,
    baseURL: typeof document === 'undefined' || document.getElementsByTagName('base').length === 0 ? '' : String(document.location).replace(/#.*$/, '')
  },
  tags: {
    base: BaseTags
  },
  postprocessors: [[filterNonscript, -4]]
});

var __extends$1d = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$9 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$9 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$9.apply(this, arguments);
});
var __read$B = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __importDefault$x = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(tex$2, "__esModule", {
  value: true
});
var TeX_1 = tex$2.TeX = void 0;
var InputJax_js_1 = InputJax;
var Options_js_1$7 = Options;
var FindTeX_js_1 = FindTeX$1;
var FilterUtil_js_1 = __importDefault$x(FilterUtil$1);
var NodeUtil_js_1$8 = __importDefault$x(NodeUtil$1);
var TexParser_js_1$8 = __importDefault$x(TexParser$1);
var TexError_js_1$e = __importDefault$x(TexError$1);
var ParseOptions_js_1$1 = __importDefault$x(ParseOptions$1);
var Tags_js_1$4 = Tags;
var Configuration_js_1$j = Configuration;
var TeX = (function (_super) {
  __extends$1d(TeX, _super);
  function TeX(options) {
    if (options === void 0) {
      options = {};
    }
    var _this = this;
    var _a = __read$B((0, Options_js_1$7.separateOptions)(options, TeX.OPTIONS, FindTeX_js_1.FindTeX.OPTIONS), 3), rest = _a[0], tex = _a[1], find = _a[2];
    _this = _super.call(this, tex) || this;
    _this.findTeX = _this.options['FindTeX'] || new FindTeX_js_1.FindTeX(find);
    var packages = _this.options.packages;
    var configuration = _this.configuration = TeX.configure(packages);
    var parseOptions = _this._parseOptions = new ParseOptions_js_1$1.default(configuration, [_this.options, Tags_js_1$4.TagsFactory.OPTIONS]);
    (0, Options_js_1$7.userOptions)(parseOptions.options, rest);
    configuration.config(_this);
    TeX.tags(parseOptions, configuration);
    _this.postFilters.add(FilterUtil_js_1.default.cleanSubSup, -6);
    _this.postFilters.add(FilterUtil_js_1.default.setInherited, -5);
    _this.postFilters.add(FilterUtil_js_1.default.moveLimits, -4);
    _this.postFilters.add(FilterUtil_js_1.default.cleanStretchy, -3);
    _this.postFilters.add(FilterUtil_js_1.default.cleanAttributes, -2);
    _this.postFilters.add(FilterUtil_js_1.default.combineRelations, -1);
    return _this;
  }
  TeX.configure = function (packages) {
    var configuration = new Configuration_js_1$j.ParserConfiguration(packages, ['tex']);
    configuration.init();
    return configuration;
  };
  TeX.tags = function (options, configuration) {
    Tags_js_1$4.TagsFactory.addTags(configuration.tags);
    Tags_js_1$4.TagsFactory.setDefault(options.options.tags);
    options.tags = Tags_js_1$4.TagsFactory.getDefault();
    options.tags.configuration = options;
  };
  TeX.prototype.setMmlFactory = function (mmlFactory) {
    _super.prototype.setMmlFactory.call(this, mmlFactory);
    this._parseOptions.nodeFactory.setMmlFactory(mmlFactory);
  };
  Object.defineProperty(TeX.prototype, "parseOptions", {
    get: function () {
      return this._parseOptions;
    },
    enumerable: false,
    configurable: true
  });
  TeX.prototype.reset = function (tag) {
    if (tag === void 0) {
      tag = 0;
    }
    this.parseOptions.tags.reset(tag);
  };
  TeX.prototype.compile = function (math, document) {
    this.parseOptions.clear();
    this.executeFilters(this.preFilters, math, document, this.parseOptions);
    var display = math.display;
    this.latex = math.math;
    var node;
    this.parseOptions.tags.startEquation(math);
    var globalEnv;
    try {
      var parser = new TexParser_js_1$8.default(this.latex, {
        display: display,
        isInner: false
      }, this.parseOptions);
      node = parser.mml();
      globalEnv = parser.stack.global;
    } catch (err) {
      if (!(err instanceof TexError_js_1$e.default)) {
        throw err;
      }
      this.parseOptions.error = true;
      node = this.options.formatError(this, err);
    }
    node = this.parseOptions.nodeFactory.create('node', 'math', [node]);
    if (globalEnv === null || globalEnv === void 0 ? void 0 : globalEnv.indentalign) {
      NodeUtil_js_1$8.default.setAttribute(node, 'indentalign', globalEnv.indentalign);
    }
    if (display) {
      NodeUtil_js_1$8.default.setAttribute(node, 'display', 'block');
    }
    this.parseOptions.tags.finishEquation(math);
    this.parseOptions.root = node;
    this.executeFilters(this.postFilters, math, document, this.parseOptions);
    this.mathNode = this.parseOptions.root;
    return this.mathNode;
  };
  TeX.prototype.findMath = function (strings) {
    return this.findTeX.findMath(strings);
  };
  TeX.prototype.formatError = function (err) {
    var message = err.message.replace(/\n.*/, '');
    return this.parseOptions.nodeFactory.create('error', message, err.id, this.latex);
  };
  TeX.NAME = 'TeX';
  TeX.OPTIONS = __assign$9(__assign$9({}, InputJax_js_1.AbstractInputJax.OPTIONS), {
    FindTeX: null,
    packages: ['base'],
    digits: /^(?:[0-9]+(?:\{,\}[0-9]{3})*(?:\.[0-9]*)?|\.[0-9]+)/,
    maxBuffer: 5 * 1024,
    formatError: function (jax, err) {
      return jax.formatError(err);
    }
  });
  return TeX;
})(InputJax_js_1.AbstractInputJax);
TeX_1 = tex$2.TeX = TeX;

var chtml = {};

var OutputJax$1 = {};

var OutputJax = {};

Object.defineProperty(OutputJax, "__esModule", {
  value: true
});
OutputJax.AbstractOutputJax = void 0;
var Options_js_1$6 = Options;
var FunctionList_js_1 = FunctionList$1;
var AbstractOutputJax = (function () {
  function AbstractOutputJax(options) {
    if (options === void 0) {
      options = {};
    }
    this.adaptor = null;
    var CLASS = this.constructor;
    this.options = (0, Options_js_1$6.userOptions)((0, Options_js_1$6.defaultOptions)({}, CLASS.OPTIONS), options);
    this.postFilters = new FunctionList_js_1.FunctionList();
  }
  Object.defineProperty(AbstractOutputJax.prototype, "name", {
    get: function () {
      return this.constructor.NAME;
    },
    enumerable: false,
    configurable: true
  });
  AbstractOutputJax.prototype.setAdaptor = function (adaptor) {
    this.adaptor = adaptor;
  };
  AbstractOutputJax.prototype.initialize = function () {};
  AbstractOutputJax.prototype.reset = function () {
  };
  AbstractOutputJax.prototype.getMetrics = function (_document) {};
  AbstractOutputJax.prototype.styleSheet = function (_document) {
    return null;
  };
  AbstractOutputJax.prototype.pageElements = function (_document) {
    return null;
  };
  AbstractOutputJax.prototype.executeFilters = function (filters, math, document, data) {
    var args = {
      math: math,
      document: document,
      data: data
    };
    filters.execute(args);
    return args.data;
  };
  AbstractOutputJax.NAME = 'generic';
  AbstractOutputJax.OPTIONS = {};
  return AbstractOutputJax;
})();
OutputJax.AbstractOutputJax = AbstractOutputJax;

var Styles$1 = {};

var __values$u = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$A = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$i = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(Styles$1, "__esModule", {
  value: true
});
Styles$1.Styles = void 0;
var TRBL = ['top', 'right', 'bottom', 'left'];
var WSC = ['width', 'style', 'color'];
function splitSpaces(text) {
  var parts = text.split(/((?:'[^']*'|"[^"]*"|,[\s\n]|[^\s\n])*)/g);
  var split = [];
  while (parts.length > 1) {
    parts.shift();
    split.push(parts.shift());
  }
  return split;
}
function splitTRBL(name) {
  var e_1, _a;
  var parts = splitSpaces(this.styles[name]);
  if (parts.length === 0) {
    parts.push('');
  }
  if (parts.length === 1) {
    parts.push(parts[0]);
  }
  if (parts.length === 2) {
    parts.push(parts[0]);
  }
  if (parts.length === 3) {
    parts.push(parts[1]);
  }
  try {
    for (var _b = __values$u(Styles.connect[name].children), _c = _b.next(); !_c.done; _c = _b.next()) {
      var child = _c.value;
      this.setStyle(this.childName(name, child), parts.shift());
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}
function combineTRBL(name) {
  var e_2, _a;
  var children = Styles.connect[name].children;
  var parts = [];
  try {
    for (var children_1 = __values$u(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
      var child = children_1_1.value;
      var part = this.styles[name + '-' + child];
      if (!part) {
        delete this.styles[name];
        return;
      }
      parts.push(part);
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  if (parts[3] === parts[1]) {
    parts.pop();
    if (parts[2] === parts[0]) {
      parts.pop();
      if (parts[1] === parts[0]) {
        parts.pop();
      }
    }
  }
  this.styles[name] = parts.join(' ');
}
function splitSame(name) {
  var e_3, _a;
  try {
    for (var _b = __values$u(Styles.connect[name].children), _c = _b.next(); !_c.done; _c = _b.next()) {
      var child = _c.value;
      this.setStyle(this.childName(name, child), this.styles[name]);
    }
  } catch (e_3_1) {
    e_3 = {
      error: e_3_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_3) throw e_3.error;
    }
  }
}
function combineSame(name) {
  var e_4, _a;
  var children = __spreadArray$i([], __read$A(Styles.connect[name].children), false);
  var value = this.styles[this.childName(name, children.shift())];
  try {
    for (var children_2 = __values$u(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
      var child = children_2_1.value;
      if (this.styles[this.childName(name, child)] !== value) {
        delete this.styles[name];
        return;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (children_2_1 && !children_2_1.done && (_a = children_2.return)) _a.call(children_2);
    } finally {
      if (e_4) throw e_4.error;
    }
  }
  this.styles[name] = value;
}
var BORDER = {
  width: /^(?:[\d.]+(?:[a-z]+)|thin|medium|thick|inherit|initial|unset)$/,
  style: /^(?:none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset|inherit|initial|unset)$/
};
function splitWSC(name) {
  var e_5, _a, e_6, _b;
  var parts = {
    width: '',
    style: '',
    color: ''
  };
  try {
    for (var _c = __values$u(splitSpaces(this.styles[name])), _d = _c.next(); !_d.done; _d = _c.next()) {
      var part = _d.value;
      if (part.match(BORDER.width) && parts.width === '') {
        parts.width = part;
      } else if (part.match(BORDER.style) && parts.style === '') {
        parts.style = part;
      } else {
        parts.color = part;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
    } finally {
      if (e_5) throw e_5.error;
    }
  }
  try {
    for (var _e = __values$u(Styles.connect[name].children), _f = _e.next(); !_f.done; _f = _e.next()) {
      var child = _f.value;
      this.setStyle(this.childName(name, child), parts[child]);
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
    } finally {
      if (e_6) throw e_6.error;
    }
  }
}
function combineWSC(name) {
  var e_7, _a;
  var parts = [];
  try {
    for (var _b = __values$u(Styles.connect[name].children), _c = _b.next(); !_c.done; _c = _b.next()) {
      var child = _c.value;
      var value = this.styles[this.childName(name, child)];
      if (value) {
        parts.push(value);
      }
    }
  } catch (e_7_1) {
    e_7 = {
      error: e_7_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_7) throw e_7.error;
    }
  }
  if (parts.length) {
    this.styles[name] = parts.join(' ');
  } else {
    delete this.styles[name];
  }
}
var FONT = {
  style: /^(?:normal|italic|oblique|inherit|initial|unset)$/,
  variant: new RegExp('^(?:' + ['normal|none', 'inherit|initial|unset', 'common-ligatures|no-common-ligatures', 'discretionary-ligatures|no-discretionary-ligatures', 'historical-ligatures|no-historical-ligatures', 'contextual|no-contextual', '(?:stylistic|character-variant|swash|ornaments|annotation)\\([^)]*\\)', 'small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps', 'lining-nums|oldstyle-nums|proportional-nums|tabular-nums', 'diagonal-fractions|stacked-fractions', 'ordinal|slashed-zero', 'jis78|jis83|jis90|jis04|simplified|traditional', 'full-width|proportional-width', 'ruby'].join('|') + ')$'),
  weight: /^(?:normal|bold|bolder|lighter|[1-9]00|inherit|initial|unset)$/,
  stretch: new RegExp('^(?:' + ['normal', '(?:(?:ultra|extra|semi)-)?condensed', '(?:(?:semi|extra|ulta)-)?expanded', 'inherit|initial|unset'].join('|') + ')$'),
  size: new RegExp('^(?:' + ['xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller', '[\d.]+%|[\d.]+[a-z]+', 'inherit|initial|unset'].join('|') + ')' + '(?:\/(?:normal|[\d.\+](?:%|[a-z]+)?))?$')
};
function splitFont(name) {
  var e_8, _a, e_9, _b;
  var parts = splitSpaces(this.styles[name]);
  var value = {
    style: '',
    variant: [],
    weight: '',
    stretch: '',
    size: '',
    family: '',
    'line-height': ''
  };
  try {
    for (var parts_1 = __values$u(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
      var part = parts_1_1.value;
      value.family = part;
      try {
        for (var _c = (e_9 = void 0, __values$u(Object.keys(FONT))), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_1 = _d.value;
          if ((Array.isArray(value[name_1]) || value[name_1] === '') && part.match(FONT[name_1])) {
            if (name_1 === 'size') {
              var _e = __read$A(part.split(/\//), 2), size = _e[0], height = _e[1];
              value[name_1] = size;
              if (height) {
                value['line-height'] = height;
              }
            } else if (value.size === '') {
              if (Array.isArray(value[name_1])) {
                value[name_1].push(part);
              } else {
                value[name_1] = part;
              }
            }
          }
        }
      } catch (e_9_1) {
        e_9 = {
          error: e_9_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_9) throw e_9.error;
        }
      }
    }
  } catch (e_8_1) {
    e_8 = {
      error: e_8_1
    };
  } finally {
    try {
      if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
    } finally {
      if (e_8) throw e_8.error;
    }
  }
  saveFontParts(name, value);
  delete this.styles[name];
}
function saveFontParts(name, value) {
  var e_10, _a;
  try {
    for (var _b = __values$u(Styles.connect[name].children), _c = _b.next(); !_c.done; _c = _b.next()) {
      var child = _c.value;
      var cname = this.childName(name, child);
      if (Array.isArray(value[child])) {
        var values = value[child];
        if (values.length) {
          this.styles[cname] = values.join(' ');
        }
      } else if (value[child] !== '') {
        this.styles[cname] = value[child];
      }
    }
  } catch (e_10_1) {
    e_10 = {
      error: e_10_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_10) throw e_10.error;
    }
  }
}
function combineFont(_name) {}
var Styles = (function () {
  function Styles(cssText) {
    if (cssText === void 0) {
      cssText = '';
    }
    this.parse(cssText);
  }
  Object.defineProperty(Styles.prototype, "cssText", {
    get: function () {
      var e_11, _a;
      var styles = [];
      try {
        for (var _b = __values$u(Object.keys(this.styles)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var name_2 = _c.value;
          var parent_1 = this.parentName(name_2);
          if (!this.styles[parent_1]) {
            styles.push(name_2 + ': ' + this.styles[name_2] + ';');
          }
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_11) throw e_11.error;
        }
      }
      return styles.join(' ');
    },
    enumerable: false,
    configurable: true
  });
  Styles.prototype.set = function (name, value) {
    name = this.normalizeName(name);
    this.setStyle(name, value);
    if (Styles.connect[name] && !Styles.connect[name].combine) {
      this.combineChildren(name);
      delete this.styles[name];
    }
    while (name.match(/-/)) {
      name = this.parentName(name);
      if (!Styles.connect[name]) break;
      Styles.connect[name].combine.call(this, name);
    }
  };
  Styles.prototype.get = function (name) {
    name = this.normalizeName(name);
    return this.styles.hasOwnProperty(name) ? this.styles[name] : '';
  };
  Styles.prototype.setStyle = function (name, value) {
    this.styles[name] = value;
    if (Styles.connect[name] && Styles.connect[name].children) {
      Styles.connect[name].split.call(this, name);
    }
    if (value === '') {
      delete this.styles[name];
    }
  };
  Styles.prototype.combineChildren = function (name) {
    var e_12, _a;
    var parent = this.parentName(name);
    try {
      for (var _b = __values$u(Styles.connect[name].children), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        var cname = this.childName(parent, child);
        Styles.connect[cname].combine.call(this, cname);
      }
    } catch (e_12_1) {
      e_12 = {
        error: e_12_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_12) throw e_12.error;
      }
    }
  };
  Styles.prototype.parentName = function (name) {
    var parent = name.replace(/-[^-]*$/, '');
    return name === parent ? '' : parent;
  };
  Styles.prototype.childName = function (name, child) {
    if (child.match(/-/)) {
      return child;
    }
    if (Styles.connect[name] && !Styles.connect[name].combine) {
      child += name.replace(/.*-/, '-');
      name = this.parentName(name);
    }
    return name + '-' + child;
  };
  Styles.prototype.normalizeName = function (name) {
    return name.replace(/[A-Z]/g, function (c) {
      return '-' + c.toLowerCase();
    });
  };
  Styles.prototype.parse = function (cssText) {
    if (cssText === void 0) {
      cssText = '';
    }
    var PATTERN = this.constructor.pattern;
    this.styles = {};
    var parts = cssText.replace(PATTERN.comment, '').split(PATTERN.style);
    while (parts.length > 1) {
      var _a = __read$A(parts.splice(0, 3), 3), space = _a[0], name_3 = _a[1], value = _a[2];
      if (space.match(/[^\s\n]/)) return;
      this.set(name_3, value);
    }
  };
  Styles.pattern = {
    style: /([-a-z]+)[\s\n]*:[\s\n]*((?:'[^']*'|"[^"]*"|\n|.)*?)[\s\n]*(?:;|$)/g,
    comment: /\/\*[^]*?\*\//g
  };
  Styles.connect = {
    padding: {
      children: TRBL,
      split: splitTRBL,
      combine: combineTRBL
    },
    border: {
      children: TRBL,
      split: splitSame,
      combine: combineSame
    },
    'border-top': {
      children: WSC,
      split: splitWSC,
      combine: combineWSC
    },
    'border-right': {
      children: WSC,
      split: splitWSC,
      combine: combineWSC
    },
    'border-bottom': {
      children: WSC,
      split: splitWSC,
      combine: combineWSC
    },
    'border-left': {
      children: WSC,
      split: splitWSC,
      combine: combineWSC
    },
    'border-width': {
      children: TRBL,
      split: splitTRBL,
      combine: null
    },
    'border-style': {
      children: TRBL,
      split: splitTRBL,
      combine: null
    },
    'border-color': {
      children: TRBL,
      split: splitTRBL,
      combine: null
    },
    font: {
      children: ['style', 'variant', 'weight', 'stretch', 'line-height', 'size', 'family'],
      split: splitFont,
      combine: combineFont
    }
  };
  return Styles;
})();
Styles$1.Styles = Styles;

var StyleList = {};

var __values$t = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(StyleList, "__esModule", {
  value: true
});
StyleList.CssStyles = void 0;
var CssStyles = (function () {
  function CssStyles(styles) {
    if (styles === void 0) {
      styles = null;
    }
    this.styles = {};
    this.addStyles(styles);
  }
  Object.defineProperty(CssStyles.prototype, "cssText", {
    get: function () {
      return this.getStyleString();
    },
    enumerable: false,
    configurable: true
  });
  CssStyles.prototype.addStyles = function (styles) {
    var e_1, _a;
    if (!styles) return;
    try {
      for (var _b = __values$t(Object.keys(styles)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var style = _c.value;
        if (!this.styles[style]) {
          this.styles[style] = {};
        }
        Object.assign(this.styles[style], styles[style]);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  CssStyles.prototype.removeStyles = function () {
    var e_2, _a;
    var selectors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      selectors[_i] = arguments[_i];
    }
    try {
      for (var selectors_1 = __values$t(selectors), selectors_1_1 = selectors_1.next(); !selectors_1_1.done; selectors_1_1 = selectors_1.next()) {
        var selector = selectors_1_1.value;
        delete this.styles[selector];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (selectors_1_1 && !selectors_1_1.done && (_a = selectors_1.return)) _a.call(selectors_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  CssStyles.prototype.clear = function () {
    this.styles = {};
  };
  CssStyles.prototype.getStyleString = function () {
    return this.getStyleRules().join('\n\n');
  };
  CssStyles.prototype.getStyleRules = function () {
    var e_3, _a;
    var selectors = Object.keys(this.styles);
    var defs = new Array(selectors.length);
    var i = 0;
    try {
      for (var selectors_2 = __values$t(selectors), selectors_2_1 = selectors_2.next(); !selectors_2_1.done; selectors_2_1 = selectors_2.next()) {
        var selector = selectors_2_1.value;
        defs[i++] = selector + ' {\n' + this.getStyleDefString(this.styles[selector]) + '\n}';
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (selectors_2_1 && !selectors_2_1.done && (_a = selectors_2.return)) _a.call(selectors_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return defs;
  };
  CssStyles.prototype.getStyleDefString = function (styles) {
    var e_4, _a;
    var properties = Object.keys(styles);
    var values = new Array(properties.length);
    var i = 0;
    try {
      for (var properties_1 = __values$t(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
        var property = properties_1_1.value;
        values[i++] = '  ' + property + ': ' + styles[property] + ';';
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    return values.join('\n');
  };
  return CssStyles;
})();
StyleList.CssStyles = CssStyles;

var __extends$1c = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$8 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$8 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$8.apply(this, arguments);
});
var __read$z = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$s = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(OutputJax$1, "__esModule", {
  value: true
});
OutputJax$1.CommonOutputJax = void 0;
var OutputJax_js_1$1 = OutputJax;
var MathItem_js_1$2 = MathItem;
var Options_js_1$5 = Options;
var lengths_js_1$4 = lengths;
var Styles_js_1$1 = Styles$1;
var StyleList_js_1$1 = StyleList;
var CommonOutputJax = (function (_super) {
  __extends$1c(CommonOutputJax, _super);
  function CommonOutputJax(options, defaultFactory, defaultFont) {
    if (options === void 0) {
      options = null;
    }
    if (defaultFactory === void 0) {
      defaultFactory = null;
    }
    if (defaultFont === void 0) {
      defaultFont = null;
    }
    var _this = this;
    var _a = __read$z((0, Options_js_1$5.separateOptions)(options, defaultFont.OPTIONS), 2), jaxOptions = _a[0], fontOptions = _a[1];
    _this = _super.call(this, jaxOptions) || this;
    _this.factory = _this.options.wrapperFactory || new defaultFactory();
    _this.factory.jax = _this;
    _this.cssStyles = _this.options.cssStyles || new StyleList_js_1$1.CssStyles();
    _this.font = _this.options.font || new defaultFont(fontOptions);
    _this.unknownCache = new Map();
    return _this;
  }
  CommonOutputJax.prototype.typeset = function (math, html) {
    this.setDocument(html);
    var node = this.createNode();
    this.toDOM(math, node, html);
    return node;
  };
  CommonOutputJax.prototype.createNode = function () {
    var jax = this.constructor.NAME;
    return this.html('mjx-container', {
      'class': 'MathJax',
      jax: jax
    });
  };
  CommonOutputJax.prototype.setScale = function (node) {
    var scale = this.math.metrics.scale * this.options.scale;
    if (scale !== 1) {
      this.adaptor.setStyle(node, 'fontSize', (0, lengths_js_1$4.percent)(scale));
    }
  };
  CommonOutputJax.prototype.toDOM = function (math, node, html) {
    if (html === void 0) {
      html = null;
    }
    this.setDocument(html);
    this.math = math;
    this.pxPerEm = math.metrics.ex / this.font.params.x_height;
    math.root.setTeXclass(null);
    this.setScale(node);
    this.nodeMap = new Map();
    this.container = node;
    this.processMath(math.root, node);
    this.nodeMap = null;
    this.executeFilters(this.postFilters, math, html, node);
  };
  CommonOutputJax.prototype.getBBox = function (math, html) {
    this.setDocument(html);
    this.math = math;
    math.root.setTeXclass(null);
    this.nodeMap = new Map();
    var bbox = this.factory.wrap(math.root).getOuterBBox();
    this.nodeMap = null;
    return bbox;
  };
  CommonOutputJax.prototype.getMetrics = function (html) {
    var e_1, _a;
    this.setDocument(html);
    var adaptor = this.adaptor;
    var maps = this.getMetricMaps(html);
    try {
      for (var _b = __values$s(html.math), _c = _b.next(); !_c.done; _c = _b.next()) {
        var math = _c.value;
        var parent_1 = adaptor.parent(math.start.node);
        if (math.state() < MathItem_js_1$2.STATE.METRICS && parent_1) {
          var map = maps[math.display ? 1 : 0];
          var _d = map.get(parent_1), em = _d.em, ex = _d.ex, containerWidth = _d.containerWidth, lineWidth = _d.lineWidth, scale = _d.scale, family = _d.family;
          math.setMetrics(em, ex, containerWidth, lineWidth, scale);
          if (this.options.mtextInheritFont) {
            math.outputData.mtextFamily = family;
          }
          if (this.options.merrorInheritFont) {
            math.outputData.merrorFamily = family;
          }
          math.state(MathItem_js_1$2.STATE.METRICS);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  CommonOutputJax.prototype.getMetricsFor = function (node, display) {
    var getFamily = this.options.mtextInheritFont || this.options.merrorInheritFont;
    var test = this.getTestElement(node, display);
    var metrics = this.measureMetrics(test, getFamily);
    this.adaptor.remove(test);
    return metrics;
  };
  CommonOutputJax.prototype.getMetricMaps = function (html) {
    var e_2, _a, e_3, _b, e_4, _c, e_5, _d, e_6, _e;
    var adaptor = this.adaptor;
    var domMaps = [new Map(), new Map()];
    try {
      for (var _f = __values$s(html.math), _g = _f.next(); !_g.done; _g = _f.next()) {
        var math = _g.value;
        var node = adaptor.parent(math.start.node);
        if (node && math.state() < MathItem_js_1$2.STATE.METRICS) {
          var map = domMaps[math.display ? 1 : 0];
          if (!map.has(node)) {
            map.set(node, this.getTestElement(node, math.display));
          }
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    var getFamily = this.options.mtextInheritFont || this.options.merrorInheritFont;
    var maps = [new Map(), new Map()];
    try {
      for (var _h = __values$s(maps.keys()), _j = _h.next(); !_j.done; _j = _h.next()) {
        var i = _j.value;
        try {
          for (var _k = (e_4 = void 0, __values$s(domMaps[i].keys())), _l = _k.next(); !_l.done; _l = _k.next()) {
            var node = _l.value;
            maps[i].set(node, this.measureMetrics(domMaps[i].get(node), getFamily));
          }
        } catch (e_4_1) {
          e_4 = {
            error: e_4_1
          };
        } finally {
          try {
            if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
          } finally {
            if (e_4) throw e_4.error;
          }
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    try {
      for (var _m = __values$s(maps.keys()), _o = _m.next(); !_o.done; _o = _m.next()) {
        var i = _o.value;
        try {
          for (var _p = (e_6 = void 0, __values$s(domMaps[i].values())), _q = _p.next(); !_q.done; _q = _p.next()) {
            var node = _q.value;
            adaptor.remove(node);
          }
        } catch (e_6_1) {
          e_6 = {
            error: e_6_1
          };
        } finally {
          try {
            if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
          } finally {
            if (e_6) throw e_6.error;
          }
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
      } finally {
        if (e_5) throw e_5.error;
      }
    }
    return maps;
  };
  CommonOutputJax.prototype.getTestElement = function (node, display) {
    var adaptor = this.adaptor;
    if (!this.testInline) {
      this.testInline = this.html('mjx-test', {
        style: {
          display: 'inline-block',
          width: '100%',
          'font-style': 'normal',
          'font-weight': 'normal',
          'font-size': '100%',
          'font-size-adjust': 'none',
          'text-indent': 0,
          'text-transform': 'none',
          'letter-spacing': 'normal',
          'word-spacing': 'normal',
          overflow: 'hidden',
          height: '1px',
          'margin-right': '-1px'
        }
      }, [this.html('mjx-left-box', {
        style: {
          display: 'inline-block',
          width: 0,
          'float': 'left'
        }
      }), this.html('mjx-ex-box', {
        style: {
          position: 'absolute',
          overflow: 'hidden',
          width: '1px',
          height: '60ex'
        }
      }), this.html('mjx-right-box', {
        style: {
          display: 'inline-block',
          width: 0,
          'float': 'right'
        }
      })]);
      this.testDisplay = adaptor.clone(this.testInline);
      adaptor.setStyle(this.testDisplay, 'display', 'table');
      adaptor.setStyle(this.testDisplay, 'margin-right', '');
      adaptor.setStyle(adaptor.firstChild(this.testDisplay), 'display', 'none');
      var right = adaptor.lastChild(this.testDisplay);
      adaptor.setStyle(right, 'display', 'table-cell');
      adaptor.setStyle(right, 'width', '10000em');
      adaptor.setStyle(right, 'float', '');
    }
    return adaptor.append(node, adaptor.clone(display ? this.testDisplay : this.testInline));
  };
  CommonOutputJax.prototype.measureMetrics = function (node, getFamily) {
    var adaptor = this.adaptor;
    var family = getFamily ? adaptor.fontFamily(node) : '';
    var em = adaptor.fontSize(node);
    var _a = __read$z(adaptor.nodeSize(adaptor.childNode(node, 1)), 2), w = _a[0], h = _a[1];
    var ex = w ? h / 60 : em * this.options.exFactor;
    var containerWidth = !w ? 1000000 : adaptor.getStyle(node, 'display') === 'table' ? adaptor.nodeSize(adaptor.lastChild(node))[0] - 1 : adaptor.nodeBBox(adaptor.lastChild(node)).left - adaptor.nodeBBox(adaptor.firstChild(node)).left - 2;
    var scale = Math.max(this.options.minScale, this.options.matchFontHeight ? ex / this.font.params.x_height / em : 1);
    var lineWidth = 1000000;
    return {
      em: em,
      ex: ex,
      containerWidth: containerWidth,
      lineWidth: lineWidth,
      scale: scale,
      family: family
    };
  };
  CommonOutputJax.prototype.styleSheet = function (html) {
    var e_7, _a;
    this.setDocument(html);
    this.cssStyles.clear();
    this.cssStyles.addStyles(this.constructor.commonStyles);
    if (('getStyles' in html)) {
      try {
        for (var _b = __values$s(html.getStyles()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var styles = _c.value;
          this.cssStyles.addStyles(styles);
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
    }
    this.addWrapperStyles(this.cssStyles);
    this.addFontStyles(this.cssStyles);
    var sheet = this.html('style', {
      id: 'MJX-styles'
    }, [this.text('\n' + this.cssStyles.cssText + '\n')]);
    return sheet;
  };
  CommonOutputJax.prototype.addFontStyles = function (styles) {
    styles.addStyles(this.font.styles);
  };
  CommonOutputJax.prototype.addWrapperStyles = function (styles) {
    var e_8, _a;
    try {
      for (var _b = __values$s(this.factory.getKinds()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var kind = _c.value;
        this.addClassStyles(this.factory.getNodeClass(kind), styles);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_8) throw e_8.error;
      }
    }
  };
  CommonOutputJax.prototype.addClassStyles = function (CLASS, styles) {
    styles.addStyles(CLASS.styles);
  };
  CommonOutputJax.prototype.setDocument = function (html) {
    if (html) {
      this.document = html;
      this.adaptor.document = html.document;
    }
  };
  CommonOutputJax.prototype.html = function (type, def, content, ns) {
    if (def === void 0) {
      def = {};
    }
    if (content === void 0) {
      content = [];
    }
    return this.adaptor.node(type, def, content, ns);
  };
  CommonOutputJax.prototype.text = function (text) {
    return this.adaptor.text(text);
  };
  CommonOutputJax.prototype.fixed = function (m, n) {
    if (n === void 0) {
      n = 3;
    }
    if (Math.abs(m) < .0006) {
      return '0';
    }
    return m.toFixed(n).replace(/\.?0+$/, '');
  };
  CommonOutputJax.prototype.measureText = function (text, variant, font) {
    if (font === void 0) {
      font = ['', false, false];
    }
    var node = this.unknownText(text, variant);
    if (variant === '-explicitFont') {
      var styles = this.cssFontStyles(font);
      this.adaptor.setAttributes(node, {
        style: styles
      });
    }
    return this.measureTextNodeWithCache(node, text, variant, font);
  };
  CommonOutputJax.prototype.measureTextNodeWithCache = function (text, chars, variant, font) {
    if (font === void 0) {
      font = ['', false, false];
    }
    if (variant === '-explicitFont') {
      variant = [font[0], font[1] ? 'T' : 'F', font[2] ? 'T' : 'F', ''].join('-');
    }
    if (!this.unknownCache.has(variant)) {
      this.unknownCache.set(variant, new Map());
    }
    var map = this.unknownCache.get(variant);
    var cached = map.get(chars);
    if (cached) return cached;
    var bbox = this.measureTextNode(text);
    map.set(chars, bbox);
    return bbox;
  };
  CommonOutputJax.prototype.measureXMLnode = function (xml) {
    var adaptor = this.adaptor;
    var content = this.html('mjx-xml-block', {
      style: {
        display: 'inline-block'
      }
    }, [adaptor.clone(xml)]);
    var base = this.html('mjx-baseline', {
      style: {
        display: 'inline-block',
        width: 0,
        height: 0
      }
    });
    var style = {
      position: 'absolute',
      display: 'inline-block',
      'font-family': 'initial',
      'line-height': 'normal'
    };
    var node = this.html('mjx-measure-xml', {
      style: style
    }, [base, content]);
    adaptor.append(adaptor.parent(this.math.start.node), this.container);
    adaptor.append(this.container, node);
    var em = this.math.metrics.em * this.math.metrics.scale;
    var _a = adaptor.nodeBBox(content), left = _a.left, right = _a.right, bottom = _a.bottom, top = _a.top;
    var w = (right - left) / em;
    var h = (adaptor.nodeBBox(base).top - top) / em;
    var d = (bottom - top) / em - h;
    adaptor.remove(this.container);
    adaptor.remove(node);
    return {
      w: w,
      h: h,
      d: d
    };
  };
  CommonOutputJax.prototype.cssFontStyles = function (font, styles) {
    if (styles === void 0) {
      styles = {};
    }
    var _a = __read$z(font, 3), family = _a[0], italic = _a[1], bold = _a[2];
    styles['font-family'] = this.font.getFamily(family);
    if (italic) styles['font-style'] = 'italic';
    if (bold) styles['font-weight'] = 'bold';
    return styles;
  };
  CommonOutputJax.prototype.getFontData = function (styles) {
    if (!styles) {
      styles = new Styles_js_1$1.Styles();
    }
    return [this.font.getFamily(styles.get('font-family')), styles.get('font-style') === 'italic', styles.get('font-weight') === 'bold'];
  };
  CommonOutputJax.NAME = 'Common';
  CommonOutputJax.OPTIONS = __assign$8(__assign$8({}, OutputJax_js_1$1.AbstractOutputJax.OPTIONS), {
    scale: 1,
    minScale: .5,
    mtextInheritFont: false,
    merrorInheritFont: false,
    mtextFont: '',
    merrorFont: 'serif',
    mathmlSpacing: false,
    skipAttributes: {},
    exFactor: .5,
    displayAlign: 'center',
    displayIndent: '0',
    wrapperFactory: null,
    font: null,
    cssStyles: null
  });
  CommonOutputJax.commonStyles = {};
  return CommonOutputJax;
})(OutputJax_js_1$1.AbstractOutputJax);
OutputJax$1.CommonOutputJax = CommonOutputJax;

var WrapperFactory$2 = {};

var WrapperFactory$1 = {};

var WrapperFactory = {};

var __extends$1b = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$y = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$h = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(WrapperFactory, "__esModule", {
  value: true
});
WrapperFactory.AbstractWrapperFactory = void 0;
var Factory_js_1 = Factory;
var AbstractWrapperFactory = (function (_super) {
  __extends$1b(AbstractWrapperFactory, _super);
  function AbstractWrapperFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AbstractWrapperFactory.prototype.wrap = function (node) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    return this.create.apply(this, __spreadArray$h([node.kind, node], __read$y(args), false));
  };
  return AbstractWrapperFactory;
})(Factory_js_1.AbstractFactory);
WrapperFactory.AbstractWrapperFactory = AbstractWrapperFactory;

var __extends$1a = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(WrapperFactory$1, "__esModule", {
  value: true
});
WrapperFactory$1.CommonWrapperFactory = void 0;
var WrapperFactory_js_1$2 = WrapperFactory;
var CommonWrapperFactory = (function (_super) {
  __extends$1a(CommonWrapperFactory, _super);
  function CommonWrapperFactory() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.jax = null;
    return _this;
  }
  Object.defineProperty(CommonWrapperFactory.prototype, "Wrappers", {
    get: function () {
      return this.node;
    },
    enumerable: false,
    configurable: true
  });
  CommonWrapperFactory.defaultNodes = {};
  return CommonWrapperFactory;
})(WrapperFactory_js_1$2.AbstractWrapperFactory);
WrapperFactory$1.CommonWrapperFactory = CommonWrapperFactory;

var Wrappers = {};

var Wrapper$2 = {};

var Wrapper$1 = {};

var Wrapper = {};

Object.defineProperty(Wrapper, "__esModule", {
  value: true
});
Wrapper.AbstractWrapper = void 0;
var AbstractWrapper = (function () {
  function AbstractWrapper(factory, node) {
    this.factory = factory;
    this.node = node;
  }
  Object.defineProperty(AbstractWrapper.prototype, "kind", {
    get: function () {
      return this.node.kind;
    },
    enumerable: false,
    configurable: true
  });
  AbstractWrapper.prototype.wrap = function (node) {
    return this.factory.wrap(node);
  };
  return AbstractWrapper;
})();
Wrapper.AbstractWrapper = AbstractWrapper;

var BBox$1 = {};

Object.defineProperty(BBox$1, "__esModule", {
  value: true
});
BBox$1.BBox = void 0;
var lengths_js_1$3 = lengths;
var BBox = (function () {
  function BBox(def) {
    if (def === void 0) {
      def = {
        w: 0,
        h: -lengths_js_1$3.BIGDIMEN,
        d: -lengths_js_1$3.BIGDIMEN
      };
    }
    this.w = def.w || 0;
    this.h = ('h' in def) ? def.h : -lengths_js_1$3.BIGDIMEN;
    this.d = ('d' in def) ? def.d : -lengths_js_1$3.BIGDIMEN;
    this.L = this.R = this.ic = this.sk = this.dx = 0;
    this.scale = this.rscale = 1;
    this.pwidth = '';
  }
  BBox.zero = function () {
    return new BBox({
      h: 0,
      d: 0,
      w: 0
    });
  };
  BBox.empty = function () {
    return new BBox();
  };
  BBox.prototype.empty = function () {
    this.w = 0;
    this.h = this.d = -lengths_js_1$3.BIGDIMEN;
    return this;
  };
  BBox.prototype.clean = function () {
    if (this.w === -lengths_js_1$3.BIGDIMEN) this.w = 0;
    if (this.h === -lengths_js_1$3.BIGDIMEN) this.h = 0;
    if (this.d === -lengths_js_1$3.BIGDIMEN) this.d = 0;
  };
  BBox.prototype.rescale = function (scale) {
    this.w *= scale;
    this.h *= scale;
    this.d *= scale;
  };
  BBox.prototype.combine = function (cbox, x, y) {
    if (x === void 0) {
      x = 0;
    }
    if (y === void 0) {
      y = 0;
    }
    var rscale = cbox.rscale;
    var w = x + rscale * (cbox.w + cbox.L + cbox.R);
    var h = y + rscale * cbox.h;
    var d = rscale * cbox.d - y;
    if (w > this.w) this.w = w;
    if (h > this.h) this.h = h;
    if (d > this.d) this.d = d;
  };
  BBox.prototype.append = function (cbox) {
    var scale = cbox.rscale;
    this.w += scale * (cbox.w + cbox.L + cbox.R);
    if (scale * cbox.h > this.h) {
      this.h = scale * cbox.h;
    }
    if (scale * cbox.d > this.d) {
      this.d = scale * cbox.d;
    }
  };
  BBox.prototype.updateFrom = function (cbox) {
    this.h = cbox.h;
    this.d = cbox.d;
    this.w = cbox.w;
    if (cbox.pwidth) {
      this.pwidth = cbox.pwidth;
    }
  };
  BBox.fullWidth = '100%';
  BBox.StyleAdjust = [['borderTopWidth', 'h'], ['borderRightWidth', 'w'], ['borderBottomWidth', 'd'], ['borderLeftWidth', 'w', 0], ['paddingTop', 'h'], ['paddingRight', 'w'], ['paddingBottom', 'd'], ['paddingLeft', 'w', 0]];
  return BBox;
})();
BBox$1.BBox = BBox;

var FontData$2 = {};

var __assign$7 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$7 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$7.apply(this, arguments);
});
var __read$x = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$g = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$r = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(FontData$2, "__esModule", {
  value: true
});
FontData$2.FontData = FontData$2.NOSTRETCH = FontData$2.H = FontData$2.V = void 0;
var Options_js_1$4 = Options;
FontData$2.V = 1;
FontData$2.H = 2;
FontData$2.NOSTRETCH = {
  dir: 0
};
var FontData$1 = (function () {
  function FontData(options) {
    var e_1, _a, e_2, _b;
    if (options === void 0) {
      options = null;
    }
    this.variant = {};
    this.delimiters = {};
    this.cssFontMap = {};
    this.remapChars = {};
    this.skewIcFactor = .75;
    var CLASS = this.constructor;
    this.options = (0, Options_js_1$4.userOptions)((0, Options_js_1$4.defaultOptions)({}, CLASS.OPTIONS), options);
    this.params = __assign$7({}, CLASS.defaultParams);
    this.sizeVariants = __spreadArray$g([], __read$x(CLASS.defaultSizeVariants), false);
    this.stretchVariants = __spreadArray$g([], __read$x(CLASS.defaultStretchVariants), false);
    this.cssFontMap = __assign$7({}, CLASS.defaultCssFonts);
    try {
      for (var _c = __values$r(Object.keys(this.cssFontMap)), _d = _c.next(); !_d.done; _d = _c.next()) {
        var name_1 = _d.value;
        if (this.cssFontMap[name_1][0] === 'unknown') {
          this.cssFontMap[name_1][0] = this.options.unknownFamily;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    this.cssFamilyPrefix = CLASS.defaultCssFamilyPrefix;
    this.createVariants(CLASS.defaultVariants);
    this.defineDelimiters(CLASS.defaultDelimiters);
    try {
      for (var _e = __values$r(Object.keys(CLASS.defaultChars)), _f = _e.next(); !_f.done; _f = _e.next()) {
        var name_2 = _f.value;
        this.defineChars(name_2, CLASS.defaultChars[name_2]);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    this.defineRemap('accent', CLASS.defaultAccentMap);
    this.defineRemap('mo', CLASS.defaultMoMap);
    this.defineRemap('mn', CLASS.defaultMnMap);
  }
  FontData.charOptions = function (font, n) {
    var char = font[n];
    if (char.length === 3) {
      char[3] = {};
    }
    return char[3];
  };
  Object.defineProperty(FontData.prototype, "styles", {
    get: function () {
      return this._styles;
    },
    set: function (style) {
      this._styles = style;
    },
    enumerable: false,
    configurable: true
  });
  FontData.prototype.createVariant = function (name, inherit, link) {
    if (inherit === void 0) {
      inherit = null;
    }
    if (link === void 0) {
      link = null;
    }
    var variant = {
      linked: [],
      chars: inherit ? Object.create(this.variant[inherit].chars) : {}
    };
    if (link && this.variant[link]) {
      Object.assign(variant.chars, this.variant[link].chars);
      this.variant[link].linked.push(variant.chars);
      variant.chars = Object.create(variant.chars);
    }
    this.remapSmpChars(variant.chars, name);
    this.variant[name] = variant;
  };
  FontData.prototype.remapSmpChars = function (chars, name) {
    var e_3, _a, e_4, _b;
    var CLASS = this.constructor;
    if (CLASS.VariantSmp[name]) {
      var SmpRemap = CLASS.SmpRemap;
      var SmpGreek = [null, null, CLASS.SmpRemapGreekU, CLASS.SmpRemapGreekL];
      try {
        for (var _c = __values$r(CLASS.SmpRanges), _d = _c.next(); !_d.done; _d = _c.next()) {
          var _e = __read$x(_d.value, 3), i = _e[0], lo = _e[1], hi = _e[2];
          var base = CLASS.VariantSmp[name][i];
          if (!base) continue;
          for (var n = lo; n <= hi; n++) {
            if (n === 0x3A2) continue;
            var smp = base + n - lo;
            chars[n] = this.smpChar(SmpRemap[smp] || smp);
          }
          if (SmpGreek[i]) {
            try {
              for (var _f = (e_4 = void 0, __values$r(Object.keys(SmpGreek[i]).map(function (x) {
                return parseInt(x);
              }))), _g = _f.next(); !_g.done; _g = _f.next()) {
                var n = _g.value;
                chars[n] = this.smpChar(base + SmpGreek[i][n]);
              }
            } catch (e_4_1) {
              e_4 = {
                error: e_4_1
              };
            } finally {
              try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
              } finally {
                if (e_4) throw e_4.error;
              }
            }
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    }
    if (name === 'bold') {
      chars[0x3DC] = this.smpChar(0x1D7CA);
      chars[0x3DD] = this.smpChar(0x1D7CB);
    }
  };
  FontData.prototype.smpChar = function (n) {
    return [, , , {
      smp: n
    }];
  };
  FontData.prototype.createVariants = function (variants) {
    var e_5, _a;
    try {
      for (var variants_1 = __values$r(variants), variants_1_1 = variants_1.next(); !variants_1_1.done; variants_1_1 = variants_1.next()) {
        var variant = variants_1_1.value;
        this.createVariant(variant[0], variant[1], variant[2]);
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (variants_1_1 && !variants_1_1.done && (_a = variants_1.return)) _a.call(variants_1);
      } finally {
        if (e_5) throw e_5.error;
      }
    }
  };
  FontData.prototype.defineChars = function (name, chars) {
    var e_6, _a;
    var variant = this.variant[name];
    Object.assign(variant.chars, chars);
    try {
      for (var _b = __values$r(variant.linked), _c = _b.next(); !_c.done; _c = _b.next()) {
        var link = _c.value;
        Object.assign(link, chars);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_6) throw e_6.error;
      }
    }
  };
  FontData.prototype.defineDelimiters = function (delims) {
    Object.assign(this.delimiters, delims);
  };
  FontData.prototype.defineRemap = function (name, remap) {
    if (!this.remapChars.hasOwnProperty(name)) {
      this.remapChars[name] = {};
    }
    Object.assign(this.remapChars[name], remap);
  };
  FontData.prototype.getDelimiter = function (n) {
    return this.delimiters[n];
  };
  FontData.prototype.getSizeVariant = function (n, i) {
    if (this.delimiters[n].variants) {
      i = this.delimiters[n].variants[i];
    }
    return this.sizeVariants[i];
  };
  FontData.prototype.getStretchVariant = function (n, i) {
    return this.stretchVariants[this.delimiters[n].stretchv ? this.delimiters[n].stretchv[i] : 0];
  };
  FontData.prototype.getChar = function (name, n) {
    return this.variant[name].chars[n];
  };
  FontData.prototype.getVariant = function (name) {
    return this.variant[name];
  };
  FontData.prototype.getCssFont = function (variant) {
    return this.cssFontMap[variant] || ['serif', false, false];
  };
  FontData.prototype.getFamily = function (family) {
    return this.cssFamilyPrefix ? this.cssFamilyPrefix + ', ' + family : family;
  };
  FontData.prototype.getRemappedChar = function (name, c) {
    var map = this.remapChars[name] || ({});
    return map[c];
  };
  FontData.OPTIONS = {
    unknownFamily: 'serif'
  };
  FontData.JAX = 'common';
  FontData.NAME = '';
  FontData.defaultVariants = [['normal'], ['bold', 'normal'], ['italic', 'normal'], ['bold-italic', 'italic', 'bold'], ['double-struck', 'bold'], ['fraktur', 'normal'], ['bold-fraktur', 'bold', 'fraktur'], ['script', 'italic'], ['bold-script', 'bold-italic', 'script'], ['sans-serif', 'normal'], ['bold-sans-serif', 'bold', 'sans-serif'], ['sans-serif-italic', 'italic', 'sans-serif'], ['sans-serif-bold-italic', 'bold-italic', 'bold-sans-serif'], ['monospace', 'normal']];
  FontData.defaultCssFonts = {
    normal: ['unknown', false, false],
    bold: ['unknown', false, true],
    italic: ['unknown', true, false],
    'bold-italic': ['unknown', true, true],
    'double-struck': ['unknown', false, true],
    fraktur: ['unknown', false, false],
    'bold-fraktur': ['unknown', false, true],
    script: ['cursive', false, false],
    'bold-script': ['cursive', false, true],
    'sans-serif': ['sans-serif', false, false],
    'bold-sans-serif': ['sans-serif', false, true],
    'sans-serif-italic': ['sans-serif', true, false],
    'sans-serif-bold-italic': ['sans-serif', true, true],
    monospace: ['monospace', false, false]
  };
  FontData.defaultCssFamilyPrefix = '';
  FontData.VariantSmp = {
    bold: [0x1D400, 0x1D41A, 0x1D6A8, 0x1D6C2, 0x1D7CE],
    italic: [0x1D434, 0x1D44E, 0x1D6E2, 0x1D6FC],
    'bold-italic': [0x1D468, 0x1D482, 0x1D71C, 0x1D736],
    script: [0x1D49C, 0x1D4B6],
    'bold-script': [0x1D4D0, 0x1D4EA],
    fraktur: [0x1D504, 0x1D51E],
    'double-struck': [0x1D538, 0x1D552, , , 0x1D7D8],
    'bold-fraktur': [0x1D56C, 0x1D586],
    'sans-serif': [0x1D5A0, 0x1D5BA, , , 0x1D7E2],
    'bold-sans-serif': [0x1D5D4, 0x1D5EE, 0x1D756, 0x1D770, 0x1D7EC],
    'sans-serif-italic': [0x1D608, 0x1D622],
    'sans-serif-bold-italic': [0x1D63C, 0x1D656, 0x1D790, 0x1D7AA],
    'monospace': [0x1D670, 0x1D68A, , , 0x1D7F6]
  };
  FontData.SmpRanges = [[0, 0x41, 0x5A], [1, 0x61, 0x7A], [2, 0x391, 0x3A9], [3, 0x3B1, 0x3C9], [4, 0x30, 0x39]];
  FontData.SmpRemap = {
    0x1D455: 0x210E,
    0x1D49D: 0x212C,
    0x1D4A0: 0x2130,
    0x1D4A1: 0x2131,
    0x1D4A3: 0x210B,
    0x1D4A4: 0x2110,
    0x1D4A7: 0x2112,
    0x1D4A8: 0x2133,
    0x1D4AD: 0x211B,
    0x1D4BA: 0x212F,
    0x1D4BC: 0x210A,
    0x1D4C4: 0x2134,
    0x1D506: 0x212D,
    0x1D50B: 0x210C,
    0x1D50C: 0x2111,
    0x1D515: 0x211C,
    0x1D51D: 0x2128,
    0x1D53A: 0x2102,
    0x1D53F: 0x210D,
    0x1D545: 0x2115,
    0x1D547: 0x2119,
    0x1D548: 0x211A,
    0x1D549: 0x211D,
    0x1D551: 0x2124
  };
  FontData.SmpRemapGreekU = {
    0x2207: 0x19,
    0x03F4: 0x11
  };
  FontData.SmpRemapGreekL = {
    0x3D1: 0x1B,
    0x3D5: 0x1D,
    0x3D6: 0x1F,
    0x3F0: 0x1C,
    0x3F1: 0x1E,
    0x3F5: 0x1A,
    0x2202: 0x19
  };
  FontData.defaultAccentMap = {
    0x0300: '\u02CB',
    0x0301: '\u02CA',
    0x0302: '\u02C6',
    0x0303: '\u02DC',
    0x0304: '\u02C9',
    0x0306: '\u02D8',
    0x0307: '\u02D9',
    0x0308: '\u00A8',
    0x030A: '\u02DA',
    0x030C: '\u02C7',
    0x2192: '\u20D7',
    0x2032: '\'',
    0x2033: '\'\'',
    0x2034: '\'\'\'',
    0x2035: '`',
    0x2036: '``',
    0x2037: '```',
    0x2057: '\'\'\'\'',
    0x20D0: '\u21BC',
    0x20D1: '\u21C0',
    0x20D6: '\u2190',
    0x20E1: '\u2194',
    0x20F0: '*',
    0x20DB: '...',
    0x20DC: '....',
    0x20EC: '\u21C1',
    0x20ED: '\u21BD',
    0x20EE: '\u2190',
    0x20EF: '\u2192'
  };
  FontData.defaultMoMap = {
    0x002D: '\u2212'
  };
  FontData.defaultMnMap = {
    0x002D: '\u2212'
  };
  FontData.defaultParams = {
    x_height: .442,
    quad: 1,
    num1: .676,
    num2: .394,
    num3: .444,
    denom1: .686,
    denom2: .345,
    sup1: .413,
    sup2: .363,
    sup3: .289,
    sub1: .15,
    sub2: .247,
    sup_drop: .386,
    sub_drop: .05,
    delim1: 2.39,
    delim2: 1.0,
    axis_height: .25,
    rule_thickness: .06,
    big_op_spacing1: .111,
    big_op_spacing2: .167,
    big_op_spacing3: .2,
    big_op_spacing4: .6,
    big_op_spacing5: .1,
    surd_height: .075,
    scriptspace: .05,
    nulldelimiterspace: .12,
    delimiterfactor: 901,
    delimitershortfall: .3,
    min_rule_thickness: 1.25,
    separation_factor: 1.75,
    extra_ic: .033
  };
  FontData.defaultDelimiters = {};
  FontData.defaultChars = {};
  FontData.defaultSizeVariants = [];
  FontData.defaultStretchVariants = [];
  return FontData;
})();
FontData$2.FontData = FontData$1;

var __extends$19 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __createBinding$9 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$9 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$9 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$9(result, mod, k);
  __setModuleDefault$9(result, mod);
  return result;
});
var __values$q = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$w = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$f = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(Wrapper$1, "__esModule", {
  value: true
});
Wrapper$1.CommonWrapper = void 0;
var Wrapper_js_1$n = Wrapper;
var MmlNode_js_1$c = MmlNode;
var string_js_1$6 = string;
var LENGTHS$1 = __importStar$9(lengths);
var Styles_js_1 = Styles$1;
var BBox_js_1$5 = BBox$1;
var FontData_js_1$j = FontData$2;
var SMALLSIZE = 2 / 18;
function MathMLSpace(script, size) {
  return script ? size < SMALLSIZE ? 0 : SMALLSIZE : size;
}
var CommonWrapper = (function (_super) {
  __extends$19(CommonWrapper, _super);
  function CommonWrapper(factory, node, parent) {
    if (parent === void 0) {
      parent = null;
    }
    var _this = _super.call(this, factory, node) || this;
    _this.parent = null;
    _this.removedStyles = null;
    _this.styles = null;
    _this.variant = '';
    _this.bboxComputed = false;
    _this.stretch = FontData_js_1$j.NOSTRETCH;
    _this.font = null;
    _this.parent = parent;
    _this.font = factory.jax.font;
    _this.bbox = BBox_js_1$5.BBox.zero();
    _this.getStyles();
    _this.getVariant();
    _this.getScale();
    _this.getSpace();
    _this.childNodes = node.childNodes.map(function (child) {
      var wrapped = _this.wrap(child);
      if (wrapped.bbox.pwidth && (node.notParent || node.isKind('math'))) {
        _this.bbox.pwidth = BBox_js_1$5.BBox.fullWidth;
      }
      return wrapped;
    });
    return _this;
  }
  Object.defineProperty(CommonWrapper.prototype, "jax", {
    get: function () {
      return this.factory.jax;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonWrapper.prototype, "adaptor", {
    get: function () {
      return this.factory.jax.adaptor;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonWrapper.prototype, "metrics", {
    get: function () {
      return this.factory.jax.math.metrics;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonWrapper.prototype, "fixesPWidth", {
    get: function () {
      return !this.node.notParent && !this.node.isToken;
    },
    enumerable: false,
    configurable: true
  });
  CommonWrapper.prototype.wrap = function (node, parent) {
    if (parent === void 0) {
      parent = null;
    }
    var wrapped = this.factory.wrap(node, parent || this);
    if (parent) {
      parent.childNodes.push(wrapped);
    }
    this.jax.nodeMap.set(node, wrapped);
    return wrapped;
  };
  CommonWrapper.prototype.getBBox = function (save) {
    if (save === void 0) {
      save = true;
    }
    if (this.bboxComputed) {
      return this.bbox;
    }
    var bbox = save ? this.bbox : BBox_js_1$5.BBox.zero();
    this.computeBBox(bbox);
    this.bboxComputed = save;
    return bbox;
  };
  CommonWrapper.prototype.getOuterBBox = function (save) {
    var e_1, _a;
    if (save === void 0) {
      save = true;
    }
    var bbox = this.getBBox(save);
    if (!this.styles) return bbox;
    var obox = new BBox_js_1$5.BBox();
    Object.assign(obox, bbox);
    try {
      for (var _b = __values$q(BBox_js_1$5.BBox.StyleAdjust), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = __read$w(_c.value, 2), name_1 = _d[0], side = _d[1];
        var x = this.styles.get(name_1);
        if (x) {
          obox[side] += this.length2em(x, 1, obox.rscale);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return obox;
  };
  CommonWrapper.prototype.computeBBox = function (bbox, recompute) {
    var e_2, _a;
    if (recompute === void 0) {
      recompute = false;
    }
    bbox.empty();
    try {
      for (var _b = __values$q(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        bbox.append(child.getOuterBBox());
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    bbox.clean();
    if (this.fixesPWidth && this.setChildPWidths(recompute)) {
      this.computeBBox(bbox, true);
    }
  };
  CommonWrapper.prototype.setChildPWidths = function (recompute, w, clear) {
    var e_3, _a;
    if (w === void 0) {
      w = null;
    }
    if (clear === void 0) {
      clear = true;
    }
    if (recompute) {
      return false;
    }
    if (clear) {
      this.bbox.pwidth = '';
    }
    var changed = false;
    try {
      for (var _b = __values$q(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        var cbox = child.getOuterBBox();
        if (cbox.pwidth && child.setChildPWidths(recompute, w === null ? cbox.w : w, clear)) {
          changed = true;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return changed;
  };
  CommonWrapper.prototype.invalidateBBox = function () {
    if (this.bboxComputed) {
      this.bboxComputed = false;
      if (this.parent) {
        this.parent.invalidateBBox();
      }
    }
  };
  CommonWrapper.prototype.copySkewIC = function (bbox) {
    var first = this.childNodes[0];
    if (first === null || first === void 0 ? void 0 : first.bbox.sk) {
      bbox.sk = first.bbox.sk;
    }
    if (first === null || first === void 0 ? void 0 : first.bbox.dx) {
      bbox.dx = first.bbox.dx;
    }
    var last = this.childNodes[this.childNodes.length - 1];
    if (last === null || last === void 0 ? void 0 : last.bbox.ic) {
      bbox.ic = last.bbox.ic;
      bbox.w += bbox.ic;
    }
  };
  CommonWrapper.prototype.getStyles = function () {
    var styleString = this.node.attributes.getExplicit('style');
    if (!styleString) return;
    var style = this.styles = new Styles_js_1.Styles(styleString);
    for (var i = 0, m = CommonWrapper.removeStyles.length; i < m; i++) {
      var id = CommonWrapper.removeStyles[i];
      if (style.get(id)) {
        if (!this.removedStyles) this.removedStyles = {};
        this.removedStyles[id] = style.get(id);
        style.set(id, '');
      }
    }
  };
  CommonWrapper.prototype.getVariant = function () {
    if (!this.node.isToken) return;
    var attributes = this.node.attributes;
    var variant = attributes.get('mathvariant');
    if (!attributes.getExplicit('mathvariant')) {
      var values = attributes.getList('fontfamily', 'fontweight', 'fontstyle');
      if (this.removedStyles) {
        var style = this.removedStyles;
        if (style.fontFamily) values.family = style.fontFamily;
        if (style.fontWeight) values.weight = style.fontWeight;
        if (style.fontStyle) values.style = style.fontStyle;
      }
      if (values.fontfamily) values.family = values.fontfamily;
      if (values.fontweight) values.weight = values.fontweight;
      if (values.fontstyle) values.style = values.fontstyle;
      if (values.weight && values.weight.match(/^\d+$/)) {
        values.weight = parseInt(values.weight) > 600 ? 'bold' : 'normal';
      }
      if (values.family) {
        variant = this.explicitVariant(values.family, values.weight, values.style);
      } else {
        if (this.node.getProperty('variantForm')) variant = '-tex-variant';
        variant = (CommonWrapper.BOLDVARIANTS[values.weight] || ({}))[variant] || variant;
        variant = (CommonWrapper.ITALICVARIANTS[values.style] || ({}))[variant] || variant;
      }
    }
    this.variant = variant;
  };
  CommonWrapper.prototype.explicitVariant = function (fontFamily, fontWeight, fontStyle) {
    var style = this.styles;
    if (!style) style = this.styles = new Styles_js_1.Styles();
    style.set('fontFamily', fontFamily);
    if (fontWeight) style.set('fontWeight', fontWeight);
    if (fontStyle) style.set('fontStyle', fontStyle);
    return '-explicitFont';
  };
  CommonWrapper.prototype.getScale = function () {
    var scale = 1, parent = this.parent;
    var pscale = parent ? parent.bbox.scale : 1;
    var attributes = this.node.attributes;
    var scriptlevel = Math.min(attributes.get('scriptlevel'), 2);
    var fontsize = attributes.get('fontsize');
    var mathsize = this.node.isToken || this.node.isKind('mstyle') ? attributes.get('mathsize') : attributes.getInherited('mathsize');
    if (scriptlevel !== 0) {
      scale = Math.pow(attributes.get('scriptsizemultiplier'), scriptlevel);
      var scriptminsize = this.length2em(attributes.get('scriptminsize'), .8, 1);
      if (scale < scriptminsize) scale = scriptminsize;
    }
    if (this.removedStyles && this.removedStyles.fontSize && !fontsize) {
      fontsize = this.removedStyles.fontSize;
    }
    if (fontsize && !attributes.getExplicit('mathsize')) {
      mathsize = fontsize;
    }
    if (mathsize !== '1') {
      scale *= this.length2em(mathsize, 1, 1);
    }
    this.bbox.scale = scale;
    this.bbox.rscale = scale / pscale;
  };
  CommonWrapper.prototype.getSpace = function () {
    var isTop = this.isTopEmbellished();
    var hasSpacing = this.node.hasSpacingAttributes();
    if (this.jax.options.mathmlSpacing || hasSpacing) {
      isTop && this.getMathMLSpacing();
    } else {
      this.getTeXSpacing(isTop, hasSpacing);
    }
  };
  CommonWrapper.prototype.getMathMLSpacing = function () {
    var node = this.node.coreMO();
    var child = node.coreParent();
    var parent = child.parent;
    if (!parent || !parent.isKind('mrow') || parent.childNodes.length === 1) return;
    var attributes = node.attributes;
    var isScript = attributes.get('scriptlevel') > 0;
    this.bbox.L = attributes.isSet('lspace') ? Math.max(0, this.length2em(attributes.get('lspace'))) : MathMLSpace(isScript, node.lspace);
    this.bbox.R = attributes.isSet('rspace') ? Math.max(0, this.length2em(attributes.get('rspace'))) : MathMLSpace(isScript, node.rspace);
    var n = parent.childIndex(child);
    if (n === 0) return;
    var prev = parent.childNodes[n - 1];
    if (!prev.isEmbellished) return;
    var bbox = this.jax.nodeMap.get(prev).getBBox();
    if (bbox.R) {
      this.bbox.L = Math.max(0, this.bbox.L - bbox.R);
    }
  };
  CommonWrapper.prototype.getTeXSpacing = function (isTop, hasSpacing) {
    if (!hasSpacing) {
      var space = this.node.texSpacing();
      if (space) {
        this.bbox.L = this.length2em(space);
      }
    }
    if (isTop || hasSpacing) {
      var attributes = this.node.coreMO().attributes;
      if (attributes.isSet('lspace')) {
        this.bbox.L = Math.max(0, this.length2em(attributes.get('lspace')));
      }
      if (attributes.isSet('rspace')) {
        this.bbox.R = Math.max(0, this.length2em(attributes.get('rspace')));
      }
    }
  };
  CommonWrapper.prototype.isTopEmbellished = function () {
    return this.node.isEmbellished && !(this.node.parent && this.node.parent.isEmbellished);
  };
  CommonWrapper.prototype.core = function () {
    return this.jax.nodeMap.get(this.node.core());
  };
  CommonWrapper.prototype.coreMO = function () {
    return this.jax.nodeMap.get(this.node.coreMO());
  };
  CommonWrapper.prototype.getText = function () {
    var e_4, _a;
    var text = '';
    if (this.node.isToken) {
      try {
        for (var _b = __values$q(this.node.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (child instanceof MmlNode_js_1$c.TextNode) {
            text += child.getText();
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
    }
    return text;
  };
  CommonWrapper.prototype.canStretch = function (direction) {
    this.stretch = FontData_js_1$j.NOSTRETCH;
    if (this.node.isEmbellished) {
      var core = this.core();
      if (core && core.node !== this.node) {
        if (core.canStretch(direction)) {
          this.stretch = core.stretch;
        }
      }
    }
    return this.stretch.dir !== 0;
  };
  CommonWrapper.prototype.getAlignShift = function () {
    var _a;
    var _b = (_a = this.node.attributes).getList.apply(_a, __spreadArray$f([], __read$w(MmlNode_js_1$c.indentAttributes), false)), indentalign = _b.indentalign, indentshift = _b.indentshift, indentalignfirst = _b.indentalignfirst, indentshiftfirst = _b.indentshiftfirst;
    if (indentalignfirst !== 'indentalign') {
      indentalign = indentalignfirst;
    }
    if (indentalign === 'auto') {
      indentalign = this.jax.options.displayAlign;
    }
    if (indentshiftfirst !== 'indentshift') {
      indentshift = indentshiftfirst;
    }
    if (indentshift === 'auto') {
      indentshift = this.jax.options.displayIndent;
      if (indentalign === 'right' && !indentshift.match(/^\s*0[a-z]*\s*$/)) {
        indentshift = ('-' + indentshift.trim()).replace(/^--/, '');
      }
    }
    var shift = this.length2em(indentshift, this.metrics.containerWidth);
    return [indentalign, shift];
  };
  CommonWrapper.prototype.getAlignX = function (W, bbox, align) {
    return align === 'right' ? W - (bbox.w + bbox.R) * bbox.rscale : align === 'left' ? bbox.L * bbox.rscale : (W - bbox.w * bbox.rscale) / 2;
  };
  CommonWrapper.prototype.getAlignY = function (H, D, h, d, align) {
    return align === 'top' ? H - h : align === 'bottom' ? d - D : align === 'center' ? (H - h - (D - d)) / 2 : 0;
  };
  CommonWrapper.prototype.getWrapWidth = function (i) {
    return this.childNodes[i].getBBox().w;
  };
  CommonWrapper.prototype.getChildAlign = function (_i) {
    return 'left';
  };
  CommonWrapper.prototype.percent = function (m) {
    return LENGTHS$1.percent(m);
  };
  CommonWrapper.prototype.em = function (m) {
    return LENGTHS$1.em(m);
  };
  CommonWrapper.prototype.px = function (m, M) {
    if (M === void 0) {
      M = -LENGTHS$1.BIGDIMEN;
    }
    return LENGTHS$1.px(m, M, this.metrics.em);
  };
  CommonWrapper.prototype.length2em = function (length, size, scale) {
    if (size === void 0) {
      size = 1;
    }
    if (scale === void 0) {
      scale = null;
    }
    if (scale === null) {
      scale = this.bbox.scale;
    }
    return LENGTHS$1.length2em(length, size, scale, this.jax.pxPerEm);
  };
  CommonWrapper.prototype.unicodeChars = function (text, name) {
    if (name === void 0) {
      name = this.variant;
    }
    var chars = (0, string_js_1$6.unicodeChars)(text);
    var variant = this.font.getVariant(name);
    if (variant && variant.chars) {
      var map_1 = variant.chars;
      chars = chars.map(function (n) {
        return ((map_1[n] || [])[3] || ({})).smp || n;
      });
    }
    return chars;
  };
  CommonWrapper.prototype.remapChars = function (chars) {
    return chars;
  };
  CommonWrapper.prototype.mmlText = function (text) {
    return this.node.factory.create('text').setText(text);
  };
  CommonWrapper.prototype.mmlNode = function (kind, properties, children) {
    if (properties === void 0) {
      properties = {};
    }
    if (children === void 0) {
      children = [];
    }
    return this.node.factory.create(kind, properties, children);
  };
  CommonWrapper.prototype.createMo = function (text) {
    var mmlFactory = this.node.factory;
    var textNode = mmlFactory.create('text').setText(text);
    var mml = mmlFactory.create('mo', {
      stretchy: true
    }, [textNode]);
    mml.inheritAttributesFrom(this.node);
    var node = this.wrap(mml);
    node.parent = this;
    return node;
  };
  CommonWrapper.prototype.getVariantChar = function (variant, n) {
    var char = this.font.getChar(variant, n) || [0, 0, 0, {
      unknown: true
    }];
    if (char.length === 3) {
      char[3] = {};
    }
    return char;
  };
  CommonWrapper.kind = 'unknown';
  CommonWrapper.styles = {};
  CommonWrapper.removeStyles = ['fontSize', 'fontFamily', 'fontWeight', 'fontStyle', 'fontVariant', 'font'];
  CommonWrapper.skipAttributes = {
    fontfamily: true,
    fontsize: true,
    fontweight: true,
    fontstyle: true,
    color: true,
    background: true,
    'class': true,
    href: true,
    style: true,
    xmlns: true
  };
  CommonWrapper.BOLDVARIANTS = {
    bold: {
      normal: 'bold',
      italic: 'bold-italic',
      fraktur: 'bold-fraktur',
      script: 'bold-script',
      'sans-serif': 'bold-sans-serif',
      'sans-serif-italic': 'sans-serif-bold-italic'
    },
    normal: {
      bold: 'normal',
      'bold-italic': 'italic',
      'bold-fraktur': 'fraktur',
      'bold-script': 'script',
      'bold-sans-serif': 'sans-serif',
      'sans-serif-bold-italic': 'sans-serif-italic'
    }
  };
  CommonWrapper.ITALICVARIANTS = {
    italic: {
      normal: 'italic',
      bold: 'bold-italic',
      'sans-serif': 'sans-serif-italic',
      'bold-sans-serif': 'sans-serif-bold-italic'
    },
    normal: {
      italic: 'normal',
      'bold-italic': 'bold',
      'sans-serif-italic': 'sans-serif',
      'sans-serif-bold-italic': 'bold-sans-serif'
    }
  };
  return CommonWrapper;
})(Wrapper_js_1$n.AbstractWrapper);
Wrapper$1.CommonWrapper = CommonWrapper;

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var _a;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CHTMLWrapper = exports.SPACE = exports.FONTSIZE = void 0;
  var LENGTHS = __importStar(lengths);
  var Wrapper_js_1 = Wrapper$1;
  var BBox_js_1 = BBox$1;
  exports.FONTSIZE = {
    '70.7%': 's',
    '70%': 's',
    '50%': 'ss',
    '60%': 'Tn',
    '85%': 'sm',
    '120%': 'lg',
    '144%': 'Lg',
    '173%': 'LG',
    '207%': 'hg',
    '249%': 'HG'
  };
  exports.SPACE = (_a = {}, _a[LENGTHS.em(2 / 18)] = '1', _a[LENGTHS.em(3 / 18)] = '2', _a[LENGTHS.em(4 / 18)] = '3', _a[LENGTHS.em(5 / 18)] = '4', _a[LENGTHS.em(6 / 18)] = '5', _a);
  var CHTMLWrapper = (function (_super) {
    __extends(CHTMLWrapper, _super);
    function CHTMLWrapper() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.chtml = null;
      return _this;
    }
    CHTMLWrapper.prototype.toCHTML = function (parent) {
      var e_1, _a;
      var chtml = this.standardCHTMLnode(parent);
      try {
        for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          child.toCHTML(chtml);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    };
    CHTMLWrapper.prototype.standardCHTMLnode = function (parent) {
      this.markUsed();
      var chtml = this.createCHTMLnode(parent);
      this.handleStyles();
      this.handleVariant();
      this.handleScale();
      this.handleColor();
      this.handleSpace();
      this.handleAttributes();
      this.handlePWidth();
      return chtml;
    };
    CHTMLWrapper.prototype.markUsed = function () {
      this.jax.wrapperUsage.add(this.kind);
    };
    CHTMLWrapper.prototype.createCHTMLnode = function (parent) {
      var href = this.node.attributes.get('href');
      if (href) {
        parent = this.adaptor.append(parent, this.html('a', {
          href: href
        }));
      }
      this.chtml = this.adaptor.append(parent, this.html('mjx-' + this.node.kind));
      return this.chtml;
    };
    CHTMLWrapper.prototype.handleStyles = function () {
      if (!this.styles) return;
      var styles = this.styles.cssText;
      if (styles) {
        this.adaptor.setAttribute(this.chtml, 'style', styles);
        var family = this.styles.get('font-family');
        if (family) {
          this.adaptor.setStyle(this.chtml, 'font-family', 'MJXZERO, ' + family);
        }
      }
    };
    CHTMLWrapper.prototype.handleVariant = function () {
      if (this.node.isToken && this.variant !== '-explicitFont') {
        this.adaptor.setAttribute(this.chtml, 'class', (this.font.getVariant(this.variant) || this.font.getVariant('normal')).classes);
      }
    };
    CHTMLWrapper.prototype.handleScale = function () {
      this.setScale(this.chtml, this.bbox.rscale);
    };
    CHTMLWrapper.prototype.setScale = function (chtml, rscale) {
      var scale = Math.abs(rscale - 1) < .001 ? 1 : rscale;
      if (chtml && scale !== 1) {
        var size = this.percent(scale);
        if (exports.FONTSIZE[size]) {
          this.adaptor.setAttribute(chtml, 'size', exports.FONTSIZE[size]);
        } else {
          this.adaptor.setStyle(chtml, 'fontSize', size);
        }
      }
      return chtml;
    };
    CHTMLWrapper.prototype.handleSpace = function () {
      var e_2, _a;
      try {
        for (var _b = __values([[this.bbox.L, 'space', 'marginLeft'], [this.bbox.R, 'rspace', 'marginRight']]), _c = _b.next(); !_c.done; _c = _b.next()) {
          var data = _c.value;
          var _d = __read(data, 3), dimen = _d[0], name_1 = _d[1], margin = _d[2];
          if (dimen) {
            var space = this.em(dimen);
            if (exports.SPACE[space]) {
              this.adaptor.setAttribute(this.chtml, name_1, exports.SPACE[space]);
            } else {
              this.adaptor.setStyle(this.chtml, margin, space);
            }
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    };
    CHTMLWrapper.prototype.handleColor = function () {
      var attributes = this.node.attributes;
      var mathcolor = attributes.getExplicit('mathcolor');
      var color = attributes.getExplicit('color');
      var mathbackground = attributes.getExplicit('mathbackground');
      var background = attributes.getExplicit('background');
      if (mathcolor || color) {
        this.adaptor.setStyle(this.chtml, 'color', mathcolor || color);
      }
      if (mathbackground || background) {
        this.adaptor.setStyle(this.chtml, 'backgroundColor', mathbackground || background);
      }
    };
    CHTMLWrapper.prototype.handleAttributes = function () {
      var e_3, _a, e_4, _b;
      var attributes = this.node.attributes;
      var defaults = attributes.getAllDefaults();
      var skip = CHTMLWrapper.skipAttributes;
      try {
        for (var _c = __values(attributes.getExplicitNames()), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_2 = _d.value;
          if (skip[name_2] === false || !((name_2 in defaults)) && !skip[name_2] && !this.adaptor.hasAttribute(this.chtml, name_2)) {
            this.adaptor.setAttribute(this.chtml, name_2, attributes.getExplicit(name_2));
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
      if (attributes.get('class')) {
        var names = attributes.get('class').trim().split(/ +/);
        try {
          for (var names_1 = __values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
            var name_3 = names_1_1.value;
            this.adaptor.addClass(this.chtml, name_3);
          }
        } catch (e_4_1) {
          e_4 = {
            error: e_4_1
          };
        } finally {
          try {
            if (names_1_1 && !names_1_1.done && (_b = names_1.return)) _b.call(names_1);
          } finally {
            if (e_4) throw e_4.error;
          }
        }
      }
    };
    CHTMLWrapper.prototype.handlePWidth = function () {
      if (this.bbox.pwidth) {
        if (this.bbox.pwidth === BBox_js_1.BBox.fullWidth) {
          this.adaptor.setAttribute(this.chtml, 'width', 'full');
        } else {
          this.adaptor.setStyle(this.chtml, 'width', this.bbox.pwidth);
        }
      }
    };
    CHTMLWrapper.prototype.setIndent = function (chtml, align, shift) {
      var adaptor = this.adaptor;
      if (align === 'center' || align === 'left') {
        var L = this.getBBox().L;
        adaptor.setStyle(chtml, 'margin-left', this.em(shift + L));
      }
      if (align === 'center' || align === 'right') {
        var R = this.getBBox().R;
        adaptor.setStyle(chtml, 'margin-right', this.em(-shift + R));
      }
    };
    CHTMLWrapper.prototype.drawBBox = function () {
      var _a = this.getBBox(), w = _a.w, h = _a.h, d = _a.d, R = _a.R;
      var box = this.html('mjx-box', {
        style: {
          opacity: .25,
          'margin-left': this.em(-w - R)
        }
      }, [this.html('mjx-box', {
        style: {
          height: this.em(h),
          width: this.em(w),
          'background-color': 'red'
        }
      }), this.html('mjx-box', {
        style: {
          height: this.em(d),
          width: this.em(w),
          'margin-left': this.em(-w),
          'vertical-align': this.em(-d),
          'background-color': 'green'
        }
      })]);
      var node = this.chtml || this.parent.chtml;
      var size = this.adaptor.getAttribute(node, 'size');
      if (size) {
        this.adaptor.setAttribute(box, 'size', size);
      }
      var fontsize = this.adaptor.getStyle(node, 'fontSize');
      if (fontsize) {
        this.adaptor.setStyle(box, 'fontSize', fontsize);
      }
      this.adaptor.append(this.adaptor.parent(node), box);
      this.adaptor.setStyle(node, 'backgroundColor', '#FFEE00');
    };
    CHTMLWrapper.prototype.html = function (type, def, content) {
      if (def === void 0) {
        def = {};
      }
      if (content === void 0) {
        content = [];
      }
      return this.jax.html(type, def, content);
    };
    CHTMLWrapper.prototype.text = function (text) {
      return this.jax.text(text);
    };
    CHTMLWrapper.prototype.char = function (n) {
      return this.font.charSelector(n).substr(1);
    };
    CHTMLWrapper.kind = 'unknown';
    CHTMLWrapper.autoStyle = true;
    return CHTMLWrapper;
  })(Wrapper_js_1.CommonWrapper);
  exports.CHTMLWrapper = CHTMLWrapper;
})(Wrapper$2);
getDefaultExportFromCjs(Wrapper$2);

var math$1 = {};

var math = {};

var __extends$18 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(math, "__esModule", {
  value: true
});
math.CommonMathMixin = void 0;
function CommonMathMixin(Base) {
  return (function (_super) {
    __extends$18(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.getWrapWidth = function (_i) {
      return this.parent ? this.getBBox().w : this.metrics.containerWidth / this.jax.pxPerEm;
    };
    return class_1;
  })(Base);
}
math.CommonMathMixin = CommonMathMixin;

var __extends$17 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$v = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(math$1, "__esModule", {
  value: true
});
math$1.CHTMLmath = void 0;
var Wrapper_js_1$m = Wrapper$2;
var math_js_1$1 = math;
var math_js_2 = math$2;
var BBox_js_1$4 = BBox$1;
var CHTMLmath = (function (_super) {
  __extends$17(CHTMLmath, _super);
  function CHTMLmath() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmath.prototype.toCHTML = function (parent) {
    _super.prototype.toCHTML.call(this, parent);
    var chtml = this.chtml;
    var adaptor = this.adaptor;
    var display = this.node.attributes.get('display') === 'block';
    if (display) {
      adaptor.setAttribute(chtml, 'display', 'true');
      adaptor.setAttribute(parent, 'display', 'true');
      this.handleDisplay(parent);
    } else {
      this.handleInline(parent);
    }
    adaptor.addClass(chtml, 'MJX-TEX');
  };
  CHTMLmath.prototype.handleDisplay = function (parent) {
    var adaptor = this.adaptor;
    var _a = __read$v(this.getAlignShift(), 2), align = _a[0], shift = _a[1];
    if (align !== 'center') {
      adaptor.setAttribute(parent, 'justify', align);
    }
    if (this.bbox.pwidth === BBox_js_1$4.BBox.fullWidth) {
      adaptor.setAttribute(parent, 'width', 'full');
      if (this.jax.table) {
        var _b = this.jax.table.getOuterBBox(), L = _b.L, w = _b.w, R = _b.R;
        if (align === 'right') {
          R = Math.max(R || -shift, -shift);
        } else if (align === 'left') {
          L = Math.max(L || shift, shift);
        } else if (align === 'center') {
          w += 2 * Math.abs(shift);
        }
        var W = this.em(Math.max(0, L + w + R));
        adaptor.setStyle(parent, 'min-width', W);
        adaptor.setStyle(this.jax.table.chtml, 'min-width', W);
      }
    } else {
      this.setIndent(this.chtml, align, shift);
    }
  };
  CHTMLmath.prototype.handleInline = function (parent) {
    var adaptor = this.adaptor;
    var margin = adaptor.getStyle(this.chtml, 'margin-right');
    if (margin) {
      adaptor.setStyle(this.chtml, 'margin-right', '');
      adaptor.setStyle(parent, 'margin-right', margin);
      adaptor.setStyle(parent, 'width', '0');
    }
  };
  CHTMLmath.prototype.setChildPWidths = function (recompute, w, clear) {
    if (w === void 0) {
      w = null;
    }
    if (clear === void 0) {
      clear = true;
    }
    return this.parent ? _super.prototype.setChildPWidths.call(this, recompute, w, clear) : false;
  };
  CHTMLmath.kind = math_js_2.MmlMath.prototype.kind;
  CHTMLmath.styles = {
    'mjx-math': {
      'line-height': 0,
      'text-align': 'left',
      'text-indent': 0,
      'font-style': 'normal',
      'font-weight': 'normal',
      'font-size': '100%',
      'font-size-adjust': 'none',
      'letter-spacing': 'normal',
      'border-collapse': 'collapse',
      'word-wrap': 'normal',
      'word-spacing': 'normal',
      'white-space': 'nowrap',
      'direction': 'ltr',
      'padding': '1px 0'
    },
    'mjx-container[jax="CHTML"][display="true"]': {
      display: 'block',
      'text-align': 'center',
      margin: '1em 0'
    },
    'mjx-container[jax="CHTML"][display="true"][width="full"]': {
      display: 'flex'
    },
    'mjx-container[jax="CHTML"][display="true"] mjx-math': {
      padding: 0
    },
    'mjx-container[jax="CHTML"][justify="left"]': {
      'text-align': 'left'
    },
    'mjx-container[jax="CHTML"][justify="right"]': {
      'text-align': 'right'
    }
  };
  return CHTMLmath;
})((0, math_js_1$1.CommonMathMixin)(Wrapper_js_1$m.CHTMLWrapper));
math$1.CHTMLmath = CHTMLmath;

var mi$1 = {};

var mi = {};

var __extends$16 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mi, "__esModule", {
  value: true
});
mi.CommonMiMixin = void 0;
function CommonMiMixin(Base) {
  return (function (_super) {
    __extends$16(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.computeBBox = function (bbox, _recompute) {
      _super.prototype.computeBBox.call(this, bbox);
      this.copySkewIC(bbox);
    };
    return class_1;
  })(Base);
}
mi.CommonMiMixin = CommonMiMixin;

var __extends$15 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mi$1, "__esModule", {
  value: true
});
mi$1.CHTMLmi = void 0;
var Wrapper_js_1$l = Wrapper$2;
var mi_js_1$1 = mi;
var mi_js_2 = mi$2;
var CHTMLmi = (function (_super) {
  __extends$15(CHTMLmi, _super);
  function CHTMLmi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmi.kind = mi_js_2.MmlMi.prototype.kind;
  return CHTMLmi;
})((0, mi_js_1$1.CommonMiMixin)(Wrapper_js_1$l.CHTMLWrapper));
mi$1.CHTMLmi = CHTMLmi;

var mo$1 = {};

var mo = {};

var __extends$14 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$6 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$6 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$6.apply(this, arguments);
});
var __read$u = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$e = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$p = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var _a$8;
Object.defineProperty(mo, "__esModule", {
  value: true
});
mo.CommonMoMixin = mo.DirectionVH = void 0;
var BBox_js_1$3 = BBox$1;
var string_js_1$5 = string;
var FontData_js_1$i = FontData$2;
mo.DirectionVH = (_a$8 = {}, _a$8[1] = 'v', _a$8[2] = 'h', _a$8);
function CommonMoMixin(Base) {
  return (function (_super) {
    __extends$14(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$e([], __read$u(args), false)) || this;
      _this.size = null;
      _this.isAccent = _this.node.isAccent;
      return _this;
    }
    class_1.prototype.computeBBox = function (bbox, _recompute) {
      this.protoBBox(bbox);
      if (this.node.attributes.get('symmetric') && this.stretch.dir !== 2) {
        var d = this.getCenterOffset(bbox);
        bbox.h += d;
        bbox.d -= d;
      }
      if (this.node.getProperty('mathaccent') && (this.stretch.dir === 0 || this.size >= 0)) {
        bbox.w = 0;
      }
    };
    class_1.prototype.protoBBox = function (bbox) {
      var stretchy = this.stretch.dir !== 0;
      if (stretchy && this.size === null) {
        this.getStretchedVariant([0]);
      }
      if (stretchy && this.size < 0) return;
      _super.prototype.computeBBox.call(this, bbox);
      this.copySkewIC(bbox);
    };
    class_1.prototype.getAccentOffset = function () {
      var bbox = BBox_js_1$3.BBox.empty();
      this.protoBBox(bbox);
      return -bbox.w / 2;
    };
    class_1.prototype.getCenterOffset = function (bbox) {
      if (bbox === void 0) {
        bbox = null;
      }
      if (!bbox) {
        bbox = BBox_js_1$3.BBox.empty();
        _super.prototype.computeBBox.call(this, bbox);
      }
      return (bbox.h + bbox.d) / 2 + this.font.params.axis_height - bbox.h;
    };
    class_1.prototype.getVariant = function () {
      if (this.node.attributes.get('largeop')) {
        this.variant = this.node.attributes.get('displaystyle') ? '-largeop' : '-smallop';
        return;
      }
      if (!this.node.attributes.getExplicit('mathvariant') && this.node.getProperty('pseudoscript') === false) {
        this.variant = '-tex-variant';
        return;
      }
      _super.prototype.getVariant.call(this);
    };
    class_1.prototype.canStretch = function (direction) {
      if (this.stretch.dir !== 0) {
        return this.stretch.dir === direction;
      }
      var attributes = this.node.attributes;
      if (!attributes.get('stretchy')) return false;
      var c = this.getText();
      if (Array.from(c).length !== 1) return false;
      var delim = this.font.getDelimiter(c.codePointAt(0));
      this.stretch = delim && delim.dir === direction ? delim : FontData_js_1$i.NOSTRETCH;
      return this.stretch.dir !== 0;
    };
    class_1.prototype.getStretchedVariant = function (WH, exact) {
      var e_1, _a;
      if (exact === void 0) {
        exact = false;
      }
      if (this.stretch.dir !== 0) {
        var D = this.getWH(WH);
        var min = this.getSize('minsize', 0);
        var max = this.getSize('maxsize', Infinity);
        var mathaccent = this.node.getProperty('mathaccent');
        D = Math.max(min, Math.min(max, D));
        var df = this.font.params.delimiterfactor / 1000;
        var ds = this.font.params.delimitershortfall;
        var m = min || exact ? D : mathaccent ? Math.min(D / df, D + ds) : Math.max(D * df, D - ds);
        var delim = this.stretch;
        var c = delim.c || this.getText().codePointAt(0);
        var i = 0;
        if (delim.sizes) {
          try {
            for (var _b = __values$p(delim.sizes), _c = _b.next(); !_c.done; _c = _b.next()) {
              var d = _c.value;
              if (d >= m) {
                if (mathaccent && i) {
                  i--;
                }
                this.variant = this.font.getSizeVariant(c, i);
                this.size = i;
                if (delim.schar && delim.schar[i]) {
                  this.stretch = __assign$6(__assign$6({}, this.stretch), {
                    c: delim.schar[i]
                  });
                }
                return;
              }
              i++;
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        }
        if (delim.stretch) {
          this.size = -1;
          this.invalidateBBox();
          this.getStretchBBox(WH, this.checkExtendedHeight(D, delim), delim);
        } else {
          this.variant = this.font.getSizeVariant(c, i - 1);
          this.size = i - 1;
        }
      }
    };
    class_1.prototype.getSize = function (name, value) {
      var attributes = this.node.attributes;
      if (attributes.isSet(name)) {
        value = this.length2em(attributes.get(name), 1, 1);
      }
      return value;
    };
    class_1.prototype.getWH = function (WH) {
      if (WH.length === 0) return 0;
      if (WH.length === 1) return WH[0];
      var _a = __read$u(WH, 2), H = _a[0], D = _a[1];
      var a = this.font.params.axis_height;
      return this.node.attributes.get('symmetric') ? 2 * Math.max(H - a, D + a) : H + D;
    };
    class_1.prototype.getStretchBBox = function (WHD, D, C) {
      var _a;
      if (C.hasOwnProperty('min') && C.min > D) {
        D = C.min;
      }
      var _b = __read$u(C.HDW, 3), h = _b[0], d = _b[1], w = _b[2];
      if (this.stretch.dir === 1) {
        (_a = __read$u(this.getBaseline(WHD, D, C), 2), h = _a[0], d = _a[1]);
      } else {
        w = D;
      }
      this.bbox.h = h;
      this.bbox.d = d;
      this.bbox.w = w;
    };
    class_1.prototype.getBaseline = function (WHD, HD, C) {
      var hasWHD = WHD.length === 2 && WHD[0] + WHD[1] === HD;
      var symmetric = this.node.attributes.get('symmetric');
      var _a = __read$u(hasWHD ? WHD : [HD, 0], 2), H = _a[0], D = _a[1];
      var _b = __read$u([H + D, 0], 2), h = _b[0], d = _b[1];
      if (symmetric) {
        var a = this.font.params.axis_height;
        if (hasWHD) {
          h = 2 * Math.max(H - a, D + a);
        }
        d = h / 2 - a;
      } else if (hasWHD) {
        d = D;
      } else {
        var _c = __read$u(C.HDW || [.75, .25], 2), ch = _c[0], cd = _c[1];
        d = cd * (h / (ch + cd));
      }
      return [h - d, d];
    };
    class_1.prototype.checkExtendedHeight = function (D, C) {
      if (C.fullExt) {
        var _a = __read$u(C.fullExt, 2), extSize = _a[0], endSize = _a[1];
        var n = Math.ceil(Math.max(0, D - endSize) / extSize);
        D = endSize + n * extSize;
      }
      return D;
    };
    class_1.prototype.remapChars = function (chars) {
      var primes = this.node.getProperty('primes');
      if (primes) {
        return (0, string_js_1$5.unicodeChars)(primes);
      }
      if (chars.length === 1) {
        var parent_1 = this.node.coreParent().parent;
        var isAccent = this.isAccent && !parent_1.isKind('mrow');
        var map = isAccent ? 'accent' : 'mo';
        var text = this.font.getRemappedChar(map, chars[0]);
        if (text) {
          chars = this.unicodeChars(text, this.variant);
        }
      }
      return chars;
    };
    return class_1;
  })(Base);
}
mo.CommonMoMixin = CommonMoMixin;

var __extends$13 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$o = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mo$1, "__esModule", {
  value: true
});
mo$1.CHTMLmo = void 0;
var Wrapper_js_1$k = Wrapper$2;
var mo_js_1$1 = mo;
var mo_js_2 = mo$2;
var CHTMLmo = (function (_super) {
  __extends$13(CHTMLmo, _super);
  function CHTMLmo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmo.prototype.toCHTML = function (parent) {
    var e_1, _a;
    var attributes = this.node.attributes;
    var symmetric = attributes.get('symmetric') && this.stretch.dir !== 2;
    var stretchy = this.stretch.dir !== 0;
    if (stretchy && this.size === null) {
      this.getStretchedVariant([]);
    }
    var chtml = this.standardCHTMLnode(parent);
    if (stretchy && this.size < 0) {
      this.stretchHTML(chtml);
    } else {
      if (symmetric || attributes.get('largeop')) {
        var u = this.em(this.getCenterOffset());
        if (u !== '0') {
          this.adaptor.setStyle(chtml, 'verticalAlign', u);
        }
      }
      if (this.node.getProperty('mathaccent')) {
        this.adaptor.setStyle(chtml, 'width', '0');
        this.adaptor.setStyle(chtml, 'margin-left', this.em(this.getAccentOffset()));
      }
      try {
        for (var _b = __values$o(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          child.toCHTML(chtml);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  };
  CHTMLmo.prototype.stretchHTML = function (chtml) {
    var c = this.getText().codePointAt(0);
    this.font.delimUsage.add(c);
    this.childNodes[0].markUsed();
    var delim = this.stretch;
    var stretch = delim.stretch;
    var content = [];
    if (stretch[0]) {
      content.push(this.html('mjx-beg', {}, [this.html('mjx-c')]));
    }
    content.push(this.html('mjx-ext', {}, [this.html('mjx-c')]));
    if (stretch.length === 4) {
      content.push(this.html('mjx-mid', {}, [this.html('mjx-c')]), this.html('mjx-ext', {}, [this.html('mjx-c')]));
    }
    if (stretch[2]) {
      content.push(this.html('mjx-end', {}, [this.html('mjx-c')]));
    }
    var styles = {};
    var _a = this.bbox, h = _a.h, d = _a.d, w = _a.w;
    if (delim.dir === 1) {
      content.push(this.html('mjx-mark'));
      styles.height = this.em(h + d);
      styles.verticalAlign = this.em(-d);
    } else {
      styles.width = this.em(w);
    }
    var dir = mo_js_1$1.DirectionVH[delim.dir];
    var properties = {
      class: this.char(delim.c || c),
      style: styles
    };
    var html = this.html('mjx-stretchy-' + dir, properties, content);
    this.adaptor.append(chtml, html);
  };
  CHTMLmo.kind = mo_js_2.MmlMo.prototype.kind;
  CHTMLmo.styles = {
    'mjx-stretchy-h': {
      display: 'inline-table',
      width: '100%'
    },
    'mjx-stretchy-h > *': {
      display: 'table-cell',
      width: 0
    },
    'mjx-stretchy-h > * > mjx-c': {
      display: 'inline-block',
      transform: 'scalex(1.0000001)'
    },
    'mjx-stretchy-h > * > mjx-c::before': {
      display: 'inline-block',
      width: 'initial'
    },
    'mjx-stretchy-h > mjx-ext': {
      '/* IE */ overflow': 'hidden',
      '/* others */ overflow': 'clip visible',
      width: '100%'
    },
    'mjx-stretchy-h > mjx-ext > mjx-c::before': {
      transform: 'scalex(500)'
    },
    'mjx-stretchy-h > mjx-ext > mjx-c': {
      width: 0
    },
    'mjx-stretchy-h > mjx-beg > mjx-c': {
      'margin-right': '-.1em'
    },
    'mjx-stretchy-h > mjx-end > mjx-c': {
      'margin-left': '-.1em'
    },
    'mjx-stretchy-v': {
      display: 'inline-block'
    },
    'mjx-stretchy-v > *': {
      display: 'block'
    },
    'mjx-stretchy-v > mjx-beg': {
      height: 0
    },
    'mjx-stretchy-v > mjx-end > mjx-c': {
      display: 'block'
    },
    'mjx-stretchy-v > * > mjx-c': {
      transform: 'scaley(1.0000001)',
      'transform-origin': 'left center',
      overflow: 'hidden'
    },
    'mjx-stretchy-v > mjx-ext': {
      display: 'block',
      height: '100%',
      'box-sizing': 'border-box',
      border: '0px solid transparent',
      '/* IE */ overflow': 'hidden',
      '/* others */ overflow': 'visible clip'
    },
    'mjx-stretchy-v > mjx-ext > mjx-c::before': {
      width: 'initial',
      'box-sizing': 'border-box'
    },
    'mjx-stretchy-v > mjx-ext > mjx-c': {
      transform: 'scaleY(500) translateY(.075em)',
      overflow: 'visible'
    },
    'mjx-mark': {
      display: 'inline-block',
      height: '0px'
    }
  };
  return CHTMLmo;
})((0, mo_js_1$1.CommonMoMixin)(Wrapper_js_1$k.CHTMLWrapper));
mo$1.CHTMLmo = CHTMLmo;

var mn$1 = {};

var mn = {};

var __extends$12 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mn, "__esModule", {
  value: true
});
mn.CommonMnMixin = void 0;
function CommonMnMixin(Base) {
  return (function (_super) {
    __extends$12(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.remapChars = function (chars) {
      if (chars.length) {
        var text = this.font.getRemappedChar('mn', chars[0]);
        if (text) {
          var c = this.unicodeChars(text, this.variant);
          if (c.length === 1) {
            chars[0] = c[0];
          } else {
            chars = c.concat(chars.slice(1));
          }
        }
      }
      return chars;
    };
    return class_1;
  })(Base);
}
mn.CommonMnMixin = CommonMnMixin;

var __extends$11 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mn$1, "__esModule", {
  value: true
});
mn$1.CHTMLmn = void 0;
var Wrapper_js_1$j = Wrapper$2;
var mn_js_1$1 = mn;
var mn_js_2 = mn$2;
var CHTMLmn = (function (_super) {
  __extends$11(CHTMLmn, _super);
  function CHTMLmn() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmn.kind = mn_js_2.MmlMn.prototype.kind;
  return CHTMLmn;
})((0, mn_js_1$1.CommonMnMixin)(Wrapper_js_1$j.CHTMLWrapper));
mn$1.CHTMLmn = CHTMLmn;

var ms$2 = {};

var ms$1 = {};

var __extends$10 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$t = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$d = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(ms$1, "__esModule", {
  value: true
});
ms$1.CommonMsMixin = void 0;
function CommonMsMixin(Base) {
  return (function (_super) {
    __extends$10(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$d([], __read$t(args), false)) || this;
      var attributes = _this.node.attributes;
      var quotes = attributes.getList('lquote', 'rquote');
      if (_this.variant !== 'monospace') {
        if (!attributes.isSet('lquote') && quotes.lquote === '"') quotes.lquote = '\u201C';
        if (!attributes.isSet('rquote') && quotes.rquote === '"') quotes.rquote = '\u201D';
      }
      _this.childNodes.unshift(_this.createText(quotes.lquote));
      _this.childNodes.push(_this.createText(quotes.rquote));
      return _this;
    }
    class_1.prototype.createText = function (text) {
      var node = this.wrap(this.mmlText(text));
      node.parent = this;
      return node;
    };
    return class_1;
  })(Base);
}
ms$1.CommonMsMixin = CommonMsMixin;

var __extends$$ = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(ms$2, "__esModule", {
  value: true
});
ms$2.CHTMLms = void 0;
var Wrapper_js_1$i = Wrapper$2;
var ms_js_1$1 = ms$1;
var ms_js_2 = ms$3;
var CHTMLms = (function (_super) {
  __extends$$(CHTMLms, _super);
  function CHTMLms() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLms.kind = ms_js_2.MmlMs.prototype.kind;
  return CHTMLms;
})((0, ms_js_1$1.CommonMsMixin)(Wrapper_js_1$i.CHTMLWrapper));
ms$2.CHTMLms = CHTMLms;

var mtext$1 = {};

var mtext = {};

var __extends$_ = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mtext, "__esModule", {
  value: true
});
mtext.CommonMtextMixin = void 0;
function CommonMtextMixin(Base) {
  var _a;
  return (_a = (function (_super) {
    __extends$_(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.getVariant = function () {
      var options = this.jax.options;
      var data = this.jax.math.outputData;
      var merror = (!!data.merrorFamily || !!options.merrorFont) && this.node.Parent.isKind('merror');
      if (!!data.mtextFamily || !!options.mtextFont || merror) {
        var variant = this.node.attributes.get('mathvariant');
        var font = this.constructor.INHERITFONTS[variant] || this.jax.font.getCssFont(variant);
        var family = font[0] || (merror ? data.merrorFamily || options.merrorFont : data.mtextFamily || options.mtextFont);
        this.variant = this.explicitVariant(family, font[2] ? 'bold' : '', font[1] ? 'italic' : '');
        return;
      }
      _super.prototype.getVariant.call(this);
    };
    return class_1;
  })(Base), _a.INHERITFONTS = {
    normal: ['', false, false],
    bold: ['', false, true],
    italic: ['', true, false],
    'bold-italic': ['', true, true]
  }, _a);
}
mtext.CommonMtextMixin = CommonMtextMixin;

var __extends$Z = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mtext$1, "__esModule", {
  value: true
});
mtext$1.CHTMLmtext = void 0;
var Wrapper_js_1$h = Wrapper$2;
var mtext_js_1$1 = mtext;
var mtext_js_2 = mtext$2;
var CHTMLmtext = (function (_super) {
  __extends$Z(CHTMLmtext, _super);
  function CHTMLmtext() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmtext.kind = mtext_js_2.MmlMtext.prototype.kind;
  return CHTMLmtext;
})((0, mtext_js_1$1.CommonMtextMixin)(Wrapper_js_1$h.CHTMLWrapper));
mtext$1.CHTMLmtext = CHTMLmtext;

var mspace$1 = {};

var mspace = {};

var __extends$Y = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mspace, "__esModule", {
  value: true
});
mspace.CommonMspaceMixin = void 0;
function CommonMspaceMixin(Base) {
  return (function (_super) {
    __extends$Y(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.computeBBox = function (bbox, _recompute) {
      var attributes = this.node.attributes;
      bbox.w = this.length2em(attributes.get('width'), 0);
      bbox.h = this.length2em(attributes.get('height'), 0);
      bbox.d = this.length2em(attributes.get('depth'), 0);
    };
    class_1.prototype.handleVariant = function () {};
    return class_1;
  })(Base);
}
mspace.CommonMspaceMixin = CommonMspaceMixin;

var __extends$X = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mspace$1, "__esModule", {
  value: true
});
var CHTMLmspace_1 = mspace$1.CHTMLmspace = void 0;
var Wrapper_js_1$g = Wrapper$2;
var mspace_js_1$1 = mspace;
var mspace_js_2 = mspace$2;
var CHTMLmspace = (function (_super) {
  __extends$X(CHTMLmspace, _super);
  function CHTMLmspace() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmspace.prototype.toCHTML = function (parent) {
    var chtml = this.standardCHTMLnode(parent);
    var _a = this.getBBox(), w = _a.w, h = _a.h, d = _a.d;
    if (w < 0) {
      this.adaptor.setStyle(chtml, 'marginRight', this.em(w));
      w = 0;
    }
    if (w) {
      this.adaptor.setStyle(chtml, 'width', this.em(w));
    }
    h = Math.max(0, h + d);
    if (h) {
      this.adaptor.setStyle(chtml, 'height', this.em(Math.max(0, h)));
    }
    if (d) {
      this.adaptor.setStyle(chtml, 'verticalAlign', this.em(-d));
    }
  };
  CHTMLmspace.kind = mspace_js_2.MmlMspace.prototype.kind;
  return CHTMLmspace;
})((0, mspace_js_1$1.CommonMspaceMixin)(Wrapper_js_1$g.CHTMLWrapper));
CHTMLmspace_1 = mspace$1.CHTMLmspace = CHTMLmspace;

var mpadded$1 = {};

var mpadded = {};

var __extends$W = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$s = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(mpadded, "__esModule", {
  value: true
});
mpadded.CommonMpaddedMixin = void 0;
function CommonMpaddedMixin(Base) {
  return (function (_super) {
    __extends$W(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.getDimens = function () {
      var values = this.node.attributes.getList('width', 'height', 'depth', 'lspace', 'voffset');
      var bbox = this.childNodes[0].getBBox();
      var w = bbox.w, h = bbox.h, d = bbox.d;
      var W = w, H = h, D = d, x = 0, y = 0, dx = 0;
      if (values.width !== '') w = this.dimen(values.width, bbox, 'w', 0);
      if (values.height !== '') h = this.dimen(values.height, bbox, 'h', 0);
      if (values.depth !== '') d = this.dimen(values.depth, bbox, 'd', 0);
      if (values.voffset !== '') y = this.dimen(values.voffset, bbox);
      if (values.lspace !== '') x = this.dimen(values.lspace, bbox);
      var align = this.node.attributes.get('data-align');
      if (align) {
        dx = this.getAlignX(w, bbox, align);
      }
      return [H, D, W, h - H, d - D, w - W, x, y, dx];
    };
    class_1.prototype.dimen = function (length, bbox, d, m) {
      if (d === void 0) {
        d = '';
      }
      if (m === void 0) {
        m = null;
      }
      length = String(length);
      var match = length.match(/width|height|depth/);
      var size = match ? bbox[match[0].charAt(0)] : d ? bbox[d] : 0;
      var dimen = this.length2em(length, size) || 0;
      if (length.match(/^[-+]/) && d) {
        dimen += size;
      }
      if (m != null) {
        dimen = Math.max(m, dimen);
      }
      return dimen;
    };
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      var _a = __read$s(this.getDimens(), 6), H = _a[0], D = _a[1], W = _a[2], dh = _a[3], dd = _a[4], dw = _a[5];
      bbox.w = W + dw;
      bbox.h = H + dh;
      bbox.d = D + dd;
      this.setChildPWidths(recompute, bbox.w);
    };
    class_1.prototype.getWrapWidth = function (_i) {
      return this.getBBox().w;
    };
    class_1.prototype.getChildAlign = function (_i) {
      return this.node.attributes.get('data-align') || 'left';
    };
    return class_1;
  })(Base);
}
mpadded.CommonMpaddedMixin = CommonMpaddedMixin;

var __extends$V = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$r = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$n = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mpadded$1, "__esModule", {
  value: true
});
mpadded$1.CHTMLmpadded = void 0;
var Wrapper_js_1$f = Wrapper$2;
var mpadded_js_1$1 = mpadded;
var mpadded_js_2 = mpadded$2;
var CHTMLmpadded = (function (_super) {
  __extends$V(CHTMLmpadded, _super);
  function CHTMLmpadded() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmpadded.prototype.toCHTML = function (parent) {
    var e_1, _a;
    var chtml = this.standardCHTMLnode(parent);
    var content = [];
    var style = {};
    var _b = __read$r(this.getDimens(), 9), W = _b[2], dh = _b[3], dd = _b[4], dw = _b[5], x = _b[6], y = _b[7], dx = _b[8];
    if (dw) {
      style.width = this.em(W + dw);
    }
    if (dh || dd) {
      style.margin = this.em(dh) + ' 0 ' + this.em(dd);
    }
    if (x + dx || y) {
      style.position = 'relative';
      var rbox = this.html('mjx-rbox', {
        style: {
          left: this.em(x + dx),
          top: this.em(-y),
          'max-width': style.width
        }
      });
      if (x + dx && this.childNodes[0].getBBox().pwidth) {
        this.adaptor.setAttribute(rbox, 'width', 'full');
        this.adaptor.setStyle(rbox, 'left', this.em(x));
      }
      content.push(rbox);
    }
    chtml = this.adaptor.append(chtml, this.html('mjx-block', {
      style: style
    }, content));
    try {
      for (var _c = __values$n(this.childNodes), _d = _c.next(); !_d.done; _d = _c.next()) {
        var child = _d.value;
        child.toCHTML(content[0] || chtml);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  CHTMLmpadded.kind = mpadded_js_2.MmlMpadded.prototype.kind;
  CHTMLmpadded.styles = {
    'mjx-mpadded': {
      display: 'inline-block'
    },
    'mjx-rbox': {
      display: 'inline-block',
      position: 'relative'
    }
  };
  return CHTMLmpadded;
})((0, mpadded_js_1$1.CommonMpaddedMixin)(Wrapper_js_1$f.CHTMLWrapper));
mpadded$1.CHTMLmpadded = CHTMLmpadded;

var menclose$1 = {};

var menclose = {};

var Notation$3 = {};

(function (exports) {
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CommonArrow = exports.CommonDiagonalArrow = exports.CommonDiagonalStrike = exports.CommonBorder2 = exports.CommonBorder = exports.arrowBBox = exports.diagonalArrowDef = exports.arrowDef = exports.arrowBBoxW = exports.arrowBBoxHD = exports.arrowHead = exports.fullBorder = exports.fullPadding = exports.fullBBox = exports.sideNames = exports.sideIndex = exports.SOLID = exports.PADDING = exports.THICKNESS = exports.ARROWY = exports.ARROWDX = exports.ARROWX = void 0;
  (exports.ARROWX = 4, exports.ARROWDX = 1, exports.ARROWY = 2);
  exports.THICKNESS = .067;
  exports.PADDING = .2;
  exports.SOLID = exports.THICKNESS + 'em solid';
  exports.sideIndex = {
    top: 0,
    right: 1,
    bottom: 2,
    left: 3
  };
  exports.sideNames = Object.keys(exports.sideIndex);
  exports.fullBBox = function (node) {
    return new Array(4).fill(node.thickness + node.padding);
  };
  exports.fullPadding = function (node) {
    return new Array(4).fill(node.padding);
  };
  exports.fullBorder = function (node) {
    return new Array(4).fill(node.thickness);
  };
  var arrowHead = function (node) {
    return Math.max(node.padding, node.thickness * (node.arrowhead.x + node.arrowhead.dx + 1));
  };
  exports.arrowHead = arrowHead;
  var arrowBBoxHD = function (node, TRBL) {
    if (node.childNodes[0]) {
      var _a = node.childNodes[0].getBBox(), h = _a.h, d = _a.d;
      TRBL[0] = TRBL[2] = Math.max(0, node.thickness * node.arrowhead.y - (h + d) / 2);
    }
    return TRBL;
  };
  exports.arrowBBoxHD = arrowBBoxHD;
  var arrowBBoxW = function (node, TRBL) {
    if (node.childNodes[0]) {
      var w = node.childNodes[0].getBBox().w;
      TRBL[1] = TRBL[3] = Math.max(0, node.thickness * node.arrowhead.y - w / 2);
    }
    return TRBL;
  };
  exports.arrowBBoxW = arrowBBoxW;
  exports.arrowDef = {
    up: [-Math.PI / 2, false, true, 'verticalstrike'],
    down: [Math.PI / 2, false, true, 'verticakstrike'],
    right: [0, false, false, 'horizontalstrike'],
    left: [Math.PI, false, false, 'horizontalstrike'],
    updown: [Math.PI / 2, true, true, 'verticalstrike uparrow downarrow'],
    leftright: [0, true, false, 'horizontalstrike leftarrow rightarrow']
  };
  exports.diagonalArrowDef = {
    updiagonal: [-1, 0, false, 'updiagonalstrike northeastarrow'],
    northeast: [-1, 0, false, 'updiagonalstrike updiagonalarrow'],
    southeast: [1, 0, false, 'downdiagonalstrike'],
    northwest: [1, Math.PI, false, 'downdiagonalstrike'],
    southwest: [-1, Math.PI, false, 'updiagonalstrike'],
    northeastsouthwest: [-1, 0, true, 'updiagonalstrike northeastarrow updiagonalarrow southwestarrow'],
    northwestsoutheast: [1, 0, true, 'downdiagonalstrike northwestarrow southeastarrow']
  };
  exports.arrowBBox = {
    up: function (node) {
      return (0, exports.arrowBBoxW)(node, [(0, exports.arrowHead)(node), 0, node.padding, 0]);
    },
    down: function (node) {
      return (0, exports.arrowBBoxW)(node, [node.padding, 0, (0, exports.arrowHead)(node), 0]);
    },
    right: function (node) {
      return (0, exports.arrowBBoxHD)(node, [0, (0, exports.arrowHead)(node), 0, node.padding]);
    },
    left: function (node) {
      return (0, exports.arrowBBoxHD)(node, [0, node.padding, 0, (0, exports.arrowHead)(node)]);
    },
    updown: function (node) {
      return (0, exports.arrowBBoxW)(node, [(0, exports.arrowHead)(node), 0, (0, exports.arrowHead)(node), 0]);
    },
    leftright: function (node) {
      return (0, exports.arrowBBoxHD)(node, [0, (0, exports.arrowHead)(node), 0, (0, exports.arrowHead)(node)]);
    }
  };
  var CommonBorder = function (render) {
    return function (side) {
      var i = exports.sideIndex[side];
      return [side, {
        renderer: render,
        bbox: function (node) {
          var bbox = [0, 0, 0, 0];
          bbox[i] = node.thickness + node.padding;
          return bbox;
        },
        border: function (node) {
          var bbox = [0, 0, 0, 0];
          bbox[i] = node.thickness;
          return bbox;
        }
      }];
    };
  };
  exports.CommonBorder = CommonBorder;
  var CommonBorder2 = function (render) {
    return function (name, side1, side2) {
      var i1 = exports.sideIndex[side1];
      var i2 = exports.sideIndex[side2];
      return [name, {
        renderer: render,
        bbox: function (node) {
          var t = node.thickness + node.padding;
          var bbox = [0, 0, 0, 0];
          bbox[i1] = bbox[i2] = t;
          return bbox;
        },
        border: function (node) {
          var bbox = [0, 0, 0, 0];
          bbox[i1] = bbox[i2] = node.thickness;
          return bbox;
        },
        remove: side1 + ' ' + side2
      }];
    };
  };
  exports.CommonBorder2 = CommonBorder2;
  var CommonDiagonalStrike = function (render) {
    return function (name) {
      var cname = 'mjx-' + name.charAt(0) + 'strike';
      return [name + 'diagonalstrike', {
        renderer: render(cname),
        bbox: exports.fullBBox
      }];
    };
  };
  exports.CommonDiagonalStrike = CommonDiagonalStrike;
  var CommonDiagonalArrow = function (render) {
    return function (name) {
      var _a = __read(exports.diagonalArrowDef[name], 4), c = _a[0], pi = _a[1], double = _a[2], remove = _a[3];
      return [name + 'arrow', {
        renderer: function (node, _child) {
          var _a = __read(node.arrowAW(), 2), a = _a[0], W = _a[1];
          var arrow = node.arrow(W, c * (a - pi), double);
          render(node, arrow);
        },
        bbox: function (node) {
          var _a = node.arrowData(), a = _a.a, x = _a.x, y = _a.y;
          var _b = __read([node.arrowhead.x, node.arrowhead.y, node.arrowhead.dx], 3), ax = _b[0], ay = _b[1], adx = _b[2];
          var _c = __read(node.getArgMod(ax + adx, ay), 2), b = _c[0], ar = _c[1];
          var dy = y + (b > a ? node.thickness * ar * Math.sin(b - a) : 0);
          var dx = x + (b > Math.PI / 2 - a ? node.thickness * ar * Math.sin(b + a - Math.PI / 2) : 0);
          return [dy, dx, dy, dx];
        },
        remove: remove
      }];
    };
  };
  exports.CommonDiagonalArrow = CommonDiagonalArrow;
  var CommonArrow = function (render) {
    return function (name) {
      var _a = __read(exports.arrowDef[name], 4), angle = _a[0], double = _a[1], isVertical = _a[2], remove = _a[3];
      return [name + 'arrow', {
        renderer: function (node, _child) {
          var _a = node.getBBox(), w = _a.w, h = _a.h, d = _a.d;
          var _b = __read(isVertical ? [h + d, 'X'] : [w, 'Y'], 2), W = _b[0], offset = _b[1];
          var dd = node.getOffset(offset);
          var arrow = node.arrow(W, angle, double, offset, dd);
          render(node, arrow);
        },
        bbox: exports.arrowBBox[name],
        remove: remove
      }];
    };
  };
  exports.CommonArrow = CommonArrow;
})(Notation$3);
getDefaultExportFromCjs(Notation$3);

var __extends$U = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __createBinding$8 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$8 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$8 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$8(result, mod, k);
  __setModuleDefault$8(result, mod);
  return result;
});
var __read$q = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$c = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$m = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(menclose, "__esModule", {
  value: true
});
menclose.CommonMencloseMixin = void 0;
var Notation$2 = __importStar$8(Notation$3);
var string_js_1$4 = string;
function CommonMencloseMixin(Base) {
  return (function (_super) {
    __extends$U(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$c([], __read$q(args), false)) || this;
      _this.notations = {};
      _this.renderChild = null;
      _this.msqrt = null;
      _this.padding = Notation$2.PADDING;
      _this.thickness = Notation$2.THICKNESS;
      _this.arrowhead = {
        x: Notation$2.ARROWX,
        y: Notation$2.ARROWY,
        dx: Notation$2.ARROWDX
      };
      _this.TRBL = [0, 0, 0, 0];
      _this.getParameters();
      _this.getNotations();
      _this.removeRedundantNotations();
      _this.initializeNotations();
      _this.TRBL = _this.getBBoxExtenders();
      return _this;
    }
    class_1.prototype.getParameters = function () {
      var attributes = this.node.attributes;
      var padding = attributes.get('data-padding');
      if (padding !== undefined) {
        this.padding = this.length2em(padding, Notation$2.PADDING);
      }
      var thickness = attributes.get('data-thickness');
      if (thickness !== undefined) {
        this.thickness = this.length2em(thickness, Notation$2.THICKNESS);
      }
      var arrowhead = attributes.get('data-arrowhead');
      if (arrowhead !== undefined) {
        var _b = __read$q((0, string_js_1$4.split)(arrowhead), 3), x = _b[0], y = _b[1], dx = _b[2];
        this.arrowhead = {
          x: x ? parseFloat(x) : Notation$2.ARROWX,
          y: y ? parseFloat(y) : Notation$2.ARROWY,
          dx: dx ? parseFloat(dx) : Notation$2.ARROWDX
        };
      }
    };
    class_1.prototype.getNotations = function () {
      var e_1, _b;
      var Notations = this.constructor.notations;
      try {
        for (var _c = __values$m((0, string_js_1$4.split)(this.node.attributes.get('notation'))), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_1 = _d.value;
          var notation = Notations.get(name_1);
          if (notation) {
            this.notations[name_1] = notation;
            if (notation.renderChild) {
              this.renderChild = notation.renderer;
            }
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    };
    class_1.prototype.removeRedundantNotations = function () {
      var e_2, _b, e_3, _c;
      try {
        for (var _d = __values$m(Object.keys(this.notations)), _e = _d.next(); !_e.done; _e = _d.next()) {
          var name_2 = _e.value;
          if (this.notations[name_2]) {
            var remove = this.notations[name_2].remove || '';
            try {
              for (var _f = (e_3 = void 0, __values$m(remove.split(/ /))), _g = _f.next(); !_g.done; _g = _f.next()) {
                var notation = _g.value;
                delete this.notations[notation];
              }
            } catch (e_3_1) {
              e_3 = {
                error: e_3_1
              };
            } finally {
              try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
              } finally {
                if (e_3) throw e_3.error;
              }
            }
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    };
    class_1.prototype.initializeNotations = function () {
      var e_4, _b;
      try {
        for (var _c = __values$m(Object.keys(this.notations)), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_3 = _d.value;
          var init = this.notations[name_3].init;
          init && init(this);
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
    };
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      var _b = __read$q(this.TRBL, 4), T = _b[0], R = _b[1], B = _b[2], L = _b[3];
      var child = this.childNodes[0].getBBox();
      bbox.combine(child, L, 0);
      bbox.h += T;
      bbox.d += B;
      bbox.w += R;
      this.setChildPWidths(recompute);
    };
    class_1.prototype.getBBoxExtenders = function () {
      var e_5, _b;
      var TRBL = [0, 0, 0, 0];
      try {
        for (var _c = __values$m(Object.keys(this.notations)), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_4 = _d.value;
          this.maximizeEntries(TRBL, this.notations[name_4].bbox(this));
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      return TRBL;
    };
    class_1.prototype.getPadding = function () {
      var e_6, _b;
      var _this = this;
      var BTRBL = [0, 0, 0, 0];
      try {
        for (var _c = __values$m(Object.keys(this.notations)), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_5 = _d.value;
          var border = this.notations[name_5].border;
          if (border) {
            this.maximizeEntries(BTRBL, border(this));
          }
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_6) throw e_6.error;
        }
      }
      return [0, 1, 2, 3].map(function (i) {
        return _this.TRBL[i] - BTRBL[i];
      });
    };
    class_1.prototype.maximizeEntries = function (X, Y) {
      for (var i = 0; i < X.length; i++) {
        if (X[i] < Y[i]) {
          X[i] = Y[i];
        }
      }
    };
    class_1.prototype.getOffset = function (direction) {
      var _b = __read$q(this.TRBL, 4), T = _b[0], R = _b[1], B = _b[2], L = _b[3];
      var d = (direction === 'X' ? R - L : B - T) / 2;
      return Math.abs(d) > .001 ? d : 0;
    };
    class_1.prototype.getArgMod = function (w, h) {
      return [Math.atan2(h, w), Math.sqrt(w * w + h * h)];
    };
    class_1.prototype.arrow = function (_w, _a, _double, _offset, _dist) {
      return null;
    };
    class_1.prototype.arrowData = function () {
      var _b = __read$q([this.padding, this.thickness], 2), p = _b[0], t = _b[1];
      var r = t * (this.arrowhead.x + Math.max(1, this.arrowhead.dx));
      var _c = this.childNodes[0].getBBox(), h = _c.h, d = _c.d, w = _c.w;
      var H = h + d;
      var R = Math.sqrt(H * H + w * w);
      var x = Math.max(p, r * w / R);
      var y = Math.max(p, r * H / R);
      var _d = __read$q(this.getArgMod(w + 2 * x, H + 2 * y), 2), a = _d[0], W = _d[1];
      return {
        a: a,
        W: W,
        x: x,
        y: y
      };
    };
    class_1.prototype.arrowAW = function () {
      var _b = this.childNodes[0].getBBox(), h = _b.h, d = _b.d, w = _b.w;
      var _c = __read$q(this.TRBL, 4), T = _c[0], R = _c[1], B = _c[2], L = _c[3];
      return this.getArgMod(L + w + R, T + h + d + B);
    };
    class_1.prototype.createMsqrt = function (child) {
      var mmlFactory = this.node.factory;
      var mml = mmlFactory.create('msqrt');
      mml.inheritAttributesFrom(this.node);
      mml.childNodes[0] = child.node;
      var node = this.wrap(mml);
      node.parent = this;
      return node;
    };
    class_1.prototype.sqrtTRBL = function () {
      var bbox = this.msqrt.getBBox();
      var cbox = this.msqrt.childNodes[0].getBBox();
      return [bbox.h - cbox.h, 0, bbox.d - cbox.d, bbox.w - cbox.w];
    };
    return class_1;
  })(Base);
}
menclose.CommonMencloseMixin = CommonMencloseMixin;

var Notation$1 = {};

(function (exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || (function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Arrow = exports.DiagonalArrow = exports.DiagonalStrike = exports.Border2 = exports.Border = exports.RenderElement = void 0;
  var Notation = __importStar(Notation$3);
  __exportStar(Notation$3, exports);
  var RenderElement = function (name, offset) {
    if (offset === void 0) {
      offset = '';
    }
    return function (node, _child) {
      var shape = node.adjustBorder(node.html('mjx-' + name));
      if (offset) {
        var d = node.getOffset(offset);
        if (node.thickness !== Notation.THICKNESS || d) {
          var transform = ("translate").concat(offset, "(").concat(node.em(node.thickness / 2 - d), ")");
          node.adaptor.setStyle(shape, 'transform', transform);
        }
      }
      node.adaptor.append(node.chtml, shape);
    };
  };
  exports.RenderElement = RenderElement;
  var Border = function (side) {
    return Notation.CommonBorder(function (node, child) {
      node.adaptor.setStyle(child, 'border-' + side, node.em(node.thickness) + ' solid');
    })(side);
  };
  exports.Border = Border;
  var Border2 = function (name, side1, side2) {
    return Notation.CommonBorder2(function (node, child) {
      var border = node.em(node.thickness) + ' solid';
      node.adaptor.setStyle(child, 'border-' + side1, border);
      node.adaptor.setStyle(child, 'border-' + side2, border);
    })(name, side1, side2);
  };
  exports.Border2 = Border2;
  var DiagonalStrike = function (name, neg) {
    return Notation.CommonDiagonalStrike(function (cname) {
      return function (node, _child) {
        var _a = node.getBBox(), w = _a.w, h = _a.h, d = _a.d;
        var _b = __read(node.getArgMod(w, h + d), 2), a = _b[0], W = _b[1];
        var t = neg * node.thickness / 2;
        var strike = node.adjustBorder(node.html(cname, {
          style: {
            width: node.em(W),
            transform: 'rotate(' + node.fixed(-neg * a) + 'rad) translateY(' + t + 'em)'
          }
        }));
        node.adaptor.append(node.chtml, strike);
      };
    })(name);
  };
  exports.DiagonalStrike = DiagonalStrike;
  var DiagonalArrow = function (name) {
    return Notation.CommonDiagonalArrow(function (node, arrow) {
      node.adaptor.append(node.chtml, arrow);
    })(name);
  };
  exports.DiagonalArrow = DiagonalArrow;
  var Arrow = function (name) {
    return Notation.CommonArrow(function (node, arrow) {
      node.adaptor.append(node.chtml, arrow);
    })(name);
  };
  exports.Arrow = Arrow;
})(Notation$1);
getDefaultExportFromCjs(Notation$1);

var __extends$T = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __createBinding$7 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$7 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$7 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$7(result, mod, k);
  __setModuleDefault$7(result, mod);
  return result;
});
var __values$l = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$p = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(menclose$1, "__esModule", {
  value: true
});
menclose$1.CHTMLmenclose = void 0;
var Wrapper_js_1$e = Wrapper$2;
var menclose_js_1$1 = menclose;
var Notation = __importStar$7(Notation$1);
var menclose_js_2 = menclose$2;
var lengths_js_1$2 = lengths;
function Angle(x, y) {
  return Math.atan2(x, y).toFixed(3).replace(/\.?0+$/, '');
}
var ANGLE = Angle(Notation.ARROWDX, Notation.ARROWY);
var CHTMLmenclose = (function (_super) {
  __extends$T(CHTMLmenclose, _super);
  function CHTMLmenclose() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmenclose.prototype.toCHTML = function (parent) {
    var e_1, _a, e_2, _b;
    var adaptor = this.adaptor;
    var chtml = this.standardCHTMLnode(parent);
    var block = adaptor.append(chtml, this.html('mjx-box'));
    if (this.renderChild) {
      this.renderChild(this, block);
    } else {
      this.childNodes[0].toCHTML(block);
    }
    try {
      for (var _c = __values$l(Object.keys(this.notations)), _d = _c.next(); !_d.done; _d = _c.next()) {
        var name_1 = _d.value;
        var notation = this.notations[name_1];
        !notation.renderChild && notation.renderer(this, block);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    var pbox = this.getPadding();
    try {
      for (var _e = __values$l(Notation.sideNames), _f = _e.next(); !_f.done; _f = _e.next()) {
        var name_2 = _f.value;
        var i = Notation.sideIndex[name_2];
        pbox[i] > 0 && adaptor.setStyle(block, 'padding-' + name_2, this.em(pbox[i]));
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  CHTMLmenclose.prototype.arrow = function (w, a, double, offset, dist) {
    if (offset === void 0) {
      offset = '';
    }
    if (dist === void 0) {
      dist = 0;
    }
    var W = this.getBBox().w;
    var style = {
      width: this.em(w)
    };
    if (W !== w) {
      style.left = this.em((W - w) / 2);
    }
    if (a) {
      style.transform = 'rotate(' + this.fixed(a) + 'rad)';
    }
    var arrow = this.html('mjx-arrow', {
      style: style
    }, [this.html('mjx-aline'), this.html('mjx-rthead'), this.html('mjx-rbhead')]);
    if (double) {
      this.adaptor.append(arrow, this.html('mjx-lthead'));
      this.adaptor.append(arrow, this.html('mjx-lbhead'));
      this.adaptor.setAttribute(arrow, 'double', 'true');
    }
    this.adjustArrow(arrow, double);
    this.moveArrow(arrow, offset, dist);
    return arrow;
  };
  CHTMLmenclose.prototype.adjustArrow = function (arrow, double) {
    var _this = this;
    var t = this.thickness;
    var head = this.arrowhead;
    if (head.x === Notation.ARROWX && head.y === Notation.ARROWY && head.dx === Notation.ARROWDX && t === Notation.THICKNESS) return;
    var _a = __read$p([t * head.x, t * head.y].map(function (x) {
      return _this.em(x);
    }), 2), x = _a[0], y = _a[1];
    var a = Angle(head.dx, head.y);
    var _b = __read$p(this.adaptor.childNodes(arrow), 5), line = _b[0], rthead = _b[1], rbhead = _b[2], lthead = _b[3], lbhead = _b[4];
    this.adjustHead(rthead, [y, '0', '1px', x], a);
    this.adjustHead(rbhead, ['1px', '0', y, x], '-' + a);
    this.adjustHead(lthead, [y, x, '1px', '0'], '-' + a);
    this.adjustHead(lbhead, ['1px', x, y, '0'], a);
    this.adjustLine(line, t, head.x, double);
  };
  CHTMLmenclose.prototype.adjustHead = function (head, border, a) {
    if (head) {
      this.adaptor.setStyle(head, 'border-width', border.join(' '));
      this.adaptor.setStyle(head, 'transform', 'skewX(' + a + 'rad)');
    }
  };
  CHTMLmenclose.prototype.adjustLine = function (line, t, x, double) {
    this.adaptor.setStyle(line, 'borderTop', this.em(t) + ' solid');
    this.adaptor.setStyle(line, 'top', this.em(-t / 2));
    this.adaptor.setStyle(line, 'right', this.em(t * (x - 1)));
    if (double) {
      this.adaptor.setStyle(line, 'left', this.em(t * (x - 1)));
    }
  };
  CHTMLmenclose.prototype.moveArrow = function (arrow, offset, d) {
    if (!d) return;
    var transform = this.adaptor.getStyle(arrow, 'transform');
    this.adaptor.setStyle(arrow, 'transform', ("translate").concat(offset, "(").concat(this.em(-d), ")").concat(transform ? ' ' + transform : ''));
  };
  CHTMLmenclose.prototype.adjustBorder = function (node) {
    if (this.thickness !== Notation.THICKNESS) {
      this.adaptor.setStyle(node, 'borderWidth', this.em(this.thickness));
    }
    return node;
  };
  CHTMLmenclose.prototype.adjustThickness = function (shape) {
    if (this.thickness !== Notation.THICKNESS) {
      this.adaptor.setStyle(shape, 'strokeWidth', this.fixed(this.thickness));
    }
    return shape;
  };
  CHTMLmenclose.prototype.fixed = function (m, n) {
    if (n === void 0) {
      n = 3;
    }
    if (Math.abs(m) < .0006) {
      return '0';
    }
    return m.toFixed(n).replace(/\.?0+$/, '');
  };
  CHTMLmenclose.prototype.em = function (m) {
    return _super.prototype.em.call(this, m);
  };
  CHTMLmenclose.kind = menclose_js_2.MmlMenclose.prototype.kind;
  CHTMLmenclose.styles = {
    'mjx-menclose': {
      position: 'relative'
    },
    'mjx-menclose > mjx-dstrike': {
      display: 'inline-block',
      left: 0,
      top: 0,
      position: 'absolute',
      'border-top': Notation.SOLID,
      'transform-origin': 'top left'
    },
    'mjx-menclose > mjx-ustrike': {
      display: 'inline-block',
      left: 0,
      bottom: 0,
      position: 'absolute',
      'border-top': Notation.SOLID,
      'transform-origin': 'bottom left'
    },
    'mjx-menclose > mjx-hstrike': {
      'border-top': Notation.SOLID,
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: '50%',
      transform: 'translateY(' + (0, lengths_js_1$2.em)(Notation.THICKNESS / 2) + ')'
    },
    'mjx-menclose > mjx-vstrike': {
      'border-left': Notation.SOLID,
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: '50%',
      transform: 'translateX(' + (0, lengths_js_1$2.em)(Notation.THICKNESS / 2) + ')'
    },
    'mjx-menclose > mjx-rbox': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      'border': Notation.SOLID,
      'border-radius': (0, lengths_js_1$2.em)(Notation.THICKNESS + Notation.PADDING)
    },
    'mjx-menclose > mjx-cbox': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      'border': Notation.SOLID,
      'border-radius': '50%'
    },
    'mjx-menclose > mjx-arrow': {
      position: 'absolute',
      left: 0,
      bottom: '50%',
      height: 0,
      width: 0
    },
    'mjx-menclose > mjx-arrow > *': {
      display: 'block',
      position: 'absolute',
      'transform-origin': 'bottom',
      'border-left': (0, lengths_js_1$2.em)(Notation.THICKNESS * Notation.ARROWX) + ' solid',
      'border-right': 0,
      'box-sizing': 'border-box'
    },
    'mjx-menclose > mjx-arrow > mjx-aline': {
      left: 0,
      top: (0, lengths_js_1$2.em)(-Notation.THICKNESS / 2),
      right: (0, lengths_js_1$2.em)(Notation.THICKNESS * (Notation.ARROWX - 1)),
      height: 0,
      'border-top': (0, lengths_js_1$2.em)(Notation.THICKNESS) + ' solid',
      'border-left': 0
    },
    'mjx-menclose > mjx-arrow[double] > mjx-aline': {
      left: (0, lengths_js_1$2.em)(Notation.THICKNESS * (Notation.ARROWX - 1)),
      height: 0
    },
    'mjx-menclose > mjx-arrow > mjx-rthead': {
      transform: 'skewX(' + ANGLE + 'rad)',
      right: 0,
      bottom: '-1px',
      'border-bottom': '1px solid transparent',
      'border-top': (0, lengths_js_1$2.em)(Notation.THICKNESS * Notation.ARROWY) + ' solid transparent'
    },
    'mjx-menclose > mjx-arrow > mjx-rbhead': {
      transform: 'skewX(-' + ANGLE + 'rad)',
      'transform-origin': 'top',
      right: 0,
      top: '-1px',
      'border-top': '1px solid transparent',
      'border-bottom': (0, lengths_js_1$2.em)(Notation.THICKNESS * Notation.ARROWY) + ' solid transparent'
    },
    'mjx-menclose > mjx-arrow > mjx-lthead': {
      transform: 'skewX(-' + ANGLE + 'rad)',
      left: 0,
      bottom: '-1px',
      'border-left': 0,
      'border-right': (0, lengths_js_1$2.em)(Notation.THICKNESS * Notation.ARROWX) + ' solid',
      'border-bottom': '1px solid transparent',
      'border-top': (0, lengths_js_1$2.em)(Notation.THICKNESS * Notation.ARROWY) + ' solid transparent'
    },
    'mjx-menclose > mjx-arrow > mjx-lbhead': {
      transform: 'skewX(' + ANGLE + 'rad)',
      'transform-origin': 'top',
      left: 0,
      top: '-1px',
      'border-left': 0,
      'border-right': (0, lengths_js_1$2.em)(Notation.THICKNESS * Notation.ARROWX) + ' solid',
      'border-top': '1px solid transparent',
      'border-bottom': (0, lengths_js_1$2.em)(Notation.THICKNESS * Notation.ARROWY) + ' solid transparent'
    },
    'mjx-menclose > dbox': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: (0, lengths_js_1$2.em)(-1.5 * Notation.PADDING),
      width: (0, lengths_js_1$2.em)(3 * Notation.PADDING),
      border: (0, lengths_js_1$2.em)(Notation.THICKNESS) + ' solid',
      'border-radius': '50%',
      'clip-path': 'inset(0 0 0 ' + (0, lengths_js_1$2.em)(1.5 * Notation.PADDING) + ')',
      'box-sizing': 'border-box'
    }
  };
  CHTMLmenclose.notations = new Map([Notation.Border('top'), Notation.Border('right'), Notation.Border('bottom'), Notation.Border('left'), Notation.Border2('actuarial', 'top', 'right'), Notation.Border2('madruwb', 'bottom', 'right'), Notation.DiagonalStrike('up', 1), Notation.DiagonalStrike('down', -1), ['horizontalstrike', {
    renderer: Notation.RenderElement('hstrike', 'Y'),
    bbox: function (node) {
      return [0, node.padding, 0, node.padding];
    }
  }], ['verticalstrike', {
    renderer: Notation.RenderElement('vstrike', 'X'),
    bbox: function (node) {
      return [node.padding, 0, node.padding, 0];
    }
  }], ['box', {
    renderer: function (node, child) {
      node.adaptor.setStyle(child, 'border', node.em(node.thickness) + ' solid');
    },
    bbox: Notation.fullBBox,
    border: Notation.fullBorder,
    remove: 'left right top bottom'
  }], ['roundedbox', {
    renderer: Notation.RenderElement('rbox'),
    bbox: Notation.fullBBox
  }], ['circle', {
    renderer: Notation.RenderElement('cbox'),
    bbox: Notation.fullBBox
  }], ['phasorangle', {
    renderer: function (node, child) {
      var _a = node.getBBox(), h = _a.h, d = _a.d;
      var _b = __read$p(node.getArgMod(1.75 * node.padding, h + d), 2), a = _b[0], W = _b[1];
      var t = node.thickness * Math.sin(a) * .9;
      node.adaptor.setStyle(child, 'border-bottom', node.em(node.thickness) + ' solid');
      var strike = node.adjustBorder(node.html('mjx-ustrike', {
        style: {
          width: node.em(W),
          transform: 'translateX(' + node.em(t) + ') rotate(' + node.fixed(-a) + 'rad)'
        }
      }));
      node.adaptor.append(node.chtml, strike);
    },
    bbox: function (node) {
      var p = node.padding / 2;
      var t = node.thickness;
      return [2 * p, p, p + t, 3 * p + t];
    },
    border: function (node) {
      return [0, 0, node.thickness, 0];
    },
    remove: 'bottom'
  }], Notation.Arrow('up'), Notation.Arrow('down'), Notation.Arrow('left'), Notation.Arrow('right'), Notation.Arrow('updown'), Notation.Arrow('leftright'), Notation.DiagonalArrow('updiagonal'), Notation.DiagonalArrow('northeast'), Notation.DiagonalArrow('southeast'), Notation.DiagonalArrow('northwest'), Notation.DiagonalArrow('southwest'), Notation.DiagonalArrow('northeastsouthwest'), Notation.DiagonalArrow('northwestsoutheast'), ['longdiv', {
    renderer: function (node, child) {
      var adaptor = node.adaptor;
      adaptor.setStyle(child, 'border-top', node.em(node.thickness) + ' solid');
      var arc = adaptor.append(node.chtml, node.html('dbox'));
      var t = node.thickness;
      var p = node.padding;
      if (t !== Notation.THICKNESS) {
        adaptor.setStyle(arc, 'border-width', node.em(t));
      }
      if (p !== Notation.PADDING) {
        adaptor.setStyle(arc, 'left', node.em(-1.5 * p));
        adaptor.setStyle(arc, 'width', node.em(3 * p));
        adaptor.setStyle(arc, 'clip-path', 'inset(0 0 0 ' + node.em(1.5 * p) + ')');
      }
    },
    bbox: function (node) {
      var p = node.padding;
      var t = node.thickness;
      return [p + t, p, p, 2 * p + t / 2];
    }
  }], ['radical', {
    renderer: function (node, child) {
      node.msqrt.toCHTML(child);
      var TRBL = node.sqrtTRBL();
      node.adaptor.setStyle(node.msqrt.chtml, 'margin', TRBL.map(function (x) {
        return node.em(-x);
      }).join(' '));
    },
    init: function (node) {
      node.msqrt = node.createMsqrt(node.childNodes[0]);
    },
    bbox: function (node) {
      return node.sqrtTRBL();
    },
    renderChild: true
  }]]);
  return CHTMLmenclose;
})((0, menclose_js_1$1.CommonMencloseMixin)(Wrapper_js_1$e.CHTMLWrapper));
menclose$1.CHTMLmenclose = CHTMLmenclose;

var mrow$1 = {};

var mrow = {};

var __extends$S = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$o = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$b = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$k = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mrow, "__esModule", {
  value: true
});
mrow.CommonInferredMrowMixin = mrow.CommonMrowMixin = void 0;
var BBox_js_1$2 = BBox$1;
function CommonMrowMixin(Base) {
  return (function (_super) {
    __extends$S(class_1, _super);
    function class_1() {
      var e_1, _a;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$b([], __read$o(args), false)) || this;
      _this.stretchChildren();
      try {
        for (var _b = __values$k(_this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          if (child.bbox.pwidth) {
            _this.bbox.pwidth = BBox_js_1$2.BBox.fullWidth;
            break;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return _this;
    }
    Object.defineProperty(class_1.prototype, "fixesPWidth", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.stretchChildren = function () {
      var e_2, _a, e_3, _b, e_4, _c;
      var stretchy = [];
      try {
        for (var _d = __values$k(this.childNodes), _e = _d.next(); !_e.done; _e = _d.next()) {
          var child = _e.value;
          if (child.canStretch(1)) {
            stretchy.push(child);
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      var count = stretchy.length;
      var nodeCount = this.childNodes.length;
      if (count && nodeCount > 1) {
        var H = 0, D = 0;
        var all = count > 1 && count === nodeCount;
        try {
          for (var _f = __values$k(this.childNodes), _g = _f.next(); !_g.done; _g = _f.next()) {
            var child = _g.value;
            var noStretch = child.stretch.dir === 0;
            if (all || noStretch) {
              var _h = child.getOuterBBox(noStretch), h = _h.h, d = _h.d, rscale = _h.rscale;
              h *= rscale;
              d *= rscale;
              if (h > H) H = h;
              if (d > D) D = d;
            }
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
        try {
          for (var stretchy_1 = __values$k(stretchy), stretchy_1_1 = stretchy_1.next(); !stretchy_1_1.done; stretchy_1_1 = stretchy_1.next()) {
            var child = stretchy_1_1.value;
            child.coreMO().getStretchedVariant([H, D]);
          }
        } catch (e_4_1) {
          e_4 = {
            error: e_4_1
          };
        } finally {
          try {
            if (stretchy_1_1 && !stretchy_1_1.done && (_c = stretchy_1.return)) _c.call(stretchy_1);
          } finally {
            if (e_4) throw e_4.error;
          }
        }
      }
    };
    return class_1;
  })(Base);
}
mrow.CommonMrowMixin = CommonMrowMixin;
function CommonInferredMrowMixin(Base) {
  return (function (_super) {
    __extends$S(class_2, _super);
    function class_2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_2.prototype.getScale = function () {
      this.bbox.scale = this.parent.bbox.scale;
      this.bbox.rscale = 1;
    };
    return class_2;
  })(Base);
}
mrow.CommonInferredMrowMixin = CommonInferredMrowMixin;

var __extends$R = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$j = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mrow$1, "__esModule", {
  value: true
});
mrow$1.CHTMLinferredMrow = mrow$1.CHTMLmrow = void 0;
var Wrapper_js_1$d = Wrapper$2;
var mrow_js_1$1 = mrow;
var mrow_js_2 = mrow;
var mrow_js_3 = mrow$2;
var CHTMLmrow = (function (_super) {
  __extends$R(CHTMLmrow, _super);
  function CHTMLmrow() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmrow.prototype.toCHTML = function (parent) {
    var e_1, _a;
    var chtml = this.node.isInferred ? this.chtml = parent : this.standardCHTMLnode(parent);
    var hasNegative = false;
    try {
      for (var _b = __values$j(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        child.toCHTML(chtml);
        if (child.bbox.w < 0) {
          hasNegative = true;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    if (hasNegative) {
      var w = this.getBBox().w;
      if (w) {
        this.adaptor.setStyle(chtml, 'width', this.em(Math.max(0, w)));
        if (w < 0) {
          this.adaptor.setStyle(chtml, 'marginRight', this.em(w));
        }
      }
    }
  };
  CHTMLmrow.kind = mrow_js_3.MmlMrow.prototype.kind;
  return CHTMLmrow;
})((0, mrow_js_1$1.CommonMrowMixin)(Wrapper_js_1$d.CHTMLWrapper));
mrow$1.CHTMLmrow = CHTMLmrow;
var CHTMLinferredMrow = (function (_super) {
  __extends$R(CHTMLinferredMrow, _super);
  function CHTMLinferredMrow() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLinferredMrow.kind = mrow_js_3.MmlInferredMrow.prototype.kind;
  return CHTMLinferredMrow;
})((0, mrow_js_2.CommonInferredMrowMixin)(CHTMLmrow));
mrow$1.CHTMLinferredMrow = CHTMLinferredMrow;

var mfenced$1 = {};

var mfenced = {};

var __extends$Q = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$n = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$a = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$i = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mfenced, "__esModule", {
  value: true
});
mfenced.CommonMfencedMixin = void 0;
function CommonMfencedMixin(Base) {
  return (function (_super) {
    __extends$Q(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$a([], __read$n(args), false)) || this;
      _this.mrow = null;
      _this.createMrow();
      _this.addMrowChildren();
      return _this;
    }
    class_1.prototype.createMrow = function () {
      var mmlFactory = this.node.factory;
      var mrow = mmlFactory.create('inferredMrow');
      mrow.inheritAttributesFrom(this.node);
      this.mrow = this.wrap(mrow);
      this.mrow.parent = this;
    };
    class_1.prototype.addMrowChildren = function () {
      var e_1, _a;
      var mfenced = this.node;
      var mrow = this.mrow;
      this.addMo(mfenced.open);
      if (this.childNodes.length) {
        mrow.childNodes.push(this.childNodes[0]);
      }
      var i = 0;
      try {
        for (var _b = __values$i(this.childNodes.slice(1)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          this.addMo(mfenced.separators[i++]);
          mrow.childNodes.push(child);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      this.addMo(mfenced.close);
      mrow.stretchChildren();
    };
    class_1.prototype.addMo = function (node) {
      if (!node) return;
      var mo = this.wrap(node);
      this.mrow.childNodes.push(mo);
      mo.parent = this.mrow;
    };
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      bbox.updateFrom(this.mrow.getOuterBBox());
      this.setChildPWidths(recompute);
    };
    return class_1;
  })(Base);
}
mfenced.CommonMfencedMixin = CommonMfencedMixin;

var __extends$P = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mfenced$1, "__esModule", {
  value: true
});
mfenced$1.CHTMLmfenced = void 0;
var Wrapper_js_1$c = Wrapper$2;
var mfenced_js_1$1 = mfenced;
var mfenced_js_2 = mfenced$2;
var CHTMLmfenced = (function (_super) {
  __extends$P(CHTMLmfenced, _super);
  function CHTMLmfenced() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmfenced.prototype.toCHTML = function (parent) {
    var chtml = this.standardCHTMLnode(parent);
    this.mrow.toCHTML(chtml);
  };
  CHTMLmfenced.kind = mfenced_js_2.MmlMfenced.prototype.kind;
  return CHTMLmfenced;
})((0, mfenced_js_1$1.CommonMfencedMixin)(Wrapper_js_1$c.CHTMLWrapper));
mfenced$1.CHTMLmfenced = CHTMLmfenced;

var mfrac$1 = {};

var mfrac = {};

var __extends$O = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$m = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$9 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(mfrac, "__esModule", {
  value: true
});
mfrac.CommonMfracMixin = void 0;
function CommonMfracMixin(Base) {
  return (function (_super) {
    __extends$O(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$9([], __read$m(args), false)) || this;
      _this.bevel = null;
      _this.pad = _this.node.getProperty('withDelims') ? 0 : _this.font.params.nulldelimiterspace;
      if (_this.node.attributes.get('bevelled')) {
        var H = _this.getBevelData(_this.isDisplay()).H;
        var bevel = _this.bevel = _this.createMo('/');
        bevel.node.attributes.set('symmetric', true);
        bevel.canStretch(1);
        bevel.getStretchedVariant([H], true);
      }
      return _this;
    }
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      bbox.empty();
      var _a = this.node.attributes.getList('linethickness', 'bevelled'), linethickness = _a.linethickness, bevelled = _a.bevelled;
      var display = this.isDisplay();
      var w = null;
      if (bevelled) {
        this.getBevelledBBox(bbox, display);
      } else {
        var thickness = this.length2em(String(linethickness), .06);
        w = -2 * this.pad;
        if (thickness === 0) {
          this.getAtopBBox(bbox, display);
        } else {
          this.getFractionBBox(bbox, display, thickness);
          w -= .2;
        }
        w += bbox.w;
      }
      bbox.clean();
      this.setChildPWidths(recompute, w);
    };
    class_1.prototype.getFractionBBox = function (bbox, display, t) {
      var nbox = this.childNodes[0].getOuterBBox();
      var dbox = this.childNodes[1].getOuterBBox();
      var tex = this.font.params;
      var a = tex.axis_height;
      var _a = this.getTUV(display, t), T = _a.T, u = _a.u, v = _a.v;
      bbox.combine(nbox, 0, a + T + Math.max(nbox.d * nbox.rscale, u));
      bbox.combine(dbox, 0, a - T - Math.max(dbox.h * dbox.rscale, v));
      bbox.w += 2 * this.pad + .2;
    };
    class_1.prototype.getTUV = function (display, t) {
      var tex = this.font.params;
      var a = tex.axis_height;
      var T = (display ? 3.5 : 1.5) * t;
      return {
        T: (display ? 3.5 : 1.5) * t,
        u: (display ? tex.num1 : tex.num2) - a - T,
        v: (display ? tex.denom1 : tex.denom2) + a - T
      };
    };
    class_1.prototype.getAtopBBox = function (bbox, display) {
      var _a = this.getUVQ(display), u = _a.u, v = _a.v, nbox = _a.nbox, dbox = _a.dbox;
      bbox.combine(nbox, 0, u);
      bbox.combine(dbox, 0, -v);
      bbox.w += 2 * this.pad;
    };
    class_1.prototype.getUVQ = function (display) {
      var nbox = this.childNodes[0].getOuterBBox();
      var dbox = this.childNodes[1].getOuterBBox();
      var tex = this.font.params;
      var _a = __read$m(display ? [tex.num1, tex.denom1] : [tex.num3, tex.denom2], 2), u = _a[0], v = _a[1];
      var p = (display ? 7 : 3) * tex.rule_thickness;
      var q = u - nbox.d * nbox.scale - (dbox.h * dbox.scale - v);
      if (q < p) {
        u += (p - q) / 2;
        v += (p - q) / 2;
        q = p;
      }
      return {
        u: u,
        v: v,
        q: q,
        nbox: nbox,
        dbox: dbox
      };
    };
    class_1.prototype.getBevelledBBox = function (bbox, display) {
      var _a = this.getBevelData(display), u = _a.u, v = _a.v, delta = _a.delta, nbox = _a.nbox, dbox = _a.dbox;
      var lbox = this.bevel.getOuterBBox();
      bbox.combine(nbox, 0, u);
      bbox.combine(lbox, bbox.w - delta / 2, 0);
      bbox.combine(dbox, bbox.w - delta / 2, v);
    };
    class_1.prototype.getBevelData = function (display) {
      var nbox = this.childNodes[0].getOuterBBox();
      var dbox = this.childNodes[1].getOuterBBox();
      var delta = display ? .4 : .15;
      var H = Math.max(nbox.scale * (nbox.h + nbox.d), dbox.scale * (dbox.h + dbox.d)) + 2 * delta;
      var a = this.font.params.axis_height;
      var u = nbox.scale * (nbox.d - nbox.h) / 2 + a + delta;
      var v = dbox.scale * (dbox.d - dbox.h) / 2 + a - delta;
      return {
        H: H,
        delta: delta,
        u: u,
        v: v,
        nbox: nbox,
        dbox: dbox
      };
    };
    class_1.prototype.canStretch = function (_direction) {
      return false;
    };
    class_1.prototype.isDisplay = function () {
      var _a = this.node.attributes.getList('displaystyle', 'scriptlevel'), displaystyle = _a.displaystyle, scriptlevel = _a.scriptlevel;
      return displaystyle && scriptlevel === 0;
    };
    class_1.prototype.getWrapWidth = function (i) {
      var attributes = this.node.attributes;
      if (attributes.get('bevelled')) {
        return this.childNodes[i].getOuterBBox().w;
      }
      var w = this.getBBox().w;
      var thickness = this.length2em(attributes.get('linethickness'));
      return w - (thickness ? .2 : 0) - 2 * this.pad;
    };
    class_1.prototype.getChildAlign = function (i) {
      var attributes = this.node.attributes;
      return attributes.get('bevelled') ? 'left' : attributes.get(['numalign', 'denomalign'][i]);
    };
    return class_1;
  })(Base);
}
mfrac.CommonMfracMixin = CommonMfracMixin;

var __extends$N = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$5 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$5 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$5.apply(this, arguments);
});
Object.defineProperty(mfrac$1, "__esModule", {
  value: true
});
mfrac$1.CHTMLmfrac = void 0;
var Wrapper_js_1$b = Wrapper$2;
var mfrac_js_1$1 = mfrac;
var mfrac_js_2 = mfrac$2;
var CHTMLmfrac = (function (_super) {
  __extends$N(CHTMLmfrac, _super);
  function CHTMLmfrac() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmfrac.prototype.toCHTML = function (parent) {
    this.standardCHTMLnode(parent);
    var _a = this.node.attributes.getList('linethickness', 'bevelled'), linethickness = _a.linethickness, bevelled = _a.bevelled;
    var display = this.isDisplay();
    if (bevelled) {
      this.makeBevelled(display);
    } else {
      var thickness = this.length2em(String(linethickness), .06);
      if (thickness === 0) {
        this.makeAtop(display);
      } else {
        this.makeFraction(display, thickness);
      }
    }
  };
  CHTMLmfrac.prototype.makeFraction = function (display, t) {
    var _a = this.node.attributes.getList('numalign', 'denomalign'), numalign = _a.numalign, denomalign = _a.denomalign;
    var withDelims = this.node.getProperty('withDelims');
    var attr = display ? {
      type: 'd'
    } : {};
    var fattr = withDelims ? __assign$5(__assign$5({}, attr), {
      delims: 'true'
    }) : __assign$5({}, attr);
    var nattr = numalign !== 'center' ? {
      align: numalign
    } : {};
    var dattr = denomalign !== 'center' ? {
      align: denomalign
    } : {};
    var dsattr = __assign$5({}, attr), nsattr = __assign$5({}, attr);
    var tex = this.font.params;
    if (t !== .06) {
      var a = tex.axis_height;
      var tEm = this.em(t);
      var _b = this.getTUV(display, t), T = _b.T, u = _b.u, v = _b.v;
      var m = (display ? this.em(3 * t) : tEm) + ' -.1em';
      attr.style = {
        height: tEm,
        'border-top': tEm + ' solid',
        margin: m
      };
      var nh = this.em(Math.max(0, u));
      nsattr.style = {
        height: nh,
        'vertical-align': '-' + nh
      };
      dsattr.style = {
        height: this.em(Math.max(0, v))
      };
      fattr.style = {
        'vertical-align': this.em(a - T)
      };
    }
    var num, den;
    this.adaptor.append(this.chtml, this.html('mjx-frac', fattr, [num = this.html('mjx-num', nattr, [this.html('mjx-nstrut', nsattr)]), this.html('mjx-dbox', {}, [this.html('mjx-dtable', {}, [this.html('mjx-line', attr), this.html('mjx-row', {}, [den = this.html('mjx-den', dattr, [this.html('mjx-dstrut', dsattr)])])])])]));
    this.childNodes[0].toCHTML(num);
    this.childNodes[1].toCHTML(den);
  };
  CHTMLmfrac.prototype.makeAtop = function (display) {
    var _a = this.node.attributes.getList('numalign', 'denomalign'), numalign = _a.numalign, denomalign = _a.denomalign;
    var withDelims = this.node.getProperty('withDelims');
    var attr = display ? {
      type: 'd',
      atop: true
    } : {
      atop: true
    };
    var fattr = withDelims ? __assign$5(__assign$5({}, attr), {
      delims: true
    }) : __assign$5({}, attr);
    var nattr = numalign !== 'center' ? {
      align: numalign
    } : {};
    var dattr = denomalign !== 'center' ? {
      align: denomalign
    } : {};
    var _b = this.getUVQ(display), v = _b.v, q = _b.q;
    nattr.style = {
      'padding-bottom': this.em(q)
    };
    fattr.style = {
      'vertical-align': this.em(-v)
    };
    var num, den;
    this.adaptor.append(this.chtml, this.html('mjx-frac', fattr, [num = this.html('mjx-num', nattr), den = this.html('mjx-den', dattr)]));
    this.childNodes[0].toCHTML(num);
    this.childNodes[1].toCHTML(den);
  };
  CHTMLmfrac.prototype.makeBevelled = function (display) {
    var adaptor = this.adaptor;
    adaptor.setAttribute(this.chtml, 'bevelled', 'ture');
    var num = adaptor.append(this.chtml, this.html('mjx-num'));
    this.childNodes[0].toCHTML(num);
    this.bevel.toCHTML(this.chtml);
    var den = adaptor.append(this.chtml, this.html('mjx-den'));
    this.childNodes[1].toCHTML(den);
    var _a = this.getBevelData(display), u = _a.u, v = _a.v, delta = _a.delta, nbox = _a.nbox, dbox = _a.dbox;
    if (u) {
      adaptor.setStyle(num, 'verticalAlign', this.em(u / nbox.scale));
    }
    if (v) {
      adaptor.setStyle(den, 'verticalAlign', this.em(v / dbox.scale));
    }
    var dx = this.em(-delta / 2);
    adaptor.setStyle(this.bevel.chtml, 'marginLeft', dx);
    adaptor.setStyle(this.bevel.chtml, 'marginRight', dx);
  };
  CHTMLmfrac.kind = mfrac_js_2.MmlMfrac.prototype.kind;
  CHTMLmfrac.styles = {
    'mjx-frac': {
      display: 'inline-block',
      'vertical-align': '0.17em',
      padding: '0 .22em'
    },
    'mjx-frac[type="d"]': {
      'vertical-align': '.04em'
    },
    'mjx-frac[delims]': {
      padding: '0 .1em'
    },
    'mjx-frac[atop]': {
      padding: '0 .12em'
    },
    'mjx-frac[atop][delims]': {
      padding: '0'
    },
    'mjx-dtable': {
      display: 'inline-table',
      width: '100%'
    },
    'mjx-dtable > *': {
      'font-size': '2000%'
    },
    'mjx-dbox': {
      display: 'block',
      'font-size': '5%'
    },
    'mjx-num': {
      display: 'block',
      'text-align': 'center'
    },
    'mjx-den': {
      display: 'block',
      'text-align': 'center'
    },
    'mjx-mfrac[bevelled] > mjx-num': {
      display: 'inline-block'
    },
    'mjx-mfrac[bevelled] > mjx-den': {
      display: 'inline-block'
    },
    'mjx-den[align="right"], mjx-num[align="right"]': {
      'text-align': 'right'
    },
    'mjx-den[align="left"], mjx-num[align="left"]': {
      'text-align': 'left'
    },
    'mjx-nstrut': {
      display: 'inline-block',
      height: '.054em',
      width: 0,
      'vertical-align': '-.054em'
    },
    'mjx-nstrut[type="d"]': {
      height: '.217em',
      'vertical-align': '-.217em'
    },
    'mjx-dstrut': {
      display: 'inline-block',
      height: '.505em',
      width: 0
    },
    'mjx-dstrut[type="d"]': {
      height: '.726em'
    },
    'mjx-line': {
      display: 'block',
      'box-sizing': 'border-box',
      'min-height': '1px',
      height: '.06em',
      'border-top': '.06em solid',
      margin: '.06em -.1em',
      overflow: 'hidden'
    },
    'mjx-line[type="d"]': {
      margin: '.18em -.1em'
    }
  };
  return CHTMLmfrac;
})((0, mfrac_js_1$1.CommonMfracMixin)(Wrapper_js_1$b.CHTMLWrapper));
mfrac$1.CHTMLmfrac = CHTMLmfrac;

var msqrt$1 = {};

var msqrt = {};

var __extends$M = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$l = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$8 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(msqrt, "__esModule", {
  value: true
});
msqrt.CommonMsqrtMixin = void 0;
var BBox_js_1$1 = BBox$1;
function CommonMsqrtMixin(Base) {
  return (function (_super) {
    __extends$M(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$8([], __read$l(args), false)) || this;
      var surd = _this.createMo('\u221A');
      surd.canStretch(1);
      var _a = _this.childNodes[_this.base].getOuterBBox(), h = _a.h, d = _a.d;
      var t = _this.font.params.rule_thickness;
      var p = _this.node.attributes.get('displaystyle') ? _this.font.params.x_height : t;
      _this.surdH = h + d + 2 * t + p / 4;
      surd.getStretchedVariant([_this.surdH - d, d], true);
      return _this;
    }
    Object.defineProperty(class_1.prototype, "base", {
      get: function () {
        return 0;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_1.prototype, "surd", {
      get: function () {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_1.prototype, "root", {
      get: function () {
        return null;
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.createMo = function (text) {
      var node = _super.prototype.createMo.call(this, text);
      this.childNodes.push(node);
      return node;
    };
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      var surdbox = this.childNodes[this.surd].getBBox();
      var basebox = new BBox_js_1$1.BBox(this.childNodes[this.base].getOuterBBox());
      var q = this.getPQ(surdbox)[1];
      var t = this.font.params.rule_thickness;
      var H = basebox.h + q + t;
      var _a = __read$l(this.getRootDimens(surdbox, H), 1), x = _a[0];
      bbox.h = H + t;
      this.combineRootBBox(bbox, surdbox, H);
      bbox.combine(surdbox, x, H - surdbox.h);
      bbox.combine(basebox, x + surdbox.w, 0);
      bbox.clean();
      this.setChildPWidths(recompute);
    };
    class_1.prototype.combineRootBBox = function (_bbox, _sbox, _H) {};
    class_1.prototype.getPQ = function (sbox) {
      var t = this.font.params.rule_thickness;
      var p = this.node.attributes.get('displaystyle') ? this.font.params.x_height : t;
      var q = sbox.h + sbox.d > this.surdH ? (sbox.h + sbox.d - (this.surdH - 2 * t - p / 2)) / 2 : t + p / 4;
      return [p, q];
    };
    class_1.prototype.getRootDimens = function (_sbox, _H) {
      return [0, 0, 0, 0];
    };
    return class_1;
  })(Base);
}
msqrt.CommonMsqrtMixin = CommonMsqrtMixin;

var __extends$L = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$k = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(msqrt$1, "__esModule", {
  value: true
});
msqrt$1.CHTMLmsqrt = void 0;
var Wrapper_js_1$a = Wrapper$2;
var msqrt_js_1$2 = msqrt;
var msqrt_js_2 = msqrt$2;
var CHTMLmsqrt = (function (_super) {
  __extends$L(CHTMLmsqrt, _super);
  function CHTMLmsqrt() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmsqrt.prototype.toCHTML = function (parent) {
    var surd = this.childNodes[this.surd];
    var base = this.childNodes[this.base];
    var sbox = surd.getBBox();
    var bbox = base.getOuterBBox();
    var _a = __read$k(this.getPQ(sbox), 2), q = _a[1];
    var t = this.font.params.rule_thickness;
    var H = bbox.h + q + t;
    var CHTML = this.standardCHTMLnode(parent);
    var SURD, BASE, ROOT, root;
    if (this.root != null) {
      ROOT = this.adaptor.append(CHTML, this.html('mjx-root'));
      root = this.childNodes[this.root];
    }
    var SQRT = this.adaptor.append(CHTML, this.html('mjx-sqrt', {}, [SURD = this.html('mjx-surd'), BASE = this.html('mjx-box', {
      style: {
        paddingTop: this.em(q)
      }
    })]));
    this.addRoot(ROOT, root, sbox, H);
    surd.toCHTML(SURD);
    base.toCHTML(BASE);
    if (surd.size < 0) {
      this.adaptor.addClass(SQRT, 'mjx-tall');
    }
  };
  CHTMLmsqrt.prototype.addRoot = function (_ROOT, _root, _sbox, _H) {};
  CHTMLmsqrt.kind = msqrt_js_2.MmlMsqrt.prototype.kind;
  CHTMLmsqrt.styles = {
    'mjx-root': {
      display: 'inline-block',
      'white-space': 'nowrap'
    },
    'mjx-surd': {
      display: 'inline-block',
      'vertical-align': 'top'
    },
    'mjx-sqrt': {
      display: 'inline-block',
      'padding-top': '.07em'
    },
    'mjx-sqrt > mjx-box': {
      'border-top': '.07em solid'
    },
    'mjx-sqrt.mjx-tall > mjx-box': {
      'padding-left': '.3em',
      'margin-left': '-.3em'
    }
  };
  return CHTMLmsqrt;
})((0, msqrt_js_1$2.CommonMsqrtMixin)(Wrapper_js_1$a.CHTMLWrapper));
msqrt$1.CHTMLmsqrt = CHTMLmsqrt;

var mroot$1 = {};

var mroot = {};

var __extends$K = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mroot, "__esModule", {
  value: true
});
mroot.CommonMrootMixin = void 0;
function CommonMrootMixin(Base) {
  return (function (_super) {
    __extends$K(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(class_1.prototype, "surd", {
      get: function () {
        return 2;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_1.prototype, "root", {
      get: function () {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.combineRootBBox = function (BBOX, sbox, H) {
      var bbox = this.childNodes[this.root].getOuterBBox();
      var h = this.getRootDimens(sbox, H)[1];
      BBOX.combine(bbox, 0, h);
    };
    class_1.prototype.getRootDimens = function (sbox, H) {
      var surd = this.childNodes[this.surd];
      var bbox = this.childNodes[this.root].getOuterBBox();
      var offset = (surd.size < 0 ? .5 : .6) * sbox.w;
      var w = bbox.w, rscale = bbox.rscale;
      var W = Math.max(w, offset / rscale);
      var dx = Math.max(0, W - w);
      var h = this.rootHeight(bbox, sbox, surd.size, H);
      var x = W * rscale - offset;
      return [x, h, dx];
    };
    class_1.prototype.rootHeight = function (rbox, sbox, size, H) {
      var h = sbox.h + sbox.d;
      var b = (size < 0 ? 1.9 : .55 * h) - (h - H);
      return b + Math.max(0, rbox.d * rbox.rscale);
    };
    return class_1;
  })(Base);
}
mroot.CommonMrootMixin = CommonMrootMixin;

var __extends$J = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$j = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(mroot$1, "__esModule", {
  value: true
});
mroot$1.CHTMLmroot = void 0;
var msqrt_js_1$1 = msqrt$1;
var mroot_js_1$1 = mroot;
var mroot_js_2 = mroot$2;
var CHTMLmroot = (function (_super) {
  __extends$J(CHTMLmroot, _super);
  function CHTMLmroot() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmroot.prototype.addRoot = function (ROOT, root, sbox, H) {
    root.toCHTML(ROOT);
    var _a = __read$j(this.getRootDimens(sbox, H), 3), x = _a[0], h = _a[1], dx = _a[2];
    this.adaptor.setStyle(ROOT, 'verticalAlign', this.em(h));
    this.adaptor.setStyle(ROOT, 'width', this.em(x));
    if (dx) {
      this.adaptor.setStyle(this.adaptor.firstChild(ROOT), 'paddingLeft', this.em(dx));
    }
  };
  CHTMLmroot.kind = mroot_js_2.MmlMroot.prototype.kind;
  return CHTMLmroot;
})((0, mroot_js_1$1.CommonMrootMixin)(msqrt_js_1$1.CHTMLmsqrt));
mroot$1.CHTMLmroot = CHTMLmroot;

var msubsup$1 = {};

var scriptbase$1 = {};

var scriptbase = {};

var __extends$I = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$i = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$7 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$h = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(scriptbase, "__esModule", {
  value: true
});
scriptbase.CommonScriptbaseMixin = void 0;
var MmlNode_js_1$b = MmlNode;
function CommonScriptbaseMixin(Base) {
  var _a;
  return (_a = (function (_super) {
    __extends$I(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$7([], __read$i(args), false)) || this;
      _this.baseScale = 1;
      _this.baseIc = 0;
      _this.baseRemoveIc = false;
      _this.baseIsChar = false;
      _this.baseHasAccentOver = null;
      _this.baseHasAccentUnder = null;
      _this.isLineAbove = false;
      _this.isLineBelow = false;
      _this.isMathAccent = false;
      var core = _this.baseCore = _this.getBaseCore();
      if (!core) return _this;
      _this.setBaseAccentsFor(core);
      _this.baseScale = _this.getBaseScale();
      _this.baseIc = _this.getBaseIc();
      _this.baseIsChar = _this.isCharBase();
      _this.isMathAccent = _this.baseIsChar && (_this.scriptChild && !!_this.scriptChild.coreMO().node.getProperty('mathaccent'));
      _this.checkLineAccents();
      _this.baseRemoveIc = !_this.isLineAbove && !_this.isLineBelow && (!_this.constructor.useIC || _this.isMathAccent);
      return _this;
    }
    Object.defineProperty(class_1.prototype, "baseChild", {
      get: function () {
        return this.childNodes[this.node.base];
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_1.prototype, "scriptChild", {
      get: function () {
        return this.childNodes[1];
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.getBaseCore = function () {
      var core = this.getSemanticBase() || this.childNodes[0];
      while (core && (core.childNodes.length === 1 && (core.node.isKind('mrow') || core.node.isKind('TeXAtom') && core.node.texClass !== MmlNode_js_1$b.TEXCLASS.VCENTER || core.node.isKind('mstyle') || core.node.isKind('mpadded') || core.node.isKind('mphantom') || core.node.isKind('semantics')) || core.node.isKind('munderover') && core.isMathAccent)) {
        this.setBaseAccentsFor(core);
        core = core.childNodes[0];
      }
      if (!core) {
        this.baseHasAccentOver = this.baseHasAccentUnder = false;
      }
      return core || this.childNodes[0];
    };
    class_1.prototype.setBaseAccentsFor = function (core) {
      if (core.node.isKind('munderover')) {
        if (this.baseHasAccentOver === null) {
          this.baseHasAccentOver = !!core.node.attributes.get('accent');
        }
        if (this.baseHasAccentUnder === null) {
          this.baseHasAccentUnder = !!core.node.attributes.get('accentunder');
        }
      }
    };
    class_1.prototype.getSemanticBase = function () {
      var fence = this.node.attributes.getExplicit('data-semantic-fencepointer');
      return this.getBaseFence(this.baseChild, fence);
    };
    class_1.prototype.getBaseFence = function (fence, id) {
      var e_1, _a;
      if (!fence || !fence.node.attributes || !id) {
        return null;
      }
      if (fence.node.attributes.getExplicit('data-semantic-id') === id) {
        return fence;
      }
      try {
        for (var _b = __values$h(fence.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          var result = this.getBaseFence(child, id);
          if (result) {
            return result;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return null;
    };
    class_1.prototype.getBaseScale = function () {
      var child = this.baseCore;
      var scale = 1;
      while (child && child !== this) {
        var bbox = child.getOuterBBox();
        scale *= bbox.rscale;
        child = child.parent;
      }
      return scale;
    };
    class_1.prototype.getBaseIc = function () {
      return this.baseCore.getOuterBBox().ic * this.baseScale;
    };
    class_1.prototype.getAdjustedIc = function () {
      var bbox = this.baseCore.getOuterBBox();
      return (bbox.ic ? 1.05 * bbox.ic + .05 : 0) * this.baseScale;
    };
    class_1.prototype.isCharBase = function () {
      var base = this.baseCore;
      return (base.node.isKind('mo') && base.size === null || base.node.isKind('mi') || base.node.isKind('mn')) && base.bbox.rscale === 1 && Array.from(base.getText()).length === 1;
    };
    class_1.prototype.checkLineAccents = function () {
      if (!this.node.isKind('munderover')) return;
      if (this.node.isKind('mover')) {
        this.isLineAbove = this.isLineAccent(this.scriptChild);
      } else if (this.node.isKind('munder')) {
        this.isLineBelow = this.isLineAccent(this.scriptChild);
      } else {
        var mml = this;
        this.isLineAbove = this.isLineAccent(mml.overChild);
        this.isLineBelow = this.isLineAccent(mml.underChild);
      }
    };
    class_1.prototype.isLineAccent = function (script) {
      var node = script.coreMO().node;
      return node.isToken && node.getText() === '\u2015';
    };
    class_1.prototype.getBaseWidth = function () {
      var bbox = this.baseChild.getOuterBBox();
      return bbox.w * bbox.rscale - (this.baseRemoveIc ? this.baseIc : 0) + this.font.params.extra_ic;
    };
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      var w = this.getBaseWidth();
      var _a = __read$i(this.getOffset(), 2), x = _a[0], y = _a[1];
      bbox.append(this.baseChild.getOuterBBox());
      bbox.combine(this.scriptChild.getOuterBBox(), w + x, y);
      bbox.w += this.font.params.scriptspace;
      bbox.clean();
      this.setChildPWidths(recompute);
    };
    class_1.prototype.getOffset = function () {
      return [0, 0];
    };
    class_1.prototype.baseCharZero = function (n) {
      var largeop = !!this.baseCore.node.attributes.get('largeop');
      var scale = this.baseScale;
      return this.baseIsChar && !largeop && scale === 1 ? 0 : n;
    };
    class_1.prototype.getV = function () {
      var bbox = this.baseCore.getOuterBBox();
      var sbox = this.scriptChild.getOuterBBox();
      var tex = this.font.params;
      var subscriptshift = this.length2em(this.node.attributes.get('subscriptshift'), tex.sub1);
      return Math.max(this.baseCharZero(bbox.d * this.baseScale + tex.sub_drop * sbox.rscale), subscriptshift, sbox.h * sbox.rscale - 4 / 5 * tex.x_height);
    };
    class_1.prototype.getU = function () {
      var bbox = this.baseCore.getOuterBBox();
      var sbox = this.scriptChild.getOuterBBox();
      var tex = this.font.params;
      var attr = this.node.attributes.getList('displaystyle', 'superscriptshift');
      var prime = this.node.getProperty('texprimestyle');
      var p = prime ? tex.sup3 : attr.displaystyle ? tex.sup1 : tex.sup2;
      var superscriptshift = this.length2em(attr.superscriptshift, p);
      return Math.max(this.baseCharZero(bbox.h * this.baseScale - tex.sup_drop * sbox.rscale), superscriptshift, sbox.d * sbox.rscale + 1 / 4 * tex.x_height);
    };
    class_1.prototype.hasMovableLimits = function () {
      var display = this.node.attributes.get('displaystyle');
      var mo = this.baseChild.coreMO().node;
      return !display && !!mo.attributes.get('movablelimits');
    };
    class_1.prototype.getOverKU = function (basebox, overbox) {
      var accent = this.node.attributes.get('accent');
      var tex = this.font.params;
      var d = overbox.d * overbox.rscale;
      var t = tex.rule_thickness * tex.separation_factor;
      var delta = this.baseHasAccentOver ? t : 0;
      var T = this.isLineAbove ? 3 * tex.rule_thickness : t;
      var k = (accent ? T : Math.max(tex.big_op_spacing1, tex.big_op_spacing3 - Math.max(0, d))) - delta;
      return [k, basebox.h * basebox.rscale + k + d];
    };
    class_1.prototype.getUnderKV = function (basebox, underbox) {
      var accent = this.node.attributes.get('accentunder');
      var tex = this.font.params;
      var h = underbox.h * underbox.rscale;
      var t = tex.rule_thickness * tex.separation_factor;
      var delta = this.baseHasAccentUnder ? t : 0;
      var T = this.isLineBelow ? 3 * tex.rule_thickness : t;
      var k = (accent ? T : Math.max(tex.big_op_spacing2, tex.big_op_spacing4 - h)) - delta;
      return [k, -(basebox.d * basebox.rscale + k + h)];
    };
    class_1.prototype.getDeltaW = function (boxes, delta) {
      var e_2, _a, e_3, _b;
      if (delta === void 0) {
        delta = [0, 0, 0];
      }
      var align = this.node.attributes.get('align');
      var widths = boxes.map(function (box) {
        return box.w * box.rscale;
      });
      widths[0] -= this.baseRemoveIc && !this.baseCore.node.attributes.get('largeop') ? this.baseIc : 0;
      var w = Math.max.apply(Math, __spreadArray$7([], __read$i(widths), false));
      var dw = [];
      var m = 0;
      try {
        for (var _c = __values$h(widths.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
          var i = _d.value;
          dw[i] = (align === 'center' ? (w - widths[i]) / 2 : align === 'right' ? w - widths[i] : 0) + delta[i];
          if (dw[i] < m) {
            m = -dw[i];
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      if (m) {
        try {
          for (var _e = __values$h(dw.keys()), _f = _e.next(); !_f.done; _f = _e.next()) {
            var i = _f.value;
            dw[i] += m;
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
      }
      [1, 2].map(function (i) {
        return dw[i] += boxes[i] ? boxes[i].dx * boxes[0].scale : 0;
      });
      return dw;
    };
    class_1.prototype.getDelta = function (noskew) {
      if (noskew === void 0) {
        noskew = false;
      }
      var accent = this.node.attributes.get('accent');
      var _a = this.baseCore.getOuterBBox(), sk = _a.sk, ic = _a.ic;
      return ((accent && !noskew ? sk : 0) + this.font.skewIcFactor * ic) * this.baseScale;
    };
    class_1.prototype.stretchChildren = function () {
      var e_4, _a, e_5, _b, e_6, _c;
      var stretchy = [];
      try {
        for (var _d = __values$h(this.childNodes), _e = _d.next(); !_e.done; _e = _d.next()) {
          var child = _e.value;
          if (child.canStretch(2)) {
            stretchy.push(child);
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
      var count = stretchy.length;
      var nodeCount = this.childNodes.length;
      if (count && nodeCount > 1) {
        var W = 0;
        var all = count > 1 && count === nodeCount;
        try {
          for (var _f = __values$h(this.childNodes), _g = _f.next(); !_g.done; _g = _f.next()) {
            var child = _g.value;
            var noStretch = child.stretch.dir === 0;
            if (all || noStretch) {
              var _h = child.getOuterBBox(noStretch), w = _h.w, rscale = _h.rscale;
              if (w * rscale > W) W = w * rscale;
            }
          }
        } catch (e_5_1) {
          e_5 = {
            error: e_5_1
          };
        } finally {
          try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
          } finally {
            if (e_5) throw e_5.error;
          }
        }
        try {
          for (var stretchy_1 = __values$h(stretchy), stretchy_1_1 = stretchy_1.next(); !stretchy_1_1.done; stretchy_1_1 = stretchy_1.next()) {
            var child = stretchy_1_1.value;
            child.coreMO().getStretchedVariant([W / child.bbox.rscale]);
          }
        } catch (e_6_1) {
          e_6 = {
            error: e_6_1
          };
        } finally {
          try {
            if (stretchy_1_1 && !stretchy_1_1.done && (_c = stretchy_1.return)) _c.call(stretchy_1);
          } finally {
            if (e_6) throw e_6.error;
          }
        }
      }
    };
    return class_1;
  })(Base), _a.useIC = true, _a);
}
scriptbase.CommonScriptbaseMixin = CommonScriptbaseMixin;

var __extends$H = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$h = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$g = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(scriptbase$1, "__esModule", {
  value: true
});
scriptbase$1.CHTMLscriptbase = void 0;
var Wrapper_js_1$9 = Wrapper$2;
var scriptbase_js_1$1 = scriptbase;
var CHTMLscriptbase = (function (_super) {
  __extends$H(CHTMLscriptbase, _super);
  function CHTMLscriptbase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLscriptbase.prototype.toCHTML = function (parent) {
    this.chtml = this.standardCHTMLnode(parent);
    var _a = __read$h(this.getOffset(), 2), x = _a[0], v = _a[1];
    var dx = x - (this.baseRemoveIc ? this.baseIc : 0);
    var style = {
      'vertical-align': this.em(v)
    };
    if (dx) {
      style['margin-left'] = this.em(dx);
    }
    this.baseChild.toCHTML(this.chtml);
    this.scriptChild.toCHTML(this.adaptor.append(this.chtml, this.html('mjx-script', {
      style: style
    })));
  };
  CHTMLscriptbase.prototype.setDeltaW = function (nodes, dx) {
    for (var i = 0; i < dx.length; i++) {
      if (dx[i]) {
        this.adaptor.setStyle(nodes[i], 'paddingLeft', this.em(dx[i]));
      }
    }
  };
  CHTMLscriptbase.prototype.adjustOverDepth = function (over, overbox) {
    if (overbox.d >= 0) return;
    this.adaptor.setStyle(over, 'marginBottom', this.em(overbox.d * overbox.rscale));
  };
  CHTMLscriptbase.prototype.adjustUnderDepth = function (under, underbox) {
    var e_1, _a;
    if (underbox.d >= 0) return;
    var adaptor = this.adaptor;
    var v = this.em(underbox.d);
    var box = this.html('mjx-box', {
      style: {
        'margin-bottom': v,
        'vertical-align': v
      }
    });
    try {
      for (var _b = __values$g(adaptor.childNodes(adaptor.firstChild(under))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        adaptor.append(box, child);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    adaptor.append(adaptor.firstChild(under), box);
  };
  CHTMLscriptbase.prototype.adjustBaseHeight = function (base, basebox) {
    if (this.node.attributes.get('accent')) {
      var minH = this.font.params.x_height * basebox.scale;
      if (basebox.h < minH) {
        this.adaptor.setStyle(base, 'paddingTop', this.em(minH - basebox.h));
        basebox.h = minH;
      }
    }
  };
  CHTMLscriptbase.kind = 'scriptbase';
  return CHTMLscriptbase;
})((0, scriptbase_js_1$1.CommonScriptbaseMixin)(Wrapper_js_1$9.CHTMLWrapper));
scriptbase$1.CHTMLscriptbase = CHTMLscriptbase;

var msubsup = {};

var __extends$G = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$g = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(msubsup, "__esModule", {
  value: true
});
msubsup.CommonMsubsupMixin = msubsup.CommonMsupMixin = msubsup.CommonMsubMixin = void 0;
function CommonMsubMixin(Base) {
  var _a;
  return (_a = (function (_super) {
    __extends$G(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(class_1.prototype, "scriptChild", {
      get: function () {
        return this.childNodes[this.node.sub];
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.getOffset = function () {
      return [0, -this.getV()];
    };
    return class_1;
  })(Base), _a.useIC = false, _a);
}
msubsup.CommonMsubMixin = CommonMsubMixin;
function CommonMsupMixin(Base) {
  return (function (_super) {
    __extends$G(class_2, _super);
    function class_2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(class_2.prototype, "scriptChild", {
      get: function () {
        return this.childNodes[this.node.sup];
      },
      enumerable: false,
      configurable: true
    });
    class_2.prototype.getOffset = function () {
      var x = this.getAdjustedIc() - (this.baseRemoveIc ? 0 : this.baseIc);
      return [x, this.getU()];
    };
    return class_2;
  })(Base);
}
msubsup.CommonMsupMixin = CommonMsupMixin;
function CommonMsubsupMixin(Base) {
  var _a;
  return (_a = (function (_super) {
    __extends$G(class_3, _super);
    function class_3() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.UVQ = null;
      return _this;
    }
    Object.defineProperty(class_3.prototype, "subChild", {
      get: function () {
        return this.childNodes[this.node.sub];
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_3.prototype, "supChild", {
      get: function () {
        return this.childNodes[this.node.sup];
      },
      enumerable: false,
      configurable: true
    });
    class_3.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      var basebox = this.baseChild.getOuterBBox();
      var _a = __read$g([this.subChild.getOuterBBox(), this.supChild.getOuterBBox()], 2), subbox = _a[0], supbox = _a[1];
      bbox.empty();
      bbox.append(basebox);
      var w = this.getBaseWidth();
      var x = this.getAdjustedIc();
      var _b = __read$g(this.getUVQ(), 2), u = _b[0], v = _b[1];
      bbox.combine(subbox, w, v);
      bbox.combine(supbox, w + x, u);
      bbox.w += this.font.params.scriptspace;
      bbox.clean();
      this.setChildPWidths(recompute);
    };
    class_3.prototype.getUVQ = function (subbox, supbox) {
      if (subbox === void 0) {
        subbox = this.subChild.getOuterBBox();
      }
      if (supbox === void 0) {
        supbox = this.supChild.getOuterBBox();
      }
      var basebox = this.baseCore.getOuterBBox();
      if (this.UVQ) return this.UVQ;
      var tex = this.font.params;
      var t = 3 * tex.rule_thickness;
      var subscriptshift = this.length2em(this.node.attributes.get('subscriptshift'), tex.sub2);
      var drop = this.baseCharZero(basebox.d * this.baseScale + tex.sub_drop * subbox.rscale);
      var _a = __read$g([this.getU(), Math.max(drop, subscriptshift)], 2), u = _a[0], v = _a[1];
      var q = u - supbox.d * supbox.rscale - (subbox.h * subbox.rscale - v);
      if (q < t) {
        v += t - q;
        var p = 4 / 5 * tex.x_height - (u - supbox.d * supbox.rscale);
        if (p > 0) {
          u += p;
          v -= p;
        }
      }
      u = Math.max(this.length2em(this.node.attributes.get('superscriptshift'), u), u);
      v = Math.max(this.length2em(this.node.attributes.get('subscriptshift'), v), v);
      q = u - supbox.d * supbox.rscale - (subbox.h * subbox.rscale - v);
      this.UVQ = [u, -v, q];
      return this.UVQ;
    };
    return class_3;
  })(Base), _a.useIC = false, _a);
}
msubsup.CommonMsubsupMixin = CommonMsubsupMixin;

var __extends$F = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$f = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(msubsup$1, "__esModule", {
  value: true
});
msubsup$1.CHTMLmsubsup = msubsup$1.CHTMLmsup = msubsup$1.CHTMLmsub = void 0;
var scriptbase_js_1 = scriptbase$1;
var msubsup_js_1$3 = msubsup;
var msubsup_js_2 = msubsup;
var msubsup_js_3 = msubsup;
var msubsup_js_4 = msubsup$2;
var CHTMLmsub = (function (_super) {
  __extends$F(CHTMLmsub, _super);
  function CHTMLmsub() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmsub.kind = msubsup_js_4.MmlMsub.prototype.kind;
  return CHTMLmsub;
})((0, msubsup_js_1$3.CommonMsubMixin)(scriptbase_js_1.CHTMLscriptbase));
msubsup$1.CHTMLmsub = CHTMLmsub;
var CHTMLmsup = (function (_super) {
  __extends$F(CHTMLmsup, _super);
  function CHTMLmsup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmsup.kind = msubsup_js_4.MmlMsup.prototype.kind;
  return CHTMLmsup;
})((0, msubsup_js_2.CommonMsupMixin)(scriptbase_js_1.CHTMLscriptbase));
msubsup$1.CHTMLmsup = CHTMLmsup;
var CHTMLmsubsup = (function (_super) {
  __extends$F(CHTMLmsubsup, _super);
  function CHTMLmsubsup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmsubsup.prototype.toCHTML = function (parent) {
    var adaptor = this.adaptor;
    var chtml = this.standardCHTMLnode(parent);
    var _a = __read$f([this.baseChild, this.supChild, this.subChild], 3), base = _a[0], sup = _a[1], sub = _a[2];
    var _b = __read$f(this.getUVQ(), 3), v = _b[1], q = _b[2];
    var style = {
      'vertical-align': this.em(v)
    };
    base.toCHTML(chtml);
    var stack = adaptor.append(chtml, this.html('mjx-script', {
      style: style
    }));
    sup.toCHTML(stack);
    adaptor.append(stack, this.html('mjx-spacer', {
      style: {
        'margin-top': this.em(q)
      }
    }));
    sub.toCHTML(stack);
    var ic = this.getAdjustedIc();
    if (ic) {
      adaptor.setStyle(sup.chtml, 'marginLeft', this.em(ic / sup.bbox.rscale));
    }
    if (this.baseRemoveIc) {
      adaptor.setStyle(stack, 'marginLeft', this.em(-this.baseIc));
    }
  };
  CHTMLmsubsup.kind = msubsup_js_4.MmlMsubsup.prototype.kind;
  CHTMLmsubsup.styles = {
    'mjx-script': {
      display: 'inline-block',
      'padding-right': '.05em',
      'padding-left': '.033em'
    },
    'mjx-script > mjx-spacer': {
      display: 'block'
    }
  };
  return CHTMLmsubsup;
})((0, msubsup_js_3.CommonMsubsupMixin)(scriptbase_js_1.CHTMLscriptbase));
msubsup$1.CHTMLmsubsup = CHTMLmsubsup;

var munderover$1 = {};

var munderover = {};

var __extends$E = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$e = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$6 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(munderover, "__esModule", {
  value: true
});
munderover.CommonMunderoverMixin = munderover.CommonMoverMixin = munderover.CommonMunderMixin = void 0;
function CommonMunderMixin(Base) {
  return (function (_super) {
    __extends$E(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$6([], __read$e(args), false)) || this;
      _this.stretchChildren();
      return _this;
    }
    Object.defineProperty(class_1.prototype, "scriptChild", {
      get: function () {
        return this.childNodes[this.node.under];
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      if (this.hasMovableLimits()) {
        _super.prototype.computeBBox.call(this, bbox, recompute);
        return;
      }
      bbox.empty();
      var basebox = this.baseChild.getOuterBBox();
      var underbox = this.scriptChild.getOuterBBox();
      var v = this.getUnderKV(basebox, underbox)[1];
      var delta = this.isLineBelow ? 0 : this.getDelta(true);
      var _a = __read$e(this.getDeltaW([basebox, underbox], [0, -delta]), 2), bw = _a[0], uw = _a[1];
      bbox.combine(basebox, bw, 0);
      bbox.combine(underbox, uw, v);
      bbox.d += this.font.params.big_op_spacing5;
      bbox.clean();
      this.setChildPWidths(recompute);
    };
    return class_1;
  })(Base);
}
munderover.CommonMunderMixin = CommonMunderMixin;
function CommonMoverMixin(Base) {
  return (function (_super) {
    __extends$E(class_2, _super);
    function class_2() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$6([], __read$e(args), false)) || this;
      _this.stretchChildren();
      return _this;
    }
    Object.defineProperty(class_2.prototype, "scriptChild", {
      get: function () {
        return this.childNodes[this.node.over];
      },
      enumerable: false,
      configurable: true
    });
    class_2.prototype.computeBBox = function (bbox) {
      if (this.hasMovableLimits()) {
        _super.prototype.computeBBox.call(this, bbox);
        return;
      }
      bbox.empty();
      var basebox = this.baseChild.getOuterBBox();
      var overbox = this.scriptChild.getOuterBBox();
      if (this.node.attributes.get('accent')) {
        basebox.h = Math.max(basebox.h, this.font.params.x_height * basebox.scale);
      }
      var u = this.getOverKU(basebox, overbox)[1];
      var delta = this.isLineAbove ? 0 : this.getDelta();
      var _a = __read$e(this.getDeltaW([basebox, overbox], [0, delta]), 2), bw = _a[0], ow = _a[1];
      bbox.combine(basebox, bw, 0);
      bbox.combine(overbox, ow, u);
      bbox.h += this.font.params.big_op_spacing5;
      bbox.clean();
    };
    return class_2;
  })(Base);
}
munderover.CommonMoverMixin = CommonMoverMixin;
function CommonMunderoverMixin(Base) {
  return (function (_super) {
    __extends$E(class_3, _super);
    function class_3() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$6([], __read$e(args), false)) || this;
      _this.stretchChildren();
      return _this;
    }
    Object.defineProperty(class_3.prototype, "underChild", {
      get: function () {
        return this.childNodes[this.node.under];
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_3.prototype, "overChild", {
      get: function () {
        return this.childNodes[this.node.over];
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_3.prototype, "subChild", {
      get: function () {
        return this.underChild;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_3.prototype, "supChild", {
      get: function () {
        return this.overChild;
      },
      enumerable: false,
      configurable: true
    });
    class_3.prototype.computeBBox = function (bbox) {
      if (this.hasMovableLimits()) {
        _super.prototype.computeBBox.call(this, bbox);
        return;
      }
      bbox.empty();
      var overbox = this.overChild.getOuterBBox();
      var basebox = this.baseChild.getOuterBBox();
      var underbox = this.underChild.getOuterBBox();
      if (this.node.attributes.get('accent')) {
        basebox.h = Math.max(basebox.h, this.font.params.x_height * basebox.scale);
      }
      var u = this.getOverKU(basebox, overbox)[1];
      var v = this.getUnderKV(basebox, underbox)[1];
      var delta = this.getDelta();
      var _a = __read$e(this.getDeltaW([basebox, underbox, overbox], [0, this.isLineBelow ? 0 : -delta, this.isLineAbove ? 0 : delta]), 3), bw = _a[0], uw = _a[1], ow = _a[2];
      bbox.combine(basebox, bw, 0);
      bbox.combine(overbox, ow, u);
      bbox.combine(underbox, uw, v);
      var z = this.font.params.big_op_spacing5;
      bbox.h += z;
      bbox.d += z;
      bbox.clean();
    };
    return class_3;
  })(Base);
}
munderover.CommonMunderoverMixin = CommonMunderoverMixin;

var __extends$D = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(munderover$1, "__esModule", {
  value: true
});
munderover$1.CHTMLmunderover = munderover$1.CHTMLmover = munderover$1.CHTMLmunder = void 0;
var msubsup_js_1$2 = msubsup$1;
var munderover_js_1$1 = munderover;
var munderover_js_2 = munderover;
var munderover_js_3 = munderover;
var munderover_js_4 = munderover$2;
var CHTMLmunder = (function (_super) {
  __extends$D(CHTMLmunder, _super);
  function CHTMLmunder() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmunder.prototype.toCHTML = function (parent) {
    if (this.hasMovableLimits()) {
      _super.prototype.toCHTML.call(this, parent);
      this.adaptor.setAttribute(this.chtml, 'limits', 'false');
      return;
    }
    this.chtml = this.standardCHTMLnode(parent);
    var base = this.adaptor.append(this.adaptor.append(this.chtml, this.html('mjx-row')), this.html('mjx-base'));
    var under = this.adaptor.append(this.adaptor.append(this.chtml, this.html('mjx-row')), this.html('mjx-under'));
    this.baseChild.toCHTML(base);
    this.scriptChild.toCHTML(under);
    var basebox = this.baseChild.getOuterBBox();
    var underbox = this.scriptChild.getOuterBBox();
    var k = this.getUnderKV(basebox, underbox)[0];
    var delta = this.isLineBelow ? 0 : this.getDelta(true);
    this.adaptor.setStyle(under, 'paddingTop', this.em(k));
    this.setDeltaW([base, under], this.getDeltaW([basebox, underbox], [0, -delta]));
    this.adjustUnderDepth(under, underbox);
  };
  CHTMLmunder.kind = munderover_js_4.MmlMunder.prototype.kind;
  CHTMLmunder.styles = {
    'mjx-over': {
      'text-align': 'left'
    },
    'mjx-munder:not([limits="false"])': {
      display: 'inline-table'
    },
    'mjx-munder > mjx-row': {
      'text-align': 'left'
    },
    'mjx-under': {
      'padding-bottom': '.1em'
    }
  };
  return CHTMLmunder;
})((0, munderover_js_1$1.CommonMunderMixin)(msubsup_js_1$2.CHTMLmsub));
munderover$1.CHTMLmunder = CHTMLmunder;
var CHTMLmover = (function (_super) {
  __extends$D(CHTMLmover, _super);
  function CHTMLmover() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmover.prototype.toCHTML = function (parent) {
    if (this.hasMovableLimits()) {
      _super.prototype.toCHTML.call(this, parent);
      this.adaptor.setAttribute(this.chtml, 'limits', 'false');
      return;
    }
    this.chtml = this.standardCHTMLnode(parent);
    var over = this.adaptor.append(this.chtml, this.html('mjx-over'));
    var base = this.adaptor.append(this.chtml, this.html('mjx-base'));
    this.scriptChild.toCHTML(over);
    this.baseChild.toCHTML(base);
    var overbox = this.scriptChild.getOuterBBox();
    var basebox = this.baseChild.getOuterBBox();
    this.adjustBaseHeight(base, basebox);
    var k = this.getOverKU(basebox, overbox)[0];
    var delta = this.isLineAbove ? 0 : this.getDelta();
    this.adaptor.setStyle(over, 'paddingBottom', this.em(k));
    this.setDeltaW([base, over], this.getDeltaW([basebox, overbox], [0, delta]));
    this.adjustOverDepth(over, overbox);
  };
  CHTMLmover.kind = munderover_js_4.MmlMover.prototype.kind;
  CHTMLmover.styles = {
    'mjx-mover:not([limits="false"])': {
      'padding-top': '.1em'
    },
    'mjx-mover:not([limits="false"]) > *': {
      display: 'block',
      'text-align': 'left'
    }
  };
  return CHTMLmover;
})((0, munderover_js_2.CommonMoverMixin)(msubsup_js_1$2.CHTMLmsup));
munderover$1.CHTMLmover = CHTMLmover;
var CHTMLmunderover = (function (_super) {
  __extends$D(CHTMLmunderover, _super);
  function CHTMLmunderover() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmunderover.prototype.toCHTML = function (parent) {
    if (this.hasMovableLimits()) {
      _super.prototype.toCHTML.call(this, parent);
      this.adaptor.setAttribute(this.chtml, 'limits', 'false');
      return;
    }
    this.chtml = this.standardCHTMLnode(parent);
    var over = this.adaptor.append(this.chtml, this.html('mjx-over'));
    var table = this.adaptor.append(this.adaptor.append(this.chtml, this.html('mjx-box')), this.html('mjx-munder'));
    var base = this.adaptor.append(this.adaptor.append(table, this.html('mjx-row')), this.html('mjx-base'));
    var under = this.adaptor.append(this.adaptor.append(table, this.html('mjx-row')), this.html('mjx-under'));
    this.overChild.toCHTML(over);
    this.baseChild.toCHTML(base);
    this.underChild.toCHTML(under);
    var overbox = this.overChild.getOuterBBox();
    var basebox = this.baseChild.getOuterBBox();
    var underbox = this.underChild.getOuterBBox();
    this.adjustBaseHeight(base, basebox);
    var ok = this.getOverKU(basebox, overbox)[0];
    var uk = this.getUnderKV(basebox, underbox)[0];
    var delta = this.getDelta();
    this.adaptor.setStyle(over, 'paddingBottom', this.em(ok));
    this.adaptor.setStyle(under, 'paddingTop', this.em(uk));
    this.setDeltaW([base, under, over], this.getDeltaW([basebox, underbox, overbox], [0, this.isLineBelow ? 0 : -delta, this.isLineAbove ? 0 : delta]));
    this.adjustOverDepth(over, overbox);
    this.adjustUnderDepth(under, underbox);
  };
  CHTMLmunderover.prototype.markUsed = function () {
    _super.prototype.markUsed.call(this);
    this.jax.wrapperUsage.add(msubsup_js_1$2.CHTMLmsubsup.kind);
  };
  CHTMLmunderover.kind = munderover_js_4.MmlMunderover.prototype.kind;
  CHTMLmunderover.styles = {
    'mjx-munderover:not([limits="false"])': {
      'padding-top': '.1em'
    },
    'mjx-munderover:not([limits="false"]) > *': {
      display: 'block'
    }
  };
  return CHTMLmunderover;
})((0, munderover_js_3.CommonMunderoverMixin)(msubsup_js_1$2.CHTMLmsubsup));
munderover$1.CHTMLmunderover = CHTMLmunderover;

var mmultiscripts$1 = {};

var mmultiscripts = {};

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !((i in from))) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CommonMmultiscriptsMixin = exports.ScriptNames = exports.NextScript = void 0;
  var BBox_js_1 = BBox$1;
  exports.NextScript = {
    base: 'subList',
    subList: 'supList',
    supList: 'subList',
    psubList: 'psupList',
    psupList: 'psubList'
  };
  exports.ScriptNames = ['sup', 'sup', 'psup', 'psub'];
  function CommonMmultiscriptsMixin(Base) {
    return (function (_super) {
      __extends(class_1, _super);
      function class_1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArray([], __read(args), false)) || this;
        _this.scriptData = null;
        _this.firstPrescript = 0;
        _this.getScriptData();
        return _this;
      }
      class_1.prototype.combinePrePost = function (pre, post) {
        var bbox = new BBox_js_1.BBox(pre);
        bbox.combine(post, 0, 0);
        return bbox;
      };
      class_1.prototype.computeBBox = function (bbox, recompute) {
        if (recompute === void 0) {
          recompute = false;
        }
        var scriptspace = this.font.params.scriptspace;
        var data = this.scriptData;
        var sub = this.combinePrePost(data.sub, data.psub);
        var sup = this.combinePrePost(data.sup, data.psup);
        var _a = __read(this.getUVQ(sub, sup), 2), u = _a[0], v = _a[1];
        bbox.empty();
        if (data.numPrescripts) {
          bbox.combine(data.psup, scriptspace, u);
          bbox.combine(data.psub, scriptspace, v);
        }
        bbox.append(data.base);
        if (data.numScripts) {
          var w = bbox.w;
          bbox.combine(data.sup, w, u);
          bbox.combine(data.sub, w, v);
          bbox.w += scriptspace;
        }
        bbox.clean();
        this.setChildPWidths(recompute);
      };
      class_1.prototype.getScriptData = function () {
        var data = this.scriptData = {
          base: null,
          sub: BBox_js_1.BBox.empty(),
          sup: BBox_js_1.BBox.empty(),
          psub: BBox_js_1.BBox.empty(),
          psup: BBox_js_1.BBox.empty(),
          numPrescripts: 0,
          numScripts: 0
        };
        var lists = this.getScriptBBoxLists();
        this.combineBBoxLists(data.sub, data.sup, lists.subList, lists.supList);
        this.combineBBoxLists(data.psub, data.psup, lists.psubList, lists.psupList);
        data.base = lists.base[0];
        data.numPrescripts = lists.psubList.length;
        data.numScripts = lists.subList.length;
      };
      class_1.prototype.getScriptBBoxLists = function () {
        var e_1, _a;
        var lists = {
          base: [],
          subList: [],
          supList: [],
          psubList: [],
          psupList: []
        };
        var script = 'base';
        try {
          for (var _b = __values(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            if (child.node.isKind('mprescripts')) {
              script = 'psubList';
            } else {
              lists[script].push(child.getOuterBBox());
              script = exports.NextScript[script];
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        this.firstPrescript = lists.subList.length + lists.supList.length + 2;
        this.padLists(lists.subList, lists.supList);
        this.padLists(lists.psubList, lists.psupList);
        return lists;
      };
      class_1.prototype.padLists = function (list1, list2) {
        if (list1.length > list2.length) {
          list2.push(BBox_js_1.BBox.empty());
        }
      };
      class_1.prototype.combineBBoxLists = function (bbox1, bbox2, list1, list2) {
        for (var i = 0; i < list1.length; i++) {
          var _a = __read(this.getScaledWHD(list1[i]), 3), w1 = _a[0], h1 = _a[1], d1 = _a[2];
          var _b = __read(this.getScaledWHD(list2[i]), 3), w2 = _b[0], h2 = _b[1], d2 = _b[2];
          var w = Math.max(w1, w2);
          bbox1.w += w;
          bbox2.w += w;
          if (h1 > bbox1.h) bbox1.h = h1;
          if (d1 > bbox1.d) bbox1.d = d1;
          if (h2 > bbox2.h) bbox2.h = h2;
          if (d2 > bbox2.d) bbox2.d = d2;
        }
      };
      class_1.prototype.getScaledWHD = function (bbox) {
        var w = bbox.w, h = bbox.h, d = bbox.d, rscale = bbox.rscale;
        return [w * rscale, h * rscale, d * rscale];
      };
      class_1.prototype.getUVQ = function (subbox, supbox) {
        var _a;
        if (!this.UVQ) {
          var _b = __read([0, 0, 0], 3), u = _b[0], v = _b[1], q = _b[2];
          if (subbox.h === 0 && subbox.d === 0) {
            u = this.getU();
          } else if (supbox.h === 0 && supbox.d === 0) {
            u = -this.getV();
          } else {
            (_a = __read(_super.prototype.getUVQ.call(this, subbox, supbox), 3), u = _a[0], v = _a[1], q = _a[2]);
          }
          this.UVQ = [u, v, q];
        }
        return this.UVQ;
      };
      return class_1;
    })(Base);
  }
  exports.CommonMmultiscriptsMixin = CommonMmultiscriptsMixin;
})(mmultiscripts);
getDefaultExportFromCjs(mmultiscripts);

var __extends$C = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$d = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(mmultiscripts$1, "__esModule", {
  value: true
});
mmultiscripts$1.CHTMLmmultiscripts = void 0;
var msubsup_js_1$1 = msubsup$1;
var mmultiscripts_js_1$1 = mmultiscripts;
var mmultiscripts_js_2 = mmultiscripts$2;
var string_js_1$3 = string;
var CHTMLmmultiscripts = (function (_super) {
  __extends$C(CHTMLmmultiscripts, _super);
  function CHTMLmmultiscripts() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmmultiscripts.prototype.toCHTML = function (parent) {
    var chtml = this.standardCHTMLnode(parent);
    var data = this.scriptData;
    var scriptalign = this.node.getProperty('scriptalign') || 'right left';
    var _a = __read$d((0, string_js_1$3.split)(scriptalign + ' ' + scriptalign), 2), preAlign = _a[0], postAlign = _a[1];
    var sub = this.combinePrePost(data.sub, data.psub);
    var sup = this.combinePrePost(data.sup, data.psup);
    var _b = __read$d(this.getUVQ(sub, sup), 2), u = _b[0], v = _b[1];
    if (data.numPrescripts) {
      var scripts = this.addScripts(u, -v, true, data.psub, data.psup, this.firstPrescript, data.numPrescripts);
      preAlign !== 'right' && this.adaptor.setAttribute(scripts, 'script-align', preAlign);
    }
    this.childNodes[0].toCHTML(chtml);
    if (data.numScripts) {
      var scripts = this.addScripts(u, -v, false, data.sub, data.sup, 1, data.numScripts);
      postAlign !== 'left' && this.adaptor.setAttribute(scripts, 'script-align', postAlign);
    }
  };
  CHTMLmmultiscripts.prototype.addScripts = function (u, v, isPre, sub, sup, i, n) {
    var adaptor = this.adaptor;
    var q = u - sup.d + (v - sub.h);
    var U = u < 0 && v === 0 ? sub.h + u : u;
    var rowdef = q > 0 ? {
      style: {
        height: this.em(q)
      }
    } : {};
    var tabledef = U ? {
      style: {
        'vertical-align': this.em(U)
      }
    } : {};
    var supRow = this.html('mjx-row');
    var sepRow = this.html('mjx-row', rowdef);
    var subRow = this.html('mjx-row');
    var name = 'mjx-' + (isPre ? 'pre' : '') + 'scripts';
    var m = i + 2 * n;
    while (i < m) {
      this.childNodes[i++].toCHTML(adaptor.append(subRow, this.html('mjx-cell')));
      this.childNodes[i++].toCHTML(adaptor.append(supRow, this.html('mjx-cell')));
    }
    return adaptor.append(this.chtml, this.html(name, tabledef, [supRow, sepRow, subRow]));
  };
  CHTMLmmultiscripts.kind = mmultiscripts_js_2.MmlMmultiscripts.prototype.kind;
  CHTMLmmultiscripts.styles = {
    'mjx-prescripts': {
      display: 'inline-table',
      'padding-left': '.05em'
    },
    'mjx-scripts': {
      display: 'inline-table',
      'padding-right': '.05em'
    },
    'mjx-prescripts > mjx-row > mjx-cell': {
      'text-align': 'right'
    },
    '[script-align="left"] > mjx-row > mjx-cell': {
      'text-align': 'left'
    },
    '[script-align="center"] > mjx-row > mjx-cell': {
      'text-align': 'center'
    },
    '[script-align="right"] > mjx-row > mjx-cell': {
      'text-align': 'right'
    }
  };
  return CHTMLmmultiscripts;
})((0, mmultiscripts_js_1$1.CommonMmultiscriptsMixin)(msubsup_js_1$1.CHTMLmsubsup));
mmultiscripts$1.CHTMLmmultiscripts = CHTMLmmultiscripts;

var mtable$1 = {};

var mtable = {};

var numeric = {};

Object.defineProperty(numeric, "__esModule", {
  value: true
});
numeric.max = numeric.sum = void 0;
function sum(A) {
  return A.reduce(function (a, b) {
    return a + b;
  }, 0);
}
numeric.sum = sum;
function max(A) {
  return A.reduce(function (a, b) {
    return Math.max(a, b);
  }, 0);
}
numeric.max = max;

var __extends$B = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$c = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$5 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __values$f = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mtable, "__esModule", {
  value: true
});
mtable.CommonMtableMixin = void 0;
var BBox_js_1 = BBox$1;
var string_js_1$2 = string;
var numeric_js_1 = numeric;
function CommonMtableMixin(Base) {
  return (function (_super) {
    __extends$B(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$5([], __read$c(args), false)) || this;
      _this.numCols = 0;
      _this.numRows = 0;
      _this.data = null;
      _this.pwidthCells = [];
      _this.pWidth = 0;
      _this.numCols = (0, numeric_js_1.max)(_this.tableRows.map(function (row) {
        return row.numCells;
      }));
      _this.numRows = _this.childNodes.length;
      _this.hasLabels = _this.childNodes.reduce(function (value, row) {
        return value || row.node.isKind('mlabeledtr');
      }, false);
      _this.findContainer();
      _this.isTop = !_this.container || _this.container.node.isKind('math') && !_this.container.parent;
      if (_this.isTop) {
        _this.jax.table = _this;
      }
      _this.getPercentageWidth();
      var attributes = _this.node.attributes;
      _this.frame = attributes.get('frame') !== 'none';
      _this.fLine = _this.frame && attributes.get('frame') ? .07 : 0;
      _this.fSpace = _this.frame ? _this.convertLengths(_this.getAttributeArray('framespacing')) : [0, 0];
      _this.cSpace = _this.convertLengths(_this.getColumnAttributes('columnspacing'));
      _this.rSpace = _this.convertLengths(_this.getRowAttributes('rowspacing'));
      _this.cLines = _this.getColumnAttributes('columnlines').map(function (x) {
        return x === 'none' ? 0 : .07;
      });
      _this.rLines = _this.getRowAttributes('rowlines').map(function (x) {
        return x === 'none' ? 0 : .07;
      });
      _this.cWidths = _this.getColumnWidths();
      _this.stretchRows();
      _this.stretchColumns();
      return _this;
    }
    Object.defineProperty(class_1.prototype, "tableRows", {
      get: function () {
        return this.childNodes;
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.findContainer = function () {
      var node = this;
      var parent = node.parent;
      while (parent && (parent.node.notParent || parent.node.isKind('mrow'))) {
        node = parent;
        parent = parent.parent;
      }
      this.container = parent;
      this.containerI = node.node.childPosition();
    };
    class_1.prototype.getPercentageWidth = function () {
      if (this.hasLabels) {
        this.bbox.pwidth = BBox_js_1.BBox.fullWidth;
      } else {
        var width = this.node.attributes.get('width');
        if ((0, string_js_1$2.isPercent)(width)) {
          this.bbox.pwidth = width;
        }
      }
    };
    class_1.prototype.stretchRows = function () {
      var equal = this.node.attributes.get('equalrows');
      var HD = equal ? this.getEqualRowHeight() : 0;
      var _a = equal ? this.getTableData() : {
        H: [0],
        D: [0]
      }, H = _a.H, D = _a.D;
      var rows = this.tableRows;
      for (var i = 0; i < this.numRows; i++) {
        var hd = equal ? [(HD + H[i] - D[i]) / 2, (HD - H[i] + D[i]) / 2] : null;
        rows[i].stretchChildren(hd);
      }
    };
    class_1.prototype.stretchColumns = function () {
      for (var i = 0; i < this.numCols; i++) {
        var width = typeof this.cWidths[i] === 'number' ? this.cWidths[i] : null;
        this.stretchColumn(i, width);
      }
    };
    class_1.prototype.stretchColumn = function (i, W) {
      var e_1, _a, e_2, _b, e_3, _c;
      var stretchy = [];
      try {
        for (var _d = __values$f(this.tableRows), _e = _d.next(); !_e.done; _e = _d.next()) {
          var row = _e.value;
          var cell = row.getChild(i);
          if (cell) {
            var child = cell.childNodes[0];
            if (child.stretch.dir === 0 && child.canStretch(2)) {
              stretchy.push(child);
            }
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      var count = stretchy.length;
      var nodeCount = this.childNodes.length;
      if (count && nodeCount > 1) {
        if (W === null) {
          W = 0;
          var all = count > 1 && count === nodeCount;
          try {
            for (var _f = __values$f(this.tableRows), _g = _f.next(); !_g.done; _g = _f.next()) {
              var row = _g.value;
              var cell = row.getChild(i);
              if (cell) {
                var child = cell.childNodes[0];
                var noStretch = child.stretch.dir === 0;
                if (all || noStretch) {
                  var w = child.getBBox(noStretch).w;
                  if (w > W) {
                    W = w;
                  }
                }
              }
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
        }
        try {
          for (var stretchy_1 = __values$f(stretchy), stretchy_1_1 = stretchy_1.next(); !stretchy_1_1.done; stretchy_1_1 = stretchy_1.next()) {
            var child = stretchy_1_1.value;
            child.coreMO().getStretchedVariant([W]);
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (stretchy_1_1 && !stretchy_1_1.done && (_c = stretchy_1.return)) _c.call(stretchy_1);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
      }
    };
    class_1.prototype.getTableData = function () {
      if (this.data) {
        return this.data;
      }
      var H = new Array(this.numRows).fill(0);
      var D = new Array(this.numRows).fill(0);
      var W = new Array(this.numCols).fill(0);
      var NH = new Array(this.numRows);
      var ND = new Array(this.numRows);
      var LW = [0];
      var rows = this.tableRows;
      for (var j = 0; j < rows.length; j++) {
        var M = 0;
        var row = rows[j];
        var align = row.node.attributes.get('rowalign');
        for (var i = 0; i < row.numCells; i++) {
          var cell = row.getChild(i);
          M = this.updateHDW(cell, i, j, align, H, D, W, M);
          this.recordPWidthCell(cell, i);
        }
        NH[j] = H[j];
        ND[j] = D[j];
        if (row.labeled) {
          M = this.updateHDW(row.childNodes[0], 0, j, align, H, D, LW, M);
        }
        this.extendHD(j, H, D, M);
        this.extendHD(j, NH, ND, M);
      }
      var L = LW[0];
      this.data = {
        H: H,
        D: D,
        W: W,
        NH: NH,
        ND: ND,
        L: L
      };
      return this.data;
    };
    class_1.prototype.updateHDW = function (cell, i, j, align, H, D, W, M) {
      var _a = cell.getBBox(), h = _a.h, d = _a.d, w = _a.w;
      var scale = cell.parent.bbox.rscale;
      if (cell.parent.bbox.rscale !== 1) {
        h *= scale;
        d *= scale;
        w *= scale;
      }
      if (this.node.getProperty('useHeight')) {
        if (h < .75) h = .75;
        if (d < .25) d = .25;
      }
      var m = 0;
      align = cell.node.attributes.get('rowalign') || align;
      if (align !== 'baseline' && align !== 'axis') {
        m = h + d;
        h = d = 0;
      }
      if (h > H[j]) H[j] = h;
      if (d > D[j]) D[j] = d;
      if (m > M) M = m;
      if (W && w > W[i]) W[i] = w;
      return M;
    };
    class_1.prototype.extendHD = function (i, H, D, M) {
      var d = (M - (H[i] + D[i])) / 2;
      if (d < .00001) return;
      H[i] += d;
      D[i] += d;
    };
    class_1.prototype.recordPWidthCell = function (cell, i) {
      if (cell.childNodes[0] && cell.childNodes[0].getBBox().pwidth) {
        this.pwidthCells.push([cell, i]);
      }
    };
    class_1.prototype.computeBBox = function (bbox, _recompute) {
      var _a = this.getTableData(), H = _a.H, D = _a.D;
      var height, width;
      if (this.node.attributes.get('equalrows')) {
        var HD = this.getEqualRowHeight();
        height = (0, numeric_js_1.sum)([].concat(this.rLines, this.rSpace)) + HD * this.numRows;
      } else {
        height = (0, numeric_js_1.sum)(H.concat(D, this.rLines, this.rSpace));
      }
      height += 2 * (this.fLine + this.fSpace[1]);
      var CW = this.getComputedWidths();
      width = (0, numeric_js_1.sum)(CW.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]);
      var w = this.node.attributes.get('width');
      if (w !== 'auto') {
        width = Math.max(this.length2em(w, 0) + 2 * this.fLine, width);
      }
      var _b = __read$c(this.getBBoxHD(height), 2), h = _b[0], d = _b[1];
      bbox.h = h;
      bbox.d = d;
      bbox.w = width;
      var _c = __read$c(this.getBBoxLR(), 2), L = _c[0], R = _c[1];
      bbox.L = L;
      bbox.R = R;
      if (!(0, string_js_1$2.isPercent)(w)) {
        this.setColumnPWidths();
      }
    };
    class_1.prototype.setChildPWidths = function (_recompute, cwidth, _clear) {
      var width = this.node.attributes.get('width');
      if (!(0, string_js_1$2.isPercent)(width)) return false;
      if (!this.hasLabels) {
        this.bbox.pwidth = '';
        this.container.bbox.pwidth = '';
      }
      var _a = this.bbox, w = _a.w, L = _a.L, R = _a.R;
      var labelInWidth = this.node.attributes.get('data-width-includes-label');
      var W = Math.max(w, this.length2em(width, Math.max(cwidth, L + w + R))) - (labelInWidth ? L + R : 0);
      var cols = this.node.attributes.get('equalcolumns') ? Array(this.numCols).fill(this.percent(1 / Math.max(1, this.numCols))) : this.getColumnAttributes('columnwidth', 0);
      this.cWidths = this.getColumnWidthsFixed(cols, W);
      var CW = this.getComputedWidths();
      this.pWidth = (0, numeric_js_1.sum)(CW.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]);
      if (this.isTop) {
        this.bbox.w = this.pWidth;
      }
      this.setColumnPWidths();
      if (this.pWidth !== w) {
        this.parent.invalidateBBox();
      }
      return this.pWidth !== w;
    };
    class_1.prototype.setColumnPWidths = function () {
      var e_4, _a;
      var W = this.cWidths;
      try {
        for (var _b = __values$f(this.pwidthCells), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read$c(_c.value, 2), cell = _d[0], i = _d[1];
          if (cell.setChildPWidths(false, W[i])) {
            cell.invalidateBBox();
            cell.getBBox();
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
    };
    class_1.prototype.getBBoxHD = function (height) {
      var _a = __read$c(this.getAlignmentRow(), 2), align = _a[0], row = _a[1];
      if (row === null) {
        var a = this.font.params.axis_height;
        var h2 = height / 2;
        var HD = {
          top: [0, height],
          center: [h2, h2],
          bottom: [height, 0],
          baseline: [h2, h2],
          axis: [h2 + a, h2 - a]
        };
        return HD[align] || [h2, h2];
      } else {
        var y = this.getVerticalPosition(row, align);
        return [y, height - y];
      }
    };
    class_1.prototype.getBBoxLR = function () {
      if (this.hasLabels) {
        var attributes = this.node.attributes;
        var side = attributes.get('side');
        var _a = __read$c(this.getPadAlignShift(side), 2), pad = _a[0], align = _a[1];
        var labels = this.hasLabels && !!attributes.get('data-width-includes-label');
        if (labels && this.frame && this.fSpace[0]) {
          pad -= this.fSpace[0];
        }
        return align === 'center' && !labels ? [pad, pad] : side === 'left' ? [pad, 0] : [0, pad];
      }
      return [0, 0];
    };
    class_1.prototype.getPadAlignShift = function (side) {
      var L = this.getTableData().L;
      var sep = this.length2em(this.node.attributes.get('minlabelspacing'));
      var pad = L + sep;
      var _a = __read$c(this.styles == null ? ['', ''] : [this.styles.get('padding-left'), this.styles.get('padding-right')], 2), lpad = _a[0], rpad = _a[1];
      if (lpad || rpad) {
        pad = Math.max(pad, this.length2em(lpad || '0'), this.length2em(rpad || '0'));
      }
      var _b = __read$c(this.getAlignShift(), 2), align = _b[0], shift = _b[1];
      if (align === side) {
        shift = side === 'left' ? Math.max(pad, shift) - pad : Math.min(-pad, shift) + pad;
      }
      return [pad, align, shift];
    };
    class_1.prototype.getAlignShift = function () {
      return this.isTop ? _super.prototype.getAlignShift.call(this) : [this.container.getChildAlign(this.containerI), 0];
    };
    class_1.prototype.getWidth = function () {
      return this.pWidth || this.getBBox().w;
    };
    class_1.prototype.getEqualRowHeight = function () {
      var _a = this.getTableData(), H = _a.H, D = _a.D;
      var HD = Array.from(H.keys()).map(function (i) {
        return H[i] + D[i];
      });
      return Math.max.apply(Math, HD);
    };
    class_1.prototype.getComputedWidths = function () {
      var _this = this;
      var W = this.getTableData().W;
      var CW = Array.from(W.keys()).map(function (i) {
        return typeof _this.cWidths[i] === 'number' ? _this.cWidths[i] : W[i];
      });
      if (this.node.attributes.get('equalcolumns')) {
        CW = Array(CW.length).fill((0, numeric_js_1.max)(CW));
      }
      return CW;
    };
    class_1.prototype.getColumnWidths = function () {
      var width = this.node.attributes.get('width');
      if (this.node.attributes.get('equalcolumns')) {
        return this.getEqualColumns(width);
      }
      var swidths = this.getColumnAttributes('columnwidth', 0);
      if (width === 'auto') {
        return this.getColumnWidthsAuto(swidths);
      }
      if ((0, string_js_1$2.isPercent)(width)) {
        return this.getColumnWidthsPercent(swidths);
      }
      return this.getColumnWidthsFixed(swidths, this.length2em(width));
    };
    class_1.prototype.getEqualColumns = function (width) {
      var n = Math.max(1, this.numCols);
      var cwidth;
      if (width === 'auto') {
        var W = this.getTableData().W;
        cwidth = (0, numeric_js_1.max)(W);
      } else if ((0, string_js_1$2.isPercent)(width)) {
        cwidth = this.percent(1 / n);
      } else {
        var w = (0, numeric_js_1.sum)([].concat(this.cLines, this.cSpace)) + 2 * this.fSpace[0];
        cwidth = Math.max(0, this.length2em(width) - w) / n;
      }
      return Array(this.numCols).fill(cwidth);
    };
    class_1.prototype.getColumnWidthsAuto = function (swidths) {
      var _this = this;
      return swidths.map(function (x) {
        if (x === 'auto' || x === 'fit') return null;
        if ((0, string_js_1$2.isPercent)(x)) return x;
        return _this.length2em(x);
      });
    };
    class_1.prototype.getColumnWidthsPercent = function (swidths) {
      var _this = this;
      var hasFit = swidths.indexOf('fit') >= 0;
      var W = (hasFit ? this.getTableData() : {
        W: null
      }).W;
      return Array.from(swidths.keys()).map(function (i) {
        var x = swidths[i];
        if (x === 'fit') return null;
        if (x === 'auto') return hasFit ? W[i] : null;
        if ((0, string_js_1$2.isPercent)(x)) return x;
        return _this.length2em(x);
      });
    };
    class_1.prototype.getColumnWidthsFixed = function (swidths, width) {
      var _this = this;
      var indices = Array.from(swidths.keys());
      var fit = indices.filter(function (i) {
        return swidths[i] === 'fit';
      });
      var auto = indices.filter(function (i) {
        return swidths[i] === 'auto';
      });
      var n = fit.length || auto.length;
      var W = (n ? this.getTableData() : {
        W: null
      }).W;
      var cwidth = width - (0, numeric_js_1.sum)([].concat(this.cLines, this.cSpace)) - 2 * this.fSpace[0];
      var dw = cwidth;
      indices.forEach(function (i) {
        var x = swidths[i];
        dw -= x === 'fit' || x === 'auto' ? W[i] : _this.length2em(x, cwidth);
      });
      var fw = n && dw > 0 ? dw / n : 0;
      return indices.map(function (i) {
        var x = swidths[i];
        if (x === 'fit') return W[i] + fw;
        if (x === 'auto') return W[i] + (fit.length === 0 ? fw : 0);
        return _this.length2em(x, cwidth);
      });
    };
    class_1.prototype.getVerticalPosition = function (i, align) {
      var equal = this.node.attributes.get('equalrows');
      var _a = this.getTableData(), H = _a.H, D = _a.D;
      var HD = equal ? this.getEqualRowHeight() : 0;
      var space = this.getRowHalfSpacing();
      var y = this.fLine;
      for (var j = 0; j < i; j++) {
        y += space[j] + (equal ? HD : H[j] + D[j]) + space[j + 1] + this.rLines[j];
      }
      var _b = __read$c(equal ? [(HD + H[i] - D[i]) / 2, (HD - H[i] + D[i]) / 2] : [H[i], D[i]], 2), h = _b[0], d = _b[1];
      var offset = {
        top: 0,
        center: space[i] + (h + d) / 2,
        bottom: space[i] + h + d + space[i + 1],
        baseline: space[i] + h,
        axis: space[i] + h - .25
      };
      y += offset[align] || 0;
      return y;
    };
    class_1.prototype.getEmHalfSpacing = function (fspace, space, scale) {
      if (scale === void 0) {
        scale = 1;
      }
      var fspaceEm = this.em(fspace * scale);
      var spaceEm = this.addEm(space, 2 / scale);
      spaceEm.unshift(fspaceEm);
      spaceEm.push(fspaceEm);
      return spaceEm;
    };
    class_1.prototype.getRowHalfSpacing = function () {
      var space = this.rSpace.map(function (x) {
        return x / 2;
      });
      space.unshift(this.fSpace[1]);
      space.push(this.fSpace[1]);
      return space;
    };
    class_1.prototype.getColumnHalfSpacing = function () {
      var space = this.cSpace.map(function (x) {
        return x / 2;
      });
      space.unshift(this.fSpace[0]);
      space.push(this.fSpace[0]);
      return space;
    };
    class_1.prototype.getAlignmentRow = function () {
      var _a = __read$c((0, string_js_1$2.split)(this.node.attributes.get('align')), 2), align = _a[0], row = _a[1];
      if (row == null) return [align, null];
      var i = parseInt(row);
      if (i < 0) i += this.numRows + 1;
      return [align, i < 1 || i > this.numRows ? null : i - 1];
    };
    class_1.prototype.getColumnAttributes = function (name, i) {
      if (i === void 0) {
        i = 1;
      }
      var n = this.numCols - i;
      var columns = this.getAttributeArray(name);
      if (columns.length === 0) return null;
      while (columns.length < n) {
        columns.push(columns[columns.length - 1]);
      }
      if (columns.length > n) {
        columns.splice(n);
      }
      return columns;
    };
    class_1.prototype.getRowAttributes = function (name, i) {
      if (i === void 0) {
        i = 1;
      }
      var n = this.numRows - i;
      var rows = this.getAttributeArray(name);
      if (rows.length === 0) return null;
      while (rows.length < n) {
        rows.push(rows[rows.length - 1]);
      }
      if (rows.length > n) {
        rows.splice(n);
      }
      return rows;
    };
    class_1.prototype.getAttributeArray = function (name) {
      var value = this.node.attributes.get(name);
      if (!value) return [this.node.attributes.getDefault(name)];
      return (0, string_js_1$2.split)(value);
    };
    class_1.prototype.addEm = function (list, n) {
      var _this = this;
      if (n === void 0) {
        n = 1;
      }
      if (!list) return null;
      return list.map(function (x) {
        return _this.em(x / n);
      });
    };
    class_1.prototype.convertLengths = function (list) {
      var _this = this;
      if (!list) return null;
      return list.map(function (x) {
        return _this.length2em(x);
      });
    };
    return class_1;
  })(Base);
}
mtable.CommonMtableMixin = CommonMtableMixin;

var __extends$A = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$e = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$b = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(mtable$1, "__esModule", {
  value: true
});
mtable$1.CHTMLmtable = void 0;
var Wrapper_js_1$8 = Wrapper$2;
var mtable_js_1$1 = mtable;
var mtable_js_2 = mtable$2;
var string_js_1$1 = string;
var CHTMLmtable = (function (_super) {
  __extends$A(CHTMLmtable, _super);
  function CHTMLmtable(factory, node, parent) {
    if (parent === void 0) {
      parent = null;
    }
    var _this = _super.call(this, factory, node, parent) || this;
    _this.itable = _this.html('mjx-itable');
    _this.labels = _this.html('mjx-itable');
    return _this;
  }
  CHTMLmtable.prototype.getAlignShift = function () {
    var data = _super.prototype.getAlignShift.call(this);
    if (!this.isTop) {
      data[1] = 0;
    }
    return data;
  };
  CHTMLmtable.prototype.toCHTML = function (parent) {
    var e_1, _a;
    var chtml = this.standardCHTMLnode(parent);
    this.adaptor.append(chtml, this.html('mjx-table', {}, [this.itable]));
    try {
      for (var _b = __values$e(this.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        child.toCHTML(this.itable);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    this.padRows();
    this.handleColumnSpacing();
    this.handleColumnLines();
    this.handleColumnWidths();
    this.handleRowSpacing();
    this.handleRowLines();
    this.handleRowHeights();
    this.handleFrame();
    this.handleWidth();
    this.handleLabels();
    this.handleAlign();
    this.handleJustify();
    this.shiftColor();
  };
  CHTMLmtable.prototype.shiftColor = function () {
    var adaptor = this.adaptor;
    var color = adaptor.getStyle(this.chtml, 'backgroundColor');
    if (color) {
      adaptor.setStyle(this.chtml, 'backgroundColor', '');
      adaptor.setStyle(this.itable, 'backgroundColor', color);
    }
  };
  CHTMLmtable.prototype.padRows = function () {
    var e_2, _a;
    var adaptor = this.adaptor;
    try {
      for (var _b = __values$e(adaptor.childNodes(this.itable)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var row = _c.value;
        while (adaptor.childNodes(row).length < this.numCols) {
          adaptor.append(row, this.html('mjx-mtd', {
            'extra': true
          }));
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  CHTMLmtable.prototype.handleColumnSpacing = function () {
    var e_3, _a, e_4, _b;
    var scale = this.childNodes[0] ? 1 / this.childNodes[0].getBBox().rscale : 1;
    var spacing = this.getEmHalfSpacing(this.fSpace[0], this.cSpace, scale);
    var frame = this.frame;
    try {
      for (var _c = __values$e(this.tableRows), _d = _c.next(); !_d.done; _d = _c.next()) {
        var row = _d.value;
        var i = 0;
        try {
          for (var _e = (e_4 = void 0, __values$e(row.tableCells)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var cell = _f.value;
            var lspace = spacing[i++];
            var rspace = spacing[i];
            var styleNode = cell ? cell.chtml : this.adaptor.childNodes(row.chtml)[i];
            if (i > 1 && lspace !== '0.4em' || frame && i === 1) {
              this.adaptor.setStyle(styleNode, 'paddingLeft', lspace);
            }
            if (i < this.numCols && rspace !== '0.4em' || frame && i === this.numCols) {
              this.adaptor.setStyle(styleNode, 'paddingRight', rspace);
            }
          }
        } catch (e_4_1) {
          e_4 = {
            error: e_4_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_4) throw e_4.error;
          }
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
  };
  CHTMLmtable.prototype.handleColumnLines = function () {
    var e_5, _a, e_6, _b;
    if (this.node.attributes.get('columnlines') === 'none') return;
    var lines = this.getColumnAttributes('columnlines');
    try {
      for (var _c = __values$e(this.childNodes), _d = _c.next(); !_d.done; _d = _c.next()) {
        var row = _d.value;
        var i = 0;
        try {
          for (var _e = (e_6 = void 0, __values$e(this.adaptor.childNodes(row.chtml).slice(1))), _f = _e.next(); !_f.done; _f = _e.next()) {
            var cell = _f.value;
            var line = lines[i++];
            if (line === 'none') continue;
            this.adaptor.setStyle(cell, 'borderLeft', '.07em ' + line);
          }
        } catch (e_6_1) {
          e_6 = {
            error: e_6_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_6) throw e_6.error;
          }
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_5) throw e_5.error;
      }
    }
  };
  CHTMLmtable.prototype.handleColumnWidths = function () {
    var e_7, _a, e_8, _b;
    try {
      for (var _c = __values$e(this.childNodes), _d = _c.next(); !_d.done; _d = _c.next()) {
        var row = _d.value;
        var i = 0;
        try {
          for (var _e = (e_8 = void 0, __values$e(this.adaptor.childNodes(row.chtml))), _f = _e.next(); !_f.done; _f = _e.next()) {
            var cell = _f.value;
            var w = this.cWidths[i++];
            if (w !== null) {
              var width = typeof w === 'number' ? this.em(w) : w;
              this.adaptor.setStyle(cell, 'width', width);
              this.adaptor.setStyle(cell, 'maxWidth', width);
              this.adaptor.setStyle(cell, 'minWidth', width);
            }
          }
        } catch (e_8_1) {
          e_8 = {
            error: e_8_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_8) throw e_8.error;
          }
        }
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_7) throw e_7.error;
      }
    }
  };
  CHTMLmtable.prototype.handleRowSpacing = function () {
    var e_9, _a, e_10, _b;
    var scale = this.childNodes[0] ? 1 / this.childNodes[0].getBBox().rscale : 1;
    var spacing = this.getEmHalfSpacing(this.fSpace[1], this.rSpace, scale);
    var frame = this.frame;
    var i = 0;
    try {
      for (var _c = __values$e(this.childNodes), _d = _c.next(); !_d.done; _d = _c.next()) {
        var row = _d.value;
        var tspace = spacing[i++];
        var bspace = spacing[i];
        try {
          for (var _e = (e_10 = void 0, __values$e(row.childNodes)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var cell = _f.value;
            if (i > 1 && tspace !== '0.215em' || frame && i === 1) {
              this.adaptor.setStyle(cell.chtml, 'paddingTop', tspace);
            }
            if (i < this.numRows && bspace !== '0.215em' || frame && i === this.numRows) {
              this.adaptor.setStyle(cell.chtml, 'paddingBottom', bspace);
            }
          }
        } catch (e_10_1) {
          e_10 = {
            error: e_10_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_10) throw e_10.error;
          }
        }
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_9) throw e_9.error;
      }
    }
  };
  CHTMLmtable.prototype.handleRowLines = function () {
    var e_11, _a, e_12, _b;
    if (this.node.attributes.get('rowlines') === 'none') return;
    var lines = this.getRowAttributes('rowlines');
    var i = 0;
    try {
      for (var _c = __values$e(this.childNodes.slice(1)), _d = _c.next(); !_d.done; _d = _c.next()) {
        var row = _d.value;
        var line = lines[i++];
        if (line === 'none') continue;
        try {
          for (var _e = (e_12 = void 0, __values$e(this.adaptor.childNodes(row.chtml))), _f = _e.next(); !_f.done; _f = _e.next()) {
            var cell = _f.value;
            this.adaptor.setStyle(cell, 'borderTop', '.07em ' + line);
          }
        } catch (e_12_1) {
          e_12 = {
            error: e_12_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_12) throw e_12.error;
          }
        }
      }
    } catch (e_11_1) {
      e_11 = {
        error: e_11_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_11) throw e_11.error;
      }
    }
  };
  CHTMLmtable.prototype.handleRowHeights = function () {
    if (this.node.attributes.get('equalrows')) {
      this.handleEqualRows();
    }
  };
  CHTMLmtable.prototype.handleEqualRows = function () {
    var space = this.getRowHalfSpacing();
    var _a = this.getTableData(), H = _a.H, D = _a.D, NH = _a.NH, ND = _a.ND;
    var HD = this.getEqualRowHeight();
    for (var i = 0; i < this.numRows; i++) {
      var row = this.childNodes[i];
      this.setRowHeight(row, HD + space[i] + space[i + 1] + this.rLines[i]);
      if (HD !== NH[i] + ND[i]) {
        this.setRowBaseline(row, HD, (HD - H[i] + D[i]) / 2);
      }
    }
  };
  CHTMLmtable.prototype.setRowHeight = function (row, HD) {
    this.adaptor.setStyle(row.chtml, 'height', this.em(HD));
  };
  CHTMLmtable.prototype.setRowBaseline = function (row, HD, D) {
    var e_13, _a;
    var ralign = row.node.attributes.get('rowalign');
    try {
      for (var _b = __values$e(row.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var cell = _c.value;
        if (this.setCellBaseline(cell, ralign, HD, D)) break;
      }
    } catch (e_13_1) {
      e_13 = {
        error: e_13_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_13) throw e_13.error;
      }
    }
  };
  CHTMLmtable.prototype.setCellBaseline = function (cell, ralign, HD, D) {
    var calign = cell.node.attributes.get('rowalign');
    if (calign === 'baseline' || calign === 'axis') {
      var adaptor = this.adaptor;
      var child = adaptor.lastChild(cell.chtml);
      adaptor.setStyle(child, 'height', this.em(HD));
      adaptor.setStyle(child, 'verticalAlign', this.em(-D));
      var row = cell.parent;
      if ((!row.node.isKind('mlabeledtr') || cell !== row.childNodes[0]) && (ralign === 'baseline' || ralign === 'axis')) {
        return true;
      }
    }
    return false;
  };
  CHTMLmtable.prototype.handleFrame = function () {
    if (this.frame && this.fLine) {
      this.adaptor.setStyle(this.itable, 'border', '.07em ' + this.node.attributes.get('frame'));
    }
  };
  CHTMLmtable.prototype.handleWidth = function () {
    var adaptor = this.adaptor;
    var _a = this.getBBox(), w = _a.w, L = _a.L, R = _a.R;
    adaptor.setStyle(this.chtml, 'minWidth', this.em(L + w + R));
    var W = this.node.attributes.get('width');
    if ((0, string_js_1$1.isPercent)(W)) {
      adaptor.setStyle(this.chtml, 'width', '');
      adaptor.setAttribute(this.chtml, 'width', 'full');
    } else if (!this.hasLabels) {
      if (W === 'auto') return;
      W = this.em(this.length2em(W) + 2 * this.fLine);
    }
    var table = adaptor.firstChild(this.chtml);
    adaptor.setStyle(table, 'width', W);
    adaptor.setStyle(table, 'minWidth', this.em(w));
    if (L || R) {
      adaptor.setStyle(this.chtml, 'margin', '');
      var style = this.node.attributes.get('data-width-includes-label') ? 'padding' : 'margin';
      if (L === R) {
        adaptor.setStyle(table, style, '0 ' + this.em(R));
      } else {
        adaptor.setStyle(table, style, '0 ' + this.em(R) + ' 0 ' + this.em(L));
      }
    }
    adaptor.setAttribute(this.itable, 'width', 'full');
  };
  CHTMLmtable.prototype.handleAlign = function () {
    var _a = __read$b(this.getAlignmentRow(), 2), align = _a[0], row = _a[1];
    if (row === null) {
      if (align !== 'axis') {
        this.adaptor.setAttribute(this.chtml, 'align', align);
      }
    } else {
      var y = this.getVerticalPosition(row, align);
      this.adaptor.setAttribute(this.chtml, 'align', 'top');
      this.adaptor.setStyle(this.chtml, 'verticalAlign', this.em(y));
    }
  };
  CHTMLmtable.prototype.handleJustify = function () {
    var align = this.getAlignShift()[0];
    if (align !== 'center') {
      this.adaptor.setAttribute(this.chtml, 'justify', align);
    }
  };
  CHTMLmtable.prototype.handleLabels = function () {
    if (!this.hasLabels) return;
    var labels = this.labels;
    var attributes = this.node.attributes;
    var adaptor = this.adaptor;
    var side = attributes.get('side');
    adaptor.setAttribute(this.chtml, 'side', side);
    adaptor.setAttribute(labels, 'align', side);
    adaptor.setStyle(labels, side, '0');
    var _a = __read$b(this.addLabelPadding(side), 2), align = _a[0], shift = _a[1];
    if (shift) {
      var table = adaptor.firstChild(this.chtml);
      this.setIndent(table, align, shift);
    }
    this.updateRowHeights();
    this.addLabelSpacing();
  };
  CHTMLmtable.prototype.addLabelPadding = function (side) {
    var _a = __read$b(this.getPadAlignShift(side), 3), align = _a[1], shift = _a[2];
    var styles = {};
    if (side === 'right' && !this.node.attributes.get('data-width-includes-label')) {
      var W = this.node.attributes.get('width');
      var _b = this.getBBox(), w = _b.w, L = _b.L, R = _b.R;
      styles.style = {
        width: (0, string_js_1$1.isPercent)(W) ? 'calc(' + W + ' + ' + this.em(L + R) + ')' : this.em(L + w + R)
      };
    }
    this.adaptor.append(this.chtml, this.html('mjx-labels', styles, [this.labels]));
    return [align, shift];
  };
  CHTMLmtable.prototype.updateRowHeights = function () {
    var _a = this.getTableData(), H = _a.H, D = _a.D, NH = _a.NH, ND = _a.ND;
    var space = this.getRowHalfSpacing();
    for (var i = 0; i < this.numRows; i++) {
      var row = this.childNodes[i];
      this.setRowHeight(row, H[i] + D[i] + space[i] + space[i + 1] + this.rLines[i]);
      if (H[i] !== NH[i] || D[i] !== ND[i]) {
        this.setRowBaseline(row, H[i] + D[i], D[i]);
      } else if (row.node.isKind('mlabeledtr')) {
        this.setCellBaseline(row.childNodes[0], '', H[i] + D[i], D[i]);
      }
    }
  };
  CHTMLmtable.prototype.addLabelSpacing = function () {
    var adaptor = this.adaptor;
    var equal = this.node.attributes.get('equalrows');
    var _a = this.getTableData(), H = _a.H, D = _a.D;
    var HD = equal ? this.getEqualRowHeight() : 0;
    var space = this.getRowHalfSpacing();
    var h = this.fLine;
    var current = adaptor.firstChild(this.labels);
    for (var i = 0; i < this.numRows; i++) {
      var row = this.childNodes[i];
      if (row.node.isKind('mlabeledtr')) {
        h && adaptor.insert(this.html('mjx-mtr', {
          style: {
            height: this.em(h)
          }
        }), current);
        adaptor.setStyle(current, 'height', this.em((equal ? HD : H[i] + D[i]) + space[i] + space[i + 1]));
        current = adaptor.next(current);
        h = this.rLines[i];
      } else {
        h += space[i] + (equal ? HD : H[i] + D[i]) + space[i + 1] + this.rLines[i];
      }
    }
  };
  CHTMLmtable.kind = mtable_js_2.MmlMtable.prototype.kind;
  CHTMLmtable.styles = {
    'mjx-mtable': {
      'vertical-align': '.25em',
      'text-align': 'center',
      'position': 'relative',
      'box-sizing': 'border-box',
      'border-spacing': 0,
      'border-collapse': 'collapse'
    },
    'mjx-mstyle[size="s"] mjx-mtable': {
      'vertical-align': '.354em'
    },
    'mjx-labels': {
      position: 'absolute',
      left: 0,
      top: 0
    },
    'mjx-table': {
      'display': 'inline-block',
      'vertical-align': '-.5ex',
      'box-sizing': 'border-box'
    },
    'mjx-table > mjx-itable': {
      'vertical-align': 'middle',
      'text-align': 'left',
      'box-sizing': 'border-box'
    },
    'mjx-labels > mjx-itable': {
      position: 'absolute',
      top: 0
    },
    'mjx-mtable[justify="left"]': {
      'text-align': 'left'
    },
    'mjx-mtable[justify="right"]': {
      'text-align': 'right'
    },
    'mjx-mtable[justify="left"][side="left"]': {
      'padding-right': '0 ! important'
    },
    'mjx-mtable[justify="left"][side="right"]': {
      'padding-left': '0 ! important'
    },
    'mjx-mtable[justify="right"][side="left"]': {
      'padding-right': '0 ! important'
    },
    'mjx-mtable[justify="right"][side="right"]': {
      'padding-left': '0 ! important'
    },
    'mjx-mtable[align]': {
      'vertical-align': 'baseline'
    },
    'mjx-mtable[align="top"] > mjx-table': {
      'vertical-align': 'top'
    },
    'mjx-mtable[align="bottom"] > mjx-table': {
      'vertical-align': 'bottom'
    },
    'mjx-mtable[side="right"] mjx-labels': {
      'min-width': '100%'
    }
  };
  return CHTMLmtable;
})((0, mtable_js_1$1.CommonMtableMixin)(Wrapper_js_1$8.CHTMLWrapper));
mtable$1.CHTMLmtable = CHTMLmtable;

var mtr$1 = {};

var mtr = {};

var __extends$z = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$d = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(mtr, "__esModule", {
  value: true
});
mtr.CommonMlabeledtrMixin = mtr.CommonMtrMixin = void 0;
function CommonMtrMixin(Base) {
  return (function (_super) {
    __extends$z(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(class_1.prototype, "fixesPWidth", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_1.prototype, "numCells", {
      get: function () {
        return this.childNodes.length;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_1.prototype, "labeled", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_1.prototype, "tableCells", {
      get: function () {
        return this.childNodes;
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.getChild = function (i) {
      return this.childNodes[i];
    };
    class_1.prototype.getChildBBoxes = function () {
      return this.childNodes.map(function (cell) {
        return cell.getBBox();
      });
    };
    class_1.prototype.stretchChildren = function (HD) {
      var e_1, _a, e_2, _b, e_3, _c;
      if (HD === void 0) {
        HD = null;
      }
      var stretchy = [];
      var children = this.labeled ? this.childNodes.slice(1) : this.childNodes;
      try {
        for (var children_1 = __values$d(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
          var mtd = children_1_1.value;
          var child = mtd.childNodes[0];
          if (child.canStretch(1)) {
            stretchy.push(child);
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      var count = stretchy.length;
      var nodeCount = this.childNodes.length;
      if (count && nodeCount > 1) {
        if (HD === null) {
          var H = 0, D = 0;
          var all = count > 1 && count === nodeCount;
          try {
            for (var children_2 = __values$d(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
              var mtd = children_2_1.value;
              var child = mtd.childNodes[0];
              var noStretch = child.stretch.dir === 0;
              if (all || noStretch) {
                var _d = child.getBBox(noStretch), h = _d.h, d = _d.d;
                if (h > H) {
                  H = h;
                }
                if (d > D) {
                  D = d;
                }
              }
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (children_2_1 && !children_2_1.done && (_b = children_2.return)) _b.call(children_2);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
          HD = [H, D];
        }
        try {
          for (var stretchy_1 = __values$d(stretchy), stretchy_1_1 = stretchy_1.next(); !stretchy_1_1.done; stretchy_1_1 = stretchy_1.next()) {
            var child = stretchy_1_1.value;
            child.coreMO().getStretchedVariant(HD);
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (stretchy_1_1 && !stretchy_1_1.done && (_c = stretchy_1.return)) _c.call(stretchy_1);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
      }
    };
    return class_1;
  })(Base);
}
mtr.CommonMtrMixin = CommonMtrMixin;
function CommonMlabeledtrMixin(Base) {
  return (function (_super) {
    __extends$z(class_2, _super);
    function class_2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(class_2.prototype, "numCells", {
      get: function () {
        return Math.max(0, this.childNodes.length - 1);
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_2.prototype, "labeled", {
      get: function () {
        return true;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(class_2.prototype, "tableCells", {
      get: function () {
        return this.childNodes.slice(1);
      },
      enumerable: false,
      configurable: true
    });
    class_2.prototype.getChild = function (i) {
      return this.childNodes[i + 1];
    };
    class_2.prototype.getChildBBoxes = function () {
      return this.childNodes.slice(1).map(function (cell) {
        return cell.getBBox();
      });
    };
    return class_2;
  })(Base);
}
mtr.CommonMlabeledtrMixin = CommonMlabeledtrMixin;

var __extends$y = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mtr$1, "__esModule", {
  value: true
});
mtr$1.CHTMLmlabeledtr = mtr$1.CHTMLmtr = void 0;
var Wrapper_js_1$7 = Wrapper$2;
var mtr_js_1$1 = mtr;
var mtr_js_2 = mtr;
var mtr_js_3 = mtr$2;
var CHTMLmtr = (function (_super) {
  __extends$y(CHTMLmtr, _super);
  function CHTMLmtr() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmtr.prototype.toCHTML = function (parent) {
    _super.prototype.toCHTML.call(this, parent);
    var align = this.node.attributes.get('rowalign');
    if (align !== 'baseline') {
      this.adaptor.setAttribute(this.chtml, 'rowalign', align);
    }
  };
  CHTMLmtr.kind = mtr_js_3.MmlMtr.prototype.kind;
  CHTMLmtr.styles = {
    'mjx-mtr': {
      display: 'table-row'
    },
    'mjx-mtr[rowalign="top"] > mjx-mtd': {
      'vertical-align': 'top'
    },
    'mjx-mtr[rowalign="center"] > mjx-mtd': {
      'vertical-align': 'middle'
    },
    'mjx-mtr[rowalign="bottom"] > mjx-mtd': {
      'vertical-align': 'bottom'
    },
    'mjx-mtr[rowalign="baseline"] > mjx-mtd': {
      'vertical-align': 'baseline'
    },
    'mjx-mtr[rowalign="axis"] > mjx-mtd': {
      'vertical-align': '.25em'
    }
  };
  return CHTMLmtr;
})((0, mtr_js_1$1.CommonMtrMixin)(Wrapper_js_1$7.CHTMLWrapper));
mtr$1.CHTMLmtr = CHTMLmtr;
var CHTMLmlabeledtr = (function (_super) {
  __extends$y(CHTMLmlabeledtr, _super);
  function CHTMLmlabeledtr() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmlabeledtr.prototype.toCHTML = function (parent) {
    _super.prototype.toCHTML.call(this, parent);
    var child = this.adaptor.firstChild(this.chtml);
    if (child) {
      this.adaptor.remove(child);
      var align = this.node.attributes.get('rowalign');
      var attr = align !== 'baseline' && align !== 'axis' ? {
        rowalign: align
      } : {};
      var row = this.html('mjx-mtr', attr, [child]);
      this.adaptor.append(this.parent.labels, row);
    }
  };
  CHTMLmlabeledtr.prototype.markUsed = function () {
    _super.prototype.markUsed.call(this);
    this.jax.wrapperUsage.add(CHTMLmtr.kind);
  };
  CHTMLmlabeledtr.kind = mtr_js_3.MmlMlabeledtr.prototype.kind;
  CHTMLmlabeledtr.styles = {
    'mjx-mlabeledtr': {
      display: 'table-row'
    },
    'mjx-mlabeledtr[rowalign="top"] > mjx-mtd': {
      'vertical-align': 'top'
    },
    'mjx-mlabeledtr[rowalign="center"] > mjx-mtd': {
      'vertical-align': 'middle'
    },
    'mjx-mlabeledtr[rowalign="bottom"] > mjx-mtd': {
      'vertical-align': 'bottom'
    },
    'mjx-mlabeledtr[rowalign="baseline"] > mjx-mtd': {
      'vertical-align': 'baseline'
    },
    'mjx-mlabeledtr[rowalign="axis"] > mjx-mtd': {
      'vertical-align': '.25em'
    }
  };
  return CHTMLmlabeledtr;
})((0, mtr_js_2.CommonMlabeledtrMixin)(CHTMLmtr));
mtr$1.CHTMLmlabeledtr = CHTMLmlabeledtr;

var mtd$1 = {};

var mtd = {};

var __extends$x = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mtd, "__esModule", {
  value: true
});
mtd.CommonMtdMixin = void 0;
function CommonMtdMixin(Base) {
  return (function (_super) {
    __extends$x(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(class_1.prototype, "fixesPWidth", {
      get: function () {
        return false;
      },
      enumerable: false,
      configurable: true
    });
    class_1.prototype.invalidateBBox = function () {
      this.bboxComputed = false;
    };
    class_1.prototype.getWrapWidth = function (_j) {
      var table = this.parent.parent;
      var row = this.parent;
      var i = this.node.childPosition() - (row.labeled ? 1 : 0);
      return typeof table.cWidths[i] === 'number' ? table.cWidths[i] : table.getTableData().W[i];
    };
    class_1.prototype.getChildAlign = function (_i) {
      return this.node.attributes.get('columnalign');
    };
    return class_1;
  })(Base);
}
mtd.CommonMtdMixin = CommonMtdMixin;

var __extends$w = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mtd$1, "__esModule", {
  value: true
});
mtd$1.CHTMLmtd = void 0;
var Wrapper_js_1$6 = Wrapper$2;
var mtd_js_1$1 = mtd;
var mtd_js_2 = mtd$2;
var CHTMLmtd = (function (_super) {
  __extends$w(CHTMLmtd, _super);
  function CHTMLmtd() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmtd.prototype.toCHTML = function (parent) {
    _super.prototype.toCHTML.call(this, parent);
    var ralign = this.node.attributes.get('rowalign');
    var calign = this.node.attributes.get('columnalign');
    var palign = this.parent.node.attributes.get('rowalign');
    if (ralign !== palign) {
      this.adaptor.setAttribute(this.chtml, 'rowalign', ralign);
    }
    if (calign !== 'center' && (this.parent.kind !== 'mlabeledtr' || this !== this.parent.childNodes[0] || calign !== this.parent.parent.node.attributes.get('side'))) {
      this.adaptor.setStyle(this.chtml, 'textAlign', calign);
    }
    if (this.parent.parent.node.getProperty('useHeight')) {
      this.adaptor.append(this.chtml, this.html('mjx-tstrut'));
    }
  };
  CHTMLmtd.kind = mtd_js_2.MmlMtd.prototype.kind;
  CHTMLmtd.styles = {
    'mjx-mtd': {
      display: 'table-cell',
      'text-align': 'center',
      'padding': '.215em .4em'
    },
    'mjx-mtd:first-child': {
      'padding-left': 0
    },
    'mjx-mtd:last-child': {
      'padding-right': 0
    },
    'mjx-mtable > * > mjx-itable > *:first-child > mjx-mtd': {
      'padding-top': 0
    },
    'mjx-mtable > * > mjx-itable > *:last-child > mjx-mtd': {
      'padding-bottom': 0
    },
    'mjx-tstrut': {
      display: 'inline-block',
      height: '1em',
      'vertical-align': '-.25em'
    },
    'mjx-labels[align="left"] > mjx-mtr > mjx-mtd': {
      'text-align': 'left'
    },
    'mjx-labels[align="right"] > mjx-mtr > mjx-mtd': {
      'text-align': 'right'
    },
    'mjx-mtd[extra]': {
      padding: 0
    },
    'mjx-mtd[rowalign="top"]': {
      'vertical-align': 'top'
    },
    'mjx-mtd[rowalign="center"]': {
      'vertical-align': 'middle'
    },
    'mjx-mtd[rowalign="bottom"]': {
      'vertical-align': 'bottom'
    },
    'mjx-mtd[rowalign="baseline"]': {
      'vertical-align': 'baseline'
    },
    'mjx-mtd[rowalign="axis"]': {
      'vertical-align': '.25em'
    }
  };
  return CHTMLmtd;
})((0, mtd_js_1$1.CommonMtdMixin)(Wrapper_js_1$6.CHTMLWrapper));
mtd$1.CHTMLmtd = CHTMLmtd;

var maction$1 = {};

var maction = {};

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !((i in from))) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CommonMactionMixin = exports.TooltipData = void 0;
  var string_js_1 = string;
  exports.TooltipData = {
    dx: '.2em',
    dy: '.1em',
    postDelay: 600,
    clearDelay: 100,
    hoverTimer: new Map(),
    clearTimer: new Map(),
    stopTimers: function (node, data) {
      if (data.clearTimer.has(node)) {
        clearTimeout(data.clearTimer.get(node));
        data.clearTimer.delete(node);
      }
      if (data.hoverTimer.has(node)) {
        clearTimeout(data.hoverTimer.get(node));
        data.hoverTimer.delete(node);
      }
    }
  };
  function CommonMactionMixin(Base) {
    return (function (_super) {
      __extends(class_1, _super);
      function class_1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArray([], __read(args), false)) || this;
        var actions = _this.constructor.actions;
        var action = _this.node.attributes.get('actiontype');
        var _a = __read(actions.get(action) || [function (_node, _data) {}, {}], 2), handler = _a[0], data = _a[1];
        _this.action = handler;
        _this.data = data;
        _this.getParameters();
        return _this;
      }
      Object.defineProperty(class_1.prototype, "selected", {
        get: function () {
          var selection = this.node.attributes.get('selection');
          var i = Math.max(1, Math.min(this.childNodes.length, selection)) - 1;
          return this.childNodes[i] || this.wrap(this.node.selected);
        },
        enumerable: false,
        configurable: true
      });
      class_1.prototype.getParameters = function () {
        var offsets = this.node.attributes.get('data-offsets');
        var _a = __read((0, string_js_1.split)(offsets || ''), 2), dx = _a[0], dy = _a[1];
        this.dx = this.length2em(dx || exports.TooltipData.dx);
        this.dy = this.length2em(dy || exports.TooltipData.dy);
      };
      class_1.prototype.computeBBox = function (bbox, recompute) {
        if (recompute === void 0) {
          recompute = false;
        }
        bbox.updateFrom(this.selected.getOuterBBox());
        this.selected.setChildPWidths(recompute);
      };
      return class_1;
    })(Base);
  }
  exports.CommonMactionMixin = CommonMactionMixin;
})(maction);
getDefaultExportFromCjs(maction);

var __extends$v = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(maction$1, "__esModule", {
  value: true
});
maction$1.CHTMLmaction = void 0;
var Wrapper_js_1$5 = Wrapper$2;
var maction_js_1$1 = maction;
var maction_js_2 = maction;
var maction_js_3 = maction$2;
var CHTMLmaction = (function (_super) {
  __extends$v(CHTMLmaction, _super);
  function CHTMLmaction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmaction.prototype.toCHTML = function (parent) {
    var chtml = this.standardCHTMLnode(parent);
    var child = this.selected;
    child.toCHTML(chtml);
    this.action(this, this.data);
  };
  CHTMLmaction.prototype.setEventHandler = function (type, handler) {
    this.chtml.addEventListener(type, handler);
  };
  CHTMLmaction.kind = maction_js_3.MmlMaction.prototype.kind;
  CHTMLmaction.styles = {
    'mjx-maction': {
      position: 'relative'
    },
    'mjx-maction > mjx-tool': {
      display: 'none',
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: 0,
      height: 0,
      'z-index': 500
    },
    'mjx-tool > mjx-tip': {
      display: 'inline-block',
      padding: '.2em',
      border: '1px solid #888',
      'font-size': '70%',
      'background-color': '#F8F8F8',
      color: 'black',
      'box-shadow': '2px 2px 5px #AAAAAA'
    },
    'mjx-maction[toggle]': {
      cursor: 'pointer'
    },
    'mjx-status': {
      display: 'block',
      position: 'fixed',
      left: '1em',
      bottom: '1em',
      'min-width': '25%',
      padding: '.2em .4em',
      border: '1px solid #888',
      'font-size': '90%',
      'background-color': '#F8F8F8',
      color: 'black'
    }
  };
  CHTMLmaction.actions = new Map([['toggle', [function (node, _data) {
    node.adaptor.setAttribute(node.chtml, 'toggle', node.node.attributes.get('selection'));
    var math = node.factory.jax.math;
    var document = node.factory.jax.document;
    var mml = node.node;
    node.setEventHandler('click', function (event) {
      if (!math.end.node) {
        math.start.node = math.end.node = math.typesetRoot;
        math.start.n = math.end.n = 0;
      }
      mml.nextToggleSelection();
      math.rerender(document);
      event.stopPropagation();
    });
  }, {}]], ['tooltip', [function (node, data) {
    var tip = node.childNodes[1];
    if (!tip) return;
    if (tip.node.isKind('mtext')) {
      var text = tip.node.getText();
      node.adaptor.setAttribute(node.chtml, 'title', text);
    } else {
      var adaptor_1 = node.adaptor;
      var tool_1 = adaptor_1.append(node.chtml, node.html('mjx-tool', {
        style: {
          bottom: node.em(-node.dy),
          right: node.em(-node.dx)
        }
      }, [node.html('mjx-tip')]));
      tip.toCHTML(adaptor_1.firstChild(tool_1));
      node.setEventHandler('mouseover', function (event) {
        data.stopTimers(node, data);
        var timeout = setTimeout(function () {
          return adaptor_1.setStyle(tool_1, 'display', 'block');
        }, data.postDelay);
        data.hoverTimer.set(node, timeout);
        event.stopPropagation();
      });
      node.setEventHandler('mouseout', function (event) {
        data.stopTimers(node, data);
        var timeout = setTimeout(function () {
          return adaptor_1.setStyle(tool_1, 'display', '');
        }, data.clearDelay);
        data.clearTimer.set(node, timeout);
        event.stopPropagation();
      });
    }
  }, maction_js_2.TooltipData]], ['statusline', [function (node, data) {
    var tip = node.childNodes[1];
    if (!tip) return;
    if (tip.node.isKind('mtext')) {
      var adaptor_2 = node.adaptor;
      var text_1 = tip.node.getText();
      adaptor_2.setAttribute(node.chtml, 'statusline', text_1);
      node.setEventHandler('mouseover', function (event) {
        if (data.status === null) {
          var body = adaptor_2.body(adaptor_2.document);
          data.status = adaptor_2.append(body, node.html('mjx-status', {}, [node.text(text_1)]));
        }
        event.stopPropagation();
      });
      node.setEventHandler('mouseout', function (event) {
        if (data.status) {
          adaptor_2.remove(data.status);
          data.status = null;
        }
        event.stopPropagation();
      });
    }
  }, {
    status: null
  }]]]);
  return CHTMLmaction;
})((0, maction_js_1$1.CommonMactionMixin)(Wrapper_js_1$5.CHTMLWrapper));
maction$1.CHTMLmaction = CHTMLmaction;

var mglyph$1 = {};

var mglyph = {};

var __extends$u = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __read$a = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$4 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(mglyph, "__esModule", {
  value: true
});
mglyph.CommonMglyphMixin = void 0;
function CommonMglyphMixin(Base) {
  return (function (_super) {
    __extends$u(class_1, _super);
    function class_1() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, __spreadArray$4([], __read$a(args), false)) || this;
      _this.getParameters();
      return _this;
    }
    class_1.prototype.getParameters = function () {
      var _a = this.node.attributes.getList('width', 'height', 'valign', 'src', 'index'), width = _a.width, height = _a.height, valign = _a.valign, src = _a.src, index = _a.index;
      if (src) {
        this.width = width === 'auto' ? 1 : this.length2em(width);
        this.height = height === 'auto' ? 1 : this.length2em(height);
        this.valign = this.length2em(valign || '0');
      } else {
        var text = String.fromCodePoint(parseInt(index));
        var mmlFactory = this.node.factory;
        this.charWrapper = this.wrap(mmlFactory.create('text').setText(text));
        this.charWrapper.parent = this;
      }
    };
    class_1.prototype.computeBBox = function (bbox, _recompute) {
      if (this.charWrapper) {
        bbox.updateFrom(this.charWrapper.getBBox());
      } else {
        bbox.w = this.width;
        bbox.h = this.height + this.valign;
        bbox.d = -this.valign;
      }
    };
    return class_1;
  })(Base);
}
mglyph.CommonMglyphMixin = CommonMglyphMixin;

var __extends$t = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(mglyph$1, "__esModule", {
  value: true
});
mglyph$1.CHTMLmglyph = void 0;
var Wrapper_js_1$4 = Wrapper$2;
var mglyph_js_1$1 = mglyph;
var mglyph_js_2 = mglyph$2;
var CHTMLmglyph = (function (_super) {
  __extends$t(CHTMLmglyph, _super);
  function CHTMLmglyph() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLmglyph.prototype.toCHTML = function (parent) {
    var chtml = this.standardCHTMLnode(parent);
    if (this.charWrapper) {
      this.charWrapper.toCHTML(chtml);
      return;
    }
    var _a = this.node.attributes.getList('src', 'alt'), src = _a.src, alt = _a.alt;
    var styles = {
      width: this.em(this.width),
      height: this.em(this.height)
    };
    if (this.valign) {
      styles.verticalAlign = this.em(this.valign);
    }
    var img = this.html('img', {
      src: src,
      style: styles,
      alt: alt,
      title: alt
    });
    this.adaptor.append(chtml, img);
  };
  CHTMLmglyph.kind = mglyph_js_2.MmlMglyph.prototype.kind;
  CHTMLmglyph.styles = {
    'mjx-mglyph > img': {
      display: 'inline-block',
      border: 0,
      padding: 0
    }
  };
  return CHTMLmglyph;
})((0, mglyph_js_1$1.CommonMglyphMixin)(Wrapper_js_1$4.CHTMLWrapper));
mglyph$1.CHTMLmglyph = CHTMLmglyph;

var semantics$1 = {};

var semantics = {};

var __extends$s = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(semantics, "__esModule", {
  value: true
});
semantics.CommonSemanticsMixin = void 0;
function CommonSemanticsMixin(Base) {
  return (function (_super) {
    __extends$s(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.computeBBox = function (bbox, _recompute) {
      if (this.childNodes.length) {
        var _a = this.childNodes[0].getBBox(), w = _a.w, h = _a.h, d = _a.d;
        bbox.w = w;
        bbox.h = h;
        bbox.d = d;
      }
    };
    return class_1;
  })(Base);
}
semantics.CommonSemanticsMixin = CommonSemanticsMixin;

var __extends$r = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(semantics$1, "__esModule", {
  value: true
});
semantics$1.CHTMLxml = semantics$1.CHTMLannotationXML = semantics$1.CHTMLannotation = semantics$1.CHTMLsemantics = void 0;
var Wrapper_js_1$3 = Wrapper$2;
var semantics_js_1$1 = semantics;
var semantics_js_2 = semantics$2;
var MmlNode_js_1$a = MmlNode;
var CHTMLsemantics = (function (_super) {
  __extends$r(CHTMLsemantics, _super);
  function CHTMLsemantics() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLsemantics.prototype.toCHTML = function (parent) {
    var chtml = this.standardCHTMLnode(parent);
    if (this.childNodes.length) {
      this.childNodes[0].toCHTML(chtml);
    }
  };
  CHTMLsemantics.kind = semantics_js_2.MmlSemantics.prototype.kind;
  return CHTMLsemantics;
})((0, semantics_js_1$1.CommonSemanticsMixin)(Wrapper_js_1$3.CHTMLWrapper));
semantics$1.CHTMLsemantics = CHTMLsemantics;
var CHTMLannotation = (function (_super) {
  __extends$r(CHTMLannotation, _super);
  function CHTMLannotation() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLannotation.prototype.toCHTML = function (parent) {
    _super.prototype.toCHTML.call(this, parent);
  };
  CHTMLannotation.prototype.computeBBox = function () {
    return this.bbox;
  };
  CHTMLannotation.kind = semantics_js_2.MmlAnnotation.prototype.kind;
  return CHTMLannotation;
})(Wrapper_js_1$3.CHTMLWrapper);
semantics$1.CHTMLannotation = CHTMLannotation;
var CHTMLannotationXML = (function (_super) {
  __extends$r(CHTMLannotationXML, _super);
  function CHTMLannotationXML() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLannotationXML.kind = semantics_js_2.MmlAnnotationXML.prototype.kind;
  CHTMLannotationXML.styles = {
    'mjx-annotation-xml': {
      'font-family': 'initial',
      'line-height': 'normal'
    }
  };
  return CHTMLannotationXML;
})(Wrapper_js_1$3.CHTMLWrapper);
semantics$1.CHTMLannotationXML = CHTMLannotationXML;
var CHTMLxml = (function (_super) {
  __extends$r(CHTMLxml, _super);
  function CHTMLxml() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLxml.prototype.toCHTML = function (parent) {
    this.chtml = this.adaptor.append(parent, this.adaptor.clone(this.node.getXML()));
  };
  CHTMLxml.prototype.computeBBox = function (bbox, _recompute) {
    var _a = this.jax.measureXMLnode(this.node.getXML()), w = _a.w, h = _a.h, d = _a.d;
    bbox.w = w;
    bbox.h = h;
    bbox.d = d;
  };
  CHTMLxml.prototype.getStyles = function () {};
  CHTMLxml.prototype.getScale = function () {};
  CHTMLxml.prototype.getVariant = function () {};
  CHTMLxml.kind = MmlNode_js_1$a.XMLNode.prototype.kind;
  CHTMLxml.autoStyle = false;
  return CHTMLxml;
})(Wrapper_js_1$3.CHTMLWrapper);
semantics$1.CHTMLxml = CHTMLxml;

var TeXAtom$1 = {};

var TeXAtom = {};

var __extends$q = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(TeXAtom, "__esModule", {
  value: true
});
TeXAtom.CommonTeXAtomMixin = void 0;
var MmlNode_js_1$9 = MmlNode;
function CommonTeXAtomMixin(Base) {
  return (function (_super) {
    __extends$q(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.computeBBox = function (bbox, recompute) {
      if (recompute === void 0) {
        recompute = false;
      }
      _super.prototype.computeBBox.call(this, bbox, recompute);
      if (this.childNodes[0] && this.childNodes[0].bbox.ic) {
        bbox.ic = this.childNodes[0].bbox.ic;
      }
      if (this.node.texClass === MmlNode_js_1$9.TEXCLASS.VCENTER) {
        var h = bbox.h, d = bbox.d;
        var a = this.font.params.axis_height;
        var dh = (h + d) / 2 + a - h;
        bbox.h += dh;
        bbox.d -= dh;
      }
    };
    return class_1;
  })(Base);
}
TeXAtom.CommonTeXAtomMixin = CommonTeXAtomMixin;

var __extends$p = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(TeXAtom$1, "__esModule", {
  value: true
});
TeXAtom$1.CHTMLTeXAtom = void 0;
var Wrapper_js_1$2 = Wrapper$2;
var TeXAtom_js_1$1 = TeXAtom;
var TeXAtom_js_2 = TeXAtom$3;
var MmlNode_js_1$8 = MmlNode;
var CHTMLTeXAtom = (function (_super) {
  __extends$p(CHTMLTeXAtom, _super);
  function CHTMLTeXAtom() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLTeXAtom.prototype.toCHTML = function (parent) {
    _super.prototype.toCHTML.call(this, parent);
    this.adaptor.setAttribute(this.chtml, 'texclass', MmlNode_js_1$8.TEXCLASSNAMES[this.node.texClass]);
    if (this.node.texClass === MmlNode_js_1$8.TEXCLASS.VCENTER) {
      var bbox = this.childNodes[0].getBBox();
      var h = bbox.h, d = bbox.d;
      var a = this.font.params.axis_height;
      var dh = (h + d) / 2 + a - h;
      this.adaptor.setStyle(this.chtml, 'verticalAlign', this.em(dh));
    }
  };
  CHTMLTeXAtom.kind = TeXAtom_js_2.TeXAtom.prototype.kind;
  return CHTMLTeXAtom;
})((0, TeXAtom_js_1$1.CommonTeXAtomMixin)(Wrapper_js_1$2.CHTMLWrapper));
TeXAtom$1.CHTMLTeXAtom = CHTMLTeXAtom;

var TextNode$1 = {};

var TextNode = {};

var __extends$o = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$c = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$9 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(TextNode, "__esModule", {
  value: true
});
TextNode.CommonTextNodeMixin = void 0;
function CommonTextNodeMixin(Base) {
  return (function (_super) {
    __extends$o(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.computeBBox = function (bbox, _recompute) {
      var e_1, _a;
      var variant = this.parent.variant;
      var text = this.node.getText();
      if (variant === '-explicitFont') {
        var font = this.jax.getFontData(this.parent.styles);
        var _b = this.jax.measureText(text, variant, font), w = _b.w, h = _b.h, d = _b.d;
        bbox.h = h;
        bbox.d = d;
        bbox.w = w;
      } else {
        var chars = this.remappedText(text, variant);
        bbox.empty();
        try {
          for (var chars_1 = __values$c(chars), chars_1_1 = chars_1.next(); !chars_1_1.done; chars_1_1 = chars_1.next()) {
            var char = chars_1_1.value;
            var _c = __read$9(this.getVariantChar(variant, char), 4), h = _c[0], d = _c[1], w = _c[2], data = _c[3];
            if (data.unknown) {
              var cbox = this.jax.measureText(String.fromCodePoint(char), variant);
              w = cbox.w;
              h = cbox.h;
              d = cbox.d;
            }
            bbox.w += w;
            if (h > bbox.h) bbox.h = h;
            if (d > bbox.d) bbox.d = d;
            bbox.ic = data.ic || 0;
            bbox.sk = data.sk || 0;
            bbox.dx = data.dx || 0;
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (chars_1_1 && !chars_1_1.done && (_a = chars_1.return)) _a.call(chars_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        if (chars.length > 1) {
          bbox.sk = 0;
        }
        bbox.clean();
      }
    };
    class_1.prototype.remappedText = function (text, variant) {
      var c = this.parent.stretch.c;
      return c ? [c] : this.parent.remapChars(this.unicodeChars(text, variant));
    };
    class_1.prototype.getStyles = function () {};
    class_1.prototype.getVariant = function () {};
    class_1.prototype.getScale = function () {};
    class_1.prototype.getSpace = function () {};
    return class_1;
  })(Base);
}
TextNode.CommonTextNodeMixin = CommonTextNodeMixin;

var __extends$n = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$b = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(TextNode$1, "__esModule", {
  value: true
});
TextNode$1.CHTMLTextNode = void 0;
var MmlNode_js_1$7 = MmlNode;
var Wrapper_js_1$1 = Wrapper$2;
var TextNode_js_1$1 = TextNode;
var CHTMLTextNode = (function (_super) {
  __extends$n(CHTMLTextNode, _super);
  function CHTMLTextNode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLTextNode.prototype.toCHTML = function (parent) {
    var e_1, _a;
    this.markUsed();
    var adaptor = this.adaptor;
    var variant = this.parent.variant;
    var text = this.node.getText();
    if (text.length === 0) return;
    if (variant === '-explicitFont') {
      adaptor.append(parent, this.jax.unknownText(text, variant, this.getBBox().w));
    } else {
      var chars = this.remappedText(text, variant);
      try {
        for (var chars_1 = __values$b(chars), chars_1_1 = chars_1.next(); !chars_1_1.done; chars_1_1 = chars_1.next()) {
          var n = chars_1_1.value;
          var data = this.getVariantChar(variant, n)[3];
          var font = data.f ? ' TEX-' + data.f : '';
          var node = data.unknown ? this.jax.unknownText(String.fromCodePoint(n), variant) : this.html('mjx-c', {
            class: this.char(n) + font
          });
          adaptor.append(parent, node);
          !data.unknown && this.font.charUsage.add([variant, n]);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (chars_1_1 && !chars_1_1.done && (_a = chars_1.return)) _a.call(chars_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  };
  CHTMLTextNode.kind = MmlNode_js_1$7.TextNode.prototype.kind;
  CHTMLTextNode.autoStyle = false;
  CHTMLTextNode.styles = {
    'mjx-c': {
      display: 'inline-block'
    },
    'mjx-utext': {
      display: 'inline-block',
      padding: '.75em 0 .2em 0'
    }
  };
  return CHTMLTextNode;
})((0, TextNode_js_1$1.CommonTextNodeMixin)(Wrapper_js_1$1.CHTMLWrapper));
TextNode$1.CHTMLTextNode = CHTMLTextNode;

var _a$7;
Object.defineProperty(Wrappers, "__esModule", {
  value: true
});
Wrappers.CHTMLWrappers = void 0;
var Wrapper_js_1 = Wrapper$2;
var math_js_1 = math$1;
var mi_js_1 = mi$1;
var mo_js_1 = mo$1;
var mn_js_1 = mn$1;
var ms_js_1 = ms$2;
var mtext_js_1 = mtext$1;
var mspace_js_1 = mspace$1;
var mpadded_js_1 = mpadded$1;
var menclose_js_1 = menclose$1;
var mrow_js_1 = mrow$1;
var mfenced_js_1 = mfenced$1;
var mfrac_js_1 = mfrac$1;
var msqrt_js_1 = msqrt$1;
var mroot_js_1 = mroot$1;
var msubsup_js_1 = msubsup$1;
var munderover_js_1 = munderover$1;
var mmultiscripts_js_1 = mmultiscripts$1;
var mtable_js_1 = mtable$1;
var mtr_js_1 = mtr$1;
var mtd_js_1 = mtd$1;
var maction_js_1 = maction$1;
var mglyph_js_1 = mglyph$1;
var semantics_js_1 = semantics$1;
var TeXAtom_js_1 = TeXAtom$1;
var TextNode_js_1 = TextNode$1;
Wrappers.CHTMLWrappers = (_a$7 = {}, _a$7[math_js_1.CHTMLmath.kind] = math_js_1.CHTMLmath, _a$7[mrow_js_1.CHTMLmrow.kind] = mrow_js_1.CHTMLmrow, _a$7[mrow_js_1.CHTMLinferredMrow.kind] = mrow_js_1.CHTMLinferredMrow, _a$7[mi_js_1.CHTMLmi.kind] = mi_js_1.CHTMLmi, _a$7[mo_js_1.CHTMLmo.kind] = mo_js_1.CHTMLmo, _a$7[mn_js_1.CHTMLmn.kind] = mn_js_1.CHTMLmn, _a$7[ms_js_1.CHTMLms.kind] = ms_js_1.CHTMLms, _a$7[mtext_js_1.CHTMLmtext.kind] = mtext_js_1.CHTMLmtext, _a$7[mspace_js_1.CHTMLmspace.kind] = mspace_js_1.CHTMLmspace, _a$7[mpadded_js_1.CHTMLmpadded.kind] = mpadded_js_1.CHTMLmpadded, _a$7[menclose_js_1.CHTMLmenclose.kind] = menclose_js_1.CHTMLmenclose, _a$7[mfrac_js_1.CHTMLmfrac.kind] = mfrac_js_1.CHTMLmfrac, _a$7[msqrt_js_1.CHTMLmsqrt.kind] = msqrt_js_1.CHTMLmsqrt, _a$7[mroot_js_1.CHTMLmroot.kind] = mroot_js_1.CHTMLmroot, _a$7[msubsup_js_1.CHTMLmsub.kind] = msubsup_js_1.CHTMLmsub, _a$7[msubsup_js_1.CHTMLmsup.kind] = msubsup_js_1.CHTMLmsup, _a$7[msubsup_js_1.CHTMLmsubsup.kind] = msubsup_js_1.CHTMLmsubsup, _a$7[munderover_js_1.CHTMLmunder.kind] = munderover_js_1.CHTMLmunder, _a$7[munderover_js_1.CHTMLmover.kind] = munderover_js_1.CHTMLmover, _a$7[munderover_js_1.CHTMLmunderover.kind] = munderover_js_1.CHTMLmunderover, _a$7[mmultiscripts_js_1.CHTMLmmultiscripts.kind] = mmultiscripts_js_1.CHTMLmmultiscripts, _a$7[mfenced_js_1.CHTMLmfenced.kind] = mfenced_js_1.CHTMLmfenced, _a$7[mtable_js_1.CHTMLmtable.kind] = mtable_js_1.CHTMLmtable, _a$7[mtr_js_1.CHTMLmtr.kind] = mtr_js_1.CHTMLmtr, _a$7[mtr_js_1.CHTMLmlabeledtr.kind] = mtr_js_1.CHTMLmlabeledtr, _a$7[mtd_js_1.CHTMLmtd.kind] = mtd_js_1.CHTMLmtd, _a$7[maction_js_1.CHTMLmaction.kind] = maction_js_1.CHTMLmaction, _a$7[mglyph_js_1.CHTMLmglyph.kind] = mglyph_js_1.CHTMLmglyph, _a$7[semantics_js_1.CHTMLsemantics.kind] = semantics_js_1.CHTMLsemantics, _a$7[semantics_js_1.CHTMLannotation.kind] = semantics_js_1.CHTMLannotation, _a$7[semantics_js_1.CHTMLannotationXML.kind] = semantics_js_1.CHTMLannotationXML, _a$7[semantics_js_1.CHTMLxml.kind] = semantics_js_1.CHTMLxml, _a$7[TeXAtom_js_1.CHTMLTeXAtom.kind] = TeXAtom_js_1.CHTMLTeXAtom, _a$7[TextNode_js_1.CHTMLTextNode.kind] = TextNode_js_1.CHTMLTextNode, _a$7[Wrapper_js_1.CHTMLWrapper.kind] = Wrapper_js_1.CHTMLWrapper, _a$7);

var __extends$m = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(WrapperFactory$2, "__esModule", {
  value: true
});
var CHTMLWrapperFactory_1 = WrapperFactory$2.CHTMLWrapperFactory = void 0;
var WrapperFactory_js_1$1 = WrapperFactory$1;
var Wrappers_js_1 = Wrappers;
var CHTMLWrapperFactory = (function (_super) {
  __extends$m(CHTMLWrapperFactory, _super);
  function CHTMLWrapperFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CHTMLWrapperFactory.defaultNodes = Wrappers_js_1.CHTMLWrappers;
  return CHTMLWrapperFactory;
})(WrapperFactory_js_1$1.CommonWrapperFactory);
CHTMLWrapperFactory_1 = WrapperFactory$2.CHTMLWrapperFactory = CHTMLWrapperFactory;

var Usage$1 = {};

Object.defineProperty(Usage$1, "__esModule", {
  value: true
});
Usage$1.Usage = void 0;
var Usage = (function () {
  function Usage() {
    this.used = new Set();
    this.needsUpdate = [];
  }
  Usage.prototype.add = function (item) {
    var name = JSON.stringify(item);
    if (!this.used.has(name)) {
      this.needsUpdate.push(item);
    }
    this.used.add(name);
  };
  Usage.prototype.has = function (item) {
    return this.used.has(JSON.stringify(item));
  };
  Usage.prototype.clear = function () {
    this.used.clear();
    this.needsUpdate = [];
  };
  Usage.prototype.update = function () {
    var update = this.needsUpdate;
    this.needsUpdate = [];
    return update;
  };
  return Usage;
})();
Usage$1.Usage = Usage;

var tex$1 = {};

var FontData = {};

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __assign = commonjsGlobal && commonjsGlobal.__assign || (function () {
    __assign = Object.assign || (function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    });
    return __assign.apply(this, arguments);
  });
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || (function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.AddCSS = exports.CHTMLFontData = void 0;
  var FontData_js_1 = FontData$2;
  var Usage_js_1 = Usage$1;
  var lengths_js_1 = lengths;
  __exportStar(FontData$2, exports);
  var CHTMLFontData = (function (_super) {
    __extends(CHTMLFontData, _super);
    function CHTMLFontData() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.charUsage = new Usage_js_1.Usage();
      _this.delimUsage = new Usage_js_1.Usage();
      return _this;
    }
    CHTMLFontData.charOptions = function (font, n) {
      return _super.charOptions.call(this, font, n);
    };
    CHTMLFontData.prototype.adaptiveCSS = function (adapt) {
      this.options.adaptiveCSS = adapt;
    };
    CHTMLFontData.prototype.clearCache = function () {
      if (this.options.adaptiveCSS) {
        this.charUsage.clear();
        this.delimUsage.clear();
      }
    };
    CHTMLFontData.prototype.createVariant = function (name, inherit, link) {
      if (inherit === void 0) {
        inherit = null;
      }
      if (link === void 0) {
        link = null;
      }
      _super.prototype.createVariant.call(this, name, inherit, link);
      var CLASS = this.constructor;
      this.variant[name].classes = CLASS.defaultVariantClasses[name];
      this.variant[name].letter = CLASS.defaultVariantLetters[name];
    };
    CHTMLFontData.prototype.defineChars = function (name, chars) {
      var e_1, _a;
      _super.prototype.defineChars.call(this, name, chars);
      var letter = this.variant[name].letter;
      try {
        for (var _b = __values(Object.keys(chars)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var n = _c.value;
          var options = CHTMLFontData.charOptions(chars, parseInt(n));
          if (options.f === undefined) {
            options.f = letter;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    };
    Object.defineProperty(CHTMLFontData.prototype, "styles", {
      get: function () {
        var CLASS = this.constructor;
        var styles = __assign({}, CLASS.defaultStyles);
        this.addFontURLs(styles, CLASS.defaultFonts, this.options.fontURL);
        if (this.options.adaptiveCSS) {
          this.updateStyles(styles);
        } else {
          this.allStyles(styles);
        }
        return styles;
      },
      enumerable: false,
      configurable: true
    });
    CHTMLFontData.prototype.updateStyles = function (styles) {
      var e_2, _a, e_3, _b;
      try {
        for (var _c = __values(this.delimUsage.update()), _d = _c.next(); !_d.done; _d = _c.next()) {
          var N = _d.value;
          this.addDelimiterStyles(styles, N, this.delimiters[N]);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      try {
        for (var _e = __values(this.charUsage.update()), _f = _e.next(); !_f.done; _f = _e.next()) {
          var _g = __read(_f.value, 2), name_1 = _g[0], N = _g[1];
          var variant = this.variant[name_1];
          this.addCharStyles(styles, variant.letter, N, variant.chars[N]);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
      return styles;
    };
    CHTMLFontData.prototype.allStyles = function (styles) {
      var e_4, _a, e_5, _b, e_6, _c;
      try {
        for (var _d = __values(Object.keys(this.delimiters)), _e = _d.next(); !_e.done; _e = _d.next()) {
          var n = _e.value;
          var N = parseInt(n);
          this.addDelimiterStyles(styles, N, this.delimiters[N]);
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
      try {
        for (var _f = __values(Object.keys(this.variant)), _g = _f.next(); !_g.done; _g = _f.next()) {
          var name_2 = _g.value;
          var variant = this.variant[name_2];
          var vletter = variant.letter;
          try {
            for (var _h = (e_6 = void 0, __values(Object.keys(variant.chars))), _j = _h.next(); !_j.done; _j = _h.next()) {
              var n = _j.value;
              var N = parseInt(n);
              var char = variant.chars[N];
              if ((char[3] || ({})).smp) continue;
              if (char.length < 4) {
                char[3] = {};
              }
              this.addCharStyles(styles, vletter, N, char);
            }
          } catch (e_6_1) {
            e_6 = {
              error: e_6_1
            };
          } finally {
            try {
              if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
            } finally {
              if (e_6) throw e_6.error;
            }
          }
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
    };
    CHTMLFontData.prototype.addFontURLs = function (styles, fonts, url) {
      var e_7, _a;
      try {
        for (var _b = __values(Object.keys(fonts)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var name_3 = _c.value;
          var font = __assign({}, fonts[name_3]);
          font.src = font.src.replace(/%%URL%%/, url);
          styles[name_3] = font;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
    };
    CHTMLFontData.prototype.addDelimiterStyles = function (styles, n, data) {
      var c = this.charSelector(n);
      if (data.c && data.c !== n) {
        c = this.charSelector(data.c);
        styles['.mjx-stretched mjx-c' + c + '::before'] = {
          content: this.charContent(data.c)
        };
      }
      if (!data.stretch) return;
      if (data.dir === 1) {
        this.addDelimiterVStyles(styles, c, data);
      } else {
        this.addDelimiterHStyles(styles, c, data);
      }
    };
    CHTMLFontData.prototype.addDelimiterVStyles = function (styles, c, data) {
      var HDW = data.HDW;
      var _a = __read(data.stretch, 4), beg = _a[0], ext = _a[1], end = _a[2], mid = _a[3];
      var Hb = this.addDelimiterVPart(styles, c, 'beg', beg, HDW);
      this.addDelimiterVPart(styles, c, 'ext', ext, HDW);
      var He = this.addDelimiterVPart(styles, c, 'end', end, HDW);
      var css = {};
      if (mid) {
        var Hm = this.addDelimiterVPart(styles, c, 'mid', mid, HDW);
        css.height = '50%';
        styles['mjx-stretchy-v' + c + ' > mjx-mid'] = {
          'margin-top': this.em(-Hm / 2),
          'margin-bottom': this.em(-Hm / 2)
        };
      }
      if (Hb) {
        css['border-top-width'] = this.em0(Hb - .03);
      }
      if (He) {
        css['border-bottom-width'] = this.em0(He - .03);
        styles['mjx-stretchy-v' + c + ' > mjx-end'] = {
          'margin-top': this.em(-He)
        };
      }
      if (Object.keys(css).length) {
        styles['mjx-stretchy-v' + c + ' > mjx-ext'] = css;
      }
    };
    CHTMLFontData.prototype.addDelimiterVPart = function (styles, c, part, n, HDW) {
      if (!n) return 0;
      var data = this.getDelimiterData(n);
      var dw = (HDW[2] - data[2]) / 2;
      var css = {
        content: this.charContent(n)
      };
      if (part !== 'ext') {
        css.padding = this.padding(data, dw);
      } else {
        css.width = this.em0(HDW[2]);
        if (dw) {
          css['padding-left'] = this.em0(dw);
        }
      }
      styles['mjx-stretchy-v' + c + ' mjx-' + part + ' mjx-c::before'] = css;
      return data[0] + data[1];
    };
    CHTMLFontData.prototype.addDelimiterHStyles = function (styles, c, data) {
      var _a = __read(data.stretch, 4), beg = _a[0], ext = _a[1], end = _a[2], mid = _a[3];
      var HDW = data.HDW;
      this.addDelimiterHPart(styles, c, 'beg', beg, HDW);
      this.addDelimiterHPart(styles, c, 'ext', ext, HDW);
      this.addDelimiterHPart(styles, c, 'end', end, HDW);
      if (mid) {
        this.addDelimiterHPart(styles, c, 'mid', mid, HDW);
        styles['mjx-stretchy-h' + c + ' > mjx-ext'] = {
          width: '50%'
        };
      }
    };
    CHTMLFontData.prototype.addDelimiterHPart = function (styles, c, part, n, HDW) {
      if (!n) return;
      var data = this.getDelimiterData(n);
      var options = data[3];
      var css = {
        content: options && options.c ? '"' + options.c + '"' : this.charContent(n)
      };
      css.padding = this.padding(HDW, 0, -HDW[2]);
      styles['mjx-stretchy-h' + c + ' mjx-' + part + ' mjx-c::before'] = css;
    };
    CHTMLFontData.prototype.addCharStyles = function (styles, vletter, n, data) {
      var options = data[3];
      var letter = options.f !== undefined ? options.f : vletter;
      var selector = 'mjx-c' + this.charSelector(n) + (letter ? '.TEX-' + letter : '');
      styles[selector + '::before'] = {
        padding: this.padding(data, 0, options.ic || 0),
        content: options.c != null ? '"' + options.c + '"' : this.charContent(n)
      };
    };
    CHTMLFontData.prototype.getDelimiterData = function (n) {
      return this.getChar('-smallop', n);
    };
    CHTMLFontData.prototype.em = function (n) {
      return (0, lengths_js_1.em)(n);
    };
    CHTMLFontData.prototype.em0 = function (n) {
      return (0, lengths_js_1.em)(Math.max(0, n));
    };
    CHTMLFontData.prototype.padding = function (_a, dw, ic) {
      var _b = __read(_a, 3), h = _b[0], d = _b[1], w = _b[2];
      if (dw === void 0) {
        dw = 0;
      }
      if (ic === void 0) {
        ic = 0;
      }
      return [h, w + ic, d, dw].map(this.em0).join(' ');
    };
    CHTMLFontData.prototype.charContent = function (n) {
      return '"' + (n >= 0x20 && n <= 0x7E && n !== 0x22 && n !== 0x27 && n !== 0x5C ? String.fromCharCode(n) : '\\' + n.toString(16).toUpperCase()) + '"';
    };
    CHTMLFontData.prototype.charSelector = function (n) {
      return '.mjx-c' + n.toString(16).toUpperCase();
    };
    CHTMLFontData.OPTIONS = __assign(__assign({}, FontData_js_1.FontData.OPTIONS), {
      fontURL: 'js/output/chtml/fonts/tex-woff-v2'
    });
    CHTMLFontData.JAX = 'CHTML';
    CHTMLFontData.defaultVariantClasses = {};
    CHTMLFontData.defaultVariantLetters = {};
    CHTMLFontData.defaultStyles = {
      'mjx-c::before': {
        display: 'block',
        width: 0
      }
    };
    CHTMLFontData.defaultFonts = {
      '@font-face /* 0 */': {
        'font-family': 'MJXZERO',
        src: 'url("%%URL%%/MathJax_Zero.woff") format("woff")'
      }
    };
    return CHTMLFontData;
  })(FontData_js_1.FontData);
  exports.CHTMLFontData = CHTMLFontData;
  function AddCSS(font, options) {
    var e_8, _a;
    try {
      for (var _b = __values(Object.keys(options)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var c = _c.value;
        var n = parseInt(c);
        Object.assign(FontData_js_1.FontData.charOptions(font, n), options[n]);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_8) throw e_8.error;
      }
    }
    return font;
  }
  exports.AddCSS = AddCSS;
})(FontData);
getDefaultExportFromCjs(FontData);

var tex = {};

var __extends$l = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$4 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$4 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$4.apply(this, arguments);
});
var __read$8 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$3 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(tex, "__esModule", {
  value: true
});
tex.CommonTeXFontMixin = void 0;
function CommonTeXFontMixin(Base) {
  var _a;
  return (_a = (function (_super) {
    __extends$l(class_1, _super);
    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.getDelimiterData = function (n) {
      return this.getChar('-smallop', n) || this.getChar('-size4', n);
    };
    return class_1;
  })(Base), _a.NAME = 'TeX', _a.defaultVariants = __spreadArray$3(__spreadArray$3([], __read$8(Base.defaultVariants), false), [['-smallop', 'normal'], ['-largeop', 'normal'], ['-size3', 'normal'], ['-size4', 'normal'], ['-tex-calligraphic', 'italic'], ['-tex-bold-calligraphic', 'bold-italic'], ['-tex-oldstyle', 'normal'], ['-tex-bold-oldstyle', 'bold'], ['-tex-mathit', 'italic'], ['-tex-variant', 'normal']], false), _a.defaultCssFonts = __assign$4(__assign$4({}, Base.defaultCssFonts), {
    '-smallop': ['serif', false, false],
    '-largeop': ['serif', false, false],
    '-size3': ['serif', false, false],
    '-size4': ['serif', false, false],
    '-tex-calligraphic': ['cursive', true, false],
    '-tex-bold-calligraphic': ['cursive', true, true],
    '-tex-oldstyle': ['serif', false, false],
    '-tex-bold-oldstyle': ['serif', false, true],
    '-tex-mathit': ['serif', true, false]
  }), _a.defaultSizeVariants = ['normal', '-smallop', '-largeop', '-size3', '-size4', '-tex-variant'], _a.defaultStretchVariants = ['-size4'], _a);
}
tex.CommonTeXFontMixin = CommonTeXFontMixin;

var boldItalic$1 = {};

var boldItalic = {};

Object.defineProperty(boldItalic, "__esModule", {
  value: true
});
boldItalic.boldItalic = void 0;
boldItalic.boldItalic = {
  0x2F: [.711, .21, .894],
  0x131: [.452, .008, .394, {
    sk: .0319
  }],
  0x237: [.451, .201, .439, {
    sk: .0958
  }],
  0x2044: [.711, .21, .894],
  0x2206: [.711, 0, .958, {
    sk: .192
  }],
  0x29F8: [.711, .21, .894]
};

Object.defineProperty(boldItalic$1, "__esModule", {
  value: true
});
boldItalic$1.boldItalic = void 0;
var FontData_js_1$h = FontData;
var bold_italic_js_1$1 = boldItalic;
boldItalic$1.boldItalic = (0, FontData_js_1$h.AddCSS)(bold_italic_js_1$1.boldItalic, {
  0x131: {
    f: 'B'
  },
  0x237: {
    f: 'B'
  },
  0x2044: {
    c: '/'
  },
  0x2206: {
    c: '\\394'
  },
  0x29F8: {
    c: '/'
  }
});

var bold$1 = {};

var bold = {};

Object.defineProperty(bold, "__esModule", {
  value: true
});
bold.bold = void 0;
bold.bold = {
  0x21: [.705, 0, .35],
  0x22: [.694, -0.329, .603],
  0x23: [.694, .193, .958],
  0x24: [.75, .056, .575],
  0x25: [.75, .056, .958],
  0x26: [.705, .011, .894],
  0x27: [.694, -0.329, .319],
  0x28: [.75, .249, .447],
  0x29: [.75, .249, .447],
  0x2A: [.75, -0.306, .575],
  0x2B: [.633, .131, .894],
  0x2C: [.171, .194, .319],
  0x2D: [.278, -0.166, .383],
  0x2E: [.171, 0, .319],
  0x2F: [.75, .25, .575],
  0x3A: [.444, 0, .319],
  0x3B: [.444, .194, .319],
  0x3C: [.587, .085, .894],
  0x3D: [.393, -0.109, .894],
  0x3E: [.587, .085, .894],
  0x3F: [.7, 0, .543],
  0x40: [.699, .006, .894],
  0x5B: [.75, .25, .319],
  0x5C: [.75, .25, .575],
  0x5D: [.75, .25, .319],
  0x5E: [.694, -0.52, .575],
  0x5F: [-0.01, .061, .575],
  0x60: [.706, -0.503, .575],
  0x7B: [.75, .25, .575],
  0x7C: [.75, .249, .319],
  0x7D: [.75, .25, .575],
  0x7E: [.344, -0.202, .575],
  0xA8: [.695, -0.535, .575],
  0xAC: [.371, -0.061, .767],
  0xAF: [.607, -0.54, .575],
  0xB0: [.702, -0.536, .575],
  0xB1: [.728, .035, .894],
  0xB4: [.706, -0.503, .575],
  0xB7: [.336, -0.166, .319],
  0xD7: [.53, .028, .894],
  0xF7: [.597, .096, .894],
  0x131: [.442, 0, .278, {
    sk: .0278
  }],
  0x237: [.442, .205, .306, {
    sk: .0833
  }],
  0x2B9: [.563, -0.033, .344],
  0x2C6: [.694, -0.52, .575],
  0x2C7: [.66, -0.515, .575],
  0x2C9: [.607, -0.54, .575],
  0x2CA: [.706, -0.503, .575],
  0x2CB: [.706, -0.503, .575],
  0x2D8: [.694, -0.5, .575],
  0x2D9: [.695, -0.525, .575],
  0x2DA: [.702, -0.536, .575],
  0x2DC: [.694, -0.552, .575],
  0x300: [.706, -0.503, 0],
  0x301: [.706, -0.503, 0],
  0x302: [.694, -0.52, 0],
  0x303: [.694, -0.552, 0],
  0x304: [.607, -0.54, 0],
  0x306: [.694, -0.5, 0],
  0x307: [.695, -0.525, 0],
  0x308: [.695, -0.535, 0],
  0x30A: [.702, -0.536, 0],
  0x30B: [.714, -0.511, 0],
  0x30C: [.66, -0.515, 0],
  0x338: [.711, .21, 0],
  0x2002: [0, 0, .5],
  0x2003: [0, 0, .999],
  0x2004: [0, 0, .333],
  0x2005: [0, 0, .25],
  0x2006: [0, 0, .167],
  0x2009: [0, 0, .167],
  0x200A: [0, 0, .083],
  0x2013: [.3, -0.249, .575],
  0x2014: [.3, -0.249, 1.15],
  0x2015: [.3, -0.249, 1.15],
  0x2016: [.75, .248, .575],
  0x2017: [-0.01, .061, .575],
  0x2018: [.694, -0.329, .319],
  0x2019: [.694, -0.329, .319],
  0x201C: [.694, -0.329, .603],
  0x201D: [.694, -0.329, .603],
  0x2020: [.702, .211, .511],
  0x2021: [.702, .202, .511],
  0x2022: [.474, -0.028, .575],
  0x2026: [.171, 0, 1.295],
  0x2032: [.563, -0.033, .344],
  0x2033: [.563, 0, .688],
  0x2034: [.563, 0, 1.032],
  0x203E: [.607, -0.54, .575],
  0x2044: [.75, .25, .575],
  0x2057: [.563, 0, 1.376],
  0x20D7: [.723, -0.513, .575],
  0x210F: [.694, .008, .668, {
    sk: -0.0319
  }],
  0x2113: [.702, .019, .474, {
    sk: .128
  }],
  0x2118: [.461, .21, .74],
  0x2135: [.694, 0, .703],
  0x2190: [.518, .017, 1.15],
  0x2191: [.694, .193, .575],
  0x2192: [.518, .017, 1.15],
  0x2193: [.694, .194, .575],
  0x2194: [.518, .017, 1.15],
  0x2195: [.767, .267, .575],
  0x2196: [.724, .194, 1.15],
  0x2197: [.724, .193, 1.15],
  0x2198: [.694, .224, 1.15],
  0x2199: [.694, .224, 1.15],
  0x219A: [.711, .21, 1.15],
  0x219B: [.711, .21, 1.15],
  0x21A6: [.518, .017, 1.15],
  0x21A9: [.518, .017, 1.282],
  0x21AA: [.518, .017, 1.282],
  0x21AE: [.711, .21, 1.15],
  0x21BC: [.518, -0.22, 1.15],
  0x21BD: [.281, .017, 1.15],
  0x21C0: [.518, -0.22, 1.15],
  0x21C1: [.281, .017, 1.15],
  0x21CC: [.718, .017, 1.15],
  0x21CD: [.711, .21, 1.15],
  0x21CE: [.711, .21, 1.15],
  0x21CF: [.711, .21, 1.15],
  0x21D0: [.547, .046, 1.15],
  0x21D1: [.694, .193, .703],
  0x21D2: [.547, .046, 1.15],
  0x21D3: [.694, .194, .703],
  0x21D4: [.547, .046, 1.15],
  0x21D5: [.767, .267, .703],
  0x2200: [.694, .016, .639],
  0x2203: [.694, 0, .639],
  0x2204: [.711, .21, .639],
  0x2205: [.767, .073, .575],
  0x2206: [.698, 0, .958],
  0x2208: [.587, .086, .767],
  0x2209: [.711, .21, .767],
  0x220B: [.587, .086, .767],
  0x220C: [.711, .21, .767],
  0x2212: [.281, -0.221, .894],
  0x2213: [.537, .227, .894],
  0x2215: [.75, .25, .575],
  0x2216: [.75, .25, .575],
  0x2217: [.472, -0.028, .575],
  0x2218: [.474, -0.028, .575],
  0x2219: [.474, -0.028, .575],
  0x221A: [.82, .18, .958, {
    ic: .03
  }],
  0x221D: [.451, .008, .894],
  0x221E: [.452, .008, 1.15],
  0x2220: [.714, 0, .722],
  0x2223: [.75, .249, .319],
  0x2224: [.75, .249, .319],
  0x2225: [.75, .248, .575],
  0x2226: [.75, .248, .575],
  0x2227: [.604, .017, .767],
  0x2228: [.604, .016, .767],
  0x2229: [.603, .016, .767],
  0x222A: [.604, .016, .767],
  0x222B: [.711, .211, .569, {
    ic: .063
  }],
  0x223C: [.391, -0.109, .894],
  0x2240: [.583, .082, .319],
  0x2241: [.711, .21, .894],
  0x2243: [.502, 0, .894],
  0x2244: [.711, .21, .894],
  0x2245: [.638, .027, .894],
  0x2247: [.711, .21, .894],
  0x2248: [.524, -0.032, .894],
  0x2249: [.711, .21, .894],
  0x224D: [.533, .032, .894],
  0x2250: [.721, -0.109, .894],
  0x2260: [.711, .21, .894],
  0x2261: [.505, 0, .894],
  0x2262: [.711, .21, .894],
  0x2264: [.697, .199, .894],
  0x2265: [.697, .199, .894],
  0x226A: [.617, .116, 1.15],
  0x226B: [.618, .116, 1.15],
  0x226D: [.711, .21, .894],
  0x226E: [.711, .21, .894],
  0x226F: [.711, .21, .894],
  0x2270: [.711, .21, .894],
  0x2271: [.711, .21, .894],
  0x227A: [.585, .086, .894],
  0x227B: [.586, .086, .894],
  0x2280: [.711, .21, .894],
  0x2281: [.711, .21, .894],
  0x2282: [.587, .085, .894],
  0x2283: [.587, .086, .894],
  0x2284: [.711, .21, .894],
  0x2285: [.711, .21, .894],
  0x2286: [.697, .199, .894],
  0x2287: [.697, .199, .894],
  0x2288: [.711, .21, .894],
  0x2289: [.711, .21, .894],
  0x228E: [.604, .016, .767],
  0x2291: [.697, .199, .894],
  0x2292: [.697, .199, .894],
  0x2293: [.604, 0, .767],
  0x2294: [.604, 0, .767],
  0x2295: [.632, .132, .894],
  0x2296: [.632, .132, .894],
  0x2297: [.632, .132, .894],
  0x2298: [.632, .132, .894],
  0x2299: [.632, .132, .894],
  0x22A2: [.693, 0, .703],
  0x22A3: [.693, 0, .703],
  0x22A4: [.694, 0, .894],
  0x22A5: [.693, 0, .894],
  0x22A8: [.75, .249, .974],
  0x22AC: [.711, .21, .703],
  0x22AD: [.75, .249, .974],
  0x22C4: [.523, .021, .575],
  0x22C5: [.336, -0.166, .319],
  0x22C6: [.502, 0, .575],
  0x22C8: [.54, .039, 1],
  0x22E2: [.711, .21, .894],
  0x22E3: [.711, .21, .894],
  0x22EE: [.951, .029, .319],
  0x22EF: [.336, -0.166, 1.295],
  0x22F1: [.871, -0.101, 1.323],
  0x2308: [.75, .248, .511],
  0x2309: [.75, .248, .511],
  0x230A: [.749, .248, .511],
  0x230B: [.749, .248, .511],
  0x2322: [.405, -0.108, 1.15],
  0x2323: [.392, -0.126, 1.15],
  0x2329: [.75, .249, .447],
  0x232A: [.75, .249, .447],
  0x25B3: [.711, 0, 1.022],
  0x25B5: [.711, 0, 1.022],
  0x25B9: [.54, .039, .575],
  0x25BD: [.5, .21, 1.022],
  0x25BF: [.5, .21, 1.022],
  0x25C3: [.539, .038, .575],
  0x25EF: [.711, .211, 1.15],
  0x2660: [.719, .129, .894],
  0x2661: [.711, .024, .894],
  0x2662: [.719, .154, .894],
  0x2663: [.719, .129, .894],
  0x266D: [.75, .017, .447],
  0x266E: [.741, .223, .447],
  0x266F: [.724, .224, .447],
  0x2758: [.75, .249, .319],
  0x27E8: [.75, .249, .447],
  0x27E9: [.75, .249, .447],
  0x27F5: [.518, .017, 1.805],
  0x27F6: [.518, .017, 1.833],
  0x27F7: [.518, .017, 2.126],
  0x27F8: [.547, .046, 1.868],
  0x27F9: [.547, .046, 1.87],
  0x27FA: [.547, .046, 2.126],
  0x27FC: [.518, .017, 1.833],
  0x29F8: [.711, .21, .894],
  0x2A2F: [.53, .028, .894],
  0x2A3F: [.686, 0, .9],
  0x2AAF: [.696, .199, .894],
  0x2AB0: [.697, .199, .894],
  0x3008: [.75, .249, .447],
  0x3009: [.75, .249, .447]
};

Object.defineProperty(bold$1, "__esModule", {
  value: true
});
bold$1.bold = void 0;
var FontData_js_1$g = FontData;
var bold_js_1$1 = bold;
bold$1.bold = (0, FontData_js_1$g.AddCSS)(bold_js_1$1.bold, {
  0xB7: {
    c: '\\22C5'
  },
  0x131: {
    f: ''
  },
  0x237: {
    f: ''
  },
  0x2B9: {
    c: '\\2032'
  },
  0x2002: {
    c: ''
  },
  0x2003: {
    c: ''
  },
  0x2004: {
    c: ''
  },
  0x2005: {
    c: ''
  },
  0x2006: {
    c: ''
  },
  0x2009: {
    c: ''
  },
  0x200A: {
    c: ''
  },
  0x2015: {
    c: '\\2014'
  },
  0x2016: {
    c: '\\2225'
  },
  0x2017: {
    c: '_'
  },
  0x2022: {
    c: '\\2219'
  },
  0x2033: {
    c: '\\2032\\2032'
  },
  0x2034: {
    c: '\\2032\\2032\\2032'
  },
  0x203E: {
    c: '\\2C9'
  },
  0x2044: {
    c: '/'
  },
  0x2057: {
    c: '\\2032\\2032\\2032\\2032'
  },
  0x20D7: {
    c: '\\2192',
    f: 'VB'
  },
  0x219A: {
    c: '\\2190\\338'
  },
  0x219B: {
    c: '\\2192\\338'
  },
  0x21AE: {
    c: '\\2194\\338'
  },
  0x21CD: {
    c: '\\21D0\\338'
  },
  0x21CE: {
    c: '\\21D4\\338'
  },
  0x21CF: {
    c: '\\21D2\\338'
  },
  0x2204: {
    c: '\\2203\\338'
  },
  0x2206: {
    c: '\\394'
  },
  0x220C: {
    c: '\\220B\\338'
  },
  0x2224: {
    c: '\\2223\\338'
  },
  0x2226: {
    c: '\\2225\\338'
  },
  0x2241: {
    c: '\\223C\\338'
  },
  0x2244: {
    c: '\\2243\\338'
  },
  0x2247: {
    c: '\\2245\\338'
  },
  0x2249: {
    c: '\\2248\\338'
  },
  0x2262: {
    c: '\\2261\\338'
  },
  0x226D: {
    c: '\\224D\\338'
  },
  0x226E: {
    c: '<\\338'
  },
  0x226F: {
    c: '>\\338'
  },
  0x2270: {
    c: '\\2264\\338'
  },
  0x2271: {
    c: '\\2265\\338'
  },
  0x2280: {
    c: '\\227A\\338'
  },
  0x2281: {
    c: '\\227B\\338'
  },
  0x2284: {
    c: '\\2282\\338'
  },
  0x2285: {
    c: '\\2283\\338'
  },
  0x2288: {
    c: '\\2286\\338'
  },
  0x2289: {
    c: '\\2287\\338'
  },
  0x22AC: {
    c: '\\22A2\\338'
  },
  0x22AD: {
    c: '\\22A8\\338'
  },
  0x22E2: {
    c: '\\2291\\338'
  },
  0x22E3: {
    c: '\\2292\\338'
  },
  0x2329: {
    c: '\\27E8'
  },
  0x232A: {
    c: '\\27E9'
  },
  0x25B5: {
    c: '\\25B3'
  },
  0x25BF: {
    c: '\\25BD'
  },
  0x2758: {
    c: '\\2223'
  },
  0x29F8: {
    c: '/',
    f: 'BI'
  },
  0x2A2F: {
    c: '\\D7'
  },
  0x3008: {
    c: '\\27E8'
  },
  0x3009: {
    c: '\\27E9'
  }
});

var doubleStruck$1 = {};

var doubleStruck = {};

Object.defineProperty(doubleStruck, "__esModule", {
  value: true
});
doubleStruck.doubleStruck = void 0;
doubleStruck.doubleStruck = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.doubleStruck = void 0;
  var double_struck_js_1 = doubleStruck;
  Object.defineProperty(exports, "doubleStruck", {
    enumerable: true,
    get: function () {
      return double_struck_js_1.doubleStruck;
    }
  });
})(doubleStruck$1);
getDefaultExportFromCjs(doubleStruck$1);

var frakturBold$1 = {};

var frakturBold = {};

Object.defineProperty(frakturBold, "__esModule", {
  value: true
});
frakturBold.frakturBold = void 0;
frakturBold.frakturBold = {
  0x21: [.689, .012, .349],
  0x22: [.695, -0.432, .254],
  0x26: [.696, .016, .871],
  0x27: [.695, -0.436, .25],
  0x28: [.737, .186, .459],
  0x29: [.735, .187, .459],
  0x2A: [.692, -0.449, .328],
  0x2B: [.598, .082, .893],
  0x2C: [.107, .191, .328],
  0x2D: [.275, -0.236, .893],
  0x2E: [.102, .015, .328],
  0x2F: [.721, .182, .593],
  0x30: [.501, .012, .593],
  0x31: [.489, 0, .593],
  0x32: [.491, 0, .593],
  0x33: [.487, .193, .593],
  0x34: [.495, .196, .593],
  0x35: [.481, .19, .593],
  0x36: [.704, .012, .593],
  0x37: [.479, .197, .593],
  0x38: [.714, .005, .593],
  0x39: [.487, .195, .593],
  0x3A: [.457, .012, .255],
  0x3B: [.458, .19, .255],
  0x3D: [.343, -0.168, .582],
  0x3F: [.697, .014, .428],
  0x5B: [.74, .13, .257],
  0x5D: [.738, .132, .257],
  0x5E: [.734, -0.452, .59],
  0x2018: [.708, -0.411, .254],
  0x2019: [.692, -0.394, .254],
  0x2044: [.721, .182, .593],
  0xE301: [.63, .027, .587],
  0xE302: [.693, .212, .394, {
    ic: .014
  }],
  0xE303: [.681, .219, .387],
  0xE304: [.473, .212, .593],
  0xE305: [.684, .027, .393],
  0xE308: [.679, .22, .981],
  0xE309: [.717, .137, .727]
};

Object.defineProperty(frakturBold$1, "__esModule", {
  value: true
});
frakturBold$1.frakturBold = void 0;
var FontData_js_1$f = FontData;
var fraktur_bold_js_1$1 = frakturBold;
frakturBold$1.frakturBold = (0, FontData_js_1$f.AddCSS)(fraktur_bold_js_1$1.frakturBold, {
  0x2044: {
    c: '/'
  }
});

var fraktur$1 = {};

var fraktur = {};

Object.defineProperty(fraktur, "__esModule", {
  value: true
});
fraktur.fraktur = void 0;
fraktur.fraktur = {
  0x21: [.689, .012, .296],
  0x22: [.695, -0.432, .215],
  0x26: [.698, .011, .738],
  0x27: [.695, -0.436, .212],
  0x28: [.737, .186, .389],
  0x29: [.735, .187, .389],
  0x2A: [.692, -0.449, .278],
  0x2B: [.598, .082, .756],
  0x2C: [.107, .191, .278],
  0x2D: [.275, -0.236, .756],
  0x2E: [.102, .015, .278],
  0x2F: [.721, .182, .502],
  0x30: [.492, .013, .502],
  0x31: [.468, 0, .502],
  0x32: [.474, 0, .502],
  0x33: [.473, .182, .502],
  0x34: [.476, .191, .502],
  0x35: [.458, .184, .502],
  0x36: [.7, .013, .502],
  0x37: [.468, .181, .502],
  0x38: [.705, .01, .502],
  0x39: [.469, .182, .502],
  0x3A: [.457, .012, .216],
  0x3B: [.458, .189, .216],
  0x3D: [.368, -0.132, .756],
  0x3F: [.693, .011, .362],
  0x5B: [.74, .13, .278],
  0x5D: [.738, .131, .278],
  0x5E: [.734, -0.452, .5],
  0x2018: [.708, -0.41, .215],
  0x2019: [.692, -0.395, .215],
  0x2044: [.721, .182, .502],
  0xE300: [.683, .032, .497],
  0xE301: [.616, .03, .498],
  0xE302: [.68, .215, .333],
  0xE303: [.679, .224, .329],
  0xE304: [.471, .214, .503],
  0xE305: [.686, .02, .333],
  0xE306: [.577, .021, .334, {
    ic: .013
  }],
  0xE307: [.475, .022, .501, {
    ic: .013
  }]
};

Object.defineProperty(fraktur$1, "__esModule", {
  value: true
});
fraktur$1.fraktur = void 0;
var FontData_js_1$e = FontData;
var fraktur_js_1$1 = fraktur;
fraktur$1.fraktur = (0, FontData_js_1$e.AddCSS)(fraktur_js_1$1.fraktur, {
  0x2044: {
    c: '/'
  }
});

var italic$1 = {};

var italic = {};

Object.defineProperty(italic, "__esModule", {
  value: true
});
italic.italic = void 0;
italic.italic = {
  0x21: [.716, 0, .307, {
    ic: .073
  }],
  0x22: [.694, -0.379, .514, {
    ic: .024
  }],
  0x23: [.694, .194, .818, {
    ic: .01
  }],
  0x25: [.75, .056, .818, {
    ic: .029
  }],
  0x26: [.716, .022, .767, {
    ic: .035
  }],
  0x27: [.694, -0.379, .307, {
    ic: .07
  }],
  0x28: [.75, .25, .409, {
    ic: .108
  }],
  0x29: [.75, .25, .409],
  0x2A: [.75, -0.32, .511, {
    ic: .073
  }],
  0x2B: [.557, .057, .767],
  0x2C: [.121, .194, .307],
  0x2D: [.251, -0.18, .358],
  0x2E: [.121, 0, .307],
  0x2F: [.716, .215, .778],
  0x30: [.665, .021, .511, {
    ic: .051
  }],
  0x31: [.666, 0, .511],
  0x32: [.666, .022, .511, {
    ic: .04
  }],
  0x33: [.666, .022, .511, {
    ic: .051
  }],
  0x34: [.666, .194, .511],
  0x35: [.666, .022, .511, {
    ic: .056
  }],
  0x36: [.665, .022, .511, {
    ic: .054
  }],
  0x37: [.666, .022, .511, {
    ic: .123
  }],
  0x38: [.666, .021, .511, {
    ic: .042
  }],
  0x39: [.666, .022, .511, {
    ic: .042
  }],
  0x3A: [.431, 0, .307],
  0x3B: [.431, .194, .307],
  0x3D: [.367, -0.133, .767],
  0x3F: [.716, 0, .511, {
    ic: .04
  }],
  0x40: [.705, .011, .767, {
    ic: .022
  }],
  0x5B: [.75, .25, .307, {
    ic: .139
  }],
  0x5D: [.75, .25, .307, {
    ic: .052
  }],
  0x5E: [.694, -0.527, .511, {
    ic: .017
  }],
  0x5F: [-0.025, .062, .511, {
    ic: .043
  }],
  0x7E: [.318, -0.208, .511, {
    ic: .06
  }],
  0x131: [.441, .01, .307, {
    ic: .033
  }],
  0x237: [.442, .204, .332],
  0x300: [.697, -0.5, 0],
  0x301: [.697, -0.5, 0, {
    ic: .039
  }],
  0x302: [.694, -0.527, 0, {
    ic: .017
  }],
  0x303: [.668, -0.558, 0, {
    ic: .06
  }],
  0x304: [.589, -0.544, 0, {
    ic: .054
  }],
  0x306: [.694, -0.515, 0, {
    ic: .062
  }],
  0x307: [.669, -0.548, 0],
  0x308: [.669, -0.554, 0, {
    ic: .045
  }],
  0x30A: [.716, -0.542, 0],
  0x30B: [.697, -0.503, 0, {
    ic: .065
  }],
  0x30C: [.638, -0.502, 0, {
    ic: .029
  }],
  0x3DD: [.605, .085, .778],
  0x2013: [.285, -0.248, .511, {
    ic: .043
  }],
  0x2014: [.285, -0.248, 1.022, {
    ic: .016
  }],
  0x2015: [.285, -0.248, 1.022, {
    ic: .016
  }],
  0x2017: [-0.025, .062, .511, {
    ic: .043
  }],
  0x2018: [.694, -0.379, .307, {
    ic: .055
  }],
  0x2019: [.694, -0.379, .307, {
    ic: .07
  }],
  0x201C: [.694, -0.379, .514, {
    ic: .092
  }],
  0x201D: [.694, -0.379, .514, {
    ic: .024
  }],
  0x2044: [.716, .215, .778],
  0x210F: [.695, .013, .54, {
    ic: .022
  }],
  0x2206: [.716, 0, .833, {
    sk: .167
  }],
  0x29F8: [.716, .215, .778]
};

Object.defineProperty(italic$1, "__esModule", {
  value: true
});
italic$1.italic = void 0;
var FontData_js_1$d = FontData;
var italic_js_1$1 = italic;
italic$1.italic = (0, FontData_js_1$d.AddCSS)(italic_js_1$1.italic, {
  0x2F: {
    f: 'I'
  },
  0x3DD: {
    c: '\\E008',
    f: 'A'
  },
  0x2015: {
    c: '\\2014'
  },
  0x2017: {
    c: '_'
  },
  0x2044: {
    c: '/',
    f: 'I'
  },
  0x2206: {
    c: '\\394',
    f: 'I'
  },
  0x29F8: {
    c: '/',
    f: 'I'
  }
});

var largeop$1 = {};

var largeop = {};

Object.defineProperty(largeop, "__esModule", {
  value: true
});
largeop.largeop = void 0;
largeop.largeop = {
  0x28: [1.15, .649, .597],
  0x29: [1.15, .649, .597],
  0x2F: [1.15, .649, .811],
  0x5B: [1.15, .649, .472],
  0x5C: [1.15, .649, .811],
  0x5D: [1.15, .649, .472],
  0x7B: [1.15, .649, .667],
  0x7D: [1.15, .649, .667],
  0x2C6: [.772, -0.565, 1],
  0x2DC: [.75, -0.611, 1],
  0x302: [.772, -0.565, 0],
  0x303: [.75, -0.611, 0],
  0x2016: [.602, 0, .778],
  0x2044: [1.15, .649, .811],
  0x2191: [.6, 0, .667],
  0x2193: [.6, 0, .667],
  0x21D1: [.599, 0, .778],
  0x21D3: [.6, 0, .778],
  0x220F: [.95, .45, 1.278],
  0x2210: [.95, .45, 1.278],
  0x2211: [.95, .45, 1.444],
  0x221A: [1.15, .65, 1, {
    ic: .02
  }],
  0x2223: [.627, .015, .333],
  0x2225: [.627, .015, .556],
  0x222B: [1.36, .862, .556, {
    ic: .388
  }],
  0x222C: [1.36, .862, 1.084, {
    ic: .388
  }],
  0x222D: [1.36, .862, 1.592, {
    ic: .388
  }],
  0x222E: [1.36, .862, .556, {
    ic: .388
  }],
  0x22C0: [.95, .45, 1.111],
  0x22C1: [.95, .45, 1.111],
  0x22C2: [.949, .45, 1.111],
  0x22C3: [.95, .449, 1.111],
  0x2308: [1.15, .649, .528],
  0x2309: [1.15, .649, .528],
  0x230A: [1.15, .649, .528],
  0x230B: [1.15, .649, .528],
  0x2329: [1.15, .649, .611],
  0x232A: [1.15, .649, .611],
  0x23D0: [.602, 0, .667],
  0x2758: [.627, .015, .333],
  0x27E8: [1.15, .649, .611],
  0x27E9: [1.15, .649, .611],
  0x2A00: [.949, .449, 1.511],
  0x2A01: [.949, .449, 1.511],
  0x2A02: [.949, .449, 1.511],
  0x2A04: [.95, .449, 1.111],
  0x2A06: [.95, .45, 1.111],
  0x2A0C: [1.36, .862, 2.168, {
    ic: .388
  }],
  0x3008: [1.15, .649, .611],
  0x3009: [1.15, .649, .611]
};

Object.defineProperty(largeop$1, "__esModule", {
  value: true
});
largeop$1.largeop = void 0;
var FontData_js_1$c = FontData;
var largeop_js_1$1 = largeop;
largeop$1.largeop = (0, FontData_js_1$c.AddCSS)(largeop_js_1$1.largeop, {
  0x2016: {
    f: 'S1'
  },
  0x2044: {
    c: '/'
  },
  0x2191: {
    f: 'S1'
  },
  0x2193: {
    f: 'S1'
  },
  0x21D1: {
    f: 'S1'
  },
  0x21D3: {
    f: 'S1'
  },
  0x2223: {
    f: 'S1'
  },
  0x2225: {
    f: 'S1'
  },
  0x2329: {
    c: '\\27E8'
  },
  0x232A: {
    c: '\\27E9'
  },
  0x23D0: {
    f: 'S1'
  },
  0x2758: {
    c: '\\2223',
    f: 'S1'
  },
  0x2A0C: {
    c: '\\222C\\222C'
  },
  0x3008: {
    c: '\\27E8'
  },
  0x3009: {
    c: '\\27E9'
  }
});

var monospace$1 = {};

var monospace = {};

Object.defineProperty(monospace, "__esModule", {
  value: true
});
monospace.monospace = void 0;
monospace.monospace = {
  0x20: [0, 0, .525],
  0x21: [.622, 0, .525],
  0x22: [.623, -0.333, .525],
  0x23: [.611, 0, .525],
  0x24: [.694, .082, .525],
  0x25: [.694, .083, .525],
  0x26: [.622, .011, .525],
  0x27: [.611, -0.287, .525],
  0x28: [.694, .082, .525],
  0x29: [.694, .082, .525],
  0x2A: [.52, -0.09, .525],
  0x2B: [.531, -0.081, .525],
  0x2C: [.14, .139, .525],
  0x2D: [.341, -0.271, .525],
  0x2E: [.14, 0, .525],
  0x2F: [.694, .083, .525],
  0x3A: [.431, 0, .525],
  0x3B: [.431, .139, .525],
  0x3C: [.557, -0.055, .525],
  0x3D: [.417, -0.195, .525],
  0x3E: [.557, -0.055, .525],
  0x3F: [.617, 0, .525],
  0x40: [.617, .006, .525],
  0x5B: [.694, .082, .525],
  0x5C: [.694, .083, .525],
  0x5D: [.694, .082, .525],
  0x5E: [.611, -0.46, .525],
  0x5F: [-0.025, .095, .525],
  0x60: [.681, -0.357, .525],
  0x7B: [.694, .083, .525],
  0x7C: [.694, .082, .525],
  0x7D: [.694, .083, .525],
  0x7E: [.611, -0.466, .525],
  0x7F: [.612, -0.519, .525],
  0xA0: [0, 0, .525],
  0x131: [.431, 0, .525],
  0x237: [.431, .228, .525],
  0x2B9: [.623, -0.334, .525],
  0x300: [.611, -0.485, 0],
  0x301: [.611, -0.485, 0],
  0x302: [.611, -0.46, 0],
  0x303: [.611, -0.466, 0],
  0x304: [.577, -0.5, 0],
  0x306: [.611, -0.504, 0],
  0x308: [.612, -0.519, 0],
  0x30A: [.619, -0.499, 0],
  0x30C: [.577, -0.449, 0],
  0x391: [.623, 0, .525],
  0x392: [.611, 0, .525],
  0x393: [.611, 0, .525],
  0x394: [.623, 0, .525],
  0x395: [.611, 0, .525],
  0x396: [.611, 0, .525],
  0x397: [.611, 0, .525],
  0x398: [.621, .01, .525],
  0x399: [.611, 0, .525],
  0x39A: [.611, 0, .525],
  0x39B: [.623, 0, .525],
  0x39C: [.611, 0, .525],
  0x39D: [.611, 0, .525],
  0x39E: [.611, 0, .525],
  0x39F: [.621, .01, .525],
  0x3A0: [.611, 0, .525],
  0x3A1: [.611, 0, .525],
  0x3A3: [.611, 0, .525],
  0x3A4: [.611, 0, .525],
  0x3A5: [.622, 0, .525],
  0x3A6: [.611, 0, .525],
  0x3A7: [.611, 0, .525],
  0x3A8: [.611, 0, .525],
  0x3A9: [.622, 0, .525],
  0x2017: [-0.025, .095, .525],
  0x2032: [.623, -0.334, .525],
  0x2033: [.623, 0, 1.05],
  0x2034: [.623, 0, 1.575],
  0x2044: [.694, .083, .525],
  0x2057: [.623, 0, 2.1],
  0x2206: [.623, 0, .525]
};

Object.defineProperty(monospace$1, "__esModule", {
  value: true
});
monospace$1.monospace = void 0;
var FontData_js_1$b = FontData;
var monospace_js_1$1 = monospace;
monospace$1.monospace = (0, FontData_js_1$b.AddCSS)(monospace_js_1$1.monospace, {
  0x2B9: {
    c: '\\2032'
  },
  0x391: {
    c: 'A'
  },
  0x392: {
    c: 'B'
  },
  0x395: {
    c: 'E'
  },
  0x396: {
    c: 'Z'
  },
  0x397: {
    c: 'H'
  },
  0x399: {
    c: 'I'
  },
  0x39A: {
    c: 'K'
  },
  0x39C: {
    c: 'M'
  },
  0x39D: {
    c: 'N'
  },
  0x39F: {
    c: 'O'
  },
  0x3A1: {
    c: 'P'
  },
  0x3A4: {
    c: 'T'
  },
  0x3A7: {
    c: 'X'
  },
  0x2017: {
    c: '_'
  },
  0x2033: {
    c: '\\2032\\2032'
  },
  0x2034: {
    c: '\\2032\\2032\\2032'
  },
  0x2044: {
    c: '/'
  },
  0x2057: {
    c: '\\2032\\2032\\2032\\2032'
  },
  0x2206: {
    c: '\\394'
  }
});

var normal$1 = {};

var normal = {};

Object.defineProperty(normal, "__esModule", {
  value: true
});
normal.normal = void 0;
normal.normal = {
  0x20: [0, 0, .25],
  0x21: [.716, 0, .278],
  0x22: [.694, -0.379, .5],
  0x23: [.694, .194, .833],
  0x24: [.75, .056, .5],
  0x25: [.75, .056, .833],
  0x26: [.716, .022, .778],
  0x27: [.694, -0.379, .278],
  0x28: [.75, .25, .389],
  0x29: [.75, .25, .389],
  0x2A: [.75, -0.32, .5],
  0x2B: [.583, .082, .778],
  0x2C: [.121, .194, .278],
  0x2D: [.252, -0.179, .333],
  0x2E: [.12, 0, .278],
  0x2F: [.75, .25, .5],
  0x30: [.666, .022, .5],
  0x31: [.666, 0, .5],
  0x32: [.666, 0, .5],
  0x33: [.665, .022, .5],
  0x34: [.677, 0, .5],
  0x35: [.666, .022, .5],
  0x36: [.666, .022, .5],
  0x37: [.676, .022, .5],
  0x38: [.666, .022, .5],
  0x39: [.666, .022, .5],
  0x3A: [.43, 0, .278],
  0x3B: [.43, .194, .278],
  0x3C: [.54, .04, .778],
  0x3D: [.583, .082, .778],
  0x3E: [.54, .04, .778],
  0x3F: [.705, 0, .472],
  0x40: [.705, .011, .778],
  0x41: [.716, 0, .75],
  0x42: [.683, 0, .708],
  0x43: [.705, .021, .722],
  0x44: [.683, 0, .764],
  0x45: [.68, 0, .681],
  0x46: [.68, 0, .653],
  0x47: [.705, .022, .785],
  0x48: [.683, 0, .75],
  0x49: [.683, 0, .361],
  0x4A: [.683, .022, .514],
  0x4B: [.683, 0, .778],
  0x4C: [.683, 0, .625],
  0x4D: [.683, 0, .917],
  0x4E: [.683, 0, .75],
  0x4F: [.705, .022, .778],
  0x50: [.683, 0, .681],
  0x51: [.705, .193, .778],
  0x52: [.683, .022, .736],
  0x53: [.705, .022, .556],
  0x54: [.677, 0, .722],
  0x55: [.683, .022, .75],
  0x56: [.683, .022, .75],
  0x57: [.683, .022, 1.028],
  0x58: [.683, 0, .75],
  0x59: [.683, 0, .75],
  0x5A: [.683, 0, .611],
  0x5B: [.75, .25, .278],
  0x5C: [.75, .25, .5],
  0x5D: [.75, .25, .278],
  0x5E: [.694, -0.531, .5],
  0x5F: [-0.025, .062, .5],
  0x60: [.699, -0.505, .5],
  0x61: [.448, .011, .5],
  0x62: [.694, .011, .556],
  0x63: [.448, .011, .444],
  0x64: [.694, .011, .556],
  0x65: [.448, .011, .444],
  0x66: [.705, 0, .306, {
    ic: .066
  }],
  0x67: [.453, .206, .5],
  0x68: [.694, 0, .556],
  0x69: [.669, 0, .278],
  0x6A: [.669, .205, .306],
  0x6B: [.694, 0, .528],
  0x6C: [.694, 0, .278],
  0x6D: [.442, 0, .833],
  0x6E: [.442, 0, .556],
  0x6F: [.448, .01, .5],
  0x70: [.442, .194, .556],
  0x71: [.442, .194, .528],
  0x72: [.442, 0, .392],
  0x73: [.448, .011, .394],
  0x74: [.615, .01, .389],
  0x75: [.442, .011, .556],
  0x76: [.431, .011, .528],
  0x77: [.431, .011, .722],
  0x78: [.431, 0, .528],
  0x79: [.431, .204, .528],
  0x7A: [.431, 0, .444],
  0x7B: [.75, .25, .5],
  0x7C: [.75, .249, .278],
  0x7D: [.75, .25, .5],
  0x7E: [.318, -0.215, .5],
  0xA0: [0, 0, .25],
  0xA3: [.714, .011, .769],
  0xA5: [.683, 0, .75],
  0xA8: [.669, -0.554, .5],
  0xAC: [.356, -0.089, .667],
  0xAE: [.709, .175, .947],
  0xAF: [.59, -0.544, .5],
  0xB0: [.715, -0.542, .5],
  0xB1: [.666, 0, .778],
  0xB4: [.699, -0.505, .5],
  0xB7: [.31, -0.19, .278],
  0xD7: [.491, -0.009, .778],
  0xF0: [.749, .021, .556],
  0xF7: [.537, .036, .778],
  0x131: [.442, 0, .278, {
    sk: .0278
  }],
  0x237: [.442, .205, .306, {
    sk: .0833
  }],
  0x2B9: [.56, -0.043, .275],
  0x2C6: [.694, -0.531, .5],
  0x2C7: [.644, -0.513, .5],
  0x2C9: [.59, -0.544, .5],
  0x2CA: [.699, -0.505, .5],
  0x2CB: [.699, -0.505, .5],
  0x2D8: [.694, -0.515, .5],
  0x2D9: [.669, -0.549, .5],
  0x2DA: [.715, -0.542, .5],
  0x2DC: [.668, -0.565, .5],
  0x300: [.699, -0.505, 0],
  0x301: [.699, -0.505, 0],
  0x302: [.694, -0.531, 0],
  0x303: [.668, -0.565, 0],
  0x304: [.59, -0.544, 0],
  0x306: [.694, -0.515, 0],
  0x307: [.669, -0.549, 0],
  0x308: [.669, -0.554, 0],
  0x30A: [.715, -0.542, 0],
  0x30B: [.701, -0.51, 0],
  0x30C: [.644, -0.513, 0],
  0x338: [.716, .215, 0],
  0x391: [.716, 0, .75],
  0x392: [.683, 0, .708],
  0x393: [.68, 0, .625],
  0x394: [.716, 0, .833],
  0x395: [.68, 0, .681],
  0x396: [.683, 0, .611],
  0x397: [.683, 0, .75],
  0x398: [.705, .022, .778],
  0x399: [.683, 0, .361],
  0x39A: [.683, 0, .778],
  0x39B: [.716, 0, .694],
  0x39C: [.683, 0, .917],
  0x39D: [.683, 0, .75],
  0x39E: [.677, 0, .667],
  0x39F: [.705, .022, .778],
  0x3A0: [.68, 0, .75],
  0x3A1: [.683, 0, .681],
  0x3A3: [.683, 0, .722],
  0x3A4: [.677, 0, .722],
  0x3A5: [.705, 0, .778],
  0x3A6: [.683, 0, .722],
  0x3A7: [.683, 0, .75],
  0x3A8: [.683, 0, .778],
  0x3A9: [.704, 0, .722],
  0x2000: [0, 0, .5],
  0x2001: [0, 0, 1],
  0x2002: [0, 0, .5],
  0x2003: [0, 0, 1],
  0x2004: [0, 0, .333],
  0x2005: [0, 0, .25],
  0x2006: [0, 0, .167],
  0x2009: [0, 0, .167],
  0x200A: [0, 0, .1],
  0x200B: [0, 0, 0],
  0x200C: [0, 0, 0],
  0x2013: [.285, -0.248, .5],
  0x2014: [.285, -0.248, 1],
  0x2015: [.285, -0.248, 1],
  0x2016: [.75, .25, .5],
  0x2017: [-0.025, .062, .5],
  0x2018: [.694, -0.379, .278],
  0x2019: [.694, -0.379, .278],
  0x201C: [.694, -0.379, .5],
  0x201D: [.694, -0.379, .5],
  0x2020: [.705, .216, .444],
  0x2021: [.705, .205, .444],
  0x2022: [.444, -0.055, .5],
  0x2026: [.12, 0, 1.172],
  0x2032: [.56, -0.043, .275],
  0x2033: [.56, 0, .55],
  0x2034: [.56, 0, .825],
  0x2035: [.56, -0.043, .275],
  0x2036: [.56, 0, .55],
  0x2037: [.56, 0, .825],
  0x203E: [.59, -0.544, .5],
  0x2044: [.75, .25, .5],
  0x2057: [.56, 0, 1.1],
  0x2060: [0, 0, 0],
  0x2061: [0, 0, 0],
  0x2062: [0, 0, 0],
  0x2063: [0, 0, 0],
  0x2064: [0, 0, 0],
  0x20D7: [.714, -0.516, .5],
  0x2102: [.702, .019, .722],
  0x210B: [.717, .036, .969, {
    ic: .272,
    sk: .333
  }],
  0x210C: [.666, .133, .72],
  0x210D: [.683, 0, .778],
  0x210E: [.694, .011, .576, {
    sk: -0.0278
  }],
  0x210F: [.695, .013, .54, {
    ic: .022
  }],
  0x2110: [.717, .017, .809, {
    ic: .137,
    sk: .333
  }],
  0x2111: [.686, .026, .554],
  0x2112: [.717, .017, .874, {
    ic: .161,
    sk: .306
  }],
  0x2113: [.705, .02, .417, {
    sk: .111
  }],
  0x2115: [.683, .02, .722],
  0x2118: [.453, .216, .636, {
    sk: .111
  }],
  0x2119: [.683, 0, .611],
  0x211A: [.701, .181, .778],
  0x211B: [.717, .017, .85, {
    ic: .037,
    sk: .194
  }],
  0x211C: [.686, .026, .828],
  0x211D: [.683, 0, .722],
  0x2124: [.683, 0, .667],
  0x2126: [.704, 0, .722],
  0x2127: [.684, .022, .722],
  0x2128: [.729, .139, .602],
  0x212C: [.708, .028, .908, {
    ic: .02,
    sk: .194
  }],
  0x212D: [.685, .024, .613],
  0x2130: [.707, .008, .562, {
    ic: .156,
    sk: .139
  }],
  0x2131: [.735, .036, .895, {
    ic: .095,
    sk: .222
  }],
  0x2132: [.695, 0, .556],
  0x2133: [.721, .05, 1.08, {
    ic: .136,
    sk: .444
  }],
  0x2135: [.694, 0, .611],
  0x2136: [.763, .021, .667, {
    ic: .02
  }],
  0x2137: [.764, .043, .444],
  0x2138: [.764, .043, .667],
  0x2141: [.705, .023, .639],
  0x2190: [.511, .011, 1],
  0x2191: [.694, .193, .5],
  0x2192: [.511, .011, 1],
  0x2193: [.694, .194, .5],
  0x2194: [.511, .011, 1],
  0x2195: [.772, .272, .5],
  0x2196: [.72, .195, 1],
  0x2197: [.72, .195, 1],
  0x2198: [.695, .22, 1],
  0x2199: [.695, .22, 1],
  0x219A: [.437, -0.06, 1],
  0x219B: [.437, -0.06, 1],
  0x219E: [.417, -0.083, 1],
  0x21A0: [.417, -0.083, 1],
  0x21A2: [.417, -0.083, 1.111],
  0x21A3: [.417, -0.083, 1.111],
  0x21A6: [.511, .011, 1],
  0x21A9: [.511, .011, 1.126],
  0x21AA: [.511, .011, 1.126],
  0x21AB: [.575, .041, 1],
  0x21AC: [.575, .041, 1],
  0x21AD: [.417, -0.083, 1.389],
  0x21AE: [.437, -0.06, 1],
  0x21B0: [.722, 0, .5],
  0x21B1: [.722, 0, .5],
  0x21B6: [.461, 0, 1],
  0x21B7: [.46, 0, 1],
  0x21BA: [.65, .083, .778],
  0x21BB: [.65, .083, .778],
  0x21BC: [.511, -0.23, 1],
  0x21BD: [.27, .011, 1],
  0x21BE: [.694, .194, .417],
  0x21BF: [.694, .194, .417],
  0x21C0: [.511, -0.23, 1],
  0x21C1: [.27, .011, 1],
  0x21C2: [.694, .194, .417],
  0x21C3: [.694, .194, .417],
  0x21C4: [.667, 0, 1],
  0x21C6: [.667, 0, 1],
  0x21C7: [.583, .083, 1],
  0x21C8: [.694, .193, .833],
  0x21C9: [.583, .083, 1],
  0x21CA: [.694, .194, .833],
  0x21CB: [.514, .014, 1],
  0x21CC: [.671, .011, 1],
  0x21CD: [.534, .035, 1],
  0x21CE: [.534, .037, 1],
  0x21CF: [.534, .035, 1],
  0x21D0: [.525, .024, 1],
  0x21D1: [.694, .194, .611],
  0x21D2: [.525, .024, 1],
  0x21D3: [.694, .194, .611],
  0x21D4: [.526, .025, 1],
  0x21D5: [.772, .272, .611],
  0x21DA: [.611, .111, 1],
  0x21DB: [.611, .111, 1],
  0x21DD: [.417, -0.083, 1],
  0x21E0: [.437, -0.064, 1.334],
  0x21E2: [.437, -0.064, 1.334],
  0x2200: [.694, .022, .556],
  0x2201: [.846, .021, .5],
  0x2202: [.715, .022, .531, {
    ic: .035,
    sk: .0833
  }],
  0x2203: [.694, 0, .556],
  0x2204: [.716, .215, .556],
  0x2205: [.772, .078, .5],
  0x2206: [.716, 0, .833],
  0x2207: [.683, .033, .833],
  0x2208: [.54, .04, .667],
  0x2209: [.716, .215, .667],
  0x220B: [.54, .04, .667],
  0x220C: [.716, .215, .667],
  0x220D: [.44, 0, .429, {
    ic: .027
  }],
  0x220F: [.75, .25, .944],
  0x2210: [.75, .25, .944],
  0x2211: [.75, .25, 1.056],
  0x2212: [.583, .082, .778],
  0x2213: [.5, .166, .778],
  0x2214: [.766, .093, .778],
  0x2215: [.75, .25, .5],
  0x2216: [.75, .25, .5],
  0x2217: [.465, -0.035, .5],
  0x2218: [.444, -0.055, .5],
  0x2219: [.444, -0.055, .5],
  0x221A: [.8, .2, .833, {
    ic: .02
  }],
  0x221D: [.442, .011, .778],
  0x221E: [.442, .011, 1],
  0x2220: [.694, 0, .722],
  0x2221: [.714, .02, .722],
  0x2222: [.551, .051, .722],
  0x2223: [.75, .249, .278],
  0x2224: [.75, .252, .278, {
    ic: .019
  }],
  0x2225: [.75, .25, .5],
  0x2226: [.75, .25, .5, {
    ic: .018
  }],
  0x2227: [.598, .022, .667],
  0x2228: [.598, .022, .667],
  0x2229: [.598, .022, .667],
  0x222A: [.598, .022, .667],
  0x222B: [.716, .216, .417, {
    ic: .055
  }],
  0x222C: [.805, .306, .819, {
    ic: .138
  }],
  0x222D: [.805, .306, 1.166, {
    ic: .138
  }],
  0x222E: [.805, .306, .472, {
    ic: .138
  }],
  0x2234: [.471, .082, .667],
  0x2235: [.471, .082, .667],
  0x223C: [.367, -0.133, .778],
  0x223D: [.367, -0.133, .778],
  0x2240: [.583, .083, .278],
  0x2241: [.467, -0.032, .778],
  0x2242: [.463, -0.034, .778],
  0x2243: [.464, -0.036, .778],
  0x2244: [.716, .215, .778],
  0x2245: [.589, -0.022, .778],
  0x2247: [.652, .155, .778],
  0x2248: [.483, -0.055, .778],
  0x2249: [.716, .215, .778],
  0x224A: [.579, .039, .778],
  0x224D: [.484, -0.016, .778],
  0x224E: [.492, -0.008, .778],
  0x224F: [.492, -0.133, .778],
  0x2250: [.67, -0.133, .778],
  0x2251: [.609, .108, .778],
  0x2252: [.601, .101, .778],
  0x2253: [.601, .102, .778],
  0x2256: [.367, -0.133, .778],
  0x2257: [.721, -0.133, .778],
  0x225C: [.859, -0.133, .778],
  0x2260: [.716, .215, .778],
  0x2261: [.464, -0.036, .778],
  0x2262: [.716, .215, .778],
  0x2264: [.636, .138, .778],
  0x2265: [.636, .138, .778],
  0x2266: [.753, .175, .778],
  0x2267: [.753, .175, .778],
  0x2268: [.752, .286, .778],
  0x2269: [.752, .286, .778],
  0x226A: [.568, .067, 1],
  0x226B: [.567, .067, 1],
  0x226C: [.75, .25, .5],
  0x226D: [.716, .215, .778],
  0x226E: [.708, .209, .778],
  0x226F: [.708, .209, .778],
  0x2270: [.801, .303, .778],
  0x2271: [.801, .303, .778],
  0x2272: [.732, .228, .778],
  0x2273: [.732, .228, .778],
  0x2274: [.732, .228, .778],
  0x2275: [.732, .228, .778],
  0x2276: [.681, .253, .778],
  0x2277: [.681, .253, .778],
  0x2278: [.716, .253, .778],
  0x2279: [.716, .253, .778],
  0x227A: [.539, .041, .778],
  0x227B: [.539, .041, .778],
  0x227C: [.58, .153, .778],
  0x227D: [.58, .154, .778],
  0x227E: [.732, .228, .778],
  0x227F: [.732, .228, .778],
  0x2280: [.705, .208, .778],
  0x2281: [.705, .208, .778],
  0x2282: [.54, .04, .778],
  0x2283: [.54, .04, .778],
  0x2284: [.716, .215, .778],
  0x2285: [.716, .215, .778],
  0x2286: [.636, .138, .778],
  0x2287: [.636, .138, .778],
  0x2288: [.801, .303, .778],
  0x2289: [.801, .303, .778],
  0x228A: [.635, .241, .778],
  0x228B: [.635, .241, .778],
  0x228E: [.598, .022, .667],
  0x228F: [.539, .041, .778],
  0x2290: [.539, .041, .778],
  0x2291: [.636, .138, .778],
  0x2292: [.636, .138, .778],
  0x2293: [.598, 0, .667],
  0x2294: [.598, 0, .667],
  0x2295: [.583, .083, .778],
  0x2296: [.583, .083, .778],
  0x2297: [.583, .083, .778],
  0x2298: [.583, .083, .778],
  0x2299: [.583, .083, .778],
  0x229A: [.582, .082, .778],
  0x229B: [.582, .082, .778],
  0x229D: [.582, .082, .778],
  0x229E: [.689, 0, .778],
  0x229F: [.689, 0, .778],
  0x22A0: [.689, 0, .778],
  0x22A1: [.689, 0, .778],
  0x22A2: [.694, 0, .611],
  0x22A3: [.694, 0, .611],
  0x22A4: [.668, 0, .778],
  0x22A5: [.668, 0, .778],
  0x22A8: [.75, .249, .867],
  0x22A9: [.694, 0, .722],
  0x22AA: [.694, 0, .889],
  0x22AC: [.695, 0, .611],
  0x22AD: [.695, 0, .611],
  0x22AE: [.695, 0, .722],
  0x22AF: [.695, 0, .722],
  0x22B2: [.539, .041, .778],
  0x22B3: [.539, .041, .778],
  0x22B4: [.636, .138, .778],
  0x22B5: [.636, .138, .778],
  0x22B8: [.408, -0.092, 1.111],
  0x22BA: [.431, .212, .556],
  0x22BB: [.716, 0, .611],
  0x22BC: [.716, 0, .611],
  0x22C0: [.75, .249, .833],
  0x22C1: [.75, .249, .833],
  0x22C2: [.75, .249, .833],
  0x22C3: [.75, .249, .833],
  0x22C4: [.488, -0.012, .5],
  0x22C5: [.31, -0.19, .278],
  0x22C6: [.486, -0.016, .5],
  0x22C7: [.545, .044, .778],
  0x22C8: [.505, .005, .9],
  0x22C9: [.492, -0.008, .778],
  0x22CA: [.492, -0.008, .778],
  0x22CB: [.694, .022, .778],
  0x22CC: [.694, .022, .778],
  0x22CD: [.464, -0.036, .778],
  0x22CE: [.578, .021, .76],
  0x22CF: [.578, .022, .76],
  0x22D0: [.54, .04, .778],
  0x22D1: [.54, .04, .778],
  0x22D2: [.598, .022, .667],
  0x22D3: [.598, .022, .667],
  0x22D4: [.736, .022, .667],
  0x22D6: [.541, .041, .778],
  0x22D7: [.541, .041, .778],
  0x22D8: [.568, .067, 1.333],
  0x22D9: [.568, .067, 1.333],
  0x22DA: [.886, .386, .778],
  0x22DB: [.886, .386, .778],
  0x22DE: [.734, 0, .778],
  0x22DF: [.734, 0, .778],
  0x22E0: [.801, .303, .778],
  0x22E1: [.801, .303, .778],
  0x22E2: [.716, .215, .778],
  0x22E3: [.716, .215, .778],
  0x22E6: [.73, .359, .778],
  0x22E7: [.73, .359, .778],
  0x22E8: [.73, .359, .778],
  0x22E9: [.73, .359, .778],
  0x22EA: [.706, .208, .778],
  0x22EB: [.706, .208, .778],
  0x22EC: [.802, .303, .778],
  0x22ED: [.801, .303, .778],
  0x22EE: [1.3, .03, .278],
  0x22EF: [.31, -0.19, 1.172],
  0x22F1: [1.52, -0.1, 1.282],
  0x2305: [.716, 0, .611],
  0x2306: [.813, .097, .611],
  0x2308: [.75, .25, .444],
  0x2309: [.75, .25, .444],
  0x230A: [.75, .25, .444],
  0x230B: [.75, .25, .444],
  0x231C: [.694, -0.306, .5],
  0x231D: [.694, -0.306, .5],
  0x231E: [.366, .022, .5],
  0x231F: [.366, .022, .5],
  0x2322: [.388, -0.122, 1],
  0x2323: [.378, -0.134, 1],
  0x2329: [.75, .25, .389],
  0x232A: [.75, .25, .389],
  0x23B0: [.744, .244, .412],
  0x23B1: [.744, .244, .412],
  0x23D0: [.602, 0, .667],
  0x24C8: [.709, .175, .902],
  0x250C: [.694, -0.306, .5],
  0x2510: [.694, -0.306, .5],
  0x2514: [.366, .022, .5],
  0x2518: [.366, .022, .5],
  0x2571: [.694, .195, .889],
  0x2572: [.694, .195, .889],
  0x25A0: [.689, 0, .778],
  0x25A1: [.689, 0, .778],
  0x25AA: [.689, 0, .778],
  0x25B2: [.575, .02, .722],
  0x25B3: [.716, 0, .889],
  0x25B4: [.575, .02, .722],
  0x25B5: [.716, 0, .889],
  0x25B6: [.539, .041, .778],
  0x25B8: [.539, .041, .778],
  0x25B9: [.505, .005, .5],
  0x25BC: [.576, .019, .722],
  0x25BD: [.5, .215, .889],
  0x25BE: [.576, .019, .722],
  0x25BF: [.5, .215, .889],
  0x25C0: [.539, .041, .778],
  0x25C2: [.539, .041, .778],
  0x25C3: [.505, .005, .5],
  0x25CA: [.716, .132, .667],
  0x25EF: [.715, .215, 1],
  0x25FB: [.689, 0, .778],
  0x25FC: [.689, 0, .778],
  0x2605: [.694, .111, .944],
  0x2660: [.727, .13, .778],
  0x2661: [.716, .033, .778],
  0x2662: [.727, .162, .778],
  0x2663: [.726, .13, .778],
  0x266D: [.75, .022, .389],
  0x266E: [.734, .223, .389],
  0x266F: [.723, .223, .389],
  0x2713: [.706, .034, .833],
  0x2720: [.716, .022, .833],
  0x2758: [.75, .249, .278],
  0x27E8: [.75, .25, .389],
  0x27E9: [.75, .25, .389],
  0x27EE: [.744, .244, .412],
  0x27EF: [.744, .244, .412],
  0x27F5: [.511, .011, 1.609],
  0x27F6: [.511, .011, 1.638],
  0x27F7: [.511, .011, 1.859],
  0x27F8: [.525, .024, 1.609],
  0x27F9: [.525, .024, 1.638],
  0x27FA: [.525, .024, 1.858],
  0x27FC: [.511, .011, 1.638],
  0x29EB: [.716, .132, .667],
  0x29F8: [.716, .215, .778],
  0x2A00: [.75, .25, 1.111],
  0x2A01: [.75, .25, 1.111],
  0x2A02: [.75, .25, 1.111],
  0x2A04: [.75, .249, .833],
  0x2A06: [.75, .249, .833],
  0x2A0C: [.805, .306, 1.638, {
    ic: .138
  }],
  0x2A2F: [.491, -0.009, .778],
  0x2A3F: [.683, 0, .75],
  0x2A5E: [.813, .097, .611],
  0x2A7D: [.636, .138, .778],
  0x2A7E: [.636, .138, .778],
  0x2A85: [.762, .29, .778],
  0x2A86: [.762, .29, .778],
  0x2A87: [.635, .241, .778],
  0x2A88: [.635, .241, .778],
  0x2A89: [.761, .387, .778],
  0x2A8A: [.761, .387, .778],
  0x2A8B: [1.003, .463, .778],
  0x2A8C: [1.003, .463, .778],
  0x2A95: [.636, .138, .778],
  0x2A96: [.636, .138, .778],
  0x2AAF: [.636, .138, .778],
  0x2AB0: [.636, .138, .778],
  0x2AB5: [.752, .286, .778],
  0x2AB6: [.752, .286, .778],
  0x2AB7: [.761, .294, .778],
  0x2AB8: [.761, .294, .778],
  0x2AB9: [.761, .337, .778],
  0x2ABA: [.761, .337, .778],
  0x2AC5: [.753, .215, .778],
  0x2AC6: [.753, .215, .778],
  0x2ACB: [.783, .385, .778],
  0x2ACC: [.783, .385, .778],
  0x3008: [.75, .25, .389],
  0x3009: [.75, .25, .389],
  0xE006: [.43, .023, .222, {
    ic: .018
  }],
  0xE007: [.431, .024, .389, {
    ic: .018
  }],
  0xE008: [.605, .085, .778],
  0xE009: [.434, .006, .667, {
    ic: .067
  }],
  0xE00C: [.752, .284, .778],
  0xE00D: [.752, .284, .778],
  0xE00E: [.919, .421, .778],
  0xE00F: [.801, .303, .778],
  0xE010: [.801, .303, .778],
  0xE011: [.919, .421, .778],
  0xE016: [.828, .33, .778],
  0xE017: [.752, .332, .778],
  0xE018: [.828, .33, .778],
  0xE019: [.752, .333, .778],
  0xE01A: [.634, .255, .778],
  0xE01B: [.634, .254, .778],
  0x1D400: [.698, 0, .869],
  0x1D401: [.686, 0, .818],
  0x1D402: [.697, .011, .831],
  0x1D403: [.686, 0, .882],
  0x1D404: [.68, 0, .756],
  0x1D405: [.68, 0, .724],
  0x1D406: [.697, .01, .904],
  0x1D407: [.686, 0, .9],
  0x1D408: [.686, 0, .436],
  0x1D409: [.686, .011, .594],
  0x1D40A: [.686, 0, .901],
  0x1D40B: [.686, 0, .692],
  0x1D40C: [.686, 0, 1.092],
  0x1D40D: [.686, 0, .9],
  0x1D40E: [.696, .01, .864],
  0x1D40F: [.686, 0, .786],
  0x1D410: [.696, .193, .864],
  0x1D411: [.686, .011, .862],
  0x1D412: [.697, .011, .639],
  0x1D413: [.675, 0, .8],
  0x1D414: [.686, .011, .885],
  0x1D415: [.686, .007, .869],
  0x1D416: [.686, .007, 1.189],
  0x1D417: [.686, 0, .869],
  0x1D418: [.686, 0, .869],
  0x1D419: [.686, 0, .703],
  0x1D41A: [.453, .006, .559],
  0x1D41B: [.694, .006, .639],
  0x1D41C: [.453, .006, .511],
  0x1D41D: [.694, .006, .639],
  0x1D41E: [.452, .006, .527],
  0x1D41F: [.7, 0, .351, {
    ic: .101
  }],
  0x1D420: [.455, .201, .575],
  0x1D421: [.694, 0, .639],
  0x1D422: [.695, 0, .319],
  0x1D423: [.695, .2, .351],
  0x1D424: [.694, 0, .607],
  0x1D425: [.694, 0, .319],
  0x1D426: [.45, 0, .958],
  0x1D427: [.45, 0, .639],
  0x1D428: [.452, .005, .575],
  0x1D429: [.45, .194, .639],
  0x1D42A: [.45, .194, .607],
  0x1D42B: [.45, 0, .474],
  0x1D42C: [.453, .006, .454],
  0x1D42D: [.635, .005, .447],
  0x1D42E: [.45, .006, .639],
  0x1D42F: [.444, 0, .607],
  0x1D430: [.444, 0, .831],
  0x1D431: [.444, 0, .607],
  0x1D432: [.444, .2, .607],
  0x1D433: [.444, 0, .511],
  0x1D434: [.716, 0, .75, {
    sk: .139
  }],
  0x1D435: [.683, 0, .759, {
    sk: .0833
  }],
  0x1D436: [.705, .022, .715, {
    ic: .045,
    sk: .0833
  }],
  0x1D437: [.683, 0, .828, {
    sk: .0556
  }],
  0x1D438: [.68, 0, .738, {
    ic: .026,
    sk: .0833
  }],
  0x1D439: [.68, 0, .643, {
    ic: .106,
    sk: .0833
  }],
  0x1D43A: [.705, .022, .786, {
    sk: .0833
  }],
  0x1D43B: [.683, 0, .831, {
    ic: .057,
    sk: .0556
  }],
  0x1D43C: [.683, 0, .44, {
    ic: .064,
    sk: .111
  }],
  0x1D43D: [.683, .022, .555, {
    ic: .078,
    sk: .167
  }],
  0x1D43E: [.683, 0, .849, {
    ic: .04,
    sk: .0556
  }],
  0x1D43F: [.683, 0, .681, {
    sk: .0278
  }],
  0x1D440: [.683, 0, .97, {
    ic: .081,
    sk: .0833
  }],
  0x1D441: [.683, 0, .803, {
    ic: .085,
    sk: .0833
  }],
  0x1D442: [.704, .022, .763, {
    sk: .0833
  }],
  0x1D443: [.683, 0, .642, {
    ic: .109,
    sk: .0833
  }],
  0x1D444: [.704, .194, .791, {
    sk: .0833
  }],
  0x1D445: [.683, .021, .759, {
    sk: .0833
  }],
  0x1D446: [.705, .022, .613, {
    ic: .032,
    sk: .0833
  }],
  0x1D447: [.677, 0, .584, {
    ic: .12,
    sk: .0833
  }],
  0x1D448: [.683, .022, .683, {
    ic: .084,
    sk: .0278
  }],
  0x1D449: [.683, .022, .583, {
    ic: .186
  }],
  0x1D44A: [.683, .022, .944, {
    ic: .104
  }],
  0x1D44B: [.683, 0, .828, {
    ic: .024,
    sk: .0833
  }],
  0x1D44C: [.683, 0, .581, {
    ic: .182
  }],
  0x1D44D: [.683, 0, .683, {
    ic: .04,
    sk: .0833
  }],
  0x1D44E: [.441, .01, .529],
  0x1D44F: [.694, .011, .429],
  0x1D450: [.442, .011, .433, {
    sk: .0556
  }],
  0x1D451: [.694, .01, .52, {
    sk: .167
  }],
  0x1D452: [.442, .011, .466, {
    sk: .0556
  }],
  0x1D453: [.705, .205, .49, {
    ic: .06,
    sk: .167
  }],
  0x1D454: [.442, .205, .477, {
    sk: .0278
  }],
  0x1D456: [.661, .011, .345],
  0x1D457: [.661, .204, .412],
  0x1D458: [.694, .011, .521],
  0x1D459: [.694, .011, .298, {
    sk: .0833
  }],
  0x1D45A: [.442, .011, .878],
  0x1D45B: [.442, .011, .6],
  0x1D45C: [.441, .011, .485, {
    sk: .0556
  }],
  0x1D45D: [.442, .194, .503, {
    sk: .0833
  }],
  0x1D45E: [.442, .194, .446, {
    ic: .014,
    sk: .0833
  }],
  0x1D45F: [.442, .011, .451, {
    sk: .0556
  }],
  0x1D460: [.442, .01, .469, {
    sk: .0556
  }],
  0x1D461: [.626, .011, .361, {
    sk: .0833
  }],
  0x1D462: [.442, .011, .572, {
    sk: .0278
  }],
  0x1D463: [.443, .011, .485, {
    sk: .0278
  }],
  0x1D464: [.443, .011, .716, {
    sk: .0833
  }],
  0x1D465: [.442, .011, .572, {
    sk: .0278
  }],
  0x1D466: [.442, .205, .49, {
    sk: .0556
  }],
  0x1D467: [.442, .011, .465, {
    sk: .0556
  }],
  0x1D468: [.711, 0, .869, {
    sk: .16
  }],
  0x1D469: [.686, 0, .866, {
    sk: .0958
  }],
  0x1D46A: [.703, .017, .817, {
    ic: .038,
    sk: .0958
  }],
  0x1D46B: [.686, 0, .938, {
    sk: .0639
  }],
  0x1D46C: [.68, 0, .81, {
    ic: .015,
    sk: .0958
  }],
  0x1D46D: [.68, 0, .689, {
    ic: .12,
    sk: .0958
  }],
  0x1D46E: [.703, .016, .887, {
    sk: .0958
  }],
  0x1D46F: [.686, 0, .982, {
    ic: .045,
    sk: .0639
  }],
  0x1D470: [.686, 0, .511, {
    ic: .062,
    sk: .128
  }],
  0x1D471: [.686, .017, .631, {
    ic: .063,
    sk: .192
  }],
  0x1D472: [.686, 0, .971, {
    ic: .032,
    sk: .0639
  }],
  0x1D473: [.686, 0, .756, {
    sk: .0319
  }],
  0x1D474: [.686, 0, 1.142, {
    ic: .077,
    sk: .0958
  }],
  0x1D475: [.686, 0, .95, {
    ic: .077,
    sk: .0958
  }],
  0x1D476: [.703, .017, .837, {
    sk: .0958
  }],
  0x1D477: [.686, 0, .723, {
    ic: .124,
    sk: .0958
  }],
  0x1D478: [.703, .194, .869, {
    sk: .0958
  }],
  0x1D479: [.686, .017, .872, {
    sk: .0958
  }],
  0x1D47A: [.703, .017, .693, {
    ic: .021,
    sk: .0958
  }],
  0x1D47B: [.675, 0, .637, {
    ic: .135,
    sk: .0958
  }],
  0x1D47C: [.686, .016, .8, {
    ic: .077,
    sk: .0319
  }],
  0x1D47D: [.686, .016, .678, {
    ic: .208
  }],
  0x1D47E: [.686, .017, 1.093, {
    ic: .114
  }],
  0x1D47F: [.686, 0, .947, {
    sk: .0958
  }],
  0x1D480: [.686, 0, .675, {
    ic: .201
  }],
  0x1D481: [.686, 0, .773, {
    ic: .032,
    sk: .0958
  }],
  0x1D482: [.452, .008, .633],
  0x1D483: [.694, .008, .521],
  0x1D484: [.451, .008, .513, {
    sk: .0639
  }],
  0x1D485: [.694, .008, .61, {
    sk: .192
  }],
  0x1D486: [.452, .008, .554, {
    sk: .0639
  }],
  0x1D487: [.701, .201, .568, {
    ic: .056,
    sk: .192
  }],
  0x1D488: [.452, .202, .545, {
    sk: .0319
  }],
  0x1D489: [.694, .008, .668, {
    sk: -0.0319
  }],
  0x1D48A: [.694, .008, .405],
  0x1D48B: [.694, .202, .471],
  0x1D48C: [.694, .008, .604],
  0x1D48D: [.694, .008, .348, {
    sk: .0958
  }],
  0x1D48E: [.452, .008, 1.032],
  0x1D48F: [.452, .008, .713],
  0x1D490: [.452, .008, .585, {
    sk: .0639
  }],
  0x1D491: [.452, .194, .601, {
    sk: .0958
  }],
  0x1D492: [.452, .194, .542, {
    sk: .0958
  }],
  0x1D493: [.452, .008, .529, {
    sk: .0639
  }],
  0x1D494: [.451, .008, .531, {
    sk: .0639
  }],
  0x1D495: [.643, .007, .415, {
    sk: .0958
  }],
  0x1D496: [.452, .008, .681, {
    sk: .0319
  }],
  0x1D497: [.453, .008, .567, {
    sk: .0319
  }],
  0x1D498: [.453, .008, .831, {
    sk: .0958
  }],
  0x1D499: [.452, .008, .659, {
    sk: .0319
  }],
  0x1D49A: [.452, .202, .59, {
    sk: .0639
  }],
  0x1D49B: [.452, .008, .555, {
    sk: .0639
  }],
  0x1D49C: [.717, .008, .803, {
    ic: .213,
    sk: .389
  }],
  0x1D49E: [.728, .026, .666, {
    ic: .153,
    sk: .278
  }],
  0x1D49F: [.708, .031, .774, {
    ic: .081,
    sk: .111
  }],
  0x1D4A2: [.717, .037, .61, {
    ic: .128,
    sk: .25
  }],
  0x1D4A5: [.717, .314, 1.052, {
    ic: .081,
    sk: .417
  }],
  0x1D4A6: [.717, .037, .914, {
    ic: .29,
    sk: .361
  }],
  0x1D4A9: [.726, .036, .902, {
    ic: .306,
    sk: .389
  }],
  0x1D4AA: [.707, .008, .738, {
    ic: .067,
    sk: .167
  }],
  0x1D4AB: [.716, .037, 1.013, {
    ic: .018,
    sk: .222
  }],
  0x1D4AC: [.717, .017, .883, {
    sk: .278
  }],
  0x1D4AE: [.708, .036, .868, {
    ic: .148,
    sk: .333
  }],
  0x1D4AF: [.735, .037, .747, {
    ic: .249,
    sk: .222
  }],
  0x1D4B0: [.717, .017, .8, {
    ic: .16,
    sk: .25
  }],
  0x1D4B1: [.717, .017, .622, {
    ic: .228,
    sk: .222
  }],
  0x1D4B2: [.717, .017, .805, {
    ic: .221,
    sk: .25
  }],
  0x1D4B3: [.717, .017, .944, {
    ic: .187,
    sk: .278
  }],
  0x1D4B4: [.716, .017, .71, {
    ic: .249,
    sk: .194
  }],
  0x1D4B5: [.717, .016, .821, {
    ic: .211,
    sk: .306
  }],
  0x1D504: [.696, .026, .718],
  0x1D505: [.691, .027, .884],
  0x1D507: [.685, .027, .832],
  0x1D508: [.685, .024, .663],
  0x1D509: [.686, .153, .611],
  0x1D50A: [.69, .026, .785],
  0x1D50D: [.686, .139, .552],
  0x1D50E: [.68, .027, .668, {
    ic: .014
  }],
  0x1D50F: [.686, .026, .666],
  0x1D510: [.692, .027, 1.05],
  0x1D511: [.686, .025, .832],
  0x1D512: [.729, .027, .827],
  0x1D513: [.692, .218, .828],
  0x1D514: [.729, .069, .827],
  0x1D516: [.692, .027, .829],
  0x1D517: [.701, .027, .669],
  0x1D518: [.697, .027, .646, {
    ic: .019
  }],
  0x1D519: [.686, .026, .831],
  0x1D51A: [.686, .027, 1.046],
  0x1D51B: [.688, .027, .719],
  0x1D51C: [.686, .218, .833],
  0x1D51E: [.47, .035, .5],
  0x1D51F: [.685, .031, .513],
  0x1D520: [.466, .029, .389],
  0x1D521: [.609, .033, .499],
  0x1D522: [.467, .03, .401],
  0x1D523: [.681, .221, .326],
  0x1D524: [.47, .209, .504],
  0x1D525: [.688, .205, .521],
  0x1D526: [.673, .02, .279],
  0x1D527: [.672, .208, .281],
  0x1D528: [.689, .025, .389],
  0x1D529: [.685, .02, .28],
  0x1D52A: [.475, .026, .767],
  0x1D52B: [.475, .022, .527],
  0x1D52C: [.48, .028, .489],
  0x1D52D: [.541, .212, .5],
  0x1D52E: [.479, .219, .489],
  0x1D52F: [.474, .021, .389],
  0x1D530: [.478, .029, .443],
  0x1D531: [.64, .02, .333, {
    ic: .015
  }],
  0x1D532: [.474, .023, .517],
  0x1D533: [.53, .028, .512],
  0x1D534: [.532, .028, .774],
  0x1D535: [.472, .188, .389],
  0x1D536: [.528, .218, .499],
  0x1D537: [.471, .214, .391],
  0x1D538: [.701, 0, .722],
  0x1D539: [.683, 0, .667],
  0x1D53B: [.683, 0, .722],
  0x1D53C: [.683, 0, .667],
  0x1D53D: [.683, 0, .611],
  0x1D53E: [.702, .019, .778],
  0x1D540: [.683, 0, .389],
  0x1D541: [.683, .077, .5],
  0x1D542: [.683, 0, .778],
  0x1D543: [.683, 0, .667],
  0x1D544: [.683, 0, .944],
  0x1D546: [.701, .019, .778],
  0x1D54A: [.702, .012, .556],
  0x1D54B: [.683, 0, .667],
  0x1D54C: [.683, .019, .722],
  0x1D54D: [.683, .02, .722],
  0x1D54E: [.683, .019, 1],
  0x1D54F: [.683, 0, .722],
  0x1D550: [.683, 0, .722],
  0x1D56C: [.686, .031, .847],
  0x1D56D: [.684, .031, 1.044],
  0x1D56E: [.676, .032, .723],
  0x1D56F: [.683, .029, .982],
  0x1D570: [.686, .029, .783],
  0x1D571: [.684, .146, .722],
  0x1D572: [.687, .029, .927],
  0x1D573: [.683, .126, .851],
  0x1D574: [.681, .025, .655],
  0x1D575: [.68, .141, .652],
  0x1D576: [.681, .026, .789, {
    ic: .017
  }],
  0x1D577: [.683, .028, .786],
  0x1D578: [.683, .032, 1.239],
  0x1D579: [.679, .03, .983],
  0x1D57A: [.726, .03, .976],
  0x1D57B: [.688, .223, .977],
  0x1D57C: [.726, .083, .976],
  0x1D57D: [.688, .028, .978],
  0x1D57E: [.685, .031, .978],
  0x1D57F: [.686, .03, .79, {
    ic: .012
  }],
  0x1D580: [.688, .039, .851, {
    ic: .02
  }],
  0x1D581: [.685, .029, .982],
  0x1D582: [.683, .03, 1.235],
  0x1D583: [.681, .035, .849],
  0x1D584: [.688, .214, .984],
  0x1D585: [.677, .148, .711],
  0x1D586: [.472, .032, .603],
  0x1D587: [.69, .032, .59],
  0x1D588: [.473, .026, .464],
  0x1D589: [.632, .028, .589],
  0x1D58A: [.471, .027, .472],
  0x1D58B: [.687, .222, .388],
  0x1D58C: [.472, .208, .595],
  0x1D58D: [.687, .207, .615],
  0x1D58E: [.686, .025, .331],
  0x1D58F: [.682, .203, .332],
  0x1D590: [.682, .025, .464],
  0x1D591: [.681, .024, .337],
  0x1D592: [.476, .031, .921],
  0x1D593: [.473, .028, .654],
  0x1D594: [.482, .034, .609],
  0x1D595: [.557, .207, .604],
  0x1D596: [.485, .211, .596],
  0x1D597: [.472, .026, .46],
  0x1D598: [.479, .034, .523],
  0x1D599: [.648, .027, .393, {
    ic: .014
  }],
  0x1D59A: [.472, .032, .589, {
    ic: .014
  }],
  0x1D59B: [.546, .027, .604],
  0x1D59C: [.549, .032, .918],
  0x1D59D: [.471, .188, .459],
  0x1D59E: [.557, .221, .589],
  0x1D59F: [.471, .214, .461],
  0x1D5A0: [.694, 0, .667],
  0x1D5A1: [.694, 0, .667],
  0x1D5A2: [.705, .011, .639],
  0x1D5A3: [.694, 0, .722],
  0x1D5A4: [.691, 0, .597],
  0x1D5A5: [.691, 0, .569],
  0x1D5A6: [.704, .011, .667],
  0x1D5A7: [.694, 0, .708],
  0x1D5A8: [.694, 0, .278],
  0x1D5A9: [.694, .022, .472],
  0x1D5AA: [.694, 0, .694],
  0x1D5AB: [.694, 0, .542],
  0x1D5AC: [.694, 0, .875],
  0x1D5AD: [.694, 0, .708],
  0x1D5AE: [.715, .022, .736],
  0x1D5AF: [.694, 0, .639],
  0x1D5B0: [.715, .125, .736],
  0x1D5B1: [.694, 0, .646],
  0x1D5B2: [.716, .022, .556],
  0x1D5B3: [.688, 0, .681],
  0x1D5B4: [.694, .022, .688],
  0x1D5B5: [.694, 0, .667],
  0x1D5B6: [.694, 0, .944],
  0x1D5B7: [.694, 0, .667],
  0x1D5B8: [.694, 0, .667],
  0x1D5B9: [.694, 0, .611],
  0x1D5BA: [.46, .01, .481],
  0x1D5BB: [.694, .011, .517],
  0x1D5BC: [.46, .01, .444],
  0x1D5BD: [.694, .01, .517],
  0x1D5BE: [.461, .01, .444],
  0x1D5BF: [.705, 0, .306, {
    ic: .041
  }],
  0x1D5C0: [.455, .206, .5],
  0x1D5C1: [.694, 0, .517],
  0x1D5C2: [.68, 0, .239],
  0x1D5C3: [.68, .205, .267],
  0x1D5C4: [.694, 0, .489],
  0x1D5C5: [.694, 0, .239],
  0x1D5C6: [.455, 0, .794],
  0x1D5C7: [.455, 0, .517],
  0x1D5C8: [.46, .01, .5],
  0x1D5C9: [.455, .194, .517],
  0x1D5CA: [.455, .194, .517],
  0x1D5CB: [.455, 0, .342],
  0x1D5CC: [.46, .01, .383],
  0x1D5CD: [.571, .01, .361],
  0x1D5CE: [.444, .01, .517],
  0x1D5CF: [.444, 0, .461],
  0x1D5D0: [.444, 0, .683],
  0x1D5D1: [.444, 0, .461],
  0x1D5D2: [.444, .204, .461],
  0x1D5D3: [.444, 0, .435],
  0x1D5D4: [.694, 0, .733],
  0x1D5D5: [.694, 0, .733],
  0x1D5D6: [.704, .011, .703],
  0x1D5D7: [.694, 0, .794],
  0x1D5D8: [.691, 0, .642],
  0x1D5D9: [.691, 0, .611],
  0x1D5DA: [.705, .011, .733],
  0x1D5DB: [.694, 0, .794],
  0x1D5DC: [.694, 0, .331],
  0x1D5DD: [.694, .022, .519],
  0x1D5DE: [.694, 0, .764],
  0x1D5DF: [.694, 0, .581],
  0x1D5E0: [.694, 0, .978],
  0x1D5E1: [.694, 0, .794],
  0x1D5E2: [.716, .022, .794],
  0x1D5E3: [.694, 0, .703],
  0x1D5E4: [.716, .106, .794],
  0x1D5E5: [.694, 0, .703],
  0x1D5E6: [.716, .022, .611],
  0x1D5E7: [.688, 0, .733],
  0x1D5E8: [.694, .022, .764],
  0x1D5E9: [.694, 0, .733],
  0x1D5EA: [.694, 0, 1.039],
  0x1D5EB: [.694, 0, .733],
  0x1D5EC: [.694, 0, .733],
  0x1D5ED: [.694, 0, .672],
  0x1D5EE: [.475, .011, .525],
  0x1D5EF: [.694, .01, .561],
  0x1D5F0: [.475, .011, .489],
  0x1D5F1: [.694, .011, .561],
  0x1D5F2: [.474, .01, .511],
  0x1D5F3: [.705, 0, .336, {
    ic: .045
  }],
  0x1D5F4: [.469, .206, .55],
  0x1D5F5: [.694, 0, .561],
  0x1D5F6: [.695, 0, .256],
  0x1D5F7: [.695, .205, .286],
  0x1D5F8: [.694, 0, .531],
  0x1D5F9: [.694, 0, .256],
  0x1D5FA: [.469, 0, .867],
  0x1D5FB: [.468, 0, .561],
  0x1D5FC: [.474, .011, .55],
  0x1D5FD: [.469, .194, .561],
  0x1D5FE: [.469, .194, .561],
  0x1D5FF: [.469, 0, .372],
  0x1D600: [.474, .01, .422],
  0x1D601: [.589, .01, .404],
  0x1D602: [.458, .011, .561],
  0x1D603: [.458, 0, .5],
  0x1D604: [.458, 0, .744],
  0x1D605: [.458, 0, .5],
  0x1D606: [.458, .205, .5],
  0x1D607: [.458, 0, .476],
  0x1D608: [.694, 0, .667],
  0x1D609: [.694, 0, .667, {
    ic: .029
  }],
  0x1D60A: [.705, .01, .639, {
    ic: .08
  }],
  0x1D60B: [.694, 0, .722, {
    ic: .025
  }],
  0x1D60C: [.691, 0, .597, {
    ic: .091
  }],
  0x1D60D: [.691, 0, .569, {
    ic: .104
  }],
  0x1D60E: [.705, .011, .667, {
    ic: .063
  }],
  0x1D60F: [.694, 0, .708, {
    ic: .06
  }],
  0x1D610: [.694, 0, .278, {
    ic: .06
  }],
  0x1D611: [.694, .022, .472, {
    ic: .063
  }],
  0x1D612: [.694, 0, .694, {
    ic: .091
  }],
  0x1D613: [.694, 0, .542],
  0x1D614: [.694, 0, .875, {
    ic: .054
  }],
  0x1D615: [.694, 0, .708, {
    ic: .058
  }],
  0x1D616: [.716, .022, .736, {
    ic: .027
  }],
  0x1D617: [.694, 0, .639, {
    ic: .051
  }],
  0x1D618: [.716, .125, .736, {
    ic: .027
  }],
  0x1D619: [.694, 0, .646, {
    ic: .052
  }],
  0x1D61A: [.716, .022, .556, {
    ic: .053
  }],
  0x1D61B: [.688, 0, .681, {
    ic: .109
  }],
  0x1D61C: [.694, .022, .688, {
    ic: .059
  }],
  0x1D61D: [.694, 0, .667, {
    ic: .132
  }],
  0x1D61E: [.694, 0, .944, {
    ic: .132
  }],
  0x1D61F: [.694, 0, .667, {
    ic: .091
  }],
  0x1D620: [.694, 0, .667, {
    ic: .143
  }],
  0x1D621: [.694, 0, .611, {
    ic: .091
  }],
  0x1D622: [.461, .01, .481],
  0x1D623: [.694, .011, .517, {
    ic: .022
  }],
  0x1D624: [.46, .011, .444, {
    ic: .055
  }],
  0x1D625: [.694, .01, .517, {
    ic: .071
  }],
  0x1D626: [.46, .011, .444, {
    ic: .028
  }],
  0x1D627: [.705, 0, .306, {
    ic: .188
  }],
  0x1D628: [.455, .206, .5, {
    ic: .068
  }],
  0x1D629: [.694, 0, .517],
  0x1D62A: [.68, 0, .239, {
    ic: .076
  }],
  0x1D62B: [.68, .204, .267, {
    ic: .069
  }],
  0x1D62C: [.694, 0, .489, {
    ic: .054
  }],
  0x1D62D: [.694, 0, .239, {
    ic: .072
  }],
  0x1D62E: [.455, 0, .794],
  0x1D62F: [.454, 0, .517],
  0x1D630: [.461, .011, .5, {
    ic: .023
  }],
  0x1D631: [.455, .194, .517, {
    ic: .021
  }],
  0x1D632: [.455, .194, .517, {
    ic: .021
  }],
  0x1D633: [.455, 0, .342, {
    ic: .082
  }],
  0x1D634: [.461, .011, .383, {
    ic: .053
  }],
  0x1D635: [.571, .011, .361, {
    ic: .049
  }],
  0x1D636: [.444, .01, .517, {
    ic: .02
  }],
  0x1D637: [.444, 0, .461, {
    ic: .079
  }],
  0x1D638: [.444, 0, .683, {
    ic: .079
  }],
  0x1D639: [.444, 0, .461, {
    ic: .076
  }],
  0x1D63A: [.444, .205, .461, {
    ic: .079
  }],
  0x1D63B: [.444, 0, .435, {
    ic: .059
  }],
  0x1D670: [.623, 0, .525],
  0x1D671: [.611, 0, .525],
  0x1D672: [.622, .011, .525],
  0x1D673: [.611, 0, .525],
  0x1D674: [.611, 0, .525],
  0x1D675: [.611, 0, .525],
  0x1D676: [.622, .011, .525],
  0x1D677: [.611, 0, .525],
  0x1D678: [.611, 0, .525],
  0x1D679: [.611, .011, .525],
  0x1D67A: [.611, 0, .525],
  0x1D67B: [.611, 0, .525],
  0x1D67C: [.611, 0, .525],
  0x1D67D: [.611, 0, .525],
  0x1D67E: [.621, .01, .525],
  0x1D67F: [.611, 0, .525],
  0x1D680: [.621, .138, .525],
  0x1D681: [.611, .011, .525],
  0x1D682: [.622, .011, .525],
  0x1D683: [.611, 0, .525],
  0x1D684: [.611, .011, .525],
  0x1D685: [.611, .007, .525],
  0x1D686: [.611, .007, .525],
  0x1D687: [.611, 0, .525],
  0x1D688: [.611, 0, .525],
  0x1D689: [.611, 0, .525],
  0x1D68A: [.439, .006, .525],
  0x1D68B: [.611, .006, .525],
  0x1D68C: [.44, .006, .525],
  0x1D68D: [.611, .006, .525],
  0x1D68E: [.44, .006, .525],
  0x1D68F: [.617, 0, .525],
  0x1D690: [.442, .229, .525],
  0x1D691: [.611, 0, .525],
  0x1D692: [.612, 0, .525],
  0x1D693: [.612, .228, .525],
  0x1D694: [.611, 0, .525],
  0x1D695: [.611, 0, .525],
  0x1D696: [.436, 0, .525, {
    ic: .011
  }],
  0x1D697: [.436, 0, .525],
  0x1D698: [.44, .006, .525],
  0x1D699: [.437, .221, .525],
  0x1D69A: [.437, .221, .525, {
    ic: .02
  }],
  0x1D69B: [.437, 0, .525],
  0x1D69C: [.44, .006, .525],
  0x1D69D: [.554, .006, .525],
  0x1D69E: [.431, .005, .525],
  0x1D69F: [.431, 0, .525],
  0x1D6A0: [.431, 0, .525],
  0x1D6A1: [.431, 0, .525],
  0x1D6A2: [.431, .228, .525],
  0x1D6A3: [.431, 0, .525],
  0x1D6A8: [.698, 0, .869],
  0x1D6A9: [.686, 0, .818],
  0x1D6AA: [.68, 0, .692],
  0x1D6AB: [.698, 0, .958],
  0x1D6AC: [.68, 0, .756],
  0x1D6AD: [.686, 0, .703],
  0x1D6AE: [.686, 0, .9],
  0x1D6AF: [.696, .01, .894],
  0x1D6B0: [.686, 0, .436],
  0x1D6B1: [.686, 0, .901],
  0x1D6B2: [.698, 0, .806],
  0x1D6B3: [.686, 0, 1.092],
  0x1D6B4: [.686, 0, .9],
  0x1D6B5: [.675, 0, .767],
  0x1D6B6: [.696, .01, .864],
  0x1D6B7: [.68, 0, .9],
  0x1D6B8: [.686, 0, .786],
  0x1D6BA: [.686, 0, .831],
  0x1D6BB: [.675, 0, .8],
  0x1D6BC: [.697, 0, .894],
  0x1D6BD: [.686, 0, .831],
  0x1D6BE: [.686, 0, .869],
  0x1D6BF: [.686, 0, .894],
  0x1D6C0: [.696, 0, .831],
  0x1D6C1: [.686, .024, .958],
  0x1D6E2: [.716, 0, .75, {
    sk: .139
  }],
  0x1D6E3: [.683, 0, .759, {
    sk: .0833
  }],
  0x1D6E4: [.68, 0, .615, {
    ic: .106,
    sk: .0833
  }],
  0x1D6E5: [.716, 0, .833, {
    sk: .167
  }],
  0x1D6E6: [.68, 0, .738, {
    ic: .026,
    sk: .0833
  }],
  0x1D6E7: [.683, 0, .683, {
    ic: .04,
    sk: .0833
  }],
  0x1D6E8: [.683, 0, .831, {
    ic: .057,
    sk: .0556
  }],
  0x1D6E9: [.704, .022, .763, {
    sk: .0833
  }],
  0x1D6EA: [.683, 0, .44, {
    ic: .064,
    sk: .111
  }],
  0x1D6EB: [.683, 0, .849, {
    ic: .04,
    sk: .0556
  }],
  0x1D6EC: [.716, 0, .694, {
    sk: .167
  }],
  0x1D6ED: [.683, 0, .97, {
    ic: .081,
    sk: .0833
  }],
  0x1D6EE: [.683, 0, .803, {
    ic: .085,
    sk: .0833
  }],
  0x1D6EF: [.677, 0, .742, {
    ic: .035,
    sk: .0833
  }],
  0x1D6F0: [.704, .022, .763, {
    sk: .0833
  }],
  0x1D6F1: [.68, 0, .831, {
    ic: .056,
    sk: .0556
  }],
  0x1D6F2: [.683, 0, .642, {
    ic: .109,
    sk: .0833
  }],
  0x1D6F4: [.683, 0, .78, {
    ic: .026,
    sk: .0833
  }],
  0x1D6F5: [.677, 0, .584, {
    ic: .12,
    sk: .0833
  }],
  0x1D6F6: [.705, 0, .583, {
    ic: .117,
    sk: .0556
  }],
  0x1D6F7: [.683, 0, .667, {
    sk: .0833
  }],
  0x1D6F8: [.683, 0, .828, {
    ic: .024,
    sk: .0833
  }],
  0x1D6F9: [.683, 0, .612, {
    ic: .08,
    sk: .0556
  }],
  0x1D6FA: [.704, 0, .772, {
    ic: .014,
    sk: .0833
  }],
  0x1D6FC: [.442, .011, .64, {
    sk: .0278
  }],
  0x1D6FD: [.705, .194, .566, {
    sk: .0833
  }],
  0x1D6FE: [.441, .216, .518, {
    ic: .025
  }],
  0x1D6FF: [.717, .01, .444, {
    sk: .0556
  }],
  0x1D700: [.452, .022, .466, {
    sk: .0833
  }],
  0x1D701: [.704, .204, .438, {
    ic: .033,
    sk: .0833
  }],
  0x1D702: [.442, .216, .497, {
    sk: .0556
  }],
  0x1D703: [.705, .01, .469, {
    sk: .0833
  }],
  0x1D704: [.442, .01, .354, {
    sk: .0556
  }],
  0x1D705: [.442, .011, .576],
  0x1D706: [.694, .012, .583],
  0x1D707: [.442, .216, .603, {
    sk: .0278
  }],
  0x1D708: [.442, 0, .494, {
    ic: .036,
    sk: .0278
  }],
  0x1D709: [.704, .205, .438, {
    sk: .111
  }],
  0x1D70A: [.441, .011, .485, {
    sk: .0556
  }],
  0x1D70B: [.431, .011, .57],
  0x1D70C: [.442, .216, .517, {
    sk: .0833
  }],
  0x1D70D: [.442, .107, .363, {
    ic: .042,
    sk: .0833
  }],
  0x1D70E: [.431, .011, .571],
  0x1D70F: [.431, .013, .437, {
    ic: .08,
    sk: .0278
  }],
  0x1D710: [.443, .01, .54, {
    sk: .0278
  }],
  0x1D711: [.442, .218, .654, {
    sk: .0833
  }],
  0x1D712: [.442, .204, .626, {
    sk: .0556
  }],
  0x1D713: [.694, .205, .651, {
    sk: .111
  }],
  0x1D714: [.443, .011, .622],
  0x1D715: [.715, .022, .531, {
    ic: .035,
    sk: .0833
  }],
  0x1D716: [.431, .011, .406, {
    sk: .0556
  }],
  0x1D717: [.705, .011, .591, {
    sk: .0833
  }],
  0x1D718: [.434, .006, .667, {
    ic: .067
  }],
  0x1D719: [.694, .205, .596, {
    sk: .0833
  }],
  0x1D71A: [.442, .194, .517, {
    sk: .0833
  }],
  0x1D71B: [.431, .01, .828],
  0x1D71C: [.711, 0, .869, {
    sk: .16
  }],
  0x1D71D: [.686, 0, .866, {
    sk: .0958
  }],
  0x1D71E: [.68, 0, .657, {
    ic: .12,
    sk: .0958
  }],
  0x1D71F: [.711, 0, .958, {
    sk: .192
  }],
  0x1D720: [.68, 0, .81, {
    ic: .015,
    sk: .0958
  }],
  0x1D721: [.686, 0, .773, {
    ic: .032,
    sk: .0958
  }],
  0x1D722: [.686, 0, .982, {
    ic: .045,
    sk: .0639
  }],
  0x1D723: [.702, .017, .867, {
    sk: .0958
  }],
  0x1D724: [.686, 0, .511, {
    ic: .062,
    sk: .128
  }],
  0x1D725: [.686, 0, .971, {
    ic: .032,
    sk: .0639
  }],
  0x1D726: [.711, 0, .806, {
    sk: .192
  }],
  0x1D727: [.686, 0, 1.142, {
    ic: .077,
    sk: .0958
  }],
  0x1D728: [.686, 0, .95, {
    ic: .077,
    sk: .0958
  }],
  0x1D729: [.675, 0, .841, {
    ic: .026,
    sk: .0958
  }],
  0x1D72A: [.703, .017, .837, {
    sk: .0958
  }],
  0x1D72B: [.68, 0, .982, {
    ic: .044,
    sk: .0639
  }],
  0x1D72C: [.686, 0, .723, {
    ic: .124,
    sk: .0958
  }],
  0x1D72E: [.686, 0, .885, {
    ic: .017,
    sk: .0958
  }],
  0x1D72F: [.675, 0, .637, {
    ic: .135,
    sk: .0958
  }],
  0x1D730: [.703, 0, .671, {
    ic: .131,
    sk: .0639
  }],
  0x1D731: [.686, 0, .767, {
    sk: .0958
  }],
  0x1D732: [.686, 0, .947, {
    sk: .0958
  }],
  0x1D733: [.686, 0, .714, {
    ic: .076,
    sk: .0639
  }],
  0x1D734: [.703, 0, .879, {
    sk: .0958
  }],
  0x1D736: [.452, .008, .761, {
    sk: .0319
  }],
  0x1D737: [.701, .194, .66, {
    sk: .0958
  }],
  0x1D738: [.451, .211, .59, {
    ic: .027
  }],
  0x1D739: [.725, .008, .522, {
    sk: .0639
  }],
  0x1D73A: [.461, .017, .529, {
    sk: .0958
  }],
  0x1D73B: [.711, .202, .508, {
    ic: .013,
    sk: .0958
  }],
  0x1D73C: [.452, .211, .6, {
    sk: .0639
  }],
  0x1D73D: [.702, .008, .562, {
    sk: .0958
  }],
  0x1D73E: [.452, .008, .412, {
    sk: .0639
  }],
  0x1D73F: [.452, .008, .668],
  0x1D740: [.694, .013, .671],
  0x1D741: [.452, .211, .708, {
    sk: .0319
  }],
  0x1D742: [.452, 0, .577, {
    ic: .031,
    sk: .0319
  }],
  0x1D743: [.711, .201, .508, {
    sk: .128
  }],
  0x1D744: [.452, .008, .585, {
    sk: .0639
  }],
  0x1D745: [.444, .008, .682],
  0x1D746: [.451, .211, .612, {
    sk: .0958
  }],
  0x1D747: [.451, .105, .424, {
    ic: .033,
    sk: .0958
  }],
  0x1D748: [.444, .008, .686],
  0x1D749: [.444, .013, .521, {
    ic: .089,
    sk: .0319
  }],
  0x1D74A: [.453, .008, .631, {
    sk: .0319
  }],
  0x1D74B: [.452, .216, .747, {
    sk: .0958
  }],
  0x1D74C: [.452, .201, .718, {
    sk: .0639
  }],
  0x1D74D: [.694, .202, .758, {
    sk: .128
  }],
  0x1D74E: [.453, .008, .718],
  0x1D74F: [.71, .017, .628, {
    ic: .029,
    sk: .0958
  }],
  0x1D750: [.444, .007, .483, {
    sk: .0639
  }],
  0x1D751: [.701, .008, .692, {
    sk: .0958
  }],
  0x1D752: [.434, .006, .667, {
    ic: .067
  }],
  0x1D753: [.694, .202, .712, {
    sk: .0958
  }],
  0x1D754: [.451, .194, .612, {
    sk: .0958
  }],
  0x1D755: [.444, .008, .975],
  0x1D756: [.694, 0, .733],
  0x1D757: [.694, 0, .733],
  0x1D758: [.691, 0, .581],
  0x1D759: [.694, 0, .917],
  0x1D75A: [.691, 0, .642],
  0x1D75B: [.694, 0, .672],
  0x1D75C: [.694, 0, .794],
  0x1D75D: [.716, .022, .856],
  0x1D75E: [.694, 0, .331],
  0x1D75F: [.694, 0, .764],
  0x1D760: [.694, 0, .672],
  0x1D761: [.694, 0, .978],
  0x1D762: [.694, 0, .794],
  0x1D763: [.688, 0, .733],
  0x1D764: [.716, .022, .794],
  0x1D765: [.691, 0, .794],
  0x1D766: [.694, 0, .703],
  0x1D768: [.694, 0, .794],
  0x1D769: [.688, 0, .733],
  0x1D76A: [.715, 0, .856],
  0x1D76B: [.694, 0, .794],
  0x1D76C: [.694, 0, .733],
  0x1D76D: [.694, 0, .856],
  0x1D76E: [.716, 0, .794],
  0x1D7CE: [.654, .01, .575],
  0x1D7CF: [.655, 0, .575],
  0x1D7D0: [.654, 0, .575],
  0x1D7D1: [.655, .011, .575],
  0x1D7D2: [.656, 0, .575],
  0x1D7D3: [.655, .011, .575],
  0x1D7D4: [.655, .011, .575],
  0x1D7D5: [.676, .011, .575],
  0x1D7D6: [.654, .011, .575],
  0x1D7D7: [.654, .011, .575],
  0x1D7E2: [.678, .022, .5],
  0x1D7E3: [.678, 0, .5],
  0x1D7E4: [.677, 0, .5],
  0x1D7E5: [.678, .022, .5],
  0x1D7E6: [.656, 0, .5],
  0x1D7E7: [.656, .021, .5],
  0x1D7E8: [.677, .022, .5],
  0x1D7E9: [.656, .011, .5],
  0x1D7EA: [.678, .022, .5],
  0x1D7EB: [.677, .022, .5],
  0x1D7EC: [.715, .022, .55],
  0x1D7ED: [.716, 0, .55],
  0x1D7EE: [.716, 0, .55],
  0x1D7EF: [.716, .022, .55],
  0x1D7F0: [.694, 0, .55],
  0x1D7F1: [.694, .022, .55],
  0x1D7F2: [.716, .022, .55],
  0x1D7F3: [.695, .011, .55],
  0x1D7F4: [.715, .022, .55],
  0x1D7F5: [.716, .022, .55],
  0x1D7F6: [.621, .01, .525],
  0x1D7F7: [.622, 0, .525],
  0x1D7F8: [.622, 0, .525],
  0x1D7F9: [.622, .011, .525],
  0x1D7FA: [.624, 0, .525],
  0x1D7FB: [.611, .01, .525],
  0x1D7FC: [.622, .011, .525],
  0x1D7FD: [.627, .01, .525],
  0x1D7FE: [.621, .01, .525],
  0x1D7FF: [.622, .011, .525]
};

Object.defineProperty(normal$1, "__esModule", {
  value: true
});
normal$1.normal = void 0;
var FontData_js_1$a = FontData;
var normal_js_1$1 = normal;
normal$1.normal = (0, FontData_js_1$a.AddCSS)(normal_js_1$1.normal, {
  0xA3: {
    f: 'MI'
  },
  0xA5: {
    f: 'A'
  },
  0xAE: {
    f: 'A'
  },
  0xB7: {
    c: '\\22C5'
  },
  0xF0: {
    f: 'A'
  },
  0x2B9: {
    c: '\\2032'
  },
  0x391: {
    c: 'A'
  },
  0x392: {
    c: 'B'
  },
  0x395: {
    c: 'E'
  },
  0x396: {
    c: 'Z'
  },
  0x397: {
    c: 'H'
  },
  0x399: {
    c: 'I'
  },
  0x39A: {
    c: 'K'
  },
  0x39C: {
    c: 'M'
  },
  0x39D: {
    c: 'N'
  },
  0x39F: {
    c: 'O'
  },
  0x3A1: {
    c: 'P'
  },
  0x3A4: {
    c: 'T'
  },
  0x3A7: {
    c: 'X'
  },
  0x2000: {
    c: ''
  },
  0x2001: {
    c: ''
  },
  0x2002: {
    c: ''
  },
  0x2003: {
    c: ''
  },
  0x2004: {
    c: ''
  },
  0x2005: {
    c: ''
  },
  0x2006: {
    c: ''
  },
  0x2009: {
    c: ''
  },
  0x200A: {
    c: ''
  },
  0x200B: {
    c: ''
  },
  0x200C: {
    c: ''
  },
  0x2015: {
    c: '\\2014'
  },
  0x2016: {
    c: '\\2225'
  },
  0x2017: {
    c: '_'
  },
  0x2022: {
    c: '\\2219'
  },
  0x2033: {
    c: '\\2032\\2032'
  },
  0x2034: {
    c: '\\2032\\2032\\2032'
  },
  0x2035: {
    f: 'A'
  },
  0x2036: {
    c: '\\2035\\2035',
    f: 'A'
  },
  0x2037: {
    c: '\\2035\\2035\\2035',
    f: 'A'
  },
  0x203E: {
    c: '\\2C9'
  },
  0x2044: {
    c: '/'
  },
  0x2057: {
    c: '\\2032\\2032\\2032\\2032'
  },
  0x2060: {
    c: ''
  },
  0x2061: {
    c: ''
  },
  0x2062: {
    c: ''
  },
  0x2063: {
    c: ''
  },
  0x2064: {
    c: ''
  },
  0x20D7: {
    c: '\\2192',
    f: 'V'
  },
  0x2102: {
    c: 'C',
    f: 'A'
  },
  0x210B: {
    c: 'H',
    f: 'SC'
  },
  0x210C: {
    c: 'H',
    f: 'FR'
  },
  0x210D: {
    c: 'H',
    f: 'A'
  },
  0x210E: {
    c: 'h',
    f: 'I'
  },
  0x210F: {
    f: 'A'
  },
  0x2110: {
    c: 'I',
    f: 'SC'
  },
  0x2111: {
    c: 'I',
    f: 'FR'
  },
  0x2112: {
    c: 'L',
    f: 'SC'
  },
  0x2115: {
    c: 'N',
    f: 'A'
  },
  0x2119: {
    c: 'P',
    f: 'A'
  },
  0x211A: {
    c: 'Q',
    f: 'A'
  },
  0x211B: {
    c: 'R',
    f: 'SC'
  },
  0x211C: {
    c: 'R',
    f: 'FR'
  },
  0x211D: {
    c: 'R',
    f: 'A'
  },
  0x2124: {
    c: 'Z',
    f: 'A'
  },
  0x2126: {
    c: '\\3A9'
  },
  0x2127: {
    f: 'A'
  },
  0x2128: {
    c: 'Z',
    f: 'FR'
  },
  0x212C: {
    c: 'B',
    f: 'SC'
  },
  0x212D: {
    c: 'C',
    f: 'FR'
  },
  0x2130: {
    c: 'E',
    f: 'SC'
  },
  0x2131: {
    c: 'F',
    f: 'SC'
  },
  0x2132: {
    f: 'A'
  },
  0x2133: {
    c: 'M',
    f: 'SC'
  },
  0x2136: {
    f: 'A'
  },
  0x2137: {
    f: 'A'
  },
  0x2138: {
    f: 'A'
  },
  0x2141: {
    f: 'A'
  },
  0x219A: {
    f: 'A'
  },
  0x219B: {
    f: 'A'
  },
  0x219E: {
    f: 'A'
  },
  0x21A0: {
    f: 'A'
  },
  0x21A2: {
    f: 'A'
  },
  0x21A3: {
    f: 'A'
  },
  0x21AB: {
    f: 'A'
  },
  0x21AC: {
    f: 'A'
  },
  0x21AD: {
    f: 'A'
  },
  0x21AE: {
    f: 'A'
  },
  0x21B0: {
    f: 'A'
  },
  0x21B1: {
    f: 'A'
  },
  0x21B6: {
    f: 'A'
  },
  0x21B7: {
    f: 'A'
  },
  0x21BA: {
    f: 'A'
  },
  0x21BB: {
    f: 'A'
  },
  0x21BE: {
    f: 'A'
  },
  0x21BF: {
    f: 'A'
  },
  0x21C2: {
    f: 'A'
  },
  0x21C3: {
    f: 'A'
  },
  0x21C4: {
    f: 'A'
  },
  0x21C6: {
    f: 'A'
  },
  0x21C7: {
    f: 'A'
  },
  0x21C8: {
    f: 'A'
  },
  0x21C9: {
    f: 'A'
  },
  0x21CA: {
    f: 'A'
  },
  0x21CB: {
    f: 'A'
  },
  0x21CD: {
    f: 'A'
  },
  0x21CE: {
    f: 'A'
  },
  0x21CF: {
    f: 'A'
  },
  0x21DA: {
    f: 'A'
  },
  0x21DB: {
    f: 'A'
  },
  0x21DD: {
    f: 'A'
  },
  0x21E0: {
    f: 'A'
  },
  0x21E2: {
    f: 'A'
  },
  0x2201: {
    f: 'A'
  },
  0x2204: {
    c: '\\2203\\338'
  },
  0x2206: {
    c: '\\394'
  },
  0x220C: {
    c: '\\220B\\338'
  },
  0x220D: {
    f: 'A'
  },
  0x220F: {
    f: 'S1'
  },
  0x2210: {
    f: 'S1'
  },
  0x2211: {
    f: 'S1'
  },
  0x2214: {
    f: 'A'
  },
  0x2221: {
    f: 'A'
  },
  0x2222: {
    f: 'A'
  },
  0x2224: {
    f: 'A'
  },
  0x2226: {
    f: 'A'
  },
  0x222C: {
    f: 'S1'
  },
  0x222D: {
    f: 'S1'
  },
  0x222E: {
    f: 'S1'
  },
  0x2234: {
    f: 'A'
  },
  0x2235: {
    f: 'A'
  },
  0x223D: {
    f: 'A'
  },
  0x2241: {
    f: 'A'
  },
  0x2242: {
    f: 'A'
  },
  0x2244: {
    c: '\\2243\\338'
  },
  0x2247: {
    c: '\\2246',
    f: 'A'
  },
  0x2249: {
    c: '\\2248\\338'
  },
  0x224A: {
    f: 'A'
  },
  0x224E: {
    f: 'A'
  },
  0x224F: {
    f: 'A'
  },
  0x2251: {
    f: 'A'
  },
  0x2252: {
    f: 'A'
  },
  0x2253: {
    f: 'A'
  },
  0x2256: {
    f: 'A'
  },
  0x2257: {
    f: 'A'
  },
  0x225C: {
    f: 'A'
  },
  0x2262: {
    c: '\\2261\\338'
  },
  0x2266: {
    f: 'A'
  },
  0x2267: {
    f: 'A'
  },
  0x2268: {
    f: 'A'
  },
  0x2269: {
    f: 'A'
  },
  0x226C: {
    f: 'A'
  },
  0x226D: {
    c: '\\224D\\338'
  },
  0x226E: {
    f: 'A'
  },
  0x226F: {
    f: 'A'
  },
  0x2270: {
    f: 'A'
  },
  0x2271: {
    f: 'A'
  },
  0x2272: {
    f: 'A'
  },
  0x2273: {
    f: 'A'
  },
  0x2274: {
    c: '\\2272\\338'
  },
  0x2275: {
    c: '\\2273\\338'
  },
  0x2276: {
    f: 'A'
  },
  0x2277: {
    f: 'A'
  },
  0x2278: {
    c: '\\2276\\338'
  },
  0x2279: {
    c: '\\2277\\338'
  },
  0x227C: {
    f: 'A'
  },
  0x227D: {
    f: 'A'
  },
  0x227E: {
    f: 'A'
  },
  0x227F: {
    f: 'A'
  },
  0x2280: {
    f: 'A'
  },
  0x2281: {
    f: 'A'
  },
  0x2284: {
    c: '\\2282\\338'
  },
  0x2285: {
    c: '\\2283\\338'
  },
  0x2288: {
    f: 'A'
  },
  0x2289: {
    f: 'A'
  },
  0x228A: {
    f: 'A'
  },
  0x228B: {
    f: 'A'
  },
  0x228F: {
    f: 'A'
  },
  0x2290: {
    f: 'A'
  },
  0x229A: {
    f: 'A'
  },
  0x229B: {
    f: 'A'
  },
  0x229D: {
    f: 'A'
  },
  0x229E: {
    f: 'A'
  },
  0x229F: {
    f: 'A'
  },
  0x22A0: {
    f: 'A'
  },
  0x22A1: {
    f: 'A'
  },
  0x22A9: {
    f: 'A'
  },
  0x22AA: {
    f: 'A'
  },
  0x22AC: {
    f: 'A'
  },
  0x22AD: {
    f: 'A'
  },
  0x22AE: {
    f: 'A'
  },
  0x22AF: {
    f: 'A'
  },
  0x22B2: {
    f: 'A'
  },
  0x22B3: {
    f: 'A'
  },
  0x22B4: {
    f: 'A'
  },
  0x22B5: {
    f: 'A'
  },
  0x22B8: {
    f: 'A'
  },
  0x22BA: {
    f: 'A'
  },
  0x22BB: {
    f: 'A'
  },
  0x22BC: {
    f: 'A'
  },
  0x22C0: {
    f: 'S1'
  },
  0x22C1: {
    f: 'S1'
  },
  0x22C2: {
    f: 'S1'
  },
  0x22C3: {
    f: 'S1'
  },
  0x22C7: {
    f: 'A'
  },
  0x22C9: {
    f: 'A'
  },
  0x22CA: {
    f: 'A'
  },
  0x22CB: {
    f: 'A'
  },
  0x22CC: {
    f: 'A'
  },
  0x22CD: {
    f: 'A'
  },
  0x22CE: {
    f: 'A'
  },
  0x22CF: {
    f: 'A'
  },
  0x22D0: {
    f: 'A'
  },
  0x22D1: {
    f: 'A'
  },
  0x22D2: {
    f: 'A'
  },
  0x22D3: {
    f: 'A'
  },
  0x22D4: {
    f: 'A'
  },
  0x22D6: {
    f: 'A'
  },
  0x22D7: {
    f: 'A'
  },
  0x22D8: {
    f: 'A'
  },
  0x22D9: {
    f: 'A'
  },
  0x22DA: {
    f: 'A'
  },
  0x22DB: {
    f: 'A'
  },
  0x22DE: {
    f: 'A'
  },
  0x22DF: {
    f: 'A'
  },
  0x22E0: {
    f: 'A'
  },
  0x22E1: {
    f: 'A'
  },
  0x22E2: {
    c: '\\2291\\338'
  },
  0x22E3: {
    c: '\\2292\\338'
  },
  0x22E6: {
    f: 'A'
  },
  0x22E7: {
    f: 'A'
  },
  0x22E8: {
    f: 'A'
  },
  0x22E9: {
    f: 'A'
  },
  0x22EA: {
    f: 'A'
  },
  0x22EB: {
    f: 'A'
  },
  0x22EC: {
    f: 'A'
  },
  0x22ED: {
    f: 'A'
  },
  0x2305: {
    c: '\\22BC',
    f: 'A'
  },
  0x2306: {
    c: '\\2A5E',
    f: 'A'
  },
  0x231C: {
    c: '\\250C',
    f: 'A'
  },
  0x231D: {
    c: '\\2510',
    f: 'A'
  },
  0x231E: {
    c: '\\2514',
    f: 'A'
  },
  0x231F: {
    c: '\\2518',
    f: 'A'
  },
  0x2329: {
    c: '\\27E8'
  },
  0x232A: {
    c: '\\27E9'
  },
  0x23D0: {
    f: 'S1'
  },
  0x24C8: {
    f: 'A'
  },
  0x250C: {
    f: 'A'
  },
  0x2510: {
    f: 'A'
  },
  0x2514: {
    f: 'A'
  },
  0x2518: {
    f: 'A'
  },
  0x2571: {
    f: 'A'
  },
  0x2572: {
    f: 'A'
  },
  0x25A0: {
    f: 'A'
  },
  0x25A1: {
    f: 'A'
  },
  0x25AA: {
    c: '\\25A0',
    f: 'A'
  },
  0x25B2: {
    f: 'A'
  },
  0x25B4: {
    c: '\\25B2',
    f: 'A'
  },
  0x25B5: {
    c: '\\25B3'
  },
  0x25B6: {
    f: 'A'
  },
  0x25B8: {
    c: '\\25B6',
    f: 'A'
  },
  0x25BC: {
    f: 'A'
  },
  0x25BE: {
    c: '\\25BC',
    f: 'A'
  },
  0x25BF: {
    c: '\\25BD'
  },
  0x25C0: {
    f: 'A'
  },
  0x25C2: {
    c: '\\25C0',
    f: 'A'
  },
  0x25CA: {
    f: 'A'
  },
  0x25FB: {
    c: '\\25A1',
    f: 'A'
  },
  0x25FC: {
    c: '\\25A0',
    f: 'A'
  },
  0x2605: {
    f: 'A'
  },
  0x2713: {
    f: 'A'
  },
  0x2720: {
    f: 'A'
  },
  0x2758: {
    c: '\\2223'
  },
  0x29EB: {
    f: 'A'
  },
  0x29F8: {
    c: '/',
    f: 'I'
  },
  0x2A00: {
    f: 'S1'
  },
  0x2A01: {
    f: 'S1'
  },
  0x2A02: {
    f: 'S1'
  },
  0x2A04: {
    f: 'S1'
  },
  0x2A06: {
    f: 'S1'
  },
  0x2A0C: {
    c: '\\222C\\222C',
    f: 'S1'
  },
  0x2A2F: {
    c: '\\D7'
  },
  0x2A5E: {
    f: 'A'
  },
  0x2A7D: {
    f: 'A'
  },
  0x2A7E: {
    f: 'A'
  },
  0x2A85: {
    f: 'A'
  },
  0x2A86: {
    f: 'A'
  },
  0x2A87: {
    f: 'A'
  },
  0x2A88: {
    f: 'A'
  },
  0x2A89: {
    f: 'A'
  },
  0x2A8A: {
    f: 'A'
  },
  0x2A8B: {
    f: 'A'
  },
  0x2A8C: {
    f: 'A'
  },
  0x2A95: {
    f: 'A'
  },
  0x2A96: {
    f: 'A'
  },
  0x2AB5: {
    f: 'A'
  },
  0x2AB6: {
    f: 'A'
  },
  0x2AB7: {
    f: 'A'
  },
  0x2AB8: {
    f: 'A'
  },
  0x2AB9: {
    f: 'A'
  },
  0x2ABA: {
    f: 'A'
  },
  0x2AC5: {
    f: 'A'
  },
  0x2AC6: {
    f: 'A'
  },
  0x2ACB: {
    f: 'A'
  },
  0x2ACC: {
    f: 'A'
  },
  0x3008: {
    c: '\\27E8'
  },
  0x3009: {
    c: '\\27E9'
  },
  0xE006: {
    f: 'A'
  },
  0xE007: {
    f: 'A'
  },
  0xE008: {
    f: 'A'
  },
  0xE009: {
    f: 'A'
  },
  0xE00C: {
    f: 'A'
  },
  0xE00D: {
    f: 'A'
  },
  0xE00E: {
    f: 'A'
  },
  0xE00F: {
    f: 'A'
  },
  0xE010: {
    f: 'A'
  },
  0xE011: {
    f: 'A'
  },
  0xE016: {
    f: 'A'
  },
  0xE017: {
    f: 'A'
  },
  0xE018: {
    f: 'A'
  },
  0xE019: {
    f: 'A'
  },
  0xE01A: {
    f: 'A'
  },
  0xE01B: {
    f: 'A'
  },
  0x1D400: {
    c: 'A',
    f: 'B'
  },
  0x1D401: {
    c: 'B',
    f: 'B'
  },
  0x1D402: {
    c: 'C',
    f: 'B'
  },
  0x1D403: {
    c: 'D',
    f: 'B'
  },
  0x1D404: {
    c: 'E',
    f: 'B'
  },
  0x1D405: {
    c: 'F',
    f: 'B'
  },
  0x1D406: {
    c: 'G',
    f: 'B'
  },
  0x1D407: {
    c: 'H',
    f: 'B'
  },
  0x1D408: {
    c: 'I',
    f: 'B'
  },
  0x1D409: {
    c: 'J',
    f: 'B'
  },
  0x1D40A: {
    c: 'K',
    f: 'B'
  },
  0x1D40B: {
    c: 'L',
    f: 'B'
  },
  0x1D40C: {
    c: 'M',
    f: 'B'
  },
  0x1D40D: {
    c: 'N',
    f: 'B'
  },
  0x1D40E: {
    c: 'O',
    f: 'B'
  },
  0x1D40F: {
    c: 'P',
    f: 'B'
  },
  0x1D410: {
    c: 'Q',
    f: 'B'
  },
  0x1D411: {
    c: 'R',
    f: 'B'
  },
  0x1D412: {
    c: 'S',
    f: 'B'
  },
  0x1D413: {
    c: 'T',
    f: 'B'
  },
  0x1D414: {
    c: 'U',
    f: 'B'
  },
  0x1D415: {
    c: 'V',
    f: 'B'
  },
  0x1D416: {
    c: 'W',
    f: 'B'
  },
  0x1D417: {
    c: 'X',
    f: 'B'
  },
  0x1D418: {
    c: 'Y',
    f: 'B'
  },
  0x1D419: {
    c: 'Z',
    f: 'B'
  },
  0x1D41A: {
    c: 'a',
    f: 'B'
  },
  0x1D41B: {
    c: 'b',
    f: 'B'
  },
  0x1D41C: {
    c: 'c',
    f: 'B'
  },
  0x1D41D: {
    c: 'd',
    f: 'B'
  },
  0x1D41E: {
    c: 'e',
    f: 'B'
  },
  0x1D41F: {
    c: 'f',
    f: 'B'
  },
  0x1D420: {
    c: 'g',
    f: 'B'
  },
  0x1D421: {
    c: 'h',
    f: 'B'
  },
  0x1D422: {
    c: 'i',
    f: 'B'
  },
  0x1D423: {
    c: 'j',
    f: 'B'
  },
  0x1D424: {
    c: 'k',
    f: 'B'
  },
  0x1D425: {
    c: 'l',
    f: 'B'
  },
  0x1D426: {
    c: 'm',
    f: 'B'
  },
  0x1D427: {
    c: 'n',
    f: 'B'
  },
  0x1D428: {
    c: 'o',
    f: 'B'
  },
  0x1D429: {
    c: 'p',
    f: 'B'
  },
  0x1D42A: {
    c: 'q',
    f: 'B'
  },
  0x1D42B: {
    c: 'r',
    f: 'B'
  },
  0x1D42C: {
    c: 's',
    f: 'B'
  },
  0x1D42D: {
    c: 't',
    f: 'B'
  },
  0x1D42E: {
    c: 'u',
    f: 'B'
  },
  0x1D42F: {
    c: 'v',
    f: 'B'
  },
  0x1D430: {
    c: 'w',
    f: 'B'
  },
  0x1D431: {
    c: 'x',
    f: 'B'
  },
  0x1D432: {
    c: 'y',
    f: 'B'
  },
  0x1D433: {
    c: 'z',
    f: 'B'
  },
  0x1D434: {
    c: 'A',
    f: 'I'
  },
  0x1D435: {
    c: 'B',
    f: 'I'
  },
  0x1D436: {
    c: 'C',
    f: 'I'
  },
  0x1D437: {
    c: 'D',
    f: 'I'
  },
  0x1D438: {
    c: 'E',
    f: 'I'
  },
  0x1D439: {
    c: 'F',
    f: 'I'
  },
  0x1D43A: {
    c: 'G',
    f: 'I'
  },
  0x1D43B: {
    c: 'H',
    f: 'I'
  },
  0x1D43C: {
    c: 'I',
    f: 'I'
  },
  0x1D43D: {
    c: 'J',
    f: 'I'
  },
  0x1D43E: {
    c: 'K',
    f: 'I'
  },
  0x1D43F: {
    c: 'L',
    f: 'I'
  },
  0x1D440: {
    c: 'M',
    f: 'I'
  },
  0x1D441: {
    c: 'N',
    f: 'I'
  },
  0x1D442: {
    c: 'O',
    f: 'I'
  },
  0x1D443: {
    c: 'P',
    f: 'I'
  },
  0x1D444: {
    c: 'Q',
    f: 'I'
  },
  0x1D445: {
    c: 'R',
    f: 'I'
  },
  0x1D446: {
    c: 'S',
    f: 'I'
  },
  0x1D447: {
    c: 'T',
    f: 'I'
  },
  0x1D448: {
    c: 'U',
    f: 'I'
  },
  0x1D449: {
    c: 'V',
    f: 'I'
  },
  0x1D44A: {
    c: 'W',
    f: 'I'
  },
  0x1D44B: {
    c: 'X',
    f: 'I'
  },
  0x1D44C: {
    c: 'Y',
    f: 'I'
  },
  0x1D44D: {
    c: 'Z',
    f: 'I'
  },
  0x1D44E: {
    c: 'a',
    f: 'I'
  },
  0x1D44F: {
    c: 'b',
    f: 'I'
  },
  0x1D450: {
    c: 'c',
    f: 'I'
  },
  0x1D451: {
    c: 'd',
    f: 'I'
  },
  0x1D452: {
    c: 'e',
    f: 'I'
  },
  0x1D453: {
    c: 'f',
    f: 'I'
  },
  0x1D454: {
    c: 'g',
    f: 'I'
  },
  0x1D456: {
    c: 'i',
    f: 'I'
  },
  0x1D457: {
    c: 'j',
    f: 'I'
  },
  0x1D458: {
    c: 'k',
    f: 'I'
  },
  0x1D459: {
    c: 'l',
    f: 'I'
  },
  0x1D45A: {
    c: 'm',
    f: 'I'
  },
  0x1D45B: {
    c: 'n',
    f: 'I'
  },
  0x1D45C: {
    c: 'o',
    f: 'I'
  },
  0x1D45D: {
    c: 'p',
    f: 'I'
  },
  0x1D45E: {
    c: 'q',
    f: 'I'
  },
  0x1D45F: {
    c: 'r',
    f: 'I'
  },
  0x1D460: {
    c: 's',
    f: 'I'
  },
  0x1D461: {
    c: 't',
    f: 'I'
  },
  0x1D462: {
    c: 'u',
    f: 'I'
  },
  0x1D463: {
    c: 'v',
    f: 'I'
  },
  0x1D464: {
    c: 'w',
    f: 'I'
  },
  0x1D465: {
    c: 'x',
    f: 'I'
  },
  0x1D466: {
    c: 'y',
    f: 'I'
  },
  0x1D467: {
    c: 'z',
    f: 'I'
  },
  0x1D468: {
    c: 'A',
    f: 'BI'
  },
  0x1D469: {
    c: 'B',
    f: 'BI'
  },
  0x1D46A: {
    c: 'C',
    f: 'BI'
  },
  0x1D46B: {
    c: 'D',
    f: 'BI'
  },
  0x1D46C: {
    c: 'E',
    f: 'BI'
  },
  0x1D46D: {
    c: 'F',
    f: 'BI'
  },
  0x1D46E: {
    c: 'G',
    f: 'BI'
  },
  0x1D46F: {
    c: 'H',
    f: 'BI'
  },
  0x1D470: {
    c: 'I',
    f: 'BI'
  },
  0x1D471: {
    c: 'J',
    f: 'BI'
  },
  0x1D472: {
    c: 'K',
    f: 'BI'
  },
  0x1D473: {
    c: 'L',
    f: 'BI'
  },
  0x1D474: {
    c: 'M',
    f: 'BI'
  },
  0x1D475: {
    c: 'N',
    f: 'BI'
  },
  0x1D476: {
    c: 'O',
    f: 'BI'
  },
  0x1D477: {
    c: 'P',
    f: 'BI'
  },
  0x1D478: {
    c: 'Q',
    f: 'BI'
  },
  0x1D479: {
    c: 'R',
    f: 'BI'
  },
  0x1D47A: {
    c: 'S',
    f: 'BI'
  },
  0x1D47B: {
    c: 'T',
    f: 'BI'
  },
  0x1D47C: {
    c: 'U',
    f: 'BI'
  },
  0x1D47D: {
    c: 'V',
    f: 'BI'
  },
  0x1D47E: {
    c: 'W',
    f: 'BI'
  },
  0x1D47F: {
    c: 'X',
    f: 'BI'
  },
  0x1D480: {
    c: 'Y',
    f: 'BI'
  },
  0x1D481: {
    c: 'Z',
    f: 'BI'
  },
  0x1D482: {
    c: 'a',
    f: 'BI'
  },
  0x1D483: {
    c: 'b',
    f: 'BI'
  },
  0x1D484: {
    c: 'c',
    f: 'BI'
  },
  0x1D485: {
    c: 'd',
    f: 'BI'
  },
  0x1D486: {
    c: 'e',
    f: 'BI'
  },
  0x1D487: {
    c: 'f',
    f: 'BI'
  },
  0x1D488: {
    c: 'g',
    f: 'BI'
  },
  0x1D489: {
    c: 'h',
    f: 'BI'
  },
  0x1D48A: {
    c: 'i',
    f: 'BI'
  },
  0x1D48B: {
    c: 'j',
    f: 'BI'
  },
  0x1D48C: {
    c: 'k',
    f: 'BI'
  },
  0x1D48D: {
    c: 'l',
    f: 'BI'
  },
  0x1D48E: {
    c: 'm',
    f: 'BI'
  },
  0x1D48F: {
    c: 'n',
    f: 'BI'
  },
  0x1D490: {
    c: 'o',
    f: 'BI'
  },
  0x1D491: {
    c: 'p',
    f: 'BI'
  },
  0x1D492: {
    c: 'q',
    f: 'BI'
  },
  0x1D493: {
    c: 'r',
    f: 'BI'
  },
  0x1D494: {
    c: 's',
    f: 'BI'
  },
  0x1D495: {
    c: 't',
    f: 'BI'
  },
  0x1D496: {
    c: 'u',
    f: 'BI'
  },
  0x1D497: {
    c: 'v',
    f: 'BI'
  },
  0x1D498: {
    c: 'w',
    f: 'BI'
  },
  0x1D499: {
    c: 'x',
    f: 'BI'
  },
  0x1D49A: {
    c: 'y',
    f: 'BI'
  },
  0x1D49B: {
    c: 'z',
    f: 'BI'
  },
  0x1D49C: {
    c: 'A',
    f: 'SC'
  },
  0x1D49E: {
    c: 'C',
    f: 'SC'
  },
  0x1D49F: {
    c: 'D',
    f: 'SC'
  },
  0x1D4A2: {
    c: 'G',
    f: 'SC'
  },
  0x1D4A5: {
    c: 'J',
    f: 'SC'
  },
  0x1D4A6: {
    c: 'K',
    f: 'SC'
  },
  0x1D4A9: {
    c: 'N',
    f: 'SC'
  },
  0x1D4AA: {
    c: 'O',
    f: 'SC'
  },
  0x1D4AB: {
    c: 'P',
    f: 'SC'
  },
  0x1D4AC: {
    c: 'Q',
    f: 'SC'
  },
  0x1D4AE: {
    c: 'S',
    f: 'SC'
  },
  0x1D4AF: {
    c: 'T',
    f: 'SC'
  },
  0x1D4B0: {
    c: 'U',
    f: 'SC'
  },
  0x1D4B1: {
    c: 'V',
    f: 'SC'
  },
  0x1D4B2: {
    c: 'W',
    f: 'SC'
  },
  0x1D4B3: {
    c: 'X',
    f: 'SC'
  },
  0x1D4B4: {
    c: 'Y',
    f: 'SC'
  },
  0x1D4B5: {
    c: 'Z',
    f: 'SC'
  },
  0x1D504: {
    c: 'A',
    f: 'FR'
  },
  0x1D505: {
    c: 'B',
    f: 'FR'
  },
  0x1D507: {
    c: 'D',
    f: 'FR'
  },
  0x1D508: {
    c: 'E',
    f: 'FR'
  },
  0x1D509: {
    c: 'F',
    f: 'FR'
  },
  0x1D50A: {
    c: 'G',
    f: 'FR'
  },
  0x1D50D: {
    c: 'J',
    f: 'FR'
  },
  0x1D50E: {
    c: 'K',
    f: 'FR'
  },
  0x1D50F: {
    c: 'L',
    f: 'FR'
  },
  0x1D510: {
    c: 'M',
    f: 'FR'
  },
  0x1D511: {
    c: 'N',
    f: 'FR'
  },
  0x1D512: {
    c: 'O',
    f: 'FR'
  },
  0x1D513: {
    c: 'P',
    f: 'FR'
  },
  0x1D514: {
    c: 'Q',
    f: 'FR'
  },
  0x1D516: {
    c: 'S',
    f: 'FR'
  },
  0x1D517: {
    c: 'T',
    f: 'FR'
  },
  0x1D518: {
    c: 'U',
    f: 'FR'
  },
  0x1D519: {
    c: 'V',
    f: 'FR'
  },
  0x1D51A: {
    c: 'W',
    f: 'FR'
  },
  0x1D51B: {
    c: 'X',
    f: 'FR'
  },
  0x1D51C: {
    c: 'Y',
    f: 'FR'
  },
  0x1D51E: {
    c: 'a',
    f: 'FR'
  },
  0x1D51F: {
    c: 'b',
    f: 'FR'
  },
  0x1D520: {
    c: 'c',
    f: 'FR'
  },
  0x1D521: {
    c: 'd',
    f: 'FR'
  },
  0x1D522: {
    c: 'e',
    f: 'FR'
  },
  0x1D523: {
    c: 'f',
    f: 'FR'
  },
  0x1D524: {
    c: 'g',
    f: 'FR'
  },
  0x1D525: {
    c: 'h',
    f: 'FR'
  },
  0x1D526: {
    c: 'i',
    f: 'FR'
  },
  0x1D527: {
    c: 'j',
    f: 'FR'
  },
  0x1D528: {
    c: 'k',
    f: 'FR'
  },
  0x1D529: {
    c: 'l',
    f: 'FR'
  },
  0x1D52A: {
    c: 'm',
    f: 'FR'
  },
  0x1D52B: {
    c: 'n',
    f: 'FR'
  },
  0x1D52C: {
    c: 'o',
    f: 'FR'
  },
  0x1D52D: {
    c: 'p',
    f: 'FR'
  },
  0x1D52E: {
    c: 'q',
    f: 'FR'
  },
  0x1D52F: {
    c: 'r',
    f: 'FR'
  },
  0x1D530: {
    c: 's',
    f: 'FR'
  },
  0x1D531: {
    c: 't',
    f: 'FR'
  },
  0x1D532: {
    c: 'u',
    f: 'FR'
  },
  0x1D533: {
    c: 'v',
    f: 'FR'
  },
  0x1D534: {
    c: 'w',
    f: 'FR'
  },
  0x1D535: {
    c: 'x',
    f: 'FR'
  },
  0x1D536: {
    c: 'y',
    f: 'FR'
  },
  0x1D537: {
    c: 'z',
    f: 'FR'
  },
  0x1D538: {
    c: 'A',
    f: 'A'
  },
  0x1D539: {
    c: 'B',
    f: 'A'
  },
  0x1D53B: {
    c: 'D',
    f: 'A'
  },
  0x1D53C: {
    c: 'E',
    f: 'A'
  },
  0x1D53D: {
    c: 'F',
    f: 'A'
  },
  0x1D53E: {
    c: 'G',
    f: 'A'
  },
  0x1D540: {
    c: 'I',
    f: 'A'
  },
  0x1D541: {
    c: 'J',
    f: 'A'
  },
  0x1D542: {
    c: 'K',
    f: 'A'
  },
  0x1D543: {
    c: 'L',
    f: 'A'
  },
  0x1D544: {
    c: 'M',
    f: 'A'
  },
  0x1D546: {
    c: 'O',
    f: 'A'
  },
  0x1D54A: {
    c: 'S',
    f: 'A'
  },
  0x1D54B: {
    c: 'T',
    f: 'A'
  },
  0x1D54C: {
    c: 'U',
    f: 'A'
  },
  0x1D54D: {
    c: 'V',
    f: 'A'
  },
  0x1D54E: {
    c: 'W',
    f: 'A'
  },
  0x1D54F: {
    c: 'X',
    f: 'A'
  },
  0x1D550: {
    c: 'Y',
    f: 'A'
  },
  0x1D56C: {
    c: 'A',
    f: 'FRB'
  },
  0x1D56D: {
    c: 'B',
    f: 'FRB'
  },
  0x1D56E: {
    c: 'C',
    f: 'FRB'
  },
  0x1D56F: {
    c: 'D',
    f: 'FRB'
  },
  0x1D570: {
    c: 'E',
    f: 'FRB'
  },
  0x1D571: {
    c: 'F',
    f: 'FRB'
  },
  0x1D572: {
    c: 'G',
    f: 'FRB'
  },
  0x1D573: {
    c: 'H',
    f: 'FRB'
  },
  0x1D574: {
    c: 'I',
    f: 'FRB'
  },
  0x1D575: {
    c: 'J',
    f: 'FRB'
  },
  0x1D576: {
    c: 'K',
    f: 'FRB'
  },
  0x1D577: {
    c: 'L',
    f: 'FRB'
  },
  0x1D578: {
    c: 'M',
    f: 'FRB'
  },
  0x1D579: {
    c: 'N',
    f: 'FRB'
  },
  0x1D57A: {
    c: 'O',
    f: 'FRB'
  },
  0x1D57B: {
    c: 'P',
    f: 'FRB'
  },
  0x1D57C: {
    c: 'Q',
    f: 'FRB'
  },
  0x1D57D: {
    c: 'R',
    f: 'FRB'
  },
  0x1D57E: {
    c: 'S',
    f: 'FRB'
  },
  0x1D57F: {
    c: 'T',
    f: 'FRB'
  },
  0x1D580: {
    c: 'U',
    f: 'FRB'
  },
  0x1D581: {
    c: 'V',
    f: 'FRB'
  },
  0x1D582: {
    c: 'W',
    f: 'FRB'
  },
  0x1D583: {
    c: 'X',
    f: 'FRB'
  },
  0x1D584: {
    c: 'Y',
    f: 'FRB'
  },
  0x1D585: {
    c: 'Z',
    f: 'FRB'
  },
  0x1D586: {
    c: 'a',
    f: 'FRB'
  },
  0x1D587: {
    c: 'b',
    f: 'FRB'
  },
  0x1D588: {
    c: 'c',
    f: 'FRB'
  },
  0x1D589: {
    c: 'd',
    f: 'FRB'
  },
  0x1D58A: {
    c: 'e',
    f: 'FRB'
  },
  0x1D58B: {
    c: 'f',
    f: 'FRB'
  },
  0x1D58C: {
    c: 'g',
    f: 'FRB'
  },
  0x1D58D: {
    c: 'h',
    f: 'FRB'
  },
  0x1D58E: {
    c: 'i',
    f: 'FRB'
  },
  0x1D58F: {
    c: 'j',
    f: 'FRB'
  },
  0x1D590: {
    c: 'k',
    f: 'FRB'
  },
  0x1D591: {
    c: 'l',
    f: 'FRB'
  },
  0x1D592: {
    c: 'm',
    f: 'FRB'
  },
  0x1D593: {
    c: 'n',
    f: 'FRB'
  },
  0x1D594: {
    c: 'o',
    f: 'FRB'
  },
  0x1D595: {
    c: 'p',
    f: 'FRB'
  },
  0x1D596: {
    c: 'q',
    f: 'FRB'
  },
  0x1D597: {
    c: 'r',
    f: 'FRB'
  },
  0x1D598: {
    c: 's',
    f: 'FRB'
  },
  0x1D599: {
    c: 't',
    f: 'FRB'
  },
  0x1D59A: {
    c: 'u',
    f: 'FRB'
  },
  0x1D59B: {
    c: 'v',
    f: 'FRB'
  },
  0x1D59C: {
    c: 'w',
    f: 'FRB'
  },
  0x1D59D: {
    c: 'x',
    f: 'FRB'
  },
  0x1D59E: {
    c: 'y',
    f: 'FRB'
  },
  0x1D59F: {
    c: 'z',
    f: 'FRB'
  },
  0x1D5A0: {
    c: 'A',
    f: 'SS'
  },
  0x1D5A1: {
    c: 'B',
    f: 'SS'
  },
  0x1D5A2: {
    c: 'C',
    f: 'SS'
  },
  0x1D5A3: {
    c: 'D',
    f: 'SS'
  },
  0x1D5A4: {
    c: 'E',
    f: 'SS'
  },
  0x1D5A5: {
    c: 'F',
    f: 'SS'
  },
  0x1D5A6: {
    c: 'G',
    f: 'SS'
  },
  0x1D5A7: {
    c: 'H',
    f: 'SS'
  },
  0x1D5A8: {
    c: 'I',
    f: 'SS'
  },
  0x1D5A9: {
    c: 'J',
    f: 'SS'
  },
  0x1D5AA: {
    c: 'K',
    f: 'SS'
  },
  0x1D5AB: {
    c: 'L',
    f: 'SS'
  },
  0x1D5AC: {
    c: 'M',
    f: 'SS'
  },
  0x1D5AD: {
    c: 'N',
    f: 'SS'
  },
  0x1D5AE: {
    c: 'O',
    f: 'SS'
  },
  0x1D5AF: {
    c: 'P',
    f: 'SS'
  },
  0x1D5B0: {
    c: 'Q',
    f: 'SS'
  },
  0x1D5B1: {
    c: 'R',
    f: 'SS'
  },
  0x1D5B2: {
    c: 'S',
    f: 'SS'
  },
  0x1D5B3: {
    c: 'T',
    f: 'SS'
  },
  0x1D5B4: {
    c: 'U',
    f: 'SS'
  },
  0x1D5B5: {
    c: 'V',
    f: 'SS'
  },
  0x1D5B6: {
    c: 'W',
    f: 'SS'
  },
  0x1D5B7: {
    c: 'X',
    f: 'SS'
  },
  0x1D5B8: {
    c: 'Y',
    f: 'SS'
  },
  0x1D5B9: {
    c: 'Z',
    f: 'SS'
  },
  0x1D5BA: {
    c: 'a',
    f: 'SS'
  },
  0x1D5BB: {
    c: 'b',
    f: 'SS'
  },
  0x1D5BC: {
    c: 'c',
    f: 'SS'
  },
  0x1D5BD: {
    c: 'd',
    f: 'SS'
  },
  0x1D5BE: {
    c: 'e',
    f: 'SS'
  },
  0x1D5BF: {
    c: 'f',
    f: 'SS'
  },
  0x1D5C0: {
    c: 'g',
    f: 'SS'
  },
  0x1D5C1: {
    c: 'h',
    f: 'SS'
  },
  0x1D5C2: {
    c: 'i',
    f: 'SS'
  },
  0x1D5C3: {
    c: 'j',
    f: 'SS'
  },
  0x1D5C4: {
    c: 'k',
    f: 'SS'
  },
  0x1D5C5: {
    c: 'l',
    f: 'SS'
  },
  0x1D5C6: {
    c: 'm',
    f: 'SS'
  },
  0x1D5C7: {
    c: 'n',
    f: 'SS'
  },
  0x1D5C8: {
    c: 'o',
    f: 'SS'
  },
  0x1D5C9: {
    c: 'p',
    f: 'SS'
  },
  0x1D5CA: {
    c: 'q',
    f: 'SS'
  },
  0x1D5CB: {
    c: 'r',
    f: 'SS'
  },
  0x1D5CC: {
    c: 's',
    f: 'SS'
  },
  0x1D5CD: {
    c: 't',
    f: 'SS'
  },
  0x1D5CE: {
    c: 'u',
    f: 'SS'
  },
  0x1D5CF: {
    c: 'v',
    f: 'SS'
  },
  0x1D5D0: {
    c: 'w',
    f: 'SS'
  },
  0x1D5D1: {
    c: 'x',
    f: 'SS'
  },
  0x1D5D2: {
    c: 'y',
    f: 'SS'
  },
  0x1D5D3: {
    c: 'z',
    f: 'SS'
  },
  0x1D5D4: {
    c: 'A',
    f: 'SSB'
  },
  0x1D5D5: {
    c: 'B',
    f: 'SSB'
  },
  0x1D5D6: {
    c: 'C',
    f: 'SSB'
  },
  0x1D5D7: {
    c: 'D',
    f: 'SSB'
  },
  0x1D5D8: {
    c: 'E',
    f: 'SSB'
  },
  0x1D5D9: {
    c: 'F',
    f: 'SSB'
  },
  0x1D5DA: {
    c: 'G',
    f: 'SSB'
  },
  0x1D5DB: {
    c: 'H',
    f: 'SSB'
  },
  0x1D5DC: {
    c: 'I',
    f: 'SSB'
  },
  0x1D5DD: {
    c: 'J',
    f: 'SSB'
  },
  0x1D5DE: {
    c: 'K',
    f: 'SSB'
  },
  0x1D5DF: {
    c: 'L',
    f: 'SSB'
  },
  0x1D5E0: {
    c: 'M',
    f: 'SSB'
  },
  0x1D5E1: {
    c: 'N',
    f: 'SSB'
  },
  0x1D5E2: {
    c: 'O',
    f: 'SSB'
  },
  0x1D5E3: {
    c: 'P',
    f: 'SSB'
  },
  0x1D5E4: {
    c: 'Q',
    f: 'SSB'
  },
  0x1D5E5: {
    c: 'R',
    f: 'SSB'
  },
  0x1D5E6: {
    c: 'S',
    f: 'SSB'
  },
  0x1D5E7: {
    c: 'T',
    f: 'SSB'
  },
  0x1D5E8: {
    c: 'U',
    f: 'SSB'
  },
  0x1D5E9: {
    c: 'V',
    f: 'SSB'
  },
  0x1D5EA: {
    c: 'W',
    f: 'SSB'
  },
  0x1D5EB: {
    c: 'X',
    f: 'SSB'
  },
  0x1D5EC: {
    c: 'Y',
    f: 'SSB'
  },
  0x1D5ED: {
    c: 'Z',
    f: 'SSB'
  },
  0x1D5EE: {
    c: 'a',
    f: 'SSB'
  },
  0x1D5EF: {
    c: 'b',
    f: 'SSB'
  },
  0x1D5F0: {
    c: 'c',
    f: 'SSB'
  },
  0x1D5F1: {
    c: 'd',
    f: 'SSB'
  },
  0x1D5F2: {
    c: 'e',
    f: 'SSB'
  },
  0x1D5F3: {
    c: 'f',
    f: 'SSB'
  },
  0x1D5F4: {
    c: 'g',
    f: 'SSB'
  },
  0x1D5F5: {
    c: 'h',
    f: 'SSB'
  },
  0x1D5F6: {
    c: 'i',
    f: 'SSB'
  },
  0x1D5F7: {
    c: 'j',
    f: 'SSB'
  },
  0x1D5F8: {
    c: 'k',
    f: 'SSB'
  },
  0x1D5F9: {
    c: 'l',
    f: 'SSB'
  },
  0x1D5FA: {
    c: 'm',
    f: 'SSB'
  },
  0x1D5FB: {
    c: 'n',
    f: 'SSB'
  },
  0x1D5FC: {
    c: 'o',
    f: 'SSB'
  },
  0x1D5FD: {
    c: 'p',
    f: 'SSB'
  },
  0x1D5FE: {
    c: 'q',
    f: 'SSB'
  },
  0x1D5FF: {
    c: 'r',
    f: 'SSB'
  },
  0x1D600: {
    c: 's',
    f: 'SSB'
  },
  0x1D601: {
    c: 't',
    f: 'SSB'
  },
  0x1D602: {
    c: 'u',
    f: 'SSB'
  },
  0x1D603: {
    c: 'v',
    f: 'SSB'
  },
  0x1D604: {
    c: 'w',
    f: 'SSB'
  },
  0x1D605: {
    c: 'x',
    f: 'SSB'
  },
  0x1D606: {
    c: 'y',
    f: 'SSB'
  },
  0x1D607: {
    c: 'z',
    f: 'SSB'
  },
  0x1D608: {
    c: 'A',
    f: 'SSI'
  },
  0x1D609: {
    c: 'B',
    f: 'SSI'
  },
  0x1D60A: {
    c: 'C',
    f: 'SSI'
  },
  0x1D60B: {
    c: 'D',
    f: 'SSI'
  },
  0x1D60C: {
    c: 'E',
    f: 'SSI'
  },
  0x1D60D: {
    c: 'F',
    f: 'SSI'
  },
  0x1D60E: {
    c: 'G',
    f: 'SSI'
  },
  0x1D60F: {
    c: 'H',
    f: 'SSI'
  },
  0x1D610: {
    c: 'I',
    f: 'SSI'
  },
  0x1D611: {
    c: 'J',
    f: 'SSI'
  },
  0x1D612: {
    c: 'K',
    f: 'SSI'
  },
  0x1D613: {
    c: 'L',
    f: 'SSI'
  },
  0x1D614: {
    c: 'M',
    f: 'SSI'
  },
  0x1D615: {
    c: 'N',
    f: 'SSI'
  },
  0x1D616: {
    c: 'O',
    f: 'SSI'
  },
  0x1D617: {
    c: 'P',
    f: 'SSI'
  },
  0x1D618: {
    c: 'Q',
    f: 'SSI'
  },
  0x1D619: {
    c: 'R',
    f: 'SSI'
  },
  0x1D61A: {
    c: 'S',
    f: 'SSI'
  },
  0x1D61B: {
    c: 'T',
    f: 'SSI'
  },
  0x1D61C: {
    c: 'U',
    f: 'SSI'
  },
  0x1D61D: {
    c: 'V',
    f: 'SSI'
  },
  0x1D61E: {
    c: 'W',
    f: 'SSI'
  },
  0x1D61F: {
    c: 'X',
    f: 'SSI'
  },
  0x1D620: {
    c: 'Y',
    f: 'SSI'
  },
  0x1D621: {
    c: 'Z',
    f: 'SSI'
  },
  0x1D622: {
    c: 'a',
    f: 'SSI'
  },
  0x1D623: {
    c: 'b',
    f: 'SSI'
  },
  0x1D624: {
    c: 'c',
    f: 'SSI'
  },
  0x1D625: {
    c: 'd',
    f: 'SSI'
  },
  0x1D626: {
    c: 'e',
    f: 'SSI'
  },
  0x1D627: {
    c: 'f',
    f: 'SSI'
  },
  0x1D628: {
    c: 'g',
    f: 'SSI'
  },
  0x1D629: {
    c: 'h',
    f: 'SSI'
  },
  0x1D62A: {
    c: 'i',
    f: 'SSI'
  },
  0x1D62B: {
    c: 'j',
    f: 'SSI'
  },
  0x1D62C: {
    c: 'k',
    f: 'SSI'
  },
  0x1D62D: {
    c: 'l',
    f: 'SSI'
  },
  0x1D62E: {
    c: 'm',
    f: 'SSI'
  },
  0x1D62F: {
    c: 'n',
    f: 'SSI'
  },
  0x1D630: {
    c: 'o',
    f: 'SSI'
  },
  0x1D631: {
    c: 'p',
    f: 'SSI'
  },
  0x1D632: {
    c: 'q',
    f: 'SSI'
  },
  0x1D633: {
    c: 'r',
    f: 'SSI'
  },
  0x1D634: {
    c: 's',
    f: 'SSI'
  },
  0x1D635: {
    c: 't',
    f: 'SSI'
  },
  0x1D636: {
    c: 'u',
    f: 'SSI'
  },
  0x1D637: {
    c: 'v',
    f: 'SSI'
  },
  0x1D638: {
    c: 'w',
    f: 'SSI'
  },
  0x1D639: {
    c: 'x',
    f: 'SSI'
  },
  0x1D63A: {
    c: 'y',
    f: 'SSI'
  },
  0x1D63B: {
    c: 'z',
    f: 'SSI'
  },
  0x1D670: {
    c: 'A',
    f: 'T'
  },
  0x1D671: {
    c: 'B',
    f: 'T'
  },
  0x1D672: {
    c: 'C',
    f: 'T'
  },
  0x1D673: {
    c: 'D',
    f: 'T'
  },
  0x1D674: {
    c: 'E',
    f: 'T'
  },
  0x1D675: {
    c: 'F',
    f: 'T'
  },
  0x1D676: {
    c: 'G',
    f: 'T'
  },
  0x1D677: {
    c: 'H',
    f: 'T'
  },
  0x1D678: {
    c: 'I',
    f: 'T'
  },
  0x1D679: {
    c: 'J',
    f: 'T'
  },
  0x1D67A: {
    c: 'K',
    f: 'T'
  },
  0x1D67B: {
    c: 'L',
    f: 'T'
  },
  0x1D67C: {
    c: 'M',
    f: 'T'
  },
  0x1D67D: {
    c: 'N',
    f: 'T'
  },
  0x1D67E: {
    c: 'O',
    f: 'T'
  },
  0x1D67F: {
    c: 'P',
    f: 'T'
  },
  0x1D680: {
    c: 'Q',
    f: 'T'
  },
  0x1D681: {
    c: 'R',
    f: 'T'
  },
  0x1D682: {
    c: 'S',
    f: 'T'
  },
  0x1D683: {
    c: 'T',
    f: 'T'
  },
  0x1D684: {
    c: 'U',
    f: 'T'
  },
  0x1D685: {
    c: 'V',
    f: 'T'
  },
  0x1D686: {
    c: 'W',
    f: 'T'
  },
  0x1D687: {
    c: 'X',
    f: 'T'
  },
  0x1D688: {
    c: 'Y',
    f: 'T'
  },
  0x1D689: {
    c: 'Z',
    f: 'T'
  },
  0x1D68A: {
    c: 'a',
    f: 'T'
  },
  0x1D68B: {
    c: 'b',
    f: 'T'
  },
  0x1D68C: {
    c: 'c',
    f: 'T'
  },
  0x1D68D: {
    c: 'd',
    f: 'T'
  },
  0x1D68E: {
    c: 'e',
    f: 'T'
  },
  0x1D68F: {
    c: 'f',
    f: 'T'
  },
  0x1D690: {
    c: 'g',
    f: 'T'
  },
  0x1D691: {
    c: 'h',
    f: 'T'
  },
  0x1D692: {
    c: 'i',
    f: 'T'
  },
  0x1D693: {
    c: 'j',
    f: 'T'
  },
  0x1D694: {
    c: 'k',
    f: 'T'
  },
  0x1D695: {
    c: 'l',
    f: 'T'
  },
  0x1D696: {
    c: 'm',
    f: 'T'
  },
  0x1D697: {
    c: 'n',
    f: 'T'
  },
  0x1D698: {
    c: 'o',
    f: 'T'
  },
  0x1D699: {
    c: 'p',
    f: 'T'
  },
  0x1D69A: {
    c: 'q',
    f: 'T'
  },
  0x1D69B: {
    c: 'r',
    f: 'T'
  },
  0x1D69C: {
    c: 's',
    f: 'T'
  },
  0x1D69D: {
    c: 't',
    f: 'T'
  },
  0x1D69E: {
    c: 'u',
    f: 'T'
  },
  0x1D69F: {
    c: 'v',
    f: 'T'
  },
  0x1D6A0: {
    c: 'w',
    f: 'T'
  },
  0x1D6A1: {
    c: 'x',
    f: 'T'
  },
  0x1D6A2: {
    c: 'y',
    f: 'T'
  },
  0x1D6A3: {
    c: 'z',
    f: 'T'
  },
  0x1D6A8: {
    c: 'A',
    f: 'B'
  },
  0x1D6A9: {
    c: 'B',
    f: 'B'
  },
  0x1D6AA: {
    c: '\\393',
    f: 'B'
  },
  0x1D6AB: {
    c: '\\394',
    f: 'B'
  },
  0x1D6AC: {
    c: 'E',
    f: 'B'
  },
  0x1D6AD: {
    c: 'Z',
    f: 'B'
  },
  0x1D6AE: {
    c: 'H',
    f: 'B'
  },
  0x1D6AF: {
    c: '\\398',
    f: 'B'
  },
  0x1D6B0: {
    c: 'I',
    f: 'B'
  },
  0x1D6B1: {
    c: 'K',
    f: 'B'
  },
  0x1D6B2: {
    c: '\\39B',
    f: 'B'
  },
  0x1D6B3: {
    c: 'M',
    f: 'B'
  },
  0x1D6B4: {
    c: 'N',
    f: 'B'
  },
  0x1D6B5: {
    c: '\\39E',
    f: 'B'
  },
  0x1D6B6: {
    c: 'O',
    f: 'B'
  },
  0x1D6B7: {
    c: '\\3A0',
    f: 'B'
  },
  0x1D6B8: {
    c: 'P',
    f: 'B'
  },
  0x1D6BA: {
    c: '\\3A3',
    f: 'B'
  },
  0x1D6BB: {
    c: 'T',
    f: 'B'
  },
  0x1D6BC: {
    c: '\\3A5',
    f: 'B'
  },
  0x1D6BD: {
    c: '\\3A6',
    f: 'B'
  },
  0x1D6BE: {
    c: 'X',
    f: 'B'
  },
  0x1D6BF: {
    c: '\\3A8',
    f: 'B'
  },
  0x1D6C0: {
    c: '\\3A9',
    f: 'B'
  },
  0x1D6C1: {
    c: '\\2207',
    f: 'B'
  },
  0x1D6E2: {
    c: 'A',
    f: 'I'
  },
  0x1D6E3: {
    c: 'B',
    f: 'I'
  },
  0x1D6E4: {
    c: '\\393',
    f: 'I'
  },
  0x1D6E5: {
    c: '\\394',
    f: 'I'
  },
  0x1D6E6: {
    c: 'E',
    f: 'I'
  },
  0x1D6E7: {
    c: 'Z',
    f: 'I'
  },
  0x1D6E8: {
    c: 'H',
    f: 'I'
  },
  0x1D6E9: {
    c: '\\398',
    f: 'I'
  },
  0x1D6EA: {
    c: 'I',
    f: 'I'
  },
  0x1D6EB: {
    c: 'K',
    f: 'I'
  },
  0x1D6EC: {
    c: '\\39B',
    f: 'I'
  },
  0x1D6ED: {
    c: 'M',
    f: 'I'
  },
  0x1D6EE: {
    c: 'N',
    f: 'I'
  },
  0x1D6EF: {
    c: '\\39E',
    f: 'I'
  },
  0x1D6F0: {
    c: 'O',
    f: 'I'
  },
  0x1D6F1: {
    c: '\\3A0',
    f: 'I'
  },
  0x1D6F2: {
    c: 'P',
    f: 'I'
  },
  0x1D6F4: {
    c: '\\3A3',
    f: 'I'
  },
  0x1D6F5: {
    c: 'T',
    f: 'I'
  },
  0x1D6F6: {
    c: '\\3A5',
    f: 'I'
  },
  0x1D6F7: {
    c: '\\3A6',
    f: 'I'
  },
  0x1D6F8: {
    c: 'X',
    f: 'I'
  },
  0x1D6F9: {
    c: '\\3A8',
    f: 'I'
  },
  0x1D6FA: {
    c: '\\3A9',
    f: 'I'
  },
  0x1D6FC: {
    c: '\\3B1',
    f: 'I'
  },
  0x1D6FD: {
    c: '\\3B2',
    f: 'I'
  },
  0x1D6FE: {
    c: '\\3B3',
    f: 'I'
  },
  0x1D6FF: {
    c: '\\3B4',
    f: 'I'
  },
  0x1D700: {
    c: '\\3B5',
    f: 'I'
  },
  0x1D701: {
    c: '\\3B6',
    f: 'I'
  },
  0x1D702: {
    c: '\\3B7',
    f: 'I'
  },
  0x1D703: {
    c: '\\3B8',
    f: 'I'
  },
  0x1D704: {
    c: '\\3B9',
    f: 'I'
  },
  0x1D705: {
    c: '\\3BA',
    f: 'I'
  },
  0x1D706: {
    c: '\\3BB',
    f: 'I'
  },
  0x1D707: {
    c: '\\3BC',
    f: 'I'
  },
  0x1D708: {
    c: '\\3BD',
    f: 'I'
  },
  0x1D709: {
    c: '\\3BE',
    f: 'I'
  },
  0x1D70A: {
    c: '\\3BF',
    f: 'I'
  },
  0x1D70B: {
    c: '\\3C0',
    f: 'I'
  },
  0x1D70C: {
    c: '\\3C1',
    f: 'I'
  },
  0x1D70D: {
    c: '\\3C2',
    f: 'I'
  },
  0x1D70E: {
    c: '\\3C3',
    f: 'I'
  },
  0x1D70F: {
    c: '\\3C4',
    f: 'I'
  },
  0x1D710: {
    c: '\\3C5',
    f: 'I'
  },
  0x1D711: {
    c: '\\3C6',
    f: 'I'
  },
  0x1D712: {
    c: '\\3C7',
    f: 'I'
  },
  0x1D713: {
    c: '\\3C8',
    f: 'I'
  },
  0x1D714: {
    c: '\\3C9',
    f: 'I'
  },
  0x1D715: {
    c: '\\2202'
  },
  0x1D716: {
    c: '\\3F5',
    f: 'I'
  },
  0x1D717: {
    c: '\\3D1',
    f: 'I'
  },
  0x1D718: {
    c: '\\E009',
    f: 'A'
  },
  0x1D719: {
    c: '\\3D5',
    f: 'I'
  },
  0x1D71A: {
    c: '\\3F1',
    f: 'I'
  },
  0x1D71B: {
    c: '\\3D6',
    f: 'I'
  },
  0x1D71C: {
    c: 'A',
    f: 'BI'
  },
  0x1D71D: {
    c: 'B',
    f: 'BI'
  },
  0x1D71E: {
    c: '\\393',
    f: 'BI'
  },
  0x1D71F: {
    c: '\\394',
    f: 'BI'
  },
  0x1D720: {
    c: 'E',
    f: 'BI'
  },
  0x1D721: {
    c: 'Z',
    f: 'BI'
  },
  0x1D722: {
    c: 'H',
    f: 'BI'
  },
  0x1D723: {
    c: '\\398',
    f: 'BI'
  },
  0x1D724: {
    c: 'I',
    f: 'BI'
  },
  0x1D725: {
    c: 'K',
    f: 'BI'
  },
  0x1D726: {
    c: '\\39B',
    f: 'BI'
  },
  0x1D727: {
    c: 'M',
    f: 'BI'
  },
  0x1D728: {
    c: 'N',
    f: 'BI'
  },
  0x1D729: {
    c: '\\39E',
    f: 'BI'
  },
  0x1D72A: {
    c: 'O',
    f: 'BI'
  },
  0x1D72B: {
    c: '\\3A0',
    f: 'BI'
  },
  0x1D72C: {
    c: 'P',
    f: 'BI'
  },
  0x1D72E: {
    c: '\\3A3',
    f: 'BI'
  },
  0x1D72F: {
    c: 'T',
    f: 'BI'
  },
  0x1D730: {
    c: '\\3A5',
    f: 'BI'
  },
  0x1D731: {
    c: '\\3A6',
    f: 'BI'
  },
  0x1D732: {
    c: 'X',
    f: 'BI'
  },
  0x1D733: {
    c: '\\3A8',
    f: 'BI'
  },
  0x1D734: {
    c: '\\3A9',
    f: 'BI'
  },
  0x1D736: {
    c: '\\3B1',
    f: 'BI'
  },
  0x1D737: {
    c: '\\3B2',
    f: 'BI'
  },
  0x1D738: {
    c: '\\3B3',
    f: 'BI'
  },
  0x1D739: {
    c: '\\3B4',
    f: 'BI'
  },
  0x1D73A: {
    c: '\\3B5',
    f: 'BI'
  },
  0x1D73B: {
    c: '\\3B6',
    f: 'BI'
  },
  0x1D73C: {
    c: '\\3B7',
    f: 'BI'
  },
  0x1D73D: {
    c: '\\3B8',
    f: 'BI'
  },
  0x1D73E: {
    c: '\\3B9',
    f: 'BI'
  },
  0x1D73F: {
    c: '\\3BA',
    f: 'BI'
  },
  0x1D740: {
    c: '\\3BB',
    f: 'BI'
  },
  0x1D741: {
    c: '\\3BC',
    f: 'BI'
  },
  0x1D742: {
    c: '\\3BD',
    f: 'BI'
  },
  0x1D743: {
    c: '\\3BE',
    f: 'BI'
  },
  0x1D744: {
    c: '\\3BF',
    f: 'BI'
  },
  0x1D745: {
    c: '\\3C0',
    f: 'BI'
  },
  0x1D746: {
    c: '\\3C1',
    f: 'BI'
  },
  0x1D747: {
    c: '\\3C2',
    f: 'BI'
  },
  0x1D748: {
    c: '\\3C3',
    f: 'BI'
  },
  0x1D749: {
    c: '\\3C4',
    f: 'BI'
  },
  0x1D74A: {
    c: '\\3C5',
    f: 'BI'
  },
  0x1D74B: {
    c: '\\3C6',
    f: 'BI'
  },
  0x1D74C: {
    c: '\\3C7',
    f: 'BI'
  },
  0x1D74D: {
    c: '\\3C8',
    f: 'BI'
  },
  0x1D74E: {
    c: '\\3C9',
    f: 'BI'
  },
  0x1D74F: {
    c: '\\2202',
    f: 'B'
  },
  0x1D750: {
    c: '\\3F5',
    f: 'BI'
  },
  0x1D751: {
    c: '\\3D1',
    f: 'BI'
  },
  0x1D752: {
    c: '\\E009',
    f: 'A'
  },
  0x1D753: {
    c: '\\3D5',
    f: 'BI'
  },
  0x1D754: {
    c: '\\3F1',
    f: 'BI'
  },
  0x1D755: {
    c: '\\3D6',
    f: 'BI'
  },
  0x1D756: {
    c: 'A',
    f: 'SSB'
  },
  0x1D757: {
    c: 'B',
    f: 'SSB'
  },
  0x1D758: {
    c: '\\393',
    f: 'SSB'
  },
  0x1D759: {
    c: '\\394',
    f: 'SSB'
  },
  0x1D75A: {
    c: 'E',
    f: 'SSB'
  },
  0x1D75B: {
    c: 'Z',
    f: 'SSB'
  },
  0x1D75C: {
    c: 'H',
    f: 'SSB'
  },
  0x1D75D: {
    c: '\\398',
    f: 'SSB'
  },
  0x1D75E: {
    c: 'I',
    f: 'SSB'
  },
  0x1D75F: {
    c: 'K',
    f: 'SSB'
  },
  0x1D760: {
    c: '\\39B',
    f: 'SSB'
  },
  0x1D761: {
    c: 'M',
    f: 'SSB'
  },
  0x1D762: {
    c: 'N',
    f: 'SSB'
  },
  0x1D763: {
    c: '\\39E',
    f: 'SSB'
  },
  0x1D764: {
    c: 'O',
    f: 'SSB'
  },
  0x1D765: {
    c: '\\3A0',
    f: 'SSB'
  },
  0x1D766: {
    c: 'P',
    f: 'SSB'
  },
  0x1D768: {
    c: '\\3A3',
    f: 'SSB'
  },
  0x1D769: {
    c: 'T',
    f: 'SSB'
  },
  0x1D76A: {
    c: '\\3A5',
    f: 'SSB'
  },
  0x1D76B: {
    c: '\\3A6',
    f: 'SSB'
  },
  0x1D76C: {
    c: 'X',
    f: 'SSB'
  },
  0x1D76D: {
    c: '\\3A8',
    f: 'SSB'
  },
  0x1D76E: {
    c: '\\3A9',
    f: 'SSB'
  },
  0x1D7CE: {
    c: '0',
    f: 'B'
  },
  0x1D7CF: {
    c: '1',
    f: 'B'
  },
  0x1D7D0: {
    c: '2',
    f: 'B'
  },
  0x1D7D1: {
    c: '3',
    f: 'B'
  },
  0x1D7D2: {
    c: '4',
    f: 'B'
  },
  0x1D7D3: {
    c: '5',
    f: 'B'
  },
  0x1D7D4: {
    c: '6',
    f: 'B'
  },
  0x1D7D5: {
    c: '7',
    f: 'B'
  },
  0x1D7D6: {
    c: '8',
    f: 'B'
  },
  0x1D7D7: {
    c: '9',
    f: 'B'
  },
  0x1D7E2: {
    c: '0',
    f: 'SS'
  },
  0x1D7E3: {
    c: '1',
    f: 'SS'
  },
  0x1D7E4: {
    c: '2',
    f: 'SS'
  },
  0x1D7E5: {
    c: '3',
    f: 'SS'
  },
  0x1D7E6: {
    c: '4',
    f: 'SS'
  },
  0x1D7E7: {
    c: '5',
    f: 'SS'
  },
  0x1D7E8: {
    c: '6',
    f: 'SS'
  },
  0x1D7E9: {
    c: '7',
    f: 'SS'
  },
  0x1D7EA: {
    c: '8',
    f: 'SS'
  },
  0x1D7EB: {
    c: '9',
    f: 'SS'
  },
  0x1D7EC: {
    c: '0',
    f: 'SSB'
  },
  0x1D7ED: {
    c: '1',
    f: 'SSB'
  },
  0x1D7EE: {
    c: '2',
    f: 'SSB'
  },
  0x1D7EF: {
    c: '3',
    f: 'SSB'
  },
  0x1D7F0: {
    c: '4',
    f: 'SSB'
  },
  0x1D7F1: {
    c: '5',
    f: 'SSB'
  },
  0x1D7F2: {
    c: '6',
    f: 'SSB'
  },
  0x1D7F3: {
    c: '7',
    f: 'SSB'
  },
  0x1D7F4: {
    c: '8',
    f: 'SSB'
  },
  0x1D7F5: {
    c: '9',
    f: 'SSB'
  },
  0x1D7F6: {
    c: '0',
    f: 'T'
  },
  0x1D7F7: {
    c: '1',
    f: 'T'
  },
  0x1D7F8: {
    c: '2',
    f: 'T'
  },
  0x1D7F9: {
    c: '3',
    f: 'T'
  },
  0x1D7FA: {
    c: '4',
    f: 'T'
  },
  0x1D7FB: {
    c: '5',
    f: 'T'
  },
  0x1D7FC: {
    c: '6',
    f: 'T'
  },
  0x1D7FD: {
    c: '7',
    f: 'T'
  },
  0x1D7FE: {
    c: '8',
    f: 'T'
  },
  0x1D7FF: {
    c: '9',
    f: 'T'
  }
});

var sansSerifBoldItalic$1 = {};

var sansSerifBoldItalic = {};

Object.defineProperty(sansSerifBoldItalic, "__esModule", {
  value: true
});
sansSerifBoldItalic.sansSerifBoldItalic = void 0;
sansSerifBoldItalic.sansSerifBoldItalic = {
  0x131: [.458, 0, .256],
  0x237: [.458, .205, .286]
};

Object.defineProperty(sansSerifBoldItalic$1, "__esModule", {
  value: true
});
sansSerifBoldItalic$1.sansSerifBoldItalic = void 0;
var FontData_js_1$9 = FontData;
var sans_serif_bold_italic_js_1$1 = sansSerifBoldItalic;
sansSerifBoldItalic$1.sansSerifBoldItalic = (0, FontData_js_1$9.AddCSS)(sans_serif_bold_italic_js_1$1.sansSerifBoldItalic, {
  0x131: {
    f: 'SSB'
  },
  0x237: {
    f: 'SSB'
  }
});

var sansSerifBold$1 = {};

var sansSerifBold = {};

Object.defineProperty(sansSerifBold, "__esModule", {
  value: true
});
sansSerifBold.sansSerifBold = void 0;
sansSerifBold.sansSerifBold = {
  0x21: [.694, 0, .367],
  0x22: [.694, -0.442, .558],
  0x23: [.694, .193, .917],
  0x24: [.75, .056, .55],
  0x25: [.75, .056, 1.029],
  0x26: [.716, .022, .831],
  0x27: [.694, -0.442, .306],
  0x28: [.75, .249, .428],
  0x29: [.75, .25, .428],
  0x2A: [.75, -0.293, .55],
  0x2B: [.617, .116, .856],
  0x2C: [.146, .106, .306],
  0x2D: [.273, -0.186, .367],
  0x2E: [.146, 0, .306],
  0x2F: [.75, .249, .55],
  0x3A: [.458, 0, .306],
  0x3B: [.458, .106, .306],
  0x3D: [.407, -0.094, .856],
  0x3F: [.705, 0, .519],
  0x40: [.704, .011, .733],
  0x5B: [.75, .25, .343],
  0x5D: [.75, .25, .343],
  0x5E: [.694, -0.537, .55],
  0x5F: [-0.023, .11, .55],
  0x7E: [.344, -0.198, .55],
  0x131: [.458, 0, .256],
  0x237: [.458, .205, .286],
  0x300: [.694, -0.537, 0],
  0x301: [.694, -0.537, 0],
  0x302: [.694, -0.537, 0],
  0x303: [.694, -0.548, 0],
  0x304: [.66, -0.56, 0],
  0x306: [.694, -0.552, 0],
  0x307: [.695, -0.596, 0],
  0x308: [.695, -0.595, 0],
  0x30A: [.694, -0.538, 0],
  0x30B: [.694, -0.537, 0],
  0x30C: [.657, -0.5, 0],
  0x2013: [.327, -0.24, .55],
  0x2014: [.327, -0.24, 1.1],
  0x2015: [.327, -0.24, 1.1],
  0x2017: [-0.023, .11, .55],
  0x2018: [.694, -0.443, .306],
  0x2019: [.694, -0.442, .306],
  0x201C: [.694, -0.443, .558],
  0x201D: [.694, -0.442, .558],
  0x2044: [.75, .249, .55],
  0x2206: [.694, 0, .917]
};

Object.defineProperty(sansSerifBold$1, "__esModule", {
  value: true
});
sansSerifBold$1.sansSerifBold = void 0;
var FontData_js_1$8 = FontData;
var sans_serif_bold_js_1$1 = sansSerifBold;
sansSerifBold$1.sansSerifBold = (0, FontData_js_1$8.AddCSS)(sans_serif_bold_js_1$1.sansSerifBold, {
  0x2015: {
    c: '\\2014'
  },
  0x2017: {
    c: '_'
  },
  0x2044: {
    c: '/'
  },
  0x2206: {
    c: '\\394'
  }
});

var sansSerifItalic$1 = {};

var sansSerifItalic = {};

Object.defineProperty(sansSerifItalic, "__esModule", {
  value: true
});
sansSerifItalic.sansSerifItalic = void 0;
sansSerifItalic.sansSerifItalic = {
  0x21: [.694, 0, .319, {
    ic: .036
  }],
  0x22: [.694, -0.471, .5],
  0x23: [.694, .194, .833, {
    ic: .018
  }],
  0x24: [.75, .056, .5, {
    ic: .065
  }],
  0x25: [.75, .056, .833],
  0x26: [.716, .022, .758],
  0x27: [.694, -0.471, .278, {
    ic: .057
  }],
  0x28: [.75, .25, .389, {
    ic: .102
  }],
  0x29: [.75, .25, .389],
  0x2A: [.75, -0.306, .5, {
    ic: .068
  }],
  0x2B: [.583, .083, .778],
  0x2C: [.098, .125, .278],
  0x2D: [.259, -0.186, .333],
  0x2E: [.098, 0, .278],
  0x2F: [.75, .25, .5, {
    ic: .1
  }],
  0x30: [.678, .022, .5, {
    ic: .049
  }],
  0x31: [.678, 0, .5],
  0x32: [.678, 0, .5, {
    ic: .051
  }],
  0x33: [.678, .022, .5, {
    ic: .044
  }],
  0x34: [.656, 0, .5, {
    ic: .021
  }],
  0x35: [.656, .022, .5, {
    ic: .055
  }],
  0x36: [.678, .022, .5, {
    ic: .048
  }],
  0x37: [.656, .011, .5, {
    ic: .096
  }],
  0x38: [.678, .022, .5, {
    ic: .054
  }],
  0x39: [.677, .022, .5, {
    ic: .045
  }],
  0x3A: [.444, 0, .278],
  0x3B: [.444, .125, .278],
  0x3D: [.37, -0.13, .778, {
    ic: .018
  }],
  0x3F: [.704, 0, .472, {
    ic: .064
  }],
  0x40: [.705, .01, .667, {
    ic: .04
  }],
  0x5B: [.75, .25, .289, {
    ic: .136
  }],
  0x5D: [.75, .25, .289, {
    ic: .064
  }],
  0x5E: [.694, -0.527, .5, {
    ic: .033
  }],
  0x5F: [-0.038, .114, .5, {
    ic: .065
  }],
  0x7E: [.327, -0.193, .5, {
    ic: .06
  }],
  0x131: [.444, 0, .239, {
    ic: .019
  }],
  0x237: [.444, .204, .267, {
    ic: .019
  }],
  0x300: [.694, -0.527, 0],
  0x301: [.694, -0.527, 0, {
    ic: .063
  }],
  0x302: [.694, -0.527, 0, {
    ic: .033
  }],
  0x303: [.677, -0.543, 0, {
    ic: .06
  }],
  0x304: [.631, -0.552, 0, {
    ic: .064
  }],
  0x306: [.694, -0.508, 0, {
    ic: .073
  }],
  0x307: [.68, -0.576, 0],
  0x308: [.68, -0.582, 0, {
    ic: .04
  }],
  0x30A: [.693, -0.527, 0],
  0x30B: [.694, -0.527, 0, {
    ic: .063
  }],
  0x30C: [.654, -0.487, 0, {
    ic: .06
  }],
  0x391: [.694, 0, .667],
  0x392: [.694, 0, .667, {
    ic: .029
  }],
  0x393: [.691, 0, .542, {
    ic: .104
  }],
  0x394: [.694, 0, .833],
  0x395: [.691, 0, .597, {
    ic: .091
  }],
  0x396: [.694, 0, .611, {
    ic: .091
  }],
  0x397: [.694, 0, .708, {
    ic: .06
  }],
  0x398: [.715, .022, .778, {
    ic: .026
  }],
  0x399: [.694, 0, .278, {
    ic: .06
  }],
  0x39A: [.694, 0, .694, {
    ic: .091
  }],
  0x39B: [.694, 0, .611],
  0x39C: [.694, 0, .875, {
    ic: .054
  }],
  0x39D: [.694, 0, .708, {
    ic: .058
  }],
  0x39E: [.688, 0, .667, {
    ic: .098
  }],
  0x39F: [.716, .022, .736, {
    ic: .027
  }],
  0x3A0: [.691, 0, .708, {
    ic: .06
  }],
  0x3A1: [.694, 0, .639, {
    ic: .051
  }],
  0x3A3: [.694, 0, .722, {
    ic: .091
  }],
  0x3A4: [.688, 0, .681, {
    ic: .109
  }],
  0x3A5: [.716, 0, .778, {
    ic: .065
  }],
  0x3A6: [.694, 0, .722, {
    ic: .021
  }],
  0x3A7: [.694, 0, .667, {
    ic: .091
  }],
  0x3A8: [.694, 0, .778, {
    ic: .076
  }],
  0x3A9: [.716, 0, .722, {
    ic: .047
  }],
  0x2013: [.312, -0.236, .5, {
    ic: .065
  }],
  0x2014: [.312, -0.236, 1, {
    ic: .065
  }],
  0x2015: [.312, -0.236, 1, {
    ic: .065
  }],
  0x2017: [-0.038, .114, .5, {
    ic: .065
  }],
  0x2018: [.694, -0.471, .278, {
    ic: .058
  }],
  0x2019: [.694, -0.471, .278, {
    ic: .057
  }],
  0x201C: [.694, -0.471, .5, {
    ic: .114
  }],
  0x201D: [.694, -0.471, .5],
  0x2044: [.75, .25, .5, {
    ic: .1
  }],
  0x2206: [.694, 0, .833]
};

Object.defineProperty(sansSerifItalic$1, "__esModule", {
  value: true
});
sansSerifItalic$1.sansSerifItalic = void 0;
var FontData_js_1$7 = FontData;
var sans_serif_italic_js_1$1 = sansSerifItalic;
sansSerifItalic$1.sansSerifItalic = (0, FontData_js_1$7.AddCSS)(sans_serif_italic_js_1$1.sansSerifItalic, {
  0x391: {
    c: 'A'
  },
  0x392: {
    c: 'B'
  },
  0x395: {
    c: 'E'
  },
  0x396: {
    c: 'Z'
  },
  0x397: {
    c: 'H'
  },
  0x399: {
    c: 'I'
  },
  0x39A: {
    c: 'K'
  },
  0x39C: {
    c: 'M'
  },
  0x39D: {
    c: 'N'
  },
  0x39F: {
    c: 'O'
  },
  0x3A1: {
    c: 'P'
  },
  0x3A4: {
    c: 'T'
  },
  0x3A7: {
    c: 'X'
  },
  0x2015: {
    c: '\\2014'
  },
  0x2017: {
    c: '_'
  },
  0x2044: {
    c: '/'
  },
  0x2206: {
    c: '\\394'
  }
});

var sansSerif$1 = {};

var sansSerif = {};

Object.defineProperty(sansSerif, "__esModule", {
  value: true
});
sansSerif.sansSerif = void 0;
sansSerif.sansSerif = {
  0x21: [.694, 0, .319],
  0x22: [.694, -0.471, .5],
  0x23: [.694, .194, .833],
  0x24: [.75, .056, .5],
  0x25: [.75, .056, .833],
  0x26: [.716, .022, .758],
  0x27: [.694, -0.471, .278],
  0x28: [.75, .25, .389],
  0x29: [.75, .25, .389],
  0x2A: [.75, -0.306, .5],
  0x2B: [.583, .082, .778],
  0x2C: [.098, .125, .278],
  0x2D: [.259, -0.186, .333],
  0x2E: [.098, 0, .278],
  0x2F: [.75, .25, .5],
  0x3A: [.444, 0, .278],
  0x3B: [.444, .125, .278],
  0x3D: [.37, -0.13, .778],
  0x3F: [.704, 0, .472],
  0x40: [.704, .011, .667],
  0x5B: [.75, .25, .289],
  0x5D: [.75, .25, .289],
  0x5E: [.694, -0.527, .5],
  0x5F: [-0.038, .114, .5],
  0x7E: [.327, -0.193, .5],
  0x131: [.444, 0, .239],
  0x237: [.444, .205, .267],
  0x300: [.694, -0.527, 0],
  0x301: [.694, -0.527, 0],
  0x302: [.694, -0.527, 0],
  0x303: [.677, -0.543, 0],
  0x304: [.631, -0.552, 0],
  0x306: [.694, -0.508, 0],
  0x307: [.68, -0.576, 0],
  0x308: [.68, -0.582, 0],
  0x30A: [.694, -0.527, 0],
  0x30B: [.694, -0.527, 0],
  0x30C: [.654, -0.487, 0],
  0x391: [.694, 0, .667],
  0x392: [.694, 0, .667],
  0x393: [.691, 0, .542],
  0x394: [.694, 0, .833],
  0x395: [.691, 0, .597],
  0x396: [.694, 0, .611],
  0x397: [.694, 0, .708],
  0x398: [.716, .021, .778],
  0x399: [.694, 0, .278],
  0x39A: [.694, 0, .694],
  0x39B: [.694, 0, .611],
  0x39C: [.694, 0, .875],
  0x39D: [.694, 0, .708],
  0x39E: [.688, 0, .667],
  0x39F: [.715, .022, .736],
  0x3A0: [.691, 0, .708],
  0x3A1: [.694, 0, .639],
  0x3A3: [.694, 0, .722],
  0x3A4: [.688, 0, .681],
  0x3A5: [.716, 0, .778],
  0x3A6: [.694, 0, .722],
  0x3A7: [.694, 0, .667],
  0x3A8: [.694, 0, .778],
  0x3A9: [.716, 0, .722],
  0x2013: [.312, -0.236, .5],
  0x2014: [.312, -0.236, 1],
  0x2015: [.312, -0.236, 1],
  0x2017: [-0.038, .114, .5],
  0x2018: [.694, -0.471, .278],
  0x2019: [.694, -0.471, .278],
  0x201C: [.694, -0.471, .5],
  0x201D: [.694, -0.471, .5],
  0x2044: [.75, .25, .5],
  0x2206: [.694, 0, .833]
};

Object.defineProperty(sansSerif$1, "__esModule", {
  value: true
});
sansSerif$1.sansSerif = void 0;
var FontData_js_1$6 = FontData;
var sans_serif_js_1$1 = sansSerif;
sansSerif$1.sansSerif = (0, FontData_js_1$6.AddCSS)(sans_serif_js_1$1.sansSerif, {
  0x391: {
    c: 'A'
  },
  0x392: {
    c: 'B'
  },
  0x395: {
    c: 'E'
  },
  0x396: {
    c: 'Z'
  },
  0x397: {
    c: 'H'
  },
  0x399: {
    c: 'I'
  },
  0x39A: {
    c: 'K'
  },
  0x39C: {
    c: 'M'
  },
  0x39D: {
    c: 'N'
  },
  0x39F: {
    c: 'O'
  },
  0x3A1: {
    c: 'P'
  },
  0x3A4: {
    c: 'T'
  },
  0x3A7: {
    c: 'X'
  },
  0x2015: {
    c: '\\2014'
  },
  0x2017: {
    c: '_'
  },
  0x2044: {
    c: '/'
  },
  0x2206: {
    c: '\\394'
  }
});

var scriptBold$1 = {};

var scriptBold = {};

Object.defineProperty(scriptBold, "__esModule", {
  value: true
});
scriptBold.scriptBold = void 0;
scriptBold.scriptBold = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.scriptBold = void 0;
  var script_bold_js_1 = scriptBold;
  Object.defineProperty(exports, "scriptBold", {
    enumerable: true,
    get: function () {
      return script_bold_js_1.scriptBold;
    }
  });
})(scriptBold$1);
getDefaultExportFromCjs(scriptBold$1);

var script$1 = {};

var script = {};

Object.defineProperty(script, "__esModule", {
  value: true
});
script.script = void 0;
script.script = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.script = void 0;
  var script_js_1 = script;
  Object.defineProperty(exports, "script", {
    enumerable: true,
    get: function () {
      return script_js_1.script;
    }
  });
})(script$1);
getDefaultExportFromCjs(script$1);

var smallop$1 = {};

var smallop = {};

Object.defineProperty(smallop, "__esModule", {
  value: true
});
smallop.smallop = void 0;
smallop.smallop = {
  0x28: [.85, .349, .458],
  0x29: [.85, .349, .458],
  0x2F: [.85, .349, .578],
  0x5B: [.85, .349, .417],
  0x5C: [.85, .349, .578],
  0x5D: [.85, .349, .417],
  0x7B: [.85, .349, .583],
  0x7D: [.85, .349, .583],
  0x2C6: [.744, -0.551, .556],
  0x2DC: [.722, -0.597, .556],
  0x302: [.744, -0.551, 0],
  0x303: [.722, -0.597, 0],
  0x2016: [.602, 0, .778],
  0x2044: [.85, .349, .578],
  0x2191: [.6, 0, .667],
  0x2193: [.6, 0, .667],
  0x21D1: [.599, 0, .778],
  0x21D3: [.6, 0, .778],
  0x220F: [.75, .25, .944],
  0x2210: [.75, .25, .944],
  0x2211: [.75, .25, 1.056],
  0x221A: [.85, .35, 1, {
    ic: .02
  }],
  0x2223: [.627, .015, .333],
  0x2225: [.627, .015, .556],
  0x222B: [.805, .306, .472, {
    ic: .138
  }],
  0x222C: [.805, .306, .819, {
    ic: .138
  }],
  0x222D: [.805, .306, 1.166, {
    ic: .138
  }],
  0x222E: [.805, .306, .472, {
    ic: .138
  }],
  0x22C0: [.75, .249, .833],
  0x22C1: [.75, .249, .833],
  0x22C2: [.75, .249, .833],
  0x22C3: [.75, .249, .833],
  0x2308: [.85, .349, .472],
  0x2309: [.85, .349, .472],
  0x230A: [.85, .349, .472],
  0x230B: [.85, .349, .472],
  0x2329: [.85, .35, .472],
  0x232A: [.85, .35, .472],
  0x23D0: [.602, 0, .667],
  0x2758: [.627, .015, .333],
  0x27E8: [.85, .35, .472],
  0x27E9: [.85, .35, .472],
  0x2A00: [.75, .25, 1.111],
  0x2A01: [.75, .25, 1.111],
  0x2A02: [.75, .25, 1.111],
  0x2A04: [.75, .249, .833],
  0x2A06: [.75, .249, .833],
  0x2A0C: [.805, .306, 1.638, {
    ic: .138
  }],
  0x3008: [.85, .35, .472],
  0x3009: [.85, .35, .472]
};

Object.defineProperty(smallop$1, "__esModule", {
  value: true
});
smallop$1.smallop = void 0;
var FontData_js_1$5 = FontData;
var smallop_js_1$1 = smallop;
smallop$1.smallop = (0, FontData_js_1$5.AddCSS)(smallop_js_1$1.smallop, {
  0x2044: {
    c: '/'
  },
  0x2329: {
    c: '\\27E8'
  },
  0x232A: {
    c: '\\27E9'
  },
  0x2758: {
    c: '\\2223'
  },
  0x2A0C: {
    c: '\\222C\\222C'
  },
  0x3008: {
    c: '\\27E8'
  },
  0x3009: {
    c: '\\27E9'
  }
});

var texCalligraphicBold$1 = {};

var texCalligraphicBold = {};

Object.defineProperty(texCalligraphicBold, "__esModule", {
  value: true
});
texCalligraphicBold.texCalligraphicBold = void 0;
texCalligraphicBold.texCalligraphicBold = {
  0x41: [.751, .049, .921, {
    ic: .068,
    sk: .224
  }],
  0x42: [.705, .017, .748, {
    sk: .16
  }],
  0x43: [.703, .02, .613, {
    sk: .16
  }],
  0x44: [.686, 0, .892, {
    sk: .0958
  }],
  0x45: [.703, .016, .607, {
    ic: .02,
    sk: .128
  }],
  0x46: [.686, .03, .814, {
    ic: .116,
    sk: .128
  }],
  0x47: [.703, .113, .682, {
    sk: .128
  }],
  0x48: [.686, .048, .987, {
    sk: .128
  }],
  0x49: [.686, 0, .642, {
    ic: .104,
    sk: .0319
  }],
  0x4A: [.686, .114, .779, {
    ic: .158,
    sk: .192
  }],
  0x4B: [.703, .017, .871, {
    sk: .0639
  }],
  0x4C: [.703, .017, .788, {
    sk: .16
  }],
  0x4D: [.703, .049, 1.378, {
    sk: .16
  }],
  0x4E: [.84, .049, .937, {
    ic: .168,
    sk: .0958
  }],
  0x4F: [.703, .017, .906, {
    sk: .128
  }],
  0x50: [.686, .067, .81, {
    ic: .036,
    sk: .0958
  }],
  0x51: [.703, .146, .939, {
    sk: .128
  }],
  0x52: [.686, .017, .99, {
    sk: .0958
  }],
  0x53: [.703, .016, .696, {
    ic: .025,
    sk: .16
  }],
  0x54: [.72, .069, .644, {
    ic: .303,
    sk: .0319
  }],
  0x55: [.686, .024, .715, {
    ic: .056,
    sk: .0958
  }],
  0x56: [.686, .077, .737, {
    ic: .037,
    sk: .0319
  }],
  0x57: [.686, .077, 1.169, {
    ic: .037,
    sk: .0958
  }],
  0x58: [.686, 0, .817, {
    ic: .089,
    sk: .16
  }],
  0x59: [.686, .164, .759, {
    ic: .038,
    sk: .0958
  }],
  0x5A: [.686, 0, .818, {
    ic: .035,
    sk: .16
  }],
  0x131: [.452, .008, .394, {
    sk: .0319
  }],
  0x237: [.451, .201, .439, {
    sk: .0958
  }]
};

Object.defineProperty(texCalligraphicBold$1, "__esModule", {
  value: true
});
texCalligraphicBold$1.texCalligraphicBold = void 0;
var FontData_js_1$4 = FontData;
var tex_calligraphic_bold_js_1$1 = texCalligraphicBold;
texCalligraphicBold$1.texCalligraphicBold = (0, FontData_js_1$4.AddCSS)(tex_calligraphic_bold_js_1$1.texCalligraphicBold, {
  0x131: {
    f: 'B'
  },
  0x237: {
    f: 'B'
  }
});

var texCalligraphic$1 = {};

var texCalligraphic = {};

Object.defineProperty(texCalligraphic, "__esModule", {
  value: true
});
texCalligraphic.texCalligraphic = void 0;
texCalligraphic.texCalligraphic = {
  0x41: [.728, .05, .798, {
    ic: .021,
    sk: .194
  }],
  0x42: [.705, .022, .657, {
    sk: .139
  }],
  0x43: [.705, .025, .527, {
    sk: .139
  }],
  0x44: [.683, 0, .771, {
    sk: .0833
  }],
  0x45: [.705, .022, .528, {
    ic: .036,
    sk: .111
  }],
  0x46: [.683, .032, .719, {
    ic: .11,
    sk: .111
  }],
  0x47: [.704, .119, .595, {
    sk: .111
  }],
  0x48: [.683, .048, .845, {
    sk: .111
  }],
  0x49: [.683, 0, .545, {
    ic: .097,
    sk: .0278
  }],
  0x4A: [.683, .119, .678, {
    ic: .161,
    sk: .167
  }],
  0x4B: [.705, .022, .762, {
    sk: .0556
  }],
  0x4C: [.705, .022, .69, {
    sk: .139
  }],
  0x4D: [.705, .05, 1.201, {
    sk: .139
  }],
  0x4E: [.789, .05, .82, {
    ic: .159,
    sk: .0833
  }],
  0x4F: [.705, .022, .796, {
    sk: .111
  }],
  0x50: [.683, .057, .696, {
    ic: .037,
    sk: .0833
  }],
  0x51: [.705, .131, .817, {
    sk: .111
  }],
  0x52: [.682, .022, .848, {
    sk: .0833
  }],
  0x53: [.705, .022, .606, {
    ic: .036,
    sk: .139
  }],
  0x54: [.717, .068, .545, {
    ic: .288,
    sk: .0278
  }],
  0x55: [.683, .028, .626, {
    ic: .061,
    sk: .0833
  }],
  0x56: [.683, .052, .613, {
    ic: .045,
    sk: .0278
  }],
  0x57: [.683, .053, .988, {
    ic: .046,
    sk: .0833
  }],
  0x58: [.683, 0, .713, {
    ic: .094,
    sk: .139
  }],
  0x59: [.683, .143, .668, {
    ic: .046,
    sk: .0833
  }],
  0x5A: [.683, 0, .725, {
    ic: .042,
    sk: .139
  }]
};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.texCalligraphic = void 0;
  var tex_calligraphic_js_1 = texCalligraphic;
  Object.defineProperty(exports, "texCalligraphic", {
    enumerable: true,
    get: function () {
      return tex_calligraphic_js_1.texCalligraphic;
    }
  });
})(texCalligraphic$1);
getDefaultExportFromCjs(texCalligraphic$1);

var texMathit$1 = {};

var texMathit = {};

Object.defineProperty(texMathit, "__esModule", {
  value: true
});
texMathit.texMathit = void 0;
texMathit.texMathit = {
  0x41: [.716, 0, .743],
  0x42: [.683, 0, .704],
  0x43: [.705, .021, .716],
  0x44: [.683, 0, .755],
  0x45: [.68, 0, .678],
  0x46: [.68, 0, .653],
  0x47: [.705, .022, .774],
  0x48: [.683, 0, .743],
  0x49: [.683, 0, .386],
  0x4A: [.683, .021, .525],
  0x4B: [.683, 0, .769],
  0x4C: [.683, 0, .627],
  0x4D: [.683, 0, .897],
  0x4E: [.683, 0, .743],
  0x4F: [.704, .022, .767],
  0x50: [.683, 0, .678],
  0x51: [.704, .194, .767],
  0x52: [.683, .022, .729],
  0x53: [.705, .022, .562],
  0x54: [.677, 0, .716],
  0x55: [.683, .022, .743],
  0x56: [.683, .022, .743],
  0x57: [.683, .022, .999],
  0x58: [.683, 0, .743],
  0x59: [.683, 0, .743],
  0x5A: [.683, 0, .613],
  0x61: [.442, .011, .511],
  0x62: [.694, .011, .46],
  0x63: [.441, .01, .46],
  0x64: [.694, .011, .511],
  0x65: [.442, .01, .46],
  0x66: [.705, .204, .307],
  0x67: [.442, .205, .46],
  0x68: [.694, .011, .511],
  0x69: [.656, .01, .307],
  0x6A: [.656, .204, .307],
  0x6B: [.694, .011, .46],
  0x6C: [.694, .011, .256],
  0x6D: [.442, .011, .818],
  0x6E: [.442, .011, .562],
  0x6F: [.442, .011, .511],
  0x70: [.442, .194, .511],
  0x71: [.442, .194, .46],
  0x72: [.442, .011, .422],
  0x73: [.442, .011, .409],
  0x74: [.626, .011, .332],
  0x75: [.441, .011, .537],
  0x76: [.443, .01, .46],
  0x77: [.443, .011, .664],
  0x78: [.442, .011, .464],
  0x79: [.441, .205, .486],
  0x7A: [.442, .011, .409]
};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.texMathit = void 0;
  var tex_mathit_js_1 = texMathit;
  Object.defineProperty(exports, "texMathit", {
    enumerable: true,
    get: function () {
      return tex_mathit_js_1.texMathit;
    }
  });
})(texMathit$1);
getDefaultExportFromCjs(texMathit$1);

var texOldstyleBold$1 = {};

var texOldstyleBold = {};

Object.defineProperty(texOldstyleBold, "__esModule", {
  value: true
});
texOldstyleBold.texOldstyleBold = void 0;
texOldstyleBold.texOldstyleBold = {
  0x30: [.46, .017, .575],
  0x31: [.461, 0, .575],
  0x32: [.46, 0, .575],
  0x33: [.461, .211, .575],
  0x34: [.469, .194, .575],
  0x35: [.461, .211, .575],
  0x36: [.66, .017, .575],
  0x37: [.476, .211, .575],
  0x38: [.661, .017, .575],
  0x39: [.461, .21, .575],
  0x41: [.751, .049, .921, {
    ic: .068,
    sk: .224
  }],
  0x42: [.705, .017, .748, {
    sk: .16
  }],
  0x43: [.703, .02, .613, {
    sk: .16
  }],
  0x44: [.686, 0, .892, {
    sk: .0958
  }],
  0x45: [.703, .016, .607, {
    ic: .02,
    sk: .128
  }],
  0x46: [.686, .03, .814, {
    ic: .116,
    sk: .128
  }],
  0x47: [.703, .113, .682, {
    sk: .128
  }],
  0x48: [.686, .048, .987, {
    sk: .128
  }],
  0x49: [.686, 0, .642, {
    ic: .104,
    sk: .0319
  }],
  0x4A: [.686, .114, .779, {
    ic: .158,
    sk: .192
  }],
  0x4B: [.703, .017, .871, {
    sk: .0639
  }],
  0x4C: [.703, .017, .788, {
    sk: .16
  }],
  0x4D: [.703, .049, 1.378, {
    sk: .16
  }],
  0x4E: [.84, .049, .937, {
    ic: .168,
    sk: .0958
  }],
  0x4F: [.703, .017, .906, {
    sk: .128
  }],
  0x50: [.686, .067, .81, {
    ic: .036,
    sk: .0958
  }],
  0x51: [.703, .146, .939, {
    sk: .128
  }],
  0x52: [.686, .017, .99, {
    sk: .0958
  }],
  0x53: [.703, .016, .696, {
    ic: .025,
    sk: .16
  }],
  0x54: [.72, .069, .644, {
    ic: .303,
    sk: .0319
  }],
  0x55: [.686, .024, .715, {
    ic: .056,
    sk: .0958
  }],
  0x56: [.686, .077, .737, {
    ic: .037,
    sk: .0319
  }],
  0x57: [.686, .077, 1.169, {
    ic: .037,
    sk: .0958
  }],
  0x58: [.686, 0, .817, {
    ic: .089,
    sk: .16
  }],
  0x59: [.686, .164, .759, {
    ic: .038,
    sk: .0958
  }],
  0x5A: [.686, 0, .818, {
    ic: .035,
    sk: .16
  }]
};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.texOldstyleBold = void 0;
  var tex_oldstyle_bold_js_1 = texOldstyleBold;
  Object.defineProperty(exports, "texOldstyleBold", {
    enumerable: true,
    get: function () {
      return tex_oldstyle_bold_js_1.texOldstyleBold;
    }
  });
})(texOldstyleBold$1);
getDefaultExportFromCjs(texOldstyleBold$1);

var texOldstyle$1 = {};

var texOldstyle = {};

Object.defineProperty(texOldstyle, "__esModule", {
  value: true
});
texOldstyle.texOldstyle = void 0;
texOldstyle.texOldstyle = {
  0x30: [.452, .022, .5],
  0x31: [.453, 0, .5],
  0x32: [.453, 0, .5],
  0x33: [.452, .216, .5],
  0x34: [.464, .194, .5],
  0x35: [.453, .216, .5],
  0x36: [.665, .022, .5],
  0x37: [.463, .216, .5],
  0x38: [.666, .021, .5],
  0x39: [.453, .216, .5],
  0x41: [.728, .05, .798, {
    ic: .021,
    sk: .194
  }],
  0x42: [.705, .022, .657, {
    sk: .139
  }],
  0x43: [.705, .025, .527, {
    sk: .139
  }],
  0x44: [.683, 0, .771, {
    sk: .0833
  }],
  0x45: [.705, .022, .528, {
    ic: .036,
    sk: .111
  }],
  0x46: [.683, .032, .719, {
    ic: .11,
    sk: .111
  }],
  0x47: [.704, .119, .595, {
    sk: .111
  }],
  0x48: [.683, .048, .845, {
    sk: .111
  }],
  0x49: [.683, 0, .545, {
    ic: .097,
    sk: .0278
  }],
  0x4A: [.683, .119, .678, {
    ic: .161,
    sk: .167
  }],
  0x4B: [.705, .022, .762, {
    sk: .0556
  }],
  0x4C: [.705, .022, .69, {
    sk: .139
  }],
  0x4D: [.705, .05, 1.201, {
    sk: .139
  }],
  0x4E: [.789, .05, .82, {
    ic: .159,
    sk: .0833
  }],
  0x4F: [.705, .022, .796, {
    sk: .111
  }],
  0x50: [.683, .057, .696, {
    ic: .037,
    sk: .0833
  }],
  0x51: [.705, .131, .817, {
    sk: .111
  }],
  0x52: [.682, .022, .848, {
    sk: .0833
  }],
  0x53: [.705, .022, .606, {
    ic: .036,
    sk: .139
  }],
  0x54: [.717, .068, .545, {
    ic: .288,
    sk: .0278
  }],
  0x55: [.683, .028, .626, {
    ic: .061,
    sk: .0833
  }],
  0x56: [.683, .052, .613, {
    ic: .045,
    sk: .0278
  }],
  0x57: [.683, .053, .988, {
    ic: .046,
    sk: .0833
  }],
  0x58: [.683, 0, .713, {
    ic: .094,
    sk: .139
  }],
  0x59: [.683, .143, .668, {
    ic: .046,
    sk: .0833
  }],
  0x5A: [.683, 0, .725, {
    ic: .042,
    sk: .139
  }]
};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.texOldstyle = void 0;
  var tex_oldstyle_js_1 = texOldstyle;
  Object.defineProperty(exports, "texOldstyle", {
    enumerable: true,
    get: function () {
      return tex_oldstyle_js_1.texOldstyle;
    }
  });
})(texOldstyle$1);
getDefaultExportFromCjs(texOldstyle$1);

var texSize3$1 = {};

var texSize3 = {};

Object.defineProperty(texSize3, "__esModule", {
  value: true
});
texSize3.texSize3 = void 0;
texSize3.texSize3 = {
  0x28: [1.45, .949, .736],
  0x29: [1.45, .949, .736],
  0x2F: [1.45, .949, 1.044],
  0x5B: [1.45, .949, .528],
  0x5C: [1.45, .949, 1.044],
  0x5D: [1.45, .949, .528],
  0x7B: [1.45, .949, .75],
  0x7D: [1.45, .949, .75],
  0x2C6: [.772, -0.564, 1.444],
  0x2DC: [.749, -0.61, 1.444],
  0x302: [.772, -0.564, 0],
  0x303: [.749, -0.61, 0],
  0x2044: [1.45, .949, 1.044],
  0x221A: [1.45, .95, 1, {
    ic: .02
  }],
  0x2308: [1.45, .949, .583],
  0x2309: [1.45, .949, .583],
  0x230A: [1.45, .949, .583],
  0x230B: [1.45, .949, .583],
  0x2329: [1.45, .95, .75],
  0x232A: [1.45, .949, .75],
  0x27E8: [1.45, .95, .75],
  0x27E9: [1.45, .949, .75],
  0x3008: [1.45, .95, .75],
  0x3009: [1.45, .949, .75]
};

Object.defineProperty(texSize3$1, "__esModule", {
  value: true
});
texSize3$1.texSize3 = void 0;
var FontData_js_1$3 = FontData;
var tex_size3_js_1$1 = texSize3;
texSize3$1.texSize3 = (0, FontData_js_1$3.AddCSS)(tex_size3_js_1$1.texSize3, {
  0x2044: {
    c: '/'
  },
  0x2329: {
    c: '\\27E8'
  },
  0x232A: {
    c: '\\27E9'
  },
  0x3008: {
    c: '\\27E8'
  },
  0x3009: {
    c: '\\27E9'
  }
});

var texSize4$1 = {};

var texSize4 = {};

Object.defineProperty(texSize4, "__esModule", {
  value: true
});
texSize4.texSize4 = void 0;
texSize4.texSize4 = {
  0x28: [1.75, 1.249, .792],
  0x29: [1.75, 1.249, .792],
  0x2F: [1.75, 1.249, 1.278],
  0x5B: [1.75, 1.249, .583],
  0x5C: [1.75, 1.249, 1.278],
  0x5D: [1.75, 1.249, .583],
  0x7B: [1.75, 1.249, .806],
  0x7D: [1.75, 1.249, .806],
  0x2C6: [.845, -0.561, 1.889, {
    ic: .013
  }],
  0x2DC: [.823, -0.583, 1.889],
  0x302: [.845, -0.561, 0, {
    ic: .013
  }],
  0x303: [.823, -0.583, 0],
  0x2044: [1.75, 1.249, 1.278],
  0x221A: [1.75, 1.25, 1, {
    ic: .02
  }],
  0x2308: [1.75, 1.249, .639],
  0x2309: [1.75, 1.249, .639],
  0x230A: [1.75, 1.249, .639],
  0x230B: [1.75, 1.249, .639],
  0x2329: [1.75, 1.248, .806],
  0x232A: [1.75, 1.248, .806],
  0x239B: [1.154, .655, .875],
  0x239C: [.61, .01, .875],
  0x239D: [1.165, .644, .875],
  0x239E: [1.154, .655, .875],
  0x239F: [.61, .01, .875],
  0x23A0: [1.165, .644, .875],
  0x23A1: [1.154, .645, .667],
  0x23A2: [.602, 0, .667],
  0x23A3: [1.155, .644, .667],
  0x23A4: [1.154, .645, .667],
  0x23A5: [.602, 0, .667],
  0x23A6: [1.155, .644, .667],
  0x23A7: [.899, .01, .889],
  0x23A8: [1.16, .66, .889],
  0x23A9: [.01, .899, .889],
  0x23AA: [.29, .015, .889],
  0x23AB: [.899, .01, .889],
  0x23AC: [1.16, .66, .889],
  0x23AD: [.01, .899, .889],
  0x23B7: [.935, .885, 1.056],
  0x27E8: [1.75, 1.248, .806],
  0x27E9: [1.75, 1.248, .806],
  0x3008: [1.75, 1.248, .806],
  0x3009: [1.75, 1.248, .806],
  0xE000: [.625, .014, 1.056],
  0xE001: [.605, .014, 1.056, {
    ic: .02
  }],
  0xE150: [.12, .213, .45, {
    ic: .01
  }],
  0xE151: [.12, .213, .45, {
    ic: .024
  }],
  0xE152: [.333, 0, .45, {
    ic: .01
  }],
  0xE153: [.333, 0, .45, {
    ic: .024
  }],
  0xE154: [.32, .2, .4, {
    ic: .01
  }],
  0xE155: [.333, 0, .9, {
    ic: .01
  }],
  0xE156: [.12, .213, .9, {
    ic: .01
  }]
};

Object.defineProperty(texSize4$1, "__esModule", {
  value: true
});
texSize4$1.texSize4 = void 0;
var FontData_js_1$2 = FontData;
var tex_size4_js_1$1 = texSize4;
texSize4$1.texSize4 = (0, FontData_js_1$2.AddCSS)(tex_size4_js_1$1.texSize4, {
  0x2044: {
    c: '/'
  },
  0x2329: {
    c: '\\27E8'
  },
  0x232A: {
    c: '\\27E9'
  },
  0x3008: {
    c: '\\27E8'
  },
  0x3009: {
    c: '\\27E9'
  },
  0xE155: {
    c: '\\E153\\E152'
  },
  0xE156: {
    c: '\\E151\\E150'
  }
});

var texVariant$1 = {};

var texVariant = {};

Object.defineProperty(texVariant, "__esModule", {
  value: true
});
texVariant.texVariant = void 0;
texVariant.texVariant = {
  0x2C6: [.845, -0.561, 2.333, {
    ic: .013
  }],
  0x2DC: [.899, -0.628, 2.333],
  0x302: [.845, -0.561, 0, {
    ic: .013
  }],
  0x303: [.899, -0.628, 0],
  0x3F0: [.434, .006, .667, {
    ic: .067
  }],
  0x210F: [.695, .013, .54, {
    ic: .022
  }],
  0x2190: [.437, -0.064, .5],
  0x2192: [.437, -0.064, .5],
  0x21CC: [.514, .014, 1],
  0x2204: [.86, .166, .556],
  0x2205: [.587, 0, .778],
  0x2212: [.27, -0.23, .5],
  0x2216: [.43, .023, .778],
  0x221D: [.472, -0.028, .778],
  0x2223: [.43, .023, .222],
  0x2224: [.43, .023, .222, {
    ic: .018
  }],
  0x2225: [.431, .023, .389],
  0x2226: [.431, .024, .389, {
    ic: .018
  }],
  0x223C: [.365, -0.132, .778],
  0x2248: [.481, -0.05, .778],
  0x2268: [.752, .284, .778],
  0x2269: [.752, .284, .778],
  0x2270: [.919, .421, .778],
  0x2271: [.919, .421, .778],
  0x2288: [.828, .33, .778],
  0x2289: [.828, .33, .778],
  0x228A: [.634, .255, .778],
  0x228B: [.634, .254, .778],
  0x22A8: [.694, 0, .611],
  0x22C5: [.189, 0, .278],
  0x2322: [.378, -0.122, .778],
  0x2323: [.378, -0.143, .778],
  0x25B3: [.575, .02, .722],
  0x25BD: [.576, .019, .722],
  0x2A87: [.801, .303, .778],
  0x2A88: [.801, .303, .778],
  0x2ACB: [.752, .332, .778],
  0x2ACC: [.752, .333, .778]
};

Object.defineProperty(texVariant$1, "__esModule", {
  value: true
});
texVariant$1.texVariant = void 0;
var FontData_js_1$1 = FontData;
var tex_variant_js_1$1 = texVariant;
texVariant$1.texVariant = (0, FontData_js_1$1.AddCSS)(tex_variant_js_1$1.texVariant, {
  0x3F0: {
    c: '\\E009'
  },
  0x210F: {
    f: ''
  },
  0x2224: {
    c: '\\E006'
  },
  0x2226: {
    c: '\\E007'
  },
  0x2268: {
    c: '\\E00C'
  },
  0x2269: {
    c: '\\E00D'
  },
  0x2270: {
    c: '\\E011'
  },
  0x2271: {
    c: '\\E00E'
  },
  0x2288: {
    c: '\\E016'
  },
  0x2289: {
    c: '\\E018'
  },
  0x228A: {
    c: '\\E01A'
  },
  0x228B: {
    c: '\\E01B'
  },
  0x2A87: {
    c: '\\E010'
  },
  0x2A88: {
    c: '\\E00F'
  },
  0x2ACB: {
    c: '\\E017'
  },
  0x2ACC: {
    c: '\\E019'
  }
});

var delimiters = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.delimiters = exports.VSIZES = exports.HDW3 = exports.HDW2 = exports.HDW1 = void 0;
  var FontData_js_1 = FontData$2;
  exports.HDW1 = [.75, .25, .875];
  exports.HDW2 = [.85, .349, .667];
  exports.HDW3 = [.583, .082, .5];
  exports.VSIZES = [1, 1.2, 1.8, 2.4, 3];
  var DELIM2F = {
    c: 0x2F,
    dir: FontData_js_1.V,
    sizes: exports.VSIZES
  };
  var DELIMAF = {
    c: 0xAF,
    dir: FontData_js_1.H,
    sizes: [.5],
    stretch: [0, 0xAF],
    HDW: [.59, -0.544, .5]
  };
  var DELIM2C6 = {
    c: 0x2C6,
    dir: FontData_js_1.H,
    sizes: [.5, .556, 1, 1.444, 1.889]
  };
  var DELIM2DC = {
    c: 0x2DC,
    dir: FontData_js_1.H,
    sizes: [.5, .556, 1, 1.444, 1.889]
  };
  var DELIM2013 = {
    c: 0x2013,
    dir: FontData_js_1.H,
    sizes: [.5],
    stretch: [0, 0x2013],
    HDW: [.285, -0.248, .5]
  };
  var DELIM2190 = {
    c: 0x2190,
    dir: FontData_js_1.H,
    sizes: [1],
    stretch: [0x2190, 0x2212],
    HDW: exports.HDW3
  };
  var DELIM2192 = {
    c: 0x2192,
    dir: FontData_js_1.H,
    sizes: [1],
    stretch: [0, 0x2212, 0x2192],
    HDW: exports.HDW3
  };
  var DELIM2194 = {
    c: 0x2194,
    dir: FontData_js_1.H,
    sizes: [1],
    stretch: [0x2190, 0x2212, 0x2192],
    HDW: exports.HDW3
  };
  var DELIM21A4 = {
    c: 0x21A4,
    dir: FontData_js_1.H,
    stretch: [0x2190, 0x2212, 0x2223],
    HDW: exports.HDW3,
    min: 1.278
  };
  var DELIM21A6 = {
    c: 0x21A6,
    dir: FontData_js_1.H,
    sizes: [1],
    stretch: [0x2223, 0x2212, 0x2192],
    HDW: exports.HDW3
  };
  var DELIM21D0 = {
    c: 0x21D0,
    dir: FontData_js_1.H,
    sizes: [1],
    stretch: [0x21D0, 0x3D],
    HDW: exports.HDW3
  };
  var DELIM21D2 = {
    c: 0x21D2,
    dir: FontData_js_1.H,
    sizes: [1],
    stretch: [0, 0x3D, 0x21D2],
    HDW: exports.HDW3
  };
  var DELIM21D4 = {
    c: 0x21D4,
    dir: FontData_js_1.H,
    sizes: [1],
    stretch: [0x21D0, 0x3D, 0x21D2],
    HDW: exports.HDW3
  };
  var DELIM2212 = {
    c: 0x2212,
    dir: FontData_js_1.H,
    sizes: [.778],
    stretch: [0, 0x2212],
    HDW: exports.HDW3
  };
  var DELIM2223 = {
    c: 0x2223,
    dir: FontData_js_1.V,
    sizes: [1],
    stretch: [0, 0x2223],
    HDW: [.627, .015, .333]
  };
  var DELIM23DC = {
    c: 0x23DC,
    dir: FontData_js_1.H,
    sizes: [.778, 1],
    schar: [0x2322, 0x2322],
    variants: [5, 0],
    stretch: [0xE150, 0xE154, 0xE151],
    HDW: [.32, .2, .5]
  };
  var DELIM23DD = {
    c: 0x23DD,
    dir: FontData_js_1.H,
    sizes: [.778, 1],
    schar: [0x2323, 0x2323],
    variants: [5, 0],
    stretch: [0xE152, 0xE154, 0xE153],
    HDW: [.32, .2, .5]
  };
  var DELIM23DE = {
    c: 0x23DE,
    dir: FontData_js_1.H,
    stretch: [0xE150, 0xE154, 0xE151, 0xE155],
    HDW: [.32, .2, .5],
    min: 1.8
  };
  var DELIM23DF = {
    c: 0x23DF,
    dir: FontData_js_1.H,
    stretch: [0xE152, 0xE154, 0xE153, 0xE156],
    HDW: [.32, .2, .5],
    min: 1.8
  };
  var DELIM27E8 = {
    c: 0x27E8,
    dir: FontData_js_1.V,
    sizes: exports.VSIZES
  };
  var DELIM27E9 = {
    c: 0x27E9,
    dir: FontData_js_1.V,
    sizes: exports.VSIZES
  };
  var DELIM2906 = {
    c: 0x2906,
    dir: FontData_js_1.H,
    stretch: [0x21D0, 0x3D, 0x2223],
    HDW: exports.HDW3,
    min: 1.278
  };
  var DELIM2907 = {
    c: 0x2907,
    dir: FontData_js_1.H,
    stretch: [0x22A8, 0x3D, 0x21D2],
    HDW: exports.HDW3,
    min: 1.278
  };
  exports.delimiters = {
    0x28: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x239B, 0x239C, 0x239D],
      HDW: [.85, .349, .875]
    },
    0x29: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x239E, 0x239F, 0x23A0],
      HDW: [.85, .349, .875]
    },
    0x2D: DELIM2212,
    0x2F: DELIM2F,
    0x3D: {
      dir: FontData_js_1.H,
      sizes: [.778],
      stretch: [0, 0x3D],
      HDW: exports.HDW3
    },
    0x5B: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x23A1, 0x23A2, 0x23A3],
      HDW: exports.HDW2
    },
    0x5C: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES
    },
    0x5D: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x23A4, 0x23A5, 0x23A6],
      HDW: exports.HDW2
    },
    0x5E: DELIM2C6,
    0x5F: DELIM2013,
    0x7B: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x23A7, 0x23AA, 0x23A9, 0x23A8],
      HDW: [.85, .349, .889]
    },
    0x7C: {
      dir: FontData_js_1.V,
      sizes: [1],
      stretch: [0, 0x2223],
      HDW: [.75, .25, .333]
    },
    0x7D: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x23AB, 0x23AA, 0x23AD, 0x23AC],
      HDW: [.85, .349, .889]
    },
    0x7E: DELIM2DC,
    0xAF: DELIMAF,
    0x2C6: DELIM2C6,
    0x2C9: DELIMAF,
    0x2DC: DELIM2DC,
    0x302: DELIM2C6,
    0x303: DELIM2DC,
    0x332: DELIM2013,
    0x2013: DELIM2013,
    0x2014: DELIM2013,
    0x2015: DELIM2013,
    0x2016: {
      dir: FontData_js_1.V,
      sizes: [.602, 1],
      schar: [0, 0x2225],
      variants: [1, 0],
      stretch: [0, 0x2225],
      HDW: [.602, 0, .556]
    },
    0x2017: DELIM2013,
    0x203E: DELIMAF,
    0x20D7: DELIM2192,
    0x2190: DELIM2190,
    0x2191: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0x2191, 0x23D0],
      HDW: [.6, 0, .667]
    },
    0x2192: DELIM2192,
    0x2193: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0, 0x23D0, 0x2193],
      HDW: [.6, 0, .667]
    },
    0x2194: DELIM2194,
    0x2195: {
      dir: FontData_js_1.V,
      sizes: [1.044],
      stretch: [0x2191, 0x23D0, 0x2193],
      HDW: exports.HDW1
    },
    0x219E: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0x219E, 0x2212],
      HDW: exports.HDW3
    },
    0x21A0: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0, 0x2212, 0x21A0],
      HDW: exports.HDW3
    },
    0x21A4: DELIM21A4,
    0x21A5: {
      dir: FontData_js_1.V,
      stretch: [0x2191, 0x23D0, 0x22A5],
      HDW: exports.HDW1,
      min: 1.555
    },
    0x21A6: DELIM21A6,
    0x21A7: {
      dir: FontData_js_1.V,
      stretch: [0x22A4, 0x23D0, 0x2193],
      HDW: exports.HDW1,
      min: 1.555
    },
    0x21B0: {
      dir: FontData_js_1.V,
      sizes: [.722],
      stretch: [0x21B0, 0x23D0],
      HDW: exports.HDW1
    },
    0x21B1: {
      dir: FontData_js_1.V,
      sizes: [.722],
      stretch: [0x21B1, 0x23D0],
      HDW: exports.HDW1
    },
    0x21BC: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0x21BC, 0x2212],
      HDW: exports.HDW3
    },
    0x21BD: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0x21BD, 0x2212],
      HDW: exports.HDW3
    },
    0x21BE: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0x21BE, 0x23D0],
      HDW: exports.HDW1
    },
    0x21BF: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0x21BF, 0x23D0],
      HDW: exports.HDW1
    },
    0x21C0: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0, 0x2212, 0x21C0],
      HDW: exports.HDW3
    },
    0x21C1: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0, 0x2212, 0x21C1],
      HDW: exports.HDW3
    },
    0x21C2: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0, 0x23D0, 0x21C2],
      HDW: exports.HDW1
    },
    0x21C3: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0, 0x23D0, 0x21C3],
      HDW: exports.HDW1
    },
    0x21D0: DELIM21D0,
    0x21D1: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0x21D1, 0x2016],
      HDW: [.599, 0, .778]
    },
    0x21D2: DELIM21D2,
    0x21D3: {
      dir: FontData_js_1.V,
      sizes: [.888],
      stretch: [0, 0x2016, 0x21D3],
      HDW: [.6, 0, .778]
    },
    0x21D4: DELIM21D4,
    0x21D5: {
      dir: FontData_js_1.V,
      sizes: [1.044],
      stretch: [0x21D1, 0x2016, 0x21D3],
      HDW: [.75, .25, .778]
    },
    0x21DA: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0x21DA, 0x2261],
      HDW: [.464, -0.036, .5]
    },
    0x21DB: {
      dir: FontData_js_1.H,
      sizes: [1],
      stretch: [0, 0x2261, 0x21DB],
      HDW: [.464, -0.036, .5]
    },
    0x2212: DELIM2212,
    0x2215: DELIM2F,
    0x221A: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0xE001, 0xE000, 0x23B7],
      fullExt: [.65, 2.3],
      HDW: [.85, .35, 1.056]
    },
    0x2223: DELIM2223,
    0x2225: {
      dir: FontData_js_1.V,
      sizes: [1],
      stretch: [0, 0x2225],
      HDW: [.627, .015, .556]
    },
    0x2308: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x23A1, 0x23A2],
      HDW: exports.HDW2
    },
    0x2309: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0x23A4, 0x23A5],
      HDW: exports.HDW2
    },
    0x230A: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0, 0x23A2, 0x23A3],
      HDW: exports.HDW2
    },
    0x230B: {
      dir: FontData_js_1.V,
      sizes: exports.VSIZES,
      stretch: [0, 0x23A5, 0x23A6],
      HDW: exports.HDW2
    },
    0x2312: DELIM23DC,
    0x2322: DELIM23DC,
    0x2323: DELIM23DD,
    0x2329: DELIM27E8,
    0x232A: DELIM27E9,
    0x23AA: {
      dir: FontData_js_1.V,
      sizes: [.32],
      stretch: [0x23AA, 0x23AA, 0x23AA],
      HDW: [.29, .015, .889]
    },
    0x23AF: DELIM2013,
    0x23B0: {
      dir: FontData_js_1.V,
      sizes: [.989],
      stretch: [0x23A7, 0x23AA, 0x23AD],
      HDW: [.75, .25, .889]
    },
    0x23B1: {
      dir: FontData_js_1.V,
      sizes: [.989],
      stretch: [0x23AB, 0x23AA, 0x23A9],
      HDW: [.75, .25, .889]
    },
    0x23B4: {
      dir: FontData_js_1.H,
      stretch: [0x250C, 0x2212, 0x2510],
      HDW: exports.HDW3,
      min: 1
    },
    0x23B5: {
      dir: FontData_js_1.H,
      stretch: [0x2514, 0x2212, 0x2518],
      HDW: exports.HDW3,
      min: 1
    },
    0x23D0: {
      dir: FontData_js_1.V,
      sizes: [.602, 1],
      schar: [0, 0x2223],
      variants: [1, 0],
      stretch: [0, 0x2223],
      HDW: [.602, 0, .333]
    },
    0x23DC: DELIM23DC,
    0x23DD: DELIM23DD,
    0x23DE: DELIM23DE,
    0x23DF: DELIM23DF,
    0x23E0: {
      dir: FontData_js_1.H,
      stretch: [0x2CA, 0x2C9, 0x2CB],
      HDW: [.59, -0.544, .5],
      min: 1
    },
    0x23E1: {
      dir: FontData_js_1.H,
      stretch: [0x2CB, 0x2C9, 0x2CA],
      HDW: [.59, -0.544, .5],
      min: 1
    },
    0x2500: DELIM2013,
    0x2758: DELIM2223,
    0x27E8: DELIM27E8,
    0x27E9: DELIM27E9,
    0x27EE: {
      dir: FontData_js_1.V,
      sizes: [.989],
      stretch: [0x23A7, 0x23AA, 0x23A9],
      HDW: [.75, .25, .889]
    },
    0x27EF: {
      dir: FontData_js_1.V,
      sizes: [.989],
      stretch: [0x23AB, 0x23AA, 0x23AD],
      HDW: [.75, .25, .889]
    },
    0x27F5: DELIM2190,
    0x27F6: DELIM2192,
    0x27F7: DELIM2194,
    0x27F8: DELIM21D0,
    0x27F9: DELIM21D2,
    0x27FA: DELIM21D4,
    0x27FB: DELIM21A4,
    0x27FC: DELIM21A6,
    0x27FD: DELIM2906,
    0x27FE: DELIM2907,
    0x2906: DELIM2906,
    0x2907: DELIM2907,
    0x294E: {
      dir: FontData_js_1.H,
      stretch: [0x21BC, 0x2212, 0x21C0],
      HDW: exports.HDW3,
      min: 2
    },
    0x294F: {
      dir: FontData_js_1.V,
      stretch: [0x21BE, 0x23D0, 0x21C2],
      HDW: exports.HDW1,
      min: 1.776
    },
    0x2950: {
      dir: FontData_js_1.H,
      stretch: [0x21BD, 0x2212, 0x21C1],
      HDW: exports.HDW3,
      min: 2
    },
    0x2951: {
      dir: FontData_js_1.V,
      stretch: [0x21BF, 0x23D0, 0x21C3],
      HDW: exports.HDW1,
      min: .5
    },
    0x295A: {
      dir: FontData_js_1.H,
      stretch: [0x21BC, 0x2212, 0x2223],
      HDW: exports.HDW3,
      min: 1.278
    },
    0x295B: {
      dir: FontData_js_1.H,
      stretch: [0x2223, 0x2212, 0x21C0],
      HDW: exports.HDW3,
      min: 1.278
    },
    0x295C: {
      dir: FontData_js_1.V,
      stretch: [0x21BE, 0x23D0, 0x22A5],
      HDW: exports.HDW1,
      min: 1.556
    },
    0x295D: {
      dir: FontData_js_1.V,
      stretch: [0x22A4, 0x23D0, 0x21C2],
      HDW: exports.HDW1,
      min: 1.556
    },
    0x295E: {
      dir: FontData_js_1.H,
      stretch: [0x21BD, 0x2212, 0x2223],
      HDW: exports.HDW3,
      min: 1.278
    },
    0x295F: {
      dir: FontData_js_1.H,
      stretch: [0x2223, 0x2212, 0x21C1],
      HDW: exports.HDW3,
      min: 1.278
    },
    0x2960: {
      dir: FontData_js_1.V,
      stretch: [0x21BF, 0x23D0, 0x22A5],
      HDW: exports.HDW1,
      min: 1.776
    },
    0x2961: {
      dir: FontData_js_1.V,
      stretch: [0x22A4, 0x23D0, 0x21C3],
      HDW: exports.HDW1,
      min: 1.776
    },
    0x3008: DELIM27E8,
    0x3009: DELIM27E9,
    0xFE37: DELIM23DE,
    0xFE38: DELIM23DF
  };
})(delimiters);
getDefaultExportFromCjs(delimiters);

var __extends$k = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$3 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$3 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$3.apply(this, arguments);
});
Object.defineProperty(tex$1, "__esModule", {
  value: true
});
tex$1.TeXFont = void 0;
var FontData_js_1 = FontData;
var tex_js_1$1 = tex;
var bold_italic_js_1 = boldItalic$1;
var bold_js_1 = bold$1;
var double_struck_js_1 = doubleStruck$1;
var fraktur_bold_js_1 = frakturBold$1;
var fraktur_js_1 = fraktur$1;
var italic_js_1 = italic$1;
var largeop_js_1 = largeop$1;
var monospace_js_1 = monospace$1;
var normal_js_1 = normal$1;
var sans_serif_bold_italic_js_1 = sansSerifBoldItalic$1;
var sans_serif_bold_js_1 = sansSerifBold$1;
var sans_serif_italic_js_1 = sansSerifItalic$1;
var sans_serif_js_1 = sansSerif$1;
var script_bold_js_1 = scriptBold$1;
var script_js_1 = script$1;
var smallop_js_1 = smallop$1;
var tex_calligraphic_bold_js_1 = texCalligraphicBold$1;
var tex_calligraphic_js_1 = texCalligraphic$1;
var tex_mathit_js_1 = texMathit$1;
var tex_oldstyle_bold_js_1 = texOldstyleBold$1;
var tex_oldstyle_js_1 = texOldstyle$1;
var tex_size3_js_1 = texSize3$1;
var tex_size4_js_1 = texSize4$1;
var tex_variant_js_1 = texVariant$1;
var delimiters_js_1 = delimiters;
var TeXFont = (function (_super) {
  __extends$k(TeXFont, _super);
  function TeXFont() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TeXFont.defaultCssFamilyPrefix = 'MJXZERO';
  TeXFont.defaultVariantClasses = {
    'normal': 'mjx-n',
    'bold': 'mjx-b',
    'italic': 'mjx-i',
    'bold-italic': 'mjx-b mjx-i',
    'double-struck': 'mjx-ds mjx-b',
    'fraktur': 'mjx-fr',
    'bold-fraktur': 'mjx-fr mjx-b',
    'script': 'mjx-sc mjx-i',
    'bold-script': 'mjx-sc mjx-b mjx-i',
    'sans-serif': 'mjx-ss',
    'bold-sans-serif': 'mjx-ss mjx-b',
    'sans-serif-italic': 'mjx-ss mjx-i',
    'sans-serif-bold-italic': 'mjx-ss mjx-b mjx-i',
    'monospace': 'mjx-ty',
    '-smallop': 'mjx-sop',
    '-largeop': 'mjx-lop',
    '-size3': 'mjx-s3',
    '-size4': 'mjx-s4',
    '-tex-calligraphic': 'mjx-cal mjx-i',
    '-tex-bold-calligraphic': 'mjx-cal mjx-b',
    '-tex-mathit': 'mjx-mit mjx-i',
    '-tex-oldstyle': 'mjx-os',
    '-tex-bold-oldstyle': 'mjx-os mjx-b',
    '-tex-variant': 'mjx-var'
  };
  TeXFont.defaultVariantLetters = {
    'normal': '',
    'bold': 'B',
    'italic': 'MI',
    'bold-italic': 'BI',
    'double-struck': 'A',
    'fraktur': 'FR',
    'bold-fraktur': 'FRB',
    'script': 'SC',
    'bold-script': 'SCB',
    'sans-serif': 'SS',
    'bold-sans-serif': 'SSB',
    'sans-serif-italic': 'SSI',
    'sans-serif-bold-italic': 'SSBI',
    'monospace': 'T',
    '-smallop': 'S1',
    '-largeop': 'S2',
    '-size3': 'S3',
    '-size4': 'S4',
    '-tex-calligraphic': 'C',
    '-tex-bold-calligraphic': 'CB',
    '-tex-mathit': 'MI',
    '-tex-oldstyle': 'C',
    '-tex-bold-oldstyle': 'CB',
    '-tex-variant': 'A'
  };
  TeXFont.defaultDelimiters = delimiters_js_1.delimiters;
  TeXFont.defaultChars = {
    'normal': normal_js_1.normal,
    'bold': bold_js_1.bold,
    'italic': italic_js_1.italic,
    'bold-italic': bold_italic_js_1.boldItalic,
    'double-struck': double_struck_js_1.doubleStruck,
    'fraktur': fraktur_js_1.fraktur,
    'bold-fraktur': fraktur_bold_js_1.frakturBold,
    'script': script_js_1.script,
    'bold-script': script_bold_js_1.scriptBold,
    'sans-serif': sans_serif_js_1.sansSerif,
    'bold-sans-serif': sans_serif_bold_js_1.sansSerifBold,
    'sans-serif-italic': sans_serif_italic_js_1.sansSerifItalic,
    'sans-serif-bold-italic': sans_serif_bold_italic_js_1.sansSerifBoldItalic,
    'monospace': monospace_js_1.monospace,
    '-smallop': smallop_js_1.smallop,
    '-largeop': largeop_js_1.largeop,
    '-size3': tex_size3_js_1.texSize3,
    '-size4': tex_size4_js_1.texSize4,
    '-tex-calligraphic': tex_calligraphic_js_1.texCalligraphic,
    '-tex-bold-calligraphic': tex_calligraphic_bold_js_1.texCalligraphicBold,
    '-tex-mathit': tex_mathit_js_1.texMathit,
    '-tex-oldstyle': tex_oldstyle_js_1.texOldstyle,
    '-tex-bold-oldstyle': tex_oldstyle_bold_js_1.texOldstyleBold,
    '-tex-variant': tex_variant_js_1.texVariant
  };
  TeXFont.defaultStyles = __assign$3(__assign$3({}, FontData_js_1.CHTMLFontData.defaultStyles), {
    '.MJX-TEX': {
      'font-family': 'MJXZERO, MJXTEX'
    },
    '.TEX-B': {
      'font-family': 'MJXZERO, MJXTEX-B'
    },
    '.TEX-I': {
      'font-family': 'MJXZERO, MJXTEX-I'
    },
    '.TEX-MI': {
      'font-family': 'MJXZERO, MJXTEX-MI'
    },
    '.TEX-BI': {
      'font-family': 'MJXZERO, MJXTEX-BI'
    },
    '.TEX-S1': {
      'font-family': 'MJXZERO, MJXTEX-S1'
    },
    '.TEX-S2': {
      'font-family': 'MJXZERO, MJXTEX-S2'
    },
    '.TEX-S3': {
      'font-family': 'MJXZERO, MJXTEX-S3'
    },
    '.TEX-S4': {
      'font-family': 'MJXZERO, MJXTEX-S4'
    },
    '.TEX-A': {
      'font-family': 'MJXZERO, MJXTEX-A'
    },
    '.TEX-C': {
      'font-family': 'MJXZERO, MJXTEX-C'
    },
    '.TEX-CB': {
      'font-family': 'MJXZERO, MJXTEX-CB'
    },
    '.TEX-FR': {
      'font-family': 'MJXZERO, MJXTEX-FR'
    },
    '.TEX-FRB': {
      'font-family': 'MJXZERO, MJXTEX-FRB'
    },
    '.TEX-SS': {
      'font-family': 'MJXZERO, MJXTEX-SS'
    },
    '.TEX-SSB': {
      'font-family': 'MJXZERO, MJXTEX-SSB'
    },
    '.TEX-SSI': {
      'font-family': 'MJXZERO, MJXTEX-SSI'
    },
    '.TEX-SC': {
      'font-family': 'MJXZERO, MJXTEX-SC'
    },
    '.TEX-T': {
      'font-family': 'MJXZERO, MJXTEX-T'
    },
    '.TEX-V': {
      'font-family': 'MJXZERO, MJXTEX-V'
    },
    '.TEX-VB': {
      'font-family': 'MJXZERO, MJXTEX-VB'
    },
    'mjx-stretchy-v mjx-c, mjx-stretchy-h mjx-c': {
      'font-family': 'MJXZERO, MJXTEX-S1, MJXTEX-S4, MJXTEX, MJXTEX-A ! important'
    }
  });
  TeXFont.defaultFonts = __assign$3(__assign$3({}, FontData_js_1.CHTMLFontData.defaultFonts), {
    '@font-face /* 1 */': {
      'font-family': 'MJXTEX',
      src: 'url("%%URL%%/MathJax_Main-Regular.woff") format("woff")'
    },
    '@font-face /* 2 */': {
      'font-family': 'MJXTEX-B',
      src: 'url("%%URL%%/MathJax_Main-Bold.woff") format("woff")'
    },
    '@font-face /* 3 */': {
      'font-family': 'MJXTEX-I',
      src: 'url("%%URL%%/MathJax_Math-Italic.woff") format("woff")'
    },
    '@font-face /* 4 */': {
      'font-family': 'MJXTEX-MI',
      src: 'url("%%URL%%/MathJax_Main-Italic.woff") format("woff")'
    },
    '@font-face /* 5 */': {
      'font-family': 'MJXTEX-BI',
      src: 'url("%%URL%%/MathJax_Math-BoldItalic.woff") format("woff")'
    },
    '@font-face /* 6 */': {
      'font-family': 'MJXTEX-S1',
      src: 'url("%%URL%%/MathJax_Size1-Regular.woff") format("woff")'
    },
    '@font-face /* 7 */': {
      'font-family': 'MJXTEX-S2',
      src: 'url("%%URL%%/MathJax_Size2-Regular.woff") format("woff")'
    },
    '@font-face /* 8 */': {
      'font-family': 'MJXTEX-S3',
      src: 'url("%%URL%%/MathJax_Size3-Regular.woff") format("woff")'
    },
    '@font-face /* 9 */': {
      'font-family': 'MJXTEX-S4',
      src: 'url("%%URL%%/MathJax_Size4-Regular.woff") format("woff")'
    },
    '@font-face /* 10 */': {
      'font-family': 'MJXTEX-A',
      src: 'url("%%URL%%/MathJax_AMS-Regular.woff") format("woff")'
    },
    '@font-face /* 11 */': {
      'font-family': 'MJXTEX-C',
      src: 'url("%%URL%%/MathJax_Calligraphic-Regular.woff") format("woff")'
    },
    '@font-face /* 12 */': {
      'font-family': 'MJXTEX-CB',
      src: 'url("%%URL%%/MathJax_Calligraphic-Bold.woff") format("woff")'
    },
    '@font-face /* 13 */': {
      'font-family': 'MJXTEX-FR',
      src: 'url("%%URL%%/MathJax_Fraktur-Regular.woff") format("woff")'
    },
    '@font-face /* 14 */': {
      'font-family': 'MJXTEX-FRB',
      src: 'url("%%URL%%/MathJax_Fraktur-Bold.woff") format("woff")'
    },
    '@font-face /* 15 */': {
      'font-family': 'MJXTEX-SS',
      src: 'url("%%URL%%/MathJax_SansSerif-Regular.woff") format("woff")'
    },
    '@font-face /* 16 */': {
      'font-family': 'MJXTEX-SSB',
      src: 'url("%%URL%%/MathJax_SansSerif-Bold.woff") format("woff")'
    },
    '@font-face /* 17 */': {
      'font-family': 'MJXTEX-SSI',
      src: 'url("%%URL%%/MathJax_SansSerif-Italic.woff") format("woff")'
    },
    '@font-face /* 18 */': {
      'font-family': 'MJXTEX-SC',
      src: 'url("%%URL%%/MathJax_Script-Regular.woff") format("woff")'
    },
    '@font-face /* 19 */': {
      'font-family': 'MJXTEX-T',
      src: 'url("%%URL%%/MathJax_Typewriter-Regular.woff") format("woff")'
    },
    '@font-face /* 20 */': {
      'font-family': 'MJXTEX-V',
      src: 'url("%%URL%%/MathJax_Vector-Regular.woff") format("woff")'
    },
    '@font-face /* 21 */': {
      'font-family': 'MJXTEX-VB',
      src: 'url("%%URL%%/MathJax_Vector-Bold.woff") format("woff")'
    }
  });
  return TeXFont;
})((0, tex_js_1$1.CommonTeXFontMixin)(FontData_js_1.CHTMLFontData));
tex$1.TeXFont = TeXFont;

var __extends$j = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$2 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$2 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$2.apply(this, arguments);
});
var __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$6(result, mod, k);
  __setModuleDefault$6(result, mod);
  return result;
});
var __values$a = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(chtml, "__esModule", {
  value: true
});
var CHTML_1 = chtml.CHTML = void 0;
var OutputJax_js_1 = OutputJax$1;
var StyleList_js_1 = StyleList;
var WrapperFactory_js_1 = WrapperFactory$2;
var Usage_js_1 = Usage$1;
var tex_js_1 = tex$1;
var LENGTHS = __importStar$6(lengths);
var string_js_1 = string;
var CHTML = (function (_super) {
  __extends$j(CHTML, _super);
  function CHTML(options) {
    if (options === void 0) {
      options = null;
    }
    var _this = _super.call(this, options, WrapperFactory_js_1.CHTMLWrapperFactory, tex_js_1.TeXFont) || this;
    _this.chtmlStyles = null;
    _this.font.adaptiveCSS(_this.options.adaptiveCSS);
    _this.wrapperUsage = new Usage_js_1.Usage();
    return _this;
  }
  CHTML.prototype.escaped = function (math, html) {
    this.setDocument(html);
    return this.html('span', {}, [this.text(math.math)]);
  };
  CHTML.prototype.styleSheet = function (html) {
    if (this.chtmlStyles) {
      if (this.options.adaptiveCSS) {
        var styles = new StyleList_js_1.CssStyles();
        this.addWrapperStyles(styles);
        this.updateFontStyles(styles);
        this.adaptor.insertRules(this.chtmlStyles, styles.getStyleRules());
      }
      return this.chtmlStyles;
    }
    var sheet = this.chtmlStyles = _super.prototype.styleSheet.call(this, html);
    this.adaptor.setAttribute(sheet, 'id', CHTML.STYLESHEETID);
    this.wrapperUsage.update();
    return sheet;
  };
  CHTML.prototype.updateFontStyles = function (styles) {
    styles.addStyles(this.font.updateStyles({}));
  };
  CHTML.prototype.addWrapperStyles = function (styles) {
    var e_1, _a;
    if (!this.options.adaptiveCSS) {
      _super.prototype.addWrapperStyles.call(this, styles);
      return;
    }
    try {
      for (var _b = __values$a(this.wrapperUsage.update()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var kind = _c.value;
        var wrapper = this.factory.getNodeClass(kind);
        wrapper && this.addClassStyles(wrapper, styles);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  CHTML.prototype.addClassStyles = function (wrapper, styles) {
    var _a;
    var CLASS = wrapper;
    if (CLASS.autoStyle && CLASS.kind !== 'unknown') {
      styles.addStyles((_a = {}, _a['mjx-' + CLASS.kind] = {
        display: 'inline-block',
        'text-align': 'left'
      }, _a));
    }
    this.wrapperUsage.add(CLASS.kind);
    _super.prototype.addClassStyles.call(this, wrapper, styles);
  };
  CHTML.prototype.processMath = function (math, parent) {
    this.factory.wrap(math).toCHTML(parent);
  };
  CHTML.prototype.clearCache = function () {
    this.cssStyles.clear();
    this.font.clearCache();
    this.wrapperUsage.clear();
    this.chtmlStyles = null;
  };
  CHTML.prototype.reset = function () {
    this.clearCache();
  };
  CHTML.prototype.unknownText = function (text, variant, width) {
    if (width === void 0) {
      width = null;
    }
    var styles = {};
    var scale = 100 / this.math.metrics.scale;
    if (scale !== 100) {
      styles['font-size'] = this.fixed(scale, 1) + '%';
      styles.padding = LENGTHS.em(75 / scale) + ' 0 ' + LENGTHS.em(20 / scale) + ' 0';
    }
    if (variant !== '-explicitFont') {
      var c = (0, string_js_1.unicodeChars)(text);
      if (c.length !== 1 || c[0] < 0x1D400 || c[0] > 0x1D7FF) {
        this.cssFontStyles(this.font.getCssFont(variant), styles);
      }
    }
    if (width !== null) {
      var metrics = this.math.metrics;
      styles.width = Math.round(width * metrics.em * metrics.scale) + 'px';
    }
    return this.html('mjx-utext', {
      variant: variant,
      style: styles
    }, [this.text(text)]);
  };
  CHTML.prototype.measureTextNode = function (textNode) {
    var adaptor = this.adaptor;
    var text = adaptor.clone(textNode);
    adaptor.setStyle(text, 'font-family', adaptor.getStyle(text, 'font-family').replace(/MJXZERO, /g, ''));
    var style = {
      position: 'absolute',
      'white-space': 'nowrap'
    };
    var node = this.html('mjx-measure-text', {
      style: style
    }, [text]);
    adaptor.append(adaptor.parent(this.math.start.node), this.container);
    adaptor.append(this.container, node);
    var w = adaptor.nodeSize(text, this.math.metrics.em)[0] / this.math.metrics.scale;
    adaptor.remove(this.container);
    adaptor.remove(node);
    return {
      w: w,
      h: .75,
      d: .2
    };
  };
  CHTML.NAME = 'CHTML';
  CHTML.OPTIONS = __assign$2(__assign$2({}, OutputJax_js_1.CommonOutputJax.OPTIONS), {
    adaptiveCSS: true,
    matchFontHeight: true
  });
  CHTML.commonStyles = {
    'mjx-container[jax="CHTML"]': {
      'line-height': 0
    },
    'mjx-container [space="1"]': {
      'margin-left': '.111em'
    },
    'mjx-container [space="2"]': {
      'margin-left': '.167em'
    },
    'mjx-container [space="3"]': {
      'margin-left': '.222em'
    },
    'mjx-container [space="4"]': {
      'margin-left': '.278em'
    },
    'mjx-container [space="5"]': {
      'margin-left': '.333em'
    },
    'mjx-container [rspace="1"]': {
      'margin-right': '.111em'
    },
    'mjx-container [rspace="2"]': {
      'margin-right': '.167em'
    },
    'mjx-container [rspace="3"]': {
      'margin-right': '.222em'
    },
    'mjx-container [rspace="4"]': {
      'margin-right': '.278em'
    },
    'mjx-container [rspace="5"]': {
      'margin-right': '.333em'
    },
    'mjx-container [size="s"]': {
      'font-size': '70.7%'
    },
    'mjx-container [size="ss"]': {
      'font-size': '50%'
    },
    'mjx-container [size="Tn"]': {
      'font-size': '60%'
    },
    'mjx-container [size="sm"]': {
      'font-size': '85%'
    },
    'mjx-container [size="lg"]': {
      'font-size': '120%'
    },
    'mjx-container [size="Lg"]': {
      'font-size': '144%'
    },
    'mjx-container [size="LG"]': {
      'font-size': '173%'
    },
    'mjx-container [size="hg"]': {
      'font-size': '207%'
    },
    'mjx-container [size="HG"]': {
      'font-size': '249%'
    },
    'mjx-container [width="full"]': {
      width: '100%'
    },
    'mjx-box': {
      display: 'inline-block'
    },
    'mjx-block': {
      display: 'block'
    },
    'mjx-itable': {
      display: 'inline-table'
    },
    'mjx-row': {
      display: 'table-row'
    },
    'mjx-row > *': {
      display: 'table-cell'
    },
    'mjx-mtext': {
      display: 'inline-block'
    },
    'mjx-mstyle': {
      display: 'inline-block'
    },
    'mjx-merror': {
      display: 'inline-block',
      color: 'red',
      'background-color': 'yellow'
    },
    'mjx-mphantom': {
      visibility: 'hidden'
    },
    '_::-webkit-full-page-media, _:future, :root mjx-container': {
      'will-change': 'opacity'
    }
  };
  CHTML.STYLESHEETID = 'MJX-CHTML-styles';
  return CHTML;
})(OutputJax_js_1.CommonOutputJax);
CHTML_1 = chtml.CHTML = CHTML;

var html = {};

var HTMLHandler$1 = {};

var Handler = {};

var MathDocument = {};

var MathList = {};

var LinkedList = {};

(function (exports) {
  var __generator = commonjsGlobal && commonjsGlobal.__generator || (function (thisArg, body) {
    var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    }, f, y, t, g;
    return (g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g);
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_) try {
        if ((f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)) return t;
        if ((y = 0, t)) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !((i in from))) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.LinkedList = exports.ListItem = exports.END = void 0;
  exports.END = Symbol();
  var ListItem = (function () {
    function ListItem(data) {
      if (data === void 0) {
        data = null;
      }
      this.next = null;
      this.prev = null;
      this.data = data;
    }
    return ListItem;
  })();
  exports.ListItem = ListItem;
  var LinkedList = (function () {
    function LinkedList() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      this.list = new ListItem(exports.END);
      this.list.next = this.list.prev = this.list;
      this.push.apply(this, __spreadArray([], __read(args), false));
    }
    LinkedList.prototype.isBefore = function (a, b) {
      return a < b;
    };
    LinkedList.prototype.push = function () {
      var e_1, _a;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
          var data = args_1_1.value;
          var item = new ListItem(data);
          item.next = this.list;
          item.prev = this.list.prev;
          this.list.prev = item;
          item.prev.next = item;
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return this;
    };
    LinkedList.prototype.pop = function () {
      var item = this.list.prev;
      if (item.data === exports.END) {
        return null;
      }
      this.list.prev = item.prev;
      item.prev.next = this.list;
      item.next = item.prev = null;
      return item.data;
    };
    LinkedList.prototype.unshift = function () {
      var e_2, _a;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      try {
        for (var _b = __values(args.slice(0).reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var data = _c.value;
          var item = new ListItem(data);
          item.next = this.list.next;
          item.prev = this.list;
          this.list.next = item;
          item.next.prev = item;
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      return this;
    };
    LinkedList.prototype.shift = function () {
      var item = this.list.next;
      if (item.data === exports.END) {
        return null;
      }
      this.list.next = item.next;
      item.next.prev = this.list;
      item.next = item.prev = null;
      return item.data;
    };
    LinkedList.prototype.remove = function () {
      var e_3, _a;
      var items = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
      }
      var map = new Map();
      try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
          var item_1 = items_1_1.value;
          map.set(item_1, true);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
      var item = this.list.next;
      while (item.data !== exports.END) {
        var next = item.next;
        if (map.has(item.data)) {
          item.prev.next = item.next;
          item.next.prev = item.prev;
          item.next = item.prev = null;
        }
        item = next;
      }
    };
    LinkedList.prototype.clear = function () {
      this.list.next.prev = this.list.prev.next = null;
      this.list.next = this.list.prev = this.list;
      return this;
    };
    LinkedList.prototype[Symbol.iterator] = function () {
      var current;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            current = this.list.next;
            _a.label = 1;
          case 1:
            if (!(current.data !== exports.END)) return [3, 3];
            return [4, current.data];
          case 2:
            _a.sent();
            current = current.next;
            return [3, 1];
          case 3:
            return [2];
        }
      });
    };
    LinkedList.prototype.reversed = function () {
      var current;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            current = this.list.prev;
            _a.label = 1;
          case 1:
            if (!(current.data !== exports.END)) return [3, 3];
            return [4, current.data];
          case 2:
            _a.sent();
            current = current.prev;
            return [3, 1];
          case 3:
            return [2];
        }
      });
    };
    LinkedList.prototype.insert = function (data, isBefore) {
      if (isBefore === void 0) {
        isBefore = null;
      }
      if (isBefore === null) {
        isBefore = this.isBefore.bind(this);
      }
      var item = new ListItem(data);
      var cur = this.list.next;
      while (cur.data !== exports.END && isBefore(cur.data, item.data)) {
        cur = cur.next;
      }
      item.prev = cur.prev;
      item.next = cur;
      cur.prev.next = cur.prev = item;
      return this;
    };
    LinkedList.prototype.sort = function (isBefore) {
      var e_4, _a;
      if (isBefore === void 0) {
        isBefore = null;
      }
      if (isBefore === null) {
        isBefore = this.isBefore.bind(this);
      }
      var lists = [];
      try {
        for (var _b = __values(this), _c = _b.next(); !_c.done; _c = _b.next()) {
          var item = _c.value;
          lists.push(new LinkedList(item));
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
      this.list.next = this.list.prev = this.list;
      while (lists.length > 1) {
        var l1 = lists.shift();
        var l2 = lists.shift();
        l1.merge(l2, isBefore);
        lists.push(l1);
      }
      if (lists.length) {
        this.list = lists[0].list;
      }
      return this;
    };
    LinkedList.prototype.merge = function (list, isBefore) {
      var _a, _b, _c, _d, _e;
      if (isBefore === void 0) {
        isBefore = null;
      }
      if (isBefore === null) {
        isBefore = this.isBefore.bind(this);
      }
      var lcur = this.list.next;
      var mcur = list.list.next;
      while (lcur.data !== exports.END && mcur.data !== exports.END) {
        if (isBefore(mcur.data, lcur.data)) {
          (_a = __read([lcur, mcur], 2), mcur.prev.next = _a[0], lcur.prev.next = _a[1]);
          (_b = __read([lcur.prev, mcur.prev], 2), mcur.prev = _b[0], lcur.prev = _b[1]);
          (_c = __read([list.list, this.list], 2), this.list.prev.next = _c[0], list.list.prev.next = _c[1]);
          (_d = __read([list.list.prev, this.list.prev], 2), this.list.prev = _d[0], list.list.prev = _d[1]);
          (_e = __read([mcur.next, lcur], 2), lcur = _e[0], mcur = _e[1]);
        } else {
          lcur = lcur.next;
        }
      }
      if (mcur.data !== exports.END) {
        this.list.prev.next = list.list.next;
        list.list.next.prev = this.list.prev;
        list.list.prev.next = this.list;
        this.list.prev = list.list.prev;
        list.list.next = list.list.prev = list.list;
      }
      return this;
    };
    return LinkedList;
  })();
  exports.LinkedList = LinkedList;
})(LinkedList);
getDefaultExportFromCjs(LinkedList);

var __extends$i = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(MathList, "__esModule", {
  value: true
});
MathList.AbstractMathList = void 0;
var LinkedList_js_1 = LinkedList;
var AbstractMathList = (function (_super) {
  __extends$i(AbstractMathList, _super);
  function AbstractMathList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AbstractMathList.prototype.isBefore = function (a, b) {
    return a.start.i < b.start.i || a.start.i === b.start.i && a.start.n < b.start.n;
  };
  return AbstractMathList;
})(LinkedList_js_1.LinkedList);
MathList.AbstractMathList = AbstractMathList;

var BitField$1 = {};

var __extends$h = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$9 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$7 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$2 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
Object.defineProperty(BitField$1, "__esModule", {
  value: true
});
BitField$1.BitFieldClass = BitField$1.BitField = void 0;
var BitField = (function () {
  function BitField() {
    this.bits = 0;
  }
  BitField.allocate = function () {
    var e_1, _a;
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      names[_i] = arguments[_i];
    }
    try {
      for (var names_1 = __values$9(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
        var name_1 = names_1_1.value;
        if (this.has(name_1)) {
          throw new Error('Bit already allocated for ' + name_1);
        }
        if (this.next === BitField.MAXBIT) {
          throw new Error('Maximum number of bits already allocated');
        }
        this.names.set(name_1, this.next);
        this.next <<= 1;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  BitField.has = function (name) {
    return this.names.has(name);
  };
  BitField.prototype.set = function (name) {
    this.bits |= this.getBit(name);
  };
  BitField.prototype.clear = function (name) {
    this.bits &= ~this.getBit(name);
  };
  BitField.prototype.isSet = function (name) {
    return !!(this.bits & this.getBit(name));
  };
  BitField.prototype.reset = function () {
    this.bits = 0;
  };
  BitField.prototype.getBit = function (name) {
    var bit = this.constructor.names.get(name);
    if (!bit) {
      throw new Error('Unknown bit-field name: ' + name);
    }
    return bit;
  };
  BitField.MAXBIT = 1 << 31;
  BitField.next = 1;
  BitField.names = new Map();
  return BitField;
})();
BitField$1.BitField = BitField;
function BitFieldClass() {
  var names = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    names[_i] = arguments[_i];
  }
  var Bits = (function (_super) {
    __extends$h(Bits, _super);
    function Bits() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    return Bits;
  })(BitField);
  Bits.allocate.apply(Bits, __spreadArray$2([], __read$7(names), false));
  return Bits;
}
BitField$1.BitFieldClass = BitFieldClass;

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !((i in from))) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.AbstractMathDocument = exports.resetAllOptions = exports.resetOptions = exports.RenderList = void 0;
  var Options_js_1 = Options;
  var InputJax_js_1 = InputJax;
  var OutputJax_js_1 = OutputJax;
  var MathList_js_1 = MathList;
  var MathItem_js_1 = MathItem;
  var MmlFactory_js_1 = MmlFactory$1;
  var BitField_js_1 = BitField$1;
  var PrioritizedList_js_1 = PrioritizedList$1;
  var RenderList = (function (_super) {
    __extends(RenderList, _super);
    function RenderList() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderList.create = function (actions) {
      var e_1, _a;
      var list = new this();
      try {
        for (var _b = __values(Object.keys(actions)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var id = _c.value;
          var _d = __read(this.action(id, actions[id]), 2), action = _d[0], priority = _d[1];
          if (priority) {
            list.add(action, priority);
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return list;
    };
    RenderList.action = function (id, action) {
      var _a, _b, _c, _d;
      var renderDoc, renderMath;
      var convert = true;
      var priority = action[0];
      if (action.length === 1 || typeof action[1] === 'boolean') {
        action.length === 2 && (convert = action[1]);
        (_a = __read(this.methodActions(id), 2), renderDoc = _a[0], renderMath = _a[1]);
      } else if (typeof action[1] === 'string') {
        if (typeof action[2] === 'string') {
          action.length === 4 && (convert = action[3]);
          var _e = __read(action.slice(1), 2), method1 = _e[0], method2 = _e[1];
          (_b = __read(this.methodActions(method1, method2), 2), renderDoc = _b[0], renderMath = _b[1]);
        } else {
          action.length === 3 && (convert = action[2]);
          (_c = __read(this.methodActions(action[1]), 2), renderDoc = _c[0], renderMath = _c[1]);
        }
      } else {
        action.length === 4 && (convert = action[3]);
        (_d = __read(action.slice(1), 2), renderDoc = _d[0], renderMath = _d[1]);
      }
      return [{
        id: id,
        renderDoc: renderDoc,
        renderMath: renderMath,
        convert: convert
      }, priority];
    };
    RenderList.methodActions = function (method1, method2) {
      if (method2 === void 0) {
        method2 = method1;
      }
      return [function (document) {
        method1 && document[method1]();
        return false;
      }, function (math, document) {
        method2 && math[method2](document);
        return false;
      }];
    };
    RenderList.prototype.renderDoc = function (document, start) {
      var e_2, _a;
      if (start === void 0) {
        start = MathItem_js_1.STATE.UNPROCESSED;
      }
      try {
        for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
          var item = _c.value;
          if (item.priority >= start) {
            if (item.item.renderDoc(document)) return;
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    };
    RenderList.prototype.renderMath = function (math, document, start) {
      var e_3, _a;
      if (start === void 0) {
        start = MathItem_js_1.STATE.UNPROCESSED;
      }
      try {
        for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
          var item = _c.value;
          if (item.priority >= start) {
            if (item.item.renderMath(math, document)) return;
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    };
    RenderList.prototype.renderConvert = function (math, document, end) {
      var e_4, _a;
      if (end === void 0) {
        end = MathItem_js_1.STATE.LAST;
      }
      try {
        for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
          var item = _c.value;
          if (item.priority > end) return;
          if (item.item.convert) {
            if (item.item.renderMath(math, document)) return;
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
    };
    RenderList.prototype.findID = function (id) {
      var e_5, _a;
      try {
        for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
          var item = _c.value;
          if (item.item.id === id) {
            return item.item;
          }
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      return null;
    };
    return RenderList;
  })(PrioritizedList_js_1.PrioritizedList);
  exports.RenderList = RenderList;
  exports.resetOptions = {
    all: false,
    processed: false,
    inputJax: null,
    outputJax: null
  };
  exports.resetAllOptions = {
    all: true,
    processed: true,
    inputJax: [],
    outputJax: []
  };
  var DefaultInputJax = (function (_super) {
    __extends(DefaultInputJax, _super);
    function DefaultInputJax() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultInputJax.prototype.compile = function (_math) {
      return null;
    };
    return DefaultInputJax;
  })(InputJax_js_1.AbstractInputJax);
  var DefaultOutputJax = (function (_super) {
    __extends(DefaultOutputJax, _super);
    function DefaultOutputJax() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultOutputJax.prototype.typeset = function (_math, _document) {
      return null;
    };
    DefaultOutputJax.prototype.escaped = function (_math, _document) {
      return null;
    };
    return DefaultOutputJax;
  })(OutputJax_js_1.AbstractOutputJax);
  var DefaultMathList = (function (_super) {
    __extends(DefaultMathList, _super);
    function DefaultMathList() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    return DefaultMathList;
  })(MathList_js_1.AbstractMathList);
  var DefaultMathItem = (function (_super) {
    __extends(DefaultMathItem, _super);
    function DefaultMathItem() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    return DefaultMathItem;
  })(MathItem_js_1.AbstractMathItem);
  var AbstractMathDocument = (function () {
    function AbstractMathDocument(document, adaptor, options) {
      var _this = this;
      var CLASS = this.constructor;
      this.document = document;
      this.options = (0, Options_js_1.userOptions)((0, Options_js_1.defaultOptions)({}, CLASS.OPTIONS), options);
      this.math = new (this.options['MathList'] || DefaultMathList)();
      this.renderActions = RenderList.create(this.options['renderActions']);
      this.processed = new AbstractMathDocument.ProcessBits();
      this.outputJax = this.options['OutputJax'] || new DefaultOutputJax();
      var inputJax = this.options['InputJax'] || [new DefaultInputJax()];
      if (!Array.isArray(inputJax)) {
        inputJax = [inputJax];
      }
      this.inputJax = inputJax;
      this.adaptor = adaptor;
      this.outputJax.setAdaptor(adaptor);
      this.inputJax.map(function (jax) {
        return jax.setAdaptor(adaptor);
      });
      this.mmlFactory = this.options['MmlFactory'] || new MmlFactory_js_1.MmlFactory();
      this.inputJax.map(function (jax) {
        return jax.setMmlFactory(_this.mmlFactory);
      });
      this.outputJax.initialize();
      this.inputJax.map(function (jax) {
        return jax.initialize();
      });
    }
    Object.defineProperty(AbstractMathDocument.prototype, "kind", {
      get: function () {
        return this.constructor.KIND;
      },
      enumerable: false,
      configurable: true
    });
    AbstractMathDocument.prototype.addRenderAction = function (id) {
      var action = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        action[_i - 1] = arguments[_i];
      }
      var _a = __read(RenderList.action(id, action), 2), fn = _a[0], p = _a[1];
      this.renderActions.add(fn, p);
    };
    AbstractMathDocument.prototype.removeRenderAction = function (id) {
      var action = this.renderActions.findID(id);
      if (action) {
        this.renderActions.remove(action);
      }
    };
    AbstractMathDocument.prototype.render = function () {
      this.renderActions.renderDoc(this);
      return this;
    };
    AbstractMathDocument.prototype.rerender = function (start) {
      if (start === void 0) {
        start = MathItem_js_1.STATE.RERENDER;
      }
      this.state(start - 1);
      this.render();
      return this;
    };
    AbstractMathDocument.prototype.convert = function (math, options) {
      if (options === void 0) {
        options = {};
      }
      var _a = (0, Options_js_1.userOptions)({
        format: this.inputJax[0].name,
        display: true,
        end: MathItem_js_1.STATE.LAST,
        em: 16,
        ex: 8,
        containerWidth: null,
        lineWidth: 1000000,
        scale: 1,
        family: ''
      }, options), format = _a.format, display = _a.display, end = _a.end, ex = _a.ex, em = _a.em, containerWidth = _a.containerWidth, lineWidth = _a.lineWidth, scale = _a.scale, family = _a.family;
      if (containerWidth === null) {
        containerWidth = 80 * ex;
      }
      var jax = this.inputJax.reduce(function (jax, ijax) {
        return ijax.name === format ? ijax : jax;
      }, null);
      var mitem = new this.options.MathItem(math, jax, display);
      mitem.start.node = this.adaptor.body(this.document);
      mitem.setMetrics(em, ex, containerWidth, lineWidth, scale);
      if (this.outputJax.options.mtextInheritFont) {
        mitem.outputData.mtextFamily = family;
      }
      if (this.outputJax.options.merrorInheritFont) {
        mitem.outputData.merrorFamily = family;
      }
      mitem.convert(this, end);
      return mitem.typesetRoot || mitem.root;
    };
    AbstractMathDocument.prototype.findMath = function (_options) {
      this.processed.set('findMath');
      return this;
    };
    AbstractMathDocument.prototype.compile = function () {
      var e_6, _a, e_7, _b;
      if (!this.processed.isSet('compile')) {
        var recompile = [];
        try {
          for (var _c = __values(this.math), _d = _c.next(); !_d.done; _d = _c.next()) {
            var math = _d.value;
            this.compileMath(math);
            if (math.inputData.recompile !== undefined) {
              recompile.push(math);
            }
          }
        } catch (e_6_1) {
          e_6 = {
            error: e_6_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_6) throw e_6.error;
          }
        }
        try {
          for (var recompile_1 = __values(recompile), recompile_1_1 = recompile_1.next(); !recompile_1_1.done; recompile_1_1 = recompile_1.next()) {
            var math = recompile_1_1.value;
            var data = math.inputData.recompile;
            math.state(data.state);
            math.inputData.recompile = data;
            this.compileMath(math);
          }
        } catch (e_7_1) {
          e_7 = {
            error: e_7_1
          };
        } finally {
          try {
            if (recompile_1_1 && !recompile_1_1.done && (_b = recompile_1.return)) _b.call(recompile_1);
          } finally {
            if (e_7) throw e_7.error;
          }
        }
        this.processed.set('compile');
      }
      return this;
    };
    AbstractMathDocument.prototype.compileMath = function (math) {
      try {
        math.compile(this);
      } catch (err) {
        if (err.retry || err.restart) {
          throw err;
        }
        this.options['compileError'](this, math, err);
        math.inputData['error'] = err;
      }
    };
    AbstractMathDocument.prototype.compileError = function (math, err) {
      math.root = this.mmlFactory.create('math', null, [this.mmlFactory.create('merror', {
        'data-mjx-error': err.message,
        title: err.message
      }, [this.mmlFactory.create('mtext', null, [this.mmlFactory.create('text').setText('Math input error')])])]);
      if (math.display) {
        math.root.attributes.set('display', 'block');
      }
      math.inputData.error = err.message;
    };
    AbstractMathDocument.prototype.typeset = function () {
      var e_8, _a;
      if (!this.processed.isSet('typeset')) {
        try {
          for (var _b = __values(this.math), _c = _b.next(); !_c.done; _c = _b.next()) {
            var math = _c.value;
            try {
              math.typeset(this);
            } catch (err) {
              if (err.retry || err.restart) {
                throw err;
              }
              this.options['typesetError'](this, math, err);
              math.outputData['error'] = err;
            }
          }
        } catch (e_8_1) {
          e_8 = {
            error: e_8_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_8) throw e_8.error;
          }
        }
        this.processed.set('typeset');
      }
      return this;
    };
    AbstractMathDocument.prototype.typesetError = function (math, err) {
      math.typesetRoot = this.adaptor.node('mjx-container', {
        class: 'MathJax mjx-output-error',
        jax: this.outputJax.name
      }, [this.adaptor.node('span', {
        'data-mjx-error': err.message,
        title: err.message,
        style: {
          color: 'red',
          'background-color': 'yellow',
          'line-height': 'normal'
        }
      }, [this.adaptor.text('Math output error')])]);
      if (math.display) {
        this.adaptor.setAttributes(math.typesetRoot, {
          style: {
            display: 'block',
            margin: '1em 0',
            'text-align': 'center'
          }
        });
      }
      math.outputData.error = err.message;
    };
    AbstractMathDocument.prototype.getMetrics = function () {
      if (!this.processed.isSet('getMetrics')) {
        this.outputJax.getMetrics(this);
        this.processed.set('getMetrics');
      }
      return this;
    };
    AbstractMathDocument.prototype.updateDocument = function () {
      var e_9, _a;
      if (!this.processed.isSet('updateDocument')) {
        try {
          for (var _b = __values(this.math.reversed()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var math = _c.value;
            math.updateDocument(this);
          }
        } catch (e_9_1) {
          e_9 = {
            error: e_9_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_9) throw e_9.error;
          }
        }
        this.processed.set('updateDocument');
      }
      return this;
    };
    AbstractMathDocument.prototype.removeFromDocument = function (_restore) {
      return this;
    };
    AbstractMathDocument.prototype.state = function (state, restore) {
      var e_10, _a;
      if (restore === void 0) {
        restore = false;
      }
      try {
        for (var _b = __values(this.math), _c = _b.next(); !_c.done; _c = _b.next()) {
          var math = _c.value;
          math.state(state, restore);
        }
      } catch (e_10_1) {
        e_10 = {
          error: e_10_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_10) throw e_10.error;
        }
      }
      if (state < MathItem_js_1.STATE.INSERTED) {
        this.processed.clear('updateDocument');
      }
      if (state < MathItem_js_1.STATE.TYPESET) {
        this.processed.clear('typeset');
        this.processed.clear('getMetrics');
      }
      if (state < MathItem_js_1.STATE.COMPILED) {
        this.processed.clear('compile');
      }
      return this;
    };
    AbstractMathDocument.prototype.reset = function (options) {
      var _a;
      if (options === void 0) {
        options = {
          processed: true
        };
      }
      options = (0, Options_js_1.userOptions)(Object.assign({}, exports.resetOptions), options);
      options.all && Object.assign(options, exports.resetAllOptions);
      options.processed && this.processed.reset();
      options.inputJax && this.inputJax.forEach(function (jax) {
        return jax.reset.apply(jax, __spreadArray([], __read(options.inputJax), false));
      });
      options.outputJax && (_a = this.outputJax).reset.apply(_a, __spreadArray([], __read(options.outputJax), false));
      return this;
    };
    AbstractMathDocument.prototype.clear = function () {
      this.reset();
      this.math.clear();
      return this;
    };
    AbstractMathDocument.prototype.concat = function (list) {
      this.math.merge(list);
      return this;
    };
    AbstractMathDocument.prototype.clearMathItemsWithin = function (containers) {
      var _a;
      var items = this.getMathItemsWithin(containers);
      (_a = this.math).remove.apply(_a, __spreadArray([], __read(items), false));
      return items;
    };
    AbstractMathDocument.prototype.getMathItemsWithin = function (elements) {
      var e_11, _a, e_12, _b;
      if (!Array.isArray(elements)) {
        elements = [elements];
      }
      var adaptor = this.adaptor;
      var items = [];
      var containers = adaptor.getElements(elements, this.document);
      try {
        ITEMS: for (var _c = __values(this.math), _d = _c.next(); !_d.done; _d = _c.next()) {
          var item = _d.value;
          try {
            for (var containers_1 = (e_12 = void 0, __values(containers)), containers_1_1 = containers_1.next(); !containers_1_1.done; containers_1_1 = containers_1.next()) {
              var container = containers_1_1.value;
              if (item.start.node && adaptor.contains(container, item.start.node)) {
                items.push(item);
                continue ITEMS;
              }
            }
          } catch (e_12_1) {
            e_12 = {
              error: e_12_1
            };
          } finally {
            try {
              if (containers_1_1 && !containers_1_1.done && (_b = containers_1.return)) _b.call(containers_1);
            } finally {
              if (e_12) throw e_12.error;
            }
          }
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_11) throw e_11.error;
        }
      }
      return items;
    };
    AbstractMathDocument.KIND = 'MathDocument';
    AbstractMathDocument.OPTIONS = {
      OutputJax: null,
      InputJax: null,
      MmlFactory: null,
      MathList: DefaultMathList,
      MathItem: DefaultMathItem,
      compileError: function (doc, math, err) {
        doc.compileError(math, err);
      },
      typesetError: function (doc, math, err) {
        doc.typesetError(math, err);
      },
      renderActions: (0, Options_js_1.expandable)({
        find: [MathItem_js_1.STATE.FINDMATH, 'findMath', '', false],
        compile: [MathItem_js_1.STATE.COMPILED],
        metrics: [MathItem_js_1.STATE.METRICS, 'getMetrics', '', false],
        typeset: [MathItem_js_1.STATE.TYPESET],
        update: [MathItem_js_1.STATE.INSERTED, 'updateDocument', false]
      })
    };
    AbstractMathDocument.ProcessBits = (0, BitField_js_1.BitFieldClass)('findMath', 'compile', 'getMetrics', 'typeset', 'updateDocument');
    return AbstractMathDocument;
  })();
  exports.AbstractMathDocument = AbstractMathDocument;
})(MathDocument);
getDefaultExportFromCjs(MathDocument);

var __extends$g = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(Handler, "__esModule", {
  value: true
});
Handler.AbstractHandler = void 0;
var MathDocument_js_1$1 = MathDocument;
var DefaultMathDocument = (function (_super) {
  __extends$g(DefaultMathDocument, _super);
  function DefaultMathDocument() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return DefaultMathDocument;
})(MathDocument_js_1$1.AbstractMathDocument);
var AbstractHandler = (function () {
  function AbstractHandler(adaptor, priority) {
    if (priority === void 0) {
      priority = 5;
    }
    this.documentClass = DefaultMathDocument;
    this.adaptor = adaptor;
    this.priority = priority;
  }
  Object.defineProperty(AbstractHandler.prototype, "name", {
    get: function () {
      return this.constructor.NAME;
    },
    enumerable: false,
    configurable: true
  });
  AbstractHandler.prototype.handlesDocument = function (_document) {
    return false;
  };
  AbstractHandler.prototype.create = function (document, options) {
    return new this.documentClass(document, this.adaptor, options);
  };
  AbstractHandler.NAME = 'generic';
  return AbstractHandler;
})();
Handler.AbstractHandler = AbstractHandler;

var HTMLDocument$1 = {};

var HTMLMathItem$1 = {};

var __extends$f = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(HTMLMathItem$1, "__esModule", {
  value: true
});
HTMLMathItem$1.HTMLMathItem = void 0;
var MathItem_js_1$1 = MathItem;
var HTMLMathItem = (function (_super) {
  __extends$f(HTMLMathItem, _super);
  function HTMLMathItem(math, jax, display, start, end) {
    if (display === void 0) {
      display = true;
    }
    if (start === void 0) {
      start = {
        node: null,
        n: 0,
        delim: ''
      };
    }
    if (end === void 0) {
      end = {
        node: null,
        n: 0,
        delim: ''
      };
    }
    return _super.call(this, math, jax, display, start, end) || this;
  }
  Object.defineProperty(HTMLMathItem.prototype, "adaptor", {
    get: function () {
      return this.inputJax.adaptor;
    },
    enumerable: false,
    configurable: true
  });
  HTMLMathItem.prototype.updateDocument = function (_html) {
    if (this.state() < MathItem_js_1$1.STATE.INSERTED) {
      if (this.inputJax.processStrings) {
        var node = this.start.node;
        if (node === this.end.node) {
          if (this.end.n && this.end.n < this.adaptor.value(this.end.node).length) {
            this.adaptor.split(this.end.node, this.end.n);
          }
          if (this.start.n) {
            node = this.adaptor.split(this.start.node, this.start.n);
          }
          this.adaptor.replace(this.typesetRoot, node);
        } else {
          if (this.start.n) {
            node = this.adaptor.split(node, this.start.n);
          }
          while (node !== this.end.node) {
            var next = this.adaptor.next(node);
            this.adaptor.remove(node);
            node = next;
          }
          this.adaptor.insert(this.typesetRoot, node);
          if (this.end.n < this.adaptor.value(node).length) {
            this.adaptor.split(node, this.end.n);
          }
          this.adaptor.remove(node);
        }
      } else {
        this.adaptor.replace(this.typesetRoot, this.start.node);
      }
      this.start.node = this.end.node = this.typesetRoot;
      this.start.n = this.end.n = 0;
      this.state(MathItem_js_1$1.STATE.INSERTED);
    }
  };
  HTMLMathItem.prototype.updateStyleSheet = function (document) {
    document.addStyleSheet();
  };
  HTMLMathItem.prototype.removeFromDocument = function (restore) {
    if (restore === void 0) {
      restore = false;
    }
    if (this.state() >= MathItem_js_1$1.STATE.TYPESET) {
      var adaptor = this.adaptor;
      var node = this.start.node;
      var math = adaptor.text('');
      if (restore) {
        var text = this.start.delim + this.math + this.end.delim;
        if (this.inputJax.processStrings) {
          math = adaptor.text(text);
        } else {
          var doc = adaptor.parse(text, 'text/html');
          math = adaptor.firstChild(adaptor.body(doc));
        }
      }
      if (adaptor.parent(node)) {
        adaptor.replace(math, node);
      }
      this.start.node = this.end.node = math;
      this.start.n = this.end.n = 0;
    }
  };
  return HTMLMathItem;
})(MathItem_js_1$1.AbstractMathItem);
HTMLMathItem$1.HTMLMathItem = HTMLMathItem;

var HTMLMathList$1 = {};

var __extends$e = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(HTMLMathList$1, "__esModule", {
  value: true
});
HTMLMathList$1.HTMLMathList = void 0;
var MathList_js_1 = MathList;
var HTMLMathList = (function (_super) {
  __extends$e(HTMLMathList, _super);
  function HTMLMathList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return HTMLMathList;
})(MathList_js_1.AbstractMathList);
HTMLMathList$1.HTMLMathList = HTMLMathList;

var HTMLDomStrings$1 = {};

var __read$6 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
Object.defineProperty(HTMLDomStrings$1, "__esModule", {
  value: true
});
var HTMLDomStrings_2 = HTMLDomStrings$1.HTMLDomStrings = void 0;
var Options_js_1$3 = Options;
var HTMLDomStrings = (function () {
  function HTMLDomStrings(options) {
    if (options === void 0) {
      options = null;
    }
    var CLASS = this.constructor;
    this.options = (0, Options_js_1$3.userOptions)((0, Options_js_1$3.defaultOptions)({}, CLASS.OPTIONS), options);
    this.init();
    this.getPatterns();
  }
  HTMLDomStrings.prototype.init = function () {
    this.strings = [];
    this.string = '';
    this.snodes = [];
    this.nodes = [];
    this.stack = [];
  };
  HTMLDomStrings.prototype.getPatterns = function () {
    var skip = (0, Options_js_1$3.makeArray)(this.options['skipHtmlTags']);
    var ignore = (0, Options_js_1$3.makeArray)(this.options['ignoreHtmlClass']);
    var process = (0, Options_js_1$3.makeArray)(this.options['processHtmlClass']);
    this.skipHtmlTags = new RegExp('^(?:' + skip.join('|') + ')$', 'i');
    this.ignoreHtmlClass = new RegExp('(?:^| )(?:' + ignore.join('|') + ')(?: |$)');
    this.processHtmlClass = new RegExp('(?:^| )(?:' + process + ')(?: |$)');
  };
  HTMLDomStrings.prototype.pushString = function () {
    if (this.string.match(/\S/)) {
      this.strings.push(this.string);
      this.nodes.push(this.snodes);
    }
    this.string = '';
    this.snodes = [];
  };
  HTMLDomStrings.prototype.extendString = function (node, text) {
    this.snodes.push([node, text.length]);
    this.string += text;
  };
  HTMLDomStrings.prototype.handleText = function (node, ignore) {
    if (!ignore) {
      this.extendString(node, this.adaptor.value(node));
    }
    return this.adaptor.next(node);
  };
  HTMLDomStrings.prototype.handleTag = function (node, ignore) {
    if (!ignore) {
      var text = this.options['includeHtmlTags'][this.adaptor.kind(node)];
      this.extendString(node, text);
    }
    return this.adaptor.next(node);
  };
  HTMLDomStrings.prototype.handleContainer = function (node, ignore) {
    this.pushString();
    var cname = this.adaptor.getAttribute(node, 'class') || '';
    var tname = this.adaptor.kind(node) || '';
    var process = this.processHtmlClass.exec(cname);
    var next = node;
    if (this.adaptor.firstChild(node) && !this.adaptor.getAttribute(node, 'data-MJX') && (process || !this.skipHtmlTags.exec(tname))) {
      if (this.adaptor.next(node)) {
        this.stack.push([this.adaptor.next(node), ignore]);
      }
      next = this.adaptor.firstChild(node);
      ignore = (ignore || this.ignoreHtmlClass.exec(cname)) && !process;
    } else {
      next = this.adaptor.next(node);
    }
    return [next, ignore];
  };
  HTMLDomStrings.prototype.handleOther = function (node, _ignore) {
    this.pushString();
    return this.adaptor.next(node);
  };
  HTMLDomStrings.prototype.find = function (node) {
    var _a, _b;
    this.init();
    var stop = this.adaptor.next(node);
    var ignore = false;
    var include = this.options['includeHtmlTags'];
    while (node && node !== stop) {
      var kind = this.adaptor.kind(node);
      if (kind === '#text') {
        node = this.handleText(node, ignore);
      } else if (include.hasOwnProperty(kind)) {
        node = this.handleTag(node, ignore);
      } else if (kind) {
        (_a = __read$6(this.handleContainer(node, ignore), 2), node = _a[0], ignore = _a[1]);
      } else {
        node = this.handleOther(node, ignore);
      }
      if (!node && this.stack.length) {
        this.pushString();
        (_b = __read$6(this.stack.pop(), 2), node = _b[0], ignore = _b[1]);
      }
    }
    this.pushString();
    var result = [this.strings, this.nodes];
    this.init();
    return result;
  };
  HTMLDomStrings.OPTIONS = {
    skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code', 'annotation', 'annotation-xml'],
    includeHtmlTags: {
      br: '\n',
      wbr: '',
      '#comment': ''
    },
    ignoreHtmlClass: 'mathjax_ignore',
    processHtmlClass: 'mathjax_process'
  };
  return HTMLDomStrings;
})();
HTMLDomStrings_2 = HTMLDomStrings$1.HTMLDomStrings = HTMLDomStrings;

var __extends$d = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign$1 = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign$1.apply(this, arguments);
});
var __read$5 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __values$8 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(HTMLDocument$1, "__esModule", {
  value: true
});
HTMLDocument$1.HTMLDocument = void 0;
var MathDocument_js_1 = MathDocument;
var Options_js_1$2 = Options;
var HTMLMathItem_js_1 = HTMLMathItem$1;
var HTMLMathList_js_1 = HTMLMathList$1;
var HTMLDomStrings_js_1 = HTMLDomStrings$1;
var MathItem_js_1 = MathItem;
var HTMLDocument = (function (_super) {
  __extends$d(HTMLDocument, _super);
  function HTMLDocument(document, adaptor, options) {
    var _this = this;
    var _a = __read$5((0, Options_js_1$2.separateOptions)(options, HTMLDomStrings_js_1.HTMLDomStrings.OPTIONS), 2), html = _a[0], dom = _a[1];
    _this = _super.call(this, document, adaptor, html) || this;
    _this.domStrings = _this.options['DomStrings'] || new HTMLDomStrings_js_1.HTMLDomStrings(dom);
    _this.domStrings.adaptor = adaptor;
    _this.styles = [];
    return _this;
  }
  HTMLDocument.prototype.findPosition = function (N, index, delim, nodes) {
    var e_1, _a;
    var adaptor = this.adaptor;
    try {
      for (var _b = __values$8(nodes[N]), _c = _b.next(); !_c.done; _c = _b.next()) {
        var list = _c.value;
        var _d = __read$5(list, 2), node = _d[0], n = _d[1];
        if (index <= n && adaptor.kind(node) === '#text') {
          return {
            node: node,
            n: Math.max(index, 0),
            delim: delim
          };
        }
        index -= n;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return {
      node: null,
      n: 0,
      delim: delim
    };
  };
  HTMLDocument.prototype.mathItem = function (item, jax, nodes) {
    var math = item.math;
    var start = this.findPosition(item.n, item.start.n, item.open, nodes);
    var end = this.findPosition(item.n, item.end.n, item.close, nodes);
    return new this.options.MathItem(math, jax, item.display, start, end);
  };
  HTMLDocument.prototype.findMath = function (options) {
    var e_2, _a, e_3, _b, _c, e_4, _d, e_5, _e;
    if (!this.processed.isSet('findMath')) {
      this.adaptor.document = this.document;
      options = (0, Options_js_1$2.userOptions)({
        elements: this.options.elements || [this.adaptor.body(this.document)]
      }, options);
      try {
        for (var _f = __values$8(this.adaptor.getElements(options['elements'], this.document)), _g = _f.next(); !_g.done; _g = _f.next()) {
          var container = _g.value;
          var _h = __read$5([null, null], 2), strings = _h[0], nodes = _h[1];
          try {
            for (var _j = (e_3 = void 0, __values$8(this.inputJax)), _k = _j.next(); !_k.done; _k = _j.next()) {
              var jax = _k.value;
              var list = new this.options['MathList']();
              if (jax.processStrings) {
                if (strings === null) {
                  (_c = __read$5(this.domStrings.find(container), 2), strings = _c[0], nodes = _c[1]);
                }
                try {
                  for (var _l = (e_4 = void 0, __values$8(jax.findMath(strings))), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var math = _m.value;
                    list.push(this.mathItem(math, jax, nodes));
                  }
                } catch (e_4_1) {
                  e_4 = {
                    error: e_4_1
                  };
                } finally {
                  try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                  } finally {
                    if (e_4) throw e_4.error;
                  }
                }
              } else {
                try {
                  for (var _o = (e_5 = void 0, __values$8(jax.findMath(container))), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var math = _p.value;
                    var item = new this.options.MathItem(math.math, jax, math.display, math.start, math.end);
                    list.push(item);
                  }
                } catch (e_5_1) {
                  e_5 = {
                    error: e_5_1
                  };
                } finally {
                  try {
                    if (_p && !_p.done && (_e = _o.return)) _e.call(_o);
                  } finally {
                    if (e_5) throw e_5.error;
                  }
                }
              }
              this.math.merge(list);
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      this.processed.set('findMath');
    }
    return this;
  };
  HTMLDocument.prototype.updateDocument = function () {
    if (!this.processed.isSet('updateDocument')) {
      this.addPageElements();
      this.addStyleSheet();
      _super.prototype.updateDocument.call(this);
      this.processed.set('updateDocument');
    }
    return this;
  };
  HTMLDocument.prototype.addPageElements = function () {
    var body = this.adaptor.body(this.document);
    var node = this.documentPageElements();
    if (node) {
      this.adaptor.append(body, node);
    }
  };
  HTMLDocument.prototype.addStyleSheet = function () {
    var sheet = this.documentStyleSheet();
    var adaptor = this.adaptor;
    if (sheet && !adaptor.parent(sheet)) {
      var head = adaptor.head(this.document);
      var styles = this.findSheet(head, adaptor.getAttribute(sheet, 'id'));
      if (styles) {
        adaptor.replace(sheet, styles);
      } else {
        adaptor.append(head, sheet);
      }
    }
  };
  HTMLDocument.prototype.findSheet = function (head, id) {
    var e_6, _a;
    if (id) {
      try {
        for (var _b = __values$8(this.adaptor.tags(head, 'style')), _c = _b.next(); !_c.done; _c = _b.next()) {
          var sheet = _c.value;
          if (this.adaptor.getAttribute(sheet, 'id') === id) {
            return sheet;
          }
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_6) throw e_6.error;
        }
      }
    }
    return null;
  };
  HTMLDocument.prototype.removeFromDocument = function (restore) {
    var e_7, _a;
    if (restore === void 0) {
      restore = false;
    }
    if (this.processed.isSet('updateDocument')) {
      try {
        for (var _b = __values$8(this.math), _c = _b.next(); !_c.done; _c = _b.next()) {
          var math = _c.value;
          if (math.state() >= MathItem_js_1.STATE.INSERTED) {
            math.state(MathItem_js_1.STATE.TYPESET, restore);
          }
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
    }
    this.processed.clear('updateDocument');
    return this;
  };
  HTMLDocument.prototype.documentStyleSheet = function () {
    return this.outputJax.styleSheet(this);
  };
  HTMLDocument.prototype.documentPageElements = function () {
    return this.outputJax.pageElements(this);
  };
  HTMLDocument.prototype.addStyles = function (styles) {
    this.styles.push(styles);
  };
  HTMLDocument.prototype.getStyles = function () {
    return this.styles;
  };
  HTMLDocument.KIND = 'HTML';
  HTMLDocument.OPTIONS = __assign$1(__assign$1({}, MathDocument_js_1.AbstractMathDocument.OPTIONS), {
    renderActions: (0, Options_js_1$2.expandable)(__assign$1(__assign$1({}, MathDocument_js_1.AbstractMathDocument.OPTIONS.renderActions), {
      styles: [MathItem_js_1.STATE.INSERTED + 1, '', 'updateStyleSheet', false]
    })),
    MathList: HTMLMathList_js_1.HTMLMathList,
    MathItem: HTMLMathItem_js_1.HTMLMathItem,
    DomStrings: null
  });
  return HTMLDocument;
})(MathDocument_js_1.AbstractMathDocument);
HTMLDocument$1.HTMLDocument = HTMLDocument;

var __extends$c = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(HTMLHandler$1, "__esModule", {
  value: true
});
HTMLHandler$1.HTMLHandler = void 0;
var Handler_js_1 = Handler;
var HTMLDocument_js_1 = HTMLDocument$1;
var HTMLHandler = (function (_super) {
  __extends$c(HTMLHandler, _super);
  function HTMLHandler() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.documentClass = HTMLDocument_js_1.HTMLDocument;
    return _this;
  }
  HTMLHandler.prototype.handlesDocument = function (document) {
    var adaptor = this.adaptor;
    if (typeof document === 'string') {
      try {
        document = adaptor.parse(document, 'text/html');
      } catch (err) {}
    }
    if (document instanceof adaptor.window.Document || document instanceof adaptor.window.HTMLElement || document instanceof adaptor.window.DocumentFragment) {
      return true;
    }
    return false;
  };
  HTMLHandler.prototype.create = function (document, options) {
    var adaptor = this.adaptor;
    if (typeof document === 'string') {
      document = adaptor.parse(document, 'text/html');
    } else if (document instanceof adaptor.window.HTMLElement || document instanceof adaptor.window.DocumentFragment) {
      var child = document;
      document = adaptor.parse('', 'text/html');
      adaptor.append(adaptor.body(document), child);
    }
    return _super.prototype.create.call(this, document, options);
  };
  return HTMLHandler;
})(Handler_js_1.AbstractHandler);
HTMLHandler$1.HTMLHandler = HTMLHandler;

Object.defineProperty(html, "__esModule", {
  value: true
});
var RegisterHTMLHandler_1 = html.RegisterHTMLHandler = void 0;
var mathjax_js_1 = mathjax;
var HTMLHandler_js_1 = HTMLHandler$1;
function RegisterHTMLHandler(adaptor) {
  var handler = new HTMLHandler_js_1.HTMLHandler(adaptor);
  mathjax_js_1.mathjax.handlers.register(handler);
  return handler;
}
RegisterHTMLHandler_1 = html.RegisterHTMLHandler = RegisterHTMLHandler;

var browserAdaptor$1 = {};

var HTMLAdaptor$1 = {};

var DOMAdaptor = {};

var __values$7 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(DOMAdaptor, "__esModule", {
  value: true
});
DOMAdaptor.AbstractDOMAdaptor = void 0;
var AbstractDOMAdaptor = (function () {
  function AbstractDOMAdaptor(document) {
    if (document === void 0) {
      document = null;
    }
    this.document = document;
  }
  AbstractDOMAdaptor.prototype.node = function (kind, def, children, ns) {
    var e_1, _a;
    if (def === void 0) {
      def = {};
    }
    if (children === void 0) {
      children = [];
    }
    var node = this.create(kind, ns);
    this.setAttributes(node, def);
    try {
      for (var children_1 = __values$7(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
        var child = children_1_1.value;
        this.append(node, child);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return node;
  };
  AbstractDOMAdaptor.prototype.setAttributes = function (node, def) {
    var e_2, _a, e_3, _b, e_4, _c;
    if (def.style && typeof def.style !== 'string') {
      try {
        for (var _d = __values$7(Object.keys(def.style)), _e = _d.next(); !_e.done; _e = _d.next()) {
          var key = _e.value;
          this.setStyle(node, key.replace(/-([a-z])/g, function (_m, c) {
            return c.toUpperCase();
          }), def.style[key]);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
    if (def.properties) {
      try {
        for (var _f = __values$7(Object.keys(def.properties)), _g = _f.next(); !_g.done; _g = _f.next()) {
          var key = _g.value;
          node[key] = def.properties[key];
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    }
    try {
      for (var _h = __values$7(Object.keys(def)), _j = _h.next(); !_j.done; _j = _h.next()) {
        var key = _j.value;
        if ((key !== 'style' || typeof def.style === 'string') && key !== 'properties') {
          this.setAttribute(node, key, def[key]);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
  };
  AbstractDOMAdaptor.prototype.replace = function (nnode, onode) {
    this.insert(nnode, onode);
    this.remove(onode);
    return onode;
  };
  AbstractDOMAdaptor.prototype.childNode = function (node, i) {
    return this.childNodes(node)[i];
  };
  AbstractDOMAdaptor.prototype.allClasses = function (node) {
    var classes = this.getAttribute(node, 'class');
    return !classes ? [] : classes.replace(/  +/g, ' ').replace(/^ /, '').replace(/ $/, '').split(/ /);
  };
  return AbstractDOMAdaptor;
})();
DOMAdaptor.AbstractDOMAdaptor = AbstractDOMAdaptor;

var __extends$b = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$6 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(HTMLAdaptor$1, "__esModule", {
  value: true
});
HTMLAdaptor$1.HTMLAdaptor = void 0;
var DOMAdaptor_js_1 = DOMAdaptor;
var HTMLAdaptor = (function (_super) {
  __extends$b(HTMLAdaptor, _super);
  function HTMLAdaptor(window) {
    var _this = _super.call(this, window.document) || this;
    _this.window = window;
    _this.parser = new window.DOMParser();
    return _this;
  }
  HTMLAdaptor.prototype.parse = function (text, format) {
    if (format === void 0) {
      format = 'text/html';
    }
    return this.parser.parseFromString(text, format);
  };
  HTMLAdaptor.prototype.create = function (kind, ns) {
    return ns ? this.document.createElementNS(ns, kind) : this.document.createElement(kind);
  };
  HTMLAdaptor.prototype.text = function (text) {
    return this.document.createTextNode(text);
  };
  HTMLAdaptor.prototype.head = function (doc) {
    return doc.head || doc;
  };
  HTMLAdaptor.prototype.body = function (doc) {
    return doc.body || doc;
  };
  HTMLAdaptor.prototype.root = function (doc) {
    return doc.documentElement || doc;
  };
  HTMLAdaptor.prototype.doctype = function (doc) {
    return doc.doctype ? ("<!DOCTYPE ").concat(doc.doctype.name, ">") : '';
  };
  HTMLAdaptor.prototype.tags = function (node, name, ns) {
    if (ns === void 0) {
      ns = null;
    }
    var nodes = ns ? node.getElementsByTagNameNS(ns, name) : node.getElementsByTagName(name);
    return Array.from(nodes);
  };
  HTMLAdaptor.prototype.getElements = function (nodes, _document) {
    var e_1, _a;
    var containers = [];
    try {
      for (var nodes_1 = __values$6(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
        var node = nodes_1_1.value;
        if (typeof node === 'string') {
          containers = containers.concat(Array.from(this.document.querySelectorAll(node)));
        } else if (Array.isArray(node)) {
          containers = containers.concat(Array.from(node));
        } else if (node instanceof this.window.NodeList || node instanceof this.window.HTMLCollection) {
          containers = containers.concat(Array.from(node));
        } else {
          containers.push(node);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return containers;
  };
  HTMLAdaptor.prototype.contains = function (container, node) {
    return container.contains(node);
  };
  HTMLAdaptor.prototype.parent = function (node) {
    return node.parentNode;
  };
  HTMLAdaptor.prototype.append = function (node, child) {
    return node.appendChild(child);
  };
  HTMLAdaptor.prototype.insert = function (nchild, ochild) {
    return this.parent(ochild).insertBefore(nchild, ochild);
  };
  HTMLAdaptor.prototype.remove = function (child) {
    return this.parent(child).removeChild(child);
  };
  HTMLAdaptor.prototype.replace = function (nnode, onode) {
    return this.parent(onode).replaceChild(nnode, onode);
  };
  HTMLAdaptor.prototype.clone = function (node) {
    return node.cloneNode(true);
  };
  HTMLAdaptor.prototype.split = function (node, n) {
    return node.splitText(n);
  };
  HTMLAdaptor.prototype.next = function (node) {
    return node.nextSibling;
  };
  HTMLAdaptor.prototype.previous = function (node) {
    return node.previousSibling;
  };
  HTMLAdaptor.prototype.firstChild = function (node) {
    return node.firstChild;
  };
  HTMLAdaptor.prototype.lastChild = function (node) {
    return node.lastChild;
  };
  HTMLAdaptor.prototype.childNodes = function (node) {
    return Array.from(node.childNodes);
  };
  HTMLAdaptor.prototype.childNode = function (node, i) {
    return node.childNodes[i];
  };
  HTMLAdaptor.prototype.kind = function (node) {
    var n = node.nodeType;
    return n === 1 || n === 3 || n === 8 ? node.nodeName.toLowerCase() : '';
  };
  HTMLAdaptor.prototype.value = function (node) {
    return node.nodeValue || '';
  };
  HTMLAdaptor.prototype.textContent = function (node) {
    return node.textContent;
  };
  HTMLAdaptor.prototype.innerHTML = function (node) {
    return node.innerHTML;
  };
  HTMLAdaptor.prototype.outerHTML = function (node) {
    return node.outerHTML;
  };
  HTMLAdaptor.prototype.serializeXML = function (node) {
    var serializer = new this.window.XMLSerializer();
    return serializer.serializeToString(node);
  };
  HTMLAdaptor.prototype.setAttribute = function (node, name, value, ns) {
    if (ns === void 0) {
      ns = null;
    }
    if (!ns) {
      return node.setAttribute(name, value);
    }
    name = ns.replace(/.*\//, '') + ':' + name.replace(/^.*:/, '');
    return node.setAttributeNS(ns, name, value);
  };
  HTMLAdaptor.prototype.getAttribute = function (node, name) {
    return node.getAttribute(name);
  };
  HTMLAdaptor.prototype.removeAttribute = function (node, name) {
    return node.removeAttribute(name);
  };
  HTMLAdaptor.prototype.hasAttribute = function (node, name) {
    return node.hasAttribute(name);
  };
  HTMLAdaptor.prototype.allAttributes = function (node) {
    return Array.from(node.attributes).map(function (x) {
      return {
        name: x.name,
        value: x.value
      };
    });
  };
  HTMLAdaptor.prototype.addClass = function (node, name) {
    if (node.classList) {
      node.classList.add(name);
    } else {
      node.className = (node.className + ' ' + name).trim();
    }
  };
  HTMLAdaptor.prototype.removeClass = function (node, name) {
    if (node.classList) {
      node.classList.remove(name);
    } else {
      node.className = node.className.split(/ /).filter(function (c) {
        return c !== name;
      }).join(' ');
    }
  };
  HTMLAdaptor.prototype.hasClass = function (node, name) {
    if (node.classList) {
      return node.classList.contains(name);
    }
    return node.className.split(/ /).indexOf(name) >= 0;
  };
  HTMLAdaptor.prototype.setStyle = function (node, name, value) {
    node.style[name] = value;
  };
  HTMLAdaptor.prototype.getStyle = function (node, name) {
    return node.style[name];
  };
  HTMLAdaptor.prototype.allStyles = function (node) {
    return node.style.cssText;
  };
  HTMLAdaptor.prototype.insertRules = function (node, rules) {
    var e_2, _a;
    try {
      for (var _b = __values$6(rules.reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var rule = _c.value;
        try {
          node.sheet.insertRule(rule, 0);
        } catch (e) {
          console.warn(("MathJax: can't insert css rule '").concat(rule, "': ").concat(e.message));
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  HTMLAdaptor.prototype.fontSize = function (node) {
    var style = this.window.getComputedStyle(node);
    return parseFloat(style.fontSize);
  };
  HTMLAdaptor.prototype.fontFamily = function (node) {
    var style = this.window.getComputedStyle(node);
    return style.fontFamily || '';
  };
  HTMLAdaptor.prototype.nodeSize = function (node, em, local) {
    if (em === void 0) {
      em = 1;
    }
    if (local === void 0) {
      local = false;
    }
    if (local && node.getBBox) {
      var _a = node.getBBox(), width = _a.width, height = _a.height;
      return [width / em, height / em];
    }
    return [node.offsetWidth / em, node.offsetHeight / em];
  };
  HTMLAdaptor.prototype.nodeBBox = function (node) {
    var _a = node.getBoundingClientRect(), left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom;
    return {
      left: left,
      right: right,
      top: top,
      bottom: bottom
    };
  };
  return HTMLAdaptor;
})(DOMAdaptor_js_1.AbstractDOMAdaptor);
HTMLAdaptor$1.HTMLAdaptor = HTMLAdaptor;

Object.defineProperty(browserAdaptor$1, "__esModule", {
  value: true
});
var browserAdaptor_2 = browserAdaptor$1.browserAdaptor = void 0;
var HTMLAdaptor_js_1 = HTMLAdaptor$1;
function browserAdaptor() {
  return new HTMLAdaptor_js_1.HTMLAdaptor(window);
}
browserAdaptor_2 = browserAdaptor$1.browserAdaptor = browserAdaptor;

var AllPackages = {};

var ActionConfiguration = {};

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ActionConfiguration = exports.ActionMethods = void 0;
  var Configuration_js_1 = Configuration;
  var TexParser_js_1 = __importDefault(TexParser$1);
  var SymbolMap_js_1 = SymbolMap;
  var BaseMethods_js_1 = __importDefault(BaseMethods$1);
  exports.ActionMethods = {};
  exports.ActionMethods.Macro = BaseMethods_js_1.default.Macro;
  exports.ActionMethods.Toggle = function (parser, name) {
    var children = [];
    var arg;
    while ((arg = parser.GetArgument(name)) !== '\\endtoggle') {
      children.push(new TexParser_js_1.default(arg, parser.stack.env, parser.configuration).mml());
    }
    parser.Push(parser.create('node', 'maction', children, {
      actiontype: 'toggle'
    }));
  };
  exports.ActionMethods.Mathtip = function (parser, name) {
    var arg = parser.ParseArg(name);
    var tip = parser.ParseArg(name);
    parser.Push(parser.create('node', 'maction', [arg, tip], {
      actiontype: 'tooltip'
    }));
  };
  new SymbolMap_js_1.CommandMap('action-macros', {
    toggle: 'Toggle',
    mathtip: 'Mathtip',
    texttip: ['Macro', '\\mathtip{#1}{\\text{#2}}', 2]
  }, exports.ActionMethods);
  exports.ActionConfiguration = Configuration_js_1.Configuration.create('action', {
    handler: {
      macro: ['action-macros']
    }
  });
})(ActionConfiguration);
getDefaultExportFromCjs(ActionConfiguration);

var AmsConfiguration = {};

var AmsItems = {};

var __extends$a = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __assign = commonjsGlobal && commonjsGlobal.__assign || (function () {
  __assign = Object.assign || (function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  });
  return __assign.apply(this, arguments);
});
var __importDefault$w = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(AmsItems, "__esModule", {
  value: true
});
AmsItems.FlalignItem = AmsItems.MultlineItem = void 0;
var BaseItems_js_1$4 = BaseItems;
var ParseUtil_js_1$a = __importDefault$w(ParseUtil$1);
var NodeUtil_js_1$7 = __importDefault$w(NodeUtil$1);
var TexError_js_1$d = __importDefault$w(TexError$1);
var TexConstants_js_1$8 = TexConstants;
var MultlineItem = (function (_super) {
  __extends$a(MultlineItem, _super);
  function MultlineItem(factory) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var _this = _super.call(this, factory) || this;
    _this.factory.configuration.tags.start('multline', true, args[0]);
    return _this;
  }
  Object.defineProperty(MultlineItem.prototype, "kind", {
    get: function () {
      return 'multline';
    },
    enumerable: false,
    configurable: true
  });
  MultlineItem.prototype.EndEntry = function () {
    if (this.table.length) {
      ParseUtil_js_1$a.default.fixInitialMO(this.factory.configuration, this.nodes);
    }
    var shove = this.getProperty('shove');
    var mtd = this.create('node', 'mtd', this.nodes, shove ? {
      columnalign: shove
    } : {});
    this.setProperty('shove', null);
    this.row.push(mtd);
    this.Clear();
  };
  MultlineItem.prototype.EndRow = function () {
    if (this.row.length !== 1) {
      throw new TexError_js_1$d.default('MultlineRowsOneCol', 'The rows within the %1 environment must have exactly one column', 'multline');
    }
    var row = this.create('node', 'mtr', this.row);
    this.table.push(row);
    this.row = [];
  };
  MultlineItem.prototype.EndTable = function () {
    _super.prototype.EndTable.call(this);
    if (this.table.length) {
      var m = this.table.length - 1, label = -1;
      if (!NodeUtil_js_1$7.default.getAttribute(NodeUtil_js_1$7.default.getChildren(this.table[0])[0], 'columnalign')) {
        NodeUtil_js_1$7.default.setAttribute(NodeUtil_js_1$7.default.getChildren(this.table[0])[0], 'columnalign', TexConstants_js_1$8.TexConstant.Align.LEFT);
      }
      if (!NodeUtil_js_1$7.default.getAttribute(NodeUtil_js_1$7.default.getChildren(this.table[m])[0], 'columnalign')) {
        NodeUtil_js_1$7.default.setAttribute(NodeUtil_js_1$7.default.getChildren(this.table[m])[0], 'columnalign', TexConstants_js_1$8.TexConstant.Align.RIGHT);
      }
      var tag = this.factory.configuration.tags.getTag();
      if (tag) {
        label = this.arraydef.side === TexConstants_js_1$8.TexConstant.Align.LEFT ? 0 : this.table.length - 1;
        var mtr = this.table[label];
        var mlabel = this.create('node', 'mlabeledtr', [tag].concat(NodeUtil_js_1$7.default.getChildren(mtr)));
        NodeUtil_js_1$7.default.copyAttributes(mtr, mlabel);
        this.table[label] = mlabel;
      }
    }
    this.factory.configuration.tags.end();
  };
  return MultlineItem;
})(BaseItems_js_1$4.ArrayItem);
AmsItems.MultlineItem = MultlineItem;
var FlalignItem = (function (_super) {
  __extends$a(FlalignItem, _super);
  function FlalignItem(factory, name, numbered, padded, center) {
    var _this = _super.call(this, factory) || this;
    _this.name = name;
    _this.numbered = numbered;
    _this.padded = padded;
    _this.center = center;
    _this.factory.configuration.tags.start(name, numbered, numbered);
    return _this;
  }
  Object.defineProperty(FlalignItem.prototype, "kind", {
    get: function () {
      return 'flalign';
    },
    enumerable: false,
    configurable: true
  });
  FlalignItem.prototype.EndEntry = function () {
    _super.prototype.EndEntry.call(this);
    var n = this.getProperty('xalignat');
    if (!n) return;
    if (this.row.length > n) {
      throw new TexError_js_1$d.default('XalignOverflow', 'Extra %1 in row of %2', '&', this.name);
    }
  };
  FlalignItem.prototype.EndRow = function () {
    var cell;
    var row = this.row;
    var n = this.getProperty('xalignat');
    while (row.length < n) {
      row.push(this.create('node', 'mtd'));
    }
    this.row = [];
    if (this.padded) {
      this.row.push(this.create('node', 'mtd'));
    }
    while (cell = row.shift()) {
      this.row.push(cell);
      cell = row.shift();
      if (cell) this.row.push(cell);
      if (row.length || this.padded) {
        this.row.push(this.create('node', 'mtd'));
      }
    }
    if (this.row.length > this.maxrow) {
      this.maxrow = this.row.length;
    }
    _super.prototype.EndRow.call(this);
    var mtr = this.table[this.table.length - 1];
    if (this.getProperty('zeroWidthLabel') && mtr.isKind('mlabeledtr')) {
      var mtd = NodeUtil_js_1$7.default.getChildren(mtr)[0];
      var side = this.factory.configuration.options['tagSide'];
      var def = __assign({
        width: 0
      }, side === 'right' ? {
        lspace: '-1width'
      } : {});
      var mpadded = this.create('node', 'mpadded', NodeUtil_js_1$7.default.getChildren(mtd), def);
      mtd.setChildren([mpadded]);
    }
  };
  FlalignItem.prototype.EndTable = function () {
    _super.prototype.EndTable.call(this);
    if (this.center) {
      if (this.maxrow <= 2) {
        var def = this.arraydef;
        delete def.width;
        delete this.global.indentalign;
      }
    }
  };
  return FlalignItem;
})(BaseItems_js_1$4.EqnArrayItem);
AmsItems.FlalignItem = FlalignItem;

var AmsMethods = {};

(function (exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || (function () {
    __assign = Object.assign || (function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    });
    return __assign.apply(this, arguments);
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NEW_OPS = exports.AmsMethods = void 0;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var ParseMethods_js_1 = __importDefault(ParseMethods$1);
  var NodeUtil_js_1 = __importDefault(NodeUtil$1);
  var TexConstants_js_1 = TexConstants;
  var TexParser_js_1 = __importDefault(TexParser$1);
  var TexError_js_1 = __importDefault(TexError$1);
  var Symbol_js_1 = _Symbol;
  var BaseMethods_js_1 = __importDefault(BaseMethods$1);
  var MmlNode_js_1 = MmlNode;
  exports.AmsMethods = {};
  exports.AmsMethods.AmsEqnArray = function (parser, begin, numbered, taggable, align, spacing, style) {
    var args = parser.GetBrackets('\\begin{' + begin.getName() + '}');
    var array = BaseMethods_js_1.default.EqnArray(parser, begin, numbered, taggable, align, spacing, style);
    return ParseUtil_js_1.default.setArrayAlign(array, args);
  };
  exports.AmsMethods.AlignAt = function (parser, begin, numbered, taggable) {
    var name = begin.getName();
    var n, valign, align = '', spacing = [];
    if (!taggable) {
      valign = parser.GetBrackets('\\begin{' + name + '}');
    }
    n = parser.GetArgument('\\begin{' + name + '}');
    if (n.match(/[^0-9]/)) {
      throw new TexError_js_1.default('PositiveIntegerArg', 'Argument to %1 must me a positive integer', '\\begin{' + name + '}');
    }
    var count = parseInt(n, 10);
    while (count > 0) {
      align += 'rl';
      spacing.push('0em 0em');
      count--;
    }
    var spaceStr = spacing.join(' ');
    if (taggable) {
      return exports.AmsMethods.EqnArray(parser, begin, numbered, taggable, align, spaceStr);
    }
    var array = exports.AmsMethods.EqnArray(parser, begin, numbered, taggable, align, spaceStr);
    return ParseUtil_js_1.default.setArrayAlign(array, valign);
  };
  exports.AmsMethods.Multline = function (parser, begin, numbered) {
    parser.Push(begin);
    ParseUtil_js_1.default.checkEqnEnv(parser);
    var item = parser.itemFactory.create('multline', numbered, parser.stack);
    item.arraydef = {
      displaystyle: true,
      rowspacing: '.5em',
      columnspacing: '100%',
      width: parser.options.ams['multlineWidth'],
      side: parser.options['tagSide'],
      minlabelspacing: parser.options['tagIndent'],
      framespacing: parser.options.ams['multlineIndent'] + ' 0',
      frame: '',
      'data-width-includes-label': true
    };
    return item;
  };
  exports.AmsMethods.XalignAt = function (parser, begin, numbered, padded) {
    var n = parser.GetArgument('\\begin{' + begin.getName() + '}');
    if (n.match(/[^0-9]/)) {
      throw new TexError_js_1.default('PositiveIntegerArg', 'Argument to %1 must me a positive integer', '\\begin{' + begin.getName() + '}');
    }
    var align = padded ? 'crl' : 'rlc';
    var width = padded ? 'fit auto auto' : 'auto auto fit';
    var item = exports.AmsMethods.FlalignArray(parser, begin, numbered, padded, false, align, width, true);
    item.setProperty('xalignat', 2 * parseInt(n));
    return item;
  };
  exports.AmsMethods.FlalignArray = function (parser, begin, numbered, padded, center, align, width, zeroWidthLabel) {
    if (zeroWidthLabel === void 0) {
      zeroWidthLabel = false;
    }
    parser.Push(begin);
    ParseUtil_js_1.default.checkEqnEnv(parser);
    align = align.split('').join(' ').replace(/r/g, 'right').replace(/l/g, 'left').replace(/c/g, 'center');
    var item = parser.itemFactory.create('flalign', begin.getName(), numbered, padded, center, parser.stack);
    item.arraydef = {
      width: '100%',
      displaystyle: true,
      columnalign: align,
      columnspacing: '0em',
      columnwidth: width,
      rowspacing: '3pt',
      side: parser.options['tagSide'],
      minlabelspacing: zeroWidthLabel ? '0' : parser.options['tagIndent'],
      'data-width-includes-label': true
    };
    item.setProperty('zeroWidthLabel', zeroWidthLabel);
    return item;
  };
  exports.NEW_OPS = 'ams-declare-ops';
  exports.AmsMethods.HandleDeclareOp = function (parser, name) {
    var star = parser.GetStar() ? '*' : '';
    var cs = ParseUtil_js_1.default.trimSpaces(parser.GetArgument(name));
    if (cs.charAt(0) === '\\') {
      cs = cs.substr(1);
    }
    var op = parser.GetArgument(name);
    parser.configuration.handlers.retrieve(exports.NEW_OPS).add(cs, new Symbol_js_1.Macro(cs, exports.AmsMethods.Macro, [("\\operatorname").concat(star, "{").concat(op, "}")]));
  };
  exports.AmsMethods.HandleOperatorName = function (parser, name) {
    var star = parser.GetStar();
    var op = ParseUtil_js_1.default.trimSpaces(parser.GetArgument(name));
    var mml = new TexParser_js_1.default(op, __assign(__assign({}, parser.stack.env), {
      font: TexConstants_js_1.TexConstant.Variant.NORMAL,
      multiLetterIdentifiers: /^[-*a-z]+/i,
      operatorLetters: true
    }), parser.configuration).mml();
    if (!mml.isKind('mi')) {
      mml = parser.create('node', 'TeXAtom', [mml]);
    }
    NodeUtil_js_1.default.setProperties(mml, {
      movesupsub: star,
      movablelimits: true,
      texClass: MmlNode_js_1.TEXCLASS.OP
    });
    if (!star) {
      var c = parser.GetNext(), i = parser.i;
      if (c === '\\' && ++parser.i && parser.GetCS() !== 'limits') {
        parser.i = i;
      }
    }
    parser.Push(mml);
  };
  exports.AmsMethods.SideSet = function (parser, name) {
    var _a = __read(splitSideSet(parser.ParseArg(name)), 2), preScripts = _a[0], preRest = _a[1];
    var _b = __read(splitSideSet(parser.ParseArg(name)), 2), postScripts = _b[0], postRest = _b[1];
    var base = parser.ParseArg(name);
    var mml = base;
    if (preScripts) {
      if (preRest) {
        preScripts.replaceChild(parser.create('node', 'mphantom', [parser.create('node', 'mpadded', [ParseUtil_js_1.default.copyNode(base, parser)], {
          width: 0
        })]), NodeUtil_js_1.default.getChildAt(preScripts, 0));
      } else {
        mml = parser.create('node', 'mmultiscripts', [base]);
        if (postScripts) {
          NodeUtil_js_1.default.appendChildren(mml, [NodeUtil_js_1.default.getChildAt(postScripts, 1) || parser.create('node', 'none'), NodeUtil_js_1.default.getChildAt(postScripts, 2) || parser.create('node', 'none')]);
        }
        NodeUtil_js_1.default.setProperty(mml, 'scriptalign', 'left');
        NodeUtil_js_1.default.appendChildren(mml, [parser.create('node', 'mprescripts'), NodeUtil_js_1.default.getChildAt(preScripts, 1) || parser.create('node', 'none'), NodeUtil_js_1.default.getChildAt(preScripts, 2) || parser.create('node', 'none')]);
      }
    }
    if (postScripts && mml === base) {
      postScripts.replaceChild(base, NodeUtil_js_1.default.getChildAt(postScripts, 0));
      mml = postScripts;
    }
    var mrow = parser.create('node', 'TeXAtom', [], {
      texClass: MmlNode_js_1.TEXCLASS.OP,
      movesupsub: true,
      movablelimits: true
    });
    if (preRest) {
      preScripts && mrow.appendChild(preScripts);
      mrow.appendChild(preRest);
    }
    mrow.appendChild(mml);
    postRest && mrow.appendChild(postRest);
    parser.Push(mrow);
  };
  function splitSideSet(mml) {
    if (!mml || mml.isInferred && mml.childNodes.length === 0) return [null, null];
    if (mml.isKind('msubsup') && checkSideSetBase(mml)) return [mml, null];
    var child = NodeUtil_js_1.default.getChildAt(mml, 0);
    if (!(mml.isInferred && child && checkSideSetBase(child))) return [null, mml];
    mml.childNodes.splice(0, 1);
    return [child, mml];
  }
  function checkSideSetBase(mml) {
    var base = mml.childNodes[0];
    return base && base.isKind('mi') && base.getText() === '';
  }
  exports.AmsMethods.operatorLetter = function (parser, c) {
    return parser.stack.env.operatorLetters ? ParseMethods_js_1.default.variable(parser, c) : false;
  };
  exports.AmsMethods.MultiIntegral = function (parser, name, integral) {
    var next = parser.GetNext();
    if (next === '\\') {
      var i = parser.i;
      next = parser.GetArgument(name);
      parser.i = i;
      if (next === '\\limits') {
        if (name === '\\idotsint') {
          integral = '\\!\\!\\mathop{\\,\\,' + integral + '}';
        } else {
          integral = '\\!\\!\\!\\mathop{\\,\\,\\,' + integral + '}';
        }
      }
    }
    parser.string = integral + ' ' + parser.string.slice(parser.i);
    parser.i = 0;
  };
  exports.AmsMethods.xArrow = function (parser, name, chr, l, r) {
    var def = {
      width: '+' + ParseUtil_js_1.default.Em((l + r) / 18),
      lspace: ParseUtil_js_1.default.Em(l / 18)
    };
    var bot = parser.GetBrackets(name);
    var first = parser.ParseArg(name);
    var dstrut = parser.create('node', 'mspace', [], {
      depth: '.25em'
    });
    var arrow = parser.create('token', 'mo', {
      stretchy: true,
      texClass: MmlNode_js_1.TEXCLASS.REL
    }, String.fromCodePoint(chr));
    arrow = parser.create('node', 'mstyle', [arrow], {
      scriptlevel: 0
    });
    var mml = parser.create('node', 'munderover', [arrow]);
    var mpadded = parser.create('node', 'mpadded', [first, dstrut], def);
    NodeUtil_js_1.default.setAttribute(mpadded, 'voffset', '-.2em');
    NodeUtil_js_1.default.setAttribute(mpadded, 'height', '-.2em');
    NodeUtil_js_1.default.setChild(mml, mml.over, mpadded);
    if (bot) {
      var bottom = new TexParser_js_1.default(bot, parser.stack.env, parser.configuration).mml();
      var bstrut = parser.create('node', 'mspace', [], {
        height: '.75em'
      });
      mpadded = parser.create('node', 'mpadded', [bottom, bstrut], def);
      NodeUtil_js_1.default.setAttribute(mpadded, 'voffset', '.15em');
      NodeUtil_js_1.default.setAttribute(mpadded, 'depth', '-.15em');
      NodeUtil_js_1.default.setChild(mml, mml.under, mpadded);
    }
    NodeUtil_js_1.default.setProperty(mml, 'subsupOK', true);
    parser.Push(mml);
  };
  exports.AmsMethods.HandleShove = function (parser, _name, shove) {
    var top = parser.stack.Top();
    if (top.kind !== 'multline') {
      throw new TexError_js_1.default('CommandOnlyAllowedInEnv', '%1 only allowed in %2 environment', parser.currentCS, 'multline');
    }
    if (top.Size()) {
      throw new TexError_js_1.default('CommandAtTheBeginingOfLine', '%1 must come at the beginning of the line', parser.currentCS);
    }
    top.setProperty('shove', shove);
  };
  exports.AmsMethods.CFrac = function (parser, name) {
    var lr = ParseUtil_js_1.default.trimSpaces(parser.GetBrackets(name, ''));
    var num = parser.GetArgument(name);
    var den = parser.GetArgument(name);
    var lrMap = {
      l: TexConstants_js_1.TexConstant.Align.LEFT,
      r: TexConstants_js_1.TexConstant.Align.RIGHT,
      '': ''
    };
    var numNode = new TexParser_js_1.default('\\strut\\textstyle{' + num + '}', parser.stack.env, parser.configuration).mml();
    var denNode = new TexParser_js_1.default('\\strut\\textstyle{' + den + '}', parser.stack.env, parser.configuration).mml();
    var frac = parser.create('node', 'mfrac', [numNode, denNode]);
    lr = lrMap[lr];
    if (lr == null) {
      throw new TexError_js_1.default('IllegalAlign', 'Illegal alignment specified in %1', parser.currentCS);
    }
    if (lr) {
      NodeUtil_js_1.default.setProperties(frac, {
        numalign: lr,
        denomalign: lr
      });
    }
    parser.Push(frac);
  };
  exports.AmsMethods.Genfrac = function (parser, name, left, right, thick, style) {
    if (left == null) {
      left = parser.GetDelimiterArg(name);
    }
    if (right == null) {
      right = parser.GetDelimiterArg(name);
    }
    if (thick == null) {
      thick = parser.GetArgument(name);
    }
    if (style == null) {
      style = ParseUtil_js_1.default.trimSpaces(parser.GetArgument(name));
    }
    var num = parser.ParseArg(name);
    var den = parser.ParseArg(name);
    var frac = parser.create('node', 'mfrac', [num, den]);
    if (thick !== '') {
      NodeUtil_js_1.default.setAttribute(frac, 'linethickness', thick);
    }
    if (left || right) {
      NodeUtil_js_1.default.setProperty(frac, 'withDelims', true);
      frac = ParseUtil_js_1.default.fixedFence(parser.configuration, left, frac, right);
    }
    if (style !== '') {
      var styleDigit = parseInt(style, 10);
      var styleAlpha = ['D', 'T', 'S', 'SS'][styleDigit];
      if (styleAlpha == null) {
        throw new TexError_js_1.default('BadMathStyleFor', 'Bad math style for %1', parser.currentCS);
      }
      frac = parser.create('node', 'mstyle', [frac]);
      if (styleAlpha === 'D') {
        NodeUtil_js_1.default.setProperties(frac, {
          displaystyle: true,
          scriptlevel: 0
        });
      } else {
        NodeUtil_js_1.default.setProperties(frac, {
          displaystyle: false,
          scriptlevel: styleDigit - 1
        });
      }
    }
    parser.Push(frac);
  };
  exports.AmsMethods.HandleTag = function (parser, name) {
    if (!parser.tags.currentTag.taggable && parser.tags.env) {
      throw new TexError_js_1.default('CommandNotAllowedInEnv', '%1 not allowed in %2 environment', parser.currentCS, parser.tags.env);
    }
    if (parser.tags.currentTag.tag) {
      throw new TexError_js_1.default('MultipleCommand', 'Multiple %1', parser.currentCS);
    }
    var star = parser.GetStar();
    var tagId = ParseUtil_js_1.default.trimSpaces(parser.GetArgument(name));
    parser.tags.tag(tagId, star);
  };
  exports.AmsMethods.HandleNoTag = BaseMethods_js_1.default.HandleNoTag;
  exports.AmsMethods.HandleRef = BaseMethods_js_1.default.HandleRef;
  exports.AmsMethods.Macro = BaseMethods_js_1.default.Macro;
  exports.AmsMethods.Accent = BaseMethods_js_1.default.Accent;
  exports.AmsMethods.Tilde = BaseMethods_js_1.default.Tilde;
  exports.AmsMethods.Array = BaseMethods_js_1.default.Array;
  exports.AmsMethods.Spacer = BaseMethods_js_1.default.Spacer;
  exports.AmsMethods.NamedOp = BaseMethods_js_1.default.NamedOp;
  exports.AmsMethods.EqnArray = BaseMethods_js_1.default.EqnArray;
  exports.AmsMethods.Equation = BaseMethods_js_1.default.Equation;
})(AmsMethods);
getDefaultExportFromCjs(AmsMethods);

var __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$5(result, mod, k);
  __setModuleDefault$5(result, mod);
  return result;
});
var __importDefault$v = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var AmsMethods_js_1$2 = AmsMethods;
var sm$3 = __importStar$5(SymbolMap);
var TexConstants_js_1$7 = TexConstants;
var ParseMethods_js_1$6 = __importDefault$v(ParseMethods$1);
var ParseUtil_js_1$9 = __importDefault$v(ParseUtil$1);
var MmlNode_js_1$6 = MmlNode;
var lengths_js_1$1 = lengths;
new sm$3.CharacterMap('AMSmath-mathchar0mo', ParseMethods_js_1$6.default.mathchar0mo, {
  iiiint: ['\u2A0C', {
    texClass: MmlNode_js_1$6.TEXCLASS.OP
  }]
});
new sm$3.RegExpMap('AMSmath-operatorLetter', AmsMethods_js_1$2.AmsMethods.operatorLetter, /[-*]/i);
new sm$3.CommandMap('AMSmath-macros', {
  mathring: ['Accent', '02DA'],
  nobreakspace: 'Tilde',
  negmedspace: ['Spacer', lengths_js_1$1.MATHSPACE.negativemediummathspace],
  negthickspace: ['Spacer', lengths_js_1$1.MATHSPACE.negativethickmathspace],
  idotsint: ['MultiIntegral', '\\int\\cdots\\int'],
  dddot: ['Accent', '20DB'],
  ddddot: ['Accent', '20DC'],
  sideset: 'SideSet',
  boxed: ['Macro', '\\fbox{$\\displaystyle{#1}$}', 1],
  tag: 'HandleTag',
  notag: 'HandleNoTag',
  eqref: ['HandleRef', true],
  substack: ['Macro', '\\begin{subarray}{c}#1\\end{subarray}', 1],
  injlim: ['NamedOp', 'inj&thinsp;lim'],
  projlim: ['NamedOp', 'proj&thinsp;lim'],
  varliminf: ['Macro', '\\mathop{\\underline{\\mmlToken{mi}{lim}}}'],
  varlimsup: ['Macro', '\\mathop{\\overline{\\mmlToken{mi}{lim}}}'],
  varinjlim: ['Macro', '\\mathop{\\underrightarrow{\\mmlToken{mi}{lim}}}'],
  varprojlim: ['Macro', '\\mathop{\\underleftarrow{\\mmlToken{mi}{lim}}}'],
  DeclareMathOperator: 'HandleDeclareOp',
  operatorname: 'HandleOperatorName',
  genfrac: 'Genfrac',
  frac: ['Genfrac', '', '', '', ''],
  tfrac: ['Genfrac', '', '', '', '1'],
  dfrac: ['Genfrac', '', '', '', '0'],
  binom: ['Genfrac', '(', ')', '0', ''],
  tbinom: ['Genfrac', '(', ')', '0', '1'],
  dbinom: ['Genfrac', '(', ')', '0', '0'],
  cfrac: 'CFrac',
  shoveleft: ['HandleShove', TexConstants_js_1$7.TexConstant.Align.LEFT],
  shoveright: ['HandleShove', TexConstants_js_1$7.TexConstant.Align.RIGHT],
  xrightarrow: ['xArrow', 0x2192, 5, 10],
  xleftarrow: ['xArrow', 0x2190, 10, 5]
}, AmsMethods_js_1$2.AmsMethods);
new sm$3.EnvironmentMap('AMSmath-environment', ParseMethods_js_1$6.default.environment, {
  'equation*': ['Equation', null, false],
  'eqnarray*': ['EqnArray', null, false, true, 'rcl', ParseUtil_js_1$9.default.cols(0, lengths_js_1$1.MATHSPACE.thickmathspace), '.5em'],
  align: ['EqnArray', null, true, true, 'rl', ParseUtil_js_1$9.default.cols(0, 2)],
  'align*': ['EqnArray', null, false, true, 'rl', ParseUtil_js_1$9.default.cols(0, 2)],
  multline: ['Multline', null, true],
  'multline*': ['Multline', null, false],
  split: ['EqnArray', null, false, false, 'rl', ParseUtil_js_1$9.default.cols(0)],
  gather: ['EqnArray', null, true, true, 'c'],
  'gather*': ['EqnArray', null, false, true, 'c'],
  alignat: ['AlignAt', null, true, true],
  'alignat*': ['AlignAt', null, false, true],
  alignedat: ['AlignAt', null, false, false],
  aligned: ['AmsEqnArray', null, null, null, 'rl', ParseUtil_js_1$9.default.cols(0, 2), '.5em', 'D'],
  gathered: ['AmsEqnArray', null, null, null, 'c', null, '.5em', 'D'],
  xalignat: ['XalignAt', null, true, true],
  'xalignat*': ['XalignAt', null, false, true],
  xxalignat: ['XalignAt', null, false, false],
  flalign: ['FlalignArray', null, true, false, true, 'rlc', 'auto auto fit'],
  'flalign*': ['FlalignArray', null, false, false, true, 'rlc', 'auto auto fit'],
  subarray: ['Array', null, null, null, null, ParseUtil_js_1$9.default.cols(0), '0.1em', 'S', 1],
  smallmatrix: ['Array', null, null, null, 'c', ParseUtil_js_1$9.default.cols(1 / 3), '.2em', 'S', 1],
  matrix: ['Array', null, null, null, 'c'],
  pmatrix: ['Array', null, '(', ')', 'c'],
  bmatrix: ['Array', null, '[', ']', 'c'],
  Bmatrix: ['Array', null, '\\{', '\\}', 'c'],
  vmatrix: ['Array', null, '\\vert', '\\vert', 'c'],
  Vmatrix: ['Array', null, '\\Vert', '\\Vert', 'c'],
  cases: ['Array', null, '\\{', '.', 'll', null, '.2em', 'T']
}, AmsMethods_js_1$2.AmsMethods);
new sm$3.DelimiterMap('AMSmath-delimiter', ParseMethods_js_1$6.default.delimiter, {
  '\\lvert': ['\u007C', {
    texClass: MmlNode_js_1$6.TEXCLASS.OPEN
  }],
  '\\rvert': ['\u007C', {
    texClass: MmlNode_js_1$6.TEXCLASS.CLOSE
  }],
  '\\lVert': ['\u2016', {
    texClass: MmlNode_js_1$6.TEXCLASS.OPEN
  }],
  '\\rVert': ['\u2016', {
    texClass: MmlNode_js_1$6.TEXCLASS.CLOSE
  }]
});
new sm$3.CharacterMap('AMSsymbols-mathchar0mi', ParseMethods_js_1$6.default.mathchar0mi, {
  digamma: '\u03DD',
  varkappa: '\u03F0',
  varGamma: ['\u0393', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varDelta: ['\u0394', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varTheta: ['\u0398', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varLambda: ['\u039B', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varXi: ['\u039E', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varPi: ['\u03A0', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varSigma: ['\u03A3', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varUpsilon: ['\u03A5', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varPhi: ['\u03A6', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varPsi: ['\u03A8', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  varOmega: ['\u03A9', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.ITALIC
  }],
  beth: '\u2136',
  gimel: '\u2137',
  daleth: '\u2138',
  backprime: ['\u2035', {
    variantForm: true
  }],
  hslash: '\u210F',
  varnothing: ['\u2205', {
    variantForm: true
  }],
  blacktriangle: '\u25B4',
  triangledown: ['\u25BD', {
    variantForm: true
  }],
  blacktriangledown: '\u25BE',
  square: '\u25FB',
  Box: '\u25FB',
  blacksquare: '\u25FC',
  lozenge: '\u25CA',
  Diamond: '\u25CA',
  blacklozenge: '\u29EB',
  circledS: ['\u24C8', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.NORMAL
  }],
  bigstar: '\u2605',
  sphericalangle: '\u2222',
  measuredangle: '\u2221',
  nexists: '\u2204',
  complement: '\u2201',
  mho: '\u2127',
  eth: ['\u00F0', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.NORMAL
  }],
  Finv: '\u2132',
  diagup: '\u2571',
  Game: '\u2141',
  diagdown: '\u2572',
  Bbbk: ['\u006B', {
    mathvariant: TexConstants_js_1$7.TexConstant.Variant.DOUBLESTRUCK
  }],
  yen: '\u00A5',
  circledR: '\u00AE',
  checkmark: '\u2713',
  maltese: '\u2720'
});
new sm$3.CharacterMap('AMSsymbols-mathchar0mo', ParseMethods_js_1$6.default.mathchar0mo, {
  dotplus: '\u2214',
  ltimes: '\u22C9',
  smallsetminus: ['\u2216', {
    variantForm: true
  }],
  rtimes: '\u22CA',
  Cap: '\u22D2',
  doublecap: '\u22D2',
  leftthreetimes: '\u22CB',
  Cup: '\u22D3',
  doublecup: '\u22D3',
  rightthreetimes: '\u22CC',
  barwedge: '\u22BC',
  curlywedge: '\u22CF',
  veebar: '\u22BB',
  curlyvee: '\u22CE',
  doublebarwedge: '\u2A5E',
  boxminus: '\u229F',
  circleddash: '\u229D',
  boxtimes: '\u22A0',
  circledast: '\u229B',
  boxdot: '\u22A1',
  circledcirc: '\u229A',
  boxplus: '\u229E',
  centerdot: ['\u22C5', {
    variantForm: true
  }],
  divideontimes: '\u22C7',
  intercal: '\u22BA',
  leqq: '\u2266',
  geqq: '\u2267',
  leqslant: '\u2A7D',
  geqslant: '\u2A7E',
  eqslantless: '\u2A95',
  eqslantgtr: '\u2A96',
  lesssim: '\u2272',
  gtrsim: '\u2273',
  lessapprox: '\u2A85',
  gtrapprox: '\u2A86',
  approxeq: '\u224A',
  lessdot: '\u22D6',
  gtrdot: '\u22D7',
  lll: '\u22D8',
  llless: '\u22D8',
  ggg: '\u22D9',
  gggtr: '\u22D9',
  lessgtr: '\u2276',
  gtrless: '\u2277',
  lesseqgtr: '\u22DA',
  gtreqless: '\u22DB',
  lesseqqgtr: '\u2A8B',
  gtreqqless: '\u2A8C',
  doteqdot: '\u2251',
  Doteq: '\u2251',
  eqcirc: '\u2256',
  risingdotseq: '\u2253',
  circeq: '\u2257',
  fallingdotseq: '\u2252',
  triangleq: '\u225C',
  backsim: '\u223D',
  thicksim: ['\u223C', {
    variantForm: true
  }],
  backsimeq: '\u22CD',
  thickapprox: ['\u2248', {
    variantForm: true
  }],
  subseteqq: '\u2AC5',
  supseteqq: '\u2AC6',
  Subset: '\u22D0',
  Supset: '\u22D1',
  sqsubset: '\u228F',
  sqsupset: '\u2290',
  preccurlyeq: '\u227C',
  succcurlyeq: '\u227D',
  curlyeqprec: '\u22DE',
  curlyeqsucc: '\u22DF',
  precsim: '\u227E',
  succsim: '\u227F',
  precapprox: '\u2AB7',
  succapprox: '\u2AB8',
  vartriangleleft: '\u22B2',
  lhd: '\u22B2',
  vartriangleright: '\u22B3',
  rhd: '\u22B3',
  trianglelefteq: '\u22B4',
  unlhd: '\u22B4',
  trianglerighteq: '\u22B5',
  unrhd: '\u22B5',
  vDash: ['\u22A8', {
    variantForm: true
  }],
  Vdash: '\u22A9',
  Vvdash: '\u22AA',
  smallsmile: ['\u2323', {
    variantForm: true
  }],
  shortmid: ['\u2223', {
    variantForm: true
  }],
  smallfrown: ['\u2322', {
    variantForm: true
  }],
  shortparallel: ['\u2225', {
    variantForm: true
  }],
  bumpeq: '\u224F',
  between: '\u226C',
  Bumpeq: '\u224E',
  pitchfork: '\u22D4',
  varpropto: ['\u221D', {
    variantForm: true
  }],
  backepsilon: '\u220D',
  blacktriangleleft: '\u25C2',
  blacktriangleright: '\u25B8',
  therefore: '\u2234',
  because: '\u2235',
  eqsim: '\u2242',
  vartriangle: ['\u25B3', {
    variantForm: true
  }],
  Join: '\u22C8',
  nless: '\u226E',
  ngtr: '\u226F',
  nleq: '\u2270',
  ngeq: '\u2271',
  nleqslant: ['\u2A87', {
    variantForm: true
  }],
  ngeqslant: ['\u2A88', {
    variantForm: true
  }],
  nleqq: ['\u2270', {
    variantForm: true
  }],
  ngeqq: ['\u2271', {
    variantForm: true
  }],
  lneq: '\u2A87',
  gneq: '\u2A88',
  lneqq: '\u2268',
  gneqq: '\u2269',
  lvertneqq: ['\u2268', {
    variantForm: true
  }],
  gvertneqq: ['\u2269', {
    variantForm: true
  }],
  lnsim: '\u22E6',
  gnsim: '\u22E7',
  lnapprox: '\u2A89',
  gnapprox: '\u2A8A',
  nprec: '\u2280',
  nsucc: '\u2281',
  npreceq: ['\u22E0', {
    variantForm: true
  }],
  nsucceq: ['\u22E1', {
    variantForm: true
  }],
  precneqq: '\u2AB5',
  succneqq: '\u2AB6',
  precnsim: '\u22E8',
  succnsim: '\u22E9',
  precnapprox: '\u2AB9',
  succnapprox: '\u2ABA',
  nsim: '\u2241',
  ncong: '\u2247',
  nshortmid: ['\u2224', {
    variantForm: true
  }],
  nshortparallel: ['\u2226', {
    variantForm: true
  }],
  nmid: '\u2224',
  nparallel: '\u2226',
  nvdash: '\u22AC',
  nvDash: '\u22AD',
  nVdash: '\u22AE',
  nVDash: '\u22AF',
  ntriangleleft: '\u22EA',
  ntriangleright: '\u22EB',
  ntrianglelefteq: '\u22EC',
  ntrianglerighteq: '\u22ED',
  nsubseteq: '\u2288',
  nsupseteq: '\u2289',
  nsubseteqq: ['\u2288', {
    variantForm: true
  }],
  nsupseteqq: ['\u2289', {
    variantForm: true
  }],
  subsetneq: '\u228A',
  supsetneq: '\u228B',
  varsubsetneq: ['\u228A', {
    variantForm: true
  }],
  varsupsetneq: ['\u228B', {
    variantForm: true
  }],
  subsetneqq: '\u2ACB',
  supsetneqq: '\u2ACC',
  varsubsetneqq: ['\u2ACB', {
    variantForm: true
  }],
  varsupsetneqq: ['\u2ACC', {
    variantForm: true
  }],
  leftleftarrows: '\u21C7',
  rightrightarrows: '\u21C9',
  leftrightarrows: '\u21C6',
  rightleftarrows: '\u21C4',
  Lleftarrow: '\u21DA',
  Rrightarrow: '\u21DB',
  twoheadleftarrow: '\u219E',
  twoheadrightarrow: '\u21A0',
  leftarrowtail: '\u21A2',
  rightarrowtail: '\u21A3',
  looparrowleft: '\u21AB',
  looparrowright: '\u21AC',
  leftrightharpoons: '\u21CB',
  rightleftharpoons: ['\u21CC', {
    variantForm: true
  }],
  curvearrowleft: '\u21B6',
  curvearrowright: '\u21B7',
  circlearrowleft: '\u21BA',
  circlearrowright: '\u21BB',
  Lsh: '\u21B0',
  Rsh: '\u21B1',
  upuparrows: '\u21C8',
  downdownarrows: '\u21CA',
  upharpoonleft: '\u21BF',
  upharpoonright: '\u21BE',
  downharpoonleft: '\u21C3',
  restriction: '\u21BE',
  multimap: '\u22B8',
  downharpoonright: '\u21C2',
  leftrightsquigarrow: '\u21AD',
  rightsquigarrow: '\u21DD',
  leadsto: '\u21DD',
  dashrightarrow: '\u21E2',
  dashleftarrow: '\u21E0',
  nleftarrow: '\u219A',
  nrightarrow: '\u219B',
  nLeftarrow: '\u21CD',
  nRightarrow: '\u21CF',
  nleftrightarrow: '\u21AE',
  nLeftrightarrow: '\u21CE'
});
new sm$3.DelimiterMap('AMSsymbols-delimiter', ParseMethods_js_1$6.default.delimiter, {
  '\\ulcorner': '\u231C',
  '\\urcorner': '\u231D',
  '\\llcorner': '\u231E',
  '\\lrcorner': '\u231F'
});
new sm$3.CommandMap('AMSsymbols-macros', {
  implies: ['Macro', '\\;\\Longrightarrow\\;'],
  impliedby: ['Macro', '\\;\\Longleftarrow\\;']
}, AmsMethods_js_1$2.AmsMethods);

var __extends$9 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var _a$6;
Object.defineProperty(AmsConfiguration, "__esModule", {
  value: true
});
AmsConfiguration.AmsConfiguration = AmsConfiguration.AmsTags = void 0;
var Configuration_js_1$i = Configuration;
var AmsItems_js_1$1 = AmsItems;
var Tags_js_1$3 = Tags;
var AmsMethods_js_1$1 = AmsMethods;
var SymbolMap_js_1$f = SymbolMap;
var AmsTags = (function (_super) {
  __extends$9(AmsTags, _super);
  function AmsTags() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return AmsTags;
})(Tags_js_1$3.AbstractTags);
AmsConfiguration.AmsTags = AmsTags;
var init$1 = function (config) {
  new SymbolMap_js_1$f.CommandMap(AmsMethods_js_1$1.NEW_OPS, {}, {});
  config.append(Configuration_js_1$i.Configuration.local({
    handler: {
      macro: [AmsMethods_js_1$1.NEW_OPS]
    },
    priority: -1
  }));
};
AmsConfiguration.AmsConfiguration = Configuration_js_1$i.Configuration.create('ams', {
  handler: {
    character: ['AMSmath-operatorLetter'],
    delimiter: ['AMSsymbols-delimiter', 'AMSmath-delimiter'],
    macro: ['AMSsymbols-mathchar0mi', 'AMSsymbols-mathchar0mo', 'AMSsymbols-delimiter', 'AMSsymbols-macros', 'AMSmath-mathchar0mo', 'AMSmath-macros', 'AMSmath-delimiter'],
    environment: ['AMSmath-environment']
  },
  items: (_a$6 = {}, _a$6[AmsItems_js_1$1.MultlineItem.prototype.kind] = AmsItems_js_1$1.MultlineItem, _a$6[AmsItems_js_1$1.FlalignItem.prototype.kind] = AmsItems_js_1$1.FlalignItem, _a$6),
  tags: {
    'ams': AmsTags
  },
  init: init$1,
  config: function (_config, jax) {
    if (jax.parseOptions.options.multlineWidth) {
      jax.parseOptions.options.ams.multlineWidth = jax.parseOptions.options.multlineWidth;
    }
    delete jax.parseOptions.options.multlineWidth;
  },
  options: {
    multlineWidth: '',
    ams: {
      multlineWidth: '100%',
      multlineIndent: '1em'
    }
  }
});

var AmsCdConfiguration = {};

var AmsCdMethods$1 = {};

var __importDefault$u = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(AmsCdMethods$1, "__esModule", {
  value: true
});
var TexParser_js_1$7 = __importDefault$u(TexParser$1);
var BaseConfiguration_js_1 = BaseConfiguration;
var MmlNode_js_1$5 = MmlNode;
var NodeUtil_js_1$6 = __importDefault$u(NodeUtil$1);
var AmsCdMethods = {};
AmsCdMethods.CD = function (parser, begin) {
  parser.Push(begin);
  var item = parser.itemFactory.create('array');
  var options = parser.configuration.options.amscd;
  item.setProperties({
    minw: parser.stack.env.CD_minw || options.harrowsize,
    minh: parser.stack.env.CD_minh || options.varrowsize
  });
  item.arraydef = {
    columnalign: 'center',
    columnspacing: options.colspace,
    rowspacing: options.rowspace,
    displaystyle: true
  };
  return item;
};
AmsCdMethods.arrow = function (parser, name) {
  var c = parser.string.charAt(parser.i);
  if (!c.match(/[><VA.|=]/)) {
    return (0, BaseConfiguration_js_1.Other)(parser, name);
  } else {
    parser.i++;
  }
  var first = parser.stack.Top();
  if (!first.isKind('array') || first.Size()) {
    AmsCdMethods.cell(parser, name);
    first = parser.stack.Top();
  }
  var top = first;
  var arrowRow = top.table.length % 2 === 1;
  var n = (top.row.length + (arrowRow ? 0 : 1)) % 2;
  while (n) {
    AmsCdMethods.cell(parser, name);
    n--;
  }
  var mml;
  var hdef = {
    minsize: top.getProperty('minw'),
    stretchy: true
  }, vdef = {
    minsize: top.getProperty('minh'),
    stretchy: true,
    symmetric: true,
    lspace: 0,
    rspace: 0
  };
  if (c === '.') ; else if (c === '|') {
    mml = parser.create('token', 'mo', vdef, '\u2225');
  } else if (c === '=') {
    mml = parser.create('token', 'mo', hdef, '=');
  } else {
    var arrow = ({
      '>': '\u2192',
      '<': '\u2190',
      'V': '\u2193',
      'A': '\u2191'
    })[c];
    var a = parser.GetUpTo(name + c, c);
    var b = parser.GetUpTo(name + c, c);
    if (c === '>' || c === '<') {
      mml = parser.create('token', 'mo', hdef, arrow);
      if (!a) {
        a = '\\kern ' + top.getProperty('minw');
      }
      if (a || b) {
        var pad = {
          width: '+.67em',
          lspace: '.33em'
        };
        mml = parser.create('node', 'munderover', [mml]);
        if (a) {
          var nodeA = new TexParser_js_1$7.default(a, parser.stack.env, parser.configuration).mml();
          var mpadded = parser.create('node', 'mpadded', [nodeA], pad);
          NodeUtil_js_1$6.default.setAttribute(mpadded, 'voffset', '.1em');
          NodeUtil_js_1$6.default.setChild(mml, mml.over, mpadded);
        }
        if (b) {
          var nodeB = new TexParser_js_1$7.default(b, parser.stack.env, parser.configuration).mml();
          NodeUtil_js_1$6.default.setChild(mml, mml.under, parser.create('node', 'mpadded', [nodeB], pad));
        }
        if (parser.configuration.options.amscd.hideHorizontalLabels) {
          mml = parser.create('node', 'mpadded', mml, {
            depth: 0,
            height: '.67em'
          });
        }
      }
    } else {
      var arrowNode = parser.create('token', 'mo', vdef, arrow);
      mml = arrowNode;
      if (a || b) {
        mml = parser.create('node', 'mrow');
        if (a) {
          NodeUtil_js_1$6.default.appendChildren(mml, [new TexParser_js_1$7.default('\\scriptstyle\\llap{' + a + '}', parser.stack.env, parser.configuration).mml()]);
        }
        arrowNode.texClass = MmlNode_js_1$5.TEXCLASS.ORD;
        NodeUtil_js_1$6.default.appendChildren(mml, [arrowNode]);
        if (b) {
          NodeUtil_js_1$6.default.appendChildren(mml, [new TexParser_js_1$7.default('\\scriptstyle\\rlap{' + b + '}', parser.stack.env, parser.configuration).mml()]);
        }
      }
    }
  }
  if (mml) {
    parser.Push(mml);
  }
  AmsCdMethods.cell(parser, name);
};
AmsCdMethods.cell = function (parser, name) {
  var top = parser.stack.Top();
  if ((top.table || []).length % 2 === 0 && (top.row || []).length === 0) {
    parser.Push(parser.create('node', 'mpadded', [], {
      height: '8.5pt',
      depth: '2pt'
    }));
  }
  parser.Push(parser.itemFactory.create('cell').setProperties({
    isEntry: true,
    name: name
  }));
};
AmsCdMethods.minCDarrowwidth = function (parser, name) {
  parser.stack.env.CD_minw = parser.GetDimen(name);
};
AmsCdMethods.minCDarrowheight = function (parser, name) {
  parser.stack.env.CD_minh = parser.GetDimen(name);
};
AmsCdMethods$1.default = AmsCdMethods;

var __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$4(result, mod, k);
  __setModuleDefault$4(result, mod);
  return result;
});
var __importDefault$t = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var sm$2 = __importStar$4(SymbolMap);
var ParseMethods_js_1$5 = __importDefault$t(ParseMethods$1);
var AmsCdMethods_js_1 = __importDefault$t(AmsCdMethods$1);
new sm$2.EnvironmentMap('amscd_environment', ParseMethods_js_1$5.default.environment, {
  CD: 'CD'
}, AmsCdMethods_js_1.default);
new sm$2.CommandMap('amscd_macros', {
  minCDarrowwidth: 'minCDarrowwidth',
  minCDarrowheight: 'minCDarrowheight'
}, AmsCdMethods_js_1.default);
new sm$2.MacroMap('amscd_special', {
  '@': 'arrow'
}, AmsCdMethods_js_1.default);

Object.defineProperty(AmsCdConfiguration, "__esModule", {
  value: true
});
AmsCdConfiguration.AmsCdConfiguration = void 0;
var Configuration_js_1$h = Configuration;
AmsCdConfiguration.AmsCdConfiguration = Configuration_js_1$h.Configuration.create('amscd', {
  handler: {
    character: ['amscd_special'],
    macro: ['amscd_macros'],
    environment: ['amscd_environment']
  },
  options: {
    amscd: {
      colspace: '5pt',
      rowspace: '5pt',
      harrowsize: '2.75em',
      varrowsize: '1.75em',
      hideHorizontalLabels: false
    }
  }
});

var BboxConfiguration = {};

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BboxConfiguration = exports.BboxMethods = void 0;
  var Configuration_js_1 = Configuration;
  var SymbolMap_js_1 = SymbolMap;
  var TexError_js_1 = __importDefault(TexError$1);
  exports.BboxMethods = {};
  exports.BboxMethods.BBox = function (parser, name) {
    var bbox = parser.GetBrackets(name, '');
    var math = parser.ParseArg(name);
    var parts = bbox.split(/,/);
    var def, background, style;
    for (var i = 0, m = parts.length; i < m; i++) {
      var part = parts[i].trim();
      var match = part.match(/^(\.\d+|\d+(\.\d*)?)(pt|em|ex|mu|px|in|cm|mm)$/);
      if (match) {
        if (def) {
          throw new TexError_js_1.default('MultipleBBoxProperty', '%1 specified twice in %2', 'Padding', name);
        }
        var pad = BBoxPadding(match[1] + match[3]);
        if (pad) {
          def = {
            height: '+' + pad,
            depth: '+' + pad,
            lspace: pad,
            width: '+' + 2 * parseInt(match[1], 10) + match[3]
          };
        }
      } else if (part.match(/^([a-z0-9]+|\#[0-9a-f]{6}|\#[0-9a-f]{3})$/i)) {
        if (background) {
          throw new TexError_js_1.default('MultipleBBoxProperty', '%1 specified twice in %2', 'Background', name);
        }
        background = part;
      } else if (part.match(/^[-a-z]+:/i)) {
        if (style) {
          throw new TexError_js_1.default('MultipleBBoxProperty', '%1 specified twice in %2', 'Style', name);
        }
        style = BBoxStyle(part);
      } else if (part !== '') {
        throw new TexError_js_1.default('InvalidBBoxProperty', '"%1" doesn\'t look like a color, a padding dimension, or a style', part);
      }
    }
    if (def) {
      math = parser.create('node', 'mpadded', [math], def);
    }
    if (background || style) {
      def = {};
      if (background) {
        Object.assign(def, {
          mathbackground: background
        });
      }
      if (style) {
        Object.assign(def, {
          style: style
        });
      }
      math = parser.create('node', 'mstyle', [math], def);
    }
    parser.Push(math);
  };
  var BBoxStyle = function (styles) {
    return styles;
  };
  var BBoxPadding = function (pad) {
    return pad;
  };
  new SymbolMap_js_1.CommandMap('bbox', {
    bbox: 'BBox'
  }, exports.BboxMethods);
  exports.BboxConfiguration = Configuration_js_1.Configuration.create('bbox', {
    handler: {
      macro: ['bbox']
    }
  });
})(BboxConfiguration);
getDefaultExportFromCjs(BboxConfiguration);

var BoldsymbolConfiguration = {};

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BoldsymbolConfiguration = exports.rewriteBoldTokens = exports.createBoldToken = exports.BoldsymbolMethods = void 0;
  var Configuration_js_1 = Configuration;
  var NodeUtil_js_1 = __importDefault(NodeUtil$1);
  var TexConstants_js_1 = TexConstants;
  var SymbolMap_js_1 = SymbolMap;
  var NodeFactory_js_1 = NodeFactory$1;
  var BOLDVARIANT = {};
  BOLDVARIANT[TexConstants_js_1.TexConstant.Variant.NORMAL] = TexConstants_js_1.TexConstant.Variant.BOLD;
  BOLDVARIANT[TexConstants_js_1.TexConstant.Variant.ITALIC] = TexConstants_js_1.TexConstant.Variant.BOLDITALIC;
  BOLDVARIANT[TexConstants_js_1.TexConstant.Variant.FRAKTUR] = TexConstants_js_1.TexConstant.Variant.BOLDFRAKTUR;
  BOLDVARIANT[TexConstants_js_1.TexConstant.Variant.SCRIPT] = TexConstants_js_1.TexConstant.Variant.BOLDSCRIPT;
  BOLDVARIANT[TexConstants_js_1.TexConstant.Variant.SANSSERIF] = TexConstants_js_1.TexConstant.Variant.BOLDSANSSERIF;
  BOLDVARIANT['-tex-calligraphic'] = '-tex-bold-calligraphic';
  BOLDVARIANT['-tex-oldstyle'] = '-tex-bold-oldstyle';
  BOLDVARIANT['-tex-mathit'] = TexConstants_js_1.TexConstant.Variant.BOLDITALIC;
  exports.BoldsymbolMethods = {};
  exports.BoldsymbolMethods.Boldsymbol = function (parser, name) {
    var boldsymbol = parser.stack.env['boldsymbol'];
    parser.stack.env['boldsymbol'] = true;
    var mml = parser.ParseArg(name);
    parser.stack.env['boldsymbol'] = boldsymbol;
    parser.Push(mml);
  };
  new SymbolMap_js_1.CommandMap('boldsymbol', {
    boldsymbol: 'Boldsymbol'
  }, exports.BoldsymbolMethods);
  function createBoldToken(factory, kind, def, text) {
    var token = NodeFactory_js_1.NodeFactory.createToken(factory, kind, def, text);
    if (kind !== 'mtext' && factory.configuration.parser.stack.env['boldsymbol']) {
      NodeUtil_js_1.default.setProperty(token, 'fixBold', true);
      factory.configuration.addNode('fixBold', token);
    }
    return token;
  }
  exports.createBoldToken = createBoldToken;
  function rewriteBoldTokens(arg) {
    var e_1, _a;
    try {
      for (var _b = __values(arg.data.getList('fixBold')), _c = _b.next(); !_c.done; _c = _b.next()) {
        var node = _c.value;
        if (NodeUtil_js_1.default.getProperty(node, 'fixBold')) {
          var variant = NodeUtil_js_1.default.getAttribute(node, 'mathvariant');
          if (variant == null) {
            NodeUtil_js_1.default.setAttribute(node, 'mathvariant', TexConstants_js_1.TexConstant.Variant.BOLD);
          } else {
            NodeUtil_js_1.default.setAttribute(node, 'mathvariant', BOLDVARIANT[variant] || variant);
          }
          NodeUtil_js_1.default.removeProperties(node, 'fixBold');
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  exports.rewriteBoldTokens = rewriteBoldTokens;
  exports.BoldsymbolConfiguration = Configuration_js_1.Configuration.create('boldsymbol', {
    handler: {
      macro: ['boldsymbol']
    },
    nodes: {
      'token': createBoldToken
    },
    postprocessors: [rewriteBoldTokens]
  });
})(BoldsymbolConfiguration);
getDefaultExportFromCjs(BoldsymbolConfiguration);

var BraketConfiguration = {};

var BraketItems = {};

var __extends$8 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __importDefault$s = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(BraketItems, "__esModule", {
  value: true
});
BraketItems.BraketItem = void 0;
var StackItem_js_1$3 = StackItem;
var MmlNode_js_1$4 = MmlNode;
var ParseUtil_js_1$8 = __importDefault$s(ParseUtil$1);
var BraketItem = (function (_super) {
  __extends$8(BraketItem, _super);
  function BraketItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(BraketItem.prototype, "kind", {
    get: function () {
      return 'braket';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BraketItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  BraketItem.prototype.checkItem = function (item) {
    if (item.isKind('close')) {
      return [[this.factory.create('mml', this.toMml())], true];
    }
    if (item.isKind('mml')) {
      this.Push(item.toMml());
      if (this.getProperty('single')) {
        return [[this.toMml()], true];
      }
      return StackItem_js_1$3.BaseItem.fail;
    }
    return _super.prototype.checkItem.call(this, item);
  };
  BraketItem.prototype.toMml = function () {
    var inner = _super.prototype.toMml.call(this);
    var open = this.getProperty('open');
    var close = this.getProperty('close');
    if (this.getProperty('stretchy')) {
      return ParseUtil_js_1$8.default.fenced(this.factory.configuration, open, inner, close);
    }
    var attrs = {
      fence: true,
      stretchy: false,
      symmetric: true,
      texClass: MmlNode_js_1$4.TEXCLASS.OPEN
    };
    var openNode = this.create('token', 'mo', attrs, open);
    attrs.texClass = MmlNode_js_1$4.TEXCLASS.CLOSE;
    var closeNode = this.create('token', 'mo', attrs, close);
    var mrow = this.create('node', 'mrow', [openNode, inner, closeNode], {
      open: open,
      close: close,
      texClass: MmlNode_js_1$4.TEXCLASS.INNER
    });
    return mrow;
  };
  return BraketItem;
})(StackItem_js_1$3.BaseItem);
BraketItems.BraketItem = BraketItem;

var BraketMethods$1 = {};

var __importDefault$r = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(BraketMethods$1, "__esModule", {
  value: true
});
var BaseMethods_js_1$5 = __importDefault$r(BaseMethods$1);
var MmlNode_js_1$3 = MmlNode;
var TexError_js_1$c = __importDefault$r(TexError$1);
var BraketMethods = {};
BraketMethods.Macro = BaseMethods_js_1$5.default.Macro;
BraketMethods.Braket = function (parser, _name, open, close, stretchy, barmax) {
  var next = parser.GetNext();
  if (next === '') {
    throw new TexError_js_1$c.default('MissingArgFor', 'Missing argument for %1', parser.currentCS);
  }
  var single = true;
  if (next === '{') {
    parser.i++;
    single = false;
  }
  parser.Push(parser.itemFactory.create('braket').setProperties({
    barmax: barmax,
    barcount: 0,
    open: open,
    close: close,
    stretchy: stretchy,
    single: single
  }));
};
BraketMethods.Bar = function (parser, name) {
  var c = name === '|' ? '|' : '\u2225';
  var top = parser.stack.Top();
  if (top.kind !== 'braket' || top.getProperty('barcount') >= top.getProperty('barmax')) {
    var mml = parser.create('token', 'mo', {
      texClass: MmlNode_js_1$3.TEXCLASS.ORD,
      stretchy: false
    }, c);
    parser.Push(mml);
    return;
  }
  if (c === '|' && parser.GetNext() === '|') {
    parser.i++;
    c = '\u2225';
  }
  var stretchy = top.getProperty('stretchy');
  if (!stretchy) {
    var node_1 = parser.create('token', 'mo', {
      stretchy: false,
      braketbar: true
    }, c);
    parser.Push(node_1);
    return;
  }
  var node = parser.create('node', 'TeXAtom', [], {
    texClass: MmlNode_js_1$3.TEXCLASS.CLOSE
  });
  parser.Push(node);
  top.setProperty('barcount', top.getProperty('barcount') + 1);
  node = parser.create('token', 'mo', {
    stretchy: true,
    braketbar: true
  }, c);
  parser.Push(node);
  node = parser.create('node', 'TeXAtom', [], {
    texClass: MmlNode_js_1$3.TEXCLASS.OPEN
  });
  parser.Push(node);
};
BraketMethods$1.default = BraketMethods;

var __importDefault$q = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var SymbolMap_js_1$e = SymbolMap;
var BraketMethods_js_1 = __importDefault$q(BraketMethods$1);
new SymbolMap_js_1$e.CommandMap('Braket-macros', {
  bra: ['Macro', '{\\langle {#1} \\vert}', 1],
  ket: ['Macro', '{\\vert {#1} \\rangle}', 1],
  braket: ['Braket', '\u27E8', '\u27E9', false, Infinity],
  'set': ['Braket', '{', '}', false, 1],
  Bra: ['Macro', '{\\left\\langle {#1} \\right\\vert}', 1],
  Ket: ['Macro', '{\\left\\vert {#1} \\right\\rangle}', 1],
  Braket: ['Braket', '\u27E8', '\u27E9', true, Infinity],
  Set: ['Braket', '{', '}', true, 1],
  ketbra: ['Macro', '{\\vert {#1} \\rangle\\langle {#2} \\vert}', 2],
  Ketbra: ['Macro', '{\\left\\vert {#1} \\right\\rangle\\left\\langle {#2} \\right\\vert}', 2],
  '|': 'Bar'
}, BraketMethods_js_1.default);
new SymbolMap_js_1$e.MacroMap('Braket-characters', {
  '|': 'Bar'
}, BraketMethods_js_1.default);

var _a$5;
Object.defineProperty(BraketConfiguration, "__esModule", {
  value: true
});
BraketConfiguration.BraketConfiguration = void 0;
var Configuration_js_1$g = Configuration;
var BraketItems_js_1 = BraketItems;
BraketConfiguration.BraketConfiguration = Configuration_js_1$g.Configuration.create('braket', {
  handler: {
    character: ['Braket-characters'],
    macro: ['Braket-macros']
  },
  items: (_a$5 = {}, _a$5[BraketItems_js_1.BraketItem.prototype.kind] = BraketItems_js_1.BraketItem, _a$5)
});

var BussproofsConfiguration = {};

var BussproofsItems = {};

var BussproofsUtil$2 = {};

(function (exports) {
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  var _a;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.clearDocument = exports.saveDocument = exports.makeBsprAttributes = exports.removeProperty = exports.getProperty = exports.setProperty = exports.balanceRules = void 0;
  var NodeUtil_js_1 = __importDefault(NodeUtil$1);
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var doc = null;
  var item = null;
  var getBBox = function (node) {
    item.root = node;
    var width = doc.outputJax.getBBox(item, doc).w;
    return width;
  };
  var getRule = function (node) {
    var i = 0;
    while (node && !NodeUtil_js_1.default.isType(node, 'mtable')) {
      if (NodeUtil_js_1.default.isType(node, 'text')) {
        return null;
      }
      if (NodeUtil_js_1.default.isType(node, 'mrow')) {
        node = node.childNodes[0];
        i = 0;
        continue;
      }
      node = node.parent.childNodes[i];
      i++;
    }
    return node;
  };
  var getPremises = function (rule, direction) {
    return rule.childNodes[direction === 'up' ? 1 : 0].childNodes[0].childNodes[0].childNodes[0].childNodes[0];
  };
  var getPremise = function (premises, n) {
    return premises.childNodes[n].childNodes[0].childNodes[0];
  };
  var firstPremise = function (premises) {
    return getPremise(premises, 0);
  };
  var lastPremise = function (premises) {
    return getPremise(premises, premises.childNodes.length - 1);
  };
  var getConclusion = function (rule, direction) {
    return rule.childNodes[direction === 'up' ? 0 : 1].childNodes[0].childNodes[0].childNodes[0];
  };
  var getColumn = function (inf) {
    while (inf && !NodeUtil_js_1.default.isType(inf, 'mtd')) {
      inf = inf.parent;
    }
    return inf;
  };
  var nextSibling = function (inf) {
    return inf.parent.childNodes[inf.parent.childNodes.indexOf(inf) + 1];
  };
  var getParentInf = function (inf) {
    while (inf && (0, exports.getProperty)(inf, 'inference') == null) {
      inf = inf.parent;
    }
    return inf;
  };
  var getSpaces = function (inf, rule, right) {
    if (right === void 0) {
      right = false;
    }
    var result = 0;
    if (inf === rule) {
      return result;
    }
    if (inf !== rule.parent) {
      var children_1 = inf.childNodes;
      var index_1 = right ? children_1.length - 1 : 0;
      if (NodeUtil_js_1.default.isType(children_1[index_1], 'mspace')) {
        result += getBBox(children_1[index_1]);
      }
      inf = rule.parent;
    }
    if (inf === rule) {
      return result;
    }
    var children = inf.childNodes;
    var index = right ? children.length - 1 : 0;
    if (children[index] !== rule) {
      result += getBBox(children[index]);
    }
    return result;
  };
  var adjustValue = function (inf, right) {
    if (right === void 0) {
      right = false;
    }
    var rule = getRule(inf);
    var conc = getConclusion(rule, (0, exports.getProperty)(rule, 'inferenceRule'));
    var w = getSpaces(inf, rule, right);
    var x = getBBox(rule);
    var y = getBBox(conc);
    return w + (x - y) / 2;
  };
  var addSpace = function (config, inf, space, right) {
    if (right === void 0) {
      right = false;
    }
    if ((0, exports.getProperty)(inf, 'inferenceRule') || (0, exports.getProperty)(inf, 'labelledRule')) {
      var mrow = config.nodeFactory.create('node', 'mrow');
      inf.parent.replaceChild(mrow, inf);
      mrow.setChildren([inf]);
      moveProperties(inf, mrow);
      inf = mrow;
    }
    var index = right ? inf.childNodes.length - 1 : 0;
    var mspace = inf.childNodes[index];
    if (NodeUtil_js_1.default.isType(mspace, 'mspace')) {
      NodeUtil_js_1.default.setAttribute(mspace, 'width', ParseUtil_js_1.default.Em(ParseUtil_js_1.default.dimen2em(NodeUtil_js_1.default.getAttribute(mspace, 'width')) + space));
      return;
    }
    mspace = config.nodeFactory.create('node', 'mspace', [], {
      width: ParseUtil_js_1.default.Em(space)
    });
    if (right) {
      inf.appendChild(mspace);
      return;
    }
    mspace.parent = inf;
    inf.childNodes.unshift(mspace);
  };
  var moveProperties = function (src, dest) {
    var props = ['inference', 'proof', 'maxAdjust', 'labelledRule'];
    props.forEach(function (x) {
      var value = (0, exports.getProperty)(src, x);
      if (value != null) {
        (0, exports.setProperty)(dest, x, value);
        (0, exports.removeProperty)(src, x);
      }
    });
  };
  var adjustSequents = function (config) {
    var sequents = config.nodeLists['sequent'];
    if (!sequents) {
      return;
    }
    for (var i = sequents.length - 1, seq = void 0; seq = sequents[i]; i--) {
      if ((0, exports.getProperty)(seq, 'sequentProcessed')) {
        (0, exports.removeProperty)(seq, 'sequentProcessed');
        continue;
      }
      var collect = [];
      var inf = getParentInf(seq);
      if ((0, exports.getProperty)(inf, 'inference') !== 1) {
        continue;
      }
      collect.push(seq);
      while ((0, exports.getProperty)(inf, 'inference') === 1) {
        inf = getRule(inf);
        var premise = firstPremise(getPremises(inf, (0, exports.getProperty)(inf, 'inferenceRule')));
        var sequent = (0, exports.getProperty)(premise, 'inferenceRule') ? getConclusion(premise, (0, exports.getProperty)(premise, 'inferenceRule')) : premise;
        if ((0, exports.getProperty)(sequent, 'sequent')) {
          seq = sequent.childNodes[0];
          collect.push(seq);
          (0, exports.setProperty)(seq, 'sequentProcessed', true);
        }
        inf = premise;
      }
      adjustSequentPairwise(config, collect);
    }
  };
  var addSequentSpace = function (config, sequent, position, direction, width) {
    var mspace = config.nodeFactory.create('node', 'mspace', [], {
      width: ParseUtil_js_1.default.Em(width)
    });
    if (direction === 'left') {
      var row = sequent.childNodes[position].childNodes[0];
      mspace.parent = row;
      row.childNodes.unshift(mspace);
    } else {
      sequent.childNodes[position].appendChild(mspace);
    }
    (0, exports.setProperty)(sequent.parent, 'sequentAdjust_' + direction, width);
  };
  var adjustSequentPairwise = function (config, sequents) {
    var top = sequents.pop();
    while (sequents.length) {
      var bottom = sequents.pop();
      var _a = __read(compareSequents(top, bottom), 2), left = _a[0], right = _a[1];
      if ((0, exports.getProperty)(top.parent, 'axiom')) {
        addSequentSpace(config, left < 0 ? top : bottom, 0, 'left', Math.abs(left));
        addSequentSpace(config, right < 0 ? top : bottom, 2, 'right', Math.abs(right));
      }
      top = bottom;
    }
  };
  var compareSequents = function (top, bottom) {
    var tr = getBBox(top.childNodes[2]);
    var br = getBBox(bottom.childNodes[2]);
    var tl = getBBox(top.childNodes[0]);
    var bl = getBBox(bottom.childNodes[0]);
    var dl = tl - bl;
    var dr = tr - br;
    return [dl, dr];
  };
  var balanceRules = function (arg) {
    var e_1, _a;
    item = new arg.document.options.MathItem('', null, arg.math.display);
    var config = arg.data;
    adjustSequents(config);
    var inferences = config.nodeLists['inference'] || [];
    try {
      for (var inferences_1 = __values(inferences), inferences_1_1 = inferences_1.next(); !inferences_1_1.done; inferences_1_1 = inferences_1.next()) {
        var inf = inferences_1_1.value;
        var isProof = (0, exports.getProperty)(inf, 'proof');
        var rule = getRule(inf);
        var premises = getPremises(rule, (0, exports.getProperty)(rule, 'inferenceRule'));
        var premiseF = firstPremise(premises);
        if ((0, exports.getProperty)(premiseF, 'inference')) {
          var adjust_1 = adjustValue(premiseF);
          if (adjust_1) {
            addSpace(config, premiseF, -adjust_1);
            var w_1 = getSpaces(inf, rule, false);
            addSpace(config, inf, adjust_1 - w_1);
          }
        }
        var premiseL = lastPremise(premises);
        if ((0, exports.getProperty)(premiseL, 'inference') == null) {
          continue;
        }
        var adjust = adjustValue(premiseL, true);
        addSpace(config, premiseL, -adjust, true);
        var w = getSpaces(inf, rule, true);
        var maxAdjust = (0, exports.getProperty)(inf, 'maxAdjust');
        if (maxAdjust != null) {
          adjust = Math.max(adjust, maxAdjust);
        }
        var column = void 0;
        if (isProof || !(column = getColumn(inf))) {
          addSpace(config, (0, exports.getProperty)(inf, 'proof') ? inf : inf.parent, adjust - w, true);
          continue;
        }
        var sibling = nextSibling(column);
        if (sibling) {
          var pos = config.nodeFactory.create('node', 'mspace', [], {
            width: adjust - w + 'em'
          });
          sibling.appendChild(pos);
          inf.removeProperty('maxAdjust');
          continue;
        }
        var parentRule = getParentInf(column);
        if (!parentRule) {
          continue;
        }
        adjust = (0, exports.getProperty)(parentRule, 'maxAdjust') ? Math.max((0, exports.getProperty)(parentRule, 'maxAdjust'), adjust) : adjust;
        (0, exports.setProperty)(parentRule, 'maxAdjust', adjust);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (inferences_1_1 && !inferences_1_1.done && (_a = inferences_1.return)) _a.call(inferences_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  exports.balanceRules = balanceRules;
  var property_prefix = 'bspr_';
  var blacklistedProperties = (_a = {}, _a[property_prefix + 'maxAdjust'] = true, _a);
  var setProperty = function (node, property, value) {
    NodeUtil_js_1.default.setProperty(node, property_prefix + property, value);
  };
  exports.setProperty = setProperty;
  var getProperty = function (node, property) {
    return NodeUtil_js_1.default.getProperty(node, property_prefix + property);
  };
  exports.getProperty = getProperty;
  var removeProperty = function (node, property) {
    node.removeProperty(property_prefix + property);
  };
  exports.removeProperty = removeProperty;
  var makeBsprAttributes = function (arg) {
    arg.data.root.walkTree(function (mml, _data) {
      var attr = [];
      mml.getPropertyNames().forEach(function (x) {
        if (!blacklistedProperties[x] && x.match(RegExp('^' + property_prefix))) {
          attr.push(x + ':' + mml.getProperty(x));
        }
      });
      if (attr.length) {
        NodeUtil_js_1.default.setAttribute(mml, 'semantics', attr.join(';'));
      }
    });
  };
  exports.makeBsprAttributes = makeBsprAttributes;
  var saveDocument = function (arg) {
    doc = arg.document;
    if (!(('getBBox' in doc.outputJax))) {
      throw Error('The bussproofs extension requires an output jax with a getBBox() method');
    }
  };
  exports.saveDocument = saveDocument;
  var clearDocument = function (_arg) {
    doc = null;
  };
  exports.clearDocument = clearDocument;
})(BussproofsUtil$2);
getDefaultExportFromCjs(BussproofsUtil$2);

var __extends$7 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$3(result, mod, k);
  __setModuleDefault$3(result, mod);
  return result;
});
var __importDefault$p = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(BussproofsItems, "__esModule", {
  value: true
});
BussproofsItems.ProofTreeItem = void 0;
var TexError_js_1$b = __importDefault$p(TexError$1);
var StackItem_js_1$2 = StackItem;
var Stack_js_1 = __importDefault$p(Stack$1);
var BussproofsUtil$1 = __importStar$3(BussproofsUtil$2);
var ProofTreeItem = (function (_super) {
  __extends$7(ProofTreeItem, _super);
  function ProofTreeItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.leftLabel = null;
    _this.rigthLabel = null;
    _this.innerStack = new Stack_js_1.default(_this.factory, {}, true);
    return _this;
  }
  Object.defineProperty(ProofTreeItem.prototype, "kind", {
    get: function () {
      return 'proofTree';
    },
    enumerable: false,
    configurable: true
  });
  ProofTreeItem.prototype.checkItem = function (item) {
    if (item.isKind('end') && item.getName() === 'prooftree') {
      var node = this.toMml();
      BussproofsUtil$1.setProperty(node, 'proof', true);
      return [[this.factory.create('mml', node), item], true];
    }
    if (item.isKind('stop')) {
      throw new TexError_js_1$b.default('EnvMissingEnd', 'Missing \\end{%1}', this.getName());
    }
    this.innerStack.Push(item);
    return StackItem_js_1$2.BaseItem.fail;
  };
  ProofTreeItem.prototype.toMml = function () {
    var tree = _super.prototype.toMml.call(this);
    var start = this.innerStack.Top();
    if (start.isKind('start') && !start.Size()) {
      return tree;
    }
    this.innerStack.Push(this.factory.create('stop'));
    var prefix = this.innerStack.Top().toMml();
    return this.create('node', 'mrow', [prefix, tree], {});
  };
  return ProofTreeItem;
})(StackItem_js_1$2.BaseItem);
BussproofsItems.ProofTreeItem = ProofTreeItem;

var BussproofsMethods$1 = {};

var __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$2(result, mod, k);
  __setModuleDefault$2(result, mod);
  return result;
});
var __read$4 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray$1 = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$o = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(BussproofsMethods$1, "__esModule", {
  value: true
});
var TexError_js_1$a = __importDefault$o(TexError$1);
var TexParser_js_1$6 = __importDefault$o(TexParser$1);
var ParseUtil_js_1$7 = __importDefault$o(ParseUtil$1);
var BussproofsUtil = __importStar$2(BussproofsUtil$2);
var BussproofsMethods = {};
BussproofsMethods.Prooftree = function (parser, begin) {
  parser.Push(begin);
  var newItem = parser.itemFactory.create('proofTree').setProperties({
    name: begin.getName(),
    line: 'solid',
    currentLine: 'solid',
    rootAtTop: false
  });
  return newItem;
};
BussproofsMethods.Axiom = function (parser, name) {
  var top = parser.stack.Top();
  if (top.kind !== 'proofTree') {
    throw new TexError_js_1$a.default('IllegalProofCommand', 'Proof commands only allowed in prooftree environment.');
  }
  var content = paddedContent(parser, parser.GetArgument(name));
  BussproofsUtil.setProperty(content, 'axiom', true);
  top.Push(content);
};
var paddedContent = function (parser, content) {
  var nodes = ParseUtil_js_1$7.default.internalMath(parser, ParseUtil_js_1$7.default.trimSpaces(content), 0);
  if (!nodes[0].childNodes[0].childNodes.length) {
    return parser.create('node', 'mrow', []);
  }
  var lpad = parser.create('node', 'mspace', [], {
    width: '.5ex'
  });
  var rpad = parser.create('node', 'mspace', [], {
    width: '.5ex'
  });
  return parser.create('node', 'mrow', __spreadArray$1(__spreadArray$1([lpad], __read$4(nodes), false), [rpad], false));
};
BussproofsMethods.Inference = function (parser, name, n) {
  var top = parser.stack.Top();
  if (top.kind !== 'proofTree') {
    throw new TexError_js_1$a.default('IllegalProofCommand', 'Proof commands only allowed in prooftree environment.');
  }
  if (top.Size() < n) {
    throw new TexError_js_1$a.default('BadProofTree', 'Proof tree badly specified.');
  }
  var rootAtTop = top.getProperty('rootAtTop');
  var childCount = n === 1 && !top.Peek()[0].childNodes.length ? 0 : n;
  var children = [];
  do {
    if (children.length) {
      children.unshift(parser.create('node', 'mtd', [], {}));
    }
    children.unshift(parser.create('node', 'mtd', [top.Pop()], {
      'rowalign': rootAtTop ? 'top' : 'bottom'
    }));
    n--;
  } while (n > 0);
  var row = parser.create('node', 'mtr', children, {});
  var table = parser.create('node', 'mtable', [row], {
    framespacing: '0 0'
  });
  var conclusion = paddedContent(parser, parser.GetArgument(name));
  var style = top.getProperty('currentLine');
  if (style !== top.getProperty('line')) {
    top.setProperty('currentLine', top.getProperty('line'));
  }
  var rule = createRule(parser, table, [conclusion], top.getProperty('left'), top.getProperty('right'), style, rootAtTop);
  top.setProperty('left', null);
  top.setProperty('right', null);
  BussproofsUtil.setProperty(rule, 'inference', childCount);
  parser.configuration.addNode('inference', rule);
  top.Push(rule);
};
function createRule(parser, premise, conclusions, left, right, style, rootAtTop) {
  var upper = parser.create('node', 'mtr', [parser.create('node', 'mtd', [premise], {})], {});
  var lower = parser.create('node', 'mtr', [parser.create('node', 'mtd', conclusions, {})], {});
  var rule = parser.create('node', 'mtable', rootAtTop ? [lower, upper] : [upper, lower], {
    align: 'top 2',
    rowlines: style,
    framespacing: '0 0'
  });
  BussproofsUtil.setProperty(rule, 'inferenceRule', rootAtTop ? 'up' : 'down');
  var leftLabel, rightLabel;
  if (left) {
    leftLabel = parser.create('node', 'mpadded', [left], {
      height: '+.5em',
      width: '+.5em',
      voffset: '-.15em'
    });
    BussproofsUtil.setProperty(leftLabel, 'prooflabel', 'left');
  }
  if (right) {
    rightLabel = parser.create('node', 'mpadded', [right], {
      height: '+.5em',
      width: '+.5em',
      voffset: '-.15em'
    });
    BussproofsUtil.setProperty(rightLabel, 'prooflabel', 'right');
  }
  var children, label;
  if (left && right) {
    children = [leftLabel, rule, rightLabel];
    label = 'both';
  } else if (left) {
    children = [leftLabel, rule];
    label = 'left';
  } else if (right) {
    children = [rule, rightLabel];
    label = 'right';
  } else {
    return rule;
  }
  rule = parser.create('node', 'mrow', children);
  BussproofsUtil.setProperty(rule, 'labelledRule', label);
  return rule;
}
BussproofsMethods.Label = function (parser, name, side) {
  var top = parser.stack.Top();
  if (top.kind !== 'proofTree') {
    throw new TexError_js_1$a.default('IllegalProofCommand', 'Proof commands only allowed in prooftree environment.');
  }
  var content = ParseUtil_js_1$7.default.internalMath(parser, parser.GetArgument(name), 0);
  var label = content.length > 1 ? parser.create('node', 'mrow', content, {}) : content[0];
  top.setProperty(side, label);
};
BussproofsMethods.SetLine = function (parser, _name, style, always) {
  var top = parser.stack.Top();
  if (top.kind !== 'proofTree') {
    throw new TexError_js_1$a.default('IllegalProofCommand', 'Proof commands only allowed in prooftree environment.');
  }
  top.setProperty('currentLine', style);
  if (always) {
    top.setProperty('line', style);
  }
};
BussproofsMethods.RootAtTop = function (parser, _name, where) {
  var top = parser.stack.Top();
  if (top.kind !== 'proofTree') {
    throw new TexError_js_1$a.default('IllegalProofCommand', 'Proof commands only allowed in prooftree environment.');
  }
  top.setProperty('rootAtTop', where);
};
BussproofsMethods.AxiomF = function (parser, name) {
  var top = parser.stack.Top();
  if (top.kind !== 'proofTree') {
    throw new TexError_js_1$a.default('IllegalProofCommand', 'Proof commands only allowed in prooftree environment.');
  }
  var line = parseFCenterLine(parser, name);
  BussproofsUtil.setProperty(line, 'axiom', true);
  top.Push(line);
};
function parseFCenterLine(parser, name) {
  var dollar = parser.GetNext();
  if (dollar !== '$') {
    throw new TexError_js_1$a.default('IllegalUseOfCommand', 'Use of %1 does not match it\'s definition.', name);
  }
  parser.i++;
  var axiom = parser.GetUpTo(name, '$');
  if (axiom.indexOf('\\fCenter') === -1) {
    throw new TexError_js_1$a.default('IllegalUseOfCommand', 'Missing \\fCenter in %1.', name);
  }
  var _a = __read$4(axiom.split('\\fCenter'), 2), prem = _a[0], conc = _a[1];
  var premise = new TexParser_js_1$6.default(prem, parser.stack.env, parser.configuration).mml();
  var conclusion = new TexParser_js_1$6.default(conc, parser.stack.env, parser.configuration).mml();
  var fcenter = new TexParser_js_1$6.default('\\fCenter', parser.stack.env, parser.configuration).mml();
  var left = parser.create('node', 'mtd', [premise], {});
  var middle = parser.create('node', 'mtd', [fcenter], {});
  var right = parser.create('node', 'mtd', [conclusion], {});
  var row = parser.create('node', 'mtr', [left, middle, right], {});
  var table = parser.create('node', 'mtable', [row], {
    columnspacing: '.5ex',
    columnalign: 'center 2'
  });
  BussproofsUtil.setProperty(table, 'sequent', true);
  parser.configuration.addNode('sequent', row);
  return table;
}
BussproofsMethods.FCenter = function (_parser, _name) {};
BussproofsMethods.InferenceF = function (parser, name, n) {
  var top = parser.stack.Top();
  if (top.kind !== 'proofTree') {
    throw new TexError_js_1$a.default('IllegalProofCommand', 'Proof commands only allowed in prooftree environment.');
  }
  if (top.Size() < n) {
    throw new TexError_js_1$a.default('BadProofTree', 'Proof tree badly specified.');
  }
  var rootAtTop = top.getProperty('rootAtTop');
  var childCount = n === 1 && !top.Peek()[0].childNodes.length ? 0 : n;
  var children = [];
  do {
    if (children.length) {
      children.unshift(parser.create('node', 'mtd', [], {}));
    }
    children.unshift(parser.create('node', 'mtd', [top.Pop()], {
      'rowalign': rootAtTop ? 'top' : 'bottom'
    }));
    n--;
  } while (n > 0);
  var row = parser.create('node', 'mtr', children, {});
  var table = parser.create('node', 'mtable', [row], {
    framespacing: '0 0'
  });
  var conclusion = parseFCenterLine(parser, name);
  var style = top.getProperty('currentLine');
  if (style !== top.getProperty('line')) {
    top.setProperty('currentLine', top.getProperty('line'));
  }
  var rule = createRule(parser, table, [conclusion], top.getProperty('left'), top.getProperty('right'), style, rootAtTop);
  top.setProperty('left', null);
  top.setProperty('right', null);
  BussproofsUtil.setProperty(rule, 'inference', childCount);
  parser.configuration.addNode('inference', rule);
  top.Push(rule);
};
BussproofsMethods$1.default = BussproofsMethods;

var __importDefault$n = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var BussproofsMethods_js_1 = __importDefault$n(BussproofsMethods$1);
var ParseMethods_js_1$4 = __importDefault$n(ParseMethods$1);
var SymbolMap_js_1$d = SymbolMap;
new SymbolMap_js_1$d.CommandMap('Bussproofs-macros', {
  AxiomC: 'Axiom',
  UnaryInfC: ['Inference', 1],
  BinaryInfC: ['Inference', 2],
  TrinaryInfC: ['Inference', 3],
  QuaternaryInfC: ['Inference', 4],
  QuinaryInfC: ['Inference', 5],
  RightLabel: ['Label', 'right'],
  LeftLabel: ['Label', 'left'],
  AXC: 'Axiom',
  UIC: ['Inference', 1],
  BIC: ['Inference', 2],
  TIC: ['Inference', 3],
  RL: ['Label', 'right'],
  LL: ['Label', 'left'],
  noLine: ['SetLine', 'none', false],
  singleLine: ['SetLine', 'solid', false],
  solidLine: ['SetLine', 'solid', false],
  dashedLine: ['SetLine', 'dashed', false],
  alwaysNoLine: ['SetLine', 'none', true],
  alwaysSingleLine: ['SetLine', 'solid', true],
  alwaysSolidLine: ['SetLine', 'solid', true],
  alwaysDashedLine: ['SetLine', 'dashed', true],
  rootAtTop: ['RootAtTop', true],
  alwaysRootAtTop: ['RootAtTop', true],
  rootAtBottom: ['RootAtTop', false],
  alwaysRootAtBottom: ['RootAtTop', false],
  fCenter: 'FCenter',
  Axiom: 'AxiomF',
  UnaryInf: ['InferenceF', 1],
  BinaryInf: ['InferenceF', 2],
  TrinaryInf: ['InferenceF', 3],
  QuaternaryInf: ['InferenceF', 4],
  QuinaryInf: ['InferenceF', 5]
}, BussproofsMethods_js_1.default);
new SymbolMap_js_1$d.EnvironmentMap('Bussproofs-environments', ParseMethods_js_1$4.default.environment, {
  prooftree: ['Prooftree', null, false]
}, BussproofsMethods_js_1.default);

var _a$4;
Object.defineProperty(BussproofsConfiguration, "__esModule", {
  value: true
});
BussproofsConfiguration.BussproofsConfiguration = void 0;
var Configuration_js_1$f = Configuration;
var BussproofsItems_js_1 = BussproofsItems;
var BussproofsUtil_js_1 = BussproofsUtil$2;
BussproofsConfiguration.BussproofsConfiguration = Configuration_js_1$f.Configuration.create('bussproofs', {
  handler: {
    macro: ['Bussproofs-macros'],
    environment: ['Bussproofs-environments']
  },
  items: (_a$4 = {}, _a$4[BussproofsItems_js_1.ProofTreeItem.prototype.kind] = BussproofsItems_js_1.ProofTreeItem, _a$4),
  preprocessors: [[BussproofsUtil_js_1.saveDocument, 1]],
  postprocessors: [[BussproofsUtil_js_1.clearDocument, 3], [BussproofsUtil_js_1.makeBsprAttributes, 2], [BussproofsUtil_js_1.balanceRules, 1]]
});

var CancelConfiguration = {};

var EncloseConfiguration = {};

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EncloseConfiguration = exports.EncloseMethods = exports.ENCLOSE_OPTIONS = void 0;
  var Configuration_js_1 = Configuration;
  var SymbolMap_js_1 = SymbolMap;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  exports.ENCLOSE_OPTIONS = {
    'data-arrowhead': 1,
    color: 1,
    mathcolor: 1,
    background: 1,
    mathbackground: 1,
    'data-padding': 1,
    'data-thickness': 1
  };
  exports.EncloseMethods = {};
  exports.EncloseMethods.Enclose = function (parser, name) {
    var notation = parser.GetArgument(name).replace(/,/g, ' ');
    var attr = parser.GetBrackets(name, '');
    var math = parser.ParseArg(name);
    var def = ParseUtil_js_1.default.keyvalOptions(attr, exports.ENCLOSE_OPTIONS);
    def.notation = notation;
    parser.Push(parser.create('node', 'menclose', [math], def));
  };
  new SymbolMap_js_1.CommandMap('enclose', {
    enclose: 'Enclose'
  }, exports.EncloseMethods);
  exports.EncloseConfiguration = Configuration_js_1.Configuration.create('enclose', {
    handler: {
      macro: ['enclose']
    }
  });
})(EncloseConfiguration);
getDefaultExportFromCjs(EncloseConfiguration);

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CancelConfiguration = exports.CancelMethods = void 0;
  var Configuration_js_1 = Configuration;
  var TexConstants_js_1 = TexConstants;
  var SymbolMap_js_1 = SymbolMap;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var EncloseConfiguration_js_1 = EncloseConfiguration;
  exports.CancelMethods = {};
  exports.CancelMethods.Cancel = function (parser, name, notation) {
    var attr = parser.GetBrackets(name, '');
    var math = parser.ParseArg(name);
    var def = ParseUtil_js_1.default.keyvalOptions(attr, EncloseConfiguration_js_1.ENCLOSE_OPTIONS);
    def['notation'] = notation;
    parser.Push(parser.create('node', 'menclose', [math], def));
  };
  exports.CancelMethods.CancelTo = function (parser, name) {
    var attr = parser.GetBrackets(name, '');
    var value = parser.ParseArg(name);
    var math = parser.ParseArg(name);
    var def = ParseUtil_js_1.default.keyvalOptions(attr, EncloseConfiguration_js_1.ENCLOSE_OPTIONS);
    def['notation'] = [TexConstants_js_1.TexConstant.Notation.UPDIAGONALSTRIKE, TexConstants_js_1.TexConstant.Notation.UPDIAGONALARROW, TexConstants_js_1.TexConstant.Notation.NORTHEASTARROW].join(' ');
    value = parser.create('node', 'mpadded', [value], {
      depth: '-.1em',
      height: '+.1em',
      voffset: '.1em'
    });
    parser.Push(parser.create('node', 'msup', [parser.create('node', 'menclose', [math], def), value]));
  };
  new SymbolMap_js_1.CommandMap('cancel', {
    cancel: ['Cancel', TexConstants_js_1.TexConstant.Notation.UPDIAGONALSTRIKE],
    bcancel: ['Cancel', TexConstants_js_1.TexConstant.Notation.DOWNDIAGONALSTRIKE],
    xcancel: ['Cancel', TexConstants_js_1.TexConstant.Notation.UPDIAGONALSTRIKE + ' ' + TexConstants_js_1.TexConstant.Notation.DOWNDIAGONALSTRIKE],
    cancelto: 'CancelTo'
  }, exports.CancelMethods);
  exports.CancelConfiguration = Configuration_js_1.Configuration.create('cancel', {
    handler: {
      macro: ['cancel']
    }
  });
})(CancelConfiguration);
getDefaultExportFromCjs(CancelConfiguration);

var CasesConfiguration = {};

var EmpheqUtil = {};

(function (exports) {
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !((i in from))) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EmpheqUtil = void 0;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var TexParser_js_1 = __importDefault(TexParser$1);
  exports.EmpheqUtil = {
    environment: function (parser, env, func, args) {
      var name = args[0];
      var item = parser.itemFactory.create(name + '-begin').setProperties({
        name: env,
        end: name
      });
      parser.Push(func.apply(void 0, __spreadArray([parser, item], __read(args.slice(1)), false)));
    },
    splitOptions: function (text, allowed) {
      if (allowed === void 0) {
        allowed = null;
      }
      return ParseUtil_js_1.default.keyvalOptions(text, allowed, true);
    },
    columnCount: function (table) {
      var e_1, _a;
      var m = 0;
      try {
        for (var _b = __values(table.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
          var row = _c.value;
          var n = row.childNodes.length - (row.isKind('mlabeledtr') ? 1 : 0);
          if (n > m) m = n;
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return m;
    },
    cellBlock: function (tex, table, parser, env) {
      var e_2, _a;
      var mpadded = parser.create('node', 'mpadded', [], {
        height: 0,
        depth: 0,
        voffset: '-1height'
      });
      var result = new TexParser_js_1.default(tex, parser.stack.env, parser.configuration);
      var mml = result.mml();
      if (env && result.configuration.tags.label) {
        result.configuration.tags.currentTag.env = env;
        result.configuration.tags.getTag(true);
      }
      try {
        for (var _b = __values(mml.isInferred ? mml.childNodes : [mml]), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          mpadded.appendChild(child);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
      mpadded.appendChild(parser.create('node', 'mphantom', [parser.create('node', 'mpadded', [table], {
        width: 0
      })]));
      return mpadded;
    },
    topRowTable: function (original, parser) {
      var table = ParseUtil_js_1.default.copyNode(original, parser);
      table.setChildren(table.childNodes.slice(0, 1));
      table.attributes.set('align', 'baseline 1');
      return original.factory.create('mphantom', {}, [parser.create('node', 'mpadded', [table], {
        width: 0
      })]);
    },
    rowspanCell: function (mtd, tex, table, parser, env) {
      mtd.appendChild(parser.create('node', 'mpadded', [this.cellBlock(tex, ParseUtil_js_1.default.copyNode(table, parser), parser, env), this.topRowTable(table, parser)], {
        height: 0,
        depth: 0,
        voffset: 'height'
      }));
    },
    left: function (table, original, left, parser, env) {
      var e_3, _a;
      if (env === void 0) {
        env = '';
      }
      table.attributes.set('columnalign', 'right ' + (table.attributes.get('columnalign') || ''));
      table.attributes.set('columnspacing', '0em ' + (table.attributes.get('columnspacing') || ''));
      var mtd;
      try {
        for (var _b = __values(table.childNodes.slice(0).reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var row = _c.value;
          mtd = parser.create('node', 'mtd');
          row.childNodes.unshift(mtd);
          mtd.parent = row;
          if (row.isKind('mlabeledtr')) {
            row.childNodes[0] = row.childNodes[1];
            row.childNodes[1] = mtd;
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
      this.rowspanCell(mtd, left, original, parser, env);
    },
    right: function (table, original, right, parser, env) {
      if (env === void 0) {
        env = '';
      }
      if (table.childNodes.length === 0) {
        table.appendChild(parser.create('node', 'mtr'));
      }
      var m = exports.EmpheqUtil.columnCount(table);
      var row = table.childNodes[0];
      while (row.childNodes.length < m) row.appendChild(parser.create('node', 'mtd'));
      var mtd = row.appendChild(parser.create('node', 'mtd'));
      exports.EmpheqUtil.rowspanCell(mtd, right, original, parser, env);
      table.attributes.set('columnalign', (table.attributes.get('columnalign') || '').split(/ /).slice(0, m).join(' ') + ' left');
      table.attributes.set('columnspacing', (table.attributes.get('columnspacing') || '').split(/ /).slice(0, m - 1).join(' ') + ' 0em');
    },
    adjustTable: function (empheq, parser) {
      var left = empheq.getProperty('left');
      var right = empheq.getProperty('right');
      if (left || right) {
        var table = empheq.Last;
        var original = ParseUtil_js_1.default.copyNode(table, parser);
        if (left) this.left(table, original, left, parser);
        if (right) this.right(table, original, right, parser);
      }
    },
    allowEnv: {
      equation: true,
      align: true,
      gather: true,
      flalign: true,
      alignat: true,
      multline: true
    },
    checkEnv: function (env) {
      return this.allowEnv.hasOwnProperty(env.replace(/\*$/, '')) || false;
    }
  };
})(EmpheqUtil);
getDefaultExportFromCjs(EmpheqUtil);

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  var _a;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CasesConfiguration = exports.CasesMethods = exports.CasesTags = exports.CasesBeginItem = void 0;
  var Configuration_js_1 = Configuration;
  var SymbolMap_js_1 = SymbolMap;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var BaseMethods_js_1 = __importDefault(BaseMethods$1);
  var TexError_js_1 = __importDefault(TexError$1);
  var BaseItems_js_1 = BaseItems;
  var AmsConfiguration_js_1 = AmsConfiguration;
  var EmpheqUtil_js_1 = EmpheqUtil;
  var CasesBeginItem = (function (_super) {
    __extends(CasesBeginItem, _super);
    function CasesBeginItem() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CasesBeginItem.prototype, "kind", {
      get: function () {
        return 'cases-begin';
      },
      enumerable: false,
      configurable: true
    });
    CasesBeginItem.prototype.checkItem = function (item) {
      if (item.isKind('end') && item.getName() === this.getName()) {
        if (this.getProperty('end')) {
          this.setProperty('end', false);
          return [[], true];
        }
      }
      return _super.prototype.checkItem.call(this, item);
    };
    return CasesBeginItem;
  })(BaseItems_js_1.BeginItem);
  exports.CasesBeginItem = CasesBeginItem;
  var CasesTags = (function (_super) {
    __extends(CasesTags, _super);
    function CasesTags() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.subcounter = 0;
      return _this;
    }
    CasesTags.prototype.start = function (env, taggable, defaultTags) {
      this.subcounter = 0;
      _super.prototype.start.call(this, env, taggable, defaultTags);
    };
    CasesTags.prototype.autoTag = function () {
      if (this.currentTag.tag != null) return;
      if (this.currentTag.env === 'subnumcases') {
        if (this.subcounter === 0) this.counter++;
        this.subcounter++;
        this.tag(this.formatNumber(this.counter, this.subcounter), false);
      } else {
        if (this.subcounter === 0 || this.currentTag.env !== 'numcases-left') this.counter++;
        this.tag(this.formatNumber(this.counter), false);
      }
    };
    CasesTags.prototype.formatNumber = function (n, m) {
      if (m === void 0) {
        m = null;
      }
      return n.toString() + (m === null ? '' : String.fromCharCode(0x60 + m));
    };
    return CasesTags;
  })(AmsConfiguration_js_1.AmsTags);
  exports.CasesTags = CasesTags;
  exports.CasesMethods = {
    NumCases: function (parser, begin) {
      if (parser.stack.env.closing === begin.getName()) {
        delete parser.stack.env.closing;
        parser.Push(parser.itemFactory.create('end').setProperty('name', begin.getName()));
        var cases = parser.stack.Top();
        var table = cases.Last;
        var original = ParseUtil_js_1.default.copyNode(table, parser);
        var left = cases.getProperty('left');
        EmpheqUtil_js_1.EmpheqUtil.left(table, original, left + '\\empheqlbrace\\,', parser, 'numcases-left');
        parser.Push(parser.itemFactory.create('end').setProperty('name', begin.getName()));
        return null;
      } else {
        var left = parser.GetArgument('\\begin{' + begin.getName() + '}');
        begin.setProperty('left', left);
        var array = BaseMethods_js_1.default.EqnArray(parser, begin, true, true, 'll');
        array.arraydef.displaystyle = false;
        array.arraydef.rowspacing = '.2em';
        array.setProperty('numCases', true);
        parser.Push(begin);
        return array;
      }
    },
    Entry: function (parser, name) {
      if (!parser.stack.Top().getProperty('numCases')) {
        return BaseMethods_js_1.default.Entry(parser, name);
      }
      parser.Push(parser.itemFactory.create('cell').setProperties({
        isEntry: true,
        name: name
      }));
      var tex = parser.string;
      var braces = 0, i = parser.i, m = tex.length;
      while (i < m) {
        var c = tex.charAt(i);
        if (c === '{') {
          braces++;
          i++;
        } else if (c === '}') {
          if (braces === 0) {
            break;
          } else {
            braces--;
            i++;
          }
        } else if (c === '&' && braces === 0) {
          throw new TexError_js_1.default('ExtraCasesAlignTab', 'Extra alignment tab in text for numcase environment');
        } else if (c === '\\' && braces === 0) {
          var cs = (tex.slice(i + 1).match(/^[a-z]+|./i) || [])[0];
          if (cs === '\\' || cs === 'cr' || cs === 'end' || cs === 'label') {
            break;
          } else {
            i += cs.length;
          }
        } else {
          i++;
        }
      }
      var text = tex.substr(parser.i, i - parser.i).replace(/^\s*/, '');
      parser.PushAll(ParseUtil_js_1.default.internalMath(parser, text, 0));
      parser.i = i;
    }
  };
  new SymbolMap_js_1.EnvironmentMap('cases-env', EmpheqUtil_js_1.EmpheqUtil.environment, {
    numcases: ['NumCases', 'cases'],
    subnumcases: ['NumCases', 'cases']
  }, exports.CasesMethods);
  new SymbolMap_js_1.MacroMap('cases-macros', {
    '&': 'Entry'
  }, exports.CasesMethods);
  exports.CasesConfiguration = Configuration_js_1.Configuration.create('cases', {
    handler: {
      environment: ['cases-env'],
      character: ['cases-macros']
    },
    items: (_a = {}, _a[CasesBeginItem.prototype.kind] = CasesBeginItem, _a),
    tags: {
      'cases': CasesTags
    }
  });
})(CasesConfiguration);
getDefaultExportFromCjs(CasesConfiguration);

var CenternotConfiguration = {};

var __values$5 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$m = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(CenternotConfiguration, "__esModule", {
  value: true
});
CenternotConfiguration.CenternotConfiguration = CenternotConfiguration.filterCenterOver = void 0;
var Configuration_js_1$e = Configuration;
var TexParser_js_1$5 = __importDefault$m(TexParser$1);
var NodeUtil_js_1$5 = __importDefault$m(NodeUtil$1);
var SymbolMap_js_1$c = SymbolMap;
var BaseMethods_js_1$4 = __importDefault$m(BaseMethods$1);
new SymbolMap_js_1$c.CommandMap('centernot', {
  centerOver: 'CenterOver',
  centernot: ['Macro', '\\centerOver{#1}{{\u29F8}}', 1]
}, {
  CenterOver: function (parser, name) {
    var arg = '{' + parser.GetArgument(name) + '}';
    var over = parser.ParseArg(name);
    var base = new TexParser_js_1$5.default(arg, parser.stack.env, parser.configuration).mml();
    var mml = parser.create('node', 'TeXAtom', [new TexParser_js_1$5.default(arg, parser.stack.env, parser.configuration).mml(), parser.create('node', 'mpadded', [parser.create('node', 'mpadded', [over], {
      width: 0,
      lspace: '-.5width'
    }), parser.create('node', 'mphantom', [base])], {
      width: 0,
      lspace: '-.5width'
    })]);
    parser.configuration.addNode('centerOver', base);
    parser.Push(mml);
  },
  Macro: BaseMethods_js_1$4.default.Macro
});
function filterCenterOver(_a) {
  var e_1, _b;
  var data = _a.data;
  try {
    for (var _c = __values$5(data.getList('centerOver')), _d = _c.next(); !_d.done; _d = _c.next()) {
      var base = _d.value;
      var texClass = NodeUtil_js_1$5.default.getTexClass(base.childNodes[0].childNodes[0]);
      if (texClass !== null) {
        NodeUtil_js_1$5.default.setProperties(base.parent.parent.parent.parent.parent.parent, {
          texClass: texClass
        });
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}
CenternotConfiguration.filterCenterOver = filterCenterOver;
CenternotConfiguration.CenternotConfiguration = Configuration_js_1$e.Configuration.create('centernot', {
  handler: {
    macro: ['centernot']
  },
  postprocessors: [filterCenterOver]
});

var ColorConfiguration = {};

var ColorMethods = {};

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ColorMethods = void 0;
  var NodeUtil_js_1 = __importDefault(NodeUtil$1);
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  function padding(colorPadding) {
    var pad = ("+").concat(colorPadding);
    var unit = colorPadding.replace(/^.*?([a-z]*)$/, '$1');
    var pad2 = 2 * parseFloat(pad);
    return {
      width: ("+").concat(pad2).concat(unit),
      height: pad,
      depth: pad,
      lspace: colorPadding
    };
  }
  exports.ColorMethods = {};
  exports.ColorMethods.Color = function (parser, name) {
    var model = parser.GetBrackets(name, '');
    var colorDef = parser.GetArgument(name);
    var colorModel = parser.configuration.packageData.get('color').model;
    var color = colorModel.getColor(model, colorDef);
    var style = parser.itemFactory.create('style').setProperties({
      styles: {
        mathcolor: color
      }
    });
    parser.stack.env['color'] = color;
    parser.Push(style);
  };
  exports.ColorMethods.TextColor = function (parser, name) {
    var model = parser.GetBrackets(name, '');
    var colorDef = parser.GetArgument(name);
    var colorModel = parser.configuration.packageData.get('color').model;
    var color = colorModel.getColor(model, colorDef);
    var old = parser.stack.env['color'];
    parser.stack.env['color'] = color;
    var math = parser.ParseArg(name);
    if (old) {
      parser.stack.env['color'] = old;
    } else {
      delete parser.stack.env['color'];
    }
    var node = parser.create('node', 'mstyle', [math], {
      mathcolor: color
    });
    parser.Push(node);
  };
  exports.ColorMethods.DefineColor = function (parser, name) {
    var cname = parser.GetArgument(name);
    var model = parser.GetArgument(name);
    var def = parser.GetArgument(name);
    var colorModel = parser.configuration.packageData.get('color').model;
    colorModel.defineColor(model, cname, def);
  };
  exports.ColorMethods.ColorBox = function (parser, name) {
    var cname = parser.GetArgument(name);
    var math = ParseUtil_js_1.default.internalMath(parser, parser.GetArgument(name));
    var colorModel = parser.configuration.packageData.get('color').model;
    var node = parser.create('node', 'mpadded', math, {
      mathbackground: colorModel.getColor('named', cname)
    });
    NodeUtil_js_1.default.setProperties(node, padding(parser.options.color.padding));
    parser.Push(node);
  };
  exports.ColorMethods.FColorBox = function (parser, name) {
    var fname = parser.GetArgument(name);
    var cname = parser.GetArgument(name);
    var math = ParseUtil_js_1.default.internalMath(parser, parser.GetArgument(name));
    var options = parser.options.color;
    var colorModel = parser.configuration.packageData.get('color').model;
    var node = parser.create('node', 'mpadded', math, {
      mathbackground: colorModel.getColor('named', cname),
      style: ("border: ").concat(options.borderWidth, " solid ").concat(colorModel.getColor('named', fname))
    });
    NodeUtil_js_1.default.setProperties(node, padding(options.padding));
    parser.Push(node);
  };
})(ColorMethods);
getDefaultExportFromCjs(ColorMethods);

var ColorUtil = {};

var ColorConstants = {};

Object.defineProperty(ColorConstants, "__esModule", {
  value: true
});
ColorConstants.COLORS = void 0;
ColorConstants.COLORS = new Map([['Apricot', '#FBB982'], ['Aquamarine', '#00B5BE'], ['Bittersweet', '#C04F17'], ['Black', '#221E1F'], ['Blue', '#2D2F92'], ['BlueGreen', '#00B3B8'], ['BlueViolet', '#473992'], ['BrickRed', '#B6321C'], ['Brown', '#792500'], ['BurntOrange', '#F7921D'], ['CadetBlue', '#74729A'], ['CarnationPink', '#F282B4'], ['Cerulean', '#00A2E3'], ['CornflowerBlue', '#41B0E4'], ['Cyan', '#00AEEF'], ['Dandelion', '#FDBC42'], ['DarkOrchid', '#A4538A'], ['Emerald', '#00A99D'], ['ForestGreen', '#009B55'], ['Fuchsia', '#8C368C'], ['Goldenrod', '#FFDF42'], ['Gray', '#949698'], ['Green', '#00A64F'], ['GreenYellow', '#DFE674'], ['JungleGreen', '#00A99A'], ['Lavender', '#F49EC4'], ['LimeGreen', '#8DC73E'], ['Magenta', '#EC008C'], ['Mahogany', '#A9341F'], ['Maroon', '#AF3235'], ['Melon', '#F89E7B'], ['MidnightBlue', '#006795'], ['Mulberry', '#A93C93'], ['NavyBlue', '#006EB8'], ['OliveGreen', '#3C8031'], ['Orange', '#F58137'], ['OrangeRed', '#ED135A'], ['Orchid', '#AF72B0'], ['Peach', '#F7965A'], ['Periwinkle', '#7977B8'], ['PineGreen', '#008B72'], ['Plum', '#92268F'], ['ProcessBlue', '#00B0F0'], ['Purple', '#99479B'], ['RawSienna', '#974006'], ['Red', '#ED1B23'], ['RedOrange', '#F26035'], ['RedViolet', '#A1246B'], ['Rhodamine', '#EF559F'], ['RoyalBlue', '#0071BC'], ['RoyalPurple', '#613F99'], ['RubineRed', '#ED017D'], ['Salmon', '#F69289'], ['SeaGreen', '#3FBC9D'], ['Sepia', '#671800'], ['SkyBlue', '#46C5DD'], ['SpringGreen', '#C6DC67'], ['Tan', '#DA9D76'], ['TealBlue', '#00AEB3'], ['Thistle', '#D883B7'], ['Turquoise', '#00B4CE'], ['Violet', '#58429B'], ['VioletRed', '#EF58A0'], ['White', '#FFFFFF'], ['WildStrawberry', '#EE2967'], ['Yellow', '#FFF200'], ['YellowGreen', '#98CC70'], ['YellowOrange', '#FAA21A']]);

var __values$4 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$l = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(ColorUtil, "__esModule", {
  value: true
});
ColorUtil.ColorModel = void 0;
var TexError_js_1$9 = __importDefault$l(TexError$1);
var ColorConstants_js_1 = ColorConstants;
var ColorModelProcessors = new Map();
var ColorModel = (function () {
  function ColorModel() {
    this.userColors = new Map();
  }
  ColorModel.prototype.normalizeColor = function (model, def) {
    if (!model || model === 'named') {
      return def;
    }
    if (ColorModelProcessors.has(model)) {
      var modelProcessor = ColorModelProcessors.get(model);
      return modelProcessor(def);
    }
    throw new TexError_js_1$9.default('UndefinedColorModel', 'Color model \'%1\' not defined', model);
  };
  ColorModel.prototype.getColor = function (model, def) {
    if (!model || model === 'named') {
      return this.getColorByName(def);
    }
    return this.normalizeColor(model, def);
  };
  ColorModel.prototype.getColorByName = function (name) {
    if (this.userColors.has(name)) {
      return this.userColors.get(name);
    }
    if (ColorConstants_js_1.COLORS.has(name)) {
      return ColorConstants_js_1.COLORS.get(name);
    }
    return name;
  };
  ColorModel.prototype.defineColor = function (model, name, def) {
    var normalized = this.normalizeColor(model, def);
    this.userColors.set(name, normalized);
  };
  return ColorModel;
})();
ColorUtil.ColorModel = ColorModel;
ColorModelProcessors.set('rgb', function (rgb) {
  var e_1, _a;
  var rgbParts = rgb.trim().split(/\s*,\s*/);
  var RGB = '#';
  if (rgbParts.length !== 3) {
    throw new TexError_js_1$9.default('ModelArg1', 'Color values for the %1 model require 3 numbers', 'rgb');
  }
  try {
    for (var rgbParts_1 = __values$4(rgbParts), rgbParts_1_1 = rgbParts_1.next(); !rgbParts_1_1.done; rgbParts_1_1 = rgbParts_1.next()) {
      var rgbPart = rgbParts_1_1.value;
      if (!rgbPart.match(/^(\d+(\.\d*)?|\.\d+)$/)) {
        throw new TexError_js_1$9.default('InvalidDecimalNumber', 'Invalid decimal number');
      }
      var n = parseFloat(rgbPart);
      if (n < 0 || n > 1) {
        throw new TexError_js_1$9.default('ModelArg2', 'Color values for the %1 model must be between %2 and %3', 'rgb', '0', '1');
      }
      var pn = Math.floor(n * 255).toString(16);
      if (pn.length < 2) {
        pn = '0' + pn;
      }
      RGB += pn;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (rgbParts_1_1 && !rgbParts_1_1.done && (_a = rgbParts_1.return)) _a.call(rgbParts_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return RGB;
});
ColorModelProcessors.set('RGB', function (rgb) {
  var e_2, _a;
  var rgbParts = rgb.trim().split(/\s*,\s*/);
  var RGB = '#';
  if (rgbParts.length !== 3) {
    throw new TexError_js_1$9.default('ModelArg1', 'Color values for the %1 model require 3 numbers', 'RGB');
  }
  try {
    for (var rgbParts_2 = __values$4(rgbParts), rgbParts_2_1 = rgbParts_2.next(); !rgbParts_2_1.done; rgbParts_2_1 = rgbParts_2.next()) {
      var rgbPart = rgbParts_2_1.value;
      if (!rgbPart.match(/^\d+$/)) {
        throw new TexError_js_1$9.default('InvalidNumber', 'Invalid number');
      }
      var n = parseInt(rgbPart);
      if (n > 255) {
        throw new TexError_js_1$9.default('ModelArg2', 'Color values for the %1 model must be between %2 and %3', 'RGB', '0', '255');
      }
      var pn = n.toString(16);
      if (pn.length < 2) {
        pn = '0' + pn;
      }
      RGB += pn;
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (rgbParts_2_1 && !rgbParts_2_1.done && (_a = rgbParts_2.return)) _a.call(rgbParts_2);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return RGB;
});
ColorModelProcessors.set('gray', function (gray) {
  if (!gray.match(/^\s*(\d+(\.\d*)?|\.\d+)\s*$/)) {
    throw new TexError_js_1$9.default('InvalidDecimalNumber', 'Invalid decimal number');
  }
  var n = parseFloat(gray);
  if (n < 0 || n > 1) {
    throw new TexError_js_1$9.default('ModelArg2', 'Color values for the %1 model must be between %2 and %3', 'gray', '0', '1');
  }
  var pn = Math.floor(n * 255).toString(16);
  if (pn.length < 2) {
    pn = '0' + pn;
  }
  return ("#").concat(pn).concat(pn).concat(pn);
});

Object.defineProperty(ColorConfiguration, "__esModule", {
  value: true
});
ColorConfiguration.ColorConfiguration = void 0;
var SymbolMap_js_1$b = SymbolMap;
var Configuration_js_1$d = Configuration;
var ColorMethods_js_1 = ColorMethods;
var ColorUtil_js_1 = ColorUtil;
new SymbolMap_js_1$b.CommandMap('color', {
  color: 'Color',
  textcolor: 'TextColor',
  definecolor: 'DefineColor',
  colorbox: 'ColorBox',
  fcolorbox: 'FColorBox'
}, ColorMethods_js_1.ColorMethods);
var config$1 = function (_config, jax) {
  jax.parseOptions.packageData.set('color', {
    model: new ColorUtil_js_1.ColorModel()
  });
};
ColorConfiguration.ColorConfiguration = Configuration_js_1$d.Configuration.create('color', {
  handler: {
    macro: ['color']
  },
  options: {
    color: {
      padding: '5px',
      borderWidth: '2px'
    }
  },
  config: config$1
});

var ColorV2Configuration = {};

(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ColorConfiguration = exports.ColorV2Methods = void 0;
  var SymbolMap_js_1 = SymbolMap;
  var Configuration_js_1 = Configuration;
  exports.ColorV2Methods = {
    Color: function (parser, name) {
      var color = parser.GetArgument(name);
      var old = parser.stack.env['color'];
      parser.stack.env['color'] = color;
      var math = parser.ParseArg(name);
      if (old) {
        parser.stack.env['color'] = old;
      } else {
        delete parser.stack.env['color'];
      }
      var node = parser.create('node', 'mstyle', [math], {
        mathcolor: color
      });
      parser.Push(node);
    }
  };
  new SymbolMap_js_1.CommandMap('colorv2', {
    color: 'Color'
  }, exports.ColorV2Methods);
  exports.ColorConfiguration = Configuration_js_1.Configuration.create('colorv2', {
    handler: {
      macro: ['colorv2']
    }
  });
})(ColorV2Configuration);
getDefaultExportFromCjs(ColorV2Configuration);

var ColortblConfiguration = {};

var __extends$6 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __importDefault$k = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(ColortblConfiguration, "__esModule", {
  value: true
});
ColortblConfiguration.ColortblConfiguration = ColortblConfiguration.ColorArrayItem = void 0;
var BaseItems_js_1$3 = BaseItems;
var Configuration_js_1$c = Configuration;
var SymbolMap_js_1$a = SymbolMap;
var TexError_js_1$8 = __importDefault$k(TexError$1);
var ColorArrayItem = (function (_super) {
  __extends$6(ColorArrayItem, _super);
  function ColorArrayItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.color = {
      cell: '',
      row: '',
      col: []
    };
    _this.hasColor = false;
    return _this;
  }
  ColorArrayItem.prototype.EndEntry = function () {
    _super.prototype.EndEntry.call(this);
    var cell = this.row[this.row.length - 1];
    var color = this.color.cell || this.color.row || this.color.col[this.row.length - 1];
    if (color) {
      cell.attributes.set('mathbackground', color);
      this.color.cell = '';
      this.hasColor = true;
    }
  };
  ColorArrayItem.prototype.EndRow = function () {
    _super.prototype.EndRow.call(this);
    this.color.row = '';
  };
  ColorArrayItem.prototype.createMml = function () {
    var mml = _super.prototype.createMml.call(this);
    var table = mml.isKind('mrow') ? mml.childNodes[1] : mml;
    if (table.isKind('menclose')) {
      table = table.childNodes[0].childNodes[0];
    }
    if (this.hasColor && table.attributes.get('frame') === 'none') {
      table.attributes.set('frame', '');
    }
    return mml;
  };
  return ColorArrayItem;
})(BaseItems_js_1$3.ArrayItem);
ColortblConfiguration.ColorArrayItem = ColorArrayItem;
new SymbolMap_js_1$a.CommandMap('colortbl', {
  cellcolor: ['TableColor', 'cell'],
  rowcolor: ['TableColor', 'row'],
  columncolor: ['TableColor', 'col']
}, {
  TableColor: function (parser, name, type) {
    var lookup = parser.configuration.packageData.get('color').model;
    var model = parser.GetBrackets(name, '');
    var color = lookup.getColor(model, parser.GetArgument(name));
    var top = parser.stack.Top();
    if (!(top instanceof ColorArrayItem)) {
      throw new TexError_js_1$8.default('UnsupportedTableColor', 'Unsupported use of %1', parser.currentCS);
    }
    if (type === 'col') {
      if (top.table.length) {
        throw new TexError_js_1$8.default('ColumnColorNotTop', '%1 must be in the top row', name);
      }
      top.color.col[top.row.length] = color;
      if (parser.GetBrackets(name, '')) {
        parser.GetBrackets(name, '');
      }
    } else {
      top.color[type] = color;
      if (type === 'row' && (top.Size() || top.row.length)) {
        throw new TexError_js_1$8.default('RowColorNotFirst', '%1 must be at the beginning of a row', name);
      }
    }
  }
});
var config = function (config, jax) {
  if (!jax.parseOptions.packageData.has('color')) {
    Configuration_js_1$c.ConfigurationHandler.get('color').config(config, jax);
  }
};
ColortblConfiguration.ColortblConfiguration = Configuration_js_1$c.Configuration.create('colortbl', {
  handler: {
    macro: ['colortbl']
  },
  items: {
    'array': ColorArrayItem
  },
  priority: 10,
  config: [config, 10]
});

var ConfigMacrosConfiguration = {};

var NewcommandMethods$1 = {};

var NewcommandUtil$1 = {};

var __importDefault$j = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(NewcommandUtil$1, "__esModule", {
  value: true
});
var ParseUtil_js_1$6 = __importDefault$j(ParseUtil$1);
var TexError_js_1$7 = __importDefault$j(TexError$1);
var Symbol_js_1$2 = _Symbol;
var NewcommandUtil;
(function (NewcommandUtil) {
  function disassembleSymbol(name, symbol) {
    var newArgs = [name, symbol.char];
    if (symbol.attributes) {
      for (var key in symbol.attributes) {
        newArgs.push(key);
        newArgs.push(symbol.attributes[key]);
      }
    }
    return newArgs;
  }
  NewcommandUtil.disassembleSymbol = disassembleSymbol;
  function assembleSymbol(args) {
    var name = args[0];
    var char = args[1];
    var attrs = {};
    for (var i = 2; i < args.length; i = i + 2) {
      attrs[args[i]] = args[i + 1];
    }
    return new Symbol_js_1$2.Symbol(name, char, attrs);
  }
  NewcommandUtil.assembleSymbol = assembleSymbol;
  function GetCSname(parser, cmd) {
    var c = parser.GetNext();
    if (c !== '\\') {
      throw new TexError_js_1$7.default('MissingCS', '%1 must be followed by a control sequence', cmd);
    }
    var cs = ParseUtil_js_1$6.default.trimSpaces(parser.GetArgument(cmd));
    return cs.substr(1);
  }
  NewcommandUtil.GetCSname = GetCSname;
  function GetCsNameArgument(parser, name) {
    var cs = ParseUtil_js_1$6.default.trimSpaces(parser.GetArgument(name));
    if (cs.charAt(0) === '\\') {
      cs = cs.substr(1);
    }
    if (!cs.match(/^(.|[a-z]+)$/i)) {
      throw new TexError_js_1$7.default('IllegalControlSequenceName', 'Illegal control sequence name for %1', name);
    }
    return cs;
  }
  NewcommandUtil.GetCsNameArgument = GetCsNameArgument;
  function GetArgCount(parser, name) {
    var n = parser.GetBrackets(name);
    if (n) {
      n = ParseUtil_js_1$6.default.trimSpaces(n);
      if (!n.match(/^[0-9]+$/)) {
        throw new TexError_js_1$7.default('IllegalParamNumber', 'Illegal number of parameters specified in %1', name);
      }
    }
    return n;
  }
  NewcommandUtil.GetArgCount = GetArgCount;
  function GetTemplate(parser, cmd, cs) {
    var c = parser.GetNext();
    var params = [];
    var n = 0;
    var i = parser.i;
    while (parser.i < parser.string.length) {
      c = parser.GetNext();
      if (c === '#') {
        if (i !== parser.i) {
          params[n] = parser.string.substr(i, parser.i - i);
        }
        c = parser.string.charAt(++parser.i);
        if (!c.match(/^[1-9]$/)) {
          throw new TexError_js_1$7.default('CantUseHash2', 'Illegal use of # in template for %1', cs);
        }
        if (parseInt(c) !== ++n) {
          throw new TexError_js_1$7.default('SequentialParam', 'Parameters for %1 must be numbered sequentially', cs);
        }
        i = parser.i + 1;
      } else if (c === '{') {
        if (i !== parser.i) {
          params[n] = parser.string.substr(i, parser.i - i);
        }
        if (params.length > 0) {
          return [n.toString()].concat(params);
        } else {
          return n;
        }
      }
      parser.i++;
    }
    throw new TexError_js_1$7.default('MissingReplacementString', 'Missing replacement string for definition of %1', cmd);
  }
  NewcommandUtil.GetTemplate = GetTemplate;
  function GetParameter(parser, name, param) {
    if (param == null) {
      return parser.GetArgument(name);
    }
    var i = parser.i;
    var j = 0;
    var hasBraces = 0;
    while (parser.i < parser.string.length) {
      var c = parser.string.charAt(parser.i);
      if (c === '{') {
        if (parser.i === i) {
          hasBraces = 1;
        }
        parser.GetArgument(name);
        j = parser.i - i;
      } else if (MatchParam(parser, param)) {
        if (hasBraces) {
          i++;
          j -= 2;
        }
        return parser.string.substr(i, j);
      } else if (c === '\\') {
        parser.i++;
        j++;
        hasBraces = 0;
        var match = parser.string.substr(parser.i).match(/[a-z]+|./i);
        if (match) {
          parser.i += match[0].length;
          j = parser.i - i;
        }
      } else {
        parser.i++;
        j++;
        hasBraces = 0;
      }
    }
    throw new TexError_js_1$7.default('RunawayArgument', 'Runaway argument for %1?', name);
  }
  NewcommandUtil.GetParameter = GetParameter;
  function MatchParam(parser, param) {
    if (parser.string.substr(parser.i, param.length) !== param) {
      return 0;
    }
    if (param.match(/\\[a-z]+$/i) && parser.string.charAt(parser.i + param.length).match(/[a-z]/i)) {
      return 0;
    }
    parser.i += param.length;
    return 1;
  }
  NewcommandUtil.MatchParam = MatchParam;
  function addDelimiter(parser, cs, char, attr) {
    var handlers = parser.configuration.handlers;
    var handler = handlers.retrieve(NewcommandUtil.NEW_DELIMITER);
    handler.add(cs, new Symbol_js_1$2.Symbol(cs, char, attr));
  }
  NewcommandUtil.addDelimiter = addDelimiter;
  function addMacro(parser, cs, func, attr, symbol) {
    if (symbol === void 0) {
      symbol = '';
    }
    var handlers = parser.configuration.handlers;
    var handler = handlers.retrieve(NewcommandUtil.NEW_COMMAND);
    handler.add(cs, new Symbol_js_1$2.Macro(symbol ? symbol : cs, func, attr));
  }
  NewcommandUtil.addMacro = addMacro;
  function addEnvironment(parser, env, func, attr) {
    var handlers = parser.configuration.handlers;
    var handler = handlers.retrieve(NewcommandUtil.NEW_ENVIRONMENT);
    handler.add(env, new Symbol_js_1$2.Macro(env, func, attr));
  }
  NewcommandUtil.addEnvironment = addEnvironment;
  NewcommandUtil.NEW_DELIMITER = 'new-Delimiter';
  NewcommandUtil.NEW_COMMAND = 'new-Command';
  NewcommandUtil.NEW_ENVIRONMENT = 'new-Environment';
})(NewcommandUtil || (NewcommandUtil = {}));
NewcommandUtil$1.default = NewcommandUtil;

var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
  __setModuleDefault$1(result, mod);
  return result;
});
var __importDefault$i = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(NewcommandMethods$1, "__esModule", {
  value: true
});
var TexError_js_1$6 = __importDefault$i(TexError$1);
var sm$1 = __importStar$1(SymbolMap);
var BaseMethods_js_1$3 = __importDefault$i(BaseMethods$1);
var ParseUtil_js_1$5 = __importDefault$i(ParseUtil$1);
var NewcommandUtil_js_1$1 = __importDefault$i(NewcommandUtil$1);
var NewcommandMethods = {};
NewcommandMethods.NewCommand = function (parser, name) {
  var cs = NewcommandUtil_js_1$1.default.GetCsNameArgument(parser, name);
  var n = NewcommandUtil_js_1$1.default.GetArgCount(parser, name);
  var opt = parser.GetBrackets(name);
  var def = parser.GetArgument(name);
  NewcommandUtil_js_1$1.default.addMacro(parser, cs, NewcommandMethods.Macro, [def, n, opt]);
};
NewcommandMethods.NewEnvironment = function (parser, name) {
  var env = ParseUtil_js_1$5.default.trimSpaces(parser.GetArgument(name));
  var n = NewcommandUtil_js_1$1.default.GetArgCount(parser, name);
  var opt = parser.GetBrackets(name);
  var bdef = parser.GetArgument(name);
  var edef = parser.GetArgument(name);
  NewcommandUtil_js_1$1.default.addEnvironment(parser, env, NewcommandMethods.BeginEnv, [true, bdef, edef, n, opt]);
};
NewcommandMethods.MacroDef = function (parser, name) {
  var cs = NewcommandUtil_js_1$1.default.GetCSname(parser, name);
  var params = NewcommandUtil_js_1$1.default.GetTemplate(parser, name, '\\' + cs);
  var def = parser.GetArgument(name);
  !(params instanceof Array) ? NewcommandUtil_js_1$1.default.addMacro(parser, cs, NewcommandMethods.Macro, [def, params]) : NewcommandUtil_js_1$1.default.addMacro(parser, cs, NewcommandMethods.MacroWithTemplate, [def].concat(params));
};
NewcommandMethods.Let = function (parser, name) {
  var cs = NewcommandUtil_js_1$1.default.GetCSname(parser, name);
  var c = parser.GetNext();
  if (c === '=') {
    parser.i++;
    c = parser.GetNext();
  }
  var handlers = parser.configuration.handlers;
  if (c === '\\') {
    name = NewcommandUtil_js_1$1.default.GetCSname(parser, name);
    var macro_1 = handlers.get('delimiter').lookup('\\' + name);
    if (macro_1) {
      NewcommandUtil_js_1$1.default.addDelimiter(parser, '\\' + cs, macro_1.char, macro_1.attributes);
      return;
    }
    var map_1 = handlers.get('macro').applicable(name);
    if (!map_1) {
      return;
    }
    if (map_1 instanceof sm$1.MacroMap) {
      var macro_2 = map_1.lookup(name);
      NewcommandUtil_js_1$1.default.addMacro(parser, cs, macro_2.func, macro_2.args, macro_2.symbol);
      return;
    }
    macro_1 = map_1.lookup(name);
    var newArgs = NewcommandUtil_js_1$1.default.disassembleSymbol(cs, macro_1);
    var method = function (p, _cs) {
      var rest = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        rest[_i - 2] = arguments[_i];
      }
      var symb = NewcommandUtil_js_1$1.default.assembleSymbol(rest);
      return map_1.parser(p, symb);
    };
    NewcommandUtil_js_1$1.default.addMacro(parser, cs, method, newArgs);
    return;
  }
  parser.i++;
  var macro = handlers.get('delimiter').lookup(c);
  if (macro) {
    NewcommandUtil_js_1$1.default.addDelimiter(parser, '\\' + cs, macro.char, macro.attributes);
    return;
  }
  NewcommandUtil_js_1$1.default.addMacro(parser, cs, NewcommandMethods.Macro, [c]);
};
NewcommandMethods.MacroWithTemplate = function (parser, name, text, n) {
  var params = [];
  for (var _i = 4; _i < arguments.length; _i++) {
    params[_i - 4] = arguments[_i];
  }
  var argCount = parseInt(n, 10);
  if (argCount) {
    var args = [];
    parser.GetNext();
    if (params[0] && !NewcommandUtil_js_1$1.default.MatchParam(parser, params[0])) {
      throw new TexError_js_1$6.default('MismatchUseDef', 'Use of %1 doesn\'t match its definition', name);
    }
    for (var i = 0; i < argCount; i++) {
      args.push(NewcommandUtil_js_1$1.default.GetParameter(parser, name, params[i + 1]));
    }
    text = ParseUtil_js_1$5.default.substituteArgs(parser, args, text);
  }
  parser.string = ParseUtil_js_1$5.default.addArgs(parser, text, parser.string.slice(parser.i));
  parser.i = 0;
  ParseUtil_js_1$5.default.checkMaxMacros(parser);
};
NewcommandMethods.BeginEnv = function (parser, begin, bdef, edef, n, def) {
  if (begin.getProperty('end') && parser.stack.env['closing'] === begin.getName()) {
    delete parser.stack.env['closing'];
    var rest = parser.string.slice(parser.i);
    parser.string = edef;
    parser.i = 0;
    parser.Parse();
    parser.string = rest;
    parser.i = 0;
    return parser.itemFactory.create('end').setProperty('name', begin.getName());
  }
  if (n) {
    var args = [];
    if (def != null) {
      var optional = parser.GetBrackets('\\begin{' + begin.getName() + '}');
      args.push(optional == null ? def : optional);
    }
    for (var i = args.length; i < n; i++) {
      args.push(parser.GetArgument('\\begin{' + begin.getName() + '}'));
    }
    bdef = ParseUtil_js_1$5.default.substituteArgs(parser, args, bdef);
    edef = ParseUtil_js_1$5.default.substituteArgs(parser, [], edef);
  }
  parser.string = ParseUtil_js_1$5.default.addArgs(parser, bdef, parser.string.slice(parser.i));
  parser.i = 0;
  return parser.itemFactory.create('beginEnv').setProperty('name', begin.getName());
};
NewcommandMethods.Macro = BaseMethods_js_1$3.default.Macro;
NewcommandMethods$1.default = NewcommandMethods;

var NewcommandItems = {};

var __extends$5 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __importDefault$h = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(NewcommandItems, "__esModule", {
  value: true
});
NewcommandItems.BeginEnvItem = void 0;
var TexError_js_1$5 = __importDefault$h(TexError$1);
var StackItem_js_1$1 = StackItem;
var BeginEnvItem = (function (_super) {
  __extends$5(BeginEnvItem, _super);
  function BeginEnvItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(BeginEnvItem.prototype, "kind", {
    get: function () {
      return 'beginEnv';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BeginEnvItem.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  BeginEnvItem.prototype.checkItem = function (item) {
    if (item.isKind('end')) {
      if (item.getName() !== this.getName()) {
        throw new TexError_js_1$5.default('EnvBadEnd', '\\begin{%1} ended with \\end{%2}', this.getName(), item.getName());
      }
      return [[this.factory.create('mml', this.toMml())], true];
    }
    if (item.isKind('stop')) {
      throw new TexError_js_1$5.default('EnvMissingEnd', 'Missing \\end{%1}', this.getName());
    }
    return _super.prototype.checkItem.call(this, item);
  };
  return BeginEnvItem;
})(StackItem_js_1$1.BaseItem);
NewcommandItems.BeginEnvItem = BeginEnvItem;

var __values$3 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __importDefault$g = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var _a$3;
Object.defineProperty(ConfigMacrosConfiguration, "__esModule", {
  value: true
});
ConfigMacrosConfiguration.ConfigMacrosConfiguration = void 0;
var Configuration_js_1$b = Configuration;
var Options_js_1$1 = Options;
var SymbolMap_js_1$9 = SymbolMap;
var ParseMethods_js_1$3 = __importDefault$g(ParseMethods$1);
var Symbol_js_1$1 = _Symbol;
var NewcommandMethods_js_1$1 = __importDefault$g(NewcommandMethods$1);
var NewcommandItems_js_1$1 = NewcommandItems;
var MACROSMAP = 'configmacros-map';
var ENVIRONMENTMAP = 'configmacros-env-map';
function configmacrosInit(config) {
  new SymbolMap_js_1$9.CommandMap(MACROSMAP, {}, {});
  new SymbolMap_js_1$9.EnvironmentMap(ENVIRONMENTMAP, ParseMethods_js_1$3.default.environment, {}, {});
  config.append(Configuration_js_1$b.Configuration.local({
    handler: {
      macro: [MACROSMAP],
      environment: [ENVIRONMENTMAP]
    },
    priority: 3
  }));
}
function configmacrosConfig(_config, jax) {
  configMacros(jax);
  configEnvironments(jax);
}
function configMacros(jax) {
  var e_1, _a;
  var handler = jax.parseOptions.handlers.retrieve(MACROSMAP);
  var macros = jax.parseOptions.options.macros;
  try {
    for (var _b = __values$3(Object.keys(macros)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var cs = _c.value;
      var def = typeof macros[cs] === 'string' ? [macros[cs]] : macros[cs];
      var macro = Array.isArray(def[2]) ? new Symbol_js_1$1.Macro(cs, NewcommandMethods_js_1$1.default.MacroWithTemplate, def.slice(0, 2).concat(def[2])) : new Symbol_js_1$1.Macro(cs, NewcommandMethods_js_1$1.default.Macro, def);
      handler.add(cs, macro);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}
function configEnvironments(jax) {
  var e_2, _a;
  var handler = jax.parseOptions.handlers.retrieve(ENVIRONMENTMAP);
  var environments = jax.parseOptions.options.environments;
  try {
    for (var _b = __values$3(Object.keys(environments)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var env = _c.value;
      handler.add(env, new Symbol_js_1$1.Macro(env, NewcommandMethods_js_1$1.default.BeginEnv, [true].concat(environments[env])));
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
}
ConfigMacrosConfiguration.ConfigMacrosConfiguration = Configuration_js_1$b.Configuration.create('configmacros', {
  init: configmacrosInit,
  config: configmacrosConfig,
  items: (_a$3 = {}, _a$3[NewcommandItems_js_1$1.BeginEnvItem.prototype.kind] = NewcommandItems_js_1$1.BeginEnvItem, _a$3),
  options: {
    macros: (0, Options_js_1$1.expandable)({}),
    environments: (0, Options_js_1$1.expandable)({})
  }
});

var EmpheqConfiguration = {};

(function (exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || ({
        __proto__: []
      }) instanceof Array && (function (d, b) {
        d.__proto__ = b;
      }) || (function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      });
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  var _a;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EmpheqConfiguration = exports.EmpheqMethods = exports.EmpheqBeginItem = void 0;
  var Configuration_js_1 = Configuration;
  var SymbolMap_js_1 = SymbolMap;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var TexError_js_1 = __importDefault(TexError$1);
  var BaseItems_js_1 = BaseItems;
  var EmpheqUtil_js_1 = EmpheqUtil;
  var EmpheqBeginItem = (function (_super) {
    __extends(EmpheqBeginItem, _super);
    function EmpheqBeginItem() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EmpheqBeginItem.prototype, "kind", {
      get: function () {
        return 'empheq-begin';
      },
      enumerable: false,
      configurable: true
    });
    EmpheqBeginItem.prototype.checkItem = function (item) {
      if (item.isKind('end') && item.getName() === this.getName()) {
        this.setProperty('end', false);
      }
      return _super.prototype.checkItem.call(this, item);
    };
    return EmpheqBeginItem;
  })(BaseItems_js_1.BeginItem);
  exports.EmpheqBeginItem = EmpheqBeginItem;
  exports.EmpheqMethods = {
    Empheq: function (parser, begin) {
      if (parser.stack.env.closing === begin.getName()) {
        delete parser.stack.env.closing;
        parser.Push(parser.itemFactory.create('end').setProperty('name', parser.stack.global.empheq));
        parser.stack.global.empheq = '';
        var empheq = parser.stack.Top();
        EmpheqUtil_js_1.EmpheqUtil.adjustTable(empheq, parser);
        parser.Push(parser.itemFactory.create('end').setProperty('name', 'empheq'));
      } else {
        ParseUtil_js_1.default.checkEqnEnv(parser);
        delete parser.stack.global.eqnenv;
        var opts = parser.GetBrackets('\\begin{' + begin.getName() + '}') || '';
        var _a = __read((parser.GetArgument('\\begin{' + begin.getName() + '}') || '').split(/=/), 2), env = _a[0], n = _a[1];
        if (!EmpheqUtil_js_1.EmpheqUtil.checkEnv(env)) {
          throw new TexError_js_1.default('UnknownEnv', 'Unknown environment "%1"', env);
        }
        if (opts) {
          begin.setProperties(EmpheqUtil_js_1.EmpheqUtil.splitOptions(opts, {
            left: 1,
            right: 1
          }));
        }
        parser.stack.global.empheq = env;
        parser.string = '\\begin{' + env + '}' + (n ? '{' + n + '}' : '') + parser.string.slice(parser.i);
        parser.i = 0;
        parser.Push(begin);
      }
    },
    EmpheqMO: function (parser, _name, c) {
      parser.Push(parser.create('token', 'mo', {}, c));
    },
    EmpheqDelim: function (parser, name) {
      var c = parser.GetDelimiter(name);
      parser.Push(parser.create('token', 'mo', {
        stretchy: true,
        symmetric: true
      }, c));
    }
  };
  new SymbolMap_js_1.EnvironmentMap('empheq-env', EmpheqUtil_js_1.EmpheqUtil.environment, {
    empheq: ['Empheq', 'empheq']
  }, exports.EmpheqMethods);
  new SymbolMap_js_1.CommandMap('empheq-macros', {
    empheqlbrace: ['EmpheqMO', '{'],
    empheqrbrace: ['EmpheqMO', '}'],
    empheqlbrack: ['EmpheqMO', '['],
    empheqrbrack: ['EmpheqMO', ']'],
    empheqlangle: ['EmpheqMO', '\u27E8'],
    empheqrangle: ['EmpheqMO', '\u27E9'],
    empheqlparen: ['EmpheqMO', '('],
    empheqrparen: ['EmpheqMO', ')'],
    empheqlvert: ['EmpheqMO', '|'],
    empheqrvert: ['EmpheqMO', '|'],
    empheqlVert: ['EmpheqMO', '\u2016'],
    empheqrVert: ['EmpheqMO', '\u2016'],
    empheqlfloor: ['EmpheqMO', '\u230A'],
    empheqrfloor: ['EmpheqMO', '\u230B'],
    empheqlceil: ['EmpheqMO', '\u2308'],
    empheqrceil: ['EmpheqMO', '\u2309'],
    empheqbiglbrace: ['EmpheqMO', '{'],
    empheqbigrbrace: ['EmpheqMO', '}'],
    empheqbiglbrack: ['EmpheqMO', '['],
    empheqbigrbrack: ['EmpheqMO', ']'],
    empheqbiglangle: ['EmpheqMO', '\u27E8'],
    empheqbigrangle: ['EmpheqMO', '\u27E9'],
    empheqbiglparen: ['EmpheqMO', '('],
    empheqbigrparen: ['EmpheqMO', ')'],
    empheqbiglvert: ['EmpheqMO', '|'],
    empheqbigrvert: ['EmpheqMO', '|'],
    empheqbiglVert: ['EmpheqMO', '\u2016'],
    empheqbigrVert: ['EmpheqMO', '\u2016'],
    empheqbiglfloor: ['EmpheqMO', '\u230A'],
    empheqbigrfloor: ['EmpheqMO', '\u230B'],
    empheqbiglceil: ['EmpheqMO', '\u2308'],
    empheqbigrceil: ['EmpheqMO', '\u2309'],
    empheql: 'EmpheqDelim',
    empheqr: 'EmpheqDelim',
    empheqbigl: 'EmpheqDelim',
    empheqbigr: 'EmpheqDelim'
  }, exports.EmpheqMethods);
  exports.EmpheqConfiguration = Configuration_js_1.Configuration.create('empheq', {
    handler: {
      macro: ['empheq-macros'],
      environment: ['empheq-env']
    },
    items: (_a = {}, _a[EmpheqBeginItem.prototype.kind] = EmpheqBeginItem, _a)
  });
})(EmpheqConfiguration);
getDefaultExportFromCjs(EmpheqConfiguration);

var ExtpfeilConfiguration = {};

var NewcommandConfiguration = {};

var __importDefault$f = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var NewcommandMethods_js_1 = __importDefault$f(NewcommandMethods$1);
var SymbolMap_js_1$8 = SymbolMap;
new SymbolMap_js_1$8.CommandMap('Newcommand-macros', {
  newcommand: 'NewCommand',
  renewcommand: 'NewCommand',
  newenvironment: 'NewEnvironment',
  renewenvironment: 'NewEnvironment',
  def: 'MacroDef',
  'let': 'Let'
}, NewcommandMethods_js_1.default);

var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || (("get" in desc) ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = commonjsGlobal && commonjsGlobal.__importStar || (function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
});
var __importDefault$e = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var _a$2;
Object.defineProperty(NewcommandConfiguration, "__esModule", {
  value: true
});
NewcommandConfiguration.NewcommandConfiguration = void 0;
var Configuration_js_1$a = Configuration;
var NewcommandItems_js_1 = NewcommandItems;
var NewcommandUtil_js_1 = __importDefault$e(NewcommandUtil$1);
var ParseMethods_js_1$2 = __importDefault$e(ParseMethods$1);
var sm = __importStar(SymbolMap);
var init = function (config) {
  new sm.DelimiterMap(NewcommandUtil_js_1.default.NEW_DELIMITER, ParseMethods_js_1$2.default.delimiter, {});
  new sm.CommandMap(NewcommandUtil_js_1.default.NEW_COMMAND, {}, {});
  new sm.EnvironmentMap(NewcommandUtil_js_1.default.NEW_ENVIRONMENT, ParseMethods_js_1$2.default.environment, {}, {});
  config.append(Configuration_js_1$a.Configuration.local({
    handler: {
      character: [],
      delimiter: [NewcommandUtil_js_1.default.NEW_DELIMITER],
      macro: [NewcommandUtil_js_1.default.NEW_DELIMITER, NewcommandUtil_js_1.default.NEW_COMMAND],
      environment: [NewcommandUtil_js_1.default.NEW_ENVIRONMENT]
    },
    priority: -1
  }));
};
NewcommandConfiguration.NewcommandConfiguration = Configuration_js_1$a.Configuration.create('newcommand', {
  handler: {
    macro: ['Newcommand-macros']
  },
  items: (_a$2 = {}, _a$2[NewcommandItems_js_1.BeginEnvItem.prototype.kind] = NewcommandItems_js_1.BeginEnvItem, _a$2),
  options: {
    maxMacros: 1000
  },
  init: init
});

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ExtpfeilConfiguration = exports.ExtpfeilMethods = void 0;
  var Configuration_js_1 = Configuration;
  var SymbolMap_js_1 = SymbolMap;
  var AmsMethods_js_1 = AmsMethods;
  var NewcommandUtil_js_1 = __importDefault(NewcommandUtil$1);
  var NewcommandConfiguration_js_1 = NewcommandConfiguration;
  var TexError_js_1 = __importDefault(TexError$1);
  exports.ExtpfeilMethods = {};
  exports.ExtpfeilMethods.xArrow = AmsMethods_js_1.AmsMethods.xArrow;
  exports.ExtpfeilMethods.NewExtArrow = function (parser, name) {
    var cs = parser.GetArgument(name);
    var space = parser.GetArgument(name);
    var chr = parser.GetArgument(name);
    if (!cs.match(/^\\([a-z]+|.)$/i)) {
      throw new TexError_js_1.default('NewextarrowArg1', 'First argument to %1 must be a control sequence name', name);
    }
    if (!space.match(/^(\d+),(\d+)$/)) {
      throw new TexError_js_1.default('NewextarrowArg2', 'Second argument to %1 must be two integers separated by a comma', name);
    }
    if (!chr.match(/^(\d+|0x[0-9A-F]+)$/i)) {
      throw new TexError_js_1.default('NewextarrowArg3', 'Third argument to %1 must be a unicode character number', name);
    }
    cs = cs.substr(1);
    var spaces = space.split(',');
    NewcommandUtil_js_1.default.addMacro(parser, cs, exports.ExtpfeilMethods.xArrow, [parseInt(chr), parseInt(spaces[0]), parseInt(spaces[1])]);
  };
  new SymbolMap_js_1.CommandMap('extpfeil', {
    xtwoheadrightarrow: ['xArrow', 0x21A0, 12, 16],
    xtwoheadleftarrow: ['xArrow', 0x219E, 17, 13],
    xmapsto: ['xArrow', 0x21A6, 6, 7],
    xlongequal: ['xArrow', 0x003D, 7, 7],
    xtofrom: ['xArrow', 0x21C4, 12, 12],
    Newextarrow: 'NewExtArrow'
  }, exports.ExtpfeilMethods);
  var init = function (config) {
    NewcommandConfiguration_js_1.NewcommandConfiguration.init(config);
  };
  exports.ExtpfeilConfiguration = Configuration_js_1.Configuration.create('extpfeil', {
    handler: {
      macro: ['extpfeil']
    },
    init: init
  });
})(ExtpfeilConfiguration);
getDefaultExportFromCjs(ExtpfeilConfiguration);

var GensymbConfiguration = {};

Object.defineProperty(GensymbConfiguration, "__esModule", {
  value: true
});
GensymbConfiguration.GensymbConfiguration = void 0;
var Configuration_js_1$9 = Configuration;
var TexConstants_js_1$6 = TexConstants;
var SymbolMap_js_1$7 = SymbolMap;
function mathcharUnit(parser, mchar) {
  var def = mchar.attributes || ({});
  def.mathvariant = TexConstants_js_1$6.TexConstant.Variant.NORMAL;
  def.class = 'MathML-Unit';
  var node = parser.create('token', 'mi', def, mchar.char);
  parser.Push(node);
}
new SymbolMap_js_1$7.CharacterMap('gensymb-symbols', mathcharUnit, {
  ohm: '\u2126',
  degree: '\u00B0',
  celsius: '\u2103',
  perthousand: '\u2030',
  micro: '\u00B5'
});
GensymbConfiguration.GensymbConfiguration = Configuration_js_1$9.Configuration.create('gensymb', {
  handler: {
    macro: ['gensymb-symbols']
  }
});

var HtmlConfiguration = {};

var HtmlMethods$1 = {};

var __importDefault$d = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(HtmlMethods$1, "__esModule", {
  value: true
});
var NodeUtil_js_1$4 = __importDefault$d(NodeUtil$1);
var HtmlMethods = {};
HtmlMethods.Href = function (parser, name) {
  var url = parser.GetArgument(name);
  var arg = GetArgumentMML(parser, name);
  NodeUtil_js_1$4.default.setAttribute(arg, 'href', url);
  parser.Push(arg);
};
HtmlMethods.Class = function (parser, name) {
  var CLASS = parser.GetArgument(name);
  var arg = GetArgumentMML(parser, name);
  var oldClass = NodeUtil_js_1$4.default.getAttribute(arg, 'class');
  if (oldClass) {
    CLASS = oldClass + ' ' + CLASS;
  }
  NodeUtil_js_1$4.default.setAttribute(arg, 'class', CLASS);
  parser.Push(arg);
};
HtmlMethods.Style = function (parser, name) {
  var style = parser.GetArgument(name);
  var arg = GetArgumentMML(parser, name);
  var oldStyle = NodeUtil_js_1$4.default.getAttribute(arg, 'style');
  if (oldStyle) {
    if (style.charAt(style.length - 1) !== ';') {
      style += ';';
    }
    style = oldStyle + ' ' + style;
  }
  NodeUtil_js_1$4.default.setAttribute(arg, 'style', style);
  parser.Push(arg);
};
HtmlMethods.Id = function (parser, name) {
  var ID = parser.GetArgument(name);
  var arg = GetArgumentMML(parser, name);
  NodeUtil_js_1$4.default.setAttribute(arg, 'id', ID);
  parser.Push(arg);
};
var GetArgumentMML = function (parser, name) {
  var arg = parser.ParseArg(name);
  if (!NodeUtil_js_1$4.default.isInferred(arg)) {
    return arg;
  }
  var children = NodeUtil_js_1$4.default.getChildren(arg);
  if (children.length === 1) {
    return children[0];
  }
  var mrow = parser.create('node', 'mrow');
  NodeUtil_js_1$4.default.copyChildren(arg, mrow);
  NodeUtil_js_1$4.default.copyAttributes(arg, mrow);
  return mrow;
};
HtmlMethods$1.default = HtmlMethods;

var __importDefault$c = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(HtmlConfiguration, "__esModule", {
  value: true
});
HtmlConfiguration.HtmlConfiguration = void 0;
var Configuration_js_1$8 = Configuration;
var SymbolMap_js_1$6 = SymbolMap;
var HtmlMethods_js_1 = __importDefault$c(HtmlMethods$1);
new SymbolMap_js_1$6.CommandMap('html_macros', {
  href: 'Href',
  'class': 'Class',
  style: 'Style',
  cssId: 'Id'
}, HtmlMethods_js_1.default);
HtmlConfiguration.HtmlConfiguration = Configuration_js_1$8.Configuration.create('html', {
  handler: {
    macro: ['html_macros']
  }
});

var MathtoolsConfiguration = {};

var MathtoolsMethods = {};

var MathtoolsUtil = {};

var __read$3 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __importDefault$b = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(MathtoolsUtil, "__esModule", {
  value: true
});
MathtoolsUtil.MathtoolsUtil = void 0;
var BaseItems_js_1$2 = BaseItems;
var ParseUtil_js_1$4 = __importDefault$b(ParseUtil$1);
var TexParser_js_1$4 = __importDefault$b(TexParser$1);
var TexError_js_1$4 = __importDefault$b(TexError$1);
var Symbol_js_1 = _Symbol;
var Options_js_1 = Options;
var MathtoolsMethods_js_1$1 = MathtoolsMethods;
var MathtoolsConfiguration_js_1 = MathtoolsConfiguration;
MathtoolsUtil.MathtoolsUtil = {
  setDisplayLevel: function (mml, style) {
    if (!style) return;
    var _a = __read$3((0, Options_js_1.lookup)(style, {
      '\\displaystyle': [true, 0],
      '\\textstyle': [false, 0],
      '\\scriptstyle': [false, 1],
      '\\scriptscriptstyle': [false, 2]
    }, [null, null]), 2), display = _a[0], script = _a[1];
    if (display !== null) {
      mml.attributes.set('displaystyle', display);
      mml.attributes.set('scriptlevel', script);
    }
  },
  checkAlignment: function (parser, name) {
    var top = parser.stack.Top();
    if (top.kind !== BaseItems_js_1$2.EqnArrayItem.prototype.kind) {
      throw new TexError_js_1$4.default('NotInAlignment', '%1 can only be used in aligment environments', name);
    }
    return top;
  },
  addPairedDelims: function (config, cs, args) {
    var delims = config.handlers.retrieve(MathtoolsConfiguration_js_1.PAIREDDELIMS);
    delims.add(cs, new Symbol_js_1.Macro(cs, MathtoolsMethods_js_1$1.MathtoolsMethods.PairedDelimiters, args));
  },
  spreadLines: function (mtable, spread) {
    if (!mtable.isKind('mtable')) return;
    var rowspacing = mtable.attributes.get('rowspacing');
    if (rowspacing) {
      var add_1 = ParseUtil_js_1$4.default.dimen2em(spread);
      rowspacing = rowspacing.split(/ /).map(function (s) {
        return ParseUtil_js_1$4.default.Em(Math.max(0, ParseUtil_js_1$4.default.dimen2em(s) + add_1));
      }).join(' ');
    } else {
      rowspacing = spread;
    }
    mtable.attributes.set('rowspacing', rowspacing);
  },
  plusOrMinus: function (name, n) {
    n = n.trim();
    if (!n.match(/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)$/)) {
      throw new TexError_js_1$4.default('NotANumber', 'Argument to %1 is not a number', name);
    }
    return n.match(/^[-+]/) ? n : '+' + n;
  },
  getScript: function (parser, name, pos) {
    var arg = ParseUtil_js_1$4.default.trimSpaces(parser.GetArgument(name));
    if (arg === '') {
      return parser.create('node', 'none');
    }
    var format = parser.options.mathtools[("prescript-").concat(pos, "-format")];
    format && (arg = ("").concat(format, "{").concat(arg, "}"));
    return new TexParser_js_1$4.default(arg, parser.stack.env, parser.configuration).mml();
  }
};

(function (exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || (function () {
    __assign = Object.assign || (function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    });
    return __assign.apply(this, arguments);
  });
  var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  });
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MathtoolsMethods = void 0;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var AmsMethods_js_1 = AmsMethods;
  var BaseMethods_js_1 = __importDefault(BaseMethods$1);
  var TexParser_js_1 = __importDefault(TexParser$1);
  var TexError_js_1 = __importDefault(TexError$1);
  var NodeUtil_js_1 = __importDefault(NodeUtil$1);
  var MmlNode_js_1 = MmlNode;
  var lengths_js_1 = lengths;
  var Options_js_1 = Options;
  var NewcommandUtil_js_1 = __importDefault(NewcommandUtil$1);
  var NewcommandMethods_js_1 = __importDefault(NewcommandMethods$1);
  var MathtoolsUtil_js_1 = MathtoolsUtil;
  exports.MathtoolsMethods = {
    MtMatrix: function (parser, begin, open, close) {
      var align = parser.GetBrackets(("\\begin{").concat(begin.getName(), "}"), 'c');
      return exports.MathtoolsMethods.Array(parser, begin, open, close, align);
    },
    MtSmallMatrix: function (parser, begin, open, close, align) {
      if (!align) {
        align = parser.GetBrackets(("\\begin{").concat(begin.getName(), "}"), parser.options.mathtools['smallmatrix-align']);
      }
      return exports.MathtoolsMethods.Array(parser, begin, open, close, align, ParseUtil_js_1.default.Em(1 / 3), '.2em', 'S', 1);
    },
    MtMultlined: function (parser, begin) {
      var _a;
      var name = ("\\begin{").concat(begin.getName(), "}");
      var pos = parser.GetBrackets(name, parser.options.mathtools['multlined-pos'] || 'c');
      var width = pos ? parser.GetBrackets(name, '') : '';
      if (pos && !pos.match(/^[cbt]$/)) {
        (_a = __read([pos, width], 2), width = _a[0], pos = _a[1]);
      }
      parser.Push(begin);
      var item = parser.itemFactory.create('multlined', parser, begin);
      item.arraydef = {
        displaystyle: true,
        rowspacing: '.5em',
        width: width || 'auto',
        columnwidth: '100%'
      };
      return ParseUtil_js_1.default.setArrayAlign(item, pos || 'c');
    },
    HandleShove: function (parser, name, shove) {
      var top = parser.stack.Top();
      if (top.kind !== 'multline' && top.kind !== 'multlined') {
        throw new TexError_js_1.default('CommandInMultlined', '%1 can only appear within the multline or multlined environments', name);
      }
      if (top.Size()) {
        throw new TexError_js_1.default('CommandAtTheBeginingOfLine', '%1 must come at the beginning of the line', name);
      }
      top.setProperty('shove', shove);
      var shift = parser.GetBrackets(name);
      var mml = parser.ParseArg(name);
      if (shift) {
        var mrow = parser.create('node', 'mrow', []);
        var mspace = parser.create('node', 'mspace', [], {
          width: shift
        });
        if (shove === 'left') {
          mrow.appendChild(mspace);
          mrow.appendChild(mml);
        } else {
          mrow.appendChild(mml);
          mrow.appendChild(mspace);
        }
        mml = mrow;
      }
      parser.Push(mml);
    },
    SpreadLines: function (parser, begin) {
      var e_1, _a;
      if (parser.stack.env.closing === begin.getName()) {
        delete parser.stack.env.closing;
        var top_1 = parser.stack.Pop();
        var mml = top_1.toMml();
        var spread = top_1.getProperty('spread');
        if (mml.isInferred) {
          try {
            for (var _b = __values(NodeUtil_js_1.default.getChildren(mml)), _c = _b.next(); !_c.done; _c = _b.next()) {
              var child = _c.value;
              MathtoolsUtil_js_1.MathtoolsUtil.spreadLines(child, spread);
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          MathtoolsUtil_js_1.MathtoolsUtil.spreadLines(mml, spread);
        }
        parser.Push(mml);
      } else {
        var spread = parser.GetDimen(("\\begin{").concat(begin.getName(), "}"));
        begin.setProperty('spread', spread);
        parser.Push(begin);
      }
    },
    Cases: function (parser, begin, open, close, style) {
      var array = parser.itemFactory.create('array').setProperty('casesEnv', begin.getName());
      array.arraydef = {
        rowspacing: '.2em',
        columnspacing: '1em',
        columnalign: 'left'
      };
      if (style === 'D') {
        array.arraydef.displaystyle = true;
      }
      array.setProperties({
        open: open,
        close: close
      });
      parser.Push(begin);
      return array;
    },
    MathLap: function (parser, name, pos, cramped) {
      var style = parser.GetBrackets(name, '').trim();
      var mml = parser.create('node', 'mstyle', [parser.create('node', 'mpadded', [parser.ParseArg(name)], __assign({
        width: 0
      }, pos === 'r' ? {} : {
        lspace: pos === 'l' ? '-1width' : '-.5width'
      }))], {
        'data-cramped': cramped
      });
      MathtoolsUtil_js_1.MathtoolsUtil.setDisplayLevel(mml, style);
      parser.Push(parser.create('node', 'TeXAtom', [mml]));
    },
    Cramped: function (parser, name) {
      var style = parser.GetBrackets(name, '').trim();
      var arg = parser.ParseArg(name);
      var mml = parser.create('node', 'mstyle', [arg], {
        'data-cramped': true
      });
      MathtoolsUtil_js_1.MathtoolsUtil.setDisplayLevel(mml, style);
      parser.Push(mml);
    },
    MtLap: function (parser, name, pos) {
      var content = ParseUtil_js_1.default.internalMath(parser, parser.GetArgument(name), 0);
      var mml = parser.create('node', 'mpadded', content, {
        width: 0
      });
      if (pos !== 'r') {
        NodeUtil_js_1.default.setAttribute(mml, 'lspace', pos === 'l' ? '-1width' : '-.5width');
      }
      parser.Push(mml);
    },
    MathMakeBox: function (parser, name) {
      var width = parser.GetBrackets(name);
      var pos = parser.GetBrackets(name, 'c');
      var mml = parser.create('node', 'mpadded', [parser.ParseArg(name)]);
      if (width) {
        NodeUtil_js_1.default.setAttribute(mml, 'width', width);
      }
      var align = (0, Options_js_1.lookup)(pos, {
        c: 'center',
        r: 'right'
      }, '');
      if (align) {
        NodeUtil_js_1.default.setAttribute(mml, 'data-align', align);
      }
      parser.Push(mml);
    },
    MathMBox: function (parser, name) {
      parser.Push(parser.create('node', 'mrow', [parser.ParseArg(name)]));
    },
    UnderOverBracket: function (parser, name) {
      var thickness = (0, lengths_js_1.length2em)(parser.GetBrackets(name, '.1em'), .1);
      var height = parser.GetBrackets(name, '.2em');
      var arg = parser.GetArgument(name);
      var _a = __read(name.charAt(1) === 'o' ? ['over', 'accent', 'bottom'] : ['under', 'accentunder', 'top'], 3), pos = _a[0], accent = _a[1], border = _a[2];
      var t = (0, lengths_js_1.em)(thickness);
      var base = new TexParser_js_1.default(arg, parser.stack.env, parser.configuration).mml();
      var copy = new TexParser_js_1.default(arg, parser.stack.env, parser.configuration).mml();
      var script = parser.create('node', 'mpadded', [parser.create('node', 'mphantom', [copy])], {
        style: ("border: ").concat(t, " solid; border-").concat(border, ": none"),
        height: height,
        depth: 0
      });
      var node = ParseUtil_js_1.default.underOver(parser, base, script, pos, true);
      var munderover = NodeUtil_js_1.default.getChildAt(NodeUtil_js_1.default.getChildAt(node, 0), 0);
      NodeUtil_js_1.default.setAttribute(munderover, accent, true);
      parser.Push(node);
    },
    Aboxed: function (parser, name) {
      var top = MathtoolsUtil_js_1.MathtoolsUtil.checkAlignment(parser, name);
      if (top.row.length % 2 === 1) {
        top.row.push(parser.create('node', 'mtd', []));
      }
      var arg = parser.GetArgument(name);
      var rest = parser.string.substr(parser.i);
      parser.string = arg + '&&\\endAboxed';
      parser.i = 0;
      var left = parser.GetUpTo(name, '&');
      var right = parser.GetUpTo(name, '&');
      parser.GetUpTo(name, '\\endAboxed');
      var tex = ParseUtil_js_1.default.substituteArgs(parser, [left, right], '\\rlap{\\boxed{#1{}#2}}\\kern.267em\\phantom{#1}&\\phantom{{}#2}\\kern.267em');
      parser.string = tex + rest;
      parser.i = 0;
    },
    ArrowBetweenLines: function (parser, name) {
      var top = MathtoolsUtil_js_1.MathtoolsUtil.checkAlignment(parser, name);
      if (top.Size() || top.row.length) {
        throw new TexError_js_1.default('BetweenLines', '%1 must be on a row by itself', name);
      }
      var star = parser.GetStar();
      var symbol = parser.GetBrackets(name, '\\Updownarrow');
      if (star) {
        top.EndEntry();
        top.EndEntry();
      }
      var tex = star ? '\\quad' + symbol : symbol + '\\quad';
      var mml = new TexParser_js_1.default(tex, parser.stack.env, parser.configuration).mml();
      parser.Push(mml);
      top.EndEntry();
      top.EndRow();
    },
    VDotsWithin: function (parser, name) {
      var top = parser.stack.Top();
      var isFlush = top.getProperty('flushspaceabove') === top.table.length;
      var arg = '\\mmlToken{mi}{}' + parser.GetArgument(name) + '\\mmlToken{mi}{}';
      var base = new TexParser_js_1.default(arg, parser.stack.env, parser.configuration).mml();
      var mml = parser.create('node', 'mpadded', [parser.create('node', 'mpadded', [parser.create('node', 'mo', [parser.create('text', '\u22EE')])], __assign({
        width: 0,
        lspace: '-.5width'
      }, isFlush ? {
        height: '-.6em',
        voffset: '-.18em'
      } : {})), parser.create('node', 'mphantom', [base])], {
        lspace: '.5width'
      });
      parser.Push(mml);
    },
    ShortVDotsWithin: function (parser, _name) {
      var top = parser.stack.Top();
      var star = parser.GetStar();
      exports.MathtoolsMethods.FlushSpaceAbove(parser, '\\MTFlushSpaceAbove');
      !star && top.EndEntry();
      exports.MathtoolsMethods.VDotsWithin(parser, '\\vdotswithin');
      star && top.EndEntry();
      exports.MathtoolsMethods.FlushSpaceBelow(parser, '\\MTFlushSpaceBelow');
    },
    FlushSpaceAbove: function (parser, name) {
      var top = MathtoolsUtil_js_1.MathtoolsUtil.checkAlignment(parser, name);
      top.setProperty('flushspaceabove', top.table.length);
      top.addRowSpacing('-' + parser.options.mathtools['shortvdotsadjustabove']);
    },
    FlushSpaceBelow: function (parser, name) {
      var top = MathtoolsUtil_js_1.MathtoolsUtil.checkAlignment(parser, name);
      top.Size() && top.EndEntry();
      top.EndRow();
      top.addRowSpacing('-' + parser.options.mathtools['shortvdotsadjustbelow']);
    },
    PairedDelimiters: function (parser, name, open, close, body, n, pre, post) {
      if (body === void 0) {
        body = '#1';
      }
      if (n === void 0) {
        n = 1;
      }
      if (pre === void 0) {
        pre = '';
      }
      if (post === void 0) {
        post = '';
      }
      var star = parser.GetStar();
      var size = star ? '' : parser.GetBrackets(name);
      var _a = __read(star ? ['\\left', '\\right'] : size ? [size + 'l', size + 'r'] : ['', ''], 2), left = _a[0], right = _a[1];
      var delim = star ? '\\middle' : size || '';
      if (n) {
        var args = [];
        for (var i = args.length; i < n; i++) {
          args.push(parser.GetArgument(name));
        }
        pre = ParseUtil_js_1.default.substituteArgs(parser, args, pre);
        body = ParseUtil_js_1.default.substituteArgs(parser, args, body);
        post = ParseUtil_js_1.default.substituteArgs(parser, args, post);
      }
      body = body.replace(/\\delimsize/g, delim);
      parser.string = [pre, left, open, body, right, close, post, parser.string.substr(parser.i)].reduce(function (s, part) {
        return ParseUtil_js_1.default.addArgs(parser, s, part);
      }, '');
      parser.i = 0;
      ParseUtil_js_1.default.checkMaxMacros(parser);
    },
    DeclarePairedDelimiter: function (parser, name) {
      var cs = NewcommandUtil_js_1.default.GetCsNameArgument(parser, name);
      var open = parser.GetArgument(name);
      var close = parser.GetArgument(name);
      MathtoolsUtil_js_1.MathtoolsUtil.addPairedDelims(parser.configuration, cs, [open, close]);
    },
    DeclarePairedDelimiterX: function (parser, name) {
      var cs = NewcommandUtil_js_1.default.GetCsNameArgument(parser, name);
      var n = NewcommandUtil_js_1.default.GetArgCount(parser, name);
      var open = parser.GetArgument(name);
      var close = parser.GetArgument(name);
      var body = parser.GetArgument(name);
      MathtoolsUtil_js_1.MathtoolsUtil.addPairedDelims(parser.configuration, cs, [open, close, body, n]);
    },
    DeclarePairedDelimiterXPP: function (parser, name) {
      var cs = NewcommandUtil_js_1.default.GetCsNameArgument(parser, name);
      var n = NewcommandUtil_js_1.default.GetArgCount(parser, name);
      var pre = parser.GetArgument(name);
      var open = parser.GetArgument(name);
      var close = parser.GetArgument(name);
      var post = parser.GetArgument(name);
      var body = parser.GetArgument(name);
      MathtoolsUtil_js_1.MathtoolsUtil.addPairedDelims(parser.configuration, cs, [open, close, body, n, pre, post]);
    },
    CenterColon: function (parser, _name, center, force, thin) {
      if (force === void 0) {
        force = false;
      }
      if (thin === void 0) {
        thin = false;
      }
      var options = parser.options.mathtools;
      var mml = parser.create('token', 'mo', {}, ':');
      if (center && (options['centercolon'] || force)) {
        var dy = options['centercolon-offset'];
        mml = parser.create('node', 'mpadded', [mml], __assign({
          voffset: dy,
          height: ("+").concat(dy),
          depth: ("-").concat(dy)
        }, thin ? {
          width: options['thincolon-dw'],
          lspace: options['thincolon-dx']
        } : {}));
      }
      parser.Push(mml);
    },
    Relation: function (parser, _name, tex, unicode) {
      var options = parser.options.mathtools;
      if (options['use-unicode'] && unicode) {
        parser.Push(parser.create('token', 'mo', {
          texClass: MmlNode_js_1.TEXCLASS.REL
        }, unicode));
      } else {
        tex = '\\mathrel{' + tex.replace(/:/g, '\\MTThinColon').replace(/-/g, '\\mathrel{-}') + '}';
        parser.string = ParseUtil_js_1.default.addArgs(parser, tex, parser.string.substr(parser.i));
        parser.i = 0;
      }
    },
    NArrow: function (parser, _name, c, dy) {
      parser.Push(parser.create('node', 'TeXAtom', [parser.create('token', 'mtext', {}, c), parser.create('node', 'mpadded', [parser.create('node', 'mpadded', [parser.create('node', 'menclose', [parser.create('node', 'mspace', [], {
        height: '.2em',
        depth: 0,
        width: '.4em'
      })], {
        notation: 'updiagonalstrike',
        'data-thickness': '.05em',
        'data-padding': 0
      })], {
        width: 0,
        lspace: '-.5width',
        voffset: dy
      }), parser.create('node', 'mphantom', [parser.create('token', 'mtext', {}, c)])], {
        width: 0,
        lspace: '-.5width'
      })], {
        texClass: MmlNode_js_1.TEXCLASS.REL
      }));
    },
    SplitFrac: function (parser, name, display) {
      var num = parser.ParseArg(name);
      var den = parser.ParseArg(name);
      parser.Push(parser.create('node', 'mstyle', [parser.create('node', 'mfrac', [parser.create('node', 'mstyle', [num, parser.create('token', 'mi'), parser.create('token', 'mspace', {
        width: '1em'
      })], {
        scriptlevel: 0
      }), parser.create('node', 'mstyle', [parser.create('token', 'mspace', {
        width: '1em'
      }), parser.create('token', 'mi'), den], {
        scriptlevel: 0
      })], {
        linethickness: 0,
        numalign: 'left',
        denomalign: 'right'
      })], {
        displaystyle: display,
        scriptlevel: 0
      }));
    },
    XMathStrut: function (parser, name) {
      var dd = parser.GetBrackets(name);
      var dh = parser.GetArgument(name);
      dh = MathtoolsUtil_js_1.MathtoolsUtil.plusOrMinus(name, dh);
      dd = MathtoolsUtil_js_1.MathtoolsUtil.plusOrMinus(name, dd || dh);
      parser.Push(parser.create('node', 'TeXAtom', [parser.create('node', 'mpadded', [parser.create('node', 'mphantom', [parser.create('token', 'mo', {
        stretchy: false
      }, '(')])], {
        width: 0,
        height: dh + 'height',
        depth: dd + 'depth'
      })], {
        texClass: MmlNode_js_1.TEXCLASS.ORD
      }));
    },
    Prescript: function (parser, name) {
      var sup = MathtoolsUtil_js_1.MathtoolsUtil.getScript(parser, name, 'sup');
      var sub = MathtoolsUtil_js_1.MathtoolsUtil.getScript(parser, name, 'sub');
      var base = MathtoolsUtil_js_1.MathtoolsUtil.getScript(parser, name, 'arg');
      if (NodeUtil_js_1.default.isType(sup, 'none') && NodeUtil_js_1.default.isType(sub, 'none')) {
        parser.Push(base);
        return;
      }
      var mml = parser.create('node', 'mmultiscripts', [base]);
      NodeUtil_js_1.default.getChildren(mml).push(null, null);
      NodeUtil_js_1.default.appendChildren(mml, [parser.create('node', 'mprescripts'), sub, sup]);
      mml.setProperty('fixPrescript', true);
      parser.Push(mml);
    },
    NewTagForm: function (parser, name, renew) {
      if (renew === void 0) {
        renew = false;
      }
      var tags = parser.tags;
      if (!(('mtFormats' in tags))) {
        throw new TexError_js_1.default('TagsNotMT', '%1 can only be used with ams or mathtools tags', name);
      }
      var id = parser.GetArgument(name).trim();
      if (!id) {
        throw new TexError_js_1.default('InvalidTagFormID', 'Tag form name can\'t be empty');
      }
      var format = parser.GetBrackets(name, '');
      var left = parser.GetArgument(name);
      var right = parser.GetArgument(name);
      if (!renew && tags.mtFormats.has(id)) {
        throw new TexError_js_1.default('DuplicateTagForm', 'Duplicate tag form: %1', id);
      }
      tags.mtFormats.set(id, [left, right, format]);
    },
    UseTagForm: function (parser, name) {
      var tags = parser.tags;
      if (!(('mtFormats' in tags))) {
        throw new TexError_js_1.default('TagsNotMT', '%1 can only be used with ams or mathtools tags', name);
      }
      var id = parser.GetArgument(name).trim();
      if (!id) {
        tags.mtCurrent = null;
        return;
      }
      if (!tags.mtFormats.has(id)) {
        throw new TexError_js_1.default('UndefinedTagForm', 'Undefined tag form: %1', id);
      }
      tags.mtCurrent = tags.mtFormats.get(id);
    },
    SetOptions: function (parser, name) {
      var e_2, _a;
      var options = parser.options.mathtools;
      if (!options['allow-mathtoolsset']) {
        throw new TexError_js_1.default('ForbiddenMathtoolsSet', '%1 is disabled', name);
      }
      var allowed = {};
      Object.keys(options).forEach(function (id) {
        if (id !== 'pariedDelimiters' && id !== 'tagforms' && id !== 'allow-mathtoolsset') {
          allowed[id] = 1;
        }
      });
      var args = parser.GetArgument(name);
      var keys = ParseUtil_js_1.default.keyvalOptions(args, allowed, true);
      try {
        for (var _b = __values(Object.keys(keys)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var id = _c.value;
          options[id] = keys[id];
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    },
    Array: BaseMethods_js_1.default.Array,
    Macro: BaseMethods_js_1.default.Macro,
    xArrow: AmsMethods_js_1.AmsMethods.xArrow,
    HandleRef: AmsMethods_js_1.AmsMethods.HandleRef,
    AmsEqnArray: AmsMethods_js_1.AmsMethods.AmsEqnArray,
    MacroWithTemplate: NewcommandMethods_js_1.default.MacroWithTemplate
  };
})(MathtoolsMethods);
getDefaultExportFromCjs(MathtoolsMethods);

var __importDefault$a = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var ParseMethods_js_1$1 = __importDefault$a(ParseMethods$1);
var SymbolMap_js_1$5 = SymbolMap;
var TexConstants_js_1$5 = TexConstants;
var MathtoolsMethods_js_1 = MathtoolsMethods;
new SymbolMap_js_1$5.CommandMap('mathtools-macros', {
  shoveleft: ['HandleShove', TexConstants_js_1$5.TexConstant.Align.LEFT],
  shoveright: ['HandleShove', TexConstants_js_1$5.TexConstant.Align.RIGHT],
  xleftrightarrow: ['xArrow', 0x2194, 10, 10],
  xLeftarrow: ['xArrow', 0x21D0, 12, 7],
  xRightarrow: ['xArrow', 0x21D2, 7, 12],
  xLeftrightarrow: ['xArrow', 0x21D4, 12, 12],
  xhookleftarrow: ['xArrow', 0x21A9, 10, 5],
  xhookrightarrow: ['xArrow', 0x21AA, 5, 10],
  xmapsto: ['xArrow', 0x21A6, 10, 10],
  xrightharpoondown: ['xArrow', 0x21C1, 5, 10],
  xleftharpoondown: ['xArrow', 0x21BD, 10, 5],
  xrightleftharpoons: ['xArrow', 0x21CC, 10, 10],
  xrightharpoonup: ['xArrow', 0x21C0, 5, 10],
  xleftharpoonup: ['xArrow', 0x21BC, 10, 5],
  xleftrightharpoons: ['xArrow', 0x21CB, 10, 10],
  mathllap: ['MathLap', 'l', false],
  mathrlap: ['MathLap', 'r', false],
  mathclap: ['MathLap', 'c', false],
  clap: ['MtLap', 'c'],
  textllap: ['MtLap', 'l'],
  textrlap: ['MtLap', 'r'],
  textclap: ['MtLap', 'c'],
  cramped: 'Cramped',
  crampedllap: ['MathLap', 'l', true],
  crampedrlap: ['MathLap', 'r', true],
  crampedclap: ['MathLap', 'c', true],
  crampedsubstack: ['Macro', '\\begin{crampedsubarray}{c}#1\\end{crampedsubarray}', 1],
  mathmbox: 'MathMBox',
  mathmakebox: 'MathMakeBox',
  overbracket: 'UnderOverBracket',
  underbracket: 'UnderOverBracket',
  refeq: 'HandleRef',
  MoveEqLeft: ['Macro', '\\hspace{#1em}&\\hspace{-#1em}', 1, '2'],
  Aboxed: 'Aboxed',
  ArrowBetweenLines: 'ArrowBetweenLines',
  vdotswithin: 'VDotsWithin',
  shortvdotswithin: 'ShortVDotsWithin',
  MTFlushSpaceAbove: 'FlushSpaceAbove',
  MTFlushSpaceBelow: 'FlushSpaceBelow',
  DeclarePairedDelimiter: 'DeclarePairedDelimiter',
  DeclarePairedDelimiterX: 'DeclarePairedDelimiterX',
  DeclarePairedDelimiterXPP: 'DeclarePairedDelimiterXPP',
  DeclarePairedDelimiters: 'DeclarePairedDelimiter',
  DeclarePairedDelimitersX: 'DeclarePairedDelimiterX',
  DeclarePairedDelimitersXPP: 'DeclarePairedDelimiterXPP',
  centercolon: ['CenterColon', true, true],
  ordinarycolon: ['CenterColon', false],
  MTThinColon: ['CenterColon', true, true, true],
  coloneqq: ['Relation', ':=', '\u2254'],
  Coloneqq: ['Relation', '::=', '\u2A74'],
  coloneq: ['Relation', ':-'],
  Coloneq: ['Relation', '::-'],
  eqqcolon: ['Relation', '=:', '\u2255'],
  Eqqcolon: ['Relation', '=::'],
  eqcolon: ['Relation', '-:', '\u2239'],
  Eqcolon: ['Relation', '-::'],
  colonapprox: ['Relation', ':\\approx'],
  Colonapprox: ['Relation', '::\\approx'],
  colonsim: ['Relation', ':\\sim'],
  Colonsim: ['Relation', '::\\sim'],
  dblcolon: ['Relation', '::', '\u2237'],
  nuparrow: ['NArrow', '\u2191', '.06em'],
  ndownarrow: ['NArrow', '\u2193', '.25em'],
  bigtimes: ['Macro', '\\mathop{\\Large\\kern-.1em\\boldsymbol{\\times}\\kern-.1em}'],
  splitfrac: ['SplitFrac', false],
  splitdfrac: ['SplitFrac', true],
  xmathstrut: 'XMathStrut',
  prescript: 'Prescript',
  newtagform: ['NewTagForm', false],
  renewtagform: ['NewTagForm', true],
  usetagform: 'UseTagForm',
  adjustlimits: ['MacroWithTemplate', '\\mathop{{#1}\\vphantom{{#3}}}_{{#2}\\vphantom{{#4}}}\\mathop{{#3}\\vphantom{{#1}}}_{{#4}\\vphantom{{#2}}}', 4, , '_', , '_'],
  mathtoolsset: 'SetOptions'
}, MathtoolsMethods_js_1.MathtoolsMethods);
new SymbolMap_js_1$5.EnvironmentMap('mathtools-environments', ParseMethods_js_1$1.default.environment, {
  dcases: ['Array', null, '\\{', '', 'll', null, '.2em', 'D'],
  rcases: ['Array', null, '', '\\}', 'll', null, '.2em'],
  drcases: ['Array', null, '', '\\}', 'll', null, '.2em', 'D'],
  'dcases*': ['Cases', null, '{', '', 'D'],
  'rcases*': ['Cases', null, '', '}'],
  'drcases*': ['Cases', null, '', '}', 'D'],
  'cases*': ['Cases', null, '{', ''],
  'matrix*': ['MtMatrix', null, null, null],
  'pmatrix*': ['MtMatrix', null, '(', ')'],
  'bmatrix*': ['MtMatrix', null, '[', ']'],
  'Bmatrix*': ['MtMatrix', null, '\\{', '\\}'],
  'vmatrix*': ['MtMatrix', null, '\\vert', '\\vert'],
  'Vmatrix*': ['MtMatrix', null, '\\Vert', '\\Vert'],
  'smallmatrix*': ['MtSmallMatrix', null, null, null],
  psmallmatrix: ['MtSmallMatrix', null, '(', ')', 'c'],
  'psmallmatrix*': ['MtSmallMatrix', null, '(', ')'],
  bsmallmatrix: ['MtSmallMatrix', null, '[', ']', 'c'],
  'bsmallmatrix*': ['MtSmallMatrix', null, '[', ']'],
  Bsmallmatrix: ['MtSmallMatrix', null, '\\{', '\\}', 'c'],
  'Bsmallmatrix*': ['MtSmallMatrix', null, '\\{', '\\}'],
  vsmallmatrix: ['MtSmallMatrix', null, '\\vert', '\\vert', 'c'],
  'vsmallmatrix*': ['MtSmallMatrix', null, '\\vert', '\\vert'],
  Vsmallmatrix: ['MtSmallMatrix', null, '\\Vert', '\\Vert', 'c'],
  'Vsmallmatrix*': ['MtSmallMatrix', null, '\\Vert', '\\Vert'],
  crampedsubarray: ['Array', null, null, null, null, '0em', '0.1em', 'S\'', 1],
  multlined: 'MtMultlined',
  spreadlines: ['SpreadLines', true],
  lgathered: ['AmsEqnArray', null, null, null, 'l', null, '.5em', 'D'],
  rgathered: ['AmsEqnArray', null, null, null, 'r', null, '.5em', 'D']
}, MathtoolsMethods_js_1.MathtoolsMethods);
new SymbolMap_js_1$5.DelimiterMap('mathtools-delimiters', ParseMethods_js_1$1.default.delimiter, {
  '\\lparen': '(',
  '\\rparen': ')'
});
new SymbolMap_js_1$5.CommandMap('mathtools-characters', {
  ':': ['CenterColon', true]
}, MathtoolsMethods_js_1.MathtoolsMethods);

var MathtoolsTags = {};

var __extends$4 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values$2 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read$2 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __importDefault$9 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(MathtoolsTags, "__esModule", {
  value: true
});
MathtoolsTags.MathtoolsTagFormat = void 0;
var TexError_js_1$3 = __importDefault$9(TexError$1);
var Tags_js_1$2 = Tags;
var tagID$1 = 0;
function MathtoolsTagFormat(config, jax) {
  var tags = jax.parseOptions.options.tags;
  if (tags !== 'base' && config.tags.hasOwnProperty(tags)) {
    Tags_js_1$2.TagsFactory.add(tags, config.tags[tags]);
  }
  var TagClass = Tags_js_1$2.TagsFactory.create(jax.parseOptions.options.tags).constructor;
  var TagFormat = (function (_super) {
    __extends$4(TagFormat, _super);
    function TagFormat() {
      var e_1, _a;
      var _this = _super.call(this) || this;
      _this.mtFormats = new Map();
      _this.mtCurrent = null;
      var forms = jax.parseOptions.options.mathtools.tagforms;
      try {
        for (var _b = __values$2(Object.keys(forms)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var form = _c.value;
          if (!Array.isArray(forms[form]) || forms[form].length !== 3) {
            throw new TexError_js_1$3.default('InvalidTagFormDef', 'The tag form definition for "%1" should be an array fo three strings', form);
          }
          _this.mtFormats.set(form, forms[form]);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return _this;
    }
    TagFormat.prototype.formatTag = function (tag) {
      if (this.mtCurrent) {
        var _a = __read$2(this.mtCurrent, 3), left = _a[0], right = _a[1], format = _a[2];
        return format ? ("").concat(left).concat(format, "{").concat(tag, "}").concat(right) : ("").concat(left).concat(tag).concat(right);
      }
      return _super.prototype.formatTag.call(this, tag);
    };
    return TagFormat;
  })(TagClass);
  tagID$1++;
  var tagName = 'MathtoolsTags-' + tagID$1;
  Tags_js_1$2.TagsFactory.add(tagName, TagFormat);
  jax.parseOptions.options.tags = tagName;
}
MathtoolsTags.MathtoolsTagFormat = MathtoolsTagFormat;

var MathtoolsItems = {};

var __extends$3 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __importDefault$8 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(MathtoolsItems, "__esModule", {
  value: true
});
MathtoolsItems.MultlinedItem = void 0;
var AmsItems_js_1 = AmsItems;
var NodeUtil_js_1$3 = __importDefault$8(NodeUtil$1);
var TexConstants_js_1$4 = TexConstants;
var MultlinedItem = (function (_super) {
  __extends$3(MultlinedItem, _super);
  function MultlinedItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MultlinedItem.prototype, "kind", {
    get: function () {
      return 'multlined';
    },
    enumerable: false,
    configurable: true
  });
  MultlinedItem.prototype.EndTable = function () {
    if (this.Size() || this.row.length) {
      this.EndEntry();
      this.EndRow();
    }
    if (this.table.length > 1) {
      var options = this.factory.configuration.options.mathtools;
      var gap = options.multlinegap;
      var firstskip = options['firstline-afterskip'] || gap;
      var lastskip = options['lastline-preskip'] || gap;
      var first = NodeUtil_js_1$3.default.getChildren(this.table[0])[0];
      if (NodeUtil_js_1$3.default.getAttribute(first, 'columnalign') !== TexConstants_js_1$4.TexConstant.Align.RIGHT) {
        first.appendChild(this.create('node', 'mspace', [], {
          width: firstskip
        }));
      }
      var last = NodeUtil_js_1$3.default.getChildren(this.table[this.table.length - 1])[0];
      if (NodeUtil_js_1$3.default.getAttribute(last, 'columnalign') !== TexConstants_js_1$4.TexConstant.Align.LEFT) {
        var top_1 = NodeUtil_js_1$3.default.getChildren(last)[0];
        top_1.childNodes.unshift(null);
        var space = this.create('node', 'mspace', [], {
          width: lastskip
        });
        NodeUtil_js_1$3.default.setChild(top_1, 0, space);
      }
    }
    _super.prototype.EndTable.call(this);
  };
  return MultlinedItem;
})(AmsItems_js_1.MultlineItem);
MathtoolsItems.MultlinedItem = MultlinedItem;

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  var _a;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MathtoolsConfiguration = exports.fixPrescripts = exports.PAIREDDELIMS = void 0;
  var Configuration_js_1 = Configuration;
  var SymbolMap_js_1 = SymbolMap;
  var NodeUtil_js_1 = __importDefault(NodeUtil$1);
  var Options_js_1 = Options;
  var MathtoolsUtil_js_1 = MathtoolsUtil;
  var MathtoolsTags_js_1 = MathtoolsTags;
  var MathtoolsItems_js_1 = MathtoolsItems;
  exports.PAIREDDELIMS = 'mathtools-paired-delims';
  function initMathtools(config) {
    new SymbolMap_js_1.CommandMap(exports.PAIREDDELIMS, {}, {});
    config.append(Configuration_js_1.Configuration.local({
      handler: {
        macro: [exports.PAIREDDELIMS]
      },
      priority: -5
    }));
  }
  function configMathtools(config, jax) {
    var e_1, _a;
    var parser = jax.parseOptions;
    var pairedDelims = parser.options.mathtools.pairedDelimiters;
    try {
      for (var _b = __values(Object.keys(pairedDelims)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var cs = _c.value;
        MathtoolsUtil_js_1.MathtoolsUtil.addPairedDelims(parser, cs, pairedDelims[cs]);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    (0, MathtoolsTags_js_1.MathtoolsTagFormat)(config, jax);
  }
  function fixPrescripts(_a) {
    var e_2, _b, e_3, _c, e_4, _d;
    var data = _a.data;
    try {
      for (var _e = __values(data.getList('mmultiscripts')), _f = _e.next(); !_f.done; _f = _e.next()) {
        var node = _f.value;
        if (!node.getProperty('fixPrescript')) continue;
        var childNodes = NodeUtil_js_1.default.getChildren(node);
        var n = 0;
        try {
          for (var _g = (e_3 = void 0, __values([1, 2])), _h = _g.next(); !_h.done; _h = _g.next()) {
            var i = _h.value;
            if (!childNodes[i]) {
              NodeUtil_js_1.default.setChild(node, i, data.nodeFactory.create('node', 'none'));
              n++;
            }
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
        try {
          for (var _j = (e_4 = void 0, __values([4, 5])), _k = _j.next(); !_k.done; _k = _j.next()) {
            var i = _k.value;
            if (NodeUtil_js_1.default.isType(childNodes[i], 'mrow') && NodeUtil_js_1.default.getChildren(childNodes[i]).length === 0) {
              NodeUtil_js_1.default.setChild(node, i, data.nodeFactory.create('node', 'none'));
            }
          }
        } catch (e_4_1) {
          e_4 = {
            error: e_4_1
          };
        } finally {
          try {
            if (_k && !_k.done && (_d = _j.return)) _d.call(_j);
          } finally {
            if (e_4) throw e_4.error;
          }
        }
        if (n === 2) {
          childNodes.splice(1, 2);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  }
  exports.fixPrescripts = fixPrescripts;
  exports.MathtoolsConfiguration = Configuration_js_1.Configuration.create('mathtools', {
    handler: {
      macro: ['mathtools-macros', 'mathtools-delimiters'],
      environment: ['mathtools-environments'],
      delimiter: ['mathtools-delimiters'],
      character: ['mathtools-characters']
    },
    items: (_a = {}, _a[MathtoolsItems_js_1.MultlinedItem.prototype.kind] = MathtoolsItems_js_1.MultlinedItem, _a),
    init: initMathtools,
    config: configMathtools,
    postprocessors: [[fixPrescripts, -6]],
    options: {
      mathtools: {
        'multlinegap': '1em',
        'multlined-pos': 'c',
        'firstline-afterskip': '',
        'lastline-preskip': '',
        'smallmatrix-align': 'c',
        'shortvdotsadjustabove': '.2em',
        'shortvdotsadjustbelow': '.2em',
        'centercolon': false,
        'centercolon-offset': '.04em',
        'thincolon-dx': '-.04em',
        'thincolon-dw': '-.08em',
        'use-unicode': false,
        'prescript-sub-format': '',
        'prescript-sup-format': '',
        'prescript-arg-format': '',
        'allow-mathtoolsset': true,
        pairedDelimiters: (0, Options_js_1.expandable)({}),
        tagforms: (0, Options_js_1.expandable)({})
      }
    }
  });
})(MathtoolsConfiguration);
getDefaultExportFromCjs(MathtoolsConfiguration);

var MhchemConfiguration = {};

var mhchemParser$1 = {};

Object.defineProperty(mhchemParser$1, "__esModule", {
  value: true
});
mhchemParser$1.mhchemParser = void 0;
var mhchemParser = (function () {
  function mhchemParser() {}
  mhchemParser.toTex = function (input, type) {
    return _mhchemTexify.go(_mhchemParser.go(input, type), type !== "tex");
  };
  return mhchemParser;
})();
mhchemParser$1.mhchemParser = mhchemParser;
function _mhchemCreateTransitions(o) {
  var pattern, state;
  var transitions = {};
  for (pattern in o) {
    for (state in o[pattern]) {
      var stateArray = state.split("|");
      o[pattern][state].stateArray = stateArray;
      for (var i = 0; i < stateArray.length; i++) {
        transitions[stateArray[i]] = [];
      }
    }
  }
  for (pattern in o) {
    for (state in o[pattern]) {
      var stateArray = o[pattern][state].stateArray || [];
      for (var i = 0; i < stateArray.length; i++) {
        var p = o[pattern][state];
        p.action_ = [].concat(p.action_);
        for (var k = 0; k < p.action_.length; k++) {
          if (typeof p.action_[k] === "string") {
            p.action_[k] = {
              type_: p.action_[k]
            };
          }
        }
        var patternArray = pattern.split("|");
        for (var j = 0; j < patternArray.length; j++) {
          if (stateArray[i] === '*') {
            var t = void 0;
            for (t in transitions) {
              transitions[t].push({
                pattern: patternArray[j],
                task: p
              });
            }
          } else {
            transitions[stateArray[i]].push({
              pattern: patternArray[j],
              task: p
            });
          }
        }
      }
    }
  }
  return transitions;
}
var _mhchemParser = {
  go: function (input, stateMachine) {
    if (!input) {
      return [];
    }
    if (stateMachine === undefined) {
      stateMachine = 'ce';
    }
    var state = '0';
    var buffer = {};
    buffer['parenthesisLevel'] = 0;
    input = input.replace(/\n/g, " ");
    input = input.replace(/[\u2212\u2013\u2014\u2010]/g, "-");
    input = input.replace(/[\u2026]/g, "...");
    var lastInput;
    var watchdog = 10;
    var output = [];
    while (true) {
      if (lastInput !== input) {
        watchdog = 10;
        lastInput = input;
      } else {
        watchdog--;
      }
      var machine = _mhchemParser.stateMachines[stateMachine];
      var t = machine.transitions[state] || machine.transitions['*'];
      iterateTransitions: for (var i = 0; i < t.length; i++) {
        var matches = _mhchemParser.patterns.match_(t[i].pattern, input);
        if (matches) {
          var task = t[i].task;
          for (var iA = 0; iA < task.action_.length; iA++) {
            var o = void 0;
            if (machine.actions[task.action_[iA].type_]) {
              o = machine.actions[task.action_[iA].type_](buffer, matches.match_, task.action_[iA].option);
            } else if (_mhchemParser.actions[task.action_[iA].type_]) {
              o = _mhchemParser.actions[task.action_[iA].type_](buffer, matches.match_, task.action_[iA].option);
            } else {
              throw ["MhchemBugA", "mhchem bug A. Please report. (" + task.action_[iA].type_ + ")"];
            }
            _mhchemParser.concatArray(output, o);
          }
          state = task.nextState || state;
          if (input.length > 0) {
            if (!task.revisit) {
              input = matches.remainder;
            }
            if (!task.toContinue) {
              break iterateTransitions;
            }
          } else {
            return output;
          }
        }
      }
      if (watchdog <= 0) {
        throw ["MhchemBugU", "mhchem bug U. Please report."];
      }
    }
  },
  concatArray: function (a, b) {
    if (b) {
      if (Array.isArray(b)) {
        for (var iB = 0; iB < b.length; iB++) {
          a.push(b[iB]);
        }
      } else {
        a.push(b);
      }
    }
  },
  patterns: {
    patterns: {
      'empty': /^$/,
      'else': /^./,
      'else2': /^./,
      'space': /^\s/,
      'space A': /^\s(?=[A-Z\\$])/,
      'space$': /^\s$/,
      'a-z': /^[a-z]/,
      'x': /^x/,
      'x$': /^x$/,
      'i$': /^i$/,
      'letters': /^(?:[a-zA-Z\u03B1-\u03C9\u0391-\u03A9?@]|(?:\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))))+/,
      '\\greek': /^\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))/,
      'one lowercase latin letter $': /^(?:([a-z])(?:$|[^a-zA-Z]))$/,
      '$one lowercase latin letter$ $': /^\$(?:([a-z])(?:$|[^a-zA-Z]))\$$/,
      'one lowercase greek letter $': /^(?:\$?[\u03B1-\u03C9]\$?|\$?\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega)\s*\$?)(?:\s+|\{\}|(?![a-zA-Z]))$/,
      'digits': /^[0-9]+/,
      '-9.,9': /^[+\-]?(?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))/,
      '-9.,9 no missing 0': /^[+\-]?[0-9]+(?:[.,][0-9]+)?/,
      '(-)(9.,9)(e)(99)': function (input) {
        var match = input.match(/^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))?(\((?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))\))?(?:(?:([eE])|\s*(\*|x|\\times|\u00D7)\s*10\^)([+\-]?[0-9]+|\{[+\-]?[0-9]+\}))?/);
        if (match && match[0]) {
          return {
            match_: match.slice(1),
            remainder: input.substr(match[0].length)
          };
        }
        return null;
      },
      '(-)(9)^(-9)': /^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+)?)\^([+\-]?[0-9]+|\{[+\-]?[0-9]+\})/,
      'state of aggregation $': function (input) {
        var a = _mhchemParser.patterns.findObserveGroups(input, "", /^\([a-z]{1,3}(?=[\),])/, ")", "");
        if (a && a.remainder.match(/^($|[\s,;\)\]\}])/)) {
          return a;
        }
        var match = input.match(/^(?:\((?:\\ca\s?)?\$[amothc]\$\))/);
        if (match) {
          return {
            match_: match[0],
            remainder: input.substr(match[0].length)
          };
        }
        return null;
      },
      '_{(state of aggregation)}$': /^_\{(\([a-z]{1,3}\))\}/,
      '{[(': /^(?:\\\{|\[|\()/,
      ')]}': /^(?:\)|\]|\\\})/,
      ', ': /^[,;]\s*/,
      ',': /^[,;]/,
      '.': /^[.]/,
      '. __* ': /^([.\u22C5\u00B7\u2022]|[*])\s*/,
      '...': /^\.\.\.(?=$|[^.])/,
      '^{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "^{", "", "", "}");
      },
      '^($...$)': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "^", "$", "$", "");
      },
      '^a': /^\^([0-9]+|[^\\_])/,
      '^\\x{}{}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "^", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", true);
      },
      '^\\x{}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "^", /^\\[a-zA-Z]+\{/, "}", "");
      },
      '^\\x': /^\^(\\[a-zA-Z]+)\s*/,
      '^(-1)': /^\^(-?\d+)/,
      '\'': /^'/,
      '_{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "_{", "", "", "}");
      },
      '_($...$)': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "_", "$", "$", "");
      },
      '_9': /^_([+\-]?[0-9]+|[^\\])/,
      '_\\x{}{}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "_", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", true);
      },
      '_\\x{}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "_", /^\\[a-zA-Z]+\{/, "}", "");
      },
      '_\\x': /^_(\\[a-zA-Z]+)\s*/,
      '^_': /^(?:\^(?=_)|\_(?=\^)|[\^_]$)/,
      '{}^': /^\{\}(?=\^)/,
      '{}': /^\{\}/,
      '{...}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "", "{", "}", "");
      },
      '{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "{", "", "", "}");
      },
      '$...$': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "", "$", "$", "");
      },
      '${(...)}$__$(...)$': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "${", "", "", "}$") || _mhchemParser.patterns.findObserveGroups(input, "$", "", "", "$");
      },
      '=<>': /^[=<>]/,
      '#': /^[#\u2261]/,
      '+': /^\+/,
      '-$': /^-(?=[\s_},;\]/]|$|\([a-z]+\))/,
      '-9': /^-(?=[0-9])/,
      '- orbital overlap': /^-(?=(?:[spd]|sp)(?:$|[\s,;\)\]\}]))/,
      '-': /^-/,
      'pm-operator': /^(?:\\pm|\$\\pm\$|\+-|\+\/-)/,
      'operator': /^(?:\+|(?:[\-=<>]|<<|>>|\\approx|\$\\approx\$)(?=\s|$|-?[0-9]))/,
      'arrowUpDown': /^(?:v|\(v\)|\^|\(\^\))(?=$|[\s,;\)\]\}])/,
      '\\bond{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\bond{", "", "", "}");
      },
      '->': /^(?:<->|<-->|->|<-|<=>>|<<=>|<=>|[\u2192\u27F6\u21CC])/,
      'CMT': /^[CMT](?=\[)/,
      '[(...)]': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "[", "", "", "]");
      },
      '1st-level escape': /^(&|\\\\|\\hline)\s*/,
      '\\,': /^(?:\\[,\ ;:])/,
      '\\x{}{}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", true);
      },
      '\\x{}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "", /^\\[a-zA-Z]+\{/, "}", "");
      },
      '\\ca': /^\\ca(?:\s+|(?![a-zA-Z]))/,
      '\\x': /^(?:\\[a-zA-Z]+\s*|\\[_&{}%])/,
      'orbital': /^(?:[0-9]{1,2}[spdfgh]|[0-9]{0,2}sp)(?=$|[^a-zA-Z])/,
      'others': /^[\/~|]/,
      '\\frac{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\frac{", "", "", "}", "{", "", "", "}");
      },
      '\\overset{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\overset{", "", "", "}", "{", "", "", "}");
      },
      '\\underset{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\underset{", "", "", "}", "{", "", "", "}");
      },
      '\\underbrace{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\underbrace{", "", "", "}_", "{", "", "", "}");
      },
      '\\color{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\color{", "", "", "}");
      },
      '\\color{(...)}{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\color{", "", "", "}", "{", "", "", "}") || _mhchemParser.patterns.findObserveGroups(input, "\\color", "\\", "", /^(?=\{)/, "{", "", "", "}");
      },
      '\\ce{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\ce{", "", "", "}");
      },
      '\\pu{(...)}': function (input) {
        return _mhchemParser.patterns.findObserveGroups(input, "\\pu{", "", "", "}");
      },
      'oxidation$': /^(?:[+-][IVX]+|(?:\\pm|\$\\pm\$|\+-|\+\/-)\s*0)$/,
      'd-oxidation$': /^(?:[+-]?[IVX]+|(?:\\pm|\$\\pm\$|\+-|\+\/-)\s*0)$/,
      '1/2$': /^[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+(?:\$[a-z]\$|[a-z])?$/,
      'amount': function (input) {
        var match;
        match = input.match(/^(?:(?:(?:\([+\-]?[0-9]+\/[0-9]+\)|[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+|[+\-]?[0-9]+[.,][0-9]+|[+\-]?\.[0-9]+|[+\-]?[0-9]+)(?:[a-z](?=\s*[A-Z]))?)|[+\-]?[a-z](?=\s*[A-Z])|\+(?!\s))/);
        if (match) {
          return {
            match_: match[0],
            remainder: input.substr(match[0].length)
          };
        }
        var a = _mhchemParser.patterns.findObserveGroups(input, "", "$", "$", "");
        if (a) {
          match = a.match_.match(/^\$(?:\(?[+\-]?(?:[0-9]*[a-z]?[+\-])?[0-9]*[a-z](?:[+\-][0-9]*[a-z]?)?\)?|\+|-)\$$/);
          if (match) {
            return {
              match_: match[0],
              remainder: input.substr(match[0].length)
            };
          }
        }
        return null;
      },
      'amount2': function (input) {
        return this['amount'](input);
      },
      '(KV letters),': /^(?:[A-Z][a-z]{0,2}|i)(?=,)/,
      'formula$': function (input) {
        if (input.match(/^\([a-z]+\)$/)) {
          return null;
        }
        var match = input.match(/^(?:[a-z]|(?:[0-9\ \+\-\,\.\(\)]+[a-z])+[0-9\ \+\-\,\.\(\)]*|(?:[a-z][0-9\ \+\-\,\.\(\)]+)+[a-z]?)$/);
        if (match) {
          return {
            match_: match[0],
            remainder: input.substr(match[0].length)
          };
        }
        return null;
      },
      'uprightEntities': /^(?:pH|pOH|pC|pK|iPr|iBu)(?=$|[^a-zA-Z])/,
      '/': /^\s*(\/)\s*/,
      '//': /^\s*(\/\/)\s*/,
      '*': /^\s*[*.]\s*/
    },
    findObserveGroups: function (input, begExcl, begIncl, endIncl, endExcl, beg2Excl, beg2Incl, end2Incl, end2Excl, combine) {
      var _match = function (input, pattern) {
        if (typeof pattern === "string") {
          if (input.indexOf(pattern) !== 0) {
            return null;
          }
          return pattern;
        } else {
          var match_1 = input.match(pattern);
          if (!match_1) {
            return null;
          }
          return match_1[0];
        }
      };
      var _findObserveGroups = function (input, i, endChars) {
        var braces = 0;
        while (i < input.length) {
          var a = input.charAt(i);
          var match_2 = _match(input.substr(i), endChars);
          if (match_2 !== null && braces === 0) {
            return {
              endMatchBegin: i,
              endMatchEnd: i + match_2.length
            };
          } else if (a === "{") {
            braces++;
          } else if (a === "}") {
            if (braces === 0) {
              throw ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"];
            } else {
              braces--;
            }
          }
          i++;
        }
        if (braces > 0) {
          return null;
        }
        return null;
      };
      var match = _match(input, begExcl);
      if (match === null) {
        return null;
      }
      input = input.substr(match.length);
      match = _match(input, begIncl);
      if (match === null) {
        return null;
      }
      var e = _findObserveGroups(input, match.length, endIncl || endExcl);
      if (e === null) {
        return null;
      }
      var match1 = input.substring(0, endIncl ? e.endMatchEnd : e.endMatchBegin);
      if (!(beg2Excl || beg2Incl)) {
        return {
          match_: match1,
          remainder: input.substr(e.endMatchEnd)
        };
      } else {
        var group2 = this.findObserveGroups(input.substr(e.endMatchEnd), beg2Excl, beg2Incl, end2Incl, end2Excl);
        if (group2 === null) {
          return null;
        }
        var matchRet = [match1, group2.match_];
        return {
          match_: combine ? matchRet.join("") : matchRet,
          remainder: group2.remainder
        };
      }
    },
    match_: function (m, input) {
      var pattern = _mhchemParser.patterns.patterns[m];
      if (pattern === undefined) {
        throw ["MhchemBugP", "mhchem bug P. Please report. (" + m + ")"];
      } else if (typeof pattern === "function") {
        return _mhchemParser.patterns.patterns[m](input);
      } else {
        var match = input.match(pattern);
        if (match) {
          if (match.length > 2) {
            return {
              match_: match.slice(1),
              remainder: input.substr(match[0].length)
            };
          } else {
            return {
              match_: match[1] || match[0],
              remainder: input.substr(match[0].length)
            };
          }
        }
        return null;
      }
    }
  },
  actions: {
    'a=': function (buffer, m) {
      buffer.a = (buffer.a || "") + m;
      return undefined;
    },
    'b=': function (buffer, m) {
      buffer.b = (buffer.b || "") + m;
      return undefined;
    },
    'p=': function (buffer, m) {
      buffer.p = (buffer.p || "") + m;
      return undefined;
    },
    'o=': function (buffer, m) {
      buffer.o = (buffer.o || "") + m;
      return undefined;
    },
    'o=+p1': function (buffer, _m, a) {
      buffer.o = (buffer.o || "") + a;
      return undefined;
    },
    'q=': function (buffer, m) {
      buffer.q = (buffer.q || "") + m;
      return undefined;
    },
    'd=': function (buffer, m) {
      buffer.d = (buffer.d || "") + m;
      return undefined;
    },
    'rm=': function (buffer, m) {
      buffer.rm = (buffer.rm || "") + m;
      return undefined;
    },
    'text=': function (buffer, m) {
      buffer.text_ = (buffer.text_ || "") + m;
      return undefined;
    },
    'insert': function (_buffer, _m, a) {
      return {
        type_: a
      };
    },
    'insert+p1': function (_buffer, m, a) {
      return {
        type_: a,
        p1: m
      };
    },
    'insert+p1+p2': function (_buffer, m, a) {
      return {
        type_: a,
        p1: m[0],
        p2: m[1]
      };
    },
    'copy': function (_buffer, m) {
      return m;
    },
    'write': function (_buffer, _m, a) {
      return a;
    },
    'rm': function (_buffer, m) {
      return {
        type_: 'rm',
        p1: m
      };
    },
    'text': function (_buffer, m) {
      return _mhchemParser.go(m, 'text');
    },
    'tex-math': function (_buffer, m) {
      return _mhchemParser.go(m, 'tex-math');
    },
    'tex-math tight': function (_buffer, m) {
      return _mhchemParser.go(m, 'tex-math tight');
    },
    'bond': function (_buffer, m, k) {
      return {
        type_: 'bond',
        kind_: k || m
      };
    },
    'color0-output': function (_buffer, m) {
      return {
        type_: 'color0',
        color: m
      };
    },
    'ce': function (_buffer, m) {
      return _mhchemParser.go(m, 'ce');
    },
    'pu': function (_buffer, m) {
      return _mhchemParser.go(m, 'pu');
    },
    '1/2': function (_buffer, m) {
      var ret = [];
      if (m.match(/^[+\-]/)) {
        ret.push(m.substr(0, 1));
        m = m.substr(1);
      }
      var n = m.match(/^([0-9]+|\$[a-z]\$|[a-z])\/([0-9]+)(\$[a-z]\$|[a-z])?$/);
      n[1] = n[1].replace(/\$/g, "");
      ret.push({
        type_: 'frac',
        p1: n[1],
        p2: n[2]
      });
      if (n[3]) {
        n[3] = n[3].replace(/\$/g, "");
        ret.push({
          type_: 'tex-math',
          p1: n[3]
        });
      }
      return ret;
    },
    '9,9': function (_buffer, m) {
      return _mhchemParser.go(m, '9,9');
    }
  },
  stateMachines: {
    'tex': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '0': {
            action_: 'copy'
          }
        },
        '\\ce{(...)}': {
          '0': {
            action_: [{
              type_: 'write',
              option: "{"
            }, 'ce', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        '\\pu{(...)}': {
          '0': {
            action_: [{
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        'else': {
          '0': {
            action_: 'copy'
          }
        }
      }),
      actions: {}
    },
    'ce': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: 'output'
          }
        },
        'else': {
          '0|1|2': {
            action_: 'beginsWithBond=false',
            revisit: true,
            toContinue: true
          }
        },
        'oxidation$': {
          '0': {
            action_: 'oxidation-output'
          }
        },
        'CMT': {
          'r': {
            action_: 'rdt=',
            nextState: 'rt'
          },
          'rd': {
            action_: 'rqt=',
            nextState: 'rdt'
          }
        },
        'arrowUpDown': {
          '0|1|2|as': {
            action_: ['sb=false', 'output', 'operator'],
            nextState: '1'
          }
        },
        'uprightEntities': {
          '0|1|2': {
            action_: ['o=', 'output'],
            nextState: '1'
          }
        },
        'orbital': {
          '0|1|2|3': {
            action_: 'o=',
            nextState: 'o'
          }
        },
        '->': {
          '0|1|2|3': {
            action_: 'r=',
            nextState: 'r'
          },
          'a|as': {
            action_: ['output', 'r='],
            nextState: 'r'
          },
          '*': {
            action_: ['output', 'r='],
            nextState: 'r'
          }
        },
        '+': {
          'o': {
            action_: 'd= kv',
            nextState: 'd'
          },
          'd|D': {
            action_: 'd=',
            nextState: 'd'
          },
          'q': {
            action_: 'd=',
            nextState: 'qd'
          },
          'qd|qD': {
            action_: 'd=',
            nextState: 'qd'
          },
          'dq': {
            action_: ['output', 'd='],
            nextState: 'd'
          },
          '3': {
            action_: ['sb=false', 'output', 'operator'],
            nextState: '0'
          }
        },
        'amount': {
          '0|2': {
            action_: 'a=',
            nextState: 'a'
          }
        },
        'pm-operator': {
          '0|1|2|a|as': {
            action_: ['sb=false', 'output', {
              type_: 'operator',
              option: '\\pm'
            }],
            nextState: '0'
          }
        },
        'operator': {
          '0|1|2|a|as': {
            action_: ['sb=false', 'output', 'operator'],
            nextState: '0'
          }
        },
        '-$': {
          'o|q': {
            action_: ['charge or bond', 'output'],
            nextState: 'qd'
          },
          'd': {
            action_: 'd=',
            nextState: 'd'
          },
          'D': {
            action_: ['output', {
              type_: 'bond',
              option: "-"
            }],
            nextState: '3'
          },
          'q': {
            action_: 'd=',
            nextState: 'qd'
          },
          'qd': {
            action_: 'd=',
            nextState: 'qd'
          },
          'qD|dq': {
            action_: ['output', {
              type_: 'bond',
              option: "-"
            }],
            nextState: '3'
          }
        },
        '-9': {
          '3|o': {
            action_: ['output', {
              type_: 'insert',
              option: 'hyphen'
            }],
            nextState: '3'
          }
        },
        '- orbital overlap': {
          'o': {
            action_: ['output', {
              type_: 'insert',
              option: 'hyphen'
            }],
            nextState: '2'
          },
          'd': {
            action_: ['output', {
              type_: 'insert',
              option: 'hyphen'
            }],
            nextState: '2'
          }
        },
        '-': {
          '0|1|2': {
            action_: [{
              type_: 'output',
              option: 1
            }, 'beginsWithBond=true', {
              type_: 'bond',
              option: "-"
            }],
            nextState: '3'
          },
          '3': {
            action_: {
              type_: 'bond',
              option: "-"
            }
          },
          'a': {
            action_: ['output', {
              type_: 'insert',
              option: 'hyphen'
            }],
            nextState: '2'
          },
          'as': {
            action_: [{
              type_: 'output',
              option: 2
            }, {
              type_: 'bond',
              option: "-"
            }],
            nextState: '3'
          },
          'b': {
            action_: 'b='
          },
          'o': {
            action_: {
              type_: '- after o/d',
              option: false
            },
            nextState: '2'
          },
          'q': {
            action_: {
              type_: '- after o/d',
              option: false
            },
            nextState: '2'
          },
          'd|qd|dq': {
            action_: {
              type_: '- after o/d',
              option: true
            },
            nextState: '2'
          },
          'D|qD|p': {
            action_: ['output', {
              type_: 'bond',
              option: "-"
            }],
            nextState: '3'
          }
        },
        'amount2': {
          '1|3': {
            action_: 'a=',
            nextState: 'a'
          }
        },
        'letters': {
          '0|1|2|3|a|as|b|p|bp|o': {
            action_: 'o=',
            nextState: 'o'
          },
          'q|dq': {
            action_: ['output', 'o='],
            nextState: 'o'
          },
          'd|D|qd|qD': {
            action_: 'o after d',
            nextState: 'o'
          }
        },
        'digits': {
          'o': {
            action_: 'q=',
            nextState: 'q'
          },
          'd|D': {
            action_: 'q=',
            nextState: 'dq'
          },
          'q': {
            action_: ['output', 'o='],
            nextState: 'o'
          },
          'a': {
            action_: 'o=',
            nextState: 'o'
          }
        },
        'space A': {
          'b|p|bp': {
            action_: []
          }
        },
        'space': {
          'a': {
            action_: [],
            nextState: 'as'
          },
          '0': {
            action_: 'sb=false'
          },
          '1|2': {
            action_: 'sb=true'
          },
          'r|rt|rd|rdt|rdq': {
            action_: 'output',
            nextState: '0'
          },
          '*': {
            action_: ['output', 'sb=true'],
            nextState: '1'
          }
        },
        '1st-level escape': {
          '1|2': {
            action_: ['output', {
              type_: 'insert+p1',
              option: '1st-level escape'
            }]
          },
          '*': {
            action_: ['output', {
              type_: 'insert+p1',
              option: '1st-level escape'
            }],
            nextState: '0'
          }
        },
        '[(...)]': {
          'r|rt': {
            action_: 'rd=',
            nextState: 'rd'
          },
          'rd|rdt': {
            action_: 'rq=',
            nextState: 'rdq'
          }
        },
        '...': {
          'o|d|D|dq|qd|qD': {
            action_: ['output', {
              type_: 'bond',
              option: "..."
            }],
            nextState: '3'
          },
          '*': {
            action_: [{
              type_: 'output',
              option: 1
            }, {
              type_: 'insert',
              option: 'ellipsis'
            }],
            nextState: '1'
          }
        },
        '. __* ': {
          '*': {
            action_: ['output', {
              type_: 'insert',
              option: 'addition compound'
            }],
            nextState: '1'
          }
        },
        'state of aggregation $': {
          '*': {
            action_: ['output', 'state of aggregation'],
            nextState: '1'
          }
        },
        '{[(': {
          'a|as|o': {
            action_: ['o=', 'output', 'parenthesisLevel++'],
            nextState: '2'
          },
          '0|1|2|3': {
            action_: ['o=', 'output', 'parenthesisLevel++'],
            nextState: '2'
          },
          '*': {
            action_: ['output', 'o=', 'output', 'parenthesisLevel++'],
            nextState: '2'
          }
        },
        ')]}': {
          '0|1|2|3|b|p|bp|o': {
            action_: ['o=', 'parenthesisLevel--'],
            nextState: 'o'
          },
          'a|as|d|D|q|qd|qD|dq': {
            action_: ['output', 'o=', 'parenthesisLevel--'],
            nextState: 'o'
          }
        },
        ', ': {
          '*': {
            action_: ['output', 'comma'],
            nextState: '0'
          }
        },
        '^_': {
          '*': {
            action_: []
          }
        },
        '^{(...)}|^($...$)': {
          '0|1|2|as': {
            action_: 'b=',
            nextState: 'b'
          },
          'p': {
            action_: 'b=',
            nextState: 'bp'
          },
          '3|o': {
            action_: 'd= kv',
            nextState: 'D'
          },
          'q': {
            action_: 'd=',
            nextState: 'qD'
          },
          'd|D|qd|qD|dq': {
            action_: ['output', 'd='],
            nextState: 'D'
          }
        },
        '^a|^\\x{}{}|^\\x{}|^\\x|\'': {
          '0|1|2|as': {
            action_: 'b=',
            nextState: 'b'
          },
          'p': {
            action_: 'b=',
            nextState: 'bp'
          },
          '3|o': {
            action_: 'd= kv',
            nextState: 'd'
          },
          'q': {
            action_: 'd=',
            nextState: 'qd'
          },
          'd|qd|D|qD': {
            action_: 'd='
          },
          'dq': {
            action_: ['output', 'd='],
            nextState: 'd'
          }
        },
        '_{(state of aggregation)}$': {
          'd|D|q|qd|qD|dq': {
            action_: ['output', 'q='],
            nextState: 'q'
          }
        },
        '_{(...)}|_($...$)|_9|_\\x{}{}|_\\x{}|_\\x': {
          '0|1|2|as': {
            action_: 'p=',
            nextState: 'p'
          },
          'b': {
            action_: 'p=',
            nextState: 'bp'
          },
          '3|o': {
            action_: 'q=',
            nextState: 'q'
          },
          'd|D': {
            action_: 'q=',
            nextState: 'dq'
          },
          'q|qd|qD|dq': {
            action_: ['output', 'q='],
            nextState: 'q'
          }
        },
        '=<>': {
          '0|1|2|3|a|as|o|q|d|D|qd|qD|dq': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'bond'],
            nextState: '3'
          }
        },
        '#': {
          '0|1|2|3|a|as|o': {
            action_: [{
              type_: 'output',
              option: 2
            }, {
              type_: 'bond',
              option: "#"
            }],
            nextState: '3'
          }
        },
        '{}^': {
          '*': {
            action_: [{
              type_: 'output',
              option: 1
            }, {
              type_: 'insert',
              option: 'tinySkip'
            }],
            nextState: '1'
          }
        },
        '{}': {
          '*': {
            action_: {
              type_: 'output',
              option: 1
            },
            nextState: '1'
          }
        },
        '{...}': {
          '0|1|2|3|a|as|b|p|bp': {
            action_: 'o=',
            nextState: 'o'
          },
          'o|d|D|q|qd|qD|dq': {
            action_: ['output', 'o='],
            nextState: 'o'
          }
        },
        '$...$': {
          'a': {
            action_: 'a='
          },
          '0|1|2|3|as|b|p|bp|o': {
            action_: 'o=',
            nextState: 'o'
          },
          'as|o': {
            action_: 'o='
          },
          'q|d|D|qd|qD|dq': {
            action_: ['output', 'o='],
            nextState: 'o'
          }
        },
        '\\bond{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'bond'],
            nextState: "3"
          }
        },
        '\\frac{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 1
            }, 'frac-output'],
            nextState: '3'
          }
        },
        '\\overset{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'overset-output'],
            nextState: '3'
          }
        },
        '\\underset{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'underset-output'],
            nextState: '3'
          }
        },
        '\\underbrace{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'underbrace-output'],
            nextState: '3'
          }
        },
        '\\color{(...)}{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'color-output'],
            nextState: '3'
          }
        },
        '\\color{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'color0-output']
          }
        },
        '\\ce{(...)}': {
          '*': {
            action_: [{
              type_: 'output',
              option: 2
            }, 'ce'],
            nextState: '3'
          }
        },
        '\\,': {
          '*': {
            action_: [{
              type_: 'output',
              option: 1
            }, 'copy'],
            nextState: '1'
          }
        },
        '\\pu{(...)}': {
          '*': {
            action_: ['output', {
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }],
            nextState: '3'
          }
        },
        '\\x{}{}|\\x{}|\\x': {
          '0|1|2|3|a|as|b|p|bp|o|c0': {
            action_: ['o=', 'output'],
            nextState: '3'
          },
          '*': {
            action_: ['output', 'o=', 'output'],
            nextState: '3'
          }
        },
        'others': {
          '*': {
            action_: [{
              type_: 'output',
              option: 1
            }, 'copy'],
            nextState: '3'
          }
        },
        'else2': {
          'a': {
            action_: 'a to o',
            nextState: 'o',
            revisit: true
          },
          'as': {
            action_: ['output', 'sb=true'],
            nextState: '1',
            revisit: true
          },
          'r|rt|rd|rdt|rdq': {
            action_: ['output'],
            nextState: '0',
            revisit: true
          },
          '*': {
            action_: ['output', 'copy'],
            nextState: '3'
          }
        }
      }),
      actions: {
        'o after d': function (buffer, m) {
          var ret;
          if ((buffer.d || "").match(/^[1-9][0-9]*$/)) {
            var tmp = buffer.d;
            buffer.d = undefined;
            ret = this['output'](buffer);
            ret.push({
              type_: 'tinySkip'
            });
            buffer.b = tmp;
          } else {
            ret = this['output'](buffer);
          }
          _mhchemParser.actions['o='](buffer, m);
          return ret;
        },
        'd= kv': function (buffer, m) {
          buffer.d = m;
          buffer.dType = 'kv';
          return undefined;
        },
        'charge or bond': function (buffer, m) {
          if (buffer['beginsWithBond']) {
            var ret = [];
            _mhchemParser.concatArray(ret, this['output'](buffer));
            _mhchemParser.concatArray(ret, _mhchemParser.actions['bond'](buffer, m, "-"));
            return ret;
          } else {
            buffer.d = m;
            return undefined;
          }
        },
        '- after o/d': function (buffer, m, isAfterD) {
          var c1 = _mhchemParser.patterns.match_('orbital', buffer.o || "");
          var c2 = _mhchemParser.patterns.match_('one lowercase greek letter $', buffer.o || "");
          var c3 = _mhchemParser.patterns.match_('one lowercase latin letter $', buffer.o || "");
          var c4 = _mhchemParser.patterns.match_('$one lowercase latin letter$ $', buffer.o || "");
          var hyphenFollows = m === "-" && (c1 && c1.remainder === "" || c2 || c3 || c4);
          if (hyphenFollows && !buffer.a && !buffer.b && !buffer.p && !buffer.d && !buffer.q && !c1 && c3) {
            buffer.o = '$' + buffer.o + '$';
          }
          var ret = [];
          if (hyphenFollows) {
            _mhchemParser.concatArray(ret, this['output'](buffer));
            ret.push({
              type_: 'hyphen'
            });
          } else {
            c1 = _mhchemParser.patterns.match_('digits', buffer.d || "");
            if (isAfterD && c1 && c1.remainder === '') {
              _mhchemParser.concatArray(ret, _mhchemParser.actions['d='](buffer, m));
              _mhchemParser.concatArray(ret, this['output'](buffer));
            } else {
              _mhchemParser.concatArray(ret, this['output'](buffer));
              _mhchemParser.concatArray(ret, _mhchemParser.actions['bond'](buffer, m, "-"));
            }
          }
          return ret;
        },
        'a to o': function (buffer) {
          buffer.o = buffer.a;
          buffer.a = undefined;
          return undefined;
        },
        'sb=true': function (buffer) {
          buffer.sb = true;
          return undefined;
        },
        'sb=false': function (buffer) {
          buffer.sb = false;
          return undefined;
        },
        'beginsWithBond=true': function (buffer) {
          buffer['beginsWithBond'] = true;
          return undefined;
        },
        'beginsWithBond=false': function (buffer) {
          buffer['beginsWithBond'] = false;
          return undefined;
        },
        'parenthesisLevel++': function (buffer) {
          buffer['parenthesisLevel']++;
          return undefined;
        },
        'parenthesisLevel--': function (buffer) {
          buffer['parenthesisLevel']--;
          return undefined;
        },
        'state of aggregation': function (_buffer, m) {
          return {
            type_: 'state of aggregation',
            p1: _mhchemParser.go(m, 'o')
          };
        },
        'comma': function (buffer, m) {
          var a = m.replace(/\s*$/, '');
          var withSpace = a !== m;
          if (withSpace && buffer['parenthesisLevel'] === 0) {
            return {
              type_: 'comma enumeration L',
              p1: a
            };
          } else {
            return {
              type_: 'comma enumeration M',
              p1: a
            };
          }
        },
        'output': function (buffer, _m, entityFollows) {
          var ret;
          if (!buffer.r) {
            ret = [];
            if (!buffer.a && !buffer.b && !buffer.p && !buffer.o && !buffer.q && !buffer.d && !entityFollows) ; else {
              if (buffer.sb) {
                ret.push({
                  type_: 'entitySkip'
                });
              }
              if (!buffer.o && !buffer.q && !buffer.d && !buffer.b && !buffer.p && entityFollows !== 2) {
                buffer.o = buffer.a;
                buffer.a = undefined;
              } else if (!buffer.o && !buffer.q && !buffer.d && (buffer.b || buffer.p)) {
                buffer.o = buffer.a;
                buffer.d = buffer.b;
                buffer.q = buffer.p;
                buffer.a = buffer.b = buffer.p = undefined;
              } else {
                if (buffer.o && buffer.dType === 'kv' && _mhchemParser.patterns.match_('d-oxidation$', buffer.d || "")) {
                  buffer.dType = 'oxidation';
                } else if (buffer.o && buffer.dType === 'kv' && !buffer.q) {
                  buffer.dType = undefined;
                }
              }
              ret.push({
                type_: 'chemfive',
                a: _mhchemParser.go(buffer.a, 'a'),
                b: _mhchemParser.go(buffer.b, 'bd'),
                p: _mhchemParser.go(buffer.p, 'pq'),
                o: _mhchemParser.go(buffer.o, 'o'),
                q: _mhchemParser.go(buffer.q, 'pq'),
                d: _mhchemParser.go(buffer.d, buffer.dType === 'oxidation' ? 'oxidation' : 'bd'),
                dType: buffer.dType
              });
            }
          } else {
            var rd = void 0;
            if (buffer.rdt === 'M') {
              rd = _mhchemParser.go(buffer.rd, 'tex-math');
            } else if (buffer.rdt === 'T') {
              rd = [{
                type_: 'text',
                p1: buffer.rd || ""
              }];
            } else {
              rd = _mhchemParser.go(buffer.rd, 'ce');
            }
            var rq = void 0;
            if (buffer.rqt === 'M') {
              rq = _mhchemParser.go(buffer.rq, 'tex-math');
            } else if (buffer.rqt === 'T') {
              rq = [{
                type_: 'text',
                p1: buffer.rq || ""
              }];
            } else {
              rq = _mhchemParser.go(buffer.rq, 'ce');
            }
            ret = {
              type_: 'arrow',
              r: buffer.r,
              rd: rd,
              rq: rq
            };
          }
          for (var p in buffer) {
            if (p !== 'parenthesisLevel' && p !== 'beginsWithBond') {
              delete buffer[p];
            }
          }
          return ret;
        },
        'oxidation-output': function (_buffer, m) {
          var ret = ["{"];
          _mhchemParser.concatArray(ret, _mhchemParser.go(m, 'oxidation'));
          ret.push("}");
          return ret;
        },
        'frac-output': function (_buffer, m) {
          return {
            type_: 'frac-ce',
            p1: _mhchemParser.go(m[0], 'ce'),
            p2: _mhchemParser.go(m[1], 'ce')
          };
        },
        'overset-output': function (_buffer, m) {
          return {
            type_: 'overset',
            p1: _mhchemParser.go(m[0], 'ce'),
            p2: _mhchemParser.go(m[1], 'ce')
          };
        },
        'underset-output': function (_buffer, m) {
          return {
            type_: 'underset',
            p1: _mhchemParser.go(m[0], 'ce'),
            p2: _mhchemParser.go(m[1], 'ce')
          };
        },
        'underbrace-output': function (_buffer, m) {
          return {
            type_: 'underbrace',
            p1: _mhchemParser.go(m[0], 'ce'),
            p2: _mhchemParser.go(m[1], 'ce')
          };
        },
        'color-output': function (_buffer, m) {
          return {
            type_: 'color',
            color1: m[0],
            color2: _mhchemParser.go(m[1], 'ce')
          };
        },
        'r=': function (buffer, m) {
          buffer.r = m;
          return undefined;
        },
        'rdt=': function (buffer, m) {
          buffer.rdt = m;
          return undefined;
        },
        'rd=': function (buffer, m) {
          buffer.rd = m;
          return undefined;
        },
        'rqt=': function (buffer, m) {
          buffer.rqt = m;
          return undefined;
        },
        'rq=': function (buffer, m) {
          buffer.rq = m;
          return undefined;
        },
        'operator': function (_buffer, m, p1) {
          return {
            type_: 'operator',
            kind_: p1 || m
          };
        }
      }
    },
    'a': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: []
          }
        },
        '1/2$': {
          '0': {
            action_: '1/2'
          }
        },
        'else': {
          '0': {
            action_: [],
            nextState: '1',
            revisit: true
          }
        },
        '${(...)}$__$(...)$': {
          '*': {
            action_: 'tex-math tight',
            nextState: '1'
          }
        },
        ',': {
          '*': {
            action_: {
              type_: 'insert',
              option: 'commaDecimal'
            }
          }
        },
        'else2': {
          '*': {
            action_: 'copy'
          }
        }
      }),
      actions: {}
    },
    'o': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: []
          }
        },
        '1/2$': {
          '0': {
            action_: '1/2'
          }
        },
        'else': {
          '0': {
            action_: [],
            nextState: '1',
            revisit: true
          }
        },
        'letters': {
          '*': {
            action_: 'rm'
          }
        },
        '\\ca': {
          '*': {
            action_: {
              type_: 'insert',
              option: 'circa'
            }
          }
        },
        '\\pu{(...)}': {
          '*': {
            action_: [{
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        '\\x{}{}|\\x{}|\\x': {
          '*': {
            action_: 'copy'
          }
        },
        '${(...)}$__$(...)$': {
          '*': {
            action_: 'tex-math'
          }
        },
        '{(...)}': {
          '*': {
            action_: [{
              type_: 'write',
              option: "{"
            }, 'text', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        'else2': {
          '*': {
            action_: 'copy'
          }
        }
      }),
      actions: {}
    },
    'text': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: 'output'
          }
        },
        '{...}': {
          '*': {
            action_: 'text='
          }
        },
        '${(...)}$__$(...)$': {
          '*': {
            action_: 'tex-math'
          }
        },
        '\\greek': {
          '*': {
            action_: ['output', 'rm']
          }
        },
        '\\pu{(...)}': {
          '*': {
            action_: ['output', {
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        '\\,|\\x{}{}|\\x{}|\\x': {
          '*': {
            action_: ['output', 'copy']
          }
        },
        'else': {
          '*': {
            action_: 'text='
          }
        }
      }),
      actions: {
        'output': function (buffer) {
          if (buffer.text_) {
            var ret = {
              type_: 'text',
              p1: buffer.text_
            };
            for (var p in buffer) {
              delete buffer[p];
            }
            return ret;
          }
          return undefined;
        }
      }
    },
    'pq': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: []
          }
        },
        'state of aggregation $': {
          '*': {
            action_: 'state of aggregation'
          }
        },
        'i$': {
          '0': {
            action_: [],
            nextState: '!f',
            revisit: true
          }
        },
        '(KV letters),': {
          '0': {
            action_: 'rm',
            nextState: '0'
          }
        },
        'formula$': {
          '0': {
            action_: [],
            nextState: 'f',
            revisit: true
          }
        },
        '1/2$': {
          '0': {
            action_: '1/2'
          }
        },
        'else': {
          '0': {
            action_: [],
            nextState: '!f',
            revisit: true
          }
        },
        '${(...)}$__$(...)$': {
          '*': {
            action_: 'tex-math'
          }
        },
        '{(...)}': {
          '*': {
            action_: 'text'
          }
        },
        'a-z': {
          'f': {
            action_: 'tex-math'
          }
        },
        'letters': {
          '*': {
            action_: 'rm'
          }
        },
        '-9.,9': {
          '*': {
            action_: '9,9'
          }
        },
        ',': {
          '*': {
            action_: {
              type_: 'insert+p1',
              option: 'comma enumeration S'
            }
          }
        },
        '\\color{(...)}{(...)}': {
          '*': {
            action_: 'color-output'
          }
        },
        '\\color{(...)}': {
          '*': {
            action_: 'color0-output'
          }
        },
        '\\ce{(...)}': {
          '*': {
            action_: 'ce'
          }
        },
        '\\pu{(...)}': {
          '*': {
            action_: [{
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        '\\,|\\x{}{}|\\x{}|\\x': {
          '*': {
            action_: 'copy'
          }
        },
        'else2': {
          '*': {
            action_: 'copy'
          }
        }
      }),
      actions: {
        'state of aggregation': function (_buffer, m) {
          return {
            type_: 'state of aggregation subscript',
            p1: _mhchemParser.go(m, 'o')
          };
        },
        'color-output': function (_buffer, m) {
          return {
            type_: 'color',
            color1: m[0],
            color2: _mhchemParser.go(m[1], 'pq')
          };
        }
      }
    },
    'bd': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: []
          }
        },
        'x$': {
          '0': {
            action_: [],
            nextState: '!f',
            revisit: true
          }
        },
        'formula$': {
          '0': {
            action_: [],
            nextState: 'f',
            revisit: true
          }
        },
        'else': {
          '0': {
            action_: [],
            nextState: '!f',
            revisit: true
          }
        },
        '-9.,9 no missing 0': {
          '*': {
            action_: '9,9'
          }
        },
        '.': {
          '*': {
            action_: {
              type_: 'insert',
              option: 'electron dot'
            }
          }
        },
        'a-z': {
          'f': {
            action_: 'tex-math'
          }
        },
        'x': {
          '*': {
            action_: {
              type_: 'insert',
              option: 'KV x'
            }
          }
        },
        'letters': {
          '*': {
            action_: 'rm'
          }
        },
        '\'': {
          '*': {
            action_: {
              type_: 'insert',
              option: 'prime'
            }
          }
        },
        '${(...)}$__$(...)$': {
          '*': {
            action_: 'tex-math'
          }
        },
        '{(...)}': {
          '*': {
            action_: 'text'
          }
        },
        '\\color{(...)}{(...)}': {
          '*': {
            action_: 'color-output'
          }
        },
        '\\color{(...)}': {
          '*': {
            action_: 'color0-output'
          }
        },
        '\\ce{(...)}': {
          '*': {
            action_: 'ce'
          }
        },
        '\\pu{(...)}': {
          '*': {
            action_: [{
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        '\\,|\\x{}{}|\\x{}|\\x': {
          '*': {
            action_: 'copy'
          }
        },
        'else2': {
          '*': {
            action_: 'copy'
          }
        }
      }),
      actions: {
        'color-output': function (_buffer, m) {
          return {
            type_: 'color',
            color1: m[0],
            color2: _mhchemParser.go(m[1], 'bd')
          };
        }
      }
    },
    'oxidation': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: 'roman-numeral'
          }
        },
        'pm-operator': {
          '*': {
            action_: {
              type_: 'o=+p1',
              option: "\\pm"
            }
          }
        },
        'else': {
          '*': {
            action_: 'o='
          }
        }
      }),
      actions: {
        'roman-numeral': function (buffer) {
          return {
            type_: 'roman numeral',
            p1: buffer.o || ""
          };
        }
      }
    },
    'tex-math': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: 'output'
          }
        },
        '\\ce{(...)}': {
          '*': {
            action_: ['output', 'ce']
          }
        },
        '\\pu{(...)}': {
          '*': {
            action_: ['output', {
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        '{...}|\\,|\\x{}{}|\\x{}|\\x': {
          '*': {
            action_: 'o='
          }
        },
        'else': {
          '*': {
            action_: 'o='
          }
        }
      }),
      actions: {
        'output': function (buffer) {
          if (buffer.o) {
            var ret = {
              type_: 'tex-math',
              p1: buffer.o
            };
            for (var p in buffer) {
              delete buffer[p];
            }
            return ret;
          }
          return undefined;
        }
      }
    },
    'tex-math tight': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: 'output'
          }
        },
        '\\ce{(...)}': {
          '*': {
            action_: ['output', 'ce']
          }
        },
        '\\pu{(...)}': {
          '*': {
            action_: ['output', {
              type_: 'write',
              option: "{"
            }, 'pu', {
              type_: 'write',
              option: "}"
            }]
          }
        },
        '{...}|\\,|\\x{}{}|\\x{}|\\x': {
          '*': {
            action_: 'o='
          }
        },
        '-|+': {
          '*': {
            action_: 'tight operator'
          }
        },
        'else': {
          '*': {
            action_: 'o='
          }
        }
      }),
      actions: {
        'tight operator': function (buffer, m) {
          buffer.o = (buffer.o || "") + "{" + m + "}";
          return undefined;
        },
        'output': function (buffer) {
          if (buffer.o) {
            var ret = {
              type_: 'tex-math',
              p1: buffer.o
            };
            for (var p in buffer) {
              delete buffer[p];
            }
            return ret;
          }
          return undefined;
        }
      }
    },
    '9,9': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: []
          }
        },
        ',': {
          '*': {
            action_: 'comma'
          }
        },
        'else': {
          '*': {
            action_: 'copy'
          }
        }
      }),
      actions: {
        'comma': function () {
          return {
            type_: 'commaDecimal'
          };
        }
      }
    },
    'pu': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: 'output'
          }
        },
        'space$': {
          '*': {
            action_: ['output', 'space']
          }
        },
        '{[(|)]}': {
          '0|a': {
            action_: 'copy'
          }
        },
        '(-)(9)^(-9)': {
          '0': {
            action_: 'number^',
            nextState: 'a'
          }
        },
        '(-)(9.,9)(e)(99)': {
          '0': {
            action_: 'enumber',
            nextState: 'a'
          }
        },
        'space': {
          '0|a': {
            action_: []
          }
        },
        'pm-operator': {
          '0|a': {
            action_: {
              type_: 'operator',
              option: '\\pm'
            },
            nextState: '0'
          }
        },
        'operator': {
          '0|a': {
            action_: 'copy',
            nextState: '0'
          }
        },
        '//': {
          'd': {
            action_: 'o=',
            nextState: '/'
          }
        },
        '/': {
          'd': {
            action_: 'o=',
            nextState: '/'
          }
        },
        '{...}|else': {
          '0|d': {
            action_: 'd=',
            nextState: 'd'
          },
          'a': {
            action_: ['space', 'd='],
            nextState: 'd'
          },
          '/|q': {
            action_: 'q=',
            nextState: 'q'
          }
        }
      }),
      actions: {
        'enumber': function (_buffer, m) {
          var ret = [];
          if (m[0] === "+-" || m[0] === "+/-") {
            ret.push("\\pm ");
          } else if (m[0]) {
            ret.push(m[0]);
          }
          if (m[1]) {
            _mhchemParser.concatArray(ret, _mhchemParser.go(m[1], 'pu-9,9'));
            if (m[2]) {
              if (m[2].match(/[,.]/)) {
                _mhchemParser.concatArray(ret, _mhchemParser.go(m[2], 'pu-9,9'));
              } else {
                ret.push(m[2]);
              }
            }
            if (m[3] || m[4]) {
              if (m[3] === "e" || m[4] === "*") {
                ret.push({
                  type_: 'cdot'
                });
              } else {
                ret.push({
                  type_: 'times'
                });
              }
            }
          }
          if (m[5]) {
            ret.push("10^{" + m[5] + "}");
          }
          return ret;
        },
        'number^': function (_buffer, m) {
          var ret = [];
          if (m[0] === "+-" || m[0] === "+/-") {
            ret.push("\\pm ");
          } else if (m[0]) {
            ret.push(m[0]);
          }
          _mhchemParser.concatArray(ret, _mhchemParser.go(m[1], 'pu-9,9'));
          ret.push("^{" + m[2] + "}");
          return ret;
        },
        'operator': function (_buffer, m, p1) {
          return {
            type_: 'operator',
            kind_: p1 || m
          };
        },
        'space': function () {
          return {
            type_: 'pu-space-1'
          };
        },
        'output': function (buffer) {
          var ret;
          var md = _mhchemParser.patterns.match_('{(...)}', buffer.d || "");
          if (md && md.remainder === '') {
            buffer.d = md.match_;
          }
          var mq = _mhchemParser.patterns.match_('{(...)}', buffer.q || "");
          if (mq && mq.remainder === '') {
            buffer.q = mq.match_;
          }
          if (buffer.d) {
            buffer.d = buffer.d.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C");
            buffer.d = buffer.d.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F");
          }
          if (buffer.q) {
            buffer.q = buffer.q.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C");
            buffer.q = buffer.q.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F");
            var b5 = {
              d: _mhchemParser.go(buffer.d, 'pu'),
              q: _mhchemParser.go(buffer.q, 'pu')
            };
            if (buffer.o === '//') {
              ret = {
                type_: 'pu-frac',
                p1: b5.d,
                p2: b5.q
              };
            } else {
              ret = b5.d;
              if (b5.d.length > 1 || b5.q.length > 1) {
                ret.push({
                  type_: ' / '
                });
              } else {
                ret.push({
                  type_: '/'
                });
              }
              _mhchemParser.concatArray(ret, b5.q);
            }
          } else {
            ret = _mhchemParser.go(buffer.d, 'pu-2');
          }
          for (var p in buffer) {
            delete buffer[p];
          }
          return ret;
        }
      }
    },
    'pu-2': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '*': {
            action_: 'output'
          }
        },
        '*': {
          '*': {
            action_: ['output', 'cdot'],
            nextState: '0'
          }
        },
        '\\x': {
          '*': {
            action_: 'rm='
          }
        },
        'space': {
          '*': {
            action_: ['output', 'space'],
            nextState: '0'
          }
        },
        '^{(...)}|^(-1)': {
          '1': {
            action_: '^(-1)'
          }
        },
        '-9.,9': {
          '0': {
            action_: 'rm=',
            nextState: '0'
          },
          '1': {
            action_: '^(-1)',
            nextState: '0'
          }
        },
        '{...}|else': {
          '*': {
            action_: 'rm=',
            nextState: '1'
          }
        }
      }),
      actions: {
        'cdot': function () {
          return {
            type_: 'tight cdot'
          };
        },
        '^(-1)': function (buffer, m) {
          buffer.rm += "^{" + m + "}";
          return undefined;
        },
        'space': function () {
          return {
            type_: 'pu-space-2'
          };
        },
        'output': function (buffer) {
          var ret = [];
          if (buffer.rm) {
            var mrm = _mhchemParser.patterns.match_('{(...)}', buffer.rm || "");
            if (mrm && mrm.remainder === '') {
              ret = _mhchemParser.go(mrm.match_, 'pu');
            } else {
              ret = {
                type_: 'rm',
                p1: buffer.rm
              };
            }
          }
          for (var p in buffer) {
            delete buffer[p];
          }
          return ret;
        }
      }
    },
    'pu-9,9': {
      transitions: _mhchemCreateTransitions({
        'empty': {
          '0': {
            action_: 'output-0'
          },
          'o': {
            action_: 'output-o'
          }
        },
        ',': {
          '0': {
            action_: ['output-0', 'comma'],
            nextState: 'o'
          }
        },
        '.': {
          '0': {
            action_: ['output-0', 'copy'],
            nextState: 'o'
          }
        },
        'else': {
          '*': {
            action_: 'text='
          }
        }
      }),
      actions: {
        'comma': function () {
          return {
            type_: 'commaDecimal'
          };
        },
        'output-0': function (buffer) {
          var ret = [];
          buffer.text_ = buffer.text_ || "";
          if (buffer.text_.length > 4) {
            var a = buffer.text_.length % 3;
            if (a === 0) {
              a = 3;
            }
            for (var i = buffer.text_.length - 3; i > 0; i -= 3) {
              ret.push(buffer.text_.substr(i, 3));
              ret.push({
                type_: '1000 separator'
              });
            }
            ret.push(buffer.text_.substr(0, a));
            ret.reverse();
          } else {
            ret.push(buffer.text_);
          }
          for (var p in buffer) {
            delete buffer[p];
          }
          return ret;
        },
        'output-o': function (buffer) {
          var ret = [];
          buffer.text_ = buffer.text_ || "";
          if (buffer.text_.length > 4) {
            var a = buffer.text_.length - 3;
            var i = void 0;
            for (i = 0; i < a; i += 3) {
              ret.push(buffer.text_.substr(i, 3));
              ret.push({
                type_: '1000 separator'
              });
            }
            ret.push(buffer.text_.substr(i));
          } else {
            ret.push(buffer.text_);
          }
          for (var p in buffer) {
            delete buffer[p];
          }
          return ret;
        }
      }
    }
  }
};
var _mhchemTexify = {
  go: function (input, addOuterBraces) {
    if (!input) {
      return "";
    }
    var res = "";
    var cee = false;
    for (var i = 0; i < input.length; i++) {
      var inputi = input[i];
      if (typeof inputi === "string") {
        res += inputi;
      } else {
        res += _mhchemTexify._go2(inputi);
        if (inputi.type_ === '1st-level escape') {
          cee = true;
        }
      }
    }
    if (addOuterBraces && !cee && res) {
      res = "{" + res + "}";
    }
    return res;
  },
  _goInner: function (input) {
    return _mhchemTexify.go(input, false);
  },
  _go2: function (buf) {
    var res;
    switch (buf.type_) {
      case 'chemfive':
        res = "";
        var b5 = {
          a: _mhchemTexify._goInner(buf.a),
          b: _mhchemTexify._goInner(buf.b),
          p: _mhchemTexify._goInner(buf.p),
          o: _mhchemTexify._goInner(buf.o),
          q: _mhchemTexify._goInner(buf.q),
          d: _mhchemTexify._goInner(buf.d)
        };
        if (b5.a) {
          if (b5.a.match(/^[+\-]/)) {
            b5.a = "{" + b5.a + "}";
          }
          res += b5.a + "\\,";
        }
        if (b5.b || b5.p) {
          res += "{\\vphantom{A}}";
          res += "^{\\hphantom{" + (b5.b || "") + "}}_{\\hphantom{" + (b5.p || "") + "}}";
          res += "\\mkern-1.5mu";
          res += "{\\vphantom{A}}";
          res += "^{\\smash[t]{\\vphantom{2}}\\llap{" + (b5.b || "") + "}}";
          res += "_{\\vphantom{2}\\llap{\\smash[t]{" + (b5.p || "") + "}}}";
        }
        if (b5.o) {
          if (b5.o.match(/^[+\-]/)) {
            b5.o = "{" + b5.o + "}";
          }
          res += b5.o;
        }
        if (buf.dType === 'kv') {
          if (b5.d || b5.q) {
            res += "{\\vphantom{A}}";
          }
          if (b5.d) {
            res += "^{" + b5.d + "}";
          }
          if (b5.q) {
            res += "_{\\smash[t]{" + b5.q + "}}";
          }
        } else if (buf.dType === 'oxidation') {
          if (b5.d) {
            res += "{\\vphantom{A}}";
            res += "^{" + b5.d + "}";
          }
          if (b5.q) {
            res += "{\\vphantom{A}}";
            res += "_{\\smash[t]{" + b5.q + "}}";
          }
        } else {
          if (b5.q) {
            res += "{\\vphantom{A}}";
            res += "_{\\smash[t]{" + b5.q + "}}";
          }
          if (b5.d) {
            res += "{\\vphantom{A}}";
            res += "^{" + b5.d + "}";
          }
        }
        break;
      case 'rm':
        res = "\\mathrm{" + buf.p1 + "}";
        break;
      case 'text':
        if (buf.p1.match(/[\^_]/)) {
          buf.p1 = buf.p1.replace(" ", "~").replace("-", "\\text{-}");
          res = "\\mathrm{" + buf.p1 + "}";
        } else {
          res = "\\text{" + buf.p1 + "}";
        }
        break;
      case 'roman numeral':
        res = "\\mathrm{" + buf.p1 + "}";
        break;
      case 'state of aggregation':
        res = "\\mskip2mu " + _mhchemTexify._goInner(buf.p1);
        break;
      case 'state of aggregation subscript':
        res = "\\mskip1mu " + _mhchemTexify._goInner(buf.p1);
        break;
      case 'bond':
        res = _mhchemTexify._getBond(buf.kind_);
        if (!res) {
          throw ["MhchemErrorBond", "mhchem Error. Unknown bond type (" + buf.kind_ + ")"];
        }
        break;
      case 'frac':
        var c = "\\frac{" + buf.p1 + "}{" + buf.p2 + "}";
        res = "\\mathchoice{\\textstyle" + c + "}{" + c + "}{" + c + "}{" + c + "}";
        break;
      case 'pu-frac':
        var d = "\\frac{" + _mhchemTexify._goInner(buf.p1) + "}{" + _mhchemTexify._goInner(buf.p2) + "}";
        res = "\\mathchoice{\\textstyle" + d + "}{" + d + "}{" + d + "}{" + d + "}";
        break;
      case 'tex-math':
        res = buf.p1 + " ";
        break;
      case 'frac-ce':
        res = "\\frac{" + _mhchemTexify._goInner(buf.p1) + "}{" + _mhchemTexify._goInner(buf.p2) + "}";
        break;
      case 'overset':
        res = "\\overset{" + _mhchemTexify._goInner(buf.p1) + "}{" + _mhchemTexify._goInner(buf.p2) + "}";
        break;
      case 'underset':
        res = "\\underset{" + _mhchemTexify._goInner(buf.p1) + "}{" + _mhchemTexify._goInner(buf.p2) + "}";
        break;
      case 'underbrace':
        res = "\\underbrace{" + _mhchemTexify._goInner(buf.p1) + "}_{" + _mhchemTexify._goInner(buf.p2) + "}";
        break;
      case 'color':
        res = "{\\color{" + buf.color1 + "}{" + _mhchemTexify._goInner(buf.color2) + "}}";
        break;
      case 'color0':
        res = "\\color{" + buf.color + "}";
        break;
      case 'arrow':
        var b6 = {
          rd: _mhchemTexify._goInner(buf.rd),
          rq: _mhchemTexify._goInner(buf.rq)
        };
        var arrow = _mhchemTexify._getArrow(buf.r);
        if (b6.rd || b6.rq) {
          if (buf.r === "<=>" || buf.r === "<=>>" || buf.r === "<<=>" || buf.r === "<-->") {
            arrow = "\\long" + arrow;
            if (b6.rd) {
              arrow = "\\overset{" + b6.rd + "}{" + arrow + "}";
            }
            if (b6.rq) {
              if (buf.r === "<-->") {
                arrow = "\\underset{\\lower2mu{" + b6.rq + "}}{" + arrow + "}";
              } else {
                arrow = "\\underset{\\lower6mu{" + b6.rq + "}}{" + arrow + "}";
              }
            }
            arrow = " {}\\mathrel{" + arrow + "}{} ";
          } else {
            if (b6.rq) {
              arrow += "[{" + b6.rq + "}]";
            }
            arrow += "{" + b6.rd + "}";
            arrow = " {}\\mathrel{\\x" + arrow + "}{} ";
          }
        } else {
          arrow = " {}\\mathrel{\\long" + arrow + "}{} ";
        }
        res = arrow;
        break;
      case 'operator':
        res = _mhchemTexify._getOperator(buf.kind_);
        break;
      case '1st-level escape':
        res = buf.p1 + " ";
        break;
      case 'space':
        res = " ";
        break;
      case 'tinySkip':
        res = '\\mkern2mu';
        break;
      case 'entitySkip':
        res = "~";
        break;
      case 'pu-space-1':
        res = "~";
        break;
      case 'pu-space-2':
        res = "\\mkern3mu ";
        break;
      case '1000 separator':
        res = "\\mkern2mu ";
        break;
      case 'commaDecimal':
        res = "{,}";
        break;
      case 'comma enumeration L':
        res = "{" + buf.p1 + "}\\mkern6mu ";
        break;
      case 'comma enumeration M':
        res = "{" + buf.p1 + "}\\mkern3mu ";
        break;
      case 'comma enumeration S':
        res = "{" + buf.p1 + "}\\mkern1mu ";
        break;
      case 'hyphen':
        res = "\\text{-}";
        break;
      case 'addition compound':
        res = "\\,{\\cdot}\\,";
        break;
      case 'electron dot':
        res = "\\mkern1mu \\bullet\\mkern1mu ";
        break;
      case 'KV x':
        res = "{\\times}";
        break;
      case 'prime':
        res = "\\prime ";
        break;
      case 'cdot':
        res = "\\cdot ";
        break;
      case 'tight cdot':
        res = "\\mkern1mu{\\cdot}\\mkern1mu ";
        break;
      case 'times':
        res = "\\times ";
        break;
      case 'circa':
        res = "{\\sim}";
        break;
      case '^':
        res = "uparrow";
        break;
      case 'v':
        res = "downarrow";
        break;
      case 'ellipsis':
        res = "\\ldots ";
        break;
      case '/':
        res = "/";
        break;
      case ' / ':
        res = "\\,/\\,";
        break;
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
    return res;
  },
  _getArrow: function (a) {
    switch (a) {
      case "->":
        return "rightarrow";
      case "\u2192":
        return "rightarrow";
      case "\u27F6":
        return "rightarrow";
      case "<-":
        return "leftarrow";
      case "<->":
        return "leftrightarrow";
      case "<-->":
        return "leftrightarrows";
      case "<=>":
        return "rightleftharpoons";
      case "\u21CC":
        return "rightleftharpoons";
      case "<=>>":
        return "Rightleftharpoons";
      case "<<=>":
        return "Leftrightharpoons";
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
  },
  _getBond: function (a) {
    switch (a) {
      case "-":
        return "{-}";
      case "1":
        return "{-}";
      case "=":
        return "{=}";
      case "2":
        return "{=}";
      case "#":
        return "{\\equiv}";
      case "3":
        return "{\\equiv}";
      case "~":
        return "{\\tripledash}";
      case "~-":
        return "{\\rlap{\\lower.1em{-}}\\raise.1em{\\tripledash}}";
      case "~=":
        return "{\\rlap{\\lower.2em{-}}\\rlap{\\raise.2em{\\tripledash}}-}";
      case "~--":
        return "{\\rlap{\\lower.2em{-}}\\rlap{\\raise.2em{\\tripledash}}-}";
      case "-~-":
        return "{\\rlap{\\lower.2em{-}}\\rlap{\\raise.2em{-}}\\tripledash}";
      case "...":
        return "{{\\cdot}{\\cdot}{\\cdot}}";
      case "....":
        return "{{\\cdot}{\\cdot}{\\cdot}{\\cdot}}";
      case "->":
        return "{\\rightarrow}";
      case "<-":
        return "{\\leftarrow}";
      case "<":
        return "{<}";
      case ">":
        return "{>}";
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
  },
  _getOperator: function (a) {
    switch (a) {
      case "+":
        return " {}+{} ";
      case "-":
        return " {}-{} ";
      case "=":
        return " {}={} ";
      case "<":
        return " {}<{} ";
      case ">":
        return " {}>{} ";
      case "<<":
        return " {}\\ll{} ";
      case ">>":
        return " {}\\gg{} ";
      case "\\pm":
        return " {}\\pm{} ";
      case "\\approx":
        return " {}\\approx{} ";
      case "$\\approx$":
        return " {}\\approx{} ";
      case "v":
        return " \\downarrow{} ";
      case "(v)":
        return " \\downarrow{} ";
      case "^":
        return " \\uparrow{} ";
      case "(^)":
        return " \\uparrow{} ";
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
  }
};

var __importDefault$7 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(MhchemConfiguration, "__esModule", {
  value: true
});
MhchemConfiguration.MhchemConfiguration = void 0;
var Configuration_js_1$7 = Configuration;
var SymbolMap_js_1$4 = SymbolMap;
var TexError_js_1$2 = __importDefault$7(TexError$1);
var BaseMethods_js_1$2 = __importDefault$7(BaseMethods$1);
var AmsMethods_js_1 = AmsMethods;
var mhchemParser_js_1 = mhchemParser$1;
var MhchemMethods = {};
MhchemMethods.Macro = BaseMethods_js_1$2.default.Macro;
MhchemMethods.xArrow = AmsMethods_js_1.AmsMethods.xArrow;
MhchemMethods.Machine = function (parser, name, machine) {
  var arg = parser.GetArgument(name);
  var tex;
  try {
    tex = mhchemParser_js_1.mhchemParser.toTex(arg, machine);
  } catch (err) {
    throw new TexError_js_1$2.default(err[0], err[1]);
  }
  parser.string = tex + parser.string.substr(parser.i);
  parser.i = 0;
};
new SymbolMap_js_1$4.CommandMap('mhchem', {
  ce: ['Machine', 'ce'],
  pu: ['Machine', 'pu'],
  longrightleftharpoons: ['Macro', '\\stackrel{\\textstyle{-}\\!\\!{\\rightharpoonup}}{\\smash{{\\leftharpoondown}\\!\\!{-}}}'],
  longRightleftharpoons: ['Macro', '\\stackrel{\\textstyle{-}\\!\\!{\\rightharpoonup}}{\\smash{\\leftharpoondown}}'],
  longLeftrightharpoons: ['Macro', '\\stackrel{\\textstyle\\vphantom{{-}}{\\rightharpoonup}}{\\smash{{\\leftharpoondown}\\!\\!{-}}}'],
  longleftrightarrows: ['Macro', '\\stackrel{\\longrightarrow}{\\smash{\\longleftarrow}\\Rule{0px}{.25em}{0px}}'],
  tripledash: ['Macro', '\\vphantom{-}\\raise2mu{\\kern2mu\\tiny\\text{-}\\kern1mu\\text{-}\\kern1mu\\text{-}\\kern2mu}'],
  xleftrightarrow: ['xArrow', 0x2194, 6, 6],
  xrightleftharpoons: ['xArrow', 0x21CC, 5, 7],
  xRightleftharpoons: ['xArrow', 0x21CC, 5, 7],
  xLeftrightharpoons: ['xArrow', 0x21CC, 5, 7]
}, MhchemMethods);
MhchemConfiguration.MhchemConfiguration = Configuration_js_1$7.Configuration.create('mhchem', {
  handler: {
    macro: ['mhchem']
  }
});

var NoErrorsConfiguration = {};

Object.defineProperty(NoErrorsConfiguration, "__esModule", {
  value: true
});
NoErrorsConfiguration.NoErrorsConfiguration = void 0;
var Configuration_js_1$6 = Configuration;
function noErrors(factory, message, _id, expr) {
  var mtext = factory.create('token', 'mtext', {}, expr.replace(/\n/g, ' '));
  var error = factory.create('node', 'merror', [mtext], {
    'data-mjx-error': message,
    title: message
  });
  return error;
}
NoErrorsConfiguration.NoErrorsConfiguration = Configuration_js_1$6.Configuration.create('noerrors', {
  nodes: {
    'error': noErrors
  }
});

var NoUndefinedConfiguration = {};

var __values$1 = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
Object.defineProperty(NoUndefinedConfiguration, "__esModule", {
  value: true
});
NoUndefinedConfiguration.NoUndefinedConfiguration = void 0;
var Configuration_js_1$5 = Configuration;
function noUndefined(parser, name) {
  var e_1, _a;
  var textNode = parser.create('text', '\\' + name);
  var options = parser.options.noundefined || ({});
  var def = {};
  try {
    for (var _b = __values$1(['color', 'background', 'size']), _c = _b.next(); !_c.done; _c = _b.next()) {
      var id = _c.value;
      if (options[id]) {
        def['math' + id] = options[id];
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  parser.Push(parser.create('node', 'mtext', [], def, textNode));
}
NoUndefinedConfiguration.NoUndefinedConfiguration = Configuration_js_1$5.Configuration.create('noundefined', {
  fallback: {
    macro: noUndefined
  },
  options: {
    noundefined: {
      color: 'red',
      background: '',
      size: ''
    }
  },
  priority: 3
});

var PhysicsConfiguration = {};

var PhysicsItems = {};

var __extends$2 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __importDefault$6 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(PhysicsItems, "__esModule", {
  value: true
});
PhysicsItems.AutoOpen = void 0;
var StackItem_js_1 = StackItem;
var ParseUtil_js_1$3 = __importDefault$6(ParseUtil$1);
var NodeUtil_js_1$2 = __importDefault$6(NodeUtil$1);
var TexParser_js_1$3 = __importDefault$6(TexParser$1);
var AutoOpen = (function (_super) {
  __extends$2(AutoOpen, _super);
  function AutoOpen() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.openCount = 0;
    return _this;
  }
  Object.defineProperty(AutoOpen.prototype, "kind", {
    get: function () {
      return 'auto open';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AutoOpen.prototype, "isOpen", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  AutoOpen.prototype.toMml = function () {
    var parser = this.factory.configuration.parser;
    var right = this.getProperty('right');
    if (this.getProperty('smash')) {
      var mml_1 = _super.prototype.toMml.call(this);
      var smash = parser.create('node', 'mpadded', [mml_1], {
        height: 0,
        depth: 0
      });
      this.Clear();
      this.Push(parser.create('node', 'TeXAtom', [smash]));
    }
    if (right) {
      this.Push(new TexParser_js_1$3.default(right, parser.stack.env, parser.configuration).mml());
    }
    var mml = ParseUtil_js_1$3.default.fenced(this.factory.configuration, this.getProperty('open'), _super.prototype.toMml.call(this), this.getProperty('close'), this.getProperty('big'));
    NodeUtil_js_1$2.default.removeProperties(mml, 'open', 'close', 'texClass');
    return mml;
  };
  AutoOpen.prototype.checkItem = function (item) {
    if (item.isKind('mml') && item.Size() === 1) {
      var mml = item.toMml();
      if (mml.isKind('mo') && mml.getText() === this.getProperty('open')) {
        this.openCount++;
      }
    }
    var close = item.getProperty('autoclose');
    if (close && close === this.getProperty('close') && !this.openCount--) {
      if (this.getProperty('ignore')) {
        this.Clear();
        return [[], true];
      }
      return [[this.toMml()], true];
    }
    return _super.prototype.checkItem.call(this, item);
  };
  AutoOpen.errors = Object.assign(Object.create(StackItem_js_1.BaseItem.errors), {
    'stop': ['ExtraOrMissingDelims', 'Extra open or missing close delimiter']
  });
  return AutoOpen;
})(StackItem_js_1.BaseItem);
PhysicsItems.AutoOpen = AutoOpen;

var PhysicsMethods$1 = {};

var __read$1 = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __importDefault$5 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(PhysicsMethods$1, "__esModule", {
  value: true
});
var BaseMethods_js_1$1 = __importDefault$5(BaseMethods$1);
var TexParser_js_1$2 = __importDefault$5(TexParser$1);
var TexError_js_1$1 = __importDefault$5(TexError$1);
var MmlNode_js_1$2 = MmlNode;
var ParseUtil_js_1$2 = __importDefault$5(ParseUtil$1);
var NodeUtil_js_1$1 = __importDefault$5(NodeUtil$1);
var NodeFactory_js_1 = NodeFactory$1;
var PhysicsMethods = {};
var pairs = {
  '(': ')',
  '[': ']',
  '{': '}',
  '|': '|'
};
var biggs = /^(b|B)i(g{1,2})$/;
PhysicsMethods.Quantity = function (parser, name, open, close, arg, named, variant) {
  if (open === void 0) {
    open = '(';
  }
  if (close === void 0) {
    close = ')';
  }
  if (arg === void 0) {
    arg = false;
  }
  if (named === void 0) {
    named = '';
  }
  if (variant === void 0) {
    variant = '';
  }
  var star = arg ? parser.GetStar() : false;
  var next = parser.GetNext();
  var position = parser.i;
  var big = null;
  if (next === '\\') {
    parser.i++;
    big = parser.GetCS();
    if (!big.match(biggs)) {
      var empty = parser.create('node', 'mrow');
      parser.Push(ParseUtil_js_1$2.default.fenced(parser.configuration, open, empty, close));
      parser.i = position;
      return;
    }
    next = parser.GetNext();
  }
  var right = pairs[next];
  if (arg && next !== '{') {
    throw new TexError_js_1$1.default('MissingArgFor', 'Missing argument for %1', parser.currentCS);
  }
  if (!right) {
    var empty = parser.create('node', 'mrow');
    parser.Push(ParseUtil_js_1$2.default.fenced(parser.configuration, open, empty, close));
    parser.i = position;
    return;
  }
  if (named) {
    var mml = parser.create('token', 'mi', {
      texClass: MmlNode_js_1$2.TEXCLASS.OP
    }, named);
    if (variant) {
      NodeUtil_js_1$1.default.setAttribute(mml, 'mathvariant', variant);
    }
    parser.Push(parser.itemFactory.create('fn', mml));
  }
  if (next === '{') {
    var argument = parser.GetArgument(name);
    next = arg ? open : '\\{';
    right = arg ? close : '\\}';
    argument = star ? next + ' ' + argument + ' ' + right : big ? '\\' + big + 'l' + next + ' ' + argument + ' ' + '\\' + big + 'r' + right : '\\left' + next + ' ' + argument + ' ' + '\\right' + right;
    parser.Push(new TexParser_js_1$2.default(argument, parser.stack.env, parser.configuration).mml());
    return;
  }
  if (arg) {
    next = open;
    right = close;
  }
  parser.i++;
  parser.Push(parser.itemFactory.create('auto open').setProperties({
    open: next,
    close: right,
    big: big
  }));
};
PhysicsMethods.Eval = function (parser, name) {
  var star = parser.GetStar();
  var next = parser.GetNext();
  if (next === '{') {
    var arg = parser.GetArgument(name);
    var replace = '\\left. ' + (star ? '\\smash{' + arg + '}' : arg) + ' ' + '\\vphantom{\\int}\\right|';
    parser.string = parser.string.slice(0, parser.i) + replace + parser.string.slice(parser.i);
    return;
  }
  if (next === '(' || next === '[') {
    parser.i++;
    parser.Push(parser.itemFactory.create('auto open').setProperties({
      open: next,
      close: '|',
      smash: star,
      right: '\\vphantom{\\int}'
    }));
    return;
  }
  throw new TexError_js_1$1.default('MissingArgFor', 'Missing argument for %1', parser.currentCS);
};
PhysicsMethods.Commutator = function (parser, name, open, close) {
  if (open === void 0) {
    open = '[';
  }
  if (close === void 0) {
    close = ']';
  }
  var star = parser.GetStar();
  var next = parser.GetNext();
  var big = null;
  if (next === '\\') {
    parser.i++;
    big = parser.GetCS();
    if (!big.match(biggs)) {
      throw new TexError_js_1$1.default('MissingArgFor', 'Missing argument for %1', parser.currentCS);
    }
    next = parser.GetNext();
  }
  if (next !== '{') {
    throw new TexError_js_1$1.default('MissingArgFor', 'Missing argument for %1', parser.currentCS);
  }
  var arg1 = parser.GetArgument(name);
  var arg2 = parser.GetArgument(name);
  var argument = arg1 + ',' + arg2;
  argument = star ? open + ' ' + argument + ' ' + close : big ? '\\' + big + 'l' + open + ' ' + argument + ' ' + '\\' + big + 'r' + close : '\\left' + open + ' ' + argument + ' ' + '\\right' + close;
  parser.Push(new TexParser_js_1$2.default(argument, parser.stack.env, parser.configuration).mml());
};
var latinCap = [0x41, 0x5A];
var latinSmall = [0x61, 0x7A];
var greekCap = [0x391, 0x3A9];
var greekSmall = [0x3B1, 0x3C9];
var digits = [0x30, 0x39];
function inRange(value, range) {
  return value >= range[0] && value <= range[1];
}
function createVectorToken(factory, kind, def, text) {
  var parser = factory.configuration.parser;
  var token = NodeFactory_js_1.NodeFactory.createToken(factory, kind, def, text);
  var code = text.codePointAt(0);
  if (text.length === 1 && !parser.stack.env.font && parser.stack.env.vectorFont && (inRange(code, latinCap) || inRange(code, latinSmall) || inRange(code, greekCap) || inRange(code, digits) || inRange(code, greekSmall) && parser.stack.env.vectorStar || NodeUtil_js_1$1.default.getAttribute(token, 'accent'))) {
    NodeUtil_js_1$1.default.setAttribute(token, 'mathvariant', parser.stack.env.vectorFont);
  }
  return token;
}
PhysicsMethods.VectorBold = function (parser, name) {
  var star = parser.GetStar();
  var arg = parser.GetArgument(name);
  var oldToken = parser.configuration.nodeFactory.get('token');
  var oldFont = parser.stack.env.font;
  delete parser.stack.env.font;
  parser.configuration.nodeFactory.set('token', createVectorToken);
  parser.stack.env.vectorFont = star ? 'bold-italic' : 'bold';
  parser.stack.env.vectorStar = star;
  var node = new TexParser_js_1$2.default(arg, parser.stack.env, parser.configuration).mml();
  if (oldFont) {
    parser.stack.env.font = oldFont;
  }
  delete parser.stack.env.vectorFont;
  delete parser.stack.env.vectorStar;
  parser.configuration.nodeFactory.set('token', oldToken);
  parser.Push(node);
};
PhysicsMethods.StarMacro = function (parser, name, argcount) {
  var parts = [];
  for (var _i = 3; _i < arguments.length; _i++) {
    parts[_i - 3] = arguments[_i];
  }
  var star = parser.GetStar();
  var args = [];
  if (argcount) {
    for (var i = args.length; i < argcount; i++) {
      args.push(parser.GetArgument(name));
    }
  }
  var macro = parts.join(star ? '*' : '');
  macro = ParseUtil_js_1$2.default.substituteArgs(parser, args, macro);
  parser.string = ParseUtil_js_1$2.default.addArgs(parser, macro, parser.string.slice(parser.i));
  parser.i = 0;
  ParseUtil_js_1$2.default.checkMaxMacros(parser);
};
var vectorApplication = function (parser, kind, name, operator, fences) {
  var op = new TexParser_js_1$2.default(operator, parser.stack.env, parser.configuration).mml();
  parser.Push(parser.itemFactory.create(kind, op));
  var left = parser.GetNext();
  var right = pairs[left];
  if (!right) {
    return;
  }
  var lfence = '', rfence = '', arg = '';
  var enlarge = fences.indexOf(left) !== -1;
  if (left === '{') {
    arg = parser.GetArgument(name);
    lfence = enlarge ? '\\left\\{' : '';
    rfence = enlarge ? '\\right\\}' : '';
    var macro = lfence + ' ' + arg + ' ' + rfence;
    parser.string = macro + parser.string.slice(parser.i);
    parser.i = 0;
    return;
  }
  if (!enlarge) {
    return;
  }
  parser.i++;
  parser.Push(parser.itemFactory.create('auto open').setProperties({
    open: left,
    close: right
  }));
};
PhysicsMethods.OperatorApplication = function (parser, name, operator) {
  var fences = [];
  for (var _i = 3; _i < arguments.length; _i++) {
    fences[_i - 3] = arguments[_i];
  }
  vectorApplication(parser, 'fn', name, operator, fences);
};
PhysicsMethods.VectorOperator = function (parser, name, operator) {
  var fences = [];
  for (var _i = 3; _i < arguments.length; _i++) {
    fences[_i - 3] = arguments[_i];
  }
  vectorApplication(parser, 'mml', name, operator, fences);
};
PhysicsMethods.Expression = function (parser, name, opt, id) {
  if (opt === void 0) {
    opt = true;
  }
  if (id === void 0) {
    id = '';
  }
  id = id || name.slice(1);
  var exp = opt ? parser.GetBrackets(name) : null;
  var mml = parser.create('token', 'mi', {
    texClass: MmlNode_js_1$2.TEXCLASS.OP
  }, id);
  if (exp) {
    var sup = new TexParser_js_1$2.default(exp, parser.stack.env, parser.configuration).mml();
    mml = parser.create('node', 'msup', [mml, sup]);
  }
  parser.Push(parser.itemFactory.create('fn', mml));
  if (parser.GetNext() !== '(') {
    return;
  }
  parser.i++;
  parser.Push(parser.itemFactory.create('auto open').setProperties({
    open: '(',
    close: ')'
  }));
};
PhysicsMethods.Qqtext = function (parser, name, text) {
  var star = parser.GetStar();
  var arg = text ? text : parser.GetArgument(name);
  var replace = (star ? '' : '\\quad') + '\\text{' + arg + '}\\quad ';
  parser.string = parser.string.slice(0, parser.i) + replace + parser.string.slice(parser.i);
};
PhysicsMethods.Differential = function (parser, name, op) {
  var optArg = parser.GetBrackets(name);
  var power = optArg != null ? '^{' + optArg + '}' : ' ';
  var parens = parser.GetNext() === '(';
  var braces = parser.GetNext() === '{';
  var macro = op + power;
  if (!(parens || braces)) {
    macro += parser.GetArgument(name, true) || '';
    var mml = new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml();
    parser.Push(mml);
    return;
  }
  if (braces) {
    macro += parser.GetArgument(name);
    var mml = new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml();
    parser.Push(parser.create('node', 'TeXAtom', [mml], {
      texClass: MmlNode_js_1$2.TEXCLASS.OP
    }));
    return;
  }
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
  parser.i++;
  parser.Push(parser.itemFactory.create('auto open').setProperties({
    open: '(',
    close: ')'
  }));
};
PhysicsMethods.Derivative = function (parser, name, argMax, op) {
  var star = parser.GetStar();
  var optArg = parser.GetBrackets(name);
  var argCounter = 1;
  var args = [];
  args.push(parser.GetArgument(name));
  while (parser.GetNext() === '{' && argCounter < argMax) {
    args.push(parser.GetArgument(name));
    argCounter++;
  }
  var ignore = false;
  var power1 = ' ';
  var power2 = ' ';
  if (argMax > 2 && args.length > 2) {
    power1 = '^{' + (args.length - 1) + '}';
    ignore = true;
  } else if (optArg != null) {
    if (argMax > 2 && args.length > 1) {
      ignore = true;
    }
    power1 = '^{' + optArg + '}';
    power2 = power1;
  }
  var frac = star ? '\\flatfrac' : '\\frac';
  var first = args.length > 1 ? args[0] : '';
  var second = args.length > 1 ? args[1] : args[0];
  var rest = '';
  for (var i = 2, arg = void 0; arg = args[i]; i++) {
    rest += op + ' ' + arg;
  }
  var macro = frac + '{' + op + power1 + first + '}' + '{' + op + ' ' + second + power2 + ' ' + rest + '}';
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
  if (parser.GetNext() === '(') {
    parser.i++;
    parser.Push(parser.itemFactory.create('auto open').setProperties({
      open: '(',
      close: ')',
      ignore: ignore
    }));
  }
};
PhysicsMethods.Bra = function (parser, name) {
  var starBra = parser.GetStar();
  var bra = parser.GetArgument(name);
  var ket = '';
  var hasKet = false;
  var starKet = false;
  if (parser.GetNext() === '\\') {
    var saveI = parser.i;
    parser.i++;
    var cs = parser.GetCS();
    var symbol = parser.lookup('macro', cs);
    if (symbol && symbol.symbol === 'ket') {
      hasKet = true;
      saveI = parser.i;
      starKet = parser.GetStar();
      if (parser.GetNext() === '{') {
        ket = parser.GetArgument(cs, true);
      } else {
        parser.i = saveI;
        starKet = false;
      }
    } else {
      parser.i = saveI;
    }
  }
  var macro = '';
  if (hasKet) {
    macro = starBra || starKet ? ("\\langle{").concat(bra, "}\\vert{").concat(ket, "}\\rangle") : ("\\left\\langle{").concat(bra, "}\\middle\\vert{").concat(ket, "}\\right\\rangle");
  } else {
    macro = starBra || starKet ? ("\\langle{").concat(bra, "}\\vert") : ("\\left\\langle{").concat(bra, "}\\right\\vert{").concat(ket, "}");
  }
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.Ket = function (parser, name) {
  var star = parser.GetStar();
  var ket = parser.GetArgument(name);
  var macro = star ? ("\\vert{").concat(ket, "}\\rangle") : ("\\left\\vert{").concat(ket, "}\\right\\rangle");
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.BraKet = function (parser, name) {
  var star = parser.GetStar();
  var bra = parser.GetArgument(name);
  var ket = null;
  if (parser.GetNext() === '{') {
    ket = parser.GetArgument(name, true);
  }
  var macro = '';
  if (ket == null) {
    macro = star ? ("\\langle{").concat(bra, "}\\vert{").concat(bra, "}\\rangle") : ("\\left\\langle{").concat(bra, "}\\middle\\vert{").concat(bra, "}\\right\\rangle");
  } else {
    macro = star ? ("\\langle{").concat(bra, "}\\vert{").concat(ket, "}\\rangle") : ("\\left\\langle{").concat(bra, "}\\middle\\vert{").concat(ket, "}\\right\\rangle");
  }
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.KetBra = function (parser, name) {
  var star = parser.GetStar();
  var ket = parser.GetArgument(name);
  var bra = null;
  if (parser.GetNext() === '{') {
    bra = parser.GetArgument(name, true);
  }
  var macro = '';
  if (bra == null) {
    macro = star ? ("\\vert{").concat(ket, "}\\rangle\\!\\langle{").concat(ket, "}\\vert") : ("\\left\\vert{").concat(ket, "}\\middle\\rangle\\!\\middle\\langle{").concat(ket, "}\\right\\vert");
  } else {
    macro = star ? ("\\vert{").concat(ket, "}\\rangle\\!\\langle{").concat(bra, "}\\vert") : ("\\left\\vert{").concat(ket, "}\\middle\\rangle\\!\\middle\\langle{").concat(bra, "}\\right\\vert");
  }
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
};
function outputBraket(_a, star1, star2) {
  var _b = __read$1(_a, 3), arg1 = _b[0], arg2 = _b[1], arg3 = _b[2];
  return star1 && star2 ? ("\\left\\langle{").concat(arg1, "}\\middle\\vert{").concat(arg2, "}\\middle\\vert{").concat(arg3, "}\\right\\rangle") : star1 ? ("\\langle{").concat(arg1, "}\\vert{").concat(arg2, "}\\vert{").concat(arg3, "}\\rangle") : ("\\left\\langle{").concat(arg1, "}\\right\\vert{").concat(arg2, "}\\left\\vert{").concat(arg3, "}\\right\\rangle");
}
PhysicsMethods.Expectation = function (parser, name) {
  var star1 = parser.GetStar();
  var star2 = star1 && parser.GetStar();
  var arg1 = parser.GetArgument(name);
  var arg2 = null;
  if (parser.GetNext() === '{') {
    arg2 = parser.GetArgument(name, true);
  }
  var macro = arg1 && arg2 ? outputBraket([arg2, arg1, arg2], star1, star2) : star1 ? ("\\langle {").concat(arg1, "} \\rangle") : ("\\left\\langle {").concat(arg1, "} \\right\\rangle");
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.MatrixElement = function (parser, name) {
  var star1 = parser.GetStar();
  var star2 = star1 && parser.GetStar();
  var arg1 = parser.GetArgument(name);
  var arg2 = parser.GetArgument(name);
  var arg3 = parser.GetArgument(name);
  var macro = outputBraket([arg1, arg2, arg3], star1, star2);
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.MatrixQuantity = function (parser, name, small) {
  var star = parser.GetStar();
  var next = parser.GetNext();
  var array = small ? 'smallmatrix' : 'array';
  var arg = '';
  var open = '';
  var close = '';
  switch (next) {
    case '{':
      arg = parser.GetArgument(name);
      break;
    case '(':
      parser.i++;
      open = star ? '\\lgroup' : '(';
      close = star ? '\\rgroup' : ')';
      arg = parser.GetUpTo(name, ')');
      break;
    case '[':
      parser.i++;
      open = '[';
      close = ']';
      arg = parser.GetUpTo(name, ']');
      break;
    case '|':
      parser.i++;
      open = '|';
      close = '|';
      arg = parser.GetUpTo(name, '|');
      break;
    default:
      open = '(';
      close = ')';
      break;
  }
  var macro = (open ? '\\left' : '') + open + '\\begin{' + array + '}{} ' + arg + '\\end{' + array + '}' + (open ? '\\right' : '') + close;
  parser.Push(new TexParser_js_1$2.default(macro, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.IdentityMatrix = function (parser, name) {
  var arg = parser.GetArgument(name);
  var size = parseInt(arg, 10);
  if (isNaN(size)) {
    throw new TexError_js_1$1.default('InvalidNumber', 'Invalid number');
  }
  if (size <= 1) {
    parser.string = '1' + parser.string.slice(parser.i);
    parser.i = 0;
    return;
  }
  var zeros = Array(size).fill('0');
  var columns = [];
  for (var i = 0; i < size; i++) {
    var row = zeros.slice();
    row[i] = '1';
    columns.push(row.join(' & '));
  }
  parser.string = columns.join('\\\\ ') + parser.string.slice(parser.i);
  parser.i = 0;
};
PhysicsMethods.XMatrix = function (parser, name) {
  var star = parser.GetStar();
  var arg1 = parser.GetArgument(name);
  var arg2 = parser.GetArgument(name);
  var arg3 = parser.GetArgument(name);
  var n = parseInt(arg2, 10);
  var m = parseInt(arg3, 10);
  if (isNaN(n) || isNaN(m) || m.toString() !== arg3 || n.toString() !== arg2) {
    throw new TexError_js_1$1.default('InvalidNumber', 'Invalid number');
  }
  n = n < 1 ? 1 : n;
  m = m < 1 ? 1 : m;
  if (!star) {
    var row = Array(m).fill(arg1).join(' & ');
    var matrix_1 = Array(n).fill(row).join('\\\\ ');
    parser.string = matrix_1 + parser.string.slice(parser.i);
    parser.i = 0;
    return;
  }
  var matrix = '';
  if (n === 1 && m === 1) {
    matrix = arg1;
  } else if (n === 1) {
    var row = [];
    for (var i = 1; i <= m; i++) {
      row.push(("").concat(arg1, "_{").concat(i, "}"));
    }
    matrix = row.join(' & ');
  } else if (m === 1) {
    var row = [];
    for (var i = 1; i <= n; i++) {
      row.push(("").concat(arg1, "_{").concat(i, "}"));
    }
    matrix = row.join('\\\\ ');
  } else {
    var rows = [];
    for (var i = 1; i <= n; i++) {
      var row = [];
      for (var j = 1; j <= m; j++) {
        row.push(("").concat(arg1, "_{{").concat(i, "}{").concat(j, "}}"));
      }
      rows.push(row.join(' & '));
    }
    matrix = rows.join('\\\\ ');
  }
  parser.string = matrix + parser.string.slice(parser.i);
  parser.i = 0;
  return;
};
PhysicsMethods.PauliMatrix = function (parser, name) {
  var arg = parser.GetArgument(name);
  var matrix = arg.slice(1);
  switch (arg[0]) {
    case '0':
      matrix += ' 1 & 0\\\\ 0 & 1';
      break;
    case '1':
    case 'x':
      matrix += ' 0 & 1\\\\ 1 & 0';
      break;
    case '2':
    case 'y':
      matrix += ' 0 & -i\\\\ i & 0';
      break;
    case '3':
    case 'z':
      matrix += ' 1 & 0\\\\ 0 & -1';
      break;
  }
  parser.string = matrix + parser.string.slice(parser.i);
  parser.i = 0;
};
PhysicsMethods.DiagonalMatrix = function (parser, name, anti) {
  if (parser.GetNext() !== '{') {
    return;
  }
  var startI = parser.i;
  parser.GetArgument(name);
  var endI = parser.i;
  parser.i = startI + 1;
  var elements = [];
  var element = '';
  var currentI = parser.i;
  while (currentI < endI) {
    try {
      element = parser.GetUpTo(name, ',');
    } catch (e) {
      parser.i = endI;
      elements.push(parser.string.slice(currentI, endI - 1));
      break;
    }
    if (parser.i >= endI) {
      elements.push(parser.string.slice(currentI, endI));
      break;
    }
    currentI = parser.i;
    elements.push(element);
  }
  parser.string = makeDiagMatrix(elements, anti) + parser.string.slice(endI);
  parser.i = 0;
};
function makeDiagMatrix(elements, anti) {
  var length = elements.length;
  var matrix = [];
  for (var i = 0; i < length; i++) {
    matrix.push(Array(anti ? length - i : i + 1).join('&') + '\\mqty{' + elements[i] + '}');
  }
  return matrix.join('\\\\ ');
}
PhysicsMethods.AutoClose = function (parser, fence, _texclass) {
  var mo = parser.create('token', 'mo', {
    stretchy: false
  }, fence);
  var item = parser.itemFactory.create('mml', mo).setProperties({
    autoclose: fence
  });
  parser.Push(item);
};
PhysicsMethods.Vnabla = function (parser, _name) {
  var argument = parser.options.physics.arrowdel ? '\\vec{\\gradientnabla}' : '{\\gradientnabla}';
  return parser.Push(new TexParser_js_1$2.default(argument, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.DiffD = function (parser, _name) {
  var argument = parser.options.physics.italicdiff ? 'd' : '{\\rm d}';
  return parser.Push(new TexParser_js_1$2.default(argument, parser.stack.env, parser.configuration).mml());
};
PhysicsMethods.Macro = BaseMethods_js_1$1.default.Macro;
PhysicsMethods.NamedFn = BaseMethods_js_1$1.default.NamedFn;
PhysicsMethods.Array = BaseMethods_js_1$1.default.Array;
PhysicsMethods$1.default = PhysicsMethods;

var __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var SymbolMap_js_1$3 = SymbolMap;
var PhysicsMethods_js_1 = __importDefault$4(PhysicsMethods$1);
var TexConstants_js_1$3 = TexConstants;
var ParseMethods_js_1 = __importDefault$4(ParseMethods$1);
var MmlNode_js_1$1 = MmlNode;
new SymbolMap_js_1$3.CommandMap('Physics-automatic-bracing-macros', {
  'quantity': 'Quantity',
  'qty': 'Quantity',
  'pqty': ['Quantity', '(', ')', true],
  'bqty': ['Quantity', '[', ']', true],
  'vqty': ['Quantity', '|', '|', true],
  'Bqty': ['Quantity', '\\{', '\\}', true],
  'absolutevalue': ['Quantity', '|', '|', true],
  'abs': ['Quantity', '|', '|', true],
  'norm': ['Quantity', '\\|', '\\|', true],
  'evaluated': 'Eval',
  'eval': 'Eval',
  'order': ['Quantity', '(', ')', true, 'O', TexConstants_js_1$3.TexConstant.Variant.CALLIGRAPHIC],
  'commutator': 'Commutator',
  'comm': 'Commutator',
  'anticommutator': ['Commutator', '\\{', '\\}'],
  'acomm': ['Commutator', '\\{', '\\}'],
  'poissonbracket': ['Commutator', '\\{', '\\}'],
  'pb': ['Commutator', '\\{', '\\}']
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.CharacterMap('Physics-vector-mo', ParseMethods_js_1.default.mathchar0mo, {
  dotproduct: ['\u22C5', {
    mathvariant: TexConstants_js_1$3.TexConstant.Variant.BOLD
  }],
  vdot: ['\u22C5', {
    mathvariant: TexConstants_js_1$3.TexConstant.Variant.BOLD
  }],
  crossproduct: '\u00D7',
  cross: '\u00D7',
  cp: '\u00D7',
  gradientnabla: ['\u2207', {
    mathvariant: TexConstants_js_1$3.TexConstant.Variant.BOLD
  }]
});
new SymbolMap_js_1$3.CharacterMap('Physics-vector-mi', ParseMethods_js_1.default.mathchar0mi, {
  real: ['\u211C', {
    mathvariant: TexConstants_js_1$3.TexConstant.Variant.NORMAL
  }],
  imaginary: ['\u2111', {
    mathvariant: TexConstants_js_1$3.TexConstant.Variant.NORMAL
  }]
});
new SymbolMap_js_1$3.CommandMap('Physics-vector-macros', {
  'vnabla': 'Vnabla',
  'vectorbold': 'VectorBold',
  'vb': 'VectorBold',
  'vectorarrow': ['StarMacro', 1, '\\vec{\\vb', '{#1}}'],
  'va': ['StarMacro', 1, '\\vec{\\vb', '{#1}}'],
  'vectorunit': ['StarMacro', 1, '\\hat{\\vb', '{#1}}'],
  'vu': ['StarMacro', 1, '\\hat{\\vb', '{#1}}'],
  'gradient': ['OperatorApplication', '\\vnabla', '(', '['],
  'grad': ['OperatorApplication', '\\vnabla', '(', '['],
  'divergence': ['VectorOperator', '\\vnabla\\vdot', '(', '['],
  'div': ['VectorOperator', '\\vnabla\\vdot', '(', '['],
  'curl': ['VectorOperator', '\\vnabla\\crossproduct', '(', '['],
  'laplacian': ['OperatorApplication', '\\nabla^2', '(', '[']
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.CommandMap('Physics-expressions-macros', {
  'sin': 'Expression',
  'sinh': 'Expression',
  'arcsin': 'Expression',
  'asin': 'Expression',
  'cos': 'Expression',
  'cosh': 'Expression',
  'arccos': 'Expression',
  'acos': 'Expression',
  'tan': 'Expression',
  'tanh': 'Expression',
  'arctan': 'Expression',
  'atan': 'Expression',
  'csc': 'Expression',
  'csch': 'Expression',
  'arccsc': 'Expression',
  'acsc': 'Expression',
  'sec': 'Expression',
  'sech': 'Expression',
  'arcsec': 'Expression',
  'asec': 'Expression',
  'cot': 'Expression',
  'coth': 'Expression',
  'arccot': 'Expression',
  'acot': 'Expression',
  'exp': ['Expression', false],
  'log': 'Expression',
  'ln': 'Expression',
  'det': ['Expression', false],
  'Pr': ['Expression', false],
  'tr': ['Expression', false],
  'trace': ['Expression', false, 'tr'],
  'Tr': ['Expression', false],
  'Trace': ['Expression', false, 'Tr'],
  'rank': 'NamedFn',
  'erf': ['Expression', false],
  'Residue': ['Macro', '\\mathrm{Res}'],
  'Res': ['OperatorApplication', '\\Residue', '(', '[', '{'],
  'principalvalue': ['OperatorApplication', '{\\cal P}'],
  'pv': ['OperatorApplication', '{\\cal P}'],
  'PV': ['OperatorApplication', '{\\rm P.V.}'],
  'Re': ['OperatorApplication', '\\mathrm{Re}', '{'],
  'Im': ['OperatorApplication', '\\mathrm{Im}', '{'],
  'sine': ['NamedFn', 'sin'],
  'hypsine': ['NamedFn', 'sinh'],
  'arcsine': ['NamedFn', 'arcsin'],
  'asine': ['NamedFn', 'asin'],
  'cosine': ['NamedFn', 'cos'],
  'hypcosine': ['NamedFn', 'cosh'],
  'arccosine': ['NamedFn', 'arccos'],
  'acosine': ['NamedFn', 'acos'],
  'tangent': ['NamedFn', 'tan'],
  'hyptangent': ['NamedFn', 'tanh'],
  'arctangent': ['NamedFn', 'arctan'],
  'atangent': ['NamedFn', 'atan'],
  'cosecant': ['NamedFn', 'csc'],
  'hypcosecant': ['NamedFn', 'csch'],
  'arccosecant': ['NamedFn', 'arccsc'],
  'acosecant': ['NamedFn', 'acsc'],
  'secant': ['NamedFn', 'sec'],
  'hypsecant': ['NamedFn', 'sech'],
  'arcsecant': ['NamedFn', 'arcsec'],
  'asecant': ['NamedFn', 'asec'],
  'cotangent': ['NamedFn', 'cot'],
  'hypcotangent': ['NamedFn', 'coth'],
  'arccotangent': ['NamedFn', 'arccot'],
  'acotangent': ['NamedFn', 'acot'],
  'exponential': ['NamedFn', 'exp'],
  'logarithm': ['NamedFn', 'log'],
  'naturallogarithm': ['NamedFn', 'ln'],
  'determinant': ['NamedFn', 'det'],
  'Probability': ['NamedFn', 'Pr']
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.CommandMap('Physics-quick-quad-macros', {
  'qqtext': 'Qqtext',
  'qq': 'Qqtext',
  'qcomma': ['Macro', '\\qqtext*{,}'],
  'qc': ['Macro', '\\qqtext*{,}'],
  'qcc': ['Qqtext', 'c.c.'],
  'qif': ['Qqtext', 'if'],
  'qthen': ['Qqtext', 'then'],
  'qelse': ['Qqtext', 'else'],
  'qotherwise': ['Qqtext', 'otherwise'],
  'qunless': ['Qqtext', 'unless'],
  'qgiven': ['Qqtext', 'given'],
  'qusing': ['Qqtext', 'using'],
  'qassume': ['Qqtext', 'assume'],
  'qsince': ['Qqtext', 'since'],
  'qlet': ['Qqtext', 'let'],
  'qfor': ['Qqtext', 'for'],
  'qall': ['Qqtext', 'all'],
  'qeven': ['Qqtext', 'even'],
  'qodd': ['Qqtext', 'odd'],
  'qinteger': ['Qqtext', 'integer'],
  'qand': ['Qqtext', 'and'],
  'qor': ['Qqtext', 'or'],
  'qas': ['Qqtext', 'as'],
  'qin': ['Qqtext', 'in']
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.CommandMap('Physics-derivative-macros', {
  'diffd': 'DiffD',
  'flatfrac': ['Macro', '\\left.#1\\middle/#2\\right.', 2],
  'differential': ['Differential', '\\diffd'],
  'dd': ['Differential', '\\diffd'],
  'variation': ['Differential', '\\delta'],
  'var': ['Differential', '\\delta'],
  'derivative': ['Derivative', 2, '\\diffd'],
  'dv': ['Derivative', 2, '\\diffd'],
  'partialderivative': ['Derivative', 3, '\\partial'],
  'pderivative': ['Derivative', 3, '\\partial'],
  'pdv': ['Derivative', 3, '\\partial'],
  'functionalderivative': ['Derivative', 2, '\\delta'],
  'fderivative': ['Derivative', 2, '\\delta'],
  'fdv': ['Derivative', 2, '\\delta']
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.CommandMap('Physics-bra-ket-macros', {
  'bra': 'Bra',
  'ket': 'Ket',
  'innerproduct': 'BraKet',
  'ip': 'BraKet',
  'braket': 'BraKet',
  'outerproduct': 'KetBra',
  'dyad': 'KetBra',
  'ketbra': 'KetBra',
  'op': 'KetBra',
  'expectationvalue': 'Expectation',
  'expval': 'Expectation',
  'ev': 'Expectation',
  'matrixelement': 'MatrixElement',
  'matrixel': 'MatrixElement',
  'mel': 'MatrixElement'
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.CommandMap('Physics-matrix-macros', {
  'matrixquantity': 'MatrixQuantity',
  'mqty': 'MatrixQuantity',
  'pmqty': ['Macro', '\\mqty(#1)', 1],
  'Pmqty': ['Macro', '\\mqty*(#1)', 1],
  'bmqty': ['Macro', '\\mqty[#1]', 1],
  'vmqty': ['Macro', '\\mqty|#1|', 1],
  'smallmatrixquantity': ['MatrixQuantity', true],
  'smqty': ['MatrixQuantity', true],
  'spmqty': ['Macro', '\\smqty(#1)', 1],
  'sPmqty': ['Macro', '\\smqty*(#1)', 1],
  'sbmqty': ['Macro', '\\smqty[#1]', 1],
  'svmqty': ['Macro', '\\smqty|#1|', 1],
  'matrixdeterminant': ['Macro', '\\vmqty{#1}', 1],
  'mdet': ['Macro', '\\vmqty{#1}', 1],
  'smdet': ['Macro', '\\svmqty{#1}', 1],
  'identitymatrix': 'IdentityMatrix',
  'imat': 'IdentityMatrix',
  'xmatrix': 'XMatrix',
  'xmat': 'XMatrix',
  'zeromatrix': ['Macro', '\\xmat{0}{#1}{#2}', 2],
  'zmat': ['Macro', '\\xmat{0}{#1}{#2}', 2],
  'paulimatrix': 'PauliMatrix',
  'pmat': 'PauliMatrix',
  'diagonalmatrix': 'DiagonalMatrix',
  'dmat': 'DiagonalMatrix',
  'antidiagonalmatrix': ['DiagonalMatrix', true],
  'admat': ['DiagonalMatrix', true]
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.EnvironmentMap('Physics-aux-envs', ParseMethods_js_1.default.environment, {
  smallmatrix: ['Array', null, null, null, 'c', '0.333em', '.2em', 'S', 1]
}, PhysicsMethods_js_1.default);
new SymbolMap_js_1$3.MacroMap('Physics-characters', {
  '|': ['AutoClose', MmlNode_js_1$1.TEXCLASS.ORD],
  ')': 'AutoClose',
  ']': 'AutoClose'
}, PhysicsMethods_js_1.default);

var _a$1;
Object.defineProperty(PhysicsConfiguration, "__esModule", {
  value: true
});
PhysicsConfiguration.PhysicsConfiguration = void 0;
var Configuration_js_1$4 = Configuration;
var PhysicsItems_js_1 = PhysicsItems;
PhysicsConfiguration.PhysicsConfiguration = Configuration_js_1$4.Configuration.create('physics', {
  handler: {
    macro: ['Physics-automatic-bracing-macros', 'Physics-vector-macros', 'Physics-vector-mo', 'Physics-vector-mi', 'Physics-derivative-macros', 'Physics-expressions-macros', 'Physics-quick-quad-macros', 'Physics-bra-ket-macros', 'Physics-matrix-macros'],
    character: ['Physics-characters'],
    environment: ['Physics-aux-envs']
  },
  items: (_a$1 = {}, _a$1[PhysicsItems_js_1.AutoOpen.prototype.kind] = PhysicsItems_js_1.AutoOpen, _a$1),
  options: {
    physics: {
      italicdiff: false,
      arrowdel: false
    }
  }
});

var SetOptionsConfiguration = {};

(function (exports) {
  var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  });
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SetOptionsConfiguration = exports.SetOptionsUtil = void 0;
  var Configuration_js_1 = Configuration;
  var SymbolMap_js_1 = SymbolMap;
  var TexError_js_1 = __importDefault(TexError$1);
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var Symbol_js_1 = _Symbol;
  var BaseMethods_js_1 = __importDefault(BaseMethods$1);
  var Options_js_1 = Options;
  exports.SetOptionsUtil = {
    filterPackage: function (parser, extension) {
      if (extension !== 'tex' && !Configuration_js_1.ConfigurationHandler.get(extension)) {
        throw new TexError_js_1.default('NotAPackage', 'Not a defined package: %1', extension);
      }
      var config = parser.options.setoptions;
      var options = config.allowOptions[extension];
      if (options === undefined && !config.allowPackageDefault || options === false) {
        throw new TexError_js_1.default('PackageNotSettable', 'Options can\'t be set for package "%1"', extension);
      }
      return true;
    },
    filterOption: function (parser, extension, option) {
      var _a;
      var config = parser.options.setoptions;
      var options = config.allowOptions[extension] || ({});
      var allow = options.hasOwnProperty(option) && !(0, Options_js_1.isObject)(options[option]) ? options[option] : null;
      if (allow === false || allow === null && !config.allowOptionsDefault) {
        throw new TexError_js_1.default('OptionNotSettable', 'Option "%1" is not allowed to be set', option);
      }
      if (!((_a = extension === 'tex' ? parser.options : parser.options[extension]) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(option))) {
        if (extension === 'tex') {
          throw new TexError_js_1.default('InvalidTexOption', 'Invalid TeX option "%1"', option);
        } else {
          throw new TexError_js_1.default('InvalidOptionKey', 'Invalid option "%1" for package "%2"', option, extension);
        }
      }
      return true;
    },
    filterValue: function (_parser, _extension, _option, value) {
      return value;
    }
  };
  var setOptionsMap = new SymbolMap_js_1.CommandMap('setoptions', {
    setOptions: 'SetOptions'
  }, {
    SetOptions: function (parser, name) {
      var e_1, _a;
      var extension = parser.GetBrackets(name) || 'tex';
      var options = ParseUtil_js_1.default.keyvalOptions(parser.GetArgument(name));
      var config = parser.options.setoptions;
      if (!config.filterPackage(parser, extension)) return;
      try {
        for (var _b = __values(Object.keys(options)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          if (config.filterOption(parser, extension, key)) {
            (extension === 'tex' ? parser.options : parser.options[extension])[key] = config.filterValue(parser, extension, key, options[key]);
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  });
  function setoptionsConfig(_config, jax) {
    var require = jax.parseOptions.handlers.get('macro').lookup('require');
    if (require) {
      setOptionsMap.add('Require', new Symbol_js_1.Macro('Require', require._func));
      setOptionsMap.add('require', new Symbol_js_1.Macro('require', BaseMethods_js_1.default.Macro, ['\\Require{#2}\\setOptions[#2]{#1}', 2, '']));
    }
  }
  exports.SetOptionsConfiguration = Configuration_js_1.Configuration.create('setoptions', {
    handler: {
      macro: ['setoptions']
    },
    config: setoptionsConfig,
    priority: 3,
    options: {
      setoptions: {
        filterPackage: exports.SetOptionsUtil.filterPackage,
        filterOption: exports.SetOptionsUtil.filterOption,
        filterValue: exports.SetOptionsUtil.filterValue,
        allowPackageDefault: true,
        allowOptionsDefault: true,
        allowOptions: (0, Options_js_1.expandable)({
          tex: {
            FindTeX: false,
            formatError: false,
            package: false,
            baseURL: false,
            tags: false,
            maxBuffer: false,
            maxMaxros: false,
            macros: false,
            environments: false
          },
          setoptions: false,
          autoload: false,
          require: false,
          configmacros: false,
          tagformat: false
        })
      }
    }
  });
})(SetOptionsConfiguration);
getDefaultExportFromCjs(SetOptionsConfiguration);

var TagFormatConfiguration = {};

var __extends$1 = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
Object.defineProperty(TagFormatConfiguration, "__esModule", {
  value: true
});
TagFormatConfiguration.TagFormatConfiguration = TagFormatConfiguration.tagformatConfig = void 0;
var Configuration_js_1$3 = Configuration;
var Tags_js_1$1 = Tags;
var tagID = 0;
function tagformatConfig(config, jax) {
  var tags = jax.parseOptions.options.tags;
  if (tags !== 'base' && config.tags.hasOwnProperty(tags)) {
    Tags_js_1$1.TagsFactory.add(tags, config.tags[tags]);
  }
  var TagClass = Tags_js_1$1.TagsFactory.create(jax.parseOptions.options.tags).constructor;
  var TagFormat = (function (_super) {
    __extends$1(TagFormat, _super);
    function TagFormat() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    TagFormat.prototype.formatNumber = function (n) {
      return jax.parseOptions.options.tagformat.number(n);
    };
    TagFormat.prototype.formatTag = function (tag) {
      return jax.parseOptions.options.tagformat.tag(tag);
    };
    TagFormat.prototype.formatId = function (id) {
      return jax.parseOptions.options.tagformat.id(id);
    };
    TagFormat.prototype.formatUrl = function (id, base) {
      return jax.parseOptions.options.tagformat.url(id, base);
    };
    return TagFormat;
  })(TagClass);
  tagID++;
  var tagName = 'configTags-' + tagID;
  Tags_js_1$1.TagsFactory.add(tagName, TagFormat);
  jax.parseOptions.options.tags = tagName;
}
TagFormatConfiguration.tagformatConfig = tagformatConfig;
TagFormatConfiguration.TagFormatConfiguration = Configuration_js_1$3.Configuration.create('tagformat', {
  config: [tagformatConfig, 10],
  options: {
    tagformat: {
      number: function (n) {
        return n.toString();
      },
      tag: function (tag) {
        return '(' + tag + ')';
      },
      id: function (id) {
        return 'mjx-eqn:' + id.replace(/\s/g, '_');
      },
      url: function (id, base) {
        return base + '#' + encodeURIComponent(id);
      }
    }
  }
});

var TextcompConfiguration = {};

var TextMacrosMethods = {};

var __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(TextMacrosMethods, "__esModule", {
  value: true
});
TextMacrosMethods.TextMacrosMethods = void 0;
var TexParser_js_1$1 = __importDefault$3(TexParser$1);
var Retries_js_1 = Retries;
var BaseMethods_js_1 = __importDefault$3(BaseMethods$1);
TextMacrosMethods.TextMacrosMethods = {
  Comment: function (parser, _c) {
    while (parser.i < parser.string.length && parser.string.charAt(parser.i) !== '\n') {
      parser.i++;
    }
    parser.i++;
  },
  Math: function (parser, open) {
    parser.saveText();
    var i = parser.i;
    var j, c;
    var braces = 0;
    while (c = parser.GetNext()) {
      j = parser.i++;
      switch (c) {
        case '\\':
          var cs = parser.GetCS();
          if (cs === ')') c = '\\(';
        case '$':
          if (braces === 0 && open === c) {
            var config = parser.texParser.configuration;
            var mml = new TexParser_js_1$1.default(parser.string.substr(i, j - i), parser.stack.env, config).mml();
            parser.PushMath(mml);
            return;
          }
          break;
        case '{':
          braces++;
          break;
        case '}':
          if (braces === 0) {
            parser.Error('ExtraCloseMissingOpen', 'Extra close brace or missing open brace');
          }
          braces--;
          break;
      }
    }
    parser.Error('MathNotTerminated', 'Math-mode is not properly terminated');
  },
  MathModeOnly: function (parser, c) {
    parser.Error('MathModeOnly', '\'%1\' allowed only in math mode', c);
  },
  Misplaced: function (parser, c) {
    parser.Error('Misplaced', '\'%1\' can not be used here', c);
  },
  OpenBrace: function (parser, _c) {
    var env = parser.stack.env;
    parser.envStack.push(env);
    parser.stack.env = Object.assign({}, env);
  },
  CloseBrace: function (parser, _c) {
    if (parser.envStack.length) {
      parser.saveText();
      parser.stack.env = parser.envStack.pop();
    } else {
      parser.Error('ExtraCloseMissingOpen', 'Extra close brace or missing open brace');
    }
  },
  OpenQuote: function (parser, c) {
    if (parser.string.charAt(parser.i) === c) {
      parser.text += '\u201C';
      parser.i++;
    } else {
      parser.text += '\u2018';
    }
  },
  CloseQuote: function (parser, c) {
    if (parser.string.charAt(parser.i) === c) {
      parser.text += '\u201D';
      parser.i++;
    } else {
      parser.text += '\u2019';
    }
  },
  Tilde: function (parser, _c) {
    parser.text += '\u00A0';
  },
  Space: function (parser, _c) {
    parser.text += ' ';
    while (parser.GetNext().match(/\s/)) parser.i++;
  },
  SelfQuote: function (parser, name) {
    parser.text += name.substr(1);
  },
  Insert: function (parser, _name, c) {
    parser.text += c;
  },
  Accent: function (parser, name, c) {
    var base = parser.ParseArg(name);
    var accent = parser.create('token', 'mo', {}, c);
    parser.addAttributes(accent);
    parser.Push(parser.create('node', 'mover', [base, accent]));
  },
  Emph: function (parser, name) {
    var variant = parser.stack.env.mathvariant === '-tex-mathit' ? 'normal' : '-tex-mathit';
    parser.Push(parser.ParseTextArg(name, {
      mathvariant: variant
    }));
  },
  SetFont: function (parser, _name, variant) {
    parser.saveText();
    parser.stack.env.mathvariant = variant;
  },
  SetSize: function (parser, _name, size) {
    parser.saveText();
    parser.stack.env.mathsize = size;
  },
  CheckAutoload: function (parser, name) {
    var autoload = parser.configuration.packageData.get('autoload');
    var texParser = parser.texParser;
    name = name.slice(1);
    var macro = texParser.lookup('macro', name);
    if (!macro || autoload && macro._func === autoload.Autoload) {
      texParser.parse('macro', [texParser, name]);
      if (!macro) return;
      (0, Retries_js_1.retryAfter)(Promise.resolve());
    }
    texParser.parse('macro', [parser, name]);
  },
  Macro: BaseMethods_js_1.default.Macro,
  Spacer: BaseMethods_js_1.default.Spacer,
  Hskip: BaseMethods_js_1.default.Hskip,
  rule: BaseMethods_js_1.default.rule,
  Rule: BaseMethods_js_1.default.Rule,
  HandleRef: BaseMethods_js_1.default.HandleRef
};

var TextParser$1 = {};

var __extends = commonjsGlobal && commonjsGlobal.__extends || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || ({
      __proto__: []
    }) instanceof Array && (function (d, b) {
      d.__proto__ = b;
    }) || (function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    });
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
})();
var __values = commonjsGlobal && commonjsGlobal.__values || (function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
var __read = commonjsGlobal && commonjsGlobal.__read || (function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
});
var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || (function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !((i in from))) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
});
var __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
Object.defineProperty(TextParser$1, "__esModule", {
  value: true
});
TextParser$1.TextParser = void 0;
var TexParser_js_1 = __importDefault$2(TexParser$1);
var TexError_js_1 = __importDefault$2(TexError$1);
var ParseUtil_js_1$1 = __importDefault$2(ParseUtil$1);
var MmlNode_js_1 = MmlNode;
var NodeUtil_js_1 = __importDefault$2(NodeUtil$1);
var BaseItems_js_1$1 = BaseItems;
var TextParser = (function (_super) {
  __extends(TextParser, _super);
  function TextParser(text, env, configuration, level) {
    var _this = _super.call(this, text, env, configuration) || this;
    _this.level = level;
    return _this;
  }
  Object.defineProperty(TextParser.prototype, "texParser", {
    get: function () {
      return this.configuration.packageData.get('textmacros').texParser;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextParser.prototype, "tags", {
    get: function () {
      return this.texParser.tags;
    },
    enumerable: false,
    configurable: true
  });
  TextParser.prototype.mml = function () {
    return this.level != null ? this.create('node', 'mstyle', this.nodes, {
      displaystyle: false,
      scriptlevel: this.level
    }) : this.nodes.length === 1 ? this.nodes[0] : this.create('node', 'mrow', this.nodes);
  };
  TextParser.prototype.Parse = function () {
    this.text = '';
    this.nodes = [];
    this.envStack = [];
    _super.prototype.Parse.call(this);
  };
  TextParser.prototype.saveText = function () {
    if (this.text) {
      var mathvariant = this.stack.env.mathvariant;
      var text = ParseUtil_js_1$1.default.internalText(this, this.text, mathvariant ? {
        mathvariant: mathvariant
      } : {});
      this.text = '';
      this.Push(text);
    }
  };
  TextParser.prototype.Push = function (mml) {
    if (this.text) {
      this.saveText();
    }
    if (mml instanceof BaseItems_js_1$1.StopItem) {
      return _super.prototype.Push.call(this, mml);
    }
    if (mml instanceof BaseItems_js_1$1.StyleItem) {
      this.stack.env.mathcolor = this.stack.env.color;
      return;
    }
    if (mml instanceof MmlNode_js_1.AbstractMmlNode) {
      this.addAttributes(mml);
      this.nodes.push(mml);
    }
  };
  TextParser.prototype.PushMath = function (mml) {
    var e_1, _a;
    var env = this.stack.env;
    if (!mml.isKind('TeXAtom')) {
      mml = this.create('node', 'TeXAtom', [mml]);
    }
    try {
      for (var _b = __values(['mathsize', 'mathcolor']), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_1 = _c.value;
        if (env[name_1] && !mml.attributes.getExplicit(name_1)) {
          if (!mml.isToken && !mml.isKind('mstyle')) {
            mml = this.create('node', 'mstyle', [mml]);
          }
          NodeUtil_js_1.default.setAttribute(mml, name_1, env[name_1]);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    if (mml.isInferred) {
      mml = this.create('node', 'mrow', mml.childNodes);
    }
    this.nodes.push(mml);
  };
  TextParser.prototype.addAttributes = function (mml) {
    var e_2, _a;
    var env = this.stack.env;
    if (!mml.isToken) return;
    try {
      for (var _b = __values(['mathsize', 'mathcolor', 'mathvariant']), _c = _b.next(); !_c.done; _c = _b.next()) {
        var name_2 = _c.value;
        if (env[name_2] && !mml.attributes.getExplicit(name_2)) {
          NodeUtil_js_1.default.setAttribute(mml, name_2, env[name_2]);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };
  TextParser.prototype.ParseTextArg = function (name, env) {
    var text = this.GetArgument(name);
    env = Object.assign(Object.assign({}, this.stack.env), env);
    return new TextParser(text, env, this.configuration).mml();
  };
  TextParser.prototype.ParseArg = function (name) {
    return new TextParser(this.GetArgument(name), this.stack.env, this.configuration).mml();
  };
  TextParser.prototype.Error = function (id, message) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    throw new (TexError_js_1.default.bind.apply(TexError_js_1.default, __spreadArray([void 0, id, message], __read(args), false)))();
  };
  return TextParser;
})(TexParser_js_1.default);
TextParser$1.TextParser = TextParser;

var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var SymbolMap_js_1$2 = SymbolMap;
var TexConstants_js_1$2 = TexConstants;
var TextMacrosMethods_js_1$2 = TextMacrosMethods;
var ParseUtil_js_1 = __importDefault$1(ParseUtil$1);
var TextParser_js_1$1 = TextParser$1;
new SymbolMap_js_1$2.CommandMap('textcomp-macros', {
  'textasciicircum': ['Insert', '\u005E'],
  'textasciitilde': ['Insert', '\u007E'],
  'textasteriskcentered': ['Insert', '\u002A'],
  'textbackslash': ['Insert', '\u005C'],
  'textbar': ['Insert', '\u007C'],
  'textbraceleft': ['Insert', '\u007B'],
  'textbraceright': ['Insert', '\u007D'],
  'textbullet': ['Insert', '\u2022'],
  'textdagger': ['Insert', '\u2020'],
  'textdaggerdbl': ['Insert', '\u2021'],
  'textellipsis': ['Insert', '\u2026'],
  'textemdash': ['Insert', '\u2014'],
  'textendash': ['Insert', '\u2013'],
  'textexclamdown': ['Insert', '\u00A1'],
  'textgreater': ['Insert', '\u003E'],
  'textless': ['Insert', '\u003C'],
  'textordfeminine': ['Insert', '\u00AA'],
  'textordmasculine': ['Insert', '\u00BA'],
  'textparagraph': ['Insert', '\u00B6'],
  'textperiodcentered': ['Insert', '\u00B7'],
  'textquestiondown': ['Insert', '\u00BF'],
  'textquotedblleft': ['Insert', '\u201C'],
  'textquotedblright': ['Insert', '\u201D'],
  'textquoteleft': ['Insert', '\u2018'],
  'textquoteright': ['Insert', '\u2019'],
  'textsection': ['Insert', '\u00A7'],
  'textunderscore': ['Insert', '\u005F'],
  'textvisiblespace': ['Insert', '\u2423'],
  'textacutedbl': ['Insert', '\u02DD'],
  'textasciiacute': ['Insert', '\u00B4'],
  'textasciibreve': ['Insert', '\u02D8'],
  'textasciicaron': ['Insert', '\u02C7'],
  'textasciidieresis': ['Insert', '\u00A8'],
  'textasciimacron': ['Insert', '\u00AF'],
  'textgravedbl': ['Insert', '\u02F5'],
  'texttildelow': ['Insert', '\u02F7'],
  'textbaht': ['Insert', '\u0E3F'],
  'textcent': ['Insert', '\u00A2'],
  'textcolonmonetary': ['Insert', '\u20A1'],
  'textcurrency': ['Insert', '\u00A4'],
  'textdollar': ['Insert', '\u0024'],
  'textdong': ['Insert', '\u20AB'],
  'texteuro': ['Insert', '\u20AC'],
  'textflorin': ['Insert', '\u0192'],
  'textguarani': ['Insert', '\u20B2'],
  'textlira': ['Insert', '\u20A4'],
  'textnaira': ['Insert', '\u20A6'],
  'textpeso': ['Insert', '\u20B1'],
  'textsterling': ['Insert', '\u00A3'],
  'textwon': ['Insert', '\u20A9'],
  'textyen': ['Insert', '\u00A5'],
  'textcircledP': ['Insert', '\u2117'],
  'textcompwordmark': ['Insert', '\u200C'],
  'textcopyleft': ['Insert', "\uD83C\uDD2F"],
  'textcopyright': ['Insert', '\u00A9'],
  'textregistered': ['Insert', '\u00AE'],
  'textservicemark': ['Insert', '\u2120'],
  'texttrademark': ['Insert', '\u2122'],
  'textbardbl': ['Insert', '\u2016'],
  'textbigcircle': ['Insert', '\u25EF'],
  'textblank': ['Insert', '\u2422'],
  'textbrokenbar': ['Insert', '\u00A6'],
  'textdiscount': ['Insert', '\u2052'],
  'textestimated': ['Insert', '\u212E'],
  'textinterrobang': ['Insert', '\u203D'],
  'textinterrobangdown': ['Insert', '\u2E18'],
  'textmusicalnote': ['Insert', '\u266A'],
  'textnumero': ['Insert', '\u2116'],
  'textopenbullet': ['Insert', '\u25E6'],
  'textpertenthousand': ['Insert', '\u2031'],
  'textperthousand': ['Insert', '\u2030'],
  'textrecipe': ['Insert', '\u211E'],
  'textreferencemark': ['Insert', '\u203B'],
  'textlangle': ['Insert', '\u2329'],
  'textrangle': ['Insert', '\u232A'],
  'textlbrackdbl': ['Insert', '\u27E6'],
  'textrbrackdbl': ['Insert', '\u27E7'],
  'textlquill': ['Insert', '\u2045'],
  'textrquill': ['Insert', '\u2046'],
  'textcelsius': ['Insert', '\u2103'],
  'textdegree': ['Insert', '\u00B0'],
  'textdiv': ['Insert', '\u00F7'],
  'textdownarrow': ['Insert', '\u2193'],
  'textfractionsolidus': ['Insert', '\u2044'],
  'textleftarrow': ['Insert', '\u2190'],
  'textlnot': ['Insert', '\u00AC'],
  'textmho': ['Insert', '\u2127'],
  'textminus': ['Insert', '\u2212'],
  'textmu': ['Insert', '\u00B5'],
  'textohm': ['Insert', '\u2126'],
  'textonehalf': ['Insert', '\u00BD'],
  'textonequarter': ['Insert', '\u00BC'],
  'textonesuperior': ['Insert', '\u00B9'],
  'textpm': ['Insert', '\u00B1'],
  'textrightarrow': ['Insert', '\u2192'],
  'textsurd': ['Insert', '\u221A'],
  'textthreequarters': ['Insert', '\u00BE'],
  'textthreesuperior': ['Insert', '\u00B3'],
  'texttimes': ['Insert', '\u00D7'],
  'texttwosuperior': ['Insert', '\u00B2'],
  'textuparrow': ['Insert', '\u2191'],
  'textborn': ['Insert', '\u002A'],
  'textdied': ['Insert', '\u2020'],
  'textdivorced': ['Insert', '\u26AE'],
  'textmarried': ['Insert', '\u26AD'],
  'textcentoldstyle': ['Insert', '\u00A2', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textdollaroldstyle': ['Insert', '\u0024', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textzerooldstyle': ['Insert', '0', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textoneoldstyle': ['Insert', '1', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'texttwooldstyle': ['Insert', '2', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textthreeoldstyle': ['Insert', '3', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textfouroldstyle': ['Insert', '4', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textfiveoldstyle': ['Insert', '5', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textsixoldstyle': ['Insert', '6', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textsevenoldstyle': ['Insert', '7', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'texteightoldstyle': ['Insert', '8', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE],
  'textnineoldstyle': ['Insert', '9', TexConstants_js_1$2.TexConstant.Variant.OLDSTYLE]
}, {
  Insert: function (parser, name, c, font) {
    if (parser instanceof TextParser_js_1$1.TextParser) {
      if (!font) {
        TextMacrosMethods_js_1$2.TextMacrosMethods.Insert(parser, name, c);
        return;
      }
      parser.saveText();
    }
    parser.Push(ParseUtil_js_1.default.internalText(parser, c, font ? {
      mathvariant: font
    } : {}));
  }
});

Object.defineProperty(TextcompConfiguration, "__esModule", {
  value: true
});
TextcompConfiguration.TextcompConfiguration = void 0;
var Configuration_js_1$2 = Configuration;
TextcompConfiguration.TextcompConfiguration = Configuration_js_1$2.Configuration.create('textcomp', {
  handler: {
    macro: ['textcomp-macros']
  }
});

var TextMacrosConfiguration = {};

var SymbolMap_js_1$1 = SymbolMap;
var TexConstants_js_1$1 = TexConstants;
var TextMacrosMethods_js_1$1 = TextMacrosMethods;
var lengths_js_1 = lengths;
new SymbolMap_js_1$1.MacroMap('text-special', {
  '$': 'Math',
  '%': 'Comment',
  '^': 'MathModeOnly',
  '_': 'MathModeOnly',
  '&': 'Misplaced',
  '#': 'Misplaced',
  '~': 'Tilde',
  ' ': 'Space',
  '\t': 'Space',
  '\r': 'Space',
  '\n': 'Space',
  '\u00A0': 'Tilde',
  '{': 'OpenBrace',
  '}': 'CloseBrace',
  '`': 'OpenQuote',
  '\'': 'CloseQuote'
}, TextMacrosMethods_js_1$1.TextMacrosMethods);
new SymbolMap_js_1$1.CommandMap('text-macros', {
  '(': 'Math',
  '$': 'SelfQuote',
  '_': 'SelfQuote',
  '%': 'SelfQuote',
  '{': 'SelfQuote',
  '}': 'SelfQuote',
  ' ': 'SelfQuote',
  '&': 'SelfQuote',
  '#': 'SelfQuote',
  '\\': 'SelfQuote',
  '\'': ['Accent', '\u00B4'],
  '\u2019': ['Accent', '\u00B4'],
  '`': ['Accent', '\u0060'],
  '\u2018': ['Accent', '\u0060'],
  '^': ['Accent', '^'],
  '\"': ['Accent', '\u00A8'],
  '~': ['Accent', '~'],
  '=': ['Accent', '\u00AF'],
  '.': ['Accent', '\u02D9'],
  'u': ['Accent', '\u02D8'],
  'v': ['Accent', '\u02C7'],
  emph: 'Emph',
  rm: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.NORMAL],
  mit: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.ITALIC],
  oldstyle: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.OLDSTYLE],
  cal: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.CALLIGRAPHIC],
  it: ['SetFont', '-tex-mathit'],
  bf: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.BOLD],
  bbFont: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.DOUBLESTRUCK],
  scr: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.SCRIPT],
  frak: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.FRAKTUR],
  sf: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.SANSSERIF],
  tt: ['SetFont', TexConstants_js_1$1.TexConstant.Variant.MONOSPACE],
  tiny: ['SetSize', 0.5],
  Tiny: ['SetSize', 0.6],
  scriptsize: ['SetSize', 0.7],
  small: ['SetSize', 0.85],
  normalsize: ['SetSize', 1.0],
  large: ['SetSize', 1.2],
  Large: ['SetSize', 1.44],
  LARGE: ['SetSize', 1.73],
  huge: ['SetSize', 2.07],
  Huge: ['SetSize', 2.49],
  Bbb: ['Macro', '{\\bbFont #1}', 1],
  textnormal: ['Macro', '{\\rm #1}', 1],
  textup: ['Macro', '{\\rm #1}', 1],
  textrm: ['Macro', '{\\rm #1}', 1],
  textit: ['Macro', '{\\it #1}', 1],
  textbf: ['Macro', '{\\bf #1}', 1],
  textsf: ['Macro', '{\\sf #1}', 1],
  texttt: ['Macro', '{\\tt #1}', 1],
  dagger: ['Insert', '\u2020'],
  ddagger: ['Insert', '\u2021'],
  S: ['Insert', '\u00A7'],
  ',': ['Spacer', lengths_js_1.MATHSPACE.thinmathspace],
  ':': ['Spacer', lengths_js_1.MATHSPACE.mediummathspace],
  '>': ['Spacer', lengths_js_1.MATHSPACE.mediummathspace],
  ';': ['Spacer', lengths_js_1.MATHSPACE.thickmathspace],
  '!': ['Spacer', lengths_js_1.MATHSPACE.negativethinmathspace],
  enspace: ['Spacer', .5],
  quad: ['Spacer', 1],
  qquad: ['Spacer', 2],
  thinspace: ['Spacer', lengths_js_1.MATHSPACE.thinmathspace],
  negthinspace: ['Spacer', lengths_js_1.MATHSPACE.negativethinmathspace],
  hskip: 'Hskip',
  hspace: 'Hskip',
  kern: 'Hskip',
  mskip: 'Hskip',
  mspace: 'Hskip',
  mkern: 'Hskip',
  rule: 'rule',
  Rule: ['Rule'],
  Space: ['Rule', 'blank'],
  color: 'CheckAutoload',
  textcolor: 'CheckAutoload',
  colorbox: 'CheckAutoload',
  fcolorbox: 'CheckAutoload',
  href: 'CheckAutoload',
  style: 'CheckAutoload',
  class: 'CheckAutoload',
  cssId: 'CheckAutoload',
  unicode: 'CheckAutoload',
  ref: ['HandleRef', false],
  eqref: ['HandleRef', true]
}, TextMacrosMethods_js_1$1.TextMacrosMethods);

var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
});
var _a;
Object.defineProperty(TextMacrosConfiguration, "__esModule", {
  value: true
});
TextMacrosConfiguration.TextMacrosConfiguration = TextMacrosConfiguration.TextBaseConfiguration = void 0;
var Configuration_js_1$1 = Configuration;
var ParseOptions_js_1 = __importDefault(ParseOptions$1);
var Tags_js_1 = Tags;
var BaseItems_js_1 = BaseItems;
var TextParser_js_1 = TextParser$1;
var TextMacrosMethods_js_1 = TextMacrosMethods;
TextMacrosConfiguration.TextBaseConfiguration = Configuration_js_1$1.Configuration.create('text-base', {
  parser: 'text',
  handler: {
    character: ['command', 'text-special'],
    macro: ['text-macros']
  },
  fallback: {
    character: function (parser, c) {
      parser.text += c;
    },
    macro: function (parser, name) {
      var texParser = parser.texParser;
      var macro = texParser.lookup('macro', name);
      if (macro && macro._func !== TextMacrosMethods_js_1.TextMacrosMethods.Macro) {
        parser.Error('MathMacro', '%1 is only supported in math mode', '\\' + name);
      }
      texParser.parse('macro', [parser, name]);
    }
  },
  items: (_a = {}, _a[BaseItems_js_1.StartItem.prototype.kind] = BaseItems_js_1.StartItem, _a[BaseItems_js_1.StopItem.prototype.kind] = BaseItems_js_1.StopItem, _a[BaseItems_js_1.MmlItem.prototype.kind] = BaseItems_js_1.MmlItem, _a[BaseItems_js_1.StyleItem.prototype.kind] = BaseItems_js_1.StyleItem, _a)
});
function internalMath(parser, text, level, mathvariant) {
  var config = parser.configuration.packageData.get('textmacros');
  if (!(parser instanceof TextParser_js_1.TextParser)) {
    config.texParser = parser;
  }
  return [new TextParser_js_1.TextParser(text, mathvariant ? {
    mathvariant: mathvariant
  } : {}, config.parseOptions, level).mml()];
}
TextMacrosConfiguration.TextMacrosConfiguration = Configuration_js_1$1.Configuration.create('textmacros', {
  config: function (_config, jax) {
    var textConf = new Configuration_js_1$1.ParserConfiguration(jax.parseOptions.options.textmacros.packages, ['tex', 'text']);
    textConf.init();
    var parseOptions = new ParseOptions_js_1.default(textConf, []);
    parseOptions.options = jax.parseOptions.options;
    textConf.config(jax);
    Tags_js_1.TagsFactory.addTags(textConf.tags);
    parseOptions.tags = Tags_js_1.TagsFactory.getDefault();
    parseOptions.tags.configuration = parseOptions;
    parseOptions.packageData = jax.parseOptions.packageData;
    parseOptions.packageData.set('textmacros', {
      parseOptions: parseOptions,
      jax: jax,
      texParser: null
    });
    parseOptions.options.internalMath = internalMath;
  },
  preprocessors: [function (data) {
    var config = data.data.packageData.get('textmacros');
    config.parseOptions.nodeFactory.setMmlFactory(config.jax.mmlFactory);
  }],
  options: {
    textmacros: {
      packages: ['text-base']
    }
  }
});

var UpgreekConfiguration = {};

Object.defineProperty(UpgreekConfiguration, "__esModule", {
  value: true
});
UpgreekConfiguration.UpgreekConfiguration = void 0;
var Configuration_js_1 = Configuration;
var SymbolMap_js_1 = SymbolMap;
var TexConstants_js_1 = TexConstants;
function mathchar0miNormal(parser, mchar) {
  var def = mchar.attributes || ({});
  def.mathvariant = TexConstants_js_1.TexConstant.Variant.NORMAL;
  var node = parser.create('token', 'mi', def, mchar.char);
  parser.Push(node);
}
new SymbolMap_js_1.CharacterMap('upgreek', mathchar0miNormal, {
  upalpha: '\u03B1',
  upbeta: '\u03B2',
  upgamma: '\u03B3',
  updelta: '\u03B4',
  upepsilon: '\u03F5',
  upzeta: '\u03B6',
  upeta: '\u03B7',
  uptheta: '\u03B8',
  upiota: '\u03B9',
  upkappa: '\u03BA',
  uplambda: '\u03BB',
  upmu: '\u03BC',
  upnu: '\u03BD',
  upxi: '\u03BE',
  upomicron: '\u03BF',
  uppi: '\u03C0',
  uprho: '\u03C1',
  upsigma: '\u03C3',
  uptau: '\u03C4',
  upupsilon: '\u03C5',
  upphi: '\u03D5',
  upchi: '\u03C7',
  uppsi: '\u03C8',
  upomega: '\u03C9',
  upvarepsilon: '\u03B5',
  upvartheta: '\u03D1',
  upvarpi: '\u03D6',
  upvarrho: '\u03F1',
  upvarsigma: '\u03C2',
  upvarphi: '\u03C6',
  Upgamma: '\u0393',
  Updelta: '\u0394',
  Uptheta: '\u0398',
  Uplambda: '\u039B',
  Upxi: '\u039E',
  Uppi: '\u03A0',
  Upsigma: '\u03A3',
  Upupsilon: '\u03A5',
  Upphi: '\u03A6',
  Uppsi: '\u03A8',
  Upomega: '\u03A9'
});
UpgreekConfiguration.UpgreekConfiguration = Configuration_js_1.Configuration.create('upgreek', {
  handler: {
    macro: ['upgreek']
  }
});

var UnicodeConfiguration = {};

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.UnicodeConfiguration = exports.UnicodeMethods = void 0;
  var Configuration_js_1 = Configuration;
  var TexError_js_1 = __importDefault(TexError$1);
  var SymbolMap_js_1 = SymbolMap;
  var ParseUtil_js_1 = __importDefault(ParseUtil$1);
  var NodeUtil_js_1 = __importDefault(NodeUtil$1);
  var Entities_js_1 = Entities$1;
  exports.UnicodeMethods = {};
  var UnicodeCache = {};
  exports.UnicodeMethods.Unicode = function (parser, name) {
    var HD = parser.GetBrackets(name);
    var HDsplit = null;
    var font = null;
    if (HD) {
      if (HD.replace(/ /g, '').match(/^(\d+(\.\d*)?|\.\d+),(\d+(\.\d*)?|\.\d+)$/)) {
        HDsplit = HD.replace(/ /g, '').split(/,/);
        font = parser.GetBrackets(name);
      } else {
        font = HD;
      }
    }
    var n = ParseUtil_js_1.default.trimSpaces(parser.GetArgument(name)).replace(/^0x/, 'x');
    if (!n.match(/^(x[0-9A-Fa-f]+|[0-9]+)$/)) {
      throw new TexError_js_1.default('BadUnicode', 'Argument to \\unicode must be a number');
    }
    var N = parseInt(n.match(/^x/) ? '0' + n : n);
    if (!UnicodeCache[N]) {
      UnicodeCache[N] = [800, 200, font, N];
    } else if (!font) {
      font = UnicodeCache[N][2];
    }
    if (HDsplit) {
      UnicodeCache[N][0] = Math.floor(parseFloat(HDsplit[0]) * 1000);
      UnicodeCache[N][1] = Math.floor(parseFloat(HDsplit[1]) * 1000);
    }
    var variant = parser.stack.env.font;
    var def = {};
    if (font) {
      UnicodeCache[N][2] = def.fontfamily = font.replace(/'/g, '\'');
      if (variant) {
        if (variant.match(/bold/)) {
          def.fontweight = 'bold';
        }
        if (variant.match(/italic|-mathit/)) {
          def.fontstyle = 'italic';
        }
      }
    } else if (variant) {
      def.mathvariant = variant;
    }
    var node = parser.create('token', 'mtext', def, (0, Entities_js_1.numeric)(n));
    NodeUtil_js_1.default.setProperty(node, 'unicode', true);
    parser.Push(node);
  };
  new SymbolMap_js_1.CommandMap('unicode', {
    unicode: 'Unicode'
  }, exports.UnicodeMethods);
  exports.UnicodeConfiguration = Configuration_js_1.Configuration.create('unicode', {
    handler: {
      macro: ['unicode']
    }
  });
})(UnicodeConfiguration);
getDefaultExportFromCjs(UnicodeConfiguration);

var VerbConfiguration = {};

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || (function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  });
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.VerbConfiguration = exports.VerbMethods = void 0;
  var Configuration_js_1 = Configuration;
  var TexConstants_js_1 = TexConstants;
  var SymbolMap_js_1 = SymbolMap;
  var TexError_js_1 = __importDefault(TexError$1);
  exports.VerbMethods = {};
  exports.VerbMethods.Verb = function (parser, name) {
    var c = parser.GetNext();
    var start = ++parser.i;
    if (c === '') {
      throw new TexError_js_1.default('MissingArgFor', 'Missing argument for %1', name);
    }
    while (parser.i < parser.string.length && parser.string.charAt(parser.i) !== c) {
      parser.i++;
    }
    if (parser.i === parser.string.length) {
      throw new TexError_js_1.default('NoClosingDelim', 'Can\'t find closing delimiter for %1', parser.currentCS);
    }
    var text = parser.string.slice(start, parser.i).replace(/ /g, '\u00A0');
    parser.i++;
    parser.Push(parser.create('token', 'mtext', {
      mathvariant: TexConstants_js_1.TexConstant.Variant.MONOSPACE
    }, text));
  };
  new SymbolMap_js_1.CommandMap('verb', {
    verb: 'Verb'
  }, exports.VerbMethods);
  exports.VerbConfiguration = Configuration_js_1.Configuration.create('verb', {
    handler: {
      macro: ['verb']
    }
  });
})(VerbConfiguration);
getDefaultExportFromCjs(VerbConfiguration);

Object.defineProperty(AllPackages, "__esModule", {
  value: true
});
var AllPackages_1 = AllPackages.AllPackages = void 0;
if (typeof MathJax !== 'undefined' && MathJax.loader) {
  MathJax.loader.preLoad('[tex]/action', '[tex]/ams', '[tex]/amscd', '[tex]/bbox', '[tex]/boldsymbol', '[tex]/braket', '[tex]/bussproofs', '[tex]/cancel', '[tex]/cases', '[tex]/centernot', '[tex]/color', '[tex]/colorv2', '[tex]/colortbl', '[tex]/empheq', '[tex]/enclose', '[tex]/extpfeil', '[tex]/gensymb', '[tex]/html', '[tex]/mathtools', '[tex]/mhchem', '[tex]/newcommand', '[tex]/noerrors', '[tex]/noundefined', '[tex]/physics', '[tex]/upgreek', '[tex]/unicode', '[tex]/verb', '[tex]/configmacros', '[tex]/tagformat', '[tex]/textcomp', '[tex]/textmacros', '[tex]/setoptions');
}
AllPackages_1 = AllPackages.AllPackages = ['base', 'action', 'ams', 'amscd', 'bbox', 'boldsymbol', 'braket', 'bussproofs', 'cancel', 'cases', 'centernot', 'color', 'colortbl', 'empheq', 'enclose', 'extpfeil', 'gensymb', 'html', 'mathtools', 'mhchem', 'newcommand', 'noerrors', 'noundefined', 'upgreek', 'unicode', 'verb', 'configmacros', 'tagformat', 'textcomp', 'textmacros'];

var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;

var objectProto$2 = Object.prototype;
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
var nativeObjectToString$1 = objectProto$2.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var objectProto$1 = Object.prototype;
var nativeObjectToString = objectProto$1.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}

var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && (symToStringTag in Object(value)) ? getRawTag(value) : objectToString(value);
}

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var symbolTag = '[object Symbol]';
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

var isArray = Array.isArray;
var isArray$1 = isArray;

var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

function toInteger(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

function identity(value) {
  return value;
}

function baseTimes(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var argsTag = '[object Arguments]';
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
var isArguments = baseIsArguments((function () {
  return arguments;
})()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments$1 = isArguments;

function arrayPush(array, values) {
  var index = -1, length = values.length, offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;
function isFlattenable(value) {
  return isArray$1(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

function baseSlice(array, start, end) {
  var index = -1, length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

function compact(array) {
  var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

function head(array) {
  return array && array.length ? array[0] : undefined;
}

function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

var MAX_SAFE_INTEGER = 9007199254740991;
var MAX_ARRAY_LENGTH = 4294967295;
var nativeMin = Math.min;
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;
  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

const reduceText = (acc, n) => {
  if (n.node && n.node.kind === 'text') {
    acc += n.node.text;
  }
  return acc;
};
class Line {
  constructor() {
    this.kind = 'line';
  }
  get columns() {
    return [];
  }
}
class Row {
  constructor(columns, operator) {
    this.kind = 'row';
    this.operator = operator;
    this.columns = columns;
  }
  pad(count, direction = 'right') {
    if (count < this.columns.length) {
      throw new Error('no');
    }
    const diff = count - this.columns.length;
    const padding = times(diff).map(() => '__pad__');
    return direction === 'right' ? [...padding, ...this.columns] : [...this.columns, ...padding];
  }
}
const mathNodeToCharArray = mn => {
  const text = mn.childNodes.reduce(reduceText, '');
  return text.split('');
};
const toColumnArray = child => {
  if (!child || !child.kind) {
    return [];
  }
  if (child.kind === 'msrow') {
    throw new Error('msrow in msrow?');
  }
  if (child.kind === 'mo') {
    console.warn('mo that is not 1st node in msrow?');
    return mathNodeToCharArray(child);
  }
  if (child.kind === 'mn') {
    return mathNodeToCharArray(child);
  }
  if (child.toCHTML) {
    return child;
  }
};
const rowStack = child => {
  if (!child || !child.kind) {
    return;
  }
  if (child.kind === 'msrow') {
    if (!child.childNodes || child.childNodes.length === 0) {
      return new Row([]);
    }
    const f = head(child.childNodes);
    const nodes = f && f.kind === 'mo' ? tail(child.childNodes) : child.childNodes;
    const columns = flatten(nodes.map(toColumnArray));
    return new Row(columns, f.kind === 'mo' ? f : undefined);
  }
  if (child.kind === 'mn') {
    const columns = mathNodeToCharArray(child);
    return new Row(columns, undefined);
  }
  if (child.kind === 'mo') {
    console.warn('mo on its own row?');
    return new Row([], child);
  }
  if (child.kind === 'msline') {
    return new Line();
  }
  if (child.toCHTML) {
    return new Row([child]);
  }
};
const getStackData = mstack => {
  if (!mstack || !mstack.childNodes) {
    return [];
  }
  return compact(mstack.childNodes.map(rowStack));
};
class CHTMLmstack extends Wrapper$2.CHTMLWrapper {
  constructor(factory, node, parent = null) {
    super(factory, node, parent);
    this.ce = this.adaptor.document.createElement.bind(this.adaptor.document);
  }
  toCHTML(parent) {
    const chtml = this.standardCHTMLnode(parent);
    const stackData = getStackData(this);
    const maxCols = stackData.reduce((acc, r) => {
      if (r && r.columns.length > acc) {
        acc = r.columns.length;
      }
      return acc;
    }, 0);
    const table = this.ce('table');
    chtml.appendChild(table);
    stackData.forEach(row => {
      const tr = this.ce('tr');
      table.appendChild(tr);
      if (row.kind === 'row') {
        const td = this.ce('td');
        tr.appendChild(td);
        if (row.operator && row.operator.toCHTML) {
          td.setAttribute('class', 'inner');
          row.operator.toCHTML(td);
        } else {
          td.textContent = '';
        }
        const cols = row.pad(maxCols, 'right');
        cols.forEach(c => {
          const t = this.ce('td');
          tr.appendChild(t);
          if (c === '__pad__') {
            t.textContent = '';
          } else if (typeof c === 'string') {
            t.textContent = c;
          } else if (c.kind === 'none') {
            t.textContent = '';
          } else if (c.toCHTML) {
            t.setAttribute('class', 'inner');
            c.toCHTML(t);
          }
        });
      } else if (row.kind === 'line') {
        const td = this.ce('td');
        tr.appendChild(td);
        td.setAttribute('colspan', maxCols + 1);
        td.setAttribute('class', 'mjx-line');
        td.textContent = '';
      }
    });
  }
}
CHTMLmstack.styles = {
  'mjx-mstack > table': {
    'line-height': 'initial',
    border: 'solid 0px red',
    'border-spacing': '0em',
    'border-collapse': 'separate'
  },
  'mjx-mstack > table > tr': {
    'line-height': 'initial'
  },
  'mjx-mstack > table > tr > td': {
    border: 'solid 0px blue',
    'font-family': 'sans-serif',
    'line-height': 'initial'
  },
  'mjx-mstack > table > tr > td.inner': {
    'font-family': 'inherit'
  },
  'mjx-mstack > table > tr > .mjx-line': {
    padding: 0,
    'border-top': 'solid 1px black'
  },
  '.TEX-A': {
    'font-family': 'MJXZERO, MJXTEX !important'
  }
};

class MmlNone extends MmlNode.AbstractMmlNode {
  get kind() {
    return 'none';
  }
}
class MmlMstack extends MmlNode.AbstractMmlNode {
  get kind() {
    return 'mstack';
  }
}
class MmlMsrow extends MmlNode.AbstractMmlNode {
  get kind() {
    return 'msrow';
  }
}
class MmlMsline extends MmlNode.AbstractMmlNode {
  get kind() {
    return 'msline';
  }
}

const chtmlNodes = {
  mstack: CHTMLmstack
};
const mmlNodes = {
  mstack: MmlMstack,
  msline: MmlMsline,
  msrow: MmlMsrow,
  none: MmlNone
};

var browser = {
  exports: {}
};

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
var ms = function (val, options) {
  options = options || ({});
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = (/^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i).exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}
function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}
function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}
function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = ms;
  createDebug.destroy = destroy;
  Object.keys(env).forEach(key => {
    createDebug[key] = env[key];
  });
  createDebug.names = [];
  createDebug.skips = [];
  createDebug.formatters = {};
  function selectColor(namespace) {
    let hash = 0;
    for (let i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0;
    }
    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }
  createDebug.selectColor = selectColor;
  function createDebug(namespace) {
    let prevTime;
    let enableOverride = null;
    let namespacesCache;
    let enabledCache;
    function debug(...args) {
      if (!debug.enabled) {
        return;
      }
      const self = debug;
      const curr = Number(new Date());
      const ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);
      if (typeof args[0] !== 'string') {
        args.unshift('%O');
      }
      let index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
        if (match === '%%') {
          return '%';
        }
        index++;
        const formatter = createDebug.formatters[format];
        if (typeof formatter === 'function') {
          const val = args[index];
          match = formatter.call(self, val);
          args.splice(index, 1);
          index--;
        }
        return match;
      });
      createDebug.formatArgs.call(self, args);
      const logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.useColors = createDebug.useColors();
    debug.color = createDebug.selectColor(namespace);
    debug.extend = extend;
    debug.destroy = createDebug.destroy;
    Object.defineProperty(debug, 'enabled', {
      enumerable: true,
      configurable: false,
      get: () => {
        if (enableOverride !== null) {
          return enableOverride;
        }
        if (namespacesCache !== createDebug.namespaces) {
          namespacesCache = createDebug.namespaces;
          enabledCache = createDebug.enabled(namespace);
        }
        return enabledCache;
      },
      set: v => {
        enableOverride = v;
      }
    });
    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }
    return debug;
  }
  function extend(namespace, delimiter) {
    const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
    newDebug.log = this.log;
    return newDebug;
  }
  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.namespaces = namespaces;
    createDebug.names = [];
    createDebug.skips = [];
    const split = (typeof namespaces === 'string' ? namespaces : '').trim().replace(/\s+/g, ',').split(',').filter(Boolean);
    for (const ns of split) {
      if (ns[0] === '-') {
        createDebug.skips.push(ns.slice(1));
      } else {
        createDebug.names.push(ns);
      }
    }
  }
  function matchesTemplate(search, template) {
    let searchIndex = 0;
    let templateIndex = 0;
    let starIndex = -1;
    let matchIndex = 0;
    while (searchIndex < search.length) {
      if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === '*')) {
        if (template[templateIndex] === '*') {
          starIndex = templateIndex;
          matchIndex = searchIndex;
          templateIndex++;
        } else {
          searchIndex++;
          templateIndex++;
        }
      } else if (starIndex !== -1) {
        templateIndex = starIndex + 1;
        matchIndex++;
        searchIndex = matchIndex;
      } else {
        return false;
      }
    }
    while (templateIndex < template.length && template[templateIndex] === '*') {
      templateIndex++;
    }
    return templateIndex === template.length;
  }
  function disable() {
    const namespaces = [...createDebug.names, ...createDebug.skips.map(namespace => '-' + namespace)].join(',');
    createDebug.enable('');
    return namespaces;
  }
  function enabled(name) {
    for (const skip of createDebug.skips) {
      if (matchesTemplate(name, skip)) {
        return false;
      }
    }
    for (const ns of createDebug.names) {
      if (matchesTemplate(name, ns)) {
        return true;
      }
    }
    return false;
  }
  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }
    return val;
  }
  function destroy() {
    console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
  }
  createDebug.enable(createDebug.load());
  return createDebug;
}
var common = setup;

(function (module, exports) {
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = localstorage();
  exports.destroy = (() => {
    let warned = false;
    return () => {
      if (!warned) {
        warned = true;
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
      }
    };
  })();
  exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
  function useColors() {
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
      return true;
    }
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
      return false;
    }
    let m;
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) {
      return;
    }
    const c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, match => {
      if (match === '%%') {
        return;
      }
      index++;
      if (match === '%c') {
        lastC = index;
      }
    });
    args.splice(lastC, 0, c);
  }
  exports.log = console.debug || console.log || (() => {});
  function save(namespaces) {
    try {
      if (namespaces) {
        exports.storage.setItem('debug', namespaces);
      } else {
        exports.storage.removeItem('debug');
      }
    } catch (error) {}
  }
  function load() {
    let r;
    try {
      r = exports.storage.getItem('debug') || exports.storage.getItem('DEBUG');
    } catch (error) {}
    if (!r && typeof process !== 'undefined' && ('env' in process)) {
      r = process.env.DEBUG;
    }
    return r;
  }
  function localstorage() {
    try {
      return localStorage;
    } catch (error) {}
  }
  module.exports = common(exports);
  const {formatters} = module.exports;
  formatters.j = function (v) {
    try {
      return JSON.stringify(v);
    } catch (error) {
      return '[UnexpectedJSONParseError]: ' + error.message;
    }
  };
})(browser, browser.exports);
var debug = browser.exports;

const BracketTypes = {};
BracketTypes.ROUND_BRACKETS = 'round_brackets';
BracketTypes.SQUARE_BRACKETS = 'square_brackets';
BracketTypes.DOLLAR = 'dollar';
BracketTypes.DOUBLE_DOLLAR = 'double_dollar';
const PAIRS = {
  [BracketTypes.ROUND_BRACKETS]: ['\\(', '\\)'],
  [BracketTypes.SQUARE_BRACKETS]: ['\\[', '\\]'],
  [BracketTypes.DOLLAR]: ['$', '$'],
  [BracketTypes.DOUBLE_DOLLAR]: ['$$', '$$']
};
const wrapMath = (content, wrapType) => {
  if (wrapType === BracketTypes.SQUARE_BRACKETS) {
    console.warn('\\[...\\] is not supported yet');
    wrapType = BracketTypes.ROUND_BRACKETS;
  }
  if (wrapType === BracketTypes.DOUBLE_DOLLAR) {
    console.warn('$$...$$ is not supported yet');
    wrapType = BracketTypes.DOLLAR;
  }
  const [start, end] = PAIRS[wrapType] || PAIRS[BracketTypes.ROUND_BRACKETS];
  return `${start}${content}${end}`;
};
const unWrapMath = content => {
  const displayStyleIndex = content.indexOf('\\displaystyle');
  if (displayStyleIndex !== -1) {
    console.warn('\\displaystyle is not supported - removing');
    content = content.replace('\\displaystyle', '').trim();
  }
  if (content.startsWith('$$') && content.endsWith('$$')) {
    console.warn('$$ syntax is not yet supported');
    return {
      unwrapped: content.substring(2, content.length - 2),
      wrapType: BracketTypes.DOLLAR
    };
  }
  if (content.startsWith('$') && content.endsWith('$')) {
    return {
      unwrapped: content.substring(1, content.length - 1),
      wrapType: BracketTypes.DOLLAR
    };
  }
  if (content.startsWith('\\[') && content.endsWith('\\]')) {
    console.warn('\\[..\\] syntax is not yet supported');
    return {
      unwrapped: content.substring(2, content.length - 2),
      wrapType: BracketTypes.ROUND_BRACKETS
    };
  }
  if (content.startsWith('\\(') && content.endsWith('\\)')) {
    return {
      unwrapped: content.substring(2, content.length - 2),
      wrapType: BracketTypes.ROUND_BRACKETS
    };
  }
  return {
    unwrapped: content,
    wrapType: BracketTypes.ROUND_BRACKETS
  };
};

function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
if (typeof window !== 'undefined') {
  RegisterHTMLHandler_1(browserAdaptor_2());
}
let sreReady = false;
system.engineReady().then(() => {
  sreReady = true;
});
const visitor = new SerializedMmlVisitor.SerializedMmlVisitor();
const toMMl = node => visitor.visitTree(node);
const log = debug('pie-lib:math-rendering');
const NEWLINE_BLOCK_REGEX = /\\embed\{newLine\}\[\]/g;
const NEWLINE_LATEX = '\\newline ';
const getGlobal = () => {
  const key = '@pie-lib/math-rendering@2';
  if (typeof window !== 'undefined') {
    if (!window[key]) {
      window[key] = {};
    }
    return window[key];
  } else {
    return {};
  }
};
const defaultOpts = () => getGlobal().opts || ({});
const fixMathElement = element => {
  if (element.dataset.mathHandled) {
    return;
  }
  let property = 'innerText';
  if (element.textContent) {
    property = 'textContent';
  }
  if (element[property]) {
    element[property] = wrapMath(unWrapMath(element[property]).unwrapped);
    element[property] = element[property].replace(NEWLINE_BLOCK_REGEX, NEWLINE_LATEX);
    element.dataset.mathHandled = true;
  }
};
const fixMathElements = (el = document) => {
  const mathElements = el.querySelectorAll('[data-latex]');
  mathElements.forEach(item => fixMathElement(item));
};
const adjustMathMLStyle = (el = document) => {
  const nodes = el.querySelectorAll('math');
  nodes.forEach(node => node.setAttribute('displaystyle', 'true'));
};
class myFindMathML extends FindMathML_2 {
  processMath(set) {
    const adaptor = this.adaptor;
    for (const mml of Array.from(set)) {
      if (adaptor.kind(adaptor.parent(mml)) === 'mjx-assistive-mml') {
        set.delete(mml);
      }
    }
    return super.processMath(set);
  }
}
const createMathMLInstance = (opts, docProvided = document) => {
  opts = opts || defaultOpts();
  if (opts.useSingleDollar) {
    console.warn('[math-rendering] using $ is not advisable, please use $$..$$ or \\(...\\)');
  }
  const packages = AllPackages_1.filter(name => name !== 'bussproofs');
  packages.push('autoload');
  const macros = {
    parallelogram: '\\lower.2em{\\Huge\\unicode{x25B1}}',
    overarc: '\\overparen',
    napprox: '\\not\\approx',
    longdiv: '\\enclose{longdiv}',
    abs: ['\\left|#1\\right|', 1]
  };
  const texConfig = opts.useSingleDollar ? {
    packages,
    macros,
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    processEscapes: true
  } : {
    packages,
    macros
  };
  const mmlConfig = {
    parseError: function (node) {
      console.log('error:', node);
      this.error(this.adaptor.textContent(node).replace(/\n.*/g, ''));
    },
    FindMathML: new myFindMathML()
  };
  let cachedMathjax;
  if (global$1.MathJax && global$1.MathJax.version !== mathjax.mathjax.version) {
    window.MathJax._ = window.MathJax._ || ({});
    window.MathJax.config = window.MathJax.config || ({});
    cachedMathjax = window.MathJax;
    Object.assign(global$1.MathJax, mathjax.mathjax);
  }
  const fontURL = `https://unpkg.com/mathjax-full@${mathjax.mathjax.version}/ts/output/chtml/fonts/tex-woff-v2`;
  const htmlConfig = {
    fontURL,
    wrapperFactory: new CHTMLWrapperFactory_1({
      ...CHTMLWrapperFactory_1.defaultNodes,
      ...chtmlNodes
    })
  };
  const mml = new MathML_1(mmlConfig);
  const customMmlFactory = new MmlFactory_2({
    ...MmlFactory_2.defaultNodes,
    ...mmlNodes
  });
  const classFactory = EnrichHandler_1(MenuHandler_2(AssistiveMmlHandler_1(mathjax.mathjax.handlers.handlesDocument(docProvided))), mml);
  const html = classFactory.create(docProvided, {
    compileError: (mj, math, err) => {
      console.log('bad math?:', math);
      console.error(err);
    },
    typesetError: function (doc, math, err) {
      console.log('typeset error');
      console.error(err);
      doc.typesetError(math, err);
    },
    sre: {
      speech: 'deep'
    },
    enrichSpeech: 'deep',
    InputJax: [new TeX_1(texConfig), mml],
    OutputJax: new CHTML_1(htmlConfig),
    DomStrings: new HTMLDomStrings_2({
      skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code', 'annotation', 'annotation-xml', 'mjx-assistive-mml', 'mjx-container']
    })
  });
  mml.setMmlFactory(customMmlFactory);
  if (cachedMathjax) {
    window.MathJax = cachedMathjax;
  }
  return html;
};
let enrichSpeechInitialized = false;
const bootstrap = opts => {
  if (typeof window === 'undefined') {
    return {
      Typeset: () => ({})
    };
  }
  const html = createMathMLInstance(opts);
  return {
    version: mathjax.mathjax.version,
    html: html,
    Typeset: function (...elements) {
      const attemptRender = (temporary = false) => {
        let updatedDocument = this.html.findMath(elements.length ? {
          elements
        } : {}).compile();
        if (!temporary && sreReady) {
          try {
            updatedDocument = updatedDocument.enrich();
          } catch (e) {
            console.warn('[math-rendering] Speech-rule-engine not fully initialized, skipping enrichment');
            sreReady = false;
          }
        }
        updatedDocument = updatedDocument.getMetrics().typeset();
        try {
          updatedDocument = updatedDocument.assistiveMml();
        } catch (e) {
          console.warn('[math-rendering] Failed to attach assistive MathML:', e);
        }
        if (!temporary && sreReady) {
          try {
            updatedDocument = updatedDocument.attachSpeech();
          } catch (e) {
            console.warn('[math-rendering] Speech-rule-engine not fully initialized, skipping speech attachment');
            sreReady = false;
          }
        }
        updatedDocument = updatedDocument.addMenu().updateDocument();
        if (!enrichSpeechInitialized && typeof _optionalChain([updatedDocument, 'access', _2 => _2.math, 'access', _3 => _3.list, 'optionalAccess', _4 => _4.next, 'optionalAccess', _5 => _5.data]) === 'object') {
          enrichSpeechInitialized = true;
        }
        try {
          const list = updatedDocument.math.list;
          if (list) {
            for (let item = list.next; typeof item.data !== 'symbol'; item = item.next) {
              const mathMl = toMMl(item.data.root);
              const parsedMathMl = mathMl.replaceAll('\n', '');
              item.data.typesetRoot.setAttribute('data-mathml', parsedMathMl);
              item.data.typesetRoot.setAttribute('tabindex', '-1');
            }
          }
        } catch (e) {
          console.error(e.toString());
        }
        updatedDocument.clear();
      };
      if (!enrichSpeechInitialized) {
        attemptRender(true);
      }
      mathjax.mathjax.handleRetriesFor(() => {
        attemptRender();
      });
    }
  };
};
const renderMath = (el, renderOpts) => {
  if (window && window.MathJax && window.MathJax.customKey && window.MathJax.customKey == '@pie-lib/math-rendering-accessible@1') {
    return;
  }
  const isString = typeof el === 'string';
  let executeOn = document.body;
  if (isString) {
    const div = document.createElement('div');
    div.innerHTML = el;
    executeOn = div;
  }
  fixMathElements(executeOn);
  adjustMathMLStyle(executeOn);
  if (isString) {
    const html = createMathMLInstance(undefined, executeOn);
    const updatedDocument = html.findMath().compile().getMetrics().typeset().updateDocument();
    const list = updatedDocument.math.list;
    const item = list.next;
    if (!item) {
      return '';
    }
    const mathMl = toMMl(item.data.root);
    const parsedMathMl = mathMl.replaceAll('\n', '');
    return parsedMathMl;
  }
  if (!getGlobal().instance) {
    getGlobal().instance = bootstrap(renderOpts);
  }
  if (!el) {
    log('el is undefined');
    return;
  }
  if (el instanceof Element && _optionalChain([getGlobal, 'call', _6 => _6(), 'access', _7 => _7.instance, 'optionalAccess', _8 => _8.Typeset])) {
    getGlobal().instance.Typeset(el);
  } else if (el.length && _optionalChain([getGlobal, 'call', _9 => _9(), 'access', _10 => _10.instance, 'optionalAccess', _11 => _11.Typeset])) {
    const arr = Array.from(el);
    getGlobal().instance.Typeset(...arr);
  }
};
CHTMLmspace_1.styles = {
  'mjx-mspace': {
    display: 'block',
    'text-align': 'center',
    height: '5px'
  }
};

var bundle_min = {
  exports: {}
};

(function (module, exports) {
  !(function (e, t) {
    module.exports = t() ;
  })(commonjsGlobal, () => (() => {
    var e = {
      2167: (e, t) => {
        function r(e, t) {
          return (void 0 === t && (t = Object), t && "function" == typeof t.freeze ? t.freeze(e) : e);
        }
        var a = r({
          HTML: "text/html",
          isHTML: function (e) {
            return e === a.HTML;
          },
          XML_APPLICATION: "application/xml",
          XML_TEXT: "text/xml",
          XML_XHTML_APPLICATION: "application/xhtml+xml",
          XML_SVG_IMAGE: "image/svg+xml"
        }), n = r({
          HTML: "http://www.w3.org/1999/xhtml",
          isHTML: function (e) {
            return e === n.HTML;
          },
          SVG: "http://www.w3.org/2000/svg",
          XML: "http://www.w3.org/XML/1998/namespace",
          XMLNS: "http://www.w3.org/2000/xmlns/"
        });
        (t.assign = function (e, t) {
          if (null === e || "object" != typeof e) throw new TypeError("target is not an object");
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          return e;
        }, t.find = function (e, t, r) {
          if ((void 0 === r && (r = Array.prototype), e && "function" == typeof r.find)) return r.find.call(e, t);
          for (var a = 0; a < e.length; a++) if (Object.prototype.hasOwnProperty.call(e, a)) {
            var n = e[a];
            if (t.call(void 0, n, a, e)) return n;
          }
        }, t.freeze = r, t.MIME_TYPE = a, t.NAMESPACE = n);
      },
      6129: (e, t, r) => {
        var a = r(2167), n = r(1146), o = r(1045), i = r(6925), l = n.DOMImplementation, s = a.NAMESPACE, c = i.ParseError, u = i.XMLReader;
        function h(e) {
          return e.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
        }
        function d(e) {
          this.options = e || ({
            locator: {}
          });
        }
        function m() {
          this.cdata = !1;
        }
        function p(e, t) {
          (t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber);
        }
        function f(e) {
          if (e) return "\n@" + (e.systemId || "") + "#[line:" + e.lineNumber + ",col:" + e.columnNumber + "]";
        }
        function x(e, t, r) {
          return "string" == typeof e ? e.substr(t, r) : e.length >= t + r || t ? new java.lang.String(e, t, r) + "" : e;
        }
        function g(e, t) {
          e.currentElement ? e.currentElement.appendChild(t) : e.doc.appendChild(t);
        }
        (d.prototype.parseFromString = function (e, t) {
          var r = this.options, a = new u(), n = r.domBuilder || new m(), i = r.errorHandler, l = r.locator, c = r.xmlns || ({}), d = (/\/x?html?$/).test(t), p = d ? o.HTML_ENTITIES : o.XML_ENTITIES;
          (l && n.setDocumentLocator(l), a.errorHandler = (function (e, t, r) {
            if (!e) {
              if (t instanceof m) return t;
              e = t;
            }
            var a = {}, n = e instanceof Function;
            function o(t) {
              var o = e[t];
              (!o && n && (o = 2 == e.length ? function (r) {
                e(t, r);
              } : e), a[t] = o && (function (e) {
                o("[xmldom " + t + "]\t" + e + f(r));
              }) || (function () {}));
            }
            return (r = r || ({}), o("warning"), o("error"), o("fatalError"), a);
          })(i, n, l), a.domBuilder = r.domBuilder || n, d && (c[""] = s.HTML), c.xml = c.xml || s.XML);
          var x = r.normalizeLineEndings || h;
          return (e && "string" == typeof e ? a.parse(x(e), c, p) : a.errorHandler.error("invalid doc source"), n.doc);
        }, m.prototype = {
          startDocument: function () {
            (this.doc = new l().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId));
          },
          startElement: function (e, t, r, a) {
            var n = this.doc, o = n.createElementNS(e, r || t), i = a.length;
            (g(this, o), this.currentElement = o, this.locator && p(this.locator, o));
            for (var l = 0; l < i; l++) {
              e = a.getURI(l);
              var s = a.getValue(l), c = (r = a.getQName(l), n.createAttributeNS(e, r));
              (this.locator && p(a.getLocator(l), c), c.value = c.nodeValue = s, o.setAttributeNode(c));
            }
          },
          endElement: function (e, t, r) {
            var a = this.currentElement;
            (a.tagName, this.currentElement = a.parentNode);
          },
          startPrefixMapping: function (e, t) {},
          endPrefixMapping: function (e) {},
          processingInstruction: function (e, t) {
            var r = this.doc.createProcessingInstruction(e, t);
            (this.locator && p(this.locator, r), g(this, r));
          },
          ignorableWhitespace: function (e, t, r) {},
          characters: function (e, t, r) {
            if (e = x.apply(this, arguments)) {
              if (this.cdata) var a = this.doc.createCDATASection(e); else a = this.doc.createTextNode(e);
              (this.currentElement ? this.currentElement.appendChild(a) : (/^\s*$/).test(e) && this.doc.appendChild(a), this.locator && p(this.locator, a));
            }
          },
          skippedEntity: function (e) {},
          endDocument: function () {
            this.doc.normalize();
          },
          setDocumentLocator: function (e) {
            (this.locator = e) && (e.lineNumber = 0);
          },
          comment: function (e, t, r) {
            e = x.apply(this, arguments);
            var a = this.doc.createComment(e);
            (this.locator && p(this.locator, a), g(this, a));
          },
          startCDATA: function () {
            this.cdata = !0;
          },
          endCDATA: function () {
            this.cdata = !1;
          },
          startDTD: function (e, t, r) {
            var a = this.doc.implementation;
            if (a && a.createDocumentType) {
              var n = a.createDocumentType(e, t, r);
              (this.locator && p(this.locator, n), g(this, n), this.doc.doctype = n);
            }
          },
          warning: function (e) {
            console.warn("[xmldom warning]\t" + e, f(this.locator));
          },
          error: function (e) {
            console.error("[xmldom error]\t" + e, f(this.locator));
          },
          fatalError: function (e) {
            throw new c(e, this.locator);
          }
        }, ("endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl").replace(/\w+/g, function (e) {
          m.prototype[e] = function () {
            return null;
          };
        }), t.DOMParser = d);
      },
      1146: (e, t, r) => {
        var a = r(2167), n = a.find, o = a.NAMESPACE;
        function i(e) {
          return "" !== e;
        }
        function l(e, t) {
          return (e.hasOwnProperty(t) || (e[t] = !0), e);
        }
        function s(e) {
          if (!e) return [];
          var t = (function (e) {
            return e ? e.split(/[\t\n\f\r ]+/).filter(i) : [];
          })(e);
          return Object.keys(t.reduce(l, {}));
        }
        function c(e, t) {
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        function u(e, t) {
          var r = e.prototype;
          if (!(r instanceof t)) {
            function a() {}
            (a.prototype = t.prototype, c(r, a = new a()), e.prototype = r = a);
          }
          r.constructor != e && ("function" != typeof e && console.error("unknown Class:" + e), r.constructor = e);
        }
        var h = {}, d = h.ELEMENT_NODE = 1, m = h.ATTRIBUTE_NODE = 2, p = h.TEXT_NODE = 3, f = h.CDATA_SECTION_NODE = 4, x = h.ENTITY_REFERENCE_NODE = 5, g = h.ENTITY_NODE = 6, w = h.PROCESSING_INSTRUCTION_NODE = 7, b = h.COMMENT_NODE = 8, v = h.DOCUMENT_NODE = 9, C = h.DOCUMENT_TYPE_NODE = 10, A = h.DOCUMENT_FRAGMENT_NODE = 11, E = h.NOTATION_NODE = 12, y = {}, _ = {}, q = (y.INDEX_SIZE_ERR = (_[1] = "Index size error", 1), y.DOMSTRING_SIZE_ERR = (_[2] = "DOMString size error", 2), y.HIERARCHY_REQUEST_ERR = (_[3] = "Hierarchy request error", 3)), D = (y.WRONG_DOCUMENT_ERR = (_[4] = "Wrong document", 4), y.INVALID_CHARACTER_ERR = (_[5] = "Invalid character", 5), y.NO_DATA_ALLOWED_ERR = (_[6] = "No data allowed", 6), y.NO_MODIFICATION_ALLOWED_ERR = (_[7] = "No modification allowed", 7), y.NOT_FOUND_ERR = (_[8] = "Not found", 8)), N = (y.NOT_SUPPORTED_ERR = (_[9] = "Not supported", 9), y.INUSE_ATTRIBUTE_ERR = (_[10] = "Attribute in use", 10));
        function T(e, t) {
          if (t instanceof Error) var r = t; else (r = this, Error.call(this, _[e]), this.message = _[e], Error.captureStackTrace && Error.captureStackTrace(this, T));
          return (r.code = e, t && (this.message = this.message + ": " + t), r);
        }
        function M() {}
        function O(e, t) {
          (this._node = e, this._refresh = t, L(this));
        }
        function L(e) {
          var t = e._node._inc || e._node.ownerDocument._inc;
          if (e._inc !== t) {
            var r = e._refresh(e._node);
            if ((we(e, "length", r.length), !e.$$length || r.length < e.$$length)) for (var a = r.length; (a in e); a++) Object.prototype.hasOwnProperty.call(e, a) && delete e[a];
            (c(r, e), e._inc = t);
          }
        }
        function B() {}
        function S(e, t) {
          for (var r = e.length; r--; ) if (e[r] === t) return r;
        }
        function F(e, t, r, a) {
          if ((a ? t[S(t, a)] = r : t[t.length++] = r, e)) {
            r.ownerElement = e;
            var n = e.ownerDocument;
            n && (a && G(n, e, a), (function (e, t, r) {
              (e && e._inc++, r.namespaceURI === o.XMLNS && (t._nsMap[r.prefix ? r.localName : ""] = r.value));
            })(n, e, r));
          }
        }
        function k(e, t, r) {
          var a = S(t, r);
          if (!(a >= 0)) throw new T(D, new Error(e.tagName + "@" + r));
          for (var n = t.length - 1; a < n; ) t[a] = t[++a];
          if ((t.length = n, e)) {
            var o = e.ownerDocument;
            o && (G(o, e, r), r.ownerElement = null);
          }
        }
        function P() {}
        function R() {}
        function I(e) {
          return ("<" == e ? "&lt;" : ">" == e && "&gt;") || "&" == e && "&amp;" || '"' == e && "&quot;" || "&#" + e.charCodeAt() + ";";
        }
        function U(e, t) {
          if (t(e)) return !0;
          if (e = e.firstChild) do {
            if (U(e, t)) return !0;
          } while (e = e.nextSibling);
        }
        function j() {
          this.ownerDocument = this;
        }
        function G(e, t, r, a) {
          (e && e._inc++, r.namespaceURI === o.XMLNS && delete t._nsMap[r.prefix ? r.localName : ""]);
        }
        function $(e, t, r) {
          if (e && e._inc) {
            e._inc++;
            var a = t.childNodes;
            if (r) a[a.length++] = r; else {
              for (var n = t.firstChild, o = 0; n; ) (a[o++] = n, n = n.nextSibling);
              (a.length = o, delete a[a.length]);
            }
          }
        }
        function V(e, t) {
          var r = t.previousSibling, a = t.nextSibling;
          return (r ? r.nextSibling = a : e.firstChild = a, a ? a.previousSibling = r : e.lastChild = r, t.parentNode = null, t.previousSibling = null, t.nextSibling = null, $(e.ownerDocument, e), t);
        }
        function X(e) {
          return e && e.nodeType === R.DOCUMENT_TYPE_NODE;
        }
        function H(e) {
          return e && e.nodeType === R.ELEMENT_NODE;
        }
        function W(e) {
          return e && e.nodeType === R.TEXT_NODE;
        }
        function z(e, t) {
          var r = e.childNodes || [];
          if (n(r, H) || X(t)) return !1;
          var a = n(r, X);
          return !(t && a && r.indexOf(a) > r.indexOf(t));
        }
        function Y(e, t) {
          var r = e.childNodes || [];
          if (n(r, function (e) {
            return H(e) && e !== t;
          })) return !1;
          var a = n(r, X);
          return !(t && a && r.indexOf(a) > r.indexOf(t));
        }
        function J(e, t, r) {
          var a = e.childNodes || [], o = t.childNodes || [];
          if (t.nodeType === R.DOCUMENT_FRAGMENT_NODE) {
            var i = o.filter(H);
            if (i.length > 1 || n(o, W)) throw new T(q, "More than one element or text in fragment");
            if (1 === i.length && !z(e, r)) throw new T(q, "Element in fragment can not be inserted before doctype");
          }
          if (H(t) && !z(e, r)) throw new T(q, "Only one element can be added and only after doctype");
          if (X(t)) {
            if (n(a, X)) throw new T(q, "Only one doctype is allowed");
            var l = n(a, H);
            if (r && a.indexOf(l) < a.indexOf(r)) throw new T(q, "Doctype can only be inserted before an element");
            if (!r && l) throw new T(q, "Doctype can not be appended since element is present");
          }
        }
        function Z(e, t, r) {
          var a = e.childNodes || [], o = t.childNodes || [];
          if (t.nodeType === R.DOCUMENT_FRAGMENT_NODE) {
            var i = o.filter(H);
            if (i.length > 1 || n(o, W)) throw new T(q, "More than one element or text in fragment");
            if (1 === i.length && !Y(e, r)) throw new T(q, "Element in fragment can not be inserted before doctype");
          }
          if (H(t) && !Y(e, r)) throw new T(q, "Only one element can be added and only after doctype");
          if (X(t)) {
            if (n(a, function (e) {
              return X(e) && e !== r;
            })) throw new T(q, "Only one doctype is allowed");
            var l = n(a, H);
            if (r && a.indexOf(l) < a.indexOf(r)) throw new T(q, "Doctype can only be inserted before an element");
          }
        }
        function Q(e, t, r, a) {
          (((function (e, t, r) {
            if (!(function (e) {
              return e && (e.nodeType === R.DOCUMENT_NODE || e.nodeType === R.DOCUMENT_FRAGMENT_NODE || e.nodeType === R.ELEMENT_NODE);
            })(e)) throw new T(q, "Unexpected parent node type " + e.nodeType);
            if (r && r.parentNode !== e) throw new T(D, "child not in parent");
            if (!(function (e) {
              return e && (H(e) || W(e) || X(e) || e.nodeType === R.DOCUMENT_FRAGMENT_NODE || e.nodeType === R.COMMENT_NODE || e.nodeType === R.PROCESSING_INSTRUCTION_NODE);
            })(t) || X(t) && e.nodeType !== R.DOCUMENT_NODE) throw new T(q, "Unexpected node type " + t.nodeType + " for parent node type " + e.nodeType);
          }))(e, t, r), e.nodeType === R.DOCUMENT_NODE && (a || J)(e, t, r));
          var n = t.parentNode;
          if ((n && n.removeChild(t), t.nodeType === A)) {
            var o = t.firstChild;
            if (null == o) return t;
            var i = t.lastChild;
          } else o = i = t;
          var l = r ? r.previousSibling : e.lastChild;
          (o.previousSibling = l, i.nextSibling = r, l ? l.nextSibling = o : e.firstChild = o, null == r ? e.lastChild = i : r.previousSibling = i);
          do {
            o.parentNode = e;
          } while (o !== i && (o = o.nextSibling));
          return ($(e.ownerDocument || e, e), t.nodeType == A && (t.firstChild = t.lastChild = null), t);
        }
        function K() {
          this._nsMap = {};
        }
        function ee() {}
        function te() {}
        function re() {}
        function ae() {}
        function ne() {}
        function oe() {}
        function ie() {}
        function le() {}
        function se() {}
        function ce() {}
        function ue() {}
        function he() {}
        function de(e, t) {
          var r = [], a = 9 == this.nodeType && this.documentElement || this, n = a.prefix, o = a.namespaceURI;
          if (o && null == n && null == (n = a.lookupPrefix(o))) var i = [{
            namespace: o,
            prefix: null
          }];
          return (fe(this, r, e, t, i), r.join(""));
        }
        function me(e, t, r) {
          var a = e.prefix || "", n = e.namespaceURI;
          if (!n) return !1;
          if ("xml" === a && n === o.XML || n === o.XMLNS) return !1;
          for (var i = r.length; i--; ) {
            var l = r[i];
            if (l.prefix === a) return l.namespace !== n;
          }
          return !0;
        }
        function pe(e, t, r) {
          e.push(" ", t, '="', r.replace(/[<>&"\t\n\r]/g, I), '"');
        }
        function fe(e, t, r, a, n) {
          if ((n || (n = []), a)) {
            if (!(e = a(e))) return;
            if ("string" == typeof e) return void t.push(e);
          }
          switch (e.nodeType) {
            case d:
              var i = e.attributes, l = i.length, s = e.firstChild, c = e.tagName, u = c;
              if (!(r = o.isHTML(e.namespaceURI) || r) && !e.prefix && e.namespaceURI) {
                for (var h, g = 0; g < i.length; g++) if ("xmlns" === i.item(g).name) {
                  h = i.item(g).value;
                  break;
                }
                if (!h) for (var E = n.length - 1; E >= 0; E--) if ("" === (y = n[E]).prefix && y.namespace === e.namespaceURI) {
                  h = y.namespace;
                  break;
                }
                if (h !== e.namespaceURI) for (E = n.length - 1; E >= 0; E--) {
                  var y;
                  if ((y = n[E]).namespace === e.namespaceURI) {
                    y.prefix && (u = y.prefix + ":" + c);
                    break;
                  }
                }
              }
              t.push("<", u);
              for (var _ = 0; _ < l; _++) "xmlns" == (q = i.item(_)).prefix ? n.push({
                prefix: q.localName,
                namespace: q.value
              }) : "xmlns" == q.nodeName && n.push({
                prefix: "",
                namespace: q.value
              });
              for (_ = 0; _ < l; _++) {
                var q, D, N;
                (me(q = i.item(_), 0, n) && (pe(t, (D = q.prefix || "") ? "xmlns:" + D : "xmlns", N = q.namespaceURI), n.push({
                  prefix: D,
                  namespace: N
                })), fe(q, t, r, a, n));
              }
              if ((c === u && me(e, 0, n) && (pe(t, (D = e.prefix || "") ? "xmlns:" + D : "xmlns", N = e.namespaceURI), n.push({
                prefix: D,
                namespace: N
              })), s || r && !(/^(?:meta|link|img|br|hr|input)$/i).test(c))) {
                if ((t.push(">"), r && (/^script$/i).test(c))) for (; s; ) (s.data ? t.push(s.data) : fe(s, t, r, a, n.slice()), s = s.nextSibling); else for (; s; ) (fe(s, t, r, a, n.slice()), s = s.nextSibling);
                t.push("</", u, ">");
              } else t.push("/>");
              return;
            case v:
            case A:
              for (s = e.firstChild; s; ) (fe(s, t, r, a, n.slice()), s = s.nextSibling);
              return;
            case m:
              return pe(t, e.name, e.value);
            case p:
              return t.push(e.data.replace(/[<&>]/g, I));
            case f:
              return t.push("<![CDATA[", e.data, "]]>");
            case b:
              return t.push("\x3c!--", e.data, "--\x3e");
            case C:
              var T = e.publicId, M = e.systemId;
              if ((t.push("<!DOCTYPE ", e.name), T)) (t.push(" PUBLIC ", T), M && "." != M && t.push(" ", M), t.push(">")); else if (M && "." != M) t.push(" SYSTEM ", M, ">"); else {
                var O = e.internalSubset;
                (O && t.push(" [", O, "]"), t.push(">"));
              }
              return;
            case w:
              return t.push("<?", e.target, " ", e.data, "?>");
            case x:
              return t.push("&", e.nodeName, ";");
            default:
              t.push("??", e.nodeName);
          }
        }
        function xe(e, t, r) {
          var a;
          switch (t.nodeType) {
            case d:
              (a = t.cloneNode(!1)).ownerDocument = e;
            case A:
              break;
            case m:
              r = !0;
          }
          if ((a || (a = t.cloneNode(!1)), a.ownerDocument = e, a.parentNode = null, r)) for (var n = t.firstChild; n; ) (a.appendChild(xe(e, n, r)), n = n.nextSibling);
          return a;
        }
        function ge(e, t, r) {
          var a = new t.constructor();
          for (var n in t) if (Object.prototype.hasOwnProperty.call(t, n)) {
            var o = t[n];
            "object" != typeof o && o != a[n] && (a[n] = o);
          }
          switch ((t.childNodes && (a.childNodes = new M()), a.ownerDocument = e, a.nodeType)) {
            case d:
              var i = t.attributes, l = a.attributes = new B(), s = i.length;
              l._ownerElement = a;
              for (var c = 0; c < s; c++) a.setAttributeNode(ge(e, i.item(c), !0));
              break;
            case m:
              r = !0;
          }
          if (r) for (var u = t.firstChild; u; ) (a.appendChild(ge(e, u, r)), u = u.nextSibling);
          return a;
        }
        function we(e, t, r) {
          e[t] = r;
        }
        (y.INVALID_STATE_ERR = (_[11] = "Invalid state", 11), y.SYNTAX_ERR = (_[12] = "Syntax error", 12), y.INVALID_MODIFICATION_ERR = (_[13] = "Invalid modification", 13), y.NAMESPACE_ERR = (_[14] = "Invalid namespace", 14), y.INVALID_ACCESS_ERR = (_[15] = "Invalid access", 15), T.prototype = Error.prototype, c(y, T), M.prototype = {
          length: 0,
          item: function (e) {
            return e >= 0 && e < this.length ? this[e] : null;
          },
          toString: function (e, t) {
            for (var r = [], a = 0; a < this.length; a++) fe(this[a], r, e, t);
            return r.join("");
          },
          filter: function (e) {
            return Array.prototype.filter.call(this, e);
          },
          indexOf: function (e) {
            return Array.prototype.indexOf.call(this, e);
          }
        }, O.prototype.item = function (e) {
          return (L(this), this[e] || null);
        }, u(O, M), B.prototype = {
          length: 0,
          item: M.prototype.item,
          getNamedItem: function (e) {
            for (var t = this.length; t--; ) {
              var r = this[t];
              if (r.nodeName == e) return r;
            }
          },
          setNamedItem: function (e) {
            var t = e.ownerElement;
            if (t && t != this._ownerElement) throw new T(N);
            var r = this.getNamedItem(e.nodeName);
            return (F(this._ownerElement, this, e, r), r);
          },
          setNamedItemNS: function (e) {
            var t, r = e.ownerElement;
            if (r && r != this._ownerElement) throw new T(N);
            return (t = this.getNamedItemNS(e.namespaceURI, e.localName), F(this._ownerElement, this, e, t), t);
          },
          removeNamedItem: function (e) {
            var t = this.getNamedItem(e);
            return (k(this._ownerElement, this, t), t);
          },
          removeNamedItemNS: function (e, t) {
            var r = this.getNamedItemNS(e, t);
            return (k(this._ownerElement, this, r), r);
          },
          getNamedItemNS: function (e, t) {
            for (var r = this.length; r--; ) {
              var a = this[r];
              if (a.localName == t && a.namespaceURI == e) return a;
            }
            return null;
          }
        }, P.prototype = {
          hasFeature: function (e, t) {
            return !0;
          },
          createDocument: function (e, t, r) {
            var a = new j();
            if ((a.implementation = this, a.childNodes = new M(), a.doctype = r || null, r && a.appendChild(r), t)) {
              var n = a.createElementNS(e, t);
              a.appendChild(n);
            }
            return a;
          },
          createDocumentType: function (e, t, r) {
            var a = new oe();
            return (a.name = e, a.nodeName = e, a.publicId = t || "", a.systemId = r || "", a);
          }
        }, R.prototype = {
          firstChild: null,
          lastChild: null,
          previousSibling: null,
          nextSibling: null,
          attributes: null,
          parentNode: null,
          childNodes: null,
          ownerDocument: null,
          nodeValue: null,
          namespaceURI: null,
          prefix: null,
          localName: null,
          insertBefore: function (e, t) {
            return Q(this, e, t);
          },
          replaceChild: function (e, t) {
            (Q(this, e, t, Z), t && this.removeChild(t));
          },
          removeChild: function (e) {
            return V(this, e);
          },
          appendChild: function (e) {
            return this.insertBefore(e, null);
          },
          hasChildNodes: function () {
            return null != this.firstChild;
          },
          cloneNode: function (e) {
            return ge(this.ownerDocument || this, this, e);
          },
          normalize: function () {
            for (var e = this.firstChild; e; ) {
              var t = e.nextSibling;
              t && t.nodeType == p && e.nodeType == p ? (this.removeChild(t), e.appendData(t.data)) : (e.normalize(), e = t);
            }
          },
          isSupported: function (e, t) {
            return this.ownerDocument.implementation.hasFeature(e, t);
          },
          hasAttributes: function () {
            return this.attributes.length > 0;
          },
          lookupPrefix: function (e) {
            for (var t = this; t; ) {
              var r = t._nsMap;
              if (r) for (var a in r) if (Object.prototype.hasOwnProperty.call(r, a) && r[a] === e) return a;
              t = t.nodeType == m ? t.ownerDocument : t.parentNode;
            }
            return null;
          },
          lookupNamespaceURI: function (e) {
            for (var t = this; t; ) {
              var r = t._nsMap;
              if (r && Object.prototype.hasOwnProperty.call(r, e)) return r[e];
              t = t.nodeType == m ? t.ownerDocument : t.parentNode;
            }
            return null;
          },
          isDefaultNamespace: function (e) {
            return null == this.lookupPrefix(e);
          }
        }, c(h, R), c(h, R.prototype), j.prototype = {
          nodeName: "#document",
          nodeType: v,
          doctype: null,
          documentElement: null,
          _inc: 1,
          insertBefore: function (e, t) {
            if (e.nodeType == A) {
              for (var r = e.firstChild; r; ) {
                var a = r.nextSibling;
                (this.insertBefore(r, t), r = a);
              }
              return e;
            }
            return (Q(this, e, t), e.ownerDocument = this, null === this.documentElement && e.nodeType === d && (this.documentElement = e), e);
          },
          removeChild: function (e) {
            return (this.documentElement == e && (this.documentElement = null), V(this, e));
          },
          replaceChild: function (e, t) {
            (Q(this, e, t, Z), e.ownerDocument = this, t && this.removeChild(t), H(e) && (this.documentElement = e));
          },
          importNode: function (e, t) {
            return xe(this, e, t);
          },
          getElementById: function (e) {
            var t = null;
            return (U(this.documentElement, function (r) {
              if (r.nodeType == d && r.getAttribute("id") == e) return (t = r, !0);
            }), t);
          },
          getElementsByClassName: function (e) {
            var t = s(e);
            return new O(this, function (r) {
              var a = [];
              return (t.length > 0 && U(r.documentElement, function (n) {
                if (n !== r && n.nodeType === d) {
                  var o = n.getAttribute("class");
                  if (o) {
                    var i = e === o;
                    if (!i) {
                      var l = s(o);
                      i = t.every((c = l, function (e) {
                        return c && -1 !== c.indexOf(e);
                      }));
                    }
                    i && a.push(n);
                  }
                }
                var c;
              }), a);
            });
          },
          createElement: function (e) {
            var t = new K();
            return (t.ownerDocument = this, t.nodeName = e, t.tagName = e, t.localName = e, t.childNodes = new M(), (t.attributes = new B())._ownerElement = t, t);
          },
          createDocumentFragment: function () {
            var e = new ce();
            return (e.ownerDocument = this, e.childNodes = new M(), e);
          },
          createTextNode: function (e) {
            var t = new re();
            return (t.ownerDocument = this, t.appendData(e), t);
          },
          createComment: function (e) {
            var t = new ae();
            return (t.ownerDocument = this, t.appendData(e), t);
          },
          createCDATASection: function (e) {
            var t = new ne();
            return (t.ownerDocument = this, t.appendData(e), t);
          },
          createProcessingInstruction: function (e, t) {
            var r = new ue();
            return (r.ownerDocument = this, r.tagName = r.nodeName = r.target = e, r.nodeValue = r.data = t, r);
          },
          createAttribute: function (e) {
            var t = new ee();
            return (t.ownerDocument = this, t.name = e, t.nodeName = e, t.localName = e, t.specified = !0, t);
          },
          createEntityReference: function (e) {
            var t = new se();
            return (t.ownerDocument = this, t.nodeName = e, t);
          },
          createElementNS: function (e, t) {
            var r = new K(), a = t.split(":"), n = r.attributes = new B();
            return (r.childNodes = new M(), r.ownerDocument = this, r.nodeName = t, r.tagName = t, r.namespaceURI = e, 2 == a.length ? (r.prefix = a[0], r.localName = a[1]) : r.localName = t, n._ownerElement = r, r);
          },
          createAttributeNS: function (e, t) {
            var r = new ee(), a = t.split(":");
            return (r.ownerDocument = this, r.nodeName = t, r.name = t, r.namespaceURI = e, r.specified = !0, 2 == a.length ? (r.prefix = a[0], r.localName = a[1]) : r.localName = t, r);
          }
        }, u(j, R), K.prototype = {
          nodeType: d,
          hasAttribute: function (e) {
            return null != this.getAttributeNode(e);
          },
          getAttribute: function (e) {
            var t = this.getAttributeNode(e);
            return t && t.value || "";
          },
          getAttributeNode: function (e) {
            return this.attributes.getNamedItem(e);
          },
          setAttribute: function (e, t) {
            var r = this.ownerDocument.createAttribute(e);
            (r.value = r.nodeValue = "" + t, this.setAttributeNode(r));
          },
          removeAttribute: function (e) {
            var t = this.getAttributeNode(e);
            t && this.removeAttributeNode(t);
          },
          appendChild: function (e) {
            return e.nodeType === A ? this.insertBefore(e, null) : (function (e, t) {
              return (t.parentNode && t.parentNode.removeChild(t), t.parentNode = e, t.previousSibling = e.lastChild, t.nextSibling = null, t.previousSibling ? t.previousSibling.nextSibling = t : e.firstChild = t, e.lastChild = t, $(e.ownerDocument, e, t), t);
            })(this, e);
          },
          setAttributeNode: function (e) {
            return this.attributes.setNamedItem(e);
          },
          setAttributeNodeNS: function (e) {
            return this.attributes.setNamedItemNS(e);
          },
          removeAttributeNode: function (e) {
            return this.attributes.removeNamedItem(e.nodeName);
          },
          removeAttributeNS: function (e, t) {
            var r = this.getAttributeNodeNS(e, t);
            r && this.removeAttributeNode(r);
          },
          hasAttributeNS: function (e, t) {
            return null != this.getAttributeNodeNS(e, t);
          },
          getAttributeNS: function (e, t) {
            var r = this.getAttributeNodeNS(e, t);
            return r && r.value || "";
          },
          setAttributeNS: function (e, t, r) {
            var a = this.ownerDocument.createAttributeNS(e, t);
            (a.value = a.nodeValue = "" + r, this.setAttributeNode(a));
          },
          getAttributeNodeNS: function (e, t) {
            return this.attributes.getNamedItemNS(e, t);
          },
          getElementsByTagName: function (e) {
            return new O(this, function (t) {
              var r = [];
              return (U(t, function (a) {
                a === t || a.nodeType != d || "*" !== e && a.tagName != e || r.push(a);
              }), r);
            });
          },
          getElementsByTagNameNS: function (e, t) {
            return new O(this, function (r) {
              var a = [];
              return (U(r, function (n) {
                n === r || n.nodeType !== d || "*" !== e && n.namespaceURI !== e || "*" !== t && n.localName != t || a.push(n);
              }), a);
            });
          }
        }, j.prototype.getElementsByTagName = K.prototype.getElementsByTagName, j.prototype.getElementsByTagNameNS = K.prototype.getElementsByTagNameNS, u(K, R), ee.prototype.nodeType = m, u(ee, R), te.prototype = {
          data: "",
          substringData: function (e, t) {
            return this.data.substring(e, e + t);
          },
          appendData: function (e) {
            (e = this.data + e, this.nodeValue = this.data = e, this.length = e.length);
          },
          insertData: function (e, t) {
            this.replaceData(e, 0, t);
          },
          appendChild: function (e) {
            throw new Error(_[q]);
          },
          deleteData: function (e, t) {
            this.replaceData(e, t, "");
          },
          replaceData: function (e, t, r) {
            (r = this.data.substring(0, e) + r + this.data.substring(e + t), this.nodeValue = this.data = r, this.length = r.length);
          }
        }, u(te, R), re.prototype = {
          nodeName: "#text",
          nodeType: p,
          splitText: function (e) {
            var t = this.data, r = t.substring(e);
            (t = t.substring(0, e), this.data = this.nodeValue = t, this.length = t.length);
            var a = this.ownerDocument.createTextNode(r);
            return (this.parentNode && this.parentNode.insertBefore(a, this.nextSibling), a);
          }
        }, u(re, te), ae.prototype = {
          nodeName: "#comment",
          nodeType: b
        }, u(ae, te), ne.prototype = {
          nodeName: "#cdata-section",
          nodeType: f
        }, u(ne, te), oe.prototype.nodeType = C, u(oe, R), ie.prototype.nodeType = E, u(ie, R), le.prototype.nodeType = g, u(le, R), se.prototype.nodeType = x, u(se, R), ce.prototype.nodeName = "#document-fragment", ce.prototype.nodeType = A, u(ce, R), ue.prototype.nodeType = w, u(ue, R), he.prototype.serializeToString = function (e, t, r) {
          return de.call(e, t, r);
        }, R.prototype.toString = de);
        try {
          if (Object.defineProperty) {
            function be(e) {
              switch (e.nodeType) {
                case d:
                case A:
                  var t = [];
                  for (e = e.firstChild; e; ) (7 !== e.nodeType && 8 !== e.nodeType && t.push(be(e)), e = e.nextSibling);
                  return t.join("");
                default:
                  return e.nodeValue;
              }
            }
            (Object.defineProperty(O.prototype, "length", {
              get: function () {
                return (L(this), this.$$length);
              }
            }), Object.defineProperty(R.prototype, "textContent", {
              get: function () {
                return be(this);
              },
              set: function (e) {
                switch (this.nodeType) {
                  case d:
                  case A:
                    for (; this.firstChild; ) this.removeChild(this.firstChild);
                    (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
                    break;
                  default:
                    (this.data = e, this.value = e, this.nodeValue = e);
                }
              }
            }), we = function (e, t, r) {
              e["$$" + t] = r;
            });
          }
        } catch (ve) {}
        (t.DocumentType = oe, t.DOMException = T, t.DOMImplementation = P, t.Element = K, t.Node = R, t.NodeList = M, t.XMLSerializer = he);
      },
      1045: (e, t, r) => {
        var a = r(2167).freeze;
        (t.XML_ENTITIES = a({
          amp: "&",
          apos: "'",
          gt: ">",
          lt: "<",
          quot: '"'
        }), t.HTML_ENTITIES = a({
          Aacute: "Á",
          aacute: "á",
          Abreve: "Ă",
          abreve: "ă",
          ac: "∾",
          acd: "∿",
          acE: "∾̳",
          Acirc: "Â",
          acirc: "â",
          acute: "´",
          Acy: "А",
          acy: "а",
          AElig: "Æ",
          aelig: "æ",
          af: "⁡",
          Afr: "𝔄",
          afr: "𝔞",
          Agrave: "À",
          agrave: "à",
          alefsym: "ℵ",
          aleph: "ℵ",
          Alpha: "Α",
          alpha: "α",
          Amacr: "Ā",
          amacr: "ā",
          amalg: "⨿",
          AMP: "&",
          amp: "&",
          And: "⩓",
          and: "∧",
          andand: "⩕",
          andd: "⩜",
          andslope: "⩘",
          andv: "⩚",
          ang: "∠",
          ange: "⦤",
          angle: "∠",
          angmsd: "∡",
          angmsdaa: "⦨",
          angmsdab: "⦩",
          angmsdac: "⦪",
          angmsdad: "⦫",
          angmsdae: "⦬",
          angmsdaf: "⦭",
          angmsdag: "⦮",
          angmsdah: "⦯",
          angrt: "∟",
          angrtvb: "⊾",
          angrtvbd: "⦝",
          angsph: "∢",
          angst: "Å",
          angzarr: "⍼",
          Aogon: "Ą",
          aogon: "ą",
          Aopf: "𝔸",
          aopf: "𝕒",
          ap: "≈",
          apacir: "⩯",
          apE: "⩰",
          ape: "≊",
          apid: "≋",
          apos: "'",
          ApplyFunction: "⁡",
          approx: "≈",
          approxeq: "≊",
          Aring: "Å",
          aring: "å",
          Ascr: "𝒜",
          ascr: "𝒶",
          Assign: "≔",
          ast: "*",
          asymp: "≈",
          asympeq: "≍",
          Atilde: "Ã",
          atilde: "ã",
          Auml: "Ä",
          auml: "ä",
          awconint: "∳",
          awint: "⨑",
          backcong: "≌",
          backepsilon: "϶",
          backprime: "‵",
          backsim: "∽",
          backsimeq: "⋍",
          Backslash: "∖",
          Barv: "⫧",
          barvee: "⊽",
          Barwed: "⌆",
          barwed: "⌅",
          barwedge: "⌅",
          bbrk: "⎵",
          bbrktbrk: "⎶",
          bcong: "≌",
          Bcy: "Б",
          bcy: "б",
          bdquo: "„",
          becaus: "∵",
          Because: "∵",
          because: "∵",
          bemptyv: "⦰",
          bepsi: "϶",
          bernou: "ℬ",
          Bernoullis: "ℬ",
          Beta: "Β",
          beta: "β",
          beth: "ℶ",
          between: "≬",
          Bfr: "𝔅",
          bfr: "𝔟",
          bigcap: "⋂",
          bigcirc: "◯",
          bigcup: "⋃",
          bigodot: "⨀",
          bigoplus: "⨁",
          bigotimes: "⨂",
          bigsqcup: "⨆",
          bigstar: "★",
          bigtriangledown: "▽",
          bigtriangleup: "△",
          biguplus: "⨄",
          bigvee: "⋁",
          bigwedge: "⋀",
          bkarow: "⤍",
          blacklozenge: "⧫",
          blacksquare: "▪",
          blacktriangle: "▴",
          blacktriangledown: "▾",
          blacktriangleleft: "◂",
          blacktriangleright: "▸",
          blank: "␣",
          blk12: "▒",
          blk14: "░",
          blk34: "▓",
          block: "█",
          bne: "=⃥",
          bnequiv: "≡⃥",
          bNot: "⫭",
          bnot: "⌐",
          Bopf: "𝔹",
          bopf: "𝕓",
          bot: "⊥",
          bottom: "⊥",
          bowtie: "⋈",
          boxbox: "⧉",
          boxDL: "╗",
          boxDl: "╖",
          boxdL: "╕",
          boxdl: "┐",
          boxDR: "╔",
          boxDr: "╓",
          boxdR: "╒",
          boxdr: "┌",
          boxH: "═",
          boxh: "─",
          boxHD: "╦",
          boxHd: "╤",
          boxhD: "╥",
          boxhd: "┬",
          boxHU: "╩",
          boxHu: "╧",
          boxhU: "╨",
          boxhu: "┴",
          boxminus: "⊟",
          boxplus: "⊞",
          boxtimes: "⊠",
          boxUL: "╝",
          boxUl: "╜",
          boxuL: "╛",
          boxul: "┘",
          boxUR: "╚",
          boxUr: "╙",
          boxuR: "╘",
          boxur: "└",
          boxV: "║",
          boxv: "│",
          boxVH: "╬",
          boxVh: "╫",
          boxvH: "╪",
          boxvh: "┼",
          boxVL: "╣",
          boxVl: "╢",
          boxvL: "╡",
          boxvl: "┤",
          boxVR: "╠",
          boxVr: "╟",
          boxvR: "╞",
          boxvr: "├",
          bprime: "‵",
          Breve: "˘",
          breve: "˘",
          brvbar: "¦",
          Bscr: "ℬ",
          bscr: "𝒷",
          bsemi: "⁏",
          bsim: "∽",
          bsime: "⋍",
          bsol: "\\",
          bsolb: "⧅",
          bsolhsub: "⟈",
          bull: "•",
          bullet: "•",
          bump: "≎",
          bumpE: "⪮",
          bumpe: "≏",
          Bumpeq: "≎",
          bumpeq: "≏",
          Cacute: "Ć",
          cacute: "ć",
          Cap: "⋒",
          cap: "∩",
          capand: "⩄",
          capbrcup: "⩉",
          capcap: "⩋",
          capcup: "⩇",
          capdot: "⩀",
          CapitalDifferentialD: "ⅅ",
          caps: "∩︀",
          caret: "⁁",
          caron: "ˇ",
          Cayleys: "ℭ",
          ccaps: "⩍",
          Ccaron: "Č",
          ccaron: "č",
          Ccedil: "Ç",
          ccedil: "ç",
          Ccirc: "Ĉ",
          ccirc: "ĉ",
          Cconint: "∰",
          ccups: "⩌",
          ccupssm: "⩐",
          Cdot: "Ċ",
          cdot: "ċ",
          cedil: "¸",
          Cedilla: "¸",
          cemptyv: "⦲",
          cent: "¢",
          CenterDot: "·",
          centerdot: "·",
          Cfr: "ℭ",
          cfr: "𝔠",
          CHcy: "Ч",
          chcy: "ч",
          check: "✓",
          checkmark: "✓",
          Chi: "Χ",
          chi: "χ",
          cir: "○",
          circ: "ˆ",
          circeq: "≗",
          circlearrowleft: "↺",
          circlearrowright: "↻",
          circledast: "⊛",
          circledcirc: "⊚",
          circleddash: "⊝",
          CircleDot: "⊙",
          circledR: "®",
          circledS: "Ⓢ",
          CircleMinus: "⊖",
          CirclePlus: "⊕",
          CircleTimes: "⊗",
          cirE: "⧃",
          cire: "≗",
          cirfnint: "⨐",
          cirmid: "⫯",
          cirscir: "⧂",
          ClockwiseContourIntegral: "∲",
          CloseCurlyDoubleQuote: "”",
          CloseCurlyQuote: "’",
          clubs: "♣",
          clubsuit: "♣",
          Colon: "∷",
          colon: ":",
          Colone: "⩴",
          colone: "≔",
          coloneq: "≔",
          comma: ",",
          commat: "@",
          comp: "∁",
          compfn: "∘",
          complement: "∁",
          complexes: "ℂ",
          cong: "≅",
          congdot: "⩭",
          Congruent: "≡",
          Conint: "∯",
          conint: "∮",
          ContourIntegral: "∮",
          Copf: "ℂ",
          copf: "𝕔",
          coprod: "∐",
          Coproduct: "∐",
          COPY: "©",
          copy: "©",
          copysr: "℗",
          CounterClockwiseContourIntegral: "∳",
          crarr: "↵",
          Cross: "⨯",
          cross: "✗",
          Cscr: "𝒞",
          cscr: "𝒸",
          csub: "⫏",
          csube: "⫑",
          csup: "⫐",
          csupe: "⫒",
          ctdot: "⋯",
          cudarrl: "⤸",
          cudarrr: "⤵",
          cuepr: "⋞",
          cuesc: "⋟",
          cularr: "↶",
          cularrp: "⤽",
          Cup: "⋓",
          cup: "∪",
          cupbrcap: "⩈",
          CupCap: "≍",
          cupcap: "⩆",
          cupcup: "⩊",
          cupdot: "⊍",
          cupor: "⩅",
          cups: "∪︀",
          curarr: "↷",
          curarrm: "⤼",
          curlyeqprec: "⋞",
          curlyeqsucc: "⋟",
          curlyvee: "⋎",
          curlywedge: "⋏",
          curren: "¤",
          curvearrowleft: "↶",
          curvearrowright: "↷",
          cuvee: "⋎",
          cuwed: "⋏",
          cwconint: "∲",
          cwint: "∱",
          cylcty: "⌭",
          Dagger: "‡",
          dagger: "†",
          daleth: "ℸ",
          Darr: "↡",
          dArr: "⇓",
          darr: "↓",
          dash: "‐",
          Dashv: "⫤",
          dashv: "⊣",
          dbkarow: "⤏",
          dblac: "˝",
          Dcaron: "Ď",
          dcaron: "ď",
          Dcy: "Д",
          dcy: "д",
          DD: "ⅅ",
          dd: "ⅆ",
          ddagger: "‡",
          ddarr: "⇊",
          DDotrahd: "⤑",
          ddotseq: "⩷",
          deg: "°",
          Del: "∇",
          Delta: "Δ",
          delta: "δ",
          demptyv: "⦱",
          dfisht: "⥿",
          Dfr: "𝔇",
          dfr: "𝔡",
          dHar: "⥥",
          dharl: "⇃",
          dharr: "⇂",
          DiacriticalAcute: "´",
          DiacriticalDot: "˙",
          DiacriticalDoubleAcute: "˝",
          DiacriticalGrave: "`",
          DiacriticalTilde: "˜",
          diam: "⋄",
          Diamond: "⋄",
          diamond: "⋄",
          diamondsuit: "♦",
          diams: "♦",
          die: "¨",
          DifferentialD: "ⅆ",
          digamma: "ϝ",
          disin: "⋲",
          div: "÷",
          divide: "÷",
          divideontimes: "⋇",
          divonx: "⋇",
          DJcy: "Ђ",
          djcy: "ђ",
          dlcorn: "⌞",
          dlcrop: "⌍",
          dollar: "$",
          Dopf: "𝔻",
          dopf: "𝕕",
          Dot: "¨",
          dot: "˙",
          DotDot: "⃜",
          doteq: "≐",
          doteqdot: "≑",
          DotEqual: "≐",
          dotminus: "∸",
          dotplus: "∔",
          dotsquare: "⊡",
          doublebarwedge: "⌆",
          DoubleContourIntegral: "∯",
          DoubleDot: "¨",
          DoubleDownArrow: "⇓",
          DoubleLeftArrow: "⇐",
          DoubleLeftRightArrow: "⇔",
          DoubleLeftTee: "⫤",
          DoubleLongLeftArrow: "⟸",
          DoubleLongLeftRightArrow: "⟺",
          DoubleLongRightArrow: "⟹",
          DoubleRightArrow: "⇒",
          DoubleRightTee: "⊨",
          DoubleUpArrow: "⇑",
          DoubleUpDownArrow: "⇕",
          DoubleVerticalBar: "∥",
          DownArrow: "↓",
          Downarrow: "⇓",
          downarrow: "↓",
          DownArrowBar: "⤓",
          DownArrowUpArrow: "⇵",
          DownBreve: "̑",
          downdownarrows: "⇊",
          downharpoonleft: "⇃",
          downharpoonright: "⇂",
          DownLeftRightVector: "⥐",
          DownLeftTeeVector: "⥞",
          DownLeftVector: "↽",
          DownLeftVectorBar: "⥖",
          DownRightTeeVector: "⥟",
          DownRightVector: "⇁",
          DownRightVectorBar: "⥗",
          DownTee: "⊤",
          DownTeeArrow: "↧",
          drbkarow: "⤐",
          drcorn: "⌟",
          drcrop: "⌌",
          Dscr: "𝒟",
          dscr: "𝒹",
          DScy: "Ѕ",
          dscy: "ѕ",
          dsol: "⧶",
          Dstrok: "Đ",
          dstrok: "đ",
          dtdot: "⋱",
          dtri: "▿",
          dtrif: "▾",
          duarr: "⇵",
          duhar: "⥯",
          dwangle: "⦦",
          DZcy: "Џ",
          dzcy: "џ",
          dzigrarr: "⟿",
          Eacute: "É",
          eacute: "é",
          easter: "⩮",
          Ecaron: "Ě",
          ecaron: "ě",
          ecir: "≖",
          Ecirc: "Ê",
          ecirc: "ê",
          ecolon: "≕",
          Ecy: "Э",
          ecy: "э",
          eDDot: "⩷",
          Edot: "Ė",
          eDot: "≑",
          edot: "ė",
          ee: "ⅇ",
          efDot: "≒",
          Efr: "𝔈",
          efr: "𝔢",
          eg: "⪚",
          Egrave: "È",
          egrave: "è",
          egs: "⪖",
          egsdot: "⪘",
          el: "⪙",
          Element: "∈",
          elinters: "⏧",
          ell: "ℓ",
          els: "⪕",
          elsdot: "⪗",
          Emacr: "Ē",
          emacr: "ē",
          empty: "∅",
          emptyset: "∅",
          EmptySmallSquare: "◻",
          emptyv: "∅",
          EmptyVerySmallSquare: "▫",
          emsp: " ",
          emsp13: " ",
          emsp14: " ",
          ENG: "Ŋ",
          eng: "ŋ",
          ensp: " ",
          Eogon: "Ę",
          eogon: "ę",
          Eopf: "𝔼",
          eopf: "𝕖",
          epar: "⋕",
          eparsl: "⧣",
          eplus: "⩱",
          epsi: "ε",
          Epsilon: "Ε",
          epsilon: "ε",
          epsiv: "ϵ",
          eqcirc: "≖",
          eqcolon: "≕",
          eqsim: "≂",
          eqslantgtr: "⪖",
          eqslantless: "⪕",
          Equal: "⩵",
          equals: "=",
          EqualTilde: "≂",
          equest: "≟",
          Equilibrium: "⇌",
          equiv: "≡",
          equivDD: "⩸",
          eqvparsl: "⧥",
          erarr: "⥱",
          erDot: "≓",
          Escr: "ℰ",
          escr: "ℯ",
          esdot: "≐",
          Esim: "⩳",
          esim: "≂",
          Eta: "Η",
          eta: "η",
          ETH: "Ð",
          eth: "ð",
          Euml: "Ë",
          euml: "ë",
          euro: "€",
          excl: "!",
          exist: "∃",
          Exists: "∃",
          expectation: "ℰ",
          ExponentialE: "ⅇ",
          exponentiale: "ⅇ",
          fallingdotseq: "≒",
          Fcy: "Ф",
          fcy: "ф",
          female: "♀",
          ffilig: "ﬃ",
          fflig: "ﬀ",
          ffllig: "ﬄ",
          Ffr: "𝔉",
          ffr: "𝔣",
          filig: "ﬁ",
          FilledSmallSquare: "◼",
          FilledVerySmallSquare: "▪",
          fjlig: "fj",
          flat: "♭",
          fllig: "ﬂ",
          fltns: "▱",
          fnof: "ƒ",
          Fopf: "𝔽",
          fopf: "𝕗",
          ForAll: "∀",
          forall: "∀",
          fork: "⋔",
          forkv: "⫙",
          Fouriertrf: "ℱ",
          fpartint: "⨍",
          frac12: "½",
          frac13: "⅓",
          frac14: "¼",
          frac15: "⅕",
          frac16: "⅙",
          frac18: "⅛",
          frac23: "⅔",
          frac25: "⅖",
          frac34: "¾",
          frac35: "⅗",
          frac38: "⅜",
          frac45: "⅘",
          frac56: "⅚",
          frac58: "⅝",
          frac78: "⅞",
          frasl: "⁄",
          frown: "⌢",
          Fscr: "ℱ",
          fscr: "𝒻",
          gacute: "ǵ",
          Gamma: "Γ",
          gamma: "γ",
          Gammad: "Ϝ",
          gammad: "ϝ",
          gap: "⪆",
          Gbreve: "Ğ",
          gbreve: "ğ",
          Gcedil: "Ģ",
          Gcirc: "Ĝ",
          gcirc: "ĝ",
          Gcy: "Г",
          gcy: "г",
          Gdot: "Ġ",
          gdot: "ġ",
          gE: "≧",
          ge: "≥",
          gEl: "⪌",
          gel: "⋛",
          geq: "≥",
          geqq: "≧",
          geqslant: "⩾",
          ges: "⩾",
          gescc: "⪩",
          gesdot: "⪀",
          gesdoto: "⪂",
          gesdotol: "⪄",
          gesl: "⋛︀",
          gesles: "⪔",
          Gfr: "𝔊",
          gfr: "𝔤",
          Gg: "⋙",
          gg: "≫",
          ggg: "⋙",
          gimel: "ℷ",
          GJcy: "Ѓ",
          gjcy: "ѓ",
          gl: "≷",
          gla: "⪥",
          glE: "⪒",
          glj: "⪤",
          gnap: "⪊",
          gnapprox: "⪊",
          gnE: "≩",
          gne: "⪈",
          gneq: "⪈",
          gneqq: "≩",
          gnsim: "⋧",
          Gopf: "𝔾",
          gopf: "𝕘",
          grave: "`",
          GreaterEqual: "≥",
          GreaterEqualLess: "⋛",
          GreaterFullEqual: "≧",
          GreaterGreater: "⪢",
          GreaterLess: "≷",
          GreaterSlantEqual: "⩾",
          GreaterTilde: "≳",
          Gscr: "𝒢",
          gscr: "ℊ",
          gsim: "≳",
          gsime: "⪎",
          gsiml: "⪐",
          Gt: "≫",
          GT: ">",
          gt: ">",
          gtcc: "⪧",
          gtcir: "⩺",
          gtdot: "⋗",
          gtlPar: "⦕",
          gtquest: "⩼",
          gtrapprox: "⪆",
          gtrarr: "⥸",
          gtrdot: "⋗",
          gtreqless: "⋛",
          gtreqqless: "⪌",
          gtrless: "≷",
          gtrsim: "≳",
          gvertneqq: "≩︀",
          gvnE: "≩︀",
          Hacek: "ˇ",
          hairsp: " ",
          half: "½",
          hamilt: "ℋ",
          HARDcy: "Ъ",
          hardcy: "ъ",
          hArr: "⇔",
          harr: "↔",
          harrcir: "⥈",
          harrw: "↭",
          Hat: "^",
          hbar: "ℏ",
          Hcirc: "Ĥ",
          hcirc: "ĥ",
          hearts: "♥",
          heartsuit: "♥",
          hellip: "…",
          hercon: "⊹",
          Hfr: "ℌ",
          hfr: "𝔥",
          HilbertSpace: "ℋ",
          hksearow: "⤥",
          hkswarow: "⤦",
          hoarr: "⇿",
          homtht: "∻",
          hookleftarrow: "↩",
          hookrightarrow: "↪",
          Hopf: "ℍ",
          hopf: "𝕙",
          horbar: "―",
          HorizontalLine: "─",
          Hscr: "ℋ",
          hscr: "𝒽",
          hslash: "ℏ",
          Hstrok: "Ħ",
          hstrok: "ħ",
          HumpDownHump: "≎",
          HumpEqual: "≏",
          hybull: "⁃",
          hyphen: "‐",
          Iacute: "Í",
          iacute: "í",
          ic: "⁣",
          Icirc: "Î",
          icirc: "î",
          Icy: "И",
          icy: "и",
          Idot: "İ",
          IEcy: "Е",
          iecy: "е",
          iexcl: "¡",
          iff: "⇔",
          Ifr: "ℑ",
          ifr: "𝔦",
          Igrave: "Ì",
          igrave: "ì",
          ii: "ⅈ",
          iiiint: "⨌",
          iiint: "∭",
          iinfin: "⧜",
          iiota: "℩",
          IJlig: "Ĳ",
          ijlig: "ĳ",
          Im: "ℑ",
          Imacr: "Ī",
          imacr: "ī",
          image: "ℑ",
          ImaginaryI: "ⅈ",
          imagline: "ℐ",
          imagpart: "ℑ",
          imath: "ı",
          imof: "⊷",
          imped: "Ƶ",
          Implies: "⇒",
          in: "∈",
          incare: "℅",
          infin: "∞",
          infintie: "⧝",
          inodot: "ı",
          Int: "∬",
          int: "∫",
          intcal: "⊺",
          integers: "ℤ",
          Integral: "∫",
          intercal: "⊺",
          Intersection: "⋂",
          intlarhk: "⨗",
          intprod: "⨼",
          InvisibleComma: "⁣",
          InvisibleTimes: "⁢",
          IOcy: "Ё",
          iocy: "ё",
          Iogon: "Į",
          iogon: "į",
          Iopf: "𝕀",
          iopf: "𝕚",
          Iota: "Ι",
          iota: "ι",
          iprod: "⨼",
          iquest: "¿",
          Iscr: "ℐ",
          iscr: "𝒾",
          isin: "∈",
          isindot: "⋵",
          isinE: "⋹",
          isins: "⋴",
          isinsv: "⋳",
          isinv: "∈",
          it: "⁢",
          Itilde: "Ĩ",
          itilde: "ĩ",
          Iukcy: "І",
          iukcy: "і",
          Iuml: "Ï",
          iuml: "ï",
          Jcirc: "Ĵ",
          jcirc: "ĵ",
          Jcy: "Й",
          jcy: "й",
          Jfr: "𝔍",
          jfr: "𝔧",
          jmath: "ȷ",
          Jopf: "𝕁",
          jopf: "𝕛",
          Jscr: "𝒥",
          jscr: "𝒿",
          Jsercy: "Ј",
          jsercy: "ј",
          Jukcy: "Є",
          jukcy: "є",
          Kappa: "Κ",
          kappa: "κ",
          kappav: "ϰ",
          Kcedil: "Ķ",
          kcedil: "ķ",
          Kcy: "К",
          kcy: "к",
          Kfr: "𝔎",
          kfr: "𝔨",
          kgreen: "ĸ",
          KHcy: "Х",
          khcy: "х",
          KJcy: "Ќ",
          kjcy: "ќ",
          Kopf: "𝕂",
          kopf: "𝕜",
          Kscr: "𝒦",
          kscr: "𝓀",
          lAarr: "⇚",
          Lacute: "Ĺ",
          lacute: "ĺ",
          laemptyv: "⦴",
          lagran: "ℒ",
          Lambda: "Λ",
          lambda: "λ",
          Lang: "⟪",
          lang: "⟨",
          langd: "⦑",
          langle: "⟨",
          lap: "⪅",
          Laplacetrf: "ℒ",
          laquo: "«",
          Larr: "↞",
          lArr: "⇐",
          larr: "←",
          larrb: "⇤",
          larrbfs: "⤟",
          larrfs: "⤝",
          larrhk: "↩",
          larrlp: "↫",
          larrpl: "⤹",
          larrsim: "⥳",
          larrtl: "↢",
          lat: "⪫",
          lAtail: "⤛",
          latail: "⤙",
          late: "⪭",
          lates: "⪭︀",
          lBarr: "⤎",
          lbarr: "⤌",
          lbbrk: "❲",
          lbrace: "{",
          lbrack: "[",
          lbrke: "⦋",
          lbrksld: "⦏",
          lbrkslu: "⦍",
          Lcaron: "Ľ",
          lcaron: "ľ",
          Lcedil: "Ļ",
          lcedil: "ļ",
          lceil: "⌈",
          lcub: "{",
          Lcy: "Л",
          lcy: "л",
          ldca: "⤶",
          ldquo: "“",
          ldquor: "„",
          ldrdhar: "⥧",
          ldrushar: "⥋",
          ldsh: "↲",
          lE: "≦",
          le: "≤",
          LeftAngleBracket: "⟨",
          LeftArrow: "←",
          Leftarrow: "⇐",
          leftarrow: "←",
          LeftArrowBar: "⇤",
          LeftArrowRightArrow: "⇆",
          leftarrowtail: "↢",
          LeftCeiling: "⌈",
          LeftDoubleBracket: "⟦",
          LeftDownTeeVector: "⥡",
          LeftDownVector: "⇃",
          LeftDownVectorBar: "⥙",
          LeftFloor: "⌊",
          leftharpoondown: "↽",
          leftharpoonup: "↼",
          leftleftarrows: "⇇",
          LeftRightArrow: "↔",
          Leftrightarrow: "⇔",
          leftrightarrow: "↔",
          leftrightarrows: "⇆",
          leftrightharpoons: "⇋",
          leftrightsquigarrow: "↭",
          LeftRightVector: "⥎",
          LeftTee: "⊣",
          LeftTeeArrow: "↤",
          LeftTeeVector: "⥚",
          leftthreetimes: "⋋",
          LeftTriangle: "⊲",
          LeftTriangleBar: "⧏",
          LeftTriangleEqual: "⊴",
          LeftUpDownVector: "⥑",
          LeftUpTeeVector: "⥠",
          LeftUpVector: "↿",
          LeftUpVectorBar: "⥘",
          LeftVector: "↼",
          LeftVectorBar: "⥒",
          lEg: "⪋",
          leg: "⋚",
          leq: "≤",
          leqq: "≦",
          leqslant: "⩽",
          les: "⩽",
          lescc: "⪨",
          lesdot: "⩿",
          lesdoto: "⪁",
          lesdotor: "⪃",
          lesg: "⋚︀",
          lesges: "⪓",
          lessapprox: "⪅",
          lessdot: "⋖",
          lesseqgtr: "⋚",
          lesseqqgtr: "⪋",
          LessEqualGreater: "⋚",
          LessFullEqual: "≦",
          LessGreater: "≶",
          lessgtr: "≶",
          LessLess: "⪡",
          lesssim: "≲",
          LessSlantEqual: "⩽",
          LessTilde: "≲",
          lfisht: "⥼",
          lfloor: "⌊",
          Lfr: "𝔏",
          lfr: "𝔩",
          lg: "≶",
          lgE: "⪑",
          lHar: "⥢",
          lhard: "↽",
          lharu: "↼",
          lharul: "⥪",
          lhblk: "▄",
          LJcy: "Љ",
          ljcy: "љ",
          Ll: "⋘",
          ll: "≪",
          llarr: "⇇",
          llcorner: "⌞",
          Lleftarrow: "⇚",
          llhard: "⥫",
          lltri: "◺",
          Lmidot: "Ŀ",
          lmidot: "ŀ",
          lmoust: "⎰",
          lmoustache: "⎰",
          lnap: "⪉",
          lnapprox: "⪉",
          lnE: "≨",
          lne: "⪇",
          lneq: "⪇",
          lneqq: "≨",
          lnsim: "⋦",
          loang: "⟬",
          loarr: "⇽",
          lobrk: "⟦",
          LongLeftArrow: "⟵",
          Longleftarrow: "⟸",
          longleftarrow: "⟵",
          LongLeftRightArrow: "⟷",
          Longleftrightarrow: "⟺",
          longleftrightarrow: "⟷",
          longmapsto: "⟼",
          LongRightArrow: "⟶",
          Longrightarrow: "⟹",
          longrightarrow: "⟶",
          looparrowleft: "↫",
          looparrowright: "↬",
          lopar: "⦅",
          Lopf: "𝕃",
          lopf: "𝕝",
          loplus: "⨭",
          lotimes: "⨴",
          lowast: "∗",
          lowbar: "_",
          LowerLeftArrow: "↙",
          LowerRightArrow: "↘",
          loz: "◊",
          lozenge: "◊",
          lozf: "⧫",
          lpar: "(",
          lparlt: "⦓",
          lrarr: "⇆",
          lrcorner: "⌟",
          lrhar: "⇋",
          lrhard: "⥭",
          lrm: "‎",
          lrtri: "⊿",
          lsaquo: "‹",
          Lscr: "ℒ",
          lscr: "𝓁",
          Lsh: "↰",
          lsh: "↰",
          lsim: "≲",
          lsime: "⪍",
          lsimg: "⪏",
          lsqb: "[",
          lsquo: "‘",
          lsquor: "‚",
          Lstrok: "Ł",
          lstrok: "ł",
          Lt: "≪",
          LT: "<",
          lt: "<",
          ltcc: "⪦",
          ltcir: "⩹",
          ltdot: "⋖",
          lthree: "⋋",
          ltimes: "⋉",
          ltlarr: "⥶",
          ltquest: "⩻",
          ltri: "◃",
          ltrie: "⊴",
          ltrif: "◂",
          ltrPar: "⦖",
          lurdshar: "⥊",
          luruhar: "⥦",
          lvertneqq: "≨︀",
          lvnE: "≨︀",
          macr: "¯",
          male: "♂",
          malt: "✠",
          maltese: "✠",
          Map: "⤅",
          map: "↦",
          mapsto: "↦",
          mapstodown: "↧",
          mapstoleft: "↤",
          mapstoup: "↥",
          marker: "▮",
          mcomma: "⨩",
          Mcy: "М",
          mcy: "м",
          mdash: "—",
          mDDot: "∺",
          measuredangle: "∡",
          MediumSpace: " ",
          Mellintrf: "ℳ",
          Mfr: "𝔐",
          mfr: "𝔪",
          mho: "℧",
          micro: "µ",
          mid: "∣",
          midast: "*",
          midcir: "⫰",
          middot: "·",
          minus: "−",
          minusb: "⊟",
          minusd: "∸",
          minusdu: "⨪",
          MinusPlus: "∓",
          mlcp: "⫛",
          mldr: "…",
          mnplus: "∓",
          models: "⊧",
          Mopf: "𝕄",
          mopf: "𝕞",
          mp: "∓",
          Mscr: "ℳ",
          mscr: "𝓂",
          mstpos: "∾",
          Mu: "Μ",
          mu: "μ",
          multimap: "⊸",
          mumap: "⊸",
          nabla: "∇",
          Nacute: "Ń",
          nacute: "ń",
          nang: "∠⃒",
          nap: "≉",
          napE: "⩰̸",
          napid: "≋̸",
          napos: "ŉ",
          napprox: "≉",
          natur: "♮",
          natural: "♮",
          naturals: "ℕ",
          nbsp: " ",
          nbump: "≎̸",
          nbumpe: "≏̸",
          ncap: "⩃",
          Ncaron: "Ň",
          ncaron: "ň",
          Ncedil: "Ņ",
          ncedil: "ņ",
          ncong: "≇",
          ncongdot: "⩭̸",
          ncup: "⩂",
          Ncy: "Н",
          ncy: "н",
          ndash: "–",
          ne: "≠",
          nearhk: "⤤",
          neArr: "⇗",
          nearr: "↗",
          nearrow: "↗",
          nedot: "≐̸",
          NegativeMediumSpace: "​",
          NegativeThickSpace: "​",
          NegativeThinSpace: "​",
          NegativeVeryThinSpace: "​",
          nequiv: "≢",
          nesear: "⤨",
          nesim: "≂̸",
          NestedGreaterGreater: "≫",
          NestedLessLess: "≪",
          NewLine: "\n",
          nexist: "∄",
          nexists: "∄",
          Nfr: "𝔑",
          nfr: "𝔫",
          ngE: "≧̸",
          nge: "≱",
          ngeq: "≱",
          ngeqq: "≧̸",
          ngeqslant: "⩾̸",
          nges: "⩾̸",
          nGg: "⋙̸",
          ngsim: "≵",
          nGt: "≫⃒",
          ngt: "≯",
          ngtr: "≯",
          nGtv: "≫̸",
          nhArr: "⇎",
          nharr: "↮",
          nhpar: "⫲",
          ni: "∋",
          nis: "⋼",
          nisd: "⋺",
          niv: "∋",
          NJcy: "Њ",
          njcy: "њ",
          nlArr: "⇍",
          nlarr: "↚",
          nldr: "‥",
          nlE: "≦̸",
          nle: "≰",
          nLeftarrow: "⇍",
          nleftarrow: "↚",
          nLeftrightarrow: "⇎",
          nleftrightarrow: "↮",
          nleq: "≰",
          nleqq: "≦̸",
          nleqslant: "⩽̸",
          nles: "⩽̸",
          nless: "≮",
          nLl: "⋘̸",
          nlsim: "≴",
          nLt: "≪⃒",
          nlt: "≮",
          nltri: "⋪",
          nltrie: "⋬",
          nLtv: "≪̸",
          nmid: "∤",
          NoBreak: "⁠",
          NonBreakingSpace: " ",
          Nopf: "ℕ",
          nopf: "𝕟",
          Not: "⫬",
          not: "¬",
          NotCongruent: "≢",
          NotCupCap: "≭",
          NotDoubleVerticalBar: "∦",
          NotElement: "∉",
          NotEqual: "≠",
          NotEqualTilde: "≂̸",
          NotExists: "∄",
          NotGreater: "≯",
          NotGreaterEqual: "≱",
          NotGreaterFullEqual: "≧̸",
          NotGreaterGreater: "≫̸",
          NotGreaterLess: "≹",
          NotGreaterSlantEqual: "⩾̸",
          NotGreaterTilde: "≵",
          NotHumpDownHump: "≎̸",
          NotHumpEqual: "≏̸",
          notin: "∉",
          notindot: "⋵̸",
          notinE: "⋹̸",
          notinva: "∉",
          notinvb: "⋷",
          notinvc: "⋶",
          NotLeftTriangle: "⋪",
          NotLeftTriangleBar: "⧏̸",
          NotLeftTriangleEqual: "⋬",
          NotLess: "≮",
          NotLessEqual: "≰",
          NotLessGreater: "≸",
          NotLessLess: "≪̸",
          NotLessSlantEqual: "⩽̸",
          NotLessTilde: "≴",
          NotNestedGreaterGreater: "⪢̸",
          NotNestedLessLess: "⪡̸",
          notni: "∌",
          notniva: "∌",
          notnivb: "⋾",
          notnivc: "⋽",
          NotPrecedes: "⊀",
          NotPrecedesEqual: "⪯̸",
          NotPrecedesSlantEqual: "⋠",
          NotReverseElement: "∌",
          NotRightTriangle: "⋫",
          NotRightTriangleBar: "⧐̸",
          NotRightTriangleEqual: "⋭",
          NotSquareSubset: "⊏̸",
          NotSquareSubsetEqual: "⋢",
          NotSquareSuperset: "⊐̸",
          NotSquareSupersetEqual: "⋣",
          NotSubset: "⊂⃒",
          NotSubsetEqual: "⊈",
          NotSucceeds: "⊁",
          NotSucceedsEqual: "⪰̸",
          NotSucceedsSlantEqual: "⋡",
          NotSucceedsTilde: "≿̸",
          NotSuperset: "⊃⃒",
          NotSupersetEqual: "⊉",
          NotTilde: "≁",
          NotTildeEqual: "≄",
          NotTildeFullEqual: "≇",
          NotTildeTilde: "≉",
          NotVerticalBar: "∤",
          npar: "∦",
          nparallel: "∦",
          nparsl: "⫽⃥",
          npart: "∂̸",
          npolint: "⨔",
          npr: "⊀",
          nprcue: "⋠",
          npre: "⪯̸",
          nprec: "⊀",
          npreceq: "⪯̸",
          nrArr: "⇏",
          nrarr: "↛",
          nrarrc: "⤳̸",
          nrarrw: "↝̸",
          nRightarrow: "⇏",
          nrightarrow: "↛",
          nrtri: "⋫",
          nrtrie: "⋭",
          nsc: "⊁",
          nsccue: "⋡",
          nsce: "⪰̸",
          Nscr: "𝒩",
          nscr: "𝓃",
          nshortmid: "∤",
          nshortparallel: "∦",
          nsim: "≁",
          nsime: "≄",
          nsimeq: "≄",
          nsmid: "∤",
          nspar: "∦",
          nsqsube: "⋢",
          nsqsupe: "⋣",
          nsub: "⊄",
          nsubE: "⫅̸",
          nsube: "⊈",
          nsubset: "⊂⃒",
          nsubseteq: "⊈",
          nsubseteqq: "⫅̸",
          nsucc: "⊁",
          nsucceq: "⪰̸",
          nsup: "⊅",
          nsupE: "⫆̸",
          nsupe: "⊉",
          nsupset: "⊃⃒",
          nsupseteq: "⊉",
          nsupseteqq: "⫆̸",
          ntgl: "≹",
          Ntilde: "Ñ",
          ntilde: "ñ",
          ntlg: "≸",
          ntriangleleft: "⋪",
          ntrianglelefteq: "⋬",
          ntriangleright: "⋫",
          ntrianglerighteq: "⋭",
          Nu: "Ν",
          nu: "ν",
          num: "#",
          numero: "№",
          numsp: " ",
          nvap: "≍⃒",
          nVDash: "⊯",
          nVdash: "⊮",
          nvDash: "⊭",
          nvdash: "⊬",
          nvge: "≥⃒",
          nvgt: ">⃒",
          nvHarr: "⤄",
          nvinfin: "⧞",
          nvlArr: "⤂",
          nvle: "≤⃒",
          nvlt: "<⃒",
          nvltrie: "⊴⃒",
          nvrArr: "⤃",
          nvrtrie: "⊵⃒",
          nvsim: "∼⃒",
          nwarhk: "⤣",
          nwArr: "⇖",
          nwarr: "↖",
          nwarrow: "↖",
          nwnear: "⤧",
          Oacute: "Ó",
          oacute: "ó",
          oast: "⊛",
          ocir: "⊚",
          Ocirc: "Ô",
          ocirc: "ô",
          Ocy: "О",
          ocy: "о",
          odash: "⊝",
          Odblac: "Ő",
          odblac: "ő",
          odiv: "⨸",
          odot: "⊙",
          odsold: "⦼",
          OElig: "Œ",
          oelig: "œ",
          ofcir: "⦿",
          Ofr: "𝔒",
          ofr: "𝔬",
          ogon: "˛",
          Ograve: "Ò",
          ograve: "ò",
          ogt: "⧁",
          ohbar: "⦵",
          ohm: "Ω",
          oint: "∮",
          olarr: "↺",
          olcir: "⦾",
          olcross: "⦻",
          oline: "‾",
          olt: "⧀",
          Omacr: "Ō",
          omacr: "ō",
          Omega: "Ω",
          omega: "ω",
          Omicron: "Ο",
          omicron: "ο",
          omid: "⦶",
          ominus: "⊖",
          Oopf: "𝕆",
          oopf: "𝕠",
          opar: "⦷",
          OpenCurlyDoubleQuote: "“",
          OpenCurlyQuote: "‘",
          operp: "⦹",
          oplus: "⊕",
          Or: "⩔",
          or: "∨",
          orarr: "↻",
          ord: "⩝",
          order: "ℴ",
          orderof: "ℴ",
          ordf: "ª",
          ordm: "º",
          origof: "⊶",
          oror: "⩖",
          orslope: "⩗",
          orv: "⩛",
          oS: "Ⓢ",
          Oscr: "𝒪",
          oscr: "ℴ",
          Oslash: "Ø",
          oslash: "ø",
          osol: "⊘",
          Otilde: "Õ",
          otilde: "õ",
          Otimes: "⨷",
          otimes: "⊗",
          otimesas: "⨶",
          Ouml: "Ö",
          ouml: "ö",
          ovbar: "⌽",
          OverBar: "‾",
          OverBrace: "⏞",
          OverBracket: "⎴",
          OverParenthesis: "⏜",
          par: "∥",
          para: "¶",
          parallel: "∥",
          parsim: "⫳",
          parsl: "⫽",
          part: "∂",
          PartialD: "∂",
          Pcy: "П",
          pcy: "п",
          percnt: "%",
          period: ".",
          permil: "‰",
          perp: "⊥",
          pertenk: "‱",
          Pfr: "𝔓",
          pfr: "𝔭",
          Phi: "Φ",
          phi: "φ",
          phiv: "ϕ",
          phmmat: "ℳ",
          phone: "☎",
          Pi: "Π",
          pi: "π",
          pitchfork: "⋔",
          piv: "ϖ",
          planck: "ℏ",
          planckh: "ℎ",
          plankv: "ℏ",
          plus: "+",
          plusacir: "⨣",
          plusb: "⊞",
          pluscir: "⨢",
          plusdo: "∔",
          plusdu: "⨥",
          pluse: "⩲",
          PlusMinus: "±",
          plusmn: "±",
          plussim: "⨦",
          plustwo: "⨧",
          pm: "±",
          Poincareplane: "ℌ",
          pointint: "⨕",
          Popf: "ℙ",
          popf: "𝕡",
          pound: "£",
          Pr: "⪻",
          pr: "≺",
          prap: "⪷",
          prcue: "≼",
          prE: "⪳",
          pre: "⪯",
          prec: "≺",
          precapprox: "⪷",
          preccurlyeq: "≼",
          Precedes: "≺",
          PrecedesEqual: "⪯",
          PrecedesSlantEqual: "≼",
          PrecedesTilde: "≾",
          preceq: "⪯",
          precnapprox: "⪹",
          precneqq: "⪵",
          precnsim: "⋨",
          precsim: "≾",
          Prime: "″",
          prime: "′",
          primes: "ℙ",
          prnap: "⪹",
          prnE: "⪵",
          prnsim: "⋨",
          prod: "∏",
          Product: "∏",
          profalar: "⌮",
          profline: "⌒",
          profsurf: "⌓",
          prop: "∝",
          Proportion: "∷",
          Proportional: "∝",
          propto: "∝",
          prsim: "≾",
          prurel: "⊰",
          Pscr: "𝒫",
          pscr: "𝓅",
          Psi: "Ψ",
          psi: "ψ",
          puncsp: " ",
          Qfr: "𝔔",
          qfr: "𝔮",
          qint: "⨌",
          Qopf: "ℚ",
          qopf: "𝕢",
          qprime: "⁗",
          Qscr: "𝒬",
          qscr: "𝓆",
          quaternions: "ℍ",
          quatint: "⨖",
          quest: "?",
          questeq: "≟",
          QUOT: '"',
          quot: '"',
          rAarr: "⇛",
          race: "∽̱",
          Racute: "Ŕ",
          racute: "ŕ",
          radic: "√",
          raemptyv: "⦳",
          Rang: "⟫",
          rang: "⟩",
          rangd: "⦒",
          range: "⦥",
          rangle: "⟩",
          raquo: "»",
          Rarr: "↠",
          rArr: "⇒",
          rarr: "→",
          rarrap: "⥵",
          rarrb: "⇥",
          rarrbfs: "⤠",
          rarrc: "⤳",
          rarrfs: "⤞",
          rarrhk: "↪",
          rarrlp: "↬",
          rarrpl: "⥅",
          rarrsim: "⥴",
          Rarrtl: "⤖",
          rarrtl: "↣",
          rarrw: "↝",
          rAtail: "⤜",
          ratail: "⤚",
          ratio: "∶",
          rationals: "ℚ",
          RBarr: "⤐",
          rBarr: "⤏",
          rbarr: "⤍",
          rbbrk: "❳",
          rbrace: "}",
          rbrack: "]",
          rbrke: "⦌",
          rbrksld: "⦎",
          rbrkslu: "⦐",
          Rcaron: "Ř",
          rcaron: "ř",
          Rcedil: "Ŗ",
          rcedil: "ŗ",
          rceil: "⌉",
          rcub: "}",
          Rcy: "Р",
          rcy: "р",
          rdca: "⤷",
          rdldhar: "⥩",
          rdquo: "”",
          rdquor: "”",
          rdsh: "↳",
          Re: "ℜ",
          real: "ℜ",
          realine: "ℛ",
          realpart: "ℜ",
          reals: "ℝ",
          rect: "▭",
          REG: "®",
          reg: "®",
          ReverseElement: "∋",
          ReverseEquilibrium: "⇋",
          ReverseUpEquilibrium: "⥯",
          rfisht: "⥽",
          rfloor: "⌋",
          Rfr: "ℜ",
          rfr: "𝔯",
          rHar: "⥤",
          rhard: "⇁",
          rharu: "⇀",
          rharul: "⥬",
          Rho: "Ρ",
          rho: "ρ",
          rhov: "ϱ",
          RightAngleBracket: "⟩",
          RightArrow: "→",
          Rightarrow: "⇒",
          rightarrow: "→",
          RightArrowBar: "⇥",
          RightArrowLeftArrow: "⇄",
          rightarrowtail: "↣",
          RightCeiling: "⌉",
          RightDoubleBracket: "⟧",
          RightDownTeeVector: "⥝",
          RightDownVector: "⇂",
          RightDownVectorBar: "⥕",
          RightFloor: "⌋",
          rightharpoondown: "⇁",
          rightharpoonup: "⇀",
          rightleftarrows: "⇄",
          rightleftharpoons: "⇌",
          rightrightarrows: "⇉",
          rightsquigarrow: "↝",
          RightTee: "⊢",
          RightTeeArrow: "↦",
          RightTeeVector: "⥛",
          rightthreetimes: "⋌",
          RightTriangle: "⊳",
          RightTriangleBar: "⧐",
          RightTriangleEqual: "⊵",
          RightUpDownVector: "⥏",
          RightUpTeeVector: "⥜",
          RightUpVector: "↾",
          RightUpVectorBar: "⥔",
          RightVector: "⇀",
          RightVectorBar: "⥓",
          ring: "˚",
          risingdotseq: "≓",
          rlarr: "⇄",
          rlhar: "⇌",
          rlm: "‏",
          rmoust: "⎱",
          rmoustache: "⎱",
          rnmid: "⫮",
          roang: "⟭",
          roarr: "⇾",
          robrk: "⟧",
          ropar: "⦆",
          Ropf: "ℝ",
          ropf: "𝕣",
          roplus: "⨮",
          rotimes: "⨵",
          RoundImplies: "⥰",
          rpar: ")",
          rpargt: "⦔",
          rppolint: "⨒",
          rrarr: "⇉",
          Rrightarrow: "⇛",
          rsaquo: "›",
          Rscr: "ℛ",
          rscr: "𝓇",
          Rsh: "↱",
          rsh: "↱",
          rsqb: "]",
          rsquo: "’",
          rsquor: "’",
          rthree: "⋌",
          rtimes: "⋊",
          rtri: "▹",
          rtrie: "⊵",
          rtrif: "▸",
          rtriltri: "⧎",
          RuleDelayed: "⧴",
          ruluhar: "⥨",
          rx: "℞",
          Sacute: "Ś",
          sacute: "ś",
          sbquo: "‚",
          Sc: "⪼",
          sc: "≻",
          scap: "⪸",
          Scaron: "Š",
          scaron: "š",
          sccue: "≽",
          scE: "⪴",
          sce: "⪰",
          Scedil: "Ş",
          scedil: "ş",
          Scirc: "Ŝ",
          scirc: "ŝ",
          scnap: "⪺",
          scnE: "⪶",
          scnsim: "⋩",
          scpolint: "⨓",
          scsim: "≿",
          Scy: "С",
          scy: "с",
          sdot: "⋅",
          sdotb: "⊡",
          sdote: "⩦",
          searhk: "⤥",
          seArr: "⇘",
          searr: "↘",
          searrow: "↘",
          sect: "§",
          semi: ";",
          seswar: "⤩",
          setminus: "∖",
          setmn: "∖",
          sext: "✶",
          Sfr: "𝔖",
          sfr: "𝔰",
          sfrown: "⌢",
          sharp: "♯",
          SHCHcy: "Щ",
          shchcy: "щ",
          SHcy: "Ш",
          shcy: "ш",
          ShortDownArrow: "↓",
          ShortLeftArrow: "←",
          shortmid: "∣",
          shortparallel: "∥",
          ShortRightArrow: "→",
          ShortUpArrow: "↑",
          shy: "­",
          Sigma: "Σ",
          sigma: "σ",
          sigmaf: "ς",
          sigmav: "ς",
          sim: "∼",
          simdot: "⩪",
          sime: "≃",
          simeq: "≃",
          simg: "⪞",
          simgE: "⪠",
          siml: "⪝",
          simlE: "⪟",
          simne: "≆",
          simplus: "⨤",
          simrarr: "⥲",
          slarr: "←",
          SmallCircle: "∘",
          smallsetminus: "∖",
          smashp: "⨳",
          smeparsl: "⧤",
          smid: "∣",
          smile: "⌣",
          smt: "⪪",
          smte: "⪬",
          smtes: "⪬︀",
          SOFTcy: "Ь",
          softcy: "ь",
          sol: "/",
          solb: "⧄",
          solbar: "⌿",
          Sopf: "𝕊",
          sopf: "𝕤",
          spades: "♠",
          spadesuit: "♠",
          spar: "∥",
          sqcap: "⊓",
          sqcaps: "⊓︀",
          sqcup: "⊔",
          sqcups: "⊔︀",
          Sqrt: "√",
          sqsub: "⊏",
          sqsube: "⊑",
          sqsubset: "⊏",
          sqsubseteq: "⊑",
          sqsup: "⊐",
          sqsupe: "⊒",
          sqsupset: "⊐",
          sqsupseteq: "⊒",
          squ: "□",
          Square: "□",
          square: "□",
          SquareIntersection: "⊓",
          SquareSubset: "⊏",
          SquareSubsetEqual: "⊑",
          SquareSuperset: "⊐",
          SquareSupersetEqual: "⊒",
          SquareUnion: "⊔",
          squarf: "▪",
          squf: "▪",
          srarr: "→",
          Sscr: "𝒮",
          sscr: "𝓈",
          ssetmn: "∖",
          ssmile: "⌣",
          sstarf: "⋆",
          Star: "⋆",
          star: "☆",
          starf: "★",
          straightepsilon: "ϵ",
          straightphi: "ϕ",
          strns: "¯",
          Sub: "⋐",
          sub: "⊂",
          subdot: "⪽",
          subE: "⫅",
          sube: "⊆",
          subedot: "⫃",
          submult: "⫁",
          subnE: "⫋",
          subne: "⊊",
          subplus: "⪿",
          subrarr: "⥹",
          Subset: "⋐",
          subset: "⊂",
          subseteq: "⊆",
          subseteqq: "⫅",
          SubsetEqual: "⊆",
          subsetneq: "⊊",
          subsetneqq: "⫋",
          subsim: "⫇",
          subsub: "⫕",
          subsup: "⫓",
          succ: "≻",
          succapprox: "⪸",
          succcurlyeq: "≽",
          Succeeds: "≻",
          SucceedsEqual: "⪰",
          SucceedsSlantEqual: "≽",
          SucceedsTilde: "≿",
          succeq: "⪰",
          succnapprox: "⪺",
          succneqq: "⪶",
          succnsim: "⋩",
          succsim: "≿",
          SuchThat: "∋",
          Sum: "∑",
          sum: "∑",
          sung: "♪",
          Sup: "⋑",
          sup: "⊃",
          sup1: "¹",
          sup2: "²",
          sup3: "³",
          supdot: "⪾",
          supdsub: "⫘",
          supE: "⫆",
          supe: "⊇",
          supedot: "⫄",
          Superset: "⊃",
          SupersetEqual: "⊇",
          suphsol: "⟉",
          suphsub: "⫗",
          suplarr: "⥻",
          supmult: "⫂",
          supnE: "⫌",
          supne: "⊋",
          supplus: "⫀",
          Supset: "⋑",
          supset: "⊃",
          supseteq: "⊇",
          supseteqq: "⫆",
          supsetneq: "⊋",
          supsetneqq: "⫌",
          supsim: "⫈",
          supsub: "⫔",
          supsup: "⫖",
          swarhk: "⤦",
          swArr: "⇙",
          swarr: "↙",
          swarrow: "↙",
          swnwar: "⤪",
          szlig: "ß",
          Tab: "\t",
          target: "⌖",
          Tau: "Τ",
          tau: "τ",
          tbrk: "⎴",
          Tcaron: "Ť",
          tcaron: "ť",
          Tcedil: "Ţ",
          tcedil: "ţ",
          Tcy: "Т",
          tcy: "т",
          tdot: "⃛",
          telrec: "⌕",
          Tfr: "𝔗",
          tfr: "𝔱",
          there4: "∴",
          Therefore: "∴",
          therefore: "∴",
          Theta: "Θ",
          theta: "θ",
          thetasym: "ϑ",
          thetav: "ϑ",
          thickapprox: "≈",
          thicksim: "∼",
          ThickSpace: "  ",
          thinsp: " ",
          ThinSpace: " ",
          thkap: "≈",
          thksim: "∼",
          THORN: "Þ",
          thorn: "þ",
          Tilde: "∼",
          tilde: "˜",
          TildeEqual: "≃",
          TildeFullEqual: "≅",
          TildeTilde: "≈",
          times: "×",
          timesb: "⊠",
          timesbar: "⨱",
          timesd: "⨰",
          tint: "∭",
          toea: "⤨",
          top: "⊤",
          topbot: "⌶",
          topcir: "⫱",
          Topf: "𝕋",
          topf: "𝕥",
          topfork: "⫚",
          tosa: "⤩",
          tprime: "‴",
          TRADE: "™",
          trade: "™",
          triangle: "▵",
          triangledown: "▿",
          triangleleft: "◃",
          trianglelefteq: "⊴",
          triangleq: "≜",
          triangleright: "▹",
          trianglerighteq: "⊵",
          tridot: "◬",
          trie: "≜",
          triminus: "⨺",
          TripleDot: "⃛",
          triplus: "⨹",
          trisb: "⧍",
          tritime: "⨻",
          trpezium: "⏢",
          Tscr: "𝒯",
          tscr: "𝓉",
          TScy: "Ц",
          tscy: "ц",
          TSHcy: "Ћ",
          tshcy: "ћ",
          Tstrok: "Ŧ",
          tstrok: "ŧ",
          twixt: "≬",
          twoheadleftarrow: "↞",
          twoheadrightarrow: "↠",
          Uacute: "Ú",
          uacute: "ú",
          Uarr: "↟",
          uArr: "⇑",
          uarr: "↑",
          Uarrocir: "⥉",
          Ubrcy: "Ў",
          ubrcy: "ў",
          Ubreve: "Ŭ",
          ubreve: "ŭ",
          Ucirc: "Û",
          ucirc: "û",
          Ucy: "У",
          ucy: "у",
          udarr: "⇅",
          Udblac: "Ű",
          udblac: "ű",
          udhar: "⥮",
          ufisht: "⥾",
          Ufr: "𝔘",
          ufr: "𝔲",
          Ugrave: "Ù",
          ugrave: "ù",
          uHar: "⥣",
          uharl: "↿",
          uharr: "↾",
          uhblk: "▀",
          ulcorn: "⌜",
          ulcorner: "⌜",
          ulcrop: "⌏",
          ultri: "◸",
          Umacr: "Ū",
          umacr: "ū",
          uml: "¨",
          UnderBar: "_",
          UnderBrace: "⏟",
          UnderBracket: "⎵",
          UnderParenthesis: "⏝",
          Union: "⋃",
          UnionPlus: "⊎",
          Uogon: "Ų",
          uogon: "ų",
          Uopf: "𝕌",
          uopf: "𝕦",
          UpArrow: "↑",
          Uparrow: "⇑",
          uparrow: "↑",
          UpArrowBar: "⤒",
          UpArrowDownArrow: "⇅",
          UpDownArrow: "↕",
          Updownarrow: "⇕",
          updownarrow: "↕",
          UpEquilibrium: "⥮",
          upharpoonleft: "↿",
          upharpoonright: "↾",
          uplus: "⊎",
          UpperLeftArrow: "↖",
          UpperRightArrow: "↗",
          Upsi: "ϒ",
          upsi: "υ",
          upsih: "ϒ",
          Upsilon: "Υ",
          upsilon: "υ",
          UpTee: "⊥",
          UpTeeArrow: "↥",
          upuparrows: "⇈",
          urcorn: "⌝",
          urcorner: "⌝",
          urcrop: "⌎",
          Uring: "Ů",
          uring: "ů",
          urtri: "◹",
          Uscr: "𝒰",
          uscr: "𝓊",
          utdot: "⋰",
          Utilde: "Ũ",
          utilde: "ũ",
          utri: "▵",
          utrif: "▴",
          uuarr: "⇈",
          Uuml: "Ü",
          uuml: "ü",
          uwangle: "⦧",
          vangrt: "⦜",
          varepsilon: "ϵ",
          varkappa: "ϰ",
          varnothing: "∅",
          varphi: "ϕ",
          varpi: "ϖ",
          varpropto: "∝",
          vArr: "⇕",
          varr: "↕",
          varrho: "ϱ",
          varsigma: "ς",
          varsubsetneq: "⊊︀",
          varsubsetneqq: "⫋︀",
          varsupsetneq: "⊋︀",
          varsupsetneqq: "⫌︀",
          vartheta: "ϑ",
          vartriangleleft: "⊲",
          vartriangleright: "⊳",
          Vbar: "⫫",
          vBar: "⫨",
          vBarv: "⫩",
          Vcy: "В",
          vcy: "в",
          VDash: "⊫",
          Vdash: "⊩",
          vDash: "⊨",
          vdash: "⊢",
          Vdashl: "⫦",
          Vee: "⋁",
          vee: "∨",
          veebar: "⊻",
          veeeq: "≚",
          vellip: "⋮",
          Verbar: "‖",
          verbar: "|",
          Vert: "‖",
          vert: "|",
          VerticalBar: "∣",
          VerticalLine: "|",
          VerticalSeparator: "❘",
          VerticalTilde: "≀",
          VeryThinSpace: " ",
          Vfr: "𝔙",
          vfr: "𝔳",
          vltri: "⊲",
          vnsub: "⊂⃒",
          vnsup: "⊃⃒",
          Vopf: "𝕍",
          vopf: "𝕧",
          vprop: "∝",
          vrtri: "⊳",
          Vscr: "𝒱",
          vscr: "𝓋",
          vsubnE: "⫋︀",
          vsubne: "⊊︀",
          vsupnE: "⫌︀",
          vsupne: "⊋︀",
          Vvdash: "⊪",
          vzigzag: "⦚",
          Wcirc: "Ŵ",
          wcirc: "ŵ",
          wedbar: "⩟",
          Wedge: "⋀",
          wedge: "∧",
          wedgeq: "≙",
          weierp: "℘",
          Wfr: "𝔚",
          wfr: "𝔴",
          Wopf: "𝕎",
          wopf: "𝕨",
          wp: "℘",
          wr: "≀",
          wreath: "≀",
          Wscr: "𝒲",
          wscr: "𝓌",
          xcap: "⋂",
          xcirc: "◯",
          xcup: "⋃",
          xdtri: "▽",
          Xfr: "𝔛",
          xfr: "𝔵",
          xhArr: "⟺",
          xharr: "⟷",
          Xi: "Ξ",
          xi: "ξ",
          xlArr: "⟸",
          xlarr: "⟵",
          xmap: "⟼",
          xnis: "⋻",
          xodot: "⨀",
          Xopf: "𝕏",
          xopf: "𝕩",
          xoplus: "⨁",
          xotime: "⨂",
          xrArr: "⟹",
          xrarr: "⟶",
          Xscr: "𝒳",
          xscr: "𝓍",
          xsqcup: "⨆",
          xuplus: "⨄",
          xutri: "△",
          xvee: "⋁",
          xwedge: "⋀",
          Yacute: "Ý",
          yacute: "ý",
          YAcy: "Я",
          yacy: "я",
          Ycirc: "Ŷ",
          ycirc: "ŷ",
          Ycy: "Ы",
          ycy: "ы",
          yen: "¥",
          Yfr: "𝔜",
          yfr: "𝔶",
          YIcy: "Ї",
          yicy: "ї",
          Yopf: "𝕐",
          yopf: "𝕪",
          Yscr: "𝒴",
          yscr: "𝓎",
          YUcy: "Ю",
          yucy: "ю",
          Yuml: "Ÿ",
          yuml: "ÿ",
          Zacute: "Ź",
          zacute: "ź",
          Zcaron: "Ž",
          zcaron: "ž",
          Zcy: "З",
          zcy: "з",
          Zdot: "Ż",
          zdot: "ż",
          zeetrf: "ℨ",
          ZeroWidthSpace: "​",
          Zeta: "Ζ",
          zeta: "ζ",
          Zfr: "ℨ",
          zfr: "𝔷",
          ZHcy: "Ж",
          zhcy: "ж",
          zigrarr: "⇝",
          Zopf: "ℤ",
          zopf: "𝕫",
          Zscr: "𝒵",
          zscr: "𝓏",
          zwj: "‍",
          zwnj: "‌"
        }), t.entityMap = t.HTML_ENTITIES);
      },
      3969: (e, t, r) => {
        var a = r(1146);
        (t.DOMImplementation = a.DOMImplementation, t.XMLSerializer = a.XMLSerializer, t.DOMParser = r(6129).DOMParser);
      },
      6925: (e, t, r) => {
        var a = r(2167).NAMESPACE, n = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, o = new RegExp("[\\-\\.0-9" + n.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), i = new RegExp("^" + n.source + o.source + "*(?::" + n.source + o.source + "*)?$");
        function l(e, t) {
          (this.message = e, this.locator = t, Error.captureStackTrace && Error.captureStackTrace(this, l));
        }
        function s() {}
        function c(e, t) {
          return (t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber, t);
        }
        function u(e, t, r, n, o, i) {
          function l(e, t, a) {
            (r.attributeNames.hasOwnProperty(e) && i.fatalError("Attribute " + e + " redefined"), r.addValue(e, t.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, o), a));
          }
          for (var s, c = ++t, u = 0; ; ) {
            var h = e.charAt(c);
            switch (h) {
              case "=":
                if (1 === u) (s = e.slice(t, c), u = 3); else {
                  if (2 !== u) throw new Error("attribute equal must after attrName");
                  u = 3;
                }
                break;
              case "'":
              case '"':
                if (3 === u || 1 === u) {
                  if ((1 === u && (i.warning('attribute value must after "="'), s = e.slice(t, c)), t = c + 1, !((c = e.indexOf(h, t)) > 0))) throw new Error("attribute value no end '" + h + "' match");
                  (l(s, d = e.slice(t, c), t - 1), u = 5);
                } else {
                  if (4 != u) throw new Error('attribute value must after "="');
                  (l(s, d = e.slice(t, c), t), i.warning('attribute "' + s + '" missed start quot(' + h + ")!!"), t = c + 1, u = 5);
                }
                break;
              case "/":
                switch (u) {
                  case 0:
                    r.setTagName(e.slice(t, c));
                  case 5:
                  case 6:
                  case 7:
                    (u = 7, r.closed = !0);
                  case 4:
                  case 1:
                    break;
                  case 2:
                    r.closed = !0;
                    break;
                  default:
                    throw new Error("attribute invalid close char('/')");
                }
                break;
              case "":
                return (i.error("unexpected end of input"), 0 == u && r.setTagName(e.slice(t, c)), c);
              case ">":
                switch (u) {
                  case 0:
                    r.setTagName(e.slice(t, c));
                  case 5:
                  case 6:
                  case 7:
                    break;
                  case 4:
                  case 1:
                    "/" === (d = e.slice(t, c)).slice(-1) && (r.closed = !0, d = d.slice(0, -1));
                  case 2:
                    (2 === u && (d = s), 4 == u ? (i.warning('attribute "' + d + '" missed quot(")!'), l(s, d, t)) : (a.isHTML(n[""]) && d.match(/^(?:disabled|checked|selected)$/i) || i.warning('attribute "' + d + '" missed value!! "' + d + '" instead!!'), l(d, d, t)));
                    break;
                  case 3:
                    throw new Error("attribute value missed!!");
                }
                return c;
              case "":
                h = " ";
              default:
                if (h <= " ") switch (u) {
                  case 0:
                    (r.setTagName(e.slice(t, c)), u = 6);
                    break;
                  case 1:
                    (s = e.slice(t, c), u = 2);
                    break;
                  case 4:
                    var d = e.slice(t, c);
                    (i.warning('attribute "' + d + '" missed quot(")!!'), l(s, d, t));
                  case 5:
                    u = 6;
                } else switch (u) {
                  case 2:
                    (r.tagName, a.isHTML(n[""]) && s.match(/^(?:disabled|checked|selected)$/i) || i.warning('attribute "' + s + '" missed value!! "' + s + '" instead2!!'), l(s, s, t), t = c, u = 1);
                    break;
                  case 5:
                    i.warning('attribute space is required"' + s + '"!!');
                  case 6:
                    (u = 1, t = c);
                    break;
                  case 3:
                    (u = 4, t = c);
                    break;
                  case 7:
                    throw new Error("elements closed character '/' and '>' must be connected to");
                }
            }
            c++;
          }
        }
        function h(e, t, r) {
          for (var n = e.tagName, o = null, i = e.length; i--; ) {
            var l = e[i], s = l.qName, c = l.value;
            if ((m = s.indexOf(":")) > 0) var u = l.prefix = s.slice(0, m), h = s.slice(m + 1), d = "xmlns" === u && h; else (h = s, u = null, d = "xmlns" === s && "");
            (l.localName = h, !1 !== d && (null == o && (o = {}, p(r, r = {})), r[d] = o[d] = c, l.uri = a.XMLNS, t.startPrefixMapping(d, c)));
          }
          for (i = e.length; i--; ) (u = (l = e[i]).prefix) && ("xml" === u && (l.uri = a.XML), "xmlns" !== u && (l.uri = r[u || ""]));
          var m;
          (m = n.indexOf(":")) > 0 ? (u = e.prefix = n.slice(0, m), h = e.localName = n.slice(m + 1)) : (u = null, h = e.localName = n);
          var f = e.uri = r[u || ""];
          if ((t.startElement(f, h, n, e), !e.closed)) return (e.currentNSMap = r, e.localNSMap = o, !0);
          if ((t.endElement(f, h, n), o)) for (u in o) Object.prototype.hasOwnProperty.call(o, u) && t.endPrefixMapping(u);
        }
        function d(e, t, r, a, n) {
          if ((/^(?:script|textarea)$/i).test(r)) {
            var o = e.indexOf("</" + r + ">", t), i = e.substring(t + 1, o);
            if ((/[&<]/).test(i)) return (/^script$/i).test(r) ? (n.characters(i, 0, i.length), o) : (i = i.replace(/&#?\w+;/g, a), n.characters(i, 0, i.length), o);
          }
          return t + 1;
        }
        function m(e, t, r, a) {
          var n = a[r];
          return (null == n && ((n = e.lastIndexOf("</" + r + ">")) < t && (n = e.lastIndexOf("</" + r)), a[r] = n), n < t);
        }
        function p(e, t) {
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        function f(e, t, r, a) {
          if ("-" === e.charAt(t + 2)) return "-" === e.charAt(t + 3) ? (n = e.indexOf("--\x3e", t + 4)) > t ? (r.comment(e, t + 4, n - t - 4), n + 3) : (a.error("Unclosed comment"), -1) : -1;
          if ("CDATA[" == e.substr(t + 3, 6)) {
            var n = e.indexOf("]]>", t + 9);
            return (r.startCDATA(), r.characters(e, t + 9, n - t - 9), r.endCDATA(), n + 3);
          }
          var o = (function (e, t) {
            var r, a = [], n = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
            for ((n.lastIndex = t, n.exec(e)); r = n.exec(e); ) if ((a.push(r), r[1])) return a;
          })(e, t), i = o.length;
          if (i > 1 && (/!doctype/i).test(o[0][0])) {
            var l = o[1][0], s = !1, c = !1;
            i > 3 && ((/^public$/i).test(o[2][0]) ? (s = o[3][0], c = i > 4 && o[4][0]) : (/^system$/i).test(o[2][0]) && (c = o[3][0]));
            var u = o[i - 1];
            return (r.startDTD(l, s, c), r.endDTD(), u.index + u[0].length);
          }
          return -1;
        }
        function x(e, t, r) {
          var a = e.indexOf("?>", t);
          if (a) {
            var n = e.substring(t, a).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
            return n ? (n[0].length, r.processingInstruction(n[1], n[2]), a + 2) : -1;
          }
          return -1;
        }
        function g() {
          this.attributeNames = {};
        }
        (l.prototype = new Error(), l.prototype.name = l.name, s.prototype = {
          parse: function (e, t, r) {
            var n = this.domBuilder;
            (n.startDocument(), p(t, t = {}), (function (e, t, r, n, o) {
              function i(e) {
                var t = e.slice(1, -1);
                return Object.hasOwnProperty.call(r, t) ? r[t] : "#" === t.charAt(0) ? (function (e) {
                  if (e > 65535) {
                    var t = 55296 + ((e -= 65536) >> 10), r = 56320 + (1023 & e);
                    return String.fromCharCode(t, r);
                  }
                  return String.fromCharCode(e);
                })(parseInt(t.substr(1).replace("x", "0x"))) : (o.error("entity not found:" + e), e);
              }
              function s(t) {
                if (t > y) {
                  var r = e.substring(y, t).replace(/&#?\w+;/g, i);
                  (C && p(y), n.characters(r, 0, t - y), y = t);
                }
              }
              function p(t, r) {
                for (; t >= b && (r = v.exec(e)); ) (w = r.index, b = w + r[0].length, C.lineNumber++);
                C.columnNumber = t - w + 1;
              }
              for (var w = 0, b = 0, v = /.*(?:\r\n?|\n)|.*$/g, C = n.locator, A = [{
                currentNSMap: t
              }], E = {}, y = 0; ; ) {
                try {
                  var _ = e.indexOf("<", y);
                  if (_ < 0) {
                    if (!e.substr(y).match(/^\s*$/)) {
                      var q = n.doc, D = q.createTextNode(e.substr(y));
                      (q.appendChild(D), n.currentElement = D);
                    }
                    return;
                  }
                  switch ((_ > y && s(_), e.charAt(_ + 1))) {
                    case "/":
                      var N = e.indexOf(">", _ + 3), T = e.substring(_ + 2, N).replace(/[ \t\n\r]+$/g, ""), M = A.pop();
                      N < 0 ? (T = e.substring(_ + 2).replace(/[\s<].*/, ""), o.error("end tag name: " + T + " is not complete:" + M.tagName), N = _ + 1 + T.length) : T.match(/\s</) && (T = T.replace(/[\s<].*/, ""), o.error("end tag name: " + T + " maybe not complete"), N = _ + 1 + T.length);
                      var O = M.localNSMap, L = M.tagName == T;
                      if (L || M.tagName && M.tagName.toLowerCase() == T.toLowerCase()) {
                        if ((n.endElement(M.uri, M.localName, T), O)) for (var B in O) Object.prototype.hasOwnProperty.call(O, B) && n.endPrefixMapping(B);
                        L || o.fatalError("end tag name: " + T + " is not match the current start tagName:" + M.tagName);
                      } else A.push(M);
                      N++;
                      break;
                    case "?":
                      (C && p(_), N = x(e, _, n));
                      break;
                    case "!":
                      (C && p(_), N = f(e, _, n, o));
                      break;
                    default:
                      C && p(_);
                      var S = new g(), F = A[A.length - 1].currentNSMap, k = (N = u(e, _, S, F, i, o), S.length);
                      if ((!S.closed && m(e, N, S.tagName, E) && (S.closed = !0, r.nbsp || o.warning("unclosed xml attribute")), C && k)) {
                        for (var P = c(C, {}), R = 0; R < k; R++) {
                          var I = S[R];
                          (p(I.offset), I.locator = c(C, {}));
                        }
                        (n.locator = P, h(S, n, F) && A.push(S), n.locator = C);
                      } else h(S, n, F) && A.push(S);
                      a.isHTML(S.uri) && !S.closed ? N = d(e, N, S.tagName, i, n) : N++;
                  }
                } catch (e) {
                  if (e instanceof l) throw e;
                  (o.error("element parse error: " + e), N = -1);
                }
                N > y ? y = N : s(Math.max(_, y) + 1);
              }
            })(e, t, r, n, this.errorHandler), n.endDocument());
          }
        }, g.prototype = {
          setTagName: function (e) {
            if (!i.test(e)) throw new Error("invalid tagName:" + e);
            this.tagName = e;
          },
          addValue: function (e, t, r) {
            if (!i.test(e)) throw new Error("invalid attribute:" + e);
            (this.attributeNames[e] = this.length, this[this.length++] = {
              qName: e,
              value: t,
              offset: r
            });
          },
          length: 0,
          getLocalName: function (e) {
            return this[e].localName;
          },
          getLocator: function (e) {
            return this[e].locator;
          },
          getQName: function (e) {
            return this[e].qName;
          },
          getURI: function (e) {
            return this[e].uri;
          },
          getValue: function (e) {
            return this[e].value;
          }
        }, t.XMLReader = s, t.ParseError = l);
      },
      6036: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.InvalidNumberOfChildrenError = void 0);
        var a = r(6187);
        Object.defineProperty(t, "InvalidNumberOfChildrenError", {
          enumerable: !0,
          get: function () {
            return a.InvalidNumberOfChildrenError;
          }
        });
      },
      6187: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.InvalidNumberOfChildrenError = void 0);
        class r extends Error {
          constructor(e, t, r, a = "exactly") {
            (super(`${e} tag must have ${a} ${t} children. It's actually ${r}`), this.name = "InvalidNumberOfChildrenError");
          }
        }
        t.InvalidNumberOfChildrenError = r;
      },
      8398: function (e, t, r) {
        var a = this && this.__createBinding || (Object.create ? function (e, t, r, a) {
          void 0 === a && (a = r);
          var n = Object.getOwnPropertyDescriptor(t, r);
          (n && !(("get" in n) ? !t.__esModule : n.writable || n.configurable) || (n = {
            enumerable: !0,
            get: function () {
              return t[r];
            }
          }), Object.defineProperty(e, a, n));
        } : function (e, t, r, a) {
          (void 0 === a && (a = r), e[a] = t[r]);
        }), n = this && this.__exportStar || (function (e, t) {
          for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || a(t, e, r);
        });
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), n(r(8208), t), n(r(7011), t), n(r(3487), t), n(r(5379), t));
      },
      7011: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.JoinWithManySeparators = void 0);
        class r {
          constructor(e) {
            this._separators = e;
          }
          static join(e, t) {
            return new r(t)._join(e);
          }
          _join(e) {
            return e.reduce((e, t, r, a) => e + t + (r === a.length - 1 ? "" : this._get(r)), "");
          }
          _get(e) {
            return this._separators[e] ? this._separators[e] : this._separators.length > 0 ? this._separators[this._separators.length - 1] : ",";
          }
        }
        t.JoinWithManySeparators = r;
      },
      3487: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.mathMLElementToLaTeXConverter = void 0);
        const a = r(6483);
        t.mathMLElementToLaTeXConverter = e => new a.MathMLElementToLatexConverterAdapter(e).toLatexConverter();
      },
      5379: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.normalizeWhiteSpaces = void 0, t.normalizeWhiteSpaces = e => e.replace(/\s+/g, " "));
      },
      7274: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.BracketWrapper = void 0);
        const a = r(836);
        t.BracketWrapper = class {
          constructor() {
            (this._open = "{", this._close = "}");
          }
          wrap(e) {
            return new a.Wrapper(this._open, this._close).wrap(e);
          }
        };
      },
      5667: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.GenericWrapper = void 0);
        const a = r(836);
        t.GenericWrapper = class {
          constructor(e, t) {
            (this._open = "\\left" + e, this._close = "\\right" + t);
          }
          wrap(e) {
            return new a.Wrapper(this._open, this._close).wrap(e);
          }
        };
      },
      8208: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.GenericWrapper = t.ParenthesisWrapper = t.BracketWrapper = void 0);
        var a = r(7274);
        Object.defineProperty(t, "BracketWrapper", {
          enumerable: !0,
          get: function () {
            return a.BracketWrapper;
          }
        });
        var n = r(3246);
        Object.defineProperty(t, "ParenthesisWrapper", {
          enumerable: !0,
          get: function () {
            return n.ParenthesisWrapper;
          }
        });
        var o = r(5667);
        Object.defineProperty(t, "GenericWrapper", {
          enumerable: !0,
          get: function () {
            return o.GenericWrapper;
          }
        });
      },
      3246: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ParenthesisWrapper = void 0);
        const a = r(836);
        t.ParenthesisWrapper = class {
          constructor() {
            (this._open = "\\left(", this._close = "\\right)");
          }
          wrap(e) {
            return new a.Wrapper(this._open, this._close).wrap(e);
          }
          wrapIfMoreThanOneChar(e) {
            return e.length <= 1 ? e : this.wrap(e);
          }
        };
      },
      836: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Wrapper = void 0, t.Wrapper = class {
          constructor(e, t) {
            (this._open = e, this._close = t);
          }
          wrap(e) {
            return this._open + e + this._close;
          }
        });
      },
      7510: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.GenericSpacingWrapper = void 0);
        const a = r(8398);
        t.GenericSpacingWrapper = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            return this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" ");
          }
        };
      },
      3589: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.GenericUnderOver = void 0);
        const a = r(3487), n = r(6036), o = r(6626);
        t.GenericUnderOver = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {name: e, children: t} = this._mathmlElement, r = t.length;
            if (2 !== r) throw new n.InvalidNumberOfChildrenError(e, 2, r);
            const o = (0, a.mathMLElementToLaTeXConverter)(t[0]).convert(), i = (0, a.mathMLElementToLaTeXConverter)(t[1]).convert();
            return this._applyCommand(o, i);
          }
          _applyCommand(e, t) {
            const r = this._mathmlElement.name.match(/under/) ? l.Under : l.Over;
            return new i(r).apply(e, t);
          }
        };
        class i {
          constructor(e) {
            this._type = e;
          }
          apply(e, t) {
            return o.latexAccents.includes(t) ? `${t}{${e}}` : `${this._defaultCommand}{${t}}{${e}}`;
          }
          get _defaultCommand() {
            return this._type === l.Under ? "\\underset" : "\\overset";
          }
        }
        var l;
        !(function (e) {
          (e[e.Under = 0] = "Under", e[e.Over = 1] = "Over");
        })(l || (l = {}));
      },
      1733: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.GenericUnderOver = t.GenericSpacingWrapper = t.MTr = t.MTable = t.MUnderover = t.MText = t.MMultiscripts = t.MSubsup = t.MSub = t.MSup = t.MPhantom = t.MError = t.MEnclose = t.MAction = t.MRoot = t.MFrac = t.MFenced = t.MSqrt = t.MN = t.MO = t.MI = t.Math = void 0);
        var a = r(2283);
        Object.defineProperty(t, "Math", {
          enumerable: !0,
          get: function () {
            return a.Math;
          }
        });
        var n = r(7523);
        Object.defineProperty(t, "MI", {
          enumerable: !0,
          get: function () {
            return n.MI;
          }
        });
        var o = r(5258);
        Object.defineProperty(t, "MO", {
          enumerable: !0,
          get: function () {
            return o.MO;
          }
        });
        var i = r(411);
        Object.defineProperty(t, "MN", {
          enumerable: !0,
          get: function () {
            return i.MN;
          }
        });
        var l = r(8301);
        Object.defineProperty(t, "MSqrt", {
          enumerable: !0,
          get: function () {
            return l.MSqrt;
          }
        });
        var s = r(5237);
        Object.defineProperty(t, "MFenced", {
          enumerable: !0,
          get: function () {
            return s.MFenced;
          }
        });
        var c = r(4060);
        Object.defineProperty(t, "MFrac", {
          enumerable: !0,
          get: function () {
            return c.MFrac;
          }
        });
        var u = r(5851);
        Object.defineProperty(t, "MRoot", {
          enumerable: !0,
          get: function () {
            return u.MRoot;
          }
        });
        var h = r(916);
        Object.defineProperty(t, "MAction", {
          enumerable: !0,
          get: function () {
            return h.MAction;
          }
        });
        var d = r(7018);
        Object.defineProperty(t, "MEnclose", {
          enumerable: !0,
          get: function () {
            return d.MEnclose;
          }
        });
        var m = r(6752);
        Object.defineProperty(t, "MError", {
          enumerable: !0,
          get: function () {
            return m.MError;
          }
        });
        var p = r(9897);
        Object.defineProperty(t, "MPhantom", {
          enumerable: !0,
          get: function () {
            return p.MPhantom;
          }
        });
        var f = r(5806);
        Object.defineProperty(t, "MSup", {
          enumerable: !0,
          get: function () {
            return f.MSup;
          }
        });
        var x = r(9);
        Object.defineProperty(t, "MSub", {
          enumerable: !0,
          get: function () {
            return x.MSub;
          }
        });
        var g = r(2740);
        Object.defineProperty(t, "MSubsup", {
          enumerable: !0,
          get: function () {
            return g.MSubsup;
          }
        });
        var w = r(4596);
        Object.defineProperty(t, "MMultiscripts", {
          enumerable: !0,
          get: function () {
            return w.MMultiscripts;
          }
        });
        var b = r(3808);
        Object.defineProperty(t, "MText", {
          enumerable: !0,
          get: function () {
            return b.MText;
          }
        });
        var v = r(2710);
        Object.defineProperty(t, "MUnderover", {
          enumerable: !0,
          get: function () {
            return v.MUnderover;
          }
        });
        var C = r(4134);
        Object.defineProperty(t, "MTable", {
          enumerable: !0,
          get: function () {
            return C.MTable;
          }
        });
        var A = r(7188);
        Object.defineProperty(t, "MTr", {
          enumerable: !0,
          get: function () {
            return A.MTr;
          }
        });
        var E = r(7510);
        Object.defineProperty(t, "GenericSpacingWrapper", {
          enumerable: !0,
          get: function () {
            return E.GenericSpacingWrapper;
          }
        });
        var y = r(3589);
        Object.defineProperty(t, "GenericUnderOver", {
          enumerable: !0,
          get: function () {
            return y.GenericUnderOver;
          }
        });
      },
      916: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MAction = void 0);
        const a = r(3487);
        t.MAction = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {children: e} = this._mathmlElement;
            return this._isToggle() ? e.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" \\Longrightarrow ") : (0, a.mathMLElementToLaTeXConverter)(e[0]).convert();
          }
          _isToggle() {
            const {actiontype: e} = this._mathmlElement.attributes;
            return "toggle" === e || !e;
          }
        };
      },
      2283: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Math = void 0);
        const a = r(3487), n = r(5379);
        t.Math = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const e = this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" ");
            return (0, n.normalizeWhiteSpaces)(e);
          }
        };
      },
      7018: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MEnclose = void 0);
        const a = r(3487);
        t.MEnclose = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const e = this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" ");
            return "actuarial" === this._notation ? `\\overline{\\left.${e}\\right|}` : "radical" === this._notation ? `\\sqrt{${e}}` : ["box", "roundedbox", "circle"].includes(this._notation) ? `\\boxed{${e}}` : "left" === this._notation ? `\\left|${e}` : "right" === this._notation ? `${e}\\right|` : "top" === this._notation ? `\\overline{${e}}` : "bottom" === this._notation ? `\\underline{${e}}` : "updiagonalstrike" === this._notation ? `\\cancel{${e}}` : "downdiagonalstrike" === this._notation ? `\\bcancel{${e}}` : "updiagonalarrow" === this._notation ? `\\cancelto{}{${e}}` : ["verticalstrike", "horizontalstrike"].includes(this._notation) ? `\\hcancel{${e}}` : "madruwb" === this._notation ? `\\underline{${e}\\right|}` : "phasorangle" === this._notation ? `{\\angle \\underline{${e}}}` : "longdiv" === this._notation ? `\\longdiv{${e}}` : `\\overline{\\left.\\right)${e}}`;
          }
          get _notation() {
            return this._mathmlElement.attributes.notation || "longdiv";
          }
        };
      },
      6752: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MError = void 0);
        const a = r(3487);
        t.MError = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            return `\\color{red}{${this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" ")}}`;
          }
        };
      },
      5237: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MFenced = void 0);
        const a = r(3487), n = r(8398);
        t.MFenced = class {
          constructor(e) {
            (this._mathmlElement = e, this._open = this._mathmlElement.attributes.open || "", this._close = this._mathmlElement.attributes.close || "", this._separators = Array.from(this._mathmlElement.attributes.separators || ""));
          }
          convert() {
            const e = this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert());
            return this._isThereRelativeOfName(this._mathmlElement.children, "mtable") ? new i(this._open, this._close).apply(e) : new o(this._open, this._close, this._separators).apply(e);
          }
          _isThereRelativeOfName(e, t) {
            return e.some(e => e.name === t || this._isThereRelativeOfName(e.children, t));
          }
        };
        class o {
          constructor(e, t, r) {
            (this._open = e || "(", this._close = t || ")", this._separators = r);
          }
          apply(e) {
            const t = n.JoinWithManySeparators.join(e, this._separators);
            return new n.GenericWrapper(this._open, this._close).wrap(t);
          }
        }
        class i {
          constructor(e, t) {
            (this._genericCommand = "matrix", this._separators = new l(e, t));
          }
          apply(e) {
            const t = this._command, r = `\\begin{${t}}\n${e.join("")}\n\\end{${t}}`;
            return t === this._genericCommand ? this._separators.wrap(r) : r;
          }
          get _command() {
            return this._separators.areParentheses() ? "pmatrix" : this._separators.areSquareBrackets() ? "bmatrix" : this._separators.areBrackets() ? "Bmatrix" : this._separators.areDivides() ? "vmatrix" : this._separators.areParallels() ? "Vmatrix" : this._separators.areNotEqual() ? this._genericCommand : "bmatrix";
          }
        }
        class l {
          constructor(e, t) {
            (this._open = e, this._close = t);
          }
          wrap(e) {
            return new n.GenericWrapper(this._open, this._close).wrap(e);
          }
          areParentheses() {
            return this._compare("(", ")");
          }
          areSquareBrackets() {
            return this._compare("[", "]");
          }
          areBrackets() {
            return this._compare("{", "}");
          }
          areDivides() {
            return this._compare("|", "|");
          }
          areParallels() {
            return this._compare("||", "||");
          }
          areNotEqual() {
            return this._open !== this._close;
          }
          _compare(e, t) {
            return this._open === e && this._close === t;
          }
        }
      },
      4060: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MFrac = void 0);
        const a = r(6036), n = r(8398);
        t.MFrac = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {children: e, name: t} = this._mathmlElement, r = e.length;
            if (2 !== r) throw new a.InvalidNumberOfChildrenError(t, 2, r);
            const o = (0, n.mathMLElementToLaTeXConverter)(e[0]).convert(), i = (0, n.mathMLElementToLaTeXConverter)(e[1]).convert();
            return this._isBevelled() ? `${this._wrapIfMoreThanOneChar(o)}/${this._wrapIfMoreThanOneChar(i)}` : `\\frac{${o}}{${i}}`;
          }
          _wrapIfMoreThanOneChar(e) {
            return new n.ParenthesisWrapper().wrapIfMoreThanOneChar(e);
          }
          _isBevelled() {
            return !!this._mathmlElement.attributes.bevelled;
          }
        };
      },
      7523: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MI = void 0);
        const a = r(8398), n = r(2408), o = r(4317);
        t.MI = class {
          constructor(e) {
            (this.utf8Converter = new o.HashUTF8ToLtXConverter(), this._mathmlElement = e);
          }
          convert() {
            const e = (0, a.normalizeWhiteSpaces)(this._mathmlElement.value);
            if (" " === e) return i.apply(e);
            const t = e.trim(), r = i.apply(t), n = this.utf8Converter.convert(r);
            return n !== r ? n : this.wrapInMathVariant(r, this.getMathVariant(this._mathmlElement.attributes));
          }
          getMathVariant(e) {
            if (e && e.mathvariant) return e.mathvariant;
          }
          wrapInMathVariant(e, t) {
            switch (t) {
              case "bold":
                return `\\mathbf{${e}}`;
              case "italic":
                return `\\mathit{${e}}`;
              case "bold-italic":
                return `\\mathbf{\\mathit{${e}}}`;
              case "double-struck":
                return `\\mathbb{${e}}`;
              case "bold-fraktur":
                return `\\mathbf{\\mathfrak{${e}}}`;
              case "script":
                return `\\mathcal{${e}}`;
              case "bold-script":
                return `\\mathbf{\\mathcal{${e}}}`;
              case "fraktur":
                return `\\mathfrak{${e}}`;
              case "sans-serif":
                return `\\mathsf{${e}}`;
              case "bold-sans-serif":
                return `\\mathbf{\\mathsf{${e}}}`;
              case "sans-serif-italic":
                return `\\mathsf{\\mathit{${e}}}`;
              case "sans-serif-bold-italic":
                return `\\mathbf{\\mathsf{\\mathit{${e}}}}`;
              case "monospace":
                return `\\mathtt{${e}}`;
              default:
                return e;
            }
          }
        };
        class i {
          constructor(e) {
            this._value = e;
          }
          static apply(e) {
            return new i(e)._apply();
          }
          _apply() {
            return this._findByCharacter() || this._findByGlyph() || this._findByNumber() || new o.HashUTF8ToLtXConverter().convert(this._value);
          }
          _findByCharacter() {
            return n.allMathSymbolsByChar[this._value];
          }
          _findByGlyph() {
            return n.allMathSymbolsByGlyphSpecial[`"${this._value}"`] || n.allMathSymbolsByGlyph[this._value];
          }
          _findByNumber() {
            return n.mathNumberByGlyphSpecial[`"${this._value}"`] || n.mathNumberByGlyph[this._value];
          }
        }
      },
      4596: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MMultiscripts = void 0);
        const a = r(8398), n = r(6036);
        t.MMultiscripts = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {name: e, children: t} = this._mathmlElement, r = t.length;
            if (r < 3) throw new n.InvalidNumberOfChildrenError(e, 3, r, "at least");
            const o = (0, a.mathMLElementToLaTeXConverter)(t[0]).convert();
            return this._prescriptLatex() + this._wrapInParenthesisIfThereIsSpace(o) + this._postscriptLatex();
          }
          _prescriptLatex() {
            const {children: e} = this._mathmlElement;
            let t, r;
            if (this._isPrescripts(e[1])) (t = e[2], r = e[3]); else {
              if (!this._isPrescripts(e[3])) return "";
              (t = e[4], r = e[5]);
            }
            return `\\_{${(0, a.mathMLElementToLaTeXConverter)(t).convert()}}^{${(0, a.mathMLElementToLaTeXConverter)(r).convert()}}`;
          }
          _postscriptLatex() {
            const {children: e} = this._mathmlElement;
            if (this._isPrescripts(e[1])) return "";
            const t = e[1], r = e[2];
            return `_{${(0, a.mathMLElementToLaTeXConverter)(t).convert()}}^{${(0, a.mathMLElementToLaTeXConverter)(r).convert()}}`;
          }
          _wrapInParenthesisIfThereIsSpace(e) {
            return e.match(/\s+/g) ? new a.ParenthesisWrapper().wrap(e) : e;
          }
          _isPrescripts(e) {
            return "mprescripts" === (null == e ? void 0 : e.name);
          }
        };
      },
      411: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MN = void 0);
        const a = r(8398), n = r(2408);
        t.MN = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const e = (0, a.normalizeWhiteSpaces)(this._mathmlElement.value).trim();
            return n.mathNumberByGlyphSpecial[`"${e}"`] || n.mathNumberByGlyph[e] || e;
          }
        };
      },
      5258: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MO = void 0);
        const a = r(8398), n = r(2408);
        t.MO = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const e = (0, a.normalizeWhiteSpaces)(this._mathmlElement.value).trim();
            return "OPEN" === this._mathmlElement.attributes["data-mjx-texclass"] && "|" === e ? "\\left|" : "CLOSE" === this._mathmlElement.attributes["data-mjx-texclass"] && "|" === e ? "\\right|" : o.operate(e);
          }
        };
        class o {
          constructor(e) {
            this._value = e;
          }
          static operate(e) {
            return new o(e)._operate();
          }
          _operate() {
            return this._findByCharacter() || this._findByGlyph() || this._findByNumber() || new n.HashUTF8ToLtXConverter().convert(this._value);
          }
          _findByCharacter() {
            return n.allMathOperatorsByChar[this._value];
          }
          _findByGlyph() {
            return n.allMathOperatorsByGlyphSpecial[`"${this._value}"`] || n.allMathOperatorsByGlyph[this._value];
          }
          _findByNumber() {
            return n.mathNumberByGlyphSpecial[`"${this._value}"`] || n.mathNumberByGlyph[this._value];
          }
        }
      },
      9897: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MPhantom = void 0, t.MPhantom = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            return "";
          }
        });
      },
      5851: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MRoot = void 0);
        const a = r(8398), n = r(6036);
        t.MRoot = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {name: e, children: t} = this._mathmlElement, r = t.length;
            if (2 !== r) throw new n.InvalidNumberOfChildrenError(e, 2, r);
            const o = (0, a.mathMLElementToLaTeXConverter)(t[0]).convert();
            return `\\sqrt[${(0, a.mathMLElementToLaTeXConverter)(t[1]).convert()}]{${o}}`;
          }
        };
      },
      8301: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MSqrt = void 0);
        const a = r(8398);
        t.MSqrt = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            return `\\sqrt{${this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" ")}}`;
          }
        };
      },
      9: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MSub = void 0);
        const a = r(8398), n = r(6036);
        t.MSub = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {name: e, children: t} = this._mathmlElement, r = t.length;
            if (2 !== r) throw new n.InvalidNumberOfChildrenError(e, 2, r);
            const o = (0, a.mathMLElementToLaTeXConverter)(t[0]).convert(), i = (0, a.mathMLElementToLaTeXConverter)(t[1]).convert();
            return "log" === o ? `\\${o}_${new a.BracketWrapper().wrap(i)}` : `${o}_${new a.BracketWrapper().wrap(i)}`;
          }
        };
      },
      2740: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MSubsup = void 0);
        const a = r(8398), n = r(6036);
        t.MSubsup = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {name: e, children: t} = this._mathmlElement, r = t.length;
            if (3 !== r) throw new n.InvalidNumberOfChildrenError(e, 3, r);
            const o = (0, a.mathMLElementToLaTeXConverter)(t[0]).convert(), i = (0, a.mathMLElementToLaTeXConverter)(t[1]).convert(), l = (0, a.mathMLElementToLaTeXConverter)(t[2]).convert(), s = new a.BracketWrapper().wrap(i), c = new a.BracketWrapper().wrap(l);
            return `${this._wrapInParenthesisIfThereIsSpace(o)}_${s}^${c}`;
          }
          _wrapInParenthesisIfThereIsSpace(e) {
            return e.match(/\s+/g) ? new a.ParenthesisWrapper().wrap(e) : e;
          }
        };
      },
      5806: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MSup = void 0);
        const a = r(8398), n = r(6036);
        t.MSup = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {name: e, children: t} = this._mathmlElement, r = t.length;
            if (2 !== r) throw new n.InvalidNumberOfChildrenError(e, 2, r);
            const o = (0, a.mathMLElementToLaTeXConverter)(t[0]).convert(), i = (0, a.mathMLElementToLaTeXConverter)(t[1]).convert();
            return ["'", "″"].indexOf(i) ? `${o}${i}` : `${o}^${new a.BracketWrapper().wrap(i)}`;
          }
        };
      },
      4134: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MTable = void 0);
        const a = r(8398);
        t.MTable = class {
          constructor(e) {
            (this._mathmlElement = e, this._addFlagRecursiveIfName(this._mathmlElement.children, "mtable", "innerTable"));
          }
          convert() {
            const e = this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" \\\\\n");
            return this._hasFlag("innerTable") ? this._wrap(e) : e;
          }
          _wrap(e) {
            return `\\begin{matrix}${e}\\end{matrix}`;
          }
          _addFlagRecursiveIfName(e, t, r) {
            e.forEach(e => {
              (e.name === t && (e.attributes[r] = r), this._addFlagRecursiveIfName(e.children, t, r));
            });
          }
          _hasFlag(e) {
            return !!this._mathmlElement.attributes[e];
          }
        };
      },
      3808: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MText = void 0);
        const a = r(7523);
        t.MText = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {attributes: e, value: t} = this._mathmlElement;
            return [...t].map(e => (/^[a-zA-Z0-9]$/).test(e) || " " == e ? {
              value: e,
              isAlphanumeric: !0
            } : {
              value: e,
              isAlphanumeric: !1
            }).reduce((e, t) => {
              if (t.isAlphanumeric) {
                const r = e[e.length - 1];
                if (r && r.isAlphanumeric) return (r.value += t.value, e);
              }
              return [...e, t];
            }, []).map(t => t.isAlphanumeric ? new n(e.mathvariant).apply(t.value) : new a.MI({
              name: "mi",
              attributes: {},
              children: [],
              value: t.value
            }).convert()).join("");
          }
        };
        class n {
          constructor(e) {
            this._mathvariant = e || "normal";
          }
          apply(e) {
            return this._commands.reduce((t, r, a) => 0 === a ? `${r}{${e}}` : `${r}{${t}}`, "");
          }
          get _commands() {
            switch (this._mathvariant) {
              case "bold":
                return ["\\textbf"];
              case "log":
                return ["\\log"];
              case "italic":
                return ["\\textit"];
              case "bold-italic":
                return ["\\textit", "\\textbf"];
              case "double-struck":
                return ["\\mathbb"];
              case "monospace":
                return ["\\mathtt"];
              case "bold-fraktur":
              case "fraktur":
                return ["\\mathfrak"];
              default:
                return ["\\text"];
            }
          }
        }
      },
      7188: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MTr = void 0);
        const a = r(8398);
        t.MTr = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            return this._mathmlElement.children.map(e => (0, a.mathMLElementToLaTeXConverter)(e)).map(e => e.convert()).join(" & ");
          }
        };
      },
      2710: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MUnderover = void 0);
        const a = r(8398), n = r(6036);
        t.MUnderover = class {
          constructor(e) {
            this._mathmlElement = e;
          }
          convert() {
            const {name: e, children: t} = this._mathmlElement, r = t.length;
            if (3 !== r) throw new n.InvalidNumberOfChildrenError(e, 3, r);
            return `${(0, a.mathMLElementToLaTeXConverter)(t[0]).convert()}_{${(0, a.mathMLElementToLaTeXConverter)(t[1]).convert()}}^{${(0, a.mathMLElementToLaTeXConverter)(t[2]).convert()}}`;
          }
        };
      },
      6483: function (e, t, r) {
        var a = this && this.__createBinding || (Object.create ? function (e, t, r, a) {
          void 0 === a && (a = r);
          var n = Object.getOwnPropertyDescriptor(t, r);
          (n && !(("get" in n) ? !t.__esModule : n.writable || n.configurable) || (n = {
            enumerable: !0,
            get: function () {
              return t[r];
            }
          }), Object.defineProperty(e, a, n));
        } : function (e, t, r, a) {
          (void 0 === a && (a = r), e[a] = t[r]);
        }), n = this && this.__setModuleDefault || (Object.create ? function (e, t) {
          Object.defineProperty(e, "default", {
            enumerable: !0,
            value: t
          });
        } : function (e, t) {
          e.default = t;
        }), o = this && this.__importStar || (function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && a(t, e, r);
          return (n(t, e), t);
        });
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MathMLElementToLatexConverterAdapter = void 0);
        const i = o(r(1733));
        t.MathMLElementToLatexConverterAdapter = class {
          constructor(e) {
            this._mathMLElement = e;
          }
          toLatexConverter() {
            const {name: e} = this._mathMLElement;
            return new (l[e] || i.GenericSpacingWrapper)(this._mathMLElement);
          }
        };
        const l = {
          math: i.Math,
          mi: i.MI,
          mo: i.MO,
          mn: i.MN,
          msqrt: i.MSqrt,
          mfenced: i.MFenced,
          mfrac: i.MFrac,
          mroot: i.MRoot,
          maction: i.MAction,
          menclose: i.MEnclose,
          merror: i.MError,
          mphantom: i.MPhantom,
          msup: i.MSup,
          msub: i.MSub,
          msubsup: i.MSubsup,
          mmultiscripts: i.MMultiscripts,
          mtext: i.MText,
          munderover: i.MUnderover,
          mtable: i.MTable,
          mtr: i.MTr,
          mover: i.GenericUnderOver,
          munder: i.GenericUnderOver,
          mrow: i.GenericSpacingWrapper,
          mpadded: i.GenericSpacingWrapper
        };
      },
      965: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ErrorHandler = void 0, t.ErrorHandler = class {
          constructor() {
            (this._errors = [], this.errorLocator = {});
          }
          fixError(e, t) {
            return this._isMissingAttributeValueError(t) ? (this._errors.push(t), this._fixMissingAttribute(t, e)) : e;
          }
          isThereAnyErrors() {
            return this._errors.length > 0;
          }
          cleanErrors() {
            this._errors = [];
          }
          _fixMissingAttribute(e, t) {
            const r = e.split('"')[1];
            if (r) return t.replace(this._matchMissingValueForAttribute(r), "");
            for (; this._mathGenericMissingValue().exec(t); ) t = t.replace(this._mathGenericMissingValue(), "$1$3");
            return t;
          }
          _matchMissingValueForAttribute(e) {
            return new RegExp(`(${e}=(?!("|')))|(${e}(?!("|')))`, "gm");
          }
          _mathGenericMissingValue() {
            return /(\<.* )(\w+=(?!\"|\'))(.*\>)/gm;
          }
          _isMissingAttributeValueError(e) {
            return !!e.includes("attribute") && !!e.includes("missed") || e.includes("attribute value missed");
          }
        });
      },
      6177: function (e, t, r) {
        var a = this && this.__createBinding || (Object.create ? function (e, t, r, a) {
          void 0 === a && (a = r);
          var n = Object.getOwnPropertyDescriptor(t, r);
          (n && !(("get" in n) ? !t.__esModule : n.writable || n.configurable) || (n = {
            enumerable: !0,
            get: function () {
              return t[r];
            }
          }), Object.defineProperty(e, a, n));
        } : function (e, t, r, a) {
          (void 0 === a && (a = r), e[a] = t[r]);
        }), n = this && this.__exportStar || (function (e, t) {
          for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || a(t, e, r);
        });
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), n(r(5242), t), n(r(965), t), n(r(1877), t));
      },
      1877: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ElementsToMathMLAdapter = void 0, t.ElementsToMathMLAdapter = class {
          convert(e) {
            return e.filter(e => void 0 !== e.tagName).map(e => this._convertElement(e));
          }
          _convertElement(e) {
            return {
              name: e.tagName,
              attributes: this._convertElementAttributes(e.attributes),
              value: this._hasElementChild(e) ? "" : e.textContent || "",
              children: this._hasElementChild(e) ? this.convert(Array.from(e.childNodes)) : []
            };
          }
          _convertElementAttributes(e) {
            return Array.from(e).reduce((e, t) => Object.assign({
              [t.nodeName]: t.nodeValue === t.nodeName ? "" : t.nodeValue
            }, e), {});
          }
          _hasElementChild(e) {
            const t = e.childNodes;
            return !!t && 0 !== t.length && this._isThereAnyNoTextNode(t);
          }
          _isThereAnyNoTextNode(e) {
            return Array.from(e).some(e => "#text" !== e.nodeName);
          }
        });
      },
      5242: function (e, t, r) {
        var a = this && this.__importDefault || (function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        });
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.XmlToMathMLAdapter = void 0);
        const n = a(r(3969));
        t.XmlToMathMLAdapter = class {
          constructor(e, t) {
            (this._xml = "", this._elementsConvertor = e, this._errorHandler = t, this._xmlDOM = new n.default.DOMParser({
              locator: this._errorHandler.errorLocator,
              errorHandler: this._fixError.bind(this)
            }));
          }
          convert(e) {
            return (this._xml = this._removeLineBreaks(e), this._elementsConvertor.convert(this._mathMLElements));
          }
          _fixError(e) {
            this._xml = this._errorHandler.fixError(this._xml, e);
          }
          _removeLineBreaks(e) {
            return e.replace(/\n|\r\n|\r/g, "");
          }
          get _mathMLElements() {
            let e = this._xmlDOM.parseFromString(this._xml).getElementsByTagName("math");
            return (this._errorHandler.isThereAnyErrors() && (this._errorHandler.cleanErrors(), e = this._xmlDOM.parseFromString(this._xml).getElementsByTagName("math")), Array.from(e));
          }
        };
      },
      4150: function (e, t, r) {
        var a = this && this.__createBinding || (Object.create ? function (e, t, r, a) {
          void 0 === a && (a = r);
          var n = Object.getOwnPropertyDescriptor(t, r);
          (n && !(("get" in n) ? !t.__esModule : n.writable || n.configurable) || (n = {
            enumerable: !0,
            get: function () {
              return t[r];
            }
          }), Object.defineProperty(e, a, n));
        } : function (e, t, r, a) {
          (void 0 === a && (a = r), e[a] = t[r]);
        }), n = this && this.__exportStar || (function (e, t) {
          for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || a(t, e, r);
        });
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), n(r(488), t));
      },
      488: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.makeToMathElementsConverter = void 0);
        const a = r(6177);
        t.makeToMathElementsConverter = () => {
          const e = new a.ElementsToMathMLAdapter(), t = new a.ErrorHandler();
          return new a.XmlToMathMLAdapter(e, t);
        };
      },
      8863: function (e, t, r) {
        var a = this && this.__createBinding || (Object.create ? function (e, t, r, a) {
          void 0 === a && (a = r);
          var n = Object.getOwnPropertyDescriptor(t, r);
          (n && !(("get" in n) ? !t.__esModule : n.writable || n.configurable) || (n = {
            enumerable: !0,
            get: function () {
              return t[r];
            }
          }), Object.defineProperty(e, a, n));
        } : function (e, t, r, a) {
          (void 0 === a && (a = r), e[a] = t[r]);
        }), n = this && this.__exportStar || (function (e, t) {
          for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || a(t, e, r);
        });
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), n(r(862), t));
      },
      862: (e, t, r) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MathMLToLaTeX = void 0);
        const a = r(6483), n = r(4150);
        t.MathMLToLaTeX = class {
          static convert(e) {
            return (0, n.makeToMathElementsConverter)().convert(e).map(e => new a.MathMLElementToLatexConverterAdapter(e).toLatexConverter()).map(e => e.convert()).join("").trim();
          }
        };
      },
      1868: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.allMathOperatorsByChar = void 0, t.allMathOperatorsByChar = {
          _: "\\underline",
          "&#x23E1;": "\\underbrace",
          "&#x23E0;": "\\overbrace",
          "&#x23DF;": "\\underbrace",
          "&#x23DE;": "\\overbrace",
          "&#x23DD;": "\\underbrace",
          "&#x23DC;": "\\overarc",
          "&#x23B5;": "\\underbrace",
          "&#x23B4;": "\\overbrace",
          "&#x20DC;": "\\square",
          "&#x20DB;": "\\square",
          "&#x2064;": "",
          "&#x2057;": "''''",
          "&#x203E;": "\\overline",
          "&#x2015;": "\\overline",
          "&#xAF;": "\\overline",
          "&#x2037;": "```",
          "&#x2036;": "``",
          "&#x2035;": "`",
          "&#x2034;": "'''",
          "&#x2033;": "''",
          "&#x201F;": "``",
          "&#x201E;": ",,",
          "&#x201B;": "`",
          "&#x201A;": ",",
          "&#x302;": "\\hat",
          "&#x2F7;": "\\sim",
          "&#x2DD;": "\\sim",
          "&#x2DC;": "\\sim",
          "&#x2DA;": "\\degree",
          "&#x2D9;": "\\cdot",
          "&#x2D8;": "",
          "&#x2CD;": "\\_",
          "&#x2CB;": "ˋ",
          "&#x2CA;": "ˊ",
          "&#x2C9;": "ˉ",
          "&#x2C7;": "",
          "&#x2C6;": "\\hat",
          "&#xBA;": "o",
          "&#xB9;": "1",
          "&#xB8;": "¸",
          "&#xB4;": "´",
          "&#xB3;": "3",
          "&#xB2;": "2",
          "&#xB0;": "\\degree",
          "&#xAA;": "a",
          "&#xA8;": "\\cdot\\cdot",
          "~": "\\sim",
          "`": "`",
          "^": "\\hat",
          "--": "--",
          "++": "++",
          "&amp;": "\\&",
          "&#x2061;": "",
          "&#x221C;": "\\sqrt[4]{}",
          "&#x221B;": "\\sqrt[3]{}",
          "&#x221A;": "\\sqrt{}",
          "&#x2146;": "d",
          "&#x2145;": "\\mathbb{D}",
          "?": "?",
          "@": "@",
          "//": "//",
          "!!": "!!",
          "!": "!",
          "&#x266F;": "\\#",
          "&#x266E;": "",
          "&#x266D;": "",
          "&#x2032;": "'",
          "&lt;>": "<>",
          "**": "\\star\\star",
          "&#x2207;": "\\nabla",
          "&#x2202;": "\\partial",
          "&#x2299;": "\\bigodot",
          "&#xAC;": "\\neg",
          "&#x2222;": "\\measuredangle",
          "&#x2221;": "\\measuredangle",
          "&#x2220;": "\\angle",
          "&#xF7;": "\\div",
          "/": "/",
          "&#x2216;": "\\backslash",
          "\\": "\\backslash",
          "%": "\\%",
          "&#x2297;": "\\bigotimes",
          "&#xB7;": "\\cdot",
          "&#x2A3F;": "\\coprod",
          "&#x2A2F;": "\\times",
          "&#x22C5;": "\\cdot",
          "&#x22A1;": "\\boxdot",
          "&#x22A0;": "\\boxtimes",
          "&#x2062;": "",
          "&#x2043;": "-",
          "&#x2022;": "\\cdot",
          "&#xD7;": "\\times",
          ".": ".",
          "*": "\\star",
          "&#x222A;": "\\cup",
          "&#x2229;": "\\cap",
          "&#x2210;": "\\coprod",
          "&#x220F;": "\\prod",
          "&#x2240;": "",
          "&#x2AFF;": "",
          "&#x2AFC;": "\\mid\\mid\\mid",
          "&#x2A09;": "\\times",
          "&#x2A08;": "",
          "&#x2A07;": "",
          "&#x2A06;": "\\sqcup",
          "&#x2A05;": "\\sqcap",
          "&#x2A02;": "\\otimes",
          "&#x2A00;": "\\odot",
          "&#x22C2;": "\\cap",
          "&#x22C1;": "\\vee",
          "&#x22C0;": "\\wedge",
          "&#x2A04;": "\\uplus",
          "&#x2A03;": "\\cup",
          "&#x22C3;": "\\cup",
          "&#x2A1C;": "\\underline{\\int}",
          "&#x2A1B;": "\\overline{\\int}",
          "&#x2A1A;": "\\int",
          "&#x2A19;": "\\int",
          "&#x2A18;": "\\int",
          "&#x2A17;": "\\int",
          "&#x2A16;": "\\oint",
          "&#x2A15;": "\\oint",
          "&#x2A14;": "\\int",
          "&#x2A13;": "\\int",
          "&#x2A12;": "\\int",
          "&#x2A11;": "\\int",
          "&#x2A10;": "\\int",
          "&#x2A0F;": "\\bcancel{\\int}",
          "&#x2A0E;": "",
          "&#x2A0D;": "\\hcancel{\\int}",
          "&#x2A0C;": "\\iiiint",
          "&#x2233;": "\\oint",
          "&#x2232;": "\\oint",
          "&#x2231;": "\\int",
          "&#x2230;": "\\oiint",
          "&#x222F;": "\\oiint",
          "&#x222E;": "\\oint",
          "&#x222B;": "\\int",
          "&#x2A01;": "\\oplus",
          "&#x2298;": "\\oslash",
          "&#x2296;": "\\ominus",
          "&#x2295;": "\\oplus",
          "&#x222D;": "\\iiint",
          "&#x222C;": "\\iint",
          "&#x2A0B;": "",
          "&#x2A0A;": "",
          "&#x2211;": "\\sum",
          "&#x229F;": "\\boxminus",
          "&#x229E;": "\\boxplus",
          "&#x2214;": "\\dot{+}",
          "&#x2213;": "+-",
          "&#x2212;": "-",
          "&#xB1;": "\\pm",
          "-": "-",
          "+": "+",
          "&#x2B46;": "\\Rrightarrow",
          "&#x2B45;": "\\Lleftarrow",
          "&#x29F4;": ":\\rightarrow",
          "&#x29EF;": "",
          "&#x29DF;": "\\bullet-\\bullet",
          "&#x299F;": "\\angle",
          "&#x299E;": "\\measuredangle",
          "&#x299D;": "\\measuredangle",
          "&#x299C;": "\\perp",
          "&#x299B;": "\\measuredangle",
          "&#x299A;": "",
          "&#x2999;": "\\vdots",
          "&#x297F;": "",
          "&#x297E;": "",
          "&#x297D;": "\\prec",
          "&#x297C;": "\\succ",
          "&#x297B;": "\\underset{\\rightarrow}{\\supset}",
          "&#x297A;": "",
          "&#x2979;": "\\underset{\\rightarrow}{\\subset}",
          "&#x2978;": "\\underset{\\rightarrow}{>}",
          "&#x2977;": "",
          "&#x2976;": "\\underset{\\leftarrow}{<}",
          "&#x2975;": "\\underset{\\approx}{\\rightarrow}",
          "&#x2974;": "\\underset{\\sim}{\\rightarrow}",
          "&#x2973;": "\\underset{\\sim}{\\leftarrow}",
          "&#x2972;": "\\overset{\\sim}{\\rightarrow}",
          "&#x2971;": "\\overset{=}{\\rightarrow}",
          "&#x2970;": "",
          "&#x296F;": "",
          "&#x296E;": "",
          "&#x296D;": "\\overline{\\rightharpoondown}",
          "&#x296C;": "\\underline{\\rightharpoonup}",
          "&#x296B;": "\\overline{\\leftharpoondown}",
          "&#x296A;": "\\underline{\\leftharpoonup}",
          "&#x2969;": "\\rightleftharpoons",
          "&#x2968;": "\\rightleftharpoons",
          "&#x2967;": "\\rightleftharpoons",
          "&#x2966;": "\\rightleftharpoons",
          "&#x2965;": "\\Downarrow",
          "&#x2964;": "\\Rightarrow",
          "&#x2963;": "\\Uparrow",
          "&#x2962;": "\\Leftarrow",
          "&#x2961;": "\\downarrow",
          "&#x2960;": "\\uparrow",
          "&#x295F;": "\\rightarrow",
          "&#x295E;": "\\leftarrow",
          "&#x295D;": "\\downarrow",
          "&#x295C;": "\\uparrow",
          "&#x295B;": "\\rightarrow",
          "&#x295A;": "\\leftarrow",
          "&#x2959;": "\\downarrow",
          "&#x2958;": "\\uparrow",
          "&#x2957;": "\\rightarrow",
          "&#x2956;": "\\leftarrow",
          "&#x2955;": "\\downarrow",
          "&#x2954;": "\\uparrow",
          "&#x2953;": "\\rightarrow",
          "&#x2952;": "\\leftarrow",
          "&#x2951;": "\\updownarrow",
          "&#x2950;": "\\leftrightarrow",
          "&#x294F;": "\\updownarrow",
          "&#x294E;": "\\leftrightarrow",
          "&#x294D;": "\\updownarrow",
          "&#x294C;": "\\updownarrow",
          "&#x294B;": "\\leftrightarrow",
          "&#x294A;": "\\leftrightarrow",
          "&#x2949;": "",
          "&#x2948;": "\\leftrightarrow",
          "&#x2947;": "\\nrightarrow",
          "&#x2946;": "",
          "&#x2945;": "",
          "&#x2944;": "\\rightleftarrows",
          "&#x2943;": "\\leftrightarrows",
          "&#x2942;": "\\rightleftarrows",
          "&#x2941;": "\\circlearrowright",
          "&#x2940;": "\\circlearrowleft",
          "&#x293F;": "\\rightarrow",
          "&#x293E;": "\\leftarrow",
          "&#x293D;": "",
          "&#x293C;": "",
          "&#x293B;": "",
          "&#x293A;": "",
          "&#x2939;": "",
          "&#x2938;": "",
          "&#x2937;": "\\Rsh",
          "&#x2936;": "\\Lsh",
          "&#x2935;": "\\downarrow",
          "&#x2934;": "\\uparrow",
          "&#x2933;": "\\leadsto",
          "&#x2932;": "",
          "&#x2931;": "",
          "&#x2930;": "",
          "&#x292F;": "",
          "&#x292E;": "",
          "&#x292D;": "",
          "&#x292C;": "\\times",
          "&#x292B;": "\\times",
          "&#x292A;": "",
          "&#x2929;": "",
          "&#x2928;": "",
          "&#x2927;": "",
          "&#x2926;": "",
          "&#x2925;": "",
          "&#x2924;": "",
          "&#x2923;": "",
          "&#x2922;": "",
          "&#x2921;": "",
          "&#x2920;": "\\mapsto\\cdot",
          "&#x291F;": "\\cdot\\leftarrow",
          "&#x291E;": "\\rightarrow\\cdot",
          "&#x291D;": "\\leftarrow",
          "&#x291C;": "\\rightarrow",
          "&#x291B;": "\\leftarrow",
          "&#x291A;": "\\rightarrow",
          "&#x2919;": "\\leftarrow",
          "&#x2918;": "\\rightarrow",
          "&#x2917;": "\\rightarrow",
          "&#x2916;": "\\rightarrow",
          "&#x2915;": "\\rightarrow",
          "&#x2914;": "\\rightarrow",
          "&#x2913;": "\\downarrow",
          "&#x2912;": "\\uparrow",
          "&#x2911;": "\\rightarrow",
          "&#x2910;": "\\rightarrow",
          "&#x290F;": "\\rightarrow",
          "&#x290E;": "\\leftarrow",
          "&#x290D;": "\\rightarrow",
          "&#x290C;": "\\leftarrow",
          "&#x290B;": "\\Downarrow",
          "&#x290A;": "\\Uparrow",
          "&#x2909;": "\\uparrow",
          "&#x2908;": "\\downarrow",
          "&#x2907;": "\\Rightarrow",
          "&#x2906;": "\\Leftarrow",
          "&#x2905;": "\\mapsto",
          "&#x2904;": "\\nLeftrightarrow",
          "&#x2903;": "\\nRightarrow",
          "&#x2902;": "\\nLeftarrow",
          "&#x2901;": "\\rightsquigarrow",
          "&#x2900;": "\\rightsquigarrow",
          "&#x27FF;": "\\rightsquigarrow",
          "&#x27FE;": "\\Rightarrow",
          "&#x27FD;": "\\Leftarrow",
          "&#x27FC;": "\\mapsto",
          "&#x27FB;": "\\leftarrow",
          "&#x27FA;": "\\Longleftrightarrow",
          "&#x27F9;": "\\Longrightarrow",
          "&#x27F8;": "\\Longleftarrow",
          "&#x27F7;": "\\leftrightarrow",
          "&#x27F6;": "\\rightarrow",
          "&#x27F5;": "\\leftarrow",
          "&#x27F1;": "\\Downarrow",
          "&#x27F0;": "\\Uparrow",
          "&#x22B8;": "\\rightarrow",
          "&#x21FF;": "\\leftrightarrow",
          "&#x21FE;": "\\rightarrow",
          "&#x21FD;": "\\leftarrow",
          "&#x21FC;": "\\nleftrightarrow",
          "&#x21FB;": "\\nrightarrow",
          "&#x21FA;": "\\nleftarrow",
          "&#x21F9;": "\\nleftrightarrow",
          "&#x21F8;": "\\nrightarrow",
          "&#x21F7;": "\\nleftarrow",
          "&#x21F6;": "\\Rrightarrow",
          "&#x21F5;": "",
          "&#x21F4;": "\\rightarrow",
          "&#x21F3;": "\\Updownarrow",
          "&#x21F2;": "\\searrow",
          "&#x21F1;": "\\nwarrow",
          "&#x21F0;": "\\Leftarrow",
          "&#x21EF;": "\\Uparrow",
          "&#x21EE;": "\\Uparrow",
          "&#x21ED;": "\\Uparrow",
          "&#x21EC;": "\\Uparrow",
          "&#x21EB;": "\\Uparrow",
          "&#x21EA;": "\\Uparrow",
          "&#x21E9;": "\\Downarrow",
          "&#x21E8;": "\\Rightarrow",
          "&#x21E7;": "\\Uparrow",
          "&#x21E6;": "\\Leftarrow",
          "&#x21E5;": "\\rightarrow",
          "&#x21E4;": "\\leftarrow",
          "&#x21E3;": "\\downarrow",
          "&#x21E2;": "\\rightarrow",
          "&#x21E1;": "\\uparrow",
          "&#x21E0;": "\\leftarrow",
          "&#x21DF;": "\\downarrow",
          "&#x21DE;": "\\uparrow",
          "&#x21DD;": "\\rightsquigarrow",
          "&#x21DC;": "\\leftarrow",
          "&#x21DB;": "\\Rrightarrow",
          "&#x21DA;": "\\Lleftarrow",
          "&#x21D9;": "\\swarrow",
          "&#x21D8;": "\\searrow",
          "&#x21D7;": "\\nearrow",
          "&#x21D6;": "\\nwarrow",
          "&#x21D5;": "\\Updownarrow",
          "&#x21D4;": "\\Leftrightarrow",
          "&#x21D3;": "\\Downarrow",
          "&#x21D2;": "\\Rightarrow",
          "&#x21D1;": "\\Uparrow",
          "&#x21D0;": "\\Leftarrow",
          "&#x21CF;": "\\nRightarrow",
          "&#x21CE;": "\\nLeftrightarrow",
          "&#x21CD;": "\\nLeftarrow",
          "&#x21CC;": "\\rightleftharpoons",
          "&#x21CB;": "\\leftrightharpoons",
          "&#x21CA;": "\\downdownarrows",
          "&#x21C9;": "\\rightrightarrows",
          "&#x21C8;": "\\upuparrows",
          "&#x21C7;": "\\leftleftarrows",
          "&#x21C6;": "\\leftrightarrows",
          "&#x21C5;": "",
          "&#x21C4;": "\\rightleftarrows",
          "&#x21C3;": "\\downharpoonleft",
          "&#x21C2;": "\\downharpoonright",
          "&#x21C1;": "\\rightharpoondown",
          "&#x21C0;": "\\rightharpoonup",
          "&#x21BF;": "\\upharpoonleft",
          "&#x21BE;": "\\upharpoonright",
          "&#x21BD;": "\\leftharpoondown",
          "&#x21BC;": "\\leftharpoonup",
          "&#x21BB;": "\\circlearrowright",
          "&#x21BA;": "\\circlearrowleft",
          "&#x21B9;": "\\leftrightarrows",
          "&#x21B8;": "\\overline{\\nwarrow}",
          "&#x21B7;": "\\curvearrowright",
          "&#x21B6;": "\\curvearrowleft",
          "&#x21B5;": "\\swarrow",
          "&#x21B4;": "\\searrow",
          "&#x21B3;": "\\Rsh",
          "&#x21B2;": "\\Lsh",
          "&#x21B1;": "\\Rsh",
          "&#x21B0;": "\\Lsh",
          "&#x21AF;": "\\swarrow",
          "&#x21AE;": "",
          "&#x21AD;": "\\leftrightsquigarrow",
          "&#x21AC;": "\\looparrowright",
          "&#x21AB;": "\\looparrowleft",
          "&#x21AA;": "\\hookrightarrow",
          "&#x21A9;": "\\hookleftarrow",
          "&#x21A8;": "\\underline{\\updownarrow}",
          "&#x21A7;": "\\downarrow",
          "&#x21A6;": "\\rightarrowtail",
          "&#x21A5;": "\\uparrow",
          "&#x21A4;": "\\leftarrowtail",
          "&#x21A3;": "\\rightarrowtail",
          "&#x21A2;": "\\leftarrowtail",
          "&#x21A1;": "\\downarrow",
          "&#x21A0;": "\\twoheadrightarrow",
          "&#x219F;": "\\uparrow",
          "&#x219E;": "\\twoheadleftarrow",
          "&#x219D;": "\\nearrow",
          "&#x219C;": "\\nwarrow",
          "&#x219B;": "",
          "&#x219A;": "",
          "&#x2199;": "\\swarrow",
          "&#x2198;": "\\searrow",
          "&#x2197;": "\\nearrow",
          "&#x2196;": "\\nwarrow",
          "&#x2195;": "\\updownarrow",
          "&#x2194;": "\\leftrightarrow",
          "&#x2193;": "\\downarrow",
          "&#x2192;": "\\rightarrow",
          "&#x2191;": "\\uparrow",
          "&#x2190;": "\\leftarrow",
          "|||": "\\left|||\\right.",
          "||": "\\left||\\right.",
          "|": "\\left|\\right.",
          "&#x2AFE;": "",
          "&#x2AFD;": "//",
          "&#x2AFB;": "///",
          "&#x2AFA;": "",
          "&#x2AF9;": "",
          "&#x2AF8;": "",
          "&#x2AF7;": "",
          "&#x2AF6;": "\\vdots",
          "&#x2AF5;": "",
          "&#x2AF4;": "",
          "&#x2AF3;": "",
          "&#x2AF2;": "\\nparallel",
          "&#x2AF1;": "",
          "&#x2AF0;": "",
          "&#x2AEF;": "",
          "&#x2AEE;": "\\bcancel{\\mid}",
          "&#x2AED;": "",
          "&#x2AEC;": "",
          "&#x2AEB;": "",
          "&#x2AEA;": "",
          "&#x2AE9;": "",
          "&#x2AE8;": "\\underline{\\perp}",
          "&#x2AE7;": "\\overline{\\top}",
          "&#x2AE6;": "",
          "&#x2AE5;": "",
          "&#x2AE4;": "",
          "&#x2AE3;": "",
          "&#x2AE2;": "",
          "&#x2AE1;": "",
          "&#x2AE0;": "\\perp",
          "&#x2ADF;": "\\top",
          "&#x2ADE;": "\\dashv",
          "&#x2ADD;&#x338;": "",
          "&#x2ADD;": "",
          "&#x2ADB;": "\\pitchfork",
          "&#x2ADA;": "",
          "&#x2AD9;": "",
          "&#x2AD8;": "",
          "&#x2AD7;": "",
          "&#x2AD6;": "",
          "&#x2AD5;": "",
          "&#x2AD4;": "",
          "&#x2AD3;": "",
          "&#x2AD2;": "",
          "&#x2AD1;": "",
          "&#x2AD0;": "",
          "&#x2ACF;": "",
          "&#x2ACE;": "",
          "&#x2ACD;": "",
          "&#x2ACC;": "\\underset{\\neq}{\\supset}",
          "&#x2ACB;": "\\underset{\\neq}{\\subset}",
          "&#x2ACA;": "\\underset{\\approx}{\\supset}",
          "&#x2AC9;": "\\underset{\\approx}{\\subset}",
          "&#x2AC8;": "\\underset{\\sim}{\\supset}",
          "&#x2AC7;": "\\underset{\\sim}{\\subset}",
          "&#x2AC6;": "\\supseteqq",
          "&#x2AC5;": "\\subseteqq",
          "&#x2AC4;": "\\dot{\\supseteq}",
          "&#x2AC3;": "\\dot{\\subseteq}",
          "&#x2AC2;": "\\underset{\\times}{\\supset}",
          "&#x2AC1;": "\\underset{\\times}{\\subset}",
          "&#x2AC0;": "\\underset{+}{\\supset}",
          "&#x2ABF;": "\\underset{+}{\\subset}",
          "&#x2ABE;": "",
          "&#x2ABD;": "",
          "&#x2ABC;": "\\gg ",
          "&#x2ABB;": "\\ll",
          "&#x2ABA;": "\\underset{\\cancel{\\approx}}{\\succ}",
          "&#x2AB9;": "\\underset{\\cancel{\\approx}}{\\prec}",
          "&#x2AB8;": "\\underset{\\approx}{\\succ}",
          "&#x2AB7;": "\\underset{\\approx}{\\prec}",
          "&#x2AB6;": "\\underset{\\cancel{=}}{\\succ}",
          "&#x2AB5;": "\\underset{\\cancel{=}}{\\prec}",
          "&#x2AB4;": "\\underset{=}{\\succ}",
          "&#x2AB3;": "\\underset{=}{\\prec}",
          "&#x2AB2;": "",
          "&#x2AB1;": "",
          "&#x2AAE;": "",
          "&#x2AAD;": "\\underline{\\hcancel{>}}",
          "&#x2AAC;": "\\underline{\\hcancel{>}}",
          "&#x2AAB;": "\\hcancel{>}",
          "&#x2AAA;": "\\hcancel{<}",
          "&#x2AA9;": "",
          "&#x2AA8;": "",
          "&#x2AA7;": "\\vartriangleright",
          "&#x2AA6;": "\\vartriangleleft",
          "&#x2AA5;": "><",
          "&#x2AA4;": "><",
          "&#x2AA3;": "\\underline{\\ll}",
          "&#x2AA2;&#x338;": "\\cancel{\\gg}",
          "&#x2AA2;": "\\gg",
          "&#x2AA1;&#x338;": "\\cancel{\\ll}",
          "&#x2AA1;": "\\ll",
          "&#x2AA0;": "\\overset{\\sim}{\\geqq}",
          "&#x2A9F;": "\\overset{\\sim}{\\leqq}",
          "&#x2A9E;": "\\overset{\\sim}{>}",
          "&#x2A9D;": "\\overset{\\sim}{<}",
          "&#x2A9C;": "",
          "&#x2A9B;": "",
          "&#x2A9A;": "\\overset{=}{>}",
          "&#x2A99;": "\\overset{=}{<}",
          "&#x2A98;": "",
          "&#x2A97;": "",
          "&#x2A96;": "",
          "&#x2A95;": "",
          "&#x2A94;": "",
          "&#x2A93;": "",
          "&#x2A92;": "\\underset{=}{\\gtrless}",
          "&#x2A91;": "\\underset{=}{\\lessgtr}",
          "&#x2A90;": "\\underset{<}{\\gtrsim}",
          "&#x2A8F;": "\\underset{>}{\\lesssim}",
          "&#x2A8E;": "\\underset{\\simeq}{>}",
          "&#x2A8D;": "\\underset{\\simeq}{<}",
          "&#x2A8C;": "\\gtreqqless",
          "&#x2A8B;": "\\lesseqqgtr",
          "&#x2A8A;": "\\underset{\\cancel{\\approx}}{>}",
          "&#x2A89;": "\\underset{\\approx}{<}",
          "&#x2A86;": "\\underset{\\approx}{>}",
          "&#x2A85;": "\\underset{\\approx}{<}",
          "&#x2A84;": "",
          "&#x2A83;": "",
          "&#x2A82;": "",
          "&#x2A81;": "",
          "&#x2A80;": "",
          "&#x2A7F;": "",
          "&#x2A7E;&#x338;": "\\bcancel{\\geq}",
          "&#x2A7E;": "\\geq",
          "&#x2A7D;&#x338;": "\\bcancel{\\leq}",
          "&#x2A7D;": "\\leq",
          "&#x2A7C;": "",
          "&#x2A7B;": "",
          "&#x2A7A;": "",
          "&#x2A79;": "",
          "&#x2A78;": "\\overset{\\dots}{\\equiv}",
          "&#x2A77;": "",
          "&#x2A76;": "===",
          "&#x2A75;": "==",
          "&#x2A74;": "::=",
          "&#x2A73;": "",
          "&#x2A72;": "\\underset{=}{+}",
          "&#x2A71;": "\\overset{=}{+}",
          "&#x2A70;": "\\overset{\\approx}{=}",
          "&#x2A6F;": "\\overset{\\wedge}{=}",
          "&#x2A6E;": "\\overset{*}{=}",
          "&#x2A6D;": "\\dot{\\approx}",
          "&#x2A6C;": "",
          "&#x2A6B;": "",
          "&#x2A6A;": "\\dot{\\sim}",
          "&#x2A69;": "",
          "&#x2A68;": "",
          "&#x2A67;": "\\dot{\\equiv}",
          "&#x2A66;": "\\underset{\\cdot}{=}",
          "&#x2A65;": "",
          "&#x2A64;": "",
          "&#x2A63;": "\\underset{=}{\\vee}",
          "&#x2A62;": "\\overset{=}{\\vee}",
          "&#x2A61;": "ul(vv)",
          "&#x2A60;": "\\underset{=}{\\wedge}",
          "&#x2A5F;": "\\underline{\\wedge}",
          "&#x2A5E;": "\\overset{=}{\\wedge}",
          "&#x2A5D;": "\\hcancel{\\vee}",
          "&#x2A5C;": "\\hcancel{\\wedge}",
          "&#x2A5B;": "",
          "&#x2A5A;": "",
          "&#x2A59;": "",
          "&#x2A58;": "\\vee",
          "&#x2A57;": "\\wedge",
          "&#x2A56;": "",
          "&#x2A55;": "",
          "&#x2A54;": "",
          "&#x2A53;": "",
          "&#x2A52;": "\\dot{\\vee}",
          "&#x2A51;": "\\dot{\\wedge}",
          "&#x2A50;": "",
          "&#x2A4F;": "",
          "&#x2A4E;": "",
          "&#x2A4D;": "\\overline{\\cap}",
          "&#x2A4C;": "\\overline{\\cup}",
          "&#x2A4B;": "",
          "&#x2A4A;": "",
          "&#x2A49;": "",
          "&#x2A48;": "",
          "&#x2A47;": "",
          "&#x2A46;": "",
          "&#x2A45;": "",
          "&#x2A44;": "",
          "&#x2A43;": "\\overline{\\cap}",
          "&#x2A42;": "\\overline{\\cup}",
          "&#x2A41;": "",
          "&#x2A40;": "",
          "&#x2A3E;": "",
          "&#x2A3D;": "\\llcorner",
          "&#x2A3C;": "\\lrcorner",
          "&#x2A3B;": "",
          "&#x2A3A;": "",
          "&#x2A39;": "",
          "&#x2A38;": "",
          "&#x2A37;": "",
          "&#x2A36;": "\\hat{\\otimes}",
          "&#x2A35;": "",
          "&#x2A34;": "",
          "&#x2A33;": "",
          "&#x2A32;": "\\underline{\\times}",
          "&#x2A31;": "\\underline{\\times}",
          "&#x2A30;": "\\dot{\\times}",
          "&#x2A2E;": "",
          "&#x2A2D;": "",
          "&#x2A2C;": "",
          "&#x2A2B;": "",
          "&#x2A2A;": "",
          "&#x2A29;": "",
          "&#x2A28;": "",
          "&#x2A27;": "",
          "&#x2A26;": "\\underset{\\sim}{+}",
          "&#x2A25;": "\\underset{\\circ}{+}",
          "&#x2A24;": "\\overset{\\sim}{+}",
          "&#x2A23;": "\\hat{+}",
          "&#x2A22;": "\\dot{+}",
          "&#x2A21;": "\\upharpoonright",
          "&#x2A20;": ">>",
          "&#x2A1F;": "",
          "&#x2A1E;": "\\triangleleft",
          "&#x2A1D;": "\\bowtie",
          "&#x29FF;": "",
          "&#x29FE;": "+",
          "&#x29FB;": "\\hcancel{|||}",
          "&#x29FA;": "\\hcancel{||}",
          "&#x29F9;": "\\backslash",
          "&#x29F8;": "/",
          "&#x29F7;": "hcancel{\backslash}",
          "&#x29F6;": "",
          "&#x29F5;": "\\backslash",
          "&#x29F2;": "\\Phi",
          "&#x29F1;": "",
          "&#x29F0;": "",
          "&#x29EE;": "",
          "&#x29ED;": "",
          "&#x29EC;": "",
          "&#x29EB;": "\\lozenge",
          "&#x29EA;": "",
          "&#x29E9;": "",
          "&#x29E8;": "",
          "&#x29E7;": "\\ddagger",
          "&#x29E2;": "\\sqcup\\sqcup",
          "&#x29E1;": "",
          "&#x29E0;": "\\square",
          "&#x29DE;": "",
          "&#x29DD;": "",
          "&#x29DC;": "",
          "&#x29DB;": "\\{\\{",
          "&#x29D9;": "\\{",
          "&#x29D8;": "\\}",
          "&#x29D7;": "",
          "&#x29D6;": "",
          "&#x29D5;": "\\bowtie",
          "&#x29D4;": "\\bowtie",
          "&#x29D3;": "\\bowtie",
          "&#x29D2;": "\\bowtie",
          "&#x29D1;": "\\bowtie",
          "&#x29D0;&#x338;": "| \\not\\triangleright",
          "&#x29D0;": "| \\triangleright",
          "&#x29CF;&#x338;": "\\not\\triangleleft |",
          "&#x29CF;": "\\triangleleft |",
          "&#x29CE;": "",
          "&#x29CD;": "\\triangle",
          "&#x29CC;": "",
          "&#x29CB;": "\\underline{\\triangle}",
          "&#x29CA;": "\\dot{\\triangle}",
          "&#x29C9;": "",
          "&#x29C8;": "\\boxed{\\circ}",
          "&#x29C7;": "\\boxed{\\circ}",
          "&#x29C6;": "\\boxed{\\rightarrow}",
          "&#x29C5;": "\\bcancel{\\square}",
          "&#x29C4;": "\\cancel{\\square}",
          "&#x29C3;": "\\odot",
          "&#x29C2;": "\\odot",
          "&#x29BF;": "\\odot",
          "&#x29BE;": "\\odot",
          "&#x29BD;": "\\varnothing",
          "&#x29BC;": "\\oplus",
          "&#x29BB;": "\\otimes",
          "&#x29BA;": "",
          "&#x29B9;": "\\varnothing",
          "&#x29B8;": "\\varnothing",
          "&#x29B7;": "\\ominus",
          "&#x29B6;": "\\ominus",
          "&#x29B5;": "\\ominus",
          "&#x29B4;": "\\vec{\\varnothing}",
          "&#x29B3;": "\\vec{\\varnothing}",
          "&#x29B2;": "\\dot{\\varnothing}",
          "&#x29B1;": "\\overline{\\varnothing}",
          "&#x29B0;": "\\varnothing",
          "&#x29AF;": "",
          "&#x29AE;": "",
          "&#x29AD;": "",
          "&#x29AC;": "",
          "&#x29AB;": "",
          "&#x29AA;": "",
          "&#x29A9;": "",
          "&#x29A8;": "",
          "&#x29A7;": "",
          "&#x29A6;": "",
          "&#x29A5;": "",
          "&#x29A4;": "",
          "&#x29A3;": "",
          "&#x29A2;": "",
          "&#x29A1;": "\\not\\lor",
          "&#x29A0;": "\\bcancel{>}",
          "&#x2982;": ":",
          "&#x2981;": "\\circ",
          "&#x2758;": "|",
          "&#x25B2;": "\\bigtriangleup",
          "&#x22FF;": "\\Epsilon",
          "&#x25FB;": "\\square",
          "&#x22FE;": "\\overline{\\ni}",
          "&#x22FD;": "\\overline{\\ni}",
          "&#x22FC;": "\\in",
          "&#x22FB;": "\\in",
          "&#x22FA;": "\\in",
          "&#x22F9;": "\\underline{\\in}",
          "&#x22F8;": "\\underline{\\in}",
          "&#x22F7;": "\\overline{\\in}",
          "&#x22F6;": "\\overline{\\in}",
          "&#x22F5;": "\\dot{\\in}",
          "&#x22F4;": "\\in",
          "&#x22F3;": "\\in",
          "&#x22F2;": "\\in",
          "&#x22F0;": "\\ddots",
          "&#x22E9;": "\\underset{\\sim}{\\succ}",
          "&#x22E8;": "\\underset{\\sim}{\\prec}",
          "&#x22E7;": "\\underset{\\not\\sim}{>}",
          "&#x22E6;": "\\underset{\\not\\sim}{<}",
          "&#x22E5;": "\\not\\sqsupseteq",
          "&#x22E4;": "\\not\\sqsubseteq",
          "&#x22E3;": "\\not\\sqsupseteq",
          "&#x22E2;": "\\not\\sqsubseteq",
          "&#x22E1;": "\\nsucc",
          "&#x22E0;": "\\nprec",
          "&#x22DF;": "\\succ",
          "&#x22DE;": "\\prec",
          "&#x22DD;": "\\overline{>}",
          "&#x22DC;": "\\overline{<}",
          "&#x22DB;": "\\underset{>}{\\leq}",
          "&#x22DA;": "\\underset{<}{\\geq}",
          "&#x22D5;": "\\#",
          "&#x22D3;": "\\cup",
          "&#x22D2;": "\\cap",
          "&#x22D1;": "\\supset",
          "&#x22D0;": "\\subset",
          "&#x22CF;": "\\wedge",
          "&#x22CE;": "\\vee",
          "&#x22CD;": "\\simeq",
          "&#x22C8;": "\\bowtie",
          "&#x22C7;": "\\ast",
          "&#x22C6;": "\\star",
          "&#x22C4;": "\\diamond",
          "&#x22BF;": "\\triangle",
          "&#x22BE;": "\\measuredangle",
          "&#x22BD;": "\\overline{\\lor}",
          "&#x22BC;": "\\overline{\\land}",
          "&#x22BB;": "\\underline{\\lor}",
          "&#x22BA;": "\\top",
          "&#x22B9;": "",
          "&#x22B7;": "\\circ\\multimap",
          "&#x22B6;": "\\circ\\multimap",
          "&#x22B3;": "\\triangleright",
          "&#x22B2;": "\\triangleleft",
          "&#x22B1;": "\\succ",
          "&#x22B0;": "\\prec",
          "&#x22AB;": "|\\models",
          "&#x22AA;": "|\\models",
          "&#x22A7;": "\\models",
          "&#x22A6;": "\\vdash",
          "&#x229D;": "\\ominus",
          "&#x229C;": "\\ominus",
          "&#x229B;": "\\odot",
          "&#x229A;": "\\odot",
          "&#x2294;": "\\sqcup",
          "&#x2293;": "\\sqcap",
          "&#x2292;": "\\sqsupseteq",
          "&#x2291;": "\\sqsubseteq",
          "&#x2290;&#x338;": "\\not\\sqsupset",
          "&#x2290;": "\\sqsupset",
          "&#x228F;&#x338;": "\\not\\sqsubset",
          "&#x228F;": "\\sqsubset",
          "&#x228E;": "\\cup",
          "&#x228D;": "\\cup",
          "&#x228C;": "\\cup",
          "&#x227F;&#x338;": "\\not\\succsim",
          "&#x227F;": "\\succsim",
          "&#x227E;": "\\precsim",
          "&#x2279;": "\\not\\overset{>}{<}",
          "&#x2278;": "\\not\\overset{>}{<}",
          "&#x2277;": "\\overset{>}{<}",
          "&#x2276;": "\\overset{<}{>}",
          "&#x2275;": "\\not\\geg",
          "&#x2274;": "\\not\\leq",
          "&#x2273;": "\\geg",
          "&#x2272;": "\\leq",
          "&#x226C;": "",
          "&#x2267;": "\\geg",
          "&#x2266;&#x338;": "\\not\\leq",
          "&#x2266;": "\\leq",
          "&#x2263;": "\\overset{=}{=} ",
          "&#x225E;": "\\overset{m}{=} ",
          "&#x225D;": "\\overset{def}{=}",
          "&#x2258;": "=",
          "&#x2256;": "=",
          "&#x2255;": "=:",
          "&#x2253;": "\\doteq",
          "&#x2252;": "\\doteq",
          "&#x2251;": "\\doteq",
          "&#x2250;": "\\doteq",
          "&#x224F;&#x338;": "",
          "&#x224F;": "",
          "&#x224E;&#x338;": "",
          "&#x224E;": "",
          "&#x224C;": "\\approx",
          "&#x224B;": "\\approx",
          "&#x224A;": "\\approx",
          "&#x2242;&#x338;": "\\neq",
          "&#x2242;": "=",
          "&#x223F;": "\\sim",
          "&#x223E;": "\\infty",
          "&#x223D;&#x331;": "\\sim",
          "&#x223D;": "\\sim",
          "&#x223B;": "\\sim",
          "&#x223A;": ":-:",
          "&#x2239;": "-:",
          "&#x2238;": "\\bot",
          "&#x2237;": "::",
          "&#x2236;": ":",
          "&#x2223;": "|",
          "&#x221F;": "\\llcorner",
          "&#x2219;": "\\cdot",
          "&#x2218;": "\\circ",
          "&#x2217;": "*",
          "&#x2215;": "/",
          "&#x220E;": "\\square",
          "&#x220D;": "\\ni",
          "&#x220A;": "\\in",
          "&#x2206;": "\\Delta",
          "&#x2044;": "/",
          "&#x2AB0;&#x338;": "\\nsucceq",
          "&#x2AB0;": "\\succeq",
          "&#x2AAF;&#x338;": "\\npreceq",
          "&#x2AAF;": "\\preceq",
          "&#x2A88;": "\\ngeqslant",
          "&#x2A87;": "\\nleqslant",
          "&#x29F3;": "\\Phi",
          "&#x29E6;": "\\models",
          "&#x29E5;": "\\not\\equiv",
          "&#x29E4;": "\\approx\\neq",
          "&#x29E3;": "\\neq",
          "&#x29C1;": "\\circle",
          "&#x29C0;": "\\circle",
          "&#x25E6;": "\\circle",
          "&#x25D7;": "\\circle",
          "&#x25D6;": "\\circle",
          "&#x25CF;": "\\circle",
          "&#x25CE;": "\\circledcirc",
          "&#x25CD;": "\\circledcirc",
          "&#x25CC;": "\\circledcirc",
          "&#x25C9;": "\\circledcirc",
          "&#x25C8;": "\\diamond",
          "&#x25C7;": "\\diamond",
          "&#x25C6;": "\\diamond",
          "&#x25C5;": "\\triangleleft",
          "&#x25C4;": "\\triangleleft",
          "&#x25C3;": "\\triangleleft",
          "&#x25C2;": "\\triangleleft",
          "&#x25C1;": "\\triangleleft",
          "&#x25C0;": "\\triangleleft",
          "&#x25BF;": "\\triangledown",
          "&#x25BE;": "\\triangledown",
          "&#x25BD;": "\\triangledown",
          "&#x25BC;": "\\triangledown",
          "&#x25B9;": "\\triangleright",
          "&#x25B8;": "\\triangleright",
          "&#x25B7;": "\\triangleright",
          "&#x25B6;": "\\triangleright",
          "&#x25B5;": "\\triangle",
          "&#x25B4;": "\\triangle",
          "&#x25B3;": "\\triangle",
          "&#x25B1;": "\\square",
          "&#x25B0;": "\\square",
          "&#x25AF;": "\\square",
          "&#x25AE;": "\\square",
          "&#x25AD;": "\\square",
          "&#x25AB;": "\\square",
          "&#x25AA;": "\\square",
          "&#x25A1;": "\\square",
          "&#x25A0;": "\\square",
          "&#x22ED;": "\\not\\triangleright",
          "&#x22EC;": "\\not\\triangleleft",
          "&#x22EB;": "\\not\\triangleright",
          "&#x22EA;": "\\not\\triangleleft",
          "&#x22D9;": "\\ggg",
          "&#x22D8;": "\\lll",
          "&#x22D7;": "*>",
          "&#x22D6;": "<*",
          "&#x22D4;": "\\pitchfork",
          "&#x22CC;": "",
          "&#x22CB;": "",
          "&#x22CA;": "\\rtimes",
          "&#x22C9;": "\\ltimes",
          "&#x22B5;": "\\triangleright",
          "&#x22B4;": "",
          "&#x22A5;": "\\bot",
          "&#x2281;": "\\nsucc",
          "&#x2280;": "\\preceq",
          "&#x227D;": "\\succeq",
          "&#x227C;": "\\preceq",
          "&#x227B;": "\\succ",
          "&#x227A;": "\\prec",
          "&#x2271;": "\\geq/",
          "&#x2270;": "\\leq/",
          "&#x226D;": "\\neq",
          "&#x226B;&#x338;": "\\not\\gg",
          "&#x226B;": "\\gg",
          "&#x226A;&#x338;": "\\not\\ll",
          "&#x226A;": "\\ll",
          "&#x2269;": "\\ngeqslant",
          "&#x2268;": "\\nleqslant",
          "&#x2261;": "\\equiv",
          "&#x225F;": "\\doteq",
          "&#x225C;": "\\triangleq",
          "&#x225B;": "\\doteq",
          "&#x225A;": "\\triangleq",
          "&#x2259;": "\\triangleq",
          "&#x2257;": "\\doteq",
          "&#x2254;": ":=",
          "&#x224D;": "\\asymp",
          "&#x2247;": "\\ncong",
          "&#x2246;": "\\ncong",
          "&#x2245;": "\\cong",
          "&#x2244;": "\\not\\simeq",
          "&#x2243;": "\\simeq",
          "&#x2241;": "\\nsim",
          "&#x2226;": "\\not\\parallel",
          "&#x2225;": "\\parallel",
          "&#x2224;": "\\not|",
          "&#x221D;": "\\propto",
          "==": "==",
          "=": "=",
          " ̿": "=",
          "&#x33F;": "=",
          ":=": ":=",
          "/=": "=",
          "-=": "-=",
          "+=": "+=",
          "*=": "*=",
          "!=": "!=",
          "&#x2260;": "\\neq",
          "&#x2262;": "\\equiv /",
          "&#x2249;": "\\approx /",
          "&#x223C;": "\\sim",
          "&#x2248;": "\\approx",
          "&#x226E;": "</",
          "&lt;": "<",
          "&#x226F;": ">/",
          ">=": ">=",
          ">": ">",
          "&#x2265;": "\\geq",
          "&#x2264;": "\\leq",
          "&lt;=": "<=",
          "&#x228B;": "\\supsetneq",
          "&#x228A;": "\\subsetneq",
          "&#x2289;": "\\nsupseteq",
          "&#x2288;": "\\nsubseteq",
          "&#x2287;": "\\supseteq",
          "&#x2286;": "\\subseteq",
          "&#x2285;": "\\not\\supset",
          "&#x2284;": "\\not\\subset",
          "&#x2283;&#x20D2;": "\\supset |",
          "&#x2283;": "\\supset",
          "&#x2282;&#x20D2;": "\\subset |",
          "&#x2282;": "\\subset",
          "&#x220C;": "\\not\\in",
          "&#x2209;": "\\notin",
          "&#x2208;": "\\in",
          "&#x2201;": "C",
          "&#x2204;": "\\nexists",
          "&#x2203;": "\\exists",
          "&#x2200;": "\\forall",
          "&#x2227;": "\\land",
          "&amp;&amp;": "\\&\\&",
          "&#x2228;": "\\lor",
          "&#x22AF;": "\\cancel{\\vDash}",
          "&#x22AE;": "\\cancel{\\Vdash}",
          "&#x22AD;": "\\nvDash",
          "&#x22AC;": "\\nvDash",
          "&#x22A9;": "\\Vdash",
          "&#x22A8;": "\\vDash",
          "&#x22A4;": "\\top",
          "&#x22A3;": "\\dashv",
          "&#x22A2;": "\\vdash",
          "&#x220B;": "\\ni",
          "&#x22F1;": "\\ddots",
          "&#x22EF;": "\\hdots",
          "&#x22EE;": "\\vdots",
          "&#x2026;": "\\hdots",
          "&#x3F6;": "\\ni",
          ":": ":",
          "...": "\\cdots",
          "..": "..",
          "->": "->",
          "&#x2235;": "\\because",
          "&#x2234;": "\\therefore ",
          "&#x2063;": "",
          ",": ",",
          ";": ";",
          "&#x29FD;": "\\}",
          "&#x29FC;": "\\{",
          "&#x2998;": "\\]",
          "&#x2997;": "\\[",
          "&#x2996;": "\\ll",
          "&#x2995;": "\\gg",
          "&#x2994;": "\\gg",
          "&#x2993;": "\\ll",
          "&#x2992;": "\\gg",
          "&#x2991;": "\\ll",
          "&#x2990;": "\\]",
          "&#x298F;": "\\]",
          "&#x298E;": "\\]",
          "&#x298D;": "\\[",
          "&#x298C;": "\\[",
          "&#x298B;": "\\]",
          "&#x298A;": "\\triangleright",
          "&#x2989;": "\\triangleleft",
          "&#x2988;": "|\\)",
          "&#x2987;": "\\(|",
          "&#x2986;": "|\\)",
          "&#x2985;": "\\(\\(",
          "&#x2984;": "|\\}",
          "&#x2983;": "\\{|",
          "&#x2980;": "\\||",
          "&#x27EF;": "\\right)",
          "&#x27EE;": "\\left(",
          "&#x27ED;": "\\right]]",
          "&#x27EC;": "\\left[[",
          "&#x27EB;": "\\gg",
          "&#x27EA;": "\\ll",
          "&#x27E9;": "\\rangle",
          "&#x27E8;": "\\langle",
          "&#x27E7;": "\\right]]",
          "&#x27E6;": "\\left[[",
          "&#x2773;": "\\right)",
          "&#x2772;": "\\left(",
          "&#x232A;": "\\rangle",
          "&#x2329;": "\\langle",
          "&#x230B;": "\\rfloor",
          "&#x230A;": "\\lfloor",
          "&#x2309;": "\\rceil",
          "&#x2308;": "\\lceil",
          "&#x2016;": "\\parallel",
          "}": "\\right}",
          "{": "\\left{",
          "]": "\\right]",
          "[": "\\left[",
          ")": "\\right)",
          "(": "\\left(",
          "&#x201D;": '"',
          "&#x201C;": "``",
          "&#x2019;": "'",
          "&#x2018;": "`",
          "%CE%B1": "\\alpha",
          "%CE%B2": "\\beta",
          "%CE%B3": "\\gamma",
          "%CE%93": "\\Gamma",
          "%CE%B4": "\\delta",
          "%CE%94": "\\Delta",
          "%CF%B5": "\\epsilon",
          "%CE%B6": "\\zeta",
          "%CE%B7": "\\eta",
          "%CE%B8": "\\theta",
          "%CE%98": "\\Theta",
          "%CE%B9": "\\iota",
          "%CE%BA": "\\kappa",
          "%CE%BB": "\\lambda",
          "%CE%BC": "\\mu",
          "%CE%BD": "\\nu",
          "%CE%BF": "\\omicron",
          "%CF%80": "\\pi",
          "%CE%A0": "\\Pi",
          "%CF%81": "\\pho",
          "%CF%83": "\\sigma",
          "%CE%A3": "\\Sigma",
          "%CF%84": "\\tau",
          "%CF%85": "\\upsilon",
          "%CE%A5": "\\Upsilon",
          "%CF%95": "\\phi",
          "%CE%A6": "\\Phi",
          "%CF%87": "\\chi",
          "%CF%88": "\\psi",
          "%CE%A8": "\\Psi",
          "%CF%89": "\\omega",
          "%CE%A9": "\\Omega"
        });
      },
      598: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.allMathOperatorsByGlyph = t.allMathOperatorsByGlyphSpecial = void 0, t.allMathOperatorsByGlyphSpecial = {
          '"ˍ"': "\\_",
          '"ˋ"': "ˋ",
          '"ˊ"': "ˊ",
          '"ˉ"': "ˉ",
          '"ˇ"': "",
          '"ˆ"': "\\hat",
          '"º"': "o",
          '"ª"': "a",
          '"ⅆ"': "d",
          '"ⅅ"': "\\mathbb{D}",
          '"土"': "\\pm",
          '"十"': "+",
          '"α"': "\\alpha",
          '"β"': "\\beta",
          '"γ"': "\\gamma",
          '"Γ"': "\\Gamma",
          '"δ"': "\\delta",
          '"Δ"': "\\Delta",
          '"ϵ"': "\\epsilon",
          '"ζ"': "\\zeta",
          '"η"': "\\eta",
          '"θ"': "\\theta",
          '"Θ"': "\\Theta",
          '"ι"': "\\iota",
          '"κ"': "\\kappa",
          '"λ"': "\\lambda",
          '"ν"': "\\nu",
          '"ο"': "\\omicron",
          '"π"': "\\pi",
          '"Π"': "\\Pi",
          '"ρ"': "\\rho",
          '"σ"': "\\sigma",
          '"Σ"': "\\Sigma",
          '"τ"': "\\tau",
          '"υ"': "\\upsilon",
          '"Υ"': "\\Upsilon",
          '"ϕ"': "\\phi",
          '"Φ"': "\\Phi",
          '"χ"': "\\chi",
          '"ψ"': "\\psi",
          '"Ψ"': "\\Psi",
          '"ω"': "\\omega",
          '"Ω"': "\\Omega",
          '"Ω"': "\\Omega",
          '"ℏ"': "\\hbar",
          '"ℜ"': "\\mathfrak{R}",
          '"Ѳ"': "\\theta",
          '"Ø"': "\\emptyset",
          '"ϱ"': "\\varrho",
          '"ф"': "\\phi",
          '"ℇ"': "\\varepsilon",
          '"Ρ"': "P",
          '"ᐁ"': "\\nabla",
          '"ƞ"': "\\eta",
          '"μ"': "\\mu",
          '"Ө"': "\\theta",
          '"ⅇ"': "\\text{e}",
          '"ɼ"': "r",
          '"ἱ"': "i",
          '"ϒ"': "\\Upsilon",
          '"ѳ"': "\\theta",
          '"ⁿ"': "^{n}",
          '"เ"': "\\prime",
          '"П"': "\\prod",
          '"о"': "o",
          '"ђ"': "\\hbar",
          '"Ʌ"': "\\Lambda",
          '"ῡ"': "\\bar{u}",
          '"φ"': "\\varphi",
          '"ȼ"': "c",
          '"Χ"': "\\mathsf{X}",
          '"ₙ"': "_{n}",
          '"ħ"': "\\hbar",
          '"T"': "T",
          '"$"': "\\$",
          '"𝛿"': "\\delta",
          '"𝜙"': "\\phi",
          '"𝞮"': "\\epsilon"
        }, t.allMathOperatorsByGlyph = {
          _: "\\underline",
          "⏡": "\\underbrace",
          "⏠": "\\overbrace",
          "⏟": "\\underbrace",
          "⏞": "\\overbrace",
          "⏝": "\\underbrace",
          "⏜": "\\overarc",
          "⎵": "\\underbrace",
          "⎴": "\\overbrace",
          "⃜": "\\square",
          "⃛": "\\square",
          "⁤": "",
          "⁗": "''''",
          "‾": "\\overline",
          "―": "\\overline",
          "‷": "```",
          "‶": "``",
          "‵": "`",
          "‴": "'''",
          "″": "''",
          "‟": "``",
          "„": ",,",
          "‛": "`",
          "‚": ",",
          "^": "\\hat",
          "˷": "\\sim",
          "˝": "\\sim",
          "˜": "\\sim",
          "˚": "\\degree",
          "˙": "\\cdot",
          "˘": " ",
          "¹": "1",
          "¸": ",",
          "´": "´",
          "³": "3",
          "²": "2",
          "°": "\\degree",
          "¯": "\\overline",
          "↛": "\\nrightarrow",
          "¨": "\\cdot\\cdot",
          "~": "\\sim",
          "`": "`",
          "--": "--",
          "++": "++",
          "&": "\\&",
          "∜": "\\sqrt[4]{}",
          "∛": "\\sqrt[3]{}",
          "√": "\\sqrt{}",
          "?": "?",
          "@": "@",
          "//": "//",
          "!!": "!!",
          "!": "!",
          "♯": "\\#",
          "♮": "",
          "♭": "",
          "′": "'",
          "<>": "<>",
          "**": "\\star\\star",
          "∇": "\\nabla",
          "∂": "\\partial",
          "⊙": "\\bigodot",
          "¬": "\\neg",
          "∢": "\\measuredangle",
          "∡": "\\measuredangle",
          "∠": "\\angle",
          "÷": "\\div",
          "/": "/",
          "∖": "\\backslash",
          "\\": "\\backslash",
          "%": "\\%",
          "⊗": "\\bigotimes",
          "·": "\\cdot",
          "⨿": "\\coprod",
          "⨯": "\\times",
          "⋅": "\\cdot",
          "⊡": "\\boxdot",
          "⊠": "\\boxtimes",
          "⁢": "",
          "⁃": "-",
          "•": "\\cdot",
          ".": ".",
          "*": "\\star",
          "∪": "\\cup",
          "∩": "\\cap",
          "∐": "\\coprod",
          "∏": "\\prod",
          "≀": "",
          "⫿": "",
          "⫼": "\\mid\\mid\\mid",
          "⨉": "\\times",
          "⨈": "",
          "⨇": "",
          "⨆": "\\sqcup",
          "⨅": "\\sqcap",
          "⨂": "\\otimes",
          "⨀": "\\odot",
          "⋂": "\\cap",
          "⋁": "\\vee",
          "⋀": "\\wedge",
          "⨄": "\\uplus",
          "⨃": "\\cup",
          "⋃": "\\cup",
          "⨜": "\\underline{\\int}",
          "⨛": "\\overline{\\int}",
          "⨚": "\\int",
          "⨙": "\\int",
          "⨘": "\\int",
          "⨗": "\\int",
          "⨖": "\\oint",
          "⨕": "\\oint",
          "⨔": "\\int",
          "⨓": "\\int",
          "⨒": "\\int",
          "⨑": "\\int",
          "⨐": "\\int",
          "⨏": "\\bcancel{\\int}",
          "⨎": "",
          "⨍": "\\hcancel{\\int}",
          "⨌": "\\iiiint",
          "∳": "\\oint",
          "∲": "\\oint",
          "∱": "\\int",
          "∰": "\\oiint",
          "∯": "\\oiint",
          "∮": "\\oint",
          "∫": "\\int",
          "⨁": "\\oplus",
          "⊘": "\\oslash",
          "⊖": "\\ominus",
          "⊕": "\\oplus",
          "∭": "\\iiint",
          "∬": "\\iint",
          "⨋": "",
          "⨊": "",
          "∑": "\\sum",
          "⊟": "\\boxminus",
          "⊞": "\\boxplus",
          "∔": "\\dot{+}",
          "∓": "+-",
          "−": "-",
          "±": "\\pm",
          "-": "-",
          "+": "+",
          "⭆": "\\Rrightarrow",
          "⭅": "\\Lleftarrow",
          "⧴": ":\\rightarrow",
          "⧯": "",
          "⧟": "\\bullet-\\bullet",
          "⦟": "\\angle",
          "⦞": "\\measuredangle",
          "⦝": "\\measuredangle",
          "⦜": "\\perp",
          "⦛": "\\measuredangle",
          "⦚": "",
          "⦙": "\\vdots",
          "⥿": "",
          "⥾": "",
          "⥽": "\\prec",
          "⥼": "\\succ",
          "⥻": "\\underset{\\rightarrow}{\\supset}",
          "⥺": "",
          "⥹": "\\underset{\\rightarrow}{\\subset}",
          "⥸": "\\underset{\\rightarrow}{>}",
          "⥷": "",
          "⥶": "\\underset{\\leftarrow}{<}",
          "⥵": "\\underset{\\approx}{\\rightarrow}",
          "⥴": "\\underset{\\sim}{\\rightarrow}",
          "⥳": "\\underset{\\sim}{\\leftarrow}",
          "⥲": "\\overset{\\sim}{\\rightarrow}",
          "⥱": "\\overset{=}{\\rightarrow}",
          "⥰": "",
          "⥯": "",
          "⥮": "",
          "⥭": "\\overline{\\rightharpoondown}",
          "⥬": "\\underline{\\rightharpoonup}",
          "⥫": "\\overline{\\leftharpoondown}",
          "⥪": "\\underline{\\leftharpoonup}",
          "⥩": "\\rightleftharpoons",
          "⥨": "\\rightleftharpoons",
          "⥧": "\\rightleftharpoons",
          "⥦": "\\rightleftharpoons",
          "⥥": "\\Downarrow",
          "⥤": "\\Rightarrow",
          "⥣": "\\Uparrow",
          "⥢": "\\Leftarrow",
          "⥡": "\\downarrow",
          "⥠": "\\uparrow",
          "⥟": "\\rightarrow",
          "⥞": "\\leftarrow",
          "⥝": "\\downarrow",
          "⥜": "\\uparrow",
          "⥛": "\\rightarrow",
          "⥚": "\\leftarrow",
          "⥙": "\\downarrow",
          "⥘": "\\uparrow",
          "⥗": "\\rightarrow",
          "⥖": "\\leftarrow",
          "⥕": "\\downarrow",
          "⥔": "\\uparrow",
          "⥓": "\\rightarrow",
          "⥒": "\\leftarrow",
          "⥑": "\\updownarrow",
          "⥐": "\\leftrightarrow",
          "⥏": "\\updownarrow",
          "⥎": "\\leftrightarrow",
          "⥍": "\\updownarrow",
          "⥌": "\\updownarrow",
          "⥋": "\\leftrightarrow",
          "⥊": "\\leftrightarrow",
          "⥉": "",
          "⥈": "\\leftrightarrow",
          "⥇": "\\nrightarrow",
          "⥆": "",
          "⥅": "",
          "⥄": "\\rightleftarrows",
          "⥃": "\\leftrightarrows",
          "⥂": "\\rightleftarrows",
          "⥁": "\\circlearrowright",
          "⥀": "\\circlearrowleft",
          "⤿": "\\rightarrow",
          "⤾": "\\leftarrow",
          "⤽": "\\leftarrow",
          "⤼": "\\rightarrow",
          "⤻": "\\rightarrow",
          "⤺": "\\leftarrow",
          "⤹": "\\downarrow",
          "⤸": "\\downarrow",
          "⤷": "\\Rsh",
          "⤶": "\\Lsh",
          "⤵": "\\downarrow",
          "⤴": "\\uparrow",
          "⤳": "\\rightarrow",
          "⤲": "\\leftarrow",
          "⤱": " ",
          "⤰": " ",
          "⤯": " ",
          "⤮": " ",
          "⤭": " ",
          "⤬": "\\times",
          "⤫": "\\times",
          "⤪": " ",
          "⤩": " ",
          "⤨": " ",
          "⤧": " ",
          "⤦": " ",
          "⤥": " ",
          "⤤": " ",
          "⤣": " ",
          "⤢": " ",
          "⤡": " ",
          "⤠": "\\mapsto\\cdot",
          "⤟": "\\cdot\\leftarrow",
          "⤞": "\\rightarrow\\cdot",
          "⤝": "\\leftarrow",
          "⤜": "\\rightarrow",
          "⤛": "\\leftarrow",
          "⤚": "\\rightarrow",
          "⤙": "\\leftarrow",
          "⤘": "\\rightarrow",
          "⤗": "\\rightarrow",
          "⤖": "\\rightarrow",
          "⤕": "\\rightarrow",
          "⤔": "\\rightarrow",
          "⤓": "\\downarrow",
          "⤒": "\\uparrow",
          "⤑": "\\rightarrow",
          "⤐": "\\rightarrow",
          "⤏": "\\rightarrow",
          "⤎": "\\leftarrow",
          "⤍": "\\rightarrow",
          "⤌": "\\leftarrow",
          "⤋": "\\Downarrow",
          "⤊": "\\Uparrow",
          "⤉": "\\uparrow",
          "⤈": "\\downarrow",
          "⤇": "\\Rightarrow",
          "⤆": "\\Leftarrow",
          "⤅": "\\mapsto",
          "⤄": "\\nLeftrightarrow",
          "⤃": "\\nRightarrow",
          "⤂": "\\nLeftarrow",
          "⤁": "\\rightsquigarrow",
          "⤀": "\\rightsquigarrow",
          "⟿": "\\rightsquigarrow",
          "⟾": "\\Rightarrow",
          "⟽": "\\Leftarrow",
          "⟼": "\\mapsto",
          "⟻": "\\leftarrow",
          "⟺": "\\Longleftrightarrow",
          "⟹": "\\Longrightarrow",
          "⟸": "\\Longleftarrow",
          "⟷": "\\leftrightarrow",
          "⟶": "\\rightarrow",
          "⟵": "\\leftarrow",
          "⟱": "\\Downarrow",
          "⟰": "\\Uparrow",
          "⊸": "\\rightarrow",
          "⇿": "\\leftrightarrow",
          "⇾": "\\rightarrow",
          "⇽": "\\leftarrow",
          "⇼": "\\nleftrightarrow",
          "⇻": "\\nrightarrow",
          "⇺": "\\nleftarrow",
          "⇹": "\\nleftrightarrow",
          "⇸": "\\nrightarrow",
          "⇷": "\\nleftarrow",
          "⇶": "\\Rrightarrow",
          "⇵": "",
          "⇴": "\\rightarrow",
          "⇳": "\\Updownarrow",
          "⇲": "\\searrow",
          "⇱": "\\nwarrow",
          "⇰": "\\Leftarrow",
          "⇯": "\\Uparrow",
          "⇮": "\\Uparrow",
          "⇭": "\\Uparrow",
          "⇬": "\\Uparrow",
          "⇫": "\\Uparrow",
          "⇪": "\\Uparrow",
          "⇩": "\\Downarrow",
          "⇨": "\\Rightarrow",
          "⇧": "\\Uparrow",
          "⇦": "\\Leftarrow",
          "⇥": "\\rightarrow",
          "⇤": "\\leftarrow",
          "⇣": "\\downarrow",
          "⇢": "\\rightarrow",
          "⇡": "\\uparrow",
          "⇠": "\\leftarrow",
          "⇟": "\\downarrow",
          "⇞": "\\uparrow",
          "⇝": "\\rightsquigarrow",
          "⇜": "\\leftarrow",
          "⇛": "\\Rrightarrow",
          "⇚": "\\Lleftarrow",
          "⇙": "\\swarrow",
          "⇘": "\\searrow",
          "⇗": "\\nearrow",
          "⇖": "\\nwarrow",
          "⇕": "\\Updownarrow",
          "⇔": "\\Leftrightarrow",
          "⇓": "\\Downarrow",
          "⇒": "\\Rightarrow",
          "⇑": "\\Uparrow",
          "⇐": "\\Leftarrow",
          "⇏": "\\nRightarrow",
          "⇎": "\\nLeftrightarrow",
          "⇍": "\\nLeftarrow",
          "⇌": "\\rightleftharpoons",
          "⇋": "\\leftrightharpoons",
          "⇊": "\\downdownarrows",
          "⇉": "\\rightrightarrows",
          "⇈": "\\upuparrows",
          "⇇": "\\leftleftarrows",
          "⇆": "\\leftrightarrows",
          "⇅": "",
          "⇄": "\\rightleftarrows",
          "⇃": "\\downharpoonleft",
          "⇂": "\\downharpoonright",
          "⇁": "\\rightharpoondown",
          "⇀": "\\rightharpoonup",
          "↿": "\\upharpoonleft",
          "↾": "\\upharpoonright",
          "↽": "\\leftharpoondown",
          "↼": "\\leftharpoonup",
          "↻": "\\circlearrowright",
          "↺": "\\circlearrowleft",
          "↹": "\\leftrightarrows",
          "↸": "\\overline{\\nwarrow}",
          "↷": "\\curvearrowright",
          "↶": "\\curvearrowleft",
          "↵": "\\swarrow",
          "↴": "\\searrow",
          "↳": "\\Rsh",
          "↲": "\\Lsh",
          "↱": "\\Rsh",
          "↰": "\\Lsh",
          "↯": "\\swarrow",
          "↮": "",
          "↭": "\\leftrightsquigarrow",
          "↬": "\\looparrowright",
          "↫": "\\looparrowleft",
          "↪": "\\hookrightarrow",
          "↩": "\\hookleftarrow",
          "↨": "\\underline{\\updownarrow}",
          "↧": "\\downarrow",
          "↦": "\\rightarrowtail",
          "↥": "\\uparrow",
          "↤": "\\leftarrowtail",
          "↣": "\\rightarrowtail",
          "↢": "\\leftarrowtail",
          "↡": "\\downarrow",
          "↠": "\\twoheadrightarrow",
          "↟": "\\uparrow",
          "↞": "\\twoheadleftarrow",
          "↝": "\\nearrow",
          "↜": "\\nwarrow",
          "↚": "",
          "↙": "\\swarrow",
          "↘": "\\searrow",
          "↗": "\\nearrow",
          "↖": "\\nwarrow",
          "↕": "\\updownarrow",
          "↔": "\\overleftrightarrow",
          "↓": "\\downarrow",
          "→": "\\overrightarrow",
          "↑": "\\uparrow",
          "←": "\\leftarrow",
          "|||": "\\left|||\\right.",
          "||": "\\left||\\right.",
          "|": "\\mid",
          "⫾": "",
          "⫽": "//",
          "⫻": "///",
          "⫺": "",
          "⫹": "",
          "⫸": "",
          "⫷": "",
          "⫶": "\\vdots",
          "⫵": "",
          "⫴": "",
          "⫳": "",
          "⫲": "\\nparallel",
          "⫱": "",
          "⫰": "",
          "⫯": "",
          "⫮": "\\bcancel{\\mid}",
          "⫭": "",
          "⫬": "",
          "⫫": "",
          "⫪": "",
          "⫩": "",
          "⫨": "\\underline{\\perp}",
          "⫧": "\\overline{\\top}",
          "⫦": "",
          "⫥": "",
          "⫤": "",
          "⫣": "",
          "⫢": "",
          "⫡": "",
          "⫠": "\\perp",
          "⫟": "\\top",
          "⫞": "\\dashv",
          "⫝̸": "",
          "⫝": "",
          "⫛": "\\pitchfork",
          "⫚": "",
          "⫙": "",
          "⫘": "",
          "⫗": "",
          "⫖": "",
          "⫕": "",
          "⫔": "",
          "⫓": "",
          "⫒": "",
          "⫑": "",
          "⫐": "",
          "⫏": "",
          "⫎": "",
          "⫍": "",
          "⫌": "\\underset{\\neq}{\\supset}",
          "⫋": "\\underset{\\neq}{\\subset}",
          "⫊": "\\underset{\\approx}{\\supset}",
          "⫉": "\\underset{\\approx}{\\subset}",
          "⫈": "\\underset{\\sim}{\\supset}",
          "⫇": "\\underset{\\sim}{\\subset}",
          "⫆": "\\supseteqq",
          "⫅": "\\subseteqq",
          "⫄": "\\dot{\\supseteq}",
          "⫃": "\\dot{\\subseteq}",
          "⫂": "\\underset{\\times}{\\supset}",
          "⫁": "\\underset{\\times}{\\subset}",
          "⫀": "\\underset{+}{\\supset}",
          "⪿": "\\underset{+}{\\subset}",
          "⪾": "",
          "⪽": "",
          "⪼": "\\gg ",
          "⪻": "\\ll",
          "⪺": "\\underset{\\cancel{\\approx}}{\\succ}",
          "⪹": "\\underset{\\cancel{\\approx}}{\\prec}",
          "⪸": "\\underset{\\approx}{\\succ}",
          "⪷": "\\underset{\\approx}{\\prec}",
          "⪶": "\\underset{\\cancel{=}}{\\succ}",
          "⪵": "\\underset{\\cancel{=}}{\\prec}",
          "⪴": "\\underset{=}{\\succ}",
          "⪳": "\\underset{=}{\\prec}",
          "⪲": "",
          "⪱": "",
          "⪮": "",
          "⪭": "\\underline{\\hcancel{>}}",
          "⪬": "\\underline{\\hcancel{>}}",
          "⪫": "\\hcancel{>}",
          "⪪": "\\hcancel{<}",
          "⪩": "",
          "⪨": "",
          "⪧": "\\vartriangleright",
          "⪦": "\\vartriangleleft",
          "⪥": "><",
          "⪤": "><",
          "⪣": "\\underline{\\ll}",
          "⪢̸": "\\cancel{\\gg}",
          "⪢": "\\gg",
          "⪡̸": "\\cancel{\\ll}",
          "⪡": "\\ll",
          "⪠": "\\overset{\\sim}{\\geqq}",
          "⪟": "\\overset{\\sim}{\\leqq}",
          "⪞": "\\overset{\\sim}{>}",
          "⪝": "\\overset{\\sim}{<}",
          "⪜": "",
          "⪛": "",
          "⪚": "\\overset{=}{>}",
          "⪙": "\\overset{=}{<}",
          "⪘": "",
          "⪗": "",
          "⪖": "",
          "⪕": "",
          "⪔": "",
          "⪓": "",
          "⪒": "\\underset{=}{\\gtrless}",
          "⪑": "\\underset{=}{\\lessgtr}",
          "⪐": "\\underset{<}{\\gtrsim}",
          "⪏": "\\underset{>}{\\lesssim}",
          "⪎": "\\underset{\\simeq}{>}",
          "⪍": "\\underset{\\simeq}{<}",
          "⪌": "\\gtreqqless",
          "⪋": "\\lesseqqgtr",
          "⪊": "\\underset{\\cancel{\\approx}}{>}",
          "⪉": "\\underset{\\approx}{<}",
          "⪆": "\\underset{\\approx}{>}",
          "⪅": "\\underset{\\approx}{<}",
          "⪄": "",
          "⪃": "",
          "⪂": "",
          "⪁": "",
          "⪀": "",
          "⩿": "",
          "⩾̸": "\\bcancel{\\geq}",
          "⩾": "\\geq",
          "⩽̸": "\\bcancel{\\leq}",
          "⩽": "\\leq",
          "⩼": "",
          "⩻": "",
          "⩺": "",
          "⩹": "",
          "⩸": "\\overset{\\dots}{\\equiv}",
          "⩷": "",
          "⩶": "===",
          "⩵": "==",
          "⩴": "::=",
          "⩳": "",
          "⩲": "\\underset{=}{+}",
          "⩱": "\\overset{=}{+}",
          "⩰": "\\overset{\\approx}{=}",
          "⩯": "\\overset{\\wedge}{=}",
          "⩮": "\\overset{*}{=}",
          "⩭": "\\dot{\\approx}",
          "⩬": "",
          "⩫": "",
          "⩪": "\\dot{\\sim}",
          "⩩": "",
          "⩨": "",
          "⩧": "\\dot{\\equiv}",
          "⩦": "\\underset{\\cdot}{=}",
          "⩥": "",
          "⩤": "",
          "⩣": "\\underset{=}{\\vee}",
          "⩢": "\\overset{=}{\\vee}",
          "⩡": "ul(vv)",
          "⩠": "\\underset{=}{\\wedge}",
          "⩟": "\\underline{\\wedge}",
          "⩞": "\\overset{=}{\\wedge}",
          "⩝": "\\hcancel{\\vee}",
          "⩜": "\\hcancel{\\wedge}",
          "⩛": "",
          "⩚": "",
          "⩙": "",
          "⩘": "\\vee",
          "⩗": "\\wedge",
          "⩖": "",
          "⩕": "",
          "⩔": "",
          "⩓": "",
          "⩒": "\\dot{\\vee}",
          "⩑": "\\dot{\\wedge}",
          "⩐": "",
          "⩏": "",
          "⩎": "",
          "⩍": "\\overline{\\cap}",
          "⩌": "\\overline{\\cup}",
          "⩋": "",
          "⩊": "",
          "⩉": "",
          "⩈": "",
          "⩇": "",
          "⩆": "",
          "⩅": "",
          "⩄": "",
          "⩃": "\\overline{\\cap}",
          "⩂": "\\overline{\\cup}",
          "⩁": "",
          "⩀": "",
          "⨾": "",
          "⨽": "\\llcorner",
          "⨼": "\\lrcorner",
          "⨻": "",
          "⨺": "",
          "⨹": "",
          "⨸": "",
          "⨷": "",
          "⨶": "\\hat{\\otimes}",
          "⨵": "",
          "⨴": "",
          "⨳": "",
          "⨲": "\\underline{\\times}",
          "⨱": "\\underline{\\times}",
          "⨰": "\\dot{\\times}",
          "⨮": "\\bigodot",
          "⨭": "\\bigodot",
          "⨬": "",
          "⨫": "",
          "⨪": "",
          "⨩": "",
          "⨨": "",
          "⨧": "",
          "◻": "\\square",
          "⨦": "\\underset{\\sim}{+}",
          "⨥": "\\underset{\\circ}{+}",
          "⨤": "\\overset{\\sim}{+}",
          "⨣": "\\hat{+}",
          "⨢": "\\dot{+}",
          "⨡": "\\upharpoonright",
          "⨠": ">>",
          "⨟": "",
          "⨞": "\\triangleleft",
          "⨝": "\\bowtie",
          "⧿": "",
          "⧾": "+",
          "⧻": "\\hcancel{|||}",
          "⧺": "\\hcancel{||}",
          "⧹": "\\backslash",
          "⧸": "/",
          "⧷": "hcancel{\backslash}",
          "⧶": "",
          "⧵": "\\backslash",
          "⧲": "\\Phi",
          "⧱": "",
          "⧰": "",
          "⧮": "",
          "⧭": "",
          "⧬": "",
          "⧫": "\\lozenge",
          "⧪": "",
          "⧩": "",
          "⧨": "",
          "⧧": "\\ddagger",
          "⧢": "\\sqcup\\sqcup",
          "⧡": "",
          "⧠": "\\square",
          "⧞": "",
          "⧝": "",
          "⧜": "",
          "⧛": "\\{\\{",
          "⧙": "\\{",
          "⧘": "\\}",
          "⧗": "",
          "⧖": "",
          "⧕": "\\bowtie",
          "⧔": "\\bowtie",
          "⧓": "\\bowtie",
          "⧒": "\\bowtie",
          "⧑": "\\bowtie",
          "⧐̸": "| \\not\\triangleright",
          "⧐": "| \\triangleright",
          "⧏̸": "\\not\\triangleleft |",
          "⧏": "\\triangleleft |",
          "⧎": "",
          "⧍": "\\triangle",
          "⧌": "",
          "⧋": "\\underline{\\triangle}",
          "⧊": "\\dot{\\triangle}",
          "⧉": "",
          "⧈": "\\boxed{\\circ}",
          "⧇": "\\boxed{\\circ}",
          "⧆": "\\boxed{\\rightarrow}",
          "⧅": "\\bcancel{\\square}",
          "⧄": "\\cancel{\\square}",
          "⧃": "\\odot",
          "⧂": "\\odot",
          "⦿": "\\odot",
          "⦾": "\\odot",
          "⦽": "\\varnothing",
          "⦼": "\\oplus",
          "⦻": "\\otimes",
          "⦺": "",
          "⦹": "\\varnothing",
          "⦸": "\\varnothing",
          "⦷": "\\ominus",
          "⦶": "\\ominus",
          "⦵": "\\ominus",
          "⦴": "\\vec{\\varnothing}",
          "⦳": "\\vec{\\varnothing}",
          "⦲": "\\dot{\\varnothing}",
          "⦱": "\\overline{\\varnothing}",
          "⦰": "\\varnothing",
          "⦯": "\\measuredangle",
          "⦮": "\\measuredangle",
          "⦭": "\\measuredangle",
          "⦬": "\\measuredangle",
          "⦫": "\\measuredangle",
          "⦪": "\\measuredangle",
          "⦩": "\\measuredangle",
          "⦨": "\\measuredangle",
          "⦧": "",
          "⦦": "",
          "⦥": "",
          "⦤": "",
          "⦣": "\\ulcorner",
          "⦢": "\\measuredangle",
          "⦡": "\\not\\lor",
          "⦠": "\\bcancel{>}",
          "⦂": ":",
          "⦁": "\\cdot",
          "❘": "\\mid",
          "▲": "\\bigtriangleup",
          "⋿": "\\Epsilon",
          "⋾": "\\overline{\\ni}",
          "⋽": "\\overline{\\ni}",
          "⋼": "\\in",
          "⋻": "\\in",
          "⋺": "\\in",
          "⋹": "\\underline{\\in}",
          "⋸": "\\underline{\\in}",
          "⋷": "\\overline{\\in}",
          "⋶": "\\overline{\\in}",
          "⋵": "\\dot{\\in}",
          "⋴": "\\in",
          "⋳": "\\in",
          "⋲": "\\in",
          "⋰": "\\ddots",
          "։": ":",
          "⋩": "\\underset{\\sim}{\\succ}",
          "⋨": "\\underset{\\sim}{\\prec}",
          "⋧": "\\underset{\\not\\sim}{>}",
          "⋦": "\\underset{\\not\\sim}{<}",
          "⋥": "\\not\\sqsupseteq",
          "⋤": "\\not\\sqsubseteq",
          "⋣": "\\not\\sqsupseteq",
          "⋢": "\\not\\sqsubseteq",
          "⋡": "\\nsucc",
          "⋠": "\\nprec",
          "⋟": "\\succ",
          "⋞": "\\prec",
          "⋝": "\\overline{>}",
          "⋜": "\\overline{<}",
          "⋛": "\\underset{>}{\\leq}",
          "⋚": "\\underset{<}{\\geq}",
          "⋕": "\\#",
          "⋓": "\\cup",
          "⋒": "\\cap",
          "⋑": "\\supset",
          "⋐": "\\subset",
          "⋏": "\\wedge",
          "⋎": "\\vee",
          "⋍": "\\simeq",
          "⋈": "\\Join",
          "⋇": "\\ast",
          "⋆": "\\star",
          "⋄": "\\diamond",
          "⊿": "\\triangle",
          "⊾": "\\measuredangle",
          "⊽": "\\overline{\\lor}",
          "⊼": "\\overline{\\land}",
          "⊻": "\\underline{\\lor}",
          "⊺": "\\top",
          "⊹": "",
          "⊷": "\\circ\\multimap",
          "⊶": "\\circ\\multimap",
          "⊳": "\\triangleright",
          "⊲": "\\triangleleft",
          "⊱": "\\succ",
          "⊰": "\\prec",
          "⊫": "|\\models",
          "⊪": "|\\models",
          "⊧": "\\models",
          "⊦": "\\vdash",
          "⊝": "\\ominus",
          "⊜": "\\ominus",
          "⊛": "\\odot",
          "⊚": "\\odot",
          "⊔": "\\sqcup",
          "⊓": "\\sqcap",
          "⊒": "\\sqsupseteq",
          "⊑": "\\sqsubseteq",
          "⊐̸": "\\not\\sqsupset",
          "⊐": "\\sqsupset",
          "⊏̸": "\\not\\sqsubset",
          "⊏": "\\sqsubset",
          "⊎": "\\cup",
          "⊍": "\\cup",
          "⊌": "\\cup",
          "≿̸": "\\not\\succsim",
          "≿": "\\succsim",
          "≾": "\\precsim",
          "≹": "\\not\\overset{>}{<}",
          "≸": "\\not\\overset{>}{<}",
          "≷": "\\overset{>}{<}",
          "≶": "\\overset{<}{>}",
          "≵": "\\not\\geg",
          "≴": "\\not\\leq",
          "≳": "\\geg",
          "≲": "\\leq",
          "≬": "",
          "≧": "\\geg",
          "≦̸": "\\not\\leq",
          "≦": "\\leq",
          "≣": "\\overset{=}{=} ",
          "≞": "\\overset{m}{=} ",
          "≝": "\\overset{def}{=}",
          "≘": "=",
          "≖": "=",
          "≕": "=:",
          "≓": "\\doteq",
          "≒": "\\doteq",
          "≑": "\\doteq",
          "≐": "\\doteq",
          "≏̸": "",
          "≏": "",
          "≎̸": "",
          "≎": "",
          "≌": "\\approx",
          "≋": "\\approx",
          "≊": "\\approx",
          "≂̸": "\\neq",
          "≂": "=",
          "∿": "\\sim",
          "∾": "\\infty",
          "∽̱": "\\sim",
          "∽": "\\sim",
          "∻": "\\sim",
          "∺": ":-:",
          "∹": "-:",
          "∸": "\\bot",
          "∷": "::",
          "∶": ":",
          "∣": "\\mid",
          "∟": "\\llcorner",
          "∘": "\\circ",
          "∗": "*",
          "∕": "/",
          "∎": "\\square",
          "∍": "\\ni",
          "∊": "\\in",
          "∆": "\\Delta",
          "⁄": "/",
          "⪰̸": "\\nsucceq",
          "⪰": "\\succeq",
          "⪯̸": "\\npreceq",
          "⪯": "\\preceq",
          "⪈": "\\ngeqslant",
          "⪇": "\\nleqslant",
          "⧳": "\\Phi",
          "⧦": "\\models",
          "⧥": "\\not\\equiv",
          "⧤": "\\approx\\neq",
          "⧣": "\\neq",
          "⧁": "\\circle",
          "⧀": "\\circle",
          "◦": "\\circle",
          "◗": "\\circle",
          "◖": "\\circle",
          "●": "\\circle",
          "◎": "\\circledcirc",
          "◍": "\\circledcirc",
          "◌": "\\circledcirc",
          "◉": "\\circledcirc",
          "◈": "\\diamond",
          "◇": "\\diamond",
          "◆": "\\diamond",
          "◅": "\\triangleleft",
          "◄": "\\triangleleft",
          "◃": "\\triangleleft",
          "◂": "\\triangleleft",
          "◁": "\\triangleleft",
          "◀": "\\triangleleft",
          "▿": "\\triangledown",
          "▾": "\\triangledown",
          "▽": "\\triangledown",
          "▼": "\\triangledown",
          "▹": "\\triangleright",
          "▸": "\\triangleright",
          "▷": "\\triangleright",
          "▶": "\\triangleright",
          "▵": "\\triangle",
          "▴": "\\triangle",
          "△": "\\triangle",
          "▱": "\\square",
          "▰": "\\blacksquare",
          "▯": "\\square",
          "▮": "\\blacksquare",
          "▭": "\\square",
          "▫": "\\square",
          "▪": "\\square",
          "□": "\\square",
          "■": "\\blacksquare",
          "⋭": "\\not\\triangleright",
          "⋬": "\\not\\triangleleft",
          "⋫": "\\not\\triangleright",
          "⋪": "\\not\\triangleleft",
          "⋙": "\\ggg",
          "⋘": "\\lll",
          "⋗": "*>",
          "⋖": "<*",
          "⋔": "\\pitchfork",
          "⋌": "",
          "⋋": "\\bowtie",
          "⋊": "\\ltimes",
          "⋉": "\\rtimes",
          "⊵": "\\triangleright",
          "\\triangleleft": "",
          "⊥": "\\bot",
          "⊁": "\\nsucc",
          "⊀": "\\preceq",
          "≽": "\\succeq",
          "≼": "\\preceq",
          "≻": "\\succ",
          "≺": "\\prec",
          "≱": "\\geq/",
          "≰": "\\leq/",
          "≭": "\\neq",
          "≫̸": "\\not\\gg",
          "≫": "\\gg",
          "≪̸": "\\not\\ll",
          "≪": "\\ll",
          "≩": "\\ngeqslant",
          "≨": "\\nleqslant",
          "≡": "\\equiv",
          "≟": "\\doteq",
          "≜": "\\triangleq",
          "≛": "\\doteq",
          "≚": "\\triangleq",
          "≙": "\\triangleq",
          "≗": "\\doteq",
          "≔": ":=",
          "≍": "\\asymp",
          "≇": "\\ncong",
          "≆": "\\ncong",
          "≅": "\\cong",
          "≄": "\\not\\simeq",
          "≃": "\\simeq",
          "≁": "\\nsim",
          "∦": "\\not\\parallel",
          "∥": "\\parallel",
          "∤": "\\not|",
          "∝": "\\propto",
          "==": "==",
          "=": "=",
          ":=": ":=",
          "/=": "=",
          "-=": "-=",
          "+=": "+=",
          "*=": "*=",
          "!=": "!=",
          "≠": "\\neq",
          "≢": "\\equiv /",
          "≉": "\\approx /",
          "∼": "\\sim",
          "≈": "\\approx",
          "≮": "</",
          "<": "<",
          "≯": ">/",
          ">=": ">=",
          ">": ">",
          "≥": "\\geq",
          "≤": "\\leq",
          "<=": "<=",
          "⊋": "\\supsetneq",
          "⊊": "\\subsetneq",
          "⊉": "\\nsupseteq",
          "⊈": "\\nsubseteq",
          "⊇": "\\supseteq",
          "⊆": "\\subseteq",
          "⊅": "\\not\\supset",
          "⊄": "\\not\\subset",
          "⊃⃒": "\\supset |",
          "⊃": "\\supset",
          "⊂⃒": "\\subset |",
          "⊂": "\\subset",
          "∌": "\\not\\in",
          "∉": "\\notin",
          "∈": "\\in",
          "∁": "C",
          "∄": "\\nexists",
          "∃": "\\exists",
          "∀": "\\forall",
          "∧": "\\land",
          "&&": "\\&\\&",
          "∨": "\\lor",
          "⊯": "\\cancel{\\vDash}",
          "⊮": "\\cancel{\\Vdash}",
          "⊭": "\\nvDash",
          "⊬": "\\nvDash",
          "⊩": "\\Vdash",
          "⊨": "\\vDash",
          "⊤": "\\top",
          "⊣": "\\dashv",
          "⊢": "\\vdash",
          "∋": "\\ni",
          "⋱": "\\ddots",
          "⋯": "\\hdots",
          "⋮": "\\vdots",
          "϶": "\\ni",
          ":": ":",
          "...": "\\cdots",
          "..": "..",
          "->": "->",
          "∵": "\\because",
          "∴": "\\therefore ",
          "⁣": "\\llbracket",
          ",": ",",
          ";": ";",
          "⧽": "\\}",
          "⧼": "\\{",
          "⦘": "\\]",
          "⦗": "\\[",
          "⦖": "\\ll",
          "⦕": "\\gg",
          "⦔": "\\gg",
          "⦓": "\\ll",
          "⦒": "\\gg",
          "⦑": "\\ll",
          "⦐": "\\]",
          "⦏": "\\]",
          "⦎": "\\]",
          "⦍": "\\[",
          "⦌": "\\[",
          "⦋": "\\]",
          "⦊": "\\triangleright",
          "⦉": "\\triangleleft",
          "⦈": "|\\)",
          "⦇": "\\(|",
          "⦆": "|\\)",
          "⦅": "\\(\\(",
          "⦄": "|\\}",
          "⦃": "\\{|",
          "⦀": "\\||",
          "⟯": "\\right]",
          "⟮": "\\left[",
          "⟭": "\\right]]",
          "⟬": "\\left[[",
          "⟫": "\\gg",
          "⟪": "\\ll",
          "⟧": "\\)|",
          "⟦": "\\(|",
          "❳": "\\right)",
          "❲": "\\left(",
          "〉": "\\rangle",
          "〈": "\\langle",
          "⌋": "\\rfloor",
          "⌊": "\\lfloor",
          "⌉": "\\rceil",
          "⌈": "\\lceil",
          "‖": "\\parallel",
          "}": "\\right}",
          "{": "\\left{",
          "]": "\\right]",
          "[": "\\left[",
          ")": "\\right)",
          "(": "\\left(",
          "”": '\\"',
          "“": "\\text{``}",
          "’": "'",
          "‘": "`",
          "∅": "\\emptyset",
          "⟲": "\\circlearrowleft",
          "⟳": "\\circlearrowright",
          "×": "\\times",
          "½": "\\dfrac{1}{2}",
          "✓": "\\checkmark",
          "⟩": "\\rangle",
          "⟨": "\\langle",
          "¼": "\\dfrac{1}{4}",
          "…": "\\ldots",
          "∙": "\\cdot",
          "∞": "\\infty",
          "⁺": "^{+}",
          "⁻": "^{-}",
          "⁼": "^{=}",
          "⁽": "^{(}",
          "⁾": "^{)}",
          "〗": "\\)|",
          "〖": "\\langle",
          ";": ";",
          "൦": "\\circ",
          "┴": "\\perp",
          "✕": "\\times",
          "⎻": "-",
          "»": "\\gg",
          "⬆": "\\uparrow",
          "⬇": "\\downarrow",
          "⬅": "\\leftarrow",
          "➡": "\\rightarrow",
          "⎼": "-",
          "⎜": "\\mid",
          "⎥": "\\mid",
          "⮕": "\\rightarrow",
          "・": "\\cdot",
          "¦": "\\mid",
          "£": "\\pounds",
          "¥": "\\yen",
          "✗": "\\times",
          "✔": "\\checkmark",
          "«": "\\ll",
          "†": "\\dagger",
          "│": "\\mid",
          "#": "\\#",
          "℃": "\\text{\\textdegree C}",
          "℉": "\\text{\\textdegree F}",
          "█": "\\blacksquare",
          "℧": "\\mho",
          "‡": "\\ddagger",
          "˳": "\\cdot",
          "।": "\\mid",
          "€": "\\euro"
        });
      },
      2335: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.allMathSymbolsByChar = void 0, t.allMathSymbolsByChar = {
          "&#xA0;": "\\textrm{ }",
          "&#x2203;": "\\exists",
          "&#x2200;": "\\forall",
          "&#x21D4;": "\\iff",
          "&#x21D2;": "=>",
          "&#xAC;": "\\neg",
          "&#x2124;": "\\mathbb{Z}",
          "&#x211D;": "\\mathbb{R}",
          "&#x211A;": "\\mathbb{Q}",
          "&#x2115;": "\\mathbb{N}",
          "&#x2102;": "CC",
          "&#x25A1;": "\\square",
          "&#x22C4;": "\\diamond",
          "&#x25B3;": "\\triangle",
          "&#x2322;": "\\frown",
          "&#x2220;": "\\angle",
          "&#x22F1;": "\\ddots",
          "&#x22EE;": "\\vdots",
          "&#x2235;": "\\because",
          "&#x2234;": "\\therefore",
          "&#x223C;": "\\sim",
          "&#x2241;": "\\nsim",
          "&#x2135;": "\\aleph",
          "&#x2205;": "\\oslash",
          "&#xB1;": "\\pm",
          "&#x2207;": "\\nabla",
          "&#x2202;": "\\partial",
          "&#x222E;": "\\oint",
          "&#x222B;": "\\int",
          "&#x22C3;": "\\cup",
          "&#x222A;": "\\cup",
          "&#x22C2;": "\\cap",
          "&#x2229;": "\\cap",
          "&#x22C1;": "\\vee",
          "&#x2228;": "\\vee",
          "&#x22C0;": "\\wedge",
          "&#x2227;": "\\wedge",
          "&#x220F;": "\\prod",
          "&#x2211;": "\\sum",
          "&#x2299;": "\\bigodot",
          "&#x2297;": "\\bigoplus",
          "&#x2295;": "o+",
          "&#x2218;": "@",
          "&#x22C8;": "\\bowtie",
          "&#x22CA;": "\\rtimes",
          "&#x22C9;": "\\ltimes",
          "&#xF7;": "\\div",
          "&#xD7;": "\\times",
          "\\": "\\backslash",
          "&#x22C6;": "\\star",
          "&#x2217;": "\\star",
          "&#x22C5;": "\\cdot",
          "&#x3A9;": "\\Omega",
          "&#x3C9;": "\\omega",
          "&#x3A8;": "\\Psi",
          "&#x3C8;": "\\psi",
          "&#x3C7;": "\\chi",
          "&#x3C6;": "\\varphi",
          "&#x3A6;": "\\Phi",
          "&#x3D5;": "\\phi",
          "&#x3C5;": "\\upsilon",
          "&#x3C4;": "\\tau",
          "&#x3A3;": "\\Sigma",
          "&#x3C3;": "\\sigma",
          "&#x3C1;": "\\rho",
          "&#x3A0;": "\\Pi",
          "&#x3C0;": "\\pi",
          "&#x39E;": "\\Xi",
          "&#x3BE;": "\\xi",
          "&#x3BD;": "\\nu",
          "&#x3BC;": "\\mu",
          "&#x39B;": "\\Lambda",
          "&#x3BB;": "\\lambda",
          "&#x3BA;": "\\kappa",
          "&#x3B9;": "\\iota",
          "&#x3D1;": "\\vartheta",
          "&#x398;": "\\Theta",
          "&#x3B8;": "\\theta",
          "&#x3B7;": "\\eta",
          "&#x3B6;": "\\zeta",
          "&#x25B;": "\\varepsilon",
          "&#x25FB;": "\\square",
          "&#x3B5;": "\\epsilon",
          "&#x394;": "\\Delta",
          "&#x3B4;": "\\delta",
          "&#x393;": "\\Gamma",
          "&#x3B3;": "\\gamma",
          "&#x3B2;": "\\beta",
          "&#x3B1;": "\\alpha",
          "&#x221E;": "\\infty",
          "‬": "\\text{\\textdir TRT}",
          "‎": "\\text{\\textdir LTR}"
        });
      },
      4104: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.allMathSymbolsByGlyph = t.allMathSymbolsByGlyphSpecial = void 0, t.allMathSymbolsByGlyphSpecial = {
          '"ℵ"': "\\aleph",
          '"Ω"': "\\Omega",
          '"ω"': "\\omega",
          '"Ψ"': "\\Psi",
          '"ψ"': "\\psi",
          '"χ"': "\\chi",
          '"φ"': "\\varphi",
          '"Φ"': "\\Phi",
          '"ϕ"': "\\phi",
          '"υ"': "\\upsilon",
          '"τ"': "\\tau",
          '"Σ"': "\\Sigma",
          '"σ"': "\\sigma",
          '"ρ"': "\\rho",
          '"Π"': "\\Pi",
          '"π"': "\\pi",
          '"Ξ"': "\\Xi",
          '"ξ"': "\\xi",
          '"ν"': "\\nu",
          '"μ"': "\\mu",
          '"Λ"': "\\Lambda",
          '"λ"': "\\lambda",
          '"κ"': "\\kappa",
          '"ι"': "\\iota",
          '"ϑ"': "\\vartheta",
          '"Θ"': "\\Theta",
          '"θ"': "\\theta",
          '"η"': "\\eta",
          '"ζ"': "\\zeta",
          '"ɛ"': "\\varepsilon",
          '"ε"': "\\epsilon",
          '"Δ"': "\\Delta",
          '"δ"': "\\delta",
          '"Γ"': "\\Gamma",
          '"γ"': "\\gamma",
          '"β"': "\\beta",
          '"α"': "\\alpha",
          '"ϵ"': "\\epsilon",
          '"µ"': "\\mu",
          '"ı"': "\\imath",
          '"ม"': "\\mathbf{m}",
          '"Ω"': "\\Omega",
          '"त"': " ",
          '"ß"': "\\ss",
          '"Ћ"': "\\hbar",
          '"เ"': "\\prime",
          '"白"': " ",
          '"ℸ"': "\\wp",
          '"퓰"': " ",
          '"Ө"': "\\theta",
          '"ⁿ"': "^{n}",
          '"ℏ"': "\\hbar",
          '"ℜ"': "\\mathfrak{R}",
          '"Ѳ"': "\\theta",
          '"Ø"': "\\emptyset",
          '"ϱ"': "\\varrho",
          '"ф"': "\\phi",
          '"Ρ"': "P",
          '"ᐁ"': "\\nabla",
          '"ƞ"': "\\eta",
          '"ɣ"': "\\gamma",
          '"ћ"': "\\hbar",
          '"Ɛ"': "\\varepsilon",
          '"ⅅ"': "\\_{D}",
          '"𝜆"': "\\lambda",
          '"𝑥"': "x",
          '"𝑦"': "y",
          '"𝑧"': "z",
          '"𝑖"': "i",
          '"𝑗"': "j",
          '"𝑘"': "k",
          '"𝑚"': "m",
          '"𝑒"': "e",
          '"𝑟"': "r",
          '"ɳ"': "\\eta",
          '"Є"': "\\epsilon",
          '"є"': "\\epsilon",
          '"𝜀"': "\\epsilon",
          '"п"': "\\pi",
          '"Ν"': "\\nu",
          '"ɵ"': "\\theta",
          '"ϴ"': "\\theta",
          '"ɸ"': "\\phi",
          '"Ӷ"': "\\Gamma",
          '"ɭ"': "\\ell",
          '"ʋ"': "\\upsilon",
          '"𝛟"': "\\varphi",
          '"Ф"': "\\Phi",
          '"ⅈ"': "i",
          '"ο"': "o",
          '"ơ"': "o",
          '"ƒ"': "f",
          '"ṁ"': "m",
          '"Փ"': "\\Phi",
          '"ħ"': "\\hbar",
          '"ፈ"': " ",
          '"ế"': "\\hat{e}",
          '"О"': "0",
          '"Υ"': "Y",
          '"х"': "x",
          '"𝓏"': "z",
          '"𝓎"': "y",
          '"𝓍"': "x",
          '"р"': "p",
          '"а"': "a",
          '"ℇ"': "\\varepsilon",
          '"ⅇ"': "\\text{e}",
          '"ɼ"': "r",
          '"ἱ"': "i",
          '"ˆ"': "\\hat{}",
          '"ϒ"': "\\Upsilon",
          '"ѳ"': "\\theta",
          '"П"': "\\prod",
          '"о"': "o",
          '"ђ"': "\\hbar",
          '"Ʌ"': "\\Lambda",
          '"土"': "\\pm",
          '"十"': "+",
          '"ῡ"': "\\bar{u}",
          '"ȼ"': "c",
          '"Χ"': "\\mathsf{X}",
          '"ₙ"': "_{n}",
          '"T"': "T",
          '"∙"': "\\cdot",
          '"〗"': "\\rangle",
          '"〖"': "\\langle",
          '";"': ";",
          '"𝛽"': "\\beta",
          '"⍵"': "\\omega",
          '"℘"': "\\wp",
          '"𝜋"': "\\pi",
          '"𝜓"': "\\psi",
          '"⍬"': "\\theta",
          '"𝜑"': "\\varphi",
          '"⍴"': "\\rho",
          '"🇽"': "x",
          '"𝞮"': "\\epsilon",
          '"𝜙"': "\\phi",
          '"𝛿"': "\\delta",
          '"$"': "\\$",
          '"m"': "m",
          '"𝚵"': "\\Xi",
          '"𝑝"': "p",
          '"𝑞"': "q",
          '"𝑠"': "s",
          '"𝑡"': "t",
          '"𝑢"': "u",
          '"𝑣"': "v",
          '"𝑤"': "w",
          '"𝑎"': "a",
          '"𝑏"': "b",
          '"𝑐"': "c",
          '"𝑑"': "d",
          '"𝑓"': "f",
          '"𝑔"': "g",
          '"𝑙"': "l",
          '"𝑛"': "n",
          '"𝑜"': "o",
          '"𝔀"': "w",
          '"𝚟"': "v"
        }, t.allMathSymbolsByGlyph = {
          " ": "\\textrm{ }",
          "∃": "\\exists",
          "∀": "\\forall",
          "⇔": "\\iff",
          "⇒": "\\Rightarrow",
          "¬": "\\neg",
          "□": "\\square",
          "⋄": "\\diamond",
          "△": "\\triangle",
          "⌢": "\\frown",
          "∠": "\\angle",
          "⋱": "\\ddots",
          "⋮": "\\vdots",
          "∵": "\\because",
          "∴": "\\therefore",
          "∅": "\\emptyset",
          "±": "\\pm",
          "∇": "\\nabla",
          "∂": "\\partial",
          "∮": "\\oint",
          "∫": "\\int",
          "⋃": "\\cup",
          "∪": "\\cup",
          "⋂": "\\cap",
          "∩": "\\cap",
          "⋁": "\\vee",
          "∨": "\\vee",
          "⋀": "\\wedge",
          "∧": "\\wedge",
          "∏": "\\prod",
          "∑": "\\sum",
          "⊙": "\\bigodot",
          "⊗": "\\bigoplus",
          "⊕": "o+",
          "∘": "@",
          "⋈": "\\bowtie",
          "⋊": "\\rtimes",
          "⋉": "\\ltimes",
          "÷": "\\div",
          "×": "\\times",
          "\\": "\\backslash",
          "⋆": "\\star",
          "∗": "\\star",
          "⋅": "\\cdot",
          "∞": "\\infty",
          "²": "^{2}",
          "∎": "\\blacksquare",
          "⟲": "\\circlearrowleft",
          "⟳": "\\circlearrowright",
          "¥": "\\yen",
          "⁽": "^{(}",
          "⁾": "^{)}",
          "⦵": "\\ominus",
          "⊿": "\\bigtriangleup",
          "↛'": "\\nrightarrow",
          "†": "\\dagger",
          "⿱": " ",
          "✔": "\\checkmark",
          "✗": "\\times",
          "½": "\\dfrac{1}{2}",
          "✓": "\\checkmark",
          "⟩": "\\rangle",
          "⟨": "\\langle",
          "〈": "\\langle",
          "¼": "\\dfrac{1}{4}",
          "…": "\\ldots",
          "൦": "\\circ",
          "┴": "\\perp",
          "✕": "\\times",
          "∣": "\\mid",
          "⎜": "\\mid",
          "⦨": "\\llbracket",
          "¢": "\\cent",
          "⤹": "\\downarrow",
          "⤸": "\\downarrow",
          "⤷": "\\Rsh",
          "⤶": "\\Lsh",
          "⤵": "\\downarrow",
          "⤴": "\\uparrow",
          "⤳": "\\rightarrow",
          "|": "\\mid",
          "⎥": "\\mid",
          "♥": "\\heartsuit",
          "£": "\\pounds",
          "⓪": "\\textcircled{0}",
          "①": "\\textcircled{1}",
          "②": "\\textcircled{2}",
          "③": "\\textcircled{3}",
          "④": "\\textcircled{4}",
          "⑤": "\\textcircled{5}",
          "⑥": "\\textcircled{6}",
          "⑦": "\\textcircled{7}",
          "⑧": "\\textcircled{8}",
          "⑨": "\\textcircled{9}",
          "⑩": "\\textcircled{10}",
          "⑪": "\\textcircled{11}",
          "⑫": "\\textcircled{12}",
          "⑬": "\\textcircled{13}",
          "⑭": "\\textcircled{14}",
          "⑮": "\\textcircled{15}",
          "⑯": "\\textcircled{16}",
          "⑰": "\\textcircled{17}",
          "⑱": "\\textcircled{18}",
          "⑲": "\\textcircled{19}",
          "⑳": "\\textcircled{20}",
          "㉑": "\\textcircled{21}",
          "㉒": "\\textcircled{22}",
          "㉓": "\\textcircled{23}",
          "㉔": "\\textcircled{24}",
          "㉕": "\\textcircled{25}",
          "㉖": "\\textcircled{26}",
          "㉗": "\\textcircled{27}",
          "㉘": "\\textcircled{28}",
          "㉙": "\\textcircled{29}",
          "㉚": "\\textcircled{30}",
          "㉛": "\\textcircled{31}",
          "㉜": "\\textcircled{32}",
          "㉝": "\\textcircled{33}",
          "㉞": "\\textcircled{34}",
          "㉟": "\\textcircled{35}",
          "㊱": "\\textcircled{36}",
          "㊲": "\\textcircled{37}",
          "㊳": "\\textcircled{38}",
          "㊴": "\\textcircled{39}",
          "㊵": "\\textcircled{40}",
          "㊶": "\\textcircled{41}",
          "㊷": "\\textcircled{42}",
          "㊸": "\\textcircled{43}",
          "㊹": "\\textcircled{44}",
          "㊺": "\\textcircled{45}",
          "㊻": "\\textcircled{46}",
          "㊼": "\\textcircled{47}",
          "㊽": "\\textcircled{48}",
          "㊾": "\\textcircled{49}",
          "㊿": "\\textcircled{50}",
          "&": "\\&",
          "‖": "\\parallel",
          "%": "\\%",
          "“": "\\text{``}",
          "#": "\\#",
          "℃": "\\text{\\textdegree C}",
          "℉": "\\text{\\textdegree F}",
          "█": "\\blacksquare",
          "℧": "\\mho",
          "⌋": "\\rfloor",
          "⌊": "\\lfloor",
          "⌉": "\\rceil",
          "⌈": "\\lceil",
          "↛": "\\nrightarrow",
          "‾": "\\overline",
          "→": "\\overrightarrow",
          "‡": "\\ddagger",
          "・": "\\cdot",
          "▱": "\\square",
          "∆": "\\Delta",
          "∡": "\\angle",
          "↓": "\\downarrow",
          "↑": "\\uparrow",
          "»": "\\gg",
          "⊤": "\\top",
          "⧸": "/",
          "˳": "\\cdot",
          "։": ":",
          "⦪": "\\measuredangle",
          "⦩": "\\measuredangle",
          "⦫": "\\measuredangle",
          "⦁": "\\cdot",
          "⦢": "\\measuredangle",
          "¸": ",",
          "⎻": "\\overline",
          "⟦": "\\llbracket",
          "≈": "\\approx",
          "≤": "\\leq",
          "⎼": "-",
          "≠": "\\neq",
          "←": "\\leftarrow",
          "।": "\\mid",
          "€": "\\euro",
          "˘": " ",
          "∥": "\\parallel",
          "↔": "\\overleftrightarrow",
          "√": "\\sqrt{}",
          "·": "\\cdot",
          "⦬": "\\measuredangle",
          "⦮": "\\measuredangle",
          "⦭": "\\measuredangle",
          "«": "\\ll",
          "│": "\\mid",
          "〉": "\\rangle",
          "▫": "\\square",
          "●": "\\circle",
          "”": '\\"',
          "◻": "\\square"
        });
      },
      2408: function (e, t, r) {
        var a = this && this.__createBinding || (Object.create ? function (e, t, r, a) {
          void 0 === a && (a = r);
          var n = Object.getOwnPropertyDescriptor(t, r);
          (n && !(("get" in n) ? !t.__esModule : n.writable || n.configurable) || (n = {
            enumerable: !0,
            get: function () {
              return t[r];
            }
          }), Object.defineProperty(e, a, n));
        } : function (e, t, r, a) {
          (void 0 === a && (a = r), e[a] = t[r]);
        }), n = this && this.__exportStar || (function (e, t) {
          for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || a(t, e, r);
        });
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), n(r(1868), t), n(r(598), t), n(r(2335), t), n(r(4104), t), n(r(6626), t), n(r(2103), t), n(r(4317), t));
      },
      6626: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.latexAccents = void 0, t.latexAccents = ["\\hat", "\\bar", "\\underbrace", "\\overarc", "\\overline", "\\overbrace", "\\overrightarrow", "\\overleftrightarrow"]);
      },
      2103: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.mathNumberByGlyph = t.mathNumberByGlyphSpecial = void 0, t.mathNumberByGlyphSpecial = {
          '"ⁿ"': "^{n}",
          '"ₙ"': "_{n}"
        }, t.mathNumberByGlyph = {
          "₀": "_{0}",
          "₁": "_{1}",
          "₂": "_{2}",
          "₃": "_{3}",
          "₄": "_{4}",
          "₅": "_{5}",
          "₆": "_{6}",
          "₇": "_{7}",
          "₈": "_{8}",
          "₉": "_{9}",
          "⁰": "^{0}",
          "¹": "^{1}",
          "²": "^{2}",
          "³": "^{3}",
          "⁴": "^{4}",
          "⁵": "^{5}",
          "⁶": "^{6}",
          "⁷": "^{7}",
          "⁸": "^{8}",
          "⁹": "^{9}",
          "⓪": "\\textcircled{0}",
          "①": "\\textcircled{1}",
          "②": "\\textcircled{2}",
          "③": "\\textcircled{3}",
          "④": "\\textcircled{4}",
          "⑤": "\\textcircled{5}",
          "⑥": "\\textcircled{6}",
          "⑦": "\\textcircled{7}",
          "⑧": "\\textcircled{8}",
          "⑨": "\\textcircled{9}",
          "⑩": "\\textcircled{10}",
          "⑪": "\\textcircled{11}",
          "⑫": "\\textcircled{12}",
          "⑬": "\\textcircled{13}",
          "⑭": "\\textcircled{14}",
          "⑮": "\\textcircled{15}",
          "⑯": "\\textcircled{16}",
          "⑰": "\\textcircled{17}",
          "⑱": "\\textcircled{18}",
          "⑲": "\\textcircled{19}",
          "⑳": "\\textcircled{20}",
          "㉑": "\\textcircled{21}",
          "㉒": "\\textcircled{22}",
          "㉓": "\\textcircled{23}",
          "㉔": "\\textcircled{24}",
          "㉕": "\\textcircled{25}",
          "㉖": "\\textcircled{26}",
          "㉗": "\\textcircled{27}",
          "㉘": "\\textcircled{28}",
          "㉙": "\\textcircled{29}",
          "㉚": "\\textcircled{30}",
          "㉛": "\\textcircled{31}",
          "㉜": "\\textcircled{32}",
          "㉝": "\\textcircled{33}",
          "㉞": "\\textcircled{34}",
          "㉟": "\\textcircled{35}",
          "㊱": "\\textcircled{36}",
          "㊲": "\\textcircled{37}",
          "㊳": "\\textcircled{38}",
          "㊴": "\\textcircled{39}",
          "㊵": "\\textcircled{40}",
          "㊶": "\\textcircled{41}",
          "㊷": "\\textcircled{42}",
          "㊸": "\\textcircled{43}",
          "㊹": "\\textcircled{44}",
          "㊺": "\\textcircled{45}",
          "㊻": "\\textcircled{46}",
          "㊼": "\\textcircled{47}",
          "㊽": "\\textcircled{48}",
          "㊾": "\\textcircled{49}",
          "㊿": "\\textcircled{50}",
          "½": "\\dfrac{1}{2}",
          "⅓": "\\dfrac{1}{3}",
          "⅔": "\\dfrac{2}{3}",
          "¼": "\\dfrac{1}{4}",
          "¾": "\\dfrac{3}{4}",
          "⅕": "\\dfrac{1}{5}",
          "⅖": "\\dfrac{2}{5}",
          "⅗": "\\dfrac{3}{5}",
          "⅘": "\\dfrac{4}{5}",
          "⅙": "\\dfrac{1}{6}",
          "⅚": "\\dfrac{5}{6}",
          "⅐": "\\dfrac{1}{7}",
          "⅛": "\\dfrac{1}{8}",
          "⅜": "\\dfrac{3}{8}",
          "⅝": "\\dfrac{5}{8}",
          "⅞": "\\dfrac{7}{8}",
          "⅑": "\\dfrac{1}{9}",
          "⅒": "\\dfrac{1}{10}"
        });
      },
      4317: (e, t) => {
        (Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.HashUTF8ToLtXConverter = void 0, t.HashUTF8ToLtXConverter = class {
          convert(e) {
            if (e.match(/[a-z0-9]/i)) return e;
            const t = r[e];
            if (t) {
              return this.convertAccentCharToLtX(t) || e;
            }
            return this.convertSpecialCharToLtX(e) || e;
          }
          convertAccentCharToLtX(e) {
            const {char: t, accent: r} = e, n = a[r];
            return n ? `\\${n}{${t}}` : null;
          }
          convertSpecialCharToLtX(e) {
            const t = n[e];
            if (!t) return null;
            const {letter: r, fontCmd: a} = t;
            return `\\${a}{${r}}`;
          }
        });
        const r = {
          á: {
            char: "a",
            accent: "´"
          },
          à: {
            char: "a",
            accent: "`"
          },
          â: {
            char: "a",
            accent: "^"
          },
          ã: {
            char: "a",
            accent: "~"
          },
          ä: {
            char: "a",
            accent: "¨"
          },
          å: {
            char: "a",
            accent: "˚"
          },
          ą: {
            char: "a",
            accent: "˙"
          },
          ă: {
            char: "a",
            accent: "˘"
          },
          ǎ: {
            char: "a",
            accent: "ˇ"
          },
          ǟ: {
            char: "a",
            accent: "ˆ"
          },
          ǻ: {
            char: "a",
            accent: "˙"
          },
          ǡ: {
            char: "a",
            accent: "-"
          },
          ā: {
            char: "a",
            accent: "-"
          },
          é: {
            char: "e",
            accent: "´"
          },
          è: {
            char: "e",
            accent: "`"
          },
          ê: {
            char: "e",
            accent: "^"
          },
          ë: {
            char: "e",
            accent: "¨"
          },
          ę: {
            char: "e",
            accent: "˙"
          },
          ě: {
            char: "e",
            accent: "ˇ"
          },
          ȇ: {
            char: "i",
            accent: "^"
          },
          ё: {
            char: "e",
            accent: "¨"
          },
          ē: {
            char: "e",
            accent: "-"
          },
          í: {
            char: "i",
            accent: "´"
          },
          ì: {
            char: "i",
            accent: "`"
          },
          î: {
            char: "i",
            accent: "^"
          },
          ï: {
            char: "i",
            accent: "¨"
          },
          į: {
            char: "i",
            accent: "˙"
          },
          ǐ: {
            char: "i",
            accent: "ˇ"
          },
          ȉ: {
            char: "i",
            accent: "`"
          },
          ȋ: {
            char: "i",
            accent: "¨"
          },
          ī: {
            char: "i",
            accent: "-"
          },
          ó: {
            char: "o",
            accent: "´"
          },
          ò: {
            char: "o",
            accent: "`"
          },
          ô: {
            char: "o",
            accent: "^"
          },
          õ: {
            char: "o",
            accent: "~"
          },
          ö: {
            char: "o",
            accent: "¨"
          },
          ő: {
            char: "o",
            accent: "˝"
          },
          ǒ: {
            char: "o",
            accent: "ˇ"
          },
          ȍ: {
            char: "o",
            accent: "`"
          },
          ȏ: {
            char: "o",
            accent: "¨"
          },
          ȫ: {
            char: "o",
            accent: "˘"
          },
          ȭ: {
            char: "o",
            accent: "˝"
          },
          ȯ: {
            char: "o",
            accent: "˙"
          },
          ō: {
            char: "o",
            accent: "-"
          },
          ú: {
            char: "u",
            accent: "´"
          },
          ù: {
            char: "u",
            accent: "`"
          },
          û: {
            char: "u",
            accent: "^"
          },
          ü: {
            char: "u",
            accent: "¨"
          },
          ű: {
            char: "u",
            accent: "˝"
          },
          ǔ: {
            char: "u",
            accent: "ˇ"
          },
          ǖ: {
            char: "u",
            accent: "¨"
          },
          ǘ: {
            char: "u",
            accent: "¨"
          },
          ǚ: {
            char: "u",
            accent: "¨"
          },
          ǜ: {
            char: "u",
            accent: "¨"
          },
          ȕ: {
            char: "u",
            accent: "`"
          },
          ȗ: {
            char: "u",
            accent: "¨"
          },
          ū: {
            char: "u",
            accent: "-"
          },
          ý: {
            char: "y",
            accent: "´"
          },
          ỳ: {
            char: "y",
            accent: "`"
          },
          ŷ: {
            char: "y",
            accent: "^"
          },
          ÿ: {
            char: "y",
            accent: "¨"
          },
          ȳ: {
            char: "y",
            accent: "-"
          },
          Á: {
            char: "A",
            accent: "´"
          },
          À: {
            char: "A",
            accent: "`"
          },
          Â: {
            char: "A",
            accent: "^"
          },
          Ã: {
            char: "A",
            accent: "~"
          },
          Ä: {
            char: "A",
            accent: "¨"
          },
          Å: {
            char: "A",
            accent: "˚"
          },
          Å: {
            char: "A",
            accent: "˚"
          },
          Ȧ: {
            char: "A",
            accent: "˙"
          },
          Ă: {
            char: "A",
            accent: "˘"
          },
          Ǎ: {
            char: "A",
            accent: "ˇ"
          },
          Ǟ: {
            char: "A",
            accent: "˝"
          },
          Ǻ: {
            char: "A",
            accent: "˚"
          },
          Ǡ: {
            char: "A",
            accent: "-"
          },
          Ā: {
            char: "A",
            accent: "-"
          },
          É: {
            char: "E",
            accent: "´"
          },
          È: {
            char: "E",
            accent: "`"
          },
          Ė: {
            char: "E",
            accent: "˙"
          },
          Ê: {
            char: "E",
            accent: "^"
          },
          Ë: {
            char: "E",
            accent: "¨"
          },
          Ě: {
            char: "E",
            accent: "ˇ"
          },
          Ȅ: {
            char: "E",
            accent: "`"
          },
          Ȇ: {
            char: "E",
            accent: "¨"
          },
          Ē: {
            char: "E",
            accent: "-"
          },
          Í: {
            char: "I",
            accent: "´"
          },
          Ì: {
            char: "I",
            accent: "`"
          },
          Î: {
            char: "I",
            accent: "^"
          },
          Ï: {
            char: "I",
            accent: "¨"
          },
          Ĭ: {
            char: "I",
            accent: "˘"
          },
          Ǐ: {
            char: "I",
            accent: "ˇ"
          },
          Ȉ: {
            char: "I",
            accent: "`"
          },
          Ȋ: {
            char: "I",
            accent: "¨"
          },
          Ī: {
            char: "I",
            accent: "-"
          },
          Ó: {
            char: "O",
            accent: "´"
          },
          Ò: {
            char: "O",
            accent: "`"
          },
          Ô: {
            char: "O",
            accent: "^"
          },
          Õ: {
            char: "O",
            accent: "~"
          },
          Ö: {
            char: "O",
            accent: "¨"
          },
          Ő: {
            char: "O",
            accent: "˝"
          },
          Ǒ: {
            char: "O",
            accent: "ˇ"
          },
          Ȍ: {
            char: "O",
            accent: "`"
          },
          Ȏ: {
            char: "O",
            accent: "¨"
          },
          Ȫ: {
            char: "O",
            accent: "˘"
          },
          Ȭ: {
            char: "O",
            accent: "˝"
          },
          Ȯ: {
            char: "O",
            accent: "˙"
          },
          Ō: {
            char: "O",
            accent: "-"
          },
          Ú: {
            char: "U",
            accent: "´"
          },
          Ù: {
            char: "U",
            accent: "`"
          },
          Û: {
            char: "U",
            accent: "^"
          },
          Ü: {
            char: "U",
            accent: "¨"
          },
          Ű: {
            char: "U",
            accent: "˝"
          },
          Ǔ: {
            char: "U",
            accent: "ˇ"
          },
          Ǖ: {
            char: "U",
            accent: "¨"
          },
          Ȕ: {
            char: "U",
            accent: "`"
          },
          Ȗ: {
            char: "U",
            accent: "¨"
          },
          Ū: {
            char: "U",
            accent: "-"
          },
          Ý: {
            char: "Y",
            accent: "´"
          },
          Ỳ: {
            char: "Y",
            accent: "`"
          },
          Ŷ: {
            char: "Y",
            accent: "^"
          },
          Ÿ: {
            char: "Y",
            accent: "¨"
          },
          Ȳ: {
            char: "Y",
            accent: "-"
          },
          ñ: {
            char: "n",
            accent: "~"
          },
          Ñ: {
            char: "N",
            accent: "~"
          },
          ç: {
            char: "c",
            accent: "˙"
          },
          Ç: {
            char: "C",
            accent: "˙"
          },
          ṽ: {
            char: "v",
            accent: "~"
          },
          Ṽ: {
            char: "V",
            accent: "~"
          },
          ĵ: {
            char: "j",
            accent: "^"
          },
          Ĵ: {
            char: "J",
            accent: "^"
          },
          ź: {
            char: "z",
            accent: "´"
          },
          Ź: {
            char: "Z",
            accent: "´"
          },
          Ż: {
            char: "Z",
            accent: "^"
          },
          ż: {
            char: "z",
            accent: "^"
          },
          Ž: {
            char: "Z",
            accent: "ˇ"
          },
          ž: {
            char: "z",
            accent: "ˇ"
          },
          ẑ: {
            char: "z",
            accent: "ˆ"
          }
        }, a = {
          "´": "grave",
          "`": "acute",
          "^": "hat",
          "~": "tilde",
          "¨": "ddot",
          "˚": "mathring",
          "˘": "breve",
          ˇ: "check",
          "˝": "ddot",
          "˙": "dot",
          "-": "bar",
          ˆ: "hat",
          "˜": "tilde"
        }, n = {
          𝐀: {
            letter: "A",
            fontCmd: "mathbf"
          },
          𝐁: {
            letter: "B",
            fontCmd: "mathbf"
          },
          𝐂: {
            letter: "C",
            fontCmd: "mathbf"
          },
          𝐃: {
            letter: "D",
            fontCmd: "mathbf"
          },
          𝐄: {
            letter: "E",
            fontCmd: "mathbf"
          },
          Ε: {
            letter: "E",
            fontCmd: "mathbf"
          },
          𝐅: {
            letter: "F",
            fontCmd: "mathbf"
          },
          𝐆: {
            letter: "G",
            fontCmd: "mathbf"
          },
          𝐇: {
            letter: "H",
            fontCmd: "mathbf"
          },
          𝐈: {
            letter: "I",
            fontCmd: "mathbf"
          },
          𝐉: {
            letter: "J",
            fontCmd: "mathbf"
          },
          𝐊: {
            letter: "K",
            fontCmd: "mathbf"
          },
          𝐋: {
            letter: "L",
            fontCmd: "mathbf"
          },
          𝐌: {
            letter: "M",
            fontCmd: "mathbf"
          },
          𝐍: {
            letter: "N",
            fontCmd: "mathbf"
          },
          𝐎: {
            letter: "O",
            fontCmd: "mathbf"
          },
          𝐏: {
            letter: "P",
            fontCmd: "mathbf"
          },
          𝐐: {
            letter: "Q",
            fontCmd: "mathbf"
          },
          𝐑: {
            letter: "R",
            fontCmd: "mathbf"
          },
          𝐒: {
            letter: "S",
            fontCmd: "mathbf"
          },
          𝐓: {
            letter: "T",
            fontCmd: "mathbf"
          },
          𝐔: {
            letter: "U",
            fontCmd: "mathbf"
          },
          𝐕: {
            letter: "V",
            fontCmd: "mathbf"
          },
          𝐖: {
            letter: "W",
            fontCmd: "mathbf"
          },
          𝐗: {
            letter: "X",
            fontCmd: "mathbf"
          },
          𝞆: {
            letter: "X",
            fontCmd: "mathbf"
          },
          𝐘: {
            letter: "Y",
            fontCmd: "mathbf"
          },
          𝐙: {
            letter: "Z",
            fontCmd: "mathbf"
          },
          "𝟎": {
            letter: "0",
            fontCmd: "mathbf"
          },
          "𝟏": {
            letter: "1",
            fontCmd: "mathbf"
          },
          "𝟐": {
            letter: "2",
            fontCmd: "mathbf"
          },
          "𝟑": {
            letter: "3",
            fontCmd: "mathbf"
          },
          "𝟒": {
            letter: "4",
            fontCmd: "mathbf"
          },
          "𝟓": {
            letter: "5",
            fontCmd: "mathbf"
          },
          "𝟔": {
            letter: "6",
            fontCmd: "mathbf"
          },
          "𝟕": {
            letter: "7",
            fontCmd: "mathbf"
          },
          "𝟖": {
            letter: "8",
            fontCmd: "mathbf"
          },
          "𝟗": {
            letter: "9",
            fontCmd: "mathbf"
          },
          𝐴: {
            letter: "A",
            fontCmd: "mathit"
          },
          𝐵: {
            letter: "B",
            fontCmd: "mathit"
          },
          𝐶: {
            letter: "C",
            fontCmd: "mathit"
          },
          𝐷: {
            letter: "D",
            fontCmd: "mathit"
          },
          𝐸: {
            letter: "E",
            fontCmd: "mathit"
          },
          𝐹: {
            letter: "F",
            fontCmd: "mathit"
          },
          𝐺: {
            letter: "G",
            fontCmd: "mathit"
          },
          𝐻: {
            letter: "H",
            fontCmd: "mathit"
          },
          𝐼: {
            letter: "I",
            fontCmd: "mathit"
          },
          Ι: {
            letter: "I",
            fontCmd: "mathit"
          },
          𝐽: {
            letter: "J",
            fontCmd: "mathit"
          },
          𝐾: {
            letter: "K",
            fontCmd: "mathit"
          },
          𝐿: {
            letter: "L",
            fontCmd: "mathit"
          },
          𝑀: {
            letter: "M",
            fontCmd: "mathit"
          },
          𝑁: {
            letter: "N",
            fontCmd: "mathit"
          },
          𝑂: {
            letter: "O",
            fontCmd: "mathit"
          },
          𝑃: {
            letter: "P",
            fontCmd: "mathit"
          },
          𝑄: {
            letter: "Q",
            fontCmd: "mathit"
          },
          𝑅: {
            letter: "R",
            fontCmd: "mathit"
          },
          𝑆: {
            letter: "S",
            fontCmd: "mathit"
          },
          𝑇: {
            letter: "T",
            fontCmd: "mathit"
          },
          𝑈: {
            letter: "U",
            fontCmd: "mathit"
          },
          𝑉: {
            letter: "V",
            fontCmd: "mathit"
          },
          𝑊: {
            letter: "W",
            fontCmd: "mathit"
          },
          𝑋: {
            letter: "X",
            fontCmd: "mathit"
          },
          𝑌: {
            letter: "Y",
            fontCmd: "mathit"
          },
          𝑍: {
            letter: "Z",
            fontCmd: "mathit"
          },
          𝔸: {
            letter: "A",
            fontCmd: "mathbb"
          },
          𝔹: {
            letter: "B",
            fontCmd: "mathbb"
          },
          ℂ: {
            letter: "C",
            fontCmd: "mathbb"
          },
          𝔻: {
            letter: "D",
            fontCmd: "mathbb"
          },
          𝔼: {
            letter: "E",
            fontCmd: "mathbb"
          },
          𝔽: {
            letter: "F",
            fontCmd: "mathbb"
          },
          𝔾: {
            letter: "G",
            fontCmd: "mathbb"
          },
          ℍ: {
            letter: "H",
            fontCmd: "mathbb"
          },
          𝕀: {
            letter: "I",
            fontCmd: "mathbb"
          },
          𝕁: {
            letter: "J",
            fontCmd: "mathbb"
          },
          𝕂: {
            letter: "K",
            fontCmd: "mathbb"
          },
          𝕃: {
            letter: "L",
            fontCmd: "mathbb"
          },
          𝕄: {
            letter: "M",
            fontCmd: "mathbb"
          },
          ℕ: {
            letter: "N",
            fontCmd: "mathbb"
          },
          𝕆: {
            letter: "O",
            fontCmd: "mathbb"
          },
          ℙ: {
            letter: "P",
            fontCmd: "mathbb"
          },
          ℚ: {
            letter: "Q",
            fontCmd: "mathbb"
          },
          ℝ: {
            letter: "R",
            fontCmd: "mathbb"
          },
          𝕊: {
            letter: "S",
            fontCmd: "mathbb"
          },
          𝕋: {
            letter: "T",
            fontCmd: "mathbb"
          },
          𝕌: {
            letter: "U",
            fontCmd: "mathbb"
          },
          𝕍: {
            letter: "V",
            fontCmd: "mathbb"
          },
          𝕎: {
            letter: "W",
            fontCmd: "mathbb"
          },
          𝕏: {
            letter: "X",
            fontCmd: "mathbb"
          },
          𝕐: {
            letter: "Y",
            fontCmd: "mathbb"
          },
          ℤ: {
            letter: "Z",
            fontCmd: "mathbb"
          },
          "𝟘": {
            letter: "0",
            fontCmd: "mathbb"
          },
          "𝟙": {
            letter: "1",
            fontCmd: "mathbb"
          },
          "𝟚": {
            letter: "2",
            fontCmd: "mathbb"
          },
          "𝟛": {
            letter: "3",
            fontCmd: "mathbb"
          },
          "𝟜": {
            letter: "4",
            fontCmd: "mathbb"
          },
          "𝟝": {
            letter: "5",
            fontCmd: "mathbb"
          },
          "𝟞": {
            letter: "6",
            fontCmd: "mathbb"
          },
          "𝟟": {
            letter: "7",
            fontCmd: "mathbb"
          },
          "𝟠": {
            letter: "8",
            fontCmd: "mathbb"
          },
          "𝟡": {
            letter: "9",
            fontCmd: "mathbb"
          },
          𝒜: {
            letter: "A",
            fontCmd: "mathcal"
          },
          𝓐: {
            letter: "A",
            fontCmd: "mathcal"
          },
          ℬ: {
            letter: "B",
            fontCmd: "mathcal"
          },
          𝒞: {
            letter: "C",
            fontCmd: "mathcal"
          },
          𝒟: {
            letter: "D",
            fontCmd: "mathcal"
          },
          𝓓: {
            letter: "D",
            fontCmd: "mathcal"
          },
          ℰ: {
            letter: "E",
            fontCmd: "mathcal"
          },
          ℱ: {
            letter: "F",
            fontCmd: "mathcal"
          },
          𝓕: {
            letter: "F",
            fontCmd: "mathcal"
          },
          𝒢: {
            letter: "G",
            fontCmd: "mathcal"
          },
          ℋ: {
            letter: "H",
            fontCmd: "mathcal"
          },
          ℐ: {
            letter: "I",
            fontCmd: "mathcal"
          },
          𝒥: {
            letter: "J",
            fontCmd: "mathcal"
          },
          𝒦: {
            letter: "K",
            fontCmd: "mathcal"
          },
          ℒ: {
            letter: "L",
            fontCmd: "mathcal"
          },
          𝓛: {
            letter: "L",
            fontCmd: "mathcal"
          },
          ℳ: {
            letter: "M",
            fontCmd: "mathcal"
          },
          𝒩: {
            letter: "N",
            fontCmd: "mathcal"
          },
          𝒪: {
            letter: "O",
            fontCmd: "mathcal"
          },
          𝓞: {
            letter: "O",
            fontCmd: "mathcal"
          },
          𝒫: {
            letter: "P",
            fontCmd: "mathcal"
          },
          𝒬: {
            letter: "Q",
            fontCmd: "mathcal"
          },
          ℛ: {
            letter: "R",
            fontCmd: "mathcal"
          },
          𝕽: {
            letter: "R",
            fontCmd: "mathcal"
          },
          "℟": {
            letter: "R",
            fontCmd: "mathcal"
          },
          𝒮: {
            letter: "S",
            fontCmd: "mathcal"
          },
          𝒯: {
            letter: "T",
            fontCmd: "mathcal"
          },
          𝒰: {
            letter: "U",
            fontCmd: "mathcal"
          },
          𝒱: {
            letter: "V",
            fontCmd: "mathcal"
          },
          𝒲: {
            letter: "W",
            fontCmd: "mathcal"
          },
          𝒳: {
            letter: "X",
            fontCmd: "mathcal"
          },
          𝒴: {
            letter: "Y",
            fontCmd: "mathcal"
          },
          𝒵: {
            letter: "Z",
            fontCmd: "mathcal"
          },
          𝔄: {
            letter: "A",
            fontCmd: "mathfrak"
          },
          𝔅: {
            letter: "B",
            fontCmd: "mathfrak"
          },
          ℭ: {
            letter: "C",
            fontCmd: "mathfrak"
          },
          𝔇: {
            letter: "D",
            fontCmd: "mathfrak"
          },
          𝔈: {
            letter: "E",
            fontCmd: "mathfrak"
          },
          𝔉: {
            letter: "F",
            fontCmd: "mathfrak"
          },
          𝔊: {
            letter: "G",
            fontCmd: "mathfrak"
          },
          ℌ: {
            letter: "H",
            fontCmd: "mathfrak"
          },
          ℑ: {
            letter: "I",
            fontCmd: "mathfrak"
          },
          𝔍: {
            letter: "J",
            fontCmd: "mathfrak"
          },
          𝔎: {
            letter: "K",
            fontCmd: "mathfrak"
          },
          𝔏: {
            letter: "L",
            fontCmd: "mathfrak"
          },
          𝔐: {
            letter: "M",
            fontCmd: "mathfrak"
          },
          𝔑: {
            letter: "N",
            fontCmd: "mathfrak"
          },
          𝔒: {
            letter: "O",
            fontCmd: "mathfrak"
          },
          𝔓: {
            letter: "P",
            fontCmd: "mathfrak"
          },
          𝔔: {
            letter: "Q",
            fontCmd: "mathfrak"
          },
          ℜ: {
            letter: "R",
            fontCmd: "mathfrak"
          },
          𝔖: {
            letter: "S",
            fontCmd: "mathfrak"
          },
          𝔗: {
            letter: "T",
            fontCmd: "mathfrak"
          },
          𝔘: {
            letter: "U",
            fontCmd: "mathfrak"
          },
          𝔙: {
            letter: "V",
            fontCmd: "mathfrak"
          },
          𝔚: {
            letter: "W",
            fontCmd: "mathfrak"
          },
          𝔛: {
            letter: "X",
            fontCmd: "mathfrak"
          },
          𝔜: {
            letter: "Y",
            fontCmd: "mathfrak"
          },
          ℨ: {
            letter: "Z",
            fontCmd: "mathfrak"
          },
          𝖠: {
            letter: "A",
            fontCmd: "mathsf"
          },
          Α: {
            letter: "A",
            fontCmd: "mathsf"
          },
          𝖡: {
            letter: "B",
            fontCmd: "mathsf"
          },
          Β: {
            letter: "B",
            fontCmd: "mathsf"
          },
          𝖢: {
            letter: "C",
            fontCmd: "mathsf"
          },
          𝖣: {
            letter: "D",
            fontCmd: "mathsf"
          },
          𝖤: {
            letter: "E",
            fontCmd: "mathsf"
          },
          𝖥: {
            letter: "F",
            fontCmd: "mathsf"
          },
          𝖦: {
            letter: "G",
            fontCmd: "mathsf"
          },
          𝖧: {
            letter: "H",
            fontCmd: "mathsf"
          },
          𝖨: {
            letter: "I",
            fontCmd: "mathsf"
          },
          𝖩: {
            letter: "J",
            fontCmd: "mathsf"
          },
          ȷ: {
            letter: "J",
            fontCmd: "mathsf"
          },
          𝖪: {
            letter: "K",
            fontCmd: "mathsf"
          },
          Κ: {
            letter: "K",
            fontCmd: "mathsf"
          },
          𝖫: {
            letter: "L",
            fontCmd: "mathsf"
          },
          𝖬: {
            letter: "M",
            fontCmd: "mathsf"
          },
          𝖭: {
            letter: "N",
            fontCmd: "mathsf"
          },
          𝖮: {
            letter: "O",
            fontCmd: "mathsf"
          },
          𝖯: {
            letter: "P",
            fontCmd: "mathsf"
          },
          𝖰: {
            letter: "Q",
            fontCmd: "mathsf"
          },
          𝖱: {
            letter: "R",
            fontCmd: "mathsf"
          },
          𝖲: {
            letter: "S",
            fontCmd: "mathsf"
          },
          𝖳: {
            letter: "T",
            fontCmd: "mathsf"
          },
          𝖴: {
            letter: "U",
            fontCmd: "mathsf"
          },
          𝖵: {
            letter: "V",
            fontCmd: "mathsf"
          },
          𝖶: {
            letter: "W",
            fontCmd: "mathsf"
          },
          𝖷: {
            letter: "X",
            fontCmd: "mathsf"
          },
          Χ: {
            letter: "X",
            fontCmd: "mathsf"
          },
          𝖸: {
            letter: "Y",
            fontCmd: "mathsf"
          },
          𝖹: {
            letter: "Z",
            fontCmd: "mathsf"
          },
          𝚨: {
            letter: "A",
            fontCmd: "mathtt"
          },
          𝚩: {
            letter: "B",
            fontCmd: "mathtt"
          },
          𝚪: {
            letter: "\\Gamma",
            fontCmd: "mathtt"
          },
          𝚫: {
            letter: "\\Delta",
            fontCmd: "mathtt"
          },
          𝚬: {
            letter: "E",
            fontCmd: "mathtt"
          },
          𝚭: {
            letter: "F",
            fontCmd: "mathtt"
          },
          𝚮: {
            letter: "G",
            fontCmd: "mathtt"
          },
          𝚯: {
            letter: "\\Theta",
            fontCmd: "mathtt"
          },
          𝚰: {
            letter: "I",
            fontCmd: "mathtt"
          },
          𝚱: {
            letter: "J",
            fontCmd: "mathtt"
          },
          𝚲: {
            letter: "\\Lambda",
            fontCmd: "mathtt"
          },
          𝚳: {
            letter: "L",
            fontCmd: "mathtt"
          },
          𝚴: {
            letter: "M",
            fontCmd: "mathtt"
          },
          𝚵: {
            letter: "\\Pi",
            fontCmd: "mathtt"
          },
          𝚶: {
            letter: "O",
            fontCmd: "mathtt"
          },
          𝚷: {
            letter: "\\Pi",
            fontCmd: "mathtt"
          },
          𝚸: {
            letter: "Q",
            fontCmd: "mathtt"
          },
          𝚹: {
            letter: "R",
            fontCmd: "mathtt"
          },
          𝚺: {
            letter: "S",
            fontCmd: "mathtt"
          },
          𝚻: {
            letter: "T",
            fontCmd: "mathtt"
          },
          𝚼: {
            letter: "U",
            fontCmd: "mathtt"
          },
          𝚽: {
            letter: "\\Phi",
            fontCmd: "mathtt"
          },
          𝚾: {
            letter: "W",
            fontCmd: "mathtt"
          },
          𝚿: {
            letter: "\\Psi",
            fontCmd: "mathtt"
          },
          𝛀: {
            letter: "\\Omega",
            fontCmd: "mathtt"
          }
        };
      }
    }, t = {};
    function r(a) {
      var n = t[a];
      if (void 0 !== n) return n.exports;
      var o = t[a] = {
        exports: {}
      };
      return (e[a].call(o.exports, o, o.exports, r), o.exports);
    }
    var a = {};
    return ((() => {
      var e = a;
      (Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.MathMLToLaTeX = void 0);
      var t = r(8863);
      Object.defineProperty(e, "MathMLToLaTeX", {
        enumerable: !0,
        get: function () {
          return t.MathMLToLaTeX;
        }
      });
    })(), a);
  })());
})(bundle_min);
getDefaultExportFromCjs(bundle_min.exports);

var mmlToLatex = mathml => bundle_min.exports.MathMLToLaTeX.convert(mathml);

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	renderMath: renderMath,
	wrapMath: wrapMath,
	unWrapMath: unWrapMath,
	mmlToLatex: mmlToLatex
});

export { index as _dll_pie_lib__math_rendering };
